import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Hex: { input: any; output: any; }
  Json: { input: any; output: any; }
  Long: { input: any; output: any; }
  RGBAHue: { input: any; output: any; }
  RGBATransparency: { input: any; output: any; }
  RichTextAST: { input: any; output: any; }
};

/** Accordion */
export type Accordion = Entity & Node & {
  __typename?: 'Accordion';
  accordionItems: Array<AccordionItem>;
  anchorNav?: Maybe<AnchorNavigation>;
  /** By default all accordion items are expanded, this field make it expanded. */
  collapsed?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Accordion>;
  /** List of Accordion versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Accordion name, should be unique per page */
  name: Scalars['String']['output'];
  /** Parent navigation url */
  navUrl?: Maybe<Scalars['String']['output']>;
  /** Show item number on left side of accordion item title */
  numbered?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Accordion */
export type AccordionAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionItemWhereInput>;
};


/** Accordion */
export type AccordionAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Accordion */
export type AccordionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Accordion */
export type AccordionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Accordion */
export type AccordionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Accordion */
export type AccordionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Accordion */
export type AccordionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Accordion */
export type AccordionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AccordionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AccordionWhereUniqueInput;
};

/** A connection to a list of items. */
export type AccordionConnection = {
  __typename?: 'AccordionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AccordionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export enum AccordionContentAlignment {
  ImageFullWidth = 'ImageFullWidth',
  ImageLeftTextRight = 'ImageLeftTextRight',
  ImageRightTextLeft = 'ImageRightTextLeft',
  NoImage = 'NoImage'
}

export type AccordionCreateInput = {
  accordionItems?: InputMaybe<AccordionItemCreateManyInlineInput>;
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  navUrl?: InputMaybe<Scalars['String']['input']>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccordionCreateManyInlineInput = {
  /** Connect multiple existing Accordion documents */
  connect?: InputMaybe<Array<AccordionWhereUniqueInput>>;
  /** Create and connect multiple existing Accordion documents */
  create?: InputMaybe<Array<AccordionCreateInput>>;
};

export type AccordionCreateOneInlineInput = {
  /** Connect one existing Accordion document */
  connect?: InputMaybe<AccordionWhereUniqueInput>;
  /** Create and connect one Accordion document */
  create?: InputMaybe<AccordionCreateInput>;
};

/** An edge in a connection. */
export type AccordionEdge = {
  __typename?: 'AccordionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Accordion;
};

/** Accordion Item */
export type AccordionItem = Entity & Node & {
  __typename?: 'AccordionItem';
  accordion?: Maybe<Accordion>;
  /** Accordion item body content */
  body?: Maybe<AccordionItemBodyRichText>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<AccordionItem>;
  /** List of AccordionItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<AccordionItem>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Accordion item title, which is clickable */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Accordion Item */
export type AccordionItemAccordionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Accordion Item */
export type AccordionItemCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Accordion Item */
export type AccordionItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Accordion Item */
export type AccordionItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Accordion Item */
export type AccordionItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Accordion Item */
export type AccordionItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Accordion Item */
export type AccordionItemPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Accordion Item */
export type AccordionItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Accordion Item */
export type AccordionItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Accordion Item */
export type AccordionItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Accordion Item */
export type AccordionItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AccordionItemBodyRichText = {
  __typename?: 'AccordionItemBodyRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<AccordionItemBodyRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type AccordionItemBodyRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type AccordionItemBodyRichTextEmbeddedTypes = Asset;

export type AccordionItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AccordionItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type AccordionItemConnection = {
  __typename?: 'AccordionItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AccordionItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AccordionItemCreateInput = {
  accordion?: InputMaybe<AccordionCreateOneInlineInput>;
  /** body input for default locale (default) */
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AccordionItemCreateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccordionItemCreateLocalizationDataInput = {
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AccordionItemCreateLocalizationInput = {
  /** Localization input */
  data: AccordionItemCreateLocalizationDataInput;
  locale: Locale;
};

export type AccordionItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AccordionItemCreateLocalizationInput>>;
};

export type AccordionItemCreateManyInlineInput = {
  /** Connect multiple existing AccordionItem documents */
  connect?: InputMaybe<Array<AccordionItemWhereUniqueInput>>;
  /** Create and connect multiple existing AccordionItem documents */
  create?: InputMaybe<Array<AccordionItemCreateInput>>;
};

export type AccordionItemCreateOneInlineInput = {
  /** Connect one existing AccordionItem document */
  connect?: InputMaybe<AccordionItemWhereUniqueInput>;
  /** Create and connect one AccordionItem document */
  create?: InputMaybe<AccordionItemCreateInput>;
};

/** An edge in a connection. */
export type AccordionItemEdge = {
  __typename?: 'AccordionItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AccordionItem;
};

/** Identifies documents */
export type AccordionItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordion?: InputMaybe<AccordionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AccordionItemWhereStageInput>;
  documentInStages_none?: InputMaybe<AccordionItemWhereStageInput>;
  documentInStages_some?: InputMaybe<AccordionItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AccordionItemOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AccordionItemUpdateInput = {
  accordion?: InputMaybe<AccordionUpdateOneInlineInput>;
  /** body input for default locale (default) */
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<AccordionItemUpdateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AccordionItemUpdateLocalizationDataInput = {
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AccordionItemUpdateLocalizationInput = {
  data: AccordionItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type AccordionItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AccordionItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AccordionItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AccordionItemUpsertLocalizationInput>>;
};

export type AccordionItemUpdateManyInlineInput = {
  /** Connect multiple existing AccordionItem documents */
  connect?: InputMaybe<Array<AccordionItemConnectInput>>;
  /** Create and connect multiple AccordionItem documents */
  create?: InputMaybe<Array<AccordionItemCreateInput>>;
  /** Delete multiple AccordionItem documents */
  delete?: InputMaybe<Array<AccordionItemWhereUniqueInput>>;
  /** Disconnect multiple AccordionItem documents */
  disconnect?: InputMaybe<Array<AccordionItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AccordionItem documents */
  set?: InputMaybe<Array<AccordionItemWhereUniqueInput>>;
  /** Update multiple AccordionItem documents */
  update?: InputMaybe<Array<AccordionItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AccordionItem documents */
  upsert?: InputMaybe<Array<AccordionItemUpsertWithNestedWhereUniqueInput>>;
};

export type AccordionItemUpdateManyInput = {
  /** body input for default locale (default) */
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<AccordionItemUpdateManyLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AccordionItemUpdateManyLocalizationDataInput = {
  body?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AccordionItemUpdateManyLocalizationInput = {
  data: AccordionItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type AccordionItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<AccordionItemUpdateManyLocalizationInput>>;
};

export type AccordionItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AccordionItemUpdateManyInput;
  /** Document search */
  where: AccordionItemWhereInput;
};

export type AccordionItemUpdateOneInlineInput = {
  /** Connect existing AccordionItem document */
  connect?: InputMaybe<AccordionItemWhereUniqueInput>;
  /** Create and connect one AccordionItem document */
  create?: InputMaybe<AccordionItemCreateInput>;
  /** Delete currently connected AccordionItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AccordionItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AccordionItem document */
  update?: InputMaybe<AccordionItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AccordionItem document */
  upsert?: InputMaybe<AccordionItemUpsertWithNestedWhereUniqueInput>;
};

export type AccordionItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AccordionItemUpdateInput;
  /** Unique document search */
  where: AccordionItemWhereUniqueInput;
};

export type AccordionItemUpsertInput = {
  /** Create document if it didn't exist */
  create: AccordionItemCreateInput;
  /** Update document if it exists */
  update: AccordionItemUpdateInput;
};

export type AccordionItemUpsertLocalizationInput = {
  create: AccordionItemCreateLocalizationDataInput;
  locale: Locale;
  update: AccordionItemUpdateLocalizationDataInput;
};

export type AccordionItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AccordionItemUpsertInput;
  /** Unique document search */
  where: AccordionItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AccordionItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AccordionItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordion?: InputMaybe<AccordionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AccordionItemWhereStageInput>;
  documentInStages_none?: InputMaybe<AccordionItemWhereStageInput>;
  documentInStages_some?: InputMaybe<AccordionItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AccordionItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AccordionItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AccordionItem record uniquely */
export type AccordionItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type AccordionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordionItems_every?: InputMaybe<AccordionItemWhereInput>;
  accordionItems_none?: InputMaybe<AccordionItemWhereInput>;
  accordionItems_some?: InputMaybe<AccordionItemWhereInput>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  collapsed_not?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AccordionWhereStageInput>;
  documentInStages_none?: InputMaybe<AccordionWhereStageInput>;
  documentInStages_some?: InputMaybe<AccordionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  navUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  navUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  navUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  navUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  navUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  navUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  navUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  navUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  navUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  navUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  numbered_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AccordionOrderByInput {
  collapsed_ASC = 'collapsed_ASC',
  collapsed_DESC = 'collapsed_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  navUrl_ASC = 'navUrl_ASC',
  navUrl_DESC = 'navUrl_DESC',
  numbered_ASC = 'numbered_ASC',
  numbered_DESC = 'numbered_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AccordionUpdateInput = {
  accordionItems?: InputMaybe<AccordionItemUpdateManyInlineInput>;
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  navUrl?: InputMaybe<Scalars['String']['input']>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionUpdateManyInlineInput = {
  /** Connect multiple existing Accordion documents */
  connect?: InputMaybe<Array<AccordionConnectInput>>;
  /** Create and connect multiple Accordion documents */
  create?: InputMaybe<Array<AccordionCreateInput>>;
  /** Delete multiple Accordion documents */
  delete?: InputMaybe<Array<AccordionWhereUniqueInput>>;
  /** Disconnect multiple Accordion documents */
  disconnect?: InputMaybe<Array<AccordionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Accordion documents */
  set?: InputMaybe<Array<AccordionWhereUniqueInput>>;
  /** Update multiple Accordion documents */
  update?: InputMaybe<Array<AccordionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Accordion documents */
  upsert?: InputMaybe<Array<AccordionUpsertWithNestedWhereUniqueInput>>;
};

export type AccordionUpdateManyInput = {
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  navUrl?: InputMaybe<Scalars['String']['input']>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccordionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AccordionUpdateManyInput;
  /** Document search */
  where: AccordionWhereInput;
};

export type AccordionUpdateOneInlineInput = {
  /** Connect existing Accordion document */
  connect?: InputMaybe<AccordionWhereUniqueInput>;
  /** Create and connect one Accordion document */
  create?: InputMaybe<AccordionCreateInput>;
  /** Delete currently connected Accordion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Accordion document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Accordion document */
  update?: InputMaybe<AccordionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Accordion document */
  upsert?: InputMaybe<AccordionUpsertWithNestedWhereUniqueInput>;
};

export type AccordionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AccordionUpdateInput;
  /** Unique document search */
  where: AccordionWhereUniqueInput;
};

export type AccordionUpsertInput = {
  /** Create document if it didn't exist */
  create: AccordionCreateInput;
  /** Update document if it exists */
  update: AccordionUpdateInput;
};

export type AccordionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AccordionUpsertInput;
  /** Unique document search */
  where: AccordionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AccordionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AccordionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordionItems_every?: InputMaybe<AccordionItemWhereInput>;
  accordionItems_none?: InputMaybe<AccordionItemWhereInput>;
  accordionItems_some?: InputMaybe<AccordionItemWhereInput>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  collapsed_not?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AccordionWhereStageInput>;
  documentInStages_none?: InputMaybe<AccordionWhereStageInput>;
  documentInStages_some?: InputMaybe<AccordionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  navUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  navUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  navUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  navUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  navUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  navUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  navUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  navUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  navUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  navUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  numbered_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AccordionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AccordionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AccordionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AccordionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AccordionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Accordion record uniquely */
export type AccordionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Aggregate = {
  __typename?: 'Aggregate';
  count: Scalars['Int']['output'];
};

export type AlexTestComponent = Entity & Node & {
  __typename?: 'AlexTestComponent';
  assetComponent?: Maybe<AssetComponent>;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<AlexTestComponent>;
  /** List of AlexTestComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<AlexTestComponent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type AlexTestComponentAssetComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AlexTestComponentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type AlexTestComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AlexTestComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type AlexTestComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type AlexTestComponentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type AlexTestComponentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type AlexTestComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AlexTestComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type AlexTestComponentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type AlexTestComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AlexTestComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AlexTestComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type AlexTestComponentConnection = {
  __typename?: 'AlexTestComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AlexTestComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AlexTestComponentCreateInput = {
  assetComponent?: InputMaybe<AssetComponentCreateOneInlineInput>;
  /** cmsTitle input for default locale (default) */
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AlexTestComponentCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AlexTestComponentCreateLocalizationDataInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AlexTestComponentCreateLocalizationInput = {
  /** Localization input */
  data: AlexTestComponentCreateLocalizationDataInput;
  locale: Locale;
};

export type AlexTestComponentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AlexTestComponentCreateLocalizationInput>>;
};

export type AlexTestComponentCreateManyInlineInput = {
  /** Connect multiple existing AlexTestComponent documents */
  connect?: InputMaybe<Array<AlexTestComponentWhereUniqueInput>>;
  /** Create and connect multiple existing AlexTestComponent documents */
  create?: InputMaybe<Array<AlexTestComponentCreateInput>>;
};

export type AlexTestComponentCreateOneInlineInput = {
  /** Connect one existing AlexTestComponent document */
  connect?: InputMaybe<AlexTestComponentWhereUniqueInput>;
  /** Create and connect one AlexTestComponent document */
  create?: InputMaybe<AlexTestComponentCreateInput>;
};

/** An edge in a connection. */
export type AlexTestComponentEdge = {
  __typename?: 'AlexTestComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlexTestComponent;
};

/** Identifies documents */
export type AlexTestComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AlexTestComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AlexTestComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AlexTestComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetComponent?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AlexTestComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<AlexTestComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<AlexTestComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AlexTestComponentOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AlexTestComponentUpdateInput = {
  assetComponent?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  /** cmsTitle input for default locale (default) */
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<AlexTestComponentUpdateLocalizationsInput>;
};

export type AlexTestComponentUpdateLocalizationDataInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
};

export type AlexTestComponentUpdateLocalizationInput = {
  data: AlexTestComponentUpdateLocalizationDataInput;
  locale: Locale;
};

export type AlexTestComponentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AlexTestComponentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AlexTestComponentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AlexTestComponentUpsertLocalizationInput>>;
};

export type AlexTestComponentUpdateManyInlineInput = {
  /** Connect multiple existing AlexTestComponent documents */
  connect?: InputMaybe<Array<AlexTestComponentConnectInput>>;
  /** Create and connect multiple AlexTestComponent documents */
  create?: InputMaybe<Array<AlexTestComponentCreateInput>>;
  /** Delete multiple AlexTestComponent documents */
  delete?: InputMaybe<Array<AlexTestComponentWhereUniqueInput>>;
  /** Disconnect multiple AlexTestComponent documents */
  disconnect?: InputMaybe<Array<AlexTestComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AlexTestComponent documents */
  set?: InputMaybe<Array<AlexTestComponentWhereUniqueInput>>;
  /** Update multiple AlexTestComponent documents */
  update?: InputMaybe<Array<AlexTestComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AlexTestComponent documents */
  upsert?: InputMaybe<Array<AlexTestComponentUpsertWithNestedWhereUniqueInput>>;
};

export type AlexTestComponentUpdateManyInput = {
  /** cmsTitle input for default locale (default) */
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<AlexTestComponentUpdateManyLocalizationsInput>;
};

export type AlexTestComponentUpdateManyLocalizationDataInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
};

export type AlexTestComponentUpdateManyLocalizationInput = {
  data: AlexTestComponentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type AlexTestComponentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<AlexTestComponentUpdateManyLocalizationInput>>;
};

export type AlexTestComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AlexTestComponentUpdateManyInput;
  /** Document search */
  where: AlexTestComponentWhereInput;
};

export type AlexTestComponentUpdateOneInlineInput = {
  /** Connect existing AlexTestComponent document */
  connect?: InputMaybe<AlexTestComponentWhereUniqueInput>;
  /** Create and connect one AlexTestComponent document */
  create?: InputMaybe<AlexTestComponentCreateInput>;
  /** Delete currently connected AlexTestComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AlexTestComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AlexTestComponent document */
  update?: InputMaybe<AlexTestComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AlexTestComponent document */
  upsert?: InputMaybe<AlexTestComponentUpsertWithNestedWhereUniqueInput>;
};

export type AlexTestComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AlexTestComponentUpdateInput;
  /** Unique document search */
  where: AlexTestComponentWhereUniqueInput;
};

export type AlexTestComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: AlexTestComponentCreateInput;
  /** Update document if it exists */
  update: AlexTestComponentUpdateInput;
};

export type AlexTestComponentUpsertLocalizationInput = {
  create: AlexTestComponentCreateLocalizationDataInput;
  locale: Locale;
  update: AlexTestComponentUpdateLocalizationDataInput;
};

export type AlexTestComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AlexTestComponentUpsertInput;
  /** Unique document search */
  where: AlexTestComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AlexTestComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AlexTestComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AlexTestComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AlexTestComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AlexTestComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetComponent?: InputMaybe<AssetComponentWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AlexTestComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<AlexTestComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<AlexTestComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AlexTestComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AlexTestComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AlexTestComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AlexTestComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AlexTestComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AlexTestComponent record uniquely */
export type AlexTestComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AlgoliaExtension = Entity & Node & {
  __typename?: 'AlgoliaExtension';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<AlgoliaExtension>;
  environment: DbEnvironment;
  extension?: Maybe<Scalars['Json']['output']>;
  /** List of AlgoliaExtension versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** field to select the market to query */
  markets: Markets;
  products?: Maybe<Scalars['Json']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  tipsAndTricks?: Maybe<Scalars['Json']['output']>;
  /** This is only used internally and won't be shown on the site */
  title?: Maybe<Scalars['String']['output']>;
  /** Note: Top Rated can only be used in the Accordion component. Please do not use in other components. */
  topRated?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type AlgoliaExtensionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AlgoliaExtensionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type AlgoliaExtensionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type AlgoliaExtensionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AlgoliaExtensionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type AlgoliaExtensionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AlgoliaExtensionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AlgoliaExtensionWhereUniqueInput;
};

/** A connection to a list of items. */
export type AlgoliaExtensionConnection = {
  __typename?: 'AlgoliaExtensionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AlgoliaExtensionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AlgoliaExtensionCreateInput = {
  cksiw0ula2b4s01xl8e1i7zfj?: InputMaybe<GenericAccordionTopRatedCreateManyInlineInput>;
  cksn2f67511sp01y2e9hg1dqr?: InputMaybe<GenericCardCarouseComponentCreateManyInlineInput>;
  cksogvh9x1sgv01w9e5lhachb?: InputMaybe<DynamicCardGridCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  environment: DbEnvironment;
  extension?: InputMaybe<Scalars['Json']['input']>;
  markets: Markets;
  products?: InputMaybe<Scalars['Json']['input']>;
  tipsAndTricks?: InputMaybe<Scalars['Json']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topRated?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AlgoliaExtensionCreateManyInlineInput = {
  /** Connect multiple existing AlgoliaExtension documents */
  connect?: InputMaybe<Array<AlgoliaExtensionWhereUniqueInput>>;
  /** Create and connect multiple existing AlgoliaExtension documents */
  create?: InputMaybe<Array<AlgoliaExtensionCreateInput>>;
};

export type AlgoliaExtensionCreateOneInlineInput = {
  /** Connect one existing AlgoliaExtension document */
  connect?: InputMaybe<AlgoliaExtensionWhereUniqueInput>;
  /** Create and connect one AlgoliaExtension document */
  create?: InputMaybe<AlgoliaExtensionCreateInput>;
};

/** An edge in a connection. */
export type AlgoliaExtensionEdge = {
  __typename?: 'AlgoliaExtensionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AlgoliaExtension;
};

/** Identifies documents */
export type AlgoliaExtensionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AlgoliaExtensionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AlgoliaExtensionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AlgoliaExtensionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AlgoliaExtensionWhereStageInput>;
  documentInStages_none?: InputMaybe<AlgoliaExtensionWhereStageInput>;
  documentInStages_some?: InputMaybe<AlgoliaExtensionWhereStageInput>;
  environment?: InputMaybe<DbEnvironment>;
  /** All values that are contained in given list. */
  environment_in?: InputMaybe<Array<InputMaybe<DbEnvironment>>>;
  /** Any other value that exists and is not equal to the given value. */
  environment_not?: InputMaybe<DbEnvironment>;
  /** All values that are not contained in given list. */
  environment_not_in?: InputMaybe<Array<InputMaybe<DbEnvironment>>>;
  /** All values containing the given json path. */
  extension_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  extension_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  markets?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  markets_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  markets_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  markets_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** All values containing the given json path. */
  products_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  products_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values containing the given json path. */
  tipsAndTricks_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  tipsAndTricks_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  topRated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  topRated_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AlgoliaExtensionOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  environment_ASC = 'environment_ASC',
  environment_DESC = 'environment_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  markets_ASC = 'markets_ASC',
  markets_DESC = 'markets_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  topRated_ASC = 'topRated_ASC',
  topRated_DESC = 'topRated_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AlgoliaExtensionUpdateInput = {
  cksiw0ula2b4s01xl8e1i7zfj?: InputMaybe<GenericAccordionTopRatedUpdateManyInlineInput>;
  cksn2f67511sp01y2e9hg1dqr?: InputMaybe<GenericCardCarouseComponentUpdateManyInlineInput>;
  cksogvh9x1sgv01w9e5lhachb?: InputMaybe<DynamicCardGridUpdateManyInlineInput>;
  environment?: InputMaybe<DbEnvironment>;
  extension?: InputMaybe<Scalars['Json']['input']>;
  markets?: InputMaybe<Markets>;
  products?: InputMaybe<Scalars['Json']['input']>;
  tipsAndTricks?: InputMaybe<Scalars['Json']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topRated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AlgoliaExtensionUpdateManyInlineInput = {
  /** Connect multiple existing AlgoliaExtension documents */
  connect?: InputMaybe<Array<AlgoliaExtensionConnectInput>>;
  /** Create and connect multiple AlgoliaExtension documents */
  create?: InputMaybe<Array<AlgoliaExtensionCreateInput>>;
  /** Delete multiple AlgoliaExtension documents */
  delete?: InputMaybe<Array<AlgoliaExtensionWhereUniqueInput>>;
  /** Disconnect multiple AlgoliaExtension documents */
  disconnect?: InputMaybe<Array<AlgoliaExtensionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AlgoliaExtension documents */
  set?: InputMaybe<Array<AlgoliaExtensionWhereUniqueInput>>;
  /** Update multiple AlgoliaExtension documents */
  update?: InputMaybe<Array<AlgoliaExtensionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AlgoliaExtension documents */
  upsert?: InputMaybe<Array<AlgoliaExtensionUpsertWithNestedWhereUniqueInput>>;
};

export type AlgoliaExtensionUpdateManyInput = {
  environment?: InputMaybe<DbEnvironment>;
  extension?: InputMaybe<Scalars['Json']['input']>;
  markets?: InputMaybe<Markets>;
  products?: InputMaybe<Scalars['Json']['input']>;
  tipsAndTricks?: InputMaybe<Scalars['Json']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  topRated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AlgoliaExtensionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AlgoliaExtensionUpdateManyInput;
  /** Document search */
  where: AlgoliaExtensionWhereInput;
};

export type AlgoliaExtensionUpdateOneInlineInput = {
  /** Connect existing AlgoliaExtension document */
  connect?: InputMaybe<AlgoliaExtensionWhereUniqueInput>;
  /** Create and connect one AlgoliaExtension document */
  create?: InputMaybe<AlgoliaExtensionCreateInput>;
  /** Delete currently connected AlgoliaExtension document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AlgoliaExtension document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AlgoliaExtension document */
  update?: InputMaybe<AlgoliaExtensionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AlgoliaExtension document */
  upsert?: InputMaybe<AlgoliaExtensionUpsertWithNestedWhereUniqueInput>;
};

export type AlgoliaExtensionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AlgoliaExtensionUpdateInput;
  /** Unique document search */
  where: AlgoliaExtensionWhereUniqueInput;
};

export type AlgoliaExtensionUpsertInput = {
  /** Create document if it didn't exist */
  create: AlgoliaExtensionCreateInput;
  /** Update document if it exists */
  update: AlgoliaExtensionUpdateInput;
};

export type AlgoliaExtensionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AlgoliaExtensionUpsertInput;
  /** Unique document search */
  where: AlgoliaExtensionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AlgoliaExtensionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AlgoliaExtensionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AlgoliaExtensionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AlgoliaExtensionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AlgoliaExtensionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AlgoliaExtensionWhereStageInput>;
  documentInStages_none?: InputMaybe<AlgoliaExtensionWhereStageInput>;
  documentInStages_some?: InputMaybe<AlgoliaExtensionWhereStageInput>;
  environment?: InputMaybe<DbEnvironment>;
  /** All values that are contained in given list. */
  environment_in?: InputMaybe<Array<InputMaybe<DbEnvironment>>>;
  /** Any other value that exists and is not equal to the given value. */
  environment_not?: InputMaybe<DbEnvironment>;
  /** All values that are not contained in given list. */
  environment_not_in?: InputMaybe<Array<InputMaybe<DbEnvironment>>>;
  /** All values containing the given json path. */
  extension_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  extension_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  markets?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  markets_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  markets_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  markets_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** All values containing the given json path. */
  products_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  products_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values containing the given json path. */
  tipsAndTricks_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  tipsAndTricks_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  topRated?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  topRated_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AlgoliaExtensionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AlgoliaExtensionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AlgoliaExtensionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AlgoliaExtensionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AlgoliaExtensionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AlgoliaExtension record uniquely */
export type AlgoliaExtensionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum AlignmentTypes {
  Center = 'Center',
  Left = 'Left',
  Right = 'Right'
}

/** this will be deprecated soon */
export type AnchorNav = Entity & Node & {
  __typename?: 'AnchorNav';
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<AnchorNav>;
  /** List of AnchorNav versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  links: Array<Link>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** this will be deprecated soon */
export type AnchorNavCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** this will be deprecated soon */
export type AnchorNavDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** this will be deprecated soon */
export type AnchorNavHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** this will be deprecated soon */
export type AnchorNavLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


/** this will be deprecated soon */
export type AnchorNavPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** this will be deprecated soon */
export type AnchorNavScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** this will be deprecated soon */
export type AnchorNavUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AnchorNavConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AnchorNavWhereUniqueInput;
};

/** A connection to a list of items. */
export type AnchorNavConnection = {
  __typename?: 'AnchorNavConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AnchorNavEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AnchorNavCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  links?: InputMaybe<LinkCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnchorNavCreateManyInlineInput = {
  /** Connect multiple existing AnchorNav documents */
  connect?: InputMaybe<Array<AnchorNavWhereUniqueInput>>;
  /** Create and connect multiple existing AnchorNav documents */
  create?: InputMaybe<Array<AnchorNavCreateInput>>;
};

export type AnchorNavCreateOneInlineInput = {
  /** Connect one existing AnchorNav document */
  connect?: InputMaybe<AnchorNavWhereUniqueInput>;
  /** Create and connect one AnchorNav document */
  create?: InputMaybe<AnchorNavCreateInput>;
};

/** An edge in a connection. */
export type AnchorNavEdge = {
  __typename?: 'AnchorNavEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AnchorNav;
};

/** Identifies documents */
export type AnchorNavManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AnchorNavWhereStageInput>;
  documentInStages_none?: InputMaybe<AnchorNavWhereStageInput>;
  documentInStages_some?: InputMaybe<AnchorNavWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AnchorNavOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AnchorNavUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<LinkUpdateManyInlineInput>;
};

export type AnchorNavUpdateManyInlineInput = {
  /** Connect multiple existing AnchorNav documents */
  connect?: InputMaybe<Array<AnchorNavConnectInput>>;
  /** Create and connect multiple AnchorNav documents */
  create?: InputMaybe<Array<AnchorNavCreateInput>>;
  /** Delete multiple AnchorNav documents */
  delete?: InputMaybe<Array<AnchorNavWhereUniqueInput>>;
  /** Disconnect multiple AnchorNav documents */
  disconnect?: InputMaybe<Array<AnchorNavWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AnchorNav documents */
  set?: InputMaybe<Array<AnchorNavWhereUniqueInput>>;
  /** Update multiple AnchorNav documents */
  update?: InputMaybe<Array<AnchorNavUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AnchorNav documents */
  upsert?: InputMaybe<Array<AnchorNavUpsertWithNestedWhereUniqueInput>>;
};

export type AnchorNavUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
};

export type AnchorNavUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AnchorNavUpdateManyInput;
  /** Document search */
  where: AnchorNavWhereInput;
};

export type AnchorNavUpdateOneInlineInput = {
  /** Connect existing AnchorNav document */
  connect?: InputMaybe<AnchorNavWhereUniqueInput>;
  /** Create and connect one AnchorNav document */
  create?: InputMaybe<AnchorNavCreateInput>;
  /** Delete currently connected AnchorNav document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AnchorNav document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AnchorNav document */
  update?: InputMaybe<AnchorNavUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AnchorNav document */
  upsert?: InputMaybe<AnchorNavUpsertWithNestedWhereUniqueInput>;
};

export type AnchorNavUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AnchorNavUpdateInput;
  /** Unique document search */
  where: AnchorNavWhereUniqueInput;
};

export type AnchorNavUpsertInput = {
  /** Create document if it didn't exist */
  create: AnchorNavCreateInput;
  /** Update document if it exists */
  update: AnchorNavUpdateInput;
};

export type AnchorNavUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AnchorNavUpsertInput;
  /** Unique document search */
  where: AnchorNavWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AnchorNavWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AnchorNavWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AnchorNavWhereStageInput>;
  documentInStages_none?: InputMaybe<AnchorNavWhereStageInput>;
  documentInStages_some?: InputMaybe<AnchorNavWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AnchorNavWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AnchorNavWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AnchorNav record uniquely */
export type AnchorNavWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** used to author anchor navigations for each page */
export type AnchorNavigation = Entity & Node & {
  __typename?: 'AnchorNavigation';
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** reference for authorable components */
  component: Array<NavLinkComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<AnchorNavigation>;
  /** select the external component displayed on this page (recipe/ tips and tricks etc) */
  externalComponent: Array<AnchorNavigationExternalComponents>;
  /** List of AnchorNavigation versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<AnchorNavigation>;
  navigationTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** used to author anchor navigations for each page */
export type AnchorNavigationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AnchorNavigationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AnchorNavigationWhereUniqueInput;
};

/** A connection to a list of items. */
export type AnchorNavigationConnection = {
  __typename?: 'AnchorNavigationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AnchorNavigationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AnchorNavigationCreateInput = {
  ckugul8wz9ryq01xh1lxag0vv?: InputMaybe<AnchorNavigationListCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  component?: InputMaybe<NavLinkComponentCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** externalComponent input for default locale (default) */
  externalComponent?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AnchorNavigationCreateLocalizationsInput>;
  /** navigationTitle input for default locale (default) */
  navigationTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnchorNavigationCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  externalComponent?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  navigationTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnchorNavigationCreateLocalizationInput = {
  /** Localization input */
  data: AnchorNavigationCreateLocalizationDataInput;
  locale: Locale;
};

export type AnchorNavigationCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AnchorNavigationCreateLocalizationInput>>;
};

export type AnchorNavigationCreateManyInlineInput = {
  /** Connect multiple existing AnchorNavigation documents */
  connect?: InputMaybe<Array<AnchorNavigationWhereUniqueInput>>;
  /** Create and connect multiple existing AnchorNavigation documents */
  create?: InputMaybe<Array<AnchorNavigationCreateInput>>;
};

export type AnchorNavigationCreateOneInlineInput = {
  /** Connect one existing AnchorNavigation document */
  connect?: InputMaybe<AnchorNavigationWhereUniqueInput>;
  /** Create and connect one AnchorNavigation document */
  create?: InputMaybe<AnchorNavigationCreateInput>;
};

/** An edge in a connection. */
export type AnchorNavigationEdge = {
  __typename?: 'AnchorNavigationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AnchorNavigation;
};

/** enumeration for componnets used in pages like recipes, tips and tricks, products, details pages */
export enum AnchorNavigationExternalComponents {
  ProductDetailPage_Footer = 'ProductDetailPage_Footer',
  ProductDetailPage_Hero_Banner = 'ProductDetailPage_Hero_Banner',
  ProductDetailPage_Recipe_Nutrition = 'ProductDetailPage_Recipe_Nutrition',
  ProductDetailPage_Related_Recipe = 'ProductDetailPage_Related_Recipe',
  ProductDetailPage_Social_Media = 'ProductDetailPage_Social_Media',
  ProductLandingPage_Category_Subcategory = 'ProductLandingPage_Category_Subcategory',
  ProductLandingPage_Footer = 'ProductLandingPage_Footer'
}

/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationList = Entity & Node & {
  __typename?: 'AnchorNavigationList';
  /** list of anchor navigation links */
  anchorNavigations: Array<AnchorNavigation>;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<AnchorNavigationList>;
  genericPage?: Maybe<GenericPage>;
  genericPages: Array<GenericPage>;
  /** List of AnchorNavigationList versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListAnchorNavigationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AnchorNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorNavigationWhereInput>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListGenericPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** list of all anchor navigation lists that should appear on a page */
export type AnchorNavigationListUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AnchorNavigationListConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AnchorNavigationListWhereUniqueInput;
};

/** A connection to a list of items. */
export type AnchorNavigationListConnection = {
  __typename?: 'AnchorNavigationListConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AnchorNavigationListEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AnchorNavigationListCreateInput = {
  anchorNavigations?: InputMaybe<AnchorNavigationCreateManyInlineInput>;
  ckunnoqb44a6n01xp9zt7cqwj?: InputMaybe<TipsAndTricksDetailsPageCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPage?: InputMaybe<GenericPageCreateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AnchorNavigationListCreateManyInlineInput = {
  /** Connect multiple existing AnchorNavigationList documents */
  connect?: InputMaybe<Array<AnchorNavigationListWhereUniqueInput>>;
  /** Create and connect multiple existing AnchorNavigationList documents */
  create?: InputMaybe<Array<AnchorNavigationListCreateInput>>;
};

export type AnchorNavigationListCreateOneInlineInput = {
  /** Connect one existing AnchorNavigationList document */
  connect?: InputMaybe<AnchorNavigationListWhereUniqueInput>;
  /** Create and connect one AnchorNavigationList document */
  create?: InputMaybe<AnchorNavigationListCreateInput>;
};

/** An edge in a connection. */
export type AnchorNavigationListEdge = {
  __typename?: 'AnchorNavigationListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AnchorNavigationList;
};

/** Identifies documents */
export type AnchorNavigationListManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavigationListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavigationListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavigationListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNavigations_every?: InputMaybe<AnchorNavigationWhereInput>;
  anchorNavigations_none?: InputMaybe<AnchorNavigationWhereInput>;
  anchorNavigations_some?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AnchorNavigationListWhereStageInput>;
  documentInStages_none?: InputMaybe<AnchorNavigationListWhereStageInput>;
  documentInStages_some?: InputMaybe<AnchorNavigationListWhereStageInput>;
  genericPage?: InputMaybe<GenericPageWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AnchorNavigationListOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AnchorNavigationListUpdateInput = {
  anchorNavigations?: InputMaybe<AnchorNavigationUpdateManyInlineInput>;
  ckunnoqb44a6n01xp9zt7cqwj?: InputMaybe<TipsAndTricksDetailsPageUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  genericPage?: InputMaybe<GenericPageUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
};

export type AnchorNavigationListUpdateManyInlineInput = {
  /** Connect multiple existing AnchorNavigationList documents */
  connect?: InputMaybe<Array<AnchorNavigationListConnectInput>>;
  /** Create and connect multiple AnchorNavigationList documents */
  create?: InputMaybe<Array<AnchorNavigationListCreateInput>>;
  /** Delete multiple AnchorNavigationList documents */
  delete?: InputMaybe<Array<AnchorNavigationListWhereUniqueInput>>;
  /** Disconnect multiple AnchorNavigationList documents */
  disconnect?: InputMaybe<Array<AnchorNavigationListWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AnchorNavigationList documents */
  set?: InputMaybe<Array<AnchorNavigationListWhereUniqueInput>>;
  /** Update multiple AnchorNavigationList documents */
  update?: InputMaybe<Array<AnchorNavigationListUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AnchorNavigationList documents */
  upsert?: InputMaybe<Array<AnchorNavigationListUpsertWithNestedWhereUniqueInput>>;
};

export type AnchorNavigationListUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
};

export type AnchorNavigationListUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AnchorNavigationListUpdateManyInput;
  /** Document search */
  where: AnchorNavigationListWhereInput;
};

export type AnchorNavigationListUpdateOneInlineInput = {
  /** Connect existing AnchorNavigationList document */
  connect?: InputMaybe<AnchorNavigationListWhereUniqueInput>;
  /** Create and connect one AnchorNavigationList document */
  create?: InputMaybe<AnchorNavigationListCreateInput>;
  /** Delete currently connected AnchorNavigationList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AnchorNavigationList document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AnchorNavigationList document */
  update?: InputMaybe<AnchorNavigationListUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AnchorNavigationList document */
  upsert?: InputMaybe<AnchorNavigationListUpsertWithNestedWhereUniqueInput>;
};

export type AnchorNavigationListUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AnchorNavigationListUpdateInput;
  /** Unique document search */
  where: AnchorNavigationListWhereUniqueInput;
};

export type AnchorNavigationListUpsertInput = {
  /** Create document if it didn't exist */
  create: AnchorNavigationListCreateInput;
  /** Update document if it exists */
  update: AnchorNavigationListUpdateInput;
};

export type AnchorNavigationListUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AnchorNavigationListUpsertInput;
  /** Unique document search */
  where: AnchorNavigationListWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AnchorNavigationListWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AnchorNavigationListWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavigationListWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavigationListWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavigationListWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNavigations_every?: InputMaybe<AnchorNavigationWhereInput>;
  anchorNavigations_none?: InputMaybe<AnchorNavigationWhereInput>;
  anchorNavigations_some?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AnchorNavigationListWhereStageInput>;
  documentInStages_none?: InputMaybe<AnchorNavigationListWhereStageInput>;
  documentInStages_some?: InputMaybe<AnchorNavigationListWhereStageInput>;
  genericPage?: InputMaybe<GenericPageWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AnchorNavigationListWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavigationListWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavigationListWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavigationListWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AnchorNavigationListWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AnchorNavigationList record uniquely */
export type AnchorNavigationListWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type AnchorNavigationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  component_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  component_some?: InputMaybe<NavLinkComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AnchorNavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<AnchorNavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<AnchorNavigationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AnchorNavigationOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  externalComponent_ASC = 'externalComponent_ASC',
  externalComponent_DESC = 'externalComponent_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  navigationTitle_ASC = 'navigationTitle_ASC',
  navigationTitle_DESC = 'navigationTitle_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AnchorNavigationUpdateInput = {
  ckugul8wz9ryq01xh1lxag0vv?: InputMaybe<AnchorNavigationListUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  component?: InputMaybe<NavLinkComponentUpdateManyInlineInput>;
  /** externalComponent input for default locale (default) */
  externalComponent?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  /** Manage document localizations */
  localizations?: InputMaybe<AnchorNavigationUpdateLocalizationsInput>;
  /** navigationTitle input for default locale (default) */
  navigationTitle?: InputMaybe<Scalars['String']['input']>;
};

export type AnchorNavigationUpdateLocalizationDataInput = {
  externalComponent?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  navigationTitle?: InputMaybe<Scalars['String']['input']>;
};

export type AnchorNavigationUpdateLocalizationInput = {
  data: AnchorNavigationUpdateLocalizationDataInput;
  locale: Locale;
};

export type AnchorNavigationUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AnchorNavigationCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AnchorNavigationUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AnchorNavigationUpsertLocalizationInput>>;
};

export type AnchorNavigationUpdateManyInlineInput = {
  /** Connect multiple existing AnchorNavigation documents */
  connect?: InputMaybe<Array<AnchorNavigationConnectInput>>;
  /** Create and connect multiple AnchorNavigation documents */
  create?: InputMaybe<Array<AnchorNavigationCreateInput>>;
  /** Delete multiple AnchorNavigation documents */
  delete?: InputMaybe<Array<AnchorNavigationWhereUniqueInput>>;
  /** Disconnect multiple AnchorNavigation documents */
  disconnect?: InputMaybe<Array<AnchorNavigationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AnchorNavigation documents */
  set?: InputMaybe<Array<AnchorNavigationWhereUniqueInput>>;
  /** Update multiple AnchorNavigation documents */
  update?: InputMaybe<Array<AnchorNavigationUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AnchorNavigation documents */
  upsert?: InputMaybe<Array<AnchorNavigationUpsertWithNestedWhereUniqueInput>>;
};

export type AnchorNavigationUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** externalComponent input for default locale (default) */
  externalComponent?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<AnchorNavigationUpdateManyLocalizationsInput>;
  /** navigationTitle input for default locale (default) */
  navigationTitle?: InputMaybe<Scalars['String']['input']>;
};

export type AnchorNavigationUpdateManyLocalizationDataInput = {
  externalComponent?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  navigationTitle?: InputMaybe<Scalars['String']['input']>;
};

export type AnchorNavigationUpdateManyLocalizationInput = {
  data: AnchorNavigationUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type AnchorNavigationUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<AnchorNavigationUpdateManyLocalizationInput>>;
};

export type AnchorNavigationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AnchorNavigationUpdateManyInput;
  /** Document search */
  where: AnchorNavigationWhereInput;
};

export type AnchorNavigationUpdateOneInlineInput = {
  /** Connect existing AnchorNavigation document */
  connect?: InputMaybe<AnchorNavigationWhereUniqueInput>;
  /** Create and connect one AnchorNavigation document */
  create?: InputMaybe<AnchorNavigationCreateInput>;
  /** Delete currently connected AnchorNavigation document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AnchorNavigation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AnchorNavigation document */
  update?: InputMaybe<AnchorNavigationUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AnchorNavigation document */
  upsert?: InputMaybe<AnchorNavigationUpsertWithNestedWhereUniqueInput>;
};

export type AnchorNavigationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AnchorNavigationUpdateInput;
  /** Unique document search */
  where: AnchorNavigationWhereUniqueInput;
};

export type AnchorNavigationUpsertInput = {
  /** Create document if it didn't exist */
  create: AnchorNavigationCreateInput;
  /** Update document if it exists */
  update: AnchorNavigationUpdateInput;
};

export type AnchorNavigationUpsertLocalizationInput = {
  create: AnchorNavigationCreateLocalizationDataInput;
  locale: Locale;
  update: AnchorNavigationUpdateLocalizationDataInput;
};

export type AnchorNavigationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AnchorNavigationUpsertInput;
  /** Unique document search */
  where: AnchorNavigationWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AnchorNavigationWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AnchorNavigationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  component_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  component_some?: InputMaybe<NavLinkComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AnchorNavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<AnchorNavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<AnchorNavigationWhereStageInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  externalComponent?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  /** Matches if the field array contains *all* items provided to the filter */
  externalComponent_contains_all?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  externalComponent_contains_none?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  /** Matches if the field array contains at least one item provided to the filter */
  externalComponent_contains_some?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  externalComponent_not?: InputMaybe<Array<AnchorNavigationExternalComponents>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  navigationTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  navigationTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  navigationTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  navigationTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  navigationTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  navigationTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  navigationTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  navigationTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  navigationTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  navigationTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AnchorNavigationWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AnchorNavigationWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AnchorNavigationWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AnchorNavigationWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AnchorNavigationWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AnchorNavigation record uniquely */
export type AnchorNavigationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Asset system model */
export type Asset = Entity & Node & {
  __typename?: 'Asset';
  /** Please add an alt text for any asset being uploaded */
  altText?: Maybe<Scalars['String']['output']>;
  /** Please dont upload any asset bigger than 3mb. This is for site performance reasons. */
  assetAssetComponent: Array<AssetComponent>;
  audioFileAudioComponent: Array<AudioComponent>;
  backgroundImgCarouselComponent: Array<CarouselComponent>;
  bannerImageCorpHero: Array<CorpHero>;
  bannerImageCorpVideoHero: Array<CorpVideoHero>;
  bannerImageHeroBanner: Array<HeroBanner>;
  bottomLeftAssetCarouselComponent: Array<CarouselComponent>;
  bottomLeftImageAssetHeroComponent: Array<HeroComponent>;
  /** Optional caption for asset */
  caption?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Asset>;
  downloadImagePressRelease: Array<PressRelease>;
  downloadPrPressRelease: Array<PressRelease>;
  downloadableFileGenericDownloadComponent: Array<GenericDownloadComponent>;
  /** The file name */
  fileName: Scalars['String']['output'];
  forAllRecipePagesSubCategoryKeyImage: Array<SubCategoryKeyImage>;
  forRecipeCategoryPageSubCategoryKeyImage: Array<SubCategoryKeyImage>;
  /** The file handle */
  handle: Scalars['String']['output'];
  /** The height of the file */
  height?: Maybe<Scalars['Float']['output']>;
  /** List of Asset versions */
  history: Array<Version>;
  iconLeftFormSelectOption: Array<FormSelectOption>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  imageGlobalMetaData: Array<GlobalMetaData>;
  imagePressRelease: Array<PressRelease>;
  imageStory: Array<Story>;
  imagesMetaData: Array<MetaData>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Asset>;
  /** The mime type of the file */
  mimeType?: Maybe<Scalars['String']['output']>;
  mobileImageCorpHero: Array<CorpHero>;
  mobileImageCorpVideoHero: Array<CorpVideoHero>;
  mobileImageHeroBanner: Array<HeroBanner>;
  mobileImageHeroComponent: Array<HeroComponent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** The file size */
  size?: Maybe<Scalars['Float']['output']>;
  slideAssetCarouselSlide: Array<CarouselSlide>;
  /** System stage field */
  stage: Stage;
  topRightAssetCarouselComponent: Array<CarouselComponent>;
  topRightImageAssetHeroComponent: Array<HeroComponent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Returns information you need to upload the asset. The type of upload is dependant on what you pass into asset creations as upload type. */
  upload?: Maybe<AssetUpload>;
  /** Get the url for the asset with provided transformations applied. */
  url: Scalars['String']['output'];
  /** The file width */
  width?: Maybe<Scalars['Float']['output']>;
};


/** Asset system model */
export type AssetAssetAssetComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentWhereInput>;
};


/** Asset system model */
export type AssetAudioFileAudioComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AudioComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AudioComponentWhereInput>;
};


/** Asset system model */
export type AssetBackgroundImgCarouselComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselComponentWhereInput>;
};


/** Asset system model */
export type AssetBannerImageCorpHeroArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CorpHeroOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpHeroWhereInput>;
};


/** Asset system model */
export type AssetBannerImageCorpVideoHeroArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CorpVideoHeroOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpVideoHeroWhereInput>;
};


/** Asset system model */
export type AssetBannerImageHeroBannerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroBannerWhereInput>;
};


/** Asset system model */
export type AssetBottomLeftAssetCarouselComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselComponentWhereInput>;
};


/** Asset system model */
export type AssetBottomLeftImageAssetHeroComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroComponentWhereInput>;
};


/** Asset system model */
export type AssetCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Asset system model */
export type AssetDownloadImagePressReleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PressReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PressReleaseWhereInput>;
};


/** Asset system model */
export type AssetDownloadPrPressReleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PressReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PressReleaseWhereInput>;
};


/** Asset system model */
export type AssetDownloadableFileGenericDownloadComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericDownloadComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericDownloadComponentWhereInput>;
};


/** Asset system model */
export type AssetForAllRecipePagesSubCategoryKeyImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SubCategoryKeyImageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubCategoryKeyImageWhereInput>;
};


/** Asset system model */
export type AssetForRecipeCategoryPageSubCategoryKeyImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SubCategoryKeyImageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubCategoryKeyImageWhereInput>;
};


/** Asset system model */
export type AssetHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Asset system model */
export type AssetIconLeftFormSelectOptionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormSelectOptionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSelectOptionWhereInput>;
};


/** Asset system model */
export type AssetImageGlobalMetaDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GlobalMetaDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GlobalMetaDataWhereInput>;
};


/** Asset system model */
export type AssetImagePressReleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<PressReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PressReleaseWhereInput>;
};


/** Asset system model */
export type AssetImageStoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<StoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


/** Asset system model */
export type AssetImagesMetaDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<MetaDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetaDataWhereInput>;
};


/** Asset system model */
export type AssetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Asset system model */
export type AssetMobileImageCorpHeroArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CorpHeroOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpHeroWhereInput>;
};


/** Asset system model */
export type AssetMobileImageCorpVideoHeroArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CorpVideoHeroOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpVideoHeroWhereInput>;
};


/** Asset system model */
export type AssetMobileImageHeroBannerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroBannerWhereInput>;
};


/** Asset system model */
export type AssetMobileImageHeroComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroComponentWhereInput>;
};


/** Asset system model */
export type AssetPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Asset system model */
export type AssetSlideAssetCarouselSlideArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CarouselSlideOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselSlideWhereInput>;
};


/** Asset system model */
export type AssetTopRightAssetCarouselComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselComponentWhereInput>;
};


/** Asset system model */
export type AssetTopRightImageAssetHeroComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroComponentWhereInput>;
};


/** Asset system model */
export type AssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset system model */
export type AssetUrlArgs = {
  transformation?: InputMaybe<AssetTransformationInput>;
};

/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponent = Entity & Node & {
  __typename?: 'AssetComponent';
  alexTestComponent?: Maybe<AlexTestComponent>;
  /** Asset to be used on the Oetker platform */
  asset: Array<Asset>;
  audioComponents: Array<AudioComponent>;
  cardComponents: Array<CardComponent>;
  /** Title to be used to identify the image */
  cmsAssetTitle?: Maybe<Scalars['String']['output']>;
  countrySelectorItem?: Maybe<CountrySelectorItem>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<AssetComponent>;
  genericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  genericCardLayoutComponents: Array<GenericCardCarouseComponent>;
  heroComponent?: Maybe<HeroComponent>;
  /** List of AssetComponent versions */
  history: Array<Version>;
  /** Page that this component is also being used on. */
  homePage?: Maybe<HomePage>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  imageAndTextCard?: Maybe<ImageAndTextCard>;
  imageCopyItem?: Maybe<ImageCopyItem>;
  imageCopyItems: Array<ImageCopyItem>;
  leftColumn?: Maybe<LeftColumn>;
  mobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  navigation?: Maybe<Navigation>;
  pressStoriesCard?: Maybe<PressStoriesCard>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  rightColumn?: Maybe<RightColumn>;
  scheduledIn: Array<ScheduledOperation>;
  socialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentAlexTestComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentAssetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentAudioComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AudioComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AudioComponentWhereInput>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentCardComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardComponentWhereInput>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentCountrySelectorItemArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentGenericCardCarouseComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentGenericCardLayoutComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericCardCarouseComponentWhereInput>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentHeroComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentHomePageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentImageAndTextCardArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentImageCopyItemArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentImageCopyItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageCopyItemWhereInput>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentLeftColumnArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentMobileOnlyMainNavigationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentNavigationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentPressStoriesCardArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentRightColumnArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentSocialMediaListComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Asset component to be used to create image pool of reusable assets across the application */
export type AssetComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AssetComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AssetComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type AssetComponentConnection = {
  __typename?: 'AssetComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AssetComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AssetComponentCreateInput = {
  alexTestComponent?: InputMaybe<AlexTestComponentCreateOneInlineInput>;
  asset?: InputMaybe<AssetCreateManyInlineInput>;
  audioComponents?: InputMaybe<AudioComponentCreateManyInlineInput>;
  cardComponents?: InputMaybe<CardComponentCreateManyInlineInput>;
  ckrovksh302bv01xtfgtlcaa8?: InputMaybe<CategoryCardCreateManyInlineInput>;
  ckruap8rn1vif01xzbdup9cjd?: InputMaybe<DeprecatedBanner1CreateManyInlineInput>;
  ckruaq9j01vjq01xz3eykb02p?: InputMaybe<DeprecatedBanner1CreateManyInlineInput>;
  ckruar0081u0i01xh9yyi4oip?: InputMaybe<DeprecatedBanner1CreateManyInlineInput>;
  cks9cwg6f1yqi01wc184refe7?: InputMaybe<Banner2CreateManyInlineInput>;
  cks9v9aou297q01xp179b589s?: InputMaybe<AuthorableContentCardCreateManyInlineInput>;
  cksu3bhyb5ogg01w9589ueomo?: InputMaybe<SustainabilityBannerCreateManyInlineInput>;
  cksu3dg725tgn01yuc2537ro4?: InputMaybe<SustainabilityBannerCreateManyInlineInput>;
  ckt3cnpy0049m01yz1kivcfvi?: InputMaybe<Banner2CreateManyInlineInput>;
  ckta6vdrf3zrf01xq76wdcwyo?: InputMaybe<ExampleComponentCreateManyInlineInput>;
  cktv4dykm0wrp01xz8xswed7w?: InputMaybe<GenericDownloadComponentCreateManyInlineInput>;
  cku3q4xpx6imm01xmgn9nb3zh?: InputMaybe<PopularSearchComponentCreateManyInlineInput>;
  ckuo0nett4rb301z65vyo3xf0?: InputMaybe<SustainabilityInfoCreateManyInlineInput>;
  ckuo0ounf4qr201xpe0y3gyrs?: InputMaybe<SustainabilityInfoCreateManyInlineInput>;
  ckuo0qk6m4rhq01z63gqz7fqq?: InputMaybe<SustainabilityInfoCreateManyInlineInput>;
  ckuo0s22f4qz001xp76kqge4s?: InputMaybe<SustainabilityInfoCreateManyInlineInput>;
  ckxzvp7xy337d01we34797flb?: InputMaybe<LocationComponentCreateManyInlineInput>;
  ckxzvqcwv361f01yu79zygdk2?: InputMaybe<LocationComponentCreateManyInlineInput>;
  cky46xbs60lgg01xlblcz20go?: InputMaybe<MediaLibraryItemCreateManyInlineInput>;
  ckz8dvp3920pt01z0262p5vu6?: InputMaybe<MediaLibraryItemCreateManyInlineInput>;
  cl1c92igs33rd01z3fhcq2cii?: InputMaybe<CorpTimelineAccordionItemCreateManyInlineInput>;
  cl1ywlg6x1ouy01xuhbihbx9e?: InputMaybe<CorpOurPeopleItemCreateManyInlineInput>;
  cl2q0122s547f01xuds18e66m?: InputMaybe<ContactCardCreateManyInlineInput>;
  cl2q16rt254gs01xjfxx34prq?: InputMaybe<CorpContactCardCreateManyInlineInput>;
  cmsAssetTitle?: InputMaybe<Scalars['String']['input']>;
  countrySelectorItem?: InputMaybe<CountrySelectorItemCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateOneInlineInput>;
  genericCardLayoutComponents?: InputMaybe<GenericCardCarouseComponentCreateManyInlineInput>;
  heroComponent?: InputMaybe<HeroComponentCreateOneInlineInput>;
  homePage?: InputMaybe<HomePageCreateOneInlineInput>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardCreateOneInlineInput>;
  imageCopyItem?: InputMaybe<ImageCopyItemCreateOneInlineInput>;
  imageCopyItems?: InputMaybe<ImageCopyItemCreateManyInlineInput>;
  leftColumn?: InputMaybe<LeftColumnCreateOneInlineInput>;
  mobileOnlyMainNavigation?: InputMaybe<MobileOnlyMainNavigationCreateOneInlineInput>;
  navigation?: InputMaybe<NavigationCreateOneInlineInput>;
  pressStoriesCard?: InputMaybe<PressStoriesCardCreateOneInlineInput>;
  rightColumn?: InputMaybe<RightColumnCreateOneInlineInput>;
  socialMediaListComponent?: InputMaybe<SocialMediaListComponentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AssetComponentCreateManyInlineInput = {
  /** Connect multiple existing AssetComponent documents */
  connect?: InputMaybe<Array<AssetComponentWhereUniqueInput>>;
  /** Create and connect multiple existing AssetComponent documents */
  create?: InputMaybe<Array<AssetComponentCreateInput>>;
};

export type AssetComponentCreateOneInlineInput = {
  /** Connect one existing AssetComponent document */
  connect?: InputMaybe<AssetComponentWhereUniqueInput>;
  /** Create and connect one AssetComponent document */
  create?: InputMaybe<AssetComponentCreateInput>;
};

/** An edge in a connection. */
export type AssetComponentEdge = {
  __typename?: 'AssetComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AssetComponent;
};

/** Identifies documents */
export type AssetComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alexTestComponent?: InputMaybe<AlexTestComponentWhereInput>;
  asset_every?: InputMaybe<AssetWhereInput>;
  asset_none?: InputMaybe<AssetWhereInput>;
  asset_some?: InputMaybe<AssetWhereInput>;
  audioComponents_every?: InputMaybe<AudioComponentWhereInput>;
  audioComponents_none?: InputMaybe<AudioComponentWhereInput>;
  audioComponents_some?: InputMaybe<AudioComponentWhereInput>;
  cardComponents_every?: InputMaybe<CardComponentWhereInput>;
  cardComponents_none?: InputMaybe<CardComponentWhereInput>;
  cardComponents_some?: InputMaybe<CardComponentWhereInput>;
  cmsAssetTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsAssetTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsAssetTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsAssetTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsAssetTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsAssetTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsAssetTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsAssetTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsAssetTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsAssetTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  countrySelectorItem?: InputMaybe<CountrySelectorItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetComponentWhereStageInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericCardLayoutComponents_every?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericCardLayoutComponents_none?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericCardLayoutComponents_some?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  heroComponent?: InputMaybe<HeroComponentWhereInput>;
  homePage?: InputMaybe<HomePageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardWhereInput>;
  imageCopyItem?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopyItems_every?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopyItems_none?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopyItems_some?: InputMaybe<ImageCopyItemWhereInput>;
  leftColumn?: InputMaybe<LeftColumnWhereInput>;
  mobileOnlyMainNavigation?: InputMaybe<MobileOnlyMainNavigationWhereInput>;
  navigation?: InputMaybe<NavigationWhereInput>;
  pressStoriesCard?: InputMaybe<PressStoriesCardWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  rightColumn?: InputMaybe<RightColumnWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  socialMediaListComponent?: InputMaybe<SocialMediaListComponentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AssetComponentOrderByInput {
  cmsAssetTitle_ASC = 'cmsAssetTitle_ASC',
  cmsAssetTitle_DESC = 'cmsAssetTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AssetComponentUpdateInput = {
  alexTestComponent?: InputMaybe<AlexTestComponentUpdateOneInlineInput>;
  asset?: InputMaybe<AssetUpdateManyInlineInput>;
  audioComponents?: InputMaybe<AudioComponentUpdateManyInlineInput>;
  cardComponents?: InputMaybe<CardComponentUpdateManyInlineInput>;
  ckrovksh302bv01xtfgtlcaa8?: InputMaybe<CategoryCardUpdateManyInlineInput>;
  ckruap8rn1vif01xzbdup9cjd?: InputMaybe<DeprecatedBanner1UpdateManyInlineInput>;
  ckruaq9j01vjq01xz3eykb02p?: InputMaybe<DeprecatedBanner1UpdateManyInlineInput>;
  ckruar0081u0i01xh9yyi4oip?: InputMaybe<DeprecatedBanner1UpdateManyInlineInput>;
  cks9cwg6f1yqi01wc184refe7?: InputMaybe<Banner2UpdateManyInlineInput>;
  cks9v9aou297q01xp179b589s?: InputMaybe<AuthorableContentCardUpdateManyInlineInput>;
  cksu3bhyb5ogg01w9589ueomo?: InputMaybe<SustainabilityBannerUpdateManyInlineInput>;
  cksu3dg725tgn01yuc2537ro4?: InputMaybe<SustainabilityBannerUpdateManyInlineInput>;
  ckt3cnpy0049m01yz1kivcfvi?: InputMaybe<Banner2UpdateManyInlineInput>;
  ckta6vdrf3zrf01xq76wdcwyo?: InputMaybe<ExampleComponentUpdateManyInlineInput>;
  cktv4dykm0wrp01xz8xswed7w?: InputMaybe<GenericDownloadComponentUpdateManyInlineInput>;
  cku3q4xpx6imm01xmgn9nb3zh?: InputMaybe<PopularSearchComponentUpdateManyInlineInput>;
  ckuo0nett4rb301z65vyo3xf0?: InputMaybe<SustainabilityInfoUpdateManyInlineInput>;
  ckuo0ounf4qr201xpe0y3gyrs?: InputMaybe<SustainabilityInfoUpdateManyInlineInput>;
  ckuo0qk6m4rhq01z63gqz7fqq?: InputMaybe<SustainabilityInfoUpdateManyInlineInput>;
  ckuo0s22f4qz001xp76kqge4s?: InputMaybe<SustainabilityInfoUpdateManyInlineInput>;
  ckxzvp7xy337d01we34797flb?: InputMaybe<LocationComponentUpdateManyInlineInput>;
  ckxzvqcwv361f01yu79zygdk2?: InputMaybe<LocationComponentUpdateManyInlineInput>;
  cky46xbs60lgg01xlblcz20go?: InputMaybe<MediaLibraryItemUpdateManyInlineInput>;
  ckz8dvp3920pt01z0262p5vu6?: InputMaybe<MediaLibraryItemUpdateManyInlineInput>;
  cl1c92igs33rd01z3fhcq2cii?: InputMaybe<CorpTimelineAccordionItemUpdateManyInlineInput>;
  cl1ywlg6x1ouy01xuhbihbx9e?: InputMaybe<CorpOurPeopleItemUpdateManyInlineInput>;
  cl2q0122s547f01xuds18e66m?: InputMaybe<ContactCardUpdateManyInlineInput>;
  cl2q16rt254gs01xjfxx34prq?: InputMaybe<CorpContactCardUpdateManyInlineInput>;
  cmsAssetTitle?: InputMaybe<Scalars['String']['input']>;
  countrySelectorItem?: InputMaybe<CountrySelectorItemUpdateOneInlineInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateOneInlineInput>;
  genericCardLayoutComponents?: InputMaybe<GenericCardCarouseComponentUpdateManyInlineInput>;
  heroComponent?: InputMaybe<HeroComponentUpdateOneInlineInput>;
  homePage?: InputMaybe<HomePageUpdateOneInlineInput>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardUpdateOneInlineInput>;
  imageCopyItem?: InputMaybe<ImageCopyItemUpdateOneInlineInput>;
  imageCopyItems?: InputMaybe<ImageCopyItemUpdateManyInlineInput>;
  leftColumn?: InputMaybe<LeftColumnUpdateOneInlineInput>;
  mobileOnlyMainNavigation?: InputMaybe<MobileOnlyMainNavigationUpdateOneInlineInput>;
  navigation?: InputMaybe<NavigationUpdateOneInlineInput>;
  pressStoriesCard?: InputMaybe<PressStoriesCardUpdateOneInlineInput>;
  rightColumn?: InputMaybe<RightColumnUpdateOneInlineInput>;
  socialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateOneInlineInput>;
};

export type AssetComponentUpdateManyInlineInput = {
  /** Connect multiple existing AssetComponent documents */
  connect?: InputMaybe<Array<AssetComponentConnectInput>>;
  /** Create and connect multiple AssetComponent documents */
  create?: InputMaybe<Array<AssetComponentCreateInput>>;
  /** Delete multiple AssetComponent documents */
  delete?: InputMaybe<Array<AssetComponentWhereUniqueInput>>;
  /** Disconnect multiple AssetComponent documents */
  disconnect?: InputMaybe<Array<AssetComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AssetComponent documents */
  set?: InputMaybe<Array<AssetComponentWhereUniqueInput>>;
  /** Update multiple AssetComponent documents */
  update?: InputMaybe<Array<AssetComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AssetComponent documents */
  upsert?: InputMaybe<Array<AssetComponentUpsertWithNestedWhereUniqueInput>>;
};

export type AssetComponentUpdateManyInput = {
  cmsAssetTitle?: InputMaybe<Scalars['String']['input']>;
};

export type AssetComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AssetComponentUpdateManyInput;
  /** Document search */
  where: AssetComponentWhereInput;
};

export type AssetComponentUpdateOneInlineInput = {
  /** Connect existing AssetComponent document */
  connect?: InputMaybe<AssetComponentWhereUniqueInput>;
  /** Create and connect one AssetComponent document */
  create?: InputMaybe<AssetComponentCreateInput>;
  /** Delete currently connected AssetComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AssetComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AssetComponent document */
  update?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AssetComponent document */
  upsert?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type AssetComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AssetComponentUpdateInput;
  /** Unique document search */
  where: AssetComponentWhereUniqueInput;
};

export type AssetComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: AssetComponentCreateInput;
  /** Update document if it exists */
  update: AssetComponentUpdateInput;
};

export type AssetComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AssetComponentUpsertInput;
  /** Unique document search */
  where: AssetComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AssetComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AssetComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alexTestComponent?: InputMaybe<AlexTestComponentWhereInput>;
  asset_every?: InputMaybe<AssetWhereInput>;
  asset_none?: InputMaybe<AssetWhereInput>;
  asset_some?: InputMaybe<AssetWhereInput>;
  audioComponents_every?: InputMaybe<AudioComponentWhereInput>;
  audioComponents_none?: InputMaybe<AudioComponentWhereInput>;
  audioComponents_some?: InputMaybe<AudioComponentWhereInput>;
  cardComponents_every?: InputMaybe<CardComponentWhereInput>;
  cardComponents_none?: InputMaybe<CardComponentWhereInput>;
  cardComponents_some?: InputMaybe<CardComponentWhereInput>;
  cmsAssetTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsAssetTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsAssetTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsAssetTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsAssetTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsAssetTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsAssetTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsAssetTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsAssetTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsAssetTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  countrySelectorItem?: InputMaybe<CountrySelectorItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetComponentWhereStageInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericCardLayoutComponents_every?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericCardLayoutComponents_none?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericCardLayoutComponents_some?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  heroComponent?: InputMaybe<HeroComponentWhereInput>;
  homePage?: InputMaybe<HomePageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardWhereInput>;
  imageCopyItem?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopyItems_every?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopyItems_none?: InputMaybe<ImageCopyItemWhereInput>;
  imageCopyItems_some?: InputMaybe<ImageCopyItemWhereInput>;
  leftColumn?: InputMaybe<LeftColumnWhereInput>;
  mobileOnlyMainNavigation?: InputMaybe<MobileOnlyMainNavigationWhereInput>;
  navigation?: InputMaybe<NavigationWhereInput>;
  pressStoriesCard?: InputMaybe<PressStoriesCardWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  rightColumn?: InputMaybe<RightColumnWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  socialMediaListComponent?: InputMaybe<SocialMediaListComponentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AssetComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AssetComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AssetComponent record uniquely */
export type AssetComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AssetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AssetWhereUniqueInput;
};

/** A connection to a list of items. */
export type AssetConnection = {
  __typename?: 'AssetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AssetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AssetCreateInput = {
  /** altText input for default locale (default) */
  altText?: InputMaybe<Scalars['String']['input']>;
  assetAssetComponent?: InputMaybe<AssetComponentCreateManyInlineInput>;
  audioFileAudioComponent?: InputMaybe<AudioComponentCreateManyInlineInput>;
  backgroundImgCarouselComponent?: InputMaybe<CarouselComponentCreateManyInlineInput>;
  bannerImageCorpHero?: InputMaybe<CorpHeroCreateManyInlineInput>;
  bannerImageCorpVideoHero?: InputMaybe<CorpVideoHeroCreateManyInlineInput>;
  bannerImageHeroBanner?: InputMaybe<HeroBannerCreateManyInlineInput>;
  bottomLeftAssetCarouselComponent?: InputMaybe<CarouselComponentCreateManyInlineInput>;
  bottomLeftImageAssetHeroComponent?: InputMaybe<HeroComponentCreateManyInlineInput>;
  /** caption input for default locale (default) */
  caption?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadImagePressRelease?: InputMaybe<PressReleaseCreateManyInlineInput>;
  downloadPrPressRelease?: InputMaybe<PressReleaseCreateManyInlineInput>;
  downloadableFileGenericDownloadComponent?: InputMaybe<GenericDownloadComponentCreateManyInlineInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  forAllRecipePagesSubCategoryKeyImage?: InputMaybe<SubCategoryKeyImageCreateManyInlineInput>;
  forRecipeCategoryPageSubCategoryKeyImage?: InputMaybe<SubCategoryKeyImageCreateManyInlineInput>;
  iconLeftFormSelectOption?: InputMaybe<FormSelectOptionCreateManyInlineInput>;
  imageGlobalMetaData?: InputMaybe<GlobalMetaDataCreateManyInlineInput>;
  imagePressRelease?: InputMaybe<PressReleaseCreateManyInlineInput>;
  imageStory?: InputMaybe<StoryCreateManyInlineInput>;
  imagesMetaData?: InputMaybe<MetaDataCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AssetCreateLocalizationsInput>;
  mobileImageCorpHero?: InputMaybe<CorpHeroCreateManyInlineInput>;
  mobileImageCorpVideoHero?: InputMaybe<CorpVideoHeroCreateManyInlineInput>;
  mobileImageHeroBanner?: InputMaybe<HeroBannerCreateManyInlineInput>;
  mobileImageHeroComponent?: InputMaybe<HeroComponentCreateManyInlineInput>;
  slideAssetCarouselSlide?: InputMaybe<CarouselSlideCreateManyInlineInput>;
  topRightAssetCarouselComponent?: InputMaybe<CarouselComponentCreateManyInlineInput>;
  topRightImageAssetHeroComponent?: InputMaybe<HeroComponentCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCreateLocalizationDataInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetCreateLocalizationInput = {
  /** Localization input */
  data: AssetCreateLocalizationDataInput;
  locale: Locale;
};

export type AssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
};

export type AssetCreateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Create and connect multiple existing Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
};

export type AssetCreateOneInlineInput = {
  /** Connect one existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
};

/** An edge in a connection. */
export type AssetEdge = {
  __typename?: 'AssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Asset;
};

/** Identifies documents */
export type AssetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetAssetComponent_every?: InputMaybe<AssetComponentWhereInput>;
  assetAssetComponent_none?: InputMaybe<AssetComponentWhereInput>;
  assetAssetComponent_some?: InputMaybe<AssetComponentWhereInput>;
  audioFileAudioComponent_every?: InputMaybe<AudioComponentWhereInput>;
  audioFileAudioComponent_none?: InputMaybe<AudioComponentWhereInput>;
  audioFileAudioComponent_some?: InputMaybe<AudioComponentWhereInput>;
  backgroundImgCarouselComponent_every?: InputMaybe<CarouselComponentWhereInput>;
  backgroundImgCarouselComponent_none?: InputMaybe<CarouselComponentWhereInput>;
  backgroundImgCarouselComponent_some?: InputMaybe<CarouselComponentWhereInput>;
  bannerImageCorpHero_every?: InputMaybe<CorpHeroWhereInput>;
  bannerImageCorpHero_none?: InputMaybe<CorpHeroWhereInput>;
  bannerImageCorpHero_some?: InputMaybe<CorpHeroWhereInput>;
  bannerImageCorpVideoHero_every?: InputMaybe<CorpVideoHeroWhereInput>;
  bannerImageCorpVideoHero_none?: InputMaybe<CorpVideoHeroWhereInput>;
  bannerImageCorpVideoHero_some?: InputMaybe<CorpVideoHeroWhereInput>;
  bannerImageHeroBanner_every?: InputMaybe<HeroBannerWhereInput>;
  bannerImageHeroBanner_none?: InputMaybe<HeroBannerWhereInput>;
  bannerImageHeroBanner_some?: InputMaybe<HeroBannerWhereInput>;
  bottomLeftAssetCarouselComponent_every?: InputMaybe<CarouselComponentWhereInput>;
  bottomLeftAssetCarouselComponent_none?: InputMaybe<CarouselComponentWhereInput>;
  bottomLeftAssetCarouselComponent_some?: InputMaybe<CarouselComponentWhereInput>;
  bottomLeftImageAssetHeroComponent_every?: InputMaybe<HeroComponentWhereInput>;
  bottomLeftImageAssetHeroComponent_none?: InputMaybe<HeroComponentWhereInput>;
  bottomLeftImageAssetHeroComponent_some?: InputMaybe<HeroComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  downloadImagePressRelease_every?: InputMaybe<PressReleaseWhereInput>;
  downloadImagePressRelease_none?: InputMaybe<PressReleaseWhereInput>;
  downloadImagePressRelease_some?: InputMaybe<PressReleaseWhereInput>;
  downloadPrPressRelease_every?: InputMaybe<PressReleaseWhereInput>;
  downloadPrPressRelease_none?: InputMaybe<PressReleaseWhereInput>;
  downloadPrPressRelease_some?: InputMaybe<PressReleaseWhereInput>;
  downloadableFileGenericDownloadComponent_every?: InputMaybe<GenericDownloadComponentWhereInput>;
  downloadableFileGenericDownloadComponent_none?: InputMaybe<GenericDownloadComponentWhereInput>;
  downloadableFileGenericDownloadComponent_some?: InputMaybe<GenericDownloadComponentWhereInput>;
  forAllRecipePagesSubCategoryKeyImage_every?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forAllRecipePagesSubCategoryKeyImage_none?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forAllRecipePagesSubCategoryKeyImage_some?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forRecipeCategoryPageSubCategoryKeyImage_every?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forRecipeCategoryPageSubCategoryKeyImage_none?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forRecipeCategoryPageSubCategoryKeyImage_some?: InputMaybe<SubCategoryKeyImageWhereInput>;
  iconLeftFormSelectOption_every?: InputMaybe<FormSelectOptionWhereInput>;
  iconLeftFormSelectOption_none?: InputMaybe<FormSelectOptionWhereInput>;
  iconLeftFormSelectOption_some?: InputMaybe<FormSelectOptionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageGlobalMetaData_every?: InputMaybe<GlobalMetaDataWhereInput>;
  imageGlobalMetaData_none?: InputMaybe<GlobalMetaDataWhereInput>;
  imageGlobalMetaData_some?: InputMaybe<GlobalMetaDataWhereInput>;
  imagePressRelease_every?: InputMaybe<PressReleaseWhereInput>;
  imagePressRelease_none?: InputMaybe<PressReleaseWhereInput>;
  imagePressRelease_some?: InputMaybe<PressReleaseWhereInput>;
  imageStory_every?: InputMaybe<StoryWhereInput>;
  imageStory_none?: InputMaybe<StoryWhereInput>;
  imageStory_some?: InputMaybe<StoryWhereInput>;
  imagesMetaData_every?: InputMaybe<MetaDataWhereInput>;
  imagesMetaData_none?: InputMaybe<MetaDataWhereInput>;
  imagesMetaData_some?: InputMaybe<MetaDataWhereInput>;
  mobileImageCorpHero_every?: InputMaybe<CorpHeroWhereInput>;
  mobileImageCorpHero_none?: InputMaybe<CorpHeroWhereInput>;
  mobileImageCorpHero_some?: InputMaybe<CorpHeroWhereInput>;
  mobileImageCorpVideoHero_every?: InputMaybe<CorpVideoHeroWhereInput>;
  mobileImageCorpVideoHero_none?: InputMaybe<CorpVideoHeroWhereInput>;
  mobileImageCorpVideoHero_some?: InputMaybe<CorpVideoHeroWhereInput>;
  mobileImageHeroBanner_every?: InputMaybe<HeroBannerWhereInput>;
  mobileImageHeroBanner_none?: InputMaybe<HeroBannerWhereInput>;
  mobileImageHeroBanner_some?: InputMaybe<HeroBannerWhereInput>;
  mobileImageHeroComponent_every?: InputMaybe<HeroComponentWhereInput>;
  mobileImageHeroComponent_none?: InputMaybe<HeroComponentWhereInput>;
  mobileImageHeroComponent_some?: InputMaybe<HeroComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slideAssetCarouselSlide_every?: InputMaybe<CarouselSlideWhereInput>;
  slideAssetCarouselSlide_none?: InputMaybe<CarouselSlideWhereInput>;
  slideAssetCarouselSlide_some?: InputMaybe<CarouselSlideWhereInput>;
  topRightAssetCarouselComponent_every?: InputMaybe<CarouselComponentWhereInput>;
  topRightAssetCarouselComponent_none?: InputMaybe<CarouselComponentWhereInput>;
  topRightAssetCarouselComponent_some?: InputMaybe<CarouselComponentWhereInput>;
  topRightImageAssetHeroComponent_every?: InputMaybe<HeroComponentWhereInput>;
  topRightImageAssetHeroComponent_none?: InputMaybe<HeroComponentWhereInput>;
  topRightImageAssetHeroComponent_some?: InputMaybe<HeroComponentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

export enum AssetOrderByInput {
  altText_ASC = 'altText_ASC',
  altText_DESC = 'altText_DESC',
  caption_ASC = 'caption_ASC',
  caption_DESC = 'caption_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fileName_ASC = 'fileName_ASC',
  fileName_DESC = 'fileName_DESC',
  handle_ASC = 'handle_ASC',
  handle_DESC = 'handle_DESC',
  height_ASC = 'height_ASC',
  height_DESC = 'height_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  mimeType_ASC = 'mimeType_ASC',
  mimeType_DESC = 'mimeType_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  size_ASC = 'size_ASC',
  size_DESC = 'size_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  width_ASC = 'width_ASC',
  width_DESC = 'width_DESC'
}

/** Identifies documents */
export type AssetSingleRelationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetSingleRelationWhereInput>>;
  upload?: InputMaybe<AssetUploadWhereInput>;
};

/** Transformations for Assets */
export type AssetTransformationInput = {
  document?: InputMaybe<DocumentTransformationInput>;
  image?: InputMaybe<ImageTransformationInput>;
  /** Pass true if you want to validate the passed transformation parameters */
  validateOptions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetUpdateInput = {
  /** altText input for default locale (default) */
  altText?: InputMaybe<Scalars['String']['input']>;
  assetAssetComponent?: InputMaybe<AssetComponentUpdateManyInlineInput>;
  audioFileAudioComponent?: InputMaybe<AudioComponentUpdateManyInlineInput>;
  backgroundImgCarouselComponent?: InputMaybe<CarouselComponentUpdateManyInlineInput>;
  bannerImageCorpHero?: InputMaybe<CorpHeroUpdateManyInlineInput>;
  bannerImageCorpVideoHero?: InputMaybe<CorpVideoHeroUpdateManyInlineInput>;
  bannerImageHeroBanner?: InputMaybe<HeroBannerUpdateManyInlineInput>;
  bottomLeftAssetCarouselComponent?: InputMaybe<CarouselComponentUpdateManyInlineInput>;
  bottomLeftImageAssetHeroComponent?: InputMaybe<HeroComponentUpdateManyInlineInput>;
  /** caption input for default locale (default) */
  caption?: InputMaybe<Scalars['String']['input']>;
  downloadImagePressRelease?: InputMaybe<PressReleaseUpdateManyInlineInput>;
  downloadPrPressRelease?: InputMaybe<PressReleaseUpdateManyInlineInput>;
  downloadableFileGenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateManyInlineInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  forAllRecipePagesSubCategoryKeyImage?: InputMaybe<SubCategoryKeyImageUpdateManyInlineInput>;
  forRecipeCategoryPageSubCategoryKeyImage?: InputMaybe<SubCategoryKeyImageUpdateManyInlineInput>;
  iconLeftFormSelectOption?: InputMaybe<FormSelectOptionUpdateManyInlineInput>;
  imageGlobalMetaData?: InputMaybe<GlobalMetaDataUpdateManyInlineInput>;
  imagePressRelease?: InputMaybe<PressReleaseUpdateManyInlineInput>;
  imageStory?: InputMaybe<StoryUpdateManyInlineInput>;
  imagesMetaData?: InputMaybe<MetaDataUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<AssetUpdateLocalizationsInput>;
  mobileImageCorpHero?: InputMaybe<CorpHeroUpdateManyInlineInput>;
  mobileImageCorpVideoHero?: InputMaybe<CorpVideoHeroUpdateManyInlineInput>;
  mobileImageHeroBanner?: InputMaybe<HeroBannerUpdateManyInlineInput>;
  mobileImageHeroComponent?: InputMaybe<HeroComponentUpdateManyInlineInput>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>;
  slideAssetCarouselSlide?: InputMaybe<CarouselSlideUpdateManyInlineInput>;
  topRightAssetCarouselComponent?: InputMaybe<CarouselComponentUpdateManyInlineInput>;
  topRightImageAssetHeroComponent?: InputMaybe<HeroComponentUpdateManyInlineInput>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateLocalizationDataInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** Use this to define if its a reupload for the asset */
  reUpload?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optionally the system can upload a file for you, for that you need to provide a publicly accessible url */
  uploadUrl?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateLocalizationInput = {
  data: AssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AssetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AssetUpsertLocalizationInput>>;
};

export type AssetUpdateManyInlineInput = {
  /** Connect multiple existing Asset documents */
  connect?: InputMaybe<Array<AssetConnectInput>>;
  /** Create and connect multiple Asset documents */
  create?: InputMaybe<Array<AssetCreateInput>>;
  /** Delete multiple Asset documents */
  delete?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Disconnect multiple Asset documents */
  disconnect?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Asset documents */
  set?: InputMaybe<Array<AssetWhereUniqueInput>>;
  /** Update multiple Asset documents */
  update?: InputMaybe<Array<AssetUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Asset documents */
  upsert?: InputMaybe<Array<AssetUpsertWithNestedWhereUniqueInput>>;
};

export type AssetUpdateManyInput = {
  /** altText input for default locale (default) */
  altText?: InputMaybe<Scalars['String']['input']>;
  /** caption input for default locale (default) */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<AssetUpdateManyLocalizationsInput>;
};

export type AssetUpdateManyLocalizationDataInput = {
  altText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
};

export type AssetUpdateManyLocalizationInput = {
  data: AssetUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<AssetUpdateManyLocalizationInput>>;
};

export type AssetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AssetUpdateManyInput;
  /** Document search */
  where: AssetWhereInput;
};

export type AssetUpdateOneInlineInput = {
  /** Connect existing Asset document */
  connect?: InputMaybe<AssetWhereUniqueInput>;
  /** Create and connect one Asset document */
  create?: InputMaybe<AssetCreateInput>;
  /** Delete currently connected Asset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Asset document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Asset document */
  update?: InputMaybe<AssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Asset document */
  upsert?: InputMaybe<AssetUpsertWithNestedWhereUniqueInput>;
};

export type AssetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AssetUpdateInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** Asset Upload */
export type AssetUpload = {
  __typename?: 'AssetUpload';
  /** Asset Upload Error */
  error?: Maybe<AssetUploadError>;
  /** Expiry Timestamp */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Asset Request Data for upload */
  requestPostData?: Maybe<AssetUploadRequestPostData>;
  /** Asset Request Data for upload */
  status?: Maybe<AssetUploadStatus>;
};

/** Represents asset upload error */
export type AssetUploadError = {
  __typename?: 'AssetUploadError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Asset Upload Request Post Data */
export type AssetUploadRequestPostData = {
  __typename?: 'AssetUploadRequestPostData';
  /** The algorithm to use in the form field. This value should be passed in the `X-Amz-Algorithm` form field. */
  algorithm: Scalars['String']['output'];
  /** The credential to use in the form field. This value should be passed in the `X-Amz-Credential` form field. */
  credential: Scalars['String']['output'];
  /** The date the request was signed, formatted as YYYYMMDDTHHMMSSZ. This value should be passed in the `X-Amz-Date` header. */
  date: Scalars['String']['output'];
  /** The key to use in the form field. This value should be passed in the `Key` form field. */
  key: Scalars['String']['output'];
  /** The policy to use in the form field. This value should be passed in the `Policy` form field. */
  policy: Scalars['String']['output'];
  /** The security token to use in the form field. This field is optional only pass it if its not null. This value should be passed in the `X-Amz-Security-Token` form field if not null. */
  securityToken?: Maybe<Scalars['String']['output']>;
  /** The signature to use in the form field. This value should be passed in the `X-Amz-Signature` form field. */
  signature: Scalars['String']['output'];
  /** The URL to which the file should be uploaded with a POST request. */
  url: Scalars['String']['output'];
};

/** System Asset Upload Status */
export enum AssetUploadStatus {
  ASSET_CREATE_PENDING = 'ASSET_CREATE_PENDING',
  ASSET_ERROR_UPLOAD = 'ASSET_ERROR_UPLOAD',
  ASSET_UPDATE_PENDING = 'ASSET_UPDATE_PENDING',
  ASSET_UPLOAD_COMPLETE = 'ASSET_UPLOAD_COMPLETE'
}

/** Identifies documents */
export type AssetUploadWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

/** Identifies documents */
export type AssetUploadWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetUploadWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetUploadWhereInput>>;
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  expiresAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  expiresAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  expiresAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  expiresAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  expiresAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  expiresAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  expiresAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<AssetUploadStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<AssetUploadStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<AssetUploadStatus>>>;
};

export type AssetUpsertInput = {
  /** Create document if it didn't exist */
  create: AssetCreateInput;
  /** Update document if it exists */
  update: AssetUpdateInput;
};

export type AssetUpsertLocalizationInput = {
  create: AssetCreateLocalizationDataInput;
  locale: Locale;
  update: AssetUpdateLocalizationDataInput;
};

export type AssetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AssetUpsertInput;
  /** Unique document search */
  where: AssetWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AssetWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AssetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  altText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  altText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  altText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  altText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  altText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  altText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  altText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  altText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  altText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  altText_starts_with?: InputMaybe<Scalars['String']['input']>;
  assetAssetComponent_every?: InputMaybe<AssetComponentWhereInput>;
  assetAssetComponent_none?: InputMaybe<AssetComponentWhereInput>;
  assetAssetComponent_some?: InputMaybe<AssetComponentWhereInput>;
  audioFileAudioComponent_every?: InputMaybe<AudioComponentWhereInput>;
  audioFileAudioComponent_none?: InputMaybe<AudioComponentWhereInput>;
  audioFileAudioComponent_some?: InputMaybe<AudioComponentWhereInput>;
  backgroundImgCarouselComponent_every?: InputMaybe<CarouselComponentWhereInput>;
  backgroundImgCarouselComponent_none?: InputMaybe<CarouselComponentWhereInput>;
  backgroundImgCarouselComponent_some?: InputMaybe<CarouselComponentWhereInput>;
  bannerImageCorpHero_every?: InputMaybe<CorpHeroWhereInput>;
  bannerImageCorpHero_none?: InputMaybe<CorpHeroWhereInput>;
  bannerImageCorpHero_some?: InputMaybe<CorpHeroWhereInput>;
  bannerImageCorpVideoHero_every?: InputMaybe<CorpVideoHeroWhereInput>;
  bannerImageCorpVideoHero_none?: InputMaybe<CorpVideoHeroWhereInput>;
  bannerImageCorpVideoHero_some?: InputMaybe<CorpVideoHeroWhereInput>;
  bannerImageHeroBanner_every?: InputMaybe<HeroBannerWhereInput>;
  bannerImageHeroBanner_none?: InputMaybe<HeroBannerWhereInput>;
  bannerImageHeroBanner_some?: InputMaybe<HeroBannerWhereInput>;
  bottomLeftAssetCarouselComponent_every?: InputMaybe<CarouselComponentWhereInput>;
  bottomLeftAssetCarouselComponent_none?: InputMaybe<CarouselComponentWhereInput>;
  bottomLeftAssetCarouselComponent_some?: InputMaybe<CarouselComponentWhereInput>;
  bottomLeftImageAssetHeroComponent_every?: InputMaybe<HeroComponentWhereInput>;
  bottomLeftImageAssetHeroComponent_none?: InputMaybe<HeroComponentWhereInput>;
  bottomLeftImageAssetHeroComponent_some?: InputMaybe<HeroComponentWhereInput>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AssetWhereStageInput>;
  documentInStages_none?: InputMaybe<AssetWhereStageInput>;
  documentInStages_some?: InputMaybe<AssetWhereStageInput>;
  downloadImagePressRelease_every?: InputMaybe<PressReleaseWhereInput>;
  downloadImagePressRelease_none?: InputMaybe<PressReleaseWhereInput>;
  downloadImagePressRelease_some?: InputMaybe<PressReleaseWhereInput>;
  downloadPrPressRelease_every?: InputMaybe<PressReleaseWhereInput>;
  downloadPrPressRelease_none?: InputMaybe<PressReleaseWhereInput>;
  downloadPrPressRelease_some?: InputMaybe<PressReleaseWhereInput>;
  downloadableFileGenericDownloadComponent_every?: InputMaybe<GenericDownloadComponentWhereInput>;
  downloadableFileGenericDownloadComponent_none?: InputMaybe<GenericDownloadComponentWhereInput>;
  downloadableFileGenericDownloadComponent_some?: InputMaybe<GenericDownloadComponentWhereInput>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fileName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fileName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fileName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fileName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fileName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fileName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fileName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fileName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fileName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forAllRecipePagesSubCategoryKeyImage_every?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forAllRecipePagesSubCategoryKeyImage_none?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forAllRecipePagesSubCategoryKeyImage_some?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forRecipeCategoryPageSubCategoryKeyImage_every?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forRecipeCategoryPageSubCategoryKeyImage_none?: InputMaybe<SubCategoryKeyImageWhereInput>;
  forRecipeCategoryPageSubCategoryKeyImage_some?: InputMaybe<SubCategoryKeyImageWhereInput>;
  handle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  iconLeftFormSelectOption_every?: InputMaybe<FormSelectOptionWhereInput>;
  iconLeftFormSelectOption_none?: InputMaybe<FormSelectOptionWhereInput>;
  iconLeftFormSelectOption_some?: InputMaybe<FormSelectOptionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageGlobalMetaData_every?: InputMaybe<GlobalMetaDataWhereInput>;
  imageGlobalMetaData_none?: InputMaybe<GlobalMetaDataWhereInput>;
  imageGlobalMetaData_some?: InputMaybe<GlobalMetaDataWhereInput>;
  imagePressRelease_every?: InputMaybe<PressReleaseWhereInput>;
  imagePressRelease_none?: InputMaybe<PressReleaseWhereInput>;
  imagePressRelease_some?: InputMaybe<PressReleaseWhereInput>;
  imageStory_every?: InputMaybe<StoryWhereInput>;
  imageStory_none?: InputMaybe<StoryWhereInput>;
  imageStory_some?: InputMaybe<StoryWhereInput>;
  imagesMetaData_every?: InputMaybe<MetaDataWhereInput>;
  imagesMetaData_none?: InputMaybe<MetaDataWhereInput>;
  imagesMetaData_some?: InputMaybe<MetaDataWhereInput>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  mimeType_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  mimeType_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  mimeType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  mimeType_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  mimeType_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  mimeType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  mimeType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  mimeType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  mimeType_starts_with?: InputMaybe<Scalars['String']['input']>;
  mobileImageCorpHero_every?: InputMaybe<CorpHeroWhereInput>;
  mobileImageCorpHero_none?: InputMaybe<CorpHeroWhereInput>;
  mobileImageCorpHero_some?: InputMaybe<CorpHeroWhereInput>;
  mobileImageCorpVideoHero_every?: InputMaybe<CorpVideoHeroWhereInput>;
  mobileImageCorpVideoHero_none?: InputMaybe<CorpVideoHeroWhereInput>;
  mobileImageCorpVideoHero_some?: InputMaybe<CorpVideoHeroWhereInput>;
  mobileImageHeroBanner_every?: InputMaybe<HeroBannerWhereInput>;
  mobileImageHeroBanner_none?: InputMaybe<HeroBannerWhereInput>;
  mobileImageHeroBanner_some?: InputMaybe<HeroBannerWhereInput>;
  mobileImageHeroComponent_every?: InputMaybe<HeroComponentWhereInput>;
  mobileImageHeroComponent_none?: InputMaybe<HeroComponentWhereInput>;
  mobileImageHeroComponent_some?: InputMaybe<HeroComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  size?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  size_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  size_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  size_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  size_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  size_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  size_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  size_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  slideAssetCarouselSlide_every?: InputMaybe<CarouselSlideWhereInput>;
  slideAssetCarouselSlide_none?: InputMaybe<CarouselSlideWhereInput>;
  slideAssetCarouselSlide_some?: InputMaybe<CarouselSlideWhereInput>;
  topRightAssetCarouselComponent_every?: InputMaybe<CarouselComponentWhereInput>;
  topRightAssetCarouselComponent_none?: InputMaybe<CarouselComponentWhereInput>;
  topRightAssetCarouselComponent_some?: InputMaybe<CarouselComponentWhereInput>;
  topRightImageAssetHeroComponent_every?: InputMaybe<HeroComponentWhereInput>;
  topRightImageAssetHeroComponent_none?: InputMaybe<HeroComponentWhereInput>;
  topRightImageAssetHeroComponent_some?: InputMaybe<HeroComponentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upload?: InputMaybe<AssetUploadWhereInput>;
  width?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  width_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  width_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  width_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  width_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  width_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  width_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  width_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AssetWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AssetWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AssetWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AssetWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Asset record uniquely */
export type AssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AudioComponent = Entity & Node & {
  __typename?: 'AudioComponent';
  audioFile?: Maybe<Asset>;
  cmsTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<AudioComponent>;
  genericPages: Array<GenericPage>;
  /** List of AudioComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image: Array<AssetComponent>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<AudioComponent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  title?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type AudioComponentAudioFileArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type AudioComponentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type AudioComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AudioComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type AudioComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type AudioComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type AudioComponentImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentWhereInput>;
};


export type AudioComponentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type AudioComponentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type AudioComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AudioComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type AudioComponentStoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


export type AudioComponentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type AudioComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AudioComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AudioComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type AudioComponentConnection = {
  __typename?: 'AudioComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AudioComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AudioComponentCreateInput = {
  audioFile?: InputMaybe<AssetCreateOneInlineInput>;
  cmsTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  image?: InputMaybe<AssetComponentCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AudioComponentCreateLocalizationsInput>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** transcript input for default locale (default) */
  transcript?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AudioComponentCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AudioComponentCreateLocalizationInput = {
  /** Localization input */
  data: AudioComponentCreateLocalizationDataInput;
  locale: Locale;
};

export type AudioComponentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AudioComponentCreateLocalizationInput>>;
};

export type AudioComponentCreateManyInlineInput = {
  /** Connect multiple existing AudioComponent documents */
  connect?: InputMaybe<Array<AudioComponentWhereUniqueInput>>;
  /** Create and connect multiple existing AudioComponent documents */
  create?: InputMaybe<Array<AudioComponentCreateInput>>;
};

export type AudioComponentCreateOneInlineInput = {
  /** Connect one existing AudioComponent document */
  connect?: InputMaybe<AudioComponentWhereUniqueInput>;
  /** Create and connect one AudioComponent document */
  create?: InputMaybe<AudioComponentCreateInput>;
};

/** An edge in a connection. */
export type AudioComponentEdge = {
  __typename?: 'AudioComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AudioComponent;
};

/** Identifies documents */
export type AudioComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AudioComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AudioComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AudioComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  audioFile?: InputMaybe<AssetWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AudioComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<AudioComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<AudioComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image_every?: InputMaybe<AssetComponentWhereInput>;
  image_none?: InputMaybe<AssetComponentWhereInput>;
  image_some?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum AudioComponentOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  transcript_ASC = 'transcript_ASC',
  transcript_DESC = 'transcript_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type AudioComponentUpdateInput = {
  audioFile?: InputMaybe<AssetUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  image?: InputMaybe<AssetComponentUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<AudioComponentUpdateLocalizationsInput>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** transcript input for default locale (default) */
  transcript?: InputMaybe<Scalars['String']['input']>;
};

export type AudioComponentUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
};

export type AudioComponentUpdateLocalizationInput = {
  data: AudioComponentUpdateLocalizationDataInput;
  locale: Locale;
};

export type AudioComponentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AudioComponentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AudioComponentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AudioComponentUpsertLocalizationInput>>;
};

export type AudioComponentUpdateManyInlineInput = {
  /** Connect multiple existing AudioComponent documents */
  connect?: InputMaybe<Array<AudioComponentConnectInput>>;
  /** Create and connect multiple AudioComponent documents */
  create?: InputMaybe<Array<AudioComponentCreateInput>>;
  /** Delete multiple AudioComponent documents */
  delete?: InputMaybe<Array<AudioComponentWhereUniqueInput>>;
  /** Disconnect multiple AudioComponent documents */
  disconnect?: InputMaybe<Array<AudioComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AudioComponent documents */
  set?: InputMaybe<Array<AudioComponentWhereUniqueInput>>;
  /** Update multiple AudioComponent documents */
  update?: InputMaybe<Array<AudioComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AudioComponent documents */
  upsert?: InputMaybe<Array<AudioComponentUpsertWithNestedWhereUniqueInput>>;
};

export type AudioComponentUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<AudioComponentUpdateManyLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  /** transcript input for default locale (default) */
  transcript?: InputMaybe<Scalars['String']['input']>;
};

export type AudioComponentUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
};

export type AudioComponentUpdateManyLocalizationInput = {
  data: AudioComponentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type AudioComponentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<AudioComponentUpdateManyLocalizationInput>>;
};

export type AudioComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AudioComponentUpdateManyInput;
  /** Document search */
  where: AudioComponentWhereInput;
};

export type AudioComponentUpdateOneInlineInput = {
  /** Connect existing AudioComponent document */
  connect?: InputMaybe<AudioComponentWhereUniqueInput>;
  /** Create and connect one AudioComponent document */
  create?: InputMaybe<AudioComponentCreateInput>;
  /** Delete currently connected AudioComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AudioComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AudioComponent document */
  update?: InputMaybe<AudioComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AudioComponent document */
  upsert?: InputMaybe<AudioComponentUpsertWithNestedWhereUniqueInput>;
};

export type AudioComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AudioComponentUpdateInput;
  /** Unique document search */
  where: AudioComponentWhereUniqueInput;
};

export type AudioComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: AudioComponentCreateInput;
  /** Update document if it exists */
  update: AudioComponentUpdateInput;
};

export type AudioComponentUpsertLocalizationInput = {
  create: AudioComponentCreateLocalizationDataInput;
  locale: Locale;
  update: AudioComponentUpdateLocalizationDataInput;
};

export type AudioComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AudioComponentUpsertInput;
  /** Unique document search */
  where: AudioComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AudioComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AudioComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AudioComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AudioComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AudioComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  audioFile?: InputMaybe<AssetWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<AudioComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<AudioComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<AudioComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image_every?: InputMaybe<AssetComponentWhereInput>;
  image_none?: InputMaybe<AssetComponentWhereInput>;
  image_some?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  transcript?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  transcript_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  transcript_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  transcript_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  transcript_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  transcript_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  transcript_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  transcript_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  transcript_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  transcript_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AudioComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AudioComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AudioComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AudioComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AudioComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AudioComponent record uniquely */
export type AudioComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AuthorableContentCard = Entity & Node & {
  __typename?: 'AuthorableContentCard';
  anchorNav?: Maybe<AnchorNavigation>;
  /** body copy text */
  copy: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<AuthorableContentCard>;
  featuredContent?: Maybe<FeaturedContent>;
  genericGridAuthorables: Array<GenericGridAuthorable>;
  genericPages: Array<GenericPage>;
  /** List of AuthorableContentCard versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** the image to be shown */
  image?: Maybe<AssetComponent>;
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<AuthorableContentCard>;
  /** title of the card */
  name: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** subtitle for the content card */
  subtitle?: Maybe<Scalars['String']['output']>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Id of the video to be shown on click of the card */
  videoId?: Maybe<Scalars['String']['output']>;
};


export type AuthorableContentCardAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AuthorableContentCardCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type AuthorableContentCardCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AuthorableContentCardDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type AuthorableContentCardFeaturedContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AuthorableContentCardGenericGridAuthorablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericGridAuthorableWhereInput>;
};


export type AuthorableContentCardGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type AuthorableContentCardHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type AuthorableContentCardImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AuthorableContentCardLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AuthorableContentCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type AuthorableContentCardPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type AuthorableContentCardPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AuthorableContentCardScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type AuthorableContentCardTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type AuthorableContentCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type AuthorableContentCardUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type AuthorableContentCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: AuthorableContentCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type AuthorableContentCardConnection = {
  __typename?: 'AuthorableContentCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<AuthorableContentCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type AuthorableContentCardCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  copy: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  featuredContent?: InputMaybe<FeaturedContentCreateOneInlineInput>;
  genericGridAuthorables?: InputMaybe<GenericGridAuthorableCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  image?: InputMaybe<AssetComponentCreateOneInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<AuthorableContentCardCreateLocalizationsInput>;
  /** name input for default locale (default) */
  name: Scalars['String']['input'];
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorableContentCardCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuthorableContentCardCreateLocalizationInput = {
  /** Localization input */
  data: AuthorableContentCardCreateLocalizationDataInput;
  locale: Locale;
};

export type AuthorableContentCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<AuthorableContentCardCreateLocalizationInput>>;
};

export type AuthorableContentCardCreateManyInlineInput = {
  /** Connect multiple existing AuthorableContentCard documents */
  connect?: InputMaybe<Array<AuthorableContentCardWhereUniqueInput>>;
  /** Create and connect multiple existing AuthorableContentCard documents */
  create?: InputMaybe<Array<AuthorableContentCardCreateInput>>;
};

export type AuthorableContentCardCreateOneInlineInput = {
  /** Connect one existing AuthorableContentCard document */
  connect?: InputMaybe<AuthorableContentCardWhereUniqueInput>;
  /** Create and connect one AuthorableContentCard document */
  create?: InputMaybe<AuthorableContentCardCreateInput>;
};

/** An edge in a connection. */
export type AuthorableContentCardEdge = {
  __typename?: 'AuthorableContentCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AuthorableContentCard;
};

/** Identifies documents */
export type AuthorableContentCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AuthorableContentCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AuthorableContentCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AuthorableContentCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  copy?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  copy_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  copy_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  copy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  copy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  copy_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AuthorableContentCardWhereStageInput>;
  documentInStages_none?: InputMaybe<AuthorableContentCardWhereStageInput>;
  documentInStages_some?: InputMaybe<AuthorableContentCardWhereStageInput>;
  featuredContent?: InputMaybe<FeaturedContentWhereInput>;
  genericGridAuthorables_every?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorables_none?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorables_some?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoId_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum AuthorableContentCardOrderByInput {
  copy_ASC = 'copy_ASC',
  copy_DESC = 'copy_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subtitle_ASC = 'subtitle_ASC',
  subtitle_DESC = 'subtitle_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  videoId_ASC = 'videoId_ASC',
  videoId_DESC = 'videoId_DESC'
}

export type AuthorableContentCardUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  copy?: InputMaybe<Scalars['String']['input']>;
  featuredContent?: InputMaybe<FeaturedContentUpdateOneInlineInput>;
  genericGridAuthorables?: InputMaybe<GenericGridAuthorableUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  image?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<AuthorableContentCardUpdateLocalizationsInput>;
  /** name input for default locale (default) */
  name?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorableContentCardUpdateLocalizationDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorableContentCardUpdateLocalizationInput = {
  data: AuthorableContentCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type AuthorableContentCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<AuthorableContentCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<AuthorableContentCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<AuthorableContentCardUpsertLocalizationInput>>;
};

export type AuthorableContentCardUpdateManyInlineInput = {
  /** Connect multiple existing AuthorableContentCard documents */
  connect?: InputMaybe<Array<AuthorableContentCardConnectInput>>;
  /** Create and connect multiple AuthorableContentCard documents */
  create?: InputMaybe<Array<AuthorableContentCardCreateInput>>;
  /** Delete multiple AuthorableContentCard documents */
  delete?: InputMaybe<Array<AuthorableContentCardWhereUniqueInput>>;
  /** Disconnect multiple AuthorableContentCard documents */
  disconnect?: InputMaybe<Array<AuthorableContentCardWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing AuthorableContentCard documents */
  set?: InputMaybe<Array<AuthorableContentCardWhereUniqueInput>>;
  /** Update multiple AuthorableContentCard documents */
  update?: InputMaybe<Array<AuthorableContentCardUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple AuthorableContentCard documents */
  upsert?: InputMaybe<Array<AuthorableContentCardUpsertWithNestedWhereUniqueInput>>;
};

export type AuthorableContentCardUpdateManyInput = {
  copy?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<AuthorableContentCardUpdateManyLocalizationsInput>;
  /** name input for default locale (default) */
  name?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorableContentCardUpdateManyLocalizationDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AuthorableContentCardUpdateManyLocalizationInput = {
  data: AuthorableContentCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type AuthorableContentCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<AuthorableContentCardUpdateManyLocalizationInput>>;
};

export type AuthorableContentCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: AuthorableContentCardUpdateManyInput;
  /** Document search */
  where: AuthorableContentCardWhereInput;
};

export type AuthorableContentCardUpdateOneInlineInput = {
  /** Connect existing AuthorableContentCard document */
  connect?: InputMaybe<AuthorableContentCardWhereUniqueInput>;
  /** Create and connect one AuthorableContentCard document */
  create?: InputMaybe<AuthorableContentCardCreateInput>;
  /** Delete currently connected AuthorableContentCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected AuthorableContentCard document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single AuthorableContentCard document */
  update?: InputMaybe<AuthorableContentCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single AuthorableContentCard document */
  upsert?: InputMaybe<AuthorableContentCardUpsertWithNestedWhereUniqueInput>;
};

export type AuthorableContentCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: AuthorableContentCardUpdateInput;
  /** Unique document search */
  where: AuthorableContentCardWhereUniqueInput;
};

export type AuthorableContentCardUpsertInput = {
  /** Create document if it didn't exist */
  create: AuthorableContentCardCreateInput;
  /** Update document if it exists */
  update: AuthorableContentCardUpdateInput;
};

export type AuthorableContentCardUpsertLocalizationInput = {
  create: AuthorableContentCardCreateLocalizationDataInput;
  locale: Locale;
  update: AuthorableContentCardUpdateLocalizationDataInput;
};

export type AuthorableContentCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: AuthorableContentCardUpsertInput;
  /** Unique document search */
  where: AuthorableContentCardWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type AuthorableContentCardWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type AuthorableContentCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AuthorableContentCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AuthorableContentCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AuthorableContentCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  copy?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  copy_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  copy_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  copy_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  copy_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  copy_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  copy_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  copy_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  copy_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  copy_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<AuthorableContentCardWhereStageInput>;
  documentInStages_none?: InputMaybe<AuthorableContentCardWhereStageInput>;
  documentInStages_some?: InputMaybe<AuthorableContentCardWhereStageInput>;
  featuredContent?: InputMaybe<FeaturedContentWhereInput>;
  genericGridAuthorables_every?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorables_none?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorables_some?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoId_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type AuthorableContentCardWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<AuthorableContentCardWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<AuthorableContentCardWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<AuthorableContentCardWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<AuthorableContentCardWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References AuthorableContentCard record uniquely */
export type AuthorableContentCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Banner2 with image and text and placement options */
export type Banner2 = Entity & Node & {
  __typename?: 'Banner2';
  anchorNav?: Maybe<AnchorNavigation>;
  /** For the main image of the banner */
  backgroundAsset?: Maybe<AssetComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<Banner2>;
  /** Whether the image should span the whole page or not */
  fullBleed?: Maybe<Scalars['Boolean']['output']>;
  genericPages: Array<GenericPage>;
  /** List of Banner2 versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Choose left or right as an option */
  imageAlignment?: Maybe<LeftRight>;
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Banner2>;
  mediaLibrary?: Maybe<MediaLibrary>;
  /** For the mobile image of the banner */
  mobileBackgroundAsset?: Maybe<AssetComponent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  /** Superscript tag line */
  superText?: Maybe<Scalars['String']['output']>;
  tabContent?: Maybe<TabContent>;
  /** Title of the banner */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Banner2 with image and text and placement options */
export type Banner2AnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner2 with image and text and placement options */
export type Banner2BackgroundAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner2 with image and text and placement options */
export type Banner2CreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Banner2 with image and text and placement options */
export type Banner2CreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner2 with image and text and placement options */
export type Banner2DocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Banner2 with image and text and placement options */
export type Banner2GenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Banner2 with image and text and placement options */
export type Banner2HistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Banner2 with image and text and placement options */
export type Banner2LinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner2 with image and text and placement options */
export type Banner2LocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Banner2 with image and text and placement options */
export type Banner2MediaLibraryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner2 with image and text and placement options */
export type Banner2MobileBackgroundAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner2 with image and text and placement options */
export type Banner2PublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Banner2 with image and text and placement options */
export type Banner2PublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner2 with image and text and placement options */
export type Banner2ScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Banner2 with image and text and placement options */
export type Banner2StoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


/** Banner2 with image and text and placement options */
export type Banner2TabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner2 with image and text and placement options */
export type Banner2UpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Banner2 with image and text and placement options */
export type Banner2UpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type Banner2ConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: Banner2WhereUniqueInput;
};

/** A connection to a list of items. */
export type Banner2Connection = {
  __typename?: 'Banner2Connection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<Banner2Edge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type Banner2CreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  backgroundAsset?: InputMaybe<AssetComponentCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  fullBleed?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  /** imageAlignment input for default locale (default) */
  imageAlignment?: InputMaybe<LeftRight>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<Banner2CreateLocalizationsInput>;
  mediaLibrary?: InputMaybe<MediaLibraryCreateOneInlineInput>;
  mobileBackgroundAsset?: InputMaybe<AssetComponentCreateOneInlineInput>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Banner2CreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageAlignment?: InputMaybe<LeftRight>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type Banner2CreateLocalizationInput = {
  /** Localization input */
  data: Banner2CreateLocalizationDataInput;
  locale: Locale;
};

export type Banner2CreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<Banner2CreateLocalizationInput>>;
};

export type Banner2CreateManyInlineInput = {
  /** Connect multiple existing Banner2 documents */
  connect?: InputMaybe<Array<Banner2WhereUniqueInput>>;
  /** Create and connect multiple existing Banner2 documents */
  create?: InputMaybe<Array<Banner2CreateInput>>;
};

export type Banner2CreateOneInlineInput = {
  /** Connect one existing Banner2 document */
  connect?: InputMaybe<Banner2WhereUniqueInput>;
  /** Create and connect one Banner2 document */
  create?: InputMaybe<Banner2CreateInput>;
};

/** An edge in a connection. */
export type Banner2Edge = {
  __typename?: 'Banner2Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Banner2;
};

/** Identifies documents */
export type Banner2ManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<Banner2WhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<Banner2WhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<Banner2WhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundAsset?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<Banner2WhereStageInput>;
  documentInStages_none?: InputMaybe<Banner2WhereStageInput>;
  documentInStages_some?: InputMaybe<Banner2WhereStageInput>;
  fullBleed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  fullBleed_not?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  mobileBackgroundAsset?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum Banner2OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  fullBleed_ASC = 'fullBleed_ASC',
  fullBleed_DESC = 'fullBleed_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  imageAlignment_ASC = 'imageAlignment_ASC',
  imageAlignment_DESC = 'imageAlignment_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type Banner2UpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  backgroundAsset?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  fullBleed?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  /** imageAlignment input for default locale (default) */
  imageAlignment?: InputMaybe<LeftRight>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<Banner2UpdateLocalizationsInput>;
  mediaLibrary?: InputMaybe<MediaLibraryUpdateOneInlineInput>;
  mobileBackgroundAsset?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Banner2UpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageAlignment?: InputMaybe<LeftRight>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Banner2UpdateLocalizationInput = {
  data: Banner2UpdateLocalizationDataInput;
  locale: Locale;
};

export type Banner2UpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<Banner2CreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<Banner2UpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<Banner2UpsertLocalizationInput>>;
};

export type Banner2UpdateManyInlineInput = {
  /** Connect multiple existing Banner2 documents */
  connect?: InputMaybe<Array<Banner2ConnectInput>>;
  /** Create and connect multiple Banner2 documents */
  create?: InputMaybe<Array<Banner2CreateInput>>;
  /** Delete multiple Banner2 documents */
  delete?: InputMaybe<Array<Banner2WhereUniqueInput>>;
  /** Disconnect multiple Banner2 documents */
  disconnect?: InputMaybe<Array<Banner2WhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Banner2 documents */
  set?: InputMaybe<Array<Banner2WhereUniqueInput>>;
  /** Update multiple Banner2 documents */
  update?: InputMaybe<Array<Banner2UpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Banner2 documents */
  upsert?: InputMaybe<Array<Banner2UpsertWithNestedWhereUniqueInput>>;
};

export type Banner2UpdateManyInput = {
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  fullBleed?: InputMaybe<Scalars['Boolean']['input']>;
  /** imageAlignment input for default locale (default) */
  imageAlignment?: InputMaybe<LeftRight>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<Banner2UpdateManyLocalizationsInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Banner2UpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  imageAlignment?: InputMaybe<LeftRight>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Banner2UpdateManyLocalizationInput = {
  data: Banner2UpdateManyLocalizationDataInput;
  locale: Locale;
};

export type Banner2UpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<Banner2UpdateManyLocalizationInput>>;
};

export type Banner2UpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: Banner2UpdateManyInput;
  /** Document search */
  where: Banner2WhereInput;
};

export type Banner2UpdateOneInlineInput = {
  /** Connect existing Banner2 document */
  connect?: InputMaybe<Banner2WhereUniqueInput>;
  /** Create and connect one Banner2 document */
  create?: InputMaybe<Banner2CreateInput>;
  /** Delete currently connected Banner2 document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Banner2 document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Banner2 document */
  update?: InputMaybe<Banner2UpdateWithNestedWhereUniqueInput>;
  /** Upsert single Banner2 document */
  upsert?: InputMaybe<Banner2UpsertWithNestedWhereUniqueInput>;
};

export type Banner2UpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: Banner2UpdateInput;
  /** Unique document search */
  where: Banner2WhereUniqueInput;
};

export type Banner2UpsertInput = {
  /** Create document if it didn't exist */
  create: Banner2CreateInput;
  /** Update document if it exists */
  update: Banner2UpdateInput;
};

export type Banner2UpsertLocalizationInput = {
  create: Banner2CreateLocalizationDataInput;
  locale: Locale;
  update: Banner2UpdateLocalizationDataInput;
};

export type Banner2UpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: Banner2UpsertInput;
  /** Unique document search */
  where: Banner2WhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type Banner2WhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type Banner2WhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<Banner2WhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<Banner2WhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<Banner2WhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundAsset?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<Banner2WhereStageInput>;
  documentInStages_none?: InputMaybe<Banner2WhereStageInput>;
  documentInStages_some?: InputMaybe<Banner2WhereStageInput>;
  fullBleed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  fullBleed_not?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageAlignment?: InputMaybe<LeftRight>;
  /** All values that are contained in given list. */
  imageAlignment_in?: InputMaybe<Array<InputMaybe<LeftRight>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageAlignment_not?: InputMaybe<LeftRight>;
  /** All values that are not contained in given list. */
  imageAlignment_not_in?: InputMaybe<Array<InputMaybe<LeftRight>>>;
  link?: InputMaybe<LinkWhereInput>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  mobileBackgroundAsset?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type Banner2WhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<Banner2WhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<Banner2WhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<Banner2WhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<Banner2WhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Banner2 record uniquely */
export type Banner2WhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum BannerHeight {
  Short = 'Short',
  Tall = 'Tall'
}

/** Type of banner */
export enum BannerType {
  alcohol_warning = 'alcohol_warning',
  recall_campaign = 'recall_campaign'
}

/** Colour of the video play button and text */
export enum BannerVideoPlayAndTextColour {
  Black = 'Black',
  Grey = 'Grey',
  White = 'White'
}

export type BatchPayload = {
  __typename?: 'BatchPayload';
  /** The number of nodes that have been affected by the Batch operation. */
  count: Scalars['Long']['output'];
};

export type BigNumber = Entity & Node & {
  __typename?: 'BigNumber';
  bigNumberItems: Array<BigNumberItem>;
  corpGenericContainers: Array<CorpGenericContainer>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<BigNumber>;
  /** List of BigNumber versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type BigNumberBigNumberItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<BigNumberItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BigNumberItemWhereInput>;
};


export type BigNumberCorpGenericContainersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericContainerWhereInput>;
};


export type BigNumberCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BigNumberDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type BigNumberHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type BigNumberPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BigNumberScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type BigNumberUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type BigNumberConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: BigNumberWhereUniqueInput;
};

/** A connection to a list of items. */
export type BigNumberConnection = {
  __typename?: 'BigNumberConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<BigNumberEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type BigNumberCreateInput = {
  bigNumberItems?: InputMaybe<BigNumberItemCreateManyInlineInput>;
  corpGenericContainers?: InputMaybe<CorpGenericContainerCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BigNumberCreateManyInlineInput = {
  /** Connect multiple existing BigNumber documents */
  connect?: InputMaybe<Array<BigNumberWhereUniqueInput>>;
  /** Create and connect multiple existing BigNumber documents */
  create?: InputMaybe<Array<BigNumberCreateInput>>;
};

export type BigNumberCreateOneInlineInput = {
  /** Connect one existing BigNumber document */
  connect?: InputMaybe<BigNumberWhereUniqueInput>;
  /** Create and connect one BigNumber document */
  create?: InputMaybe<BigNumberCreateInput>;
};

/** An edge in a connection. */
export type BigNumberEdge = {
  __typename?: 'BigNumberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BigNumber;
};

export type BigNumberItem = Entity & Node & {
  __typename?: 'BigNumberItem';
  bigNumber: Scalars['String']['output'];
  bottomText: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<BigNumberItem>;
  /** List of BigNumberItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<BigNumberItem>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type BigNumberItemCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type BigNumberItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BigNumberItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type BigNumberItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type BigNumberItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type BigNumberItemPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type BigNumberItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type BigNumberItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type BigNumberItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type BigNumberItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type BigNumberItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: BigNumberItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type BigNumberItemConnection = {
  __typename?: 'BigNumberItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<BigNumberItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type BigNumberItemCreateInput = {
  /** bigNumber input for default locale (default) */
  bigNumber: Scalars['String']['input'];
  /** bottomText input for default locale (default) */
  bottomText: Scalars['String']['input'];
  cl0zwsgk35asc01xv72vk9oft?: InputMaybe<BigNumberCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<BigNumberItemCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BigNumberItemCreateLocalizationDataInput = {
  bigNumber: Scalars['String']['input'];
  bottomText: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BigNumberItemCreateLocalizationInput = {
  /** Localization input */
  data: BigNumberItemCreateLocalizationDataInput;
  locale: Locale;
};

export type BigNumberItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<BigNumberItemCreateLocalizationInput>>;
};

export type BigNumberItemCreateManyInlineInput = {
  /** Connect multiple existing BigNumberItem documents */
  connect?: InputMaybe<Array<BigNumberItemWhereUniqueInput>>;
  /** Create and connect multiple existing BigNumberItem documents */
  create?: InputMaybe<Array<BigNumberItemCreateInput>>;
};

export type BigNumberItemCreateOneInlineInput = {
  /** Connect one existing BigNumberItem document */
  connect?: InputMaybe<BigNumberItemWhereUniqueInput>;
  /** Create and connect one BigNumberItem document */
  create?: InputMaybe<BigNumberItemCreateInput>;
};

/** An edge in a connection. */
export type BigNumberItemEdge = {
  __typename?: 'BigNumberItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BigNumberItem;
};

/** Identifies documents */
export type BigNumberItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BigNumberItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BigNumberItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BigNumberItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<BigNumberItemWhereStageInput>;
  documentInStages_none?: InputMaybe<BigNumberItemWhereStageInput>;
  documentInStages_some?: InputMaybe<BigNumberItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum BigNumberItemOrderByInput {
  bigNumber_ASC = 'bigNumber_ASC',
  bigNumber_DESC = 'bigNumber_DESC',
  bottomText_ASC = 'bottomText_ASC',
  bottomText_DESC = 'bottomText_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type BigNumberItemUpdateInput = {
  /** bigNumber input for default locale (default) */
  bigNumber?: InputMaybe<Scalars['String']['input']>;
  /** bottomText input for default locale (default) */
  bottomText?: InputMaybe<Scalars['String']['input']>;
  cl0zwsgk35asc01xv72vk9oft?: InputMaybe<BigNumberUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<BigNumberItemUpdateLocalizationsInput>;
};

export type BigNumberItemUpdateLocalizationDataInput = {
  bigNumber?: InputMaybe<Scalars['String']['input']>;
  bottomText?: InputMaybe<Scalars['String']['input']>;
};

export type BigNumberItemUpdateLocalizationInput = {
  data: BigNumberItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type BigNumberItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<BigNumberItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<BigNumberItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<BigNumberItemUpsertLocalizationInput>>;
};

export type BigNumberItemUpdateManyInlineInput = {
  /** Connect multiple existing BigNumberItem documents */
  connect?: InputMaybe<Array<BigNumberItemConnectInput>>;
  /** Create and connect multiple BigNumberItem documents */
  create?: InputMaybe<Array<BigNumberItemCreateInput>>;
  /** Delete multiple BigNumberItem documents */
  delete?: InputMaybe<Array<BigNumberItemWhereUniqueInput>>;
  /** Disconnect multiple BigNumberItem documents */
  disconnect?: InputMaybe<Array<BigNumberItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing BigNumberItem documents */
  set?: InputMaybe<Array<BigNumberItemWhereUniqueInput>>;
  /** Update multiple BigNumberItem documents */
  update?: InputMaybe<Array<BigNumberItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple BigNumberItem documents */
  upsert?: InputMaybe<Array<BigNumberItemUpsertWithNestedWhereUniqueInput>>;
};

export type BigNumberItemUpdateManyInput = {
  /** bigNumber input for default locale (default) */
  bigNumber?: InputMaybe<Scalars['String']['input']>;
  /** bottomText input for default locale (default) */
  bottomText?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<BigNumberItemUpdateManyLocalizationsInput>;
};

export type BigNumberItemUpdateManyLocalizationDataInput = {
  bigNumber?: InputMaybe<Scalars['String']['input']>;
  bottomText?: InputMaybe<Scalars['String']['input']>;
};

export type BigNumberItemUpdateManyLocalizationInput = {
  data: BigNumberItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type BigNumberItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<BigNumberItemUpdateManyLocalizationInput>>;
};

export type BigNumberItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BigNumberItemUpdateManyInput;
  /** Document search */
  where: BigNumberItemWhereInput;
};

export type BigNumberItemUpdateOneInlineInput = {
  /** Connect existing BigNumberItem document */
  connect?: InputMaybe<BigNumberItemWhereUniqueInput>;
  /** Create and connect one BigNumberItem document */
  create?: InputMaybe<BigNumberItemCreateInput>;
  /** Delete currently connected BigNumberItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected BigNumberItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single BigNumberItem document */
  update?: InputMaybe<BigNumberItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BigNumberItem document */
  upsert?: InputMaybe<BigNumberItemUpsertWithNestedWhereUniqueInput>;
};

export type BigNumberItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BigNumberItemUpdateInput;
  /** Unique document search */
  where: BigNumberItemWhereUniqueInput;
};

export type BigNumberItemUpsertInput = {
  /** Create document if it didn't exist */
  create: BigNumberItemCreateInput;
  /** Update document if it exists */
  update: BigNumberItemUpdateInput;
};

export type BigNumberItemUpsertLocalizationInput = {
  create: BigNumberItemCreateLocalizationDataInput;
  locale: Locale;
  update: BigNumberItemUpdateLocalizationDataInput;
};

export type BigNumberItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BigNumberItemUpsertInput;
  /** Unique document search */
  where: BigNumberItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type BigNumberItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type BigNumberItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BigNumberItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BigNumberItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BigNumberItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  bigNumber?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bigNumber_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bigNumber_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bigNumber_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bigNumber_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bigNumber_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bigNumber_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bigNumber_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bigNumber_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bigNumber_starts_with?: InputMaybe<Scalars['String']['input']>;
  bottomText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bottomText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bottomText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bottomText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bottomText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bottomText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bottomText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bottomText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bottomText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bottomText_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<BigNumberItemWhereStageInput>;
  documentInStages_none?: InputMaybe<BigNumberItemWhereStageInput>;
  documentInStages_some?: InputMaybe<BigNumberItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type BigNumberItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BigNumberItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BigNumberItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BigNumberItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<BigNumberItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References BigNumberItem record uniquely */
export type BigNumberItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type BigNumberManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BigNumberWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BigNumberWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BigNumberWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  bigNumberItems_every?: InputMaybe<BigNumberItemWhereInput>;
  bigNumberItems_none?: InputMaybe<BigNumberItemWhereInput>;
  bigNumberItems_some?: InputMaybe<BigNumberItemWhereInput>;
  corpGenericContainers_every?: InputMaybe<CorpGenericContainerWhereInput>;
  corpGenericContainers_none?: InputMaybe<CorpGenericContainerWhereInput>;
  corpGenericContainers_some?: InputMaybe<CorpGenericContainerWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<BigNumberWhereStageInput>;
  documentInStages_none?: InputMaybe<BigNumberWhereStageInput>;
  documentInStages_some?: InputMaybe<BigNumberWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum BigNumberOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type BigNumberUpdateInput = {
  bigNumberItems?: InputMaybe<BigNumberItemUpdateManyInlineInput>;
  corpGenericContainers?: InputMaybe<CorpGenericContainerUpdateManyInlineInput>;
};

export type BigNumberUpdateManyInlineInput = {
  /** Connect multiple existing BigNumber documents */
  connect?: InputMaybe<Array<BigNumberConnectInput>>;
  /** Create and connect multiple BigNumber documents */
  create?: InputMaybe<Array<BigNumberCreateInput>>;
  /** Delete multiple BigNumber documents */
  delete?: InputMaybe<Array<BigNumberWhereUniqueInput>>;
  /** Disconnect multiple BigNumber documents */
  disconnect?: InputMaybe<Array<BigNumberWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing BigNumber documents */
  set?: InputMaybe<Array<BigNumberWhereUniqueInput>>;
  /** Update multiple BigNumber documents */
  update?: InputMaybe<Array<BigNumberUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple BigNumber documents */
  upsert?: InputMaybe<Array<BigNumberUpsertWithNestedWhereUniqueInput>>;
};

export type BigNumberUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type BigNumberUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: BigNumberUpdateManyInput;
  /** Document search */
  where: BigNumberWhereInput;
};

export type BigNumberUpdateOneInlineInput = {
  /** Connect existing BigNumber document */
  connect?: InputMaybe<BigNumberWhereUniqueInput>;
  /** Create and connect one BigNumber document */
  create?: InputMaybe<BigNumberCreateInput>;
  /** Delete currently connected BigNumber document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected BigNumber document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single BigNumber document */
  update?: InputMaybe<BigNumberUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BigNumber document */
  upsert?: InputMaybe<BigNumberUpsertWithNestedWhereUniqueInput>;
};

export type BigNumberUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: BigNumberUpdateInput;
  /** Unique document search */
  where: BigNumberWhereUniqueInput;
};

export type BigNumberUpsertInput = {
  /** Create document if it didn't exist */
  create: BigNumberCreateInput;
  /** Update document if it exists */
  update: BigNumberUpdateInput;
};

export type BigNumberUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: BigNumberUpsertInput;
  /** Unique document search */
  where: BigNumberWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type BigNumberWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type BigNumberWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BigNumberWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BigNumberWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BigNumberWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  bigNumberItems_every?: InputMaybe<BigNumberItemWhereInput>;
  bigNumberItems_none?: InputMaybe<BigNumberItemWhereInput>;
  bigNumberItems_some?: InputMaybe<BigNumberItemWhereInput>;
  corpGenericContainers_every?: InputMaybe<CorpGenericContainerWhereInput>;
  corpGenericContainers_none?: InputMaybe<CorpGenericContainerWhereInput>;
  corpGenericContainers_some?: InputMaybe<CorpGenericContainerWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<BigNumberWhereStageInput>;
  documentInStages_none?: InputMaybe<BigNumberWhereStageInput>;
  documentInStages_some?: InputMaybe<BigNumberWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type BigNumberWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<BigNumberWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<BigNumberWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<BigNumberWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<BigNumberWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References BigNumber record uniquely */
export type BigNumberWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Card Component */
export type CardComponent = Entity & Node & {
  __typename?: 'CardComponent';
  /** Id for the Recipe, Product or Article etc */
  cardId: Scalars['String']['output'];
  /** Variation of card. Example - recipe, product, article etc */
  cardVariation?: Maybe<CardVariation>;
  /** Category in which cards belongs. */
  category: Scalars['String']['output'];
  /** Card Category ID */
  categoryId: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Description on the card */
  description?: Maybe<Scalars['String']['output']>;
  difficulty?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<CardComponent>;
  /** List of CardComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image: Array<CardComponentImage>;
  /** Title on card link */
  linkTitle?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CardComponent>;
  navigation?: Maybe<Navigation>;
  /** Category to which card belongs. Example - Recipe, Products, Articles etc */
  parentCategory?: Maybe<Scalars['String']['output']>;
  /** Card Navigation  */
  parentPage?: Maybe<Scalars['String']['output']>;
  /** For Recipe preparation time */
  preparationTime?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Rating for the Recipe */
  rating?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subCategory?: Maybe<Scalars['String']['output']>;
  tabContent?: Maybe<TabContent>;
  /** Display Title of the card */
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Url of the video */
  video?: Maybe<Scalars['String']['output']>;
};


/** Card Component */
export type CardComponentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Card Component */
export type CardComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Card Component */
export type CardComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Card Component */
export type CardComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Card Component */
export type CardComponentImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Card Component */
export type CardComponentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Card Component */
export type CardComponentNavigationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Card Component */
export type CardComponentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Card Component */
export type CardComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Card Component */
export type CardComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Card Component */
export type CardComponentTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Card Component */
export type CardComponentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Card Component */
export type CardComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CardComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CardComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type CardComponentConnection = {
  __typename?: 'CardComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CardComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CardComponentCreateInput = {
  cardId: Scalars['String']['input'];
  cardVariation?: InputMaybe<CardVariation>;
  category: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<CardComponentImageCreateManyInlineInput>;
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CardComponentCreateLocalizationsInput>;
  navigation?: InputMaybe<NavigationCreateOneInlineInput>;
  parentCategory?: InputMaybe<Scalars['String']['input']>;
  parentPage?: InputMaybe<Scalars['String']['input']>;
  preparationTime?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['String']['input']>;
  /** subCategory input for default locale (default) */
  subCategory?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  /** title input for default locale (default) */
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type CardComponentCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CardComponentCreateLocalizationInput = {
  /** Localization input */
  data: CardComponentCreateLocalizationDataInput;
  locale: Locale;
};

export type CardComponentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CardComponentCreateLocalizationInput>>;
};

export type CardComponentCreateManyInlineInput = {
  /** Connect multiple existing CardComponent documents */
  connect?: InputMaybe<Array<CardComponentWhereUniqueInput>>;
  /** Create and connect multiple existing CardComponent documents */
  create?: InputMaybe<Array<CardComponentCreateInput>>;
};

export type CardComponentCreateOneInlineInput = {
  /** Connect one existing CardComponent document */
  connect?: InputMaybe<CardComponentWhereUniqueInput>;
  /** Create and connect one CardComponent document */
  create?: InputMaybe<CardComponentCreateInput>;
};

/** An edge in a connection. */
export type CardComponentEdge = {
  __typename?: 'CardComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CardComponent;
};

export type CardComponentImage = AssetComponent;

export type CardComponentImageConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type CardComponentImageCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type CardComponentImageCreateManyInlineInput = {
  /** Connect multiple existing CardComponentImage documents */
  connect?: InputMaybe<Array<CardComponentImageWhereUniqueInput>>;
  /** Create and connect multiple existing CardComponentImage documents */
  create?: InputMaybe<Array<CardComponentImageCreateInput>>;
};

export type CardComponentImageCreateOneInlineInput = {
  /** Connect one existing CardComponentImage document */
  connect?: InputMaybe<CardComponentImageWhereUniqueInput>;
  /** Create and connect one CardComponentImage document */
  create?: InputMaybe<CardComponentImageCreateInput>;
};

export type CardComponentImageUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type CardComponentImageUpdateManyInlineInput = {
  /** Connect multiple existing CardComponentImage documents */
  connect?: InputMaybe<Array<CardComponentImageConnectInput>>;
  /** Create and connect multiple CardComponentImage documents */
  create?: InputMaybe<Array<CardComponentImageCreateInput>>;
  /** Delete multiple CardComponentImage documents */
  delete?: InputMaybe<Array<CardComponentImageWhereUniqueInput>>;
  /** Disconnect multiple CardComponentImage documents */
  disconnect?: InputMaybe<Array<CardComponentImageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CardComponentImage documents */
  set?: InputMaybe<Array<CardComponentImageWhereUniqueInput>>;
  /** Update multiple CardComponentImage documents */
  update?: InputMaybe<Array<CardComponentImageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CardComponentImage documents */
  upsert?: InputMaybe<Array<CardComponentImageUpsertWithNestedWhereUniqueInput>>;
};

export type CardComponentImageUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type CardComponentImageUpdateOneInlineInput = {
  /** Connect existing CardComponentImage document */
  connect?: InputMaybe<CardComponentImageWhereUniqueInput>;
  /** Create and connect one CardComponentImage document */
  create?: InputMaybe<CardComponentImageCreateInput>;
  /** Delete currently connected CardComponentImage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CardComponentImage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CardComponentImage document */
  update?: InputMaybe<CardComponentImageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CardComponentImage document */
  upsert?: InputMaybe<CardComponentImageUpsertWithNestedWhereUniqueInput>;
};

export type CardComponentImageUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type CardComponentImageUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type CardComponentImageWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type CardComponentImageWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

/** Identifies documents */
export type CardComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CardComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CardComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CardComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardId_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardVariation?: InputMaybe<CardVariation>;
  /** All values that are contained in given list. */
  cardVariation_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardVariation_not?: InputMaybe<CardVariation>;
  /** All values that are not contained in given list. */
  cardVariation_not_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  categoryId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  categoryId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  categoryId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  categoryId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  categoryId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  categoryId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  categoryId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  categoryId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  categoryId_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  category_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  category_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  category_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  category_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  category_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  category_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  difficulty_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  difficulty_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  difficulty_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  difficulty_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  difficulty_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  difficulty_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  difficulty_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  difficulty_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  difficulty_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CardComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<CardComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<CardComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  image_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  image_some?: InputMaybe<CardComponentImageWhereInput>;
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  navigation?: InputMaybe<NavigationWhereInput>;
  parentCategory?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  parentCategory_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  parentCategory_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  parentCategory_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  parentCategory_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  parentCategory_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  parentCategory_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  parentCategory_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  parentCategory_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  parentCategory_starts_with?: InputMaybe<Scalars['String']['input']>;
  parentPage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  parentPage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  parentPage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  parentPage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  parentPage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  parentPage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  parentPage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  parentPage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  parentPage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  parentPage_starts_with?: InputMaybe<Scalars['String']['input']>;
  preparationTime?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  preparationTime_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  preparationTime_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  preparationTime_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  preparationTime_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  preparationTime_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  preparationTime_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  preparationTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  preparationTime_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  preparationTime_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  rating?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  rating_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  rating_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  rating_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  rating_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  rating_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  rating_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  rating_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  rating_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  rating_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  video_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  video_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  video_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  video_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  video_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  video_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  video_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  video_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  video_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum CardComponentOrderByInput {
  cardId_ASC = 'cardId_ASC',
  cardId_DESC = 'cardId_DESC',
  cardVariation_ASC = 'cardVariation_ASC',
  cardVariation_DESC = 'cardVariation_DESC',
  categoryId_ASC = 'categoryId_ASC',
  categoryId_DESC = 'categoryId_DESC',
  category_ASC = 'category_ASC',
  category_DESC = 'category_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  difficulty_ASC = 'difficulty_ASC',
  difficulty_DESC = 'difficulty_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  linkTitle_ASC = 'linkTitle_ASC',
  linkTitle_DESC = 'linkTitle_DESC',
  parentCategory_ASC = 'parentCategory_ASC',
  parentCategory_DESC = 'parentCategory_DESC',
  parentPage_ASC = 'parentPage_ASC',
  parentPage_DESC = 'parentPage_DESC',
  preparationTime_ASC = 'preparationTime_ASC',
  preparationTime_DESC = 'preparationTime_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  rating_ASC = 'rating_ASC',
  rating_DESC = 'rating_DESC',
  subCategory_ASC = 'subCategory_ASC',
  subCategory_DESC = 'subCategory_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  video_ASC = 'video_ASC',
  video_DESC = 'video_DESC'
}

export type CardComponentUpdateInput = {
  cardId?: InputMaybe<Scalars['String']['input']>;
  cardVariation?: InputMaybe<CardVariation>;
  category?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<CardComponentImageUpdateManyInlineInput>;
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CardComponentUpdateLocalizationsInput>;
  navigation?: InputMaybe<NavigationUpdateOneInlineInput>;
  parentCategory?: InputMaybe<Scalars['String']['input']>;
  parentPage?: InputMaybe<Scalars['String']['input']>;
  preparationTime?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['String']['input']>;
  /** subCategory input for default locale (default) */
  subCategory?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type CardComponentUpdateLocalizationDataInput = {
  subCategory?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CardComponentUpdateLocalizationInput = {
  data: CardComponentUpdateLocalizationDataInput;
  locale: Locale;
};

export type CardComponentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CardComponentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CardComponentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CardComponentUpsertLocalizationInput>>;
};

export type CardComponentUpdateManyInlineInput = {
  /** Connect multiple existing CardComponent documents */
  connect?: InputMaybe<Array<CardComponentConnectInput>>;
  /** Create and connect multiple CardComponent documents */
  create?: InputMaybe<Array<CardComponentCreateInput>>;
  /** Delete multiple CardComponent documents */
  delete?: InputMaybe<Array<CardComponentWhereUniqueInput>>;
  /** Disconnect multiple CardComponent documents */
  disconnect?: InputMaybe<Array<CardComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CardComponent documents */
  set?: InputMaybe<Array<CardComponentWhereUniqueInput>>;
  /** Update multiple CardComponent documents */
  update?: InputMaybe<Array<CardComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CardComponent documents */
  upsert?: InputMaybe<Array<CardComponentUpsertWithNestedWhereUniqueInput>>;
};

export type CardComponentUpdateManyInput = {
  cardVariation?: InputMaybe<CardVariation>;
  category?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CardComponentUpdateManyLocalizationsInput>;
  parentCategory?: InputMaybe<Scalars['String']['input']>;
  parentPage?: InputMaybe<Scalars['String']['input']>;
  preparationTime?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['String']['input']>;
  /** subCategory input for default locale (default) */
  subCategory?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type CardComponentUpdateManyLocalizationDataInput = {
  subCategory?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CardComponentUpdateManyLocalizationInput = {
  data: CardComponentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CardComponentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CardComponentUpdateManyLocalizationInput>>;
};

export type CardComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CardComponentUpdateManyInput;
  /** Document search */
  where: CardComponentWhereInput;
};

export type CardComponentUpdateOneInlineInput = {
  /** Connect existing CardComponent document */
  connect?: InputMaybe<CardComponentWhereUniqueInput>;
  /** Create and connect one CardComponent document */
  create?: InputMaybe<CardComponentCreateInput>;
  /** Delete currently connected CardComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CardComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CardComponent document */
  update?: InputMaybe<CardComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CardComponent document */
  upsert?: InputMaybe<CardComponentUpsertWithNestedWhereUniqueInput>;
};

export type CardComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CardComponentUpdateInput;
  /** Unique document search */
  where: CardComponentWhereUniqueInput;
};

export type CardComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: CardComponentCreateInput;
  /** Update document if it exists */
  update: CardComponentUpdateInput;
};

export type CardComponentUpsertLocalizationInput = {
  create: CardComponentCreateLocalizationDataInput;
  locale: Locale;
  update: CardComponentUpdateLocalizationDataInput;
};

export type CardComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CardComponentUpsertInput;
  /** Unique document search */
  where: CardComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CardComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CardComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CardComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CardComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CardComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardId_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardVariation?: InputMaybe<CardVariation>;
  /** All values that are contained in given list. */
  cardVariation_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardVariation_not?: InputMaybe<CardVariation>;
  /** All values that are not contained in given list. */
  cardVariation_not_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  categoryId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  categoryId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  categoryId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  categoryId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  categoryId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  categoryId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  categoryId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  categoryId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  categoryId_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  category_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  category_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  category_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  category_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  category_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  category_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  category_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  category_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  category_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  difficulty_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  difficulty_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  difficulty_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  difficulty_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  difficulty_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  difficulty_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  difficulty_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  difficulty_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  difficulty_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CardComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<CardComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<CardComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  image_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  image_some?: InputMaybe<CardComponentImageWhereInput>;
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  navigation?: InputMaybe<NavigationWhereInput>;
  parentCategory?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  parentCategory_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  parentCategory_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  parentCategory_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  parentCategory_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  parentCategory_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  parentCategory_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  parentCategory_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  parentCategory_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  parentCategory_starts_with?: InputMaybe<Scalars['String']['input']>;
  parentPage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  parentPage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  parentPage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  parentPage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  parentPage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  parentPage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  parentPage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  parentPage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  parentPage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  parentPage_starts_with?: InputMaybe<Scalars['String']['input']>;
  preparationTime?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  preparationTime_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  preparationTime_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  preparationTime_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  preparationTime_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  preparationTime_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  preparationTime_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  preparationTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  preparationTime_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  preparationTime_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  rating?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  rating_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  rating_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  rating_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  rating_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  rating_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  rating_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  rating_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  rating_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  rating_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subCategory?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subCategory_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subCategory_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subCategory_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subCategory_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subCategory_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subCategory_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subCategory_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subCategory_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subCategory_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  video_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  video_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  video_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  video_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  video_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  video_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  video_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  video_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  video_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CardComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CardComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CardComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CardComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CardComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CardComponent record uniquely */
export type CardComponentWhereUniqueInput = {
  cardId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Card Layout  */
export enum CardLayout {
  Carousel = 'Carousel',
  Grid = 'Grid'
}

/** Card Varistion */
export enum CardVariation {
  article = 'article',
  object = 'object',
  product = 'product',
  recipe = 'recipe',
  tipsAndTricks = 'tipsAndTricks',
  white = 'white'
}

export type CarouselComponent = Entity & Node & {
  __typename?: 'CarouselComponent';
  anchorNav?: Maybe<AnchorNavigation>;
  backgroundImg?: Maybe<Asset>;
  bottomLeftAsset?: Maybe<Asset>;
  cardVariant?: Maybe<CorpCardCarouselVariant>;
  carouselName: Scalars['String']['output'];
  carouselSlides: Array<CarouselSlide>;
  carouselType: CarouselType;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CarouselComponent>;
  genericPages: Array<GenericPage>;
  heading?: Maybe<Scalars['String']['output']>;
  /** List of CarouselComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CarouselComponent>;
  mediaLibrary?: Maybe<MediaLibrary>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** This is the number of slides a user can see per one carousel slide */
  slidesToShow?: Maybe<Scalars['Int']['output']>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  tabContent?: Maybe<TabContent>;
  title?: Maybe<Scalars['String']['output']>;
  topRightAsset?: Maybe<Asset>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CarouselComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselComponentBackgroundImgArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CarouselComponentBottomLeftAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CarouselComponentCarouselSlidesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CarouselSlideOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselSlideWhereInput>;
};


export type CarouselComponentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CarouselComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CarouselComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type CarouselComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CarouselComponentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CarouselComponentMediaLibraryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselComponentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CarouselComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CarouselComponentStoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


export type CarouselComponentTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselComponentTopRightAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CarouselComponentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CarouselComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CarouselComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CarouselComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type CarouselComponentConnection = {
  __typename?: 'CarouselComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CarouselComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CarouselComponentCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  backgroundImg?: InputMaybe<AssetCreateOneInlineInput>;
  bottomLeftAsset?: InputMaybe<AssetCreateOneInlineInput>;
  cardVariant?: InputMaybe<CorpCardCarouselVariant>;
  carouselName: Scalars['String']['input'];
  carouselSlides?: InputMaybe<CarouselSlideCreateManyInlineInput>;
  carouselType: CarouselType;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  /** heading input for default locale (default) */
  heading?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CarouselComponentCreateLocalizationsInput>;
  mediaLibrary?: InputMaybe<MediaLibraryCreateOneInlineInput>;
  slidesToShow?: InputMaybe<Scalars['Int']['input']>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  topRightAsset?: InputMaybe<AssetCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CarouselComponentCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CarouselComponentCreateLocalizationInput = {
  /** Localization input */
  data: CarouselComponentCreateLocalizationDataInput;
  locale: Locale;
};

export type CarouselComponentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CarouselComponentCreateLocalizationInput>>;
};

export type CarouselComponentCreateManyInlineInput = {
  /** Connect multiple existing CarouselComponent documents */
  connect?: InputMaybe<Array<CarouselComponentWhereUniqueInput>>;
  /** Create and connect multiple existing CarouselComponent documents */
  create?: InputMaybe<Array<CarouselComponentCreateInput>>;
};

export type CarouselComponentCreateOneInlineInput = {
  /** Connect one existing CarouselComponent document */
  connect?: InputMaybe<CarouselComponentWhereUniqueInput>;
  /** Create and connect one CarouselComponent document */
  create?: InputMaybe<CarouselComponentCreateInput>;
};

/** An edge in a connection. */
export type CarouselComponentEdge = {
  __typename?: 'CarouselComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CarouselComponent;
};

/** Identifies documents */
export type CarouselComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CarouselComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CarouselComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CarouselComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundImg?: InputMaybe<AssetWhereInput>;
  bottomLeftAsset?: InputMaybe<AssetWhereInput>;
  cardVariant?: InputMaybe<CorpCardCarouselVariant>;
  /** All values that are contained in given list. */
  cardVariant_in?: InputMaybe<Array<InputMaybe<CorpCardCarouselVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardVariant_not?: InputMaybe<CorpCardCarouselVariant>;
  /** All values that are not contained in given list. */
  cardVariant_not_in?: InputMaybe<Array<InputMaybe<CorpCardCarouselVariant>>>;
  carouselName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  carouselName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  carouselName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  carouselName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  carouselName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  carouselName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  carouselName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  carouselName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  carouselName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  carouselName_starts_with?: InputMaybe<Scalars['String']['input']>;
  carouselSlides_every?: InputMaybe<CarouselSlideWhereInput>;
  carouselSlides_none?: InputMaybe<CarouselSlideWhereInput>;
  carouselSlides_some?: InputMaybe<CarouselSlideWhereInput>;
  carouselType?: InputMaybe<CarouselType>;
  /** All values that are contained in given list. */
  carouselType_in?: InputMaybe<Array<InputMaybe<CarouselType>>>;
  /** Any other value that exists and is not equal to the given value. */
  carouselType_not?: InputMaybe<CarouselType>;
  /** All values that are not contained in given list. */
  carouselType_not_in?: InputMaybe<Array<InputMaybe<CarouselType>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CarouselComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<CarouselComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<CarouselComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slidesToShow?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  slidesToShow_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  slidesToShow_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  slidesToShow_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  slidesToShow_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  slidesToShow_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  slidesToShow_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  slidesToShow_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  topRightAsset?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CarouselComponentOrderByInput {
  cardVariant_ASC = 'cardVariant_ASC',
  cardVariant_DESC = 'cardVariant_DESC',
  carouselName_ASC = 'carouselName_ASC',
  carouselName_DESC = 'carouselName_DESC',
  carouselType_ASC = 'carouselType_ASC',
  carouselType_DESC = 'carouselType_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slidesToShow_ASC = 'slidesToShow_ASC',
  slidesToShow_DESC = 'slidesToShow_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CarouselComponentUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  backgroundImg?: InputMaybe<AssetUpdateOneInlineInput>;
  bottomLeftAsset?: InputMaybe<AssetUpdateOneInlineInput>;
  cardVariant?: InputMaybe<CorpCardCarouselVariant>;
  carouselName?: InputMaybe<Scalars['String']['input']>;
  carouselSlides?: InputMaybe<CarouselSlideUpdateManyInlineInput>;
  carouselType?: InputMaybe<CarouselType>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  /** heading input for default locale (default) */
  heading?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CarouselComponentUpdateLocalizationsInput>;
  mediaLibrary?: InputMaybe<MediaLibraryUpdateOneInlineInput>;
  slidesToShow?: InputMaybe<Scalars['Int']['input']>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  topRightAsset?: InputMaybe<AssetUpdateOneInlineInput>;
};

export type CarouselComponentUpdateLocalizationDataInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CarouselComponentUpdateLocalizationInput = {
  data: CarouselComponentUpdateLocalizationDataInput;
  locale: Locale;
};

export type CarouselComponentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CarouselComponentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CarouselComponentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CarouselComponentUpsertLocalizationInput>>;
};

export type CarouselComponentUpdateManyInlineInput = {
  /** Connect multiple existing CarouselComponent documents */
  connect?: InputMaybe<Array<CarouselComponentConnectInput>>;
  /** Create and connect multiple CarouselComponent documents */
  create?: InputMaybe<Array<CarouselComponentCreateInput>>;
  /** Delete multiple CarouselComponent documents */
  delete?: InputMaybe<Array<CarouselComponentWhereUniqueInput>>;
  /** Disconnect multiple CarouselComponent documents */
  disconnect?: InputMaybe<Array<CarouselComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CarouselComponent documents */
  set?: InputMaybe<Array<CarouselComponentWhereUniqueInput>>;
  /** Update multiple CarouselComponent documents */
  update?: InputMaybe<Array<CarouselComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CarouselComponent documents */
  upsert?: InputMaybe<Array<CarouselComponentUpsertWithNestedWhereUniqueInput>>;
};

export type CarouselComponentUpdateManyInput = {
  cardVariant?: InputMaybe<CorpCardCarouselVariant>;
  carouselName?: InputMaybe<Scalars['String']['input']>;
  carouselType?: InputMaybe<CarouselType>;
  /** heading input for default locale (default) */
  heading?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CarouselComponentUpdateManyLocalizationsInput>;
  slidesToShow?: InputMaybe<Scalars['Int']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CarouselComponentUpdateManyLocalizationDataInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CarouselComponentUpdateManyLocalizationInput = {
  data: CarouselComponentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CarouselComponentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CarouselComponentUpdateManyLocalizationInput>>;
};

export type CarouselComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CarouselComponentUpdateManyInput;
  /** Document search */
  where: CarouselComponentWhereInput;
};

export type CarouselComponentUpdateOneInlineInput = {
  /** Connect existing CarouselComponent document */
  connect?: InputMaybe<CarouselComponentWhereUniqueInput>;
  /** Create and connect one CarouselComponent document */
  create?: InputMaybe<CarouselComponentCreateInput>;
  /** Delete currently connected CarouselComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CarouselComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CarouselComponent document */
  update?: InputMaybe<CarouselComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CarouselComponent document */
  upsert?: InputMaybe<CarouselComponentUpsertWithNestedWhereUniqueInput>;
};

export type CarouselComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CarouselComponentUpdateInput;
  /** Unique document search */
  where: CarouselComponentWhereUniqueInput;
};

export type CarouselComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: CarouselComponentCreateInput;
  /** Update document if it exists */
  update: CarouselComponentUpdateInput;
};

export type CarouselComponentUpsertLocalizationInput = {
  create: CarouselComponentCreateLocalizationDataInput;
  locale: Locale;
  update: CarouselComponentUpdateLocalizationDataInput;
};

export type CarouselComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CarouselComponentUpsertInput;
  /** Unique document search */
  where: CarouselComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CarouselComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CarouselComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CarouselComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CarouselComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CarouselComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundImg?: InputMaybe<AssetWhereInput>;
  bottomLeftAsset?: InputMaybe<AssetWhereInput>;
  cardVariant?: InputMaybe<CorpCardCarouselVariant>;
  /** All values that are contained in given list. */
  cardVariant_in?: InputMaybe<Array<InputMaybe<CorpCardCarouselVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardVariant_not?: InputMaybe<CorpCardCarouselVariant>;
  /** All values that are not contained in given list. */
  cardVariant_not_in?: InputMaybe<Array<InputMaybe<CorpCardCarouselVariant>>>;
  carouselName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  carouselName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  carouselName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  carouselName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  carouselName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  carouselName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  carouselName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  carouselName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  carouselName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  carouselName_starts_with?: InputMaybe<Scalars['String']['input']>;
  carouselSlides_every?: InputMaybe<CarouselSlideWhereInput>;
  carouselSlides_none?: InputMaybe<CarouselSlideWhereInput>;
  carouselSlides_some?: InputMaybe<CarouselSlideWhereInput>;
  carouselType?: InputMaybe<CarouselType>;
  /** All values that are contained in given list. */
  carouselType_in?: InputMaybe<Array<InputMaybe<CarouselType>>>;
  /** Any other value that exists and is not equal to the given value. */
  carouselType_not?: InputMaybe<CarouselType>;
  /** All values that are not contained in given list. */
  carouselType_not_in?: InputMaybe<Array<InputMaybe<CarouselType>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CarouselComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<CarouselComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<CarouselComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slidesToShow?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  slidesToShow_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  slidesToShow_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  slidesToShow_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  slidesToShow_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  slidesToShow_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  slidesToShow_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  slidesToShow_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  topRightAsset?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CarouselComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CarouselComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CarouselComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CarouselComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CarouselComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CarouselComponent record uniquely */
export type CarouselComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CarouselSlide = Entity & Node & {
  __typename?: 'CarouselSlide';
  caption?: Maybe<Scalars['String']['output']>;
  carouselComponent?: Maybe<CarouselComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CarouselSlide>;
  /** List of CarouselSlide versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CarouselSlide>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slideAsset?: Maybe<Asset>;
  /** System stage field */
  stage: Stage;
  /** CMS Title */
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  videoId?: Maybe<Scalars['String']['output']>;
};


export type CarouselSlideCarouselComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselSlideCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CarouselSlideCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselSlideDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CarouselSlideHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CarouselSlideLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselSlideLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CarouselSlidePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CarouselSlidePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CarouselSlideScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CarouselSlideSlideAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CarouselSlideUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CarouselSlideUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CarouselSlideConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CarouselSlideWhereUniqueInput;
};

/** A connection to a list of items. */
export type CarouselSlideConnection = {
  __typename?: 'CarouselSlideConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CarouselSlideEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CarouselSlideCreateInput = {
  /** caption input for default locale (default) */
  caption?: InputMaybe<Scalars['String']['input']>;
  carouselComponent?: InputMaybe<CarouselComponentCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CarouselSlideCreateLocalizationsInput>;
  slideAsset?: InputMaybe<AssetCreateOneInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** videoId input for default locale (default) */
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type CarouselSlideCreateLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type CarouselSlideCreateLocalizationInput = {
  /** Localization input */
  data: CarouselSlideCreateLocalizationDataInput;
  locale: Locale;
};

export type CarouselSlideCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CarouselSlideCreateLocalizationInput>>;
};

export type CarouselSlideCreateManyInlineInput = {
  /** Connect multiple existing CarouselSlide documents */
  connect?: InputMaybe<Array<CarouselSlideWhereUniqueInput>>;
  /** Create and connect multiple existing CarouselSlide documents */
  create?: InputMaybe<Array<CarouselSlideCreateInput>>;
};

export type CarouselSlideCreateOneInlineInput = {
  /** Connect one existing CarouselSlide document */
  connect?: InputMaybe<CarouselSlideWhereUniqueInput>;
  /** Create and connect one CarouselSlide document */
  create?: InputMaybe<CarouselSlideCreateInput>;
};

/** An edge in a connection. */
export type CarouselSlideEdge = {
  __typename?: 'CarouselSlideEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CarouselSlide;
};

/** Identifies documents */
export type CarouselSlideManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CarouselSlideWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CarouselSlideWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CarouselSlideWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  carouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CarouselSlideWhereStageInput>;
  documentInStages_none?: InputMaybe<CarouselSlideWhereStageInput>;
  documentInStages_some?: InputMaybe<CarouselSlideWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slideAsset?: InputMaybe<AssetWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CarouselSlideOrderByInput {
  caption_ASC = 'caption_ASC',
  caption_DESC = 'caption_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  videoId_ASC = 'videoId_ASC',
  videoId_DESC = 'videoId_DESC'
}

export type CarouselSlideUpdateInput = {
  /** caption input for default locale (default) */
  caption?: InputMaybe<Scalars['String']['input']>;
  carouselComponent?: InputMaybe<CarouselComponentUpdateOneInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CarouselSlideUpdateLocalizationsInput>;
  slideAsset?: InputMaybe<AssetUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** videoId input for default locale (default) */
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type CarouselSlideUpdateLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type CarouselSlideUpdateLocalizationInput = {
  data: CarouselSlideUpdateLocalizationDataInput;
  locale: Locale;
};

export type CarouselSlideUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CarouselSlideCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CarouselSlideUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CarouselSlideUpsertLocalizationInput>>;
};

export type CarouselSlideUpdateManyInlineInput = {
  /** Connect multiple existing CarouselSlide documents */
  connect?: InputMaybe<Array<CarouselSlideConnectInput>>;
  /** Create and connect multiple CarouselSlide documents */
  create?: InputMaybe<Array<CarouselSlideCreateInput>>;
  /** Delete multiple CarouselSlide documents */
  delete?: InputMaybe<Array<CarouselSlideWhereUniqueInput>>;
  /** Disconnect multiple CarouselSlide documents */
  disconnect?: InputMaybe<Array<CarouselSlideWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CarouselSlide documents */
  set?: InputMaybe<Array<CarouselSlideWhereUniqueInput>>;
  /** Update multiple CarouselSlide documents */
  update?: InputMaybe<Array<CarouselSlideUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CarouselSlide documents */
  upsert?: InputMaybe<Array<CarouselSlideUpsertWithNestedWhereUniqueInput>>;
};

export type CarouselSlideUpdateManyInput = {
  /** caption input for default locale (default) */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CarouselSlideUpdateManyLocalizationsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** videoId input for default locale (default) */
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type CarouselSlideUpdateManyLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type CarouselSlideUpdateManyLocalizationInput = {
  data: CarouselSlideUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CarouselSlideUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CarouselSlideUpdateManyLocalizationInput>>;
};

export type CarouselSlideUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CarouselSlideUpdateManyInput;
  /** Document search */
  where: CarouselSlideWhereInput;
};

export type CarouselSlideUpdateOneInlineInput = {
  /** Connect existing CarouselSlide document */
  connect?: InputMaybe<CarouselSlideWhereUniqueInput>;
  /** Create and connect one CarouselSlide document */
  create?: InputMaybe<CarouselSlideCreateInput>;
  /** Delete currently connected CarouselSlide document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CarouselSlide document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CarouselSlide document */
  update?: InputMaybe<CarouselSlideUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CarouselSlide document */
  upsert?: InputMaybe<CarouselSlideUpsertWithNestedWhereUniqueInput>;
};

export type CarouselSlideUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CarouselSlideUpdateInput;
  /** Unique document search */
  where: CarouselSlideWhereUniqueInput;
};

export type CarouselSlideUpsertInput = {
  /** Create document if it didn't exist */
  create: CarouselSlideCreateInput;
  /** Update document if it exists */
  update: CarouselSlideUpdateInput;
};

export type CarouselSlideUpsertLocalizationInput = {
  create: CarouselSlideCreateLocalizationDataInput;
  locale: Locale;
  update: CarouselSlideUpdateLocalizationDataInput;
};

export type CarouselSlideUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CarouselSlideUpsertInput;
  /** Unique document search */
  where: CarouselSlideWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CarouselSlideWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CarouselSlideWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CarouselSlideWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CarouselSlideWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CarouselSlideWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  carouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CarouselSlideWhereStageInput>;
  documentInStages_none?: InputMaybe<CarouselSlideWhereStageInput>;
  documentInStages_some?: InputMaybe<CarouselSlideWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slideAsset?: InputMaybe<AssetWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoId_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CarouselSlideWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CarouselSlideWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CarouselSlideWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CarouselSlideWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CarouselSlideWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CarouselSlide record uniquely */
export type CarouselSlideWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum CarouselType {
  ImageVideo = 'ImageVideo',
  Products = 'Products',
  RecipeCards = 'RecipeCards'
}

export type CategoryCard = Entity & Node & {
  __typename?: 'CategoryCard';
  anchorNav?: Maybe<AnchorNavigation>;
  /** for images of category */
  assetComponent?: Maybe<AssetComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CategoryCard>;
  /** List of CategoryCard versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CategoryCardAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CategoryCardAssetComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CategoryCardCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CategoryCardDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CategoryCardHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CategoryCardPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CategoryCardScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CategoryCardUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CategoryCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CategoryCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CategoryCardConnection = {
  __typename?: 'CategoryCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CategoryCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CategoryCardCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  assetComponent?: InputMaybe<AssetComponentCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CategoryCardCreateManyInlineInput = {
  /** Connect multiple existing CategoryCard documents */
  connect?: InputMaybe<Array<CategoryCardWhereUniqueInput>>;
  /** Create and connect multiple existing CategoryCard documents */
  create?: InputMaybe<Array<CategoryCardCreateInput>>;
};

export type CategoryCardCreateOneInlineInput = {
  /** Connect one existing CategoryCard document */
  connect?: InputMaybe<CategoryCardWhereUniqueInput>;
  /** Create and connect one CategoryCard document */
  create?: InputMaybe<CategoryCardCreateInput>;
};

/** An edge in a connection. */
export type CategoryCardEdge = {
  __typename?: 'CategoryCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CategoryCard;
};

/** Identifies documents */
export type CategoryCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CategoryCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CategoryCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CategoryCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  assetComponent?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CategoryCardWhereStageInput>;
  documentInStages_none?: InputMaybe<CategoryCardWhereStageInput>;
  documentInStages_some?: InputMaybe<CategoryCardWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CategoryCardOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CategoryCardUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  assetComponent?: InputMaybe<AssetComponentUpdateOneInlineInput>;
};

export type CategoryCardUpdateManyInlineInput = {
  /** Connect multiple existing CategoryCard documents */
  connect?: InputMaybe<Array<CategoryCardConnectInput>>;
  /** Create and connect multiple CategoryCard documents */
  create?: InputMaybe<Array<CategoryCardCreateInput>>;
  /** Delete multiple CategoryCard documents */
  delete?: InputMaybe<Array<CategoryCardWhereUniqueInput>>;
  /** Disconnect multiple CategoryCard documents */
  disconnect?: InputMaybe<Array<CategoryCardWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CategoryCard documents */
  set?: InputMaybe<Array<CategoryCardWhereUniqueInput>>;
  /** Update multiple CategoryCard documents */
  update?: InputMaybe<Array<CategoryCardUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CategoryCard documents */
  upsert?: InputMaybe<Array<CategoryCardUpsertWithNestedWhereUniqueInput>>;
};

export type CategoryCardUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CategoryCardUpdateManyInput;
  /** Document search */
  where: CategoryCardWhereInput;
};

export type CategoryCardUpdateOneInlineInput = {
  /** Connect existing CategoryCard document */
  connect?: InputMaybe<CategoryCardWhereUniqueInput>;
  /** Create and connect one CategoryCard document */
  create?: InputMaybe<CategoryCardCreateInput>;
  /** Delete currently connected CategoryCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CategoryCard document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CategoryCard document */
  update?: InputMaybe<CategoryCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CategoryCard document */
  upsert?: InputMaybe<CategoryCardUpsertWithNestedWhereUniqueInput>;
};

export type CategoryCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CategoryCardUpdateInput;
  /** Unique document search */
  where: CategoryCardWhereUniqueInput;
};

export type CategoryCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CategoryCardCreateInput;
  /** Update document if it exists */
  update: CategoryCardUpdateInput;
};

export type CategoryCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CategoryCardUpsertInput;
  /** Unique document search */
  where: CategoryCardWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CategoryCardWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CategoryCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CategoryCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CategoryCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CategoryCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  assetComponent?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CategoryCardWhereStageInput>;
  documentInStages_none?: InputMaybe<CategoryCardWhereStageInput>;
  documentInStages_some?: InputMaybe<CategoryCardWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CategoryCardWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CategoryCardWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CategoryCardWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CategoryCardWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CategoryCardWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CategoryCard record uniquely */
export type CategoryCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Representing a color value comprising of HEX, RGBA and css color values */
export type Color = {
  __typename?: 'Color';
  css: Scalars['String']['output'];
  hex: Scalars['Hex']['output'];
  rgba: Rgba;
};

/** Accepts either HEX or RGBA color value. At least one of hex or rgba value should be passed. If both are passed RGBA is used. */
export type ColorInput = {
  hex?: InputMaybe<Scalars['Hex']['input']>;
  rgba?: InputMaybe<RgbaInput>;
};

/** Number of column */
export enum Column {
  three = 'three',
  two = 'two'
}

/** Type of column  */
export enum ColumnType {
  Full = 'Full',
  Half = 'Half',
  Multi_column = 'Multi_column'
}

export enum ComparisonOperators {
  GreaterThan = 'GreaterThan',
  GreaterThanAndEqual = 'GreaterThanAndEqual',
  LesserThan = 'LesserThan',
  LesserThanAndEqual = 'LesserThanAndEqual'
}

export type ConnectPositionInput = {
  /** Connect document after specified document */
  after?: InputMaybe<Scalars['ID']['input']>;
  /** Connect document before specified document */
  before?: InputMaybe<Scalars['ID']['input']>;
  /** Connect document at last position */
  end?: InputMaybe<Scalars['Boolean']['input']>;
  /** Connect document at first position */
  start?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Contact card */
export type ContactCard = Entity & Node & {
  __typename?: 'ContactCard';
  anchorNav?: Maybe<AnchorNavigation>;
  /** Title for CMS purposes only */
  cmsTitle: Scalars['String']['output'];
  contactCardContainer?: Maybe<ContactCardContainer>;
  /** Type of icon to display above the card */
  contactTypeIcon?: Maybe<ContactType>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<ContactCard>;
  /** Label for the first field */
  field1Label?: Maybe<Scalars['String']['output']>;
  /** Text for the first field */
  field1Text?: Maybe<Scalars['String']['output']>;
  /** Label for the second field */
  field2Label?: Maybe<Scalars['String']['output']>;
  /** Text for the second field */
  field2Text?: Maybe<Scalars['String']['output']>;
  /** List of ContactCard versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<AssetComponent>;
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<ContactCard>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Title for the card */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Contact card */
export type ContactCardAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contact card */
export type ContactCardContactCardContainerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contact card */
export type ContactCardCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Contact card */
export type ContactCardCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contact card */
export type ContactCardDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Contact card */
export type ContactCardHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Contact card */
export type ContactCardImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contact card */
export type ContactCardLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contact card */
export type ContactCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Contact card */
export type ContactCardPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Contact card */
export type ContactCardPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contact card */
export type ContactCardScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Contact card */
export type ContactCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Contact card */
export type ContactCardUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ContactCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContactCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContactCardConnection = {
  __typename?: 'ContactCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContactCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Container for all the contact cards */
export type ContactCardContainer = Entity & Node & {
  __typename?: 'ContactCardContainer';
  anchorNav?: Maybe<AnchorNavigation>;
  cmsTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  data: Array<ContactCard>;
  /** Get the document in other stages */
  documentInStages: Array<ContactCardContainer>;
  genericPages: Array<GenericPage>;
  /** List of ContactCardContainer versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Container for all the contact cards */
export type ContactCardContainerAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Container for all the contact cards */
export type ContactCardContainerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Container for all the contact cards */
export type ContactCardContainerDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ContactCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContactCardWhereInput>;
};


/** Container for all the contact cards */
export type ContactCardContainerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Container for all the contact cards */
export type ContactCardContainerGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Container for all the contact cards */
export type ContactCardContainerHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Container for all the contact cards */
export type ContactCardContainerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Container for all the contact cards */
export type ContactCardContainerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Container for all the contact cards */
export type ContactCardContainerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ContactCardContainerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ContactCardContainerWhereUniqueInput;
};

/** A connection to a list of items. */
export type ContactCardContainerConnection = {
  __typename?: 'ContactCardContainerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ContactCardContainerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ContactCardContainerCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cmsTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  data?: InputMaybe<ContactCardCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContactCardContainerCreateManyInlineInput = {
  /** Connect multiple existing ContactCardContainer documents */
  connect?: InputMaybe<Array<ContactCardContainerWhereUniqueInput>>;
  /** Create and connect multiple existing ContactCardContainer documents */
  create?: InputMaybe<Array<ContactCardContainerCreateInput>>;
};

export type ContactCardContainerCreateOneInlineInput = {
  /** Connect one existing ContactCardContainer document */
  connect?: InputMaybe<ContactCardContainerWhereUniqueInput>;
  /** Create and connect one ContactCardContainer document */
  create?: InputMaybe<ContactCardContainerCreateInput>;
};

/** An edge in a connection. */
export type ContactCardContainerEdge = {
  __typename?: 'ContactCardContainerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContactCardContainer;
};

/** Identifies documents */
export type ContactCardContainerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContactCardContainerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContactCardContainerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContactCardContainerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  data_every?: InputMaybe<ContactCardWhereInput>;
  data_none?: InputMaybe<ContactCardWhereInput>;
  data_some?: InputMaybe<ContactCardWhereInput>;
  documentInStages_every?: InputMaybe<ContactCardContainerWhereStageInput>;
  documentInStages_none?: InputMaybe<ContactCardContainerWhereStageInput>;
  documentInStages_some?: InputMaybe<ContactCardContainerWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ContactCardContainerOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ContactCardContainerUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  data?: InputMaybe<ContactCardUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
};

export type ContactCardContainerUpdateManyInlineInput = {
  /** Connect multiple existing ContactCardContainer documents */
  connect?: InputMaybe<Array<ContactCardContainerConnectInput>>;
  /** Create and connect multiple ContactCardContainer documents */
  create?: InputMaybe<Array<ContactCardContainerCreateInput>>;
  /** Delete multiple ContactCardContainer documents */
  delete?: InputMaybe<Array<ContactCardContainerWhereUniqueInput>>;
  /** Disconnect multiple ContactCardContainer documents */
  disconnect?: InputMaybe<Array<ContactCardContainerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ContactCardContainer documents */
  set?: InputMaybe<Array<ContactCardContainerWhereUniqueInput>>;
  /** Update multiple ContactCardContainer documents */
  update?: InputMaybe<Array<ContactCardContainerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ContactCardContainer documents */
  upsert?: InputMaybe<Array<ContactCardContainerUpsertWithNestedWhereUniqueInput>>;
};

export type ContactCardContainerUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ContactCardContainerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContactCardContainerUpdateManyInput;
  /** Document search */
  where: ContactCardContainerWhereInput;
};

export type ContactCardContainerUpdateOneInlineInput = {
  /** Connect existing ContactCardContainer document */
  connect?: InputMaybe<ContactCardContainerWhereUniqueInput>;
  /** Create and connect one ContactCardContainer document */
  create?: InputMaybe<ContactCardContainerCreateInput>;
  /** Delete currently connected ContactCardContainer document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ContactCardContainer document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContactCardContainer document */
  update?: InputMaybe<ContactCardContainerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContactCardContainer document */
  upsert?: InputMaybe<ContactCardContainerUpsertWithNestedWhereUniqueInput>;
};

export type ContactCardContainerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContactCardContainerUpdateInput;
  /** Unique document search */
  where: ContactCardContainerWhereUniqueInput;
};

export type ContactCardContainerUpsertInput = {
  /** Create document if it didn't exist */
  create: ContactCardContainerCreateInput;
  /** Update document if it exists */
  update: ContactCardContainerUpdateInput;
};

export type ContactCardContainerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContactCardContainerUpsertInput;
  /** Unique document search */
  where: ContactCardContainerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ContactCardContainerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ContactCardContainerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContactCardContainerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContactCardContainerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContactCardContainerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  data_every?: InputMaybe<ContactCardWhereInput>;
  data_none?: InputMaybe<ContactCardWhereInput>;
  data_some?: InputMaybe<ContactCardWhereInput>;
  documentInStages_every?: InputMaybe<ContactCardContainerWhereStageInput>;
  documentInStages_none?: InputMaybe<ContactCardContainerWhereStageInput>;
  documentInStages_some?: InputMaybe<ContactCardContainerWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ContactCardContainerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContactCardContainerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContactCardContainerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContactCardContainerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ContactCardContainerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ContactCardContainer record uniquely */
export type ContactCardContainerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ContactCardCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cmsTitle: Scalars['String']['input'];
  contactCardContainer?: InputMaybe<ContactCardContainerCreateOneInlineInput>;
  /** contactTypeIcon input for default locale (default) */
  contactTypeIcon?: InputMaybe<ContactType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** field1Label input for default locale (default) */
  field1Label?: InputMaybe<Scalars['String']['input']>;
  /** field1Text input for default locale (default) */
  field1Text?: InputMaybe<Scalars['String']['input']>;
  /** field2Label input for default locale (default) */
  field2Label?: InputMaybe<Scalars['String']['input']>;
  /** field2Text input for default locale (default) */
  field2Text?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetComponentCreateOneInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ContactCardCreateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContactCardCreateLocalizationDataInput = {
  contactTypeIcon?: InputMaybe<ContactType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  field1Label?: InputMaybe<Scalars['String']['input']>;
  field1Text?: InputMaybe<Scalars['String']['input']>;
  field2Label?: InputMaybe<Scalars['String']['input']>;
  field2Text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ContactCardCreateLocalizationInput = {
  /** Localization input */
  data: ContactCardCreateLocalizationDataInput;
  locale: Locale;
};

export type ContactCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ContactCardCreateLocalizationInput>>;
};

export type ContactCardCreateManyInlineInput = {
  /** Connect multiple existing ContactCard documents */
  connect?: InputMaybe<Array<ContactCardWhereUniqueInput>>;
  /** Create and connect multiple existing ContactCard documents */
  create?: InputMaybe<Array<ContactCardCreateInput>>;
};

export type ContactCardCreateOneInlineInput = {
  /** Connect one existing ContactCard document */
  connect?: InputMaybe<ContactCardWhereUniqueInput>;
  /** Create and connect one ContactCard document */
  create?: InputMaybe<ContactCardCreateInput>;
};

/** An edge in a connection. */
export type ContactCardEdge = {
  __typename?: 'ContactCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ContactCard;
};

/** Identifies documents */
export type ContactCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContactCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContactCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContactCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  contactCardContainer?: InputMaybe<ContactCardContainerWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ContactCardWhereStageInput>;
  documentInStages_none?: InputMaybe<ContactCardWhereStageInput>;
  documentInStages_some?: InputMaybe<ContactCardWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ContactCardOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  contactTypeIcon_ASC = 'contactTypeIcon_ASC',
  contactTypeIcon_DESC = 'contactTypeIcon_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  field1Label_ASC = 'field1Label_ASC',
  field1Label_DESC = 'field1Label_DESC',
  field1Text_ASC = 'field1Text_ASC',
  field1Text_DESC = 'field1Text_DESC',
  field2Label_ASC = 'field2Label_ASC',
  field2Label_DESC = 'field2Label_DESC',
  field2Text_ASC = 'field2Text_ASC',
  field2Text_DESC = 'field2Text_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ContactCardUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  contactCardContainer?: InputMaybe<ContactCardContainerUpdateOneInlineInput>;
  /** contactTypeIcon input for default locale (default) */
  contactTypeIcon?: InputMaybe<ContactType>;
  /** field1Label input for default locale (default) */
  field1Label?: InputMaybe<Scalars['String']['input']>;
  /** field1Text input for default locale (default) */
  field1Text?: InputMaybe<Scalars['String']['input']>;
  /** field2Label input for default locale (default) */
  field2Label?: InputMaybe<Scalars['String']['input']>;
  /** field2Text input for default locale (default) */
  field2Text?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<ContactCardUpdateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContactCardUpdateLocalizationDataInput = {
  contactTypeIcon?: InputMaybe<ContactType>;
  field1Label?: InputMaybe<Scalars['String']['input']>;
  field1Text?: InputMaybe<Scalars['String']['input']>;
  field2Label?: InputMaybe<Scalars['String']['input']>;
  field2Text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContactCardUpdateLocalizationInput = {
  data: ContactCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type ContactCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ContactCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<ContactCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<ContactCardUpsertLocalizationInput>>;
};

export type ContactCardUpdateManyInlineInput = {
  /** Connect multiple existing ContactCard documents */
  connect?: InputMaybe<Array<ContactCardConnectInput>>;
  /** Create and connect multiple ContactCard documents */
  create?: InputMaybe<Array<ContactCardCreateInput>>;
  /** Delete multiple ContactCard documents */
  delete?: InputMaybe<Array<ContactCardWhereUniqueInput>>;
  /** Disconnect multiple ContactCard documents */
  disconnect?: InputMaybe<Array<ContactCardWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ContactCard documents */
  set?: InputMaybe<Array<ContactCardWhereUniqueInput>>;
  /** Update multiple ContactCard documents */
  update?: InputMaybe<Array<ContactCardUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ContactCard documents */
  upsert?: InputMaybe<Array<ContactCardUpsertWithNestedWhereUniqueInput>>;
};

export type ContactCardUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** contactTypeIcon input for default locale (default) */
  contactTypeIcon?: InputMaybe<ContactType>;
  /** field1Label input for default locale (default) */
  field1Label?: InputMaybe<Scalars['String']['input']>;
  /** field1Text input for default locale (default) */
  field1Text?: InputMaybe<Scalars['String']['input']>;
  /** field2Label input for default locale (default) */
  field2Label?: InputMaybe<Scalars['String']['input']>;
  /** field2Text input for default locale (default) */
  field2Text?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<ContactCardUpdateManyLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContactCardUpdateManyLocalizationDataInput = {
  contactTypeIcon?: InputMaybe<ContactType>;
  field1Label?: InputMaybe<Scalars['String']['input']>;
  field1Text?: InputMaybe<Scalars['String']['input']>;
  field2Label?: InputMaybe<Scalars['String']['input']>;
  field2Text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ContactCardUpdateManyLocalizationInput = {
  data: ContactCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type ContactCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ContactCardUpdateManyLocalizationInput>>;
};

export type ContactCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ContactCardUpdateManyInput;
  /** Document search */
  where: ContactCardWhereInput;
};

export type ContactCardUpdateOneInlineInput = {
  /** Connect existing ContactCard document */
  connect?: InputMaybe<ContactCardWhereUniqueInput>;
  /** Create and connect one ContactCard document */
  create?: InputMaybe<ContactCardCreateInput>;
  /** Delete currently connected ContactCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ContactCard document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ContactCard document */
  update?: InputMaybe<ContactCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ContactCard document */
  upsert?: InputMaybe<ContactCardUpsertWithNestedWhereUniqueInput>;
};

export type ContactCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ContactCardUpdateInput;
  /** Unique document search */
  where: ContactCardWhereUniqueInput;
};

export type ContactCardUpsertInput = {
  /** Create document if it didn't exist */
  create: ContactCardCreateInput;
  /** Update document if it exists */
  update: ContactCardUpdateInput;
};

export type ContactCardUpsertLocalizationInput = {
  create: ContactCardCreateLocalizationDataInput;
  locale: Locale;
  update: ContactCardUpdateLocalizationDataInput;
};

export type ContactCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ContactCardUpsertInput;
  /** Unique document search */
  where: ContactCardWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ContactCardWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ContactCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContactCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContactCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContactCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  contactCardContainer?: InputMaybe<ContactCardContainerWhereInput>;
  contactTypeIcon?: InputMaybe<ContactType>;
  /** All values that are contained in given list. */
  contactTypeIcon_in?: InputMaybe<Array<InputMaybe<ContactType>>>;
  /** Any other value that exists and is not equal to the given value. */
  contactTypeIcon_not?: InputMaybe<ContactType>;
  /** All values that are not contained in given list. */
  contactTypeIcon_not_in?: InputMaybe<Array<InputMaybe<ContactType>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ContactCardWhereStageInput>;
  documentInStages_none?: InputMaybe<ContactCardWhereStageInput>;
  documentInStages_some?: InputMaybe<ContactCardWhereStageInput>;
  field1Label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  field1Label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  field1Label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  field1Label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  field1Label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  field1Label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  field1Label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  field1Label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  field1Label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  field1Label_starts_with?: InputMaybe<Scalars['String']['input']>;
  field1Text?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  field1Text_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  field1Text_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  field1Text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  field1Text_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  field1Text_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  field1Text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  field1Text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  field1Text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  field1Text_starts_with?: InputMaybe<Scalars['String']['input']>;
  field2Label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  field2Label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  field2Label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  field2Label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  field2Label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  field2Label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  field2Label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  field2Label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  field2Label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  field2Label_starts_with?: InputMaybe<Scalars['String']['input']>;
  field2Text?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  field2Text_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  field2Text_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  field2Text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  field2Text_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  field2Text_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  field2Text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  field2Text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  field2Text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  field2Text_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ContactCardWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ContactCardWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ContactCardWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ContactCardWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ContactCardWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ContactCard record uniquely */
export type ContactCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Different ways of contacting */
export enum ContactType {
  Chat = 'Chat',
  Email = 'Email',
  Telephone = 'Telephone'
}

export type CorpAddToCalendar = Entity & Node & {
  __typename?: 'CorpAddToCalendar';
  addToCalendar: Array<CorpAddToCalendarAddToCalendar>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<CorpAddToCalendar>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** List of CorpAddToCalendar versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpAddToCalendar>;
  location?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CorpAddToCalendarAddToCalendarArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CorpAddToCalendarCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpAddToCalendarCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpAddToCalendarDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpAddToCalendarHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpAddToCalendarLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CorpAddToCalendarPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpAddToCalendarPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpAddToCalendarScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpAddToCalendarUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpAddToCalendarUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpAddToCalendarAddToCalendar = Link;

export type CorpAddToCalendarAddToCalendarConnectInput = {
  Link?: InputMaybe<LinkConnectInput>;
};

export type CorpAddToCalendarAddToCalendarCreateInput = {
  Link?: InputMaybe<LinkCreateInput>;
};

export type CorpAddToCalendarAddToCalendarCreateManyInlineInput = {
  /** Connect multiple existing CorpAddToCalendarAddToCalendar documents */
  connect?: InputMaybe<Array<CorpAddToCalendarAddToCalendarWhereUniqueInput>>;
  /** Create and connect multiple existing CorpAddToCalendarAddToCalendar documents */
  create?: InputMaybe<Array<CorpAddToCalendarAddToCalendarCreateInput>>;
};

export type CorpAddToCalendarAddToCalendarCreateOneInlineInput = {
  /** Connect one existing CorpAddToCalendarAddToCalendar document */
  connect?: InputMaybe<CorpAddToCalendarAddToCalendarWhereUniqueInput>;
  /** Create and connect one CorpAddToCalendarAddToCalendar document */
  create?: InputMaybe<CorpAddToCalendarAddToCalendarCreateInput>;
};

export type CorpAddToCalendarAddToCalendarUpdateInput = {
  Link?: InputMaybe<LinkUpdateInput>;
};

export type CorpAddToCalendarAddToCalendarUpdateManyInlineInput = {
  /** Connect multiple existing CorpAddToCalendarAddToCalendar documents */
  connect?: InputMaybe<Array<CorpAddToCalendarAddToCalendarConnectInput>>;
  /** Create and connect multiple CorpAddToCalendarAddToCalendar documents */
  create?: InputMaybe<Array<CorpAddToCalendarAddToCalendarCreateInput>>;
  /** Delete multiple CorpAddToCalendarAddToCalendar documents */
  delete?: InputMaybe<Array<CorpAddToCalendarAddToCalendarWhereUniqueInput>>;
  /** Disconnect multiple CorpAddToCalendarAddToCalendar documents */
  disconnect?: InputMaybe<Array<CorpAddToCalendarAddToCalendarWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpAddToCalendarAddToCalendar documents */
  set?: InputMaybe<Array<CorpAddToCalendarAddToCalendarWhereUniqueInput>>;
  /** Update multiple CorpAddToCalendarAddToCalendar documents */
  update?: InputMaybe<Array<CorpAddToCalendarAddToCalendarUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpAddToCalendarAddToCalendar documents */
  upsert?: InputMaybe<Array<CorpAddToCalendarAddToCalendarUpsertWithNestedWhereUniqueInput>>;
};

export type CorpAddToCalendarAddToCalendarUpdateManyWithNestedWhereInput = {
  Link?: InputMaybe<LinkUpdateManyWithNestedWhereInput>;
};

export type CorpAddToCalendarAddToCalendarUpdateOneInlineInput = {
  /** Connect existing CorpAddToCalendarAddToCalendar document */
  connect?: InputMaybe<CorpAddToCalendarAddToCalendarWhereUniqueInput>;
  /** Create and connect one CorpAddToCalendarAddToCalendar document */
  create?: InputMaybe<CorpAddToCalendarAddToCalendarCreateInput>;
  /** Delete currently connected CorpAddToCalendarAddToCalendar document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpAddToCalendarAddToCalendar document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpAddToCalendarAddToCalendar document */
  update?: InputMaybe<CorpAddToCalendarAddToCalendarUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpAddToCalendarAddToCalendar document */
  upsert?: InputMaybe<CorpAddToCalendarAddToCalendarUpsertWithNestedWhereUniqueInput>;
};

export type CorpAddToCalendarAddToCalendarUpdateWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
};

export type CorpAddToCalendarAddToCalendarUpsertWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
};

export type CorpAddToCalendarAddToCalendarWhereInput = {
  Link?: InputMaybe<LinkWhereInput>;
};

export type CorpAddToCalendarAddToCalendarWhereUniqueInput = {
  Link?: InputMaybe<LinkWhereUniqueInput>;
};

export type CorpAddToCalendarConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpAddToCalendarWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpAddToCalendarConnection = {
  __typename?: 'CorpAddToCalendarConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpAddToCalendarEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpAddToCalendarCreateInput = {
  addToCalendar?: InputMaybe<CorpAddToCalendarAddToCalendarCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpAddToCalendarCreateLocalizationsInput>;
  /** location input for default locale (default) */
  location?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpAddToCalendarCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpAddToCalendarCreateLocalizationInput = {
  /** Localization input */
  data: CorpAddToCalendarCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpAddToCalendarCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpAddToCalendarCreateLocalizationInput>>;
};

export type CorpAddToCalendarCreateManyInlineInput = {
  /** Connect multiple existing CorpAddToCalendar documents */
  connect?: InputMaybe<Array<CorpAddToCalendarWhereUniqueInput>>;
  /** Create and connect multiple existing CorpAddToCalendar documents */
  create?: InputMaybe<Array<CorpAddToCalendarCreateInput>>;
};

export type CorpAddToCalendarCreateOneInlineInput = {
  /** Connect one existing CorpAddToCalendar document */
  connect?: InputMaybe<CorpAddToCalendarWhereUniqueInput>;
  /** Create and connect one CorpAddToCalendar document */
  create?: InputMaybe<CorpAddToCalendarCreateInput>;
};

/** An edge in a connection. */
export type CorpAddToCalendarEdge = {
  __typename?: 'CorpAddToCalendarEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpAddToCalendar;
};

/** Identifies documents */
export type CorpAddToCalendarManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpAddToCalendarWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpAddToCalendarWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpAddToCalendarWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  addToCalendar_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  addToCalendar_some?: InputMaybe<CorpAddToCalendarAddToCalendarWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpAddToCalendarWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpAddToCalendarWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpAddToCalendarWhereStageInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  endDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  endDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  startDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  startDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpAddToCalendarOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  endDate_ASC = 'endDate_ASC',
  endDate_DESC = 'endDate_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  location_ASC = 'location_ASC',
  location_DESC = 'location_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  startDate_ASC = 'startDate_ASC',
  startDate_DESC = 'startDate_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpAddToCalendarUpdateInput = {
  addToCalendar?: InputMaybe<CorpAddToCalendarAddToCalendarUpdateManyInlineInput>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpAddToCalendarUpdateLocalizationsInput>;
  /** location input for default locale (default) */
  location?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpAddToCalendarUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpAddToCalendarUpdateLocalizationInput = {
  data: CorpAddToCalendarUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpAddToCalendarUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpAddToCalendarCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpAddToCalendarUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpAddToCalendarUpsertLocalizationInput>>;
};

export type CorpAddToCalendarUpdateManyInlineInput = {
  /** Connect multiple existing CorpAddToCalendar documents */
  connect?: InputMaybe<Array<CorpAddToCalendarConnectInput>>;
  /** Create and connect multiple CorpAddToCalendar documents */
  create?: InputMaybe<Array<CorpAddToCalendarCreateInput>>;
  /** Delete multiple CorpAddToCalendar documents */
  delete?: InputMaybe<Array<CorpAddToCalendarWhereUniqueInput>>;
  /** Disconnect multiple CorpAddToCalendar documents */
  disconnect?: InputMaybe<Array<CorpAddToCalendarWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpAddToCalendar documents */
  set?: InputMaybe<Array<CorpAddToCalendarWhereUniqueInput>>;
  /** Update multiple CorpAddToCalendar documents */
  update?: InputMaybe<Array<CorpAddToCalendarUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpAddToCalendar documents */
  upsert?: InputMaybe<Array<CorpAddToCalendarUpsertWithNestedWhereUniqueInput>>;
};

export type CorpAddToCalendarUpdateManyInput = {
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpAddToCalendarUpdateManyLocalizationsInput>;
  /** location input for default locale (default) */
  location?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpAddToCalendarUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpAddToCalendarUpdateManyLocalizationInput = {
  data: CorpAddToCalendarUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpAddToCalendarUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpAddToCalendarUpdateManyLocalizationInput>>;
};

export type CorpAddToCalendarUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpAddToCalendarUpdateManyInput;
  /** Document search */
  where: CorpAddToCalendarWhereInput;
};

export type CorpAddToCalendarUpdateOneInlineInput = {
  /** Connect existing CorpAddToCalendar document */
  connect?: InputMaybe<CorpAddToCalendarWhereUniqueInput>;
  /** Create and connect one CorpAddToCalendar document */
  create?: InputMaybe<CorpAddToCalendarCreateInput>;
  /** Delete currently connected CorpAddToCalendar document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpAddToCalendar document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpAddToCalendar document */
  update?: InputMaybe<CorpAddToCalendarUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpAddToCalendar document */
  upsert?: InputMaybe<CorpAddToCalendarUpsertWithNestedWhereUniqueInput>;
};

export type CorpAddToCalendarUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpAddToCalendarUpdateInput;
  /** Unique document search */
  where: CorpAddToCalendarWhereUniqueInput;
};

export type CorpAddToCalendarUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpAddToCalendarCreateInput;
  /** Update document if it exists */
  update: CorpAddToCalendarUpdateInput;
};

export type CorpAddToCalendarUpsertLocalizationInput = {
  create: CorpAddToCalendarCreateLocalizationDataInput;
  locale: Locale;
  update: CorpAddToCalendarUpdateLocalizationDataInput;
};

export type CorpAddToCalendarUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpAddToCalendarUpsertInput;
  /** Unique document search */
  where: CorpAddToCalendarWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpAddToCalendarWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpAddToCalendarWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpAddToCalendarWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpAddToCalendarWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpAddToCalendarWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  addToCalendar_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  addToCalendar_some?: InputMaybe<CorpAddToCalendarAddToCalendarWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CorpAddToCalendarWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpAddToCalendarWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpAddToCalendarWhereStageInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  endDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  endDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  location_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  location_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  location_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  location_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  location_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  location_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  location_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  location_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  location_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  startDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  startDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpAddToCalendarWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpAddToCalendarWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpAddToCalendarWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpAddToCalendarWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpAddToCalendarWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpAddToCalendar record uniquely */
export type CorpAddToCalendarWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1 = Entity & Node & {
  __typename?: 'CorpBanner1';
  anchorNav?: Maybe<AnchorNavigation>;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  color: CorpColorThemeName;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<CorpBanner1>;
  genericAccordionItems: Array<CorpGenericAccordionItem>;
  genericPages: Array<GenericPage>;
  /** List of CorpBanner1 versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpBanner1>;
  mediaLibrary?: Maybe<MediaLibrary>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  superText?: Maybe<Scalars['String']['output']>;
  tabContent?: Maybe<TabContent>;
  /** title of the banner */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1AnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1CreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1CreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1DocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1GenericAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericAccordionItemWhereInput>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1GenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1HistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1LinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1LocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1MediaLibraryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1PublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1PublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1ScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1StoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1TabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1UpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type CorpBanner1UpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpBanner1ConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpBanner1WhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpBanner1Connection = {
  __typename?: 'CorpBanner1Connection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpBanner1Edge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpBanner1CreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  color: CorpColorThemeName;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpBanner1CreateLocalizationsInput>;
  mediaLibrary?: InputMaybe<MediaLibraryCreateOneInlineInput>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpBanner1CreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpBanner1CreateLocalizationInput = {
  /** Localization input */
  data: CorpBanner1CreateLocalizationDataInput;
  locale: Locale;
};

export type CorpBanner1CreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpBanner1CreateLocalizationInput>>;
};

export type CorpBanner1CreateManyInlineInput = {
  /** Connect multiple existing CorpBanner1 documents */
  connect?: InputMaybe<Array<CorpBanner1WhereUniqueInput>>;
  /** Create and connect multiple existing CorpBanner1 documents */
  create?: InputMaybe<Array<CorpBanner1CreateInput>>;
};

export type CorpBanner1CreateOneInlineInput = {
  /** Connect one existing CorpBanner1 document */
  connect?: InputMaybe<CorpBanner1WhereUniqueInput>;
  /** Create and connect one CorpBanner1 document */
  create?: InputMaybe<CorpBanner1CreateInput>;
};

/** An edge in a connection. */
export type CorpBanner1Edge = {
  __typename?: 'CorpBanner1Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpBanner1;
};

/** Identifies documents */
export type CorpBanner1ManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpBanner1WhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpBanner1WhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpBanner1WhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  /** All values that are contained in given list. */
  color_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  /** Any other value that exists and is not equal to the given value. */
  color_not?: InputMaybe<CorpColorThemeName>;
  /** All values that are not contained in given list. */
  color_not_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpBanner1WhereStageInput>;
  documentInStages_none?: InputMaybe<CorpBanner1WhereStageInput>;
  documentInStages_some?: InputMaybe<CorpBanner1WhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpBanner1OrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  color_ASC = 'color_ASC',
  color_DESC = 'color_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpBanner1UpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpBanner1UpdateLocalizationsInput>;
  mediaLibrary?: InputMaybe<MediaLibraryUpdateOneInlineInput>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpBanner1UpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpBanner1UpdateLocalizationInput = {
  data: CorpBanner1UpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpBanner1UpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpBanner1CreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpBanner1UpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpBanner1UpsertLocalizationInput>>;
};

export type CorpBanner1UpdateManyInlineInput = {
  /** Connect multiple existing CorpBanner1 documents */
  connect?: InputMaybe<Array<CorpBanner1ConnectInput>>;
  /** Create and connect multiple CorpBanner1 documents */
  create?: InputMaybe<Array<CorpBanner1CreateInput>>;
  /** Delete multiple CorpBanner1 documents */
  delete?: InputMaybe<Array<CorpBanner1WhereUniqueInput>>;
  /** Disconnect multiple CorpBanner1 documents */
  disconnect?: InputMaybe<Array<CorpBanner1WhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpBanner1 documents */
  set?: InputMaybe<Array<CorpBanner1WhereUniqueInput>>;
  /** Update multiple CorpBanner1 documents */
  update?: InputMaybe<Array<CorpBanner1UpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpBanner1 documents */
  upsert?: InputMaybe<Array<CorpBanner1UpsertWithNestedWhereUniqueInput>>;
};

export type CorpBanner1UpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpBanner1UpdateManyLocalizationsInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpBanner1UpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpBanner1UpdateManyLocalizationInput = {
  data: CorpBanner1UpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpBanner1UpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpBanner1UpdateManyLocalizationInput>>;
};

export type CorpBanner1UpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpBanner1UpdateManyInput;
  /** Document search */
  where: CorpBanner1WhereInput;
};

export type CorpBanner1UpdateOneInlineInput = {
  /** Connect existing CorpBanner1 document */
  connect?: InputMaybe<CorpBanner1WhereUniqueInput>;
  /** Create and connect one CorpBanner1 document */
  create?: InputMaybe<CorpBanner1CreateInput>;
  /** Delete currently connected CorpBanner1 document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpBanner1 document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpBanner1 document */
  update?: InputMaybe<CorpBanner1UpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpBanner1 document */
  upsert?: InputMaybe<CorpBanner1UpsertWithNestedWhereUniqueInput>;
};

export type CorpBanner1UpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpBanner1UpdateInput;
  /** Unique document search */
  where: CorpBanner1WhereUniqueInput;
};

export type CorpBanner1UpsertInput = {
  /** Create document if it didn't exist */
  create: CorpBanner1CreateInput;
  /** Update document if it exists */
  update: CorpBanner1UpdateInput;
};

export type CorpBanner1UpsertLocalizationInput = {
  create: CorpBanner1CreateLocalizationDataInput;
  locale: Locale;
  update: CorpBanner1UpdateLocalizationDataInput;
};

export type CorpBanner1UpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpBanner1UpsertInput;
  /** Unique document search */
  where: CorpBanner1WhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpBanner1WhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpBanner1WhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpBanner1WhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpBanner1WhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpBanner1WhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  /** All values that are contained in given list. */
  color_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  /** Any other value that exists and is not equal to the given value. */
  color_not?: InputMaybe<CorpColorThemeName>;
  /** All values that are not contained in given list. */
  color_not_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CorpBanner1WhereStageInput>;
  documentInStages_none?: InputMaybe<CorpBanner1WhereStageInput>;
  documentInStages_some?: InputMaybe<CorpBanner1WhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpBanner1WhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpBanner1WhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpBanner1WhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpBanner1WhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpBanner1WhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpBanner1 record uniquely */
export type CorpBanner1WhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CorpCalendarEvent = Entity & Node & {
  __typename?: 'CorpCalendarEvent';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpCalendarEvent>;
  endDate: Scalars['DateTime']['output'];
  eventDescription: Scalars['String']['output'];
  eventLocation: Scalars['String']['output'];
  genericAccordionItems: Array<CorpGenericAccordionItem>;
  genericPages: Array<GenericPage>;
  /** List of CorpCalendarEvent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpCalendarEvent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  richText?: Maybe<CorpCalendarEventRichTextRichText>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  startDate: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CorpCalendarEventCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpCalendarEventCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpCalendarEventDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpCalendarEventGenericAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericAccordionItemWhereInput>;
};


export type CorpCalendarEventGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type CorpCalendarEventHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpCalendarEventLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CorpCalendarEventPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpCalendarEventPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpCalendarEventScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpCalendarEventUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpCalendarEventUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpCalendarEventConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpCalendarEventWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpCalendarEventConnection = {
  __typename?: 'CorpCalendarEventConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpCalendarEventEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpCalendarEventCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  endDate: Scalars['DateTime']['input'];
  /** eventDescription input for default locale (default) */
  eventDescription: Scalars['String']['input'];
  /** eventLocation input for default locale (default) */
  eventLocation: Scalars['String']['input'];
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpCalendarEventCreateLocalizationsInput>;
  /** richText input for default locale (default) */
  richText?: InputMaybe<Scalars['RichTextAST']['input']>;
  startDate: Scalars['DateTime']['input'];
  /** title input for default locale (default) */
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpCalendarEventCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  eventDescription: Scalars['String']['input'];
  eventLocation: Scalars['String']['input'];
  richText?: InputMaybe<Scalars['RichTextAST']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpCalendarEventCreateLocalizationInput = {
  /** Localization input */
  data: CorpCalendarEventCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpCalendarEventCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpCalendarEventCreateLocalizationInput>>;
};

export type CorpCalendarEventCreateManyInlineInput = {
  /** Connect multiple existing CorpCalendarEvent documents */
  connect?: InputMaybe<Array<CorpCalendarEventWhereUniqueInput>>;
  /** Create and connect multiple existing CorpCalendarEvent documents */
  create?: InputMaybe<Array<CorpCalendarEventCreateInput>>;
};

export type CorpCalendarEventCreateOneInlineInput = {
  /** Connect one existing CorpCalendarEvent document */
  connect?: InputMaybe<CorpCalendarEventWhereUniqueInput>;
  /** Create and connect one CorpCalendarEvent document */
  create?: InputMaybe<CorpCalendarEventCreateInput>;
};

/** An edge in a connection. */
export type CorpCalendarEventEdge = {
  __typename?: 'CorpCalendarEventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpCalendarEvent;
};

/** Identifies documents */
export type CorpCalendarEventManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpCalendarEventWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpCalendarEventWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpCalendarEventWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpCalendarEventWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpCalendarEventWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpCalendarEventWhereStageInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  endDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  endDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  startDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  startDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpCalendarEventOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  endDate_ASC = 'endDate_ASC',
  endDate_DESC = 'endDate_DESC',
  eventDescription_ASC = 'eventDescription_ASC',
  eventDescription_DESC = 'eventDescription_DESC',
  eventLocation_ASC = 'eventLocation_ASC',
  eventLocation_DESC = 'eventLocation_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  startDate_ASC = 'startDate_ASC',
  startDate_DESC = 'startDate_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpCalendarEventRichTextRichText = {
  __typename?: 'CorpCalendarEventRichTextRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<CorpCalendarEventRichTextRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type CorpCalendarEventRichTextRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CorpCalendarEventRichTextRichTextEmbeddedTypes = LongText;

export type CorpCalendarEventUpdateInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** eventDescription input for default locale (default) */
  eventDescription?: InputMaybe<Scalars['String']['input']>;
  /** eventLocation input for default locale (default) */
  eventLocation?: InputMaybe<Scalars['String']['input']>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpCalendarEventUpdateLocalizationsInput>;
  /** richText input for default locale (default) */
  richText?: InputMaybe<Scalars['RichTextAST']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpCalendarEventUpdateLocalizationDataInput = {
  eventDescription?: InputMaybe<Scalars['String']['input']>;
  eventLocation?: InputMaybe<Scalars['String']['input']>;
  richText?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpCalendarEventUpdateLocalizationInput = {
  data: CorpCalendarEventUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpCalendarEventUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpCalendarEventCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpCalendarEventUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpCalendarEventUpsertLocalizationInput>>;
};

export type CorpCalendarEventUpdateManyInlineInput = {
  /** Connect multiple existing CorpCalendarEvent documents */
  connect?: InputMaybe<Array<CorpCalendarEventConnectInput>>;
  /** Create and connect multiple CorpCalendarEvent documents */
  create?: InputMaybe<Array<CorpCalendarEventCreateInput>>;
  /** Delete multiple CorpCalendarEvent documents */
  delete?: InputMaybe<Array<CorpCalendarEventWhereUniqueInput>>;
  /** Disconnect multiple CorpCalendarEvent documents */
  disconnect?: InputMaybe<Array<CorpCalendarEventWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpCalendarEvent documents */
  set?: InputMaybe<Array<CorpCalendarEventWhereUniqueInput>>;
  /** Update multiple CorpCalendarEvent documents */
  update?: InputMaybe<Array<CorpCalendarEventUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpCalendarEvent documents */
  upsert?: InputMaybe<Array<CorpCalendarEventUpsertWithNestedWhereUniqueInput>>;
};

export type CorpCalendarEventUpdateManyInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** eventDescription input for default locale (default) */
  eventDescription?: InputMaybe<Scalars['String']['input']>;
  /** eventLocation input for default locale (default) */
  eventLocation?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpCalendarEventUpdateManyLocalizationsInput>;
  /** richText input for default locale (default) */
  richText?: InputMaybe<Scalars['RichTextAST']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpCalendarEventUpdateManyLocalizationDataInput = {
  eventDescription?: InputMaybe<Scalars['String']['input']>;
  eventLocation?: InputMaybe<Scalars['String']['input']>;
  richText?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpCalendarEventUpdateManyLocalizationInput = {
  data: CorpCalendarEventUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpCalendarEventUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpCalendarEventUpdateManyLocalizationInput>>;
};

export type CorpCalendarEventUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpCalendarEventUpdateManyInput;
  /** Document search */
  where: CorpCalendarEventWhereInput;
};

export type CorpCalendarEventUpdateOneInlineInput = {
  /** Connect existing CorpCalendarEvent document */
  connect?: InputMaybe<CorpCalendarEventWhereUniqueInput>;
  /** Create and connect one CorpCalendarEvent document */
  create?: InputMaybe<CorpCalendarEventCreateInput>;
  /** Delete currently connected CorpCalendarEvent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpCalendarEvent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpCalendarEvent document */
  update?: InputMaybe<CorpCalendarEventUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpCalendarEvent document */
  upsert?: InputMaybe<CorpCalendarEventUpsertWithNestedWhereUniqueInput>;
};

export type CorpCalendarEventUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpCalendarEventUpdateInput;
  /** Unique document search */
  where: CorpCalendarEventWhereUniqueInput;
};

export type CorpCalendarEventUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpCalendarEventCreateInput;
  /** Update document if it exists */
  update: CorpCalendarEventUpdateInput;
};

export type CorpCalendarEventUpsertLocalizationInput = {
  create: CorpCalendarEventCreateLocalizationDataInput;
  locale: Locale;
  update: CorpCalendarEventUpdateLocalizationDataInput;
};

export type CorpCalendarEventUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpCalendarEventUpsertInput;
  /** Unique document search */
  where: CorpCalendarEventWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpCalendarEventWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpCalendarEventWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpCalendarEventWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpCalendarEventWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpCalendarEventWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpCalendarEventWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpCalendarEventWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpCalendarEventWhereStageInput>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  endDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  endDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  endDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  endDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  endDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  endDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  endDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  eventDescription?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  eventDescription_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  eventDescription_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  eventDescription_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  eventDescription_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  eventDescription_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  eventDescription_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  eventDescription_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  eventDescription_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  eventDescription_starts_with?: InputMaybe<Scalars['String']['input']>;
  eventLocation?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  eventLocation_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  eventLocation_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  eventLocation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  eventLocation_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  eventLocation_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  eventLocation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  eventLocation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  eventLocation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  eventLocation_starts_with?: InputMaybe<Scalars['String']['input']>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  startDate_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  startDate_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  startDate_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  startDate_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  startDate_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  startDate_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  startDate_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpCalendarEventWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpCalendarEventWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpCalendarEventWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpCalendarEventWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpCalendarEventWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpCalendarEvent record uniquely */
export type CorpCalendarEventWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CorpCardCarousel = Entity & Node & {
  __typename?: 'CorpCardCarousel';
  buttonLink?: Maybe<Link>;
  cardVariant?: Maybe<CorpCardCarouselVariant>;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  color?: Maybe<CorpColorThemeName>;
  corpCarouselType?: Maybe<CorpCardCarouselType>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpCardCarousel>;
  genericPages: Array<GenericPage>;
  /** List of CorpCardCarousel versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpCardCarousel>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slidesToShow?: Maybe<Scalars['Float']['output']>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  storyItems: Array<Story>;
  super?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CorpCardCarouselButtonLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpCardCarouselCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpCardCarouselCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpCardCarouselDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpCardCarouselGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type CorpCardCarouselHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpCardCarouselLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CorpCardCarouselPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpCardCarouselPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpCardCarouselScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpCardCarouselStoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


export type CorpCardCarouselStoryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<StoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


export type CorpCardCarouselUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpCardCarouselUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpCardCarouselConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpCardCarouselWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpCardCarouselConnection = {
  __typename?: 'CorpCardCarouselConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpCardCarouselEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpCardCarouselCreateInput = {
  buttonLink?: InputMaybe<LinkCreateOneInlineInput>;
  cardVariant?: InputMaybe<CorpCardCarouselVariant>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  corpCarouselType?: InputMaybe<CorpCardCarouselType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpCardCarouselCreateLocalizationsInput>;
  slidesToShow?: InputMaybe<Scalars['Float']['input']>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  storyItems?: InputMaybe<StoryCreateManyInlineInput>;
  /** super input for default locale (default) */
  super?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpCardCarouselCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  super?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpCardCarouselCreateLocalizationInput = {
  /** Localization input */
  data: CorpCardCarouselCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpCardCarouselCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpCardCarouselCreateLocalizationInput>>;
};

export type CorpCardCarouselCreateManyInlineInput = {
  /** Connect multiple existing CorpCardCarousel documents */
  connect?: InputMaybe<Array<CorpCardCarouselWhereUniqueInput>>;
  /** Create and connect multiple existing CorpCardCarousel documents */
  create?: InputMaybe<Array<CorpCardCarouselCreateInput>>;
};

export type CorpCardCarouselCreateOneInlineInput = {
  /** Connect one existing CorpCardCarousel document */
  connect?: InputMaybe<CorpCardCarouselWhereUniqueInput>;
  /** Create and connect one CorpCardCarousel document */
  create?: InputMaybe<CorpCardCarouselCreateInput>;
};

/** An edge in a connection. */
export type CorpCardCarouselEdge = {
  __typename?: 'CorpCardCarouselEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpCardCarousel;
};

/** Identifies documents */
export type CorpCardCarouselManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpCardCarouselWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpCardCarouselWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpCardCarouselWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttonLink?: InputMaybe<LinkWhereInput>;
  cardVariant?: InputMaybe<CorpCardCarouselVariant>;
  /** All values that are contained in given list. */
  cardVariant_in?: InputMaybe<Array<InputMaybe<CorpCardCarouselVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardVariant_not?: InputMaybe<CorpCardCarouselVariant>;
  /** All values that are not contained in given list. */
  cardVariant_not_in?: InputMaybe<Array<InputMaybe<CorpCardCarouselVariant>>>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  /** All values that are contained in given list. */
  color_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  /** Any other value that exists and is not equal to the given value. */
  color_not?: InputMaybe<CorpColorThemeName>;
  /** All values that are not contained in given list. */
  color_not_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  corpCarouselType?: InputMaybe<CorpCardCarouselType>;
  /** All values that are contained in given list. */
  corpCarouselType_in?: InputMaybe<Array<InputMaybe<CorpCardCarouselType>>>;
  /** Any other value that exists and is not equal to the given value. */
  corpCarouselType_not?: InputMaybe<CorpCardCarouselType>;
  /** All values that are not contained in given list. */
  corpCarouselType_not_in?: InputMaybe<Array<InputMaybe<CorpCardCarouselType>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpCardCarouselWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpCardCarouselWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpCardCarouselWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slidesToShow?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  slidesToShow_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  slidesToShow_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  slidesToShow_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  slidesToShow_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  slidesToShow_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  slidesToShow_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  slidesToShow_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  storyItems_every?: InputMaybe<StoryWhereInput>;
  storyItems_none?: InputMaybe<StoryWhereInput>;
  storyItems_some?: InputMaybe<StoryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpCardCarouselOrderByInput {
  cardVariant_ASC = 'cardVariant_ASC',
  cardVariant_DESC = 'cardVariant_DESC',
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  color_ASC = 'color_ASC',
  color_DESC = 'color_DESC',
  corpCarouselType_ASC = 'corpCarouselType_ASC',
  corpCarouselType_DESC = 'corpCarouselType_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slidesToShow_ASC = 'slidesToShow_ASC',
  slidesToShow_DESC = 'slidesToShow_DESC',
  super_ASC = 'super_ASC',
  super_DESC = 'super_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Defines which press or stories items to show */
export enum CorpCardCarouselType {
  pressAll = 'pressAll',
  storiesAll = 'storiesAll',
  storiesCompany = 'storiesCompany',
  storiesFood = 'storiesFood',
  storiesSustainability = 'storiesSustainability',
  storiesWorld = 'storiesWorld'
}

export type CorpCardCarouselUpdateInput = {
  buttonLink?: InputMaybe<LinkUpdateOneInlineInput>;
  cardVariant?: InputMaybe<CorpCardCarouselVariant>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  corpCarouselType?: InputMaybe<CorpCardCarouselType>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpCardCarouselUpdateLocalizationsInput>;
  slidesToShow?: InputMaybe<Scalars['Float']['input']>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
  storyItems?: InputMaybe<StoryUpdateManyInlineInput>;
  /** super input for default locale (default) */
  super?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpCardCarouselUpdateLocalizationDataInput = {
  super?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpCardCarouselUpdateLocalizationInput = {
  data: CorpCardCarouselUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpCardCarouselUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpCardCarouselCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpCardCarouselUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpCardCarouselUpsertLocalizationInput>>;
};

export type CorpCardCarouselUpdateManyInlineInput = {
  /** Connect multiple existing CorpCardCarousel documents */
  connect?: InputMaybe<Array<CorpCardCarouselConnectInput>>;
  /** Create and connect multiple CorpCardCarousel documents */
  create?: InputMaybe<Array<CorpCardCarouselCreateInput>>;
  /** Delete multiple CorpCardCarousel documents */
  delete?: InputMaybe<Array<CorpCardCarouselWhereUniqueInput>>;
  /** Disconnect multiple CorpCardCarousel documents */
  disconnect?: InputMaybe<Array<CorpCardCarouselWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpCardCarousel documents */
  set?: InputMaybe<Array<CorpCardCarouselWhereUniqueInput>>;
  /** Update multiple CorpCardCarousel documents */
  update?: InputMaybe<Array<CorpCardCarouselUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpCardCarousel documents */
  upsert?: InputMaybe<Array<CorpCardCarouselUpsertWithNestedWhereUniqueInput>>;
};

export type CorpCardCarouselUpdateManyInput = {
  cardVariant?: InputMaybe<CorpCardCarouselVariant>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  corpCarouselType?: InputMaybe<CorpCardCarouselType>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpCardCarouselUpdateManyLocalizationsInput>;
  slidesToShow?: InputMaybe<Scalars['Float']['input']>;
  /** super input for default locale (default) */
  super?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpCardCarouselUpdateManyLocalizationDataInput = {
  super?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpCardCarouselUpdateManyLocalizationInput = {
  data: CorpCardCarouselUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpCardCarouselUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpCardCarouselUpdateManyLocalizationInput>>;
};

export type CorpCardCarouselUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpCardCarouselUpdateManyInput;
  /** Document search */
  where: CorpCardCarouselWhereInput;
};

export type CorpCardCarouselUpdateOneInlineInput = {
  /** Connect existing CorpCardCarousel document */
  connect?: InputMaybe<CorpCardCarouselWhereUniqueInput>;
  /** Create and connect one CorpCardCarousel document */
  create?: InputMaybe<CorpCardCarouselCreateInput>;
  /** Delete currently connected CorpCardCarousel document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpCardCarousel document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpCardCarousel document */
  update?: InputMaybe<CorpCardCarouselUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpCardCarousel document */
  upsert?: InputMaybe<CorpCardCarouselUpsertWithNestedWhereUniqueInput>;
};

export type CorpCardCarouselUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpCardCarouselUpdateInput;
  /** Unique document search */
  where: CorpCardCarouselWhereUniqueInput;
};

export type CorpCardCarouselUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpCardCarouselCreateInput;
  /** Update document if it exists */
  update: CorpCardCarouselUpdateInput;
};

export type CorpCardCarouselUpsertLocalizationInput = {
  create: CorpCardCarouselCreateLocalizationDataInput;
  locale: Locale;
  update: CorpCardCarouselUpdateLocalizationDataInput;
};

export type CorpCardCarouselUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpCardCarouselUpsertInput;
  /** Unique document search */
  where: CorpCardCarouselWhereUniqueInput;
};

export enum CorpCardCarouselVariant {
  neutral = 'neutral',
  primary = 'primary'
}

/** This contains a set of filters that can be used to compare values internally */
export type CorpCardCarouselWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpCardCarouselWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpCardCarouselWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpCardCarouselWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpCardCarouselWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttonLink?: InputMaybe<LinkWhereInput>;
  cardVariant?: InputMaybe<CorpCardCarouselVariant>;
  /** All values that are contained in given list. */
  cardVariant_in?: InputMaybe<Array<InputMaybe<CorpCardCarouselVariant>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardVariant_not?: InputMaybe<CorpCardCarouselVariant>;
  /** All values that are not contained in given list. */
  cardVariant_not_in?: InputMaybe<Array<InputMaybe<CorpCardCarouselVariant>>>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  /** All values that are contained in given list. */
  color_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  /** Any other value that exists and is not equal to the given value. */
  color_not?: InputMaybe<CorpColorThemeName>;
  /** All values that are not contained in given list. */
  color_not_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  corpCarouselType?: InputMaybe<CorpCardCarouselType>;
  /** All values that are contained in given list. */
  corpCarouselType_in?: InputMaybe<Array<InputMaybe<CorpCardCarouselType>>>;
  /** Any other value that exists and is not equal to the given value. */
  corpCarouselType_not?: InputMaybe<CorpCardCarouselType>;
  /** All values that are not contained in given list. */
  corpCarouselType_not_in?: InputMaybe<Array<InputMaybe<CorpCardCarouselType>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpCardCarouselWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpCardCarouselWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpCardCarouselWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slidesToShow?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than the given value. */
  slidesToShow_gt?: InputMaybe<Scalars['Float']['input']>;
  /** All values greater than or equal the given value. */
  slidesToShow_gte?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are contained in given list. */
  slidesToShow_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  /** All values less than the given value. */
  slidesToShow_lt?: InputMaybe<Scalars['Float']['input']>;
  /** All values less than or equal the given value. */
  slidesToShow_lte?: InputMaybe<Scalars['Float']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  slidesToShow_not?: InputMaybe<Scalars['Float']['input']>;
  /** All values that are not contained in given list. */
  slidesToShow_not_in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  storyItems_every?: InputMaybe<StoryWhereInput>;
  storyItems_none?: InputMaybe<StoryWhereInput>;
  storyItems_some?: InputMaybe<StoryWhereInput>;
  super?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  super_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  super_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  super_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  super_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  super_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  super_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  super_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  super_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  super_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpCardCarouselWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpCardCarouselWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpCardCarouselWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpCardCarouselWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpCardCarouselWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpCardCarousel record uniquely */
export type CorpCardCarouselWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum CorpColorThemeName {
  lightBlue = 'lightBlue',
  peach = 'peach'
}

export type CorpContactCard = Entity & Node & {
  __typename?: 'CorpContactCard';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<CorpContactCard>;
  email?: Maybe<Scalars['String']['output']>;
  /** List of CorpContactCard versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<AssetComponent>;
  /** Add a link like this: "https://linkedin.com/123456..." */
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpContactCard>;
  name?: Maybe<Scalars['String']['output']>;
  /** Phone number to be displayed (can contain spaces and special characters) */
  phone?: Maybe<Scalars['String']['output']>;
  /** Phone number in the following format to be used as a link: 004917112345678 (no spaces, no special characters) */
  phoneLink?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CorpContactCardCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpContactCardCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpContactCardDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpContactCardHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpContactCardImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpContactCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CorpContactCardPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpContactCardPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpContactCardScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpContactCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpContactCardUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpContactCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpContactCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpContactCardConnection = {
  __typename?: 'CorpContactCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpContactCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpContactCardContainer = Entity & Node & {
  __typename?: 'CorpContactCardContainer';
  cmsTitle?: Maybe<Scalars['String']['output']>;
  corpContactCards: Array<CorpContactCard>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpContactCardContainer>;
  genericAccordionItems: Array<CorpGenericAccordionItem>;
  genericPages: Array<GenericPage>;
  /** List of CorpContactCardContainer versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  locationItem?: Maybe<LocationItem>;
  mediaLibrary?: Maybe<MediaLibrary>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CorpContactCardContainerCorpContactCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CorpContactCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpContactCardWhereInput>;
};


export type CorpContactCardContainerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpContactCardContainerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpContactCardContainerGenericAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericAccordionItemWhereInput>;
};


export type CorpContactCardContainerGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type CorpContactCardContainerHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpContactCardContainerLocationItemArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpContactCardContainerMediaLibraryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpContactCardContainerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpContactCardContainerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpContactCardContainerStoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


export type CorpContactCardContainerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpContactCardContainerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpContactCardContainerWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpContactCardContainerConnection = {
  __typename?: 'CorpContactCardContainerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpContactCardContainerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpContactCardContainerCreateInput = {
  cl9zq6ruj374501uj0lw7ckgh?: InputMaybe<PressReleaseCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  corpContactCards?: InputMaybe<CorpContactCardCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  locationItem?: InputMaybe<LocationItemCreateOneInlineInput>;
  mediaLibrary?: InputMaybe<MediaLibraryCreateOneInlineInput>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpContactCardContainerCreateManyInlineInput = {
  /** Connect multiple existing CorpContactCardContainer documents */
  connect?: InputMaybe<Array<CorpContactCardContainerWhereUniqueInput>>;
  /** Create and connect multiple existing CorpContactCardContainer documents */
  create?: InputMaybe<Array<CorpContactCardContainerCreateInput>>;
};

export type CorpContactCardContainerCreateOneInlineInput = {
  /** Connect one existing CorpContactCardContainer document */
  connect?: InputMaybe<CorpContactCardContainerWhereUniqueInput>;
  /** Create and connect one CorpContactCardContainer document */
  create?: InputMaybe<CorpContactCardContainerCreateInput>;
};

/** An edge in a connection. */
export type CorpContactCardContainerEdge = {
  __typename?: 'CorpContactCardContainerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpContactCardContainer;
};

/** Identifies documents */
export type CorpContactCardContainerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpContactCardContainerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpContactCardContainerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpContactCardContainerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  corpContactCards_every?: InputMaybe<CorpContactCardWhereInput>;
  corpContactCards_none?: InputMaybe<CorpContactCardWhereInput>;
  corpContactCards_some?: InputMaybe<CorpContactCardWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpContactCardContainerWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpContactCardContainerWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpContactCardContainerWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  locationItem?: InputMaybe<LocationItemWhereInput>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpContactCardContainerOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpContactCardContainerUpdateInput = {
  cl9zq6ruj374501uj0lw7ckgh?: InputMaybe<PressReleaseUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  corpContactCards?: InputMaybe<CorpContactCardUpdateManyInlineInput>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  locationItem?: InputMaybe<LocationItemUpdateOneInlineInput>;
  mediaLibrary?: InputMaybe<MediaLibraryUpdateOneInlineInput>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
};

export type CorpContactCardContainerUpdateManyInlineInput = {
  /** Connect multiple existing CorpContactCardContainer documents */
  connect?: InputMaybe<Array<CorpContactCardContainerConnectInput>>;
  /** Create and connect multiple CorpContactCardContainer documents */
  create?: InputMaybe<Array<CorpContactCardContainerCreateInput>>;
  /** Delete multiple CorpContactCardContainer documents */
  delete?: InputMaybe<Array<CorpContactCardContainerWhereUniqueInput>>;
  /** Disconnect multiple CorpContactCardContainer documents */
  disconnect?: InputMaybe<Array<CorpContactCardContainerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpContactCardContainer documents */
  set?: InputMaybe<Array<CorpContactCardContainerWhereUniqueInput>>;
  /** Update multiple CorpContactCardContainer documents */
  update?: InputMaybe<Array<CorpContactCardContainerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpContactCardContainer documents */
  upsert?: InputMaybe<Array<CorpContactCardContainerUpsertWithNestedWhereUniqueInput>>;
};

export type CorpContactCardContainerUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CorpContactCardContainerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpContactCardContainerUpdateManyInput;
  /** Document search */
  where: CorpContactCardContainerWhereInput;
};

export type CorpContactCardContainerUpdateOneInlineInput = {
  /** Connect existing CorpContactCardContainer document */
  connect?: InputMaybe<CorpContactCardContainerWhereUniqueInput>;
  /** Create and connect one CorpContactCardContainer document */
  create?: InputMaybe<CorpContactCardContainerCreateInput>;
  /** Delete currently connected CorpContactCardContainer document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpContactCardContainer document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpContactCardContainer document */
  update?: InputMaybe<CorpContactCardContainerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpContactCardContainer document */
  upsert?: InputMaybe<CorpContactCardContainerUpsertWithNestedWhereUniqueInput>;
};

export type CorpContactCardContainerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpContactCardContainerUpdateInput;
  /** Unique document search */
  where: CorpContactCardContainerWhereUniqueInput;
};

export type CorpContactCardContainerUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpContactCardContainerCreateInput;
  /** Update document if it exists */
  update: CorpContactCardContainerUpdateInput;
};

export type CorpContactCardContainerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpContactCardContainerUpsertInput;
  /** Unique document search */
  where: CorpContactCardContainerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpContactCardContainerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpContactCardContainerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpContactCardContainerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpContactCardContainerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpContactCardContainerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  corpContactCards_every?: InputMaybe<CorpContactCardWhereInput>;
  corpContactCards_none?: InputMaybe<CorpContactCardWhereInput>;
  corpContactCards_some?: InputMaybe<CorpContactCardWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpContactCardContainerWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpContactCardContainerWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpContactCardContainerWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  locationItem?: InputMaybe<LocationItemWhereInput>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpContactCardContainerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpContactCardContainerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpContactCardContainerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpContactCardContainerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpContactCardContainerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpContactCardContainer record uniquely */
export type CorpContactCardContainerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CorpContactCardCreateInput = {
  cl2q1got954r601xj786w5ut8?: InputMaybe<CorpContactCardContainerCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** email input for default locale (default) */
  email?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetComponentCreateOneInlineInput>;
  /** linkedInUrl input for default locale (default) */
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpContactCardCreateLocalizationsInput>;
  /** name input for default locale (default) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** phone input for default locale (default) */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** phoneLink input for default locale (default) */
  phoneLink?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpContactCardCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneLink?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpContactCardCreateLocalizationInput = {
  /** Localization input */
  data: CorpContactCardCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpContactCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpContactCardCreateLocalizationInput>>;
};

export type CorpContactCardCreateManyInlineInput = {
  /** Connect multiple existing CorpContactCard documents */
  connect?: InputMaybe<Array<CorpContactCardWhereUniqueInput>>;
  /** Create and connect multiple existing CorpContactCard documents */
  create?: InputMaybe<Array<CorpContactCardCreateInput>>;
};

export type CorpContactCardCreateOneInlineInput = {
  /** Connect one existing CorpContactCard document */
  connect?: InputMaybe<CorpContactCardWhereUniqueInput>;
  /** Create and connect one CorpContactCard document */
  create?: InputMaybe<CorpContactCardCreateInput>;
};

/** An edge in a connection. */
export type CorpContactCardEdge = {
  __typename?: 'CorpContactCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpContactCard;
};

/** Identifies documents */
export type CorpContactCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpContactCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpContactCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpContactCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpContactCardWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpContactCardWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpContactCardWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpContactCardOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  email_ASC = 'email_ASC',
  email_DESC = 'email_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  linkedInUrl_ASC = 'linkedInUrl_ASC',
  linkedInUrl_DESC = 'linkedInUrl_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  phoneLink_ASC = 'phoneLink_ASC',
  phoneLink_DESC = 'phoneLink_DESC',
  phone_ASC = 'phone_ASC',
  phone_DESC = 'phone_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpContactCardUpdateInput = {
  cl2q1got954r601xj786w5ut8?: InputMaybe<CorpContactCardContainerUpdateManyInlineInput>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** email input for default locale (default) */
  email?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  /** linkedInUrl input for default locale (default) */
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpContactCardUpdateLocalizationsInput>;
  /** name input for default locale (default) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** phone input for default locale (default) */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** phoneLink input for default locale (default) */
  phoneLink?: InputMaybe<Scalars['String']['input']>;
};

export type CorpContactCardUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneLink?: InputMaybe<Scalars['String']['input']>;
};

export type CorpContactCardUpdateLocalizationInput = {
  data: CorpContactCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpContactCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpContactCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpContactCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpContactCardUpsertLocalizationInput>>;
};

export type CorpContactCardUpdateManyInlineInput = {
  /** Connect multiple existing CorpContactCard documents */
  connect?: InputMaybe<Array<CorpContactCardConnectInput>>;
  /** Create and connect multiple CorpContactCard documents */
  create?: InputMaybe<Array<CorpContactCardCreateInput>>;
  /** Delete multiple CorpContactCard documents */
  delete?: InputMaybe<Array<CorpContactCardWhereUniqueInput>>;
  /** Disconnect multiple CorpContactCard documents */
  disconnect?: InputMaybe<Array<CorpContactCardWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpContactCard documents */
  set?: InputMaybe<Array<CorpContactCardWhereUniqueInput>>;
  /** Update multiple CorpContactCard documents */
  update?: InputMaybe<Array<CorpContactCardUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpContactCard documents */
  upsert?: InputMaybe<Array<CorpContactCardUpsertWithNestedWhereUniqueInput>>;
};

export type CorpContactCardUpdateManyInput = {
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** email input for default locale (default) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** linkedInUrl input for default locale (default) */
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpContactCardUpdateManyLocalizationsInput>;
  /** name input for default locale (default) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** phone input for default locale (default) */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** phoneLink input for default locale (default) */
  phoneLink?: InputMaybe<Scalars['String']['input']>;
};

export type CorpContactCardUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneLink?: InputMaybe<Scalars['String']['input']>;
};

export type CorpContactCardUpdateManyLocalizationInput = {
  data: CorpContactCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpContactCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpContactCardUpdateManyLocalizationInput>>;
};

export type CorpContactCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpContactCardUpdateManyInput;
  /** Document search */
  where: CorpContactCardWhereInput;
};

export type CorpContactCardUpdateOneInlineInput = {
  /** Connect existing CorpContactCard document */
  connect?: InputMaybe<CorpContactCardWhereUniqueInput>;
  /** Create and connect one CorpContactCard document */
  create?: InputMaybe<CorpContactCardCreateInput>;
  /** Delete currently connected CorpContactCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpContactCard document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpContactCard document */
  update?: InputMaybe<CorpContactCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpContactCard document */
  upsert?: InputMaybe<CorpContactCardUpsertWithNestedWhereUniqueInput>;
};

export type CorpContactCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpContactCardUpdateInput;
  /** Unique document search */
  where: CorpContactCardWhereUniqueInput;
};

export type CorpContactCardUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpContactCardCreateInput;
  /** Update document if it exists */
  update: CorpContactCardUpdateInput;
};

export type CorpContactCardUpsertLocalizationInput = {
  create: CorpContactCardCreateLocalizationDataInput;
  locale: Locale;
  update: CorpContactCardUpdateLocalizationDataInput;
};

export type CorpContactCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpContactCardUpsertInput;
  /** Unique document search */
  where: CorpContactCardWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpContactCardWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpContactCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpContactCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpContactCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpContactCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CorpContactCardWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpContactCardWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpContactCardWhereStageInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  email_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  email_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  email_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  email_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  email_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  email_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  email_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  email_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  email_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkedInUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkedInUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkedInUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkedInUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkedInUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkedInUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkedInUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkedInUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkedInUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phoneLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  phoneLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  phoneLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  phoneLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  phoneLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  phoneLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  phoneLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  phoneLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  phoneLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  phoneLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  phone_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  phone_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  phone_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  phone_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  phone_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  phone_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  phone_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  phone_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  phone_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpContactCardWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpContactCardWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpContactCardWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpContactCardWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpContactCardWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpContactCard record uniquely */
export type CorpContactCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CorpForm = Entity & Node & {
  __typename?: 'CorpForm';
  /** Text to be displayed in the privacy disclaimer checkbox. */
  checkboxText?: Maybe<LongText>;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpForm>;
  formType: CorpFormType;
  genericPages: Array<GenericPage>;
  /** List of CorpForm versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpForm>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CorpFormCheckboxTextArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpFormCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpFormCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpFormDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpFormGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type CorpFormHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpFormLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CorpFormPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpFormPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpFormScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpFormUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpFormUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpFormConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpFormWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpFormConnection = {
  __typename?: 'CorpFormConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpFormEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpFormCreateInput = {
  checkboxText?: InputMaybe<LongTextCreateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  formType: CorpFormType;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpFormCreateLocalizationsInput>;
  /** subtitle input for default locale (default) */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpFormCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpFormCreateLocalizationInput = {
  /** Localization input */
  data: CorpFormCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpFormCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpFormCreateLocalizationInput>>;
};

export type CorpFormCreateManyInlineInput = {
  /** Connect multiple existing CorpForm documents */
  connect?: InputMaybe<Array<CorpFormWhereUniqueInput>>;
  /** Create and connect multiple existing CorpForm documents */
  create?: InputMaybe<Array<CorpFormCreateInput>>;
};

export type CorpFormCreateOneInlineInput = {
  /** Connect one existing CorpForm document */
  connect?: InputMaybe<CorpFormWhereUniqueInput>;
  /** Create and connect one CorpForm document */
  create?: InputMaybe<CorpFormCreateInput>;
};

/** An edge in a connection. */
export type CorpFormEdge = {
  __typename?: 'CorpFormEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpForm;
};

/** Identifies documents */
export type CorpFormManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpFormWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpFormWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpFormWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  checkboxText?: InputMaybe<LongTextWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpFormWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpFormWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpFormWhereStageInput>;
  formType?: InputMaybe<CorpFormType>;
  /** All values that are contained in given list. */
  formType_in?: InputMaybe<Array<InputMaybe<CorpFormType>>>;
  /** Any other value that exists and is not equal to the given value. */
  formType_not?: InputMaybe<CorpFormType>;
  /** All values that are not contained in given list. */
  formType_not_in?: InputMaybe<Array<InputMaybe<CorpFormType>>>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpFormOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  formType_ASC = 'formType_ASC',
  formType_DESC = 'formType_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subtitle_ASC = 'subtitle_ASC',
  subtitle_DESC = 'subtitle_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum CorpFormType {
  press = 'press',
  recipes = 'recipes'
}

export type CorpFormUpdateInput = {
  checkboxText?: InputMaybe<LongTextUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  formType?: InputMaybe<CorpFormType>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpFormUpdateLocalizationsInput>;
  /** subtitle input for default locale (default) */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpFormUpdateLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpFormUpdateLocalizationInput = {
  data: CorpFormUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpFormUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpFormCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpFormUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpFormUpsertLocalizationInput>>;
};

export type CorpFormUpdateManyInlineInput = {
  /** Connect multiple existing CorpForm documents */
  connect?: InputMaybe<Array<CorpFormConnectInput>>;
  /** Create and connect multiple CorpForm documents */
  create?: InputMaybe<Array<CorpFormCreateInput>>;
  /** Delete multiple CorpForm documents */
  delete?: InputMaybe<Array<CorpFormWhereUniqueInput>>;
  /** Disconnect multiple CorpForm documents */
  disconnect?: InputMaybe<Array<CorpFormWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpForm documents */
  set?: InputMaybe<Array<CorpFormWhereUniqueInput>>;
  /** Update multiple CorpForm documents */
  update?: InputMaybe<Array<CorpFormUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpForm documents */
  upsert?: InputMaybe<Array<CorpFormUpsertWithNestedWhereUniqueInput>>;
};

export type CorpFormUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  formType?: InputMaybe<CorpFormType>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpFormUpdateManyLocalizationsInput>;
  /** subtitle input for default locale (default) */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpFormUpdateManyLocalizationDataInput = {
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpFormUpdateManyLocalizationInput = {
  data: CorpFormUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpFormUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpFormUpdateManyLocalizationInput>>;
};

export type CorpFormUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpFormUpdateManyInput;
  /** Document search */
  where: CorpFormWhereInput;
};

export type CorpFormUpdateOneInlineInput = {
  /** Connect existing CorpForm document */
  connect?: InputMaybe<CorpFormWhereUniqueInput>;
  /** Create and connect one CorpForm document */
  create?: InputMaybe<CorpFormCreateInput>;
  /** Delete currently connected CorpForm document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpForm document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpForm document */
  update?: InputMaybe<CorpFormUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpForm document */
  upsert?: InputMaybe<CorpFormUpsertWithNestedWhereUniqueInput>;
};

export type CorpFormUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpFormUpdateInput;
  /** Unique document search */
  where: CorpFormWhereUniqueInput;
};

export type CorpFormUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpFormCreateInput;
  /** Update document if it exists */
  update: CorpFormUpdateInput;
};

export type CorpFormUpsertLocalizationInput = {
  create: CorpFormCreateLocalizationDataInput;
  locale: Locale;
  update: CorpFormUpdateLocalizationDataInput;
};

export type CorpFormUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpFormUpsertInput;
  /** Unique document search */
  where: CorpFormWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpFormWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpFormWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpFormWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpFormWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpFormWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  checkboxText?: InputMaybe<LongTextWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpFormWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpFormWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpFormWhereStageInput>;
  formType?: InputMaybe<CorpFormType>;
  /** All values that are contained in given list. */
  formType_in?: InputMaybe<Array<InputMaybe<CorpFormType>>>;
  /** Any other value that exists and is not equal to the given value. */
  formType_not?: InputMaybe<CorpFormType>;
  /** All values that are not contained in given list. */
  formType_not_in?: InputMaybe<Array<InputMaybe<CorpFormType>>>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpFormWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpFormWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpFormWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpFormWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpFormWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpForm record uniquely */
export type CorpFormWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CorpGenericAccordion = Entity & Node & {
  __typename?: 'CorpGenericAccordion';
  anchorNav?: Maybe<AnchorNavigation>;
  cmsTitle: Scalars['String']['output'];
  corpGenericAccordionItems: Array<CorpGenericAccordionItem>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpGenericAccordion>;
  genericPages: Array<GenericPage>;
  /** List of CorpGenericAccordion versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  mediaLibrary?: Maybe<MediaLibrary>;
  /** Show numbers in each accordion item */
  numbered?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CorpGenericAccordionAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpGenericAccordionCorpGenericAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CorpGenericAccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericAccordionItemWhereInput>;
};


export type CorpGenericAccordionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpGenericAccordionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpGenericAccordionGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type CorpGenericAccordionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpGenericAccordionMediaLibraryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpGenericAccordionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpGenericAccordionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpGenericAccordionStoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


export type CorpGenericAccordionTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpGenericAccordionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpGenericAccordionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpGenericAccordionWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpGenericAccordionConnection = {
  __typename?: 'CorpGenericAccordionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpGenericAccordionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpGenericAccordionCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cmsTitle: Scalars['String']['input'];
  corpGenericAccordionItems?: InputMaybe<CorpGenericAccordionItemCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  mediaLibrary?: InputMaybe<MediaLibraryCreateOneInlineInput>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpGenericAccordionCreateManyInlineInput = {
  /** Connect multiple existing CorpGenericAccordion documents */
  connect?: InputMaybe<Array<CorpGenericAccordionWhereUniqueInput>>;
  /** Create and connect multiple existing CorpGenericAccordion documents */
  create?: InputMaybe<Array<CorpGenericAccordionCreateInput>>;
};

export type CorpGenericAccordionCreateOneInlineInput = {
  /** Connect one existing CorpGenericAccordion document */
  connect?: InputMaybe<CorpGenericAccordionWhereUniqueInput>;
  /** Create and connect one CorpGenericAccordion document */
  create?: InputMaybe<CorpGenericAccordionCreateInput>;
};

/** An edge in a connection. */
export type CorpGenericAccordionEdge = {
  __typename?: 'CorpGenericAccordionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpGenericAccordion;
};

export type CorpGenericAccordionItem = Entity & Node & {
  __typename?: 'CorpGenericAccordionItem';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpGenericAccordionItem>;
  genericAccordionItemBodyComponents: Array<GenericAccordionItemCenericAccordionItemBodyComponents>;
  /** List of CorpGenericAccordionItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpGenericAccordionItem>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CorpGenericAccordionItemCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpGenericAccordionItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpGenericAccordionItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpGenericAccordionItemGenericAccordionItemBodyComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type CorpGenericAccordionItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpGenericAccordionItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CorpGenericAccordionItemPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpGenericAccordionItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpGenericAccordionItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpGenericAccordionItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpGenericAccordionItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpGenericAccordionItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpGenericAccordionItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpGenericAccordionItemConnection = {
  __typename?: 'CorpGenericAccordionItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpGenericAccordionItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpGenericAccordionItemCreateInput = {
  ckruqw0gc09fh01zbgjqx7bca?: InputMaybe<CorpGenericAccordionCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericAccordionItemBodyComponents?: InputMaybe<GenericAccordionItemCenericAccordionItemBodyComponentsCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpGenericAccordionItemCreateLocalizationsInput>;
  /** title input for default locale (default) */
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpGenericAccordionItemCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpGenericAccordionItemCreateLocalizationInput = {
  /** Localization input */
  data: CorpGenericAccordionItemCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpGenericAccordionItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpGenericAccordionItemCreateLocalizationInput>>;
};

export type CorpGenericAccordionItemCreateManyInlineInput = {
  /** Connect multiple existing CorpGenericAccordionItem documents */
  connect?: InputMaybe<Array<CorpGenericAccordionItemWhereUniqueInput>>;
  /** Create and connect multiple existing CorpGenericAccordionItem documents */
  create?: InputMaybe<Array<CorpGenericAccordionItemCreateInput>>;
};

export type CorpGenericAccordionItemCreateOneInlineInput = {
  /** Connect one existing CorpGenericAccordionItem document */
  connect?: InputMaybe<CorpGenericAccordionItemWhereUniqueInput>;
  /** Create and connect one CorpGenericAccordionItem document */
  create?: InputMaybe<CorpGenericAccordionItemCreateInput>;
};

/** An edge in a connection. */
export type CorpGenericAccordionItemEdge = {
  __typename?: 'CorpGenericAccordionItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpGenericAccordionItem;
};

/** Identifies documents */
export type CorpGenericAccordionItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpGenericAccordionItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpGenericAccordionItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpGenericAccordionItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpGenericAccordionItemWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpGenericAccordionItemWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpGenericAccordionItemWhereStageInput>;
  /** All values in which the union is empty */
  genericAccordionItemBodyComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  genericAccordionItemBodyComponents_some?: InputMaybe<GenericAccordionItemCenericAccordionItemBodyComponentsWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpGenericAccordionItemOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpGenericAccordionItemUpdateInput = {
  ckruqw0gc09fh01zbgjqx7bca?: InputMaybe<CorpGenericAccordionUpdateManyInlineInput>;
  genericAccordionItemBodyComponents?: InputMaybe<GenericAccordionItemCenericAccordionItemBodyComponentsUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpGenericAccordionItemUpdateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpGenericAccordionItemUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpGenericAccordionItemUpdateLocalizationInput = {
  data: CorpGenericAccordionItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpGenericAccordionItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpGenericAccordionItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpGenericAccordionItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpGenericAccordionItemUpsertLocalizationInput>>;
};

export type CorpGenericAccordionItemUpdateManyInlineInput = {
  /** Connect multiple existing CorpGenericAccordionItem documents */
  connect?: InputMaybe<Array<CorpGenericAccordionItemConnectInput>>;
  /** Create and connect multiple CorpGenericAccordionItem documents */
  create?: InputMaybe<Array<CorpGenericAccordionItemCreateInput>>;
  /** Delete multiple CorpGenericAccordionItem documents */
  delete?: InputMaybe<Array<CorpGenericAccordionItemWhereUniqueInput>>;
  /** Disconnect multiple CorpGenericAccordionItem documents */
  disconnect?: InputMaybe<Array<CorpGenericAccordionItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpGenericAccordionItem documents */
  set?: InputMaybe<Array<CorpGenericAccordionItemWhereUniqueInput>>;
  /** Update multiple CorpGenericAccordionItem documents */
  update?: InputMaybe<Array<CorpGenericAccordionItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpGenericAccordionItem documents */
  upsert?: InputMaybe<Array<CorpGenericAccordionItemUpsertWithNestedWhereUniqueInput>>;
};

export type CorpGenericAccordionItemUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpGenericAccordionItemUpdateManyLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpGenericAccordionItemUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpGenericAccordionItemUpdateManyLocalizationInput = {
  data: CorpGenericAccordionItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpGenericAccordionItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpGenericAccordionItemUpdateManyLocalizationInput>>;
};

export type CorpGenericAccordionItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpGenericAccordionItemUpdateManyInput;
  /** Document search */
  where: CorpGenericAccordionItemWhereInput;
};

export type CorpGenericAccordionItemUpdateOneInlineInput = {
  /** Connect existing CorpGenericAccordionItem document */
  connect?: InputMaybe<CorpGenericAccordionItemWhereUniqueInput>;
  /** Create and connect one CorpGenericAccordionItem document */
  create?: InputMaybe<CorpGenericAccordionItemCreateInput>;
  /** Delete currently connected CorpGenericAccordionItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpGenericAccordionItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpGenericAccordionItem document */
  update?: InputMaybe<CorpGenericAccordionItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpGenericAccordionItem document */
  upsert?: InputMaybe<CorpGenericAccordionItemUpsertWithNestedWhereUniqueInput>;
};

export type CorpGenericAccordionItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpGenericAccordionItemUpdateInput;
  /** Unique document search */
  where: CorpGenericAccordionItemWhereUniqueInput;
};

export type CorpGenericAccordionItemUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpGenericAccordionItemCreateInput;
  /** Update document if it exists */
  update: CorpGenericAccordionItemUpdateInput;
};

export type CorpGenericAccordionItemUpsertLocalizationInput = {
  create: CorpGenericAccordionItemCreateLocalizationDataInput;
  locale: Locale;
  update: CorpGenericAccordionItemUpdateLocalizationDataInput;
};

export type CorpGenericAccordionItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpGenericAccordionItemUpsertInput;
  /** Unique document search */
  where: CorpGenericAccordionItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpGenericAccordionItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpGenericAccordionItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpGenericAccordionItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpGenericAccordionItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpGenericAccordionItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpGenericAccordionItemWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpGenericAccordionItemWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpGenericAccordionItemWhereStageInput>;
  /** All values in which the union is empty */
  genericAccordionItemBodyComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  genericAccordionItemBodyComponents_some?: InputMaybe<GenericAccordionItemCenericAccordionItemBodyComponentsWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpGenericAccordionItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpGenericAccordionItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpGenericAccordionItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpGenericAccordionItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpGenericAccordionItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpGenericAccordionItem record uniquely */
export type CorpGenericAccordionItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type CorpGenericAccordionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpGenericAccordionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpGenericAccordionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpGenericAccordionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  corpGenericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  corpGenericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  corpGenericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpGenericAccordionWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpGenericAccordionWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpGenericAccordionWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  numbered_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpGenericAccordionOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  numbered_ASC = 'numbered_ASC',
  numbered_DESC = 'numbered_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpGenericAccordionUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  corpGenericAccordionItems?: InputMaybe<CorpGenericAccordionItemUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  mediaLibrary?: InputMaybe<MediaLibraryUpdateOneInlineInput>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type CorpGenericAccordionUpdateManyInlineInput = {
  /** Connect multiple existing CorpGenericAccordion documents */
  connect?: InputMaybe<Array<CorpGenericAccordionConnectInput>>;
  /** Create and connect multiple CorpGenericAccordion documents */
  create?: InputMaybe<Array<CorpGenericAccordionCreateInput>>;
  /** Delete multiple CorpGenericAccordion documents */
  delete?: InputMaybe<Array<CorpGenericAccordionWhereUniqueInput>>;
  /** Disconnect multiple CorpGenericAccordion documents */
  disconnect?: InputMaybe<Array<CorpGenericAccordionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpGenericAccordion documents */
  set?: InputMaybe<Array<CorpGenericAccordionWhereUniqueInput>>;
  /** Update multiple CorpGenericAccordion documents */
  update?: InputMaybe<Array<CorpGenericAccordionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpGenericAccordion documents */
  upsert?: InputMaybe<Array<CorpGenericAccordionUpsertWithNestedWhereUniqueInput>>;
};

export type CorpGenericAccordionUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CorpGenericAccordionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpGenericAccordionUpdateManyInput;
  /** Document search */
  where: CorpGenericAccordionWhereInput;
};

export type CorpGenericAccordionUpdateOneInlineInput = {
  /** Connect existing CorpGenericAccordion document */
  connect?: InputMaybe<CorpGenericAccordionWhereUniqueInput>;
  /** Create and connect one CorpGenericAccordion document */
  create?: InputMaybe<CorpGenericAccordionCreateInput>;
  /** Delete currently connected CorpGenericAccordion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpGenericAccordion document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpGenericAccordion document */
  update?: InputMaybe<CorpGenericAccordionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpGenericAccordion document */
  upsert?: InputMaybe<CorpGenericAccordionUpsertWithNestedWhereUniqueInput>;
};

export type CorpGenericAccordionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpGenericAccordionUpdateInput;
  /** Unique document search */
  where: CorpGenericAccordionWhereUniqueInput;
};

export type CorpGenericAccordionUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpGenericAccordionCreateInput;
  /** Update document if it exists */
  update: CorpGenericAccordionUpdateInput;
};

export type CorpGenericAccordionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpGenericAccordionUpsertInput;
  /** Unique document search */
  where: CorpGenericAccordionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpGenericAccordionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpGenericAccordionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpGenericAccordionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpGenericAccordionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpGenericAccordionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  corpGenericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  corpGenericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  corpGenericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpGenericAccordionWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpGenericAccordionWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpGenericAccordionWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  numbered_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpGenericAccordionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpGenericAccordionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpGenericAccordionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpGenericAccordionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpGenericAccordionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpGenericAccordion record uniquely */
export type CorpGenericAccordionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Corp Generic Banner */
export type CorpGenericBanner = Entity & Node & {
  __typename?: 'CorpGenericBanner';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpGenericBanner>;
  genericPages: Array<GenericPage>;
  /** List of CorpGenericBanner versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Title */
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Corp Generic Banner */
export type CorpGenericBannerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Corp Generic Banner */
export type CorpGenericBannerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Corp Generic Banner */
export type CorpGenericBannerGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Corp Generic Banner */
export type CorpGenericBannerHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Corp Generic Banner */
export type CorpGenericBannerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Corp Generic Banner */
export type CorpGenericBannerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Corp Generic Banner */
export type CorpGenericBannerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpGenericBannerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpGenericBannerWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpGenericBannerConnection = {
  __typename?: 'CorpGenericBannerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpGenericBannerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpGenericBannerCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpGenericBannerCreateManyInlineInput = {
  /** Connect multiple existing CorpGenericBanner documents */
  connect?: InputMaybe<Array<CorpGenericBannerWhereUniqueInput>>;
  /** Create and connect multiple existing CorpGenericBanner documents */
  create?: InputMaybe<Array<CorpGenericBannerCreateInput>>;
};

export type CorpGenericBannerCreateOneInlineInput = {
  /** Connect one existing CorpGenericBanner document */
  connect?: InputMaybe<CorpGenericBannerWhereUniqueInput>;
  /** Create and connect one CorpGenericBanner document */
  create?: InputMaybe<CorpGenericBannerCreateInput>;
};

/** An edge in a connection. */
export type CorpGenericBannerEdge = {
  __typename?: 'CorpGenericBannerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpGenericBanner;
};

/** Identifies documents */
export type CorpGenericBannerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpGenericBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpGenericBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpGenericBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpGenericBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpGenericBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpGenericBannerWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpGenericBannerOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpGenericBannerUpdateInput = {
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpGenericBannerUpdateManyInlineInput = {
  /** Connect multiple existing CorpGenericBanner documents */
  connect?: InputMaybe<Array<CorpGenericBannerConnectInput>>;
  /** Create and connect multiple CorpGenericBanner documents */
  create?: InputMaybe<Array<CorpGenericBannerCreateInput>>;
  /** Delete multiple CorpGenericBanner documents */
  delete?: InputMaybe<Array<CorpGenericBannerWhereUniqueInput>>;
  /** Disconnect multiple CorpGenericBanner documents */
  disconnect?: InputMaybe<Array<CorpGenericBannerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpGenericBanner documents */
  set?: InputMaybe<Array<CorpGenericBannerWhereUniqueInput>>;
  /** Update multiple CorpGenericBanner documents */
  update?: InputMaybe<Array<CorpGenericBannerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpGenericBanner documents */
  upsert?: InputMaybe<Array<CorpGenericBannerUpsertWithNestedWhereUniqueInput>>;
};

export type CorpGenericBannerUpdateManyInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpGenericBannerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpGenericBannerUpdateManyInput;
  /** Document search */
  where: CorpGenericBannerWhereInput;
};

export type CorpGenericBannerUpdateOneInlineInput = {
  /** Connect existing CorpGenericBanner document */
  connect?: InputMaybe<CorpGenericBannerWhereUniqueInput>;
  /** Create and connect one CorpGenericBanner document */
  create?: InputMaybe<CorpGenericBannerCreateInput>;
  /** Delete currently connected CorpGenericBanner document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpGenericBanner document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpGenericBanner document */
  update?: InputMaybe<CorpGenericBannerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpGenericBanner document */
  upsert?: InputMaybe<CorpGenericBannerUpsertWithNestedWhereUniqueInput>;
};

export type CorpGenericBannerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpGenericBannerUpdateInput;
  /** Unique document search */
  where: CorpGenericBannerWhereUniqueInput;
};

export type CorpGenericBannerUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpGenericBannerCreateInput;
  /** Update document if it exists */
  update: CorpGenericBannerUpdateInput;
};

export type CorpGenericBannerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpGenericBannerUpsertInput;
  /** Unique document search */
  where: CorpGenericBannerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpGenericBannerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpGenericBannerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpGenericBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpGenericBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpGenericBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpGenericBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpGenericBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpGenericBannerWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpGenericBannerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpGenericBannerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpGenericBannerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpGenericBannerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpGenericBannerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpGenericBanner record uniquely */
export type CorpGenericBannerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Container to visually constrain components horizontally (make sure things don't go full width) */
export type CorpGenericContainer = Entity & Node & {
  __typename?: 'CorpGenericContainer';
  anchorNav?: Maybe<AnchorNavigation>;
  /** Optional field to be able to easily identify it in the CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  content?: Maybe<CorpGenericContainerContent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpGenericContainer>;
  genericAccordionItems: Array<CorpGenericAccordionItem>;
  genericPages: Array<GenericPage>;
  /** List of CorpGenericContainer versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  locationItem?: Maybe<LocationItem>;
  mediaLibrary?: Maybe<MediaLibrary>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Container to visually constrain components horizontally (make sure things don't go full width) */
export type CorpGenericContainerAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Container to visually constrain components horizontally (make sure things don't go full width) */
export type CorpGenericContainerContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Container to visually constrain components horizontally (make sure things don't go full width) */
export type CorpGenericContainerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Container to visually constrain components horizontally (make sure things don't go full width) */
export type CorpGenericContainerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Container to visually constrain components horizontally (make sure things don't go full width) */
export type CorpGenericContainerGenericAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericAccordionItemWhereInput>;
};


/** Container to visually constrain components horizontally (make sure things don't go full width) */
export type CorpGenericContainerGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Container to visually constrain components horizontally (make sure things don't go full width) */
export type CorpGenericContainerHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Container to visually constrain components horizontally (make sure things don't go full width) */
export type CorpGenericContainerLocationItemArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Container to visually constrain components horizontally (make sure things don't go full width) */
export type CorpGenericContainerMediaLibraryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Container to visually constrain components horizontally (make sure things don't go full width) */
export type CorpGenericContainerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Container to visually constrain components horizontally (make sure things don't go full width) */
export type CorpGenericContainerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Container to visually constrain components horizontally (make sure things don't go full width) */
export type CorpGenericContainerStoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


/** Container to visually constrain components horizontally (make sure things don't go full width) */
export type CorpGenericContainerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpGenericContainerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpGenericContainerWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpGenericContainerConnection = {
  __typename?: 'CorpGenericContainerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpGenericContainerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpGenericContainerContent = BigNumber | ProgressBar;

export type CorpGenericContainerContentConnectInput = {
  BigNumber?: InputMaybe<BigNumberConnectInput>;
  ProgressBar?: InputMaybe<ProgressBarConnectInput>;
};

export type CorpGenericContainerContentCreateInput = {
  BigNumber?: InputMaybe<BigNumberCreateInput>;
  ProgressBar?: InputMaybe<ProgressBarCreateInput>;
};

export type CorpGenericContainerContentCreateManyInlineInput = {
  /** Connect multiple existing CorpGenericContainerContent documents */
  connect?: InputMaybe<Array<CorpGenericContainerContentWhereUniqueInput>>;
  /** Create and connect multiple existing CorpGenericContainerContent documents */
  create?: InputMaybe<Array<CorpGenericContainerContentCreateInput>>;
};

export type CorpGenericContainerContentCreateOneInlineInput = {
  /** Connect one existing CorpGenericContainerContent document */
  connect?: InputMaybe<CorpGenericContainerContentWhereUniqueInput>;
  /** Create and connect one CorpGenericContainerContent document */
  create?: InputMaybe<CorpGenericContainerContentCreateInput>;
};

export type CorpGenericContainerContentUpdateInput = {
  BigNumber?: InputMaybe<BigNumberUpdateInput>;
  ProgressBar?: InputMaybe<ProgressBarUpdateInput>;
};

export type CorpGenericContainerContentUpdateManyInlineInput = {
  /** Connect multiple existing CorpGenericContainerContent documents */
  connect?: InputMaybe<Array<CorpGenericContainerContentConnectInput>>;
  /** Create and connect multiple CorpGenericContainerContent documents */
  create?: InputMaybe<Array<CorpGenericContainerContentCreateInput>>;
  /** Delete multiple CorpGenericContainerContent documents */
  delete?: InputMaybe<Array<CorpGenericContainerContentWhereUniqueInput>>;
  /** Disconnect multiple CorpGenericContainerContent documents */
  disconnect?: InputMaybe<Array<CorpGenericContainerContentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpGenericContainerContent documents */
  set?: InputMaybe<Array<CorpGenericContainerContentWhereUniqueInput>>;
  /** Update multiple CorpGenericContainerContent documents */
  update?: InputMaybe<Array<CorpGenericContainerContentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpGenericContainerContent documents */
  upsert?: InputMaybe<Array<CorpGenericContainerContentUpsertWithNestedWhereUniqueInput>>;
};

export type CorpGenericContainerContentUpdateManyWithNestedWhereInput = {
  BigNumber?: InputMaybe<BigNumberUpdateManyWithNestedWhereInput>;
  ProgressBar?: InputMaybe<ProgressBarUpdateManyWithNestedWhereInput>;
};

export type CorpGenericContainerContentUpdateOneInlineInput = {
  /** Connect existing CorpGenericContainerContent document */
  connect?: InputMaybe<CorpGenericContainerContentWhereUniqueInput>;
  /** Create and connect one CorpGenericContainerContent document */
  create?: InputMaybe<CorpGenericContainerContentCreateInput>;
  /** Delete currently connected CorpGenericContainerContent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpGenericContainerContent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpGenericContainerContent document */
  update?: InputMaybe<CorpGenericContainerContentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpGenericContainerContent document */
  upsert?: InputMaybe<CorpGenericContainerContentUpsertWithNestedWhereUniqueInput>;
};

export type CorpGenericContainerContentUpdateWithNestedWhereUniqueInput = {
  BigNumber?: InputMaybe<BigNumberUpdateWithNestedWhereUniqueInput>;
  ProgressBar?: InputMaybe<ProgressBarUpdateWithNestedWhereUniqueInput>;
};

export type CorpGenericContainerContentUpsertWithNestedWhereUniqueInput = {
  BigNumber?: InputMaybe<BigNumberUpsertWithNestedWhereUniqueInput>;
  ProgressBar?: InputMaybe<ProgressBarUpsertWithNestedWhereUniqueInput>;
};

export type CorpGenericContainerContentWhereInput = {
  BigNumber?: InputMaybe<BigNumberWhereInput>;
  ProgressBar?: InputMaybe<ProgressBarWhereInput>;
};

export type CorpGenericContainerContentWhereUniqueInput = {
  BigNumber?: InputMaybe<BigNumberWhereUniqueInput>;
  ProgressBar?: InputMaybe<ProgressBarWhereUniqueInput>;
};

export type CorpGenericContainerCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<CorpGenericContainerContentCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  locationItem?: InputMaybe<LocationItemCreateOneInlineInput>;
  mediaLibrary?: InputMaybe<MediaLibraryCreateOneInlineInput>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpGenericContainerCreateManyInlineInput = {
  /** Connect multiple existing CorpGenericContainer documents */
  connect?: InputMaybe<Array<CorpGenericContainerWhereUniqueInput>>;
  /** Create and connect multiple existing CorpGenericContainer documents */
  create?: InputMaybe<Array<CorpGenericContainerCreateInput>>;
};

export type CorpGenericContainerCreateOneInlineInput = {
  /** Connect one existing CorpGenericContainer document */
  connect?: InputMaybe<CorpGenericContainerWhereUniqueInput>;
  /** Create and connect one CorpGenericContainer document */
  create?: InputMaybe<CorpGenericContainerCreateInput>;
};

/** An edge in a connection. */
export type CorpGenericContainerEdge = {
  __typename?: 'CorpGenericContainerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpGenericContainer;
};

/** Identifies documents */
export type CorpGenericContainerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpGenericContainerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpGenericContainerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpGenericContainerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is connected to the given models */
  content?: InputMaybe<CorpGenericContainerContentWhereInput>;
  /** All values in which the union is empty */
  content_empty?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpGenericContainerWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpGenericContainerWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpGenericContainerWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  locationItem?: InputMaybe<LocationItemWhereInput>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpGenericContainerOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpGenericContainerUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<CorpGenericContainerContentUpdateOneInlineInput>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  locationItem?: InputMaybe<LocationItemUpdateOneInlineInput>;
  mediaLibrary?: InputMaybe<MediaLibraryUpdateOneInlineInput>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
};

export type CorpGenericContainerUpdateManyInlineInput = {
  /** Connect multiple existing CorpGenericContainer documents */
  connect?: InputMaybe<Array<CorpGenericContainerConnectInput>>;
  /** Create and connect multiple CorpGenericContainer documents */
  create?: InputMaybe<Array<CorpGenericContainerCreateInput>>;
  /** Delete multiple CorpGenericContainer documents */
  delete?: InputMaybe<Array<CorpGenericContainerWhereUniqueInput>>;
  /** Disconnect multiple CorpGenericContainer documents */
  disconnect?: InputMaybe<Array<CorpGenericContainerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpGenericContainer documents */
  set?: InputMaybe<Array<CorpGenericContainerWhereUniqueInput>>;
  /** Update multiple CorpGenericContainer documents */
  update?: InputMaybe<Array<CorpGenericContainerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpGenericContainer documents */
  upsert?: InputMaybe<Array<CorpGenericContainerUpsertWithNestedWhereUniqueInput>>;
};

export type CorpGenericContainerUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type CorpGenericContainerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpGenericContainerUpdateManyInput;
  /** Document search */
  where: CorpGenericContainerWhereInput;
};

export type CorpGenericContainerUpdateOneInlineInput = {
  /** Connect existing CorpGenericContainer document */
  connect?: InputMaybe<CorpGenericContainerWhereUniqueInput>;
  /** Create and connect one CorpGenericContainer document */
  create?: InputMaybe<CorpGenericContainerCreateInput>;
  /** Delete currently connected CorpGenericContainer document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpGenericContainer document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpGenericContainer document */
  update?: InputMaybe<CorpGenericContainerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpGenericContainer document */
  upsert?: InputMaybe<CorpGenericContainerUpsertWithNestedWhereUniqueInput>;
};

export type CorpGenericContainerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpGenericContainerUpdateInput;
  /** Unique document search */
  where: CorpGenericContainerWhereUniqueInput;
};

export type CorpGenericContainerUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpGenericContainerCreateInput;
  /** Update document if it exists */
  update: CorpGenericContainerUpdateInput;
};

export type CorpGenericContainerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpGenericContainerUpsertInput;
  /** Unique document search */
  where: CorpGenericContainerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpGenericContainerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpGenericContainerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpGenericContainerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpGenericContainerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpGenericContainerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is connected to the given models */
  content?: InputMaybe<CorpGenericContainerContentWhereInput>;
  /** All values in which the union is empty */
  content_empty?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpGenericContainerWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpGenericContainerWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpGenericContainerWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  locationItem?: InputMaybe<LocationItemWhereInput>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpGenericContainerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpGenericContainerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpGenericContainerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpGenericContainerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpGenericContainerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpGenericContainer record uniquely */
export type CorpGenericContainerWhereUniqueInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CorpGridColumnComponent = Entity & Node & {
  __typename?: 'CorpGridColumnComponent';
  anchorNav?: Maybe<AnchorNavigation>;
  cardData: Array<ImageAndTextCard>;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  color?: Maybe<CorpColorThemeName>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpGridColumnComponent>;
  genericAccordionItems: Array<CorpGenericAccordionItem>;
  genericPages: Array<GenericPage>;
  /** Add metaball behind the object */
  gridMetaball: Scalars['Boolean']['output'];
  /** List of CorpGridColumnComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  locationItem?: Maybe<LocationItem>;
  mediaLibrary?: Maybe<MediaLibrary>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CorpGridColumnComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpGridColumnComponentCardDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ImageAndTextCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageAndTextCardWhereInput>;
};


export type CorpGridColumnComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpGridColumnComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpGridColumnComponentGenericAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericAccordionItemWhereInput>;
};


export type CorpGridColumnComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type CorpGridColumnComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpGridColumnComponentLocationItemArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpGridColumnComponentMediaLibraryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpGridColumnComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpGridColumnComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpGridColumnComponentStoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


export type CorpGridColumnComponentTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpGridColumnComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpGridColumnComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpGridColumnComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpGridColumnComponentConnection = {
  __typename?: 'CorpGridColumnComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpGridColumnComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpGridColumnComponentCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cardData?: InputMaybe<ImageAndTextCardCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  gridMetaball: Scalars['Boolean']['input'];
  locationItem?: InputMaybe<LocationItemCreateOneInlineInput>;
  mediaLibrary?: InputMaybe<MediaLibraryCreateOneInlineInput>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpGridColumnComponentCreateManyInlineInput = {
  /** Connect multiple existing CorpGridColumnComponent documents */
  connect?: InputMaybe<Array<CorpGridColumnComponentWhereUniqueInput>>;
  /** Create and connect multiple existing CorpGridColumnComponent documents */
  create?: InputMaybe<Array<CorpGridColumnComponentCreateInput>>;
};

export type CorpGridColumnComponentCreateOneInlineInput = {
  /** Connect one existing CorpGridColumnComponent document */
  connect?: InputMaybe<CorpGridColumnComponentWhereUniqueInput>;
  /** Create and connect one CorpGridColumnComponent document */
  create?: InputMaybe<CorpGridColumnComponentCreateInput>;
};

/** An edge in a connection. */
export type CorpGridColumnComponentEdge = {
  __typename?: 'CorpGridColumnComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpGridColumnComponent;
};

/** Identifies documents */
export type CorpGridColumnComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpGridColumnComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpGridColumnComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpGridColumnComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cardData_every?: InputMaybe<ImageAndTextCardWhereInput>;
  cardData_none?: InputMaybe<ImageAndTextCardWhereInput>;
  cardData_some?: InputMaybe<ImageAndTextCardWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  /** All values that are contained in given list. */
  color_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  /** Any other value that exists and is not equal to the given value. */
  color_not?: InputMaybe<CorpColorThemeName>;
  /** All values that are not contained in given list. */
  color_not_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpGridColumnComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpGridColumnComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpGridColumnComponentWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  gridMetaball?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  gridMetaball_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  locationItem?: InputMaybe<LocationItemWhereInput>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpGridColumnComponentOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  color_ASC = 'color_ASC',
  color_DESC = 'color_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  gridMetaball_ASC = 'gridMetaball_ASC',
  gridMetaball_DESC = 'gridMetaball_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpGridColumnComponentUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cardData?: InputMaybe<ImageAndTextCardUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  gridMetaball?: InputMaybe<Scalars['Boolean']['input']>;
  locationItem?: InputMaybe<LocationItemUpdateOneInlineInput>;
  mediaLibrary?: InputMaybe<MediaLibraryUpdateOneInlineInput>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type CorpGridColumnComponentUpdateManyInlineInput = {
  /** Connect multiple existing CorpGridColumnComponent documents */
  connect?: InputMaybe<Array<CorpGridColumnComponentConnectInput>>;
  /** Create and connect multiple CorpGridColumnComponent documents */
  create?: InputMaybe<Array<CorpGridColumnComponentCreateInput>>;
  /** Delete multiple CorpGridColumnComponent documents */
  delete?: InputMaybe<Array<CorpGridColumnComponentWhereUniqueInput>>;
  /** Disconnect multiple CorpGridColumnComponent documents */
  disconnect?: InputMaybe<Array<CorpGridColumnComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpGridColumnComponent documents */
  set?: InputMaybe<Array<CorpGridColumnComponentWhereUniqueInput>>;
  /** Update multiple CorpGridColumnComponent documents */
  update?: InputMaybe<Array<CorpGridColumnComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpGridColumnComponent documents */
  upsert?: InputMaybe<Array<CorpGridColumnComponentUpsertWithNestedWhereUniqueInput>>;
};

export type CorpGridColumnComponentUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  gridMetaball?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CorpGridColumnComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpGridColumnComponentUpdateManyInput;
  /** Document search */
  where: CorpGridColumnComponentWhereInput;
};

export type CorpGridColumnComponentUpdateOneInlineInput = {
  /** Connect existing CorpGridColumnComponent document */
  connect?: InputMaybe<CorpGridColumnComponentWhereUniqueInput>;
  /** Create and connect one CorpGridColumnComponent document */
  create?: InputMaybe<CorpGridColumnComponentCreateInput>;
  /** Delete currently connected CorpGridColumnComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpGridColumnComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpGridColumnComponent document */
  update?: InputMaybe<CorpGridColumnComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpGridColumnComponent document */
  upsert?: InputMaybe<CorpGridColumnComponentUpsertWithNestedWhereUniqueInput>;
};

export type CorpGridColumnComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpGridColumnComponentUpdateInput;
  /** Unique document search */
  where: CorpGridColumnComponentWhereUniqueInput;
};

export type CorpGridColumnComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpGridColumnComponentCreateInput;
  /** Update document if it exists */
  update: CorpGridColumnComponentUpdateInput;
};

export type CorpGridColumnComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpGridColumnComponentUpsertInput;
  /** Unique document search */
  where: CorpGridColumnComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpGridColumnComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpGridColumnComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpGridColumnComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpGridColumnComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpGridColumnComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cardData_every?: InputMaybe<ImageAndTextCardWhereInput>;
  cardData_none?: InputMaybe<ImageAndTextCardWhereInput>;
  cardData_some?: InputMaybe<ImageAndTextCardWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  /** All values that are contained in given list. */
  color_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  /** Any other value that exists and is not equal to the given value. */
  color_not?: InputMaybe<CorpColorThemeName>;
  /** All values that are not contained in given list. */
  color_not_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpGridColumnComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpGridColumnComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpGridColumnComponentWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  gridMetaball?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  gridMetaball_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  locationItem?: InputMaybe<LocationItemWhereInput>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpGridColumnComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpGridColumnComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpGridColumnComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpGridColumnComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpGridColumnComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpGridColumnComponent record uniquely */
export type CorpGridColumnComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Corp Hero */
export type CorpHero = Entity & Node & {
  __typename?: 'CorpHero';
  /** Hide / Show background image gradient */
  backgroundGradient?: Maybe<Scalars['Boolean']['output']>;
  bannerDescriptionText?: Maybe<Scalars['String']['output']>;
  bannerImage?: Maybe<Asset>;
  bannerTitle?: Maybe<Scalars['String']['output']>;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpHero>;
  genericPages: Array<GenericPage>;
  /** List of CorpHero versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpHero>;
  mobileImage?: Maybe<Asset>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  superText?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Corp Hero */
export type CorpHeroBannerImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Corp Hero */
export type CorpHeroCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Corp Hero */
export type CorpHeroCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Corp Hero */
export type CorpHeroDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Corp Hero */
export type CorpHeroGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Corp Hero */
export type CorpHeroHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Corp Hero */
export type CorpHeroLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Corp Hero */
export type CorpHeroLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Corp Hero */
export type CorpHeroMobileImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Corp Hero */
export type CorpHeroPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Corp Hero */
export type CorpHeroPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Corp Hero */
export type CorpHeroScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Corp Hero */
export type CorpHeroUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Corp Hero */
export type CorpHeroUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpHeroConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpHeroWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpHeroConnection = {
  __typename?: 'CorpHeroConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpHeroEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpHeroCreateInput = {
  backgroundGradient?: InputMaybe<Scalars['Boolean']['input']>;
  /** bannerDescriptionText input for default locale (default) */
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<AssetCreateOneInlineInput>;
  /** bannerTitle input for default locale (default) */
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  cl4e542lo02e901xu8icl1rfa?: InputMaybe<CorpStoriesPageCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpHeroCreateLocalizationsInput>;
  mobileImage?: InputMaybe<AssetCreateOneInlineInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpHeroCreateLocalizationDataInput = {
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpHeroCreateLocalizationInput = {
  /** Localization input */
  data: CorpHeroCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpHeroCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpHeroCreateLocalizationInput>>;
};

export type CorpHeroCreateManyInlineInput = {
  /** Connect multiple existing CorpHero documents */
  connect?: InputMaybe<Array<CorpHeroWhereUniqueInput>>;
  /** Create and connect multiple existing CorpHero documents */
  create?: InputMaybe<Array<CorpHeroCreateInput>>;
};

export type CorpHeroCreateOneInlineInput = {
  /** Connect one existing CorpHero document */
  connect?: InputMaybe<CorpHeroWhereUniqueInput>;
  /** Create and connect one CorpHero document */
  create?: InputMaybe<CorpHeroCreateInput>;
};

/** An edge in a connection. */
export type CorpHeroEdge = {
  __typename?: 'CorpHeroEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpHero;
};

/** Identifies documents */
export type CorpHeroManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpHeroWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpHeroWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpHeroWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundGradient?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundGradient_not?: InputMaybe<Scalars['Boolean']['input']>;
  bannerImage?: InputMaybe<AssetWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpHeroWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpHeroWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpHeroWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpHeroOrderByInput {
  backgroundGradient_ASC = 'backgroundGradient_ASC',
  backgroundGradient_DESC = 'backgroundGradient_DESC',
  bannerDescriptionText_ASC = 'bannerDescriptionText_ASC',
  bannerDescriptionText_DESC = 'bannerDescriptionText_DESC',
  bannerTitle_ASC = 'bannerTitle_ASC',
  bannerTitle_DESC = 'bannerTitle_DESC',
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpHeroUpdateInput = {
  backgroundGradient?: InputMaybe<Scalars['Boolean']['input']>;
  /** bannerDescriptionText input for default locale (default) */
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<AssetUpdateOneInlineInput>;
  /** bannerTitle input for default locale (default) */
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  cl4e542lo02e901xu8icl1rfa?: InputMaybe<CorpStoriesPageUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpHeroUpdateLocalizationsInput>;
  mobileImage?: InputMaybe<AssetUpdateOneInlineInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
};

export type CorpHeroUpdateLocalizationDataInput = {
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
};

export type CorpHeroUpdateLocalizationInput = {
  data: CorpHeroUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpHeroUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpHeroCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpHeroUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpHeroUpsertLocalizationInput>>;
};

export type CorpHeroUpdateManyInlineInput = {
  /** Connect multiple existing CorpHero documents */
  connect?: InputMaybe<Array<CorpHeroConnectInput>>;
  /** Create and connect multiple CorpHero documents */
  create?: InputMaybe<Array<CorpHeroCreateInput>>;
  /** Delete multiple CorpHero documents */
  delete?: InputMaybe<Array<CorpHeroWhereUniqueInput>>;
  /** Disconnect multiple CorpHero documents */
  disconnect?: InputMaybe<Array<CorpHeroWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpHero documents */
  set?: InputMaybe<Array<CorpHeroWhereUniqueInput>>;
  /** Update multiple CorpHero documents */
  update?: InputMaybe<Array<CorpHeroUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpHero documents */
  upsert?: InputMaybe<Array<CorpHeroUpsertWithNestedWhereUniqueInput>>;
};

export type CorpHeroUpdateManyInput = {
  backgroundGradient?: InputMaybe<Scalars['Boolean']['input']>;
  /** bannerDescriptionText input for default locale (default) */
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  /** bannerTitle input for default locale (default) */
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpHeroUpdateManyLocalizationsInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
};

export type CorpHeroUpdateManyLocalizationDataInput = {
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
};

export type CorpHeroUpdateManyLocalizationInput = {
  data: CorpHeroUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpHeroUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpHeroUpdateManyLocalizationInput>>;
};

export type CorpHeroUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpHeroUpdateManyInput;
  /** Document search */
  where: CorpHeroWhereInput;
};

export type CorpHeroUpdateOneInlineInput = {
  /** Connect existing CorpHero document */
  connect?: InputMaybe<CorpHeroWhereUniqueInput>;
  /** Create and connect one CorpHero document */
  create?: InputMaybe<CorpHeroCreateInput>;
  /** Delete currently connected CorpHero document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpHero document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpHero document */
  update?: InputMaybe<CorpHeroUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpHero document */
  upsert?: InputMaybe<CorpHeroUpsertWithNestedWhereUniqueInput>;
};

export type CorpHeroUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpHeroUpdateInput;
  /** Unique document search */
  where: CorpHeroWhereUniqueInput;
};

export type CorpHeroUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpHeroCreateInput;
  /** Update document if it exists */
  update: CorpHeroUpdateInput;
};

export type CorpHeroUpsertLocalizationInput = {
  create: CorpHeroCreateLocalizationDataInput;
  locale: Locale;
  update: CorpHeroUpdateLocalizationDataInput;
};

export type CorpHeroUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpHeroUpsertInput;
  /** Unique document search */
  where: CorpHeroWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpHeroWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpHeroWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpHeroWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpHeroWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpHeroWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  backgroundGradient?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundGradient_not?: InputMaybe<Scalars['Boolean']['input']>;
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerDescriptionText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerDescriptionText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerDescriptionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerDescriptionText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerDescriptionText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerDescriptionText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerDescriptionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerDescriptionText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerDescriptionText_starts_with?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<AssetWhereInput>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpHeroWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpHeroWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpHeroWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpHeroWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpHeroWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpHeroWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpHeroWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpHeroWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpHero record uniquely */
export type CorpHeroWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CorpLongTextComponent = Entity & {
  __typename?: 'CorpLongTextComponent';
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System stage field */
  stage: Stage;
};

/** A connection to a list of items. */
export type CorpLongTextComponentConnection = {
  __typename?: 'CorpLongTextComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpLongTextComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpLongTextComponentCreateInput = {
  /** No fields in create input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type CorpLongTextComponentCreateWithPositionInput = {
  /** Document to create */
  data: CorpLongTextComponentCreateInput;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
};

/** An edge in a connection. */
export type CorpLongTextComponentEdge = {
  __typename?: 'CorpLongTextComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpLongTextComponent;
};

/** Identifies documents */
export type CorpLongTextComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpLongTextComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpLongTextComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpLongTextComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
};

export enum CorpLongTextComponentOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC'
}

export type CorpLongTextComponentUpdateInput = {
  /** No fields in update input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type CorpLongTextComponentUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type CorpLongTextComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpLongTextComponentUpdateManyInput;
  /** Document search */
  where: CorpLongTextComponentWhereInput;
};

export type CorpLongTextComponentUpdateWithNestedWhereUniqueAndPositionInput = {
  /** Document to update */
  data?: InputMaybe<CorpLongTextComponentUpdateInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CorpLongTextComponentWhereUniqueInput;
};

export type CorpLongTextComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpLongTextComponentUpdateInput;
  /** Unique document search */
  where: CorpLongTextComponentWhereUniqueInput;
};

export type CorpLongTextComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpLongTextComponentCreateInput;
  /** Update document if it exists */
  update: CorpLongTextComponentUpdateInput;
};

export type CorpLongTextComponentUpsertWithNestedWhereUniqueAndPositionInput = {
  /** Document to upsert */
  data?: InputMaybe<CorpLongTextComponentUpsertInput>;
  /** Position in the list of existing component instances, will default to appending at the end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Unique component instance search */
  where: CorpLongTextComponentWhereUniqueInput;
};

export type CorpLongTextComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpLongTextComponentUpsertInput;
  /** Unique document search */
  where: CorpLongTextComponentWhereUniqueInput;
};

/** Identifies documents */
export type CorpLongTextComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpLongTextComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpLongTextComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpLongTextComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
};

/** References CorpLongTextComponent record uniquely */
export type CorpLongTextComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Corporate Market Countries */
export enum CorpMarketCountry {
  at = 'at',
  ch = 'ch',
  de = 'de',
  en = 'en',
  fr = 'fr',
  fr_Tn = 'fr_Tn',
  global = 'global',
  it = 'it',
  ru = 'ru',
  tr = 'tr'
}

export type CorpMediaDownloadPreview = Entity & Node & {
  __typename?: 'CorpMediaDownloadPreview';
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpMediaDownloadPreview>;
  genericPages: Array<GenericPage>;
  /** List of CorpMediaDownloadPreview versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpMediaDownloadPreview>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  super?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CorpMediaDownloadPreviewCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpMediaDownloadPreviewCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpMediaDownloadPreviewDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpMediaDownloadPreviewGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type CorpMediaDownloadPreviewHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpMediaDownloadPreviewLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpMediaDownloadPreviewLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CorpMediaDownloadPreviewPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpMediaDownloadPreviewPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpMediaDownloadPreviewScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpMediaDownloadPreviewUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpMediaDownloadPreviewUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpMediaDownloadPreviewConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpMediaDownloadPreviewWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpMediaDownloadPreviewConnection = {
  __typename?: 'CorpMediaDownloadPreviewConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpMediaDownloadPreviewEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpMediaDownloadPreviewCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpMediaDownloadPreviewCreateLocalizationsInput>;
  /** super input for default locale (default) */
  super?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpMediaDownloadPreviewCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  super?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpMediaDownloadPreviewCreateLocalizationInput = {
  /** Localization input */
  data: CorpMediaDownloadPreviewCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpMediaDownloadPreviewCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpMediaDownloadPreviewCreateLocalizationInput>>;
};

export type CorpMediaDownloadPreviewCreateManyInlineInput = {
  /** Connect multiple existing CorpMediaDownloadPreview documents */
  connect?: InputMaybe<Array<CorpMediaDownloadPreviewWhereUniqueInput>>;
  /** Create and connect multiple existing CorpMediaDownloadPreview documents */
  create?: InputMaybe<Array<CorpMediaDownloadPreviewCreateInput>>;
};

export type CorpMediaDownloadPreviewCreateOneInlineInput = {
  /** Connect one existing CorpMediaDownloadPreview document */
  connect?: InputMaybe<CorpMediaDownloadPreviewWhereUniqueInput>;
  /** Create and connect one CorpMediaDownloadPreview document */
  create?: InputMaybe<CorpMediaDownloadPreviewCreateInput>;
};

/** An edge in a connection. */
export type CorpMediaDownloadPreviewEdge = {
  __typename?: 'CorpMediaDownloadPreviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpMediaDownloadPreview;
};

/** Identifies documents */
export type CorpMediaDownloadPreviewManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpMediaDownloadPreviewWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpMediaDownloadPreviewWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpMediaDownloadPreviewWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpMediaDownloadPreviewWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpMediaDownloadPreviewWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpMediaDownloadPreviewWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpMediaDownloadPreviewOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  super_ASC = 'super_ASC',
  super_DESC = 'super_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpMediaDownloadPreviewUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpMediaDownloadPreviewUpdateLocalizationsInput>;
  /** super input for default locale (default) */
  super?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpMediaDownloadPreviewUpdateLocalizationDataInput = {
  super?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpMediaDownloadPreviewUpdateLocalizationInput = {
  data: CorpMediaDownloadPreviewUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpMediaDownloadPreviewUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpMediaDownloadPreviewCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpMediaDownloadPreviewUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpMediaDownloadPreviewUpsertLocalizationInput>>;
};

export type CorpMediaDownloadPreviewUpdateManyInlineInput = {
  /** Connect multiple existing CorpMediaDownloadPreview documents */
  connect?: InputMaybe<Array<CorpMediaDownloadPreviewConnectInput>>;
  /** Create and connect multiple CorpMediaDownloadPreview documents */
  create?: InputMaybe<Array<CorpMediaDownloadPreviewCreateInput>>;
  /** Delete multiple CorpMediaDownloadPreview documents */
  delete?: InputMaybe<Array<CorpMediaDownloadPreviewWhereUniqueInput>>;
  /** Disconnect multiple CorpMediaDownloadPreview documents */
  disconnect?: InputMaybe<Array<CorpMediaDownloadPreviewWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpMediaDownloadPreview documents */
  set?: InputMaybe<Array<CorpMediaDownloadPreviewWhereUniqueInput>>;
  /** Update multiple CorpMediaDownloadPreview documents */
  update?: InputMaybe<Array<CorpMediaDownloadPreviewUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpMediaDownloadPreview documents */
  upsert?: InputMaybe<Array<CorpMediaDownloadPreviewUpsertWithNestedWhereUniqueInput>>;
};

export type CorpMediaDownloadPreviewUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpMediaDownloadPreviewUpdateManyLocalizationsInput>;
  /** super input for default locale (default) */
  super?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpMediaDownloadPreviewUpdateManyLocalizationDataInput = {
  super?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpMediaDownloadPreviewUpdateManyLocalizationInput = {
  data: CorpMediaDownloadPreviewUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpMediaDownloadPreviewUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpMediaDownloadPreviewUpdateManyLocalizationInput>>;
};

export type CorpMediaDownloadPreviewUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpMediaDownloadPreviewUpdateManyInput;
  /** Document search */
  where: CorpMediaDownloadPreviewWhereInput;
};

export type CorpMediaDownloadPreviewUpdateOneInlineInput = {
  /** Connect existing CorpMediaDownloadPreview document */
  connect?: InputMaybe<CorpMediaDownloadPreviewWhereUniqueInput>;
  /** Create and connect one CorpMediaDownloadPreview document */
  create?: InputMaybe<CorpMediaDownloadPreviewCreateInput>;
  /** Delete currently connected CorpMediaDownloadPreview document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpMediaDownloadPreview document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpMediaDownloadPreview document */
  update?: InputMaybe<CorpMediaDownloadPreviewUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpMediaDownloadPreview document */
  upsert?: InputMaybe<CorpMediaDownloadPreviewUpsertWithNestedWhereUniqueInput>;
};

export type CorpMediaDownloadPreviewUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpMediaDownloadPreviewUpdateInput;
  /** Unique document search */
  where: CorpMediaDownloadPreviewWhereUniqueInput;
};

export type CorpMediaDownloadPreviewUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpMediaDownloadPreviewCreateInput;
  /** Update document if it exists */
  update: CorpMediaDownloadPreviewUpdateInput;
};

export type CorpMediaDownloadPreviewUpsertLocalizationInput = {
  create: CorpMediaDownloadPreviewCreateLocalizationDataInput;
  locale: Locale;
  update: CorpMediaDownloadPreviewUpdateLocalizationDataInput;
};

export type CorpMediaDownloadPreviewUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpMediaDownloadPreviewUpsertInput;
  /** Unique document search */
  where: CorpMediaDownloadPreviewWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpMediaDownloadPreviewWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpMediaDownloadPreviewWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpMediaDownloadPreviewWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpMediaDownloadPreviewWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpMediaDownloadPreviewWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpMediaDownloadPreviewWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpMediaDownloadPreviewWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpMediaDownloadPreviewWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  super?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  super_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  super_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  super_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  super_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  super_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  super_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  super_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  super_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  super_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpMediaDownloadPreviewWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpMediaDownloadPreviewWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpMediaDownloadPreviewWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpMediaDownloadPreviewWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpMediaDownloadPreviewWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpMediaDownloadPreview record uniquely */
export type CorpMediaDownloadPreviewWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** First level entry for main navigation */
export type CorpNavigation = Entity & Node & {
  __typename?: 'CorpNavigation';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpNavigation>;
  /** List of CorpNavigation versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Link Text */
  linkText: Scalars['String']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpNavigation>;
  /** Second level navigation entries */
  navigationItems: Array<CorpNavigationNavigationItems>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** First level entry for main navigation */
export type CorpNavigationCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** First level entry for main navigation */
export type CorpNavigationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** First level entry for main navigation */
export type CorpNavigationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** First level entry for main navigation */
export type CorpNavigationHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** First level entry for main navigation */
export type CorpNavigationLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** First level entry for main navigation */
export type CorpNavigationNavigationItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** First level entry for main navigation */
export type CorpNavigationPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** First level entry for main navigation */
export type CorpNavigationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** First level entry for main navigation */
export type CorpNavigationScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** First level entry for main navigation */
export type CorpNavigationUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** First level entry for main navigation */
export type CorpNavigationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpNavigationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpNavigationWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpNavigationConnection = {
  __typename?: 'CorpNavigationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpNavigationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpNavigationCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** linkText input for default locale (default) */
  linkText: Scalars['String']['input'];
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpNavigationCreateLocalizationsInput>;
  navigationItems?: InputMaybe<CorpNavigationNavigationItemsCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpNavigationCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  linkText: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpNavigationCreateLocalizationInput = {
  /** Localization input */
  data: CorpNavigationCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpNavigationCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpNavigationCreateLocalizationInput>>;
};

export type CorpNavigationCreateManyInlineInput = {
  /** Connect multiple existing CorpNavigation documents */
  connect?: InputMaybe<Array<CorpNavigationWhereUniqueInput>>;
  /** Create and connect multiple existing CorpNavigation documents */
  create?: InputMaybe<Array<CorpNavigationCreateInput>>;
};

export type CorpNavigationCreateOneInlineInput = {
  /** Connect one existing CorpNavigation document */
  connect?: InputMaybe<CorpNavigationWhereUniqueInput>;
  /** Create and connect one CorpNavigation document */
  create?: InputMaybe<CorpNavigationCreateInput>;
};

/** An edge in a connection. */
export type CorpNavigationEdge = {
  __typename?: 'CorpNavigationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpNavigation;
};

/** Second level entry for corp navigation */
export type CorpNavigationItem = Entity & Node & {
  __typename?: 'CorpNavigationItem';
  cmsTitle?: Maybe<Scalars['String']['output']>;
  corpNavigation?: Maybe<CorpNavigation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpNavigationItem>;
  /** This is used when we want a navigation item to show up on every market except the one specified here, to avoid having to set every market in the other Market field */
  excludedMarkets: Array<Markets>;
  /** If the link should be shown as highlighted link / separator */
  highlighted?: Maybe<Scalars['Boolean']['output']>;
  /** List of CorpNavigationItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  /** Markets where the link should be displayed. Leave empty to show on all markets. */
  markets: Array<Markets>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Second level entry for corp navigation */
export type CorpNavigationItemCorpNavigationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Second level entry for corp navigation */
export type CorpNavigationItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Second level entry for corp navigation */
export type CorpNavigationItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Second level entry for corp navigation */
export type CorpNavigationItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Second level entry for corp navigation */
export type CorpNavigationItemLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Second level entry for corp navigation */
export type CorpNavigationItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Second level entry for corp navigation */
export type CorpNavigationItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Second level entry for corp navigation */
export type CorpNavigationItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpNavigationItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpNavigationItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpNavigationItemConnection = {
  __typename?: 'CorpNavigationItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpNavigationItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpNavigationItemCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  corpNavigation?: InputMaybe<CorpNavigationCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  excludedMarkets?: InputMaybe<Array<Markets>>;
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  markets?: InputMaybe<Array<Markets>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpNavigationItemCreateManyInlineInput = {
  /** Connect multiple existing CorpNavigationItem documents */
  connect?: InputMaybe<Array<CorpNavigationItemWhereUniqueInput>>;
  /** Create and connect multiple existing CorpNavigationItem documents */
  create?: InputMaybe<Array<CorpNavigationItemCreateInput>>;
};

export type CorpNavigationItemCreateOneInlineInput = {
  /** Connect one existing CorpNavigationItem document */
  connect?: InputMaybe<CorpNavigationItemWhereUniqueInput>;
  /** Create and connect one CorpNavigationItem document */
  create?: InputMaybe<CorpNavigationItemCreateInput>;
};

/** An edge in a connection. */
export type CorpNavigationItemEdge = {
  __typename?: 'CorpNavigationItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpNavigationItem;
};

/** Identifies documents */
export type CorpNavigationItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpNavigationItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpNavigationItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpNavigationItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  corpNavigation?: InputMaybe<CorpNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpNavigationItemWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpNavigationItemWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpNavigationItemWhereStageInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  excludedMarkets?: InputMaybe<Array<Markets>>;
  /** Matches if the field array contains *all* items provided to the filter */
  excludedMarkets_contains_all?: InputMaybe<Array<Markets>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  excludedMarkets_contains_none?: InputMaybe<Array<Markets>>;
  /** Matches if the field array contains at least one item provided to the filter */
  excludedMarkets_contains_some?: InputMaybe<Array<Markets>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  excludedMarkets_not?: InputMaybe<Array<Markets>>;
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  highlighted_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  markets?: InputMaybe<Array<Markets>>;
  /** Matches if the field array contains *all* items provided to the filter */
  markets_contains_all?: InputMaybe<Array<Markets>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  markets_contains_none?: InputMaybe<Array<Markets>>;
  /** Matches if the field array contains at least one item provided to the filter */
  markets_contains_some?: InputMaybe<Array<Markets>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  markets_not?: InputMaybe<Array<Markets>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpNavigationItemOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  excludedMarkets_ASC = 'excludedMarkets_ASC',
  excludedMarkets_DESC = 'excludedMarkets_DESC',
  highlighted_ASC = 'highlighted_ASC',
  highlighted_DESC = 'highlighted_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  markets_ASC = 'markets_ASC',
  markets_DESC = 'markets_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpNavigationItemUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  corpNavigation?: InputMaybe<CorpNavigationUpdateOneInlineInput>;
  excludedMarkets?: InputMaybe<Array<Markets>>;
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  markets?: InputMaybe<Array<Markets>>;
};

export type CorpNavigationItemUpdateManyInlineInput = {
  /** Connect multiple existing CorpNavigationItem documents */
  connect?: InputMaybe<Array<CorpNavigationItemConnectInput>>;
  /** Create and connect multiple CorpNavigationItem documents */
  create?: InputMaybe<Array<CorpNavigationItemCreateInput>>;
  /** Delete multiple CorpNavigationItem documents */
  delete?: InputMaybe<Array<CorpNavigationItemWhereUniqueInput>>;
  /** Disconnect multiple CorpNavigationItem documents */
  disconnect?: InputMaybe<Array<CorpNavigationItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpNavigationItem documents */
  set?: InputMaybe<Array<CorpNavigationItemWhereUniqueInput>>;
  /** Update multiple CorpNavigationItem documents */
  update?: InputMaybe<Array<CorpNavigationItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpNavigationItem documents */
  upsert?: InputMaybe<Array<CorpNavigationItemUpsertWithNestedWhereUniqueInput>>;
};

export type CorpNavigationItemUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  excludedMarkets?: InputMaybe<Array<Markets>>;
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  markets?: InputMaybe<Array<Markets>>;
};

export type CorpNavigationItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpNavigationItemUpdateManyInput;
  /** Document search */
  where: CorpNavigationItemWhereInput;
};

export type CorpNavigationItemUpdateOneInlineInput = {
  /** Connect existing CorpNavigationItem document */
  connect?: InputMaybe<CorpNavigationItemWhereUniqueInput>;
  /** Create and connect one CorpNavigationItem document */
  create?: InputMaybe<CorpNavigationItemCreateInput>;
  /** Delete currently connected CorpNavigationItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpNavigationItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpNavigationItem document */
  update?: InputMaybe<CorpNavigationItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpNavigationItem document */
  upsert?: InputMaybe<CorpNavigationItemUpsertWithNestedWhereUniqueInput>;
};

export type CorpNavigationItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpNavigationItemUpdateInput;
  /** Unique document search */
  where: CorpNavigationItemWhereUniqueInput;
};

export type CorpNavigationItemUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpNavigationItemCreateInput;
  /** Update document if it exists */
  update: CorpNavigationItemUpdateInput;
};

export type CorpNavigationItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpNavigationItemUpsertInput;
  /** Unique document search */
  where: CorpNavigationItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpNavigationItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpNavigationItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpNavigationItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpNavigationItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpNavigationItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  corpNavigation?: InputMaybe<CorpNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpNavigationItemWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpNavigationItemWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpNavigationItemWhereStageInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  excludedMarkets?: InputMaybe<Array<Markets>>;
  /** Matches if the field array contains *all* items provided to the filter */
  excludedMarkets_contains_all?: InputMaybe<Array<Markets>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  excludedMarkets_contains_none?: InputMaybe<Array<Markets>>;
  /** Matches if the field array contains at least one item provided to the filter */
  excludedMarkets_contains_some?: InputMaybe<Array<Markets>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  excludedMarkets_not?: InputMaybe<Array<Markets>>;
  highlighted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  highlighted_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  markets?: InputMaybe<Array<Markets>>;
  /** Matches if the field array contains *all* items provided to the filter */
  markets_contains_all?: InputMaybe<Array<Markets>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  markets_contains_none?: InputMaybe<Array<Markets>>;
  /** Matches if the field array contains at least one item provided to the filter */
  markets_contains_some?: InputMaybe<Array<Markets>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  markets_not?: InputMaybe<Array<Markets>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpNavigationItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpNavigationItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpNavigationItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpNavigationItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpNavigationItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpNavigationItem record uniquely */
export type CorpNavigationItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type CorpNavigationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpNavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpNavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpNavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpNavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpNavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpNavigationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  navigationItems_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  navigationItems_some?: InputMaybe<CorpNavigationNavigationItemsWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type CorpNavigationNavigationItems = CorpNavigationItem;

export type CorpNavigationNavigationItemsConnectInput = {
  CorpNavigationItem?: InputMaybe<CorpNavigationItemConnectInput>;
};

export type CorpNavigationNavigationItemsCreateInput = {
  CorpNavigationItem?: InputMaybe<CorpNavigationItemCreateInput>;
};

export type CorpNavigationNavigationItemsCreateManyInlineInput = {
  /** Connect multiple existing CorpNavigationNavigationItems documents */
  connect?: InputMaybe<Array<CorpNavigationNavigationItemsWhereUniqueInput>>;
  /** Create and connect multiple existing CorpNavigationNavigationItems documents */
  create?: InputMaybe<Array<CorpNavigationNavigationItemsCreateInput>>;
};

export type CorpNavigationNavigationItemsCreateOneInlineInput = {
  /** Connect one existing CorpNavigationNavigationItems document */
  connect?: InputMaybe<CorpNavigationNavigationItemsWhereUniqueInput>;
  /** Create and connect one CorpNavigationNavigationItems document */
  create?: InputMaybe<CorpNavigationNavigationItemsCreateInput>;
};

export type CorpNavigationNavigationItemsUpdateInput = {
  CorpNavigationItem?: InputMaybe<CorpNavigationItemUpdateInput>;
};

export type CorpNavigationNavigationItemsUpdateManyInlineInput = {
  /** Connect multiple existing CorpNavigationNavigationItems documents */
  connect?: InputMaybe<Array<CorpNavigationNavigationItemsConnectInput>>;
  /** Create and connect multiple CorpNavigationNavigationItems documents */
  create?: InputMaybe<Array<CorpNavigationNavigationItemsCreateInput>>;
  /** Delete multiple CorpNavigationNavigationItems documents */
  delete?: InputMaybe<Array<CorpNavigationNavigationItemsWhereUniqueInput>>;
  /** Disconnect multiple CorpNavigationNavigationItems documents */
  disconnect?: InputMaybe<Array<CorpNavigationNavigationItemsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpNavigationNavigationItems documents */
  set?: InputMaybe<Array<CorpNavigationNavigationItemsWhereUniqueInput>>;
  /** Update multiple CorpNavigationNavigationItems documents */
  update?: InputMaybe<Array<CorpNavigationNavigationItemsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpNavigationNavigationItems documents */
  upsert?: InputMaybe<Array<CorpNavigationNavigationItemsUpsertWithNestedWhereUniqueInput>>;
};

export type CorpNavigationNavigationItemsUpdateManyWithNestedWhereInput = {
  CorpNavigationItem?: InputMaybe<CorpNavigationItemUpdateManyWithNestedWhereInput>;
};

export type CorpNavigationNavigationItemsUpdateOneInlineInput = {
  /** Connect existing CorpNavigationNavigationItems document */
  connect?: InputMaybe<CorpNavigationNavigationItemsWhereUniqueInput>;
  /** Create and connect one CorpNavigationNavigationItems document */
  create?: InputMaybe<CorpNavigationNavigationItemsCreateInput>;
  /** Delete currently connected CorpNavigationNavigationItems document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpNavigationNavigationItems document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpNavigationNavigationItems document */
  update?: InputMaybe<CorpNavigationNavigationItemsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpNavigationNavigationItems document */
  upsert?: InputMaybe<CorpNavigationNavigationItemsUpsertWithNestedWhereUniqueInput>;
};

export type CorpNavigationNavigationItemsUpdateWithNestedWhereUniqueInput = {
  CorpNavigationItem?: InputMaybe<CorpNavigationItemUpdateWithNestedWhereUniqueInput>;
};

export type CorpNavigationNavigationItemsUpsertWithNestedWhereUniqueInput = {
  CorpNavigationItem?: InputMaybe<CorpNavigationItemUpsertWithNestedWhereUniqueInput>;
};

export type CorpNavigationNavigationItemsWhereInput = {
  CorpNavigationItem?: InputMaybe<CorpNavigationItemWhereInput>;
};

export type CorpNavigationNavigationItemsWhereUniqueInput = {
  CorpNavigationItem?: InputMaybe<CorpNavigationItemWhereUniqueInput>;
};

export enum CorpNavigationOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  linkText_ASC = 'linkText_ASC',
  linkText_DESC = 'linkText_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpNavigationUpdateInput = {
  /** linkText input for default locale (default) */
  linkText?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpNavigationUpdateLocalizationsInput>;
  navigationItems?: InputMaybe<CorpNavigationNavigationItemsUpdateManyInlineInput>;
};

export type CorpNavigationUpdateLocalizationDataInput = {
  linkText?: InputMaybe<Scalars['String']['input']>;
};

export type CorpNavigationUpdateLocalizationInput = {
  data: CorpNavigationUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpNavigationUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpNavigationCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpNavigationUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpNavigationUpsertLocalizationInput>>;
};

export type CorpNavigationUpdateManyInlineInput = {
  /** Connect multiple existing CorpNavigation documents */
  connect?: InputMaybe<Array<CorpNavigationConnectInput>>;
  /** Create and connect multiple CorpNavigation documents */
  create?: InputMaybe<Array<CorpNavigationCreateInput>>;
  /** Delete multiple CorpNavigation documents */
  delete?: InputMaybe<Array<CorpNavigationWhereUniqueInput>>;
  /** Disconnect multiple CorpNavigation documents */
  disconnect?: InputMaybe<Array<CorpNavigationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpNavigation documents */
  set?: InputMaybe<Array<CorpNavigationWhereUniqueInput>>;
  /** Update multiple CorpNavigation documents */
  update?: InputMaybe<Array<CorpNavigationUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpNavigation documents */
  upsert?: InputMaybe<Array<CorpNavigationUpsertWithNestedWhereUniqueInput>>;
};

export type CorpNavigationUpdateManyInput = {
  /** linkText input for default locale (default) */
  linkText?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpNavigationUpdateManyLocalizationsInput>;
};

export type CorpNavigationUpdateManyLocalizationDataInput = {
  linkText?: InputMaybe<Scalars['String']['input']>;
};

export type CorpNavigationUpdateManyLocalizationInput = {
  data: CorpNavigationUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpNavigationUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpNavigationUpdateManyLocalizationInput>>;
};

export type CorpNavigationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpNavigationUpdateManyInput;
  /** Document search */
  where: CorpNavigationWhereInput;
};

export type CorpNavigationUpdateOneInlineInput = {
  /** Connect existing CorpNavigation document */
  connect?: InputMaybe<CorpNavigationWhereUniqueInput>;
  /** Create and connect one CorpNavigation document */
  create?: InputMaybe<CorpNavigationCreateInput>;
  /** Delete currently connected CorpNavigation document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpNavigation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpNavigation document */
  update?: InputMaybe<CorpNavigationUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpNavigation document */
  upsert?: InputMaybe<CorpNavigationUpsertWithNestedWhereUniqueInput>;
};

export type CorpNavigationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpNavigationUpdateInput;
  /** Unique document search */
  where: CorpNavigationWhereUniqueInput;
};

export type CorpNavigationUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpNavigationCreateInput;
  /** Update document if it exists */
  update: CorpNavigationUpdateInput;
};

export type CorpNavigationUpsertLocalizationInput = {
  create: CorpNavigationCreateLocalizationDataInput;
  locale: Locale;
  update: CorpNavigationUpdateLocalizationDataInput;
};

export type CorpNavigationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpNavigationUpsertInput;
  /** Unique document search */
  where: CorpNavigationWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpNavigationWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpNavigationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpNavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpNavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpNavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpNavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpNavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpNavigationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkText_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  navigationItems_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  navigationItems_some?: InputMaybe<CorpNavigationNavigationItemsWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpNavigationWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpNavigationWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpNavigationWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpNavigationWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpNavigationWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpNavigation record uniquely */
export type CorpNavigationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CorpNotificationBanner = Entity & Node & {
  __typename?: 'CorpNotificationBanner';
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Choose the type of banner. If not available, a new value should be added to the enumeration model. */
  bannerType?: Maybe<BannerType>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<CorpNotificationBanner>;
  /** List of CorpNotificationBanner versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpNotificationBanner>;
  market: Markets;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CorpNotificationBannerCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpNotificationBannerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpNotificationBannerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpNotificationBannerHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpNotificationBannerLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpNotificationBannerLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CorpNotificationBannerPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpNotificationBannerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpNotificationBannerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpNotificationBannerUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpNotificationBannerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpNotificationBannerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpNotificationBannerWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpNotificationBannerConnection = {
  __typename?: 'CorpNotificationBannerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpNotificationBannerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpNotificationBannerCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bannerType?: InputMaybe<BannerType>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpNotificationBannerCreateLocalizationsInput>;
  market: Markets;
  /** title input for default locale (default) */
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpNotificationBannerCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpNotificationBannerCreateLocalizationInput = {
  /** Localization input */
  data: CorpNotificationBannerCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpNotificationBannerCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpNotificationBannerCreateLocalizationInput>>;
};

export type CorpNotificationBannerCreateManyInlineInput = {
  /** Connect multiple existing CorpNotificationBanner documents */
  connect?: InputMaybe<Array<CorpNotificationBannerWhereUniqueInput>>;
  /** Create and connect multiple existing CorpNotificationBanner documents */
  create?: InputMaybe<Array<CorpNotificationBannerCreateInput>>;
};

export type CorpNotificationBannerCreateOneInlineInput = {
  /** Connect one existing CorpNotificationBanner document */
  connect?: InputMaybe<CorpNotificationBannerWhereUniqueInput>;
  /** Create and connect one CorpNotificationBanner document */
  create?: InputMaybe<CorpNotificationBannerCreateInput>;
};

/** An edge in a connection. */
export type CorpNotificationBannerEdge = {
  __typename?: 'CorpNotificationBannerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpNotificationBanner;
};

/** Identifies documents */
export type CorpNotificationBannerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpNotificationBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpNotificationBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpNotificationBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  active_not?: InputMaybe<Scalars['Boolean']['input']>;
  bannerType?: InputMaybe<BannerType>;
  /** All values that are contained in given list. */
  bannerType_in?: InputMaybe<Array<InputMaybe<BannerType>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerType_not?: InputMaybe<BannerType>;
  /** All values that are not contained in given list. */
  bannerType_not_in?: InputMaybe<Array<InputMaybe<BannerType>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpNotificationBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpNotificationBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpNotificationBannerWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpNotificationBannerOrderByInput {
  active_ASC = 'active_ASC',
  active_DESC = 'active_DESC',
  bannerType_ASC = 'bannerType_ASC',
  bannerType_DESC = 'bannerType_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpNotificationBannerUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bannerType?: InputMaybe<BannerType>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpNotificationBannerUpdateLocalizationsInput>;
  market?: InputMaybe<Markets>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpNotificationBannerUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpNotificationBannerUpdateLocalizationInput = {
  data: CorpNotificationBannerUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpNotificationBannerUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpNotificationBannerCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpNotificationBannerUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpNotificationBannerUpsertLocalizationInput>>;
};

export type CorpNotificationBannerUpdateManyInlineInput = {
  /** Connect multiple existing CorpNotificationBanner documents */
  connect?: InputMaybe<Array<CorpNotificationBannerConnectInput>>;
  /** Create and connect multiple CorpNotificationBanner documents */
  create?: InputMaybe<Array<CorpNotificationBannerCreateInput>>;
  /** Delete multiple CorpNotificationBanner documents */
  delete?: InputMaybe<Array<CorpNotificationBannerWhereUniqueInput>>;
  /** Disconnect multiple CorpNotificationBanner documents */
  disconnect?: InputMaybe<Array<CorpNotificationBannerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpNotificationBanner documents */
  set?: InputMaybe<Array<CorpNotificationBannerWhereUniqueInput>>;
  /** Update multiple CorpNotificationBanner documents */
  update?: InputMaybe<Array<CorpNotificationBannerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpNotificationBanner documents */
  upsert?: InputMaybe<Array<CorpNotificationBannerUpsertWithNestedWhereUniqueInput>>;
};

export type CorpNotificationBannerUpdateManyInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bannerType?: InputMaybe<BannerType>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpNotificationBannerUpdateManyLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpNotificationBannerUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpNotificationBannerUpdateManyLocalizationInput = {
  data: CorpNotificationBannerUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpNotificationBannerUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpNotificationBannerUpdateManyLocalizationInput>>;
};

export type CorpNotificationBannerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpNotificationBannerUpdateManyInput;
  /** Document search */
  where: CorpNotificationBannerWhereInput;
};

export type CorpNotificationBannerUpdateOneInlineInput = {
  /** Connect existing CorpNotificationBanner document */
  connect?: InputMaybe<CorpNotificationBannerWhereUniqueInput>;
  /** Create and connect one CorpNotificationBanner document */
  create?: InputMaybe<CorpNotificationBannerCreateInput>;
  /** Delete currently connected CorpNotificationBanner document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpNotificationBanner document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpNotificationBanner document */
  update?: InputMaybe<CorpNotificationBannerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpNotificationBanner document */
  upsert?: InputMaybe<CorpNotificationBannerUpsertWithNestedWhereUniqueInput>;
};

export type CorpNotificationBannerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpNotificationBannerUpdateInput;
  /** Unique document search */
  where: CorpNotificationBannerWhereUniqueInput;
};

export type CorpNotificationBannerUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpNotificationBannerCreateInput;
  /** Update document if it exists */
  update: CorpNotificationBannerUpdateInput;
};

export type CorpNotificationBannerUpsertLocalizationInput = {
  create: CorpNotificationBannerCreateLocalizationDataInput;
  locale: Locale;
  update: CorpNotificationBannerUpdateLocalizationDataInput;
};

export type CorpNotificationBannerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpNotificationBannerUpsertInput;
  /** Unique document search */
  where: CorpNotificationBannerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpNotificationBannerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpNotificationBannerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpNotificationBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpNotificationBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpNotificationBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  active_not?: InputMaybe<Scalars['Boolean']['input']>;
  bannerType?: InputMaybe<BannerType>;
  /** All values that are contained in given list. */
  bannerType_in?: InputMaybe<Array<InputMaybe<BannerType>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerType_not?: InputMaybe<BannerType>;
  /** All values that are not contained in given list. */
  bannerType_not_in?: InputMaybe<Array<InputMaybe<BannerType>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CorpNotificationBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpNotificationBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpNotificationBannerWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  market?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpNotificationBannerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpNotificationBannerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpNotificationBannerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpNotificationBannerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpNotificationBannerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpNotificationBanner record uniquely */
export type CorpNotificationBannerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
};

export type CorpOurPeople = Entity & Node & {
  __typename?: 'CorpOurPeople';
  anchorNav?: Maybe<AnchorNavigation>;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  corpOurPeopleItems: Array<CorpOurPeopleItem>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpOurPeople>;
  genericPages: Array<GenericPage>;
  /** List of CorpOurPeople versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CorpOurPeopleAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpOurPeopleCorpOurPeopleItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CorpOurPeopleItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpOurPeopleItemWhereInput>;
};


export type CorpOurPeopleCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpOurPeopleDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpOurPeopleGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type CorpOurPeopleHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpOurPeoplePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpOurPeopleScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpOurPeopleUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpOurPeopleConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpOurPeopleWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpOurPeopleConnection = {
  __typename?: 'CorpOurPeopleConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpOurPeopleEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpOurPeopleCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  corpOurPeopleItems?: InputMaybe<CorpOurPeopleItemCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpOurPeopleCreateManyInlineInput = {
  /** Connect multiple existing CorpOurPeople documents */
  connect?: InputMaybe<Array<CorpOurPeopleWhereUniqueInput>>;
  /** Create and connect multiple existing CorpOurPeople documents */
  create?: InputMaybe<Array<CorpOurPeopleCreateInput>>;
};

export type CorpOurPeopleCreateOneInlineInput = {
  /** Connect one existing CorpOurPeople document */
  connect?: InputMaybe<CorpOurPeopleWhereUniqueInput>;
  /** Create and connect one CorpOurPeople document */
  create?: InputMaybe<CorpOurPeopleCreateInput>;
};

/** An edge in a connection. */
export type CorpOurPeopleEdge = {
  __typename?: 'CorpOurPeopleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpOurPeople;
};

export type CorpOurPeopleItem = Entity & Node & {
  __typename?: 'CorpOurPeopleItem';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description: Scalars['String']['output'];
  /** Get the document in other stages */
  documentInStages: Array<CorpOurPeopleItem>;
  favoriteProduct?: Maybe<Scalars['String']['output']>;
  /** List of CorpOurPeopleItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<AssetComponent>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpOurPeopleItem>;
  name: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  text?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CorpOurPeopleItemCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpOurPeopleItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpOurPeopleItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpOurPeopleItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpOurPeopleItemImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpOurPeopleItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CorpOurPeopleItemPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpOurPeopleItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpOurPeopleItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpOurPeopleItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpOurPeopleItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpOurPeopleItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpOurPeopleItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpOurPeopleItemConnection = {
  __typename?: 'CorpOurPeopleItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpOurPeopleItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpOurPeopleItemCreateInput = {
  cl1ywokge1oy301xududa2y2n?: InputMaybe<CorpOurPeopleCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description: Scalars['String']['input'];
  /** favoriteProduct input for default locale (default) */
  favoriteProduct?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetComponentCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpOurPeopleItemCreateLocalizationsInput>;
  /** name input for default locale (default) */
  name: Scalars['String']['input'];
  /** text input for default locale (default) */
  text?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpOurPeopleItemCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description: Scalars['String']['input'];
  favoriteProduct?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpOurPeopleItemCreateLocalizationInput = {
  /** Localization input */
  data: CorpOurPeopleItemCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpOurPeopleItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpOurPeopleItemCreateLocalizationInput>>;
};

export type CorpOurPeopleItemCreateManyInlineInput = {
  /** Connect multiple existing CorpOurPeopleItem documents */
  connect?: InputMaybe<Array<CorpOurPeopleItemWhereUniqueInput>>;
  /** Create and connect multiple existing CorpOurPeopleItem documents */
  create?: InputMaybe<Array<CorpOurPeopleItemCreateInput>>;
};

export type CorpOurPeopleItemCreateOneInlineInput = {
  /** Connect one existing CorpOurPeopleItem document */
  connect?: InputMaybe<CorpOurPeopleItemWhereUniqueInput>;
  /** Create and connect one CorpOurPeopleItem document */
  create?: InputMaybe<CorpOurPeopleItemCreateInput>;
};

/** An edge in a connection. */
export type CorpOurPeopleItemEdge = {
  __typename?: 'CorpOurPeopleItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpOurPeopleItem;
};

/** Identifies documents */
export type CorpOurPeopleItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpOurPeopleItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpOurPeopleItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpOurPeopleItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpOurPeopleItemWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpOurPeopleItemWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpOurPeopleItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpOurPeopleItemOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  favoriteProduct_ASC = 'favoriteProduct_ASC',
  favoriteProduct_DESC = 'favoriteProduct_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  text_ASC = 'text_ASC',
  text_DESC = 'text_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpOurPeopleItemUpdateInput = {
  cl1ywokge1oy301xududa2y2n?: InputMaybe<CorpOurPeopleUpdateManyInlineInput>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** favoriteProduct input for default locale (default) */
  favoriteProduct?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpOurPeopleItemUpdateLocalizationsInput>;
  /** name input for default locale (default) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** text input for default locale (default) */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CorpOurPeopleItemUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  favoriteProduct?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CorpOurPeopleItemUpdateLocalizationInput = {
  data: CorpOurPeopleItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpOurPeopleItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpOurPeopleItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpOurPeopleItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpOurPeopleItemUpsertLocalizationInput>>;
};

export type CorpOurPeopleItemUpdateManyInlineInput = {
  /** Connect multiple existing CorpOurPeopleItem documents */
  connect?: InputMaybe<Array<CorpOurPeopleItemConnectInput>>;
  /** Create and connect multiple CorpOurPeopleItem documents */
  create?: InputMaybe<Array<CorpOurPeopleItemCreateInput>>;
  /** Delete multiple CorpOurPeopleItem documents */
  delete?: InputMaybe<Array<CorpOurPeopleItemWhereUniqueInput>>;
  /** Disconnect multiple CorpOurPeopleItem documents */
  disconnect?: InputMaybe<Array<CorpOurPeopleItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpOurPeopleItem documents */
  set?: InputMaybe<Array<CorpOurPeopleItemWhereUniqueInput>>;
  /** Update multiple CorpOurPeopleItem documents */
  update?: InputMaybe<Array<CorpOurPeopleItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpOurPeopleItem documents */
  upsert?: InputMaybe<Array<CorpOurPeopleItemUpsertWithNestedWhereUniqueInput>>;
};

export type CorpOurPeopleItemUpdateManyInput = {
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** favoriteProduct input for default locale (default) */
  favoriteProduct?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpOurPeopleItemUpdateManyLocalizationsInput>;
  /** name input for default locale (default) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** text input for default locale (default) */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CorpOurPeopleItemUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  favoriteProduct?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type CorpOurPeopleItemUpdateManyLocalizationInput = {
  data: CorpOurPeopleItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpOurPeopleItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpOurPeopleItemUpdateManyLocalizationInput>>;
};

export type CorpOurPeopleItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpOurPeopleItemUpdateManyInput;
  /** Document search */
  where: CorpOurPeopleItemWhereInput;
};

export type CorpOurPeopleItemUpdateOneInlineInput = {
  /** Connect existing CorpOurPeopleItem document */
  connect?: InputMaybe<CorpOurPeopleItemWhereUniqueInput>;
  /** Create and connect one CorpOurPeopleItem document */
  create?: InputMaybe<CorpOurPeopleItemCreateInput>;
  /** Delete currently connected CorpOurPeopleItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpOurPeopleItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpOurPeopleItem document */
  update?: InputMaybe<CorpOurPeopleItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpOurPeopleItem document */
  upsert?: InputMaybe<CorpOurPeopleItemUpsertWithNestedWhereUniqueInput>;
};

export type CorpOurPeopleItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpOurPeopleItemUpdateInput;
  /** Unique document search */
  where: CorpOurPeopleItemWhereUniqueInput;
};

export type CorpOurPeopleItemUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpOurPeopleItemCreateInput;
  /** Update document if it exists */
  update: CorpOurPeopleItemUpdateInput;
};

export type CorpOurPeopleItemUpsertLocalizationInput = {
  create: CorpOurPeopleItemCreateLocalizationDataInput;
  locale: Locale;
  update: CorpOurPeopleItemUpdateLocalizationDataInput;
};

export type CorpOurPeopleItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpOurPeopleItemUpsertInput;
  /** Unique document search */
  where: CorpOurPeopleItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpOurPeopleItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpOurPeopleItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpOurPeopleItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpOurPeopleItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpOurPeopleItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CorpOurPeopleItemWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpOurPeopleItemWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpOurPeopleItemWhereStageInput>;
  favoriteProduct?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  favoriteProduct_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  favoriteProduct_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  favoriteProduct_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  favoriteProduct_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  favoriteProduct_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  favoriteProduct_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  favoriteProduct_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  favoriteProduct_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  favoriteProduct_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  text?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  text_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  text_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  text_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  text_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  text_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  text_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  text_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  text_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  text_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpOurPeopleItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpOurPeopleItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpOurPeopleItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpOurPeopleItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpOurPeopleItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpOurPeopleItem record uniquely */
export type CorpOurPeopleItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type CorpOurPeopleManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpOurPeopleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpOurPeopleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpOurPeopleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  corpOurPeopleItems_every?: InputMaybe<CorpOurPeopleItemWhereInput>;
  corpOurPeopleItems_none?: InputMaybe<CorpOurPeopleItemWhereInput>;
  corpOurPeopleItems_some?: InputMaybe<CorpOurPeopleItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpOurPeopleWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpOurPeopleWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpOurPeopleWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpOurPeopleOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpOurPeopleUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  corpOurPeopleItems?: InputMaybe<CorpOurPeopleItemUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
};

export type CorpOurPeopleUpdateManyInlineInput = {
  /** Connect multiple existing CorpOurPeople documents */
  connect?: InputMaybe<Array<CorpOurPeopleConnectInput>>;
  /** Create and connect multiple CorpOurPeople documents */
  create?: InputMaybe<Array<CorpOurPeopleCreateInput>>;
  /** Delete multiple CorpOurPeople documents */
  delete?: InputMaybe<Array<CorpOurPeopleWhereUniqueInput>>;
  /** Disconnect multiple CorpOurPeople documents */
  disconnect?: InputMaybe<Array<CorpOurPeopleWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpOurPeople documents */
  set?: InputMaybe<Array<CorpOurPeopleWhereUniqueInput>>;
  /** Update multiple CorpOurPeople documents */
  update?: InputMaybe<Array<CorpOurPeopleUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpOurPeople documents */
  upsert?: InputMaybe<Array<CorpOurPeopleUpsertWithNestedWhereUniqueInput>>;
};

export type CorpOurPeopleUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CorpOurPeopleUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpOurPeopleUpdateManyInput;
  /** Document search */
  where: CorpOurPeopleWhereInput;
};

export type CorpOurPeopleUpdateOneInlineInput = {
  /** Connect existing CorpOurPeople document */
  connect?: InputMaybe<CorpOurPeopleWhereUniqueInput>;
  /** Create and connect one CorpOurPeople document */
  create?: InputMaybe<CorpOurPeopleCreateInput>;
  /** Delete currently connected CorpOurPeople document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpOurPeople document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpOurPeople document */
  update?: InputMaybe<CorpOurPeopleUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpOurPeople document */
  upsert?: InputMaybe<CorpOurPeopleUpsertWithNestedWhereUniqueInput>;
};

export type CorpOurPeopleUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpOurPeopleUpdateInput;
  /** Unique document search */
  where: CorpOurPeopleWhereUniqueInput;
};

export type CorpOurPeopleUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpOurPeopleCreateInput;
  /** Update document if it exists */
  update: CorpOurPeopleUpdateInput;
};

export type CorpOurPeopleUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpOurPeopleUpsertInput;
  /** Unique document search */
  where: CorpOurPeopleWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpOurPeopleWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpOurPeopleWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpOurPeopleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpOurPeopleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpOurPeopleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  corpOurPeopleItems_every?: InputMaybe<CorpOurPeopleItemWhereInput>;
  corpOurPeopleItems_none?: InputMaybe<CorpOurPeopleItemWhereInput>;
  corpOurPeopleItems_some?: InputMaybe<CorpOurPeopleItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpOurPeopleWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpOurPeopleWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpOurPeopleWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpOurPeopleWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpOurPeopleWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpOurPeopleWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpOurPeopleWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpOurPeopleWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpOurPeople record uniquely */
export type CorpOurPeopleWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Should only have 1 item */
export type CorpPressPage = Entity & Node & {
  __typename?: 'CorpPressPage';
  /** Content Grouping option to be selected to pass through to the dataLayer value cg1 */
  contentGroupingTrackingValue?: Maybe<TrackingContentGrouping>;
  /** Content Grouping options to be selected to pass through to the dataLayer value cg2 */
  contentGroupingTrackingValues?: Maybe<TrackingContentGrouping>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpPressPage>;
  /** List of CorpPressPage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  introText: Scalars['String']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpPressPage>;
  metaData?: Maybe<MetaData>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Should only have 1 item */
export type CorpPressPageCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Should only have 1 item */
export type CorpPressPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Should only have 1 item */
export type CorpPressPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Should only have 1 item */
export type CorpPressPageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Should only have 1 item */
export type CorpPressPageLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Should only have 1 item */
export type CorpPressPageMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Should only have 1 item */
export type CorpPressPagePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Should only have 1 item */
export type CorpPressPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Should only have 1 item */
export type CorpPressPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Should only have 1 item */
export type CorpPressPageUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Should only have 1 item */
export type CorpPressPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpPressPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpPressPageWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpPressPageConnection = {
  __typename?: 'CorpPressPageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpPressPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpPressPageCreateInput = {
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** introText input for default locale (default) */
  introText: Scalars['String']['input'];
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpPressPageCreateLocalizationsInput>;
  metaData?: InputMaybe<MetaDataCreateOneInlineInput>;
  /** subtitle input for default locale (default) */
  subtitle: Scalars['String']['input'];
  /** title input for default locale (default) */
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpPressPageCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  introText: Scalars['String']['input'];
  subtitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpPressPageCreateLocalizationInput = {
  /** Localization input */
  data: CorpPressPageCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpPressPageCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpPressPageCreateLocalizationInput>>;
};

export type CorpPressPageCreateManyInlineInput = {
  /** Connect multiple existing CorpPressPage documents */
  connect?: InputMaybe<Array<CorpPressPageWhereUniqueInput>>;
  /** Create and connect multiple existing CorpPressPage documents */
  create?: InputMaybe<Array<CorpPressPageCreateInput>>;
};

export type CorpPressPageCreateOneInlineInput = {
  /** Connect one existing CorpPressPage document */
  connect?: InputMaybe<CorpPressPageWhereUniqueInput>;
  /** Create and connect one CorpPressPage document */
  create?: InputMaybe<CorpPressPageCreateInput>;
};

/** An edge in a connection. */
export type CorpPressPageEdge = {
  __typename?: 'CorpPressPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpPressPage;
};

/** Identifies documents */
export type CorpPressPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpPressPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpPressPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpPressPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValue_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValue_not?: InputMaybe<TrackingContentGrouping>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValue_not_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValues_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValues_not?: InputMaybe<TrackingContentGrouping>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValues_not_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpPressPageWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpPressPageWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpPressPageWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpPressPageOrderByInput {
  contentGroupingTrackingValue_ASC = 'contentGroupingTrackingValue_ASC',
  contentGroupingTrackingValue_DESC = 'contentGroupingTrackingValue_DESC',
  contentGroupingTrackingValues_ASC = 'contentGroupingTrackingValues_ASC',
  contentGroupingTrackingValues_DESC = 'contentGroupingTrackingValues_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  introText_ASC = 'introText_ASC',
  introText_DESC = 'introText_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subtitle_ASC = 'subtitle_ASC',
  subtitle_DESC = 'subtitle_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpPressPageUpdateInput = {
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  /** introText input for default locale (default) */
  introText?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpPressPageUpdateLocalizationsInput>;
  metaData?: InputMaybe<MetaDataUpdateOneInlineInput>;
  /** subtitle input for default locale (default) */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpPressPageUpdateLocalizationDataInput = {
  introText?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpPressPageUpdateLocalizationInput = {
  data: CorpPressPageUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpPressPageUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpPressPageCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpPressPageUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpPressPageUpsertLocalizationInput>>;
};

export type CorpPressPageUpdateManyInlineInput = {
  /** Connect multiple existing CorpPressPage documents */
  connect?: InputMaybe<Array<CorpPressPageConnectInput>>;
  /** Create and connect multiple CorpPressPage documents */
  create?: InputMaybe<Array<CorpPressPageCreateInput>>;
  /** Delete multiple CorpPressPage documents */
  delete?: InputMaybe<Array<CorpPressPageWhereUniqueInput>>;
  /** Disconnect multiple CorpPressPage documents */
  disconnect?: InputMaybe<Array<CorpPressPageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpPressPage documents */
  set?: InputMaybe<Array<CorpPressPageWhereUniqueInput>>;
  /** Update multiple CorpPressPage documents */
  update?: InputMaybe<Array<CorpPressPageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpPressPage documents */
  upsert?: InputMaybe<Array<CorpPressPageUpsertWithNestedWhereUniqueInput>>;
};

export type CorpPressPageUpdateManyInput = {
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  /** introText input for default locale (default) */
  introText?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpPressPageUpdateManyLocalizationsInput>;
  /** subtitle input for default locale (default) */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpPressPageUpdateManyLocalizationDataInput = {
  introText?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpPressPageUpdateManyLocalizationInput = {
  data: CorpPressPageUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpPressPageUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpPressPageUpdateManyLocalizationInput>>;
};

export type CorpPressPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpPressPageUpdateManyInput;
  /** Document search */
  where: CorpPressPageWhereInput;
};

export type CorpPressPageUpdateOneInlineInput = {
  /** Connect existing CorpPressPage document */
  connect?: InputMaybe<CorpPressPageWhereUniqueInput>;
  /** Create and connect one CorpPressPage document */
  create?: InputMaybe<CorpPressPageCreateInput>;
  /** Delete currently connected CorpPressPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpPressPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpPressPage document */
  update?: InputMaybe<CorpPressPageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpPressPage document */
  upsert?: InputMaybe<CorpPressPageUpsertWithNestedWhereUniqueInput>;
};

export type CorpPressPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpPressPageUpdateInput;
  /** Unique document search */
  where: CorpPressPageWhereUniqueInput;
};

export type CorpPressPageUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpPressPageCreateInput;
  /** Update document if it exists */
  update: CorpPressPageUpdateInput;
};

export type CorpPressPageUpsertLocalizationInput = {
  create: CorpPressPageCreateLocalizationDataInput;
  locale: Locale;
  update: CorpPressPageUpdateLocalizationDataInput;
};

export type CorpPressPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpPressPageUpsertInput;
  /** Unique document search */
  where: CorpPressPageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpPressPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpPressPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpPressPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpPressPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpPressPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValue_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValue_not?: InputMaybe<TrackingContentGrouping>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValue_not_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValues_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValues_not?: InputMaybe<TrackingContentGrouping>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValues_not_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpPressPageWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpPressPageWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpPressPageWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  introText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  introText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  introText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  introText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  introText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  introText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  introText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  introText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  introText_starts_with?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpPressPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpPressPageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpPressPageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpPressPageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpPressPageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpPressPage record uniquely */
export type CorpPressPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum CorpPressReleaseTopicEnum {
  brandsAndProducts = 'brandsAndProducts',
  careers = 'careers',
  corporateNews = 'corporateNews',
  history = 'history',
  other = 'other',
  socialCommitment = 'socialCommitment',
  sustainability = 'sustainability'
}

export type CorpSocialMediaFooter = Entity & Node & {
  __typename?: 'CorpSocialMediaFooter';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpSocialMediaFooter>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  /** List of CorpSocialMediaFooter versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  instagramLink?: Maybe<Scalars['String']['output']>;
  linkedinLink?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpSocialMediaFooter>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  twitterLink?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  xingLink?: Maybe<Scalars['String']['output']>;
  youtubeLink?: Maybe<Scalars['String']['output']>;
};


export type CorpSocialMediaFooterCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpSocialMediaFooterCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpSocialMediaFooterDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpSocialMediaFooterHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpSocialMediaFooterLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CorpSocialMediaFooterPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpSocialMediaFooterPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpSocialMediaFooterScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpSocialMediaFooterUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpSocialMediaFooterUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpSocialMediaFooterConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpSocialMediaFooterWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpSocialMediaFooterConnection = {
  __typename?: 'CorpSocialMediaFooterConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpSocialMediaFooterEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpSocialMediaFooterCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** facebookLink input for default locale (default) */
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  /** instagramLink input for default locale (default) */
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  /** linkedinLink input for default locale (default) */
  linkedinLink?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpSocialMediaFooterCreateLocalizationsInput>;
  /** twitterLink input for default locale (default) */
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** xingLink input for default locale (default) */
  xingLink?: InputMaybe<Scalars['String']['input']>;
  /** youtubeLink input for default locale (default) */
  youtubeLink?: InputMaybe<Scalars['String']['input']>;
};

export type CorpSocialMediaFooterCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  linkedinLink?: InputMaybe<Scalars['String']['input']>;
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  xingLink?: InputMaybe<Scalars['String']['input']>;
  youtubeLink?: InputMaybe<Scalars['String']['input']>;
};

export type CorpSocialMediaFooterCreateLocalizationInput = {
  /** Localization input */
  data: CorpSocialMediaFooterCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpSocialMediaFooterCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpSocialMediaFooterCreateLocalizationInput>>;
};

export type CorpSocialMediaFooterCreateManyInlineInput = {
  /** Connect multiple existing CorpSocialMediaFooter documents */
  connect?: InputMaybe<Array<CorpSocialMediaFooterWhereUniqueInput>>;
  /** Create and connect multiple existing CorpSocialMediaFooter documents */
  create?: InputMaybe<Array<CorpSocialMediaFooterCreateInput>>;
};

export type CorpSocialMediaFooterCreateOneInlineInput = {
  /** Connect one existing CorpSocialMediaFooter document */
  connect?: InputMaybe<CorpSocialMediaFooterWhereUniqueInput>;
  /** Create and connect one CorpSocialMediaFooter document */
  create?: InputMaybe<CorpSocialMediaFooterCreateInput>;
};

/** An edge in a connection. */
export type CorpSocialMediaFooterEdge = {
  __typename?: 'CorpSocialMediaFooterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpSocialMediaFooter;
};

/** Identifies documents */
export type CorpSocialMediaFooterManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpSocialMediaFooterWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpSocialMediaFooterWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpSocialMediaFooterWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpSocialMediaFooterWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpSocialMediaFooterWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpSocialMediaFooterWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpSocialMediaFooterOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  facebookLink_ASC = 'facebookLink_ASC',
  facebookLink_DESC = 'facebookLink_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  instagramLink_ASC = 'instagramLink_ASC',
  instagramLink_DESC = 'instagramLink_DESC',
  linkedinLink_ASC = 'linkedinLink_ASC',
  linkedinLink_DESC = 'linkedinLink_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  twitterLink_ASC = 'twitterLink_ASC',
  twitterLink_DESC = 'twitterLink_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  xingLink_ASC = 'xingLink_ASC',
  xingLink_DESC = 'xingLink_DESC',
  youtubeLink_ASC = 'youtubeLink_ASC',
  youtubeLink_DESC = 'youtubeLink_DESC'
}

export type CorpSocialMediaFooterUpdateInput = {
  /** facebookLink input for default locale (default) */
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  /** instagramLink input for default locale (default) */
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  /** linkedinLink input for default locale (default) */
  linkedinLink?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpSocialMediaFooterUpdateLocalizationsInput>;
  /** twitterLink input for default locale (default) */
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  /** xingLink input for default locale (default) */
  xingLink?: InputMaybe<Scalars['String']['input']>;
  /** youtubeLink input for default locale (default) */
  youtubeLink?: InputMaybe<Scalars['String']['input']>;
};

export type CorpSocialMediaFooterUpdateLocalizationDataInput = {
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  linkedinLink?: InputMaybe<Scalars['String']['input']>;
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  xingLink?: InputMaybe<Scalars['String']['input']>;
  youtubeLink?: InputMaybe<Scalars['String']['input']>;
};

export type CorpSocialMediaFooterUpdateLocalizationInput = {
  data: CorpSocialMediaFooterUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpSocialMediaFooterUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpSocialMediaFooterCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpSocialMediaFooterUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpSocialMediaFooterUpsertLocalizationInput>>;
};

export type CorpSocialMediaFooterUpdateManyInlineInput = {
  /** Connect multiple existing CorpSocialMediaFooter documents */
  connect?: InputMaybe<Array<CorpSocialMediaFooterConnectInput>>;
  /** Create and connect multiple CorpSocialMediaFooter documents */
  create?: InputMaybe<Array<CorpSocialMediaFooterCreateInput>>;
  /** Delete multiple CorpSocialMediaFooter documents */
  delete?: InputMaybe<Array<CorpSocialMediaFooterWhereUniqueInput>>;
  /** Disconnect multiple CorpSocialMediaFooter documents */
  disconnect?: InputMaybe<Array<CorpSocialMediaFooterWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpSocialMediaFooter documents */
  set?: InputMaybe<Array<CorpSocialMediaFooterWhereUniqueInput>>;
  /** Update multiple CorpSocialMediaFooter documents */
  update?: InputMaybe<Array<CorpSocialMediaFooterUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpSocialMediaFooter documents */
  upsert?: InputMaybe<Array<CorpSocialMediaFooterUpsertWithNestedWhereUniqueInput>>;
};

export type CorpSocialMediaFooterUpdateManyInput = {
  /** facebookLink input for default locale (default) */
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  /** instagramLink input for default locale (default) */
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  /** linkedinLink input for default locale (default) */
  linkedinLink?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpSocialMediaFooterUpdateManyLocalizationsInput>;
  /** twitterLink input for default locale (default) */
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  /** xingLink input for default locale (default) */
  xingLink?: InputMaybe<Scalars['String']['input']>;
  /** youtubeLink input for default locale (default) */
  youtubeLink?: InputMaybe<Scalars['String']['input']>;
};

export type CorpSocialMediaFooterUpdateManyLocalizationDataInput = {
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  linkedinLink?: InputMaybe<Scalars['String']['input']>;
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  xingLink?: InputMaybe<Scalars['String']['input']>;
  youtubeLink?: InputMaybe<Scalars['String']['input']>;
};

export type CorpSocialMediaFooterUpdateManyLocalizationInput = {
  data: CorpSocialMediaFooterUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpSocialMediaFooterUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpSocialMediaFooterUpdateManyLocalizationInput>>;
};

export type CorpSocialMediaFooterUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpSocialMediaFooterUpdateManyInput;
  /** Document search */
  where: CorpSocialMediaFooterWhereInput;
};

export type CorpSocialMediaFooterUpdateOneInlineInput = {
  /** Connect existing CorpSocialMediaFooter document */
  connect?: InputMaybe<CorpSocialMediaFooterWhereUniqueInput>;
  /** Create and connect one CorpSocialMediaFooter document */
  create?: InputMaybe<CorpSocialMediaFooterCreateInput>;
  /** Delete currently connected CorpSocialMediaFooter document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpSocialMediaFooter document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpSocialMediaFooter document */
  update?: InputMaybe<CorpSocialMediaFooterUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpSocialMediaFooter document */
  upsert?: InputMaybe<CorpSocialMediaFooterUpsertWithNestedWhereUniqueInput>;
};

export type CorpSocialMediaFooterUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpSocialMediaFooterUpdateInput;
  /** Unique document search */
  where: CorpSocialMediaFooterWhereUniqueInput;
};

export type CorpSocialMediaFooterUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpSocialMediaFooterCreateInput;
  /** Update document if it exists */
  update: CorpSocialMediaFooterUpdateInput;
};

export type CorpSocialMediaFooterUpsertLocalizationInput = {
  create: CorpSocialMediaFooterCreateLocalizationDataInput;
  locale: Locale;
  update: CorpSocialMediaFooterUpdateLocalizationDataInput;
};

export type CorpSocialMediaFooterUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpSocialMediaFooterUpsertInput;
  /** Unique document search */
  where: CorpSocialMediaFooterWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpSocialMediaFooterWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpSocialMediaFooterWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpSocialMediaFooterWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpSocialMediaFooterWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpSocialMediaFooterWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpSocialMediaFooterWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpSocialMediaFooterWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpSocialMediaFooterWhereStageInput>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  facebookLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  facebookLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  facebookLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  facebookLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  facebookLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  facebookLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  facebookLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  facebookLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  facebookLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  instagramLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  instagramLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  instagramLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  instagramLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  instagramLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  instagramLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  instagramLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  instagramLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  instagramLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  linkedinLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  linkedinLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  linkedinLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  linkedinLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  linkedinLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  linkedinLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  linkedinLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  linkedinLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  linkedinLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  linkedinLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  twitterLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  twitterLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  twitterLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  twitterLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  twitterLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  twitterLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  twitterLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  twitterLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  twitterLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  xingLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  xingLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  xingLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  xingLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  xingLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  xingLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  xingLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  xingLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  xingLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  xingLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  youtubeLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  youtubeLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  youtubeLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  youtubeLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  youtubeLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  youtubeLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  youtubeLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  youtubeLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  youtubeLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  youtubeLink_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpSocialMediaFooterWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpSocialMediaFooterWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpSocialMediaFooterWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpSocialMediaFooterWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpSocialMediaFooterWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpSocialMediaFooter record uniquely */
export type CorpSocialMediaFooterWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Should only have 1 item */
export type CorpStoriesPage = Entity & Node & {
  __typename?: 'CorpStoriesPage';
  cmsTitle: Scalars['String']['output'];
  /** Content Grouping option to be selected to pass through to the dataLayer value cg1 */
  contentGroupingTrackingValue?: Maybe<TrackingContentGrouping>;
  /** Content Grouping options to be selected to pass through to the dataLayer value cg2 */
  contentGroupingTrackingValues?: Maybe<TrackingContentGrouping>;
  corpHero?: Maybe<CorpHero>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpStoriesPage>;
  genericFollowUs?: Maybe<GenericFollowUs>;
  /** List of CorpStoriesPage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  introText?: Maybe<IntroText>;
  metaData?: Maybe<MetaData>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Should only have 1 item */
export type CorpStoriesPageCorpHeroArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Should only have 1 item */
export type CorpStoriesPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Should only have 1 item */
export type CorpStoriesPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Should only have 1 item */
export type CorpStoriesPageGenericFollowUsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Should only have 1 item */
export type CorpStoriesPageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Should only have 1 item */
export type CorpStoriesPageIntroTextArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Should only have 1 item */
export type CorpStoriesPageMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Should only have 1 item */
export type CorpStoriesPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Should only have 1 item */
export type CorpStoriesPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Should only have 1 item */
export type CorpStoriesPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpStoriesPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpStoriesPageWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpStoriesPageConnection = {
  __typename?: 'CorpStoriesPageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpStoriesPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpStoriesPageCreateInput = {
  cmsTitle: Scalars['String']['input'];
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  corpHero?: InputMaybe<CorpHeroCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericFollowUs?: InputMaybe<GenericFollowUsCreateOneInlineInput>;
  introText?: InputMaybe<IntroTextCreateOneInlineInput>;
  metaData?: InputMaybe<MetaDataCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpStoriesPageCreateManyInlineInput = {
  /** Connect multiple existing CorpStoriesPage documents */
  connect?: InputMaybe<Array<CorpStoriesPageWhereUniqueInput>>;
  /** Create and connect multiple existing CorpStoriesPage documents */
  create?: InputMaybe<Array<CorpStoriesPageCreateInput>>;
};

export type CorpStoriesPageCreateOneInlineInput = {
  /** Connect one existing CorpStoriesPage document */
  connect?: InputMaybe<CorpStoriesPageWhereUniqueInput>;
  /** Create and connect one CorpStoriesPage document */
  create?: InputMaybe<CorpStoriesPageCreateInput>;
};

/** An edge in a connection. */
export type CorpStoriesPageEdge = {
  __typename?: 'CorpStoriesPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpStoriesPage;
};

/** Identifies documents */
export type CorpStoriesPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpStoriesPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpStoriesPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpStoriesPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValue_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValue_not?: InputMaybe<TrackingContentGrouping>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValue_not_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValues_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValues_not?: InputMaybe<TrackingContentGrouping>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValues_not_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  corpHero?: InputMaybe<CorpHeroWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpStoriesPageWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpStoriesPageWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpStoriesPageWhereStageInput>;
  genericFollowUs?: InputMaybe<GenericFollowUsWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introText?: InputMaybe<IntroTextWhereInput>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpStoriesPageOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  contentGroupingTrackingValue_ASC = 'contentGroupingTrackingValue_ASC',
  contentGroupingTrackingValue_DESC = 'contentGroupingTrackingValue_DESC',
  contentGroupingTrackingValues_ASC = 'contentGroupingTrackingValues_ASC',
  contentGroupingTrackingValues_DESC = 'contentGroupingTrackingValues_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpStoriesPageUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  corpHero?: InputMaybe<CorpHeroUpdateOneInlineInput>;
  genericFollowUs?: InputMaybe<GenericFollowUsUpdateOneInlineInput>;
  introText?: InputMaybe<IntroTextUpdateOneInlineInput>;
  metaData?: InputMaybe<MetaDataUpdateOneInlineInput>;
};

export type CorpStoriesPageUpdateManyInlineInput = {
  /** Connect multiple existing CorpStoriesPage documents */
  connect?: InputMaybe<Array<CorpStoriesPageConnectInput>>;
  /** Create and connect multiple CorpStoriesPage documents */
  create?: InputMaybe<Array<CorpStoriesPageCreateInput>>;
  /** Delete multiple CorpStoriesPage documents */
  delete?: InputMaybe<Array<CorpStoriesPageWhereUniqueInput>>;
  /** Disconnect multiple CorpStoriesPage documents */
  disconnect?: InputMaybe<Array<CorpStoriesPageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpStoriesPage documents */
  set?: InputMaybe<Array<CorpStoriesPageWhereUniqueInput>>;
  /** Update multiple CorpStoriesPage documents */
  update?: InputMaybe<Array<CorpStoriesPageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpStoriesPage documents */
  upsert?: InputMaybe<Array<CorpStoriesPageUpsertWithNestedWhereUniqueInput>>;
};

export type CorpStoriesPageUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
};

export type CorpStoriesPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpStoriesPageUpdateManyInput;
  /** Document search */
  where: CorpStoriesPageWhereInput;
};

export type CorpStoriesPageUpdateOneInlineInput = {
  /** Connect existing CorpStoriesPage document */
  connect?: InputMaybe<CorpStoriesPageWhereUniqueInput>;
  /** Create and connect one CorpStoriesPage document */
  create?: InputMaybe<CorpStoriesPageCreateInput>;
  /** Delete currently connected CorpStoriesPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpStoriesPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpStoriesPage document */
  update?: InputMaybe<CorpStoriesPageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpStoriesPage document */
  upsert?: InputMaybe<CorpStoriesPageUpsertWithNestedWhereUniqueInput>;
};

export type CorpStoriesPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpStoriesPageUpdateInput;
  /** Unique document search */
  where: CorpStoriesPageWhereUniqueInput;
};

export type CorpStoriesPageUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpStoriesPageCreateInput;
  /** Update document if it exists */
  update: CorpStoriesPageUpdateInput;
};

export type CorpStoriesPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpStoriesPageUpsertInput;
  /** Unique document search */
  where: CorpStoriesPageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpStoriesPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpStoriesPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpStoriesPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpStoriesPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpStoriesPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValue_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValue_not?: InputMaybe<TrackingContentGrouping>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValue_not_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValues_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValues_not?: InputMaybe<TrackingContentGrouping>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValues_not_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  corpHero?: InputMaybe<CorpHeroWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpStoriesPageWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpStoriesPageWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpStoriesPageWhereStageInput>;
  genericFollowUs?: InputMaybe<GenericFollowUsWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introText?: InputMaybe<IntroTextWhereInput>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpStoriesPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpStoriesPageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpStoriesPageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpStoriesPageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpStoriesPageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpStoriesPage record uniquely */
export type CorpStoriesPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CorpStoryCarousel = Entity & Node & {
  __typename?: 'CorpStoryCarousel';
  corpStory: Array<Story>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpStoryCarousel>;
  /** List of CorpStoryCarousel versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpStoryCarousel>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CorpStoryCarouselCorpStoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<StoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


export type CorpStoryCarouselCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpStoryCarouselCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpStoryCarouselDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpStoryCarouselHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpStoryCarouselLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CorpStoryCarouselPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpStoryCarouselPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpStoryCarouselScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpStoryCarouselUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpStoryCarouselUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpStoryCarouselConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpStoryCarouselWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpStoryCarouselConnection = {
  __typename?: 'CorpStoryCarouselConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpStoryCarouselEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpStoryCarouselCreateInput = {
  corpStory?: InputMaybe<StoryCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpStoryCarouselCreateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpStoryCarouselCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpStoryCarouselCreateLocalizationInput = {
  /** Localization input */
  data: CorpStoryCarouselCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpStoryCarouselCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpStoryCarouselCreateLocalizationInput>>;
};

export type CorpStoryCarouselCreateManyInlineInput = {
  /** Connect multiple existing CorpStoryCarousel documents */
  connect?: InputMaybe<Array<CorpStoryCarouselWhereUniqueInput>>;
  /** Create and connect multiple existing CorpStoryCarousel documents */
  create?: InputMaybe<Array<CorpStoryCarouselCreateInput>>;
};

export type CorpStoryCarouselCreateOneInlineInput = {
  /** Connect one existing CorpStoryCarousel document */
  connect?: InputMaybe<CorpStoryCarouselWhereUniqueInput>;
  /** Create and connect one CorpStoryCarousel document */
  create?: InputMaybe<CorpStoryCarouselCreateInput>;
};

/** An edge in a connection. */
export type CorpStoryCarouselEdge = {
  __typename?: 'CorpStoryCarouselEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpStoryCarousel;
};

/** Identifies documents */
export type CorpStoryCarouselManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpStoryCarouselWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpStoryCarouselWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpStoryCarouselWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  corpStory_every?: InputMaybe<StoryWhereInput>;
  corpStory_none?: InputMaybe<StoryWhereInput>;
  corpStory_some?: InputMaybe<StoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpStoryCarouselWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpStoryCarouselWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpStoryCarouselWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpStoryCarouselOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpStoryCarouselUpdateInput = {
  corpStory?: InputMaybe<StoryUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpStoryCarouselUpdateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpStoryCarouselUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpStoryCarouselUpdateLocalizationInput = {
  data: CorpStoryCarouselUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpStoryCarouselUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpStoryCarouselCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpStoryCarouselUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpStoryCarouselUpsertLocalizationInput>>;
};

export type CorpStoryCarouselUpdateManyInlineInput = {
  /** Connect multiple existing CorpStoryCarousel documents */
  connect?: InputMaybe<Array<CorpStoryCarouselConnectInput>>;
  /** Create and connect multiple CorpStoryCarousel documents */
  create?: InputMaybe<Array<CorpStoryCarouselCreateInput>>;
  /** Delete multiple CorpStoryCarousel documents */
  delete?: InputMaybe<Array<CorpStoryCarouselWhereUniqueInput>>;
  /** Disconnect multiple CorpStoryCarousel documents */
  disconnect?: InputMaybe<Array<CorpStoryCarouselWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpStoryCarousel documents */
  set?: InputMaybe<Array<CorpStoryCarouselWhereUniqueInput>>;
  /** Update multiple CorpStoryCarousel documents */
  update?: InputMaybe<Array<CorpStoryCarouselUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpStoryCarousel documents */
  upsert?: InputMaybe<Array<CorpStoryCarouselUpsertWithNestedWhereUniqueInput>>;
};

export type CorpStoryCarouselUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpStoryCarouselUpdateManyLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpStoryCarouselUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpStoryCarouselUpdateManyLocalizationInput = {
  data: CorpStoryCarouselUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpStoryCarouselUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpStoryCarouselUpdateManyLocalizationInput>>;
};

export type CorpStoryCarouselUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpStoryCarouselUpdateManyInput;
  /** Document search */
  where: CorpStoryCarouselWhereInput;
};

export type CorpStoryCarouselUpdateOneInlineInput = {
  /** Connect existing CorpStoryCarousel document */
  connect?: InputMaybe<CorpStoryCarouselWhereUniqueInput>;
  /** Create and connect one CorpStoryCarousel document */
  create?: InputMaybe<CorpStoryCarouselCreateInput>;
  /** Delete currently connected CorpStoryCarousel document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpStoryCarousel document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpStoryCarousel document */
  update?: InputMaybe<CorpStoryCarouselUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpStoryCarousel document */
  upsert?: InputMaybe<CorpStoryCarouselUpsertWithNestedWhereUniqueInput>;
};

export type CorpStoryCarouselUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpStoryCarouselUpdateInput;
  /** Unique document search */
  where: CorpStoryCarouselWhereUniqueInput;
};

export type CorpStoryCarouselUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpStoryCarouselCreateInput;
  /** Update document if it exists */
  update: CorpStoryCarouselUpdateInput;
};

export type CorpStoryCarouselUpsertLocalizationInput = {
  create: CorpStoryCarouselCreateLocalizationDataInput;
  locale: Locale;
  update: CorpStoryCarouselUpdateLocalizationDataInput;
};

export type CorpStoryCarouselUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpStoryCarouselUpsertInput;
  /** Unique document search */
  where: CorpStoryCarouselWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpStoryCarouselWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpStoryCarouselWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpStoryCarouselWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpStoryCarouselWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpStoryCarouselWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  corpStory_every?: InputMaybe<StoryWhereInput>;
  corpStory_none?: InputMaybe<StoryWhereInput>;
  corpStory_some?: InputMaybe<StoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpStoryCarouselWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpStoryCarouselWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpStoryCarouselWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpStoryCarouselWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpStoryCarouselWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpStoryCarouselWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpStoryCarouselWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpStoryCarouselWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpStoryCarousel record uniquely */
export type CorpStoryCarouselWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Type of a Story */
export enum CorpStoryTagEnum {
  behindScenes = 'behindScenes',
  companyAndCulture = 'companyAndCulture',
  digitalization = 'digitalization',
  history = 'history',
  productsAndServices = 'productsAndServices',
  socialCommitment = 'socialCommitment',
  sustainability = 'sustainability',
  sustainabilityCompany = 'sustainabilityCompany',
  sustainabilityFood = 'sustainabilityFood',
  sustainabilityWorld = 'sustainabilityWorld'
}

export type CorpTimelineAccordion = Entity & Node & {
  __typename?: 'CorpTimelineAccordion';
  cmsTitle: Scalars['String']['output'];
  corpTimelineAccordionItems: Array<CorpTimelineAccordionItem>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  daterange?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<CorpTimelineAccordion>;
  /** List of CorpTimelineAccordion versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpTimelineAccordion>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CorpTimelineAccordionCorpTimelineAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CorpTimelineAccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpTimelineAccordionItemWhereInput>;
};


export type CorpTimelineAccordionCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpTimelineAccordionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpTimelineAccordionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpTimelineAccordionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpTimelineAccordionLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CorpTimelineAccordionPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpTimelineAccordionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpTimelineAccordionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpTimelineAccordionUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpTimelineAccordionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpTimelineAccordionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpTimelineAccordionWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpTimelineAccordionConnection = {
  __typename?: 'CorpTimelineAccordionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpTimelineAccordionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpTimelineAccordionCreateInput = {
  cl1c5cbx42uwn01z3da0y3ev2?: InputMaybe<CorpTimelineAccordionWrapperCreateManyInlineInput>;
  cmsTitle: Scalars['String']['input'];
  corpTimelineAccordionItems?: InputMaybe<CorpTimelineAccordionItemCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** daterange input for default locale (default) */
  daterange?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpTimelineAccordionCreateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpTimelineAccordionCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  daterange?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpTimelineAccordionCreateLocalizationInput = {
  /** Localization input */
  data: CorpTimelineAccordionCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpTimelineAccordionCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpTimelineAccordionCreateLocalizationInput>>;
};

export type CorpTimelineAccordionCreateManyInlineInput = {
  /** Connect multiple existing CorpTimelineAccordion documents */
  connect?: InputMaybe<Array<CorpTimelineAccordionWhereUniqueInput>>;
  /** Create and connect multiple existing CorpTimelineAccordion documents */
  create?: InputMaybe<Array<CorpTimelineAccordionCreateInput>>;
};

export type CorpTimelineAccordionCreateOneInlineInput = {
  /** Connect one existing CorpTimelineAccordion document */
  connect?: InputMaybe<CorpTimelineAccordionWhereUniqueInput>;
  /** Create and connect one CorpTimelineAccordion document */
  create?: InputMaybe<CorpTimelineAccordionCreateInput>;
};

/** An edge in a connection. */
export type CorpTimelineAccordionEdge = {
  __typename?: 'CorpTimelineAccordionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpTimelineAccordion;
};

export type CorpTimelineAccordionItem = Entity & Node & {
  __typename?: 'CorpTimelineAccordionItem';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  date?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<CorpTimelineAccordionItem>;
  /** List of CorpTimelineAccordionItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<AssetComponent>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpTimelineAccordionItem>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  text?: Maybe<CorpTimelineAccordionItemTextRichText>;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CorpTimelineAccordionItemCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpTimelineAccordionItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpTimelineAccordionItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpTimelineAccordionItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpTimelineAccordionItemImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpTimelineAccordionItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CorpTimelineAccordionItemPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpTimelineAccordionItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpTimelineAccordionItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpTimelineAccordionItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpTimelineAccordionItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpTimelineAccordionItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpTimelineAccordionItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpTimelineAccordionItemConnection = {
  __typename?: 'CorpTimelineAccordionItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpTimelineAccordionItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpTimelineAccordionItemCreateInput = {
  cl19ekj1ok0ip01z1ht9ce2da?: InputMaybe<CorpTimelineAccordionCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** date input for default locale (default) */
  date?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetComponentCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpTimelineAccordionItemCreateLocalizationsInput>;
  /** text input for default locale (default) */
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** title input for default locale (default) */
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpTimelineAccordionItemCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpTimelineAccordionItemCreateLocalizationInput = {
  /** Localization input */
  data: CorpTimelineAccordionItemCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpTimelineAccordionItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpTimelineAccordionItemCreateLocalizationInput>>;
};

export type CorpTimelineAccordionItemCreateManyInlineInput = {
  /** Connect multiple existing CorpTimelineAccordionItem documents */
  connect?: InputMaybe<Array<CorpTimelineAccordionItemWhereUniqueInput>>;
  /** Create and connect multiple existing CorpTimelineAccordionItem documents */
  create?: InputMaybe<Array<CorpTimelineAccordionItemCreateInput>>;
};

export type CorpTimelineAccordionItemCreateOneInlineInput = {
  /** Connect one existing CorpTimelineAccordionItem document */
  connect?: InputMaybe<CorpTimelineAccordionItemWhereUniqueInput>;
  /** Create and connect one CorpTimelineAccordionItem document */
  create?: InputMaybe<CorpTimelineAccordionItemCreateInput>;
};

/** An edge in a connection. */
export type CorpTimelineAccordionItemEdge = {
  __typename?: 'CorpTimelineAccordionItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpTimelineAccordionItem;
};

/** Identifies documents */
export type CorpTimelineAccordionItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpTimelineAccordionItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpTimelineAccordionItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpTimelineAccordionItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpTimelineAccordionItemWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpTimelineAccordionItemWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpTimelineAccordionItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpTimelineAccordionItemOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  date_ASC = 'date_ASC',
  date_DESC = 'date_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpTimelineAccordionItemTextRichText = {
  __typename?: 'CorpTimelineAccordionItemTextRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<CorpTimelineAccordionItemTextRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type CorpTimelineAccordionItemTextRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type CorpTimelineAccordionItemTextRichTextEmbeddedTypes = Asset;

export type CorpTimelineAccordionItemUpdateInput = {
  cl19ekj1ok0ip01z1ht9ce2da?: InputMaybe<CorpTimelineAccordionUpdateManyInlineInput>;
  /** date input for default locale (default) */
  date?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpTimelineAccordionItemUpdateLocalizationsInput>;
  /** text input for default locale (default) */
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpTimelineAccordionItemUpdateLocalizationDataInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpTimelineAccordionItemUpdateLocalizationInput = {
  data: CorpTimelineAccordionItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpTimelineAccordionItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpTimelineAccordionItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpTimelineAccordionItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpTimelineAccordionItemUpsertLocalizationInput>>;
};

export type CorpTimelineAccordionItemUpdateManyInlineInput = {
  /** Connect multiple existing CorpTimelineAccordionItem documents */
  connect?: InputMaybe<Array<CorpTimelineAccordionItemConnectInput>>;
  /** Create and connect multiple CorpTimelineAccordionItem documents */
  create?: InputMaybe<Array<CorpTimelineAccordionItemCreateInput>>;
  /** Delete multiple CorpTimelineAccordionItem documents */
  delete?: InputMaybe<Array<CorpTimelineAccordionItemWhereUniqueInput>>;
  /** Disconnect multiple CorpTimelineAccordionItem documents */
  disconnect?: InputMaybe<Array<CorpTimelineAccordionItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpTimelineAccordionItem documents */
  set?: InputMaybe<Array<CorpTimelineAccordionItemWhereUniqueInput>>;
  /** Update multiple CorpTimelineAccordionItem documents */
  update?: InputMaybe<Array<CorpTimelineAccordionItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpTimelineAccordionItem documents */
  upsert?: InputMaybe<Array<CorpTimelineAccordionItemUpsertWithNestedWhereUniqueInput>>;
};

export type CorpTimelineAccordionItemUpdateManyInput = {
  /** date input for default locale (default) */
  date?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpTimelineAccordionItemUpdateManyLocalizationsInput>;
  /** text input for default locale (default) */
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpTimelineAccordionItemUpdateManyLocalizationDataInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpTimelineAccordionItemUpdateManyLocalizationInput = {
  data: CorpTimelineAccordionItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpTimelineAccordionItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpTimelineAccordionItemUpdateManyLocalizationInput>>;
};

export type CorpTimelineAccordionItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpTimelineAccordionItemUpdateManyInput;
  /** Document search */
  where: CorpTimelineAccordionItemWhereInput;
};

export type CorpTimelineAccordionItemUpdateOneInlineInput = {
  /** Connect existing CorpTimelineAccordionItem document */
  connect?: InputMaybe<CorpTimelineAccordionItemWhereUniqueInput>;
  /** Create and connect one CorpTimelineAccordionItem document */
  create?: InputMaybe<CorpTimelineAccordionItemCreateInput>;
  /** Delete currently connected CorpTimelineAccordionItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpTimelineAccordionItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpTimelineAccordionItem document */
  update?: InputMaybe<CorpTimelineAccordionItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpTimelineAccordionItem document */
  upsert?: InputMaybe<CorpTimelineAccordionItemUpsertWithNestedWhereUniqueInput>;
};

export type CorpTimelineAccordionItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpTimelineAccordionItemUpdateInput;
  /** Unique document search */
  where: CorpTimelineAccordionItemWhereUniqueInput;
};

export type CorpTimelineAccordionItemUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpTimelineAccordionItemCreateInput;
  /** Update document if it exists */
  update: CorpTimelineAccordionItemUpdateInput;
};

export type CorpTimelineAccordionItemUpsertLocalizationInput = {
  create: CorpTimelineAccordionItemCreateLocalizationDataInput;
  locale: Locale;
  update: CorpTimelineAccordionItemUpdateLocalizationDataInput;
};

export type CorpTimelineAccordionItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpTimelineAccordionItemUpsertInput;
  /** Unique document search */
  where: CorpTimelineAccordionItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpTimelineAccordionItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpTimelineAccordionItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpTimelineAccordionItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpTimelineAccordionItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpTimelineAccordionItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  date?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  date_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  date_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  date_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  date_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  date_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  date_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  date_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  date_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CorpTimelineAccordionItemWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpTimelineAccordionItemWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpTimelineAccordionItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpTimelineAccordionItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpTimelineAccordionItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpTimelineAccordionItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpTimelineAccordionItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpTimelineAccordionItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpTimelineAccordionItem record uniquely */
export type CorpTimelineAccordionItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type CorpTimelineAccordionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpTimelineAccordionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpTimelineAccordionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpTimelineAccordionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  corpTimelineAccordionItems_every?: InputMaybe<CorpTimelineAccordionItemWhereInput>;
  corpTimelineAccordionItems_none?: InputMaybe<CorpTimelineAccordionItemWhereInput>;
  corpTimelineAccordionItems_some?: InputMaybe<CorpTimelineAccordionItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpTimelineAccordionWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpTimelineAccordionWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpTimelineAccordionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpTimelineAccordionOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  daterange_ASC = 'daterange_ASC',
  daterange_DESC = 'daterange_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpTimelineAccordionUpdateInput = {
  cl1c5cbx42uwn01z3da0y3ev2?: InputMaybe<CorpTimelineAccordionWrapperUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  corpTimelineAccordionItems?: InputMaybe<CorpTimelineAccordionItemUpdateManyInlineInput>;
  /** daterange input for default locale (default) */
  daterange?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpTimelineAccordionUpdateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpTimelineAccordionUpdateLocalizationDataInput = {
  daterange?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpTimelineAccordionUpdateLocalizationInput = {
  data: CorpTimelineAccordionUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpTimelineAccordionUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpTimelineAccordionCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpTimelineAccordionUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpTimelineAccordionUpsertLocalizationInput>>;
};

export type CorpTimelineAccordionUpdateManyInlineInput = {
  /** Connect multiple existing CorpTimelineAccordion documents */
  connect?: InputMaybe<Array<CorpTimelineAccordionConnectInput>>;
  /** Create and connect multiple CorpTimelineAccordion documents */
  create?: InputMaybe<Array<CorpTimelineAccordionCreateInput>>;
  /** Delete multiple CorpTimelineAccordion documents */
  delete?: InputMaybe<Array<CorpTimelineAccordionWhereUniqueInput>>;
  /** Disconnect multiple CorpTimelineAccordion documents */
  disconnect?: InputMaybe<Array<CorpTimelineAccordionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpTimelineAccordion documents */
  set?: InputMaybe<Array<CorpTimelineAccordionWhereUniqueInput>>;
  /** Update multiple CorpTimelineAccordion documents */
  update?: InputMaybe<Array<CorpTimelineAccordionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpTimelineAccordion documents */
  upsert?: InputMaybe<Array<CorpTimelineAccordionUpsertWithNestedWhereUniqueInput>>;
};

export type CorpTimelineAccordionUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** daterange input for default locale (default) */
  daterange?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpTimelineAccordionUpdateManyLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpTimelineAccordionUpdateManyLocalizationDataInput = {
  daterange?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpTimelineAccordionUpdateManyLocalizationInput = {
  data: CorpTimelineAccordionUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpTimelineAccordionUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpTimelineAccordionUpdateManyLocalizationInput>>;
};

export type CorpTimelineAccordionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpTimelineAccordionUpdateManyInput;
  /** Document search */
  where: CorpTimelineAccordionWhereInput;
};

export type CorpTimelineAccordionUpdateOneInlineInput = {
  /** Connect existing CorpTimelineAccordion document */
  connect?: InputMaybe<CorpTimelineAccordionWhereUniqueInput>;
  /** Create and connect one CorpTimelineAccordion document */
  create?: InputMaybe<CorpTimelineAccordionCreateInput>;
  /** Delete currently connected CorpTimelineAccordion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpTimelineAccordion document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpTimelineAccordion document */
  update?: InputMaybe<CorpTimelineAccordionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpTimelineAccordion document */
  upsert?: InputMaybe<CorpTimelineAccordionUpsertWithNestedWhereUniqueInput>;
};

export type CorpTimelineAccordionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpTimelineAccordionUpdateInput;
  /** Unique document search */
  where: CorpTimelineAccordionWhereUniqueInput;
};

export type CorpTimelineAccordionUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpTimelineAccordionCreateInput;
  /** Update document if it exists */
  update: CorpTimelineAccordionUpdateInput;
};

export type CorpTimelineAccordionUpsertLocalizationInput = {
  create: CorpTimelineAccordionCreateLocalizationDataInput;
  locale: Locale;
  update: CorpTimelineAccordionUpdateLocalizationDataInput;
};

export type CorpTimelineAccordionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpTimelineAccordionUpsertInput;
  /** Unique document search */
  where: CorpTimelineAccordionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpTimelineAccordionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpTimelineAccordionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpTimelineAccordionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpTimelineAccordionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpTimelineAccordionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  corpTimelineAccordionItems_every?: InputMaybe<CorpTimelineAccordionItemWhereInput>;
  corpTimelineAccordionItems_none?: InputMaybe<CorpTimelineAccordionItemWhereInput>;
  corpTimelineAccordionItems_some?: InputMaybe<CorpTimelineAccordionItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  daterange?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  daterange_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  daterange_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  daterange_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  daterange_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  daterange_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  daterange_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  daterange_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  daterange_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  daterange_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CorpTimelineAccordionWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpTimelineAccordionWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpTimelineAccordionWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpTimelineAccordionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpTimelineAccordionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpTimelineAccordionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpTimelineAccordionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpTimelineAccordionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpTimelineAccordion record uniquely */
export type CorpTimelineAccordionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Wrapper containing multiple Timeline Accordions. */
export type CorpTimelineAccordionWrapper = Entity & Node & {
  __typename?: 'CorpTimelineAccordionWrapper';
  anchorNav?: Maybe<AnchorNavigation>;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  corpTimelineAccordions: Array<CorpTimelineAccordion>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpTimelineAccordionWrapper>;
  genericPages: Array<GenericPage>;
  /** List of CorpTimelineAccordionWrapper versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Wrapper containing multiple Timeline Accordions. */
export type CorpTimelineAccordionWrapperAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Wrapper containing multiple Timeline Accordions. */
export type CorpTimelineAccordionWrapperCorpTimelineAccordionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CorpTimelineAccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpTimelineAccordionWhereInput>;
};


/** Wrapper containing multiple Timeline Accordions. */
export type CorpTimelineAccordionWrapperCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Wrapper containing multiple Timeline Accordions. */
export type CorpTimelineAccordionWrapperDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Wrapper containing multiple Timeline Accordions. */
export type CorpTimelineAccordionWrapperGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Wrapper containing multiple Timeline Accordions. */
export type CorpTimelineAccordionWrapperHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Wrapper containing multiple Timeline Accordions. */
export type CorpTimelineAccordionWrapperPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Wrapper containing multiple Timeline Accordions. */
export type CorpTimelineAccordionWrapperScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Wrapper containing multiple Timeline Accordions. */
export type CorpTimelineAccordionWrapperUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpTimelineAccordionWrapperConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpTimelineAccordionWrapperWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpTimelineAccordionWrapperConnection = {
  __typename?: 'CorpTimelineAccordionWrapperConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpTimelineAccordionWrapperEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpTimelineAccordionWrapperCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  corpTimelineAccordions?: InputMaybe<CorpTimelineAccordionCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpTimelineAccordionWrapperCreateManyInlineInput = {
  /** Connect multiple existing CorpTimelineAccordionWrapper documents */
  connect?: InputMaybe<Array<CorpTimelineAccordionWrapperWhereUniqueInput>>;
  /** Create and connect multiple existing CorpTimelineAccordionWrapper documents */
  create?: InputMaybe<Array<CorpTimelineAccordionWrapperCreateInput>>;
};

export type CorpTimelineAccordionWrapperCreateOneInlineInput = {
  /** Connect one existing CorpTimelineAccordionWrapper document */
  connect?: InputMaybe<CorpTimelineAccordionWrapperWhereUniqueInput>;
  /** Create and connect one CorpTimelineAccordionWrapper document */
  create?: InputMaybe<CorpTimelineAccordionWrapperCreateInput>;
};

/** An edge in a connection. */
export type CorpTimelineAccordionWrapperEdge = {
  __typename?: 'CorpTimelineAccordionWrapperEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpTimelineAccordionWrapper;
};

/** Identifies documents */
export type CorpTimelineAccordionWrapperManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpTimelineAccordionWrapperWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpTimelineAccordionWrapperWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpTimelineAccordionWrapperWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  corpTimelineAccordions_every?: InputMaybe<CorpTimelineAccordionWhereInput>;
  corpTimelineAccordions_none?: InputMaybe<CorpTimelineAccordionWhereInput>;
  corpTimelineAccordions_some?: InputMaybe<CorpTimelineAccordionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpTimelineAccordionWrapperWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpTimelineAccordionWrapperWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpTimelineAccordionWrapperWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpTimelineAccordionWrapperOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpTimelineAccordionWrapperUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  corpTimelineAccordions?: InputMaybe<CorpTimelineAccordionUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
};

export type CorpTimelineAccordionWrapperUpdateManyInlineInput = {
  /** Connect multiple existing CorpTimelineAccordionWrapper documents */
  connect?: InputMaybe<Array<CorpTimelineAccordionWrapperConnectInput>>;
  /** Create and connect multiple CorpTimelineAccordionWrapper documents */
  create?: InputMaybe<Array<CorpTimelineAccordionWrapperCreateInput>>;
  /** Delete multiple CorpTimelineAccordionWrapper documents */
  delete?: InputMaybe<Array<CorpTimelineAccordionWrapperWhereUniqueInput>>;
  /** Disconnect multiple CorpTimelineAccordionWrapper documents */
  disconnect?: InputMaybe<Array<CorpTimelineAccordionWrapperWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpTimelineAccordionWrapper documents */
  set?: InputMaybe<Array<CorpTimelineAccordionWrapperWhereUniqueInput>>;
  /** Update multiple CorpTimelineAccordionWrapper documents */
  update?: InputMaybe<Array<CorpTimelineAccordionWrapperUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpTimelineAccordionWrapper documents */
  upsert?: InputMaybe<Array<CorpTimelineAccordionWrapperUpsertWithNestedWhereUniqueInput>>;
};

export type CorpTimelineAccordionWrapperUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CorpTimelineAccordionWrapperUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpTimelineAccordionWrapperUpdateManyInput;
  /** Document search */
  where: CorpTimelineAccordionWrapperWhereInput;
};

export type CorpTimelineAccordionWrapperUpdateOneInlineInput = {
  /** Connect existing CorpTimelineAccordionWrapper document */
  connect?: InputMaybe<CorpTimelineAccordionWrapperWhereUniqueInput>;
  /** Create and connect one CorpTimelineAccordionWrapper document */
  create?: InputMaybe<CorpTimelineAccordionWrapperCreateInput>;
  /** Delete currently connected CorpTimelineAccordionWrapper document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpTimelineAccordionWrapper document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpTimelineAccordionWrapper document */
  update?: InputMaybe<CorpTimelineAccordionWrapperUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpTimelineAccordionWrapper document */
  upsert?: InputMaybe<CorpTimelineAccordionWrapperUpsertWithNestedWhereUniqueInput>;
};

export type CorpTimelineAccordionWrapperUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpTimelineAccordionWrapperUpdateInput;
  /** Unique document search */
  where: CorpTimelineAccordionWrapperWhereUniqueInput;
};

export type CorpTimelineAccordionWrapperUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpTimelineAccordionWrapperCreateInput;
  /** Update document if it exists */
  update: CorpTimelineAccordionWrapperUpdateInput;
};

export type CorpTimelineAccordionWrapperUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpTimelineAccordionWrapperUpsertInput;
  /** Unique document search */
  where: CorpTimelineAccordionWrapperWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpTimelineAccordionWrapperWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpTimelineAccordionWrapperWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpTimelineAccordionWrapperWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpTimelineAccordionWrapperWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpTimelineAccordionWrapperWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  corpTimelineAccordions_every?: InputMaybe<CorpTimelineAccordionWhereInput>;
  corpTimelineAccordions_none?: InputMaybe<CorpTimelineAccordionWhereInput>;
  corpTimelineAccordions_some?: InputMaybe<CorpTimelineAccordionWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpTimelineAccordionWrapperWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpTimelineAccordionWrapperWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpTimelineAccordionWrapperWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpTimelineAccordionWrapperWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpTimelineAccordionWrapperWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpTimelineAccordionWrapperWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpTimelineAccordionWrapperWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpTimelineAccordionWrapperWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpTimelineAccordionWrapper record uniquely */
export type CorpTimelineAccordionWrapperWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CorpVideoHero = Entity & Node & {
  __typename?: 'CorpVideoHero';
  bannerImage?: Maybe<Asset>;
  bannerTitle?: Maybe<Scalars['String']['output']>;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  contentAlignment?: Maybe<AlignmentTypes>;
  corpVideoHeroCarousel?: Maybe<CorpVideoHeroCarousel>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  darkOverlay?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<CorpVideoHero>;
  genericPages: Array<GenericPage>;
  /** List of CorpVideoHero versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  linkComponent?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpVideoHero>;
  mobileImage?: Maybe<Asset>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  superTitle?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<VideoCarouselTextColor>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  verticalAlignment?: Maybe<VerticalAlignment>;
  /** youtube video ID. Should look like this: "JE63vMzb3UE" */
  videoId?: Maybe<Scalars['String']['output']>;
};


export type CorpVideoHeroBannerImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CorpVideoHeroCorpVideoHeroCarouselArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpVideoHeroCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpVideoHeroCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpVideoHeroDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpVideoHeroGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type CorpVideoHeroHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpVideoHeroLinkComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpVideoHeroLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CorpVideoHeroMobileImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type CorpVideoHeroPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpVideoHeroPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpVideoHeroScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpVideoHeroUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpVideoHeroUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpVideoHeroCarousel = Entity & Node & {
  __typename?: 'CorpVideoHeroCarousel';
  autoPlay?: Maybe<Scalars['Boolean']['output']>;
  bannerSize?: Maybe<VideoHeroBannerSize>;
  corpVideoHero: Array<CorpVideoHero>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CorpVideoHeroCarousel>;
  genericPages: Array<GenericPage>;
  /** List of CorpVideoHeroCarousel versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CorpVideoHeroCarousel>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type CorpVideoHeroCarouselCorpVideoHeroArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<CorpVideoHeroOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpVideoHeroWhereInput>;
};


export type CorpVideoHeroCarouselCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpVideoHeroCarouselCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpVideoHeroCarouselDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type CorpVideoHeroCarouselGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type CorpVideoHeroCarouselHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type CorpVideoHeroCarouselLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type CorpVideoHeroCarouselPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpVideoHeroCarouselPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type CorpVideoHeroCarouselScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type CorpVideoHeroCarouselUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type CorpVideoHeroCarouselUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CorpVideoHeroCarouselConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpVideoHeroCarouselWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpVideoHeroCarouselConnection = {
  __typename?: 'CorpVideoHeroCarouselConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpVideoHeroCarouselEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpVideoHeroCarouselCreateInput = {
  autoPlay?: InputMaybe<Scalars['Boolean']['input']>;
  bannerSize?: InputMaybe<VideoHeroBannerSize>;
  corpVideoHero?: InputMaybe<CorpVideoHeroCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpVideoHeroCarouselCreateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpVideoHeroCarouselCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpVideoHeroCarouselCreateLocalizationInput = {
  /** Localization input */
  data: CorpVideoHeroCarouselCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpVideoHeroCarouselCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpVideoHeroCarouselCreateLocalizationInput>>;
};

export type CorpVideoHeroCarouselCreateManyInlineInput = {
  /** Connect multiple existing CorpVideoHeroCarousel documents */
  connect?: InputMaybe<Array<CorpVideoHeroCarouselWhereUniqueInput>>;
  /** Create and connect multiple existing CorpVideoHeroCarousel documents */
  create?: InputMaybe<Array<CorpVideoHeroCarouselCreateInput>>;
};

export type CorpVideoHeroCarouselCreateOneInlineInput = {
  /** Connect one existing CorpVideoHeroCarousel document */
  connect?: InputMaybe<CorpVideoHeroCarouselWhereUniqueInput>;
  /** Create and connect one CorpVideoHeroCarousel document */
  create?: InputMaybe<CorpVideoHeroCarouselCreateInput>;
};

/** An edge in a connection. */
export type CorpVideoHeroCarouselEdge = {
  __typename?: 'CorpVideoHeroCarouselEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpVideoHeroCarousel;
};

/** Identifies documents */
export type CorpVideoHeroCarouselManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpVideoHeroCarouselWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpVideoHeroCarouselWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpVideoHeroCarouselWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  autoPlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  autoPlay_not?: InputMaybe<Scalars['Boolean']['input']>;
  bannerSize?: InputMaybe<VideoHeroBannerSize>;
  /** All values that are contained in given list. */
  bannerSize_in?: InputMaybe<Array<InputMaybe<VideoHeroBannerSize>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerSize_not?: InputMaybe<VideoHeroBannerSize>;
  /** All values that are not contained in given list. */
  bannerSize_not_in?: InputMaybe<Array<InputMaybe<VideoHeroBannerSize>>>;
  corpVideoHero_every?: InputMaybe<CorpVideoHeroWhereInput>;
  corpVideoHero_none?: InputMaybe<CorpVideoHeroWhereInput>;
  corpVideoHero_some?: InputMaybe<CorpVideoHeroWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpVideoHeroCarouselWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpVideoHeroCarouselWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpVideoHeroCarouselWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CorpVideoHeroCarouselOrderByInput {
  autoPlay_ASC = 'autoPlay_ASC',
  autoPlay_DESC = 'autoPlay_DESC',
  bannerSize_ASC = 'bannerSize_ASC',
  bannerSize_DESC = 'bannerSize_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CorpVideoHeroCarouselUpdateInput = {
  autoPlay?: InputMaybe<Scalars['Boolean']['input']>;
  bannerSize?: InputMaybe<VideoHeroBannerSize>;
  corpVideoHero?: InputMaybe<CorpVideoHeroUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpVideoHeroCarouselUpdateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpVideoHeroCarouselUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpVideoHeroCarouselUpdateLocalizationInput = {
  data: CorpVideoHeroCarouselUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpVideoHeroCarouselUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpVideoHeroCarouselCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpVideoHeroCarouselUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpVideoHeroCarouselUpsertLocalizationInput>>;
};

export type CorpVideoHeroCarouselUpdateManyInlineInput = {
  /** Connect multiple existing CorpVideoHeroCarousel documents */
  connect?: InputMaybe<Array<CorpVideoHeroCarouselConnectInput>>;
  /** Create and connect multiple CorpVideoHeroCarousel documents */
  create?: InputMaybe<Array<CorpVideoHeroCarouselCreateInput>>;
  /** Delete multiple CorpVideoHeroCarousel documents */
  delete?: InputMaybe<Array<CorpVideoHeroCarouselWhereUniqueInput>>;
  /** Disconnect multiple CorpVideoHeroCarousel documents */
  disconnect?: InputMaybe<Array<CorpVideoHeroCarouselWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpVideoHeroCarousel documents */
  set?: InputMaybe<Array<CorpVideoHeroCarouselWhereUniqueInput>>;
  /** Update multiple CorpVideoHeroCarousel documents */
  update?: InputMaybe<Array<CorpVideoHeroCarouselUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpVideoHeroCarousel documents */
  upsert?: InputMaybe<Array<CorpVideoHeroCarouselUpsertWithNestedWhereUniqueInput>>;
};

export type CorpVideoHeroCarouselUpdateManyInput = {
  autoPlay?: InputMaybe<Scalars['Boolean']['input']>;
  bannerSize?: InputMaybe<VideoHeroBannerSize>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpVideoHeroCarouselUpdateManyLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpVideoHeroCarouselUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CorpVideoHeroCarouselUpdateManyLocalizationInput = {
  data: CorpVideoHeroCarouselUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpVideoHeroCarouselUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpVideoHeroCarouselUpdateManyLocalizationInput>>;
};

export type CorpVideoHeroCarouselUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpVideoHeroCarouselUpdateManyInput;
  /** Document search */
  where: CorpVideoHeroCarouselWhereInput;
};

export type CorpVideoHeroCarouselUpdateOneInlineInput = {
  /** Connect existing CorpVideoHeroCarousel document */
  connect?: InputMaybe<CorpVideoHeroCarouselWhereUniqueInput>;
  /** Create and connect one CorpVideoHeroCarousel document */
  create?: InputMaybe<CorpVideoHeroCarouselCreateInput>;
  /** Delete currently connected CorpVideoHeroCarousel document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpVideoHeroCarousel document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpVideoHeroCarousel document */
  update?: InputMaybe<CorpVideoHeroCarouselUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpVideoHeroCarousel document */
  upsert?: InputMaybe<CorpVideoHeroCarouselUpsertWithNestedWhereUniqueInput>;
};

export type CorpVideoHeroCarouselUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpVideoHeroCarouselUpdateInput;
  /** Unique document search */
  where: CorpVideoHeroCarouselWhereUniqueInput;
};

export type CorpVideoHeroCarouselUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpVideoHeroCarouselCreateInput;
  /** Update document if it exists */
  update: CorpVideoHeroCarouselUpdateInput;
};

export type CorpVideoHeroCarouselUpsertLocalizationInput = {
  create: CorpVideoHeroCarouselCreateLocalizationDataInput;
  locale: Locale;
  update: CorpVideoHeroCarouselUpdateLocalizationDataInput;
};

export type CorpVideoHeroCarouselUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpVideoHeroCarouselUpsertInput;
  /** Unique document search */
  where: CorpVideoHeroCarouselWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpVideoHeroCarouselWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpVideoHeroCarouselWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpVideoHeroCarouselWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpVideoHeroCarouselWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpVideoHeroCarouselWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  autoPlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  autoPlay_not?: InputMaybe<Scalars['Boolean']['input']>;
  bannerSize?: InputMaybe<VideoHeroBannerSize>;
  /** All values that are contained in given list. */
  bannerSize_in?: InputMaybe<Array<InputMaybe<VideoHeroBannerSize>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerSize_not?: InputMaybe<VideoHeroBannerSize>;
  /** All values that are not contained in given list. */
  bannerSize_not_in?: InputMaybe<Array<InputMaybe<VideoHeroBannerSize>>>;
  corpVideoHero_every?: InputMaybe<CorpVideoHeroWhereInput>;
  corpVideoHero_none?: InputMaybe<CorpVideoHeroWhereInput>;
  corpVideoHero_some?: InputMaybe<CorpVideoHeroWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CorpVideoHeroCarouselWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpVideoHeroCarouselWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpVideoHeroCarouselWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpVideoHeroCarouselWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpVideoHeroCarouselWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpVideoHeroCarouselWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpVideoHeroCarouselWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpVideoHeroCarouselWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpVideoHeroCarousel record uniquely */
export type CorpVideoHeroCarouselWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CorpVideoHeroConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CorpVideoHeroWhereUniqueInput;
};

/** A connection to a list of items. */
export type CorpVideoHeroConnection = {
  __typename?: 'CorpVideoHeroConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CorpVideoHeroEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CorpVideoHeroCreateInput = {
  bannerImage?: InputMaybe<AssetCreateOneInlineInput>;
  /** bannerTitle input for default locale (default) */
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  contentAlignment?: InputMaybe<AlignmentTypes>;
  corpVideoHeroCarousel?: InputMaybe<CorpVideoHeroCarouselCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  darkOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  linkComponent?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CorpVideoHeroCreateLocalizationsInput>;
  mobileImage?: InputMaybe<AssetCreateOneInlineInput>;
  /** superTitle input for default locale (default) */
  superTitle?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<VideoCarouselTextColor>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type CorpVideoHeroCreateLocalizationDataInput = {
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  superTitle?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CorpVideoHeroCreateLocalizationInput = {
  /** Localization input */
  data: CorpVideoHeroCreateLocalizationDataInput;
  locale: Locale;
};

export type CorpVideoHeroCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CorpVideoHeroCreateLocalizationInput>>;
};

export type CorpVideoHeroCreateManyInlineInput = {
  /** Connect multiple existing CorpVideoHero documents */
  connect?: InputMaybe<Array<CorpVideoHeroWhereUniqueInput>>;
  /** Create and connect multiple existing CorpVideoHero documents */
  create?: InputMaybe<Array<CorpVideoHeroCreateInput>>;
};

export type CorpVideoHeroCreateOneInlineInput = {
  /** Connect one existing CorpVideoHero document */
  connect?: InputMaybe<CorpVideoHeroWhereUniqueInput>;
  /** Create and connect one CorpVideoHero document */
  create?: InputMaybe<CorpVideoHeroCreateInput>;
};

/** An edge in a connection. */
export type CorpVideoHeroEdge = {
  __typename?: 'CorpVideoHeroEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CorpVideoHero;
};

/** Identifies documents */
export type CorpVideoHeroManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpVideoHeroWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpVideoHeroWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpVideoHeroWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<AssetWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  contentAlignment?: InputMaybe<AlignmentTypes>;
  /** All values that are contained in given list. */
  contentAlignment_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentAlignment_not?: InputMaybe<AlignmentTypes>;
  /** All values that are not contained in given list. */
  contentAlignment_not_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  corpVideoHeroCarousel?: InputMaybe<CorpVideoHeroCarouselWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  darkOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  darkOverlay_not?: InputMaybe<Scalars['Boolean']['input']>;
  documentInStages_every?: InputMaybe<CorpVideoHeroWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpVideoHeroWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpVideoHeroWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  linkComponent?: InputMaybe<LinkWhereInput>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  textColor?: InputMaybe<VideoCarouselTextColor>;
  /** All values that are contained in given list. */
  textColor_in?: InputMaybe<Array<InputMaybe<VideoCarouselTextColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  textColor_not?: InputMaybe<VideoCarouselTextColor>;
  /** All values that are not contained in given list. */
  textColor_not_in?: InputMaybe<Array<InputMaybe<VideoCarouselTextColor>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  /** All values that are contained in given list. */
  verticalAlignment_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  verticalAlignment_not?: InputMaybe<VerticalAlignment>;
  /** All values that are not contained in given list. */
  verticalAlignment_not_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoId_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum CorpVideoHeroOrderByInput {
  bannerTitle_ASC = 'bannerTitle_ASC',
  bannerTitle_DESC = 'bannerTitle_DESC',
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  contentAlignment_ASC = 'contentAlignment_ASC',
  contentAlignment_DESC = 'contentAlignment_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  darkOverlay_ASC = 'darkOverlay_ASC',
  darkOverlay_DESC = 'darkOverlay_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superTitle_ASC = 'superTitle_ASC',
  superTitle_DESC = 'superTitle_DESC',
  textColor_ASC = 'textColor_ASC',
  textColor_DESC = 'textColor_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  verticalAlignment_ASC = 'verticalAlignment_ASC',
  verticalAlignment_DESC = 'verticalAlignment_DESC',
  videoId_ASC = 'videoId_ASC',
  videoId_DESC = 'videoId_DESC'
}

export type CorpVideoHeroUpdateInput = {
  bannerImage?: InputMaybe<AssetUpdateOneInlineInput>;
  /** bannerTitle input for default locale (default) */
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  contentAlignment?: InputMaybe<AlignmentTypes>;
  corpVideoHeroCarousel?: InputMaybe<CorpVideoHeroCarouselUpdateOneInlineInput>;
  darkOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  linkComponent?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CorpVideoHeroUpdateLocalizationsInput>;
  mobileImage?: InputMaybe<AssetUpdateOneInlineInput>;
  /** superTitle input for default locale (default) */
  superTitle?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<VideoCarouselTextColor>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type CorpVideoHeroUpdateLocalizationDataInput = {
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  superTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CorpVideoHeroUpdateLocalizationInput = {
  data: CorpVideoHeroUpdateLocalizationDataInput;
  locale: Locale;
};

export type CorpVideoHeroUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CorpVideoHeroCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CorpVideoHeroUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CorpVideoHeroUpsertLocalizationInput>>;
};

export type CorpVideoHeroUpdateManyInlineInput = {
  /** Connect multiple existing CorpVideoHero documents */
  connect?: InputMaybe<Array<CorpVideoHeroConnectInput>>;
  /** Create and connect multiple CorpVideoHero documents */
  create?: InputMaybe<Array<CorpVideoHeroCreateInput>>;
  /** Delete multiple CorpVideoHero documents */
  delete?: InputMaybe<Array<CorpVideoHeroWhereUniqueInput>>;
  /** Disconnect multiple CorpVideoHero documents */
  disconnect?: InputMaybe<Array<CorpVideoHeroWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CorpVideoHero documents */
  set?: InputMaybe<Array<CorpVideoHeroWhereUniqueInput>>;
  /** Update multiple CorpVideoHero documents */
  update?: InputMaybe<Array<CorpVideoHeroUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CorpVideoHero documents */
  upsert?: InputMaybe<Array<CorpVideoHeroUpsertWithNestedWhereUniqueInput>>;
};

export type CorpVideoHeroUpdateManyInput = {
  /** bannerTitle input for default locale (default) */
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  contentAlignment?: InputMaybe<AlignmentTypes>;
  darkOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CorpVideoHeroUpdateManyLocalizationsInput>;
  /** superTitle input for default locale (default) */
  superTitle?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<VideoCarouselTextColor>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  videoId?: InputMaybe<Scalars['String']['input']>;
};

export type CorpVideoHeroUpdateManyLocalizationDataInput = {
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  superTitle?: InputMaybe<Scalars['String']['input']>;
};

export type CorpVideoHeroUpdateManyLocalizationInput = {
  data: CorpVideoHeroUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CorpVideoHeroUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CorpVideoHeroUpdateManyLocalizationInput>>;
};

export type CorpVideoHeroUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CorpVideoHeroUpdateManyInput;
  /** Document search */
  where: CorpVideoHeroWhereInput;
};

export type CorpVideoHeroUpdateOneInlineInput = {
  /** Connect existing CorpVideoHero document */
  connect?: InputMaybe<CorpVideoHeroWhereUniqueInput>;
  /** Create and connect one CorpVideoHero document */
  create?: InputMaybe<CorpVideoHeroCreateInput>;
  /** Delete currently connected CorpVideoHero document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CorpVideoHero document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CorpVideoHero document */
  update?: InputMaybe<CorpVideoHeroUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CorpVideoHero document */
  upsert?: InputMaybe<CorpVideoHeroUpsertWithNestedWhereUniqueInput>;
};

export type CorpVideoHeroUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CorpVideoHeroUpdateInput;
  /** Unique document search */
  where: CorpVideoHeroWhereUniqueInput;
};

export type CorpVideoHeroUpsertInput = {
  /** Create document if it didn't exist */
  create: CorpVideoHeroCreateInput;
  /** Update document if it exists */
  update: CorpVideoHeroUpdateInput;
};

export type CorpVideoHeroUpsertLocalizationInput = {
  create: CorpVideoHeroCreateLocalizationDataInput;
  locale: Locale;
  update: CorpVideoHeroUpdateLocalizationDataInput;
};

export type CorpVideoHeroUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CorpVideoHeroUpsertInput;
  /** Unique document search */
  where: CorpVideoHeroWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CorpVideoHeroWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CorpVideoHeroWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpVideoHeroWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpVideoHeroWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpVideoHeroWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<AssetWhereInput>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  contentAlignment?: InputMaybe<AlignmentTypes>;
  /** All values that are contained in given list. */
  contentAlignment_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentAlignment_not?: InputMaybe<AlignmentTypes>;
  /** All values that are not contained in given list. */
  contentAlignment_not_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  corpVideoHeroCarousel?: InputMaybe<CorpVideoHeroCarouselWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  darkOverlay?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  darkOverlay_not?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<CorpVideoHeroWhereStageInput>;
  documentInStages_none?: InputMaybe<CorpVideoHeroWhereStageInput>;
  documentInStages_some?: InputMaybe<CorpVideoHeroWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  linkComponent?: InputMaybe<LinkWhereInput>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  textColor?: InputMaybe<VideoCarouselTextColor>;
  /** All values that are contained in given list. */
  textColor_in?: InputMaybe<Array<InputMaybe<VideoCarouselTextColor>>>;
  /** Any other value that exists and is not equal to the given value. */
  textColor_not?: InputMaybe<VideoCarouselTextColor>;
  /** All values that are not contained in given list. */
  textColor_not_in?: InputMaybe<Array<InputMaybe<VideoCarouselTextColor>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  verticalAlignment?: InputMaybe<VerticalAlignment>;
  /** All values that are contained in given list. */
  verticalAlignment_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  verticalAlignment_not?: InputMaybe<VerticalAlignment>;
  /** All values that are not contained in given list. */
  verticalAlignment_not_in?: InputMaybe<Array<InputMaybe<VerticalAlignment>>>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoId_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CorpVideoHeroWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CorpVideoHeroWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CorpVideoHeroWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CorpVideoHeroWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CorpVideoHeroWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CorpVideoHero record uniquely */
export type CorpVideoHeroWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Country Selector Component */
export type CountrySelector = Entity & Node & {
  __typename?: 'CountrySelector';
  /** Label on country dropdown */
  countryLabel?: Maybe<Scalars['String']['output']>;
  /** List of country items  */
  countrySelectorList: Array<CountrySelectorCountrySelectorList>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CountrySelector>;
  /** List of CountrySelector versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Label on language dropdown */
  languageLabel?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CountrySelector>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Text on button */
  textOnButton?: Maybe<Scalars['String']['output']>;
  /** Component Heading */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Country Selector Component */
export type CountrySelectorCountrySelectorListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Country Selector Component */
export type CountrySelectorCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Country Selector Component */
export type CountrySelectorCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Country Selector Component */
export type CountrySelectorDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Country Selector Component */
export type CountrySelectorHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Country Selector Component */
export type CountrySelectorLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Country Selector Component */
export type CountrySelectorPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Country Selector Component */
export type CountrySelectorPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Country Selector Component */
export type CountrySelectorScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Country Selector Component */
export type CountrySelectorUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Country Selector Component */
export type CountrySelectorUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CountrySelectorConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CountrySelectorWhereUniqueInput;
};

/** A connection to a list of items. */
export type CountrySelectorConnection = {
  __typename?: 'CountrySelectorConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CountrySelectorEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CountrySelectorCountrySelectorList = CountrySelectorItem;

export type CountrySelectorCountrySelectorListConnectInput = {
  CountrySelectorItem?: InputMaybe<CountrySelectorItemConnectInput>;
};

export type CountrySelectorCountrySelectorListCreateInput = {
  CountrySelectorItem?: InputMaybe<CountrySelectorItemCreateInput>;
};

export type CountrySelectorCountrySelectorListCreateManyInlineInput = {
  /** Connect multiple existing CountrySelectorCountrySelectorList documents */
  connect?: InputMaybe<Array<CountrySelectorCountrySelectorListWhereUniqueInput>>;
  /** Create and connect multiple existing CountrySelectorCountrySelectorList documents */
  create?: InputMaybe<Array<CountrySelectorCountrySelectorListCreateInput>>;
};

export type CountrySelectorCountrySelectorListCreateOneInlineInput = {
  /** Connect one existing CountrySelectorCountrySelectorList document */
  connect?: InputMaybe<CountrySelectorCountrySelectorListWhereUniqueInput>;
  /** Create and connect one CountrySelectorCountrySelectorList document */
  create?: InputMaybe<CountrySelectorCountrySelectorListCreateInput>;
};

export type CountrySelectorCountrySelectorListUpdateInput = {
  CountrySelectorItem?: InputMaybe<CountrySelectorItemUpdateInput>;
};

export type CountrySelectorCountrySelectorListUpdateManyInlineInput = {
  /** Connect multiple existing CountrySelectorCountrySelectorList documents */
  connect?: InputMaybe<Array<CountrySelectorCountrySelectorListConnectInput>>;
  /** Create and connect multiple CountrySelectorCountrySelectorList documents */
  create?: InputMaybe<Array<CountrySelectorCountrySelectorListCreateInput>>;
  /** Delete multiple CountrySelectorCountrySelectorList documents */
  delete?: InputMaybe<Array<CountrySelectorCountrySelectorListWhereUniqueInput>>;
  /** Disconnect multiple CountrySelectorCountrySelectorList documents */
  disconnect?: InputMaybe<Array<CountrySelectorCountrySelectorListWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CountrySelectorCountrySelectorList documents */
  set?: InputMaybe<Array<CountrySelectorCountrySelectorListWhereUniqueInput>>;
  /** Update multiple CountrySelectorCountrySelectorList documents */
  update?: InputMaybe<Array<CountrySelectorCountrySelectorListUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CountrySelectorCountrySelectorList documents */
  upsert?: InputMaybe<Array<CountrySelectorCountrySelectorListUpsertWithNestedWhereUniqueInput>>;
};

export type CountrySelectorCountrySelectorListUpdateManyWithNestedWhereInput = {
  CountrySelectorItem?: InputMaybe<CountrySelectorItemUpdateManyWithNestedWhereInput>;
};

export type CountrySelectorCountrySelectorListUpdateOneInlineInput = {
  /** Connect existing CountrySelectorCountrySelectorList document */
  connect?: InputMaybe<CountrySelectorCountrySelectorListWhereUniqueInput>;
  /** Create and connect one CountrySelectorCountrySelectorList document */
  create?: InputMaybe<CountrySelectorCountrySelectorListCreateInput>;
  /** Delete currently connected CountrySelectorCountrySelectorList document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CountrySelectorCountrySelectorList document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CountrySelectorCountrySelectorList document */
  update?: InputMaybe<CountrySelectorCountrySelectorListUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CountrySelectorCountrySelectorList document */
  upsert?: InputMaybe<CountrySelectorCountrySelectorListUpsertWithNestedWhereUniqueInput>;
};

export type CountrySelectorCountrySelectorListUpdateWithNestedWhereUniqueInput = {
  CountrySelectorItem?: InputMaybe<CountrySelectorItemUpdateWithNestedWhereUniqueInput>;
};

export type CountrySelectorCountrySelectorListUpsertWithNestedWhereUniqueInput = {
  CountrySelectorItem?: InputMaybe<CountrySelectorItemUpsertWithNestedWhereUniqueInput>;
};

export type CountrySelectorCountrySelectorListWhereInput = {
  CountrySelectorItem?: InputMaybe<CountrySelectorItemWhereInput>;
};

export type CountrySelectorCountrySelectorListWhereUniqueInput = {
  CountrySelectorItem?: InputMaybe<CountrySelectorItemWhereUniqueInput>;
};

export type CountrySelectorCreateInput = {
  /** countryLabel input for default locale (default) */
  countryLabel?: InputMaybe<Scalars['String']['input']>;
  countrySelectorList?: InputMaybe<CountrySelectorCountrySelectorListCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** languageLabel input for default locale (default) */
  languageLabel?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CountrySelectorCreateLocalizationsInput>;
  /** textOnButton input for default locale (default) */
  textOnButton?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CountrySelectorCreateLocalizationDataInput = {
  countryLabel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  languageLabel?: InputMaybe<Scalars['String']['input']>;
  textOnButton?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CountrySelectorCreateLocalizationInput = {
  /** Localization input */
  data: CountrySelectorCreateLocalizationDataInput;
  locale: Locale;
};

export type CountrySelectorCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CountrySelectorCreateLocalizationInput>>;
};

export type CountrySelectorCreateManyInlineInput = {
  /** Connect multiple existing CountrySelector documents */
  connect?: InputMaybe<Array<CountrySelectorWhereUniqueInput>>;
  /** Create and connect multiple existing CountrySelector documents */
  create?: InputMaybe<Array<CountrySelectorCreateInput>>;
};

export type CountrySelectorCreateOneInlineInput = {
  /** Connect one existing CountrySelector document */
  connect?: InputMaybe<CountrySelectorWhereUniqueInput>;
  /** Create and connect one CountrySelector document */
  create?: InputMaybe<CountrySelectorCreateInput>;
};

/** An edge in a connection. */
export type CountrySelectorEdge = {
  __typename?: 'CountrySelectorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CountrySelector;
};

/** Country Selector Country List */
export type CountrySelectorItem = Entity & Node & {
  __typename?: 'CountrySelectorItem';
  /** Country Name */
  country: Scalars['String']['output'];
  /** Country Name or Code which should be in English */
  countryCode: Scalars['String']['output'];
  /** Flag Icon */
  countryFlag?: Maybe<CountrySelectorItemCountryFlag>;
  countrySelector?: Maybe<CountrySelector>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<CountrySelectorItem>;
  /** List of CountrySelectorItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Language associated to the country */
  language: Array<CountrySelectorItemLanguage1>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<CountrySelectorItem>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Country Selector Country List */
export type CountrySelectorItemCountryFlagArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Country Selector Country List */
export type CountrySelectorItemCountrySelectorArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Country Selector Country List */
export type CountrySelectorItemCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Country Selector Country List */
export type CountrySelectorItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Country Selector Country List */
export type CountrySelectorItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Country Selector Country List */
export type CountrySelectorItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Country Selector Country List */
export type CountrySelectorItemLanguageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Country Selector Country List */
export type CountrySelectorItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Country Selector Country List */
export type CountrySelectorItemPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Country Selector Country List */
export type CountrySelectorItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Country Selector Country List */
export type CountrySelectorItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Country Selector Country List */
export type CountrySelectorItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Country Selector Country List */
export type CountrySelectorItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type CountrySelectorItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: CountrySelectorItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type CountrySelectorItemConnection = {
  __typename?: 'CountrySelectorItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<CountrySelectorItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type CountrySelectorItemCountryFlag = AssetComponent;

export type CountrySelectorItemCountryFlagConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type CountrySelectorItemCountryFlagCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type CountrySelectorItemCountryFlagCreateManyInlineInput = {
  /** Connect multiple existing CountrySelectorItemCountryFlag documents */
  connect?: InputMaybe<Array<CountrySelectorItemCountryFlagWhereUniqueInput>>;
  /** Create and connect multiple existing CountrySelectorItemCountryFlag documents */
  create?: InputMaybe<Array<CountrySelectorItemCountryFlagCreateInput>>;
};

export type CountrySelectorItemCountryFlagCreateOneInlineInput = {
  /** Connect one existing CountrySelectorItemCountryFlag document */
  connect?: InputMaybe<CountrySelectorItemCountryFlagWhereUniqueInput>;
  /** Create and connect one CountrySelectorItemCountryFlag document */
  create?: InputMaybe<CountrySelectorItemCountryFlagCreateInput>;
};

export type CountrySelectorItemCountryFlagUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type CountrySelectorItemCountryFlagUpdateManyInlineInput = {
  /** Connect multiple existing CountrySelectorItemCountryFlag documents */
  connect?: InputMaybe<Array<CountrySelectorItemCountryFlagConnectInput>>;
  /** Create and connect multiple CountrySelectorItemCountryFlag documents */
  create?: InputMaybe<Array<CountrySelectorItemCountryFlagCreateInput>>;
  /** Delete multiple CountrySelectorItemCountryFlag documents */
  delete?: InputMaybe<Array<CountrySelectorItemCountryFlagWhereUniqueInput>>;
  /** Disconnect multiple CountrySelectorItemCountryFlag documents */
  disconnect?: InputMaybe<Array<CountrySelectorItemCountryFlagWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CountrySelectorItemCountryFlag documents */
  set?: InputMaybe<Array<CountrySelectorItemCountryFlagWhereUniqueInput>>;
  /** Update multiple CountrySelectorItemCountryFlag documents */
  update?: InputMaybe<Array<CountrySelectorItemCountryFlagUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CountrySelectorItemCountryFlag documents */
  upsert?: InputMaybe<Array<CountrySelectorItemCountryFlagUpsertWithNestedWhereUniqueInput>>;
};

export type CountrySelectorItemCountryFlagUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type CountrySelectorItemCountryFlagUpdateOneInlineInput = {
  /** Connect existing CountrySelectorItemCountryFlag document */
  connect?: InputMaybe<CountrySelectorItemCountryFlagWhereUniqueInput>;
  /** Create and connect one CountrySelectorItemCountryFlag document */
  create?: InputMaybe<CountrySelectorItemCountryFlagCreateInput>;
  /** Delete currently connected CountrySelectorItemCountryFlag document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CountrySelectorItemCountryFlag document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CountrySelectorItemCountryFlag document */
  update?: InputMaybe<CountrySelectorItemCountryFlagUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CountrySelectorItemCountryFlag document */
  upsert?: InputMaybe<CountrySelectorItemCountryFlagUpsertWithNestedWhereUniqueInput>;
};

export type CountrySelectorItemCountryFlagUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type CountrySelectorItemCountryFlagUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type CountrySelectorItemCountryFlagWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type CountrySelectorItemCountryFlagWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

export type CountrySelectorItemCreateInput = {
  /** country input for default locale (default) */
  country: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  countryFlag?: InputMaybe<CountrySelectorItemCountryFlagCreateOneInlineInput>;
  countrySelector?: InputMaybe<CountrySelectorCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  language?: InputMaybe<CountrySelectorItemLanguage1CreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<CountrySelectorItemCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CountrySelectorItemCreateLocalizationDataInput = {
  country: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CountrySelectorItemCreateLocalizationInput = {
  /** Localization input */
  data: CountrySelectorItemCreateLocalizationDataInput;
  locale: Locale;
};

export type CountrySelectorItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<CountrySelectorItemCreateLocalizationInput>>;
};

export type CountrySelectorItemCreateManyInlineInput = {
  /** Connect multiple existing CountrySelectorItem documents */
  connect?: InputMaybe<Array<CountrySelectorItemWhereUniqueInput>>;
  /** Create and connect multiple existing CountrySelectorItem documents */
  create?: InputMaybe<Array<CountrySelectorItemCreateInput>>;
};

export type CountrySelectorItemCreateOneInlineInput = {
  /** Connect one existing CountrySelectorItem document */
  connect?: InputMaybe<CountrySelectorItemWhereUniqueInput>;
  /** Create and connect one CountrySelectorItem document */
  create?: InputMaybe<CountrySelectorItemCreateInput>;
};

/** An edge in a connection. */
export type CountrySelectorItemEdge = {
  __typename?: 'CountrySelectorItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CountrySelectorItem;
};

export type CountrySelectorItemLanguage1 = Link;

export type CountrySelectorItemLanguage1ConnectInput = {
  Link?: InputMaybe<LinkConnectInput>;
};

export type CountrySelectorItemLanguage1CreateInput = {
  Link?: InputMaybe<LinkCreateInput>;
};

export type CountrySelectorItemLanguage1CreateManyInlineInput = {
  /** Connect multiple existing CountrySelectorItemLanguage1 documents */
  connect?: InputMaybe<Array<CountrySelectorItemLanguage1WhereUniqueInput>>;
  /** Create and connect multiple existing CountrySelectorItemLanguage1 documents */
  create?: InputMaybe<Array<CountrySelectorItemLanguage1CreateInput>>;
};

export type CountrySelectorItemLanguage1CreateOneInlineInput = {
  /** Connect one existing CountrySelectorItemLanguage1 document */
  connect?: InputMaybe<CountrySelectorItemLanguage1WhereUniqueInput>;
  /** Create and connect one CountrySelectorItemLanguage1 document */
  create?: InputMaybe<CountrySelectorItemLanguage1CreateInput>;
};

export type CountrySelectorItemLanguage1UpdateInput = {
  Link?: InputMaybe<LinkUpdateInput>;
};

export type CountrySelectorItemLanguage1UpdateManyInlineInput = {
  /** Connect multiple existing CountrySelectorItemLanguage1 documents */
  connect?: InputMaybe<Array<CountrySelectorItemLanguage1ConnectInput>>;
  /** Create and connect multiple CountrySelectorItemLanguage1 documents */
  create?: InputMaybe<Array<CountrySelectorItemLanguage1CreateInput>>;
  /** Delete multiple CountrySelectorItemLanguage1 documents */
  delete?: InputMaybe<Array<CountrySelectorItemLanguage1WhereUniqueInput>>;
  /** Disconnect multiple CountrySelectorItemLanguage1 documents */
  disconnect?: InputMaybe<Array<CountrySelectorItemLanguage1WhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CountrySelectorItemLanguage1 documents */
  set?: InputMaybe<Array<CountrySelectorItemLanguage1WhereUniqueInput>>;
  /** Update multiple CountrySelectorItemLanguage1 documents */
  update?: InputMaybe<Array<CountrySelectorItemLanguage1UpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CountrySelectorItemLanguage1 documents */
  upsert?: InputMaybe<Array<CountrySelectorItemLanguage1UpsertWithNestedWhereUniqueInput>>;
};

export type CountrySelectorItemLanguage1UpdateManyWithNestedWhereInput = {
  Link?: InputMaybe<LinkUpdateManyWithNestedWhereInput>;
};

export type CountrySelectorItemLanguage1UpdateOneInlineInput = {
  /** Connect existing CountrySelectorItemLanguage1 document */
  connect?: InputMaybe<CountrySelectorItemLanguage1WhereUniqueInput>;
  /** Create and connect one CountrySelectorItemLanguage1 document */
  create?: InputMaybe<CountrySelectorItemLanguage1CreateInput>;
  /** Delete currently connected CountrySelectorItemLanguage1 document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CountrySelectorItemLanguage1 document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CountrySelectorItemLanguage1 document */
  update?: InputMaybe<CountrySelectorItemLanguage1UpdateWithNestedWhereUniqueInput>;
  /** Upsert single CountrySelectorItemLanguage1 document */
  upsert?: InputMaybe<CountrySelectorItemLanguage1UpsertWithNestedWhereUniqueInput>;
};

export type CountrySelectorItemLanguage1UpdateWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
};

export type CountrySelectorItemLanguage1UpsertWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
};

export type CountrySelectorItemLanguage1WhereInput = {
  Link?: InputMaybe<LinkWhereInput>;
};

export type CountrySelectorItemLanguage1WhereUniqueInput = {
  Link?: InputMaybe<LinkWhereUniqueInput>;
};

/** Identifies documents */
export type CountrySelectorItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CountrySelectorItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CountrySelectorItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CountrySelectorItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  countryCode_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  countryCode_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  countryCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  countryCode_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  countryCode_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  countryCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  countryCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  countryCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  countryCode_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is connected to the given models */
  countryFlag?: InputMaybe<CountrySelectorItemCountryFlagWhereInput>;
  /** All values in which the union is empty */
  countryFlag_empty?: InputMaybe<Scalars['Boolean']['input']>;
  countrySelector?: InputMaybe<CountrySelectorWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CountrySelectorItemWhereStageInput>;
  documentInStages_none?: InputMaybe<CountrySelectorItemWhereStageInput>;
  documentInStages_some?: InputMaybe<CountrySelectorItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  language_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  language_some?: InputMaybe<CountrySelectorItemLanguage1WhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CountrySelectorItemOrderByInput {
  countryCode_ASC = 'countryCode_ASC',
  countryCode_DESC = 'countryCode_DESC',
  country_ASC = 'country_ASC',
  country_DESC = 'country_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CountrySelectorItemUpdateInput = {
  /** country input for default locale (default) */
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryFlag?: InputMaybe<CountrySelectorItemCountryFlagUpdateOneInlineInput>;
  countrySelector?: InputMaybe<CountrySelectorUpdateOneInlineInput>;
  language?: InputMaybe<CountrySelectorItemLanguage1UpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<CountrySelectorItemUpdateLocalizationsInput>;
};

export type CountrySelectorItemUpdateLocalizationDataInput = {
  country?: InputMaybe<Scalars['String']['input']>;
};

export type CountrySelectorItemUpdateLocalizationInput = {
  data: CountrySelectorItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type CountrySelectorItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CountrySelectorItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CountrySelectorItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CountrySelectorItemUpsertLocalizationInput>>;
};

export type CountrySelectorItemUpdateManyInlineInput = {
  /** Connect multiple existing CountrySelectorItem documents */
  connect?: InputMaybe<Array<CountrySelectorItemConnectInput>>;
  /** Create and connect multiple CountrySelectorItem documents */
  create?: InputMaybe<Array<CountrySelectorItemCreateInput>>;
  /** Delete multiple CountrySelectorItem documents */
  delete?: InputMaybe<Array<CountrySelectorItemWhereUniqueInput>>;
  /** Disconnect multiple CountrySelectorItem documents */
  disconnect?: InputMaybe<Array<CountrySelectorItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CountrySelectorItem documents */
  set?: InputMaybe<Array<CountrySelectorItemWhereUniqueInput>>;
  /** Update multiple CountrySelectorItem documents */
  update?: InputMaybe<Array<CountrySelectorItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CountrySelectorItem documents */
  upsert?: InputMaybe<Array<CountrySelectorItemUpsertWithNestedWhereUniqueInput>>;
};

export type CountrySelectorItemUpdateManyInput = {
  /** country input for default locale (default) */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CountrySelectorItemUpdateManyLocalizationsInput>;
};

export type CountrySelectorItemUpdateManyLocalizationDataInput = {
  country?: InputMaybe<Scalars['String']['input']>;
};

export type CountrySelectorItemUpdateManyLocalizationInput = {
  data: CountrySelectorItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CountrySelectorItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CountrySelectorItemUpdateManyLocalizationInput>>;
};

export type CountrySelectorItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CountrySelectorItemUpdateManyInput;
  /** Document search */
  where: CountrySelectorItemWhereInput;
};

export type CountrySelectorItemUpdateOneInlineInput = {
  /** Connect existing CountrySelectorItem document */
  connect?: InputMaybe<CountrySelectorItemWhereUniqueInput>;
  /** Create and connect one CountrySelectorItem document */
  create?: InputMaybe<CountrySelectorItemCreateInput>;
  /** Delete currently connected CountrySelectorItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CountrySelectorItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CountrySelectorItem document */
  update?: InputMaybe<CountrySelectorItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CountrySelectorItem document */
  upsert?: InputMaybe<CountrySelectorItemUpsertWithNestedWhereUniqueInput>;
};

export type CountrySelectorItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CountrySelectorItemUpdateInput;
  /** Unique document search */
  where: CountrySelectorItemWhereUniqueInput;
};

export type CountrySelectorItemUpsertInput = {
  /** Create document if it didn't exist */
  create: CountrySelectorItemCreateInput;
  /** Update document if it exists */
  update: CountrySelectorItemUpdateInput;
};

export type CountrySelectorItemUpsertLocalizationInput = {
  create: CountrySelectorItemCreateLocalizationDataInput;
  locale: Locale;
  update: CountrySelectorItemUpdateLocalizationDataInput;
};

export type CountrySelectorItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CountrySelectorItemUpsertInput;
  /** Unique document search */
  where: CountrySelectorItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CountrySelectorItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CountrySelectorItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CountrySelectorItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CountrySelectorItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CountrySelectorItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  countryCode_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  countryCode_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  countryCode_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  countryCode_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  countryCode_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  countryCode_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  countryCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  countryCode_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  countryCode_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is connected to the given models */
  countryFlag?: InputMaybe<CountrySelectorItemCountryFlagWhereInput>;
  /** All values in which the union is empty */
  countryFlag_empty?: InputMaybe<Scalars['Boolean']['input']>;
  countrySelector?: InputMaybe<CountrySelectorWhereInput>;
  /** All values containing the given string. */
  country_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  country_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  country_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  country_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  country_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  country_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  country_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  country_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  country_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CountrySelectorItemWhereStageInput>;
  documentInStages_none?: InputMaybe<CountrySelectorItemWhereStageInput>;
  documentInStages_some?: InputMaybe<CountrySelectorItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  language_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  language_some?: InputMaybe<CountrySelectorItemLanguage1WhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CountrySelectorItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CountrySelectorItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CountrySelectorItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CountrySelectorItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CountrySelectorItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CountrySelectorItem record uniquely */
export type CountrySelectorItemWhereUniqueInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type CountrySelectorManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CountrySelectorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CountrySelectorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CountrySelectorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  countrySelectorList_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  countrySelectorList_some?: InputMaybe<CountrySelectorCountrySelectorListWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CountrySelectorWhereStageInput>;
  documentInStages_none?: InputMaybe<CountrySelectorWhereStageInput>;
  documentInStages_some?: InputMaybe<CountrySelectorWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum CountrySelectorOrderByInput {
  countryLabel_ASC = 'countryLabel_ASC',
  countryLabel_DESC = 'countryLabel_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  languageLabel_ASC = 'languageLabel_ASC',
  languageLabel_DESC = 'languageLabel_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  textOnButton_ASC = 'textOnButton_ASC',
  textOnButton_DESC = 'textOnButton_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type CountrySelectorUpdateInput = {
  /** countryLabel input for default locale (default) */
  countryLabel?: InputMaybe<Scalars['String']['input']>;
  countrySelectorList?: InputMaybe<CountrySelectorCountrySelectorListUpdateManyInlineInput>;
  /** languageLabel input for default locale (default) */
  languageLabel?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<CountrySelectorUpdateLocalizationsInput>;
  /** textOnButton input for default locale (default) */
  textOnButton?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CountrySelectorUpdateLocalizationDataInput = {
  countryLabel?: InputMaybe<Scalars['String']['input']>;
  languageLabel?: InputMaybe<Scalars['String']['input']>;
  textOnButton?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CountrySelectorUpdateLocalizationInput = {
  data: CountrySelectorUpdateLocalizationDataInput;
  locale: Locale;
};

export type CountrySelectorUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<CountrySelectorCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<CountrySelectorUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<CountrySelectorUpsertLocalizationInput>>;
};

export type CountrySelectorUpdateManyInlineInput = {
  /** Connect multiple existing CountrySelector documents */
  connect?: InputMaybe<Array<CountrySelectorConnectInput>>;
  /** Create and connect multiple CountrySelector documents */
  create?: InputMaybe<Array<CountrySelectorCreateInput>>;
  /** Delete multiple CountrySelector documents */
  delete?: InputMaybe<Array<CountrySelectorWhereUniqueInput>>;
  /** Disconnect multiple CountrySelector documents */
  disconnect?: InputMaybe<Array<CountrySelectorWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing CountrySelector documents */
  set?: InputMaybe<Array<CountrySelectorWhereUniqueInput>>;
  /** Update multiple CountrySelector documents */
  update?: InputMaybe<Array<CountrySelectorUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple CountrySelector documents */
  upsert?: InputMaybe<Array<CountrySelectorUpsertWithNestedWhereUniqueInput>>;
};

export type CountrySelectorUpdateManyInput = {
  /** countryLabel input for default locale (default) */
  countryLabel?: InputMaybe<Scalars['String']['input']>;
  /** languageLabel input for default locale (default) */
  languageLabel?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<CountrySelectorUpdateManyLocalizationsInput>;
  /** textOnButton input for default locale (default) */
  textOnButton?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CountrySelectorUpdateManyLocalizationDataInput = {
  countryLabel?: InputMaybe<Scalars['String']['input']>;
  languageLabel?: InputMaybe<Scalars['String']['input']>;
  textOnButton?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CountrySelectorUpdateManyLocalizationInput = {
  data: CountrySelectorUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type CountrySelectorUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<CountrySelectorUpdateManyLocalizationInput>>;
};

export type CountrySelectorUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: CountrySelectorUpdateManyInput;
  /** Document search */
  where: CountrySelectorWhereInput;
};

export type CountrySelectorUpdateOneInlineInput = {
  /** Connect existing CountrySelector document */
  connect?: InputMaybe<CountrySelectorWhereUniqueInput>;
  /** Create and connect one CountrySelector document */
  create?: InputMaybe<CountrySelectorCreateInput>;
  /** Delete currently connected CountrySelector document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected CountrySelector document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single CountrySelector document */
  update?: InputMaybe<CountrySelectorUpdateWithNestedWhereUniqueInput>;
  /** Upsert single CountrySelector document */
  upsert?: InputMaybe<CountrySelectorUpsertWithNestedWhereUniqueInput>;
};

export type CountrySelectorUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: CountrySelectorUpdateInput;
  /** Unique document search */
  where: CountrySelectorWhereUniqueInput;
};

export type CountrySelectorUpsertInput = {
  /** Create document if it didn't exist */
  create: CountrySelectorCreateInput;
  /** Update document if it exists */
  update: CountrySelectorUpdateInput;
};

export type CountrySelectorUpsertLocalizationInput = {
  create: CountrySelectorCreateLocalizationDataInput;
  locale: Locale;
  update: CountrySelectorUpdateLocalizationDataInput;
};

export type CountrySelectorUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: CountrySelectorUpsertInput;
  /** Unique document search */
  where: CountrySelectorWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type CountrySelectorWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type CountrySelectorWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CountrySelectorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CountrySelectorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CountrySelectorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  countryLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  countryLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  countryLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  countryLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  countryLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  countryLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  countryLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  countryLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  countryLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  countryLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  countrySelectorList_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  countrySelectorList_some?: InputMaybe<CountrySelectorCountrySelectorListWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<CountrySelectorWhereStageInput>;
  documentInStages_none?: InputMaybe<CountrySelectorWhereStageInput>;
  documentInStages_some?: InputMaybe<CountrySelectorWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  languageLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  languageLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  languageLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  languageLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  languageLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  languageLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  languageLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  languageLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  languageLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  languageLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  textOnButton?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  textOnButton_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  textOnButton_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  textOnButton_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  textOnButton_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  textOnButton_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  textOnButton_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  textOnButton_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  textOnButton_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  textOnButton_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type CountrySelectorWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<CountrySelectorWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<CountrySelectorWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<CountrySelectorWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<CountrySelectorWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References CountrySelector record uniquely */
export type CountrySelectorWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type DeprecatedBanner1 = Entity & Node & {
  __typename?: 'DEPRECATEDBanner1';
  anchorNav?: Maybe<AnchorNavigation>;
  /** For background image of banner */
  backgroundAsset?: Maybe<AssetComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<DeprecatedBanner1>;
  /** List of DEPRECATEDBanner1 versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<DeprecatedBanner1>;
  lowerLeftCorner?: Maybe<AssetComponent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  superText?: Maybe<Scalars['String']['output']>;
  /** title of the banner */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  upperRightCorner?: Maybe<AssetComponent>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type DeprecatedBanner1AnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type DeprecatedBanner1BackgroundAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type DeprecatedBanner1CreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type DeprecatedBanner1CreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type DeprecatedBanner1DocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type DeprecatedBanner1HistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type DeprecatedBanner1LinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type DeprecatedBanner1LocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type DeprecatedBanner1LowerLeftCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type DeprecatedBanner1PublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type DeprecatedBanner1PublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type DeprecatedBanner1ScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type DeprecatedBanner1UpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type DeprecatedBanner1UpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
export type DeprecatedBanner1UpperRightCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DeprecatedBanner1ConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DeprecatedBanner1WhereUniqueInput;
};

/** A connection to a list of items. */
export type DeprecatedBanner1Connection = {
  __typename?: 'DEPRECATEDBanner1Connection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DeprecatedBanner1Edge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DeprecatedBanner1CreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  backgroundAsset?: InputMaybe<AssetComponentCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<DeprecatedBanner1CreateLocalizationsInput>;
  lowerLeftCorner?: InputMaybe<AssetComponentCreateOneInlineInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  upperRightCorner?: InputMaybe<AssetComponentCreateOneInlineInput>;
};

export type DeprecatedBanner1CreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeprecatedBanner1CreateLocalizationInput = {
  /** Localization input */
  data: DeprecatedBanner1CreateLocalizationDataInput;
  locale: Locale;
};

export type DeprecatedBanner1CreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<DeprecatedBanner1CreateLocalizationInput>>;
};

export type DeprecatedBanner1CreateManyInlineInput = {
  /** Connect multiple existing DEPRECATEDBanner1 documents */
  connect?: InputMaybe<Array<DeprecatedBanner1WhereUniqueInput>>;
  /** Create and connect multiple existing DEPRECATEDBanner1 documents */
  create?: InputMaybe<Array<DeprecatedBanner1CreateInput>>;
};

export type DeprecatedBanner1CreateOneInlineInput = {
  /** Connect one existing DEPRECATEDBanner1 document */
  connect?: InputMaybe<DeprecatedBanner1WhereUniqueInput>;
  /** Create and connect one DEPRECATEDBanner1 document */
  create?: InputMaybe<DeprecatedBanner1CreateInput>;
};

/** An edge in a connection. */
export type DeprecatedBanner1Edge = {
  __typename?: 'DEPRECATEDBanner1Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeprecatedBanner1;
};

/** Identifies documents */
export type DeprecatedBanner1ManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DeprecatedBanner1WhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DeprecatedBanner1WhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DeprecatedBanner1WhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundAsset?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<DeprecatedBanner1WhereStageInput>;
  documentInStages_none?: InputMaybe<DeprecatedBanner1WhereStageInput>;
  documentInStages_some?: InputMaybe<DeprecatedBanner1WhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  lowerLeftCorner?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upperRightCorner?: InputMaybe<AssetComponentWhereInput>;
};

export enum DeprecatedBanner1OrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type DeprecatedBanner1UpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  backgroundAsset?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<DeprecatedBanner1UpdateLocalizationsInput>;
  lowerLeftCorner?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  upperRightCorner?: InputMaybe<AssetComponentUpdateOneInlineInput>;
};

export type DeprecatedBanner1UpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
};

export type DeprecatedBanner1UpdateLocalizationInput = {
  data: DeprecatedBanner1UpdateLocalizationDataInput;
  locale: Locale;
};

export type DeprecatedBanner1UpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<DeprecatedBanner1CreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<DeprecatedBanner1UpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<DeprecatedBanner1UpsertLocalizationInput>>;
};

export type DeprecatedBanner1UpdateManyInlineInput = {
  /** Connect multiple existing DEPRECATEDBanner1 documents */
  connect?: InputMaybe<Array<DeprecatedBanner1ConnectInput>>;
  /** Create and connect multiple DEPRECATEDBanner1 documents */
  create?: InputMaybe<Array<DeprecatedBanner1CreateInput>>;
  /** Delete multiple DEPRECATEDBanner1 documents */
  delete?: InputMaybe<Array<DeprecatedBanner1WhereUniqueInput>>;
  /** Disconnect multiple DEPRECATEDBanner1 documents */
  disconnect?: InputMaybe<Array<DeprecatedBanner1WhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing DEPRECATEDBanner1 documents */
  set?: InputMaybe<Array<DeprecatedBanner1WhereUniqueInput>>;
  /** Update multiple DEPRECATEDBanner1 documents */
  update?: InputMaybe<Array<DeprecatedBanner1UpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple DEPRECATEDBanner1 documents */
  upsert?: InputMaybe<Array<DeprecatedBanner1UpsertWithNestedWhereUniqueInput>>;
};

export type DeprecatedBanner1UpdateManyInput = {
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<DeprecatedBanner1UpdateManyLocalizationsInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DeprecatedBanner1UpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
};

export type DeprecatedBanner1UpdateManyLocalizationInput = {
  data: DeprecatedBanner1UpdateManyLocalizationDataInput;
  locale: Locale;
};

export type DeprecatedBanner1UpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<DeprecatedBanner1UpdateManyLocalizationInput>>;
};

export type DeprecatedBanner1UpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DeprecatedBanner1UpdateManyInput;
  /** Document search */
  where: DeprecatedBanner1WhereInput;
};

export type DeprecatedBanner1UpdateOneInlineInput = {
  /** Connect existing DEPRECATEDBanner1 document */
  connect?: InputMaybe<DeprecatedBanner1WhereUniqueInput>;
  /** Create and connect one DEPRECATEDBanner1 document */
  create?: InputMaybe<DeprecatedBanner1CreateInput>;
  /** Delete currently connected DEPRECATEDBanner1 document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected DEPRECATEDBanner1 document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single DEPRECATEDBanner1 document */
  update?: InputMaybe<DeprecatedBanner1UpdateWithNestedWhereUniqueInput>;
  /** Upsert single DEPRECATEDBanner1 document */
  upsert?: InputMaybe<DeprecatedBanner1UpsertWithNestedWhereUniqueInput>;
};

export type DeprecatedBanner1UpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DeprecatedBanner1UpdateInput;
  /** Unique document search */
  where: DeprecatedBanner1WhereUniqueInput;
};

export type DeprecatedBanner1UpsertInput = {
  /** Create document if it didn't exist */
  create: DeprecatedBanner1CreateInput;
  /** Update document if it exists */
  update: DeprecatedBanner1UpdateInput;
};

export type DeprecatedBanner1UpsertLocalizationInput = {
  create: DeprecatedBanner1CreateLocalizationDataInput;
  locale: Locale;
  update: DeprecatedBanner1UpdateLocalizationDataInput;
};

export type DeprecatedBanner1UpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DeprecatedBanner1UpsertInput;
  /** Unique document search */
  where: DeprecatedBanner1WhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type DeprecatedBanner1WhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type DeprecatedBanner1WhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DeprecatedBanner1WhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DeprecatedBanner1WhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DeprecatedBanner1WhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundAsset?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<DeprecatedBanner1WhereStageInput>;
  documentInStages_none?: InputMaybe<DeprecatedBanner1WhereStageInput>;
  documentInStages_some?: InputMaybe<DeprecatedBanner1WhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  lowerLeftCorner?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upperRightCorner?: InputMaybe<AssetComponentWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type DeprecatedBanner1WhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DeprecatedBanner1WhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DeprecatedBanner1WhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DeprecatedBanner1WhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<DeprecatedBanner1WhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References DEPRECATEDBanner1 record uniquely */
export type DeprecatedBanner1WhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum DbEnvironment {
  dev = 'dev',
  prod = 'prod'
}

/** Deprecated - Contains a list of corporate navigation items (e.g. Main navigation menu items) */
export type DeprecatedCorpNavigationCopy = Entity & Node & {
  __typename?: 'DeprecatedCorpNavigationCopy';
  /** Title Above the card component */
  cardComponentTitle?: Maybe<Scalars['String']['output']>;
  cardItemtId?: Maybe<Scalars['String']['output']>;
  /** Title is used to display on website */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<DeprecatedCorpNavigationCopy>;
  /** List of DeprecatedCorpNavigationCopy versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Unique key for each haeder navigation */
  key: Scalars['String']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<DeprecatedCorpNavigationCopy>;
  /** Header Navigation url */
  navUrl?: Maybe<Scalars['String']['output']>;
  /** Specifies where on the page the navigation will be displayed */
  positon: NavigationTypes;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Deprecated - Contains a list of corporate navigation items (e.g. Main navigation menu items) */
export type DeprecatedCorpNavigationCopyCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Deprecated - Contains a list of corporate navigation items (e.g. Main navigation menu items) */
export type DeprecatedCorpNavigationCopyCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Deprecated - Contains a list of corporate navigation items (e.g. Main navigation menu items) */
export type DeprecatedCorpNavigationCopyDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Deprecated - Contains a list of corporate navigation items (e.g. Main navigation menu items) */
export type DeprecatedCorpNavigationCopyHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Deprecated - Contains a list of corporate navigation items (e.g. Main navigation menu items) */
export type DeprecatedCorpNavigationCopyLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Deprecated - Contains a list of corporate navigation items (e.g. Main navigation menu items) */
export type DeprecatedCorpNavigationCopyPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Deprecated - Contains a list of corporate navigation items (e.g. Main navigation menu items) */
export type DeprecatedCorpNavigationCopyPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Deprecated - Contains a list of corporate navigation items (e.g. Main navigation menu items) */
export type DeprecatedCorpNavigationCopyScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Deprecated - Contains a list of corporate navigation items (e.g. Main navigation menu items) */
export type DeprecatedCorpNavigationCopyUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Deprecated - Contains a list of corporate navigation items (e.g. Main navigation menu items) */
export type DeprecatedCorpNavigationCopyUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DeprecatedCorpNavigationCopyConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DeprecatedCorpNavigationCopyWhereUniqueInput;
};

/** A connection to a list of items. */
export type DeprecatedCorpNavigationCopyConnection = {
  __typename?: 'DeprecatedCorpNavigationCopyConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DeprecatedCorpNavigationCopyEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DeprecatedCorpNavigationCopyCreateInput = {
  cardComponentTitle?: InputMaybe<Scalars['String']['input']>;
  cardItemtId?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  key: Scalars['String']['input'];
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<DeprecatedCorpNavigationCopyCreateLocalizationsInput>;
  /** navUrl input for default locale (default) */
  navUrl?: InputMaybe<Scalars['String']['input']>;
  positon: NavigationTypes;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeprecatedCorpNavigationCopyCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  navUrl?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeprecatedCorpNavigationCopyCreateLocalizationInput = {
  /** Localization input */
  data: DeprecatedCorpNavigationCopyCreateLocalizationDataInput;
  locale: Locale;
};

export type DeprecatedCorpNavigationCopyCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<DeprecatedCorpNavigationCopyCreateLocalizationInput>>;
};

export type DeprecatedCorpNavigationCopyCreateManyInlineInput = {
  /** Connect multiple existing DeprecatedCorpNavigationCopy documents */
  connect?: InputMaybe<Array<DeprecatedCorpNavigationCopyWhereUniqueInput>>;
  /** Create and connect multiple existing DeprecatedCorpNavigationCopy documents */
  create?: InputMaybe<Array<DeprecatedCorpNavigationCopyCreateInput>>;
};

export type DeprecatedCorpNavigationCopyCreateOneInlineInput = {
  /** Connect one existing DeprecatedCorpNavigationCopy document */
  connect?: InputMaybe<DeprecatedCorpNavigationCopyWhereUniqueInput>;
  /** Create and connect one DeprecatedCorpNavigationCopy document */
  create?: InputMaybe<DeprecatedCorpNavigationCopyCreateInput>;
};

/** An edge in a connection. */
export type DeprecatedCorpNavigationCopyEdge = {
  __typename?: 'DeprecatedCorpNavigationCopyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DeprecatedCorpNavigationCopy;
};

/** Identifies documents */
export type DeprecatedCorpNavigationCopyManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DeprecatedCorpNavigationCopyWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DeprecatedCorpNavigationCopyWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DeprecatedCorpNavigationCopyWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardComponentTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardComponentTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardComponentTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardComponentTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardComponentTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardComponentTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardComponentTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardComponentTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardComponentTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardComponentTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardItemtId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardItemtId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardItemtId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardItemtId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardItemtId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardItemtId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardItemtId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardItemtId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardItemtId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardItemtId_starts_with?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<DeprecatedCorpNavigationCopyWhereStageInput>;
  documentInStages_none?: InputMaybe<DeprecatedCorpNavigationCopyWhereStageInput>;
  documentInStages_some?: InputMaybe<DeprecatedCorpNavigationCopyWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  positon?: InputMaybe<NavigationTypes>;
  /** All values that are contained in given list. */
  positon_in?: InputMaybe<Array<InputMaybe<NavigationTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  positon_not?: InputMaybe<NavigationTypes>;
  /** All values that are not contained in given list. */
  positon_not_in?: InputMaybe<Array<InputMaybe<NavigationTypes>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum DeprecatedCorpNavigationCopyOrderByInput {
  cardComponentTitle_ASC = 'cardComponentTitle_ASC',
  cardComponentTitle_DESC = 'cardComponentTitle_DESC',
  cardItemtId_ASC = 'cardItemtId_ASC',
  cardItemtId_DESC = 'cardItemtId_DESC',
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  key_ASC = 'key_ASC',
  key_DESC = 'key_DESC',
  navUrl_ASC = 'navUrl_ASC',
  navUrl_DESC = 'navUrl_DESC',
  positon_ASC = 'positon_ASC',
  positon_DESC = 'positon_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type DeprecatedCorpNavigationCopyUpdateInput = {
  cardComponentTitle?: InputMaybe<Scalars['String']['input']>;
  cardItemtId?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<DeprecatedCorpNavigationCopyUpdateLocalizationsInput>;
  /** navUrl input for default locale (default) */
  navUrl?: InputMaybe<Scalars['String']['input']>;
  positon?: InputMaybe<NavigationTypes>;
};

export type DeprecatedCorpNavigationCopyUpdateLocalizationDataInput = {
  navUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DeprecatedCorpNavigationCopyUpdateLocalizationInput = {
  data: DeprecatedCorpNavigationCopyUpdateLocalizationDataInput;
  locale: Locale;
};

export type DeprecatedCorpNavigationCopyUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<DeprecatedCorpNavigationCopyCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<DeprecatedCorpNavigationCopyUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<DeprecatedCorpNavigationCopyUpsertLocalizationInput>>;
};

export type DeprecatedCorpNavigationCopyUpdateManyInlineInput = {
  /** Connect multiple existing DeprecatedCorpNavigationCopy documents */
  connect?: InputMaybe<Array<DeprecatedCorpNavigationCopyConnectInput>>;
  /** Create and connect multiple DeprecatedCorpNavigationCopy documents */
  create?: InputMaybe<Array<DeprecatedCorpNavigationCopyCreateInput>>;
  /** Delete multiple DeprecatedCorpNavigationCopy documents */
  delete?: InputMaybe<Array<DeprecatedCorpNavigationCopyWhereUniqueInput>>;
  /** Disconnect multiple DeprecatedCorpNavigationCopy documents */
  disconnect?: InputMaybe<Array<DeprecatedCorpNavigationCopyWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing DeprecatedCorpNavigationCopy documents */
  set?: InputMaybe<Array<DeprecatedCorpNavigationCopyWhereUniqueInput>>;
  /** Update multiple DeprecatedCorpNavigationCopy documents */
  update?: InputMaybe<Array<DeprecatedCorpNavigationCopyUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple DeprecatedCorpNavigationCopy documents */
  upsert?: InputMaybe<Array<DeprecatedCorpNavigationCopyUpsertWithNestedWhereUniqueInput>>;
};

export type DeprecatedCorpNavigationCopyUpdateManyInput = {
  cardComponentTitle?: InputMaybe<Scalars['String']['input']>;
  cardItemtId?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<DeprecatedCorpNavigationCopyUpdateManyLocalizationsInput>;
  /** navUrl input for default locale (default) */
  navUrl?: InputMaybe<Scalars['String']['input']>;
  positon?: InputMaybe<NavigationTypes>;
};

export type DeprecatedCorpNavigationCopyUpdateManyLocalizationDataInput = {
  navUrl?: InputMaybe<Scalars['String']['input']>;
};

export type DeprecatedCorpNavigationCopyUpdateManyLocalizationInput = {
  data: DeprecatedCorpNavigationCopyUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type DeprecatedCorpNavigationCopyUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<DeprecatedCorpNavigationCopyUpdateManyLocalizationInput>>;
};

export type DeprecatedCorpNavigationCopyUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DeprecatedCorpNavigationCopyUpdateManyInput;
  /** Document search */
  where: DeprecatedCorpNavigationCopyWhereInput;
};

export type DeprecatedCorpNavigationCopyUpdateOneInlineInput = {
  /** Connect existing DeprecatedCorpNavigationCopy document */
  connect?: InputMaybe<DeprecatedCorpNavigationCopyWhereUniqueInput>;
  /** Create and connect one DeprecatedCorpNavigationCopy document */
  create?: InputMaybe<DeprecatedCorpNavigationCopyCreateInput>;
  /** Delete currently connected DeprecatedCorpNavigationCopy document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected DeprecatedCorpNavigationCopy document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single DeprecatedCorpNavigationCopy document */
  update?: InputMaybe<DeprecatedCorpNavigationCopyUpdateWithNestedWhereUniqueInput>;
  /** Upsert single DeprecatedCorpNavigationCopy document */
  upsert?: InputMaybe<DeprecatedCorpNavigationCopyUpsertWithNestedWhereUniqueInput>;
};

export type DeprecatedCorpNavigationCopyUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DeprecatedCorpNavigationCopyUpdateInput;
  /** Unique document search */
  where: DeprecatedCorpNavigationCopyWhereUniqueInput;
};

export type DeprecatedCorpNavigationCopyUpsertInput = {
  /** Create document if it didn't exist */
  create: DeprecatedCorpNavigationCopyCreateInput;
  /** Update document if it exists */
  update: DeprecatedCorpNavigationCopyUpdateInput;
};

export type DeprecatedCorpNavigationCopyUpsertLocalizationInput = {
  create: DeprecatedCorpNavigationCopyCreateLocalizationDataInput;
  locale: Locale;
  update: DeprecatedCorpNavigationCopyUpdateLocalizationDataInput;
};

export type DeprecatedCorpNavigationCopyUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DeprecatedCorpNavigationCopyUpsertInput;
  /** Unique document search */
  where: DeprecatedCorpNavigationCopyWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type DeprecatedCorpNavigationCopyWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type DeprecatedCorpNavigationCopyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DeprecatedCorpNavigationCopyWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DeprecatedCorpNavigationCopyWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DeprecatedCorpNavigationCopyWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardComponentTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardComponentTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardComponentTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardComponentTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardComponentTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardComponentTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardComponentTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardComponentTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardComponentTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardComponentTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardItemtId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardItemtId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardItemtId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardItemtId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardItemtId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardItemtId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardItemtId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardItemtId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardItemtId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardItemtId_starts_with?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<DeprecatedCorpNavigationCopyWhereStageInput>;
  documentInStages_none?: InputMaybe<DeprecatedCorpNavigationCopyWhereStageInput>;
  documentInStages_some?: InputMaybe<DeprecatedCorpNavigationCopyWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  navUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  navUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  navUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  navUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  navUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  navUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  navUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  navUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  navUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  navUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  positon?: InputMaybe<NavigationTypes>;
  /** All values that are contained in given list. */
  positon_in?: InputMaybe<Array<InputMaybe<NavigationTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  positon_not?: InputMaybe<NavigationTypes>;
  /** All values that are not contained in given list. */
  positon_not_in?: InputMaybe<Array<InputMaybe<NavigationTypes>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type DeprecatedCorpNavigationCopyWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DeprecatedCorpNavigationCopyWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DeprecatedCorpNavigationCopyWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DeprecatedCorpNavigationCopyWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<DeprecatedCorpNavigationCopyWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References DeprecatedCorpNavigationCopy record uniquely */
export type DeprecatedCorpNavigationCopyWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Dictionary model for storing localized text */
export type Dictionary = Entity & Node & {
  __typename?: 'Dictionary';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  dictionaryItems: Array<DictionaryItem>;
  /** CMS only title to identify the dictorionary */
  dictionaryTitle?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<Dictionary>;
  genericPage: Array<GenericPage>;
  /** List of Dictionary versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Dictionary model for storing localized text */
export type DictionaryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Dictionary model for storing localized text */
export type DictionaryDictionaryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<DictionaryItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DictionaryItemWhereInput>;
};


/** Dictionary model for storing localized text */
export type DictionaryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Dictionary model for storing localized text */
export type DictionaryGenericPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Dictionary model for storing localized text */
export type DictionaryHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Dictionary model for storing localized text */
export type DictionaryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Dictionary model for storing localized text */
export type DictionaryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Dictionary model for storing localized text */
export type DictionaryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DictionaryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DictionaryWhereUniqueInput;
};

/** A connection to a list of items. */
export type DictionaryConnection = {
  __typename?: 'DictionaryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DictionaryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DictionaryCreateInput = {
  cktjtnwfe0j5q01zcac3d3j8s?: InputMaybe<TipsAndTricksDetailsPageCreateManyInlineInput>;
  cktvf9o1h1hfa01w50nrv83bt?: InputMaybe<SearchResultPageCreateManyInlineInput>;
  cku2qtdbw5nrp01yugt2q4v7n?: InputMaybe<FeaturedContentCreateManyInlineInput>;
  ckuezsmdk837b01xh3bezdg9w?: InputMaybe<SearchOverlayComponentCreateManyInlineInput>;
  ckumn1va03ixc01z6ezqq6pkh?: InputMaybe<GenericGridAuthorableCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionaryItems?: InputMaybe<DictionaryItemCreateManyInlineInput>;
  dictionaryTitle?: InputMaybe<Scalars['String']['input']>;
  genericPage?: InputMaybe<GenericPageCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DictionaryCreateManyInlineInput = {
  /** Connect multiple existing Dictionary documents */
  connect?: InputMaybe<Array<DictionaryWhereUniqueInput>>;
  /** Create and connect multiple existing Dictionary documents */
  create?: InputMaybe<Array<DictionaryCreateInput>>;
};

export type DictionaryCreateOneInlineInput = {
  /** Connect one existing Dictionary document */
  connect?: InputMaybe<DictionaryWhereUniqueInput>;
  /** Create and connect one Dictionary document */
  create?: InputMaybe<DictionaryCreateInput>;
};

/** An edge in a connection. */
export type DictionaryEdge = {
  __typename?: 'DictionaryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Dictionary;
};

/** Dictionary Item as key - value pair */
export type DictionaryItem = Entity & Node & {
  __typename?: 'DictionaryItem';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<DictionaryItem>;
  dynamicCardGrid?: Maybe<DynamicCardGrid>;
  genericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** List of DictionaryItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /**
   * Pattern for Key field is snake case of EN version.
   * For example text "For the cake" should have key "for_the_cake".
   */
  key: Scalars['String']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<DictionaryItem>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  value: Scalars['String']['output'];
};


/** Dictionary Item as key - value pair */
export type DictionaryItemCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemDynamicCardGridArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemGenericCardCarouseComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Dictionary Item as key - value pair */
export type DictionaryItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DictionaryItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DictionaryItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type DictionaryItemConnection = {
  __typename?: 'DictionaryItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DictionaryItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DictionaryItemCreateInput = {
  cktlcv3n00xgd01xxdxlwh2gx?: InputMaybe<DictionaryCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dynamicCardGrid?: InputMaybe<DynamicCardGridCreateOneInlineInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateOneInlineInput>;
  key: Scalars['String']['input'];
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<DictionaryItemCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** value input for default locale (default) */
  value: Scalars['String']['input'];
};

export type DictionaryItemCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
};

export type DictionaryItemCreateLocalizationInput = {
  /** Localization input */
  data: DictionaryItemCreateLocalizationDataInput;
  locale: Locale;
};

export type DictionaryItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<DictionaryItemCreateLocalizationInput>>;
};

export type DictionaryItemCreateManyInlineInput = {
  /** Connect multiple existing DictionaryItem documents */
  connect?: InputMaybe<Array<DictionaryItemWhereUniqueInput>>;
  /** Create and connect multiple existing DictionaryItem documents */
  create?: InputMaybe<Array<DictionaryItemCreateInput>>;
};

export type DictionaryItemCreateOneInlineInput = {
  /** Connect one existing DictionaryItem document */
  connect?: InputMaybe<DictionaryItemWhereUniqueInput>;
  /** Create and connect one DictionaryItem document */
  create?: InputMaybe<DictionaryItemCreateInput>;
};

/** An edge in a connection. */
export type DictionaryItemEdge = {
  __typename?: 'DictionaryItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DictionaryItem;
};

/** Identifies documents */
export type DictionaryItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DictionaryItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DictionaryItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DictionaryItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<DictionaryItemWhereStageInput>;
  documentInStages_none?: InputMaybe<DictionaryItemWhereStageInput>;
  documentInStages_some?: InputMaybe<DictionaryItemWhereStageInput>;
  dynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum DictionaryItemOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  key_ASC = 'key_ASC',
  key_DESC = 'key_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type DictionaryItemUpdateInput = {
  cktlcv3n00xgd01xxdxlwh2gx?: InputMaybe<DictionaryUpdateManyInlineInput>;
  dynamicCardGrid?: InputMaybe<DynamicCardGridUpdateOneInlineInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateOneInlineInput>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<DictionaryItemUpdateLocalizationsInput>;
  /** value input for default locale (default) */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DictionaryItemUpdateLocalizationDataInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DictionaryItemUpdateLocalizationInput = {
  data: DictionaryItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type DictionaryItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<DictionaryItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<DictionaryItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<DictionaryItemUpsertLocalizationInput>>;
};

export type DictionaryItemUpdateManyInlineInput = {
  /** Connect multiple existing DictionaryItem documents */
  connect?: InputMaybe<Array<DictionaryItemConnectInput>>;
  /** Create and connect multiple DictionaryItem documents */
  create?: InputMaybe<Array<DictionaryItemCreateInput>>;
  /** Delete multiple DictionaryItem documents */
  delete?: InputMaybe<Array<DictionaryItemWhereUniqueInput>>;
  /** Disconnect multiple DictionaryItem documents */
  disconnect?: InputMaybe<Array<DictionaryItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing DictionaryItem documents */
  set?: InputMaybe<Array<DictionaryItemWhereUniqueInput>>;
  /** Update multiple DictionaryItem documents */
  update?: InputMaybe<Array<DictionaryItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple DictionaryItem documents */
  upsert?: InputMaybe<Array<DictionaryItemUpsertWithNestedWhereUniqueInput>>;
};

export type DictionaryItemUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<DictionaryItemUpdateManyLocalizationsInput>;
  /** value input for default locale (default) */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DictionaryItemUpdateManyLocalizationDataInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export type DictionaryItemUpdateManyLocalizationInput = {
  data: DictionaryItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type DictionaryItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<DictionaryItemUpdateManyLocalizationInput>>;
};

export type DictionaryItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DictionaryItemUpdateManyInput;
  /** Document search */
  where: DictionaryItemWhereInput;
};

export type DictionaryItemUpdateOneInlineInput = {
  /** Connect existing DictionaryItem document */
  connect?: InputMaybe<DictionaryItemWhereUniqueInput>;
  /** Create and connect one DictionaryItem document */
  create?: InputMaybe<DictionaryItemCreateInput>;
  /** Delete currently connected DictionaryItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected DictionaryItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single DictionaryItem document */
  update?: InputMaybe<DictionaryItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single DictionaryItem document */
  upsert?: InputMaybe<DictionaryItemUpsertWithNestedWhereUniqueInput>;
};

export type DictionaryItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DictionaryItemUpdateInput;
  /** Unique document search */
  where: DictionaryItemWhereUniqueInput;
};

export type DictionaryItemUpsertInput = {
  /** Create document if it didn't exist */
  create: DictionaryItemCreateInput;
  /** Update document if it exists */
  update: DictionaryItemUpdateInput;
};

export type DictionaryItemUpsertLocalizationInput = {
  create: DictionaryItemCreateLocalizationDataInput;
  locale: Locale;
  update: DictionaryItemUpdateLocalizationDataInput;
};

export type DictionaryItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DictionaryItemUpsertInput;
  /** Unique document search */
  where: DictionaryItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type DictionaryItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type DictionaryItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DictionaryItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DictionaryItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DictionaryItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<DictionaryItemWhereStageInput>;
  documentInStages_none?: InputMaybe<DictionaryItemWhereStageInput>;
  documentInStages_some?: InputMaybe<DictionaryItemWhereStageInput>;
  dynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  value?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  value_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type DictionaryItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DictionaryItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DictionaryItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DictionaryItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<DictionaryItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References DictionaryItem record uniquely */
export type DictionaryItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies documents */
export type DictionaryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DictionaryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DictionaryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DictionaryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaryItems_every?: InputMaybe<DictionaryItemWhereInput>;
  dictionaryItems_none?: InputMaybe<DictionaryItemWhereInput>;
  dictionaryItems_some?: InputMaybe<DictionaryItemWhereInput>;
  dictionaryTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dictionaryTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dictionaryTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dictionaryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dictionaryTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dictionaryTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dictionaryTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dictionaryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dictionaryTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dictionaryTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<DictionaryWhereStageInput>;
  documentInStages_none?: InputMaybe<DictionaryWhereStageInput>;
  documentInStages_some?: InputMaybe<DictionaryWhereStageInput>;
  genericPage_every?: InputMaybe<GenericPageWhereInput>;
  genericPage_none?: InputMaybe<GenericPageWhereInput>;
  genericPage_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum DictionaryOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  dictionaryTitle_ASC = 'dictionaryTitle_ASC',
  dictionaryTitle_DESC = 'dictionaryTitle_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type DictionaryUpdateInput = {
  cktjtnwfe0j5q01zcac3d3j8s?: InputMaybe<TipsAndTricksDetailsPageUpdateManyInlineInput>;
  cktvf9o1h1hfa01w50nrv83bt?: InputMaybe<SearchResultPageUpdateManyInlineInput>;
  cku2qtdbw5nrp01yugt2q4v7n?: InputMaybe<FeaturedContentUpdateManyInlineInput>;
  ckuezsmdk837b01xh3bezdg9w?: InputMaybe<SearchOverlayComponentUpdateManyInlineInput>;
  ckumn1va03ixc01z6ezqq6pkh?: InputMaybe<GenericGridAuthorableUpdateManyInlineInput>;
  dictionaryItems?: InputMaybe<DictionaryItemUpdateManyInlineInput>;
  dictionaryTitle?: InputMaybe<Scalars['String']['input']>;
  genericPage?: InputMaybe<GenericPageUpdateManyInlineInput>;
};

export type DictionaryUpdateManyInlineInput = {
  /** Connect multiple existing Dictionary documents */
  connect?: InputMaybe<Array<DictionaryConnectInput>>;
  /** Create and connect multiple Dictionary documents */
  create?: InputMaybe<Array<DictionaryCreateInput>>;
  /** Delete multiple Dictionary documents */
  delete?: InputMaybe<Array<DictionaryWhereUniqueInput>>;
  /** Disconnect multiple Dictionary documents */
  disconnect?: InputMaybe<Array<DictionaryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Dictionary documents */
  set?: InputMaybe<Array<DictionaryWhereUniqueInput>>;
  /** Update multiple Dictionary documents */
  update?: InputMaybe<Array<DictionaryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Dictionary documents */
  upsert?: InputMaybe<Array<DictionaryUpsertWithNestedWhereUniqueInput>>;
};

export type DictionaryUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type DictionaryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DictionaryUpdateManyInput;
  /** Document search */
  where: DictionaryWhereInput;
};

export type DictionaryUpdateOneInlineInput = {
  /** Connect existing Dictionary document */
  connect?: InputMaybe<DictionaryWhereUniqueInput>;
  /** Create and connect one Dictionary document */
  create?: InputMaybe<DictionaryCreateInput>;
  /** Delete currently connected Dictionary document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Dictionary document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Dictionary document */
  update?: InputMaybe<DictionaryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Dictionary document */
  upsert?: InputMaybe<DictionaryUpsertWithNestedWhereUniqueInput>;
};

export type DictionaryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DictionaryUpdateInput;
  /** Unique document search */
  where: DictionaryWhereUniqueInput;
};

export type DictionaryUpsertInput = {
  /** Create document if it didn't exist */
  create: DictionaryCreateInput;
  /** Update document if it exists */
  update: DictionaryUpdateInput;
};

export type DictionaryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DictionaryUpsertInput;
  /** Unique document search */
  where: DictionaryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type DictionaryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type DictionaryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DictionaryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DictionaryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DictionaryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaryItems_every?: InputMaybe<DictionaryItemWhereInput>;
  dictionaryItems_none?: InputMaybe<DictionaryItemWhereInput>;
  dictionaryItems_some?: InputMaybe<DictionaryItemWhereInput>;
  dictionaryTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  dictionaryTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  dictionaryTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  dictionaryTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  dictionaryTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  dictionaryTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  dictionaryTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  dictionaryTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  dictionaryTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  dictionaryTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<DictionaryWhereStageInput>;
  documentInStages_none?: InputMaybe<DictionaryWhereStageInput>;
  documentInStages_some?: InputMaybe<DictionaryWhereStageInput>;
  genericPage_every?: InputMaybe<GenericPageWhereInput>;
  genericPage_none?: InputMaybe<GenericPageWhereInput>;
  genericPage_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type DictionaryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DictionaryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DictionaryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DictionaryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<DictionaryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Dictionary record uniquely */
export type DictionaryWhereUniqueInput = {
  dictionaryTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Postion  */
export enum DisplayPosition {
  Left = 'Left',
  Right = 'Right',
  Top = 'Top'
}

export enum DocumentFileTypes {
  /** Automatically selects the best format for the image based on the browser's capabilities. */
  autoImage = 'autoImage',
  avif = 'avif',
  bmp = 'bmp',
  gif = 'gif',
  heic = 'heic',
  jpg = 'jpg',
  png = 'png',
  svg = 'svg',
  tiff = 'tiff',
  webp = 'webp'
}

export type DocumentOutputInput = {
  /**
   * Transforms a document into a desired file type.
   * See this matrix for format support:
   *
   * JPG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * PNG:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * SVG:	autoImage, bmp, gif, jpg, png, webp, tiff
   * WEBP:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * GIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * TIFF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * AVIF:	autoImage, bmp, gif, jpg, png, webp, tiff, svg
   * PDF: 	autoImage, gif, jpg, png, webp, tiff
   *
   */
  format?: InputMaybe<DocumentFileTypes>;
};

/** Transformations for Documents */
export type DocumentTransformationInput = {
  /** Changes the output for the file. */
  output?: InputMaybe<DocumentOutputInput>;
};

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['Json']['output']>;
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  stage: Stage;
};

export type DynamicCardGrid = Entity & Node & {
  __typename?: 'DynamicCardGrid';
  anchorNav?: Maybe<AnchorNavigation>;
  cardLinkLabel?: Maybe<Scalars['String']['output']>;
  cardVariation?: Maybe<CardVariation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  dictionaryItem: Array<DynamicCardGridDictionaryItem>;
  /** Get the document in other stages */
  documentInStages: Array<DynamicCardGrid>;
  extension?: Maybe<AlgoliaExtension>;
  genericPages: Array<GenericPage>;
  gridCta?: Maybe<Link>;
  heading?: Maybe<Scalars['String']['output']>;
  /** List of DynamicCardGrid versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<DynamicCardGrid>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** Number of cards */
  showCards?: Maybe<Scalars['Int']['output']>;
  /** System stage field */
  stage: Stage;
  /** Sub Heading */
  subHeading?: Maybe<Scalars['String']['output']>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type DynamicCardGridAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DynamicCardGridCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type DynamicCardGridCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DynamicCardGridDictionaryItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type DynamicCardGridDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type DynamicCardGridExtensionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DynamicCardGridGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type DynamicCardGridGridCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DynamicCardGridHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type DynamicCardGridLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type DynamicCardGridPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type DynamicCardGridPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DynamicCardGridScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type DynamicCardGridTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type DynamicCardGridUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type DynamicCardGridUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type DynamicCardGridConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: DynamicCardGridWhereUniqueInput;
};

/** A connection to a list of items. */
export type DynamicCardGridConnection = {
  __typename?: 'DynamicCardGridConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<DynamicCardGridEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type DynamicCardGridCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  /** cardLinkLabel input for default locale (default) */
  cardLinkLabel?: InputMaybe<Scalars['String']['input']>;
  cardVariation?: InputMaybe<CardVariation>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  dictionaryItem?: InputMaybe<DynamicCardGridDictionaryItemCreateManyInlineInput>;
  extension?: InputMaybe<AlgoliaExtensionCreateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  gridCta?: InputMaybe<LinkCreateOneInlineInput>;
  /** heading input for default locale (default) */
  heading?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<DynamicCardGridCreateLocalizationsInput>;
  showCards?: InputMaybe<Scalars['Int']['input']>;
  /** subHeading input for default locale (default) */
  subHeading?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DynamicCardGridCreateLocalizationDataInput = {
  cardLinkLabel?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DynamicCardGridCreateLocalizationInput = {
  /** Localization input */
  data: DynamicCardGridCreateLocalizationDataInput;
  locale: Locale;
};

export type DynamicCardGridCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<DynamicCardGridCreateLocalizationInput>>;
};

export type DynamicCardGridCreateManyInlineInput = {
  /** Connect multiple existing DynamicCardGrid documents */
  connect?: InputMaybe<Array<DynamicCardGridWhereUniqueInput>>;
  /** Create and connect multiple existing DynamicCardGrid documents */
  create?: InputMaybe<Array<DynamicCardGridCreateInput>>;
};

export type DynamicCardGridCreateOneInlineInput = {
  /** Connect one existing DynamicCardGrid document */
  connect?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  /** Create and connect one DynamicCardGrid document */
  create?: InputMaybe<DynamicCardGridCreateInput>;
};

export type DynamicCardGridDictionaryItem = DictionaryItem;

export type DynamicCardGridDictionaryItemConnectInput = {
  DictionaryItem?: InputMaybe<DictionaryItemConnectInput>;
};

export type DynamicCardGridDictionaryItemCreateInput = {
  DictionaryItem?: InputMaybe<DictionaryItemCreateInput>;
};

export type DynamicCardGridDictionaryItemCreateManyInlineInput = {
  /** Connect multiple existing DynamicCardGridDictionaryItem documents */
  connect?: InputMaybe<Array<DynamicCardGridDictionaryItemWhereUniqueInput>>;
  /** Create and connect multiple existing DynamicCardGridDictionaryItem documents */
  create?: InputMaybe<Array<DynamicCardGridDictionaryItemCreateInput>>;
};

export type DynamicCardGridDictionaryItemCreateOneInlineInput = {
  /** Connect one existing DynamicCardGridDictionaryItem document */
  connect?: InputMaybe<DynamicCardGridDictionaryItemWhereUniqueInput>;
  /** Create and connect one DynamicCardGridDictionaryItem document */
  create?: InputMaybe<DynamicCardGridDictionaryItemCreateInput>;
};

export type DynamicCardGridDictionaryItemUpdateInput = {
  DictionaryItem?: InputMaybe<DictionaryItemUpdateInput>;
};

export type DynamicCardGridDictionaryItemUpdateManyInlineInput = {
  /** Connect multiple existing DynamicCardGridDictionaryItem documents */
  connect?: InputMaybe<Array<DynamicCardGridDictionaryItemConnectInput>>;
  /** Create and connect multiple DynamicCardGridDictionaryItem documents */
  create?: InputMaybe<Array<DynamicCardGridDictionaryItemCreateInput>>;
  /** Delete multiple DynamicCardGridDictionaryItem documents */
  delete?: InputMaybe<Array<DynamicCardGridDictionaryItemWhereUniqueInput>>;
  /** Disconnect multiple DynamicCardGridDictionaryItem documents */
  disconnect?: InputMaybe<Array<DynamicCardGridDictionaryItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing DynamicCardGridDictionaryItem documents */
  set?: InputMaybe<Array<DynamicCardGridDictionaryItemWhereUniqueInput>>;
  /** Update multiple DynamicCardGridDictionaryItem documents */
  update?: InputMaybe<Array<DynamicCardGridDictionaryItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple DynamicCardGridDictionaryItem documents */
  upsert?: InputMaybe<Array<DynamicCardGridDictionaryItemUpsertWithNestedWhereUniqueInput>>;
};

export type DynamicCardGridDictionaryItemUpdateManyWithNestedWhereInput = {
  DictionaryItem?: InputMaybe<DictionaryItemUpdateManyWithNestedWhereInput>;
};

export type DynamicCardGridDictionaryItemUpdateOneInlineInput = {
  /** Connect existing DynamicCardGridDictionaryItem document */
  connect?: InputMaybe<DynamicCardGridDictionaryItemWhereUniqueInput>;
  /** Create and connect one DynamicCardGridDictionaryItem document */
  create?: InputMaybe<DynamicCardGridDictionaryItemCreateInput>;
  /** Delete currently connected DynamicCardGridDictionaryItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected DynamicCardGridDictionaryItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single DynamicCardGridDictionaryItem document */
  update?: InputMaybe<DynamicCardGridDictionaryItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single DynamicCardGridDictionaryItem document */
  upsert?: InputMaybe<DynamicCardGridDictionaryItemUpsertWithNestedWhereUniqueInput>;
};

export type DynamicCardGridDictionaryItemUpdateWithNestedWhereUniqueInput = {
  DictionaryItem?: InputMaybe<DictionaryItemUpdateWithNestedWhereUniqueInput>;
};

export type DynamicCardGridDictionaryItemUpsertWithNestedWhereUniqueInput = {
  DictionaryItem?: InputMaybe<DictionaryItemUpsertWithNestedWhereUniqueInput>;
};

export type DynamicCardGridDictionaryItemWhereInput = {
  DictionaryItem?: InputMaybe<DictionaryItemWhereInput>;
};

export type DynamicCardGridDictionaryItemWhereUniqueInput = {
  DictionaryItem?: InputMaybe<DictionaryItemWhereUniqueInput>;
};

/** An edge in a connection. */
export type DynamicCardGridEdge = {
  __typename?: 'DynamicCardGridEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DynamicCardGrid;
};

/** Identifies documents */
export type DynamicCardGridManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DynamicCardGridWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DynamicCardGridWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DynamicCardGridWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cardVariation?: InputMaybe<CardVariation>;
  /** All values that are contained in given list. */
  cardVariation_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardVariation_not?: InputMaybe<CardVariation>;
  /** All values that are not contained in given list. */
  cardVariation_not_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  /** All values in which the union is empty */
  dictionaryItem_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  dictionaryItem_some?: InputMaybe<DynamicCardGridDictionaryItemWhereInput>;
  documentInStages_every?: InputMaybe<DynamicCardGridWhereStageInput>;
  documentInStages_none?: InputMaybe<DynamicCardGridWhereStageInput>;
  documentInStages_some?: InputMaybe<DynamicCardGridWhereStageInput>;
  extension?: InputMaybe<AlgoliaExtensionWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  gridCta?: InputMaybe<LinkWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showCards?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  showCards_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  showCards_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  showCards_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  showCards_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  showCards_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showCards_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  showCards_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum DynamicCardGridOrderByInput {
  cardLinkLabel_ASC = 'cardLinkLabel_ASC',
  cardLinkLabel_DESC = 'cardLinkLabel_DESC',
  cardVariation_ASC = 'cardVariation_ASC',
  cardVariation_DESC = 'cardVariation_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  showCards_ASC = 'showCards_ASC',
  showCards_DESC = 'showCards_DESC',
  subHeading_ASC = 'subHeading_ASC',
  subHeading_DESC = 'subHeading_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type DynamicCardGridUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  /** cardLinkLabel input for default locale (default) */
  cardLinkLabel?: InputMaybe<Scalars['String']['input']>;
  cardVariation?: InputMaybe<CardVariation>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  dictionaryItem?: InputMaybe<DynamicCardGridDictionaryItemUpdateManyInlineInput>;
  extension?: InputMaybe<AlgoliaExtensionUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  gridCta?: InputMaybe<LinkUpdateOneInlineInput>;
  /** heading input for default locale (default) */
  heading?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<DynamicCardGridUpdateLocalizationsInput>;
  showCards?: InputMaybe<Scalars['Int']['input']>;
  /** subHeading input for default locale (default) */
  subHeading?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type DynamicCardGridUpdateLocalizationDataInput = {
  cardLinkLabel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type DynamicCardGridUpdateLocalizationInput = {
  data: DynamicCardGridUpdateLocalizationDataInput;
  locale: Locale;
};

export type DynamicCardGridUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<DynamicCardGridCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<DynamicCardGridUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<DynamicCardGridUpsertLocalizationInput>>;
};

export type DynamicCardGridUpdateManyInlineInput = {
  /** Connect multiple existing DynamicCardGrid documents */
  connect?: InputMaybe<Array<DynamicCardGridConnectInput>>;
  /** Create and connect multiple DynamicCardGrid documents */
  create?: InputMaybe<Array<DynamicCardGridCreateInput>>;
  /** Delete multiple DynamicCardGrid documents */
  delete?: InputMaybe<Array<DynamicCardGridWhereUniqueInput>>;
  /** Disconnect multiple DynamicCardGrid documents */
  disconnect?: InputMaybe<Array<DynamicCardGridWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing DynamicCardGrid documents */
  set?: InputMaybe<Array<DynamicCardGridWhereUniqueInput>>;
  /** Update multiple DynamicCardGrid documents */
  update?: InputMaybe<Array<DynamicCardGridUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple DynamicCardGrid documents */
  upsert?: InputMaybe<Array<DynamicCardGridUpsertWithNestedWhereUniqueInput>>;
};

export type DynamicCardGridUpdateManyInput = {
  /** cardLinkLabel input for default locale (default) */
  cardLinkLabel?: InputMaybe<Scalars['String']['input']>;
  cardVariation?: InputMaybe<CardVariation>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** heading input for default locale (default) */
  heading?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<DynamicCardGridUpdateManyLocalizationsInput>;
  showCards?: InputMaybe<Scalars['Int']['input']>;
  /** subHeading input for default locale (default) */
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type DynamicCardGridUpdateManyLocalizationDataInput = {
  cardLinkLabel?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type DynamicCardGridUpdateManyLocalizationInput = {
  data: DynamicCardGridUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type DynamicCardGridUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<DynamicCardGridUpdateManyLocalizationInput>>;
};

export type DynamicCardGridUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: DynamicCardGridUpdateManyInput;
  /** Document search */
  where: DynamicCardGridWhereInput;
};

export type DynamicCardGridUpdateOneInlineInput = {
  /** Connect existing DynamicCardGrid document */
  connect?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  /** Create and connect one DynamicCardGrid document */
  create?: InputMaybe<DynamicCardGridCreateInput>;
  /** Delete currently connected DynamicCardGrid document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected DynamicCardGrid document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single DynamicCardGrid document */
  update?: InputMaybe<DynamicCardGridUpdateWithNestedWhereUniqueInput>;
  /** Upsert single DynamicCardGrid document */
  upsert?: InputMaybe<DynamicCardGridUpsertWithNestedWhereUniqueInput>;
};

export type DynamicCardGridUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: DynamicCardGridUpdateInput;
  /** Unique document search */
  where: DynamicCardGridWhereUniqueInput;
};

export type DynamicCardGridUpsertInput = {
  /** Create document if it didn't exist */
  create: DynamicCardGridCreateInput;
  /** Update document if it exists */
  update: DynamicCardGridUpdateInput;
};

export type DynamicCardGridUpsertLocalizationInput = {
  create: DynamicCardGridCreateLocalizationDataInput;
  locale: Locale;
  update: DynamicCardGridUpdateLocalizationDataInput;
};

export type DynamicCardGridUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: DynamicCardGridUpsertInput;
  /** Unique document search */
  where: DynamicCardGridWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type DynamicCardGridWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type DynamicCardGridWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DynamicCardGridWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DynamicCardGridWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DynamicCardGridWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cardLinkLabel?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardLinkLabel_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardLinkLabel_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardLinkLabel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardLinkLabel_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardLinkLabel_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardLinkLabel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardLinkLabel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardLinkLabel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardLinkLabel_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardVariation?: InputMaybe<CardVariation>;
  /** All values that are contained in given list. */
  cardVariation_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardVariation_not?: InputMaybe<CardVariation>;
  /** All values that are not contained in given list. */
  cardVariation_not_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  dictionaryItem_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  dictionaryItem_some?: InputMaybe<DynamicCardGridDictionaryItemWhereInput>;
  documentInStages_every?: InputMaybe<DynamicCardGridWhereStageInput>;
  documentInStages_none?: InputMaybe<DynamicCardGridWhereStageInput>;
  documentInStages_some?: InputMaybe<DynamicCardGridWhereStageInput>;
  extension?: InputMaybe<AlgoliaExtensionWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  gridCta?: InputMaybe<LinkWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showCards?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  showCards_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  showCards_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  showCards_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  showCards_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  showCards_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showCards_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  showCards_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type DynamicCardGridWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<DynamicCardGridWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<DynamicCardGridWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<DynamicCardGridWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<DynamicCardGridWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References DynamicCardGrid record uniquely */
export type DynamicCardGridWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** An object with an ID */
export type Entity = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

/** This enumeration holds all typenames that implement the Entity interface. Components and models implement the Entity interface. */
export enum EntityTypeName {
  /** Accordion */
  Accordion = 'Accordion',
  /** Accordion Item */
  AccordionItem = 'AccordionItem',
  AlexTestComponent = 'AlexTestComponent',
  AlgoliaExtension = 'AlgoliaExtension',
  /** this will be deprecated soon */
  AnchorNav = 'AnchorNav',
  /** used to author anchor navigations for each page */
  AnchorNavigation = 'AnchorNavigation',
  /** list of all anchor navigation lists that should appear on a page */
  AnchorNavigationList = 'AnchorNavigationList',
  /** Asset system model */
  Asset = 'Asset',
  /** Asset component to be used to create image pool of reusable assets across the application */
  AssetComponent = 'AssetComponent',
  AudioComponent = 'AudioComponent',
  AuthorableContentCard = 'AuthorableContentCard',
  /** Banner2 with image and text and placement options */
  Banner2 = 'Banner2',
  BigNumber = 'BigNumber',
  BigNumberItem = 'BigNumberItem',
  /** Card Component */
  CardComponent = 'CardComponent',
  CarouselComponent = 'CarouselComponent',
  CarouselSlide = 'CarouselSlide',
  CategoryCard = 'CategoryCard',
  /** Contact card */
  ContactCard = 'ContactCard',
  /** Container for all the contact cards */
  ContactCardContainer = 'ContactCardContainer',
  CorpAddToCalendar = 'CorpAddToCalendar',
  /** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
  CorpBanner1 = 'CorpBanner1',
  CorpCalendarEvent = 'CorpCalendarEvent',
  CorpCardCarousel = 'CorpCardCarousel',
  CorpContactCard = 'CorpContactCard',
  CorpContactCardContainer = 'CorpContactCardContainer',
  CorpForm = 'CorpForm',
  CorpGenericAccordion = 'CorpGenericAccordion',
  CorpGenericAccordionItem = 'CorpGenericAccordionItem',
  /** Corp Generic Banner */
  CorpGenericBanner = 'CorpGenericBanner',
  /** Container to visually constrain components horizontally (make sure things don't go full width) */
  CorpGenericContainer = 'CorpGenericContainer',
  CorpGridColumnComponent = 'CorpGridColumnComponent',
  /** Corp Hero */
  CorpHero = 'CorpHero',
  CorpLongTextComponent = 'CorpLongTextComponent',
  CorpMediaDownloadPreview = 'CorpMediaDownloadPreview',
  /** First level entry for main navigation */
  CorpNavigation = 'CorpNavigation',
  /** Second level entry for corp navigation */
  CorpNavigationItem = 'CorpNavigationItem',
  CorpNotificationBanner = 'CorpNotificationBanner',
  CorpOurPeople = 'CorpOurPeople',
  CorpOurPeopleItem = 'CorpOurPeopleItem',
  /** Should only have 1 item */
  CorpPressPage = 'CorpPressPage',
  CorpSocialMediaFooter = 'CorpSocialMediaFooter',
  /** Should only have 1 item */
  CorpStoriesPage = 'CorpStoriesPage',
  CorpStoryCarousel = 'CorpStoryCarousel',
  CorpTimelineAccordion = 'CorpTimelineAccordion',
  CorpTimelineAccordionItem = 'CorpTimelineAccordionItem',
  /** Wrapper containing multiple Timeline Accordions. */
  CorpTimelineAccordionWrapper = 'CorpTimelineAccordionWrapper',
  CorpVideoHero = 'CorpVideoHero',
  CorpVideoHeroCarousel = 'CorpVideoHeroCarousel',
  /** Country Selector Component */
  CountrySelector = 'CountrySelector',
  /** Country Selector Country List */
  CountrySelectorItem = 'CountrySelectorItem',
  /** Generic Banner 1 component - This banner includes text with a CTA to help lead the user to discover more.  */
  DEPRECATEDBanner1 = 'DEPRECATEDBanner1',
  /** Deprecated - Contains a list of corporate navigation items (e.g. Main navigation menu items) */
  DeprecatedCorpNavigationCopy = 'DeprecatedCorpNavigationCopy',
  /** Dictionary model for storing localized text */
  Dictionary = 'Dictionary',
  /** Dictionary Item as key - value pair */
  DictionaryItem = 'DictionaryItem',
  DynamicCardGrid = 'DynamicCardGrid',
  EvalancheFormComponent = 'EvalancheFormComponent',
  /** Title to be used to find the contents in the CMS */
  ExampleComponent = 'ExampleComponent',
  /** Featured content on a page in a prominent banner / carousel */
  FeaturedContent = 'FeaturedContent',
  FeaturedContentReference = 'FeaturedContentReference',
  /** Footer Navigation */
  FooterNavigation = 'FooterNavigation',
  Form = 'Form',
  FormCheckbox = 'FormCheckbox',
  FormEmailInput = 'FormEmailInput',
  FormError = 'FormError',
  FormPasswordInput = 'FormPasswordInput',
  FormPasswordInputWithConfirmation = 'FormPasswordInputWithConfirmation',
  FormRadioButton = 'FormRadioButton',
  FormRadioButtonCollection = 'FormRadioButtonCollection',
  FormSelectComponent = 'FormSelectComponent',
  FormSelectOption = 'FormSelectOption',
  FormSubmitButton = 'FormSubmitButton',
  FormSuccessComponent = 'FormSuccessComponent',
  FormTextInput = 'FormTextInput',
  FormTextareaInput = 'FormTextareaInput',
  GenericAccordion = 'GenericAccordion',
  GenericAccordionItem = 'GenericAccordionItem',
  GenericAccordionTopRated = 'GenericAccordionTopRated',
  GenericCardCarouseComponent = 'GenericCardCarouseComponent',
  /** documents that are available for download can be configured here, so that user can download them.  */
  GenericDownloadComponent = 'GenericDownloadComponent',
  GenericFollowUs = 'GenericFollowUs',
  /** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
  GenericGridAuthorable = 'GenericGridAuthorable',
  GenericLine = 'GenericLine',
  GenericLink = 'GenericLink',
  GenericPage = 'GenericPage',
  /** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
  GlobalMetaData = 'GlobalMetaData',
  /** Hero Banners are chosen to be displayed in the Hero Carousel Component */
  HeroBanner = 'HeroBanner',
  /** Carousel component for page hero's */
  HeroCarouselComponent = 'HeroCarouselComponent',
  /** Page header (can be a picture and in some pages even a video). */
  HeroComponent = 'HeroComponent',
  /**
   * Home page template to be used for each market
   *
   */
  HomePage = 'HomePage',
  /** Content type for adding an iframe to a page */
  Iframe = 'Iframe',
  ImageAndTextCard = 'ImageAndTextCard',
  /** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
  ImageCopy = 'ImageCopy',
  ImageCopyItem = 'ImageCopyItem',
  /** Introductory text for quick overview of the page */
  IntroText = 'IntroText',
  LeftColumn = 'LeftColumn',
  Link = 'Link',
  /** Component to show all company locations */
  LocationComponent = 'LocationComponent',
  /** Single location */
  LocationItem = 'LocationItem',
  LongText = 'LongText',
  /** Should only have 1 item */
  MediaLibrary = 'MediaLibrary',
  /** Media that can be downloaded on the press media page */
  MediaLibraryItem = 'MediaLibraryItem',
  /** Page Meta Data Component used on every page for SEO */
  MetaData = 'MetaData',
  MobileOnlyMainNavigation = 'MobileOnlyMainNavigation',
  /** Contains a list of navigation items (e.g. Main navigation menu items) */
  Navigation = 'Navigation',
  NavigationItem = 'NavigationItem',
  NotificationBanner = 'NotificationBanner',
  PageFooter = 'PageFooter',
  PageHeader = 'PageHeader',
  PopularSearchComponent = 'PopularSearchComponent',
  /** Corporate Press Releases */
  PressRelease = 'PressRelease',
  PressStoriesCard = 'PressStoriesCard',
  ProgressBar = 'ProgressBar',
  QuickLink = 'QuickLink',
  QuickLinkItem = 'QuickLinkItem',
  Redirect = 'Redirect',
  Rewrite = 'Rewrite',
  RightColumn = 'RightColumn',
  /** Scheduled Operation system model */
  ScheduledOperation = 'ScheduledOperation',
  /** Scheduled Release system model */
  ScheduledRelease = 'ScheduledRelease',
  SearchInput = 'SearchInput',
  SearchOverlayComponent = 'SearchOverlayComponent',
  SearchResultPage = 'SearchResultPage',
  /** Blue curve that can be placed at the beginning of a page */
  ShortHero = 'ShortHero',
  SocialMediaListComponent = 'SocialMediaListComponent',
  /** Empty spacer block  */
  Spacer = 'Spacer',
  /** Corporate Stories */
  Story = 'Story',
  SubCategoryKeyImage = 'SubCategoryKeyImage',
  /** Banner for sustainability teaser information */
  SustainabilityBanner = 'SustainabilityBanner',
  /** Template to hold all the information for the sustainability section of the product pages */
  SustainabilityInfo = 'SustainabilityInfo',
  /** A collection of tabs that can be rendered on screen. */
  Tab = 'Tab',
  /** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
  TabContent = 'TabContent',
  TestTipsANdTricksInAMarket = 'TestTipsANdTricksInAMarket',
  /** Single text component that can be used to add rich text to a page */
  TextComponent = 'TextComponent',
  TipsAndTricksDetailsPage = 'TipsAndTricksDetailsPage',
  Title = 'Title',
  /** Twitter SEO Optimization object */
  TwitterSeo = 'TwitterSeo',
  /** User system model */
  User = 'User',
  Widget = 'Widget'
}

/** Allows to specify input to query models and components directly */
export type EntityWhereInput = {
  /** The ID of an object */
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Locale>;
  stage: Stage;
  /** The Type name of an object */
  typename: EntityTypeName;
};

export type EvalancheFormComponent = Entity & Node & {
  __typename?: 'EvalancheFormComponent';
  accordionTitle?: Maybe<Scalars['String']['output']>;
  anchorNav?: Maybe<AnchorNavigation>;
  /** Whether the accordion items should be collapsed by default or not */
  collapsed?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<EvalancheFormComponent>;
  evalancheHost: Scalars['String']['output'];
  /** Fields that are shown at the bottom of the form outside any accordion. e.g. enter 2 to show the last 2 fields hanging outside of the accordion */
  fieldsAfterAccordion?: Maybe<Scalars['Int']['output']>;
  /** Enter the number of the field at which the form should start rendering fields within an accordion */
  fieldsBeforeAccordion?: Maybe<Scalars['Int']['output']>;
  formId: Scalars['String']['output'];
  /** List of EvalancheFormComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type EvalancheFormComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type EvalancheFormComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type EvalancheFormComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type EvalancheFormComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type EvalancheFormComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type EvalancheFormComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type EvalancheFormComponentTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type EvalancheFormComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type EvalancheFormComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: EvalancheFormComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type EvalancheFormComponentConnection = {
  __typename?: 'EvalancheFormComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<EvalancheFormComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type EvalancheFormComponentCreateInput = {
  accordionTitle?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  evalancheHost: Scalars['String']['input'];
  fieldsAfterAccordion?: InputMaybe<Scalars['Int']['input']>;
  fieldsBeforeAccordion?: InputMaybe<Scalars['Int']['input']>;
  formId: Scalars['String']['input'];
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type EvalancheFormComponentCreateManyInlineInput = {
  /** Connect multiple existing EvalancheFormComponent documents */
  connect?: InputMaybe<Array<EvalancheFormComponentWhereUniqueInput>>;
  /** Create and connect multiple existing EvalancheFormComponent documents */
  create?: InputMaybe<Array<EvalancheFormComponentCreateInput>>;
};

export type EvalancheFormComponentCreateOneInlineInput = {
  /** Connect one existing EvalancheFormComponent document */
  connect?: InputMaybe<EvalancheFormComponentWhereUniqueInput>;
  /** Create and connect one EvalancheFormComponent document */
  create?: InputMaybe<EvalancheFormComponentCreateInput>;
};

/** An edge in a connection. */
export type EvalancheFormComponentEdge = {
  __typename?: 'EvalancheFormComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: EvalancheFormComponent;
};

/** Identifies documents */
export type EvalancheFormComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EvalancheFormComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EvalancheFormComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EvalancheFormComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordionTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  accordionTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  accordionTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  accordionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  accordionTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  accordionTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  accordionTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  accordionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  accordionTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  accordionTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  collapsed_not?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<EvalancheFormComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<EvalancheFormComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<EvalancheFormComponentWhereStageInput>;
  evalancheHost?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  evalancheHost_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  evalancheHost_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  evalancheHost_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  evalancheHost_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  evalancheHost_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  evalancheHost_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  evalancheHost_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  evalancheHost_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  evalancheHost_starts_with?: InputMaybe<Scalars['String']['input']>;
  fieldsAfterAccordion?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  fieldsAfterAccordion_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  fieldsAfterAccordion_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  fieldsAfterAccordion_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  fieldsAfterAccordion_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  fieldsAfterAccordion_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  fieldsAfterAccordion_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  fieldsAfterAccordion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fieldsBeforeAccordion?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  fieldsBeforeAccordion_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  fieldsBeforeAccordion_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  fieldsBeforeAccordion_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  fieldsBeforeAccordion_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  fieldsBeforeAccordion_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  fieldsBeforeAccordion_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  fieldsBeforeAccordion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  formId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  formId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  formId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  formId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  formId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  formId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  formId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  formId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  formId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  formId_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum EvalancheFormComponentOrderByInput {
  accordionTitle_ASC = 'accordionTitle_ASC',
  accordionTitle_DESC = 'accordionTitle_DESC',
  collapsed_ASC = 'collapsed_ASC',
  collapsed_DESC = 'collapsed_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  evalancheHost_ASC = 'evalancheHost_ASC',
  evalancheHost_DESC = 'evalancheHost_DESC',
  fieldsAfterAccordion_ASC = 'fieldsAfterAccordion_ASC',
  fieldsAfterAccordion_DESC = 'fieldsAfterAccordion_DESC',
  fieldsBeforeAccordion_ASC = 'fieldsBeforeAccordion_ASC',
  fieldsBeforeAccordion_DESC = 'fieldsBeforeAccordion_DESC',
  formId_ASC = 'formId_ASC',
  formId_DESC = 'formId_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type EvalancheFormComponentUpdateInput = {
  accordionTitle?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  evalancheHost?: InputMaybe<Scalars['String']['input']>;
  fieldsAfterAccordion?: InputMaybe<Scalars['Int']['input']>;
  fieldsBeforeAccordion?: InputMaybe<Scalars['Int']['input']>;
  formId?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type EvalancheFormComponentUpdateManyInlineInput = {
  /** Connect multiple existing EvalancheFormComponent documents */
  connect?: InputMaybe<Array<EvalancheFormComponentConnectInput>>;
  /** Create and connect multiple EvalancheFormComponent documents */
  create?: InputMaybe<Array<EvalancheFormComponentCreateInput>>;
  /** Delete multiple EvalancheFormComponent documents */
  delete?: InputMaybe<Array<EvalancheFormComponentWhereUniqueInput>>;
  /** Disconnect multiple EvalancheFormComponent documents */
  disconnect?: InputMaybe<Array<EvalancheFormComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing EvalancheFormComponent documents */
  set?: InputMaybe<Array<EvalancheFormComponentWhereUniqueInput>>;
  /** Update multiple EvalancheFormComponent documents */
  update?: InputMaybe<Array<EvalancheFormComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple EvalancheFormComponent documents */
  upsert?: InputMaybe<Array<EvalancheFormComponentUpsertWithNestedWhereUniqueInput>>;
};

export type EvalancheFormComponentUpdateManyInput = {
  accordionTitle?: InputMaybe<Scalars['String']['input']>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  evalancheHost?: InputMaybe<Scalars['String']['input']>;
  fieldsAfterAccordion?: InputMaybe<Scalars['Int']['input']>;
  fieldsBeforeAccordion?: InputMaybe<Scalars['Int']['input']>;
  formId?: InputMaybe<Scalars['String']['input']>;
};

export type EvalancheFormComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: EvalancheFormComponentUpdateManyInput;
  /** Document search */
  where: EvalancheFormComponentWhereInput;
};

export type EvalancheFormComponentUpdateOneInlineInput = {
  /** Connect existing EvalancheFormComponent document */
  connect?: InputMaybe<EvalancheFormComponentWhereUniqueInput>;
  /** Create and connect one EvalancheFormComponent document */
  create?: InputMaybe<EvalancheFormComponentCreateInput>;
  /** Delete currently connected EvalancheFormComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected EvalancheFormComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single EvalancheFormComponent document */
  update?: InputMaybe<EvalancheFormComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single EvalancheFormComponent document */
  upsert?: InputMaybe<EvalancheFormComponentUpsertWithNestedWhereUniqueInput>;
};

export type EvalancheFormComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: EvalancheFormComponentUpdateInput;
  /** Unique document search */
  where: EvalancheFormComponentWhereUniqueInput;
};

export type EvalancheFormComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: EvalancheFormComponentCreateInput;
  /** Update document if it exists */
  update: EvalancheFormComponentUpdateInput;
};

export type EvalancheFormComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: EvalancheFormComponentUpsertInput;
  /** Unique document search */
  where: EvalancheFormComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type EvalancheFormComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type EvalancheFormComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EvalancheFormComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EvalancheFormComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EvalancheFormComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  accordionTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  accordionTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  accordionTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  accordionTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  accordionTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  accordionTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  accordionTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  accordionTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  accordionTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  accordionTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  collapsed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  collapsed_not?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<EvalancheFormComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<EvalancheFormComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<EvalancheFormComponentWhereStageInput>;
  evalancheHost?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  evalancheHost_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  evalancheHost_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  evalancheHost_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  evalancheHost_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  evalancheHost_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  evalancheHost_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  evalancheHost_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  evalancheHost_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  evalancheHost_starts_with?: InputMaybe<Scalars['String']['input']>;
  fieldsAfterAccordion?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  fieldsAfterAccordion_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  fieldsAfterAccordion_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  fieldsAfterAccordion_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  fieldsAfterAccordion_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  fieldsAfterAccordion_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  fieldsAfterAccordion_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  fieldsAfterAccordion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fieldsBeforeAccordion?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  fieldsBeforeAccordion_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  fieldsBeforeAccordion_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  fieldsBeforeAccordion_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  fieldsBeforeAccordion_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  fieldsBeforeAccordion_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  fieldsBeforeAccordion_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  fieldsBeforeAccordion_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  formId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  formId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  formId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  formId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  formId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  formId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  formId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  formId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  formId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  formId_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type EvalancheFormComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<EvalancheFormComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<EvalancheFormComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<EvalancheFormComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<EvalancheFormComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References EvalancheFormComponent record uniquely */
export type EvalancheFormComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Title to be used to find the contents in the CMS */
export type ExampleComponent = Entity & Node & {
  __typename?: 'ExampleComponent';
  assetsComponents: Array<AssetComponent>;
  /** Title to be used to find the contents in the CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  customfieldextension?: Maybe<Scalars['String']['output']>;
  /** Description field for adding description text in the component */
  description?: Maybe<ExampleComponentDescriptionRichText>;
  /** Get the document in other stages */
  documentInStages: Array<ExampleComponent>;
  genericPages: Array<GenericPage>;
  /** List of ExampleComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Option to configure where the text and image is rendered for the component. */
  imageTextAlignment?: Maybe<ImageTextAlignment>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<ExampleComponent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Title field for the title of the component */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentAssetsComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentWhereInput>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Title to be used to find the contents in the CMS */
export type ExampleComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ExampleComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ExampleComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type ExampleComponentConnection = {
  __typename?: 'ExampleComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ExampleComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ExampleComponentCreateInput = {
  assetsComponents?: InputMaybe<AssetComponentCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customfieldextension?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  imageTextAlignment?: InputMaybe<ImageTextAlignment>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ExampleComponentCreateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExampleComponentCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ExampleComponentCreateLocalizationInput = {
  /** Localization input */
  data: ExampleComponentCreateLocalizationDataInput;
  locale: Locale;
};

export type ExampleComponentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ExampleComponentCreateLocalizationInput>>;
};

export type ExampleComponentCreateManyInlineInput = {
  /** Connect multiple existing ExampleComponent documents */
  connect?: InputMaybe<Array<ExampleComponentWhereUniqueInput>>;
  /** Create and connect multiple existing ExampleComponent documents */
  create?: InputMaybe<Array<ExampleComponentCreateInput>>;
};

export type ExampleComponentCreateOneInlineInput = {
  /** Connect one existing ExampleComponent document */
  connect?: InputMaybe<ExampleComponentWhereUniqueInput>;
  /** Create and connect one ExampleComponent document */
  create?: InputMaybe<ExampleComponentCreateInput>;
};

export type ExampleComponentDescriptionRichText = {
  __typename?: 'ExampleComponentDescriptionRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<ExampleComponentDescriptionRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type ExampleComponentDescriptionRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ExampleComponentDescriptionRichTextEmbeddedTypes = Asset;

/** An edge in a connection. */
export type ExampleComponentEdge = {
  __typename?: 'ExampleComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ExampleComponent;
};

/** Identifies documents */
export type ExampleComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ExampleComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ExampleComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ExampleComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  customfieldextension?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  customfieldextension_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  customfieldextension_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  customfieldextension_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  customfieldextension_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  customfieldextension_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  customfieldextension_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  customfieldextension_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  customfieldextension_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  customfieldextension_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<ExampleComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<ExampleComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<ExampleComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageTextAlignment?: InputMaybe<ImageTextAlignment>;
  /** All values that are contained in given list. */
  imageTextAlignment_in?: InputMaybe<Array<InputMaybe<ImageTextAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageTextAlignment_not?: InputMaybe<ImageTextAlignment>;
  /** All values that are not contained in given list. */
  imageTextAlignment_not_in?: InputMaybe<Array<InputMaybe<ImageTextAlignment>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ExampleComponentOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  customfieldextension_ASC = 'customfieldextension_ASC',
  customfieldextension_DESC = 'customfieldextension_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  imageTextAlignment_ASC = 'imageTextAlignment_ASC',
  imageTextAlignment_DESC = 'imageTextAlignment_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ExampleComponentUpdateInput = {
  assetsComponents?: InputMaybe<AssetComponentUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  customfieldextension?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  imageTextAlignment?: InputMaybe<ImageTextAlignment>;
  /** Manage document localizations */
  localizations?: InputMaybe<ExampleComponentUpdateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ExampleComponentUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ExampleComponentUpdateLocalizationInput = {
  data: ExampleComponentUpdateLocalizationDataInput;
  locale: Locale;
};

export type ExampleComponentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ExampleComponentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<ExampleComponentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<ExampleComponentUpsertLocalizationInput>>;
};

export type ExampleComponentUpdateManyInlineInput = {
  /** Connect multiple existing ExampleComponent documents */
  connect?: InputMaybe<Array<ExampleComponentConnectInput>>;
  /** Create and connect multiple ExampleComponent documents */
  create?: InputMaybe<Array<ExampleComponentCreateInput>>;
  /** Delete multiple ExampleComponent documents */
  delete?: InputMaybe<Array<ExampleComponentWhereUniqueInput>>;
  /** Disconnect multiple ExampleComponent documents */
  disconnect?: InputMaybe<Array<ExampleComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ExampleComponent documents */
  set?: InputMaybe<Array<ExampleComponentWhereUniqueInput>>;
  /** Update multiple ExampleComponent documents */
  update?: InputMaybe<Array<ExampleComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ExampleComponent documents */
  upsert?: InputMaybe<Array<ExampleComponentUpsertWithNestedWhereUniqueInput>>;
};

export type ExampleComponentUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  customfieldextension?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  imageTextAlignment?: InputMaybe<ImageTextAlignment>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<ExampleComponentUpdateManyLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ExampleComponentUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ExampleComponentUpdateManyLocalizationInput = {
  data: ExampleComponentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type ExampleComponentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ExampleComponentUpdateManyLocalizationInput>>;
};

export type ExampleComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ExampleComponentUpdateManyInput;
  /** Document search */
  where: ExampleComponentWhereInput;
};

export type ExampleComponentUpdateOneInlineInput = {
  /** Connect existing ExampleComponent document */
  connect?: InputMaybe<ExampleComponentWhereUniqueInput>;
  /** Create and connect one ExampleComponent document */
  create?: InputMaybe<ExampleComponentCreateInput>;
  /** Delete currently connected ExampleComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ExampleComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ExampleComponent document */
  update?: InputMaybe<ExampleComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ExampleComponent document */
  upsert?: InputMaybe<ExampleComponentUpsertWithNestedWhereUniqueInput>;
};

export type ExampleComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ExampleComponentUpdateInput;
  /** Unique document search */
  where: ExampleComponentWhereUniqueInput;
};

export type ExampleComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: ExampleComponentCreateInput;
  /** Update document if it exists */
  update: ExampleComponentUpdateInput;
};

export type ExampleComponentUpsertLocalizationInput = {
  create: ExampleComponentCreateLocalizationDataInput;
  locale: Locale;
  update: ExampleComponentUpdateLocalizationDataInput;
};

export type ExampleComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ExampleComponentUpsertInput;
  /** Unique document search */
  where: ExampleComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ExampleComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ExampleComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ExampleComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ExampleComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ExampleComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  customfieldextension?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  customfieldextension_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  customfieldextension_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  customfieldextension_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  customfieldextension_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  customfieldextension_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  customfieldextension_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  customfieldextension_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  customfieldextension_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  customfieldextension_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<ExampleComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<ExampleComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<ExampleComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageTextAlignment?: InputMaybe<ImageTextAlignment>;
  /** All values that are contained in given list. */
  imageTextAlignment_in?: InputMaybe<Array<InputMaybe<ImageTextAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageTextAlignment_not?: InputMaybe<ImageTextAlignment>;
  /** All values that are not contained in given list. */
  imageTextAlignment_not_in?: InputMaybe<Array<InputMaybe<ImageTextAlignment>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ExampleComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ExampleComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ExampleComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ExampleComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ExampleComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ExampleComponent record uniquely */
export type ExampleComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContent = Entity & Node & {
  __typename?: 'FeaturedContent';
  anchorNav?: Maybe<AnchorNavigation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** If your featured content includes featured recipe items, be sure to reference the Recipe Dictionary here. */
  dictionary?: Maybe<Dictionary>;
  /** Get the document in other stages */
  documentInStages: Array<FeaturedContent>;
  genericPages: Array<GenericPage>;
  /** List of FeaturedContent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Featured Card(s) to display */
  items: Array<FeaturedContentItems>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<FeaturedContent>;
  /** Name for this featured content */
  name: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Appears above the title */
  superText?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentDictionaryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Featured content on a page in a prominent banner / carousel */
export type FeaturedContentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FeaturedContentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FeaturedContentWhereUniqueInput;
};

/** A connection to a list of items. */
export type FeaturedContentConnection = {
  __typename?: 'FeaturedContentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FeaturedContentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FeaturedContentCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionary?: InputMaybe<DictionaryCreateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  items?: InputMaybe<FeaturedContentItemsCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FeaturedContentCreateLocalizationsInput>;
  name: Scalars['String']['input'];
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FeaturedContentCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FeaturedContentCreateLocalizationInput = {
  /** Localization input */
  data: FeaturedContentCreateLocalizationDataInput;
  locale: Locale;
};

export type FeaturedContentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FeaturedContentCreateLocalizationInput>>;
};

export type FeaturedContentCreateManyInlineInput = {
  /** Connect multiple existing FeaturedContent documents */
  connect?: InputMaybe<Array<FeaturedContentWhereUniqueInput>>;
  /** Create and connect multiple existing FeaturedContent documents */
  create?: InputMaybe<Array<FeaturedContentCreateInput>>;
};

export type FeaturedContentCreateOneInlineInput = {
  /** Connect one existing FeaturedContent document */
  connect?: InputMaybe<FeaturedContentWhereUniqueInput>;
  /** Create and connect one FeaturedContent document */
  create?: InputMaybe<FeaturedContentCreateInput>;
};

/** An edge in a connection. */
export type FeaturedContentEdge = {
  __typename?: 'FeaturedContentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FeaturedContent;
};

export type FeaturedContentItems = AuthorableContentCard | FeaturedContentReference;

export type FeaturedContentItemsConnectInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardConnectInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceConnectInput>;
};

export type FeaturedContentItemsCreateInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardCreateInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceCreateInput>;
};

export type FeaturedContentItemsCreateManyInlineInput = {
  /** Connect multiple existing FeaturedContentItems documents */
  connect?: InputMaybe<Array<FeaturedContentItemsWhereUniqueInput>>;
  /** Create and connect multiple existing FeaturedContentItems documents */
  create?: InputMaybe<Array<FeaturedContentItemsCreateInput>>;
};

export type FeaturedContentItemsCreateOneInlineInput = {
  /** Connect one existing FeaturedContentItems document */
  connect?: InputMaybe<FeaturedContentItemsWhereUniqueInput>;
  /** Create and connect one FeaturedContentItems document */
  create?: InputMaybe<FeaturedContentItemsCreateInput>;
};

export type FeaturedContentItemsUpdateInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceUpdateInput>;
};

export type FeaturedContentItemsUpdateManyInlineInput = {
  /** Connect multiple existing FeaturedContentItems documents */
  connect?: InputMaybe<Array<FeaturedContentItemsConnectInput>>;
  /** Create and connect multiple FeaturedContentItems documents */
  create?: InputMaybe<Array<FeaturedContentItemsCreateInput>>;
  /** Delete multiple FeaturedContentItems documents */
  delete?: InputMaybe<Array<FeaturedContentItemsWhereUniqueInput>>;
  /** Disconnect multiple FeaturedContentItems documents */
  disconnect?: InputMaybe<Array<FeaturedContentItemsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FeaturedContentItems documents */
  set?: InputMaybe<Array<FeaturedContentItemsWhereUniqueInput>>;
  /** Update multiple FeaturedContentItems documents */
  update?: InputMaybe<Array<FeaturedContentItemsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FeaturedContentItems documents */
  upsert?: InputMaybe<Array<FeaturedContentItemsUpsertWithNestedWhereUniqueInput>>;
};

export type FeaturedContentItemsUpdateManyWithNestedWhereInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateManyWithNestedWhereInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceUpdateManyWithNestedWhereInput>;
};

export type FeaturedContentItemsUpdateOneInlineInput = {
  /** Connect existing FeaturedContentItems document */
  connect?: InputMaybe<FeaturedContentItemsWhereUniqueInput>;
  /** Create and connect one FeaturedContentItems document */
  create?: InputMaybe<FeaturedContentItemsCreateInput>;
  /** Delete currently connected FeaturedContentItems document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FeaturedContentItems document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FeaturedContentItems document */
  update?: InputMaybe<FeaturedContentItemsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FeaturedContentItems document */
  upsert?: InputMaybe<FeaturedContentItemsUpsertWithNestedWhereUniqueInput>;
};

export type FeaturedContentItemsUpdateWithNestedWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateWithNestedWhereUniqueInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceUpdateWithNestedWhereUniqueInput>;
};

export type FeaturedContentItemsUpsertWithNestedWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpsertWithNestedWhereUniqueInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceUpsertWithNestedWhereUniqueInput>;
};

export type FeaturedContentItemsWhereInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceWhereInput>;
};

export type FeaturedContentItemsWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereUniqueInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceWhereUniqueInput>;
};

/** Identifies documents */
export type FeaturedContentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FeaturedContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FeaturedContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FeaturedContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionary?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<FeaturedContentWhereStageInput>;
  documentInStages_none?: InputMaybe<FeaturedContentWhereStageInput>;
  documentInStages_some?: InputMaybe<FeaturedContentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  items_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  items_some?: InputMaybe<FeaturedContentItemsWhereInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FeaturedContentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FeaturedContentReference = Entity & Node & {
  __typename?: 'FeaturedContentReference';
  articlePage?: Maybe<GenericPage>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FeaturedContentReference>;
  featuredContent?: Maybe<FeaturedContent>;
  genericGridAuthorables: Array<GenericGridAuthorable>;
  /** List of FeaturedContentReference versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  recipeId?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  tipsAndTricksId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FeaturedContentReferenceArticlePageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FeaturedContentReferenceCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FeaturedContentReferenceDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FeaturedContentReferenceFeaturedContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FeaturedContentReferenceGenericGridAuthorablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericGridAuthorableWhereInput>;
};


export type FeaturedContentReferenceHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FeaturedContentReferencePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FeaturedContentReferenceScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FeaturedContentReferenceUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FeaturedContentReferenceConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FeaturedContentReferenceWhereUniqueInput;
};

/** A connection to a list of items. */
export type FeaturedContentReferenceConnection = {
  __typename?: 'FeaturedContentReferenceConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FeaturedContentReferenceEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FeaturedContentReferenceCreateInput = {
  articlePage?: InputMaybe<GenericPageCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  featuredContent?: InputMaybe<FeaturedContentCreateOneInlineInput>;
  genericGridAuthorables?: InputMaybe<GenericGridAuthorableCreateManyInlineInput>;
  recipeId?: InputMaybe<Scalars['String']['input']>;
  tipsAndTricksId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FeaturedContentReferenceCreateManyInlineInput = {
  /** Connect multiple existing FeaturedContentReference documents */
  connect?: InputMaybe<Array<FeaturedContentReferenceWhereUniqueInput>>;
  /** Create and connect multiple existing FeaturedContentReference documents */
  create?: InputMaybe<Array<FeaturedContentReferenceCreateInput>>;
};

export type FeaturedContentReferenceCreateOneInlineInput = {
  /** Connect one existing FeaturedContentReference document */
  connect?: InputMaybe<FeaturedContentReferenceWhereUniqueInput>;
  /** Create and connect one FeaturedContentReference document */
  create?: InputMaybe<FeaturedContentReferenceCreateInput>;
};

/** An edge in a connection. */
export type FeaturedContentReferenceEdge = {
  __typename?: 'FeaturedContentReferenceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FeaturedContentReference;
};

/** Identifies documents */
export type FeaturedContentReferenceManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FeaturedContentReferenceWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FeaturedContentReferenceWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FeaturedContentReferenceWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articlePage?: InputMaybe<GenericPageWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FeaturedContentReferenceWhereStageInput>;
  documentInStages_none?: InputMaybe<FeaturedContentReferenceWhereStageInput>;
  documentInStages_some?: InputMaybe<FeaturedContentReferenceWhereStageInput>;
  featuredContent?: InputMaybe<FeaturedContentWhereInput>;
  genericGridAuthorables_every?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorables_none?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorables_some?: InputMaybe<GenericGridAuthorableWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  recipeId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  recipeId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  recipeId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  recipeId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  recipeId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  recipeId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  recipeId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  recipeId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  recipeId_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tipsAndTricksId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tipsAndTricksId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tipsAndTricksId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tipsAndTricksId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tipsAndTricksId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tipsAndTricksId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tipsAndTricksId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tipsAndTricksId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tipsAndTricksId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tipsAndTricksId_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FeaturedContentReferenceOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  recipeId_ASC = 'recipeId_ASC',
  recipeId_DESC = 'recipeId_DESC',
  tipsAndTricksId_ASC = 'tipsAndTricksId_ASC',
  tipsAndTricksId_DESC = 'tipsAndTricksId_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FeaturedContentReferenceUpdateInput = {
  articlePage?: InputMaybe<GenericPageUpdateOneInlineInput>;
  featuredContent?: InputMaybe<FeaturedContentUpdateOneInlineInput>;
  genericGridAuthorables?: InputMaybe<GenericGridAuthorableUpdateManyInlineInput>;
  recipeId?: InputMaybe<Scalars['String']['input']>;
  tipsAndTricksId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FeaturedContentReferenceUpdateManyInlineInput = {
  /** Connect multiple existing FeaturedContentReference documents */
  connect?: InputMaybe<Array<FeaturedContentReferenceConnectInput>>;
  /** Create and connect multiple FeaturedContentReference documents */
  create?: InputMaybe<Array<FeaturedContentReferenceCreateInput>>;
  /** Delete multiple FeaturedContentReference documents */
  delete?: InputMaybe<Array<FeaturedContentReferenceWhereUniqueInput>>;
  /** Disconnect multiple FeaturedContentReference documents */
  disconnect?: InputMaybe<Array<FeaturedContentReferenceWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FeaturedContentReference documents */
  set?: InputMaybe<Array<FeaturedContentReferenceWhereUniqueInput>>;
  /** Update multiple FeaturedContentReference documents */
  update?: InputMaybe<Array<FeaturedContentReferenceUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FeaturedContentReference documents */
  upsert?: InputMaybe<Array<FeaturedContentReferenceUpsertWithNestedWhereUniqueInput>>;
};

export type FeaturedContentReferenceUpdateManyInput = {
  recipeId?: InputMaybe<Scalars['String']['input']>;
  tipsAndTricksId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FeaturedContentReferenceUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FeaturedContentReferenceUpdateManyInput;
  /** Document search */
  where: FeaturedContentReferenceWhereInput;
};

export type FeaturedContentReferenceUpdateOneInlineInput = {
  /** Connect existing FeaturedContentReference document */
  connect?: InputMaybe<FeaturedContentReferenceWhereUniqueInput>;
  /** Create and connect one FeaturedContentReference document */
  create?: InputMaybe<FeaturedContentReferenceCreateInput>;
  /** Delete currently connected FeaturedContentReference document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FeaturedContentReference document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FeaturedContentReference document */
  update?: InputMaybe<FeaturedContentReferenceUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FeaturedContentReference document */
  upsert?: InputMaybe<FeaturedContentReferenceUpsertWithNestedWhereUniqueInput>;
};

export type FeaturedContentReferenceUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FeaturedContentReferenceUpdateInput;
  /** Unique document search */
  where: FeaturedContentReferenceWhereUniqueInput;
};

export type FeaturedContentReferenceUpsertInput = {
  /** Create document if it didn't exist */
  create: FeaturedContentReferenceCreateInput;
  /** Update document if it exists */
  update: FeaturedContentReferenceUpdateInput;
};

export type FeaturedContentReferenceUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FeaturedContentReferenceUpsertInput;
  /** Unique document search */
  where: FeaturedContentReferenceWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FeaturedContentReferenceWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FeaturedContentReferenceWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FeaturedContentReferenceWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FeaturedContentReferenceWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FeaturedContentReferenceWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  articlePage?: InputMaybe<GenericPageWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FeaturedContentReferenceWhereStageInput>;
  documentInStages_none?: InputMaybe<FeaturedContentReferenceWhereStageInput>;
  documentInStages_some?: InputMaybe<FeaturedContentReferenceWhereStageInput>;
  featuredContent?: InputMaybe<FeaturedContentWhereInput>;
  genericGridAuthorables_every?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorables_none?: InputMaybe<GenericGridAuthorableWhereInput>;
  genericGridAuthorables_some?: InputMaybe<GenericGridAuthorableWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  recipeId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  recipeId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  recipeId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  recipeId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  recipeId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  recipeId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  recipeId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  recipeId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  recipeId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  recipeId_starts_with?: InputMaybe<Scalars['String']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tipsAndTricksId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tipsAndTricksId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tipsAndTricksId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tipsAndTricksId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tipsAndTricksId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tipsAndTricksId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tipsAndTricksId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tipsAndTricksId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tipsAndTricksId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tipsAndTricksId_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FeaturedContentReferenceWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FeaturedContentReferenceWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FeaturedContentReferenceWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FeaturedContentReferenceWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FeaturedContentReferenceWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FeaturedContentReference record uniquely */
export type FeaturedContentReferenceWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FeaturedContentUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  dictionary?: InputMaybe<DictionaryUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  items?: InputMaybe<FeaturedContentItemsUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<FeaturedContentUpdateLocalizationsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FeaturedContentUpdateLocalizationDataInput = {
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FeaturedContentUpdateLocalizationInput = {
  data: FeaturedContentUpdateLocalizationDataInput;
  locale: Locale;
};

export type FeaturedContentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FeaturedContentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<FeaturedContentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<FeaturedContentUpsertLocalizationInput>>;
};

export type FeaturedContentUpdateManyInlineInput = {
  /** Connect multiple existing FeaturedContent documents */
  connect?: InputMaybe<Array<FeaturedContentConnectInput>>;
  /** Create and connect multiple FeaturedContent documents */
  create?: InputMaybe<Array<FeaturedContentCreateInput>>;
  /** Delete multiple FeaturedContent documents */
  delete?: InputMaybe<Array<FeaturedContentWhereUniqueInput>>;
  /** Disconnect multiple FeaturedContent documents */
  disconnect?: InputMaybe<Array<FeaturedContentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FeaturedContent documents */
  set?: InputMaybe<Array<FeaturedContentWhereUniqueInput>>;
  /** Update multiple FeaturedContent documents */
  update?: InputMaybe<Array<FeaturedContentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FeaturedContent documents */
  upsert?: InputMaybe<Array<FeaturedContentUpsertWithNestedWhereUniqueInput>>;
};

export type FeaturedContentUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<FeaturedContentUpdateManyLocalizationsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FeaturedContentUpdateManyLocalizationDataInput = {
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FeaturedContentUpdateManyLocalizationInput = {
  data: FeaturedContentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type FeaturedContentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FeaturedContentUpdateManyLocalizationInput>>;
};

export type FeaturedContentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FeaturedContentUpdateManyInput;
  /** Document search */
  where: FeaturedContentWhereInput;
};

export type FeaturedContentUpdateOneInlineInput = {
  /** Connect existing FeaturedContent document */
  connect?: InputMaybe<FeaturedContentWhereUniqueInput>;
  /** Create and connect one FeaturedContent document */
  create?: InputMaybe<FeaturedContentCreateInput>;
  /** Delete currently connected FeaturedContent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FeaturedContent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FeaturedContent document */
  update?: InputMaybe<FeaturedContentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FeaturedContent document */
  upsert?: InputMaybe<FeaturedContentUpsertWithNestedWhereUniqueInput>;
};

export type FeaturedContentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FeaturedContentUpdateInput;
  /** Unique document search */
  where: FeaturedContentWhereUniqueInput;
};

export type FeaturedContentUpsertInput = {
  /** Create document if it didn't exist */
  create: FeaturedContentCreateInput;
  /** Update document if it exists */
  update: FeaturedContentUpdateInput;
};

export type FeaturedContentUpsertLocalizationInput = {
  create: FeaturedContentCreateLocalizationDataInput;
  locale: Locale;
  update: FeaturedContentUpdateLocalizationDataInput;
};

export type FeaturedContentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FeaturedContentUpsertInput;
  /** Unique document search */
  where: FeaturedContentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FeaturedContentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FeaturedContentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FeaturedContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FeaturedContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FeaturedContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionary?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<FeaturedContentWhereStageInput>;
  documentInStages_none?: InputMaybe<FeaturedContentWhereStageInput>;
  documentInStages_some?: InputMaybe<FeaturedContentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  items_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  items_some?: InputMaybe<FeaturedContentItemsWhereInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FeaturedContentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FeaturedContentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FeaturedContentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FeaturedContentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FeaturedContentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FeaturedContent record uniquely */
export type FeaturedContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Navigation Type inside footer */
export enum FooterNav {
  LegalSection = 'LegalSection',
  MainNav = 'MainNav'
}

/** Footer Navigation */
export type FooterNavigation = Entity & Node & {
  __typename?: 'FooterNavigation';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FooterNavigation>;
  footerNavType: FooterNav;
  /** List of FooterNavigation versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Footer links */
  links: Array<FooterNavigationLinks>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<FooterNavigation>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Footer Navigation */
export type FooterNavigationCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Footer Navigation */
export type FooterNavigationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Footer Navigation */
export type FooterNavigationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Footer Navigation */
export type FooterNavigationHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Footer Navigation */
export type FooterNavigationLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Footer Navigation */
export type FooterNavigationLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Footer Navigation */
export type FooterNavigationPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Footer Navigation */
export type FooterNavigationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Footer Navigation */
export type FooterNavigationScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Footer Navigation */
export type FooterNavigationUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Footer Navigation */
export type FooterNavigationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FooterNavigationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FooterNavigationWhereUniqueInput;
};

/** A connection to a list of items. */
export type FooterNavigationConnection = {
  __typename?: 'FooterNavigationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FooterNavigationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FooterNavigationCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  footerNavType: FooterNav;
  links?: InputMaybe<FooterNavigationLinksCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FooterNavigationCreateLocalizationsInput>;
  /** title input for default locale (default) */
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FooterNavigationCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FooterNavigationCreateLocalizationInput = {
  /** Localization input */
  data: FooterNavigationCreateLocalizationDataInput;
  locale: Locale;
};

export type FooterNavigationCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FooterNavigationCreateLocalizationInput>>;
};

export type FooterNavigationCreateManyInlineInput = {
  /** Connect multiple existing FooterNavigation documents */
  connect?: InputMaybe<Array<FooterNavigationWhereUniqueInput>>;
  /** Create and connect multiple existing FooterNavigation documents */
  create?: InputMaybe<Array<FooterNavigationCreateInput>>;
};

export type FooterNavigationCreateOneInlineInput = {
  /** Connect one existing FooterNavigation document */
  connect?: InputMaybe<FooterNavigationWhereUniqueInput>;
  /** Create and connect one FooterNavigation document */
  create?: InputMaybe<FooterNavigationCreateInput>;
};

/** An edge in a connection. */
export type FooterNavigationEdge = {
  __typename?: 'FooterNavigationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FooterNavigation;
};

export type FooterNavigationLinks = Link;

export type FooterNavigationLinksConnectInput = {
  Link?: InputMaybe<LinkConnectInput>;
};

export type FooterNavigationLinksCreateInput = {
  Link?: InputMaybe<LinkCreateInput>;
};

export type FooterNavigationLinksCreateManyInlineInput = {
  /** Connect multiple existing FooterNavigationLinks documents */
  connect?: InputMaybe<Array<FooterNavigationLinksWhereUniqueInput>>;
  /** Create and connect multiple existing FooterNavigationLinks documents */
  create?: InputMaybe<Array<FooterNavigationLinksCreateInput>>;
};

export type FooterNavigationLinksCreateOneInlineInput = {
  /** Connect one existing FooterNavigationLinks document */
  connect?: InputMaybe<FooterNavigationLinksWhereUniqueInput>;
  /** Create and connect one FooterNavigationLinks document */
  create?: InputMaybe<FooterNavigationLinksCreateInput>;
};

export type FooterNavigationLinksUpdateInput = {
  Link?: InputMaybe<LinkUpdateInput>;
};

export type FooterNavigationLinksUpdateManyInlineInput = {
  /** Connect multiple existing FooterNavigationLinks documents */
  connect?: InputMaybe<Array<FooterNavigationLinksConnectInput>>;
  /** Create and connect multiple FooterNavigationLinks documents */
  create?: InputMaybe<Array<FooterNavigationLinksCreateInput>>;
  /** Delete multiple FooterNavigationLinks documents */
  delete?: InputMaybe<Array<FooterNavigationLinksWhereUniqueInput>>;
  /** Disconnect multiple FooterNavigationLinks documents */
  disconnect?: InputMaybe<Array<FooterNavigationLinksWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FooterNavigationLinks documents */
  set?: InputMaybe<Array<FooterNavigationLinksWhereUniqueInput>>;
  /** Update multiple FooterNavigationLinks documents */
  update?: InputMaybe<Array<FooterNavigationLinksUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FooterNavigationLinks documents */
  upsert?: InputMaybe<Array<FooterNavigationLinksUpsertWithNestedWhereUniqueInput>>;
};

export type FooterNavigationLinksUpdateManyWithNestedWhereInput = {
  Link?: InputMaybe<LinkUpdateManyWithNestedWhereInput>;
};

export type FooterNavigationLinksUpdateOneInlineInput = {
  /** Connect existing FooterNavigationLinks document */
  connect?: InputMaybe<FooterNavigationLinksWhereUniqueInput>;
  /** Create and connect one FooterNavigationLinks document */
  create?: InputMaybe<FooterNavigationLinksCreateInput>;
  /** Delete currently connected FooterNavigationLinks document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FooterNavigationLinks document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FooterNavigationLinks document */
  update?: InputMaybe<FooterNavigationLinksUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FooterNavigationLinks document */
  upsert?: InputMaybe<FooterNavigationLinksUpsertWithNestedWhereUniqueInput>;
};

export type FooterNavigationLinksUpdateWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
};

export type FooterNavigationLinksUpsertWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
};

export type FooterNavigationLinksWhereInput = {
  Link?: InputMaybe<LinkWhereInput>;
};

export type FooterNavigationLinksWhereUniqueInput = {
  Link?: InputMaybe<LinkWhereUniqueInput>;
};

/** Identifies documents */
export type FooterNavigationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterNavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterNavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterNavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FooterNavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<FooterNavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<FooterNavigationWhereStageInput>;
  footerNavType?: InputMaybe<FooterNav>;
  /** All values that are contained in given list. */
  footerNavType_in?: InputMaybe<Array<InputMaybe<FooterNav>>>;
  /** Any other value that exists and is not equal to the given value. */
  footerNavType_not?: InputMaybe<FooterNav>;
  /** All values that are not contained in given list. */
  footerNavType_not_in?: InputMaybe<Array<InputMaybe<FooterNav>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  links_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  links_some?: InputMaybe<FooterNavigationLinksWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FooterNavigationOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  footerNavType_ASC = 'footerNavType_ASC',
  footerNavType_DESC = 'footerNavType_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FooterNavigationUpdateInput = {
  footerNavType?: InputMaybe<FooterNav>;
  links?: InputMaybe<FooterNavigationLinksUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<FooterNavigationUpdateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FooterNavigationUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FooterNavigationUpdateLocalizationInput = {
  data: FooterNavigationUpdateLocalizationDataInput;
  locale: Locale;
};

export type FooterNavigationUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FooterNavigationCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<FooterNavigationUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<FooterNavigationUpsertLocalizationInput>>;
};

export type FooterNavigationUpdateManyInlineInput = {
  /** Connect multiple existing FooterNavigation documents */
  connect?: InputMaybe<Array<FooterNavigationConnectInput>>;
  /** Create and connect multiple FooterNavigation documents */
  create?: InputMaybe<Array<FooterNavigationCreateInput>>;
  /** Delete multiple FooterNavigation documents */
  delete?: InputMaybe<Array<FooterNavigationWhereUniqueInput>>;
  /** Disconnect multiple FooterNavigation documents */
  disconnect?: InputMaybe<Array<FooterNavigationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FooterNavigation documents */
  set?: InputMaybe<Array<FooterNavigationWhereUniqueInput>>;
  /** Update multiple FooterNavigation documents */
  update?: InputMaybe<Array<FooterNavigationUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FooterNavigation documents */
  upsert?: InputMaybe<Array<FooterNavigationUpsertWithNestedWhereUniqueInput>>;
};

export type FooterNavigationUpdateManyInput = {
  footerNavType?: InputMaybe<FooterNav>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<FooterNavigationUpdateManyLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FooterNavigationUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FooterNavigationUpdateManyLocalizationInput = {
  data: FooterNavigationUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type FooterNavigationUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FooterNavigationUpdateManyLocalizationInput>>;
};

export type FooterNavigationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FooterNavigationUpdateManyInput;
  /** Document search */
  where: FooterNavigationWhereInput;
};

export type FooterNavigationUpdateOneInlineInput = {
  /** Connect existing FooterNavigation document */
  connect?: InputMaybe<FooterNavigationWhereUniqueInput>;
  /** Create and connect one FooterNavigation document */
  create?: InputMaybe<FooterNavigationCreateInput>;
  /** Delete currently connected FooterNavigation document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FooterNavigation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FooterNavigation document */
  update?: InputMaybe<FooterNavigationUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FooterNavigation document */
  upsert?: InputMaybe<FooterNavigationUpsertWithNestedWhereUniqueInput>;
};

export type FooterNavigationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FooterNavigationUpdateInput;
  /** Unique document search */
  where: FooterNavigationWhereUniqueInput;
};

export type FooterNavigationUpsertInput = {
  /** Create document if it didn't exist */
  create: FooterNavigationCreateInput;
  /** Update document if it exists */
  update: FooterNavigationUpdateInput;
};

export type FooterNavigationUpsertLocalizationInput = {
  create: FooterNavigationCreateLocalizationDataInput;
  locale: Locale;
  update: FooterNavigationUpdateLocalizationDataInput;
};

export type FooterNavigationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FooterNavigationUpsertInput;
  /** Unique document search */
  where: FooterNavigationWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FooterNavigationWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FooterNavigationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterNavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterNavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterNavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FooterNavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<FooterNavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<FooterNavigationWhereStageInput>;
  footerNavType?: InputMaybe<FooterNav>;
  /** All values that are contained in given list. */
  footerNavType_in?: InputMaybe<Array<InputMaybe<FooterNav>>>;
  /** Any other value that exists and is not equal to the given value. */
  footerNavType_not?: InputMaybe<FooterNav>;
  /** All values that are not contained in given list. */
  footerNavType_not_in?: InputMaybe<Array<InputMaybe<FooterNav>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  links_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  links_some?: InputMaybe<FooterNavigationLinksWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FooterNavigationWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FooterNavigationWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FooterNavigationWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FooterNavigationWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FooterNavigationWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FooterNavigation record uniquely */
export type FooterNavigationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Form = Entity & Node & {
  __typename?: 'Form';
  anchorNav?: Maybe<AnchorNavigation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Form>;
  formErrors: Array<FormError>;
  formFields: Array<FormForm>;
  /** contains success message for the form to be displayed after successful submission */
  formSuccess?: Maybe<FormSuccessComponent>;
  /** Selects a pre-defined form type. */
  formType?: Maybe<FormTypes>;
  genericPages: Array<GenericPage>;
  /** List of Form versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  tabContent?: Maybe<TabContent>;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormFormErrorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormErrorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormErrorWhereInput>;
};


export type FormFormFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FormFormSuccessArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type FormHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormCheckbox = Entity & Node & {
  __typename?: 'FormCheckbox';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormCheckbox>;
  fieldName?: Maybe<Scalars['String']['output']>;
  forms: Array<Form>;
  /** List of FormCheckbox versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<FormCheckbox>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Used in the CMS only, to identify entries. */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormCheckboxCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormCheckboxCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormCheckboxDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormCheckboxFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormCheckboxHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormCheckboxLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type FormCheckboxPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormCheckboxPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormCheckboxScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormCheckboxUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormCheckboxUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormCheckboxConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormCheckboxWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormCheckboxConnection = {
  __typename?: 'FormCheckboxConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormCheckboxEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormCheckboxCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FormCheckboxCreateLocalizationsInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** requiredErrorMessage input for default locale (default) */
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormCheckboxCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormCheckboxCreateLocalizationInput = {
  /** Localization input */
  data: FormCheckboxCreateLocalizationDataInput;
  locale: Locale;
};

export type FormCheckboxCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FormCheckboxCreateLocalizationInput>>;
};

export type FormCheckboxCreateManyInlineInput = {
  /** Connect multiple existing FormCheckbox documents */
  connect?: InputMaybe<Array<FormCheckboxWhereUniqueInput>>;
  /** Create and connect multiple existing FormCheckbox documents */
  create?: InputMaybe<Array<FormCheckboxCreateInput>>;
};

export type FormCheckboxCreateOneInlineInput = {
  /** Connect one existing FormCheckbox document */
  connect?: InputMaybe<FormCheckboxWhereUniqueInput>;
  /** Create and connect one FormCheckbox document */
  create?: InputMaybe<FormCheckboxCreateInput>;
};

/** An edge in a connection. */
export type FormCheckboxEdge = {
  __typename?: 'FormCheckboxEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormCheckbox;
};

/** Identifies documents */
export type FormCheckboxManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormCheckboxWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormCheckboxWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormCheckboxWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormCheckboxWhereStageInput>;
  documentInStages_none?: InputMaybe<FormCheckboxWhereStageInput>;
  documentInStages_some?: InputMaybe<FormCheckboxWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormCheckboxOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormCheckboxUpdateInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<FormCheckboxUpdateLocalizationsInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** requiredErrorMessage input for default locale (default) */
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormCheckboxUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
};

export type FormCheckboxUpdateLocalizationInput = {
  data: FormCheckboxUpdateLocalizationDataInput;
  locale: Locale;
};

export type FormCheckboxUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FormCheckboxCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<FormCheckboxUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<FormCheckboxUpsertLocalizationInput>>;
};

export type FormCheckboxUpdateManyInlineInput = {
  /** Connect multiple existing FormCheckbox documents */
  connect?: InputMaybe<Array<FormCheckboxConnectInput>>;
  /** Create and connect multiple FormCheckbox documents */
  create?: InputMaybe<Array<FormCheckboxCreateInput>>;
  /** Delete multiple FormCheckbox documents */
  delete?: InputMaybe<Array<FormCheckboxWhereUniqueInput>>;
  /** Disconnect multiple FormCheckbox documents */
  disconnect?: InputMaybe<Array<FormCheckboxWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormCheckbox documents */
  set?: InputMaybe<Array<FormCheckboxWhereUniqueInput>>;
  /** Update multiple FormCheckbox documents */
  update?: InputMaybe<Array<FormCheckboxUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormCheckbox documents */
  upsert?: InputMaybe<Array<FormCheckboxUpsertWithNestedWhereUniqueInput>>;
};

export type FormCheckboxUpdateManyInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<FormCheckboxUpdateManyLocalizationsInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** requiredErrorMessage input for default locale (default) */
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormCheckboxUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
};

export type FormCheckboxUpdateManyLocalizationInput = {
  data: FormCheckboxUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type FormCheckboxUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FormCheckboxUpdateManyLocalizationInput>>;
};

export type FormCheckboxUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormCheckboxUpdateManyInput;
  /** Document search */
  where: FormCheckboxWhereInput;
};

export type FormCheckboxUpdateOneInlineInput = {
  /** Connect existing FormCheckbox document */
  connect?: InputMaybe<FormCheckboxWhereUniqueInput>;
  /** Create and connect one FormCheckbox document */
  create?: InputMaybe<FormCheckboxCreateInput>;
  /** Delete currently connected FormCheckbox document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormCheckbox document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormCheckbox document */
  update?: InputMaybe<FormCheckboxUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormCheckbox document */
  upsert?: InputMaybe<FormCheckboxUpsertWithNestedWhereUniqueInput>;
};

export type FormCheckboxUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormCheckboxUpdateInput;
  /** Unique document search */
  where: FormCheckboxWhereUniqueInput;
};

export type FormCheckboxUpsertInput = {
  /** Create document if it didn't exist */
  create: FormCheckboxCreateInput;
  /** Update document if it exists */
  update: FormCheckboxUpdateInput;
};

export type FormCheckboxUpsertLocalizationInput = {
  create: FormCheckboxCreateLocalizationDataInput;
  locale: Locale;
  update: FormCheckboxUpdateLocalizationDataInput;
};

export type FormCheckboxUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormCheckboxUpsertInput;
  /** Unique document search */
  where: FormCheckboxWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormCheckboxWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormCheckboxWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormCheckboxWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormCheckboxWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormCheckboxWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormCheckboxWhereStageInput>;
  documentInStages_none?: InputMaybe<FormCheckboxWhereStageInput>;
  documentInStages_some?: InputMaybe<FormCheckboxWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormCheckboxWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormCheckboxWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormCheckboxWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormCheckboxWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormCheckboxWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormCheckbox record uniquely */
export type FormCheckboxWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormConnection = {
  __typename?: 'FormConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  formErrors?: InputMaybe<FormErrorCreateManyInlineInput>;
  formFields?: InputMaybe<FormFormCreateManyInlineInput>;
  formSuccess?: InputMaybe<FormSuccessComponentCreateOneInlineInput>;
  formType?: InputMaybe<FormTypes>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormCreateManyInlineInput = {
  /** Connect multiple existing Form documents */
  connect?: InputMaybe<Array<FormWhereUniqueInput>>;
  /** Create and connect multiple existing Form documents */
  create?: InputMaybe<Array<FormCreateInput>>;
};

export type FormCreateOneInlineInput = {
  /** Connect one existing Form document */
  connect?: InputMaybe<FormWhereUniqueInput>;
  /** Create and connect one Form document */
  create?: InputMaybe<FormCreateInput>;
};

/** An edge in a connection. */
export type FormEdge = {
  __typename?: 'FormEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Form;
};

export type FormEmailInput = Entity & Node & {
  __typename?: 'FormEmailInput';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormEmailInput>;
  /** A camel-case field name, eg. 'userEmail' */
  fieldName?: Maybe<Scalars['String']['output']>;
  forms: Array<Form>;
  /** List of FormEmailInput versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Content to pre-fill the field with. */
  initialValue?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<FormEmailInput>;
  placeholderText?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Displays when form is submitted without this field, if field is required. */
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Used for data-test attributes on the front-end. */
  testAttribute?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormEmailInputCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormEmailInputCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormEmailInputDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormEmailInputFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormEmailInputHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormEmailInputLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type FormEmailInputPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormEmailInputPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormEmailInputScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormEmailInputUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormEmailInputUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormEmailInputConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormEmailInputWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormEmailInputConnection = {
  __typename?: 'FormEmailInputConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormEmailInputEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormEmailInputCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FormEmailInputCreateLocalizationsInput>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  testAttribute?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormEmailInputCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormEmailInputCreateLocalizationInput = {
  /** Localization input */
  data: FormEmailInputCreateLocalizationDataInput;
  locale: Locale;
};

export type FormEmailInputCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FormEmailInputCreateLocalizationInput>>;
};

export type FormEmailInputCreateManyInlineInput = {
  /** Connect multiple existing FormEmailInput documents */
  connect?: InputMaybe<Array<FormEmailInputWhereUniqueInput>>;
  /** Create and connect multiple existing FormEmailInput documents */
  create?: InputMaybe<Array<FormEmailInputCreateInput>>;
};

export type FormEmailInputCreateOneInlineInput = {
  /** Connect one existing FormEmailInput document */
  connect?: InputMaybe<FormEmailInputWhereUniqueInput>;
  /** Create and connect one FormEmailInput document */
  create?: InputMaybe<FormEmailInputCreateInput>;
};

/** An edge in a connection. */
export type FormEmailInputEdge = {
  __typename?: 'FormEmailInputEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormEmailInput;
};

/** Identifies documents */
export type FormEmailInputManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormEmailInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormEmailInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormEmailInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormEmailInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormEmailInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormEmailInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholderText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholderText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholderText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholderText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholderText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholderText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholderText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholderText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholderText_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  testAttribute?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  testAttribute_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  testAttribute_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  testAttribute_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  testAttribute_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  testAttribute_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  testAttribute_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  testAttribute_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  testAttribute_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  testAttribute_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormEmailInputOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  initialValue_ASC = 'initialValue_ASC',
  initialValue_DESC = 'initialValue_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  placeholderText_ASC = 'placeholderText_ASC',
  placeholderText_DESC = 'placeholderText_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  testAttribute_ASC = 'testAttribute_ASC',
  testAttribute_DESC = 'testAttribute_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormEmailInputUpdateInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<FormEmailInputUpdateLocalizationsInput>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  testAttribute?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormEmailInputUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FormEmailInputUpdateLocalizationInput = {
  data: FormEmailInputUpdateLocalizationDataInput;
  locale: Locale;
};

export type FormEmailInputUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FormEmailInputCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<FormEmailInputUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<FormEmailInputUpsertLocalizationInput>>;
};

export type FormEmailInputUpdateManyInlineInput = {
  /** Connect multiple existing FormEmailInput documents */
  connect?: InputMaybe<Array<FormEmailInputConnectInput>>;
  /** Create and connect multiple FormEmailInput documents */
  create?: InputMaybe<Array<FormEmailInputCreateInput>>;
  /** Delete multiple FormEmailInput documents */
  delete?: InputMaybe<Array<FormEmailInputWhereUniqueInput>>;
  /** Disconnect multiple FormEmailInput documents */
  disconnect?: InputMaybe<Array<FormEmailInputWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormEmailInput documents */
  set?: InputMaybe<Array<FormEmailInputWhereUniqueInput>>;
  /** Update multiple FormEmailInput documents */
  update?: InputMaybe<Array<FormEmailInputUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormEmailInput documents */
  upsert?: InputMaybe<Array<FormEmailInputUpsertWithNestedWhereUniqueInput>>;
};

export type FormEmailInputUpdateManyInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<FormEmailInputUpdateManyLocalizationsInput>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  testAttribute?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormEmailInputUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FormEmailInputUpdateManyLocalizationInput = {
  data: FormEmailInputUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type FormEmailInputUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FormEmailInputUpdateManyLocalizationInput>>;
};

export type FormEmailInputUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormEmailInputUpdateManyInput;
  /** Document search */
  where: FormEmailInputWhereInput;
};

export type FormEmailInputUpdateOneInlineInput = {
  /** Connect existing FormEmailInput document */
  connect?: InputMaybe<FormEmailInputWhereUniqueInput>;
  /** Create and connect one FormEmailInput document */
  create?: InputMaybe<FormEmailInputCreateInput>;
  /** Delete currently connected FormEmailInput document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormEmailInput document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormEmailInput document */
  update?: InputMaybe<FormEmailInputUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormEmailInput document */
  upsert?: InputMaybe<FormEmailInputUpsertWithNestedWhereUniqueInput>;
};

export type FormEmailInputUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormEmailInputUpdateInput;
  /** Unique document search */
  where: FormEmailInputWhereUniqueInput;
};

export type FormEmailInputUpsertInput = {
  /** Create document if it didn't exist */
  create: FormEmailInputCreateInput;
  /** Update document if it exists */
  update: FormEmailInputUpdateInput;
};

export type FormEmailInputUpsertLocalizationInput = {
  create: FormEmailInputCreateLocalizationDataInput;
  locale: Locale;
  update: FormEmailInputUpdateLocalizationDataInput;
};

export type FormEmailInputUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormEmailInputUpsertInput;
  /** Unique document search */
  where: FormEmailInputWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormEmailInputWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormEmailInputWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormEmailInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormEmailInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormEmailInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormEmailInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormEmailInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormEmailInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholderText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholderText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholderText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholderText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholderText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholderText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholderText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholderText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholderText_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  testAttribute?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  testAttribute_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  testAttribute_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  testAttribute_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  testAttribute_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  testAttribute_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  testAttribute_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  testAttribute_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  testAttribute_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  testAttribute_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormEmailInputWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormEmailInputWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormEmailInputWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormEmailInputWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormEmailInputWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormEmailInput record uniquely */
export type FormEmailInputWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormError = Entity & Node & {
  __typename?: 'FormError';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormError>;
  errorCode?: Maybe<Scalars['Int']['output']>;
  forms: Array<Form>;
  /** List of FormError versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormErrorCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormErrorDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormErrorFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormErrorHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormErrorPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormErrorScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormErrorUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormErrorConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormErrorWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormErrorConnection = {
  __typename?: 'FormErrorConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormErrorEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormErrorCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  errorCode?: InputMaybe<Scalars['Int']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormErrorCreateManyInlineInput = {
  /** Connect multiple existing FormError documents */
  connect?: InputMaybe<Array<FormErrorWhereUniqueInput>>;
  /** Create and connect multiple existing FormError documents */
  create?: InputMaybe<Array<FormErrorCreateInput>>;
};

export type FormErrorCreateOneInlineInput = {
  /** Connect one existing FormError document */
  connect?: InputMaybe<FormErrorWhereUniqueInput>;
  /** Create and connect one FormError document */
  create?: InputMaybe<FormErrorCreateInput>;
};

/** An edge in a connection. */
export type FormErrorEdge = {
  __typename?: 'FormErrorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormError;
};

/** Identifies documents */
export type FormErrorManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormErrorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormErrorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormErrorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormErrorWhereStageInput>;
  documentInStages_none?: InputMaybe<FormErrorWhereStageInput>;
  documentInStages_some?: InputMaybe<FormErrorWhereStageInput>;
  errorCode?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  errorCode_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  errorCode_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  errorCode_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  errorCode_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  errorCode_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  errorCode_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  errorCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  message_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  message_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  message_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  message_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  message_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  message_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  message_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  message_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  message_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormErrorOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  errorCode_ASC = 'errorCode_ASC',
  errorCode_DESC = 'errorCode_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  message_ASC = 'message_ASC',
  message_DESC = 'message_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormErrorUpdateInput = {
  errorCode?: InputMaybe<Scalars['Int']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormErrorUpdateManyInlineInput = {
  /** Connect multiple existing FormError documents */
  connect?: InputMaybe<Array<FormErrorConnectInput>>;
  /** Create and connect multiple FormError documents */
  create?: InputMaybe<Array<FormErrorCreateInput>>;
  /** Delete multiple FormError documents */
  delete?: InputMaybe<Array<FormErrorWhereUniqueInput>>;
  /** Disconnect multiple FormError documents */
  disconnect?: InputMaybe<Array<FormErrorWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormError documents */
  set?: InputMaybe<Array<FormErrorWhereUniqueInput>>;
  /** Update multiple FormError documents */
  update?: InputMaybe<Array<FormErrorUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormError documents */
  upsert?: InputMaybe<Array<FormErrorUpsertWithNestedWhereUniqueInput>>;
};

export type FormErrorUpdateManyInput = {
  errorCode?: InputMaybe<Scalars['Int']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormErrorUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormErrorUpdateManyInput;
  /** Document search */
  where: FormErrorWhereInput;
};

export type FormErrorUpdateOneInlineInput = {
  /** Connect existing FormError document */
  connect?: InputMaybe<FormErrorWhereUniqueInput>;
  /** Create and connect one FormError document */
  create?: InputMaybe<FormErrorCreateInput>;
  /** Delete currently connected FormError document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormError document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormError document */
  update?: InputMaybe<FormErrorUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormError document */
  upsert?: InputMaybe<FormErrorUpsertWithNestedWhereUniqueInput>;
};

export type FormErrorUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormErrorUpdateInput;
  /** Unique document search */
  where: FormErrorWhereUniqueInput;
};

export type FormErrorUpsertInput = {
  /** Create document if it didn't exist */
  create: FormErrorCreateInput;
  /** Update document if it exists */
  update: FormErrorUpdateInput;
};

export type FormErrorUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormErrorUpsertInput;
  /** Unique document search */
  where: FormErrorWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormErrorWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormErrorWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormErrorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormErrorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormErrorWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormErrorWhereStageInput>;
  documentInStages_none?: InputMaybe<FormErrorWhereStageInput>;
  documentInStages_some?: InputMaybe<FormErrorWhereStageInput>;
  errorCode?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  errorCode_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  errorCode_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  errorCode_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  errorCode_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  errorCode_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  errorCode_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  errorCode_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  message_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  message_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  message_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  message_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  message_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  message_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  message_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  message_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  message_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormErrorWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormErrorWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormErrorWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormErrorWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormErrorWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormError record uniquely */
export type FormErrorWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormForm = FormCheckbox | FormEmailInput | FormPasswordInput | FormPasswordInputWithConfirmation | FormRadioButtonCollection | FormSelectComponent | FormSubmitButton | FormTextInput | FormTextareaInput;

export type FormFormConnectInput = {
  FormCheckbox?: InputMaybe<FormCheckboxConnectInput>;
  FormEmailInput?: InputMaybe<FormEmailInputConnectInput>;
  FormPasswordInput?: InputMaybe<FormPasswordInputConnectInput>;
  FormPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationConnectInput>;
  FormRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionConnectInput>;
  FormSelectComponent?: InputMaybe<FormSelectComponentConnectInput>;
  FormSubmitButton?: InputMaybe<FormSubmitButtonConnectInput>;
  FormTextInput?: InputMaybe<FormTextInputConnectInput>;
  FormTextareaInput?: InputMaybe<FormTextareaInputConnectInput>;
};

export type FormFormCreateInput = {
  FormCheckbox?: InputMaybe<FormCheckboxCreateInput>;
  FormEmailInput?: InputMaybe<FormEmailInputCreateInput>;
  FormPasswordInput?: InputMaybe<FormPasswordInputCreateInput>;
  FormPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationCreateInput>;
  FormRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionCreateInput>;
  FormSelectComponent?: InputMaybe<FormSelectComponentCreateInput>;
  FormSubmitButton?: InputMaybe<FormSubmitButtonCreateInput>;
  FormTextInput?: InputMaybe<FormTextInputCreateInput>;
  FormTextareaInput?: InputMaybe<FormTextareaInputCreateInput>;
};

export type FormFormCreateManyInlineInput = {
  /** Connect multiple existing FormForm documents */
  connect?: InputMaybe<Array<FormFormWhereUniqueInput>>;
  /** Create and connect multiple existing FormForm documents */
  create?: InputMaybe<Array<FormFormCreateInput>>;
};

export type FormFormCreateOneInlineInput = {
  /** Connect one existing FormForm document */
  connect?: InputMaybe<FormFormWhereUniqueInput>;
  /** Create and connect one FormForm document */
  create?: InputMaybe<FormFormCreateInput>;
};

export type FormFormUpdateInput = {
  FormCheckbox?: InputMaybe<FormCheckboxUpdateInput>;
  FormEmailInput?: InputMaybe<FormEmailInputUpdateInput>;
  FormPasswordInput?: InputMaybe<FormPasswordInputUpdateInput>;
  FormPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationUpdateInput>;
  FormRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionUpdateInput>;
  FormSelectComponent?: InputMaybe<FormSelectComponentUpdateInput>;
  FormSubmitButton?: InputMaybe<FormSubmitButtonUpdateInput>;
  FormTextInput?: InputMaybe<FormTextInputUpdateInput>;
  FormTextareaInput?: InputMaybe<FormTextareaInputUpdateInput>;
};

export type FormFormUpdateManyInlineInput = {
  /** Connect multiple existing FormForm documents */
  connect?: InputMaybe<Array<FormFormConnectInput>>;
  /** Create and connect multiple FormForm documents */
  create?: InputMaybe<Array<FormFormCreateInput>>;
  /** Delete multiple FormForm documents */
  delete?: InputMaybe<Array<FormFormWhereUniqueInput>>;
  /** Disconnect multiple FormForm documents */
  disconnect?: InputMaybe<Array<FormFormWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormForm documents */
  set?: InputMaybe<Array<FormFormWhereUniqueInput>>;
  /** Update multiple FormForm documents */
  update?: InputMaybe<Array<FormFormUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormForm documents */
  upsert?: InputMaybe<Array<FormFormUpsertWithNestedWhereUniqueInput>>;
};

export type FormFormUpdateManyWithNestedWhereInput = {
  FormCheckbox?: InputMaybe<FormCheckboxUpdateManyWithNestedWhereInput>;
  FormEmailInput?: InputMaybe<FormEmailInputUpdateManyWithNestedWhereInput>;
  FormPasswordInput?: InputMaybe<FormPasswordInputUpdateManyWithNestedWhereInput>;
  FormPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationUpdateManyWithNestedWhereInput>;
  FormRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionUpdateManyWithNestedWhereInput>;
  FormSelectComponent?: InputMaybe<FormSelectComponentUpdateManyWithNestedWhereInput>;
  FormSubmitButton?: InputMaybe<FormSubmitButtonUpdateManyWithNestedWhereInput>;
  FormTextInput?: InputMaybe<FormTextInputUpdateManyWithNestedWhereInput>;
  FormTextareaInput?: InputMaybe<FormTextareaInputUpdateManyWithNestedWhereInput>;
};

export type FormFormUpdateOneInlineInput = {
  /** Connect existing FormForm document */
  connect?: InputMaybe<FormFormWhereUniqueInput>;
  /** Create and connect one FormForm document */
  create?: InputMaybe<FormFormCreateInput>;
  /** Delete currently connected FormForm document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormForm document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormForm document */
  update?: InputMaybe<FormFormUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormForm document */
  upsert?: InputMaybe<FormFormUpsertWithNestedWhereUniqueInput>;
};

export type FormFormUpdateWithNestedWhereUniqueInput = {
  FormCheckbox?: InputMaybe<FormCheckboxUpdateWithNestedWhereUniqueInput>;
  FormEmailInput?: InputMaybe<FormEmailInputUpdateWithNestedWhereUniqueInput>;
  FormPasswordInput?: InputMaybe<FormPasswordInputUpdateWithNestedWhereUniqueInput>;
  FormPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationUpdateWithNestedWhereUniqueInput>;
  FormRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionUpdateWithNestedWhereUniqueInput>;
  FormSelectComponent?: InputMaybe<FormSelectComponentUpdateWithNestedWhereUniqueInput>;
  FormSubmitButton?: InputMaybe<FormSubmitButtonUpdateWithNestedWhereUniqueInput>;
  FormTextInput?: InputMaybe<FormTextInputUpdateWithNestedWhereUniqueInput>;
  FormTextareaInput?: InputMaybe<FormTextareaInputUpdateWithNestedWhereUniqueInput>;
};

export type FormFormUpsertWithNestedWhereUniqueInput = {
  FormCheckbox?: InputMaybe<FormCheckboxUpsertWithNestedWhereUniqueInput>;
  FormEmailInput?: InputMaybe<FormEmailInputUpsertWithNestedWhereUniqueInput>;
  FormPasswordInput?: InputMaybe<FormPasswordInputUpsertWithNestedWhereUniqueInput>;
  FormPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationUpsertWithNestedWhereUniqueInput>;
  FormRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionUpsertWithNestedWhereUniqueInput>;
  FormSelectComponent?: InputMaybe<FormSelectComponentUpsertWithNestedWhereUniqueInput>;
  FormSubmitButton?: InputMaybe<FormSubmitButtonUpsertWithNestedWhereUniqueInput>;
  FormTextInput?: InputMaybe<FormTextInputUpsertWithNestedWhereUniqueInput>;
  FormTextareaInput?: InputMaybe<FormTextareaInputUpsertWithNestedWhereUniqueInput>;
};

export type FormFormWhereInput = {
  FormCheckbox?: InputMaybe<FormCheckboxWhereInput>;
  FormEmailInput?: InputMaybe<FormEmailInputWhereInput>;
  FormPasswordInput?: InputMaybe<FormPasswordInputWhereInput>;
  FormPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationWhereInput>;
  FormRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  FormSelectComponent?: InputMaybe<FormSelectComponentWhereInput>;
  FormSubmitButton?: InputMaybe<FormSubmitButtonWhereInput>;
  FormTextInput?: InputMaybe<FormTextInputWhereInput>;
  FormTextareaInput?: InputMaybe<FormTextareaInputWhereInput>;
};

export type FormFormWhereUniqueInput = {
  FormCheckbox?: InputMaybe<FormCheckboxWhereUniqueInput>;
  FormEmailInput?: InputMaybe<FormEmailInputWhereUniqueInput>;
  FormPasswordInput?: InputMaybe<FormPasswordInputWhereUniqueInput>;
  FormPasswordInputWithConfirmation?: InputMaybe<FormPasswordInputWithConfirmationWhereUniqueInput>;
  FormRadioButtonCollection?: InputMaybe<FormRadioButtonCollectionWhereUniqueInput>;
  FormSelectComponent?: InputMaybe<FormSelectComponentWhereUniqueInput>;
  FormSubmitButton?: InputMaybe<FormSubmitButtonWhereUniqueInput>;
  FormTextInput?: InputMaybe<FormTextInputWhereUniqueInput>;
  FormTextareaInput?: InputMaybe<FormTextareaInputWhereUniqueInput>;
};

/** Identifies documents */
export type FormManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormWhereStageInput>;
  documentInStages_none?: InputMaybe<FormWhereStageInput>;
  documentInStages_some?: InputMaybe<FormWhereStageInput>;
  formErrors_every?: InputMaybe<FormErrorWhereInput>;
  formErrors_none?: InputMaybe<FormErrorWhereInput>;
  formErrors_some?: InputMaybe<FormErrorWhereInput>;
  /** All values in which the union is empty */
  formFields_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  formFields_some?: InputMaybe<FormFormWhereInput>;
  formSuccess?: InputMaybe<FormSuccessComponentWhereInput>;
  formType?: InputMaybe<FormTypes>;
  /** All values that are contained in given list. */
  formType_in?: InputMaybe<Array<InputMaybe<FormTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  formType_not?: InputMaybe<FormTypes>;
  /** All values that are not contained in given list. */
  formType_not_in?: InputMaybe<Array<InputMaybe<FormTypes>>>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  formType_ASC = 'formType_ASC',
  formType_DESC = 'formType_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormPasswordInput = Entity & Node & {
  __typename?: 'FormPasswordInput';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormPasswordInput>;
  /** A camel-case field name, eg. 'passwordConfirmation' */
  fieldName?: Maybe<Scalars['String']['output']>;
  forms: Array<Form>;
  /** List of FormPasswordInput versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<FormPasswordInput>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Displays when form is submitted without this field, if field is required. */
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormPasswordInputCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormPasswordInputCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormPasswordInputDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormPasswordInputFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormPasswordInputHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormPasswordInputLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type FormPasswordInputPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormPasswordInputPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormPasswordInputScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormPasswordInputUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormPasswordInputUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormPasswordInputConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormPasswordInputWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormPasswordInputConnection = {
  __typename?: 'FormPasswordInputConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormPasswordInputEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormPasswordInputCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FormPasswordInputCreateLocalizationsInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormPasswordInputCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormPasswordInputCreateLocalizationInput = {
  /** Localization input */
  data: FormPasswordInputCreateLocalizationDataInput;
  locale: Locale;
};

export type FormPasswordInputCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FormPasswordInputCreateLocalizationInput>>;
};

export type FormPasswordInputCreateManyInlineInput = {
  /** Connect multiple existing FormPasswordInput documents */
  connect?: InputMaybe<Array<FormPasswordInputWhereUniqueInput>>;
  /** Create and connect multiple existing FormPasswordInput documents */
  create?: InputMaybe<Array<FormPasswordInputCreateInput>>;
};

export type FormPasswordInputCreateOneInlineInput = {
  /** Connect one existing FormPasswordInput document */
  connect?: InputMaybe<FormPasswordInputWhereUniqueInput>;
  /** Create and connect one FormPasswordInput document */
  create?: InputMaybe<FormPasswordInputCreateInput>;
};

/** An edge in a connection. */
export type FormPasswordInputEdge = {
  __typename?: 'FormPasswordInputEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormPasswordInput;
};

/** Identifies documents */
export type FormPasswordInputManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormPasswordInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormPasswordInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormPasswordInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormPasswordInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormPasswordInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormPasswordInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormPasswordInputOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormPasswordInputUpdateInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<FormPasswordInputUpdateLocalizationsInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormPasswordInputUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FormPasswordInputUpdateLocalizationInput = {
  data: FormPasswordInputUpdateLocalizationDataInput;
  locale: Locale;
};

export type FormPasswordInputUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FormPasswordInputCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<FormPasswordInputUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<FormPasswordInputUpsertLocalizationInput>>;
};

export type FormPasswordInputUpdateManyInlineInput = {
  /** Connect multiple existing FormPasswordInput documents */
  connect?: InputMaybe<Array<FormPasswordInputConnectInput>>;
  /** Create and connect multiple FormPasswordInput documents */
  create?: InputMaybe<Array<FormPasswordInputCreateInput>>;
  /** Delete multiple FormPasswordInput documents */
  delete?: InputMaybe<Array<FormPasswordInputWhereUniqueInput>>;
  /** Disconnect multiple FormPasswordInput documents */
  disconnect?: InputMaybe<Array<FormPasswordInputWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormPasswordInput documents */
  set?: InputMaybe<Array<FormPasswordInputWhereUniqueInput>>;
  /** Update multiple FormPasswordInput documents */
  update?: InputMaybe<Array<FormPasswordInputUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormPasswordInput documents */
  upsert?: InputMaybe<Array<FormPasswordInputUpsertWithNestedWhereUniqueInput>>;
};

export type FormPasswordInputUpdateManyInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<FormPasswordInputUpdateManyLocalizationsInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormPasswordInputUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FormPasswordInputUpdateManyLocalizationInput = {
  data: FormPasswordInputUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type FormPasswordInputUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FormPasswordInputUpdateManyLocalizationInput>>;
};

export type FormPasswordInputUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormPasswordInputUpdateManyInput;
  /** Document search */
  where: FormPasswordInputWhereInput;
};

export type FormPasswordInputUpdateOneInlineInput = {
  /** Connect existing FormPasswordInput document */
  connect?: InputMaybe<FormPasswordInputWhereUniqueInput>;
  /** Create and connect one FormPasswordInput document */
  create?: InputMaybe<FormPasswordInputCreateInput>;
  /** Delete currently connected FormPasswordInput document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormPasswordInput document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormPasswordInput document */
  update?: InputMaybe<FormPasswordInputUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormPasswordInput document */
  upsert?: InputMaybe<FormPasswordInputUpsertWithNestedWhereUniqueInput>;
};

export type FormPasswordInputUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormPasswordInputUpdateInput;
  /** Unique document search */
  where: FormPasswordInputWhereUniqueInput;
};

export type FormPasswordInputUpsertInput = {
  /** Create document if it didn't exist */
  create: FormPasswordInputCreateInput;
  /** Update document if it exists */
  update: FormPasswordInputUpdateInput;
};

export type FormPasswordInputUpsertLocalizationInput = {
  create: FormPasswordInputCreateLocalizationDataInput;
  locale: Locale;
  update: FormPasswordInputUpdateLocalizationDataInput;
};

export type FormPasswordInputUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormPasswordInputUpsertInput;
  /** Unique document search */
  where: FormPasswordInputWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormPasswordInputWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormPasswordInputWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormPasswordInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormPasswordInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormPasswordInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormPasswordInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormPasswordInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormPasswordInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormPasswordInputWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormPasswordInputWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormPasswordInputWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormPasswordInputWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormPasswordInputWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormPasswordInput record uniquely */
export type FormPasswordInputWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormPasswordInputWithConfirmation = Entity & Node & {
  __typename?: 'FormPasswordInputWithConfirmation';
  confirmationTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormPasswordInputWithConfirmation>;
  forms: Array<Form>;
  /** List of FormPasswordInputWithConfirmation versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormPasswordInputWithConfirmationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormPasswordInputWithConfirmationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormPasswordInputWithConfirmationFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormPasswordInputWithConfirmationHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormPasswordInputWithConfirmationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormPasswordInputWithConfirmationScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormPasswordInputWithConfirmationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormPasswordInputWithConfirmationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormPasswordInputWithConfirmationConnection = {
  __typename?: 'FormPasswordInputWithConfirmationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormPasswordInputWithConfirmationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormPasswordInputWithConfirmationCreateInput = {
  confirmationTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormPasswordInputWithConfirmationCreateManyInlineInput = {
  /** Connect multiple existing FormPasswordInputWithConfirmation documents */
  connect?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereUniqueInput>>;
  /** Create and connect multiple existing FormPasswordInputWithConfirmation documents */
  create?: InputMaybe<Array<FormPasswordInputWithConfirmationCreateInput>>;
};

export type FormPasswordInputWithConfirmationCreateOneInlineInput = {
  /** Connect one existing FormPasswordInputWithConfirmation document */
  connect?: InputMaybe<FormPasswordInputWithConfirmationWhereUniqueInput>;
  /** Create and connect one FormPasswordInputWithConfirmation document */
  create?: InputMaybe<FormPasswordInputWithConfirmationCreateInput>;
};

/** An edge in a connection. */
export type FormPasswordInputWithConfirmationEdge = {
  __typename?: 'FormPasswordInputWithConfirmationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormPasswordInputWithConfirmation;
};

/** Identifies documents */
export type FormPasswordInputWithConfirmationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  confirmationTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  confirmationTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  confirmationTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  confirmationTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  confirmationTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  confirmationTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  confirmationTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  confirmationTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  confirmationTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  confirmationTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormPasswordInputWithConfirmationWhereStageInput>;
  documentInStages_none?: InputMaybe<FormPasswordInputWithConfirmationWhereStageInput>;
  documentInStages_some?: InputMaybe<FormPasswordInputWithConfirmationWhereStageInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormPasswordInputWithConfirmationOrderByInput {
  confirmationTitle_ASC = 'confirmationTitle_ASC',
  confirmationTitle_DESC = 'confirmationTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormPasswordInputWithConfirmationUpdateInput = {
  confirmationTitle?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormPasswordInputWithConfirmationUpdateManyInlineInput = {
  /** Connect multiple existing FormPasswordInputWithConfirmation documents */
  connect?: InputMaybe<Array<FormPasswordInputWithConfirmationConnectInput>>;
  /** Create and connect multiple FormPasswordInputWithConfirmation documents */
  create?: InputMaybe<Array<FormPasswordInputWithConfirmationCreateInput>>;
  /** Delete multiple FormPasswordInputWithConfirmation documents */
  delete?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereUniqueInput>>;
  /** Disconnect multiple FormPasswordInputWithConfirmation documents */
  disconnect?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormPasswordInputWithConfirmation documents */
  set?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereUniqueInput>>;
  /** Update multiple FormPasswordInputWithConfirmation documents */
  update?: InputMaybe<Array<FormPasswordInputWithConfirmationUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormPasswordInputWithConfirmation documents */
  upsert?: InputMaybe<Array<FormPasswordInputWithConfirmationUpsertWithNestedWhereUniqueInput>>;
};

export type FormPasswordInputWithConfirmationUpdateManyInput = {
  confirmationTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormPasswordInputWithConfirmationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormPasswordInputWithConfirmationUpdateManyInput;
  /** Document search */
  where: FormPasswordInputWithConfirmationWhereInput;
};

export type FormPasswordInputWithConfirmationUpdateOneInlineInput = {
  /** Connect existing FormPasswordInputWithConfirmation document */
  connect?: InputMaybe<FormPasswordInputWithConfirmationWhereUniqueInput>;
  /** Create and connect one FormPasswordInputWithConfirmation document */
  create?: InputMaybe<FormPasswordInputWithConfirmationCreateInput>;
  /** Delete currently connected FormPasswordInputWithConfirmation document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormPasswordInputWithConfirmation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormPasswordInputWithConfirmation document */
  update?: InputMaybe<FormPasswordInputWithConfirmationUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormPasswordInputWithConfirmation document */
  upsert?: InputMaybe<FormPasswordInputWithConfirmationUpsertWithNestedWhereUniqueInput>;
};

export type FormPasswordInputWithConfirmationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormPasswordInputWithConfirmationUpdateInput;
  /** Unique document search */
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};

export type FormPasswordInputWithConfirmationUpsertInput = {
  /** Create document if it didn't exist */
  create: FormPasswordInputWithConfirmationCreateInput;
  /** Update document if it exists */
  update: FormPasswordInputWithConfirmationUpdateInput;
};

export type FormPasswordInputWithConfirmationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormPasswordInputWithConfirmationUpsertInput;
  /** Unique document search */
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormPasswordInputWithConfirmationWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormPasswordInputWithConfirmationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  confirmationTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  confirmationTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  confirmationTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  confirmationTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  confirmationTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  confirmationTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  confirmationTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  confirmationTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  confirmationTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  confirmationTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormPasswordInputWithConfirmationWhereStageInput>;
  documentInStages_none?: InputMaybe<FormPasswordInputWithConfirmationWhereStageInput>;
  documentInStages_some?: InputMaybe<FormPasswordInputWithConfirmationWhereStageInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormPasswordInputWithConfirmationWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormPasswordInputWithConfirmationWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormPasswordInputWithConfirmationWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormPasswordInputWithConfirmation record uniquely */
export type FormPasswordInputWithConfirmationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormRadioButton = Entity & Node & {
  __typename?: 'FormRadioButton';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormRadioButton>;
  formRadioButtonCollections: Array<FormRadioButtonCollection>;
  /** List of FormRadioButton versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Label for the radio button, eg. 'Age 30-35' */
  label?: Maybe<Scalars['String']['output']>;
  /** Option for the radio button value, eg. 'married', 'single' */
  option?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Used only in the CMS to identify fields. */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormRadioButtonCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormRadioButtonDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormRadioButtonFormRadioButtonCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormRadioButtonCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormRadioButtonCollectionWhereInput>;
};


export type FormRadioButtonHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormRadioButtonPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormRadioButtonScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormRadioButtonUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormRadioButtonCollection = Entity & Node & {
  __typename?: 'FormRadioButtonCollection';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormRadioButtonCollection>;
  /** Eg. 'userAge', 'customerType' - an attribute the user select a value for */
  fieldName?: Maybe<Scalars['String']['output']>;
  formRadioButtons: Array<FormRadioButton>;
  forms: Array<Form>;
  /** List of FormRadioButtonCollection versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormRadioButtonCollectionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormRadioButtonCollectionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormRadioButtonCollectionFormRadioButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormRadioButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormRadioButtonWhereInput>;
};


export type FormRadioButtonCollectionFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormRadioButtonCollectionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormRadioButtonCollectionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormRadioButtonCollectionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormRadioButtonCollectionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormRadioButtonCollectionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormRadioButtonCollectionWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormRadioButtonCollectionConnection = {
  __typename?: 'FormRadioButtonCollectionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormRadioButtonCollectionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormRadioButtonCollectionCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  formRadioButtons?: InputMaybe<FormRadioButtonCreateManyInlineInput>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormRadioButtonCollectionCreateManyInlineInput = {
  /** Connect multiple existing FormRadioButtonCollection documents */
  connect?: InputMaybe<Array<FormRadioButtonCollectionWhereUniqueInput>>;
  /** Create and connect multiple existing FormRadioButtonCollection documents */
  create?: InputMaybe<Array<FormRadioButtonCollectionCreateInput>>;
};

export type FormRadioButtonCollectionCreateOneInlineInput = {
  /** Connect one existing FormRadioButtonCollection document */
  connect?: InputMaybe<FormRadioButtonCollectionWhereUniqueInput>;
  /** Create and connect one FormRadioButtonCollection document */
  create?: InputMaybe<FormRadioButtonCollectionCreateInput>;
};

/** An edge in a connection. */
export type FormRadioButtonCollectionEdge = {
  __typename?: 'FormRadioButtonCollectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormRadioButtonCollection;
};

/** Identifies documents */
export type FormRadioButtonCollectionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormRadioButtonCollectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormRadioButtonCollectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormRadioButtonCollectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormRadioButtonCollectionWhereStageInput>;
  documentInStages_none?: InputMaybe<FormRadioButtonCollectionWhereStageInput>;
  documentInStages_some?: InputMaybe<FormRadioButtonCollectionWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  formRadioButtons_every?: InputMaybe<FormRadioButtonWhereInput>;
  formRadioButtons_none?: InputMaybe<FormRadioButtonWhereInput>;
  formRadioButtons_some?: InputMaybe<FormRadioButtonWhereInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormRadioButtonCollectionOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormRadioButtonCollectionUpdateInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  formRadioButtons?: InputMaybe<FormRadioButtonUpdateManyInlineInput>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormRadioButtonCollectionUpdateManyInlineInput = {
  /** Connect multiple existing FormRadioButtonCollection documents */
  connect?: InputMaybe<Array<FormRadioButtonCollectionConnectInput>>;
  /** Create and connect multiple FormRadioButtonCollection documents */
  create?: InputMaybe<Array<FormRadioButtonCollectionCreateInput>>;
  /** Delete multiple FormRadioButtonCollection documents */
  delete?: InputMaybe<Array<FormRadioButtonCollectionWhereUniqueInput>>;
  /** Disconnect multiple FormRadioButtonCollection documents */
  disconnect?: InputMaybe<Array<FormRadioButtonCollectionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormRadioButtonCollection documents */
  set?: InputMaybe<Array<FormRadioButtonCollectionWhereUniqueInput>>;
  /** Update multiple FormRadioButtonCollection documents */
  update?: InputMaybe<Array<FormRadioButtonCollectionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormRadioButtonCollection documents */
  upsert?: InputMaybe<Array<FormRadioButtonCollectionUpsertWithNestedWhereUniqueInput>>;
};

export type FormRadioButtonCollectionUpdateManyInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormRadioButtonCollectionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormRadioButtonCollectionUpdateManyInput;
  /** Document search */
  where: FormRadioButtonCollectionWhereInput;
};

export type FormRadioButtonCollectionUpdateOneInlineInput = {
  /** Connect existing FormRadioButtonCollection document */
  connect?: InputMaybe<FormRadioButtonCollectionWhereUniqueInput>;
  /** Create and connect one FormRadioButtonCollection document */
  create?: InputMaybe<FormRadioButtonCollectionCreateInput>;
  /** Delete currently connected FormRadioButtonCollection document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormRadioButtonCollection document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormRadioButtonCollection document */
  update?: InputMaybe<FormRadioButtonCollectionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormRadioButtonCollection document */
  upsert?: InputMaybe<FormRadioButtonCollectionUpsertWithNestedWhereUniqueInput>;
};

export type FormRadioButtonCollectionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormRadioButtonCollectionUpdateInput;
  /** Unique document search */
  where: FormRadioButtonCollectionWhereUniqueInput;
};

export type FormRadioButtonCollectionUpsertInput = {
  /** Create document if it didn't exist */
  create: FormRadioButtonCollectionCreateInput;
  /** Update document if it exists */
  update: FormRadioButtonCollectionUpdateInput;
};

export type FormRadioButtonCollectionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormRadioButtonCollectionUpsertInput;
  /** Unique document search */
  where: FormRadioButtonCollectionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormRadioButtonCollectionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormRadioButtonCollectionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormRadioButtonCollectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormRadioButtonCollectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormRadioButtonCollectionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormRadioButtonCollectionWhereStageInput>;
  documentInStages_none?: InputMaybe<FormRadioButtonCollectionWhereStageInput>;
  documentInStages_some?: InputMaybe<FormRadioButtonCollectionWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  formRadioButtons_every?: InputMaybe<FormRadioButtonWhereInput>;
  formRadioButtons_none?: InputMaybe<FormRadioButtonWhereInput>;
  formRadioButtons_some?: InputMaybe<FormRadioButtonWhereInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormRadioButtonCollectionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormRadioButtonCollectionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormRadioButtonCollectionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormRadioButtonCollectionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormRadioButtonCollectionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormRadioButtonCollection record uniquely */
export type FormRadioButtonCollectionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormRadioButtonConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormRadioButtonWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormRadioButtonConnection = {
  __typename?: 'FormRadioButtonConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormRadioButtonEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormRadioButtonCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  formRadioButtonCollections?: InputMaybe<FormRadioButtonCollectionCreateManyInlineInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormRadioButtonCreateManyInlineInput = {
  /** Connect multiple existing FormRadioButton documents */
  connect?: InputMaybe<Array<FormRadioButtonWhereUniqueInput>>;
  /** Create and connect multiple existing FormRadioButton documents */
  create?: InputMaybe<Array<FormRadioButtonCreateInput>>;
};

export type FormRadioButtonCreateOneInlineInput = {
  /** Connect one existing FormRadioButton document */
  connect?: InputMaybe<FormRadioButtonWhereUniqueInput>;
  /** Create and connect one FormRadioButton document */
  create?: InputMaybe<FormRadioButtonCreateInput>;
};

/** An edge in a connection. */
export type FormRadioButtonEdge = {
  __typename?: 'FormRadioButtonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormRadioButton;
};

/** Identifies documents */
export type FormRadioButtonManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormRadioButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormRadioButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormRadioButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormRadioButtonWhereStageInput>;
  documentInStages_none?: InputMaybe<FormRadioButtonWhereStageInput>;
  documentInStages_some?: InputMaybe<FormRadioButtonWhereStageInput>;
  formRadioButtonCollections_every?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  formRadioButtonCollections_none?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  formRadioButtonCollections_some?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  option_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  option_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  option_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  option_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  option_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  option_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  option_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  option_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  option_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormRadioButtonOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  option_ASC = 'option_ASC',
  option_DESC = 'option_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormRadioButtonUpdateInput = {
  formRadioButtonCollections?: InputMaybe<FormRadioButtonCollectionUpdateManyInlineInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormRadioButtonUpdateManyInlineInput = {
  /** Connect multiple existing FormRadioButton documents */
  connect?: InputMaybe<Array<FormRadioButtonConnectInput>>;
  /** Create and connect multiple FormRadioButton documents */
  create?: InputMaybe<Array<FormRadioButtonCreateInput>>;
  /** Delete multiple FormRadioButton documents */
  delete?: InputMaybe<Array<FormRadioButtonWhereUniqueInput>>;
  /** Disconnect multiple FormRadioButton documents */
  disconnect?: InputMaybe<Array<FormRadioButtonWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormRadioButton documents */
  set?: InputMaybe<Array<FormRadioButtonWhereUniqueInput>>;
  /** Update multiple FormRadioButton documents */
  update?: InputMaybe<Array<FormRadioButtonUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormRadioButton documents */
  upsert?: InputMaybe<Array<FormRadioButtonUpsertWithNestedWhereUniqueInput>>;
};

export type FormRadioButtonUpdateManyInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormRadioButtonUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormRadioButtonUpdateManyInput;
  /** Document search */
  where: FormRadioButtonWhereInput;
};

export type FormRadioButtonUpdateOneInlineInput = {
  /** Connect existing FormRadioButton document */
  connect?: InputMaybe<FormRadioButtonWhereUniqueInput>;
  /** Create and connect one FormRadioButton document */
  create?: InputMaybe<FormRadioButtonCreateInput>;
  /** Delete currently connected FormRadioButton document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormRadioButton document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormRadioButton document */
  update?: InputMaybe<FormRadioButtonUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormRadioButton document */
  upsert?: InputMaybe<FormRadioButtonUpsertWithNestedWhereUniqueInput>;
};

export type FormRadioButtonUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormRadioButtonUpdateInput;
  /** Unique document search */
  where: FormRadioButtonWhereUniqueInput;
};

export type FormRadioButtonUpsertInput = {
  /** Create document if it didn't exist */
  create: FormRadioButtonCreateInput;
  /** Update document if it exists */
  update: FormRadioButtonUpdateInput;
};

export type FormRadioButtonUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormRadioButtonUpsertInput;
  /** Unique document search */
  where: FormRadioButtonWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormRadioButtonWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormRadioButtonWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormRadioButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormRadioButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormRadioButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormRadioButtonWhereStageInput>;
  documentInStages_none?: InputMaybe<FormRadioButtonWhereStageInput>;
  documentInStages_some?: InputMaybe<FormRadioButtonWhereStageInput>;
  formRadioButtonCollections_every?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  formRadioButtonCollections_none?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  formRadioButtonCollections_some?: InputMaybe<FormRadioButtonCollectionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  option?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  option_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  option_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  option_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  option_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  option_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  option_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  option_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  option_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  option_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormRadioButtonWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormRadioButtonWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormRadioButtonWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormRadioButtonWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormRadioButtonWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormRadioButton record uniquely */
export type FormRadioButtonWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormSelectComponent = Entity & Node & {
  __typename?: 'FormSelectComponent';
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormSelectComponent>;
  fieldName?: Maybe<Scalars['String']['output']>;
  forms: Array<Form>;
  /** List of FormSelectComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  initialValue?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<FormSelectComponent>;
  /** list of options to show when dropdown opens */
  options: Array<FormSelectOption>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  /** error message to show if field is required and user has not filled it */
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormSelectComponentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormSelectComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSelectComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormSelectComponentFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormSelectComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormSelectComponentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type FormSelectComponentOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<FormSelectOptionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSelectOptionWhereInput>;
};


export type FormSelectComponentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormSelectComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSelectComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormSelectComponentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormSelectComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormSelectComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormSelectComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormSelectComponentConnection = {
  __typename?: 'FormSelectComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormSelectComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormSelectComponentCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FormSelectComponentCreateLocalizationsInput>;
  options?: InputMaybe<FormSelectOptionCreateManyInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormSelectComponentCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormSelectComponentCreateLocalizationInput = {
  /** Localization input */
  data: FormSelectComponentCreateLocalizationDataInput;
  locale: Locale;
};

export type FormSelectComponentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FormSelectComponentCreateLocalizationInput>>;
};

export type FormSelectComponentCreateManyInlineInput = {
  /** Connect multiple existing FormSelectComponent documents */
  connect?: InputMaybe<Array<FormSelectComponentWhereUniqueInput>>;
  /** Create and connect multiple existing FormSelectComponent documents */
  create?: InputMaybe<Array<FormSelectComponentCreateInput>>;
};

export type FormSelectComponentCreateOneInlineInput = {
  /** Connect one existing FormSelectComponent document */
  connect?: InputMaybe<FormSelectComponentWhereUniqueInput>;
  /** Create and connect one FormSelectComponent document */
  create?: InputMaybe<FormSelectComponentCreateInput>;
};

/** An edge in a connection. */
export type FormSelectComponentEdge = {
  __typename?: 'FormSelectComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormSelectComponent;
};

/** Identifies documents */
export type FormSelectComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSelectComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSelectComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSelectComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormSelectComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<FormSelectComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<FormSelectComponentWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  options_every?: InputMaybe<FormSelectOptionWhereInput>;
  options_none?: InputMaybe<FormSelectOptionWhereInput>;
  options_some?: InputMaybe<FormSelectOptionWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormSelectComponentOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  initialValue_ASC = 'initialValue_ASC',
  initialValue_DESC = 'initialValue_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormSelectComponentUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<FormSelectComponentUpdateLocalizationsInput>;
  options?: InputMaybe<FormSelectOptionUpdateManyInlineInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
};

export type FormSelectComponentUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FormSelectComponentUpdateLocalizationInput = {
  data: FormSelectComponentUpdateLocalizationDataInput;
  locale: Locale;
};

export type FormSelectComponentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FormSelectComponentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<FormSelectComponentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<FormSelectComponentUpsertLocalizationInput>>;
};

export type FormSelectComponentUpdateManyInlineInput = {
  /** Connect multiple existing FormSelectComponent documents */
  connect?: InputMaybe<Array<FormSelectComponentConnectInput>>;
  /** Create and connect multiple FormSelectComponent documents */
  create?: InputMaybe<Array<FormSelectComponentCreateInput>>;
  /** Delete multiple FormSelectComponent documents */
  delete?: InputMaybe<Array<FormSelectComponentWhereUniqueInput>>;
  /** Disconnect multiple FormSelectComponent documents */
  disconnect?: InputMaybe<Array<FormSelectComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormSelectComponent documents */
  set?: InputMaybe<Array<FormSelectComponentWhereUniqueInput>>;
  /** Update multiple FormSelectComponent documents */
  update?: InputMaybe<Array<FormSelectComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormSelectComponent documents */
  upsert?: InputMaybe<Array<FormSelectComponentUpsertWithNestedWhereUniqueInput>>;
};

export type FormSelectComponentUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<FormSelectComponentUpdateManyLocalizationsInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
};

export type FormSelectComponentUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FormSelectComponentUpdateManyLocalizationInput = {
  data: FormSelectComponentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type FormSelectComponentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FormSelectComponentUpdateManyLocalizationInput>>;
};

export type FormSelectComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormSelectComponentUpdateManyInput;
  /** Document search */
  where: FormSelectComponentWhereInput;
};

export type FormSelectComponentUpdateOneInlineInput = {
  /** Connect existing FormSelectComponent document */
  connect?: InputMaybe<FormSelectComponentWhereUniqueInput>;
  /** Create and connect one FormSelectComponent document */
  create?: InputMaybe<FormSelectComponentCreateInput>;
  /** Delete currently connected FormSelectComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormSelectComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormSelectComponent document */
  update?: InputMaybe<FormSelectComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormSelectComponent document */
  upsert?: InputMaybe<FormSelectComponentUpsertWithNestedWhereUniqueInput>;
};

export type FormSelectComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormSelectComponentUpdateInput;
  /** Unique document search */
  where: FormSelectComponentWhereUniqueInput;
};

export type FormSelectComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: FormSelectComponentCreateInput;
  /** Update document if it exists */
  update: FormSelectComponentUpdateInput;
};

export type FormSelectComponentUpsertLocalizationInput = {
  create: FormSelectComponentCreateLocalizationDataInput;
  locale: Locale;
  update: FormSelectComponentUpdateLocalizationDataInput;
};

export type FormSelectComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormSelectComponentUpsertInput;
  /** Unique document search */
  where: FormSelectComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormSelectComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormSelectComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSelectComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSelectComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSelectComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormSelectComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<FormSelectComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<FormSelectComponentWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  options_every?: InputMaybe<FormSelectOptionWhereInput>;
  options_none?: InputMaybe<FormSelectOptionWhereInput>;
  options_some?: InputMaybe<FormSelectOptionWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormSelectComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSelectComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSelectComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSelectComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormSelectComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormSelectComponent record uniquely */
export type FormSelectComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormSelectOption = Entity & Node & {
  __typename?: 'FormSelectOption';
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormSelectOption>;
  /** List of FormSelectOption versions */
  history: Array<Version>;
  /** asset for left icon to display in options */
  iconLeft?: Maybe<Asset>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** label or text which shows up in dropdown list */
  label: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** value of the dropdown options */
  value: Scalars['String']['output'];
};


export type FormSelectOptionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSelectOptionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormSelectOptionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormSelectOptionIconLeftArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type FormSelectOptionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSelectOptionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormSelectOptionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormSelectOptionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormSelectOptionWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormSelectOptionConnection = {
  __typename?: 'FormSelectOptionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormSelectOptionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormSelectOptionCreateInput = {
  ckv0hh8fx0sk701zd8bw60y5h?: InputMaybe<FormSelectComponentCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  iconLeft?: InputMaybe<AssetCreateOneInlineInput>;
  label: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['String']['input'];
};

export type FormSelectOptionCreateManyInlineInput = {
  /** Connect multiple existing FormSelectOption documents */
  connect?: InputMaybe<Array<FormSelectOptionWhereUniqueInput>>;
  /** Create and connect multiple existing FormSelectOption documents */
  create?: InputMaybe<Array<FormSelectOptionCreateInput>>;
};

export type FormSelectOptionCreateOneInlineInput = {
  /** Connect one existing FormSelectOption document */
  connect?: InputMaybe<FormSelectOptionWhereUniqueInput>;
  /** Create and connect one FormSelectOption document */
  create?: InputMaybe<FormSelectOptionCreateInput>;
};

/** An edge in a connection. */
export type FormSelectOptionEdge = {
  __typename?: 'FormSelectOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormSelectOption;
};

/** Identifies documents */
export type FormSelectOptionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSelectOptionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSelectOptionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSelectOptionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormSelectOptionWhereStageInput>;
  documentInStages_none?: InputMaybe<FormSelectOptionWhereStageInput>;
  documentInStages_some?: InputMaybe<FormSelectOptionWhereStageInput>;
  iconLeft?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  value?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  value_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum FormSelectOptionOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  value_ASC = 'value_ASC',
  value_DESC = 'value_DESC'
}

export type FormSelectOptionUpdateInput = {
  ckv0hh8fx0sk701zd8bw60y5h?: InputMaybe<FormSelectComponentUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  iconLeft?: InputMaybe<AssetUpdateOneInlineInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FormSelectOptionUpdateManyInlineInput = {
  /** Connect multiple existing FormSelectOption documents */
  connect?: InputMaybe<Array<FormSelectOptionConnectInput>>;
  /** Create and connect multiple FormSelectOption documents */
  create?: InputMaybe<Array<FormSelectOptionCreateInput>>;
  /** Delete multiple FormSelectOption documents */
  delete?: InputMaybe<Array<FormSelectOptionWhereUniqueInput>>;
  /** Disconnect multiple FormSelectOption documents */
  disconnect?: InputMaybe<Array<FormSelectOptionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormSelectOption documents */
  set?: InputMaybe<Array<FormSelectOptionWhereUniqueInput>>;
  /** Update multiple FormSelectOption documents */
  update?: InputMaybe<Array<FormSelectOptionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormSelectOption documents */
  upsert?: InputMaybe<Array<FormSelectOptionUpsertWithNestedWhereUniqueInput>>;
};

export type FormSelectOptionUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FormSelectOptionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormSelectOptionUpdateManyInput;
  /** Document search */
  where: FormSelectOptionWhereInput;
};

export type FormSelectOptionUpdateOneInlineInput = {
  /** Connect existing FormSelectOption document */
  connect?: InputMaybe<FormSelectOptionWhereUniqueInput>;
  /** Create and connect one FormSelectOption document */
  create?: InputMaybe<FormSelectOptionCreateInput>;
  /** Delete currently connected FormSelectOption document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormSelectOption document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormSelectOption document */
  update?: InputMaybe<FormSelectOptionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormSelectOption document */
  upsert?: InputMaybe<FormSelectOptionUpsertWithNestedWhereUniqueInput>;
};

export type FormSelectOptionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormSelectOptionUpdateInput;
  /** Unique document search */
  where: FormSelectOptionWhereUniqueInput;
};

export type FormSelectOptionUpsertInput = {
  /** Create document if it didn't exist */
  create: FormSelectOptionCreateInput;
  /** Update document if it exists */
  update: FormSelectOptionUpdateInput;
};

export type FormSelectOptionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormSelectOptionUpsertInput;
  /** Unique document search */
  where: FormSelectOptionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormSelectOptionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormSelectOptionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSelectOptionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSelectOptionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSelectOptionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormSelectOptionWhereStageInput>;
  documentInStages_none?: InputMaybe<FormSelectOptionWhereStageInput>;
  documentInStages_some?: InputMaybe<FormSelectOptionWhereStageInput>;
  iconLeft?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  value?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  value_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  value_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  value_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  value_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  value_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  value_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  value_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  value_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  value_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormSelectOptionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSelectOptionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSelectOptionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSelectOptionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormSelectOptionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormSelectOption record uniquely */
export type FormSelectOptionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormSubmitButton = Entity & Node & {
  __typename?: 'FormSubmitButton';
  /** Used when the form is in a 'loading' state. */
  buttonLoadingText?: Maybe<Scalars['String']['output']>;
  buttonText?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormSubmitButton>;
  forms: Array<Form>;
  /** List of FormSubmitButton versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<FormSubmitButton>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormSubmitButtonCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormSubmitButtonCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSubmitButtonDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormSubmitButtonFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormSubmitButtonHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormSubmitButtonLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type FormSubmitButtonPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormSubmitButtonPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSubmitButtonScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormSubmitButtonUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormSubmitButtonUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormSubmitButtonConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormSubmitButtonWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormSubmitButtonConnection = {
  __typename?: 'FormSubmitButtonConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormSubmitButtonEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormSubmitButtonCreateInput = {
  buttonLoadingText?: InputMaybe<Scalars['String']['input']>;
  /** buttonText input for default locale (default) */
  buttonText?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FormSubmitButtonCreateLocalizationsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormSubmitButtonCreateLocalizationDataInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormSubmitButtonCreateLocalizationInput = {
  /** Localization input */
  data: FormSubmitButtonCreateLocalizationDataInput;
  locale: Locale;
};

export type FormSubmitButtonCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FormSubmitButtonCreateLocalizationInput>>;
};

export type FormSubmitButtonCreateManyInlineInput = {
  /** Connect multiple existing FormSubmitButton documents */
  connect?: InputMaybe<Array<FormSubmitButtonWhereUniqueInput>>;
  /** Create and connect multiple existing FormSubmitButton documents */
  create?: InputMaybe<Array<FormSubmitButtonCreateInput>>;
};

export type FormSubmitButtonCreateOneInlineInput = {
  /** Connect one existing FormSubmitButton document */
  connect?: InputMaybe<FormSubmitButtonWhereUniqueInput>;
  /** Create and connect one FormSubmitButton document */
  create?: InputMaybe<FormSubmitButtonCreateInput>;
};

/** An edge in a connection. */
export type FormSubmitButtonEdge = {
  __typename?: 'FormSubmitButtonEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormSubmitButton;
};

/** Identifies documents */
export type FormSubmitButtonManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSubmitButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSubmitButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSubmitButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttonLoadingText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  buttonLoadingText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  buttonLoadingText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  buttonLoadingText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonLoadingText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  buttonLoadingText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  buttonLoadingText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  buttonLoadingText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  buttonLoadingText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  buttonLoadingText_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormSubmitButtonWhereStageInput>;
  documentInStages_none?: InputMaybe<FormSubmitButtonWhereStageInput>;
  documentInStages_some?: InputMaybe<FormSubmitButtonWhereStageInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormSubmitButtonOrderByInput {
  buttonLoadingText_ASC = 'buttonLoadingText_ASC',
  buttonLoadingText_DESC = 'buttonLoadingText_DESC',
  buttonText_ASC = 'buttonText_ASC',
  buttonText_DESC = 'buttonText_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormSubmitButtonUpdateInput = {
  buttonLoadingText?: InputMaybe<Scalars['String']['input']>;
  /** buttonText input for default locale (default) */
  buttonText?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<FormSubmitButtonUpdateLocalizationsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormSubmitButtonUpdateLocalizationDataInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
};

export type FormSubmitButtonUpdateLocalizationInput = {
  data: FormSubmitButtonUpdateLocalizationDataInput;
  locale: Locale;
};

export type FormSubmitButtonUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FormSubmitButtonCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<FormSubmitButtonUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<FormSubmitButtonUpsertLocalizationInput>>;
};

export type FormSubmitButtonUpdateManyInlineInput = {
  /** Connect multiple existing FormSubmitButton documents */
  connect?: InputMaybe<Array<FormSubmitButtonConnectInput>>;
  /** Create and connect multiple FormSubmitButton documents */
  create?: InputMaybe<Array<FormSubmitButtonCreateInput>>;
  /** Delete multiple FormSubmitButton documents */
  delete?: InputMaybe<Array<FormSubmitButtonWhereUniqueInput>>;
  /** Disconnect multiple FormSubmitButton documents */
  disconnect?: InputMaybe<Array<FormSubmitButtonWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormSubmitButton documents */
  set?: InputMaybe<Array<FormSubmitButtonWhereUniqueInput>>;
  /** Update multiple FormSubmitButton documents */
  update?: InputMaybe<Array<FormSubmitButtonUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormSubmitButton documents */
  upsert?: InputMaybe<Array<FormSubmitButtonUpsertWithNestedWhereUniqueInput>>;
};

export type FormSubmitButtonUpdateManyInput = {
  buttonLoadingText?: InputMaybe<Scalars['String']['input']>;
  /** buttonText input for default locale (default) */
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<FormSubmitButtonUpdateManyLocalizationsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormSubmitButtonUpdateManyLocalizationDataInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
};

export type FormSubmitButtonUpdateManyLocalizationInput = {
  data: FormSubmitButtonUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type FormSubmitButtonUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FormSubmitButtonUpdateManyLocalizationInput>>;
};

export type FormSubmitButtonUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormSubmitButtonUpdateManyInput;
  /** Document search */
  where: FormSubmitButtonWhereInput;
};

export type FormSubmitButtonUpdateOneInlineInput = {
  /** Connect existing FormSubmitButton document */
  connect?: InputMaybe<FormSubmitButtonWhereUniqueInput>;
  /** Create and connect one FormSubmitButton document */
  create?: InputMaybe<FormSubmitButtonCreateInput>;
  /** Delete currently connected FormSubmitButton document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormSubmitButton document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormSubmitButton document */
  update?: InputMaybe<FormSubmitButtonUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormSubmitButton document */
  upsert?: InputMaybe<FormSubmitButtonUpsertWithNestedWhereUniqueInput>;
};

export type FormSubmitButtonUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormSubmitButtonUpdateInput;
  /** Unique document search */
  where: FormSubmitButtonWhereUniqueInput;
};

export type FormSubmitButtonUpsertInput = {
  /** Create document if it didn't exist */
  create: FormSubmitButtonCreateInput;
  /** Update document if it exists */
  update: FormSubmitButtonUpdateInput;
};

export type FormSubmitButtonUpsertLocalizationInput = {
  create: FormSubmitButtonCreateLocalizationDataInput;
  locale: Locale;
  update: FormSubmitButtonUpdateLocalizationDataInput;
};

export type FormSubmitButtonUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormSubmitButtonUpsertInput;
  /** Unique document search */
  where: FormSubmitButtonWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormSubmitButtonWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormSubmitButtonWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSubmitButtonWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSubmitButtonWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSubmitButtonWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttonLoadingText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  buttonLoadingText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  buttonLoadingText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  buttonLoadingText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonLoadingText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  buttonLoadingText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  buttonLoadingText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  buttonLoadingText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  buttonLoadingText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  buttonLoadingText_starts_with?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  buttonText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  buttonText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  buttonText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  buttonText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  buttonText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  buttonText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  buttonText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  buttonText_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormSubmitButtonWhereStageInput>;
  documentInStages_none?: InputMaybe<FormSubmitButtonWhereStageInput>;
  documentInStages_some?: InputMaybe<FormSubmitButtonWhereStageInput>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormSubmitButtonWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSubmitButtonWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSubmitButtonWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSubmitButtonWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormSubmitButtonWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormSubmitButton record uniquely */
export type FormSubmitButtonWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormSuccessComponent = Entity & Node & {
  __typename?: 'FormSuccessComponent';
  /** title for use just in CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<FormSuccessComponent>;
  /** List of FormSuccessComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<FormSuccessComponent>;
  /** success message */
  message: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormSuccessComponentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormSuccessComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSuccessComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormSuccessComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormSuccessComponentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type FormSuccessComponentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormSuccessComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormSuccessComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormSuccessComponentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormSuccessComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormSuccessComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormSuccessComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormSuccessComponentConnection = {
  __typename?: 'FormSuccessComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormSuccessComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormSuccessComponentCreateInput = {
  ckv0mmd3m0xde01yz5nm65edw?: InputMaybe<FormCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FormSuccessComponentCreateLocalizationsInput>;
  /** message input for default locale (default) */
  message: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormSuccessComponentCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormSuccessComponentCreateLocalizationInput = {
  /** Localization input */
  data: FormSuccessComponentCreateLocalizationDataInput;
  locale: Locale;
};

export type FormSuccessComponentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FormSuccessComponentCreateLocalizationInput>>;
};

export type FormSuccessComponentCreateManyInlineInput = {
  /** Connect multiple existing FormSuccessComponent documents */
  connect?: InputMaybe<Array<FormSuccessComponentWhereUniqueInput>>;
  /** Create and connect multiple existing FormSuccessComponent documents */
  create?: InputMaybe<Array<FormSuccessComponentCreateInput>>;
};

export type FormSuccessComponentCreateOneInlineInput = {
  /** Connect one existing FormSuccessComponent document */
  connect?: InputMaybe<FormSuccessComponentWhereUniqueInput>;
  /** Create and connect one FormSuccessComponent document */
  create?: InputMaybe<FormSuccessComponentCreateInput>;
};

/** An edge in a connection. */
export type FormSuccessComponentEdge = {
  __typename?: 'FormSuccessComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormSuccessComponent;
};

/** Identifies documents */
export type FormSuccessComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSuccessComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSuccessComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSuccessComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormSuccessComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<FormSuccessComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<FormSuccessComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormSuccessComponentOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  message_ASC = 'message_ASC',
  message_DESC = 'message_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormSuccessComponentUpdateInput = {
  ckv0mmd3m0xde01yz5nm65edw?: InputMaybe<FormUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<FormSuccessComponentUpdateLocalizationsInput>;
  /** message input for default locale (default) */
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormSuccessComponentUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormSuccessComponentUpdateLocalizationInput = {
  data: FormSuccessComponentUpdateLocalizationDataInput;
  locale: Locale;
};

export type FormSuccessComponentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FormSuccessComponentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<FormSuccessComponentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<FormSuccessComponentUpsertLocalizationInput>>;
};

export type FormSuccessComponentUpdateManyInlineInput = {
  /** Connect multiple existing FormSuccessComponent documents */
  connect?: InputMaybe<Array<FormSuccessComponentConnectInput>>;
  /** Create and connect multiple FormSuccessComponent documents */
  create?: InputMaybe<Array<FormSuccessComponentCreateInput>>;
  /** Delete multiple FormSuccessComponent documents */
  delete?: InputMaybe<Array<FormSuccessComponentWhereUniqueInput>>;
  /** Disconnect multiple FormSuccessComponent documents */
  disconnect?: InputMaybe<Array<FormSuccessComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormSuccessComponent documents */
  set?: InputMaybe<Array<FormSuccessComponentWhereUniqueInput>>;
  /** Update multiple FormSuccessComponent documents */
  update?: InputMaybe<Array<FormSuccessComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormSuccessComponent documents */
  upsert?: InputMaybe<Array<FormSuccessComponentUpsertWithNestedWhereUniqueInput>>;
};

export type FormSuccessComponentUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<FormSuccessComponentUpdateManyLocalizationsInput>;
  /** message input for default locale (default) */
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormSuccessComponentUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type FormSuccessComponentUpdateManyLocalizationInput = {
  data: FormSuccessComponentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type FormSuccessComponentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FormSuccessComponentUpdateManyLocalizationInput>>;
};

export type FormSuccessComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormSuccessComponentUpdateManyInput;
  /** Document search */
  where: FormSuccessComponentWhereInput;
};

export type FormSuccessComponentUpdateOneInlineInput = {
  /** Connect existing FormSuccessComponent document */
  connect?: InputMaybe<FormSuccessComponentWhereUniqueInput>;
  /** Create and connect one FormSuccessComponent document */
  create?: InputMaybe<FormSuccessComponentCreateInput>;
  /** Delete currently connected FormSuccessComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormSuccessComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormSuccessComponent document */
  update?: InputMaybe<FormSuccessComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormSuccessComponent document */
  upsert?: InputMaybe<FormSuccessComponentUpsertWithNestedWhereUniqueInput>;
};

export type FormSuccessComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormSuccessComponentUpdateInput;
  /** Unique document search */
  where: FormSuccessComponentWhereUniqueInput;
};

export type FormSuccessComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: FormSuccessComponentCreateInput;
  /** Update document if it exists */
  update: FormSuccessComponentUpdateInput;
};

export type FormSuccessComponentUpsertLocalizationInput = {
  create: FormSuccessComponentCreateLocalizationDataInput;
  locale: Locale;
  update: FormSuccessComponentUpdateLocalizationDataInput;
};

export type FormSuccessComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormSuccessComponentUpsertInput;
  /** Unique document search */
  where: FormSuccessComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormSuccessComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormSuccessComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSuccessComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSuccessComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSuccessComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<FormSuccessComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<FormSuccessComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<FormSuccessComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  message_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  message_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  message_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  message_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  message_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  message_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  message_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  message_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  message_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormSuccessComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormSuccessComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormSuccessComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormSuccessComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormSuccessComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormSuccessComponent record uniquely */
export type FormSuccessComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormTextInput = Entity & Node & {
  __typename?: 'FormTextInput';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormTextInput>;
  /** A camel-case field name, eg. 'firstName', 'lastName' */
  fieldName?: Maybe<Scalars['String']['output']>;
  forms: Array<Form>;
  /** List of FormTextInput versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Content to pre-fill the field. */
  initialValue?: Maybe<Scalars['String']['output']>;
  /** label for the field */
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<FormTextInput>;
  placeholderText?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Displays when form is submitted without this field, if field is required. */
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormTextInputCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormTextInputCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormTextInputDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormTextInputFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormTextInputHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormTextInputLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type FormTextInputPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormTextInputPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormTextInputScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormTextInputUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormTextInputUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormTextInputConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormTextInputWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormTextInputConnection = {
  __typename?: 'FormTextInputConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormTextInputEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormTextInputCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  /** initialValue input for default locale (default) */
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FormTextInputCreateLocalizationsInput>;
  /** placeholderText input for default locale (default) */
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** requiredErrorMessage input for default locale (default) */
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormTextInputCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormTextInputCreateLocalizationInput = {
  /** Localization input */
  data: FormTextInputCreateLocalizationDataInput;
  locale: Locale;
};

export type FormTextInputCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FormTextInputCreateLocalizationInput>>;
};

export type FormTextInputCreateManyInlineInput = {
  /** Connect multiple existing FormTextInput documents */
  connect?: InputMaybe<Array<FormTextInputWhereUniqueInput>>;
  /** Create and connect multiple existing FormTextInput documents */
  create?: InputMaybe<Array<FormTextInputCreateInput>>;
};

export type FormTextInputCreateOneInlineInput = {
  /** Connect one existing FormTextInput document */
  connect?: InputMaybe<FormTextInputWhereUniqueInput>;
  /** Create and connect one FormTextInput document */
  create?: InputMaybe<FormTextInputCreateInput>;
};

/** An edge in a connection. */
export type FormTextInputEdge = {
  __typename?: 'FormTextInputEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormTextInput;
};

/** Identifies documents */
export type FormTextInputManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormTextInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormTextInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormTextInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormTextInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormTextInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormTextInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormTextInputOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  initialValue_ASC = 'initialValue_ASC',
  initialValue_DESC = 'initialValue_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  placeholderText_ASC = 'placeholderText_ASC',
  placeholderText_DESC = 'placeholderText_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormTextInputUpdateInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  /** initialValue input for default locale (default) */
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<FormTextInputUpdateLocalizationsInput>;
  /** placeholderText input for default locale (default) */
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** requiredErrorMessage input for default locale (default) */
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormTextInputUpdateLocalizationDataInput = {
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
};

export type FormTextInputUpdateLocalizationInput = {
  data: FormTextInputUpdateLocalizationDataInput;
  locale: Locale;
};

export type FormTextInputUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FormTextInputCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<FormTextInputUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<FormTextInputUpsertLocalizationInput>>;
};

export type FormTextInputUpdateManyInlineInput = {
  /** Connect multiple existing FormTextInput documents */
  connect?: InputMaybe<Array<FormTextInputConnectInput>>;
  /** Create and connect multiple FormTextInput documents */
  create?: InputMaybe<Array<FormTextInputCreateInput>>;
  /** Delete multiple FormTextInput documents */
  delete?: InputMaybe<Array<FormTextInputWhereUniqueInput>>;
  /** Disconnect multiple FormTextInput documents */
  disconnect?: InputMaybe<Array<FormTextInputWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormTextInput documents */
  set?: InputMaybe<Array<FormTextInputWhereUniqueInput>>;
  /** Update multiple FormTextInput documents */
  update?: InputMaybe<Array<FormTextInputUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormTextInput documents */
  upsert?: InputMaybe<Array<FormTextInputUpsertWithNestedWhereUniqueInput>>;
};

export type FormTextInputUpdateManyInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** initialValue input for default locale (default) */
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<FormTextInputUpdateManyLocalizationsInput>;
  /** placeholderText input for default locale (default) */
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** requiredErrorMessage input for default locale (default) */
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormTextInputUpdateManyLocalizationDataInput = {
  initialValue?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
};

export type FormTextInputUpdateManyLocalizationInput = {
  data: FormTextInputUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type FormTextInputUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FormTextInputUpdateManyLocalizationInput>>;
};

export type FormTextInputUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormTextInputUpdateManyInput;
  /** Document search */
  where: FormTextInputWhereInput;
};

export type FormTextInputUpdateOneInlineInput = {
  /** Connect existing FormTextInput document */
  connect?: InputMaybe<FormTextInputWhereUniqueInput>;
  /** Create and connect one FormTextInput document */
  create?: InputMaybe<FormTextInputCreateInput>;
  /** Delete currently connected FormTextInput document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormTextInput document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormTextInput document */
  update?: InputMaybe<FormTextInputUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormTextInput document */
  upsert?: InputMaybe<FormTextInputUpsertWithNestedWhereUniqueInput>;
};

export type FormTextInputUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormTextInputUpdateInput;
  /** Unique document search */
  where: FormTextInputWhereUniqueInput;
};

export type FormTextInputUpsertInput = {
  /** Create document if it didn't exist */
  create: FormTextInputCreateInput;
  /** Update document if it exists */
  update: FormTextInputUpdateInput;
};

export type FormTextInputUpsertLocalizationInput = {
  create: FormTextInputCreateLocalizationDataInput;
  locale: Locale;
  update: FormTextInputUpdateLocalizationDataInput;
};

export type FormTextInputUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormTextInputUpsertInput;
  /** Unique document search */
  where: FormTextInputWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormTextInputWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormTextInputWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormTextInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormTextInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormTextInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormTextInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormTextInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormTextInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholderText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholderText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholderText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholderText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholderText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholderText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholderText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholderText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholderText_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormTextInputWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormTextInputWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormTextInputWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormTextInputWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormTextInputWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormTextInput record uniquely */
export type FormTextInputWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type FormTextareaInput = Entity & Node & {
  __typename?: 'FormTextareaInput';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<FormTextareaInput>;
  /** A camel-case field name, eg. 'userComment', 'contactMessage' */
  fieldName?: Maybe<Scalars['String']['output']>;
  forms: Array<Form>;
  /** List of FormTextareaInput versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Content to pre-fill the field. */
  initialValue?: Maybe<Scalars['String']['output']>;
  /** label for this field */
  label?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<FormTextareaInput>;
  placeholderText?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Displays when form is submitted without this field, if field is required. */
  requiredErrorMessage?: Maybe<Scalars['String']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type FormTextareaInputCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormTextareaInputCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormTextareaInputDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type FormTextareaInputFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormWhereInput>;
};


export type FormTextareaInputHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type FormTextareaInputLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type FormTextareaInputPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormTextareaInputPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type FormTextareaInputScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type FormTextareaInputUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type FormTextareaInputUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type FormTextareaInputConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: FormTextareaInputWhereUniqueInput;
};

/** A connection to a list of items. */
export type FormTextareaInputConnection = {
  __typename?: 'FormTextareaInputConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<FormTextareaInputEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type FormTextareaInputCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormCreateManyInlineInput>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<FormTextareaInputCreateLocalizationsInput>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormTextareaInputCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FormTextareaInputCreateLocalizationInput = {
  /** Localization input */
  data: FormTextareaInputCreateLocalizationDataInput;
  locale: Locale;
};

export type FormTextareaInputCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<FormTextareaInputCreateLocalizationInput>>;
};

export type FormTextareaInputCreateManyInlineInput = {
  /** Connect multiple existing FormTextareaInput documents */
  connect?: InputMaybe<Array<FormTextareaInputWhereUniqueInput>>;
  /** Create and connect multiple existing FormTextareaInput documents */
  create?: InputMaybe<Array<FormTextareaInputCreateInput>>;
};

export type FormTextareaInputCreateOneInlineInput = {
  /** Connect one existing FormTextareaInput document */
  connect?: InputMaybe<FormTextareaInputWhereUniqueInput>;
  /** Create and connect one FormTextareaInput document */
  create?: InputMaybe<FormTextareaInputCreateInput>;
};

/** An edge in a connection. */
export type FormTextareaInputEdge = {
  __typename?: 'FormTextareaInputEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: FormTextareaInput;
};

/** Identifies documents */
export type FormTextareaInputManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormTextareaInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormTextareaInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormTextareaInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormTextareaInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormTextareaInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormTextareaInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholderText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholderText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholderText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholderText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholderText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholderText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholderText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholderText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholderText_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum FormTextareaInputOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  fieldName_ASC = 'fieldName_ASC',
  fieldName_DESC = 'fieldName_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  initialValue_ASC = 'initialValue_ASC',
  initialValue_DESC = 'initialValue_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  placeholderText_ASC = 'placeholderText_ASC',
  placeholderText_DESC = 'placeholderText_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  requiredErrorMessage_ASC = 'requiredErrorMessage_ASC',
  requiredErrorMessage_DESC = 'requiredErrorMessage_DESC',
  required_ASC = 'required_ASC',
  required_DESC = 'required_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type FormTextareaInputUpdateInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  forms?: InputMaybe<FormUpdateManyInlineInput>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<FormTextareaInputUpdateLocalizationsInput>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormTextareaInputUpdateLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FormTextareaInputUpdateLocalizationInput = {
  data: FormTextareaInputUpdateLocalizationDataInput;
  locale: Locale;
};

export type FormTextareaInputUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<FormTextareaInputCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<FormTextareaInputUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<FormTextareaInputUpsertLocalizationInput>>;
};

export type FormTextareaInputUpdateManyInlineInput = {
  /** Connect multiple existing FormTextareaInput documents */
  connect?: InputMaybe<Array<FormTextareaInputConnectInput>>;
  /** Create and connect multiple FormTextareaInput documents */
  create?: InputMaybe<Array<FormTextareaInputCreateInput>>;
  /** Delete multiple FormTextareaInput documents */
  delete?: InputMaybe<Array<FormTextareaInputWhereUniqueInput>>;
  /** Disconnect multiple FormTextareaInput documents */
  disconnect?: InputMaybe<Array<FormTextareaInputWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing FormTextareaInput documents */
  set?: InputMaybe<Array<FormTextareaInputWhereUniqueInput>>;
  /** Update multiple FormTextareaInput documents */
  update?: InputMaybe<Array<FormTextareaInputUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple FormTextareaInput documents */
  upsert?: InputMaybe<Array<FormTextareaInputUpsertWithNestedWhereUniqueInput>>;
};

export type FormTextareaInputUpdateManyInput = {
  fieldName?: InputMaybe<Scalars['String']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** label input for default locale (default) */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<FormTextareaInputUpdateManyLocalizationsInput>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormTextareaInputUpdateManyLocalizationDataInput = {
  label?: InputMaybe<Scalars['String']['input']>;
};

export type FormTextareaInputUpdateManyLocalizationInput = {
  data: FormTextareaInputUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type FormTextareaInputUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<FormTextareaInputUpdateManyLocalizationInput>>;
};

export type FormTextareaInputUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormTextareaInputUpdateManyInput;
  /** Document search */
  where: FormTextareaInputWhereInput;
};

export type FormTextareaInputUpdateOneInlineInput = {
  /** Connect existing FormTextareaInput document */
  connect?: InputMaybe<FormTextareaInputWhereUniqueInput>;
  /** Create and connect one FormTextareaInput document */
  create?: InputMaybe<FormTextareaInputCreateInput>;
  /** Delete currently connected FormTextareaInput document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected FormTextareaInput document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single FormTextareaInput document */
  update?: InputMaybe<FormTextareaInputUpdateWithNestedWhereUniqueInput>;
  /** Upsert single FormTextareaInput document */
  upsert?: InputMaybe<FormTextareaInputUpsertWithNestedWhereUniqueInput>;
};

export type FormTextareaInputUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormTextareaInputUpdateInput;
  /** Unique document search */
  where: FormTextareaInputWhereUniqueInput;
};

export type FormTextareaInputUpsertInput = {
  /** Create document if it didn't exist */
  create: FormTextareaInputCreateInput;
  /** Update document if it exists */
  update: FormTextareaInputUpdateInput;
};

export type FormTextareaInputUpsertLocalizationInput = {
  create: FormTextareaInputCreateLocalizationDataInput;
  locale: Locale;
  update: FormTextareaInputUpdateLocalizationDataInput;
};

export type FormTextareaInputUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormTextareaInputUpsertInput;
  /** Unique document search */
  where: FormTextareaInputWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormTextareaInputWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormTextareaInputWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormTextareaInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormTextareaInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormTextareaInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormTextareaInputWhereStageInput>;
  documentInStages_none?: InputMaybe<FormTextareaInputWhereStageInput>;
  documentInStages_some?: InputMaybe<FormTextareaInputWhereStageInput>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  fieldName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  fieldName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  fieldName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  fieldName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  fieldName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  fieldName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  fieldName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  fieldName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  fieldName_starts_with?: InputMaybe<Scalars['String']['input']>;
  forms_every?: InputMaybe<FormWhereInput>;
  forms_none?: InputMaybe<FormWhereInput>;
  forms_some?: InputMaybe<FormWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  initialValue?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  initialValue_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  initialValue_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  initialValue_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  initialValue_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  initialValue_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  initialValue_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  initialValue_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  initialValue_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  initialValue_starts_with?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  placeholderText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholderText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholderText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholderText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholderText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholderText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholderText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholderText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholderText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholderText_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  requiredErrorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  requiredErrorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  requiredErrorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  requiredErrorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  requiredErrorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  requiredErrorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  requiredErrorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  requiredErrorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  requiredErrorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  requiredErrorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  required_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormTextareaInputWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormTextareaInputWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormTextareaInputWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormTextareaInputWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormTextareaInputWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References FormTextareaInput record uniquely */
export type FormTextareaInputWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum FormTypes {
  contact = 'contact',
  login = 'login',
  signup = 'signup'
}

export type FormUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  formErrors?: InputMaybe<FormErrorUpdateManyInlineInput>;
  formFields?: InputMaybe<FormFormUpdateManyInlineInput>;
  formSuccess?: InputMaybe<FormSuccessComponentUpdateOneInlineInput>;
  formType?: InputMaybe<FormTypes>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormUpdateManyInlineInput = {
  /** Connect multiple existing Form documents */
  connect?: InputMaybe<Array<FormConnectInput>>;
  /** Create and connect multiple Form documents */
  create?: InputMaybe<Array<FormCreateInput>>;
  /** Delete multiple Form documents */
  delete?: InputMaybe<Array<FormWhereUniqueInput>>;
  /** Disconnect multiple Form documents */
  disconnect?: InputMaybe<Array<FormWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Form documents */
  set?: InputMaybe<Array<FormWhereUniqueInput>>;
  /** Update multiple Form documents */
  update?: InputMaybe<Array<FormUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Form documents */
  upsert?: InputMaybe<Array<FormUpsertWithNestedWhereUniqueInput>>;
};

export type FormUpdateManyInput = {
  formType?: InputMaybe<FormTypes>;
};

export type FormUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: FormUpdateManyInput;
  /** Document search */
  where: FormWhereInput;
};

export type FormUpdateOneInlineInput = {
  /** Connect existing Form document */
  connect?: InputMaybe<FormWhereUniqueInput>;
  /** Create and connect one Form document */
  create?: InputMaybe<FormCreateInput>;
  /** Delete currently connected Form document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Form document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Form document */
  update?: InputMaybe<FormUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Form document */
  upsert?: InputMaybe<FormUpsertWithNestedWhereUniqueInput>;
};

export type FormUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: FormUpdateInput;
  /** Unique document search */
  where: FormWhereUniqueInput;
};

export type FormUpsertInput = {
  /** Create document if it didn't exist */
  create: FormCreateInput;
  /** Update document if it exists */
  update: FormUpdateInput;
};

export type FormUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: FormUpsertInput;
  /** Unique document search */
  where: FormWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type FormWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type FormWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<FormWhereStageInput>;
  documentInStages_none?: InputMaybe<FormWhereStageInput>;
  documentInStages_some?: InputMaybe<FormWhereStageInput>;
  formErrors_every?: InputMaybe<FormErrorWhereInput>;
  formErrors_none?: InputMaybe<FormErrorWhereInput>;
  formErrors_some?: InputMaybe<FormErrorWhereInput>;
  /** All values in which the union is empty */
  formFields_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  formFields_some?: InputMaybe<FormFormWhereInput>;
  formSuccess?: InputMaybe<FormSuccessComponentWhereInput>;
  formType?: InputMaybe<FormTypes>;
  /** All values that are contained in given list. */
  formType_in?: InputMaybe<Array<InputMaybe<FormTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  formType_not?: InputMaybe<FormTypes>;
  /** All values that are not contained in given list. */
  formType_not_in?: InputMaybe<Array<InputMaybe<FormTypes>>>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type FormWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<FormWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<FormWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<FormWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<FormWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Form record uniquely */
export type FormWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericAccordion = Entity & Node & {
  __typename?: 'GenericAccordion';
  cmsTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericAccordion>;
  genericAccordionItems: Array<GenericAccordionItem>;
  genericPages: Array<GenericPage>;
  /** List of GenericAccordion versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Show numbers in each accordion item */
  numbered?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericAccordionCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericAccordionGenericAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericAccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionItemWhereInput>;
};


export type GenericAccordionGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GenericAccordionHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericAccordionPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericAccordionUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericAccordionConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericAccordionWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericAccordionConnection = {
  __typename?: 'GenericAccordionConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericAccordionEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericAccordionCreateInput = {
  cmsTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericAccordionItems?: InputMaybe<GenericAccordionItemCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericAccordionCreateManyInlineInput = {
  /** Connect multiple existing GenericAccordion documents */
  connect?: InputMaybe<Array<GenericAccordionWhereUniqueInput>>;
  /** Create and connect multiple existing GenericAccordion documents */
  create?: InputMaybe<Array<GenericAccordionCreateInput>>;
};

export type GenericAccordionCreateOneInlineInput = {
  /** Connect one existing GenericAccordion document */
  connect?: InputMaybe<GenericAccordionWhereUniqueInput>;
  /** Create and connect one GenericAccordion document */
  create?: InputMaybe<GenericAccordionCreateInput>;
};

/** An edge in a connection. */
export type GenericAccordionEdge = {
  __typename?: 'GenericAccordionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericAccordion;
};

export type GenericAccordionItem = Entity & Node & {
  __typename?: 'GenericAccordionItem';
  alignment: AccordionContentAlignment;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericAccordionItem>;
  genericAccordion: Array<GenericAccordion>;
  /** List of GenericAccordionItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<GenericAccordionItem>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  text?: Maybe<GenericAccordionItemTextRichText>;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericAccordionItemCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericAccordionItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericAccordionItemGenericAccordionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericAccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionWhereInput>;
};


export type GenericAccordionItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericAccordionItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type GenericAccordionItemPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericAccordionItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericAccordionItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericAccordionItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericAccordionItemCenericAccordionItemBodyComponents = CorpBanner1 | CorpCalendarEvent | CorpContactCardContainer | CorpGenericContainer | CorpGridColumnComponent | GenericDownloadComponent | ImageCopy | IntroText | LongText | QuickLink | Spacer;

export type GenericAccordionItemCenericAccordionItemBodyComponentsConnectInput = {
  CorpBanner1?: InputMaybe<CorpBanner1ConnectInput>;
  CorpCalendarEvent?: InputMaybe<CorpCalendarEventConnectInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerConnectInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerConnectInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentConnectInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentConnectInput>;
  ImageCopy?: InputMaybe<ImageCopyConnectInput>;
  IntroText?: InputMaybe<IntroTextConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
  QuickLink?: InputMaybe<QuickLinkConnectInput>;
  Spacer?: InputMaybe<SpacerConnectInput>;
};

export type GenericAccordionItemCenericAccordionItemBodyComponentsCreateInput = {
  CorpBanner1?: InputMaybe<CorpBanner1CreateInput>;
  CorpCalendarEvent?: InputMaybe<CorpCalendarEventCreateInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerCreateInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerCreateInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentCreateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentCreateInput>;
  ImageCopy?: InputMaybe<ImageCopyCreateInput>;
  IntroText?: InputMaybe<IntroTextCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
  QuickLink?: InputMaybe<QuickLinkCreateInput>;
  Spacer?: InputMaybe<SpacerCreateInput>;
};

export type GenericAccordionItemCenericAccordionItemBodyComponentsCreateManyInlineInput = {
  /** Connect multiple existing GenericAccordionItemCenericAccordionItemBodyComponents documents */
  connect?: InputMaybe<Array<GenericAccordionItemCenericAccordionItemBodyComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing GenericAccordionItemCenericAccordionItemBodyComponents documents */
  create?: InputMaybe<Array<GenericAccordionItemCenericAccordionItemBodyComponentsCreateInput>>;
};

export type GenericAccordionItemCenericAccordionItemBodyComponentsCreateOneInlineInput = {
  /** Connect one existing GenericAccordionItemCenericAccordionItemBodyComponents document */
  connect?: InputMaybe<GenericAccordionItemCenericAccordionItemBodyComponentsWhereUniqueInput>;
  /** Create and connect one GenericAccordionItemCenericAccordionItemBodyComponents document */
  create?: InputMaybe<GenericAccordionItemCenericAccordionItemBodyComponentsCreateInput>;
};

export type GenericAccordionItemCenericAccordionItemBodyComponentsUpdateInput = {
  CorpBanner1?: InputMaybe<CorpBanner1UpdateInput>;
  CorpCalendarEvent?: InputMaybe<CorpCalendarEventUpdateInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpdateInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateInput>;
  IntroText?: InputMaybe<IntroTextUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateInput>;
  Spacer?: InputMaybe<SpacerUpdateInput>;
};

export type GenericAccordionItemCenericAccordionItemBodyComponentsUpdateManyInlineInput = {
  /** Connect multiple existing GenericAccordionItemCenericAccordionItemBodyComponents documents */
  connect?: InputMaybe<Array<GenericAccordionItemCenericAccordionItemBodyComponentsConnectInput>>;
  /** Create and connect multiple GenericAccordionItemCenericAccordionItemBodyComponents documents */
  create?: InputMaybe<Array<GenericAccordionItemCenericAccordionItemBodyComponentsCreateInput>>;
  /** Delete multiple GenericAccordionItemCenericAccordionItemBodyComponents documents */
  delete?: InputMaybe<Array<GenericAccordionItemCenericAccordionItemBodyComponentsWhereUniqueInput>>;
  /** Disconnect multiple GenericAccordionItemCenericAccordionItemBodyComponents documents */
  disconnect?: InputMaybe<Array<GenericAccordionItemCenericAccordionItemBodyComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericAccordionItemCenericAccordionItemBodyComponents documents */
  set?: InputMaybe<Array<GenericAccordionItemCenericAccordionItemBodyComponentsWhereUniqueInput>>;
  /** Update multiple GenericAccordionItemCenericAccordionItemBodyComponents documents */
  update?: InputMaybe<Array<GenericAccordionItemCenericAccordionItemBodyComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericAccordionItemCenericAccordionItemBodyComponents documents */
  upsert?: InputMaybe<Array<GenericAccordionItemCenericAccordionItemBodyComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type GenericAccordionItemCenericAccordionItemBodyComponentsUpdateManyWithNestedWhereInput = {
  CorpBanner1?: InputMaybe<CorpBanner1UpdateManyWithNestedWhereInput>;
  CorpCalendarEvent?: InputMaybe<CorpCalendarEventUpdateManyWithNestedWhereInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpdateManyWithNestedWhereInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateManyWithNestedWhereInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateManyWithNestedWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateManyWithNestedWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateManyWithNestedWhereInput>;
  IntroText?: InputMaybe<IntroTextUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateManyWithNestedWhereInput>;
  Spacer?: InputMaybe<SpacerUpdateManyWithNestedWhereInput>;
};

export type GenericAccordionItemCenericAccordionItemBodyComponentsUpdateOneInlineInput = {
  /** Connect existing GenericAccordionItemCenericAccordionItemBodyComponents document */
  connect?: InputMaybe<GenericAccordionItemCenericAccordionItemBodyComponentsWhereUniqueInput>;
  /** Create and connect one GenericAccordionItemCenericAccordionItemBodyComponents document */
  create?: InputMaybe<GenericAccordionItemCenericAccordionItemBodyComponentsCreateInput>;
  /** Delete currently connected GenericAccordionItemCenericAccordionItemBodyComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericAccordionItemCenericAccordionItemBodyComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericAccordionItemCenericAccordionItemBodyComponents document */
  update?: InputMaybe<GenericAccordionItemCenericAccordionItemBodyComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericAccordionItemCenericAccordionItemBodyComponents document */
  upsert?: InputMaybe<GenericAccordionItemCenericAccordionItemBodyComponentsUpsertWithNestedWhereUniqueInput>;
};

export type GenericAccordionItemCenericAccordionItemBodyComponentsUpdateWithNestedWhereUniqueInput = {
  CorpBanner1?: InputMaybe<CorpBanner1UpdateWithNestedWhereUniqueInput>;
  CorpCalendarEvent?: InputMaybe<CorpCalendarEventUpdateWithNestedWhereUniqueInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpdateWithNestedWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateWithNestedWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpdateWithNestedWhereUniqueInput>;
};

export type GenericAccordionItemCenericAccordionItemBodyComponentsUpsertWithNestedWhereUniqueInput = {
  CorpBanner1?: InputMaybe<CorpBanner1UpsertWithNestedWhereUniqueInput>;
  CorpCalendarEvent?: InputMaybe<CorpCalendarEventUpsertWithNestedWhereUniqueInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpsertWithNestedWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpsertWithNestedWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpsertWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpsertWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkUpsertWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpsertWithNestedWhereUniqueInput>;
};

export type GenericAccordionItemCenericAccordionItemBodyComponentsWhereInput = {
  CorpBanner1?: InputMaybe<CorpBanner1WhereInput>;
  CorpCalendarEvent?: InputMaybe<CorpCalendarEventWhereInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerWhereInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerWhereInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereInput>;
  IntroText?: InputMaybe<IntroTextWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
  QuickLink?: InputMaybe<QuickLinkWhereInput>;
  Spacer?: InputMaybe<SpacerWhereInput>;
};

export type GenericAccordionItemCenericAccordionItemBodyComponentsWhereUniqueInput = {
  CorpBanner1?: InputMaybe<CorpBanner1WhereUniqueInput>;
  CorpCalendarEvent?: InputMaybe<CorpCalendarEventWhereUniqueInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerWhereUniqueInput>;
};

export type GenericAccordionItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericAccordionItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericAccordionItemConnection = {
  __typename?: 'GenericAccordionItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericAccordionItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericAccordionItemCreateInput = {
  alignment: AccordionContentAlignment;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericAccordion?: InputMaybe<GenericAccordionCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<GenericAccordionItemCreateLocalizationsInput>;
  /** text input for default locale (default) */
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** title input for default locale (default) */
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericAccordionItemCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericAccordionItemCreateLocalizationInput = {
  /** Localization input */
  data: GenericAccordionItemCreateLocalizationDataInput;
  locale: Locale;
};

export type GenericAccordionItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<GenericAccordionItemCreateLocalizationInput>>;
};

export type GenericAccordionItemCreateManyInlineInput = {
  /** Connect multiple existing GenericAccordionItem documents */
  connect?: InputMaybe<Array<GenericAccordionItemWhereUniqueInput>>;
  /** Create and connect multiple existing GenericAccordionItem documents */
  create?: InputMaybe<Array<GenericAccordionItemCreateInput>>;
};

export type GenericAccordionItemCreateOneInlineInput = {
  /** Connect one existing GenericAccordionItem document */
  connect?: InputMaybe<GenericAccordionItemWhereUniqueInput>;
  /** Create and connect one GenericAccordionItem document */
  create?: InputMaybe<GenericAccordionItemCreateInput>;
};

/** An edge in a connection. */
export type GenericAccordionItemEdge = {
  __typename?: 'GenericAccordionItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericAccordionItem;
};

/** Identifies documents */
export type GenericAccordionItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<AccordionContentAlignment>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<AccordionContentAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<AccordionContentAlignment>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<AccordionContentAlignment>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericAccordionItemWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericAccordionItemWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericAccordionItemWhereStageInput>;
  genericAccordion_every?: InputMaybe<GenericAccordionWhereInput>;
  genericAccordion_none?: InputMaybe<GenericAccordionWhereInput>;
  genericAccordion_some?: InputMaybe<GenericAccordionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericAccordionItemOrderByInput {
  alignment_ASC = 'alignment_ASC',
  alignment_DESC = 'alignment_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericAccordionItemTextRichText = {
  __typename?: 'GenericAccordionItemTextRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<GenericAccordionItemTextRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type GenericAccordionItemTextRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type GenericAccordionItemTextRichTextEmbeddedTypes = Asset;

export type GenericAccordionItemUpdateInput = {
  alignment?: InputMaybe<AccordionContentAlignment>;
  genericAccordion?: InputMaybe<GenericAccordionUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<GenericAccordionItemUpdateLocalizationsInput>;
  /** text input for default locale (default) */
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericAccordionItemUpdateLocalizationDataInput = {
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericAccordionItemUpdateLocalizationInput = {
  data: GenericAccordionItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type GenericAccordionItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<GenericAccordionItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<GenericAccordionItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<GenericAccordionItemUpsertLocalizationInput>>;
};

export type GenericAccordionItemUpdateManyInlineInput = {
  /** Connect multiple existing GenericAccordionItem documents */
  connect?: InputMaybe<Array<GenericAccordionItemConnectInput>>;
  /** Create and connect multiple GenericAccordionItem documents */
  create?: InputMaybe<Array<GenericAccordionItemCreateInput>>;
  /** Delete multiple GenericAccordionItem documents */
  delete?: InputMaybe<Array<GenericAccordionItemWhereUniqueInput>>;
  /** Disconnect multiple GenericAccordionItem documents */
  disconnect?: InputMaybe<Array<GenericAccordionItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericAccordionItem documents */
  set?: InputMaybe<Array<GenericAccordionItemWhereUniqueInput>>;
  /** Update multiple GenericAccordionItem documents */
  update?: InputMaybe<Array<GenericAccordionItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericAccordionItem documents */
  upsert?: InputMaybe<Array<GenericAccordionItemUpsertWithNestedWhereUniqueInput>>;
};

export type GenericAccordionItemUpdateManyInput = {
  alignment?: InputMaybe<AccordionContentAlignment>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<GenericAccordionItemUpdateManyLocalizationsInput>;
  /** text input for default locale (default) */
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericAccordionItemUpdateManyLocalizationDataInput = {
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericAccordionItemUpdateManyLocalizationInput = {
  data: GenericAccordionItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type GenericAccordionItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<GenericAccordionItemUpdateManyLocalizationInput>>;
};

export type GenericAccordionItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericAccordionItemUpdateManyInput;
  /** Document search */
  where: GenericAccordionItemWhereInput;
};

export type GenericAccordionItemUpdateOneInlineInput = {
  /** Connect existing GenericAccordionItem document */
  connect?: InputMaybe<GenericAccordionItemWhereUniqueInput>;
  /** Create and connect one GenericAccordionItem document */
  create?: InputMaybe<GenericAccordionItemCreateInput>;
  /** Delete currently connected GenericAccordionItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericAccordionItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericAccordionItem document */
  update?: InputMaybe<GenericAccordionItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericAccordionItem document */
  upsert?: InputMaybe<GenericAccordionItemUpsertWithNestedWhereUniqueInput>;
};

export type GenericAccordionItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericAccordionItemUpdateInput;
  /** Unique document search */
  where: GenericAccordionItemWhereUniqueInput;
};

export type GenericAccordionItemUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericAccordionItemCreateInput;
  /** Update document if it exists */
  update: GenericAccordionItemUpdateInput;
};

export type GenericAccordionItemUpsertLocalizationInput = {
  create: GenericAccordionItemCreateLocalizationDataInput;
  locale: Locale;
  update: GenericAccordionItemUpdateLocalizationDataInput;
};

export type GenericAccordionItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericAccordionItemUpsertInput;
  /** Unique document search */
  where: GenericAccordionItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericAccordionItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericAccordionItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<AccordionContentAlignment>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<AccordionContentAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<AccordionContentAlignment>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<AccordionContentAlignment>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericAccordionItemWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericAccordionItemWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericAccordionItemWhereStageInput>;
  genericAccordion_every?: InputMaybe<GenericAccordionWhereInput>;
  genericAccordion_none?: InputMaybe<GenericAccordionWhereInput>;
  genericAccordion_some?: InputMaybe<GenericAccordionWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericAccordionItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericAccordionItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericAccordionItem record uniquely */
export type GenericAccordionItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type GenericAccordionManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericAccordionWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericAccordionWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericAccordionWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<GenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<GenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<GenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  numbered_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericAccordionOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  numbered_ASC = 'numbered_ASC',
  numbered_DESC = 'numbered_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericAccordionTopRated = Entity & Node & {
  __typename?: 'GenericAccordionTopRated';
  anchorNav?: Maybe<AnchorNavigation>;
  cmsTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericAccordionTopRated>;
  extension?: Maybe<AlgoliaExtension>;
  genericPages: Array<GenericPage>;
  /** List of GenericAccordionTopRated versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<GenericAccordionTopRated>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  super?: Maybe<Scalars['String']['output']>;
  tabContent?: Maybe<TabContent>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericAccordionTopRatedAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionTopRatedCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericAccordionTopRatedCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionTopRatedDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericAccordionTopRatedExtensionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionTopRatedGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GenericAccordionTopRatedHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericAccordionTopRatedLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type GenericAccordionTopRatedPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericAccordionTopRatedPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionTopRatedScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericAccordionTopRatedTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericAccordionTopRatedUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericAccordionTopRatedUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericAccordionTopRatedConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericAccordionTopRatedWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericAccordionTopRatedConnection = {
  __typename?: 'GenericAccordionTopRatedConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericAccordionTopRatedEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericAccordionTopRatedCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cmsTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  extension?: InputMaybe<AlgoliaExtensionCreateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<GenericAccordionTopRatedCreateLocalizationsInput>;
  /** super input for default locale (default) */
  super?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericAccordionTopRatedCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  super?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericAccordionTopRatedCreateLocalizationInput = {
  /** Localization input */
  data: GenericAccordionTopRatedCreateLocalizationDataInput;
  locale: Locale;
};

export type GenericAccordionTopRatedCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<GenericAccordionTopRatedCreateLocalizationInput>>;
};

export type GenericAccordionTopRatedCreateManyInlineInput = {
  /** Connect multiple existing GenericAccordionTopRated documents */
  connect?: InputMaybe<Array<GenericAccordionTopRatedWhereUniqueInput>>;
  /** Create and connect multiple existing GenericAccordionTopRated documents */
  create?: InputMaybe<Array<GenericAccordionTopRatedCreateInput>>;
};

export type GenericAccordionTopRatedCreateOneInlineInput = {
  /** Connect one existing GenericAccordionTopRated document */
  connect?: InputMaybe<GenericAccordionTopRatedWhereUniqueInput>;
  /** Create and connect one GenericAccordionTopRated document */
  create?: InputMaybe<GenericAccordionTopRatedCreateInput>;
};

/** An edge in a connection. */
export type GenericAccordionTopRatedEdge = {
  __typename?: 'GenericAccordionTopRatedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericAccordionTopRated;
};

/** Identifies documents */
export type GenericAccordionTopRatedManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionTopRatedWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionTopRatedWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionTopRatedWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericAccordionTopRatedWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericAccordionTopRatedWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericAccordionTopRatedWhereStageInput>;
  extension?: InputMaybe<AlgoliaExtensionWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericAccordionTopRatedOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  super_ASC = 'super_ASC',
  super_DESC = 'super_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericAccordionTopRatedUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<AlgoliaExtensionUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<GenericAccordionTopRatedUpdateLocalizationsInput>;
  /** super input for default locale (default) */
  super?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericAccordionTopRatedUpdateLocalizationDataInput = {
  super?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericAccordionTopRatedUpdateLocalizationInput = {
  data: GenericAccordionTopRatedUpdateLocalizationDataInput;
  locale: Locale;
};

export type GenericAccordionTopRatedUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<GenericAccordionTopRatedCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<GenericAccordionTopRatedUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<GenericAccordionTopRatedUpsertLocalizationInput>>;
};

export type GenericAccordionTopRatedUpdateManyInlineInput = {
  /** Connect multiple existing GenericAccordionTopRated documents */
  connect?: InputMaybe<Array<GenericAccordionTopRatedConnectInput>>;
  /** Create and connect multiple GenericAccordionTopRated documents */
  create?: InputMaybe<Array<GenericAccordionTopRatedCreateInput>>;
  /** Delete multiple GenericAccordionTopRated documents */
  delete?: InputMaybe<Array<GenericAccordionTopRatedWhereUniqueInput>>;
  /** Disconnect multiple GenericAccordionTopRated documents */
  disconnect?: InputMaybe<Array<GenericAccordionTopRatedWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericAccordionTopRated documents */
  set?: InputMaybe<Array<GenericAccordionTopRatedWhereUniqueInput>>;
  /** Update multiple GenericAccordionTopRated documents */
  update?: InputMaybe<Array<GenericAccordionTopRatedUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericAccordionTopRated documents */
  upsert?: InputMaybe<Array<GenericAccordionTopRatedUpsertWithNestedWhereUniqueInput>>;
};

export type GenericAccordionTopRatedUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<GenericAccordionTopRatedUpdateManyLocalizationsInput>;
  /** super input for default locale (default) */
  super?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericAccordionTopRatedUpdateManyLocalizationDataInput = {
  super?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericAccordionTopRatedUpdateManyLocalizationInput = {
  data: GenericAccordionTopRatedUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type GenericAccordionTopRatedUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<GenericAccordionTopRatedUpdateManyLocalizationInput>>;
};

export type GenericAccordionTopRatedUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericAccordionTopRatedUpdateManyInput;
  /** Document search */
  where: GenericAccordionTopRatedWhereInput;
};

export type GenericAccordionTopRatedUpdateOneInlineInput = {
  /** Connect existing GenericAccordionTopRated document */
  connect?: InputMaybe<GenericAccordionTopRatedWhereUniqueInput>;
  /** Create and connect one GenericAccordionTopRated document */
  create?: InputMaybe<GenericAccordionTopRatedCreateInput>;
  /** Delete currently connected GenericAccordionTopRated document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericAccordionTopRated document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericAccordionTopRated document */
  update?: InputMaybe<GenericAccordionTopRatedUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericAccordionTopRated document */
  upsert?: InputMaybe<GenericAccordionTopRatedUpsertWithNestedWhereUniqueInput>;
};

export type GenericAccordionTopRatedUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericAccordionTopRatedUpdateInput;
  /** Unique document search */
  where: GenericAccordionTopRatedWhereUniqueInput;
};

export type GenericAccordionTopRatedUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericAccordionTopRatedCreateInput;
  /** Update document if it exists */
  update: GenericAccordionTopRatedUpdateInput;
};

export type GenericAccordionTopRatedUpsertLocalizationInput = {
  create: GenericAccordionTopRatedCreateLocalizationDataInput;
  locale: Locale;
  update: GenericAccordionTopRatedUpdateLocalizationDataInput;
};

export type GenericAccordionTopRatedUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericAccordionTopRatedUpsertInput;
  /** Unique document search */
  where: GenericAccordionTopRatedWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericAccordionTopRatedWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericAccordionTopRatedWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionTopRatedWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionTopRatedWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionTopRatedWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericAccordionTopRatedWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericAccordionTopRatedWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericAccordionTopRatedWhereStageInput>;
  extension?: InputMaybe<AlgoliaExtensionWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  super?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  super_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  super_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  super_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  super_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  super_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  super_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  super_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  super_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  super_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericAccordionTopRatedWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionTopRatedWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionTopRatedWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionTopRatedWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericAccordionTopRatedWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericAccordionTopRated record uniquely */
export type GenericAccordionTopRatedWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericAccordionUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  genericAccordionItems?: InputMaybe<GenericAccordionItemUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GenericAccordionUpdateManyInlineInput = {
  /** Connect multiple existing GenericAccordion documents */
  connect?: InputMaybe<Array<GenericAccordionConnectInput>>;
  /** Create and connect multiple GenericAccordion documents */
  create?: InputMaybe<Array<GenericAccordionCreateInput>>;
  /** Delete multiple GenericAccordion documents */
  delete?: InputMaybe<Array<GenericAccordionWhereUniqueInput>>;
  /** Disconnect multiple GenericAccordion documents */
  disconnect?: InputMaybe<Array<GenericAccordionWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericAccordion documents */
  set?: InputMaybe<Array<GenericAccordionWhereUniqueInput>>;
  /** Update multiple GenericAccordion documents */
  update?: InputMaybe<Array<GenericAccordionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericAccordion documents */
  upsert?: InputMaybe<Array<GenericAccordionUpsertWithNestedWhereUniqueInput>>;
};

export type GenericAccordionUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GenericAccordionUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericAccordionUpdateManyInput;
  /** Document search */
  where: GenericAccordionWhereInput;
};

export type GenericAccordionUpdateOneInlineInput = {
  /** Connect existing GenericAccordion document */
  connect?: InputMaybe<GenericAccordionWhereUniqueInput>;
  /** Create and connect one GenericAccordion document */
  create?: InputMaybe<GenericAccordionCreateInput>;
  /** Delete currently connected GenericAccordion document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericAccordion document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericAccordion document */
  update?: InputMaybe<GenericAccordionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericAccordion document */
  upsert?: InputMaybe<GenericAccordionUpsertWithNestedWhereUniqueInput>;
};

export type GenericAccordionUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericAccordionUpdateInput;
  /** Unique document search */
  where: GenericAccordionWhereUniqueInput;
};

export type GenericAccordionUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericAccordionCreateInput;
  /** Update document if it exists */
  update: GenericAccordionUpdateInput;
};

export type GenericAccordionUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericAccordionUpsertInput;
  /** Unique document search */
  where: GenericAccordionWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericAccordionWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericAccordionWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericAccordionWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericAccordionWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericAccordionWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<GenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<GenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<GenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  numbered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  numbered_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericAccordionWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericAccordionWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericAccordionWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericAccordionWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericAccordionWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericAccordion record uniquely */
export type GenericAccordionWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericCardCarouseComponent = Entity & Node & {
  __typename?: 'GenericCardCarouseComponent';
  anchorNav?: Maybe<AnchorNavigation>;
  articles: Array<GenericPage>;
  /** Choose card variation  */
  cardVariation?: Maybe<CardVariation>;
  /** Background of the component */
  componentBackground: Array<GenericCardCarouseComponentComponentBackground>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  dictionaryItem: Array<GenericCardCarouseComponentDictionaryItem>;
  /** Get the document in other stages */
  documentInStages: Array<GenericCardCarouseComponent>;
  extension?: Maybe<AlgoliaExtension>;
  floatingObject: Array<GenericCardLayoutComponentFloatingObject>;
  /** Link on the Generic Card Carousel Component. When providing a link to the CTA button next to the text copy, it will override the default search page links. If search pages are desired, only provide the copy for the button and leave the link field empty */
  genericCardCarouselCta?: Maybe<GenericCardCarouseComponentGenericCradCarouselCta>;
  genericPages: Array<GenericPage>;
  /** Main Heading of the component */
  heading?: Maybe<Scalars['String']['output']>;
  /** List of GenericCardCarouseComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Unique Key Identifier  */
  key?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<GenericCardCarouseComponent>;
  /** CTA directs to a search results page showing all articles */
  pointCtaToArticlesList?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Sub heading above main Heading */
  subHeading?: Maybe<Scalars['String']['output']>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericCardCarouseComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericCardCarouseComponentArticlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<GenericPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GenericCardCarouseComponentComponentBackgroundArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type GenericCardCarouseComponentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericCardCarouseComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericCardCarouseComponentDictionaryItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type GenericCardCarouseComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericCardCarouseComponentExtensionArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericCardCarouseComponentFloatingObjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type GenericCardCarouseComponentGenericCardCarouselCtaArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericCardCarouseComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GenericCardCarouseComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericCardCarouseComponentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type GenericCardCarouseComponentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericCardCarouseComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericCardCarouseComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericCardCarouseComponentTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericCardCarouseComponentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericCardCarouseComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericCardCarouseComponentComponentBackground = AssetComponent;

export type GenericCardCarouseComponentComponentBackgroundConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type GenericCardCarouseComponentComponentBackgroundCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type GenericCardCarouseComponentComponentBackgroundCreateManyInlineInput = {
  /** Connect multiple existing GenericCardCarouseComponentComponentBackground documents */
  connect?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundWhereUniqueInput>>;
  /** Create and connect multiple existing GenericCardCarouseComponentComponentBackground documents */
  create?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundCreateInput>>;
};

export type GenericCardCarouseComponentComponentBackgroundCreateOneInlineInput = {
  /** Connect one existing GenericCardCarouseComponentComponentBackground document */
  connect?: InputMaybe<GenericCardCarouseComponentComponentBackgroundWhereUniqueInput>;
  /** Create and connect one GenericCardCarouseComponentComponentBackground document */
  create?: InputMaybe<GenericCardCarouseComponentComponentBackgroundCreateInput>;
};

export type GenericCardCarouseComponentComponentBackgroundUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type GenericCardCarouseComponentComponentBackgroundUpdateManyInlineInput = {
  /** Connect multiple existing GenericCardCarouseComponentComponentBackground documents */
  connect?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundConnectInput>>;
  /** Create and connect multiple GenericCardCarouseComponentComponentBackground documents */
  create?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundCreateInput>>;
  /** Delete multiple GenericCardCarouseComponentComponentBackground documents */
  delete?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundWhereUniqueInput>>;
  /** Disconnect multiple GenericCardCarouseComponentComponentBackground documents */
  disconnect?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericCardCarouseComponentComponentBackground documents */
  set?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundWhereUniqueInput>>;
  /** Update multiple GenericCardCarouseComponentComponentBackground documents */
  update?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericCardCarouseComponentComponentBackground documents */
  upsert?: InputMaybe<Array<GenericCardCarouseComponentComponentBackgroundUpsertWithNestedWhereUniqueInput>>;
};

export type GenericCardCarouseComponentComponentBackgroundUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type GenericCardCarouseComponentComponentBackgroundUpdateOneInlineInput = {
  /** Connect existing GenericCardCarouseComponentComponentBackground document */
  connect?: InputMaybe<GenericCardCarouseComponentComponentBackgroundWhereUniqueInput>;
  /** Create and connect one GenericCardCarouseComponentComponentBackground document */
  create?: InputMaybe<GenericCardCarouseComponentComponentBackgroundCreateInput>;
  /** Delete currently connected GenericCardCarouseComponentComponentBackground document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericCardCarouseComponentComponentBackground document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericCardCarouseComponentComponentBackground document */
  update?: InputMaybe<GenericCardCarouseComponentComponentBackgroundUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericCardCarouseComponentComponentBackground document */
  upsert?: InputMaybe<GenericCardCarouseComponentComponentBackgroundUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentComponentBackgroundUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentComponentBackgroundUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentComponentBackgroundWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type GenericCardCarouseComponentComponentBackgroundWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

export type GenericCardCarouseComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericCardCarouseComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericCardCarouseComponentConnection = {
  __typename?: 'GenericCardCarouseComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericCardCarouseComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericCardCarouseComponentCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  articles?: InputMaybe<GenericPageCreateManyInlineInput>;
  cardVariation?: InputMaybe<CardVariation>;
  ckttqmon70rdz01xo5a2dd8as?: InputMaybe<TipsAndTricksDetailsPageCreateManyInlineInput>;
  componentBackground?: InputMaybe<GenericCardCarouseComponentComponentBackgroundCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionaryItem?: InputMaybe<GenericCardCarouseComponentDictionaryItemCreateManyInlineInput>;
  extension?: InputMaybe<AlgoliaExtensionCreateOneInlineInput>;
  floatingObject?: InputMaybe<GenericCardLayoutComponentFloatingObjectCreateManyInlineInput>;
  genericCardCarouselCta?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaCreateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  /** heading input for default locale (default) */
  heading?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<GenericCardCarouseComponentCreateLocalizationsInput>;
  pointCtaToArticlesList?: InputMaybe<Scalars['Boolean']['input']>;
  /** subHeading input for default locale (default) */
  subHeading?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericCardCarouseComponentCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericCardCarouseComponentCreateLocalizationInput = {
  /** Localization input */
  data: GenericCardCarouseComponentCreateLocalizationDataInput;
  locale: Locale;
};

export type GenericCardCarouseComponentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<GenericCardCarouseComponentCreateLocalizationInput>>;
};

export type GenericCardCarouseComponentCreateManyInlineInput = {
  /** Connect multiple existing GenericCardCarouseComponent documents */
  connect?: InputMaybe<Array<GenericCardCarouseComponentWhereUniqueInput>>;
  /** Create and connect multiple existing GenericCardCarouseComponent documents */
  create?: InputMaybe<Array<GenericCardCarouseComponentCreateInput>>;
};

export type GenericCardCarouseComponentCreateOneInlineInput = {
  /** Connect one existing GenericCardCarouseComponent document */
  connect?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  /** Create and connect one GenericCardCarouseComponent document */
  create?: InputMaybe<GenericCardCarouseComponentCreateInput>;
};

export type GenericCardCarouseComponentDictionaryItem = DictionaryItem;

export type GenericCardCarouseComponentDictionaryItemConnectInput = {
  DictionaryItem?: InputMaybe<DictionaryItemConnectInput>;
};

export type GenericCardCarouseComponentDictionaryItemCreateInput = {
  DictionaryItem?: InputMaybe<DictionaryItemCreateInput>;
};

export type GenericCardCarouseComponentDictionaryItemCreateManyInlineInput = {
  /** Connect multiple existing GenericCardCarouseComponentDictionaryItem documents */
  connect?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemWhereUniqueInput>>;
  /** Create and connect multiple existing GenericCardCarouseComponentDictionaryItem documents */
  create?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemCreateInput>>;
};

export type GenericCardCarouseComponentDictionaryItemCreateOneInlineInput = {
  /** Connect one existing GenericCardCarouseComponentDictionaryItem document */
  connect?: InputMaybe<GenericCardCarouseComponentDictionaryItemWhereUniqueInput>;
  /** Create and connect one GenericCardCarouseComponentDictionaryItem document */
  create?: InputMaybe<GenericCardCarouseComponentDictionaryItemCreateInput>;
};

export type GenericCardCarouseComponentDictionaryItemUpdateInput = {
  DictionaryItem?: InputMaybe<DictionaryItemUpdateInput>;
};

export type GenericCardCarouseComponentDictionaryItemUpdateManyInlineInput = {
  /** Connect multiple existing GenericCardCarouseComponentDictionaryItem documents */
  connect?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemConnectInput>>;
  /** Create and connect multiple GenericCardCarouseComponentDictionaryItem documents */
  create?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemCreateInput>>;
  /** Delete multiple GenericCardCarouseComponentDictionaryItem documents */
  delete?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemWhereUniqueInput>>;
  /** Disconnect multiple GenericCardCarouseComponentDictionaryItem documents */
  disconnect?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericCardCarouseComponentDictionaryItem documents */
  set?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemWhereUniqueInput>>;
  /** Update multiple GenericCardCarouseComponentDictionaryItem documents */
  update?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericCardCarouseComponentDictionaryItem documents */
  upsert?: InputMaybe<Array<GenericCardCarouseComponentDictionaryItemUpsertWithNestedWhereUniqueInput>>;
};

export type GenericCardCarouseComponentDictionaryItemUpdateManyWithNestedWhereInput = {
  DictionaryItem?: InputMaybe<DictionaryItemUpdateManyWithNestedWhereInput>;
};

export type GenericCardCarouseComponentDictionaryItemUpdateOneInlineInput = {
  /** Connect existing GenericCardCarouseComponentDictionaryItem document */
  connect?: InputMaybe<GenericCardCarouseComponentDictionaryItemWhereUniqueInput>;
  /** Create and connect one GenericCardCarouseComponentDictionaryItem document */
  create?: InputMaybe<GenericCardCarouseComponentDictionaryItemCreateInput>;
  /** Delete currently connected GenericCardCarouseComponentDictionaryItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericCardCarouseComponentDictionaryItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericCardCarouseComponentDictionaryItem document */
  update?: InputMaybe<GenericCardCarouseComponentDictionaryItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericCardCarouseComponentDictionaryItem document */
  upsert?: InputMaybe<GenericCardCarouseComponentDictionaryItemUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentDictionaryItemUpdateWithNestedWhereUniqueInput = {
  DictionaryItem?: InputMaybe<DictionaryItemUpdateWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentDictionaryItemUpsertWithNestedWhereUniqueInput = {
  DictionaryItem?: InputMaybe<DictionaryItemUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentDictionaryItemWhereInput = {
  DictionaryItem?: InputMaybe<DictionaryItemWhereInput>;
};

export type GenericCardCarouseComponentDictionaryItemWhereUniqueInput = {
  DictionaryItem?: InputMaybe<DictionaryItemWhereUniqueInput>;
};

/** An edge in a connection. */
export type GenericCardCarouseComponentEdge = {
  __typename?: 'GenericCardCarouseComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericCardCarouseComponent;
};

export type GenericCardCarouseComponentGenericCradCarouselCta = Link;

export type GenericCardCarouseComponentGenericCradCarouselCtaConnectInput = {
  Link?: InputMaybe<LinkConnectInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaCreateInput = {
  Link?: InputMaybe<LinkCreateInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaCreateManyInlineInput = {
  /** Connect multiple existing GenericCardCarouseComponentGenericCradCarouselCta documents */
  connect?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaWhereUniqueInput>>;
  /** Create and connect multiple existing GenericCardCarouseComponentGenericCradCarouselCta documents */
  create?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaCreateInput>>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaCreateOneInlineInput = {
  /** Connect one existing GenericCardCarouseComponentGenericCradCarouselCta document */
  connect?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaWhereUniqueInput>;
  /** Create and connect one GenericCardCarouseComponentGenericCradCarouselCta document */
  create?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaCreateInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaUpdateInput = {
  Link?: InputMaybe<LinkUpdateInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaUpdateManyInlineInput = {
  /** Connect multiple existing GenericCardCarouseComponentGenericCradCarouselCta documents */
  connect?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaConnectInput>>;
  /** Create and connect multiple GenericCardCarouseComponentGenericCradCarouselCta documents */
  create?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaCreateInput>>;
  /** Delete multiple GenericCardCarouseComponentGenericCradCarouselCta documents */
  delete?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaWhereUniqueInput>>;
  /** Disconnect multiple GenericCardCarouseComponentGenericCradCarouselCta documents */
  disconnect?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericCardCarouseComponentGenericCradCarouselCta documents */
  set?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaWhereUniqueInput>>;
  /** Update multiple GenericCardCarouseComponentGenericCradCarouselCta documents */
  update?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericCardCarouseComponentGenericCradCarouselCta documents */
  upsert?: InputMaybe<Array<GenericCardCarouseComponentGenericCradCarouselCtaUpsertWithNestedWhereUniqueInput>>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaUpdateManyWithNestedWhereInput = {
  Link?: InputMaybe<LinkUpdateManyWithNestedWhereInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaUpdateOneInlineInput = {
  /** Connect existing GenericCardCarouseComponentGenericCradCarouselCta document */
  connect?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaWhereUniqueInput>;
  /** Create and connect one GenericCardCarouseComponentGenericCradCarouselCta document */
  create?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaCreateInput>;
  /** Delete currently connected GenericCardCarouseComponentGenericCradCarouselCta document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericCardCarouseComponentGenericCradCarouselCta document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericCardCarouseComponentGenericCradCarouselCta document */
  update?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericCardCarouseComponentGenericCradCarouselCta document */
  upsert?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaUpdateWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaUpsertWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaWhereInput = {
  Link?: InputMaybe<LinkWhereInput>;
};

export type GenericCardCarouseComponentGenericCradCarouselCtaWhereUniqueInput = {
  Link?: InputMaybe<LinkWhereUniqueInput>;
};

/** Identifies documents */
export type GenericCardCarouseComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericCardCarouseComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericCardCarouseComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericCardCarouseComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  articles_every?: InputMaybe<GenericPageWhereInput>;
  articles_none?: InputMaybe<GenericPageWhereInput>;
  articles_some?: InputMaybe<GenericPageWhereInput>;
  cardVariation?: InputMaybe<CardVariation>;
  /** All values that are contained in given list. */
  cardVariation_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardVariation_not?: InputMaybe<CardVariation>;
  /** All values that are not contained in given list. */
  cardVariation_not_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  /** All values in which the union is empty */
  componentBackground_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  componentBackground_some?: InputMaybe<GenericCardCarouseComponentComponentBackgroundWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  /** All values in which the union is empty */
  dictionaryItem_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  dictionaryItem_some?: InputMaybe<GenericCardCarouseComponentDictionaryItemWhereInput>;
  documentInStages_every?: InputMaybe<GenericCardCarouseComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericCardCarouseComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericCardCarouseComponentWhereStageInput>;
  extension?: InputMaybe<AlgoliaExtensionWhereInput>;
  /** All values in which the union is empty */
  floatingObject_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  floatingObject_some?: InputMaybe<GenericCardLayoutComponentFloatingObjectWhereInput>;
  /** All values in which the union is connected to the given models */
  genericCardCarouselCta?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaWhereInput>;
  /** All values in which the union is empty */
  genericCardCarouselCta_empty?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  pointCtaToArticlesList?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  pointCtaToArticlesList_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericCardCarouseComponentOrderByInput {
  cardVariation_ASC = 'cardVariation_ASC',
  cardVariation_DESC = 'cardVariation_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  key_ASC = 'key_ASC',
  key_DESC = 'key_DESC',
  pointCtaToArticlesList_ASC = 'pointCtaToArticlesList_ASC',
  pointCtaToArticlesList_DESC = 'pointCtaToArticlesList_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subHeading_ASC = 'subHeading_ASC',
  subHeading_DESC = 'subHeading_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericCardCarouseComponentUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  articles?: InputMaybe<GenericPageUpdateManyInlineInput>;
  cardVariation?: InputMaybe<CardVariation>;
  ckttqmon70rdz01xo5a2dd8as?: InputMaybe<TipsAndTricksDetailsPageUpdateManyInlineInput>;
  componentBackground?: InputMaybe<GenericCardCarouseComponentComponentBackgroundUpdateManyInlineInput>;
  dictionaryItem?: InputMaybe<GenericCardCarouseComponentDictionaryItemUpdateManyInlineInput>;
  extension?: InputMaybe<AlgoliaExtensionUpdateOneInlineInput>;
  floatingObject?: InputMaybe<GenericCardLayoutComponentFloatingObjectUpdateManyInlineInput>;
  genericCardCarouselCta?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  /** heading input for default locale (default) */
  heading?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<GenericCardCarouseComponentUpdateLocalizationsInput>;
  pointCtaToArticlesList?: InputMaybe<Scalars['Boolean']['input']>;
  /** subHeading input for default locale (default) */
  subHeading?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type GenericCardCarouseComponentUpdateLocalizationDataInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type GenericCardCarouseComponentUpdateLocalizationInput = {
  data: GenericCardCarouseComponentUpdateLocalizationDataInput;
  locale: Locale;
};

export type GenericCardCarouseComponentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<GenericCardCarouseComponentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<GenericCardCarouseComponentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<GenericCardCarouseComponentUpsertLocalizationInput>>;
};

export type GenericCardCarouseComponentUpdateManyInlineInput = {
  /** Connect multiple existing GenericCardCarouseComponent documents */
  connect?: InputMaybe<Array<GenericCardCarouseComponentConnectInput>>;
  /** Create and connect multiple GenericCardCarouseComponent documents */
  create?: InputMaybe<Array<GenericCardCarouseComponentCreateInput>>;
  /** Delete multiple GenericCardCarouseComponent documents */
  delete?: InputMaybe<Array<GenericCardCarouseComponentWhereUniqueInput>>;
  /** Disconnect multiple GenericCardCarouseComponent documents */
  disconnect?: InputMaybe<Array<GenericCardCarouseComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericCardCarouseComponent documents */
  set?: InputMaybe<Array<GenericCardCarouseComponentWhereUniqueInput>>;
  /** Update multiple GenericCardCarouseComponent documents */
  update?: InputMaybe<Array<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericCardCarouseComponent documents */
  upsert?: InputMaybe<Array<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>>;
};

export type GenericCardCarouseComponentUpdateManyInput = {
  cardVariation?: InputMaybe<CardVariation>;
  /** heading input for default locale (default) */
  heading?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<GenericCardCarouseComponentUpdateManyLocalizationsInput>;
  pointCtaToArticlesList?: InputMaybe<Scalars['Boolean']['input']>;
  /** subHeading input for default locale (default) */
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type GenericCardCarouseComponentUpdateManyLocalizationDataInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type GenericCardCarouseComponentUpdateManyLocalizationInput = {
  data: GenericCardCarouseComponentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type GenericCardCarouseComponentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<GenericCardCarouseComponentUpdateManyLocalizationInput>>;
};

export type GenericCardCarouseComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericCardCarouseComponentUpdateManyInput;
  /** Document search */
  where: GenericCardCarouseComponentWhereInput;
};

export type GenericCardCarouseComponentUpdateOneInlineInput = {
  /** Connect existing GenericCardCarouseComponent document */
  connect?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  /** Create and connect one GenericCardCarouseComponent document */
  create?: InputMaybe<GenericCardCarouseComponentCreateInput>;
  /** Delete currently connected GenericCardCarouseComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericCardCarouseComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericCardCarouseComponent document */
  update?: InputMaybe<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericCardCarouseComponent document */
  upsert?: InputMaybe<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericCardCarouseComponentUpdateInput;
  /** Unique document search */
  where: GenericCardCarouseComponentWhereUniqueInput;
};

export type GenericCardCarouseComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericCardCarouseComponentCreateInput;
  /** Update document if it exists */
  update: GenericCardCarouseComponentUpdateInput;
};

export type GenericCardCarouseComponentUpsertLocalizationInput = {
  create: GenericCardCarouseComponentCreateLocalizationDataInput;
  locale: Locale;
  update: GenericCardCarouseComponentUpdateLocalizationDataInput;
};

export type GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericCardCarouseComponentUpsertInput;
  /** Unique document search */
  where: GenericCardCarouseComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericCardCarouseComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericCardCarouseComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericCardCarouseComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericCardCarouseComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericCardCarouseComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  articles_every?: InputMaybe<GenericPageWhereInput>;
  articles_none?: InputMaybe<GenericPageWhereInput>;
  articles_some?: InputMaybe<GenericPageWhereInput>;
  cardVariation?: InputMaybe<CardVariation>;
  /** All values that are contained in given list. */
  cardVariation_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardVariation_not?: InputMaybe<CardVariation>;
  /** All values that are not contained in given list. */
  cardVariation_not_in?: InputMaybe<Array<InputMaybe<CardVariation>>>;
  /** All values in which the union is empty */
  componentBackground_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  componentBackground_some?: InputMaybe<GenericCardCarouseComponentComponentBackgroundWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  /** All values in which the union is empty */
  dictionaryItem_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  dictionaryItem_some?: InputMaybe<GenericCardCarouseComponentDictionaryItemWhereInput>;
  documentInStages_every?: InputMaybe<GenericCardCarouseComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericCardCarouseComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericCardCarouseComponentWhereStageInput>;
  extension?: InputMaybe<AlgoliaExtensionWhereInput>;
  /** All values in which the union is empty */
  floatingObject_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  floatingObject_some?: InputMaybe<GenericCardLayoutComponentFloatingObjectWhereInput>;
  /** All values in which the union is connected to the given models */
  genericCardCarouselCta?: InputMaybe<GenericCardCarouseComponentGenericCradCarouselCtaWhereInput>;
  /** All values in which the union is empty */
  genericCardCarouselCta_empty?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  pointCtaToArticlesList?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  pointCtaToArticlesList_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericCardCarouseComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericCardCarouseComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericCardCarouseComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericCardCarouseComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericCardCarouseComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericCardCarouseComponent record uniquely */
export type GenericCardCarouseComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type GenericCardLayoutComponentFloatingObject = AssetComponent;

export type GenericCardLayoutComponentFloatingObjectConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type GenericCardLayoutComponentFloatingObjectCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type GenericCardLayoutComponentFloatingObjectCreateManyInlineInput = {
  /** Connect multiple existing GenericCardLayoutComponentFloatingObject documents */
  connect?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectWhereUniqueInput>>;
  /** Create and connect multiple existing GenericCardLayoutComponentFloatingObject documents */
  create?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectCreateInput>>;
};

export type GenericCardLayoutComponentFloatingObjectCreateOneInlineInput = {
  /** Connect one existing GenericCardLayoutComponentFloatingObject document */
  connect?: InputMaybe<GenericCardLayoutComponentFloatingObjectWhereUniqueInput>;
  /** Create and connect one GenericCardLayoutComponentFloatingObject document */
  create?: InputMaybe<GenericCardLayoutComponentFloatingObjectCreateInput>;
};

export type GenericCardLayoutComponentFloatingObjectUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type GenericCardLayoutComponentFloatingObjectUpdateManyInlineInput = {
  /** Connect multiple existing GenericCardLayoutComponentFloatingObject documents */
  connect?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectConnectInput>>;
  /** Create and connect multiple GenericCardLayoutComponentFloatingObject documents */
  create?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectCreateInput>>;
  /** Delete multiple GenericCardLayoutComponentFloatingObject documents */
  delete?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectWhereUniqueInput>>;
  /** Disconnect multiple GenericCardLayoutComponentFloatingObject documents */
  disconnect?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericCardLayoutComponentFloatingObject documents */
  set?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectWhereUniqueInput>>;
  /** Update multiple GenericCardLayoutComponentFloatingObject documents */
  update?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericCardLayoutComponentFloatingObject documents */
  upsert?: InputMaybe<Array<GenericCardLayoutComponentFloatingObjectUpsertWithNestedWhereUniqueInput>>;
};

export type GenericCardLayoutComponentFloatingObjectUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type GenericCardLayoutComponentFloatingObjectUpdateOneInlineInput = {
  /** Connect existing GenericCardLayoutComponentFloatingObject document */
  connect?: InputMaybe<GenericCardLayoutComponentFloatingObjectWhereUniqueInput>;
  /** Create and connect one GenericCardLayoutComponentFloatingObject document */
  create?: InputMaybe<GenericCardLayoutComponentFloatingObjectCreateInput>;
  /** Delete currently connected GenericCardLayoutComponentFloatingObject document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericCardLayoutComponentFloatingObject document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericCardLayoutComponentFloatingObject document */
  update?: InputMaybe<GenericCardLayoutComponentFloatingObjectUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericCardLayoutComponentFloatingObject document */
  upsert?: InputMaybe<GenericCardLayoutComponentFloatingObjectUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardLayoutComponentFloatingObjectUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type GenericCardLayoutComponentFloatingObjectUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type GenericCardLayoutComponentFloatingObjectWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type GenericCardLayoutComponentFloatingObjectWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponent = Entity & Node & {
  __typename?: 'GenericDownloadComponent';
  anchorNav?: Maybe<AnchorNavigation>;
  /** Image associated to the downloadable asset */
  assetComponent?: Maybe<AssetComponent>;
  /** main content of the component  */
  body: Scalars['String']['output'];
  /** just a name to identify a particular generic download component  */
  cmsTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericDownloadComponent>;
  /** A downloadable file that can be downloaded on click of download button in generic download component (file can be pdf or image) */
  downloadableFile: Asset;
  genericAccordionItems: Array<CorpGenericAccordionItem>;
  genericPages: Array<GenericPage>;
  /** List of GenericDownloadComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<GenericDownloadComponent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** A short single line introduction of the asset that is available for download */
  superText?: Maybe<Scalars['String']['output']>;
  tabContent?: Maybe<TabContent>;
  /** A short headline about the content written in body of the component  */
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentAssetComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentDownloadableFileArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentGenericAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericAccordionItemWhereInput>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** documents that are available for download can be configured here, so that user can download them.  */
export type GenericDownloadComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericDownloadComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericDownloadComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericDownloadComponentConnection = {
  __typename?: 'GenericDownloadComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericDownloadComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericDownloadComponentCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  assetComponent?: InputMaybe<AssetComponentCreateOneInlineInput>;
  /** body input for default locale (default) */
  body: Scalars['String']['input'];
  cmsTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  downloadableFile: AssetCreateOneInlineInput;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<GenericDownloadComponentCreateLocalizationsInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  /** title input for default locale (default) */
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericDownloadComponentCreateLocalizationDataInput = {
  body: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericDownloadComponentCreateLocalizationInput = {
  /** Localization input */
  data: GenericDownloadComponentCreateLocalizationDataInput;
  locale: Locale;
};

export type GenericDownloadComponentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<GenericDownloadComponentCreateLocalizationInput>>;
};

export type GenericDownloadComponentCreateManyInlineInput = {
  /** Connect multiple existing GenericDownloadComponent documents */
  connect?: InputMaybe<Array<GenericDownloadComponentWhereUniqueInput>>;
  /** Create and connect multiple existing GenericDownloadComponent documents */
  create?: InputMaybe<Array<GenericDownloadComponentCreateInput>>;
};

export type GenericDownloadComponentCreateOneInlineInput = {
  /** Connect one existing GenericDownloadComponent document */
  connect?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  /** Create and connect one GenericDownloadComponent document */
  create?: InputMaybe<GenericDownloadComponentCreateInput>;
};

/** An edge in a connection. */
export type GenericDownloadComponentEdge = {
  __typename?: 'GenericDownloadComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericDownloadComponent;
};

/** Identifies documents */
export type GenericDownloadComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericDownloadComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericDownloadComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericDownloadComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  assetComponent?: InputMaybe<AssetComponentWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericDownloadComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericDownloadComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericDownloadComponentWhereStageInput>;
  downloadableFile?: InputMaybe<AssetWhereInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericDownloadComponentOrderByInput {
  body_ASC = 'body_ASC',
  body_DESC = 'body_DESC',
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericDownloadComponentUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  assetComponent?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  /** body input for default locale (default) */
  body?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  downloadableFile?: InputMaybe<AssetUpdateOneInlineInput>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<GenericDownloadComponentUpdateLocalizationsInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericDownloadComponentUpdateLocalizationDataInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericDownloadComponentUpdateLocalizationInput = {
  data: GenericDownloadComponentUpdateLocalizationDataInput;
  locale: Locale;
};

export type GenericDownloadComponentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<GenericDownloadComponentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<GenericDownloadComponentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<GenericDownloadComponentUpsertLocalizationInput>>;
};

export type GenericDownloadComponentUpdateManyInlineInput = {
  /** Connect multiple existing GenericDownloadComponent documents */
  connect?: InputMaybe<Array<GenericDownloadComponentConnectInput>>;
  /** Create and connect multiple GenericDownloadComponent documents */
  create?: InputMaybe<Array<GenericDownloadComponentCreateInput>>;
  /** Delete multiple GenericDownloadComponent documents */
  delete?: InputMaybe<Array<GenericDownloadComponentWhereUniqueInput>>;
  /** Disconnect multiple GenericDownloadComponent documents */
  disconnect?: InputMaybe<Array<GenericDownloadComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericDownloadComponent documents */
  set?: InputMaybe<Array<GenericDownloadComponentWhereUniqueInput>>;
  /** Update multiple GenericDownloadComponent documents */
  update?: InputMaybe<Array<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericDownloadComponent documents */
  upsert?: InputMaybe<Array<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>>;
};

export type GenericDownloadComponentUpdateManyInput = {
  /** body input for default locale (default) */
  body?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<GenericDownloadComponentUpdateManyLocalizationsInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericDownloadComponentUpdateManyLocalizationDataInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericDownloadComponentUpdateManyLocalizationInput = {
  data: GenericDownloadComponentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type GenericDownloadComponentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<GenericDownloadComponentUpdateManyLocalizationInput>>;
};

export type GenericDownloadComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericDownloadComponentUpdateManyInput;
  /** Document search */
  where: GenericDownloadComponentWhereInput;
};

export type GenericDownloadComponentUpdateOneInlineInput = {
  /** Connect existing GenericDownloadComponent document */
  connect?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  /** Create and connect one GenericDownloadComponent document */
  create?: InputMaybe<GenericDownloadComponentCreateInput>;
  /** Delete currently connected GenericDownloadComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericDownloadComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericDownloadComponent document */
  update?: InputMaybe<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericDownloadComponent document */
  upsert?: InputMaybe<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>;
};

export type GenericDownloadComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericDownloadComponentUpdateInput;
  /** Unique document search */
  where: GenericDownloadComponentWhereUniqueInput;
};

export type GenericDownloadComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericDownloadComponentCreateInput;
  /** Update document if it exists */
  update: GenericDownloadComponentUpdateInput;
};

export type GenericDownloadComponentUpsertLocalizationInput = {
  create: GenericDownloadComponentCreateLocalizationDataInput;
  locale: Locale;
  update: GenericDownloadComponentUpdateLocalizationDataInput;
};

export type GenericDownloadComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericDownloadComponentUpsertInput;
  /** Unique document search */
  where: GenericDownloadComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericDownloadComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericDownloadComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericDownloadComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericDownloadComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericDownloadComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  assetComponent?: InputMaybe<AssetComponentWhereInput>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  body_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  body_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericDownloadComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericDownloadComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericDownloadComponentWhereStageInput>;
  downloadableFile?: InputMaybe<AssetWhereInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericDownloadComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericDownloadComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericDownloadComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericDownloadComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericDownloadComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericDownloadComponent record uniquely */
export type GenericDownloadComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericFollowUs = Entity & Node & {
  __typename?: 'GenericFollowUs';
  anchorNav?: Maybe<AnchorNavigation>;
  cmsTitle: Scalars['String']['output'];
  color: CorpColorThemeName;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericFollowUs>;
  genericPages: Array<GenericPage>;
  /** List of GenericFollowUs versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<GenericFollowUs>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  socialMedia: Array<SocialMediaListComponent>;
  /** System stage field */
  stage: Stage;
  super?: Maybe<Scalars['String']['output']>;
  tabContent?: Maybe<TabContent>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericFollowUsAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericFollowUsCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericFollowUsCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericFollowUsDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericFollowUsGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GenericFollowUsHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericFollowUsLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type GenericFollowUsPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericFollowUsPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericFollowUsScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericFollowUsSocialMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<SocialMediaListComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SocialMediaListComponentWhereInput>;
};


export type GenericFollowUsTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericFollowUsUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericFollowUsUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericFollowUsConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericFollowUsWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericFollowUsConnection = {
  __typename?: 'GenericFollowUsConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericFollowUsEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericFollowUsCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cl4e9pyno0e1f01z42cjia06y?: InputMaybe<CorpStoriesPageCreateManyInlineInput>;
  cmsTitle: Scalars['String']['input'];
  color: CorpColorThemeName;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<GenericFollowUsCreateLocalizationsInput>;
  socialMedia?: InputMaybe<SocialMediaListComponentCreateManyInlineInput>;
  /** super input for default locale (default) */
  super?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericFollowUsCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  super?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericFollowUsCreateLocalizationInput = {
  /** Localization input */
  data: GenericFollowUsCreateLocalizationDataInput;
  locale: Locale;
};

export type GenericFollowUsCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<GenericFollowUsCreateLocalizationInput>>;
};

export type GenericFollowUsCreateManyInlineInput = {
  /** Connect multiple existing GenericFollowUs documents */
  connect?: InputMaybe<Array<GenericFollowUsWhereUniqueInput>>;
  /** Create and connect multiple existing GenericFollowUs documents */
  create?: InputMaybe<Array<GenericFollowUsCreateInput>>;
};

export type GenericFollowUsCreateOneInlineInput = {
  /** Connect one existing GenericFollowUs document */
  connect?: InputMaybe<GenericFollowUsWhereUniqueInput>;
  /** Create and connect one GenericFollowUs document */
  create?: InputMaybe<GenericFollowUsCreateInput>;
};

/** An edge in a connection. */
export type GenericFollowUsEdge = {
  __typename?: 'GenericFollowUsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericFollowUs;
};

/** Identifies documents */
export type GenericFollowUsManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericFollowUsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericFollowUsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericFollowUsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  /** All values that are contained in given list. */
  color_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  /** Any other value that exists and is not equal to the given value. */
  color_not?: InputMaybe<CorpColorThemeName>;
  /** All values that are not contained in given list. */
  color_not_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericFollowUsWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericFollowUsWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericFollowUsWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  socialMedia_every?: InputMaybe<SocialMediaListComponentWhereInput>;
  socialMedia_none?: InputMaybe<SocialMediaListComponentWhereInput>;
  socialMedia_some?: InputMaybe<SocialMediaListComponentWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericFollowUsOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  color_ASC = 'color_ASC',
  color_DESC = 'color_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  super_ASC = 'super_ASC',
  super_DESC = 'super_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericFollowUsUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cl4e9pyno0e1f01z42cjia06y?: InputMaybe<CorpStoriesPageUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<GenericFollowUsUpdateLocalizationsInput>;
  socialMedia?: InputMaybe<SocialMediaListComponentUpdateManyInlineInput>;
  /** super input for default locale (default) */
  super?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericFollowUsUpdateLocalizationDataInput = {
  super?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericFollowUsUpdateLocalizationInput = {
  data: GenericFollowUsUpdateLocalizationDataInput;
  locale: Locale;
};

export type GenericFollowUsUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<GenericFollowUsCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<GenericFollowUsUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<GenericFollowUsUpsertLocalizationInput>>;
};

export type GenericFollowUsUpdateManyInlineInput = {
  /** Connect multiple existing GenericFollowUs documents */
  connect?: InputMaybe<Array<GenericFollowUsConnectInput>>;
  /** Create and connect multiple GenericFollowUs documents */
  create?: InputMaybe<Array<GenericFollowUsCreateInput>>;
  /** Delete multiple GenericFollowUs documents */
  delete?: InputMaybe<Array<GenericFollowUsWhereUniqueInput>>;
  /** Disconnect multiple GenericFollowUs documents */
  disconnect?: InputMaybe<Array<GenericFollowUsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericFollowUs documents */
  set?: InputMaybe<Array<GenericFollowUsWhereUniqueInput>>;
  /** Update multiple GenericFollowUs documents */
  update?: InputMaybe<Array<GenericFollowUsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericFollowUs documents */
  upsert?: InputMaybe<Array<GenericFollowUsUpsertWithNestedWhereUniqueInput>>;
};

export type GenericFollowUsUpdateManyInput = {
  color?: InputMaybe<CorpColorThemeName>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<GenericFollowUsUpdateManyLocalizationsInput>;
  /** super input for default locale (default) */
  super?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericFollowUsUpdateManyLocalizationDataInput = {
  super?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericFollowUsUpdateManyLocalizationInput = {
  data: GenericFollowUsUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type GenericFollowUsUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<GenericFollowUsUpdateManyLocalizationInput>>;
};

export type GenericFollowUsUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericFollowUsUpdateManyInput;
  /** Document search */
  where: GenericFollowUsWhereInput;
};

export type GenericFollowUsUpdateOneInlineInput = {
  /** Connect existing GenericFollowUs document */
  connect?: InputMaybe<GenericFollowUsWhereUniqueInput>;
  /** Create and connect one GenericFollowUs document */
  create?: InputMaybe<GenericFollowUsCreateInput>;
  /** Delete currently connected GenericFollowUs document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericFollowUs document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericFollowUs document */
  update?: InputMaybe<GenericFollowUsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericFollowUs document */
  upsert?: InputMaybe<GenericFollowUsUpsertWithNestedWhereUniqueInput>;
};

export type GenericFollowUsUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericFollowUsUpdateInput;
  /** Unique document search */
  where: GenericFollowUsWhereUniqueInput;
};

export type GenericFollowUsUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericFollowUsCreateInput;
  /** Update document if it exists */
  update: GenericFollowUsUpdateInput;
};

export type GenericFollowUsUpsertLocalizationInput = {
  create: GenericFollowUsCreateLocalizationDataInput;
  locale: Locale;
  update: GenericFollowUsUpdateLocalizationDataInput;
};

export type GenericFollowUsUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericFollowUsUpsertInput;
  /** Unique document search */
  where: GenericFollowUsWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericFollowUsWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericFollowUsWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericFollowUsWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericFollowUsWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericFollowUsWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  /** All values that are contained in given list. */
  color_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  /** Any other value that exists and is not equal to the given value. */
  color_not?: InputMaybe<CorpColorThemeName>;
  /** All values that are not contained in given list. */
  color_not_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericFollowUsWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericFollowUsWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericFollowUsWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  socialMedia_every?: InputMaybe<SocialMediaListComponentWhereInput>;
  socialMedia_none?: InputMaybe<SocialMediaListComponentWhereInput>;
  socialMedia_some?: InputMaybe<SocialMediaListComponentWhereInput>;
  super?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  super_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  super_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  super_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  super_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  super_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  super_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  super_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  super_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  super_starts_with?: InputMaybe<Scalars['String']['input']>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericFollowUsWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericFollowUsWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericFollowUsWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericFollowUsWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericFollowUsWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericFollowUs record uniquely */
export type GenericFollowUsWhereUniqueInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorable = Entity & Node & {
  __typename?: 'GenericGridAuthorable';
  cards: Array<GenericGridAuthorableCards>;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  dictionary?: Maybe<Dictionary>;
  /** Get the document in other stages */
  documentInStages: Array<GenericGridAuthorable>;
  genericPages: Array<GenericPage>;
  /** List of GenericGridAuthorable versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  regularLayout?: Maybe<Scalars['Boolean']['output']>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  superText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableDictionaryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorablePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Grid of content cards on a specific topic so that user can explore the content and decide what page I want to navigate to. */
export type GenericGridAuthorableUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericGridAuthorableCards = AuthorableContentCard | FeaturedContentReference;

export type GenericGridAuthorableCardsConnectInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardConnectInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceConnectInput>;
};

export type GenericGridAuthorableCardsCreateInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardCreateInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceCreateInput>;
};

export type GenericGridAuthorableCardsCreateManyInlineInput = {
  /** Connect multiple existing GenericGridAuthorableCards documents */
  connect?: InputMaybe<Array<GenericGridAuthorableCardsWhereUniqueInput>>;
  /** Create and connect multiple existing GenericGridAuthorableCards documents */
  create?: InputMaybe<Array<GenericGridAuthorableCardsCreateInput>>;
};

export type GenericGridAuthorableCardsCreateOneInlineInput = {
  /** Connect one existing GenericGridAuthorableCards document */
  connect?: InputMaybe<GenericGridAuthorableCardsWhereUniqueInput>;
  /** Create and connect one GenericGridAuthorableCards document */
  create?: InputMaybe<GenericGridAuthorableCardsCreateInput>;
};

export type GenericGridAuthorableCardsUpdateInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceUpdateInput>;
};

export type GenericGridAuthorableCardsUpdateManyInlineInput = {
  /** Connect multiple existing GenericGridAuthorableCards documents */
  connect?: InputMaybe<Array<GenericGridAuthorableCardsConnectInput>>;
  /** Create and connect multiple GenericGridAuthorableCards documents */
  create?: InputMaybe<Array<GenericGridAuthorableCardsCreateInput>>;
  /** Delete multiple GenericGridAuthorableCards documents */
  delete?: InputMaybe<Array<GenericGridAuthorableCardsWhereUniqueInput>>;
  /** Disconnect multiple GenericGridAuthorableCards documents */
  disconnect?: InputMaybe<Array<GenericGridAuthorableCardsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericGridAuthorableCards documents */
  set?: InputMaybe<Array<GenericGridAuthorableCardsWhereUniqueInput>>;
  /** Update multiple GenericGridAuthorableCards documents */
  update?: InputMaybe<Array<GenericGridAuthorableCardsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericGridAuthorableCards documents */
  upsert?: InputMaybe<Array<GenericGridAuthorableCardsUpsertWithNestedWhereUniqueInput>>;
};

export type GenericGridAuthorableCardsUpdateManyWithNestedWhereInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateManyWithNestedWhereInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceUpdateManyWithNestedWhereInput>;
};

export type GenericGridAuthorableCardsUpdateOneInlineInput = {
  /** Connect existing GenericGridAuthorableCards document */
  connect?: InputMaybe<GenericGridAuthorableCardsWhereUniqueInput>;
  /** Create and connect one GenericGridAuthorableCards document */
  create?: InputMaybe<GenericGridAuthorableCardsCreateInput>;
  /** Delete currently connected GenericGridAuthorableCards document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericGridAuthorableCards document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericGridAuthorableCards document */
  update?: InputMaybe<GenericGridAuthorableCardsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericGridAuthorableCards document */
  upsert?: InputMaybe<GenericGridAuthorableCardsUpsertWithNestedWhereUniqueInput>;
};

export type GenericGridAuthorableCardsUpdateWithNestedWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateWithNestedWhereUniqueInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceUpdateWithNestedWhereUniqueInput>;
};

export type GenericGridAuthorableCardsUpsertWithNestedWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpsertWithNestedWhereUniqueInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceUpsertWithNestedWhereUniqueInput>;
};

export type GenericGridAuthorableCardsWhereInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceWhereInput>;
};

export type GenericGridAuthorableCardsWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereUniqueInput>;
  FeaturedContentReference?: InputMaybe<FeaturedContentReferenceWhereUniqueInput>;
};

export type GenericGridAuthorableConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericGridAuthorableWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericGridAuthorableConnection = {
  __typename?: 'GenericGridAuthorableConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericGridAuthorableEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericGridAuthorableCreateInput = {
  cards?: InputMaybe<GenericGridAuthorableCardsCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionary?: InputMaybe<DictionaryCreateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  regularLayout?: InputMaybe<Scalars['Boolean']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericGridAuthorableCreateManyInlineInput = {
  /** Connect multiple existing GenericGridAuthorable documents */
  connect?: InputMaybe<Array<GenericGridAuthorableWhereUniqueInput>>;
  /** Create and connect multiple existing GenericGridAuthorable documents */
  create?: InputMaybe<Array<GenericGridAuthorableCreateInput>>;
};

export type GenericGridAuthorableCreateOneInlineInput = {
  /** Connect one existing GenericGridAuthorable document */
  connect?: InputMaybe<GenericGridAuthorableWhereUniqueInput>;
  /** Create and connect one GenericGridAuthorable document */
  create?: InputMaybe<GenericGridAuthorableCreateInput>;
};

/** An edge in a connection. */
export type GenericGridAuthorableEdge = {
  __typename?: 'GenericGridAuthorableEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericGridAuthorable;
};

/** Identifies documents */
export type GenericGridAuthorableManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericGridAuthorableWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericGridAuthorableWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericGridAuthorableWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  cards_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  cards_some?: InputMaybe<GenericGridAuthorableCardsWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionary?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<GenericGridAuthorableWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericGridAuthorableWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericGridAuthorableWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  regularLayout?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  regularLayout_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericGridAuthorableOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  regularLayout_ASC = 'regularLayout_ASC',
  regularLayout_DESC = 'regularLayout_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericGridAuthorableUpdateInput = {
  cards?: InputMaybe<GenericGridAuthorableCardsUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  dictionary?: InputMaybe<DictionaryUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  regularLayout?: InputMaybe<Scalars['Boolean']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericGridAuthorableUpdateManyInlineInput = {
  /** Connect multiple existing GenericGridAuthorable documents */
  connect?: InputMaybe<Array<GenericGridAuthorableConnectInput>>;
  /** Create and connect multiple GenericGridAuthorable documents */
  create?: InputMaybe<Array<GenericGridAuthorableCreateInput>>;
  /** Delete multiple GenericGridAuthorable documents */
  delete?: InputMaybe<Array<GenericGridAuthorableWhereUniqueInput>>;
  /** Disconnect multiple GenericGridAuthorable documents */
  disconnect?: InputMaybe<Array<GenericGridAuthorableWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericGridAuthorable documents */
  set?: InputMaybe<Array<GenericGridAuthorableWhereUniqueInput>>;
  /** Update multiple GenericGridAuthorable documents */
  update?: InputMaybe<Array<GenericGridAuthorableUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericGridAuthorable documents */
  upsert?: InputMaybe<Array<GenericGridAuthorableUpsertWithNestedWhereUniqueInput>>;
};

export type GenericGridAuthorableUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  regularLayout?: InputMaybe<Scalars['Boolean']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericGridAuthorableUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericGridAuthorableUpdateManyInput;
  /** Document search */
  where: GenericGridAuthorableWhereInput;
};

export type GenericGridAuthorableUpdateOneInlineInput = {
  /** Connect existing GenericGridAuthorable document */
  connect?: InputMaybe<GenericGridAuthorableWhereUniqueInput>;
  /** Create and connect one GenericGridAuthorable document */
  create?: InputMaybe<GenericGridAuthorableCreateInput>;
  /** Delete currently connected GenericGridAuthorable document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericGridAuthorable document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericGridAuthorable document */
  update?: InputMaybe<GenericGridAuthorableUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericGridAuthorable document */
  upsert?: InputMaybe<GenericGridAuthorableUpsertWithNestedWhereUniqueInput>;
};

export type GenericGridAuthorableUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericGridAuthorableUpdateInput;
  /** Unique document search */
  where: GenericGridAuthorableWhereUniqueInput;
};

export type GenericGridAuthorableUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericGridAuthorableCreateInput;
  /** Update document if it exists */
  update: GenericGridAuthorableUpdateInput;
};

export type GenericGridAuthorableUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericGridAuthorableUpsertInput;
  /** Unique document search */
  where: GenericGridAuthorableWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericGridAuthorableWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericGridAuthorableWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericGridAuthorableWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericGridAuthorableWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericGridAuthorableWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  cards_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  cards_some?: InputMaybe<GenericGridAuthorableCardsWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionary?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<GenericGridAuthorableWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericGridAuthorableWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericGridAuthorableWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  regularLayout?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  regularLayout_not?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericGridAuthorableWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericGridAuthorableWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericGridAuthorableWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericGridAuthorableWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericGridAuthorableWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericGridAuthorable record uniquely */
export type GenericGridAuthorableWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericLine = Entity & Node & {
  __typename?: 'GenericLine';
  /** Title to be identified in the cms when searching content. */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericLine>;
  /** Add a line to a page by enabling this component */
  enableLine?: Maybe<Scalars['Boolean']['output']>;
  genericPages: Array<GenericPage>;
  /** List of GenericLine versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<GenericLine>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericLineCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericLineCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericLineDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericLineGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GenericLineHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericLineLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type GenericLinePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericLinePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericLineScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericLineStoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


export type GenericLineTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericLineUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericLineUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericLineConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericLineWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericLineConnection = {
  __typename?: 'GenericLineConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericLineEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericLineCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** enableLine input for default locale (default) */
  enableLine?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<GenericLineCreateLocalizationsInput>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericLineCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  enableLine?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericLineCreateLocalizationInput = {
  /** Localization input */
  data: GenericLineCreateLocalizationDataInput;
  locale: Locale;
};

export type GenericLineCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<GenericLineCreateLocalizationInput>>;
};

export type GenericLineCreateManyInlineInput = {
  /** Connect multiple existing GenericLine documents */
  connect?: InputMaybe<Array<GenericLineWhereUniqueInput>>;
  /** Create and connect multiple existing GenericLine documents */
  create?: InputMaybe<Array<GenericLineCreateInput>>;
};

export type GenericLineCreateOneInlineInput = {
  /** Connect one existing GenericLine document */
  connect?: InputMaybe<GenericLineWhereUniqueInput>;
  /** Create and connect one GenericLine document */
  create?: InputMaybe<GenericLineCreateInput>;
};

/** An edge in a connection. */
export type GenericLineEdge = {
  __typename?: 'GenericLineEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericLine;
};

/** Identifies documents */
export type GenericLineManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericLineWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericLineWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericLineWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericLineWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericLineWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericLineWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericLineOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  enableLine_ASC = 'enableLine_ASC',
  enableLine_DESC = 'enableLine_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericLineUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** enableLine input for default locale (default) */
  enableLine?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<GenericLineUpdateLocalizationsInput>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type GenericLineUpdateLocalizationDataInput = {
  enableLine?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GenericLineUpdateLocalizationInput = {
  data: GenericLineUpdateLocalizationDataInput;
  locale: Locale;
};

export type GenericLineUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<GenericLineCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<GenericLineUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<GenericLineUpsertLocalizationInput>>;
};

export type GenericLineUpdateManyInlineInput = {
  /** Connect multiple existing GenericLine documents */
  connect?: InputMaybe<Array<GenericLineConnectInput>>;
  /** Create and connect multiple GenericLine documents */
  create?: InputMaybe<Array<GenericLineCreateInput>>;
  /** Delete multiple GenericLine documents */
  delete?: InputMaybe<Array<GenericLineWhereUniqueInput>>;
  /** Disconnect multiple GenericLine documents */
  disconnect?: InputMaybe<Array<GenericLineWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericLine documents */
  set?: InputMaybe<Array<GenericLineWhereUniqueInput>>;
  /** Update multiple GenericLine documents */
  update?: InputMaybe<Array<GenericLineUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericLine documents */
  upsert?: InputMaybe<Array<GenericLineUpsertWithNestedWhereUniqueInput>>;
};

export type GenericLineUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** enableLine input for default locale (default) */
  enableLine?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<GenericLineUpdateManyLocalizationsInput>;
};

export type GenericLineUpdateManyLocalizationDataInput = {
  enableLine?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GenericLineUpdateManyLocalizationInput = {
  data: GenericLineUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type GenericLineUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<GenericLineUpdateManyLocalizationInput>>;
};

export type GenericLineUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericLineUpdateManyInput;
  /** Document search */
  where: GenericLineWhereInput;
};

export type GenericLineUpdateOneInlineInput = {
  /** Connect existing GenericLine document */
  connect?: InputMaybe<GenericLineWhereUniqueInput>;
  /** Create and connect one GenericLine document */
  create?: InputMaybe<GenericLineCreateInput>;
  /** Delete currently connected GenericLine document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericLine document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericLine document */
  update?: InputMaybe<GenericLineUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericLine document */
  upsert?: InputMaybe<GenericLineUpsertWithNestedWhereUniqueInput>;
};

export type GenericLineUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericLineUpdateInput;
  /** Unique document search */
  where: GenericLineWhereUniqueInput;
};

export type GenericLineUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericLineCreateInput;
  /** Update document if it exists */
  update: GenericLineUpdateInput;
};

export type GenericLineUpsertLocalizationInput = {
  create: GenericLineCreateLocalizationDataInput;
  locale: Locale;
  update: GenericLineUpdateLocalizationDataInput;
};

export type GenericLineUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericLineUpsertInput;
  /** Unique document search */
  where: GenericLineWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericLineWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericLineWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericLineWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericLineWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericLineWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericLineWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericLineWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericLineWhereStageInput>;
  enableLine?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  enableLine_not?: InputMaybe<Scalars['Boolean']['input']>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericLineWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericLineWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericLineWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericLineWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericLineWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericLine record uniquely */
export type GenericLineWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericLink = Entity & Node & {
  __typename?: 'GenericLink';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<GenericLink>;
  /** List of GenericLink versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericLinkCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericLinkDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericLinkHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericLinkPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericLinkScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericLinkUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericLinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericLinkWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericLinkConnection = {
  __typename?: 'GenericLinkConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericLinkEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericLinkCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  link: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericLinkCreateManyInlineInput = {
  /** Connect multiple existing GenericLink documents */
  connect?: InputMaybe<Array<GenericLinkWhereUniqueInput>>;
  /** Create and connect multiple existing GenericLink documents */
  create?: InputMaybe<Array<GenericLinkCreateInput>>;
};

export type GenericLinkCreateOneInlineInput = {
  /** Connect one existing GenericLink document */
  connect?: InputMaybe<GenericLinkWhereUniqueInput>;
  /** Create and connect one GenericLink document */
  create?: InputMaybe<GenericLinkCreateInput>;
};

/** An edge in a connection. */
export type GenericLinkEdge = {
  __typename?: 'GenericLinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericLink;
};

/** Identifies documents */
export type GenericLinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericLinkWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericLinkWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericLinkWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  link_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  link_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  link_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  link_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  link_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  link_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  link_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericLinkOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  link_ASC = 'link_ASC',
  link_DESC = 'link_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericLinkUpdateInput = {
  link?: InputMaybe<Scalars['String']['input']>;
};

export type GenericLinkUpdateManyInlineInput = {
  /** Connect multiple existing GenericLink documents */
  connect?: InputMaybe<Array<GenericLinkConnectInput>>;
  /** Create and connect multiple GenericLink documents */
  create?: InputMaybe<Array<GenericLinkCreateInput>>;
  /** Delete multiple GenericLink documents */
  delete?: InputMaybe<Array<GenericLinkWhereUniqueInput>>;
  /** Disconnect multiple GenericLink documents */
  disconnect?: InputMaybe<Array<GenericLinkWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericLink documents */
  set?: InputMaybe<Array<GenericLinkWhereUniqueInput>>;
  /** Update multiple GenericLink documents */
  update?: InputMaybe<Array<GenericLinkUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericLink documents */
  upsert?: InputMaybe<Array<GenericLinkUpsertWithNestedWhereUniqueInput>>;
};

export type GenericLinkUpdateManyInput = {
  link?: InputMaybe<Scalars['String']['input']>;
};

export type GenericLinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericLinkUpdateManyInput;
  /** Document search */
  where: GenericLinkWhereInput;
};

export type GenericLinkUpdateOneInlineInput = {
  /** Connect existing GenericLink document */
  connect?: InputMaybe<GenericLinkWhereUniqueInput>;
  /** Create and connect one GenericLink document */
  create?: InputMaybe<GenericLinkCreateInput>;
  /** Delete currently connected GenericLink document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericLink document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericLink document */
  update?: InputMaybe<GenericLinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericLink document */
  upsert?: InputMaybe<GenericLinkUpsertWithNestedWhereUniqueInput>;
};

export type GenericLinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericLinkUpdateInput;
  /** Unique document search */
  where: GenericLinkWhereUniqueInput;
};

export type GenericLinkUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericLinkCreateInput;
  /** Update document if it exists */
  update: GenericLinkUpdateInput;
};

export type GenericLinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericLinkUpsertInput;
  /** Unique document search */
  where: GenericLinkWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericLinkWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericLinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GenericLinkWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericLinkWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericLinkWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  link_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  link_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  link_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  link_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  link_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  link_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  link_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  link_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  link_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericLinkWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericLinkWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericLinkWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericLinkWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericLinkWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericLink record uniquely */
export type GenericLinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericPage = Entity & Node & {
  __typename?: 'GenericPage';
  /** If set to true, this page will be indexed on all selected markets. */
  alwaysIndex?: Maybe<Scalars['Boolean']['output']>;
  anchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Content Grouping option to be selected to pass through to the dataLayer value cg1 */
  contentGroupingTrackingValue?: Maybe<TrackingContentGrouping>;
  /** Content Grouping options to be selected to pass through to the dataLayer value cg2 */
  contentGroupingTrackingValues?: Maybe<TrackingContentGrouping>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  dictionary?: Maybe<Dictionary>;
  /** Get the document in other stages */
  documentInStages: Array<GenericPage>;
  genericPages: Array<GenericPage>;
  /** Hide Navigation and only show Logo */
  hideNavigation?: Maybe<Scalars['Boolean']['output']>;
  /** List of GenericPage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  internalLinks: Array<Link>;
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<GenericPage>;
  markets: Array<Markets>;
  metaData?: Maybe<MetaData>;
  pageComponents: Array<GenericPagePageComponents>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** If set to false, the cookie banner will not show on that page. */
  showCookieBanner: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** Page type to be able to sort and filter the generic pages */
  type: GenericPagesTypes;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type GenericPageAnchorNavigationListArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericPageCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericPageDictionaryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type GenericPageGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type GenericPageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type GenericPageInternalLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


export type GenericPageLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericPageLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type GenericPageMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericPagePageComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type GenericPagePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type GenericPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type GenericPageUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type GenericPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GenericPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GenericPageWhereUniqueInput;
};

/** A connection to a list of items. */
export type GenericPageConnection = {
  __typename?: 'GenericPageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GenericPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GenericPageCreateInput = {
  alwaysIndex?: InputMaybe<Scalars['Boolean']['input']>;
  anchorNavigationList?: InputMaybe<AnchorNavigationListCreateOneInlineInput>;
  ckuntpg4l4gcn01z67yt87trx?: InputMaybe<FeaturedContentReferenceCreateManyInlineInput>;
  ckv0ngnv50vy401xv0n2q3dhq?: InputMaybe<GenericCardCarouseComponentCreateManyInlineInput>;
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionary?: InputMaybe<DictionaryCreateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  hideNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  internalLinks?: InputMaybe<LinkCreateManyInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<GenericPageCreateLocalizationsInput>;
  markets?: InputMaybe<Array<Markets>>;
  metaData?: InputMaybe<MetaDataCreateOneInlineInput>;
  pageComponents?: InputMaybe<GenericPagePageComponentsCreateManyInlineInput>;
  showCookieBanner: Scalars['Boolean']['input'];
  /** slug input for default locale (default) */
  slug: Scalars['String']['input'];
  /** title input for default locale (default) */
  title: Scalars['String']['input'];
  type: GenericPagesTypes;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericPageCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GenericPageCreateLocalizationInput = {
  /** Localization input */
  data: GenericPageCreateLocalizationDataInput;
  locale: Locale;
};

export type GenericPageCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<GenericPageCreateLocalizationInput>>;
};

export type GenericPageCreateManyInlineInput = {
  /** Connect multiple existing GenericPage documents */
  connect?: InputMaybe<Array<GenericPageWhereUniqueInput>>;
  /** Create and connect multiple existing GenericPage documents */
  create?: InputMaybe<Array<GenericPageCreateInput>>;
};

export type GenericPageCreateOneInlineInput = {
  /** Connect one existing GenericPage document */
  connect?: InputMaybe<GenericPageWhereUniqueInput>;
  /** Create and connect one GenericPage document */
  create?: InputMaybe<GenericPageCreateInput>;
};

/** An edge in a connection. */
export type GenericPageEdge = {
  __typename?: 'GenericPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GenericPage;
};

/** Identifies documents */
export type GenericPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alwaysIndex?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  alwaysIndex_not?: InputMaybe<Scalars['Boolean']['input']>;
  anchorNavigationList?: InputMaybe<AnchorNavigationListWhereInput>;
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValue_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValue_not?: InputMaybe<TrackingContentGrouping>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValue_not_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValues_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValues_not?: InputMaybe<TrackingContentGrouping>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValues_not_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionary?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<GenericPageWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericPageWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericPageWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  hideNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hideNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalLinks_every?: InputMaybe<LinkWhereInput>;
  internalLinks_none?: InputMaybe<LinkWhereInput>;
  internalLinks_some?: InputMaybe<LinkWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  markets?: InputMaybe<Array<Markets>>;
  /** Matches if the field array contains *all* items provided to the filter */
  markets_contains_all?: InputMaybe<Array<Markets>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  markets_contains_none?: InputMaybe<Array<Markets>>;
  /** Matches if the field array contains at least one item provided to the filter */
  markets_contains_some?: InputMaybe<Array<Markets>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  markets_not?: InputMaybe<Array<Markets>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<GenericPagePageComponentsWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showCookieBanner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showCookieBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<GenericPagesTypes>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<GenericPagesTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<GenericPagesTypes>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<GenericPagesTypes>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GenericPageOrderByInput {
  alwaysIndex_ASC = 'alwaysIndex_ASC',
  alwaysIndex_DESC = 'alwaysIndex_DESC',
  contentGroupingTrackingValue_ASC = 'contentGroupingTrackingValue_ASC',
  contentGroupingTrackingValue_DESC = 'contentGroupingTrackingValue_DESC',
  contentGroupingTrackingValues_ASC = 'contentGroupingTrackingValues_ASC',
  contentGroupingTrackingValues_DESC = 'contentGroupingTrackingValues_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  hideNavigation_ASC = 'hideNavigation_ASC',
  hideNavigation_DESC = 'hideNavigation_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  markets_ASC = 'markets_ASC',
  markets_DESC = 'markets_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  showCookieBanner_ASC = 'showCookieBanner_ASC',
  showCookieBanner_DESC = 'showCookieBanner_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type GenericPagePageComponents = AnchorNavigationList | AudioComponent | AuthorableContentCard | Banner2 | CarouselComponent | ContactCardContainer | CorpBanner1 | CorpCalendarEvent | CorpCardCarousel | CorpContactCardContainer | CorpForm | CorpGenericAccordion | CorpGenericBanner | CorpGenericContainer | CorpGridColumnComponent | CorpHero | CorpMediaDownloadPreview | CorpOurPeople | CorpTimelineAccordionWrapper | CorpVideoHero | CorpVideoHeroCarousel | DynamicCardGrid | ExampleComponent | FeaturedContent | Form | GenericAccordion | GenericAccordionTopRated | GenericCardCarouseComponent | GenericDownloadComponent | GenericFollowUs | GenericGridAuthorable | GenericLine | GenericPage | HeroBanner | HeroCarouselComponent | HeroComponent | Iframe | ImageAndTextCard | ImageCopy | IntroText | Link | LocationComponent | LongText | MetaData | PageFooter | PageHeader | ProgressBar | QuickLink | SearchInput | ShortHero | Spacer | Tab;

export type GenericPagePageComponentsConnectInput = {
  AnchorNavigationList?: InputMaybe<AnchorNavigationListConnectInput>;
  AudioComponent?: InputMaybe<AudioComponentConnectInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardConnectInput>;
  Banner2?: InputMaybe<Banner2ConnectInput>;
  CarouselComponent?: InputMaybe<CarouselComponentConnectInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerConnectInput>;
  CorpBanner1?: InputMaybe<CorpBanner1ConnectInput>;
  CorpCalendarEvent?: InputMaybe<CorpCalendarEventConnectInput>;
  CorpCardCarousel?: InputMaybe<CorpCardCarouselConnectInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerConnectInput>;
  CorpForm?: InputMaybe<CorpFormConnectInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionConnectInput>;
  CorpGenericBanner?: InputMaybe<CorpGenericBannerConnectInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerConnectInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentConnectInput>;
  CorpHero?: InputMaybe<CorpHeroConnectInput>;
  CorpMediaDownloadPreview?: InputMaybe<CorpMediaDownloadPreviewConnectInput>;
  CorpOurPeople?: InputMaybe<CorpOurPeopleConnectInput>;
  CorpTimelineAccordionWrapper?: InputMaybe<CorpTimelineAccordionWrapperConnectInput>;
  CorpVideoHero?: InputMaybe<CorpVideoHeroConnectInput>;
  CorpVideoHeroCarousel?: InputMaybe<CorpVideoHeroCarouselConnectInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridConnectInput>;
  ExampleComponent?: InputMaybe<ExampleComponentConnectInput>;
  FeaturedContent?: InputMaybe<FeaturedContentConnectInput>;
  Form?: InputMaybe<FormConnectInput>;
  GenericAccordion?: InputMaybe<GenericAccordionConnectInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedConnectInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentConnectInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentConnectInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsConnectInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableConnectInput>;
  GenericLine?: InputMaybe<GenericLineConnectInput>;
  GenericPage?: InputMaybe<GenericPageConnectInput>;
  HeroBanner?: InputMaybe<HeroBannerConnectInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentConnectInput>;
  HeroComponent?: InputMaybe<HeroComponentConnectInput>;
  Iframe?: InputMaybe<IframeConnectInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardConnectInput>;
  ImageCopy?: InputMaybe<ImageCopyConnectInput>;
  IntroText?: InputMaybe<IntroTextConnectInput>;
  Link?: InputMaybe<LinkConnectInput>;
  LocationComponent?: InputMaybe<LocationComponentConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
  MetaData?: InputMaybe<MetaDataConnectInput>;
  PageFooter?: InputMaybe<PageFooterConnectInput>;
  PageHeader?: InputMaybe<PageHeaderConnectInput>;
  ProgressBar?: InputMaybe<ProgressBarConnectInput>;
  QuickLink?: InputMaybe<QuickLinkConnectInput>;
  SearchInput?: InputMaybe<SearchInputConnectInput>;
  ShortHero?: InputMaybe<ShortHeroConnectInput>;
  Spacer?: InputMaybe<SpacerConnectInput>;
  Tab?: InputMaybe<TabConnectInput>;
};

export type GenericPagePageComponentsCreateInput = {
  AnchorNavigationList?: InputMaybe<AnchorNavigationListCreateInput>;
  AudioComponent?: InputMaybe<AudioComponentCreateInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardCreateInput>;
  Banner2?: InputMaybe<Banner2CreateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentCreateInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerCreateInput>;
  CorpBanner1?: InputMaybe<CorpBanner1CreateInput>;
  CorpCalendarEvent?: InputMaybe<CorpCalendarEventCreateInput>;
  CorpCardCarousel?: InputMaybe<CorpCardCarouselCreateInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerCreateInput>;
  CorpForm?: InputMaybe<CorpFormCreateInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionCreateInput>;
  CorpGenericBanner?: InputMaybe<CorpGenericBannerCreateInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerCreateInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentCreateInput>;
  CorpHero?: InputMaybe<CorpHeroCreateInput>;
  CorpMediaDownloadPreview?: InputMaybe<CorpMediaDownloadPreviewCreateInput>;
  CorpOurPeople?: InputMaybe<CorpOurPeopleCreateInput>;
  CorpTimelineAccordionWrapper?: InputMaybe<CorpTimelineAccordionWrapperCreateInput>;
  CorpVideoHero?: InputMaybe<CorpVideoHeroCreateInput>;
  CorpVideoHeroCarousel?: InputMaybe<CorpVideoHeroCarouselCreateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridCreateInput>;
  ExampleComponent?: InputMaybe<ExampleComponentCreateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentCreateInput>;
  Form?: InputMaybe<FormCreateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionCreateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedCreateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentCreateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsCreateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableCreateInput>;
  GenericLine?: InputMaybe<GenericLineCreateInput>;
  GenericPage?: InputMaybe<GenericPageCreateInput>;
  HeroBanner?: InputMaybe<HeroBannerCreateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateInput>;
  HeroComponent?: InputMaybe<HeroComponentCreateInput>;
  Iframe?: InputMaybe<IframeCreateInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardCreateInput>;
  ImageCopy?: InputMaybe<ImageCopyCreateInput>;
  IntroText?: InputMaybe<IntroTextCreateInput>;
  Link?: InputMaybe<LinkCreateInput>;
  LocationComponent?: InputMaybe<LocationComponentCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
  MetaData?: InputMaybe<MetaDataCreateInput>;
  PageFooter?: InputMaybe<PageFooterCreateInput>;
  PageHeader?: InputMaybe<PageHeaderCreateInput>;
  ProgressBar?: InputMaybe<ProgressBarCreateInput>;
  QuickLink?: InputMaybe<QuickLinkCreateInput>;
  SearchInput?: InputMaybe<SearchInputCreateInput>;
  ShortHero?: InputMaybe<ShortHeroCreateInput>;
  Spacer?: InputMaybe<SpacerCreateInput>;
  Tab?: InputMaybe<TabCreateInput>;
};

export type GenericPagePageComponentsCreateManyInlineInput = {
  /** Connect multiple existing GenericPagePageComponents documents */
  connect?: InputMaybe<Array<GenericPagePageComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing GenericPagePageComponents documents */
  create?: InputMaybe<Array<GenericPagePageComponentsCreateInput>>;
};

export type GenericPagePageComponentsCreateOneInlineInput = {
  /** Connect one existing GenericPagePageComponents document */
  connect?: InputMaybe<GenericPagePageComponentsWhereUniqueInput>;
  /** Create and connect one GenericPagePageComponents document */
  create?: InputMaybe<GenericPagePageComponentsCreateInput>;
};

export type GenericPagePageComponentsUpdateInput = {
  AnchorNavigationList?: InputMaybe<AnchorNavigationListUpdateInput>;
  AudioComponent?: InputMaybe<AudioComponentUpdateInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateInput>;
  Banner2?: InputMaybe<Banner2UpdateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerUpdateInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpdateInput>;
  CorpCalendarEvent?: InputMaybe<CorpCalendarEventUpdateInput>;
  CorpCardCarousel?: InputMaybe<CorpCardCarouselUpdateInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpdateInput>;
  CorpForm?: InputMaybe<CorpFormUpdateInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpdateInput>;
  CorpGenericBanner?: InputMaybe<CorpGenericBannerUpdateInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateInput>;
  CorpHero?: InputMaybe<CorpHeroUpdateInput>;
  CorpMediaDownloadPreview?: InputMaybe<CorpMediaDownloadPreviewUpdateInput>;
  CorpOurPeople?: InputMaybe<CorpOurPeopleUpdateInput>;
  CorpTimelineAccordionWrapper?: InputMaybe<CorpTimelineAccordionWrapperUpdateInput>;
  CorpVideoHero?: InputMaybe<CorpVideoHeroUpdateInput>;
  CorpVideoHeroCarousel?: InputMaybe<CorpVideoHeroCarouselUpdateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateInput>;
  ExampleComponent?: InputMaybe<ExampleComponentUpdateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateInput>;
  Form?: InputMaybe<FormUpdateInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateInput>;
  GenericLine?: InputMaybe<GenericLineUpdateInput>;
  GenericPage?: InputMaybe<GenericPageUpdateInput>;
  HeroBanner?: InputMaybe<HeroBannerUpdateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateInput>;
  HeroComponent?: InputMaybe<HeroComponentUpdateInput>;
  Iframe?: InputMaybe<IframeUpdateInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardUpdateInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateInput>;
  IntroText?: InputMaybe<IntroTextUpdateInput>;
  Link?: InputMaybe<LinkUpdateInput>;
  LocationComponent?: InputMaybe<LocationComponentUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
  MetaData?: InputMaybe<MetaDataUpdateInput>;
  PageFooter?: InputMaybe<PageFooterUpdateInput>;
  PageHeader?: InputMaybe<PageHeaderUpdateInput>;
  ProgressBar?: InputMaybe<ProgressBarUpdateInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateInput>;
  SearchInput?: InputMaybe<SearchInputUpdateInput>;
  ShortHero?: InputMaybe<ShortHeroUpdateInput>;
  Spacer?: InputMaybe<SpacerUpdateInput>;
  Tab?: InputMaybe<TabUpdateInput>;
};

export type GenericPagePageComponentsUpdateManyInlineInput = {
  /** Connect multiple existing GenericPagePageComponents documents */
  connect?: InputMaybe<Array<GenericPagePageComponentsConnectInput>>;
  /** Create and connect multiple GenericPagePageComponents documents */
  create?: InputMaybe<Array<GenericPagePageComponentsCreateInput>>;
  /** Delete multiple GenericPagePageComponents documents */
  delete?: InputMaybe<Array<GenericPagePageComponentsWhereUniqueInput>>;
  /** Disconnect multiple GenericPagePageComponents documents */
  disconnect?: InputMaybe<Array<GenericPagePageComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericPagePageComponents documents */
  set?: InputMaybe<Array<GenericPagePageComponentsWhereUniqueInput>>;
  /** Update multiple GenericPagePageComponents documents */
  update?: InputMaybe<Array<GenericPagePageComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericPagePageComponents documents */
  upsert?: InputMaybe<Array<GenericPagePageComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type GenericPagePageComponentsUpdateManyWithNestedWhereInput = {
  AnchorNavigationList?: InputMaybe<AnchorNavigationListUpdateManyWithNestedWhereInput>;
  AudioComponent?: InputMaybe<AudioComponentUpdateManyWithNestedWhereInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateManyWithNestedWhereInput>;
  Banner2?: InputMaybe<Banner2UpdateManyWithNestedWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateManyWithNestedWhereInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerUpdateManyWithNestedWhereInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpdateManyWithNestedWhereInput>;
  CorpCalendarEvent?: InputMaybe<CorpCalendarEventUpdateManyWithNestedWhereInput>;
  CorpCardCarousel?: InputMaybe<CorpCardCarouselUpdateManyWithNestedWhereInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpdateManyWithNestedWhereInput>;
  CorpForm?: InputMaybe<CorpFormUpdateManyWithNestedWhereInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpdateManyWithNestedWhereInput>;
  CorpGenericBanner?: InputMaybe<CorpGenericBannerUpdateManyWithNestedWhereInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateManyWithNestedWhereInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateManyWithNestedWhereInput>;
  CorpHero?: InputMaybe<CorpHeroUpdateManyWithNestedWhereInput>;
  CorpMediaDownloadPreview?: InputMaybe<CorpMediaDownloadPreviewUpdateManyWithNestedWhereInput>;
  CorpOurPeople?: InputMaybe<CorpOurPeopleUpdateManyWithNestedWhereInput>;
  CorpTimelineAccordionWrapper?: InputMaybe<CorpTimelineAccordionWrapperUpdateManyWithNestedWhereInput>;
  CorpVideoHero?: InputMaybe<CorpVideoHeroUpdateManyWithNestedWhereInput>;
  CorpVideoHeroCarousel?: InputMaybe<CorpVideoHeroCarouselUpdateManyWithNestedWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateManyWithNestedWhereInput>;
  ExampleComponent?: InputMaybe<ExampleComponentUpdateManyWithNestedWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateManyWithNestedWhereInput>;
  Form?: InputMaybe<FormUpdateManyWithNestedWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateManyWithNestedWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateManyWithNestedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateManyWithNestedWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateManyWithNestedWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateManyWithNestedWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateManyWithNestedWhereInput>;
  GenericLine?: InputMaybe<GenericLineUpdateManyWithNestedWhereInput>;
  GenericPage?: InputMaybe<GenericPageUpdateManyWithNestedWhereInput>;
  HeroBanner?: InputMaybe<HeroBannerUpdateManyWithNestedWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateManyWithNestedWhereInput>;
  HeroComponent?: InputMaybe<HeroComponentUpdateManyWithNestedWhereInput>;
  Iframe?: InputMaybe<IframeUpdateManyWithNestedWhereInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardUpdateManyWithNestedWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateManyWithNestedWhereInput>;
  IntroText?: InputMaybe<IntroTextUpdateManyWithNestedWhereInput>;
  Link?: InputMaybe<LinkUpdateManyWithNestedWhereInput>;
  LocationComponent?: InputMaybe<LocationComponentUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
  MetaData?: InputMaybe<MetaDataUpdateManyWithNestedWhereInput>;
  PageFooter?: InputMaybe<PageFooterUpdateManyWithNestedWhereInput>;
  PageHeader?: InputMaybe<PageHeaderUpdateManyWithNestedWhereInput>;
  ProgressBar?: InputMaybe<ProgressBarUpdateManyWithNestedWhereInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateManyWithNestedWhereInput>;
  SearchInput?: InputMaybe<SearchInputUpdateManyWithNestedWhereInput>;
  ShortHero?: InputMaybe<ShortHeroUpdateManyWithNestedWhereInput>;
  Spacer?: InputMaybe<SpacerUpdateManyWithNestedWhereInput>;
  Tab?: InputMaybe<TabUpdateManyWithNestedWhereInput>;
};

export type GenericPagePageComponentsUpdateOneInlineInput = {
  /** Connect existing GenericPagePageComponents document */
  connect?: InputMaybe<GenericPagePageComponentsWhereUniqueInput>;
  /** Create and connect one GenericPagePageComponents document */
  create?: InputMaybe<GenericPagePageComponentsCreateInput>;
  /** Delete currently connected GenericPagePageComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericPagePageComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericPagePageComponents document */
  update?: InputMaybe<GenericPagePageComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericPagePageComponents document */
  upsert?: InputMaybe<GenericPagePageComponentsUpsertWithNestedWhereUniqueInput>;
};

export type GenericPagePageComponentsUpdateWithNestedWhereUniqueInput = {
  AnchorNavigationList?: InputMaybe<AnchorNavigationListUpdateWithNestedWhereUniqueInput>;
  AudioComponent?: InputMaybe<AudioComponentUpdateWithNestedWhereUniqueInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpdateWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateWithNestedWhereUniqueInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerUpdateWithNestedWhereUniqueInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpdateWithNestedWhereUniqueInput>;
  CorpCalendarEvent?: InputMaybe<CorpCalendarEventUpdateWithNestedWhereUniqueInput>;
  CorpCardCarousel?: InputMaybe<CorpCardCarouselUpdateWithNestedWhereUniqueInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpdateWithNestedWhereUniqueInput>;
  CorpForm?: InputMaybe<CorpFormUpdateWithNestedWhereUniqueInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpdateWithNestedWhereUniqueInput>;
  CorpGenericBanner?: InputMaybe<CorpGenericBannerUpdateWithNestedWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateWithNestedWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateWithNestedWhereUniqueInput>;
  CorpHero?: InputMaybe<CorpHeroUpdateWithNestedWhereUniqueInput>;
  CorpMediaDownloadPreview?: InputMaybe<CorpMediaDownloadPreviewUpdateWithNestedWhereUniqueInput>;
  CorpOurPeople?: InputMaybe<CorpOurPeopleUpdateWithNestedWhereUniqueInput>;
  CorpTimelineAccordionWrapper?: InputMaybe<CorpTimelineAccordionWrapperUpdateWithNestedWhereUniqueInput>;
  CorpVideoHero?: InputMaybe<CorpVideoHeroUpdateWithNestedWhereUniqueInput>;
  CorpVideoHeroCarousel?: InputMaybe<CorpVideoHeroCarouselUpdateWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateWithNestedWhereUniqueInput>;
  ExampleComponent?: InputMaybe<ExampleComponentUpdateWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateWithNestedWhereUniqueInput>;
  Form?: InputMaybe<FormUpdateWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpdateWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpdateWithNestedWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineUpdateWithNestedWhereUniqueInput>;
  GenericPage?: InputMaybe<GenericPageUpdateWithNestedWhereUniqueInput>;
  HeroBanner?: InputMaybe<HeroBannerUpdateWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateWithNestedWhereUniqueInput>;
  HeroComponent?: InputMaybe<HeroComponentUpdateWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpdateWithNestedWhereUniqueInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardUpdateWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpdateWithNestedWhereUniqueInput>;
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
  LocationComponent?: InputMaybe<LocationComponentUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  MetaData?: InputMaybe<MetaDataUpdateWithNestedWhereUniqueInput>;
  PageFooter?: InputMaybe<PageFooterUpdateWithNestedWhereUniqueInput>;
  PageHeader?: InputMaybe<PageHeaderUpdateWithNestedWhereUniqueInput>;
  ProgressBar?: InputMaybe<ProgressBarUpdateWithNestedWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateWithNestedWhereUniqueInput>;
  SearchInput?: InputMaybe<SearchInputUpdateWithNestedWhereUniqueInput>;
  ShortHero?: InputMaybe<ShortHeroUpdateWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpdateWithNestedWhereUniqueInput>;
  Tab?: InputMaybe<TabUpdateWithNestedWhereUniqueInput>;
};

export type GenericPagePageComponentsUpsertWithNestedWhereUniqueInput = {
  AnchorNavigationList?: InputMaybe<AnchorNavigationListUpsertWithNestedWhereUniqueInput>;
  AudioComponent?: InputMaybe<AudioComponentUpsertWithNestedWhereUniqueInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpsertWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpsertWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpsertWithNestedWhereUniqueInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerUpsertWithNestedWhereUniqueInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpsertWithNestedWhereUniqueInput>;
  CorpCalendarEvent?: InputMaybe<CorpCalendarEventUpsertWithNestedWhereUniqueInput>;
  CorpCardCarousel?: InputMaybe<CorpCardCarouselUpsertWithNestedWhereUniqueInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpsertWithNestedWhereUniqueInput>;
  CorpForm?: InputMaybe<CorpFormUpsertWithNestedWhereUniqueInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpsertWithNestedWhereUniqueInput>;
  CorpGenericBanner?: InputMaybe<CorpGenericBannerUpsertWithNestedWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpsertWithNestedWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpsertWithNestedWhereUniqueInput>;
  CorpHero?: InputMaybe<CorpHeroUpsertWithNestedWhereUniqueInput>;
  CorpMediaDownloadPreview?: InputMaybe<CorpMediaDownloadPreviewUpsertWithNestedWhereUniqueInput>;
  CorpOurPeople?: InputMaybe<CorpOurPeopleUpsertWithNestedWhereUniqueInput>;
  CorpTimelineAccordionWrapper?: InputMaybe<CorpTimelineAccordionWrapperUpsertWithNestedWhereUniqueInput>;
  CorpVideoHero?: InputMaybe<CorpVideoHeroUpsertWithNestedWhereUniqueInput>;
  CorpVideoHeroCarousel?: InputMaybe<CorpVideoHeroCarouselUpsertWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpsertWithNestedWhereUniqueInput>;
  ExampleComponent?: InputMaybe<ExampleComponentUpsertWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpsertWithNestedWhereUniqueInput>;
  Form?: InputMaybe<FormUpsertWithNestedWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionUpsertWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpsertWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpsertWithNestedWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableUpsertWithNestedWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineUpsertWithNestedWhereUniqueInput>;
  GenericPage?: InputMaybe<GenericPageUpsertWithNestedWhereUniqueInput>;
  HeroBanner?: InputMaybe<HeroBannerUpsertWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpsertWithNestedWhereUniqueInput>;
  HeroComponent?: InputMaybe<HeroComponentUpsertWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpsertWithNestedWhereUniqueInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardUpsertWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpsertWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpsertWithNestedWhereUniqueInput>;
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
  LocationComponent?: InputMaybe<LocationComponentUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
  MetaData?: InputMaybe<MetaDataUpsertWithNestedWhereUniqueInput>;
  PageFooter?: InputMaybe<PageFooterUpsertWithNestedWhereUniqueInput>;
  PageHeader?: InputMaybe<PageHeaderUpsertWithNestedWhereUniqueInput>;
  ProgressBar?: InputMaybe<ProgressBarUpsertWithNestedWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkUpsertWithNestedWhereUniqueInput>;
  SearchInput?: InputMaybe<SearchInputUpsertWithNestedWhereUniqueInput>;
  ShortHero?: InputMaybe<ShortHeroUpsertWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpsertWithNestedWhereUniqueInput>;
  Tab?: InputMaybe<TabUpsertWithNestedWhereUniqueInput>;
};

export type GenericPagePageComponentsWhereInput = {
  AnchorNavigationList?: InputMaybe<AnchorNavigationListWhereInput>;
  AudioComponent?: InputMaybe<AudioComponentWhereInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereInput>;
  Banner2?: InputMaybe<Banner2WhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerWhereInput>;
  CorpBanner1?: InputMaybe<CorpBanner1WhereInput>;
  CorpCalendarEvent?: InputMaybe<CorpCalendarEventWhereInput>;
  CorpCardCarousel?: InputMaybe<CorpCardCarouselWhereInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerWhereInput>;
  CorpForm?: InputMaybe<CorpFormWhereInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionWhereInput>;
  CorpGenericBanner?: InputMaybe<CorpGenericBannerWhereInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerWhereInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentWhereInput>;
  CorpHero?: InputMaybe<CorpHeroWhereInput>;
  CorpMediaDownloadPreview?: InputMaybe<CorpMediaDownloadPreviewWhereInput>;
  CorpOurPeople?: InputMaybe<CorpOurPeopleWhereInput>;
  CorpTimelineAccordionWrapper?: InputMaybe<CorpTimelineAccordionWrapperWhereInput>;
  CorpVideoHero?: InputMaybe<CorpVideoHeroWhereInput>;
  CorpVideoHeroCarousel?: InputMaybe<CorpVideoHeroCarouselWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  ExampleComponent?: InputMaybe<ExampleComponentWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereInput>;
  Form?: InputMaybe<FormWhereInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereInput>;
  GenericLine?: InputMaybe<GenericLineWhereInput>;
  GenericPage?: InputMaybe<GenericPageWhereInput>;
  HeroBanner?: InputMaybe<HeroBannerWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  HeroComponent?: InputMaybe<HeroComponentWhereInput>;
  Iframe?: InputMaybe<IframeWhereInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereInput>;
  IntroText?: InputMaybe<IntroTextWhereInput>;
  Link?: InputMaybe<LinkWhereInput>;
  LocationComponent?: InputMaybe<LocationComponentWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
  MetaData?: InputMaybe<MetaDataWhereInput>;
  PageFooter?: InputMaybe<PageFooterWhereInput>;
  PageHeader?: InputMaybe<PageHeaderWhereInput>;
  ProgressBar?: InputMaybe<ProgressBarWhereInput>;
  QuickLink?: InputMaybe<QuickLinkWhereInput>;
  SearchInput?: InputMaybe<SearchInputWhereInput>;
  ShortHero?: InputMaybe<ShortHeroWhereInput>;
  Spacer?: InputMaybe<SpacerWhereInput>;
  Tab?: InputMaybe<TabWhereInput>;
};

export type GenericPagePageComponentsWhereUniqueInput = {
  AnchorNavigationList?: InputMaybe<AnchorNavigationListWhereUniqueInput>;
  AudioComponent?: InputMaybe<AudioComponentWhereUniqueInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2WhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereUniqueInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerWhereUniqueInput>;
  CorpBanner1?: InputMaybe<CorpBanner1WhereUniqueInput>;
  CorpCalendarEvent?: InputMaybe<CorpCalendarEventWhereUniqueInput>;
  CorpCardCarousel?: InputMaybe<CorpCardCarouselWhereUniqueInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerWhereUniqueInput>;
  CorpForm?: InputMaybe<CorpFormWhereUniqueInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionWhereUniqueInput>;
  CorpGenericBanner?: InputMaybe<CorpGenericBannerWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentWhereUniqueInput>;
  CorpHero?: InputMaybe<CorpHeroWhereUniqueInput>;
  CorpMediaDownloadPreview?: InputMaybe<CorpMediaDownloadPreviewWhereUniqueInput>;
  CorpOurPeople?: InputMaybe<CorpOurPeopleWhereUniqueInput>;
  CorpTimelineAccordionWrapper?: InputMaybe<CorpTimelineAccordionWrapperWhereUniqueInput>;
  CorpVideoHero?: InputMaybe<CorpVideoHeroWhereUniqueInput>;
  CorpVideoHeroCarousel?: InputMaybe<CorpVideoHeroCarouselWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  ExampleComponent?: InputMaybe<ExampleComponentWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereUniqueInput>;
  Form?: InputMaybe<FormWhereUniqueInput>;
  GenericAccordion?: InputMaybe<GenericAccordionWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereUniqueInput>;
  GenericGridAuthorable?: InputMaybe<GenericGridAuthorableWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineWhereUniqueInput>;
  GenericPage?: InputMaybe<GenericPageWhereUniqueInput>;
  HeroBanner?: InputMaybe<HeroBannerWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereUniqueInput>;
  HeroComponent?: InputMaybe<HeroComponentWhereUniqueInput>;
  Iframe?: InputMaybe<IframeWhereUniqueInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextWhereUniqueInput>;
  Link?: InputMaybe<LinkWhereUniqueInput>;
  LocationComponent?: InputMaybe<LocationComponentWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
  MetaData?: InputMaybe<MetaDataWhereUniqueInput>;
  PageFooter?: InputMaybe<PageFooterWhereUniqueInput>;
  PageHeader?: InputMaybe<PageHeaderWhereUniqueInput>;
  ProgressBar?: InputMaybe<ProgressBarWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkWhereUniqueInput>;
  SearchInput?: InputMaybe<SearchInputWhereUniqueInput>;
  ShortHero?: InputMaybe<ShortHeroWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerWhereUniqueInput>;
  Tab?: InputMaybe<TabWhereUniqueInput>;
};

export type GenericPageUpdateInput = {
  alwaysIndex?: InputMaybe<Scalars['Boolean']['input']>;
  anchorNavigationList?: InputMaybe<AnchorNavigationListUpdateOneInlineInput>;
  ckuntpg4l4gcn01z67yt87trx?: InputMaybe<FeaturedContentReferenceUpdateManyInlineInput>;
  ckv0ngnv50vy401xv0n2q3dhq?: InputMaybe<GenericCardCarouseComponentUpdateManyInlineInput>;
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  dictionary?: InputMaybe<DictionaryUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  hideNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  internalLinks?: InputMaybe<LinkUpdateManyInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<GenericPageUpdateLocalizationsInput>;
  markets?: InputMaybe<Array<Markets>>;
  metaData?: InputMaybe<MetaDataUpdateOneInlineInput>;
  pageComponents?: InputMaybe<GenericPagePageComponentsUpdateManyInlineInput>;
  showCookieBanner?: InputMaybe<Scalars['Boolean']['input']>;
  /** slug input for default locale (default) */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GenericPagesTypes>;
};

export type GenericPageUpdateLocalizationDataInput = {
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericPageUpdateLocalizationInput = {
  data: GenericPageUpdateLocalizationDataInput;
  locale: Locale;
};

export type GenericPageUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<GenericPageCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<GenericPageUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<GenericPageUpsertLocalizationInput>>;
};

export type GenericPageUpdateManyInlineInput = {
  /** Connect multiple existing GenericPage documents */
  connect?: InputMaybe<Array<GenericPageConnectInput>>;
  /** Create and connect multiple GenericPage documents */
  create?: InputMaybe<Array<GenericPageCreateInput>>;
  /** Delete multiple GenericPage documents */
  delete?: InputMaybe<Array<GenericPageWhereUniqueInput>>;
  /** Disconnect multiple GenericPage documents */
  disconnect?: InputMaybe<Array<GenericPageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GenericPage documents */
  set?: InputMaybe<Array<GenericPageWhereUniqueInput>>;
  /** Update multiple GenericPage documents */
  update?: InputMaybe<Array<GenericPageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GenericPage documents */
  upsert?: InputMaybe<Array<GenericPageUpsertWithNestedWhereUniqueInput>>;
};

export type GenericPageUpdateManyInput = {
  alwaysIndex?: InputMaybe<Scalars['Boolean']['input']>;
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  hideNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<GenericPageUpdateManyLocalizationsInput>;
  markets?: InputMaybe<Array<Markets>>;
  showCookieBanner?: InputMaybe<Scalars['Boolean']['input']>;
  /** slug input for default locale (default) */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GenericPagesTypes>;
};

export type GenericPageUpdateManyLocalizationDataInput = {
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type GenericPageUpdateManyLocalizationInput = {
  data: GenericPageUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type GenericPageUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<GenericPageUpdateManyLocalizationInput>>;
};

export type GenericPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GenericPageUpdateManyInput;
  /** Document search */
  where: GenericPageWhereInput;
};

export type GenericPageUpdateOneInlineInput = {
  /** Connect existing GenericPage document */
  connect?: InputMaybe<GenericPageWhereUniqueInput>;
  /** Create and connect one GenericPage document */
  create?: InputMaybe<GenericPageCreateInput>;
  /** Delete currently connected GenericPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GenericPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GenericPage document */
  update?: InputMaybe<GenericPageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GenericPage document */
  upsert?: InputMaybe<GenericPageUpsertWithNestedWhereUniqueInput>;
};

export type GenericPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GenericPageUpdateInput;
  /** Unique document search */
  where: GenericPageWhereUniqueInput;
};

export type GenericPageUpsertInput = {
  /** Create document if it didn't exist */
  create: GenericPageCreateInput;
  /** Update document if it exists */
  update: GenericPageUpdateInput;
};

export type GenericPageUpsertLocalizationInput = {
  create: GenericPageCreateLocalizationDataInput;
  locale: Locale;
  update: GenericPageUpdateLocalizationDataInput;
};

export type GenericPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GenericPageUpsertInput;
  /** Unique document search */
  where: GenericPageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GenericPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GenericPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alwaysIndex?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  alwaysIndex_not?: InputMaybe<Scalars['Boolean']['input']>;
  anchorNavigationList?: InputMaybe<AnchorNavigationListWhereInput>;
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValue_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValue_not?: InputMaybe<TrackingContentGrouping>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValue_not_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValues_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValues_not?: InputMaybe<TrackingContentGrouping>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValues_not_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionary?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<GenericPageWhereStageInput>;
  documentInStages_none?: InputMaybe<GenericPageWhereStageInput>;
  documentInStages_some?: InputMaybe<GenericPageWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  hideNavigation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  hideNavigation_not?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  internalLinks_every?: InputMaybe<LinkWhereInput>;
  internalLinks_none?: InputMaybe<LinkWhereInput>;
  internalLinks_some?: InputMaybe<LinkWhereInput>;
  link?: InputMaybe<LinkWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  markets?: InputMaybe<Array<Markets>>;
  /** Matches if the field array contains *all* items provided to the filter */
  markets_contains_all?: InputMaybe<Array<Markets>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  markets_contains_none?: InputMaybe<Array<Markets>>;
  /** Matches if the field array contains at least one item provided to the filter */
  markets_contains_some?: InputMaybe<Array<Markets>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  markets_not?: InputMaybe<Array<Markets>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<GenericPagePageComponentsWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showCookieBanner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showCookieBanner_not?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<GenericPagesTypes>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<GenericPagesTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<GenericPagesTypes>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<GenericPagesTypes>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GenericPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GenericPageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GenericPageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GenericPageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GenericPageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GenericPage record uniquely */
export type GenericPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Used to categorise the pages for Admins and the frontend */
export enum GenericPagesTypes {
  AboutUs = 'AboutUs',
  Career = 'Career',
  Default = 'Default',
  PressPage = 'PressPage',
  Responsibility = 'Responsibility',
  Supplier = 'Supplier'
}

/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaData = Entity & Node & {
  __typename?: 'GlobalMetaData';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Can be overridden on each page. */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<GlobalMetaData>;
  /** An ID of the FB app to share website insight with */
  facebookAppId?: Maybe<Scalars['String']['output']>;
  /** List of GlobalMetaData versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<Asset>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<GlobalMetaData>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  siteName: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /**
   * title template that will be added to the page title
   * e.g. title = page title and titleTemplate = Dr Oetker
   * the page full title will be: Dr Oetker | page title
   */
  titleTemplate: Scalars['String']['output'];
  twitterSeo?: Maybe<TwitterSeo>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  url: Scalars['String']['output'];
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataTwitterSeoArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** General Metadata object to be applied to the site as a fallback incase you dont add a meta description to the page. */
export type GlobalMetaDataUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type GlobalMetaDataConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: GlobalMetaDataWhereUniqueInput;
};

/** A connection to a list of items. */
export type GlobalMetaDataConnection = {
  __typename?: 'GlobalMetaDataConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<GlobalMetaDataEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type GlobalMetaDataCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** facebookAppId input for default locale (default) */
  facebookAppId?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<GlobalMetaDataCreateLocalizationsInput>;
  /** siteName input for default locale (default) */
  siteName: Scalars['String']['input'];
  /** titleTemplate input for default locale (default) */
  titleTemplate: Scalars['String']['input'];
  twitterSeo?: InputMaybe<TwitterSeoCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** url input for default locale (default) */
  url: Scalars['String']['input'];
};

export type GlobalMetaDataCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  facebookAppId?: InputMaybe<Scalars['String']['input']>;
  siteName: Scalars['String']['input'];
  titleTemplate: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type GlobalMetaDataCreateLocalizationInput = {
  /** Localization input */
  data: GlobalMetaDataCreateLocalizationDataInput;
  locale: Locale;
};

export type GlobalMetaDataCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<GlobalMetaDataCreateLocalizationInput>>;
};

export type GlobalMetaDataCreateManyInlineInput = {
  /** Connect multiple existing GlobalMetaData documents */
  connect?: InputMaybe<Array<GlobalMetaDataWhereUniqueInput>>;
  /** Create and connect multiple existing GlobalMetaData documents */
  create?: InputMaybe<Array<GlobalMetaDataCreateInput>>;
};

export type GlobalMetaDataCreateOneInlineInput = {
  /** Connect one existing GlobalMetaData document */
  connect?: InputMaybe<GlobalMetaDataWhereUniqueInput>;
  /** Create and connect one GlobalMetaData document */
  create?: InputMaybe<GlobalMetaDataCreateInput>;
};

/** An edge in a connection. */
export type GlobalMetaDataEdge = {
  __typename?: 'GlobalMetaDataEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GlobalMetaData;
};

/** Identifies documents */
export type GlobalMetaDataManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GlobalMetaDataWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GlobalMetaDataWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GlobalMetaDataWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<GlobalMetaDataWhereStageInput>;
  documentInStages_none?: InputMaybe<GlobalMetaDataWhereStageInput>;
  documentInStages_some?: InputMaybe<GlobalMetaDataWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  twitterSeo?: InputMaybe<TwitterSeoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum GlobalMetaDataOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  facebookAppId_ASC = 'facebookAppId_ASC',
  facebookAppId_DESC = 'facebookAppId_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  siteName_ASC = 'siteName_ASC',
  siteName_DESC = 'siteName_DESC',
  titleTemplate_ASC = 'titleTemplate_ASC',
  titleTemplate_DESC = 'titleTemplate_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC'
}

export type GlobalMetaDataUpdateInput = {
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** facebookAppId input for default locale (default) */
  facebookAppId?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<GlobalMetaDataUpdateLocalizationsInput>;
  /** siteName input for default locale (default) */
  siteName?: InputMaybe<Scalars['String']['input']>;
  /** titleTemplate input for default locale (default) */
  titleTemplate?: InputMaybe<Scalars['String']['input']>;
  twitterSeo?: InputMaybe<TwitterSeoUpdateOneInlineInput>;
  /** url input for default locale (default) */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalMetaDataUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  facebookAppId?: InputMaybe<Scalars['String']['input']>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  titleTemplate?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalMetaDataUpdateLocalizationInput = {
  data: GlobalMetaDataUpdateLocalizationDataInput;
  locale: Locale;
};

export type GlobalMetaDataUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<GlobalMetaDataCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<GlobalMetaDataUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<GlobalMetaDataUpsertLocalizationInput>>;
};

export type GlobalMetaDataUpdateManyInlineInput = {
  /** Connect multiple existing GlobalMetaData documents */
  connect?: InputMaybe<Array<GlobalMetaDataConnectInput>>;
  /** Create and connect multiple GlobalMetaData documents */
  create?: InputMaybe<Array<GlobalMetaDataCreateInput>>;
  /** Delete multiple GlobalMetaData documents */
  delete?: InputMaybe<Array<GlobalMetaDataWhereUniqueInput>>;
  /** Disconnect multiple GlobalMetaData documents */
  disconnect?: InputMaybe<Array<GlobalMetaDataWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing GlobalMetaData documents */
  set?: InputMaybe<Array<GlobalMetaDataWhereUniqueInput>>;
  /** Update multiple GlobalMetaData documents */
  update?: InputMaybe<Array<GlobalMetaDataUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple GlobalMetaData documents */
  upsert?: InputMaybe<Array<GlobalMetaDataUpsertWithNestedWhereUniqueInput>>;
};

export type GlobalMetaDataUpdateManyInput = {
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** facebookAppId input for default locale (default) */
  facebookAppId?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<GlobalMetaDataUpdateManyLocalizationsInput>;
  /** siteName input for default locale (default) */
  siteName?: InputMaybe<Scalars['String']['input']>;
  /** titleTemplate input for default locale (default) */
  titleTemplate?: InputMaybe<Scalars['String']['input']>;
  /** url input for default locale (default) */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalMetaDataUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  facebookAppId?: InputMaybe<Scalars['String']['input']>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  titleTemplate?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalMetaDataUpdateManyLocalizationInput = {
  data: GlobalMetaDataUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type GlobalMetaDataUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<GlobalMetaDataUpdateManyLocalizationInput>>;
};

export type GlobalMetaDataUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: GlobalMetaDataUpdateManyInput;
  /** Document search */
  where: GlobalMetaDataWhereInput;
};

export type GlobalMetaDataUpdateOneInlineInput = {
  /** Connect existing GlobalMetaData document */
  connect?: InputMaybe<GlobalMetaDataWhereUniqueInput>;
  /** Create and connect one GlobalMetaData document */
  create?: InputMaybe<GlobalMetaDataCreateInput>;
  /** Delete currently connected GlobalMetaData document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected GlobalMetaData document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single GlobalMetaData document */
  update?: InputMaybe<GlobalMetaDataUpdateWithNestedWhereUniqueInput>;
  /** Upsert single GlobalMetaData document */
  upsert?: InputMaybe<GlobalMetaDataUpsertWithNestedWhereUniqueInput>;
};

export type GlobalMetaDataUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: GlobalMetaDataUpdateInput;
  /** Unique document search */
  where: GlobalMetaDataWhereUniqueInput;
};

export type GlobalMetaDataUpsertInput = {
  /** Create document if it didn't exist */
  create: GlobalMetaDataCreateInput;
  /** Update document if it exists */
  update: GlobalMetaDataUpdateInput;
};

export type GlobalMetaDataUpsertLocalizationInput = {
  create: GlobalMetaDataCreateLocalizationDataInput;
  locale: Locale;
  update: GlobalMetaDataUpdateLocalizationDataInput;
};

export type GlobalMetaDataUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: GlobalMetaDataUpsertInput;
  /** Unique document search */
  where: GlobalMetaDataWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type GlobalMetaDataWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type GlobalMetaDataWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GlobalMetaDataWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GlobalMetaDataWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GlobalMetaDataWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<GlobalMetaDataWhereStageInput>;
  documentInStages_none?: InputMaybe<GlobalMetaDataWhereStageInput>;
  documentInStages_some?: InputMaybe<GlobalMetaDataWhereStageInput>;
  facebookAppId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  facebookAppId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  facebookAppId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  facebookAppId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  facebookAppId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  facebookAppId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  facebookAppId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  facebookAppId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  facebookAppId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  facebookAppId_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  siteName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  siteName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  siteName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  siteName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  siteName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  siteName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  siteName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  siteName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  siteName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  siteName_starts_with?: InputMaybe<Scalars['String']['input']>;
  titleTemplate?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  titleTemplate_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  titleTemplate_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  titleTemplate_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  titleTemplate_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  titleTemplate_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  titleTemplate_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  titleTemplate_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  titleTemplate_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  titleTemplate_starts_with?: InputMaybe<Scalars['String']['input']>;
  twitterSeo?: InputMaybe<TwitterSeoWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type GlobalMetaDataWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<GlobalMetaDataWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<GlobalMetaDataWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<GlobalMetaDataWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<GlobalMetaDataWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References GlobalMetaData record uniquely */
export type GlobalMetaDataWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBanner = Entity & Node & {
  __typename?: 'HeroBanner';
  alignment?: Maybe<AlignmentTypes>;
  anchorNav?: Maybe<AnchorNavigation>;
  backgroundColour: BannerVideoPlayAndTextColour;
  bannerDescriptionText?: Maybe<Scalars['String']['output']>;
  bannerImage: Array<Asset>;
  bannerSize?: Maybe<BannerHeight>;
  bannerTitle?: Maybe<Scalars['String']['output']>;
  /** Url of video from YouTube */
  bannerVideoUrl?: Maybe<Scalars['String']['output']>;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<HeroBanner>;
  genericPages: Array<GenericPage>;
  heroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** List of HeroBanner versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<HeroBanner>;
  mobileImage?: Maybe<Asset>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  superText?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerBannerImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerHeroCarouselComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerMobileImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Hero Banners are chosen to be displayed in the Hero Carousel Component */
export type HeroBannerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HeroBannerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HeroBannerWhereUniqueInput;
};

/** A connection to a list of items. */
export type HeroBannerConnection = {
  __typename?: 'HeroBannerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HeroBannerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HeroBannerCreateInput = {
  alignment?: InputMaybe<AlignmentTypes>;
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  backgroundColour: BannerVideoPlayAndTextColour;
  /** bannerDescriptionText input for default locale (default) */
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<AssetCreateManyInlineInput>;
  bannerSize?: InputMaybe<BannerHeight>;
  /** bannerTitle input for default locale (default) */
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  bannerVideoUrl?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateOneInlineInput>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HeroBannerCreateLocalizationsInput>;
  mobileImage?: InputMaybe<AssetCreateOneInlineInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HeroBannerCreateLocalizationDataInput = {
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HeroBannerCreateLocalizationInput = {
  /** Localization input */
  data: HeroBannerCreateLocalizationDataInput;
  locale: Locale;
};

export type HeroBannerCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HeroBannerCreateLocalizationInput>>;
};

export type HeroBannerCreateManyInlineInput = {
  /** Connect multiple existing HeroBanner documents */
  connect?: InputMaybe<Array<HeroBannerWhereUniqueInput>>;
  /** Create and connect multiple existing HeroBanner documents */
  create?: InputMaybe<Array<HeroBannerCreateInput>>;
};

export type HeroBannerCreateOneInlineInput = {
  /** Connect one existing HeroBanner document */
  connect?: InputMaybe<HeroBannerWhereUniqueInput>;
  /** Create and connect one HeroBanner document */
  create?: InputMaybe<HeroBannerCreateInput>;
};

/** An edge in a connection. */
export type HeroBannerEdge = {
  __typename?: 'HeroBannerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HeroBanner;
};

/** Identifies documents */
export type HeroBannerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<AlignmentTypes>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<AlignmentTypes>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundColour?: InputMaybe<BannerVideoPlayAndTextColour>;
  /** All values that are contained in given list. */
  backgroundColour_in?: InputMaybe<Array<InputMaybe<BannerVideoPlayAndTextColour>>>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundColour_not?: InputMaybe<BannerVideoPlayAndTextColour>;
  /** All values that are not contained in given list. */
  backgroundColour_not_in?: InputMaybe<Array<InputMaybe<BannerVideoPlayAndTextColour>>>;
  bannerImage_every?: InputMaybe<AssetWhereInput>;
  bannerImage_none?: InputMaybe<AssetWhereInput>;
  bannerImage_some?: InputMaybe<AssetWhereInput>;
  bannerSize?: InputMaybe<BannerHeight>;
  /** All values that are contained in given list. */
  bannerSize_in?: InputMaybe<Array<InputMaybe<BannerHeight>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerSize_not?: InputMaybe<BannerHeight>;
  /** All values that are not contained in given list. */
  bannerSize_not_in?: InputMaybe<Array<InputMaybe<BannerHeight>>>;
  bannerVideoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerVideoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerVideoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerVideoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerVideoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerVideoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerVideoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerVideoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerVideoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerVideoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HeroBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<HeroBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<HeroBannerWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum HeroBannerOrderByInput {
  alignment_ASC = 'alignment_ASC',
  alignment_DESC = 'alignment_DESC',
  backgroundColour_ASC = 'backgroundColour_ASC',
  backgroundColour_DESC = 'backgroundColour_DESC',
  bannerDescriptionText_ASC = 'bannerDescriptionText_ASC',
  bannerDescriptionText_DESC = 'bannerDescriptionText_DESC',
  bannerSize_ASC = 'bannerSize_ASC',
  bannerSize_DESC = 'bannerSize_DESC',
  bannerTitle_ASC = 'bannerTitle_ASC',
  bannerTitle_DESC = 'bannerTitle_DESC',
  bannerVideoUrl_ASC = 'bannerVideoUrl_ASC',
  bannerVideoUrl_DESC = 'bannerVideoUrl_DESC',
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type HeroBannerUpdateInput = {
  alignment?: InputMaybe<AlignmentTypes>;
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  backgroundColour?: InputMaybe<BannerVideoPlayAndTextColour>;
  /** bannerDescriptionText input for default locale (default) */
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  bannerImage?: InputMaybe<AssetUpdateManyInlineInput>;
  bannerSize?: InputMaybe<BannerHeight>;
  /** bannerTitle input for default locale (default) */
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  bannerVideoUrl?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateOneInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<HeroBannerUpdateLocalizationsInput>;
  mobileImage?: InputMaybe<AssetUpdateOneInlineInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
};

export type HeroBannerUpdateLocalizationDataInput = {
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
};

export type HeroBannerUpdateLocalizationInput = {
  data: HeroBannerUpdateLocalizationDataInput;
  locale: Locale;
};

export type HeroBannerUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HeroBannerCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<HeroBannerUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<HeroBannerUpsertLocalizationInput>>;
};

export type HeroBannerUpdateManyInlineInput = {
  /** Connect multiple existing HeroBanner documents */
  connect?: InputMaybe<Array<HeroBannerConnectInput>>;
  /** Create and connect multiple HeroBanner documents */
  create?: InputMaybe<Array<HeroBannerCreateInput>>;
  /** Delete multiple HeroBanner documents */
  delete?: InputMaybe<Array<HeroBannerWhereUniqueInput>>;
  /** Disconnect multiple HeroBanner documents */
  disconnect?: InputMaybe<Array<HeroBannerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HeroBanner documents */
  set?: InputMaybe<Array<HeroBannerWhereUniqueInput>>;
  /** Update multiple HeroBanner documents */
  update?: InputMaybe<Array<HeroBannerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HeroBanner documents */
  upsert?: InputMaybe<Array<HeroBannerUpsertWithNestedWhereUniqueInput>>;
};

export type HeroBannerUpdateManyInput = {
  alignment?: InputMaybe<AlignmentTypes>;
  backgroundColour?: InputMaybe<BannerVideoPlayAndTextColour>;
  /** bannerDescriptionText input for default locale (default) */
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  bannerSize?: InputMaybe<BannerHeight>;
  /** bannerTitle input for default locale (default) */
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  bannerVideoUrl?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<HeroBannerUpdateManyLocalizationsInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
};

export type HeroBannerUpdateManyLocalizationDataInput = {
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
};

export type HeroBannerUpdateManyLocalizationInput = {
  data: HeroBannerUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type HeroBannerUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HeroBannerUpdateManyLocalizationInput>>;
};

export type HeroBannerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeroBannerUpdateManyInput;
  /** Document search */
  where: HeroBannerWhereInput;
};

export type HeroBannerUpdateOneInlineInput = {
  /** Connect existing HeroBanner document */
  connect?: InputMaybe<HeroBannerWhereUniqueInput>;
  /** Create and connect one HeroBanner document */
  create?: InputMaybe<HeroBannerCreateInput>;
  /** Delete currently connected HeroBanner document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HeroBanner document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HeroBanner document */
  update?: InputMaybe<HeroBannerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HeroBanner document */
  upsert?: InputMaybe<HeroBannerUpsertWithNestedWhereUniqueInput>;
};

export type HeroBannerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeroBannerUpdateInput;
  /** Unique document search */
  where: HeroBannerWhereUniqueInput;
};

export type HeroBannerUpsertInput = {
  /** Create document if it didn't exist */
  create: HeroBannerCreateInput;
  /** Update document if it exists */
  update: HeroBannerUpdateInput;
};

export type HeroBannerUpsertLocalizationInput = {
  create: HeroBannerCreateLocalizationDataInput;
  locale: Locale;
  update: HeroBannerUpdateLocalizationDataInput;
};

export type HeroBannerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeroBannerUpsertInput;
  /** Unique document search */
  where: HeroBannerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type HeroBannerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type HeroBannerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<AlignmentTypes>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<AlignmentTypes>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  backgroundColour?: InputMaybe<BannerVideoPlayAndTextColour>;
  /** All values that are contained in given list. */
  backgroundColour_in?: InputMaybe<Array<InputMaybe<BannerVideoPlayAndTextColour>>>;
  /** Any other value that exists and is not equal to the given value. */
  backgroundColour_not?: InputMaybe<BannerVideoPlayAndTextColour>;
  /** All values that are not contained in given list. */
  backgroundColour_not_in?: InputMaybe<Array<InputMaybe<BannerVideoPlayAndTextColour>>>;
  bannerDescriptionText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerDescriptionText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerDescriptionText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerDescriptionText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerDescriptionText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerDescriptionText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerDescriptionText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerDescriptionText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerDescriptionText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerDescriptionText_starts_with?: InputMaybe<Scalars['String']['input']>;
  bannerImage_every?: InputMaybe<AssetWhereInput>;
  bannerImage_none?: InputMaybe<AssetWhereInput>;
  bannerImage_some?: InputMaybe<AssetWhereInput>;
  bannerSize?: InputMaybe<BannerHeight>;
  /** All values that are contained in given list. */
  bannerSize_in?: InputMaybe<Array<InputMaybe<BannerHeight>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerSize_not?: InputMaybe<BannerHeight>;
  /** All values that are not contained in given list. */
  bannerSize_not_in?: InputMaybe<Array<InputMaybe<BannerHeight>>>;
  bannerTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  bannerVideoUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  bannerVideoUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  bannerVideoUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  bannerVideoUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerVideoUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  bannerVideoUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  bannerVideoUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  bannerVideoUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  bannerVideoUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  bannerVideoUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HeroBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<HeroBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<HeroBannerWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  heroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HeroBannerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroBannerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroBannerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroBannerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HeroBannerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References HeroBanner record uniquely */
export type HeroBannerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Carousel component for page hero's */
export type HeroCarouselComponent = Entity & Node & {
  __typename?: 'HeroCarouselComponent';
  anchorNav?: Maybe<AnchorNavigation>;
  banners: Array<HeroBanner>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<HeroCarouselComponent>;
  genericPages: Array<GenericPage>;
  /** List of HeroCarouselComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  tabContent?: Maybe<TabContent>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentBannersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<HeroBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroBannerWhereInput>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Carousel component for page hero's */
export type HeroCarouselComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HeroCarouselComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HeroCarouselComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type HeroCarouselComponentConnection = {
  __typename?: 'HeroCarouselComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HeroCarouselComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HeroCarouselComponentCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  banners?: InputMaybe<HeroBannerCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HeroCarouselComponentCreateManyInlineInput = {
  /** Connect multiple existing HeroCarouselComponent documents */
  connect?: InputMaybe<Array<HeroCarouselComponentWhereUniqueInput>>;
  /** Create and connect multiple existing HeroCarouselComponent documents */
  create?: InputMaybe<Array<HeroCarouselComponentCreateInput>>;
};

export type HeroCarouselComponentCreateOneInlineInput = {
  /** Connect one existing HeroCarouselComponent document */
  connect?: InputMaybe<HeroCarouselComponentWhereUniqueInput>;
  /** Create and connect one HeroCarouselComponent document */
  create?: InputMaybe<HeroCarouselComponentCreateInput>;
};

/** An edge in a connection. */
export type HeroCarouselComponentEdge = {
  __typename?: 'HeroCarouselComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HeroCarouselComponent;
};

/** Identifies documents */
export type HeroCarouselComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroCarouselComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroCarouselComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroCarouselComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  banners_every?: InputMaybe<HeroBannerWhereInput>;
  banners_none?: InputMaybe<HeroBannerWhereInput>;
  banners_some?: InputMaybe<HeroBannerWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HeroCarouselComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<HeroCarouselComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<HeroCarouselComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum HeroCarouselComponentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type HeroCarouselComponentUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  banners?: InputMaybe<HeroBannerUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HeroCarouselComponentUpdateManyInlineInput = {
  /** Connect multiple existing HeroCarouselComponent documents */
  connect?: InputMaybe<Array<HeroCarouselComponentConnectInput>>;
  /** Create and connect multiple HeroCarouselComponent documents */
  create?: InputMaybe<Array<HeroCarouselComponentCreateInput>>;
  /** Delete multiple HeroCarouselComponent documents */
  delete?: InputMaybe<Array<HeroCarouselComponentWhereUniqueInput>>;
  /** Disconnect multiple HeroCarouselComponent documents */
  disconnect?: InputMaybe<Array<HeroCarouselComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HeroCarouselComponent documents */
  set?: InputMaybe<Array<HeroCarouselComponentWhereUniqueInput>>;
  /** Update multiple HeroCarouselComponent documents */
  update?: InputMaybe<Array<HeroCarouselComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HeroCarouselComponent documents */
  upsert?: InputMaybe<Array<HeroCarouselComponentUpsertWithNestedWhereUniqueInput>>;
};

export type HeroCarouselComponentUpdateManyInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HeroCarouselComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeroCarouselComponentUpdateManyInput;
  /** Document search */
  where: HeroCarouselComponentWhereInput;
};

export type HeroCarouselComponentUpdateOneInlineInput = {
  /** Connect existing HeroCarouselComponent document */
  connect?: InputMaybe<HeroCarouselComponentWhereUniqueInput>;
  /** Create and connect one HeroCarouselComponent document */
  create?: InputMaybe<HeroCarouselComponentCreateInput>;
  /** Delete currently connected HeroCarouselComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HeroCarouselComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HeroCarouselComponent document */
  update?: InputMaybe<HeroCarouselComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HeroCarouselComponent document */
  upsert?: InputMaybe<HeroCarouselComponentUpsertWithNestedWhereUniqueInput>;
};

export type HeroCarouselComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeroCarouselComponentUpdateInput;
  /** Unique document search */
  where: HeroCarouselComponentWhereUniqueInput;
};

export type HeroCarouselComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: HeroCarouselComponentCreateInput;
  /** Update document if it exists */
  update: HeroCarouselComponentUpdateInput;
};

export type HeroCarouselComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeroCarouselComponentUpsertInput;
  /** Unique document search */
  where: HeroCarouselComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type HeroCarouselComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type HeroCarouselComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroCarouselComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroCarouselComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroCarouselComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  banners_every?: InputMaybe<HeroBannerWhereInput>;
  banners_none?: InputMaybe<HeroBannerWhereInput>;
  banners_some?: InputMaybe<HeroBannerWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HeroCarouselComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<HeroCarouselComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<HeroCarouselComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HeroCarouselComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroCarouselComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroCarouselComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroCarouselComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HeroCarouselComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References HeroCarouselComponent record uniquely */
export type HeroCarouselComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Page header (can be a picture and in some pages even a video). */
export type HeroComponent = Entity & Node & {
  __typename?: 'HeroComponent';
  /** set alignment for content - left / right / center */
  alignment?: Maybe<AlignmentTypes>;
  anchorNav?: Maybe<AnchorNavigation>;
  bottomLeftImageAsset?: Maybe<Asset>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /**
   * description text to be used by the hero component
   *
   *
   *
   *
   *
   *
   *
   */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<HeroComponent>;
  genericPages: Array<GenericPage>;
  /** List of HeroComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  imageComponent?: Maybe<AssetComponent>;
  /** System Locale field */
  locale: Locale;
  localeHomePageHeroComponents?: Maybe<HomePage>;
  /** Get the other localizations for this document */
  localizations: Array<HeroComponent>;
  /** add image to display for mobile/smaller screens */
  mobileImage?: Maybe<Asset>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  superText?: Maybe<Scalars['String']['output']>;
  /** Title to be used by the hero component */
  title?: Maybe<Scalars['String']['output']>;
  topRightImageAsset?: Maybe<Asset>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentBottomLeftImageAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentImageComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentLocaleHomePageHeroComponentsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentMobileImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentTopRightImageAssetArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Page header (can be a picture and in some pages even a video). */
export type HeroComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HeroComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HeroComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type HeroComponentConnection = {
  __typename?: 'HeroComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HeroComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HeroComponentCreateInput = {
  alignment?: InputMaybe<AlignmentTypes>;
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  bottomLeftImageAsset?: InputMaybe<AssetCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  imageComponent?: InputMaybe<AssetComponentCreateOneInlineInput>;
  localeHomePageHeroComponents?: InputMaybe<HomePageCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<HeroComponentCreateLocalizationsInput>;
  mobileImage?: InputMaybe<AssetCreateOneInlineInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  topRightImageAsset?: InputMaybe<AssetCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HeroComponentCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HeroComponentCreateLocalizationInput = {
  /** Localization input */
  data: HeroComponentCreateLocalizationDataInput;
  locale: Locale;
};

export type HeroComponentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<HeroComponentCreateLocalizationInput>>;
};

export type HeroComponentCreateManyInlineInput = {
  /** Connect multiple existing HeroComponent documents */
  connect?: InputMaybe<Array<HeroComponentWhereUniqueInput>>;
  /** Create and connect multiple existing HeroComponent documents */
  create?: InputMaybe<Array<HeroComponentCreateInput>>;
};

export type HeroComponentCreateOneInlineInput = {
  /** Connect one existing HeroComponent document */
  connect?: InputMaybe<HeroComponentWhereUniqueInput>;
  /** Create and connect one HeroComponent document */
  create?: InputMaybe<HeroComponentCreateInput>;
};

/** An edge in a connection. */
export type HeroComponentEdge = {
  __typename?: 'HeroComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HeroComponent;
};

/** Identifies documents */
export type HeroComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<AlignmentTypes>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<AlignmentTypes>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  bottomLeftImageAsset?: InputMaybe<AssetWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HeroComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<HeroComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<HeroComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageComponent?: InputMaybe<AssetComponentWhereInput>;
  localeHomePageHeroComponents?: InputMaybe<HomePageWhereInput>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  topRightImageAsset?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum HeroComponentOrderByInput {
  alignment_ASC = 'alignment_ASC',
  alignment_DESC = 'alignment_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type HeroComponentUpdateInput = {
  alignment?: InputMaybe<AlignmentTypes>;
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  bottomLeftImageAsset?: InputMaybe<AssetUpdateOneInlineInput>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  imageComponent?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  localeHomePageHeroComponents?: InputMaybe<HomePageUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<HeroComponentUpdateLocalizationsInput>;
  mobileImage?: InputMaybe<AssetUpdateOneInlineInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  topRightImageAsset?: InputMaybe<AssetUpdateOneInlineInput>;
};

export type HeroComponentUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HeroComponentUpdateLocalizationInput = {
  data: HeroComponentUpdateLocalizationDataInput;
  locale: Locale;
};

export type HeroComponentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<HeroComponentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<HeroComponentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<HeroComponentUpsertLocalizationInput>>;
};

export type HeroComponentUpdateManyInlineInput = {
  /** Connect multiple existing HeroComponent documents */
  connect?: InputMaybe<Array<HeroComponentConnectInput>>;
  /** Create and connect multiple HeroComponent documents */
  create?: InputMaybe<Array<HeroComponentCreateInput>>;
  /** Delete multiple HeroComponent documents */
  delete?: InputMaybe<Array<HeroComponentWhereUniqueInput>>;
  /** Disconnect multiple HeroComponent documents */
  disconnect?: InputMaybe<Array<HeroComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HeroComponent documents */
  set?: InputMaybe<Array<HeroComponentWhereUniqueInput>>;
  /** Update multiple HeroComponent documents */
  update?: InputMaybe<Array<HeroComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HeroComponent documents */
  upsert?: InputMaybe<Array<HeroComponentUpsertWithNestedWhereUniqueInput>>;
};

export type HeroComponentUpdateManyInput = {
  alignment?: InputMaybe<AlignmentTypes>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<HeroComponentUpdateManyLocalizationsInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HeroComponentUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type HeroComponentUpdateManyLocalizationInput = {
  data: HeroComponentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type HeroComponentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<HeroComponentUpdateManyLocalizationInput>>;
};

export type HeroComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HeroComponentUpdateManyInput;
  /** Document search */
  where: HeroComponentWhereInput;
};

export type HeroComponentUpdateOneInlineInput = {
  /** Connect existing HeroComponent document */
  connect?: InputMaybe<HeroComponentWhereUniqueInput>;
  /** Create and connect one HeroComponent document */
  create?: InputMaybe<HeroComponentCreateInput>;
  /** Delete currently connected HeroComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HeroComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HeroComponent document */
  update?: InputMaybe<HeroComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HeroComponent document */
  upsert?: InputMaybe<HeroComponentUpsertWithNestedWhereUniqueInput>;
};

export type HeroComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HeroComponentUpdateInput;
  /** Unique document search */
  where: HeroComponentWhereUniqueInput;
};

export type HeroComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: HeroComponentCreateInput;
  /** Update document if it exists */
  update: HeroComponentUpdateInput;
};

export type HeroComponentUpsertLocalizationInput = {
  create: HeroComponentCreateLocalizationDataInput;
  locale: Locale;
  update: HeroComponentUpdateLocalizationDataInput;
};

export type HeroComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HeroComponentUpsertInput;
  /** Unique document search */
  where: HeroComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type HeroComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type HeroComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<AlignmentTypes>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<AlignmentTypes>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<AlignmentTypes>>>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  bottomLeftImageAsset?: InputMaybe<AssetWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<HeroComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<HeroComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<HeroComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageComponent?: InputMaybe<AssetComponentWhereInput>;
  localeHomePageHeroComponents?: InputMaybe<HomePageWhereInput>;
  mobileImage?: InputMaybe<AssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  topRightImageAsset?: InputMaybe<AssetWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HeroComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HeroComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HeroComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HeroComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HeroComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References HeroComponent record uniquely */
export type HeroComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Home page template to be used for each market
 *
 */
export type HomePage = Entity & Node & {
  __typename?: 'HomePage';
  /** This title is not displayed on the website; it is only used to identify this item within CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<HomePage>;
  /** Components mandatory for any locale on the homepage */
  globalHeroComponents?: Maybe<HomePageGlobalHeroComponents>;
  /** List of HomePage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  locallHeroComponents?: Maybe<HomePageLocallHeroComponents>;
  metaData?: Maybe<MetaData>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/**
 * Home page template to be used for each market
 *
 */
export type HomePageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/**
 * Home page template to be used for each market
 *
 */
export type HomePageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/**
 * Home page template to be used for each market
 *
 */
export type HomePageGlobalHeroComponentsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/**
 * Home page template to be used for each market
 *
 */
export type HomePageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/**
 * Home page template to be used for each market
 *
 */
export type HomePageLocallHeroComponentsArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/**
 * Home page template to be used for each market
 *
 */
export type HomePageMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/**
 * Home page template to be used for each market
 *
 */
export type HomePagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/**
 * Home page template to be used for each market
 *
 */
export type HomePageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/**
 * Home page template to be used for each market
 *
 */
export type HomePageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type HomePageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: HomePageWhereUniqueInput;
};

/** A connection to a list of items. */
export type HomePageConnection = {
  __typename?: 'HomePageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<HomePageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type HomePageCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  globalHeroComponents?: InputMaybe<HomePageGlobalHeroComponentsCreateOneInlineInput>;
  locallHeroComponents?: InputMaybe<HomePageLocallHeroComponentsCreateOneInlineInput>;
  metaData?: InputMaybe<MetaDataCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type HomePageCreateManyInlineInput = {
  /** Connect multiple existing HomePage documents */
  connect?: InputMaybe<Array<HomePageWhereUniqueInput>>;
  /** Create and connect multiple existing HomePage documents */
  create?: InputMaybe<Array<HomePageCreateInput>>;
};

export type HomePageCreateOneInlineInput = {
  /** Connect one existing HomePage document */
  connect?: InputMaybe<HomePageWhereUniqueInput>;
  /** Create and connect one HomePage document */
  create?: InputMaybe<HomePageCreateInput>;
};

/** An edge in a connection. */
export type HomePageEdge = {
  __typename?: 'HomePageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HomePage;
};

export type HomePageGlobalHeroComponents = AssetComponent;

export type HomePageGlobalHeroComponentsConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type HomePageGlobalHeroComponentsCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type HomePageGlobalHeroComponentsCreateManyInlineInput = {
  /** Connect multiple existing HomePageGlobalHeroComponents documents */
  connect?: InputMaybe<Array<HomePageGlobalHeroComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing HomePageGlobalHeroComponents documents */
  create?: InputMaybe<Array<HomePageGlobalHeroComponentsCreateInput>>;
};

export type HomePageGlobalHeroComponentsCreateOneInlineInput = {
  /** Connect one existing HomePageGlobalHeroComponents document */
  connect?: InputMaybe<HomePageGlobalHeroComponentsWhereUniqueInput>;
  /** Create and connect one HomePageGlobalHeroComponents document */
  create?: InputMaybe<HomePageGlobalHeroComponentsCreateInput>;
};

export type HomePageGlobalHeroComponentsUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type HomePageGlobalHeroComponentsUpdateManyInlineInput = {
  /** Connect multiple existing HomePageGlobalHeroComponents documents */
  connect?: InputMaybe<Array<HomePageGlobalHeroComponentsConnectInput>>;
  /** Create and connect multiple HomePageGlobalHeroComponents documents */
  create?: InputMaybe<Array<HomePageGlobalHeroComponentsCreateInput>>;
  /** Delete multiple HomePageGlobalHeroComponents documents */
  delete?: InputMaybe<Array<HomePageGlobalHeroComponentsWhereUniqueInput>>;
  /** Disconnect multiple HomePageGlobalHeroComponents documents */
  disconnect?: InputMaybe<Array<HomePageGlobalHeroComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HomePageGlobalHeroComponents documents */
  set?: InputMaybe<Array<HomePageGlobalHeroComponentsWhereUniqueInput>>;
  /** Update multiple HomePageGlobalHeroComponents documents */
  update?: InputMaybe<Array<HomePageGlobalHeroComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HomePageGlobalHeroComponents documents */
  upsert?: InputMaybe<Array<HomePageGlobalHeroComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type HomePageGlobalHeroComponentsUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type HomePageGlobalHeroComponentsUpdateOneInlineInput = {
  /** Connect existing HomePageGlobalHeroComponents document */
  connect?: InputMaybe<HomePageGlobalHeroComponentsWhereUniqueInput>;
  /** Create and connect one HomePageGlobalHeroComponents document */
  create?: InputMaybe<HomePageGlobalHeroComponentsCreateInput>;
  /** Delete currently connected HomePageGlobalHeroComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HomePageGlobalHeroComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HomePageGlobalHeroComponents document */
  update?: InputMaybe<HomePageGlobalHeroComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HomePageGlobalHeroComponents document */
  upsert?: InputMaybe<HomePageGlobalHeroComponentsUpsertWithNestedWhereUniqueInput>;
};

export type HomePageGlobalHeroComponentsUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type HomePageGlobalHeroComponentsUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type HomePageGlobalHeroComponentsWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type HomePageGlobalHeroComponentsWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

export type HomePageLocallHeroComponents = HeroComponent;

export type HomePageLocallHeroComponentsConnectInput = {
  HeroComponent?: InputMaybe<HeroComponentConnectInput>;
};

export type HomePageLocallHeroComponentsCreateInput = {
  HeroComponent?: InputMaybe<HeroComponentCreateInput>;
};

export type HomePageLocallHeroComponentsCreateManyInlineInput = {
  /** Connect multiple existing HomePageLocallHeroComponents documents */
  connect?: InputMaybe<Array<HomePageLocallHeroComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing HomePageLocallHeroComponents documents */
  create?: InputMaybe<Array<HomePageLocallHeroComponentsCreateInput>>;
};

export type HomePageLocallHeroComponentsCreateOneInlineInput = {
  /** Connect one existing HomePageLocallHeroComponents document */
  connect?: InputMaybe<HomePageLocallHeroComponentsWhereUniqueInput>;
  /** Create and connect one HomePageLocallHeroComponents document */
  create?: InputMaybe<HomePageLocallHeroComponentsCreateInput>;
};

export type HomePageLocallHeroComponentsUpdateInput = {
  HeroComponent?: InputMaybe<HeroComponentUpdateInput>;
};

export type HomePageLocallHeroComponentsUpdateManyInlineInput = {
  /** Connect multiple existing HomePageLocallHeroComponents documents */
  connect?: InputMaybe<Array<HomePageLocallHeroComponentsConnectInput>>;
  /** Create and connect multiple HomePageLocallHeroComponents documents */
  create?: InputMaybe<Array<HomePageLocallHeroComponentsCreateInput>>;
  /** Delete multiple HomePageLocallHeroComponents documents */
  delete?: InputMaybe<Array<HomePageLocallHeroComponentsWhereUniqueInput>>;
  /** Disconnect multiple HomePageLocallHeroComponents documents */
  disconnect?: InputMaybe<Array<HomePageLocallHeroComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HomePageLocallHeroComponents documents */
  set?: InputMaybe<Array<HomePageLocallHeroComponentsWhereUniqueInput>>;
  /** Update multiple HomePageLocallHeroComponents documents */
  update?: InputMaybe<Array<HomePageLocallHeroComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HomePageLocallHeroComponents documents */
  upsert?: InputMaybe<Array<HomePageLocallHeroComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type HomePageLocallHeroComponentsUpdateManyWithNestedWhereInput = {
  HeroComponent?: InputMaybe<HeroComponentUpdateManyWithNestedWhereInput>;
};

export type HomePageLocallHeroComponentsUpdateOneInlineInput = {
  /** Connect existing HomePageLocallHeroComponents document */
  connect?: InputMaybe<HomePageLocallHeroComponentsWhereUniqueInput>;
  /** Create and connect one HomePageLocallHeroComponents document */
  create?: InputMaybe<HomePageLocallHeroComponentsCreateInput>;
  /** Delete currently connected HomePageLocallHeroComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HomePageLocallHeroComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HomePageLocallHeroComponents document */
  update?: InputMaybe<HomePageLocallHeroComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HomePageLocallHeroComponents document */
  upsert?: InputMaybe<HomePageLocallHeroComponentsUpsertWithNestedWhereUniqueInput>;
};

export type HomePageLocallHeroComponentsUpdateWithNestedWhereUniqueInput = {
  HeroComponent?: InputMaybe<HeroComponentUpdateWithNestedWhereUniqueInput>;
};

export type HomePageLocallHeroComponentsUpsertWithNestedWhereUniqueInput = {
  HeroComponent?: InputMaybe<HeroComponentUpsertWithNestedWhereUniqueInput>;
};

export type HomePageLocallHeroComponentsWhereInput = {
  HeroComponent?: InputMaybe<HeroComponentWhereInput>;
};

export type HomePageLocallHeroComponentsWhereUniqueInput = {
  HeroComponent?: InputMaybe<HeroComponentWhereUniqueInput>;
};

/** Identifies documents */
export type HomePageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HomePageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HomePageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HomePageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HomePageWhereStageInput>;
  documentInStages_none?: InputMaybe<HomePageWhereStageInput>;
  documentInStages_some?: InputMaybe<HomePageWhereStageInput>;
  /** All values in which the union is connected to the given models */
  globalHeroComponents?: InputMaybe<HomePageGlobalHeroComponentsWhereInput>;
  /** All values in which the union is empty */
  globalHeroComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is connected to the given models */
  locallHeroComponents?: InputMaybe<HomePageLocallHeroComponentsWhereInput>;
  /** All values in which the union is empty */
  locallHeroComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum HomePageOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type HomePageUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  globalHeroComponents?: InputMaybe<HomePageGlobalHeroComponentsUpdateOneInlineInput>;
  locallHeroComponents?: InputMaybe<HomePageLocallHeroComponentsUpdateOneInlineInput>;
  metaData?: InputMaybe<MetaDataUpdateOneInlineInput>;
};

export type HomePageUpdateManyInlineInput = {
  /** Connect multiple existing HomePage documents */
  connect?: InputMaybe<Array<HomePageConnectInput>>;
  /** Create and connect multiple HomePage documents */
  create?: InputMaybe<Array<HomePageCreateInput>>;
  /** Delete multiple HomePage documents */
  delete?: InputMaybe<Array<HomePageWhereUniqueInput>>;
  /** Disconnect multiple HomePage documents */
  disconnect?: InputMaybe<Array<HomePageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing HomePage documents */
  set?: InputMaybe<Array<HomePageWhereUniqueInput>>;
  /** Update multiple HomePage documents */
  update?: InputMaybe<Array<HomePageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple HomePage documents */
  upsert?: InputMaybe<Array<HomePageUpsertWithNestedWhereUniqueInput>>;
};

export type HomePageUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
};

export type HomePageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: HomePageUpdateManyInput;
  /** Document search */
  where: HomePageWhereInput;
};

export type HomePageUpdateOneInlineInput = {
  /** Connect existing HomePage document */
  connect?: InputMaybe<HomePageWhereUniqueInput>;
  /** Create and connect one HomePage document */
  create?: InputMaybe<HomePageCreateInput>;
  /** Delete currently connected HomePage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected HomePage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single HomePage document */
  update?: InputMaybe<HomePageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single HomePage document */
  upsert?: InputMaybe<HomePageUpsertWithNestedWhereUniqueInput>;
};

export type HomePageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: HomePageUpdateInput;
  /** Unique document search */
  where: HomePageWhereUniqueInput;
};

export type HomePageUpsertInput = {
  /** Create document if it didn't exist */
  create: HomePageCreateInput;
  /** Update document if it exists */
  update: HomePageUpdateInput;
};

export type HomePageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: HomePageUpsertInput;
  /** Unique document search */
  where: HomePageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type HomePageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type HomePageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HomePageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HomePageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HomePageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<HomePageWhereStageInput>;
  documentInStages_none?: InputMaybe<HomePageWhereStageInput>;
  documentInStages_some?: InputMaybe<HomePageWhereStageInput>;
  /** All values in which the union is connected to the given models */
  globalHeroComponents?: InputMaybe<HomePageGlobalHeroComponentsWhereInput>;
  /** All values in which the union is empty */
  globalHeroComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is connected to the given models */
  locallHeroComponents?: InputMaybe<HomePageLocallHeroComponentsWhereInput>;
  /** All values in which the union is empty */
  locallHeroComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type HomePageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<HomePageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<HomePageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<HomePageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<HomePageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References HomePage record uniquely */
export type HomePageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** This field specifies the alignment of the iframe in the page */
export enum IFrameAlignment {
  center = 'center',
  left = 'left'
}

/** Content type for adding an iframe to a page */
export type Iframe = Entity & Node & {
  __typename?: 'Iframe';
  alignment?: Maybe<IFrameAlignment>;
  /** Title to be used within the cms for searching */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Iframe>;
  genericPages: Array<GenericPage>;
  /** List of Iframe versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Height of the iframe */
  iframeHeight: Scalars['String']['output'];
  /** The type of iframe to be rendered on the page */
  iframeType: IframeTypes;
  /** URL to be used to display in the iframe */
  iframeUrl: Scalars['String']['output'];
  /** Width for the iframe */
  iframeWidth?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Iframe>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Content type for adding an iframe to a page */
export type IframeCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Content type for adding an iframe to a page */
export type IframeCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Content type for adding an iframe to a page */
export type IframeDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Content type for adding an iframe to a page */
export type IframeGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Content type for adding an iframe to a page */
export type IframeHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Content type for adding an iframe to a page */
export type IframeLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Content type for adding an iframe to a page */
export type IframePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Content type for adding an iframe to a page */
export type IframePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Content type for adding an iframe to a page */
export type IframeScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Content type for adding an iframe to a page */
export type IframeTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Content type for adding an iframe to a page */
export type IframeUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Content type for adding an iframe to a page */
export type IframeUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type IframeConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: IframeWhereUniqueInput;
};

/** A connection to a list of items. */
export type IframeConnection = {
  __typename?: 'IframeConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<IframeEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type IframeCreateInput = {
  alignment?: InputMaybe<IFrameAlignment>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  /** iframeHeight input for default locale (default) */
  iframeHeight: Scalars['String']['input'];
  iframeType: IframeTypes;
  /** iframeUrl input for default locale (default) */
  iframeUrl: Scalars['String']['input'];
  /** iframeWidth input for default locale (default) */
  iframeWidth?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<IframeCreateLocalizationsInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IframeCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  iframeHeight: Scalars['String']['input'];
  iframeUrl: Scalars['String']['input'];
  iframeWidth?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IframeCreateLocalizationInput = {
  /** Localization input */
  data: IframeCreateLocalizationDataInput;
  locale: Locale;
};

export type IframeCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<IframeCreateLocalizationInput>>;
};

export type IframeCreateManyInlineInput = {
  /** Connect multiple existing Iframe documents */
  connect?: InputMaybe<Array<IframeWhereUniqueInput>>;
  /** Create and connect multiple existing Iframe documents */
  create?: InputMaybe<Array<IframeCreateInput>>;
};

export type IframeCreateOneInlineInput = {
  /** Connect one existing Iframe document */
  connect?: InputMaybe<IframeWhereUniqueInput>;
  /** Create and connect one Iframe document */
  create?: InputMaybe<IframeCreateInput>;
};

/** An edge in a connection. */
export type IframeEdge = {
  __typename?: 'IframeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Iframe;
};

/** Identifies documents */
export type IframeManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<IframeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<IframeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<IframeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<IFrameAlignment>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<IFrameAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<IFrameAlignment>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<IFrameAlignment>>>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<IframeWhereStageInput>;
  documentInStages_none?: InputMaybe<IframeWhereStageInput>;
  documentInStages_some?: InputMaybe<IframeWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  iframeType?: InputMaybe<IframeTypes>;
  /** All values that are contained in given list. */
  iframeType_in?: InputMaybe<Array<InputMaybe<IframeTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  iframeType_not?: InputMaybe<IframeTypes>;
  /** All values that are not contained in given list. */
  iframeType_not_in?: InputMaybe<Array<InputMaybe<IframeTypes>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum IframeOrderByInput {
  alignment_ASC = 'alignment_ASC',
  alignment_DESC = 'alignment_DESC',
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  iframeHeight_ASC = 'iframeHeight_ASC',
  iframeHeight_DESC = 'iframeHeight_DESC',
  iframeType_ASC = 'iframeType_ASC',
  iframeType_DESC = 'iframeType_DESC',
  iframeUrl_ASC = 'iframeUrl_ASC',
  iframeUrl_DESC = 'iframeUrl_DESC',
  iframeWidth_ASC = 'iframeWidth_ASC',
  iframeWidth_DESC = 'iframeWidth_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** The types of iframe */
export enum IframeTypes {
  fixed = 'fixed',
  responsive = 'responsive'
}

export type IframeUpdateInput = {
  alignment?: InputMaybe<IFrameAlignment>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  /** iframeHeight input for default locale (default) */
  iframeHeight?: InputMaybe<Scalars['String']['input']>;
  iframeType?: InputMaybe<IframeTypes>;
  /** iframeUrl input for default locale (default) */
  iframeUrl?: InputMaybe<Scalars['String']['input']>;
  /** iframeWidth input for default locale (default) */
  iframeWidth?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<IframeUpdateLocalizationsInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type IframeUpdateLocalizationDataInput = {
  iframeHeight?: InputMaybe<Scalars['String']['input']>;
  iframeUrl?: InputMaybe<Scalars['String']['input']>;
  iframeWidth?: InputMaybe<Scalars['String']['input']>;
};

export type IframeUpdateLocalizationInput = {
  data: IframeUpdateLocalizationDataInput;
  locale: Locale;
};

export type IframeUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<IframeCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<IframeUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<IframeUpsertLocalizationInput>>;
};

export type IframeUpdateManyInlineInput = {
  /** Connect multiple existing Iframe documents */
  connect?: InputMaybe<Array<IframeConnectInput>>;
  /** Create and connect multiple Iframe documents */
  create?: InputMaybe<Array<IframeCreateInput>>;
  /** Delete multiple Iframe documents */
  delete?: InputMaybe<Array<IframeWhereUniqueInput>>;
  /** Disconnect multiple Iframe documents */
  disconnect?: InputMaybe<Array<IframeWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Iframe documents */
  set?: InputMaybe<Array<IframeWhereUniqueInput>>;
  /** Update multiple Iframe documents */
  update?: InputMaybe<Array<IframeUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Iframe documents */
  upsert?: InputMaybe<Array<IframeUpsertWithNestedWhereUniqueInput>>;
};

export type IframeUpdateManyInput = {
  alignment?: InputMaybe<IFrameAlignment>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** iframeHeight input for default locale (default) */
  iframeHeight?: InputMaybe<Scalars['String']['input']>;
  iframeType?: InputMaybe<IframeTypes>;
  /** iframeUrl input for default locale (default) */
  iframeUrl?: InputMaybe<Scalars['String']['input']>;
  /** iframeWidth input for default locale (default) */
  iframeWidth?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<IframeUpdateManyLocalizationsInput>;
};

export type IframeUpdateManyLocalizationDataInput = {
  iframeHeight?: InputMaybe<Scalars['String']['input']>;
  iframeUrl?: InputMaybe<Scalars['String']['input']>;
  iframeWidth?: InputMaybe<Scalars['String']['input']>;
};

export type IframeUpdateManyLocalizationInput = {
  data: IframeUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type IframeUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<IframeUpdateManyLocalizationInput>>;
};

export type IframeUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: IframeUpdateManyInput;
  /** Document search */
  where: IframeWhereInput;
};

export type IframeUpdateOneInlineInput = {
  /** Connect existing Iframe document */
  connect?: InputMaybe<IframeWhereUniqueInput>;
  /** Create and connect one Iframe document */
  create?: InputMaybe<IframeCreateInput>;
  /** Delete currently connected Iframe document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Iframe document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Iframe document */
  update?: InputMaybe<IframeUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Iframe document */
  upsert?: InputMaybe<IframeUpsertWithNestedWhereUniqueInput>;
};

export type IframeUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: IframeUpdateInput;
  /** Unique document search */
  where: IframeWhereUniqueInput;
};

export type IframeUpsertInput = {
  /** Create document if it didn't exist */
  create: IframeCreateInput;
  /** Update document if it exists */
  update: IframeUpdateInput;
};

export type IframeUpsertLocalizationInput = {
  create: IframeCreateLocalizationDataInput;
  locale: Locale;
  update: IframeUpdateLocalizationDataInput;
};

export type IframeUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: IframeUpsertInput;
  /** Unique document search */
  where: IframeWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type IframeWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type IframeWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<IframeWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<IframeWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<IframeWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<IFrameAlignment>;
  /** All values that are contained in given list. */
  alignment_in?: InputMaybe<Array<InputMaybe<IFrameAlignment>>>;
  /** Any other value that exists and is not equal to the given value. */
  alignment_not?: InputMaybe<IFrameAlignment>;
  /** All values that are not contained in given list. */
  alignment_not_in?: InputMaybe<Array<InputMaybe<IFrameAlignment>>>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<IframeWhereStageInput>;
  documentInStages_none?: InputMaybe<IframeWhereStageInput>;
  documentInStages_some?: InputMaybe<IframeWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  iframeHeight?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  iframeHeight_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  iframeHeight_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  iframeHeight_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  iframeHeight_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  iframeHeight_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  iframeHeight_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  iframeHeight_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  iframeHeight_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  iframeHeight_starts_with?: InputMaybe<Scalars['String']['input']>;
  iframeType?: InputMaybe<IframeTypes>;
  /** All values that are contained in given list. */
  iframeType_in?: InputMaybe<Array<InputMaybe<IframeTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  iframeType_not?: InputMaybe<IframeTypes>;
  /** All values that are not contained in given list. */
  iframeType_not_in?: InputMaybe<Array<InputMaybe<IframeTypes>>>;
  iframeUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  iframeUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  iframeUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  iframeUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  iframeUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  iframeUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  iframeUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  iframeUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  iframeUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  iframeUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  iframeWidth?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  iframeWidth_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  iframeWidth_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  iframeWidth_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  iframeWidth_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  iframeWidth_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  iframeWidth_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  iframeWidth_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  iframeWidth_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  iframeWidth_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type IframeWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<IframeWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<IframeWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<IframeWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<IframeWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Iframe record uniquely */
export type IframeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ImageAndTextCard = Entity & Node & {
  __typename?: 'ImageAndTextCard';
  anchorNav?: Maybe<AnchorNavigation>;
  buttonLink?: Maybe<Link>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<ImageAndTextCard>;
  genericPages: Array<GenericPage>;
  gridColumnComponent?: Maybe<CorpGridColumnComponent>;
  /** List of ImageAndTextCard versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<AssetComponent>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<ImageAndTextCard>;
  /** Another Variation of card with Metaball */
  metaBall?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Additional  Info text above main heading */
  subHeading?: Maybe<Scalars['String']['output']>;
  /** Heading of the card */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ImageAndTextCardAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageAndTextCardButtonLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageAndTextCardCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type ImageAndTextCardCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageAndTextCardDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ImageAndTextCardGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type ImageAndTextCardGridColumnComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageAndTextCardHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ImageAndTextCardImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageAndTextCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type ImageAndTextCardPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type ImageAndTextCardPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageAndTextCardScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ImageAndTextCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type ImageAndTextCardUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ImageAndTextCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ImageAndTextCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type ImageAndTextCardConnection = {
  __typename?: 'ImageAndTextCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ImageAndTextCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ImageAndTextCardCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  buttonLink?: InputMaybe<LinkCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  gridColumnComponent?: InputMaybe<CorpGridColumnComponentCreateOneInlineInput>;
  image?: InputMaybe<AssetComponentCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ImageAndTextCardCreateLocalizationsInput>;
  metaBall?: InputMaybe<Scalars['Boolean']['input']>;
  /** subHeading input for default locale (default) */
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ImageAndTextCardCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ImageAndTextCardCreateLocalizationInput = {
  /** Localization input */
  data: ImageAndTextCardCreateLocalizationDataInput;
  locale: Locale;
};

export type ImageAndTextCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ImageAndTextCardCreateLocalizationInput>>;
};

export type ImageAndTextCardCreateManyInlineInput = {
  /** Connect multiple existing ImageAndTextCard documents */
  connect?: InputMaybe<Array<ImageAndTextCardWhereUniqueInput>>;
  /** Create and connect multiple existing ImageAndTextCard documents */
  create?: InputMaybe<Array<ImageAndTextCardCreateInput>>;
};

export type ImageAndTextCardCreateOneInlineInput = {
  /** Connect one existing ImageAndTextCard document */
  connect?: InputMaybe<ImageAndTextCardWhereUniqueInput>;
  /** Create and connect one ImageAndTextCard document */
  create?: InputMaybe<ImageAndTextCardCreateInput>;
};

/** An edge in a connection. */
export type ImageAndTextCardEdge = {
  __typename?: 'ImageAndTextCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ImageAndTextCard;
};

/** Identifies documents */
export type ImageAndTextCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageAndTextCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageAndTextCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageAndTextCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  buttonLink?: InputMaybe<LinkWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ImageAndTextCardWhereStageInput>;
  documentInStages_none?: InputMaybe<ImageAndTextCardWhereStageInput>;
  documentInStages_some?: InputMaybe<ImageAndTextCardWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  gridColumnComponent?: InputMaybe<CorpGridColumnComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  metaBall?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  metaBall_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ImageAndTextCardOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  metaBall_ASC = 'metaBall_ASC',
  metaBall_DESC = 'metaBall_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subHeading_ASC = 'subHeading_ASC',
  subHeading_DESC = 'subHeading_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ImageAndTextCardUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  buttonLink?: InputMaybe<LinkUpdateOneInlineInput>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  gridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateOneInlineInput>;
  image?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<ImageAndTextCardUpdateLocalizationsInput>;
  metaBall?: InputMaybe<Scalars['Boolean']['input']>;
  /** subHeading input for default locale (default) */
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ImageAndTextCardUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ImageAndTextCardUpdateLocalizationInput = {
  data: ImageAndTextCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type ImageAndTextCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ImageAndTextCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<ImageAndTextCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<ImageAndTextCardUpsertLocalizationInput>>;
};

export type ImageAndTextCardUpdateManyInlineInput = {
  /** Connect multiple existing ImageAndTextCard documents */
  connect?: InputMaybe<Array<ImageAndTextCardConnectInput>>;
  /** Create and connect multiple ImageAndTextCard documents */
  create?: InputMaybe<Array<ImageAndTextCardCreateInput>>;
  /** Delete multiple ImageAndTextCard documents */
  delete?: InputMaybe<Array<ImageAndTextCardWhereUniqueInput>>;
  /** Disconnect multiple ImageAndTextCard documents */
  disconnect?: InputMaybe<Array<ImageAndTextCardWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ImageAndTextCard documents */
  set?: InputMaybe<Array<ImageAndTextCardWhereUniqueInput>>;
  /** Update multiple ImageAndTextCard documents */
  update?: InputMaybe<Array<ImageAndTextCardUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ImageAndTextCard documents */
  upsert?: InputMaybe<Array<ImageAndTextCardUpsertWithNestedWhereUniqueInput>>;
};

export type ImageAndTextCardUpdateManyInput = {
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<ImageAndTextCardUpdateManyLocalizationsInput>;
  metaBall?: InputMaybe<Scalars['Boolean']['input']>;
  /** subHeading input for default locale (default) */
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ImageAndTextCardUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ImageAndTextCardUpdateManyLocalizationInput = {
  data: ImageAndTextCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type ImageAndTextCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ImageAndTextCardUpdateManyLocalizationInput>>;
};

export type ImageAndTextCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ImageAndTextCardUpdateManyInput;
  /** Document search */
  where: ImageAndTextCardWhereInput;
};

export type ImageAndTextCardUpdateOneInlineInput = {
  /** Connect existing ImageAndTextCard document */
  connect?: InputMaybe<ImageAndTextCardWhereUniqueInput>;
  /** Create and connect one ImageAndTextCard document */
  create?: InputMaybe<ImageAndTextCardCreateInput>;
  /** Delete currently connected ImageAndTextCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ImageAndTextCard document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageAndTextCard document */
  update?: InputMaybe<ImageAndTextCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageAndTextCard document */
  upsert?: InputMaybe<ImageAndTextCardUpsertWithNestedWhereUniqueInput>;
};

export type ImageAndTextCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ImageAndTextCardUpdateInput;
  /** Unique document search */
  where: ImageAndTextCardWhereUniqueInput;
};

export type ImageAndTextCardUpsertInput = {
  /** Create document if it didn't exist */
  create: ImageAndTextCardCreateInput;
  /** Update document if it exists */
  update: ImageAndTextCardUpdateInput;
};

export type ImageAndTextCardUpsertLocalizationInput = {
  create: ImageAndTextCardCreateLocalizationDataInput;
  locale: Locale;
  update: ImageAndTextCardUpdateLocalizationDataInput;
};

export type ImageAndTextCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ImageAndTextCardUpsertInput;
  /** Unique document search */
  where: ImageAndTextCardWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ImageAndTextCardWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ImageAndTextCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageAndTextCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageAndTextCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageAndTextCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  buttonLink?: InputMaybe<LinkWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<ImageAndTextCardWhereStageInput>;
  documentInStages_none?: InputMaybe<ImageAndTextCardWhereStageInput>;
  documentInStages_some?: InputMaybe<ImageAndTextCardWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  gridColumnComponent?: InputMaybe<CorpGridColumnComponentWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  metaBall?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  metaBall_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ImageAndTextCardWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageAndTextCardWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageAndTextCardWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageAndTextCardWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ImageAndTextCardWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ImageAndTextCard record uniquely */
export type ImageAndTextCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ImageBlurInput = {
  /** The amount of blurring to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

/** Adds a border to the image. */
export type ImageBorderInput = {
  /** The background color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  background: Scalars['String']['input'];
  /** The color of the border. The value must be a valid hex color code. Or one of the supported color names. */
  color: Scalars['String']['input'];
  /** The width of the border in pixels. The value must be an integer from 1 to 1000. */
  width: Scalars['Int']['input'];
};

export type ImageCompressInput = {
  /** Preserves the metadata of the image. */
  metadata: Scalars['Boolean']['input'];
};

/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopy = Entity & Node & {
  __typename?: 'ImageCopy';
  anchorNav?: Maybe<AnchorNavigation>;
  /** Title to be used to find the contents in the CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<ImageCopy>;
  genericAccordionItems: Array<CorpGenericAccordionItem>;
  genericPages: Array<GenericPage>;
  /** List of ImageCopy versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Image copy items */
  imageCopyItem: Array<ImageCopyImageCopyItem>;
  locationItem?: Maybe<LocationItem>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyGenericAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericAccordionItemWhereInput>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyImageCopyItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyLocationItemArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Two panel image/video/text component that can have either an image | image, image | video, video | image, image | text, text | image, video | text, text | video */
export type ImageCopyUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ImageCopyConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ImageCopyWhereUniqueInput;
};

/** A connection to a list of items. */
export type ImageCopyConnection = {
  __typename?: 'ImageCopyConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ImageCopyEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ImageCopyCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  imageCopyItem?: InputMaybe<ImageCopyImageCopyItemCreateManyInlineInput>;
  locationItem?: InputMaybe<LocationItemCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ImageCopyCreateManyInlineInput = {
  /** Connect multiple existing ImageCopy documents */
  connect?: InputMaybe<Array<ImageCopyWhereUniqueInput>>;
  /** Create and connect multiple existing ImageCopy documents */
  create?: InputMaybe<Array<ImageCopyCreateInput>>;
};

export type ImageCopyCreateOneInlineInput = {
  /** Connect one existing ImageCopy document */
  connect?: InputMaybe<ImageCopyWhereUniqueInput>;
  /** Create and connect one ImageCopy document */
  create?: InputMaybe<ImageCopyCreateInput>;
};

/** An edge in a connection. */
export type ImageCopyEdge = {
  __typename?: 'ImageCopyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ImageCopy;
};

export type ImageCopyImageCopyItem = ImageCopyItem;

export type ImageCopyImageCopyItemConnectInput = {
  ImageCopyItem?: InputMaybe<ImageCopyItemConnectInput>;
};

export type ImageCopyImageCopyItemCreateInput = {
  ImageCopyItem?: InputMaybe<ImageCopyItemCreateInput>;
};

export type ImageCopyImageCopyItemCreateManyInlineInput = {
  /** Connect multiple existing ImageCopyImageCopyItem documents */
  connect?: InputMaybe<Array<ImageCopyImageCopyItemWhereUniqueInput>>;
  /** Create and connect multiple existing ImageCopyImageCopyItem documents */
  create?: InputMaybe<Array<ImageCopyImageCopyItemCreateInput>>;
};

export type ImageCopyImageCopyItemCreateOneInlineInput = {
  /** Connect one existing ImageCopyImageCopyItem document */
  connect?: InputMaybe<ImageCopyImageCopyItemWhereUniqueInput>;
  /** Create and connect one ImageCopyImageCopyItem document */
  create?: InputMaybe<ImageCopyImageCopyItemCreateInput>;
};

export type ImageCopyImageCopyItemUpdateInput = {
  ImageCopyItem?: InputMaybe<ImageCopyItemUpdateInput>;
};

export type ImageCopyImageCopyItemUpdateManyInlineInput = {
  /** Connect multiple existing ImageCopyImageCopyItem documents */
  connect?: InputMaybe<Array<ImageCopyImageCopyItemConnectInput>>;
  /** Create and connect multiple ImageCopyImageCopyItem documents */
  create?: InputMaybe<Array<ImageCopyImageCopyItemCreateInput>>;
  /** Delete multiple ImageCopyImageCopyItem documents */
  delete?: InputMaybe<Array<ImageCopyImageCopyItemWhereUniqueInput>>;
  /** Disconnect multiple ImageCopyImageCopyItem documents */
  disconnect?: InputMaybe<Array<ImageCopyImageCopyItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ImageCopyImageCopyItem documents */
  set?: InputMaybe<Array<ImageCopyImageCopyItemWhereUniqueInput>>;
  /** Update multiple ImageCopyImageCopyItem documents */
  update?: InputMaybe<Array<ImageCopyImageCopyItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ImageCopyImageCopyItem documents */
  upsert?: InputMaybe<Array<ImageCopyImageCopyItemUpsertWithNestedWhereUniqueInput>>;
};

export type ImageCopyImageCopyItemUpdateManyWithNestedWhereInput = {
  ImageCopyItem?: InputMaybe<ImageCopyItemUpdateManyWithNestedWhereInput>;
};

export type ImageCopyImageCopyItemUpdateOneInlineInput = {
  /** Connect existing ImageCopyImageCopyItem document */
  connect?: InputMaybe<ImageCopyImageCopyItemWhereUniqueInput>;
  /** Create and connect one ImageCopyImageCopyItem document */
  create?: InputMaybe<ImageCopyImageCopyItemCreateInput>;
  /** Delete currently connected ImageCopyImageCopyItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ImageCopyImageCopyItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageCopyImageCopyItem document */
  update?: InputMaybe<ImageCopyImageCopyItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageCopyImageCopyItem document */
  upsert?: InputMaybe<ImageCopyImageCopyItemUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyImageCopyItemUpdateWithNestedWhereUniqueInput = {
  ImageCopyItem?: InputMaybe<ImageCopyItemUpdateWithNestedWhereUniqueInput>;
};

export type ImageCopyImageCopyItemUpsertWithNestedWhereUniqueInput = {
  ImageCopyItem?: InputMaybe<ImageCopyItemUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyImageCopyItemWhereInput = {
  ImageCopyItem?: InputMaybe<ImageCopyItemWhereInput>;
};

export type ImageCopyImageCopyItemWhereUniqueInput = {
  ImageCopyItem?: InputMaybe<ImageCopyItemWhereUniqueInput>;
};

export type ImageCopyItem = Entity & Node & {
  __typename?: 'ImageCopyItem';
  /** Description */
  addDescription?: Maybe<Scalars['Boolean']['output']>;
  addImage?: Maybe<Scalars['Boolean']['output']>;
  /** Add Title */
  addTitle?: Maybe<Scalars['Boolean']['output']>;
  /** Add Video */
  addVideo?: Maybe<Scalars['Boolean']['output']>;
  /** Type of Column full, half or multi column  */
  columnType: ColumnType;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Description */
  description?: Maybe<ImageCopyItemDescriptionRichText>;
  /** Get the document in other stages */
  documentInStages: Array<ImageCopyItem>;
  /** List of ImageCopyItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image: Array<ImageCopyItemImage>;
  imageCopy?: Maybe<ImageCopy>;
  /** Image Position */
  imagePosition?: Maybe<DisplayPosition>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<ImageCopyItem>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** ID of Video */
  videoId?: Maybe<Scalars['String']['output']>;
  /** Video Postion */
  videoPosition?: Maybe<DisplayPosition>;
  /** Image to display on video */
  videoPosterImage?: Maybe<ImageCopyItemVideoPosterImage>;
};


export type ImageCopyItemCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type ImageCopyItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageCopyItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ImageCopyItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ImageCopyItemImageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageCopyItemImageCopyArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageCopyItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type ImageCopyItemPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type ImageCopyItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageCopyItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ImageCopyItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type ImageCopyItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ImageCopyItemVideoPosterImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ImageCopyItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ImageCopyItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type ImageCopyItemConnection = {
  __typename?: 'ImageCopyItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ImageCopyItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ImageCopyItemCreateInput = {
  addDescription?: InputMaybe<Scalars['Boolean']['input']>;
  addImage?: InputMaybe<Scalars['Boolean']['input']>;
  addTitle?: InputMaybe<Scalars['Boolean']['input']>;
  addVideo?: InputMaybe<Scalars['Boolean']['input']>;
  columnType: ColumnType;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  image?: InputMaybe<ImageCopyItemImageCreateManyInlineInput>;
  imageCopy?: InputMaybe<ImageCopyCreateOneInlineInput>;
  imagePosition?: InputMaybe<DisplayPosition>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ImageCopyItemCreateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  videoPosition?: InputMaybe<DisplayPosition>;
  videoPosterImage?: InputMaybe<ImageCopyItemVideoPosterImageCreateOneInlineInput>;
};

export type ImageCopyItemCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ImageCopyItemCreateLocalizationInput = {
  /** Localization input */
  data: ImageCopyItemCreateLocalizationDataInput;
  locale: Locale;
};

export type ImageCopyItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ImageCopyItemCreateLocalizationInput>>;
};

export type ImageCopyItemCreateManyInlineInput = {
  /** Connect multiple existing ImageCopyItem documents */
  connect?: InputMaybe<Array<ImageCopyItemWhereUniqueInput>>;
  /** Create and connect multiple existing ImageCopyItem documents */
  create?: InputMaybe<Array<ImageCopyItemCreateInput>>;
};

export type ImageCopyItemCreateOneInlineInput = {
  /** Connect one existing ImageCopyItem document */
  connect?: InputMaybe<ImageCopyItemWhereUniqueInput>;
  /** Create and connect one ImageCopyItem document */
  create?: InputMaybe<ImageCopyItemCreateInput>;
};

export type ImageCopyItemDescriptionRichText = {
  __typename?: 'ImageCopyItemDescriptionRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<ImageCopyItemDescriptionRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type ImageCopyItemDescriptionRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageCopyItemDescriptionRichTextEmbeddedTypes = QuickLink;

/** An edge in a connection. */
export type ImageCopyItemEdge = {
  __typename?: 'ImageCopyItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ImageCopyItem;
};

export type ImageCopyItemImage = AssetComponent;

export type ImageCopyItemImageConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type ImageCopyItemImageCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type ImageCopyItemImageCreateManyInlineInput = {
  /** Connect multiple existing ImageCopyItemImage documents */
  connect?: InputMaybe<Array<ImageCopyItemImageWhereUniqueInput>>;
  /** Create and connect multiple existing ImageCopyItemImage documents */
  create?: InputMaybe<Array<ImageCopyItemImageCreateInput>>;
};

export type ImageCopyItemImageCreateOneInlineInput = {
  /** Connect one existing ImageCopyItemImage document */
  connect?: InputMaybe<ImageCopyItemImageWhereUniqueInput>;
  /** Create and connect one ImageCopyItemImage document */
  create?: InputMaybe<ImageCopyItemImageCreateInput>;
};

export type ImageCopyItemImageUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type ImageCopyItemImageUpdateManyInlineInput = {
  /** Connect multiple existing ImageCopyItemImage documents */
  connect?: InputMaybe<Array<ImageCopyItemImageConnectInput>>;
  /** Create and connect multiple ImageCopyItemImage documents */
  create?: InputMaybe<Array<ImageCopyItemImageCreateInput>>;
  /** Delete multiple ImageCopyItemImage documents */
  delete?: InputMaybe<Array<ImageCopyItemImageWhereUniqueInput>>;
  /** Disconnect multiple ImageCopyItemImage documents */
  disconnect?: InputMaybe<Array<ImageCopyItemImageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ImageCopyItemImage documents */
  set?: InputMaybe<Array<ImageCopyItemImageWhereUniqueInput>>;
  /** Update multiple ImageCopyItemImage documents */
  update?: InputMaybe<Array<ImageCopyItemImageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ImageCopyItemImage documents */
  upsert?: InputMaybe<Array<ImageCopyItemImageUpsertWithNestedWhereUniqueInput>>;
};

export type ImageCopyItemImageUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type ImageCopyItemImageUpdateOneInlineInput = {
  /** Connect existing ImageCopyItemImage document */
  connect?: InputMaybe<ImageCopyItemImageWhereUniqueInput>;
  /** Create and connect one ImageCopyItemImage document */
  create?: InputMaybe<ImageCopyItemImageCreateInput>;
  /** Delete currently connected ImageCopyItemImage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ImageCopyItemImage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageCopyItemImage document */
  update?: InputMaybe<ImageCopyItemImageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageCopyItemImage document */
  upsert?: InputMaybe<ImageCopyItemImageUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyItemImageUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type ImageCopyItemImageUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyItemImageWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type ImageCopyItemImageWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

/** Identifies documents */
export type ImageCopyItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageCopyItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageCopyItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageCopyItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  addDescription?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  addDescription_not?: InputMaybe<Scalars['Boolean']['input']>;
  addImage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  addImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  addTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  addTitle_not?: InputMaybe<Scalars['Boolean']['input']>;
  addVideo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  addVideo_not?: InputMaybe<Scalars['Boolean']['input']>;
  columnType?: InputMaybe<ColumnType>;
  /** All values that are contained in given list. */
  columnType_in?: InputMaybe<Array<InputMaybe<ColumnType>>>;
  /** Any other value that exists and is not equal to the given value. */
  columnType_not?: InputMaybe<ColumnType>;
  /** All values that are not contained in given list. */
  columnType_not_in?: InputMaybe<Array<InputMaybe<ColumnType>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ImageCopyItemWhereStageInput>;
  documentInStages_none?: InputMaybe<ImageCopyItemWhereStageInput>;
  documentInStages_some?: InputMaybe<ImageCopyItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageCopy?: InputMaybe<ImageCopyWhereInput>;
  imagePosition?: InputMaybe<DisplayPosition>;
  /** All values that are contained in given list. */
  imagePosition_in?: InputMaybe<Array<InputMaybe<DisplayPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  imagePosition_not?: InputMaybe<DisplayPosition>;
  /** All values that are not contained in given list. */
  imagePosition_not_in?: InputMaybe<Array<InputMaybe<DisplayPosition>>>;
  /** All values in which the union is empty */
  image_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  image_some?: InputMaybe<ImageCopyItemImageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoId_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoPosition?: InputMaybe<DisplayPosition>;
  /** All values that are contained in given list. */
  videoPosition_in?: InputMaybe<Array<InputMaybe<DisplayPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoPosition_not?: InputMaybe<DisplayPosition>;
  /** All values that are not contained in given list. */
  videoPosition_not_in?: InputMaybe<Array<InputMaybe<DisplayPosition>>>;
  /** All values in which the union is connected to the given models */
  videoPosterImage?: InputMaybe<ImageCopyItemVideoPosterImageWhereInput>;
  /** All values in which the union is empty */
  videoPosterImage_empty?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ImageCopyItemOrderByInput {
  addDescription_ASC = 'addDescription_ASC',
  addDescription_DESC = 'addDescription_DESC',
  addImage_ASC = 'addImage_ASC',
  addImage_DESC = 'addImage_DESC',
  addTitle_ASC = 'addTitle_ASC',
  addTitle_DESC = 'addTitle_DESC',
  addVideo_ASC = 'addVideo_ASC',
  addVideo_DESC = 'addVideo_DESC',
  columnType_ASC = 'columnType_ASC',
  columnType_DESC = 'columnType_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  imagePosition_ASC = 'imagePosition_ASC',
  imagePosition_DESC = 'imagePosition_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  videoId_ASC = 'videoId_ASC',
  videoId_DESC = 'videoId_DESC',
  videoPosition_ASC = 'videoPosition_ASC',
  videoPosition_DESC = 'videoPosition_DESC'
}

export type ImageCopyItemUpdateInput = {
  addDescription?: InputMaybe<Scalars['Boolean']['input']>;
  addImage?: InputMaybe<Scalars['Boolean']['input']>;
  addTitle?: InputMaybe<Scalars['Boolean']['input']>;
  addVideo?: InputMaybe<Scalars['Boolean']['input']>;
  columnType?: InputMaybe<ColumnType>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  image?: InputMaybe<ImageCopyItemImageUpdateManyInlineInput>;
  imageCopy?: InputMaybe<ImageCopyUpdateOneInlineInput>;
  imagePosition?: InputMaybe<DisplayPosition>;
  /** Manage document localizations */
  localizations?: InputMaybe<ImageCopyItemUpdateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  videoPosition?: InputMaybe<DisplayPosition>;
  videoPosterImage?: InputMaybe<ImageCopyItemVideoPosterImageUpdateOneInlineInput>;
};

export type ImageCopyItemUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ImageCopyItemUpdateLocalizationInput = {
  data: ImageCopyItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type ImageCopyItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ImageCopyItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<ImageCopyItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<ImageCopyItemUpsertLocalizationInput>>;
};

export type ImageCopyItemUpdateManyInlineInput = {
  /** Connect multiple existing ImageCopyItem documents */
  connect?: InputMaybe<Array<ImageCopyItemConnectInput>>;
  /** Create and connect multiple ImageCopyItem documents */
  create?: InputMaybe<Array<ImageCopyItemCreateInput>>;
  /** Delete multiple ImageCopyItem documents */
  delete?: InputMaybe<Array<ImageCopyItemWhereUniqueInput>>;
  /** Disconnect multiple ImageCopyItem documents */
  disconnect?: InputMaybe<Array<ImageCopyItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ImageCopyItem documents */
  set?: InputMaybe<Array<ImageCopyItemWhereUniqueInput>>;
  /** Update multiple ImageCopyItem documents */
  update?: InputMaybe<Array<ImageCopyItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ImageCopyItem documents */
  upsert?: InputMaybe<Array<ImageCopyItemUpsertWithNestedWhereUniqueInput>>;
};

export type ImageCopyItemUpdateManyInput = {
  addDescription?: InputMaybe<Scalars['Boolean']['input']>;
  addImage?: InputMaybe<Scalars['Boolean']['input']>;
  addTitle?: InputMaybe<Scalars['Boolean']['input']>;
  addVideo?: InputMaybe<Scalars['Boolean']['input']>;
  columnType?: InputMaybe<ColumnType>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  imagePosition?: InputMaybe<DisplayPosition>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<ImageCopyItemUpdateManyLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  videoPosition?: InputMaybe<DisplayPosition>;
};

export type ImageCopyItemUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ImageCopyItemUpdateManyLocalizationInput = {
  data: ImageCopyItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type ImageCopyItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ImageCopyItemUpdateManyLocalizationInput>>;
};

export type ImageCopyItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ImageCopyItemUpdateManyInput;
  /** Document search */
  where: ImageCopyItemWhereInput;
};

export type ImageCopyItemUpdateOneInlineInput = {
  /** Connect existing ImageCopyItem document */
  connect?: InputMaybe<ImageCopyItemWhereUniqueInput>;
  /** Create and connect one ImageCopyItem document */
  create?: InputMaybe<ImageCopyItemCreateInput>;
  /** Delete currently connected ImageCopyItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ImageCopyItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageCopyItem document */
  update?: InputMaybe<ImageCopyItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageCopyItem document */
  upsert?: InputMaybe<ImageCopyItemUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ImageCopyItemUpdateInput;
  /** Unique document search */
  where: ImageCopyItemWhereUniqueInput;
};

export type ImageCopyItemUpsertInput = {
  /** Create document if it didn't exist */
  create: ImageCopyItemCreateInput;
  /** Update document if it exists */
  update: ImageCopyItemUpdateInput;
};

export type ImageCopyItemUpsertLocalizationInput = {
  create: ImageCopyItemCreateLocalizationDataInput;
  locale: Locale;
  update: ImageCopyItemUpdateLocalizationDataInput;
};

export type ImageCopyItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ImageCopyItemUpsertInput;
  /** Unique document search */
  where: ImageCopyItemWhereUniqueInput;
};

export type ImageCopyItemVideoPosterImage = AssetComponent;

export type ImageCopyItemVideoPosterImageConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type ImageCopyItemVideoPosterImageCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type ImageCopyItemVideoPosterImageCreateManyInlineInput = {
  /** Connect multiple existing ImageCopyItemVideoPosterImage documents */
  connect?: InputMaybe<Array<ImageCopyItemVideoPosterImageWhereUniqueInput>>;
  /** Create and connect multiple existing ImageCopyItemVideoPosterImage documents */
  create?: InputMaybe<Array<ImageCopyItemVideoPosterImageCreateInput>>;
};

export type ImageCopyItemVideoPosterImageCreateOneInlineInput = {
  /** Connect one existing ImageCopyItemVideoPosterImage document */
  connect?: InputMaybe<ImageCopyItemVideoPosterImageWhereUniqueInput>;
  /** Create and connect one ImageCopyItemVideoPosterImage document */
  create?: InputMaybe<ImageCopyItemVideoPosterImageCreateInput>;
};

export type ImageCopyItemVideoPosterImageUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type ImageCopyItemVideoPosterImageUpdateManyInlineInput = {
  /** Connect multiple existing ImageCopyItemVideoPosterImage documents */
  connect?: InputMaybe<Array<ImageCopyItemVideoPosterImageConnectInput>>;
  /** Create and connect multiple ImageCopyItemVideoPosterImage documents */
  create?: InputMaybe<Array<ImageCopyItemVideoPosterImageCreateInput>>;
  /** Delete multiple ImageCopyItemVideoPosterImage documents */
  delete?: InputMaybe<Array<ImageCopyItemVideoPosterImageWhereUniqueInput>>;
  /** Disconnect multiple ImageCopyItemVideoPosterImage documents */
  disconnect?: InputMaybe<Array<ImageCopyItemVideoPosterImageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ImageCopyItemVideoPosterImage documents */
  set?: InputMaybe<Array<ImageCopyItemVideoPosterImageWhereUniqueInput>>;
  /** Update multiple ImageCopyItemVideoPosterImage documents */
  update?: InputMaybe<Array<ImageCopyItemVideoPosterImageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ImageCopyItemVideoPosterImage documents */
  upsert?: InputMaybe<Array<ImageCopyItemVideoPosterImageUpsertWithNestedWhereUniqueInput>>;
};

export type ImageCopyItemVideoPosterImageUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type ImageCopyItemVideoPosterImageUpdateOneInlineInput = {
  /** Connect existing ImageCopyItemVideoPosterImage document */
  connect?: InputMaybe<ImageCopyItemVideoPosterImageWhereUniqueInput>;
  /** Create and connect one ImageCopyItemVideoPosterImage document */
  create?: InputMaybe<ImageCopyItemVideoPosterImageCreateInput>;
  /** Delete currently connected ImageCopyItemVideoPosterImage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ImageCopyItemVideoPosterImage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageCopyItemVideoPosterImage document */
  update?: InputMaybe<ImageCopyItemVideoPosterImageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageCopyItemVideoPosterImage document */
  upsert?: InputMaybe<ImageCopyItemVideoPosterImageUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyItemVideoPosterImageUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type ImageCopyItemVideoPosterImageUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyItemVideoPosterImageWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type ImageCopyItemVideoPosterImageWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

/** This contains a set of filters that can be used to compare values internally */
export type ImageCopyItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ImageCopyItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageCopyItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageCopyItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageCopyItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  addDescription?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  addDescription_not?: InputMaybe<Scalars['Boolean']['input']>;
  addImage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  addImage_not?: InputMaybe<Scalars['Boolean']['input']>;
  addTitle?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  addTitle_not?: InputMaybe<Scalars['Boolean']['input']>;
  addVideo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  addVideo_not?: InputMaybe<Scalars['Boolean']['input']>;
  columnType?: InputMaybe<ColumnType>;
  /** All values that are contained in given list. */
  columnType_in?: InputMaybe<Array<InputMaybe<ColumnType>>>;
  /** Any other value that exists and is not equal to the given value. */
  columnType_not?: InputMaybe<ColumnType>;
  /** All values that are not contained in given list. */
  columnType_not_in?: InputMaybe<Array<InputMaybe<ColumnType>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ImageCopyItemWhereStageInput>;
  documentInStages_none?: InputMaybe<ImageCopyItemWhereStageInput>;
  documentInStages_some?: InputMaybe<ImageCopyItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageCopy?: InputMaybe<ImageCopyWhereInput>;
  imagePosition?: InputMaybe<DisplayPosition>;
  /** All values that are contained in given list. */
  imagePosition_in?: InputMaybe<Array<InputMaybe<DisplayPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  imagePosition_not?: InputMaybe<DisplayPosition>;
  /** All values that are not contained in given list. */
  imagePosition_not_in?: InputMaybe<Array<InputMaybe<DisplayPosition>>>;
  /** All values in which the union is empty */
  image_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  image_some?: InputMaybe<ImageCopyItemImageWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  videoId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  videoId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  videoId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  videoId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  videoId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  videoId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  videoId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  videoId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  videoId_starts_with?: InputMaybe<Scalars['String']['input']>;
  videoPosition?: InputMaybe<DisplayPosition>;
  /** All values that are contained in given list. */
  videoPosition_in?: InputMaybe<Array<InputMaybe<DisplayPosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  videoPosition_not?: InputMaybe<DisplayPosition>;
  /** All values that are not contained in given list. */
  videoPosition_not_in?: InputMaybe<Array<InputMaybe<DisplayPosition>>>;
  /** All values in which the union is connected to the given models */
  videoPosterImage?: InputMaybe<ImageCopyItemVideoPosterImageWhereInput>;
  /** All values in which the union is empty */
  videoPosterImage_empty?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ImageCopyItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageCopyItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageCopyItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageCopyItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ImageCopyItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ImageCopyItem record uniquely */
export type ImageCopyItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type ImageCopyManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageCopyWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageCopyWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageCopyWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ImageCopyWhereStageInput>;
  documentInStages_none?: InputMaybe<ImageCopyWhereStageInput>;
  documentInStages_some?: InputMaybe<ImageCopyWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  imageCopyItem_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  imageCopyItem_some?: InputMaybe<ImageCopyImageCopyItemWhereInput>;
  locationItem?: InputMaybe<LocationItemWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ImageCopyOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ImageCopyUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  imageCopyItem?: InputMaybe<ImageCopyImageCopyItemUpdateManyInlineInput>;
  locationItem?: InputMaybe<LocationItemUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type ImageCopyUpdateManyInlineInput = {
  /** Connect multiple existing ImageCopy documents */
  connect?: InputMaybe<Array<ImageCopyConnectInput>>;
  /** Create and connect multiple ImageCopy documents */
  create?: InputMaybe<Array<ImageCopyCreateInput>>;
  /** Delete multiple ImageCopy documents */
  delete?: InputMaybe<Array<ImageCopyWhereUniqueInput>>;
  /** Disconnect multiple ImageCopy documents */
  disconnect?: InputMaybe<Array<ImageCopyWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ImageCopy documents */
  set?: InputMaybe<Array<ImageCopyWhereUniqueInput>>;
  /** Update multiple ImageCopy documents */
  update?: InputMaybe<Array<ImageCopyUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ImageCopy documents */
  upsert?: InputMaybe<Array<ImageCopyUpsertWithNestedWhereUniqueInput>>;
};

export type ImageCopyUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ImageCopyUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ImageCopyUpdateManyInput;
  /** Document search */
  where: ImageCopyWhereInput;
};

export type ImageCopyUpdateOneInlineInput = {
  /** Connect existing ImageCopy document */
  connect?: InputMaybe<ImageCopyWhereUniqueInput>;
  /** Create and connect one ImageCopy document */
  create?: InputMaybe<ImageCopyCreateInput>;
  /** Delete currently connected ImageCopy document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ImageCopy document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ImageCopy document */
  update?: InputMaybe<ImageCopyUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ImageCopy document */
  upsert?: InputMaybe<ImageCopyUpsertWithNestedWhereUniqueInput>;
};

export type ImageCopyUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ImageCopyUpdateInput;
  /** Unique document search */
  where: ImageCopyWhereUniqueInput;
};

export type ImageCopyUpsertInput = {
  /** Create document if it didn't exist */
  create: ImageCopyCreateInput;
  /** Update document if it exists */
  update: ImageCopyUpdateInput;
};

export type ImageCopyUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ImageCopyUpsertInput;
  /** Unique document search */
  where: ImageCopyWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ImageCopyWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ImageCopyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageCopyWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageCopyWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageCopyWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ImageCopyWhereStageInput>;
  documentInStages_none?: InputMaybe<ImageCopyWhereStageInput>;
  documentInStages_some?: InputMaybe<ImageCopyWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values in which the union is empty */
  imageCopyItem_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  imageCopyItem_some?: InputMaybe<ImageCopyImageCopyItemWhereInput>;
  locationItem?: InputMaybe<LocationItemWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ImageCopyWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ImageCopyWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ImageCopyWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ImageCopyWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ImageCopyWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ImageCopy record uniquely */
export type ImageCopyWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Crops the image to the specified dimensions.
 * The starting points for X and Y coordinates are [0,0], aligning with the top-left corner of the image.
 * The width and height parameters determine the size in pixels of the cropping rectangle.
 * The output will include only the portion of the image within the designated crop area.
 */
export type ImageCropInput = {
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height: Scalars['Int']['input'];
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width: Scalars['Int']['input'];
  /** The x coordinate of the image. The value must be an integer from 0 to 10000. */
  x: Scalars['Int']['input'];
  /** The y coordinate of the image. The value must be an integer from 0 to 10000. */
  y: Scalars['Int']['input'];
};

export enum ImageFit {
  /** Resizes the image to fit within the specified parameters without distorting, cropping, or changing the aspect ratio. */
  clip = 'clip',
  /** Resizes the image to fit the specified parameters exactly by removing any parts of the image that don't fit within the boundaries. */
  crop = 'crop',
  /** Resizes the image to fit within the parameters, but as opposed to 'fit:clip' will not scale the image if the image is smaller than the output size. */
  max = 'max',
  /** Resizes the image to fit the specified parameters exactly by scaling the image to the desired size. The aspect ratio of the image is not respected and the image can be distorted using this method. */
  scale = 'scale'
}

export type ImageQualityInput = {
  /** The quality of the image. The value must be an integer from 1 to 100. */
  value: Scalars['Int']['input'];
};

export type ImageResizeInput = {
  /** The default value for the fit parameter is fit:clip. */
  fit?: InputMaybe<ImageFit>;
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageSharpenInput = {
  /** The amount of sharpening to apply to the image. The value must be an integer from 1 to 20. */
  amount: Scalars['Int']['input'];
};

/** Image Text Alignment options */
export enum ImageTextAlignment {
  ImageLeftTextRight = 'ImageLeftTextRight',
  ImageRightTextLeft = 'ImageRightTextLeft'
}

/** Transformations for Images */
export type ImageTransformationInput = {
  /** Blurs the image. */
  blur?: InputMaybe<ImageBlurInput>;
  /** Adds a border to the image. */
  border?: InputMaybe<ImageBorderInput>;
  /** Compresses the image. */
  compress?: InputMaybe<ImageCompressInput>;
  /** Crops the image to the specified dimensions. */
  crop?: InputMaybe<ImageCropInput>;
  /**
   * Changes the quality of the image. The value must be an integer from 1 to 100.
   * Only supported for the following formats jpeg, jpg, webp, gif, heif, tiff, avif.
   */
  quality?: InputMaybe<ImageQualityInput>;
  /** Resizes the image */
  resize?: InputMaybe<ImageResizeInput>;
  /** Sharpens the image. */
  sharpen?: InputMaybe<ImageSharpenInput>;
};

/** Introductory text for quick overview of the page */
export type IntroText = Entity & Node & {
  __typename?: 'IntroText';
  anchorNav?: Maybe<AnchorNavigation>;
  /** Title to be used to find the contents in the CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<IntroText>;
  genericAccordionItems: Array<CorpGenericAccordionItem>;
  genericPages: Array<GenericPage>;
  /** List of IntroText versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** specifies in which component this intro text will be used */
  key?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<IntroText>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  richText?: Maybe<RichText>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  tabContent?: Maybe<TabContent>;
  /** Title field for the title of the component */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Introductory text for quick overview of the page */
export type IntroTextAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Introductory text for quick overview of the page */
export type IntroTextCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Introductory text for quick overview of the page */
export type IntroTextCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Introductory text for quick overview of the page */
export type IntroTextDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Introductory text for quick overview of the page */
export type IntroTextGenericAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericAccordionItemWhereInput>;
};


/** Introductory text for quick overview of the page */
export type IntroTextGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Introductory text for quick overview of the page */
export type IntroTextHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Introductory text for quick overview of the page */
export type IntroTextLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Introductory text for quick overview of the page */
export type IntroTextLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Introductory text for quick overview of the page */
export type IntroTextPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Introductory text for quick overview of the page */
export type IntroTextPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Introductory text for quick overview of the page */
export type IntroTextScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Introductory text for quick overview of the page */
export type IntroTextStoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


/** Introductory text for quick overview of the page */
export type IntroTextTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Introductory text for quick overview of the page */
export type IntroTextUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Introductory text for quick overview of the page */
export type IntroTextUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type IntroTextConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: IntroTextWhereUniqueInput;
};

/** A connection to a list of items. */
export type IntroTextConnection = {
  __typename?: 'IntroTextConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<IntroTextEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type IntroTextCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cl4e6emj307br01xs32g8a3bm?: InputMaybe<CorpStoriesPageCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  key?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<IntroTextCreateLocalizationsInput>;
  /** richText input for default locale (default) */
  richText?: InputMaybe<Scalars['RichTextAST']['input']>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IntroTextCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  richText?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type IntroTextCreateLocalizationInput = {
  /** Localization input */
  data: IntroTextCreateLocalizationDataInput;
  locale: Locale;
};

export type IntroTextCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<IntroTextCreateLocalizationInput>>;
};

export type IntroTextCreateManyInlineInput = {
  /** Connect multiple existing IntroText documents */
  connect?: InputMaybe<Array<IntroTextWhereUniqueInput>>;
  /** Create and connect multiple existing IntroText documents */
  create?: InputMaybe<Array<IntroTextCreateInput>>;
};

export type IntroTextCreateOneInlineInput = {
  /** Connect one existing IntroText document */
  connect?: InputMaybe<IntroTextWhereUniqueInput>;
  /** Create and connect one IntroText document */
  create?: InputMaybe<IntroTextCreateInput>;
};

/** An edge in a connection. */
export type IntroTextEdge = {
  __typename?: 'IntroTextEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: IntroText;
};

/** Identifies documents */
export type IntroTextManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<IntroTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<IntroTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<IntroTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<IntroTextWhereStageInput>;
  documentInStages_none?: InputMaybe<IntroTextWhereStageInput>;
  documentInStages_some?: InputMaybe<IntroTextWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum IntroTextOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  key_ASC = 'key_ASC',
  key_DESC = 'key_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type IntroTextUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cl4e6emj307br01xs32g8a3bm?: InputMaybe<CorpStoriesPageUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  key?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<IntroTextUpdateLocalizationsInput>;
  /** richText input for default locale (default) */
  richText?: InputMaybe<Scalars['RichTextAST']['input']>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IntroTextUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  richText?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IntroTextUpdateLocalizationInput = {
  data: IntroTextUpdateLocalizationDataInput;
  locale: Locale;
};

export type IntroTextUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<IntroTextCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<IntroTextUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<IntroTextUpsertLocalizationInput>>;
};

export type IntroTextUpdateManyInlineInput = {
  /** Connect multiple existing IntroText documents */
  connect?: InputMaybe<Array<IntroTextConnectInput>>;
  /** Create and connect multiple IntroText documents */
  create?: InputMaybe<Array<IntroTextCreateInput>>;
  /** Delete multiple IntroText documents */
  delete?: InputMaybe<Array<IntroTextWhereUniqueInput>>;
  /** Disconnect multiple IntroText documents */
  disconnect?: InputMaybe<Array<IntroTextWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing IntroText documents */
  set?: InputMaybe<Array<IntroTextWhereUniqueInput>>;
  /** Update multiple IntroText documents */
  update?: InputMaybe<Array<IntroTextUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple IntroText documents */
  upsert?: InputMaybe<Array<IntroTextUpsertWithNestedWhereUniqueInput>>;
};

export type IntroTextUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<IntroTextUpdateManyLocalizationsInput>;
  /** richText input for default locale (default) */
  richText?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IntroTextUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  richText?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type IntroTextUpdateManyLocalizationInput = {
  data: IntroTextUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type IntroTextUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<IntroTextUpdateManyLocalizationInput>>;
};

export type IntroTextUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: IntroTextUpdateManyInput;
  /** Document search */
  where: IntroTextWhereInput;
};

export type IntroTextUpdateOneInlineInput = {
  /** Connect existing IntroText document */
  connect?: InputMaybe<IntroTextWhereUniqueInput>;
  /** Create and connect one IntroText document */
  create?: InputMaybe<IntroTextCreateInput>;
  /** Delete currently connected IntroText document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected IntroText document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single IntroText document */
  update?: InputMaybe<IntroTextUpdateWithNestedWhereUniqueInput>;
  /** Upsert single IntroText document */
  upsert?: InputMaybe<IntroTextUpsertWithNestedWhereUniqueInput>;
};

export type IntroTextUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: IntroTextUpdateInput;
  /** Unique document search */
  where: IntroTextWhereUniqueInput;
};

export type IntroTextUpsertInput = {
  /** Create document if it didn't exist */
  create: IntroTextCreateInput;
  /** Update document if it exists */
  update: IntroTextUpdateInput;
};

export type IntroTextUpsertLocalizationInput = {
  create: IntroTextCreateLocalizationDataInput;
  locale: Locale;
  update: IntroTextUpdateLocalizationDataInput;
};

export type IntroTextUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: IntroTextUpsertInput;
  /** Unique document search */
  where: IntroTextWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type IntroTextWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type IntroTextWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<IntroTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<IntroTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<IntroTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<IntroTextWhereStageInput>;
  documentInStages_none?: InputMaybe<IntroTextWhereStageInput>;
  documentInStages_some?: InputMaybe<IntroTextWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type IntroTextWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<IntroTextWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<IntroTextWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<IntroTextWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<IntroTextWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References IntroText record uniquely */
export type IntroTextWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type LeftColumn = Entity & Node & {
  __typename?: 'LeftColumn';
  /** Asset Component for ImageCopy component */
  assetsComponents: Array<AssetComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Left column rich text */
  description?: Maybe<LeftColumnDescriptionRichText>;
  /** Get the document in other stages */
  documentInStages: Array<LeftColumn>;
  /** List of LeftColumn versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Left column title to the rich text */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Video url */
  video?: Maybe<Scalars['String']['output']>;
};


export type LeftColumnAssetsComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentWhereInput>;
};


export type LeftColumnCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LeftColumnDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type LeftColumnHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type LeftColumnPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LeftColumnScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type LeftColumnUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type LeftColumnConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: LeftColumnWhereUniqueInput;
};

/** A connection to a list of items. */
export type LeftColumnConnection = {
  __typename?: 'LeftColumnConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<LeftColumnEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LeftColumnCreateInput = {
  assetsComponents?: InputMaybe<AssetComponentCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type LeftColumnCreateManyInlineInput = {
  /** Connect multiple existing LeftColumn documents */
  connect?: InputMaybe<Array<LeftColumnWhereUniqueInput>>;
  /** Create and connect multiple existing LeftColumn documents */
  create?: InputMaybe<Array<LeftColumnCreateInput>>;
};

export type LeftColumnCreateOneInlineInput = {
  /** Connect one existing LeftColumn document */
  connect?: InputMaybe<LeftColumnWhereUniqueInput>;
  /** Create and connect one LeftColumn document */
  create?: InputMaybe<LeftColumnCreateInput>;
};

export type LeftColumnDescriptionRichText = {
  __typename?: 'LeftColumnDescriptionRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<LeftColumnDescriptionRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type LeftColumnDescriptionRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type LeftColumnDescriptionRichTextEmbeddedTypes = Asset;

/** An edge in a connection. */
export type LeftColumnEdge = {
  __typename?: 'LeftColumnEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LeftColumn;
};

/** Identifies documents */
export type LeftColumnManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LeftColumnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LeftColumnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LeftColumnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LeftColumnWhereStageInput>;
  documentInStages_none?: InputMaybe<LeftColumnWhereStageInput>;
  documentInStages_some?: InputMaybe<LeftColumnWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  video_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  video_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  video_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  video_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  video_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  video_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  video_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  video_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  video_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum LeftColumnOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  video_ASC = 'video_ASC',
  video_DESC = 'video_DESC'
}

export type LeftColumnUpdateInput = {
  assetsComponents?: InputMaybe<AssetComponentUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type LeftColumnUpdateManyInlineInput = {
  /** Connect multiple existing LeftColumn documents */
  connect?: InputMaybe<Array<LeftColumnConnectInput>>;
  /** Create and connect multiple LeftColumn documents */
  create?: InputMaybe<Array<LeftColumnCreateInput>>;
  /** Delete multiple LeftColumn documents */
  delete?: InputMaybe<Array<LeftColumnWhereUniqueInput>>;
  /** Disconnect multiple LeftColumn documents */
  disconnect?: InputMaybe<Array<LeftColumnWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing LeftColumn documents */
  set?: InputMaybe<Array<LeftColumnWhereUniqueInput>>;
  /** Update multiple LeftColumn documents */
  update?: InputMaybe<Array<LeftColumnUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple LeftColumn documents */
  upsert?: InputMaybe<Array<LeftColumnUpsertWithNestedWhereUniqueInput>>;
};

export type LeftColumnUpdateManyInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type LeftColumnUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: LeftColumnUpdateManyInput;
  /** Document search */
  where: LeftColumnWhereInput;
};

export type LeftColumnUpdateOneInlineInput = {
  /** Connect existing LeftColumn document */
  connect?: InputMaybe<LeftColumnWhereUniqueInput>;
  /** Create and connect one LeftColumn document */
  create?: InputMaybe<LeftColumnCreateInput>;
  /** Delete currently connected LeftColumn document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected LeftColumn document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single LeftColumn document */
  update?: InputMaybe<LeftColumnUpdateWithNestedWhereUniqueInput>;
  /** Upsert single LeftColumn document */
  upsert?: InputMaybe<LeftColumnUpsertWithNestedWhereUniqueInput>;
};

export type LeftColumnUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: LeftColumnUpdateInput;
  /** Unique document search */
  where: LeftColumnWhereUniqueInput;
};

export type LeftColumnUpsertInput = {
  /** Create document if it didn't exist */
  create: LeftColumnCreateInput;
  /** Update document if it exists */
  update: LeftColumnUpdateInput;
};

export type LeftColumnUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: LeftColumnUpsertInput;
  /** Unique document search */
  where: LeftColumnWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type LeftColumnWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type LeftColumnWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LeftColumnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LeftColumnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LeftColumnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LeftColumnWhereStageInput>;
  documentInStages_none?: InputMaybe<LeftColumnWhereStageInput>;
  documentInStages_some?: InputMaybe<LeftColumnWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  video_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  video_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  video_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  video_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  video_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  video_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  video_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  video_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  video_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type LeftColumnWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LeftColumnWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LeftColumnWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LeftColumnWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<LeftColumnWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References LeftColumn record uniquely */
export type LeftColumnWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum LeftRight {
  Left = 'Left',
  Right = 'Right'
}

export type Link = Entity & Node & {
  __typename?: 'Link';
  banner?: Maybe<HeroBanner>;
  corpAddToCalendar?: Maybe<CorpAddToCalendar>;
  countrySelectorItems: Array<CountrySelectorItem>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Link text */
  displayName: Scalars['String']['output'];
  /** Get the document in other stages */
  documentInStages: Array<Link>;
  footerNavigation?: Maybe<FooterNavigation>;
  genericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  genericPagesOld: Array<GenericPage>;
  /** List of Link versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  imageAndTextCard?: Maybe<ImageAndTextCard>;
  internalLink?: Maybe<GenericPage>;
  /** Links referencing pages within the CMS */
  internalLinkOld?: Maybe<LinkInernalLink>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Link>;
  /** Navigation Text and link item */
  navigation?: Maybe<Navigation>;
  navigationItems: Array<NavigationItem>;
  openInNewTab: Scalars['Boolean']['output'];
  pressStoriesCard?: Maybe<PressStoriesCard>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** These are the links that sit outside the CMS. Use "/" before any link. Example : /recipes/f1bbcdcd0eb0331fc12579ab00260e4c */
  url?: Maybe<Scalars['String']['output']>;
};


export type LinkBannerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkCorpAddToCalendarArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkCountrySelectorItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountrySelectorItemWhereInput>;
};


export type LinkCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type LinkCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type LinkFooterNavigationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkGenericCardCarouseComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkGenericPagesOldArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type LinkHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type LinkImageAndTextCardArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkInternalLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkInternalLinkOldArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type LinkNavigationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkNavigationItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationItemWhereInput>;
};


export type LinkPressStoriesCardArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type LinkPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type LinkTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LinkUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type LinkUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type LinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: LinkWhereUniqueInput;
};

/** A connection to a list of items. */
export type LinkConnection = {
  __typename?: 'LinkConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<LinkEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LinkCreateInput = {
  banner?: InputMaybe<HeroBannerCreateOneInlineInput>;
  ckruaszxz1vll01xz96vwfsha?: InputMaybe<DeprecatedBanner1CreateManyInlineInput>;
  ckrylru5d1v9f01z83lt98f6n?: InputMaybe<AnchorNavCreateManyInlineInput>;
  cks9cz40s1ygm01z3fqng99fs?: InputMaybe<Banner2CreateManyInlineInput>;
  ckseb3fdw4ip801z3hlfa5rcv?: InputMaybe<AuthorableContentCardCreateManyInlineInput>;
  cksogk5fk1tfq01xn4f3hcue8?: InputMaybe<DynamicCardGridCreateManyInlineInput>;
  cksu33ta65o9t01w95iqyaee9?: InputMaybe<SustainabilityBannerCreateManyInlineInput>;
  ckt8iwjdu2sub01xq6xz381j9?: InputMaybe<ContactCardCreateManyInlineInput>;
  ckuf783zo87n201xh3nwuhxjc?: InputMaybe<NotificationBannerCreateManyInlineInput>;
  ckul9jope2ssv01xq74r806ij?: InputMaybe<SearchOverlayComponentCreateManyInlineInput>;
  cl06ul6ca0mwn01z35vac5zh0?: InputMaybe<CorpNavigationItemCreateManyInlineInput>;
  cl0z69srp4qxh01xp3m071ex3?: InputMaybe<QuickLinkItemCreateManyInlineInput>;
  cl1osaon53c4a01w4cm0156db?: InputMaybe<CorpBanner1CreateManyInlineInput>;
  cl2spuini2xhq01z8fko87dnn?: InputMaybe<IntroTextCreateManyInlineInput>;
  cl2xe8op22hd601z51wurbrai?: InputMaybe<CorpMediaDownloadPreviewCreateManyInlineInput>;
  cl3hglc785z1301z4amgkh3op?: InputMaybe<CorpCardCarouselCreateManyInlineInput>;
  cl9wqrzk8023n01ujce7f9ayv?: InputMaybe<CorpNotificationBannerCreateManyInlineInput>;
  cl1243evq5x2k01z17iioh318?: InputMaybe<CorpHeroCreateManyInlineInput>;
  clzvqz50z005z06uq3ozp9n87?: InputMaybe<CorpVideoHeroCreateManyInlineInput>;
  cm1ns6rxl00gt06ur1fl38w2f?: InputMaybe<CarouselSlideCreateManyInlineInput>;
  corpAddToCalendar?: InputMaybe<CorpAddToCalendarCreateOneInlineInput>;
  countrySelectorItems?: InputMaybe<CountrySelectorItemCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** displayName input for default locale (default) */
  displayName: Scalars['String']['input'];
  footerNavigation?: InputMaybe<FooterNavigationCreateOneInlineInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateOneInlineInput>;
  genericPagesOld?: InputMaybe<GenericPageCreateManyInlineInput>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardCreateOneInlineInput>;
  internalLink?: InputMaybe<GenericPageCreateOneInlineInput>;
  internalLinkOld?: InputMaybe<LinkInernalLinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<LinkCreateLocalizationsInput>;
  navigation?: InputMaybe<NavigationCreateOneInlineInput>;
  navigationItems?: InputMaybe<NavigationItemCreateManyInlineInput>;
  openInNewTab: Scalars['Boolean']['input'];
  pressStoriesCard?: InputMaybe<PressStoriesCardCreateOneInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** url input for default locale (default) */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LinkCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  displayName: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LinkCreateLocalizationInput = {
  /** Localization input */
  data: LinkCreateLocalizationDataInput;
  locale: Locale;
};

export type LinkCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<LinkCreateLocalizationInput>>;
};

export type LinkCreateManyInlineInput = {
  /** Connect multiple existing Link documents */
  connect?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Create and connect multiple existing Link documents */
  create?: InputMaybe<Array<LinkCreateInput>>;
};

export type LinkCreateOneInlineInput = {
  /** Connect one existing Link document */
  connect?: InputMaybe<LinkWhereUniqueInput>;
  /** Create and connect one Link document */
  create?: InputMaybe<LinkCreateInput>;
};

/** An edge in a connection. */
export type LinkEdge = {
  __typename?: 'LinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Link;
};

export type LinkInernalLink = GenericPage;

export type LinkInernalLinkConnectInput = {
  GenericPage?: InputMaybe<GenericPageConnectInput>;
};

export type LinkInernalLinkCreateInput = {
  GenericPage?: InputMaybe<GenericPageCreateInput>;
};

export type LinkInernalLinkCreateManyInlineInput = {
  /** Connect multiple existing LinkInernalLink documents */
  connect?: InputMaybe<Array<LinkInernalLinkWhereUniqueInput>>;
  /** Create and connect multiple existing LinkInernalLink documents */
  create?: InputMaybe<Array<LinkInernalLinkCreateInput>>;
};

export type LinkInernalLinkCreateOneInlineInput = {
  /** Connect one existing LinkInernalLink document */
  connect?: InputMaybe<LinkInernalLinkWhereUniqueInput>;
  /** Create and connect one LinkInernalLink document */
  create?: InputMaybe<LinkInernalLinkCreateInput>;
};

export type LinkInernalLinkUpdateInput = {
  GenericPage?: InputMaybe<GenericPageUpdateInput>;
};

export type LinkInernalLinkUpdateManyInlineInput = {
  /** Connect multiple existing LinkInernalLink documents */
  connect?: InputMaybe<Array<LinkInernalLinkConnectInput>>;
  /** Create and connect multiple LinkInernalLink documents */
  create?: InputMaybe<Array<LinkInernalLinkCreateInput>>;
  /** Delete multiple LinkInernalLink documents */
  delete?: InputMaybe<Array<LinkInernalLinkWhereUniqueInput>>;
  /** Disconnect multiple LinkInernalLink documents */
  disconnect?: InputMaybe<Array<LinkInernalLinkWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing LinkInernalLink documents */
  set?: InputMaybe<Array<LinkInernalLinkWhereUniqueInput>>;
  /** Update multiple LinkInernalLink documents */
  update?: InputMaybe<Array<LinkInernalLinkUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple LinkInernalLink documents */
  upsert?: InputMaybe<Array<LinkInernalLinkUpsertWithNestedWhereUniqueInput>>;
};

export type LinkInernalLinkUpdateManyWithNestedWhereInput = {
  GenericPage?: InputMaybe<GenericPageUpdateManyWithNestedWhereInput>;
};

export type LinkInernalLinkUpdateOneInlineInput = {
  /** Connect existing LinkInernalLink document */
  connect?: InputMaybe<LinkInernalLinkWhereUniqueInput>;
  /** Create and connect one LinkInernalLink document */
  create?: InputMaybe<LinkInernalLinkCreateInput>;
  /** Delete currently connected LinkInernalLink document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected LinkInernalLink document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single LinkInernalLink document */
  update?: InputMaybe<LinkInernalLinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single LinkInernalLink document */
  upsert?: InputMaybe<LinkInernalLinkUpsertWithNestedWhereUniqueInput>;
};

export type LinkInernalLinkUpdateWithNestedWhereUniqueInput = {
  GenericPage?: InputMaybe<GenericPageUpdateWithNestedWhereUniqueInput>;
};

export type LinkInernalLinkUpsertWithNestedWhereUniqueInput = {
  GenericPage?: InputMaybe<GenericPageUpsertWithNestedWhereUniqueInput>;
};

export type LinkInernalLinkWhereInput = {
  GenericPage?: InputMaybe<GenericPageWhereInput>;
};

export type LinkInernalLinkWhereUniqueInput = {
  GenericPage?: InputMaybe<GenericPageWhereUniqueInput>;
};

/** Identifies documents */
export type LinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<HeroBannerWhereInput>;
  corpAddToCalendar?: InputMaybe<CorpAddToCalendarWhereInput>;
  countrySelectorItems_every?: InputMaybe<CountrySelectorItemWhereInput>;
  countrySelectorItems_none?: InputMaybe<CountrySelectorItemWhereInput>;
  countrySelectorItems_some?: InputMaybe<CountrySelectorItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LinkWhereStageInput>;
  documentInStages_none?: InputMaybe<LinkWhereStageInput>;
  documentInStages_some?: InputMaybe<LinkWhereStageInput>;
  footerNavigation?: InputMaybe<FooterNavigationWhereInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericPagesOld_every?: InputMaybe<GenericPageWhereInput>;
  genericPagesOld_none?: InputMaybe<GenericPageWhereInput>;
  genericPagesOld_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardWhereInput>;
  internalLink?: InputMaybe<GenericPageWhereInput>;
  /** All values in which the union is connected to the given models */
  internalLinkOld?: InputMaybe<LinkInernalLinkWhereInput>;
  /** All values in which the union is empty */
  internalLinkOld_empty?: InputMaybe<Scalars['Boolean']['input']>;
  navigation?: InputMaybe<NavigationWhereInput>;
  navigationItems_every?: InputMaybe<NavigationItemWhereInput>;
  navigationItems_none?: InputMaybe<NavigationItemWhereInput>;
  navigationItems_some?: InputMaybe<NavigationItemWhereInput>;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  openInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  pressStoriesCard?: InputMaybe<PressStoriesCardWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum LinkOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  displayName_ASC = 'displayName_ASC',
  displayName_DESC = 'displayName_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  openInNewTab_ASC = 'openInNewTab_ASC',
  openInNewTab_DESC = 'openInNewTab_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC'
}

export type LinkUpdateInput = {
  banner?: InputMaybe<HeroBannerUpdateOneInlineInput>;
  ckruaszxz1vll01xz96vwfsha?: InputMaybe<DeprecatedBanner1UpdateManyInlineInput>;
  ckrylru5d1v9f01z83lt98f6n?: InputMaybe<AnchorNavUpdateManyInlineInput>;
  cks9cz40s1ygm01z3fqng99fs?: InputMaybe<Banner2UpdateManyInlineInput>;
  ckseb3fdw4ip801z3hlfa5rcv?: InputMaybe<AuthorableContentCardUpdateManyInlineInput>;
  cksogk5fk1tfq01xn4f3hcue8?: InputMaybe<DynamicCardGridUpdateManyInlineInput>;
  cksu33ta65o9t01w95iqyaee9?: InputMaybe<SustainabilityBannerUpdateManyInlineInput>;
  ckt8iwjdu2sub01xq6xz381j9?: InputMaybe<ContactCardUpdateManyInlineInput>;
  ckuf783zo87n201xh3nwuhxjc?: InputMaybe<NotificationBannerUpdateManyInlineInput>;
  ckul9jope2ssv01xq74r806ij?: InputMaybe<SearchOverlayComponentUpdateManyInlineInput>;
  cl06ul6ca0mwn01z35vac5zh0?: InputMaybe<CorpNavigationItemUpdateManyInlineInput>;
  cl0z69srp4qxh01xp3m071ex3?: InputMaybe<QuickLinkItemUpdateManyInlineInput>;
  cl1osaon53c4a01w4cm0156db?: InputMaybe<CorpBanner1UpdateManyInlineInput>;
  cl2spuini2xhq01z8fko87dnn?: InputMaybe<IntroTextUpdateManyInlineInput>;
  cl2xe8op22hd601z51wurbrai?: InputMaybe<CorpMediaDownloadPreviewUpdateManyInlineInput>;
  cl3hglc785z1301z4amgkh3op?: InputMaybe<CorpCardCarouselUpdateManyInlineInput>;
  cl9wqrzk8023n01ujce7f9ayv?: InputMaybe<CorpNotificationBannerUpdateManyInlineInput>;
  cl1243evq5x2k01z17iioh318?: InputMaybe<CorpHeroUpdateManyInlineInput>;
  clzvqz50z005z06uq3ozp9n87?: InputMaybe<CorpVideoHeroUpdateManyInlineInput>;
  cm1ns6rxl00gt06ur1fl38w2f?: InputMaybe<CarouselSlideUpdateManyInlineInput>;
  corpAddToCalendar?: InputMaybe<CorpAddToCalendarUpdateOneInlineInput>;
  countrySelectorItems?: InputMaybe<CountrySelectorItemUpdateManyInlineInput>;
  /** displayName input for default locale (default) */
  displayName?: InputMaybe<Scalars['String']['input']>;
  footerNavigation?: InputMaybe<FooterNavigationUpdateOneInlineInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateOneInlineInput>;
  genericPagesOld?: InputMaybe<GenericPageUpdateManyInlineInput>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardUpdateOneInlineInput>;
  internalLink?: InputMaybe<GenericPageUpdateOneInlineInput>;
  internalLinkOld?: InputMaybe<LinkInernalLinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<LinkUpdateLocalizationsInput>;
  navigation?: InputMaybe<NavigationUpdateOneInlineInput>;
  navigationItems?: InputMaybe<NavigationItemUpdateManyInlineInput>;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  pressStoriesCard?: InputMaybe<PressStoriesCardUpdateOneInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  /** url input for default locale (default) */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LinkUpdateLocalizationDataInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LinkUpdateLocalizationInput = {
  data: LinkUpdateLocalizationDataInput;
  locale: Locale;
};

export type LinkUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<LinkCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<LinkUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<LinkUpsertLocalizationInput>>;
};

export type LinkUpdateManyInlineInput = {
  /** Connect multiple existing Link documents */
  connect?: InputMaybe<Array<LinkConnectInput>>;
  /** Create and connect multiple Link documents */
  create?: InputMaybe<Array<LinkCreateInput>>;
  /** Delete multiple Link documents */
  delete?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Disconnect multiple Link documents */
  disconnect?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Link documents */
  set?: InputMaybe<Array<LinkWhereUniqueInput>>;
  /** Update multiple Link documents */
  update?: InputMaybe<Array<LinkUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Link documents */
  upsert?: InputMaybe<Array<LinkUpsertWithNestedWhereUniqueInput>>;
};

export type LinkUpdateManyInput = {
  /** displayName input for default locale (default) */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<LinkUpdateManyLocalizationsInput>;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  /** url input for default locale (default) */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LinkUpdateManyLocalizationDataInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LinkUpdateManyLocalizationInput = {
  data: LinkUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type LinkUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<LinkUpdateManyLocalizationInput>>;
};

export type LinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: LinkUpdateManyInput;
  /** Document search */
  where: LinkWhereInput;
};

export type LinkUpdateOneInlineInput = {
  /** Connect existing Link document */
  connect?: InputMaybe<LinkWhereUniqueInput>;
  /** Create and connect one Link document */
  create?: InputMaybe<LinkCreateInput>;
  /** Delete currently connected Link document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Link document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Link document */
  update?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Link document */
  upsert?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
};

export type LinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: LinkUpdateInput;
  /** Unique document search */
  where: LinkWhereUniqueInput;
};

export type LinkUpsertInput = {
  /** Create document if it didn't exist */
  create: LinkCreateInput;
  /** Update document if it exists */
  update: LinkUpdateInput;
};

export type LinkUpsertLocalizationInput = {
  create: LinkCreateLocalizationDataInput;
  locale: Locale;
  update: LinkUpdateLocalizationDataInput;
};

export type LinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: LinkUpsertInput;
  /** Unique document search */
  where: LinkWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type LinkWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type LinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<HeroBannerWhereInput>;
  corpAddToCalendar?: InputMaybe<CorpAddToCalendarWhereInput>;
  countrySelectorItems_every?: InputMaybe<CountrySelectorItemWhereInput>;
  countrySelectorItems_none?: InputMaybe<CountrySelectorItemWhereInput>;
  countrySelectorItems_some?: InputMaybe<CountrySelectorItemWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  displayName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  displayName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  displayName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  displayName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  displayName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  displayName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  displayName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  displayName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  displayName_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<LinkWhereStageInput>;
  documentInStages_none?: InputMaybe<LinkWhereStageInput>;
  documentInStages_some?: InputMaybe<LinkWhereStageInput>;
  footerNavigation?: InputMaybe<FooterNavigationWhereInput>;
  genericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  genericPagesOld_every?: InputMaybe<GenericPageWhereInput>;
  genericPagesOld_none?: InputMaybe<GenericPageWhereInput>;
  genericPagesOld_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageAndTextCard?: InputMaybe<ImageAndTextCardWhereInput>;
  internalLink?: InputMaybe<GenericPageWhereInput>;
  /** All values in which the union is connected to the given models */
  internalLinkOld?: InputMaybe<LinkInernalLinkWhereInput>;
  /** All values in which the union is empty */
  internalLinkOld_empty?: InputMaybe<Scalars['Boolean']['input']>;
  navigation?: InputMaybe<NavigationWhereInput>;
  navigationItems_every?: InputMaybe<NavigationItemWhereInput>;
  navigationItems_none?: InputMaybe<NavigationItemWhereInput>;
  navigationItems_some?: InputMaybe<NavigationItemWhereInput>;
  openInNewTab?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  openInNewTab_not?: InputMaybe<Scalars['Boolean']['input']>;
  pressStoriesCard?: InputMaybe<PressStoriesCardWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type LinkWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LinkWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LinkWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LinkWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<LinkWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Link record uniquely */
export type LinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Locale system enumeration */
export enum Locale {
  at = 'at',
  au = 'au',
  br = 'br',
  ch = 'ch',
  de = 'de',
  /** System locale */
  default = 'default',
  fr_TN = 'fr_TN',
  it = 'it',
  tr = 'tr',
  tr_TR = 'tr_TR'
}

export enum Locales {
  au = 'au',
  br = 'br',
  de_AT = 'de_AT',
  de_DE = 'de_DE',
  en = 'en',
  en_GB = 'en_GB',
  es_ES = 'es_ES',
  fr_FR = 'fr_FR',
  it_IT = 'it_IT',
  pl_PL = 'pl_PL'
}

/** Representing a geolocation point with latitude and longitude */
export type Location = {
  __typename?: 'Location';
  distance: Scalars['Float']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};


/** Representing a geolocation point with latitude and longitude */
export type LocationDistanceArgs = {
  from: LocationInput;
};

/** Component to show all company locations */
export type LocationComponent = Entity & Node & {
  __typename?: 'LocationComponent';
  anchorNav?: Maybe<AnchorNavigation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<LocationComponent>;
  genericPages: Array<GenericPage>;
  /** List of LocationComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  locationItems: Array<LocationItem>;
  mapAllSites?: Maybe<AssetComponent>;
  mapProductionSites?: Maybe<AssetComponent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Component to show all company locations */
export type LocationComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Component to show all company locations */
export type LocationComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Component to show all company locations */
export type LocationComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Component to show all company locations */
export type LocationComponentGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Component to show all company locations */
export type LocationComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Component to show all company locations */
export type LocationComponentLocationItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LocationItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LocationItemWhereInput>;
};


/** Component to show all company locations */
export type LocationComponentMapAllSitesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Component to show all company locations */
export type LocationComponentMapProductionSitesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Component to show all company locations */
export type LocationComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Component to show all company locations */
export type LocationComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Component to show all company locations */
export type LocationComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type LocationComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: LocationComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type LocationComponentConnection = {
  __typename?: 'LocationComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<LocationComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LocationComponentCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  locationItems?: InputMaybe<LocationItemCreateManyInlineInput>;
  mapAllSites?: InputMaybe<AssetComponentCreateOneInlineInput>;
  mapProductionSites?: InputMaybe<AssetComponentCreateOneInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LocationComponentCreateManyInlineInput = {
  /** Connect multiple existing LocationComponent documents */
  connect?: InputMaybe<Array<LocationComponentWhereUniqueInput>>;
  /** Create and connect multiple existing LocationComponent documents */
  create?: InputMaybe<Array<LocationComponentCreateInput>>;
};

export type LocationComponentCreateOneInlineInput = {
  /** Connect one existing LocationComponent document */
  connect?: InputMaybe<LocationComponentWhereUniqueInput>;
  /** Create and connect one LocationComponent document */
  create?: InputMaybe<LocationComponentCreateInput>;
};

/** An edge in a connection. */
export type LocationComponentEdge = {
  __typename?: 'LocationComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LocationComponent;
};

/** Identifies documents */
export type LocationComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LocationComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LocationComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LocationComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LocationComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<LocationComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<LocationComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  locationItems_every?: InputMaybe<LocationItemWhereInput>;
  locationItems_none?: InputMaybe<LocationItemWhereInput>;
  locationItems_some?: InputMaybe<LocationItemWhereInput>;
  mapAllSites?: InputMaybe<AssetComponentWhereInput>;
  mapProductionSites?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum LocationComponentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type LocationComponentUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  locationItems?: InputMaybe<LocationItemUpdateManyInlineInput>;
  mapAllSites?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  mapProductionSites?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LocationComponentUpdateManyInlineInput = {
  /** Connect multiple existing LocationComponent documents */
  connect?: InputMaybe<Array<LocationComponentConnectInput>>;
  /** Create and connect multiple LocationComponent documents */
  create?: InputMaybe<Array<LocationComponentCreateInput>>;
  /** Delete multiple LocationComponent documents */
  delete?: InputMaybe<Array<LocationComponentWhereUniqueInput>>;
  /** Disconnect multiple LocationComponent documents */
  disconnect?: InputMaybe<Array<LocationComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing LocationComponent documents */
  set?: InputMaybe<Array<LocationComponentWhereUniqueInput>>;
  /** Update multiple LocationComponent documents */
  update?: InputMaybe<Array<LocationComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple LocationComponent documents */
  upsert?: InputMaybe<Array<LocationComponentUpsertWithNestedWhereUniqueInput>>;
};

export type LocationComponentUpdateManyInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type LocationComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: LocationComponentUpdateManyInput;
  /** Document search */
  where: LocationComponentWhereInput;
};

export type LocationComponentUpdateOneInlineInput = {
  /** Connect existing LocationComponent document */
  connect?: InputMaybe<LocationComponentWhereUniqueInput>;
  /** Create and connect one LocationComponent document */
  create?: InputMaybe<LocationComponentCreateInput>;
  /** Delete currently connected LocationComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected LocationComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single LocationComponent document */
  update?: InputMaybe<LocationComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single LocationComponent document */
  upsert?: InputMaybe<LocationComponentUpsertWithNestedWhereUniqueInput>;
};

export type LocationComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: LocationComponentUpdateInput;
  /** Unique document search */
  where: LocationComponentWhereUniqueInput;
};

export type LocationComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: LocationComponentCreateInput;
  /** Update document if it exists */
  update: LocationComponentUpdateInput;
};

export type LocationComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: LocationComponentUpsertInput;
  /** Unique document search */
  where: LocationComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type LocationComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type LocationComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LocationComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LocationComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LocationComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LocationComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<LocationComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<LocationComponentWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  locationItems_every?: InputMaybe<LocationItemWhereInput>;
  locationItems_none?: InputMaybe<LocationItemWhereInput>;
  locationItems_some?: InputMaybe<LocationItemWhereInput>;
  mapAllSites?: InputMaybe<AssetComponentWhereInput>;
  mapProductionSites?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type LocationComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LocationComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LocationComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LocationComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<LocationComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References LocationComponent record uniquely */
export type LocationComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for a geolocation point with latitude and longitude */
export type LocationInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

/** Single location */
export type LocationItem = Entity & Node & {
  __typename?: 'LocationItem';
  bodyComponents: Array<LocationItemBodyComponents>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<LocationItem>;
  /** List of LocationItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Determines if the location is a production site */
  isProductionSite?: Maybe<Scalars['Boolean']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<LocationItem>;
  locationName?: Maybe<Scalars['String']['output']>;
  numberOfEmployees: Scalars['Int']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Single location */
export type LocationItemBodyComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Single location */
export type LocationItemCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Single location */
export type LocationItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Single location */
export type LocationItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Single location */
export type LocationItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Single location */
export type LocationItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Single location */
export type LocationItemPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Single location */
export type LocationItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Single location */
export type LocationItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Single location */
export type LocationItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Single location */
export type LocationItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type LocationItemBodyComponents = CorpContactCardContainer | CorpGenericContainer | CorpGridColumnComponent | ImageCopy | LongText | QuickLink | Spacer;

export type LocationItemBodyComponentsConnectInput = {
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerConnectInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerConnectInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentConnectInput>;
  ImageCopy?: InputMaybe<ImageCopyConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
  QuickLink?: InputMaybe<QuickLinkConnectInput>;
  Spacer?: InputMaybe<SpacerConnectInput>;
};

export type LocationItemBodyComponentsCreateInput = {
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerCreateInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerCreateInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentCreateInput>;
  ImageCopy?: InputMaybe<ImageCopyCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
  QuickLink?: InputMaybe<QuickLinkCreateInput>;
  Spacer?: InputMaybe<SpacerCreateInput>;
};

export type LocationItemBodyComponentsCreateManyInlineInput = {
  /** Connect multiple existing LocationItemBodyComponents documents */
  connect?: InputMaybe<Array<LocationItemBodyComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing LocationItemBodyComponents documents */
  create?: InputMaybe<Array<LocationItemBodyComponentsCreateInput>>;
};

export type LocationItemBodyComponentsCreateOneInlineInput = {
  /** Connect one existing LocationItemBodyComponents document */
  connect?: InputMaybe<LocationItemBodyComponentsWhereUniqueInput>;
  /** Create and connect one LocationItemBodyComponents document */
  create?: InputMaybe<LocationItemBodyComponentsCreateInput>;
};

export type LocationItemBodyComponentsUpdateInput = {
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpdateInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateInput>;
  Spacer?: InputMaybe<SpacerUpdateInput>;
};

export type LocationItemBodyComponentsUpdateManyInlineInput = {
  /** Connect multiple existing LocationItemBodyComponents documents */
  connect?: InputMaybe<Array<LocationItemBodyComponentsConnectInput>>;
  /** Create and connect multiple LocationItemBodyComponents documents */
  create?: InputMaybe<Array<LocationItemBodyComponentsCreateInput>>;
  /** Delete multiple LocationItemBodyComponents documents */
  delete?: InputMaybe<Array<LocationItemBodyComponentsWhereUniqueInput>>;
  /** Disconnect multiple LocationItemBodyComponents documents */
  disconnect?: InputMaybe<Array<LocationItemBodyComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing LocationItemBodyComponents documents */
  set?: InputMaybe<Array<LocationItemBodyComponentsWhereUniqueInput>>;
  /** Update multiple LocationItemBodyComponents documents */
  update?: InputMaybe<Array<LocationItemBodyComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple LocationItemBodyComponents documents */
  upsert?: InputMaybe<Array<LocationItemBodyComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type LocationItemBodyComponentsUpdateManyWithNestedWhereInput = {
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpdateManyWithNestedWhereInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateManyWithNestedWhereInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateManyWithNestedWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateManyWithNestedWhereInput>;
  Spacer?: InputMaybe<SpacerUpdateManyWithNestedWhereInput>;
};

export type LocationItemBodyComponentsUpdateOneInlineInput = {
  /** Connect existing LocationItemBodyComponents document */
  connect?: InputMaybe<LocationItemBodyComponentsWhereUniqueInput>;
  /** Create and connect one LocationItemBodyComponents document */
  create?: InputMaybe<LocationItemBodyComponentsCreateInput>;
  /** Delete currently connected LocationItemBodyComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected LocationItemBodyComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single LocationItemBodyComponents document */
  update?: InputMaybe<LocationItemBodyComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single LocationItemBodyComponents document */
  upsert?: InputMaybe<LocationItemBodyComponentsUpsertWithNestedWhereUniqueInput>;
};

export type LocationItemBodyComponentsUpdateWithNestedWhereUniqueInput = {
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpdateWithNestedWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateWithNestedWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpdateWithNestedWhereUniqueInput>;
};

export type LocationItemBodyComponentsUpsertWithNestedWhereUniqueInput = {
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpsertWithNestedWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpsertWithNestedWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpsertWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkUpsertWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpsertWithNestedWhereUniqueInput>;
};

export type LocationItemBodyComponentsWhereInput = {
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerWhereInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerWhereInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
  QuickLink?: InputMaybe<QuickLinkWhereInput>;
  Spacer?: InputMaybe<SpacerWhereInput>;
};

export type LocationItemBodyComponentsWhereUniqueInput = {
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerWhereUniqueInput>;
};

export type LocationItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: LocationItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type LocationItemConnection = {
  __typename?: 'LocationItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<LocationItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LocationItemCreateInput = {
  bodyComponents?: InputMaybe<LocationItemBodyComponentsCreateManyInlineInput>;
  ckxsulxwd28yp01z38ot1hrrn?: InputMaybe<LocationComponentCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** date input for default locale (default) */
  date?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  isProductionSite?: InputMaybe<Scalars['Boolean']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<LocationItemCreateLocalizationsInput>;
  /** locationName input for default locale (default) */
  locationName?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LocationItemCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LocationItemCreateLocalizationInput = {
  /** Localization input */
  data: LocationItemCreateLocalizationDataInput;
  locale: Locale;
};

export type LocationItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<LocationItemCreateLocalizationInput>>;
};

export type LocationItemCreateManyInlineInput = {
  /** Connect multiple existing LocationItem documents */
  connect?: InputMaybe<Array<LocationItemWhereUniqueInput>>;
  /** Create and connect multiple existing LocationItem documents */
  create?: InputMaybe<Array<LocationItemCreateInput>>;
};

export type LocationItemCreateOneInlineInput = {
  /** Connect one existing LocationItem document */
  connect?: InputMaybe<LocationItemWhereUniqueInput>;
  /** Create and connect one LocationItem document */
  create?: InputMaybe<LocationItemCreateInput>;
};

/** An edge in a connection. */
export type LocationItemEdge = {
  __typename?: 'LocationItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LocationItem;
};

/** Identifies documents */
export type LocationItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LocationItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LocationItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LocationItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  bodyComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  bodyComponents_some?: InputMaybe<LocationItemBodyComponentsWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LocationItemWhereStageInput>;
  documentInStages_none?: InputMaybe<LocationItemWhereStageInput>;
  documentInStages_some?: InputMaybe<LocationItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isProductionSite?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isProductionSite_not?: InputMaybe<Scalars['Boolean']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  numberOfEmployees_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  numberOfEmployees_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  numberOfEmployees_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  numberOfEmployees_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  numberOfEmployees_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  numberOfEmployees_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  numberOfEmployees_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum LocationItemOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  date_ASC = 'date_ASC',
  date_DESC = 'date_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isProductionSite_ASC = 'isProductionSite_ASC',
  isProductionSite_DESC = 'isProductionSite_DESC',
  locationName_ASC = 'locationName_ASC',
  locationName_DESC = 'locationName_DESC',
  numberOfEmployees_ASC = 'numberOfEmployees_ASC',
  numberOfEmployees_DESC = 'numberOfEmployees_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type LocationItemUpdateInput = {
  bodyComponents?: InputMaybe<LocationItemBodyComponentsUpdateManyInlineInput>;
  ckxsulxwd28yp01z38ot1hrrn?: InputMaybe<LocationComponentUpdateManyInlineInput>;
  /** date input for default locale (default) */
  date?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  isProductionSite?: InputMaybe<Scalars['Boolean']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<LocationItemUpdateLocalizationsInput>;
  /** locationName input for default locale (default) */
  locationName?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationItemUpdateLocalizationDataInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
};

export type LocationItemUpdateLocalizationInput = {
  data: LocationItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type LocationItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<LocationItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<LocationItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<LocationItemUpsertLocalizationInput>>;
};

export type LocationItemUpdateManyInlineInput = {
  /** Connect multiple existing LocationItem documents */
  connect?: InputMaybe<Array<LocationItemConnectInput>>;
  /** Create and connect multiple LocationItem documents */
  create?: InputMaybe<Array<LocationItemCreateInput>>;
  /** Delete multiple LocationItem documents */
  delete?: InputMaybe<Array<LocationItemWhereUniqueInput>>;
  /** Disconnect multiple LocationItem documents */
  disconnect?: InputMaybe<Array<LocationItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing LocationItem documents */
  set?: InputMaybe<Array<LocationItemWhereUniqueInput>>;
  /** Update multiple LocationItem documents */
  update?: InputMaybe<Array<LocationItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple LocationItem documents */
  upsert?: InputMaybe<Array<LocationItemUpsertWithNestedWhereUniqueInput>>;
};

export type LocationItemUpdateManyInput = {
  /** date input for default locale (default) */
  date?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  isProductionSite?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<LocationItemUpdateManyLocalizationsInput>;
  /** locationName input for default locale (default) */
  locationName?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationItemUpdateManyLocalizationDataInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
};

export type LocationItemUpdateManyLocalizationInput = {
  data: LocationItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type LocationItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<LocationItemUpdateManyLocalizationInput>>;
};

export type LocationItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: LocationItemUpdateManyInput;
  /** Document search */
  where: LocationItemWhereInput;
};

export type LocationItemUpdateOneInlineInput = {
  /** Connect existing LocationItem document */
  connect?: InputMaybe<LocationItemWhereUniqueInput>;
  /** Create and connect one LocationItem document */
  create?: InputMaybe<LocationItemCreateInput>;
  /** Delete currently connected LocationItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected LocationItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single LocationItem document */
  update?: InputMaybe<LocationItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single LocationItem document */
  upsert?: InputMaybe<LocationItemUpsertWithNestedWhereUniqueInput>;
};

export type LocationItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: LocationItemUpdateInput;
  /** Unique document search */
  where: LocationItemWhereUniqueInput;
};

export type LocationItemUpsertInput = {
  /** Create document if it didn't exist */
  create: LocationItemCreateInput;
  /** Update document if it exists */
  update: LocationItemUpdateInput;
};

export type LocationItemUpsertLocalizationInput = {
  create: LocationItemCreateLocalizationDataInput;
  locale: Locale;
  update: LocationItemUpdateLocalizationDataInput;
};

export type LocationItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: LocationItemUpsertInput;
  /** Unique document search */
  where: LocationItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type LocationItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type LocationItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LocationItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LocationItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LocationItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  bodyComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  bodyComponents_some?: InputMaybe<LocationItemBodyComponentsWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  date?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  date_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  date_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  date_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  date_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  date_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  date_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  date_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  date_starts_with?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<LocationItemWhereStageInput>;
  documentInStages_none?: InputMaybe<LocationItemWhereStageInput>;
  documentInStages_some?: InputMaybe<LocationItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isProductionSite?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isProductionSite_not?: InputMaybe<Scalars['Boolean']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  locationName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  locationName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  locationName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  locationName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  locationName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  locationName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  locationName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  locationName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  locationName_starts_with?: InputMaybe<Scalars['String']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  numberOfEmployees_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  numberOfEmployees_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  numberOfEmployees_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  numberOfEmployees_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  numberOfEmployees_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  numberOfEmployees_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  numberOfEmployees_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type LocationItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LocationItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LocationItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LocationItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<LocationItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References LocationItem record uniquely */
export type LocationItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type LongText = Entity & Node & {
  __typename?: 'LongText';
  anchorNav?: Maybe<AnchorNavigation>;
  /** Title to be used to find the contents in the CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<LongText>;
  genericAccordionItems: Array<CorpGenericAccordionItem>;
  genericPages: Array<GenericPage>;
  /** List of LongText versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<LongText>;
  locationItem?: Maybe<LocationItem>;
  /** Long rich text field */
  longText?: Maybe<LongTextLongTextRichText>;
  mediaLibrary?: Maybe<MediaLibrary>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  tabContent?: Maybe<TabContent>;
  theme?: Maybe<CorpColorThemeName>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type LongTextAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LongTextCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type LongTextCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LongTextDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type LongTextGenericAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericAccordionItemWhereInput>;
};


export type LongTextGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type LongTextHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type LongTextLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type LongTextLocationItemArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LongTextMediaLibraryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LongTextPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type LongTextPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LongTextScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type LongTextStoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


export type LongTextTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type LongTextUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type LongTextUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type LongTextConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: LongTextWhereUniqueInput;
};

/** A connection to a list of items. */
export type LongTextConnection = {
  __typename?: 'LongTextConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<LongTextEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type LongTextCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cl470kz4g2tlf01z3eo8mdugw?: InputMaybe<CorpFormCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<LongTextCreateLocalizationsInput>;
  locationItem?: InputMaybe<LocationItemCreateOneInlineInput>;
  /** longText input for default locale (default) */
  longText?: InputMaybe<Scalars['RichTextAST']['input']>;
  mediaLibrary?: InputMaybe<MediaLibraryCreateOneInlineInput>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  theme?: InputMaybe<CorpColorThemeName>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LongTextCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  longText?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type LongTextCreateLocalizationInput = {
  /** Localization input */
  data: LongTextCreateLocalizationDataInput;
  locale: Locale;
};

export type LongTextCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<LongTextCreateLocalizationInput>>;
};

export type LongTextCreateManyInlineInput = {
  /** Connect multiple existing LongText documents */
  connect?: InputMaybe<Array<LongTextWhereUniqueInput>>;
  /** Create and connect multiple existing LongText documents */
  create?: InputMaybe<Array<LongTextCreateInput>>;
};

export type LongTextCreateOneInlineInput = {
  /** Connect one existing LongText document */
  connect?: InputMaybe<LongTextWhereUniqueInput>;
  /** Create and connect one LongText document */
  create?: InputMaybe<LongTextCreateInput>;
};

/** An edge in a connection. */
export type LongTextEdge = {
  __typename?: 'LongTextEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LongText;
};

export type LongTextLongTextRichText = {
  __typename?: 'LongTextLongTextRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<LongTextLongTextRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type LongTextLongTextRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type LongTextLongTextRichTextEmbeddedTypes = Asset | Widget;

/** Identifies documents */
export type LongTextManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LongTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LongTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LongTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LongTextWhereStageInput>;
  documentInStages_none?: InputMaybe<LongTextWhereStageInput>;
  documentInStages_some?: InputMaybe<LongTextWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  locationItem?: InputMaybe<LocationItemWhereInput>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  theme?: InputMaybe<CorpColorThemeName>;
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<CorpColorThemeName>;
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum LongTextOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  theme_ASC = 'theme_ASC',
  theme_DESC = 'theme_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type LongTextUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cl470kz4g2tlf01z3eo8mdugw?: InputMaybe<CorpFormUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<LongTextUpdateLocalizationsInput>;
  locationItem?: InputMaybe<LocationItemUpdateOneInlineInput>;
  /** longText input for default locale (default) */
  longText?: InputMaybe<Scalars['RichTextAST']['input']>;
  mediaLibrary?: InputMaybe<MediaLibraryUpdateOneInlineInput>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  theme?: InputMaybe<CorpColorThemeName>;
};

export type LongTextUpdateLocalizationDataInput = {
  longText?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type LongTextUpdateLocalizationInput = {
  data: LongTextUpdateLocalizationDataInput;
  locale: Locale;
};

export type LongTextUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<LongTextCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<LongTextUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<LongTextUpsertLocalizationInput>>;
};

export type LongTextUpdateManyInlineInput = {
  /** Connect multiple existing LongText documents */
  connect?: InputMaybe<Array<LongTextConnectInput>>;
  /** Create and connect multiple LongText documents */
  create?: InputMaybe<Array<LongTextCreateInput>>;
  /** Delete multiple LongText documents */
  delete?: InputMaybe<Array<LongTextWhereUniqueInput>>;
  /** Disconnect multiple LongText documents */
  disconnect?: InputMaybe<Array<LongTextWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing LongText documents */
  set?: InputMaybe<Array<LongTextWhereUniqueInput>>;
  /** Update multiple LongText documents */
  update?: InputMaybe<Array<LongTextUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple LongText documents */
  upsert?: InputMaybe<Array<LongTextUpsertWithNestedWhereUniqueInput>>;
};

export type LongTextUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<LongTextUpdateManyLocalizationsInput>;
  /** longText input for default locale (default) */
  longText?: InputMaybe<Scalars['RichTextAST']['input']>;
  theme?: InputMaybe<CorpColorThemeName>;
};

export type LongTextUpdateManyLocalizationDataInput = {
  longText?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type LongTextUpdateManyLocalizationInput = {
  data: LongTextUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type LongTextUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<LongTextUpdateManyLocalizationInput>>;
};

export type LongTextUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: LongTextUpdateManyInput;
  /** Document search */
  where: LongTextWhereInput;
};

export type LongTextUpdateOneInlineInput = {
  /** Connect existing LongText document */
  connect?: InputMaybe<LongTextWhereUniqueInput>;
  /** Create and connect one LongText document */
  create?: InputMaybe<LongTextCreateInput>;
  /** Delete currently connected LongText document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected LongText document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single LongText document */
  update?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  /** Upsert single LongText document */
  upsert?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
};

export type LongTextUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: LongTextUpdateInput;
  /** Unique document search */
  where: LongTextWhereUniqueInput;
};

export type LongTextUpsertInput = {
  /** Create document if it didn't exist */
  create: LongTextCreateInput;
  /** Update document if it exists */
  update: LongTextUpdateInput;
};

export type LongTextUpsertLocalizationInput = {
  create: LongTextCreateLocalizationDataInput;
  locale: Locale;
  update: LongTextUpdateLocalizationDataInput;
};

export type LongTextUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: LongTextUpsertInput;
  /** Unique document search */
  where: LongTextWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type LongTextWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type LongTextWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LongTextWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LongTextWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LongTextWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<LongTextWhereStageInput>;
  documentInStages_none?: InputMaybe<LongTextWhereStageInput>;
  documentInStages_some?: InputMaybe<LongTextWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  locationItem?: InputMaybe<LocationItemWhereInput>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  theme?: InputMaybe<CorpColorThemeName>;
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<CorpColorThemeName>;
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type LongTextWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<LongTextWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<LongTextWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<LongTextWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<LongTextWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References LongText record uniquely */
export type LongTextWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** list of markets where we have data */
export enum Markets {
  at = 'at',
  au = 'au',
  ba = 'ba',
  be = 'be',
  br = 'br',
  ch = 'ch',
  de = 'de',
  dk = 'dk',
  fr = 'fr',
  fr_TN = 'fr_TN',
  global = 'global',
  hr = 'hr',
  hu = 'hu',
  in = 'in',
  it = 'it',
  my = 'my',
  nl = 'nl',
  no = 'no',
  pl = 'pl',
  si = 'si',
  tn = 'tn',
  tr = 'tr',
  uk = 'uk'
}

/** Should only have 1 item */
export type MediaLibrary = Entity & Node & {
  __typename?: 'MediaLibrary';
  bodyComponents: Array<MediaLibraryBodyComponents>;
  /** Content Grouping option to be selected to pass through to the dataLayer value cg1 */
  contentGroupingTrackingValue?: Maybe<TrackingContentGrouping>;
  /** Content Grouping options to be selected to pass through to the dataLayer value cg2 */
  contentGroupingTrackingValues?: Maybe<TrackingContentGrouping>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<MediaLibrary>;
  /** List of MediaLibrary versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  introText: Scalars['String']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<MediaLibrary>;
  metaData?: Maybe<MetaData>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Should only have 1 item */
export type MediaLibraryBodyComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Should only have 1 item */
export type MediaLibraryCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Should only have 1 item */
export type MediaLibraryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Should only have 1 item */
export type MediaLibraryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Should only have 1 item */
export type MediaLibraryHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Should only have 1 item */
export type MediaLibraryLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Should only have 1 item */
export type MediaLibraryMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Should only have 1 item */
export type MediaLibraryPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Should only have 1 item */
export type MediaLibraryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Should only have 1 item */
export type MediaLibraryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Should only have 1 item */
export type MediaLibraryUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Should only have 1 item */
export type MediaLibraryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type MediaLibraryBodyComponents = Banner2 | CarouselComponent | CorpBanner1 | CorpContactCardContainer | CorpGenericAccordion | CorpGenericContainer | CorpGridColumnComponent | LongText | QuickLink | Spacer;

export type MediaLibraryBodyComponentsConnectInput = {
  Banner2?: InputMaybe<Banner2ConnectInput>;
  CarouselComponent?: InputMaybe<CarouselComponentConnectInput>;
  CorpBanner1?: InputMaybe<CorpBanner1ConnectInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerConnectInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionConnectInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerConnectInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
  QuickLink?: InputMaybe<QuickLinkConnectInput>;
  Spacer?: InputMaybe<SpacerConnectInput>;
};

export type MediaLibraryBodyComponentsCreateInput = {
  Banner2?: InputMaybe<Banner2CreateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentCreateInput>;
  CorpBanner1?: InputMaybe<CorpBanner1CreateInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerCreateInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionCreateInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerCreateInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
  QuickLink?: InputMaybe<QuickLinkCreateInput>;
  Spacer?: InputMaybe<SpacerCreateInput>;
};

export type MediaLibraryBodyComponentsCreateManyInlineInput = {
  /** Connect multiple existing MediaLibraryBodyComponents documents */
  connect?: InputMaybe<Array<MediaLibraryBodyComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing MediaLibraryBodyComponents documents */
  create?: InputMaybe<Array<MediaLibraryBodyComponentsCreateInput>>;
};

export type MediaLibraryBodyComponentsCreateOneInlineInput = {
  /** Connect one existing MediaLibraryBodyComponents document */
  connect?: InputMaybe<MediaLibraryBodyComponentsWhereUniqueInput>;
  /** Create and connect one MediaLibraryBodyComponents document */
  create?: InputMaybe<MediaLibraryBodyComponentsCreateInput>;
};

export type MediaLibraryBodyComponentsUpdateInput = {
  Banner2?: InputMaybe<Banner2UpdateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpdateInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpdateInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpdateInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateInput>;
  Spacer?: InputMaybe<SpacerUpdateInput>;
};

export type MediaLibraryBodyComponentsUpdateManyInlineInput = {
  /** Connect multiple existing MediaLibraryBodyComponents documents */
  connect?: InputMaybe<Array<MediaLibraryBodyComponentsConnectInput>>;
  /** Create and connect multiple MediaLibraryBodyComponents documents */
  create?: InputMaybe<Array<MediaLibraryBodyComponentsCreateInput>>;
  /** Delete multiple MediaLibraryBodyComponents documents */
  delete?: InputMaybe<Array<MediaLibraryBodyComponentsWhereUniqueInput>>;
  /** Disconnect multiple MediaLibraryBodyComponents documents */
  disconnect?: InputMaybe<Array<MediaLibraryBodyComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing MediaLibraryBodyComponents documents */
  set?: InputMaybe<Array<MediaLibraryBodyComponentsWhereUniqueInput>>;
  /** Update multiple MediaLibraryBodyComponents documents */
  update?: InputMaybe<Array<MediaLibraryBodyComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple MediaLibraryBodyComponents documents */
  upsert?: InputMaybe<Array<MediaLibraryBodyComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type MediaLibraryBodyComponentsUpdateManyWithNestedWhereInput = {
  Banner2?: InputMaybe<Banner2UpdateManyWithNestedWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateManyWithNestedWhereInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpdateManyWithNestedWhereInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpdateManyWithNestedWhereInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpdateManyWithNestedWhereInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateManyWithNestedWhereInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateManyWithNestedWhereInput>;
  Spacer?: InputMaybe<SpacerUpdateManyWithNestedWhereInput>;
};

export type MediaLibraryBodyComponentsUpdateOneInlineInput = {
  /** Connect existing MediaLibraryBodyComponents document */
  connect?: InputMaybe<MediaLibraryBodyComponentsWhereUniqueInput>;
  /** Create and connect one MediaLibraryBodyComponents document */
  create?: InputMaybe<MediaLibraryBodyComponentsCreateInput>;
  /** Delete currently connected MediaLibraryBodyComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected MediaLibraryBodyComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MediaLibraryBodyComponents document */
  update?: InputMaybe<MediaLibraryBodyComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MediaLibraryBodyComponents document */
  upsert?: InputMaybe<MediaLibraryBodyComponentsUpsertWithNestedWhereUniqueInput>;
};

export type MediaLibraryBodyComponentsUpdateWithNestedWhereUniqueInput = {
  Banner2?: InputMaybe<Banner2UpdateWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateWithNestedWhereUniqueInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpdateWithNestedWhereUniqueInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpdateWithNestedWhereUniqueInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpdateWithNestedWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateWithNestedWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpdateWithNestedWhereUniqueInput>;
};

export type MediaLibraryBodyComponentsUpsertWithNestedWhereUniqueInput = {
  Banner2?: InputMaybe<Banner2UpsertWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpsertWithNestedWhereUniqueInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpsertWithNestedWhereUniqueInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpsertWithNestedWhereUniqueInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpsertWithNestedWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpsertWithNestedWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkUpsertWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpsertWithNestedWhereUniqueInput>;
};

export type MediaLibraryBodyComponentsWhereInput = {
  Banner2?: InputMaybe<Banner2WhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  CorpBanner1?: InputMaybe<CorpBanner1WhereInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerWhereInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionWhereInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerWhereInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
  QuickLink?: InputMaybe<QuickLinkWhereInput>;
  Spacer?: InputMaybe<SpacerWhereInput>;
};

export type MediaLibraryBodyComponentsWhereUniqueInput = {
  Banner2?: InputMaybe<Banner2WhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereUniqueInput>;
  CorpBanner1?: InputMaybe<CorpBanner1WhereUniqueInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerWhereUniqueInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerWhereUniqueInput>;
};

/** Category keys for Media Library Items */
export enum MediaLibraryCategory {
  career = 'career',
  company = 'company',
  historical = 'historical',
  others = 'others',
  products = 'products',
  sustainability = 'sustainability'
}

export type MediaLibraryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MediaLibraryWhereUniqueInput;
};

/** A connection to a list of items. */
export type MediaLibraryConnection = {
  __typename?: 'MediaLibraryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MediaLibraryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MediaLibraryCreateInput = {
  bodyComponents?: InputMaybe<MediaLibraryBodyComponentsCreateManyInlineInput>;
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** introText input for default locale (default) */
  introText: Scalars['String']['input'];
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<MediaLibraryCreateLocalizationsInput>;
  metaData?: InputMaybe<MetaDataCreateOneInlineInput>;
  /** subtitle input for default locale (default) */
  subtitle: Scalars['String']['input'];
  /** title input for default locale (default) */
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MediaLibraryCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  introText: Scalars['String']['input'];
  subtitle: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MediaLibraryCreateLocalizationInput = {
  /** Localization input */
  data: MediaLibraryCreateLocalizationDataInput;
  locale: Locale;
};

export type MediaLibraryCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<MediaLibraryCreateLocalizationInput>>;
};

export type MediaLibraryCreateManyInlineInput = {
  /** Connect multiple existing MediaLibrary documents */
  connect?: InputMaybe<Array<MediaLibraryWhereUniqueInput>>;
  /** Create and connect multiple existing MediaLibrary documents */
  create?: InputMaybe<Array<MediaLibraryCreateInput>>;
};

export type MediaLibraryCreateOneInlineInput = {
  /** Connect one existing MediaLibrary document */
  connect?: InputMaybe<MediaLibraryWhereUniqueInput>;
  /** Create and connect one MediaLibrary document */
  create?: InputMaybe<MediaLibraryCreateInput>;
};

/** An edge in a connection. */
export type MediaLibraryEdge = {
  __typename?: 'MediaLibraryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MediaLibrary;
};

/** Media that can be downloaded on the press media page */
export type MediaLibraryItem = Entity & Node & {
  __typename?: 'MediaLibraryItem';
  assetComponent?: Maybe<AssetComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<MediaLibraryItem>;
  /** List of MediaLibraryItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<MediaLibraryItem>;
  market: Markets;
  mediaCategory: MediaLibraryCategory;
  /** The type of the item */
  mediaType: MediaLibraryItemType;
  metaData?: Maybe<MetaData>;
  /** Poster Image */
  posterImage?: Maybe<AssetComponent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Media that can be downloaded on the press media page */
export type MediaLibraryItemAssetComponentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Media that can be downloaded on the press media page */
export type MediaLibraryItemCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Media that can be downloaded on the press media page */
export type MediaLibraryItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Media that can be downloaded on the press media page */
export type MediaLibraryItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Media that can be downloaded on the press media page */
export type MediaLibraryItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Media that can be downloaded on the press media page */
export type MediaLibraryItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Media that can be downloaded on the press media page */
export type MediaLibraryItemMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Media that can be downloaded on the press media page */
export type MediaLibraryItemPosterImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Media that can be downloaded on the press media page */
export type MediaLibraryItemPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Media that can be downloaded on the press media page */
export type MediaLibraryItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Media that can be downloaded on the press media page */
export type MediaLibraryItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Media that can be downloaded on the press media page */
export type MediaLibraryItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Media that can be downloaded on the press media page */
export type MediaLibraryItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type MediaLibraryItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MediaLibraryItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type MediaLibraryItemConnection = {
  __typename?: 'MediaLibraryItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MediaLibraryItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MediaLibraryItemCreateInput = {
  assetComponent?: InputMaybe<AssetComponentCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<MediaLibraryItemCreateLocalizationsInput>;
  market: Markets;
  mediaCategory: MediaLibraryCategory;
  mediaType: MediaLibraryItemType;
  metaData?: InputMaybe<MetaDataCreateOneInlineInput>;
  posterImage?: InputMaybe<AssetComponentCreateOneInlineInput>;
  /** title input for default locale (default) */
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MediaLibraryItemCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MediaLibraryItemCreateLocalizationInput = {
  /** Localization input */
  data: MediaLibraryItemCreateLocalizationDataInput;
  locale: Locale;
};

export type MediaLibraryItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<MediaLibraryItemCreateLocalizationInput>>;
};

export type MediaLibraryItemCreateManyInlineInput = {
  /** Connect multiple existing MediaLibraryItem documents */
  connect?: InputMaybe<Array<MediaLibraryItemWhereUniqueInput>>;
  /** Create and connect multiple existing MediaLibraryItem documents */
  create?: InputMaybe<Array<MediaLibraryItemCreateInput>>;
};

export type MediaLibraryItemCreateOneInlineInput = {
  /** Connect one existing MediaLibraryItem document */
  connect?: InputMaybe<MediaLibraryItemWhereUniqueInput>;
  /** Create and connect one MediaLibraryItem document */
  create?: InputMaybe<MediaLibraryItemCreateInput>;
};

/** An edge in a connection. */
export type MediaLibraryItemEdge = {
  __typename?: 'MediaLibraryItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MediaLibraryItem;
};

/** Identifies documents */
export type MediaLibraryItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MediaLibraryItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MediaLibraryItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MediaLibraryItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetComponent?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MediaLibraryItemWhereStageInput>;
  documentInStages_none?: InputMaybe<MediaLibraryItemWhereStageInput>;
  documentInStages_some?: InputMaybe<MediaLibraryItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  mediaCategory?: InputMaybe<MediaLibraryCategory>;
  /** All values that are contained in given list. */
  mediaCategory_in?: InputMaybe<Array<InputMaybe<MediaLibraryCategory>>>;
  /** Any other value that exists and is not equal to the given value. */
  mediaCategory_not?: InputMaybe<MediaLibraryCategory>;
  /** All values that are not contained in given list. */
  mediaCategory_not_in?: InputMaybe<Array<InputMaybe<MediaLibraryCategory>>>;
  mediaType?: InputMaybe<MediaLibraryItemType>;
  /** All values that are contained in given list. */
  mediaType_in?: InputMaybe<Array<InputMaybe<MediaLibraryItemType>>>;
  /** Any other value that exists and is not equal to the given value. */
  mediaType_not?: InputMaybe<MediaLibraryItemType>;
  /** All values that are not contained in given list. */
  mediaType_not_in?: InputMaybe<Array<InputMaybe<MediaLibraryItemType>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  posterImage?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum MediaLibraryItemOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  mediaCategory_ASC = 'mediaCategory_ASC',
  mediaCategory_DESC = 'mediaCategory_DESC',
  mediaType_ASC = 'mediaType_ASC',
  mediaType_DESC = 'mediaType_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** The type of the media item */
export enum MediaLibraryItemType {
  audio = 'audio',
  document = 'document',
  image = 'image',
  infographic = 'infographic',
  logo = 'logo',
  video = 'video'
}

export type MediaLibraryItemUpdateInput = {
  assetComponent?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<MediaLibraryItemUpdateLocalizationsInput>;
  market?: InputMaybe<Markets>;
  mediaCategory?: InputMaybe<MediaLibraryCategory>;
  mediaType?: InputMaybe<MediaLibraryItemType>;
  metaData?: InputMaybe<MetaDataUpdateOneInlineInput>;
  posterImage?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MediaLibraryItemUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MediaLibraryItemUpdateLocalizationInput = {
  data: MediaLibraryItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type MediaLibraryItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<MediaLibraryItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<MediaLibraryItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<MediaLibraryItemUpsertLocalizationInput>>;
};

export type MediaLibraryItemUpdateManyInlineInput = {
  /** Connect multiple existing MediaLibraryItem documents */
  connect?: InputMaybe<Array<MediaLibraryItemConnectInput>>;
  /** Create and connect multiple MediaLibraryItem documents */
  create?: InputMaybe<Array<MediaLibraryItemCreateInput>>;
  /** Delete multiple MediaLibraryItem documents */
  delete?: InputMaybe<Array<MediaLibraryItemWhereUniqueInput>>;
  /** Disconnect multiple MediaLibraryItem documents */
  disconnect?: InputMaybe<Array<MediaLibraryItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing MediaLibraryItem documents */
  set?: InputMaybe<Array<MediaLibraryItemWhereUniqueInput>>;
  /** Update multiple MediaLibraryItem documents */
  update?: InputMaybe<Array<MediaLibraryItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple MediaLibraryItem documents */
  upsert?: InputMaybe<Array<MediaLibraryItemUpsertWithNestedWhereUniqueInput>>;
};

export type MediaLibraryItemUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<MediaLibraryItemUpdateManyLocalizationsInput>;
  market?: InputMaybe<Markets>;
  mediaCategory?: InputMaybe<MediaLibraryCategory>;
  mediaType?: InputMaybe<MediaLibraryItemType>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MediaLibraryItemUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MediaLibraryItemUpdateManyLocalizationInput = {
  data: MediaLibraryItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type MediaLibraryItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<MediaLibraryItemUpdateManyLocalizationInput>>;
};

export type MediaLibraryItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MediaLibraryItemUpdateManyInput;
  /** Document search */
  where: MediaLibraryItemWhereInput;
};

export type MediaLibraryItemUpdateOneInlineInput = {
  /** Connect existing MediaLibraryItem document */
  connect?: InputMaybe<MediaLibraryItemWhereUniqueInput>;
  /** Create and connect one MediaLibraryItem document */
  create?: InputMaybe<MediaLibraryItemCreateInput>;
  /** Delete currently connected MediaLibraryItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected MediaLibraryItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MediaLibraryItem document */
  update?: InputMaybe<MediaLibraryItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MediaLibraryItem document */
  upsert?: InputMaybe<MediaLibraryItemUpsertWithNestedWhereUniqueInput>;
};

export type MediaLibraryItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MediaLibraryItemUpdateInput;
  /** Unique document search */
  where: MediaLibraryItemWhereUniqueInput;
};

export type MediaLibraryItemUpsertInput = {
  /** Create document if it didn't exist */
  create: MediaLibraryItemCreateInput;
  /** Update document if it exists */
  update: MediaLibraryItemUpdateInput;
};

export type MediaLibraryItemUpsertLocalizationInput = {
  create: MediaLibraryItemCreateLocalizationDataInput;
  locale: Locale;
  update: MediaLibraryItemUpdateLocalizationDataInput;
};

export type MediaLibraryItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MediaLibraryItemUpsertInput;
  /** Unique document search */
  where: MediaLibraryItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type MediaLibraryItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type MediaLibraryItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MediaLibraryItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MediaLibraryItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MediaLibraryItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetComponent?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MediaLibraryItemWhereStageInput>;
  documentInStages_none?: InputMaybe<MediaLibraryItemWhereStageInput>;
  documentInStages_some?: InputMaybe<MediaLibraryItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  market?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  mediaCategory?: InputMaybe<MediaLibraryCategory>;
  /** All values that are contained in given list. */
  mediaCategory_in?: InputMaybe<Array<InputMaybe<MediaLibraryCategory>>>;
  /** Any other value that exists and is not equal to the given value. */
  mediaCategory_not?: InputMaybe<MediaLibraryCategory>;
  /** All values that are not contained in given list. */
  mediaCategory_not_in?: InputMaybe<Array<InputMaybe<MediaLibraryCategory>>>;
  mediaType?: InputMaybe<MediaLibraryItemType>;
  /** All values that are contained in given list. */
  mediaType_in?: InputMaybe<Array<InputMaybe<MediaLibraryItemType>>>;
  /** Any other value that exists and is not equal to the given value. */
  mediaType_not?: InputMaybe<MediaLibraryItemType>;
  /** All values that are not contained in given list. */
  mediaType_not_in?: InputMaybe<Array<InputMaybe<MediaLibraryItemType>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  posterImage?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type MediaLibraryItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MediaLibraryItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MediaLibraryItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MediaLibraryItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<MediaLibraryItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References MediaLibraryItem record uniquely */
export type MediaLibraryItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type MediaLibraryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MediaLibraryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MediaLibraryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MediaLibraryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  bodyComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  bodyComponents_some?: InputMaybe<MediaLibraryBodyComponentsWhereInput>;
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValue_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValue_not?: InputMaybe<TrackingContentGrouping>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValue_not_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValues_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValues_not?: InputMaybe<TrackingContentGrouping>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValues_not_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MediaLibraryWhereStageInput>;
  documentInStages_none?: InputMaybe<MediaLibraryWhereStageInput>;
  documentInStages_some?: InputMaybe<MediaLibraryWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum MediaLibraryOrderByInput {
  contentGroupingTrackingValue_ASC = 'contentGroupingTrackingValue_ASC',
  contentGroupingTrackingValue_DESC = 'contentGroupingTrackingValue_DESC',
  contentGroupingTrackingValues_ASC = 'contentGroupingTrackingValues_ASC',
  contentGroupingTrackingValues_DESC = 'contentGroupingTrackingValues_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  introText_ASC = 'introText_ASC',
  introText_DESC = 'introText_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subtitle_ASC = 'subtitle_ASC',
  subtitle_DESC = 'subtitle_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type MediaLibraryUpdateInput = {
  bodyComponents?: InputMaybe<MediaLibraryBodyComponentsUpdateManyInlineInput>;
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  /** introText input for default locale (default) */
  introText?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<MediaLibraryUpdateLocalizationsInput>;
  metaData?: InputMaybe<MetaDataUpdateOneInlineInput>;
  /** subtitle input for default locale (default) */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MediaLibraryUpdateLocalizationDataInput = {
  introText?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MediaLibraryUpdateLocalizationInput = {
  data: MediaLibraryUpdateLocalizationDataInput;
  locale: Locale;
};

export type MediaLibraryUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<MediaLibraryCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<MediaLibraryUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<MediaLibraryUpsertLocalizationInput>>;
};

export type MediaLibraryUpdateManyInlineInput = {
  /** Connect multiple existing MediaLibrary documents */
  connect?: InputMaybe<Array<MediaLibraryConnectInput>>;
  /** Create and connect multiple MediaLibrary documents */
  create?: InputMaybe<Array<MediaLibraryCreateInput>>;
  /** Delete multiple MediaLibrary documents */
  delete?: InputMaybe<Array<MediaLibraryWhereUniqueInput>>;
  /** Disconnect multiple MediaLibrary documents */
  disconnect?: InputMaybe<Array<MediaLibraryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing MediaLibrary documents */
  set?: InputMaybe<Array<MediaLibraryWhereUniqueInput>>;
  /** Update multiple MediaLibrary documents */
  update?: InputMaybe<Array<MediaLibraryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple MediaLibrary documents */
  upsert?: InputMaybe<Array<MediaLibraryUpsertWithNestedWhereUniqueInput>>;
};

export type MediaLibraryUpdateManyInput = {
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  /** introText input for default locale (default) */
  introText?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<MediaLibraryUpdateManyLocalizationsInput>;
  /** subtitle input for default locale (default) */
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MediaLibraryUpdateManyLocalizationDataInput = {
  introText?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type MediaLibraryUpdateManyLocalizationInput = {
  data: MediaLibraryUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type MediaLibraryUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<MediaLibraryUpdateManyLocalizationInput>>;
};

export type MediaLibraryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MediaLibraryUpdateManyInput;
  /** Document search */
  where: MediaLibraryWhereInput;
};

export type MediaLibraryUpdateOneInlineInput = {
  /** Connect existing MediaLibrary document */
  connect?: InputMaybe<MediaLibraryWhereUniqueInput>;
  /** Create and connect one MediaLibrary document */
  create?: InputMaybe<MediaLibraryCreateInput>;
  /** Delete currently connected MediaLibrary document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected MediaLibrary document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MediaLibrary document */
  update?: InputMaybe<MediaLibraryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MediaLibrary document */
  upsert?: InputMaybe<MediaLibraryUpsertWithNestedWhereUniqueInput>;
};

export type MediaLibraryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MediaLibraryUpdateInput;
  /** Unique document search */
  where: MediaLibraryWhereUniqueInput;
};

export type MediaLibraryUpsertInput = {
  /** Create document if it didn't exist */
  create: MediaLibraryCreateInput;
  /** Update document if it exists */
  update: MediaLibraryUpdateInput;
};

export type MediaLibraryUpsertLocalizationInput = {
  create: MediaLibraryCreateLocalizationDataInput;
  locale: Locale;
  update: MediaLibraryUpdateLocalizationDataInput;
};

export type MediaLibraryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MediaLibraryUpsertInput;
  /** Unique document search */
  where: MediaLibraryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type MediaLibraryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type MediaLibraryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MediaLibraryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MediaLibraryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MediaLibraryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  bodyComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  bodyComponents_some?: InputMaybe<MediaLibraryBodyComponentsWhereInput>;
  contentGroupingTrackingValue?: InputMaybe<TrackingContentGrouping>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValue_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValue_not?: InputMaybe<TrackingContentGrouping>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValue_not_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  contentGroupingTrackingValues?: InputMaybe<TrackingContentGrouping>;
  /** All values that are contained in given list. */
  contentGroupingTrackingValues_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  /** Any other value that exists and is not equal to the given value. */
  contentGroupingTrackingValues_not?: InputMaybe<TrackingContentGrouping>;
  /** All values that are not contained in given list. */
  contentGroupingTrackingValues_not_in?: InputMaybe<Array<InputMaybe<TrackingContentGrouping>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MediaLibraryWhereStageInput>;
  documentInStages_none?: InputMaybe<MediaLibraryWhereStageInput>;
  documentInStages_some?: InputMaybe<MediaLibraryWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  introText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  introText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  introText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  introText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  introText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  introText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  introText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  introText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  introText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  introText_starts_with?: InputMaybe<Scalars['String']['input']>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type MediaLibraryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MediaLibraryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MediaLibraryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MediaLibraryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<MediaLibraryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References MediaLibrary record uniquely */
export type MediaLibraryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Page Meta Data Component used on every page for SEO */
export type MetaData = Entity & Node & {
  __typename?: 'MetaData';
  anchorNav?: Maybe<AnchorNavigation>;
  corpPressPage?: Maybe<CorpPressPage>;
  corpStoriesPage?: Maybe<CorpStoriesPage>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Page description for SEO. (e.g. Google Search results). It should be ~160 characters long and summarize the page content. Search engines show the meta description in search results! */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<MetaData>;
  genericPage?: Maybe<GenericPage>;
  genericPages: Array<GenericPage>;
  /** List of MetaData versions */
  history: Array<Version>;
  homePage?: Maybe<HomePage>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  images: Array<Asset>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<MetaData>;
  mediaLibraryItem?: Maybe<MediaLibraryItem>;
  /** Facebook specific. Optionally specify an open graph type - if you are unsure, leave this field blank. This will generally not need to be set. More information at https://developers.facebook.com/docs/reference/opengraph/ */
  openGraphType?: Maybe<Scalars['String']['output']>;
  /** The name of the page */
  pageName: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** Section name for the browser tab. The format is: <page name> - <section name> */
  sectionName: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** Theme for the page. Default is the "Oetker" theme. please update for other themes when added */
  theme?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataCorpPressPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataCorpStoriesPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataGenericPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataHomePageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetWhereInput>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataMediaLibraryItemArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Page Meta Data Component used on every page for SEO */
export type MetaDataUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type MetaDataConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MetaDataWhereUniqueInput;
};

/** A connection to a list of items. */
export type MetaDataConnection = {
  __typename?: 'MetaDataConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MetaDataEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MetaDataCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  ckzo9hpz322lj01xk8l8z4otx?: InputMaybe<MediaLibraryCreateManyInlineInput>;
  cl1w9bq010ir301z8661ng8qr?: InputMaybe<StoryCreateManyInlineInput>;
  cl2snfjwu2ubp01z29ggp1o34?: InputMaybe<PressReleaseCreateManyInlineInput>;
  corpPressPage?: InputMaybe<CorpPressPageCreateOneInlineInput>;
  corpStoriesPage?: InputMaybe<CorpStoriesPageCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  genericPage?: InputMaybe<GenericPageCreateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  homePage?: InputMaybe<HomePageCreateOneInlineInput>;
  images: AssetCreateManyInlineInput;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<MetaDataCreateLocalizationsInput>;
  mediaLibraryItem?: InputMaybe<MediaLibraryItemCreateOneInlineInput>;
  /** openGraphType input for default locale (default) */
  openGraphType?: InputMaybe<Scalars['String']['input']>;
  /** pageName input for default locale (default) */
  pageName: Scalars['String']['input'];
  /** sectionName input for default locale (default) */
  sectionName: Scalars['String']['input'];
  theme?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MetaDataCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  openGraphType?: InputMaybe<Scalars['String']['input']>;
  pageName: Scalars['String']['input'];
  sectionName: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MetaDataCreateLocalizationInput = {
  /** Localization input */
  data: MetaDataCreateLocalizationDataInput;
  locale: Locale;
};

export type MetaDataCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<MetaDataCreateLocalizationInput>>;
};

export type MetaDataCreateManyInlineInput = {
  /** Connect multiple existing MetaData documents */
  connect?: InputMaybe<Array<MetaDataWhereUniqueInput>>;
  /** Create and connect multiple existing MetaData documents */
  create?: InputMaybe<Array<MetaDataCreateInput>>;
};

export type MetaDataCreateOneInlineInput = {
  /** Connect one existing MetaData document */
  connect?: InputMaybe<MetaDataWhereUniqueInput>;
  /** Create and connect one MetaData document */
  create?: InputMaybe<MetaDataCreateInput>;
};

/** An edge in a connection. */
export type MetaDataEdge = {
  __typename?: 'MetaDataEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MetaData;
};

/** Identifies documents */
export type MetaDataManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MetaDataWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MetaDataWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MetaDataWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  corpPressPage?: InputMaybe<CorpPressPageWhereInput>;
  corpStoriesPage?: InputMaybe<CorpStoriesPageWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MetaDataWhereStageInput>;
  documentInStages_none?: InputMaybe<MetaDataWhereStageInput>;
  documentInStages_some?: InputMaybe<MetaDataWhereStageInput>;
  genericPage?: InputMaybe<GenericPageWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  homePage?: InputMaybe<HomePageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  images_every?: InputMaybe<AssetWhereInput>;
  images_none?: InputMaybe<AssetWhereInput>;
  images_some?: InputMaybe<AssetWhereInput>;
  mediaLibraryItem?: InputMaybe<MediaLibraryItemWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  theme?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  theme_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  theme_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  theme_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  theme_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum MetaDataOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  openGraphType_ASC = 'openGraphType_ASC',
  openGraphType_DESC = 'openGraphType_DESC',
  pageName_ASC = 'pageName_ASC',
  pageName_DESC = 'pageName_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  sectionName_ASC = 'sectionName_ASC',
  sectionName_DESC = 'sectionName_DESC',
  theme_ASC = 'theme_ASC',
  theme_DESC = 'theme_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type MetaDataUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  ckzo9hpz322lj01xk8l8z4otx?: InputMaybe<MediaLibraryUpdateManyInlineInput>;
  cl1w9bq010ir301z8661ng8qr?: InputMaybe<StoryUpdateManyInlineInput>;
  cl2snfjwu2ubp01z29ggp1o34?: InputMaybe<PressReleaseUpdateManyInlineInput>;
  corpPressPage?: InputMaybe<CorpPressPageUpdateOneInlineInput>;
  corpStoriesPage?: InputMaybe<CorpStoriesPageUpdateOneInlineInput>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  genericPage?: InputMaybe<GenericPageUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  homePage?: InputMaybe<HomePageUpdateOneInlineInput>;
  images?: InputMaybe<AssetUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<MetaDataUpdateLocalizationsInput>;
  mediaLibraryItem?: InputMaybe<MediaLibraryItemUpdateOneInlineInput>;
  /** openGraphType input for default locale (default) */
  openGraphType?: InputMaybe<Scalars['String']['input']>;
  /** pageName input for default locale (default) */
  pageName?: InputMaybe<Scalars['String']['input']>;
  /** sectionName input for default locale (default) */
  sectionName?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

export type MetaDataUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  openGraphType?: InputMaybe<Scalars['String']['input']>;
  pageName?: InputMaybe<Scalars['String']['input']>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
};

export type MetaDataUpdateLocalizationInput = {
  data: MetaDataUpdateLocalizationDataInput;
  locale: Locale;
};

export type MetaDataUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<MetaDataCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<MetaDataUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<MetaDataUpsertLocalizationInput>>;
};

export type MetaDataUpdateManyInlineInput = {
  /** Connect multiple existing MetaData documents */
  connect?: InputMaybe<Array<MetaDataConnectInput>>;
  /** Create and connect multiple MetaData documents */
  create?: InputMaybe<Array<MetaDataCreateInput>>;
  /** Delete multiple MetaData documents */
  delete?: InputMaybe<Array<MetaDataWhereUniqueInput>>;
  /** Disconnect multiple MetaData documents */
  disconnect?: InputMaybe<Array<MetaDataWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing MetaData documents */
  set?: InputMaybe<Array<MetaDataWhereUniqueInput>>;
  /** Update multiple MetaData documents */
  update?: InputMaybe<Array<MetaDataUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple MetaData documents */
  upsert?: InputMaybe<Array<MetaDataUpsertWithNestedWhereUniqueInput>>;
};

export type MetaDataUpdateManyInput = {
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<MetaDataUpdateManyLocalizationsInput>;
  /** openGraphType input for default locale (default) */
  openGraphType?: InputMaybe<Scalars['String']['input']>;
  /** pageName input for default locale (default) */
  pageName?: InputMaybe<Scalars['String']['input']>;
  /** sectionName input for default locale (default) */
  sectionName?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
};

export type MetaDataUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  openGraphType?: InputMaybe<Scalars['String']['input']>;
  pageName?: InputMaybe<Scalars['String']['input']>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
};

export type MetaDataUpdateManyLocalizationInput = {
  data: MetaDataUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type MetaDataUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<MetaDataUpdateManyLocalizationInput>>;
};

export type MetaDataUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MetaDataUpdateManyInput;
  /** Document search */
  where: MetaDataWhereInput;
};

export type MetaDataUpdateOneInlineInput = {
  /** Connect existing MetaData document */
  connect?: InputMaybe<MetaDataWhereUniqueInput>;
  /** Create and connect one MetaData document */
  create?: InputMaybe<MetaDataCreateInput>;
  /** Delete currently connected MetaData document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected MetaData document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MetaData document */
  update?: InputMaybe<MetaDataUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MetaData document */
  upsert?: InputMaybe<MetaDataUpsertWithNestedWhereUniqueInput>;
};

export type MetaDataUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MetaDataUpdateInput;
  /** Unique document search */
  where: MetaDataWhereUniqueInput;
};

export type MetaDataUpsertInput = {
  /** Create document if it didn't exist */
  create: MetaDataCreateInput;
  /** Update document if it exists */
  update: MetaDataUpdateInput;
};

export type MetaDataUpsertLocalizationInput = {
  create: MetaDataCreateLocalizationDataInput;
  locale: Locale;
  update: MetaDataUpdateLocalizationDataInput;
};

export type MetaDataUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MetaDataUpsertInput;
  /** Unique document search */
  where: MetaDataWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type MetaDataWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type MetaDataWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MetaDataWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MetaDataWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MetaDataWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  corpPressPage?: InputMaybe<CorpPressPageWhereInput>;
  corpStoriesPage?: InputMaybe<CorpStoriesPageWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<MetaDataWhereStageInput>;
  documentInStages_none?: InputMaybe<MetaDataWhereStageInput>;
  documentInStages_some?: InputMaybe<MetaDataWhereStageInput>;
  genericPage?: InputMaybe<GenericPageWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  homePage?: InputMaybe<HomePageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  images_every?: InputMaybe<AssetWhereInput>;
  images_none?: InputMaybe<AssetWhereInput>;
  images_some?: InputMaybe<AssetWhereInput>;
  mediaLibraryItem?: InputMaybe<MediaLibraryItemWhereInput>;
  openGraphType?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  openGraphType_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  openGraphType_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  openGraphType_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  openGraphType_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  openGraphType_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  openGraphType_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  openGraphType_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  openGraphType_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  openGraphType_starts_with?: InputMaybe<Scalars['String']['input']>;
  pageName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  pageName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  pageName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  pageName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  pageName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  pageName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  pageName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  pageName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  pageName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  pageName_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sectionName?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  sectionName_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  sectionName_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  sectionName_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  sectionName_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  sectionName_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  sectionName_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  sectionName_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  sectionName_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  sectionName_starts_with?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  theme_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  theme_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  theme_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  theme_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  theme_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  theme_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  theme_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  theme_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  theme_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type MetaDataWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MetaDataWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MetaDataWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MetaDataWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<MetaDataWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References MetaData record uniquely */
export type MetaDataWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type MobileOnlyMainNavigation = Entity & Node & {
  __typename?: 'MobileOnlyMainNavigation';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<MobileOnlyMainNavigation>;
  /** List of MobileOnlyMainNavigation versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Unique Key  */
  key: Scalars['String']['output'];
  /** Mobile Primary Navigation Asset */
  navigationAsset: Array<MobileOnlyMainNavigationNavigationAsset>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type MobileOnlyMainNavigationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MobileOnlyMainNavigationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type MobileOnlyMainNavigationHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type MobileOnlyMainNavigationNavigationAssetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type MobileOnlyMainNavigationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type MobileOnlyMainNavigationScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type MobileOnlyMainNavigationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type MobileOnlyMainNavigationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: MobileOnlyMainNavigationWhereUniqueInput;
};

/** A connection to a list of items. */
export type MobileOnlyMainNavigationConnection = {
  __typename?: 'MobileOnlyMainNavigationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<MobileOnlyMainNavigationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MobileOnlyMainNavigationCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  key: Scalars['String']['input'];
  navigationAsset?: InputMaybe<MobileOnlyMainNavigationNavigationAssetCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type MobileOnlyMainNavigationCreateManyInlineInput = {
  /** Connect multiple existing MobileOnlyMainNavigation documents */
  connect?: InputMaybe<Array<MobileOnlyMainNavigationWhereUniqueInput>>;
  /** Create and connect multiple existing MobileOnlyMainNavigation documents */
  create?: InputMaybe<Array<MobileOnlyMainNavigationCreateInput>>;
};

export type MobileOnlyMainNavigationCreateOneInlineInput = {
  /** Connect one existing MobileOnlyMainNavigation document */
  connect?: InputMaybe<MobileOnlyMainNavigationWhereUniqueInput>;
  /** Create and connect one MobileOnlyMainNavigation document */
  create?: InputMaybe<MobileOnlyMainNavigationCreateInput>;
};

/** An edge in a connection. */
export type MobileOnlyMainNavigationEdge = {
  __typename?: 'MobileOnlyMainNavigationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: MobileOnlyMainNavigation;
};

/** Identifies documents */
export type MobileOnlyMainNavigationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MobileOnlyMainNavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MobileOnlyMainNavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MobileOnlyMainNavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MobileOnlyMainNavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<MobileOnlyMainNavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<MobileOnlyMainNavigationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  navigationAsset_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  navigationAsset_some?: InputMaybe<MobileOnlyMainNavigationNavigationAssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type MobileOnlyMainNavigationNavigationAsset = AssetComponent;

export type MobileOnlyMainNavigationNavigationAssetConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type MobileOnlyMainNavigationNavigationAssetCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type MobileOnlyMainNavigationNavigationAssetCreateManyInlineInput = {
  /** Connect multiple existing MobileOnlyMainNavigationNavigationAsset documents */
  connect?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetWhereUniqueInput>>;
  /** Create and connect multiple existing MobileOnlyMainNavigationNavigationAsset documents */
  create?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetCreateInput>>;
};

export type MobileOnlyMainNavigationNavigationAssetCreateOneInlineInput = {
  /** Connect one existing MobileOnlyMainNavigationNavigationAsset document */
  connect?: InputMaybe<MobileOnlyMainNavigationNavigationAssetWhereUniqueInput>;
  /** Create and connect one MobileOnlyMainNavigationNavigationAsset document */
  create?: InputMaybe<MobileOnlyMainNavigationNavigationAssetCreateInput>;
};

export type MobileOnlyMainNavigationNavigationAssetUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type MobileOnlyMainNavigationNavigationAssetUpdateManyInlineInput = {
  /** Connect multiple existing MobileOnlyMainNavigationNavigationAsset documents */
  connect?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetConnectInput>>;
  /** Create and connect multiple MobileOnlyMainNavigationNavigationAsset documents */
  create?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetCreateInput>>;
  /** Delete multiple MobileOnlyMainNavigationNavigationAsset documents */
  delete?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetWhereUniqueInput>>;
  /** Disconnect multiple MobileOnlyMainNavigationNavigationAsset documents */
  disconnect?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing MobileOnlyMainNavigationNavigationAsset documents */
  set?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetWhereUniqueInput>>;
  /** Update multiple MobileOnlyMainNavigationNavigationAsset documents */
  update?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple MobileOnlyMainNavigationNavigationAsset documents */
  upsert?: InputMaybe<Array<MobileOnlyMainNavigationNavigationAssetUpsertWithNestedWhereUniqueInput>>;
};

export type MobileOnlyMainNavigationNavigationAssetUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type MobileOnlyMainNavigationNavigationAssetUpdateOneInlineInput = {
  /** Connect existing MobileOnlyMainNavigationNavigationAsset document */
  connect?: InputMaybe<MobileOnlyMainNavigationNavigationAssetWhereUniqueInput>;
  /** Create and connect one MobileOnlyMainNavigationNavigationAsset document */
  create?: InputMaybe<MobileOnlyMainNavigationNavigationAssetCreateInput>;
  /** Delete currently connected MobileOnlyMainNavigationNavigationAsset document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected MobileOnlyMainNavigationNavigationAsset document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MobileOnlyMainNavigationNavigationAsset document */
  update?: InputMaybe<MobileOnlyMainNavigationNavigationAssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MobileOnlyMainNavigationNavigationAsset document */
  upsert?: InputMaybe<MobileOnlyMainNavigationNavigationAssetUpsertWithNestedWhereUniqueInput>;
};

export type MobileOnlyMainNavigationNavigationAssetUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type MobileOnlyMainNavigationNavigationAssetUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type MobileOnlyMainNavigationNavigationAssetWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type MobileOnlyMainNavigationNavigationAssetWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

export enum MobileOnlyMainNavigationOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  key_ASC = 'key_ASC',
  key_DESC = 'key_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type MobileOnlyMainNavigationUpdateInput = {
  key?: InputMaybe<Scalars['String']['input']>;
  navigationAsset?: InputMaybe<MobileOnlyMainNavigationNavigationAssetUpdateManyInlineInput>;
};

export type MobileOnlyMainNavigationUpdateManyInlineInput = {
  /** Connect multiple existing MobileOnlyMainNavigation documents */
  connect?: InputMaybe<Array<MobileOnlyMainNavigationConnectInput>>;
  /** Create and connect multiple MobileOnlyMainNavigation documents */
  create?: InputMaybe<Array<MobileOnlyMainNavigationCreateInput>>;
  /** Delete multiple MobileOnlyMainNavigation documents */
  delete?: InputMaybe<Array<MobileOnlyMainNavigationWhereUniqueInput>>;
  /** Disconnect multiple MobileOnlyMainNavigation documents */
  disconnect?: InputMaybe<Array<MobileOnlyMainNavigationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing MobileOnlyMainNavigation documents */
  set?: InputMaybe<Array<MobileOnlyMainNavigationWhereUniqueInput>>;
  /** Update multiple MobileOnlyMainNavigation documents */
  update?: InputMaybe<Array<MobileOnlyMainNavigationUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple MobileOnlyMainNavigation documents */
  upsert?: InputMaybe<Array<MobileOnlyMainNavigationUpsertWithNestedWhereUniqueInput>>;
};

export type MobileOnlyMainNavigationUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type MobileOnlyMainNavigationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: MobileOnlyMainNavigationUpdateManyInput;
  /** Document search */
  where: MobileOnlyMainNavigationWhereInput;
};

export type MobileOnlyMainNavigationUpdateOneInlineInput = {
  /** Connect existing MobileOnlyMainNavigation document */
  connect?: InputMaybe<MobileOnlyMainNavigationWhereUniqueInput>;
  /** Create and connect one MobileOnlyMainNavigation document */
  create?: InputMaybe<MobileOnlyMainNavigationCreateInput>;
  /** Delete currently connected MobileOnlyMainNavigation document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected MobileOnlyMainNavigation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single MobileOnlyMainNavigation document */
  update?: InputMaybe<MobileOnlyMainNavigationUpdateWithNestedWhereUniqueInput>;
  /** Upsert single MobileOnlyMainNavigation document */
  upsert?: InputMaybe<MobileOnlyMainNavigationUpsertWithNestedWhereUniqueInput>;
};

export type MobileOnlyMainNavigationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: MobileOnlyMainNavigationUpdateInput;
  /** Unique document search */
  where: MobileOnlyMainNavigationWhereUniqueInput;
};

export type MobileOnlyMainNavigationUpsertInput = {
  /** Create document if it didn't exist */
  create: MobileOnlyMainNavigationCreateInput;
  /** Update document if it exists */
  update: MobileOnlyMainNavigationUpdateInput;
};

export type MobileOnlyMainNavigationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: MobileOnlyMainNavigationUpsertInput;
  /** Unique document search */
  where: MobileOnlyMainNavigationWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type MobileOnlyMainNavigationWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type MobileOnlyMainNavigationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MobileOnlyMainNavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MobileOnlyMainNavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MobileOnlyMainNavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<MobileOnlyMainNavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<MobileOnlyMainNavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<MobileOnlyMainNavigationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  navigationAsset_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  navigationAsset_some?: InputMaybe<MobileOnlyMainNavigationNavigationAssetWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type MobileOnlyMainNavigationWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<MobileOnlyMainNavigationWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<MobileOnlyMainNavigationWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<MobileOnlyMainNavigationWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<MobileOnlyMainNavigationWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References MobileOnlyMainNavigation record uniquely */
export type MobileOnlyMainNavigationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Create one accordion */
  createAccordion?: Maybe<Accordion>;
  /** Create one accordionItem */
  createAccordionItem?: Maybe<AccordionItem>;
  /** Create one alexTestComponent */
  createAlexTestComponent?: Maybe<AlexTestComponent>;
  /** Create one algoliaExtension */
  createAlgoliaExtension?: Maybe<AlgoliaExtension>;
  /** Create one anchorNav */
  createAnchorNav?: Maybe<AnchorNav>;
  /** Create one anchorNavigation */
  createAnchorNavigation?: Maybe<AnchorNavigation>;
  /** Create one anchorNavigationList */
  createAnchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Create an asset. Use the returned info to finish the creation process by uploading the asset. */
  createAsset?: Maybe<Asset>;
  /** Create one assetComponent */
  createAssetComponent?: Maybe<AssetComponent>;
  /** Create one audioComponent */
  createAudioComponent?: Maybe<AudioComponent>;
  /** Create one authorableContentCard */
  createAuthorableContentCard?: Maybe<AuthorableContentCard>;
  /** Create one banner2 */
  createBanner2?: Maybe<Banner2>;
  /** Create one bigNumber */
  createBigNumber?: Maybe<BigNumber>;
  /** Create one bigNumberItem */
  createBigNumberItem?: Maybe<BigNumberItem>;
  /** Create one cardComponent */
  createCardComponent?: Maybe<CardComponent>;
  /** Create one carouselComponent */
  createCarouselComponent?: Maybe<CarouselComponent>;
  /** Create one carouselSlide */
  createCarouselSlide?: Maybe<CarouselSlide>;
  /** Create one categoryCard */
  createCategoryCard?: Maybe<CategoryCard>;
  /** Create one contactCard */
  createContactCard?: Maybe<ContactCard>;
  /** Create one contactCardContainer */
  createContactCardContainer?: Maybe<ContactCardContainer>;
  /** Create one corpAddToCalendar */
  createCorpAddToCalendar?: Maybe<CorpAddToCalendar>;
  /** Create one corpBanner1 */
  createCorpBanner1?: Maybe<CorpBanner1>;
  /** Create one corpCalendarEvent */
  createCorpCalendarEvent?: Maybe<CorpCalendarEvent>;
  /** Create one corpCardCarousel */
  createCorpCardCarousel?: Maybe<CorpCardCarousel>;
  /** Create one corpContactCard */
  createCorpContactCard?: Maybe<CorpContactCard>;
  /** Create one corpContactCardContainer */
  createCorpContactCardContainer?: Maybe<CorpContactCardContainer>;
  /** Create one corpForm */
  createCorpForm?: Maybe<CorpForm>;
  /** Create one corpGenericAccordion */
  createCorpGenericAccordion?: Maybe<CorpGenericAccordion>;
  /** Create one corpGenericAccordionItem */
  createCorpGenericAccordionItem?: Maybe<CorpGenericAccordionItem>;
  /** Create one corpGenericBanner */
  createCorpGenericBanner?: Maybe<CorpGenericBanner>;
  /** Create one corpGenericContainer */
  createCorpGenericContainer?: Maybe<CorpGenericContainer>;
  /** Create one corpGridColumnComponent */
  createCorpGridColumnComponent?: Maybe<CorpGridColumnComponent>;
  /** Create one corpHero */
  createCorpHero?: Maybe<CorpHero>;
  /** Create one corpMediaDownloadPreview */
  createCorpMediaDownloadPreview?: Maybe<CorpMediaDownloadPreview>;
  /** Create one corpNavigation */
  createCorpNavigation?: Maybe<CorpNavigation>;
  /** Create one corpNavigationItem */
  createCorpNavigationItem?: Maybe<CorpNavigationItem>;
  /** Create one corpNotificationBanner */
  createCorpNotificationBanner?: Maybe<CorpNotificationBanner>;
  /** Create one corpOurPeople */
  createCorpOurPeople?: Maybe<CorpOurPeople>;
  /** Create one corpOurPeopleItem */
  createCorpOurPeopleItem?: Maybe<CorpOurPeopleItem>;
  /** Create one corpPressPage */
  createCorpPressPage?: Maybe<CorpPressPage>;
  /** Create one corpSocialMediaFooter */
  createCorpSocialMediaFooter?: Maybe<CorpSocialMediaFooter>;
  /** Create one corpStoriesPage */
  createCorpStoriesPage?: Maybe<CorpStoriesPage>;
  /** Create one corpStoryCarousel */
  createCorpStoryCarousel?: Maybe<CorpStoryCarousel>;
  /** Create one corpTimelineAccordion */
  createCorpTimelineAccordion?: Maybe<CorpTimelineAccordion>;
  /** Create one corpTimelineAccordionItem */
  createCorpTimelineAccordionItem?: Maybe<CorpTimelineAccordionItem>;
  /** Create one corpTimelineAccordionWrapper */
  createCorpTimelineAccordionWrapper?: Maybe<CorpTimelineAccordionWrapper>;
  /** Create one corpVideoHero */
  createCorpVideoHero?: Maybe<CorpVideoHero>;
  /** Create one corpVideoHeroCarousel */
  createCorpVideoHeroCarousel?: Maybe<CorpVideoHeroCarousel>;
  /** Create one countrySelector */
  createCountrySelector?: Maybe<CountrySelector>;
  /** Create one countrySelectorItem */
  createCountrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Create one dEPRECATEDBanner1 */
  createDEPRECATEDBanner1?: Maybe<DeprecatedBanner1>;
  /** Create one deprecatedCorpNavigationCopy */
  createDeprecatedCorpNavigationCopy?: Maybe<DeprecatedCorpNavigationCopy>;
  /** Create one dictionary */
  createDictionary?: Maybe<Dictionary>;
  /** Create one dictionaryItem */
  createDictionaryItem?: Maybe<DictionaryItem>;
  /** Create one dynamicCardGrid */
  createDynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Create one evalancheFormComponent */
  createEvalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Create one exampleComponent */
  createExampleComponent?: Maybe<ExampleComponent>;
  /** Create one featuredContent */
  createFeaturedContent?: Maybe<FeaturedContent>;
  /** Create one featuredContentReference */
  createFeaturedContentReference?: Maybe<FeaturedContentReference>;
  /** Create one footerNavigation */
  createFooterNavigation?: Maybe<FooterNavigation>;
  /** Create one form */
  createForm?: Maybe<Form>;
  /** Create one formCheckbox */
  createFormCheckbox?: Maybe<FormCheckbox>;
  /** Create one formEmailInput */
  createFormEmailInput?: Maybe<FormEmailInput>;
  /** Create one formError */
  createFormError?: Maybe<FormError>;
  /** Create one formPasswordInput */
  createFormPasswordInput?: Maybe<FormPasswordInput>;
  /** Create one formPasswordInputWithConfirmation */
  createFormPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Create one formRadioButton */
  createFormRadioButton?: Maybe<FormRadioButton>;
  /** Create one formRadioButtonCollection */
  createFormRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Create one formSelectComponent */
  createFormSelectComponent?: Maybe<FormSelectComponent>;
  /** Create one formSelectOption */
  createFormSelectOption?: Maybe<FormSelectOption>;
  /** Create one formSubmitButton */
  createFormSubmitButton?: Maybe<FormSubmitButton>;
  /** Create one formSuccessComponent */
  createFormSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Create one formTextInput */
  createFormTextInput?: Maybe<FormTextInput>;
  /** Create one formTextareaInput */
  createFormTextareaInput?: Maybe<FormTextareaInput>;
  /** Create one genericAccordion */
  createGenericAccordion?: Maybe<GenericAccordion>;
  /** Create one genericAccordionItem */
  createGenericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Create one genericAccordionTopRated */
  createGenericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Create one genericCardCarouseComponent */
  createGenericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Create one genericDownloadComponent */
  createGenericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Create one genericFollowUs */
  createGenericFollowUs?: Maybe<GenericFollowUs>;
  /** Create one genericGridAuthorable */
  createGenericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Create one genericLine */
  createGenericLine?: Maybe<GenericLine>;
  /** Create one genericLink */
  createGenericLink?: Maybe<GenericLink>;
  /** Create one genericPage */
  createGenericPage?: Maybe<GenericPage>;
  /** Create one globalMetaData */
  createGlobalMetaData?: Maybe<GlobalMetaData>;
  /** Create one heroBanner */
  createHeroBanner?: Maybe<HeroBanner>;
  /** Create one heroCarouselComponent */
  createHeroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Create one heroComponent */
  createHeroComponent?: Maybe<HeroComponent>;
  /** Create one homePage */
  createHomePage?: Maybe<HomePage>;
  /** Create one iframe */
  createIframe?: Maybe<Iframe>;
  /** Create one imageAndTextCard */
  createImageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Create one imageCopy */
  createImageCopy?: Maybe<ImageCopy>;
  /** Create one imageCopyItem */
  createImageCopyItem?: Maybe<ImageCopyItem>;
  /** Create one introText */
  createIntroText?: Maybe<IntroText>;
  /** Create one leftColumn */
  createLeftColumn?: Maybe<LeftColumn>;
  /** Create one link */
  createLink?: Maybe<Link>;
  /** Create one locationComponent */
  createLocationComponent?: Maybe<LocationComponent>;
  /** Create one locationItem */
  createLocationItem?: Maybe<LocationItem>;
  /** Create one longText */
  createLongText?: Maybe<LongText>;
  /** Create one mediaLibrary */
  createMediaLibrary?: Maybe<MediaLibrary>;
  /** Create one mediaLibraryItem */
  createMediaLibraryItem?: Maybe<MediaLibraryItem>;
  /** Create one metaData */
  createMetaData?: Maybe<MetaData>;
  /** Create one mobileOnlyMainNavigation */
  createMobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Create one navigation */
  createNavigation?: Maybe<Navigation>;
  /** Create one navigationItem */
  createNavigationItem?: Maybe<NavigationItem>;
  /** Create one notificationBanner */
  createNotificationBanner?: Maybe<NotificationBanner>;
  /** Create one pageFooter */
  createPageFooter?: Maybe<PageFooter>;
  /** Create one pageHeader */
  createPageHeader?: Maybe<PageHeader>;
  /** Create one popularSearchComponent */
  createPopularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Create one pressRelease */
  createPressRelease?: Maybe<PressRelease>;
  /** Create one pressStoriesCard */
  createPressStoriesCard?: Maybe<PressStoriesCard>;
  /** Create one progressBar */
  createProgressBar?: Maybe<ProgressBar>;
  /** Create one quickLink */
  createQuickLink?: Maybe<QuickLink>;
  /** Create one quickLinkItem */
  createQuickLinkItem?: Maybe<QuickLinkItem>;
  /** Create one redirect */
  createRedirect?: Maybe<Redirect>;
  /** Create one rewrite */
  createRewrite?: Maybe<Rewrite>;
  /** Create one rightColumn */
  createRightColumn?: Maybe<RightColumn>;
  /** Create one scheduledRelease */
  createScheduledRelease?: Maybe<ScheduledRelease>;
  /** Create one searchInput */
  createSearchInput?: Maybe<SearchInput>;
  /** Create one searchOverlayComponent */
  createSearchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Create one searchResultPage */
  createSearchResultPage?: Maybe<SearchResultPage>;
  /** Create one shortHero */
  createShortHero?: Maybe<ShortHero>;
  /** Create one socialMediaListComponent */
  createSocialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Create one spacer */
  createSpacer?: Maybe<Spacer>;
  /** Create one story */
  createStory?: Maybe<Story>;
  /** Create one subCategoryKeyImage */
  createSubCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Create one sustainabilityBanner */
  createSustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Create one sustainabilityInfo */
  createSustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Create one tab */
  createTab?: Maybe<Tab>;
  /** Create one tabContent */
  createTabContent?: Maybe<TabContent>;
  /** Create one testTipsANdTricksInAMarket */
  createTestTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Create one textComponent */
  createTextComponent?: Maybe<TextComponent>;
  /** Create one tipsAndTricksDetailsPage */
  createTipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Create one title */
  createTitle?: Maybe<Title>;
  /** Create one twitterSeo */
  createTwitterSeo?: Maybe<TwitterSeo>;
  /** Create one widget */
  createWidget?: Maybe<Widget>;
  /** Delete one accordion from _all_ existing stages. Returns deleted document. */
  deleteAccordion?: Maybe<Accordion>;
  /** Delete one accordionItem from _all_ existing stages. Returns deleted document. */
  deleteAccordionItem?: Maybe<AccordionItem>;
  /** Delete one alexTestComponent from _all_ existing stages. Returns deleted document. */
  deleteAlexTestComponent?: Maybe<AlexTestComponent>;
  /** Delete one algoliaExtension from _all_ existing stages. Returns deleted document. */
  deleteAlgoliaExtension?: Maybe<AlgoliaExtension>;
  /** Delete one anchorNav from _all_ existing stages. Returns deleted document. */
  deleteAnchorNav?: Maybe<AnchorNav>;
  /** Delete one anchorNavigation from _all_ existing stages. Returns deleted document. */
  deleteAnchorNavigation?: Maybe<AnchorNavigation>;
  /** Delete one anchorNavigationList from _all_ existing stages. Returns deleted document. */
  deleteAnchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Delete one asset from _all_ existing stages. Returns deleted document. */
  deleteAsset?: Maybe<Asset>;
  /** Delete one assetComponent from _all_ existing stages. Returns deleted document. */
  deleteAssetComponent?: Maybe<AssetComponent>;
  /** Delete one audioComponent from _all_ existing stages. Returns deleted document. */
  deleteAudioComponent?: Maybe<AudioComponent>;
  /** Delete one authorableContentCard from _all_ existing stages. Returns deleted document. */
  deleteAuthorableContentCard?: Maybe<AuthorableContentCard>;
  /** Delete one banner2 from _all_ existing stages. Returns deleted document. */
  deleteBanner2?: Maybe<Banner2>;
  /** Delete one bigNumber from _all_ existing stages. Returns deleted document. */
  deleteBigNumber?: Maybe<BigNumber>;
  /** Delete one bigNumberItem from _all_ existing stages. Returns deleted document. */
  deleteBigNumberItem?: Maybe<BigNumberItem>;
  /** Delete one cardComponent from _all_ existing stages. Returns deleted document. */
  deleteCardComponent?: Maybe<CardComponent>;
  /** Delete one carouselComponent from _all_ existing stages. Returns deleted document. */
  deleteCarouselComponent?: Maybe<CarouselComponent>;
  /** Delete one carouselSlide from _all_ existing stages. Returns deleted document. */
  deleteCarouselSlide?: Maybe<CarouselSlide>;
  /** Delete one categoryCard from _all_ existing stages. Returns deleted document. */
  deleteCategoryCard?: Maybe<CategoryCard>;
  /** Delete one contactCard from _all_ existing stages. Returns deleted document. */
  deleteContactCard?: Maybe<ContactCard>;
  /** Delete one contactCardContainer from _all_ existing stages. Returns deleted document. */
  deleteContactCardContainer?: Maybe<ContactCardContainer>;
  /** Delete one corpAddToCalendar from _all_ existing stages. Returns deleted document. */
  deleteCorpAddToCalendar?: Maybe<CorpAddToCalendar>;
  /** Delete one corpBanner1 from _all_ existing stages. Returns deleted document. */
  deleteCorpBanner1?: Maybe<CorpBanner1>;
  /** Delete one corpCalendarEvent from _all_ existing stages. Returns deleted document. */
  deleteCorpCalendarEvent?: Maybe<CorpCalendarEvent>;
  /** Delete one corpCardCarousel from _all_ existing stages. Returns deleted document. */
  deleteCorpCardCarousel?: Maybe<CorpCardCarousel>;
  /** Delete one corpContactCard from _all_ existing stages. Returns deleted document. */
  deleteCorpContactCard?: Maybe<CorpContactCard>;
  /** Delete one corpContactCardContainer from _all_ existing stages. Returns deleted document. */
  deleteCorpContactCardContainer?: Maybe<CorpContactCardContainer>;
  /** Delete one corpForm from _all_ existing stages. Returns deleted document. */
  deleteCorpForm?: Maybe<CorpForm>;
  /** Delete one corpGenericAccordion from _all_ existing stages. Returns deleted document. */
  deleteCorpGenericAccordion?: Maybe<CorpGenericAccordion>;
  /** Delete one corpGenericAccordionItem from _all_ existing stages. Returns deleted document. */
  deleteCorpGenericAccordionItem?: Maybe<CorpGenericAccordionItem>;
  /** Delete one corpGenericBanner from _all_ existing stages. Returns deleted document. */
  deleteCorpGenericBanner?: Maybe<CorpGenericBanner>;
  /** Delete one corpGenericContainer from _all_ existing stages. Returns deleted document. */
  deleteCorpGenericContainer?: Maybe<CorpGenericContainer>;
  /** Delete one corpGridColumnComponent from _all_ existing stages. Returns deleted document. */
  deleteCorpGridColumnComponent?: Maybe<CorpGridColumnComponent>;
  /** Delete one corpHero from _all_ existing stages. Returns deleted document. */
  deleteCorpHero?: Maybe<CorpHero>;
  /** Delete one corpMediaDownloadPreview from _all_ existing stages. Returns deleted document. */
  deleteCorpMediaDownloadPreview?: Maybe<CorpMediaDownloadPreview>;
  /** Delete one corpNavigation from _all_ existing stages. Returns deleted document. */
  deleteCorpNavigation?: Maybe<CorpNavigation>;
  /** Delete one corpNavigationItem from _all_ existing stages. Returns deleted document. */
  deleteCorpNavigationItem?: Maybe<CorpNavigationItem>;
  /** Delete one corpNotificationBanner from _all_ existing stages. Returns deleted document. */
  deleteCorpNotificationBanner?: Maybe<CorpNotificationBanner>;
  /** Delete one corpOurPeople from _all_ existing stages. Returns deleted document. */
  deleteCorpOurPeople?: Maybe<CorpOurPeople>;
  /** Delete one corpOurPeopleItem from _all_ existing stages. Returns deleted document. */
  deleteCorpOurPeopleItem?: Maybe<CorpOurPeopleItem>;
  /** Delete one corpPressPage from _all_ existing stages. Returns deleted document. */
  deleteCorpPressPage?: Maybe<CorpPressPage>;
  /** Delete one corpSocialMediaFooter from _all_ existing stages. Returns deleted document. */
  deleteCorpSocialMediaFooter?: Maybe<CorpSocialMediaFooter>;
  /** Delete one corpStoriesPage from _all_ existing stages. Returns deleted document. */
  deleteCorpStoriesPage?: Maybe<CorpStoriesPage>;
  /** Delete one corpStoryCarousel from _all_ existing stages. Returns deleted document. */
  deleteCorpStoryCarousel?: Maybe<CorpStoryCarousel>;
  /** Delete one corpTimelineAccordion from _all_ existing stages. Returns deleted document. */
  deleteCorpTimelineAccordion?: Maybe<CorpTimelineAccordion>;
  /** Delete one corpTimelineAccordionItem from _all_ existing stages. Returns deleted document. */
  deleteCorpTimelineAccordionItem?: Maybe<CorpTimelineAccordionItem>;
  /** Delete one corpTimelineAccordionWrapper from _all_ existing stages. Returns deleted document. */
  deleteCorpTimelineAccordionWrapper?: Maybe<CorpTimelineAccordionWrapper>;
  /** Delete one corpVideoHero from _all_ existing stages. Returns deleted document. */
  deleteCorpVideoHero?: Maybe<CorpVideoHero>;
  /** Delete one corpVideoHeroCarousel from _all_ existing stages. Returns deleted document. */
  deleteCorpVideoHeroCarousel?: Maybe<CorpVideoHeroCarousel>;
  /** Delete one countrySelector from _all_ existing stages. Returns deleted document. */
  deleteCountrySelector?: Maybe<CountrySelector>;
  /** Delete one countrySelectorItem from _all_ existing stages. Returns deleted document. */
  deleteCountrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Delete one dEPRECATEDBanner1 from _all_ existing stages. Returns deleted document. */
  deleteDEPRECATEDBanner1?: Maybe<DeprecatedBanner1>;
  /** Delete one deprecatedCorpNavigationCopy from _all_ existing stages. Returns deleted document. */
  deleteDeprecatedCorpNavigationCopy?: Maybe<DeprecatedCorpNavigationCopy>;
  /** Delete one dictionary from _all_ existing stages. Returns deleted document. */
  deleteDictionary?: Maybe<Dictionary>;
  /** Delete one dictionaryItem from _all_ existing stages. Returns deleted document. */
  deleteDictionaryItem?: Maybe<DictionaryItem>;
  /** Delete one dynamicCardGrid from _all_ existing stages. Returns deleted document. */
  deleteDynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Delete one evalancheFormComponent from _all_ existing stages. Returns deleted document. */
  deleteEvalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Delete one exampleComponent from _all_ existing stages. Returns deleted document. */
  deleteExampleComponent?: Maybe<ExampleComponent>;
  /** Delete one featuredContent from _all_ existing stages. Returns deleted document. */
  deleteFeaturedContent?: Maybe<FeaturedContent>;
  /** Delete one featuredContentReference from _all_ existing stages. Returns deleted document. */
  deleteFeaturedContentReference?: Maybe<FeaturedContentReference>;
  /** Delete one footerNavigation from _all_ existing stages. Returns deleted document. */
  deleteFooterNavigation?: Maybe<FooterNavigation>;
  /** Delete one form from _all_ existing stages. Returns deleted document. */
  deleteForm?: Maybe<Form>;
  /** Delete one formCheckbox from _all_ existing stages. Returns deleted document. */
  deleteFormCheckbox?: Maybe<FormCheckbox>;
  /** Delete one formEmailInput from _all_ existing stages. Returns deleted document. */
  deleteFormEmailInput?: Maybe<FormEmailInput>;
  /** Delete one formError from _all_ existing stages. Returns deleted document. */
  deleteFormError?: Maybe<FormError>;
  /** Delete one formPasswordInput from _all_ existing stages. Returns deleted document. */
  deleteFormPasswordInput?: Maybe<FormPasswordInput>;
  /** Delete one formPasswordInputWithConfirmation from _all_ existing stages. Returns deleted document. */
  deleteFormPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Delete one formRadioButton from _all_ existing stages. Returns deleted document. */
  deleteFormRadioButton?: Maybe<FormRadioButton>;
  /** Delete one formRadioButtonCollection from _all_ existing stages. Returns deleted document. */
  deleteFormRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Delete one formSelectComponent from _all_ existing stages. Returns deleted document. */
  deleteFormSelectComponent?: Maybe<FormSelectComponent>;
  /** Delete one formSelectOption from _all_ existing stages. Returns deleted document. */
  deleteFormSelectOption?: Maybe<FormSelectOption>;
  /** Delete one formSubmitButton from _all_ existing stages. Returns deleted document. */
  deleteFormSubmitButton?: Maybe<FormSubmitButton>;
  /** Delete one formSuccessComponent from _all_ existing stages. Returns deleted document. */
  deleteFormSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Delete one formTextInput from _all_ existing stages. Returns deleted document. */
  deleteFormTextInput?: Maybe<FormTextInput>;
  /** Delete one formTextareaInput from _all_ existing stages. Returns deleted document. */
  deleteFormTextareaInput?: Maybe<FormTextareaInput>;
  /** Delete one genericAccordion from _all_ existing stages. Returns deleted document. */
  deleteGenericAccordion?: Maybe<GenericAccordion>;
  /** Delete one genericAccordionItem from _all_ existing stages. Returns deleted document. */
  deleteGenericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Delete one genericAccordionTopRated from _all_ existing stages. Returns deleted document. */
  deleteGenericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Delete one genericCardCarouseComponent from _all_ existing stages. Returns deleted document. */
  deleteGenericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Delete one genericDownloadComponent from _all_ existing stages. Returns deleted document. */
  deleteGenericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Delete one genericFollowUs from _all_ existing stages. Returns deleted document. */
  deleteGenericFollowUs?: Maybe<GenericFollowUs>;
  /** Delete one genericGridAuthorable from _all_ existing stages. Returns deleted document. */
  deleteGenericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Delete one genericLine from _all_ existing stages. Returns deleted document. */
  deleteGenericLine?: Maybe<GenericLine>;
  /** Delete one genericLink from _all_ existing stages. Returns deleted document. */
  deleteGenericLink?: Maybe<GenericLink>;
  /** Delete one genericPage from _all_ existing stages. Returns deleted document. */
  deleteGenericPage?: Maybe<GenericPage>;
  /** Delete one globalMetaData from _all_ existing stages. Returns deleted document. */
  deleteGlobalMetaData?: Maybe<GlobalMetaData>;
  /** Delete one heroBanner from _all_ existing stages. Returns deleted document. */
  deleteHeroBanner?: Maybe<HeroBanner>;
  /** Delete one heroCarouselComponent from _all_ existing stages. Returns deleted document. */
  deleteHeroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Delete one heroComponent from _all_ existing stages. Returns deleted document. */
  deleteHeroComponent?: Maybe<HeroComponent>;
  /** Delete one homePage from _all_ existing stages. Returns deleted document. */
  deleteHomePage?: Maybe<HomePage>;
  /** Delete one iframe from _all_ existing stages. Returns deleted document. */
  deleteIframe?: Maybe<Iframe>;
  /** Delete one imageAndTextCard from _all_ existing stages. Returns deleted document. */
  deleteImageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Delete one imageCopy from _all_ existing stages. Returns deleted document. */
  deleteImageCopy?: Maybe<ImageCopy>;
  /** Delete one imageCopyItem from _all_ existing stages. Returns deleted document. */
  deleteImageCopyItem?: Maybe<ImageCopyItem>;
  /** Delete one introText from _all_ existing stages. Returns deleted document. */
  deleteIntroText?: Maybe<IntroText>;
  /** Delete one leftColumn from _all_ existing stages. Returns deleted document. */
  deleteLeftColumn?: Maybe<LeftColumn>;
  /** Delete one link from _all_ existing stages. Returns deleted document. */
  deleteLink?: Maybe<Link>;
  /** Delete one locationComponent from _all_ existing stages. Returns deleted document. */
  deleteLocationComponent?: Maybe<LocationComponent>;
  /** Delete one locationItem from _all_ existing stages. Returns deleted document. */
  deleteLocationItem?: Maybe<LocationItem>;
  /** Delete one longText from _all_ existing stages. Returns deleted document. */
  deleteLongText?: Maybe<LongText>;
  /**
   * Delete many AccordionItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyAccordionItemsConnection)
   */
  deleteManyAccordionItems: BatchPayload;
  /** Delete many AccordionItem documents, return deleted documents */
  deleteManyAccordionItemsConnection: AccordionItemConnection;
  /**
   * Delete many Accordion documents
   * @deprecated Please use the new paginated many mutation (deleteManyAccordionsConnection)
   */
  deleteManyAccordions: BatchPayload;
  /** Delete many Accordion documents, return deleted documents */
  deleteManyAccordionsConnection: AccordionConnection;
  /**
   * Delete many AlexTestComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyAlexTestComponentsConnection)
   */
  deleteManyAlexTestComponents: BatchPayload;
  /** Delete many AlexTestComponent documents, return deleted documents */
  deleteManyAlexTestComponentsConnection: AlexTestComponentConnection;
  /**
   * Delete many AlgoliaExtension documents
   * @deprecated Please use the new paginated many mutation (deleteManyAlgoliaExtensionsConnection)
   */
  deleteManyAlgoliaExtensions: BatchPayload;
  /** Delete many AlgoliaExtension documents, return deleted documents */
  deleteManyAlgoliaExtensionsConnection: AlgoliaExtensionConnection;
  /**
   * Delete many AnchorNavigationList documents
   * @deprecated Please use the new paginated many mutation (deleteManyAnchorNavigationListsConnection)
   */
  deleteManyAnchorNavigationLists: BatchPayload;
  /** Delete many AnchorNavigationList documents, return deleted documents */
  deleteManyAnchorNavigationListsConnection: AnchorNavigationListConnection;
  /**
   * Delete many AnchorNavigation documents
   * @deprecated Please use the new paginated many mutation (deleteManyAnchorNavigationsConnection)
   */
  deleteManyAnchorNavigations: BatchPayload;
  /** Delete many AnchorNavigation documents, return deleted documents */
  deleteManyAnchorNavigationsConnection: AnchorNavigationConnection;
  /**
   * Delete many AnchorNav documents
   * @deprecated Please use the new paginated many mutation (deleteManyAnchorNavsConnection)
   */
  deleteManyAnchorNavs: BatchPayload;
  /** Delete many AnchorNav documents, return deleted documents */
  deleteManyAnchorNavsConnection: AnchorNavConnection;
  /**
   * Delete many Asset documents
   * @deprecated Please use the new paginated many mutation (deleteManyAssetsConnection)
   */
  deleteManyAssets: BatchPayload;
  /**
   * Delete many AssetComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyAssetsComponentsConnection)
   */
  deleteManyAssetsComponents: BatchPayload;
  /** Delete many AssetComponent documents, return deleted documents */
  deleteManyAssetsComponentsConnection: AssetComponentConnection;
  /** Delete many Asset documents, return deleted documents */
  deleteManyAssetsConnection: AssetConnection;
  /**
   * Delete many AudioComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyAudioComponentsConnection)
   */
  deleteManyAudioComponents: BatchPayload;
  /** Delete many AudioComponent documents, return deleted documents */
  deleteManyAudioComponentsConnection: AudioComponentConnection;
  /**
   * Delete many AuthorableContentCard documents
   * @deprecated Please use the new paginated many mutation (deleteManyAuthorableContentCardsConnection)
   */
  deleteManyAuthorableContentCards: BatchPayload;
  /** Delete many AuthorableContentCard documents, return deleted documents */
  deleteManyAuthorableContentCardsConnection: AuthorableContentCardConnection;
  /**
   * Delete many Banner2 documents
   * @deprecated Please use the new paginated many mutation (deleteManyBanner2SConnection)
   */
  deleteManyBanner2S: BatchPayload;
  /** Delete many Banner2 documents, return deleted documents */
  deleteManyBanner2SConnection: Banner2Connection;
  /**
   * Delete many BigNumberItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyBigNumberItemsConnection)
   */
  deleteManyBigNumberItems: BatchPayload;
  /** Delete many BigNumberItem documents, return deleted documents */
  deleteManyBigNumberItemsConnection: BigNumberItemConnection;
  /**
   * Delete many BigNumber documents
   * @deprecated Please use the new paginated many mutation (deleteManyBigNumbersConnection)
   */
  deleteManyBigNumbers: BatchPayload;
  /** Delete many BigNumber documents, return deleted documents */
  deleteManyBigNumbersConnection: BigNumberConnection;
  /**
   * Delete many CardComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyCardComponentsConnection)
   */
  deleteManyCardComponents: BatchPayload;
  /** Delete many CardComponent documents, return deleted documents */
  deleteManyCardComponentsConnection: CardComponentConnection;
  /**
   * Delete many CarouselComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyCarouselComponentsConnection)
   */
  deleteManyCarouselComponents: BatchPayload;
  /** Delete many CarouselComponent documents, return deleted documents */
  deleteManyCarouselComponentsConnection: CarouselComponentConnection;
  /**
   * Delete many CarouselSlide documents
   * @deprecated Please use the new paginated many mutation (deleteManyCarouselSlidesConnection)
   */
  deleteManyCarouselSlides: BatchPayload;
  /** Delete many CarouselSlide documents, return deleted documents */
  deleteManyCarouselSlidesConnection: CarouselSlideConnection;
  /**
   * Delete many CategoryCard documents
   * @deprecated Please use the new paginated many mutation (deleteManyCategoryCardsConnection)
   */
  deleteManyCategoryCards: BatchPayload;
  /** Delete many CategoryCard documents, return deleted documents */
  deleteManyCategoryCardsConnection: CategoryCardConnection;
  /**
   * Delete many ContactCardContainer documents
   * @deprecated Please use the new paginated many mutation (deleteManyContactCardContainersConnection)
   */
  deleteManyContactCardContainers: BatchPayload;
  /** Delete many ContactCardContainer documents, return deleted documents */
  deleteManyContactCardContainersConnection: ContactCardContainerConnection;
  /**
   * Delete many ContactCard documents
   * @deprecated Please use the new paginated many mutation (deleteManyContactCardsConnection)
   */
  deleteManyContactCards: BatchPayload;
  /** Delete many ContactCard documents, return deleted documents */
  deleteManyContactCardsConnection: ContactCardConnection;
  /**
   * Delete many CorpAddToCalendar documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpAddToCalendarsConnection)
   */
  deleteManyCorpAddToCalendars: BatchPayload;
  /** Delete many CorpAddToCalendar documents, return deleted documents */
  deleteManyCorpAddToCalendarsConnection: CorpAddToCalendarConnection;
  /**
   * Delete many CorpBanner1 documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpBanners1Connection)
   */
  deleteManyCorpBanners1: BatchPayload;
  /** Delete many CorpBanner1 documents, return deleted documents */
  deleteManyCorpBanners1Connection: CorpBanner1Connection;
  /**
   * Delete many CorpCalendarEvent documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpCalendarEventsConnection)
   */
  deleteManyCorpCalendarEvents: BatchPayload;
  /** Delete many CorpCalendarEvent documents, return deleted documents */
  deleteManyCorpCalendarEventsConnection: CorpCalendarEventConnection;
  /**
   * Delete many CorpCardCarousel documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpCardCarouselsConnection)
   */
  deleteManyCorpCardCarousels: BatchPayload;
  /** Delete many CorpCardCarousel documents, return deleted documents */
  deleteManyCorpCardCarouselsConnection: CorpCardCarouselConnection;
  /**
   * Delete many CorpContactCardContainer documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpContactCardContainersConnection)
   */
  deleteManyCorpContactCardContainers: BatchPayload;
  /** Delete many CorpContactCardContainer documents, return deleted documents */
  deleteManyCorpContactCardContainersConnection: CorpContactCardContainerConnection;
  /**
   * Delete many CorpContactCard documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpContactCardsConnection)
   */
  deleteManyCorpContactCards: BatchPayload;
  /** Delete many CorpContactCard documents, return deleted documents */
  deleteManyCorpContactCardsConnection: CorpContactCardConnection;
  /**
   * Delete many CorpForm documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpFormsConnection)
   */
  deleteManyCorpForms: BatchPayload;
  /** Delete many CorpForm documents, return deleted documents */
  deleteManyCorpFormsConnection: CorpFormConnection;
  /**
   * Delete many CorpGenericAccordionItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpGenericAccordionItemsConnection)
   */
  deleteManyCorpGenericAccordionItems: BatchPayload;
  /** Delete many CorpGenericAccordionItem documents, return deleted documents */
  deleteManyCorpGenericAccordionItemsConnection: CorpGenericAccordionItemConnection;
  /**
   * Delete many CorpGenericAccordion documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpGenericAccordionsConnection)
   */
  deleteManyCorpGenericAccordions: BatchPayload;
  /** Delete many CorpGenericAccordion documents, return deleted documents */
  deleteManyCorpGenericAccordionsConnection: CorpGenericAccordionConnection;
  /**
   * Delete many CorpGenericBanner documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpGenericBannersConnection)
   */
  deleteManyCorpGenericBanners: BatchPayload;
  /** Delete many CorpGenericBanner documents, return deleted documents */
  deleteManyCorpGenericBannersConnection: CorpGenericBannerConnection;
  /**
   * Delete many CorpGenericContainer documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpGenericContainersConnection)
   */
  deleteManyCorpGenericContainers: BatchPayload;
  /** Delete many CorpGenericContainer documents, return deleted documents */
  deleteManyCorpGenericContainersConnection: CorpGenericContainerConnection;
  /**
   * Delete many CorpGridColumnComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpGridColumnComponentsConnection)
   */
  deleteManyCorpGridColumnComponents: BatchPayload;
  /** Delete many CorpGridColumnComponent documents, return deleted documents */
  deleteManyCorpGridColumnComponentsConnection: CorpGridColumnComponentConnection;
  /**
   * Delete many CorpHero documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpHerosConnection)
   */
  deleteManyCorpHeros: BatchPayload;
  /** Delete many CorpHero documents, return deleted documents */
  deleteManyCorpHerosConnection: CorpHeroConnection;
  /**
   * Delete many CorpMediaDownloadPreview documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpMediaDownloadPreviewsConnection)
   */
  deleteManyCorpMediaDownloadPreviews: BatchPayload;
  /** Delete many CorpMediaDownloadPreview documents, return deleted documents */
  deleteManyCorpMediaDownloadPreviewsConnection: CorpMediaDownloadPreviewConnection;
  /**
   * Delete many CorpNavigationItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpNavigationItemsConnection)
   */
  deleteManyCorpNavigationItems: BatchPayload;
  /** Delete many CorpNavigationItem documents, return deleted documents */
  deleteManyCorpNavigationItemsConnection: CorpNavigationItemConnection;
  /**
   * Delete many CorpNavigation documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpNavigationsConnection)
   */
  deleteManyCorpNavigations: BatchPayload;
  /** Delete many CorpNavigation documents, return deleted documents */
  deleteManyCorpNavigationsConnection: CorpNavigationConnection;
  /**
   * Delete many CorpNotificationBanner documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpNotificationBannersConnection)
   */
  deleteManyCorpNotificationBanners: BatchPayload;
  /** Delete many CorpNotificationBanner documents, return deleted documents */
  deleteManyCorpNotificationBannersConnection: CorpNotificationBannerConnection;
  /**
   * Delete many CorpOurPeopleItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpOurPeopleItemsConnection)
   */
  deleteManyCorpOurPeopleItems: BatchPayload;
  /** Delete many CorpOurPeopleItem documents, return deleted documents */
  deleteManyCorpOurPeopleItemsConnection: CorpOurPeopleItemConnection;
  /**
   * Delete many CorpOurPeople documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpOurPeoplesConnection)
   */
  deleteManyCorpOurPeoples: BatchPayload;
  /** Delete many CorpOurPeople documents, return deleted documents */
  deleteManyCorpOurPeoplesConnection: CorpOurPeopleConnection;
  /**
   * Delete many CorpPressPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpPressPagesConnection)
   */
  deleteManyCorpPressPages: BatchPayload;
  /** Delete many CorpPressPage documents, return deleted documents */
  deleteManyCorpPressPagesConnection: CorpPressPageConnection;
  /**
   * Delete many CorpSocialMediaFooter documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpSocialMediaFootersConnection)
   */
  deleteManyCorpSocialMediaFooters: BatchPayload;
  /** Delete many CorpSocialMediaFooter documents, return deleted documents */
  deleteManyCorpSocialMediaFootersConnection: CorpSocialMediaFooterConnection;
  /**
   * Delete many CorpStoriesPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpStoriesPagesConnection)
   */
  deleteManyCorpStoriesPages: BatchPayload;
  /** Delete many CorpStoriesPage documents, return deleted documents */
  deleteManyCorpStoriesPagesConnection: CorpStoriesPageConnection;
  /**
   * Delete many CorpStoryCarousel documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpStoryCarouselsConnection)
   */
  deleteManyCorpStoryCarousels: BatchPayload;
  /** Delete many CorpStoryCarousel documents, return deleted documents */
  deleteManyCorpStoryCarouselsConnection: CorpStoryCarouselConnection;
  /**
   * Delete many CorpTimelineAccordionItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpTimelineAccordionItemsConnection)
   */
  deleteManyCorpTimelineAccordionItems: BatchPayload;
  /** Delete many CorpTimelineAccordionItem documents, return deleted documents */
  deleteManyCorpTimelineAccordionItemsConnection: CorpTimelineAccordionItemConnection;
  /**
   * Delete many CorpTimelineAccordionWrapper documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpTimelineAccordionWrappersConnection)
   */
  deleteManyCorpTimelineAccordionWrappers: BatchPayload;
  /** Delete many CorpTimelineAccordionWrapper documents, return deleted documents */
  deleteManyCorpTimelineAccordionWrappersConnection: CorpTimelineAccordionWrapperConnection;
  /**
   * Delete many CorpTimelineAccordion documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpTimelineAccordionsConnection)
   */
  deleteManyCorpTimelineAccordions: BatchPayload;
  /** Delete many CorpTimelineAccordion documents, return deleted documents */
  deleteManyCorpTimelineAccordionsConnection: CorpTimelineAccordionConnection;
  /**
   * Delete many CorpVideoHeroCarousel documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpVideoHeroCarouselsConnection)
   */
  deleteManyCorpVideoHeroCarousels: BatchPayload;
  /** Delete many CorpVideoHeroCarousel documents, return deleted documents */
  deleteManyCorpVideoHeroCarouselsConnection: CorpVideoHeroCarouselConnection;
  /**
   * Delete many CorpVideoHero documents
   * @deprecated Please use the new paginated many mutation (deleteManyCorpVideoHerosConnection)
   */
  deleteManyCorpVideoHeros: BatchPayload;
  /** Delete many CorpVideoHero documents, return deleted documents */
  deleteManyCorpVideoHerosConnection: CorpVideoHeroConnection;
  /**
   * Delete many CountrySelectorItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyCountrySelectorItemsConnection)
   */
  deleteManyCountrySelectorItems: BatchPayload;
  /** Delete many CountrySelectorItem documents, return deleted documents */
  deleteManyCountrySelectorItemsConnection: CountrySelectorItemConnection;
  /**
   * Delete many CountrySelector documents
   * @deprecated Please use the new paginated many mutation (deleteManyCountrySelectorsConnection)
   */
  deleteManyCountrySelectors: BatchPayload;
  /** Delete many CountrySelector documents, return deleted documents */
  deleteManyCountrySelectorsConnection: CountrySelectorConnection;
  /**
   * Delete many DEPRECATEDBanner1 documents
   * @deprecated Please use the new paginated many mutation (deleteManyDEPRECATEDBanner1sConnection)
   */
  deleteManyDEPRECATEDBanner1s: BatchPayload;
  /** Delete many DEPRECATEDBanner1 documents, return deleted documents */
  deleteManyDEPRECATEDBanner1sConnection: DeprecatedBanner1Connection;
  /**
   * Delete many DeprecatedCorpNavigationCopy documents
   * @deprecated Please use the new paginated many mutation (deleteManyDeprecatedCorpNavigationsConnection)
   */
  deleteManyDeprecatedCorpNavigations: BatchPayload;
  /** Delete many DeprecatedCorpNavigationCopy documents, return deleted documents */
  deleteManyDeprecatedCorpNavigationsConnection: DeprecatedCorpNavigationCopyConnection;
  /**
   * Delete many Dictionary documents
   * @deprecated Please use the new paginated many mutation (deleteManyDictionariesConnection)
   */
  deleteManyDictionaries: BatchPayload;
  /** Delete many Dictionary documents, return deleted documents */
  deleteManyDictionariesConnection: DictionaryConnection;
  /**
   * Delete many DictionaryItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyDictionaryItemsConnection)
   */
  deleteManyDictionaryItems: BatchPayload;
  /** Delete many DictionaryItem documents, return deleted documents */
  deleteManyDictionaryItemsConnection: DictionaryItemConnection;
  /**
   * Delete many DynamicCardGrid documents
   * @deprecated Please use the new paginated many mutation (deleteManyDynamicCardGridsConnection)
   */
  deleteManyDynamicCardGrids: BatchPayload;
  /** Delete many DynamicCardGrid documents, return deleted documents */
  deleteManyDynamicCardGridsConnection: DynamicCardGridConnection;
  /**
   * Delete many EvalancheFormComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyEvalancheFormComponentsConnection)
   */
  deleteManyEvalancheFormComponents: BatchPayload;
  /** Delete many EvalancheFormComponent documents, return deleted documents */
  deleteManyEvalancheFormComponentsConnection: EvalancheFormComponentConnection;
  /**
   * Delete many ExampleComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyExampleComponentsConnection)
   */
  deleteManyExampleComponents: BatchPayload;
  /** Delete many ExampleComponent documents, return deleted documents */
  deleteManyExampleComponentsConnection: ExampleComponentConnection;
  /**
   * Delete many FeaturedContentReference documents
   * @deprecated Please use the new paginated many mutation (deleteManyFeaturedContentReferencesConnection)
   */
  deleteManyFeaturedContentReferences: BatchPayload;
  /** Delete many FeaturedContentReference documents, return deleted documents */
  deleteManyFeaturedContentReferencesConnection: FeaturedContentReferenceConnection;
  /**
   * Delete many FeaturedContent documents
   * @deprecated Please use the new paginated many mutation (deleteManyFeaturedContentsConnection)
   */
  deleteManyFeaturedContents: BatchPayload;
  /** Delete many FeaturedContent documents, return deleted documents */
  deleteManyFeaturedContentsConnection: FeaturedContentConnection;
  /**
   * Delete many FooterNavigation documents
   * @deprecated Please use the new paginated many mutation (deleteManyFooterNavigationsConnection)
   */
  deleteManyFooterNavigations: BatchPayload;
  /** Delete many FooterNavigation documents, return deleted documents */
  deleteManyFooterNavigationsConnection: FooterNavigationConnection;
  /**
   * Delete many FormCheckbox documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormCheckboxesConnection)
   */
  deleteManyFormCheckboxes: BatchPayload;
  /** Delete many FormCheckbox documents, return deleted documents */
  deleteManyFormCheckboxesConnection: FormCheckboxConnection;
  /**
   * Delete many FormEmailInput documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormEmailInputsConnection)
   */
  deleteManyFormEmailInputs: BatchPayload;
  /** Delete many FormEmailInput documents, return deleted documents */
  deleteManyFormEmailInputsConnection: FormEmailInputConnection;
  /**
   * Delete many FormError documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormErrorsConnection)
   */
  deleteManyFormErrors: BatchPayload;
  /** Delete many FormError documents, return deleted documents */
  deleteManyFormErrorsConnection: FormErrorConnection;
  /**
   * Delete many FormPasswordInputWithConfirmation documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormPasswordInputWithConfirmationsConnection)
   */
  deleteManyFormPasswordInputWithConfirmations: BatchPayload;
  /** Delete many FormPasswordInputWithConfirmation documents, return deleted documents */
  deleteManyFormPasswordInputWithConfirmationsConnection: FormPasswordInputWithConfirmationConnection;
  /**
   * Delete many FormPasswordInput documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormPasswordInputsConnection)
   */
  deleteManyFormPasswordInputs: BatchPayload;
  /** Delete many FormPasswordInput documents, return deleted documents */
  deleteManyFormPasswordInputsConnection: FormPasswordInputConnection;
  /**
   * Delete many FormRadioButtonCollection documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormRadioButtonCollectionsConnection)
   */
  deleteManyFormRadioButtonCollections: BatchPayload;
  /** Delete many FormRadioButtonCollection documents, return deleted documents */
  deleteManyFormRadioButtonCollectionsConnection: FormRadioButtonCollectionConnection;
  /**
   * Delete many FormRadioButton documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormRadioButtonsConnection)
   */
  deleteManyFormRadioButtons: BatchPayload;
  /** Delete many FormRadioButton documents, return deleted documents */
  deleteManyFormRadioButtonsConnection: FormRadioButtonConnection;
  /**
   * Delete many FormSelectComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormSelectComponentsConnection)
   */
  deleteManyFormSelectComponents: BatchPayload;
  /** Delete many FormSelectComponent documents, return deleted documents */
  deleteManyFormSelectComponentsConnection: FormSelectComponentConnection;
  /**
   * Delete many FormSelectOption documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormSelectOptionsConnection)
   */
  deleteManyFormSelectOptions: BatchPayload;
  /** Delete many FormSelectOption documents, return deleted documents */
  deleteManyFormSelectOptionsConnection: FormSelectOptionConnection;
  /**
   * Delete many FormSubmitButton documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormSubmitButtonsConnection)
   */
  deleteManyFormSubmitButtons: BatchPayload;
  /** Delete many FormSubmitButton documents, return deleted documents */
  deleteManyFormSubmitButtonsConnection: FormSubmitButtonConnection;
  /**
   * Delete many FormSuccessComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormSuccessComponentsConnection)
   */
  deleteManyFormSuccessComponents: BatchPayload;
  /** Delete many FormSuccessComponent documents, return deleted documents */
  deleteManyFormSuccessComponentsConnection: FormSuccessComponentConnection;
  /**
   * Delete many FormTextInput documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormTextInputsConnection)
   */
  deleteManyFormTextInputs: BatchPayload;
  /** Delete many FormTextInput documents, return deleted documents */
  deleteManyFormTextInputsConnection: FormTextInputConnection;
  /**
   * Delete many FormTextareaInput documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormTextareaInputsConnection)
   */
  deleteManyFormTextareaInputs: BatchPayload;
  /** Delete many FormTextareaInput documents, return deleted documents */
  deleteManyFormTextareaInputsConnection: FormTextareaInputConnection;
  /**
   * Delete many Form documents
   * @deprecated Please use the new paginated many mutation (deleteManyFormsConnection)
   */
  deleteManyForms: BatchPayload;
  /** Delete many Form documents, return deleted documents */
  deleteManyFormsConnection: FormConnection;
  /**
   * Delete many GenericAccordionItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericAccordionItemsConnection)
   */
  deleteManyGenericAccordionItems: BatchPayload;
  /** Delete many GenericAccordionItem documents, return deleted documents */
  deleteManyGenericAccordionItemsConnection: GenericAccordionItemConnection;
  /**
   * Delete many GenericAccordionTopRated documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericAccordionTopRatedsConnection)
   */
  deleteManyGenericAccordionTopRateds: BatchPayload;
  /** Delete many GenericAccordionTopRated documents, return deleted documents */
  deleteManyGenericAccordionTopRatedsConnection: GenericAccordionTopRatedConnection;
  /**
   * Delete many GenericAccordion documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericAccordionsConnection)
   */
  deleteManyGenericAccordions: BatchPayload;
  /** Delete many GenericAccordion documents, return deleted documents */
  deleteManyGenericAccordionsConnection: GenericAccordionConnection;
  /**
   * Delete many GenericCardCarouseComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericCardCarouseComponentsConnection)
   */
  deleteManyGenericCardCarouseComponents: BatchPayload;
  /** Delete many GenericCardCarouseComponent documents, return deleted documents */
  deleteManyGenericCardCarouseComponentsConnection: GenericCardCarouseComponentConnection;
  /**
   * Delete many GenericDownloadComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericDownloadComponentsConnection)
   */
  deleteManyGenericDownloadComponents: BatchPayload;
  /** Delete many GenericDownloadComponent documents, return deleted documents */
  deleteManyGenericDownloadComponentsConnection: GenericDownloadComponentConnection;
  /**
   * Delete many GenericFollowUs documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericFollowUsesConnection)
   */
  deleteManyGenericFollowUses: BatchPayload;
  /** Delete many GenericFollowUs documents, return deleted documents */
  deleteManyGenericFollowUsesConnection: GenericFollowUsConnection;
  /**
   * Delete many GenericGridAuthorable documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericGridAuthorablesConnection)
   */
  deleteManyGenericGridAuthorables: BatchPayload;
  /** Delete many GenericGridAuthorable documents, return deleted documents */
  deleteManyGenericGridAuthorablesConnection: GenericGridAuthorableConnection;
  /**
   * Delete many GenericLine documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericLinesConnection)
   */
  deleteManyGenericLines: BatchPayload;
  /** Delete many GenericLine documents, return deleted documents */
  deleteManyGenericLinesConnection: GenericLineConnection;
  /**
   * Delete many GenericLink documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericLinksConnection)
   */
  deleteManyGenericLinks: BatchPayload;
  /** Delete many GenericLink documents, return deleted documents */
  deleteManyGenericLinksConnection: GenericLinkConnection;
  /**
   * Delete many GenericPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyGenericPagesConnection)
   */
  deleteManyGenericPages: BatchPayload;
  /** Delete many GenericPage documents, return deleted documents */
  deleteManyGenericPagesConnection: GenericPageConnection;
  /**
   * Delete many GlobalMetaData documents
   * @deprecated Please use the new paginated many mutation (deleteManyGlobalMetaDatasConnection)
   */
  deleteManyGlobalMetaDatas: BatchPayload;
  /** Delete many GlobalMetaData documents, return deleted documents */
  deleteManyGlobalMetaDatasConnection: GlobalMetaDataConnection;
  /**
   * Delete many HeroBanner documents
   * @deprecated Please use the new paginated many mutation (deleteManyHeroBannersConnection)
   */
  deleteManyHeroBanners: BatchPayload;
  /** Delete many HeroBanner documents, return deleted documents */
  deleteManyHeroBannersConnection: HeroBannerConnection;
  /**
   * Delete many HeroCarouselComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyHeroCarouselComponentsConnection)
   */
  deleteManyHeroCarouselComponents: BatchPayload;
  /** Delete many HeroCarouselComponent documents, return deleted documents */
  deleteManyHeroCarouselComponentsConnection: HeroCarouselComponentConnection;
  /**
   * Delete many HeroComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyHeroComponentsConnection)
   */
  deleteManyHeroComponents: BatchPayload;
  /** Delete many HeroComponent documents, return deleted documents */
  deleteManyHeroComponentsConnection: HeroComponentConnection;
  /**
   * Delete many HomePage documents
   * @deprecated Please use the new paginated many mutation (deleteManyHomePagesConnection)
   */
  deleteManyHomePages: BatchPayload;
  /** Delete many HomePage documents, return deleted documents */
  deleteManyHomePagesConnection: HomePageConnection;
  /**
   * Delete many Iframe documents
   * @deprecated Please use the new paginated many mutation (deleteManyIframesConnection)
   */
  deleteManyIframes: BatchPayload;
  /** Delete many Iframe documents, return deleted documents */
  deleteManyIframesConnection: IframeConnection;
  /**
   * Delete many ImageAndTextCard documents
   * @deprecated Please use the new paginated many mutation (deleteManyImageAndTextCardsConnection)
   */
  deleteManyImageAndTextCards: BatchPayload;
  /** Delete many ImageAndTextCard documents, return deleted documents */
  deleteManyImageAndTextCardsConnection: ImageAndTextCardConnection;
  /**
   * Delete many ImageCopy documents
   * @deprecated Please use the new paginated many mutation (deleteManyImageCopiesConnection)
   */
  deleteManyImageCopies: BatchPayload;
  /** Delete many ImageCopy documents, return deleted documents */
  deleteManyImageCopiesConnection: ImageCopyConnection;
  /**
   * Delete many ImageCopyItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyImageCopyItemsConnection)
   */
  deleteManyImageCopyItems: BatchPayload;
  /** Delete many ImageCopyItem documents, return deleted documents */
  deleteManyImageCopyItemsConnection: ImageCopyItemConnection;
  /**
   * Delete many IntroText documents
   * @deprecated Please use the new paginated many mutation (deleteManyIntroTextsConnection)
   */
  deleteManyIntroTexts: BatchPayload;
  /** Delete many IntroText documents, return deleted documents */
  deleteManyIntroTextsConnection: IntroTextConnection;
  /**
   * Delete many LeftColumn documents
   * @deprecated Please use the new paginated many mutation (deleteManyLeftColumnsConnection)
   */
  deleteManyLeftColumns: BatchPayload;
  /** Delete many LeftColumn documents, return deleted documents */
  deleteManyLeftColumnsConnection: LeftColumnConnection;
  /**
   * Delete many Link documents
   * @deprecated Please use the new paginated many mutation (deleteManyLinksConnection)
   */
  deleteManyLinks: BatchPayload;
  /** Delete many Link documents, return deleted documents */
  deleteManyLinksConnection: LinkConnection;
  /**
   * Delete many LocationComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyLocationComponentsConnection)
   */
  deleteManyLocationComponents: BatchPayload;
  /** Delete many LocationComponent documents, return deleted documents */
  deleteManyLocationComponentsConnection: LocationComponentConnection;
  /**
   * Delete many LocationItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyLocationItemsConnection)
   */
  deleteManyLocationItems: BatchPayload;
  /** Delete many LocationItem documents, return deleted documents */
  deleteManyLocationItemsConnection: LocationItemConnection;
  /**
   * Delete many LongText documents
   * @deprecated Please use the new paginated many mutation (deleteManyLongTextsConnection)
   */
  deleteManyLongTexts: BatchPayload;
  /** Delete many LongText documents, return deleted documents */
  deleteManyLongTextsConnection: LongTextConnection;
  /**
   * Delete many MediaLibrary documents
   * @deprecated Please use the new paginated many mutation (deleteManyMediaLibrariesConnection)
   */
  deleteManyMediaLibraries: BatchPayload;
  /** Delete many MediaLibrary documents, return deleted documents */
  deleteManyMediaLibrariesConnection: MediaLibraryConnection;
  /**
   * Delete many MediaLibraryItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyMediaLibraryItemsConnection)
   */
  deleteManyMediaLibraryItems: BatchPayload;
  /** Delete many MediaLibraryItem documents, return deleted documents */
  deleteManyMediaLibraryItemsConnection: MediaLibraryItemConnection;
  /**
   * Delete many MetaData documents
   * @deprecated Please use the new paginated many mutation (deleteManyMetaDatasConnection)
   */
  deleteManyMetaDatas: BatchPayload;
  /** Delete many MetaData documents, return deleted documents */
  deleteManyMetaDatasConnection: MetaDataConnection;
  /**
   * Delete many MobileOnlyMainNavigation documents
   * @deprecated Please use the new paginated many mutation (deleteManyMobileOnlyMainNavigationsConnection)
   */
  deleteManyMobileOnlyMainNavigations: BatchPayload;
  /** Delete many MobileOnlyMainNavigation documents, return deleted documents */
  deleteManyMobileOnlyMainNavigationsConnection: MobileOnlyMainNavigationConnection;
  /**
   * Delete many NavigationItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyNavigationItemsConnection)
   */
  deleteManyNavigationItems: BatchPayload;
  /** Delete many NavigationItem documents, return deleted documents */
  deleteManyNavigationItemsConnection: NavigationItemConnection;
  /**
   * Delete many Navigation documents
   * @deprecated Please use the new paginated many mutation (deleteManyNavigationsConnection)
   */
  deleteManyNavigations: BatchPayload;
  /** Delete many Navigation documents, return deleted documents */
  deleteManyNavigationsConnection: NavigationConnection;
  /**
   * Delete many NotificationBanner documents
   * @deprecated Please use the new paginated many mutation (deleteManyNotificationBannersConnection)
   */
  deleteManyNotificationBanners: BatchPayload;
  /** Delete many NotificationBanner documents, return deleted documents */
  deleteManyNotificationBannersConnection: NotificationBannerConnection;
  /**
   * Delete many PageFooter documents
   * @deprecated Please use the new paginated many mutation (deleteManyPageFootersConnection)
   */
  deleteManyPageFooters: BatchPayload;
  /** Delete many PageFooter documents, return deleted documents */
  deleteManyPageFootersConnection: PageFooterConnection;
  /**
   * Delete many PageHeader documents
   * @deprecated Please use the new paginated many mutation (deleteManyPageHeadersConnection)
   */
  deleteManyPageHeaders: BatchPayload;
  /** Delete many PageHeader documents, return deleted documents */
  deleteManyPageHeadersConnection: PageHeaderConnection;
  /**
   * Delete many PopularSearchComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyPopularSearchComponentsConnection)
   */
  deleteManyPopularSearchComponents: BatchPayload;
  /** Delete many PopularSearchComponent documents, return deleted documents */
  deleteManyPopularSearchComponentsConnection: PopularSearchComponentConnection;
  /**
   * Delete many PressRelease documents
   * @deprecated Please use the new paginated many mutation (deleteManyPressReleasesConnection)
   */
  deleteManyPressReleases: BatchPayload;
  /** Delete many PressRelease documents, return deleted documents */
  deleteManyPressReleasesConnection: PressReleaseConnection;
  /**
   * Delete many PressStoriesCard documents
   * @deprecated Please use the new paginated many mutation (deleteManyPressStoriesCardsConnection)
   */
  deleteManyPressStoriesCards: BatchPayload;
  /** Delete many PressStoriesCard documents, return deleted documents */
  deleteManyPressStoriesCardsConnection: PressStoriesCardConnection;
  /**
   * Delete many ProgressBar documents
   * @deprecated Please use the new paginated many mutation (deleteManyProgressBarsConnection)
   */
  deleteManyProgressBars: BatchPayload;
  /** Delete many ProgressBar documents, return deleted documents */
  deleteManyProgressBarsConnection: ProgressBarConnection;
  /**
   * Delete many QuickLinkItem documents
   * @deprecated Please use the new paginated many mutation (deleteManyQuickLinkItemsConnection)
   */
  deleteManyQuickLinkItems: BatchPayload;
  /** Delete many QuickLinkItem documents, return deleted documents */
  deleteManyQuickLinkItemsConnection: QuickLinkItemConnection;
  /**
   * Delete many QuickLink documents
   * @deprecated Please use the new paginated many mutation (deleteManyQuickLinksConnection)
   */
  deleteManyQuickLinks: BatchPayload;
  /** Delete many QuickLink documents, return deleted documents */
  deleteManyQuickLinksConnection: QuickLinkConnection;
  /**
   * Delete many Redirect documents
   * @deprecated Please use the new paginated many mutation (deleteManyRedirectsConnection)
   */
  deleteManyRedirects: BatchPayload;
  /** Delete many Redirect documents, return deleted documents */
  deleteManyRedirectsConnection: RedirectConnection;
  /**
   * Delete many Rewrite documents
   * @deprecated Please use the new paginated many mutation (deleteManyRewritesConnection)
   */
  deleteManyRewrites: BatchPayload;
  /** Delete many Rewrite documents, return deleted documents */
  deleteManyRewritesConnection: RewriteConnection;
  /**
   * Delete many RightColumn documents
   * @deprecated Please use the new paginated many mutation (deleteManyRightColumnsConnection)
   */
  deleteManyRightColumns: BatchPayload;
  /** Delete many RightColumn documents, return deleted documents */
  deleteManyRightColumnsConnection: RightColumnConnection;
  /**
   * Delete many SearchInput documents
   * @deprecated Please use the new paginated many mutation (deleteManySearchInputsConnection)
   */
  deleteManySearchInputs: BatchPayload;
  /** Delete many SearchInput documents, return deleted documents */
  deleteManySearchInputsConnection: SearchInputConnection;
  /**
   * Delete many SearchOverlayComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManySearchOverlayComponentsConnection)
   */
  deleteManySearchOverlayComponents: BatchPayload;
  /** Delete many SearchOverlayComponent documents, return deleted documents */
  deleteManySearchOverlayComponentsConnection: SearchOverlayComponentConnection;
  /**
   * Delete many SearchResultPage documents
   * @deprecated Please use the new paginated many mutation (deleteManySearchResultPagesConnection)
   */
  deleteManySearchResultPages: BatchPayload;
  /** Delete many SearchResultPage documents, return deleted documents */
  deleteManySearchResultPagesConnection: SearchResultPageConnection;
  /**
   * Delete many ShortHero documents
   * @deprecated Please use the new paginated many mutation (deleteManyShortHeroesConnection)
   */
  deleteManyShortHeroes: BatchPayload;
  /** Delete many ShortHero documents, return deleted documents */
  deleteManyShortHeroesConnection: ShortHeroConnection;
  /**
   * Delete many SocialMediaListComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManySocialMediaListComponentsConnection)
   */
  deleteManySocialMediaListComponents: BatchPayload;
  /** Delete many SocialMediaListComponent documents, return deleted documents */
  deleteManySocialMediaListComponentsConnection: SocialMediaListComponentConnection;
  /**
   * Delete many Spacer documents
   * @deprecated Please use the new paginated many mutation (deleteManySpacersConnection)
   */
  deleteManySpacers: BatchPayload;
  /** Delete many Spacer documents, return deleted documents */
  deleteManySpacersConnection: SpacerConnection;
  /**
   * Delete many Story documents
   * @deprecated Please use the new paginated many mutation (deleteManyStoriesConnection)
   */
  deleteManyStories: BatchPayload;
  /** Delete many Story documents, return deleted documents */
  deleteManyStoriesConnection: StoryConnection;
  /**
   * Delete many SubCategoryKeyImage documents
   * @deprecated Please use the new paginated many mutation (deleteManySubCategoryKeyImagesConnection)
   */
  deleteManySubCategoryKeyImages: BatchPayload;
  /** Delete many SubCategoryKeyImage documents, return deleted documents */
  deleteManySubCategoryKeyImagesConnection: SubCategoryKeyImageConnection;
  /**
   * Delete many SustainabilityBanner documents
   * @deprecated Please use the new paginated many mutation (deleteManySustainabilityBannersConnection)
   */
  deleteManySustainabilityBanners: BatchPayload;
  /** Delete many SustainabilityBanner documents, return deleted documents */
  deleteManySustainabilityBannersConnection: SustainabilityBannerConnection;
  /**
   * Delete many SustainabilityInfo documents
   * @deprecated Please use the new paginated many mutation (deleteManySustainabilityInfosConnection)
   */
  deleteManySustainabilityInfos: BatchPayload;
  /** Delete many SustainabilityInfo documents, return deleted documents */
  deleteManySustainabilityInfosConnection: SustainabilityInfoConnection;
  /**
   * Delete many TabContent documents
   * @deprecated Please use the new paginated many mutation (deleteManyTabContentsConnection)
   */
  deleteManyTabContents: BatchPayload;
  /** Delete many TabContent documents, return deleted documents */
  deleteManyTabContentsConnection: TabContentConnection;
  /**
   * Delete many Tab documents
   * @deprecated Please use the new paginated many mutation (deleteManyTabsConnection)
   */
  deleteManyTabs: BatchPayload;
  /** Delete many Tab documents, return deleted documents */
  deleteManyTabsConnection: TabConnection;
  /**
   * Delete many TestTipsANdTricksInAMarket documents
   * @deprecated Please use the new paginated many mutation (deleteManyTestTipsANdTricksInAMarketsConnection)
   */
  deleteManyTestTipsANdTricksInAMarkets: BatchPayload;
  /** Delete many TestTipsANdTricksInAMarket documents, return deleted documents */
  deleteManyTestTipsANdTricksInAMarketsConnection: TestTipsANdTricksInAMarketConnection;
  /**
   * Delete many TextComponent documents
   * @deprecated Please use the new paginated many mutation (deleteManyTextComponentsConnection)
   */
  deleteManyTextComponents: BatchPayload;
  /** Delete many TextComponent documents, return deleted documents */
  deleteManyTextComponentsConnection: TextComponentConnection;
  /**
   * Delete many TipsAndTricksDetailsPage documents
   * @deprecated Please use the new paginated many mutation (deleteManyTipsAndTricksDetailsPagesConnection)
   */
  deleteManyTipsAndTricksDetailsPages: BatchPayload;
  /** Delete many TipsAndTricksDetailsPage documents, return deleted documents */
  deleteManyTipsAndTricksDetailsPagesConnection: TipsAndTricksDetailsPageConnection;
  /**
   * Delete many Title documents
   * @deprecated Please use the new paginated many mutation (deleteManyTitlesConnection)
   */
  deleteManyTitles: BatchPayload;
  /** Delete many Title documents, return deleted documents */
  deleteManyTitlesConnection: TitleConnection;
  /**
   * Delete many TwitterSeo documents
   * @deprecated Please use the new paginated many mutation (deleteManyTwitterSeosConnection)
   */
  deleteManyTwitterSeos: BatchPayload;
  /** Delete many TwitterSeo documents, return deleted documents */
  deleteManyTwitterSeosConnection: TwitterSeoConnection;
  /**
   * Delete many Widget documents
   * @deprecated Please use the new paginated many mutation (deleteManyWidgetsConnection)
   */
  deleteManyWidgets: BatchPayload;
  /** Delete many Widget documents, return deleted documents */
  deleteManyWidgetsConnection: WidgetConnection;
  /** Delete one mediaLibrary from _all_ existing stages. Returns deleted document. */
  deleteMediaLibrary?: Maybe<MediaLibrary>;
  /** Delete one mediaLibraryItem from _all_ existing stages. Returns deleted document. */
  deleteMediaLibraryItem?: Maybe<MediaLibraryItem>;
  /** Delete one metaData from _all_ existing stages. Returns deleted document. */
  deleteMetaData?: Maybe<MetaData>;
  /** Delete one mobileOnlyMainNavigation from _all_ existing stages. Returns deleted document. */
  deleteMobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Delete one navigation from _all_ existing stages. Returns deleted document. */
  deleteNavigation?: Maybe<Navigation>;
  /** Delete one navigationItem from _all_ existing stages. Returns deleted document. */
  deleteNavigationItem?: Maybe<NavigationItem>;
  /** Delete one notificationBanner from _all_ existing stages. Returns deleted document. */
  deleteNotificationBanner?: Maybe<NotificationBanner>;
  /** Delete one pageFooter from _all_ existing stages. Returns deleted document. */
  deletePageFooter?: Maybe<PageFooter>;
  /** Delete one pageHeader from _all_ existing stages. Returns deleted document. */
  deletePageHeader?: Maybe<PageHeader>;
  /** Delete one popularSearchComponent from _all_ existing stages. Returns deleted document. */
  deletePopularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Delete one pressRelease from _all_ existing stages. Returns deleted document. */
  deletePressRelease?: Maybe<PressRelease>;
  /** Delete one pressStoriesCard from _all_ existing stages. Returns deleted document. */
  deletePressStoriesCard?: Maybe<PressStoriesCard>;
  /** Delete one progressBar from _all_ existing stages. Returns deleted document. */
  deleteProgressBar?: Maybe<ProgressBar>;
  /** Delete one quickLink from _all_ existing stages. Returns deleted document. */
  deleteQuickLink?: Maybe<QuickLink>;
  /** Delete one quickLinkItem from _all_ existing stages. Returns deleted document. */
  deleteQuickLinkItem?: Maybe<QuickLinkItem>;
  /** Delete one redirect from _all_ existing stages. Returns deleted document. */
  deleteRedirect?: Maybe<Redirect>;
  /** Delete one rewrite from _all_ existing stages. Returns deleted document. */
  deleteRewrite?: Maybe<Rewrite>;
  /** Delete one rightColumn from _all_ existing stages. Returns deleted document. */
  deleteRightColumn?: Maybe<RightColumn>;
  /** Delete and return scheduled operation */
  deleteScheduledOperation?: Maybe<ScheduledOperation>;
  /** Delete one scheduledRelease from _all_ existing stages. Returns deleted document. */
  deleteScheduledRelease?: Maybe<ScheduledRelease>;
  /** Delete one searchInput from _all_ existing stages. Returns deleted document. */
  deleteSearchInput?: Maybe<SearchInput>;
  /** Delete one searchOverlayComponent from _all_ existing stages. Returns deleted document. */
  deleteSearchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Delete one searchResultPage from _all_ existing stages. Returns deleted document. */
  deleteSearchResultPage?: Maybe<SearchResultPage>;
  /** Delete one shortHero from _all_ existing stages. Returns deleted document. */
  deleteShortHero?: Maybe<ShortHero>;
  /** Delete one socialMediaListComponent from _all_ existing stages. Returns deleted document. */
  deleteSocialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Delete one spacer from _all_ existing stages. Returns deleted document. */
  deleteSpacer?: Maybe<Spacer>;
  /** Delete one story from _all_ existing stages. Returns deleted document. */
  deleteStory?: Maybe<Story>;
  /** Delete one subCategoryKeyImage from _all_ existing stages. Returns deleted document. */
  deleteSubCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Delete one sustainabilityBanner from _all_ existing stages. Returns deleted document. */
  deleteSustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Delete one sustainabilityInfo from _all_ existing stages. Returns deleted document. */
  deleteSustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Delete one tab from _all_ existing stages. Returns deleted document. */
  deleteTab?: Maybe<Tab>;
  /** Delete one tabContent from _all_ existing stages. Returns deleted document. */
  deleteTabContent?: Maybe<TabContent>;
  /** Delete one testTipsANdTricksInAMarket from _all_ existing stages. Returns deleted document. */
  deleteTestTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Delete one textComponent from _all_ existing stages. Returns deleted document. */
  deleteTextComponent?: Maybe<TextComponent>;
  /** Delete one tipsAndTricksDetailsPage from _all_ existing stages. Returns deleted document. */
  deleteTipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Delete one title from _all_ existing stages. Returns deleted document. */
  deleteTitle?: Maybe<Title>;
  /** Delete one twitterSeo from _all_ existing stages. Returns deleted document. */
  deleteTwitterSeo?: Maybe<TwitterSeo>;
  /** Delete one widget from _all_ existing stages. Returns deleted document. */
  deleteWidget?: Maybe<Widget>;
  /** Publish one accordion */
  publishAccordion?: Maybe<Accordion>;
  /** Publish one accordionItem */
  publishAccordionItem?: Maybe<AccordionItem>;
  /** Publish one alexTestComponent */
  publishAlexTestComponent?: Maybe<AlexTestComponent>;
  /** Publish one algoliaExtension */
  publishAlgoliaExtension?: Maybe<AlgoliaExtension>;
  /** Publish one anchorNav */
  publishAnchorNav?: Maybe<AnchorNav>;
  /** Publish one anchorNavigation */
  publishAnchorNavigation?: Maybe<AnchorNavigation>;
  /** Publish one anchorNavigationList */
  publishAnchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Publish one asset */
  publishAsset?: Maybe<Asset>;
  /** Publish one assetComponent */
  publishAssetComponent?: Maybe<AssetComponent>;
  /** Publish one audioComponent */
  publishAudioComponent?: Maybe<AudioComponent>;
  /** Publish one authorableContentCard */
  publishAuthorableContentCard?: Maybe<AuthorableContentCard>;
  /** Publish one banner2 */
  publishBanner2?: Maybe<Banner2>;
  /** Publish one bigNumber */
  publishBigNumber?: Maybe<BigNumber>;
  /** Publish one bigNumberItem */
  publishBigNumberItem?: Maybe<BigNumberItem>;
  /** Publish one cardComponent */
  publishCardComponent?: Maybe<CardComponent>;
  /** Publish one carouselComponent */
  publishCarouselComponent?: Maybe<CarouselComponent>;
  /** Publish one carouselSlide */
  publishCarouselSlide?: Maybe<CarouselSlide>;
  /** Publish one categoryCard */
  publishCategoryCard?: Maybe<CategoryCard>;
  /** Publish one contactCard */
  publishContactCard?: Maybe<ContactCard>;
  /** Publish one contactCardContainer */
  publishContactCardContainer?: Maybe<ContactCardContainer>;
  /** Publish one corpAddToCalendar */
  publishCorpAddToCalendar?: Maybe<CorpAddToCalendar>;
  /** Publish one corpBanner1 */
  publishCorpBanner1?: Maybe<CorpBanner1>;
  /** Publish one corpCalendarEvent */
  publishCorpCalendarEvent?: Maybe<CorpCalendarEvent>;
  /** Publish one corpCardCarousel */
  publishCorpCardCarousel?: Maybe<CorpCardCarousel>;
  /** Publish one corpContactCard */
  publishCorpContactCard?: Maybe<CorpContactCard>;
  /** Publish one corpContactCardContainer */
  publishCorpContactCardContainer?: Maybe<CorpContactCardContainer>;
  /** Publish one corpForm */
  publishCorpForm?: Maybe<CorpForm>;
  /** Publish one corpGenericAccordion */
  publishCorpGenericAccordion?: Maybe<CorpGenericAccordion>;
  /** Publish one corpGenericAccordionItem */
  publishCorpGenericAccordionItem?: Maybe<CorpGenericAccordionItem>;
  /** Publish one corpGenericBanner */
  publishCorpGenericBanner?: Maybe<CorpGenericBanner>;
  /** Publish one corpGenericContainer */
  publishCorpGenericContainer?: Maybe<CorpGenericContainer>;
  /** Publish one corpGridColumnComponent */
  publishCorpGridColumnComponent?: Maybe<CorpGridColumnComponent>;
  /** Publish one corpHero */
  publishCorpHero?: Maybe<CorpHero>;
  /** Publish one corpMediaDownloadPreview */
  publishCorpMediaDownloadPreview?: Maybe<CorpMediaDownloadPreview>;
  /** Publish one corpNavigation */
  publishCorpNavigation?: Maybe<CorpNavigation>;
  /** Publish one corpNavigationItem */
  publishCorpNavigationItem?: Maybe<CorpNavigationItem>;
  /** Publish one corpNotificationBanner */
  publishCorpNotificationBanner?: Maybe<CorpNotificationBanner>;
  /** Publish one corpOurPeople */
  publishCorpOurPeople?: Maybe<CorpOurPeople>;
  /** Publish one corpOurPeopleItem */
  publishCorpOurPeopleItem?: Maybe<CorpOurPeopleItem>;
  /** Publish one corpPressPage */
  publishCorpPressPage?: Maybe<CorpPressPage>;
  /** Publish one corpSocialMediaFooter */
  publishCorpSocialMediaFooter?: Maybe<CorpSocialMediaFooter>;
  /** Publish one corpStoriesPage */
  publishCorpStoriesPage?: Maybe<CorpStoriesPage>;
  /** Publish one corpStoryCarousel */
  publishCorpStoryCarousel?: Maybe<CorpStoryCarousel>;
  /** Publish one corpTimelineAccordion */
  publishCorpTimelineAccordion?: Maybe<CorpTimelineAccordion>;
  /** Publish one corpTimelineAccordionItem */
  publishCorpTimelineAccordionItem?: Maybe<CorpTimelineAccordionItem>;
  /** Publish one corpTimelineAccordionWrapper */
  publishCorpTimelineAccordionWrapper?: Maybe<CorpTimelineAccordionWrapper>;
  /** Publish one corpVideoHero */
  publishCorpVideoHero?: Maybe<CorpVideoHero>;
  /** Publish one corpVideoHeroCarousel */
  publishCorpVideoHeroCarousel?: Maybe<CorpVideoHeroCarousel>;
  /** Publish one countrySelector */
  publishCountrySelector?: Maybe<CountrySelector>;
  /** Publish one countrySelectorItem */
  publishCountrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Publish one dEPRECATEDBanner1 */
  publishDEPRECATEDBanner1?: Maybe<DeprecatedBanner1>;
  /** Publish one deprecatedCorpNavigationCopy */
  publishDeprecatedCorpNavigationCopy?: Maybe<DeprecatedCorpNavigationCopy>;
  /** Publish one dictionary */
  publishDictionary?: Maybe<Dictionary>;
  /** Publish one dictionaryItem */
  publishDictionaryItem?: Maybe<DictionaryItem>;
  /** Publish one dynamicCardGrid */
  publishDynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Publish one evalancheFormComponent */
  publishEvalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Publish one exampleComponent */
  publishExampleComponent?: Maybe<ExampleComponent>;
  /** Publish one featuredContent */
  publishFeaturedContent?: Maybe<FeaturedContent>;
  /** Publish one featuredContentReference */
  publishFeaturedContentReference?: Maybe<FeaturedContentReference>;
  /** Publish one footerNavigation */
  publishFooterNavigation?: Maybe<FooterNavigation>;
  /** Publish one form */
  publishForm?: Maybe<Form>;
  /** Publish one formCheckbox */
  publishFormCheckbox?: Maybe<FormCheckbox>;
  /** Publish one formEmailInput */
  publishFormEmailInput?: Maybe<FormEmailInput>;
  /** Publish one formError */
  publishFormError?: Maybe<FormError>;
  /** Publish one formPasswordInput */
  publishFormPasswordInput?: Maybe<FormPasswordInput>;
  /** Publish one formPasswordInputWithConfirmation */
  publishFormPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Publish one formRadioButton */
  publishFormRadioButton?: Maybe<FormRadioButton>;
  /** Publish one formRadioButtonCollection */
  publishFormRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Publish one formSelectComponent */
  publishFormSelectComponent?: Maybe<FormSelectComponent>;
  /** Publish one formSelectOption */
  publishFormSelectOption?: Maybe<FormSelectOption>;
  /** Publish one formSubmitButton */
  publishFormSubmitButton?: Maybe<FormSubmitButton>;
  /** Publish one formSuccessComponent */
  publishFormSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Publish one formTextInput */
  publishFormTextInput?: Maybe<FormTextInput>;
  /** Publish one formTextareaInput */
  publishFormTextareaInput?: Maybe<FormTextareaInput>;
  /** Publish one genericAccordion */
  publishGenericAccordion?: Maybe<GenericAccordion>;
  /** Publish one genericAccordionItem */
  publishGenericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Publish one genericAccordionTopRated */
  publishGenericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Publish one genericCardCarouseComponent */
  publishGenericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Publish one genericDownloadComponent */
  publishGenericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Publish one genericFollowUs */
  publishGenericFollowUs?: Maybe<GenericFollowUs>;
  /** Publish one genericGridAuthorable */
  publishGenericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Publish one genericLine */
  publishGenericLine?: Maybe<GenericLine>;
  /** Publish one genericLink */
  publishGenericLink?: Maybe<GenericLink>;
  /** Publish one genericPage */
  publishGenericPage?: Maybe<GenericPage>;
  /** Publish one globalMetaData */
  publishGlobalMetaData?: Maybe<GlobalMetaData>;
  /** Publish one heroBanner */
  publishHeroBanner?: Maybe<HeroBanner>;
  /** Publish one heroCarouselComponent */
  publishHeroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Publish one heroComponent */
  publishHeroComponent?: Maybe<HeroComponent>;
  /** Publish one homePage */
  publishHomePage?: Maybe<HomePage>;
  /** Publish one iframe */
  publishIframe?: Maybe<Iframe>;
  /** Publish one imageAndTextCard */
  publishImageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Publish one imageCopy */
  publishImageCopy?: Maybe<ImageCopy>;
  /** Publish one imageCopyItem */
  publishImageCopyItem?: Maybe<ImageCopyItem>;
  /** Publish one introText */
  publishIntroText?: Maybe<IntroText>;
  /** Publish one leftColumn */
  publishLeftColumn?: Maybe<LeftColumn>;
  /** Publish one link */
  publishLink?: Maybe<Link>;
  /** Publish one locationComponent */
  publishLocationComponent?: Maybe<LocationComponent>;
  /** Publish one locationItem */
  publishLocationItem?: Maybe<LocationItem>;
  /** Publish one longText */
  publishLongText?: Maybe<LongText>;
  /**
   * Publish many AccordionItem documents
   * @deprecated Please use the new paginated many mutation (publishManyAccordionItemsConnection)
   */
  publishManyAccordionItems: BatchPayload;
  /** Publish many AccordionItem documents */
  publishManyAccordionItemsConnection: AccordionItemConnection;
  /**
   * Publish many Accordion documents
   * @deprecated Please use the new paginated many mutation (publishManyAccordionsConnection)
   */
  publishManyAccordions: BatchPayload;
  /** Publish many Accordion documents */
  publishManyAccordionsConnection: AccordionConnection;
  /**
   * Publish many AlexTestComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyAlexTestComponentsConnection)
   */
  publishManyAlexTestComponents: BatchPayload;
  /** Publish many AlexTestComponent documents */
  publishManyAlexTestComponentsConnection: AlexTestComponentConnection;
  /**
   * Publish many AlgoliaExtension documents
   * @deprecated Please use the new paginated many mutation (publishManyAlgoliaExtensionsConnection)
   */
  publishManyAlgoliaExtensions: BatchPayload;
  /** Publish many AlgoliaExtension documents */
  publishManyAlgoliaExtensionsConnection: AlgoliaExtensionConnection;
  /**
   * Publish many AnchorNavigationList documents
   * @deprecated Please use the new paginated many mutation (publishManyAnchorNavigationListsConnection)
   */
  publishManyAnchorNavigationLists: BatchPayload;
  /** Publish many AnchorNavigationList documents */
  publishManyAnchorNavigationListsConnection: AnchorNavigationListConnection;
  /**
   * Publish many AnchorNavigation documents
   * @deprecated Please use the new paginated many mutation (publishManyAnchorNavigationsConnection)
   */
  publishManyAnchorNavigations: BatchPayload;
  /** Publish many AnchorNavigation documents */
  publishManyAnchorNavigationsConnection: AnchorNavigationConnection;
  /**
   * Publish many AnchorNav documents
   * @deprecated Please use the new paginated many mutation (publishManyAnchorNavsConnection)
   */
  publishManyAnchorNavs: BatchPayload;
  /** Publish many AnchorNav documents */
  publishManyAnchorNavsConnection: AnchorNavConnection;
  /**
   * Publish many Asset documents
   * @deprecated Please use the new paginated many mutation (publishManyAssetsConnection)
   */
  publishManyAssets: BatchPayload;
  /**
   * Publish many AssetComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyAssetsComponentsConnection)
   */
  publishManyAssetsComponents: BatchPayload;
  /** Publish many AssetComponent documents */
  publishManyAssetsComponentsConnection: AssetComponentConnection;
  /** Publish many Asset documents */
  publishManyAssetsConnection: AssetConnection;
  /**
   * Publish many AudioComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyAudioComponentsConnection)
   */
  publishManyAudioComponents: BatchPayload;
  /** Publish many AudioComponent documents */
  publishManyAudioComponentsConnection: AudioComponentConnection;
  /**
   * Publish many AuthorableContentCard documents
   * @deprecated Please use the new paginated many mutation (publishManyAuthorableContentCardsConnection)
   */
  publishManyAuthorableContentCards: BatchPayload;
  /** Publish many AuthorableContentCard documents */
  publishManyAuthorableContentCardsConnection: AuthorableContentCardConnection;
  /**
   * Publish many Banner2 documents
   * @deprecated Please use the new paginated many mutation (publishManyBanner2SConnection)
   */
  publishManyBanner2S: BatchPayload;
  /** Publish many Banner2 documents */
  publishManyBanner2SConnection: Banner2Connection;
  /**
   * Publish many BigNumberItem documents
   * @deprecated Please use the new paginated many mutation (publishManyBigNumberItemsConnection)
   */
  publishManyBigNumberItems: BatchPayload;
  /** Publish many BigNumberItem documents */
  publishManyBigNumberItemsConnection: BigNumberItemConnection;
  /**
   * Publish many BigNumber documents
   * @deprecated Please use the new paginated many mutation (publishManyBigNumbersConnection)
   */
  publishManyBigNumbers: BatchPayload;
  /** Publish many BigNumber documents */
  publishManyBigNumbersConnection: BigNumberConnection;
  /**
   * Publish many CardComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyCardComponentsConnection)
   */
  publishManyCardComponents: BatchPayload;
  /** Publish many CardComponent documents */
  publishManyCardComponentsConnection: CardComponentConnection;
  /**
   * Publish many CarouselComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyCarouselComponentsConnection)
   */
  publishManyCarouselComponents: BatchPayload;
  /** Publish many CarouselComponent documents */
  publishManyCarouselComponentsConnection: CarouselComponentConnection;
  /**
   * Publish many CarouselSlide documents
   * @deprecated Please use the new paginated many mutation (publishManyCarouselSlidesConnection)
   */
  publishManyCarouselSlides: BatchPayload;
  /** Publish many CarouselSlide documents */
  publishManyCarouselSlidesConnection: CarouselSlideConnection;
  /**
   * Publish many CategoryCard documents
   * @deprecated Please use the new paginated many mutation (publishManyCategoryCardsConnection)
   */
  publishManyCategoryCards: BatchPayload;
  /** Publish many CategoryCard documents */
  publishManyCategoryCardsConnection: CategoryCardConnection;
  /**
   * Publish many ContactCardContainer documents
   * @deprecated Please use the new paginated many mutation (publishManyContactCardContainersConnection)
   */
  publishManyContactCardContainers: BatchPayload;
  /** Publish many ContactCardContainer documents */
  publishManyContactCardContainersConnection: ContactCardContainerConnection;
  /**
   * Publish many ContactCard documents
   * @deprecated Please use the new paginated many mutation (publishManyContactCardsConnection)
   */
  publishManyContactCards: BatchPayload;
  /** Publish many ContactCard documents */
  publishManyContactCardsConnection: ContactCardConnection;
  /**
   * Publish many CorpAddToCalendar documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpAddToCalendarsConnection)
   */
  publishManyCorpAddToCalendars: BatchPayload;
  /** Publish many CorpAddToCalendar documents */
  publishManyCorpAddToCalendarsConnection: CorpAddToCalendarConnection;
  /**
   * Publish many CorpBanner1 documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpBanners1Connection)
   */
  publishManyCorpBanners1: BatchPayload;
  /** Publish many CorpBanner1 documents */
  publishManyCorpBanners1Connection: CorpBanner1Connection;
  /**
   * Publish many CorpCalendarEvent documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpCalendarEventsConnection)
   */
  publishManyCorpCalendarEvents: BatchPayload;
  /** Publish many CorpCalendarEvent documents */
  publishManyCorpCalendarEventsConnection: CorpCalendarEventConnection;
  /**
   * Publish many CorpCardCarousel documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpCardCarouselsConnection)
   */
  publishManyCorpCardCarousels: BatchPayload;
  /** Publish many CorpCardCarousel documents */
  publishManyCorpCardCarouselsConnection: CorpCardCarouselConnection;
  /**
   * Publish many CorpContactCardContainer documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpContactCardContainersConnection)
   */
  publishManyCorpContactCardContainers: BatchPayload;
  /** Publish many CorpContactCardContainer documents */
  publishManyCorpContactCardContainersConnection: CorpContactCardContainerConnection;
  /**
   * Publish many CorpContactCard documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpContactCardsConnection)
   */
  publishManyCorpContactCards: BatchPayload;
  /** Publish many CorpContactCard documents */
  publishManyCorpContactCardsConnection: CorpContactCardConnection;
  /**
   * Publish many CorpForm documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpFormsConnection)
   */
  publishManyCorpForms: BatchPayload;
  /** Publish many CorpForm documents */
  publishManyCorpFormsConnection: CorpFormConnection;
  /**
   * Publish many CorpGenericAccordionItem documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpGenericAccordionItemsConnection)
   */
  publishManyCorpGenericAccordionItems: BatchPayload;
  /** Publish many CorpGenericAccordionItem documents */
  publishManyCorpGenericAccordionItemsConnection: CorpGenericAccordionItemConnection;
  /**
   * Publish many CorpGenericAccordion documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpGenericAccordionsConnection)
   */
  publishManyCorpGenericAccordions: BatchPayload;
  /** Publish many CorpGenericAccordion documents */
  publishManyCorpGenericAccordionsConnection: CorpGenericAccordionConnection;
  /**
   * Publish many CorpGenericBanner documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpGenericBannersConnection)
   */
  publishManyCorpGenericBanners: BatchPayload;
  /** Publish many CorpGenericBanner documents */
  publishManyCorpGenericBannersConnection: CorpGenericBannerConnection;
  /**
   * Publish many CorpGenericContainer documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpGenericContainersConnection)
   */
  publishManyCorpGenericContainers: BatchPayload;
  /** Publish many CorpGenericContainer documents */
  publishManyCorpGenericContainersConnection: CorpGenericContainerConnection;
  /**
   * Publish many CorpGridColumnComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpGridColumnComponentsConnection)
   */
  publishManyCorpGridColumnComponents: BatchPayload;
  /** Publish many CorpGridColumnComponent documents */
  publishManyCorpGridColumnComponentsConnection: CorpGridColumnComponentConnection;
  /**
   * Publish many CorpHero documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpHerosConnection)
   */
  publishManyCorpHeros: BatchPayload;
  /** Publish many CorpHero documents */
  publishManyCorpHerosConnection: CorpHeroConnection;
  /**
   * Publish many CorpMediaDownloadPreview documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpMediaDownloadPreviewsConnection)
   */
  publishManyCorpMediaDownloadPreviews: BatchPayload;
  /** Publish many CorpMediaDownloadPreview documents */
  publishManyCorpMediaDownloadPreviewsConnection: CorpMediaDownloadPreviewConnection;
  /**
   * Publish many CorpNavigationItem documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpNavigationItemsConnection)
   */
  publishManyCorpNavigationItems: BatchPayload;
  /** Publish many CorpNavigationItem documents */
  publishManyCorpNavigationItemsConnection: CorpNavigationItemConnection;
  /**
   * Publish many CorpNavigation documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpNavigationsConnection)
   */
  publishManyCorpNavigations: BatchPayload;
  /** Publish many CorpNavigation documents */
  publishManyCorpNavigationsConnection: CorpNavigationConnection;
  /**
   * Publish many CorpNotificationBanner documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpNotificationBannersConnection)
   */
  publishManyCorpNotificationBanners: BatchPayload;
  /** Publish many CorpNotificationBanner documents */
  publishManyCorpNotificationBannersConnection: CorpNotificationBannerConnection;
  /**
   * Publish many CorpOurPeopleItem documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpOurPeopleItemsConnection)
   */
  publishManyCorpOurPeopleItems: BatchPayload;
  /** Publish many CorpOurPeopleItem documents */
  publishManyCorpOurPeopleItemsConnection: CorpOurPeopleItemConnection;
  /**
   * Publish many CorpOurPeople documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpOurPeoplesConnection)
   */
  publishManyCorpOurPeoples: BatchPayload;
  /** Publish many CorpOurPeople documents */
  publishManyCorpOurPeoplesConnection: CorpOurPeopleConnection;
  /**
   * Publish many CorpPressPage documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpPressPagesConnection)
   */
  publishManyCorpPressPages: BatchPayload;
  /** Publish many CorpPressPage documents */
  publishManyCorpPressPagesConnection: CorpPressPageConnection;
  /**
   * Publish many CorpSocialMediaFooter documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpSocialMediaFootersConnection)
   */
  publishManyCorpSocialMediaFooters: BatchPayload;
  /** Publish many CorpSocialMediaFooter documents */
  publishManyCorpSocialMediaFootersConnection: CorpSocialMediaFooterConnection;
  /**
   * Publish many CorpStoriesPage documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpStoriesPagesConnection)
   */
  publishManyCorpStoriesPages: BatchPayload;
  /** Publish many CorpStoriesPage documents */
  publishManyCorpStoriesPagesConnection: CorpStoriesPageConnection;
  /**
   * Publish many CorpStoryCarousel documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpStoryCarouselsConnection)
   */
  publishManyCorpStoryCarousels: BatchPayload;
  /** Publish many CorpStoryCarousel documents */
  publishManyCorpStoryCarouselsConnection: CorpStoryCarouselConnection;
  /**
   * Publish many CorpTimelineAccordionItem documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpTimelineAccordionItemsConnection)
   */
  publishManyCorpTimelineAccordionItems: BatchPayload;
  /** Publish many CorpTimelineAccordionItem documents */
  publishManyCorpTimelineAccordionItemsConnection: CorpTimelineAccordionItemConnection;
  /**
   * Publish many CorpTimelineAccordionWrapper documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpTimelineAccordionWrappersConnection)
   */
  publishManyCorpTimelineAccordionWrappers: BatchPayload;
  /** Publish many CorpTimelineAccordionWrapper documents */
  publishManyCorpTimelineAccordionWrappersConnection: CorpTimelineAccordionWrapperConnection;
  /**
   * Publish many CorpTimelineAccordion documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpTimelineAccordionsConnection)
   */
  publishManyCorpTimelineAccordions: BatchPayload;
  /** Publish many CorpTimelineAccordion documents */
  publishManyCorpTimelineAccordionsConnection: CorpTimelineAccordionConnection;
  /**
   * Publish many CorpVideoHeroCarousel documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpVideoHeroCarouselsConnection)
   */
  publishManyCorpVideoHeroCarousels: BatchPayload;
  /** Publish many CorpVideoHeroCarousel documents */
  publishManyCorpVideoHeroCarouselsConnection: CorpVideoHeroCarouselConnection;
  /**
   * Publish many CorpVideoHero documents
   * @deprecated Please use the new paginated many mutation (publishManyCorpVideoHerosConnection)
   */
  publishManyCorpVideoHeros: BatchPayload;
  /** Publish many CorpVideoHero documents */
  publishManyCorpVideoHerosConnection: CorpVideoHeroConnection;
  /**
   * Publish many CountrySelectorItem documents
   * @deprecated Please use the new paginated many mutation (publishManyCountrySelectorItemsConnection)
   */
  publishManyCountrySelectorItems: BatchPayload;
  /** Publish many CountrySelectorItem documents */
  publishManyCountrySelectorItemsConnection: CountrySelectorItemConnection;
  /**
   * Publish many CountrySelector documents
   * @deprecated Please use the new paginated many mutation (publishManyCountrySelectorsConnection)
   */
  publishManyCountrySelectors: BatchPayload;
  /** Publish many CountrySelector documents */
  publishManyCountrySelectorsConnection: CountrySelectorConnection;
  /**
   * Publish many DEPRECATEDBanner1 documents
   * @deprecated Please use the new paginated many mutation (publishManyDEPRECATEDBanner1sConnection)
   */
  publishManyDEPRECATEDBanner1s: BatchPayload;
  /** Publish many DEPRECATEDBanner1 documents */
  publishManyDEPRECATEDBanner1sConnection: DeprecatedBanner1Connection;
  /**
   * Publish many DeprecatedCorpNavigationCopy documents
   * @deprecated Please use the new paginated many mutation (publishManyDeprecatedCorpNavigationsConnection)
   */
  publishManyDeprecatedCorpNavigations: BatchPayload;
  /** Publish many DeprecatedCorpNavigationCopy documents */
  publishManyDeprecatedCorpNavigationsConnection: DeprecatedCorpNavigationCopyConnection;
  /**
   * Publish many Dictionary documents
   * @deprecated Please use the new paginated many mutation (publishManyDictionariesConnection)
   */
  publishManyDictionaries: BatchPayload;
  /** Publish many Dictionary documents */
  publishManyDictionariesConnection: DictionaryConnection;
  /**
   * Publish many DictionaryItem documents
   * @deprecated Please use the new paginated many mutation (publishManyDictionaryItemsConnection)
   */
  publishManyDictionaryItems: BatchPayload;
  /** Publish many DictionaryItem documents */
  publishManyDictionaryItemsConnection: DictionaryItemConnection;
  /**
   * Publish many DynamicCardGrid documents
   * @deprecated Please use the new paginated many mutation (publishManyDynamicCardGridsConnection)
   */
  publishManyDynamicCardGrids: BatchPayload;
  /** Publish many DynamicCardGrid documents */
  publishManyDynamicCardGridsConnection: DynamicCardGridConnection;
  /**
   * Publish many EvalancheFormComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyEvalancheFormComponentsConnection)
   */
  publishManyEvalancheFormComponents: BatchPayload;
  /** Publish many EvalancheFormComponent documents */
  publishManyEvalancheFormComponentsConnection: EvalancheFormComponentConnection;
  /**
   * Publish many ExampleComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyExampleComponentsConnection)
   */
  publishManyExampleComponents: BatchPayload;
  /** Publish many ExampleComponent documents */
  publishManyExampleComponentsConnection: ExampleComponentConnection;
  /**
   * Publish many FeaturedContentReference documents
   * @deprecated Please use the new paginated many mutation (publishManyFeaturedContentReferencesConnection)
   */
  publishManyFeaturedContentReferences: BatchPayload;
  /** Publish many FeaturedContentReference documents */
  publishManyFeaturedContentReferencesConnection: FeaturedContentReferenceConnection;
  /**
   * Publish many FeaturedContent documents
   * @deprecated Please use the new paginated many mutation (publishManyFeaturedContentsConnection)
   */
  publishManyFeaturedContents: BatchPayload;
  /** Publish many FeaturedContent documents */
  publishManyFeaturedContentsConnection: FeaturedContentConnection;
  /**
   * Publish many FooterNavigation documents
   * @deprecated Please use the new paginated many mutation (publishManyFooterNavigationsConnection)
   */
  publishManyFooterNavigations: BatchPayload;
  /** Publish many FooterNavigation documents */
  publishManyFooterNavigationsConnection: FooterNavigationConnection;
  /**
   * Publish many FormCheckbox documents
   * @deprecated Please use the new paginated many mutation (publishManyFormCheckboxesConnection)
   */
  publishManyFormCheckboxes: BatchPayload;
  /** Publish many FormCheckbox documents */
  publishManyFormCheckboxesConnection: FormCheckboxConnection;
  /**
   * Publish many FormEmailInput documents
   * @deprecated Please use the new paginated many mutation (publishManyFormEmailInputsConnection)
   */
  publishManyFormEmailInputs: BatchPayload;
  /** Publish many FormEmailInput documents */
  publishManyFormEmailInputsConnection: FormEmailInputConnection;
  /**
   * Publish many FormError documents
   * @deprecated Please use the new paginated many mutation (publishManyFormErrorsConnection)
   */
  publishManyFormErrors: BatchPayload;
  /** Publish many FormError documents */
  publishManyFormErrorsConnection: FormErrorConnection;
  /**
   * Publish many FormPasswordInputWithConfirmation documents
   * @deprecated Please use the new paginated many mutation (publishManyFormPasswordInputWithConfirmationsConnection)
   */
  publishManyFormPasswordInputWithConfirmations: BatchPayload;
  /** Publish many FormPasswordInputWithConfirmation documents */
  publishManyFormPasswordInputWithConfirmationsConnection: FormPasswordInputWithConfirmationConnection;
  /**
   * Publish many FormPasswordInput documents
   * @deprecated Please use the new paginated many mutation (publishManyFormPasswordInputsConnection)
   */
  publishManyFormPasswordInputs: BatchPayload;
  /** Publish many FormPasswordInput documents */
  publishManyFormPasswordInputsConnection: FormPasswordInputConnection;
  /**
   * Publish many FormRadioButtonCollection documents
   * @deprecated Please use the new paginated many mutation (publishManyFormRadioButtonCollectionsConnection)
   */
  publishManyFormRadioButtonCollections: BatchPayload;
  /** Publish many FormRadioButtonCollection documents */
  publishManyFormRadioButtonCollectionsConnection: FormRadioButtonCollectionConnection;
  /**
   * Publish many FormRadioButton documents
   * @deprecated Please use the new paginated many mutation (publishManyFormRadioButtonsConnection)
   */
  publishManyFormRadioButtons: BatchPayload;
  /** Publish many FormRadioButton documents */
  publishManyFormRadioButtonsConnection: FormRadioButtonConnection;
  /**
   * Publish many FormSelectComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyFormSelectComponentsConnection)
   */
  publishManyFormSelectComponents: BatchPayload;
  /** Publish many FormSelectComponent documents */
  publishManyFormSelectComponentsConnection: FormSelectComponentConnection;
  /**
   * Publish many FormSelectOption documents
   * @deprecated Please use the new paginated many mutation (publishManyFormSelectOptionsConnection)
   */
  publishManyFormSelectOptions: BatchPayload;
  /** Publish many FormSelectOption documents */
  publishManyFormSelectOptionsConnection: FormSelectOptionConnection;
  /**
   * Publish many FormSubmitButton documents
   * @deprecated Please use the new paginated many mutation (publishManyFormSubmitButtonsConnection)
   */
  publishManyFormSubmitButtons: BatchPayload;
  /** Publish many FormSubmitButton documents */
  publishManyFormSubmitButtonsConnection: FormSubmitButtonConnection;
  /**
   * Publish many FormSuccessComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyFormSuccessComponentsConnection)
   */
  publishManyFormSuccessComponents: BatchPayload;
  /** Publish many FormSuccessComponent documents */
  publishManyFormSuccessComponentsConnection: FormSuccessComponentConnection;
  /**
   * Publish many FormTextInput documents
   * @deprecated Please use the new paginated many mutation (publishManyFormTextInputsConnection)
   */
  publishManyFormTextInputs: BatchPayload;
  /** Publish many FormTextInput documents */
  publishManyFormTextInputsConnection: FormTextInputConnection;
  /**
   * Publish many FormTextareaInput documents
   * @deprecated Please use the new paginated many mutation (publishManyFormTextareaInputsConnection)
   */
  publishManyFormTextareaInputs: BatchPayload;
  /** Publish many FormTextareaInput documents */
  publishManyFormTextareaInputsConnection: FormTextareaInputConnection;
  /**
   * Publish many Form documents
   * @deprecated Please use the new paginated many mutation (publishManyFormsConnection)
   */
  publishManyForms: BatchPayload;
  /** Publish many Form documents */
  publishManyFormsConnection: FormConnection;
  /**
   * Publish many GenericAccordionItem documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericAccordionItemsConnection)
   */
  publishManyGenericAccordionItems: BatchPayload;
  /** Publish many GenericAccordionItem documents */
  publishManyGenericAccordionItemsConnection: GenericAccordionItemConnection;
  /**
   * Publish many GenericAccordionTopRated documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericAccordionTopRatedsConnection)
   */
  publishManyGenericAccordionTopRateds: BatchPayload;
  /** Publish many GenericAccordionTopRated documents */
  publishManyGenericAccordionTopRatedsConnection: GenericAccordionTopRatedConnection;
  /**
   * Publish many GenericAccordion documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericAccordionsConnection)
   */
  publishManyGenericAccordions: BatchPayload;
  /** Publish many GenericAccordion documents */
  publishManyGenericAccordionsConnection: GenericAccordionConnection;
  /**
   * Publish many GenericCardCarouseComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericCardCarouseComponentsConnection)
   */
  publishManyGenericCardCarouseComponents: BatchPayload;
  /** Publish many GenericCardCarouseComponent documents */
  publishManyGenericCardCarouseComponentsConnection: GenericCardCarouseComponentConnection;
  /**
   * Publish many GenericDownloadComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericDownloadComponentsConnection)
   */
  publishManyGenericDownloadComponents: BatchPayload;
  /** Publish many GenericDownloadComponent documents */
  publishManyGenericDownloadComponentsConnection: GenericDownloadComponentConnection;
  /**
   * Publish many GenericFollowUs documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericFollowUsesConnection)
   */
  publishManyGenericFollowUses: BatchPayload;
  /** Publish many GenericFollowUs documents */
  publishManyGenericFollowUsesConnection: GenericFollowUsConnection;
  /**
   * Publish many GenericGridAuthorable documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericGridAuthorablesConnection)
   */
  publishManyGenericGridAuthorables: BatchPayload;
  /** Publish many GenericGridAuthorable documents */
  publishManyGenericGridAuthorablesConnection: GenericGridAuthorableConnection;
  /**
   * Publish many GenericLine documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericLinesConnection)
   */
  publishManyGenericLines: BatchPayload;
  /** Publish many GenericLine documents */
  publishManyGenericLinesConnection: GenericLineConnection;
  /**
   * Publish many GenericLink documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericLinksConnection)
   */
  publishManyGenericLinks: BatchPayload;
  /** Publish many GenericLink documents */
  publishManyGenericLinksConnection: GenericLinkConnection;
  /**
   * Publish many GenericPage documents
   * @deprecated Please use the new paginated many mutation (publishManyGenericPagesConnection)
   */
  publishManyGenericPages: BatchPayload;
  /** Publish many GenericPage documents */
  publishManyGenericPagesConnection: GenericPageConnection;
  /**
   * Publish many GlobalMetaData documents
   * @deprecated Please use the new paginated many mutation (publishManyGlobalMetaDatasConnection)
   */
  publishManyGlobalMetaDatas: BatchPayload;
  /** Publish many GlobalMetaData documents */
  publishManyGlobalMetaDatasConnection: GlobalMetaDataConnection;
  /**
   * Publish many HeroBanner documents
   * @deprecated Please use the new paginated many mutation (publishManyHeroBannersConnection)
   */
  publishManyHeroBanners: BatchPayload;
  /** Publish many HeroBanner documents */
  publishManyHeroBannersConnection: HeroBannerConnection;
  /**
   * Publish many HeroCarouselComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyHeroCarouselComponentsConnection)
   */
  publishManyHeroCarouselComponents: BatchPayload;
  /** Publish many HeroCarouselComponent documents */
  publishManyHeroCarouselComponentsConnection: HeroCarouselComponentConnection;
  /**
   * Publish many HeroComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyHeroComponentsConnection)
   */
  publishManyHeroComponents: BatchPayload;
  /** Publish many HeroComponent documents */
  publishManyHeroComponentsConnection: HeroComponentConnection;
  /**
   * Publish many HomePage documents
   * @deprecated Please use the new paginated many mutation (publishManyHomePagesConnection)
   */
  publishManyHomePages: BatchPayload;
  /** Publish many HomePage documents */
  publishManyHomePagesConnection: HomePageConnection;
  /**
   * Publish many Iframe documents
   * @deprecated Please use the new paginated many mutation (publishManyIframesConnection)
   */
  publishManyIframes: BatchPayload;
  /** Publish many Iframe documents */
  publishManyIframesConnection: IframeConnection;
  /**
   * Publish many ImageAndTextCard documents
   * @deprecated Please use the new paginated many mutation (publishManyImageAndTextCardsConnection)
   */
  publishManyImageAndTextCards: BatchPayload;
  /** Publish many ImageAndTextCard documents */
  publishManyImageAndTextCardsConnection: ImageAndTextCardConnection;
  /**
   * Publish many ImageCopy documents
   * @deprecated Please use the new paginated many mutation (publishManyImageCopiesConnection)
   */
  publishManyImageCopies: BatchPayload;
  /** Publish many ImageCopy documents */
  publishManyImageCopiesConnection: ImageCopyConnection;
  /**
   * Publish many ImageCopyItem documents
   * @deprecated Please use the new paginated many mutation (publishManyImageCopyItemsConnection)
   */
  publishManyImageCopyItems: BatchPayload;
  /** Publish many ImageCopyItem documents */
  publishManyImageCopyItemsConnection: ImageCopyItemConnection;
  /**
   * Publish many IntroText documents
   * @deprecated Please use the new paginated many mutation (publishManyIntroTextsConnection)
   */
  publishManyIntroTexts: BatchPayload;
  /** Publish many IntroText documents */
  publishManyIntroTextsConnection: IntroTextConnection;
  /**
   * Publish many LeftColumn documents
   * @deprecated Please use the new paginated many mutation (publishManyLeftColumnsConnection)
   */
  publishManyLeftColumns: BatchPayload;
  /** Publish many LeftColumn documents */
  publishManyLeftColumnsConnection: LeftColumnConnection;
  /**
   * Publish many Link documents
   * @deprecated Please use the new paginated many mutation (publishManyLinksConnection)
   */
  publishManyLinks: BatchPayload;
  /** Publish many Link documents */
  publishManyLinksConnection: LinkConnection;
  /**
   * Publish many LocationComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyLocationComponentsConnection)
   */
  publishManyLocationComponents: BatchPayload;
  /** Publish many LocationComponent documents */
  publishManyLocationComponentsConnection: LocationComponentConnection;
  /**
   * Publish many LocationItem documents
   * @deprecated Please use the new paginated many mutation (publishManyLocationItemsConnection)
   */
  publishManyLocationItems: BatchPayload;
  /** Publish many LocationItem documents */
  publishManyLocationItemsConnection: LocationItemConnection;
  /**
   * Publish many LongText documents
   * @deprecated Please use the new paginated many mutation (publishManyLongTextsConnection)
   */
  publishManyLongTexts: BatchPayload;
  /** Publish many LongText documents */
  publishManyLongTextsConnection: LongTextConnection;
  /**
   * Publish many MediaLibrary documents
   * @deprecated Please use the new paginated many mutation (publishManyMediaLibrariesConnection)
   */
  publishManyMediaLibraries: BatchPayload;
  /** Publish many MediaLibrary documents */
  publishManyMediaLibrariesConnection: MediaLibraryConnection;
  /**
   * Publish many MediaLibraryItem documents
   * @deprecated Please use the new paginated many mutation (publishManyMediaLibraryItemsConnection)
   */
  publishManyMediaLibraryItems: BatchPayload;
  /** Publish many MediaLibraryItem documents */
  publishManyMediaLibraryItemsConnection: MediaLibraryItemConnection;
  /**
   * Publish many MetaData documents
   * @deprecated Please use the new paginated many mutation (publishManyMetaDatasConnection)
   */
  publishManyMetaDatas: BatchPayload;
  /** Publish many MetaData documents */
  publishManyMetaDatasConnection: MetaDataConnection;
  /**
   * Publish many MobileOnlyMainNavigation documents
   * @deprecated Please use the new paginated many mutation (publishManyMobileOnlyMainNavigationsConnection)
   */
  publishManyMobileOnlyMainNavigations: BatchPayload;
  /** Publish many MobileOnlyMainNavigation documents */
  publishManyMobileOnlyMainNavigationsConnection: MobileOnlyMainNavigationConnection;
  /**
   * Publish many NavigationItem documents
   * @deprecated Please use the new paginated many mutation (publishManyNavigationItemsConnection)
   */
  publishManyNavigationItems: BatchPayload;
  /** Publish many NavigationItem documents */
  publishManyNavigationItemsConnection: NavigationItemConnection;
  /**
   * Publish many Navigation documents
   * @deprecated Please use the new paginated many mutation (publishManyNavigationsConnection)
   */
  publishManyNavigations: BatchPayload;
  /** Publish many Navigation documents */
  publishManyNavigationsConnection: NavigationConnection;
  /**
   * Publish many NotificationBanner documents
   * @deprecated Please use the new paginated many mutation (publishManyNotificationBannersConnection)
   */
  publishManyNotificationBanners: BatchPayload;
  /** Publish many NotificationBanner documents */
  publishManyNotificationBannersConnection: NotificationBannerConnection;
  /**
   * Publish many PageFooter documents
   * @deprecated Please use the new paginated many mutation (publishManyPageFootersConnection)
   */
  publishManyPageFooters: BatchPayload;
  /** Publish many PageFooter documents */
  publishManyPageFootersConnection: PageFooterConnection;
  /**
   * Publish many PageHeader documents
   * @deprecated Please use the new paginated many mutation (publishManyPageHeadersConnection)
   */
  publishManyPageHeaders: BatchPayload;
  /** Publish many PageHeader documents */
  publishManyPageHeadersConnection: PageHeaderConnection;
  /**
   * Publish many PopularSearchComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyPopularSearchComponentsConnection)
   */
  publishManyPopularSearchComponents: BatchPayload;
  /** Publish many PopularSearchComponent documents */
  publishManyPopularSearchComponentsConnection: PopularSearchComponentConnection;
  /**
   * Publish many PressRelease documents
   * @deprecated Please use the new paginated many mutation (publishManyPressReleasesConnection)
   */
  publishManyPressReleases: BatchPayload;
  /** Publish many PressRelease documents */
  publishManyPressReleasesConnection: PressReleaseConnection;
  /**
   * Publish many PressStoriesCard documents
   * @deprecated Please use the new paginated many mutation (publishManyPressStoriesCardsConnection)
   */
  publishManyPressStoriesCards: BatchPayload;
  /** Publish many PressStoriesCard documents */
  publishManyPressStoriesCardsConnection: PressStoriesCardConnection;
  /**
   * Publish many ProgressBar documents
   * @deprecated Please use the new paginated many mutation (publishManyProgressBarsConnection)
   */
  publishManyProgressBars: BatchPayload;
  /** Publish many ProgressBar documents */
  publishManyProgressBarsConnection: ProgressBarConnection;
  /**
   * Publish many QuickLinkItem documents
   * @deprecated Please use the new paginated many mutation (publishManyQuickLinkItemsConnection)
   */
  publishManyQuickLinkItems: BatchPayload;
  /** Publish many QuickLinkItem documents */
  publishManyQuickLinkItemsConnection: QuickLinkItemConnection;
  /**
   * Publish many QuickLink documents
   * @deprecated Please use the new paginated many mutation (publishManyQuickLinksConnection)
   */
  publishManyQuickLinks: BatchPayload;
  /** Publish many QuickLink documents */
  publishManyQuickLinksConnection: QuickLinkConnection;
  /**
   * Publish many Redirect documents
   * @deprecated Please use the new paginated many mutation (publishManyRedirectsConnection)
   */
  publishManyRedirects: BatchPayload;
  /** Publish many Redirect documents */
  publishManyRedirectsConnection: RedirectConnection;
  /**
   * Publish many Rewrite documents
   * @deprecated Please use the new paginated many mutation (publishManyRewritesConnection)
   */
  publishManyRewrites: BatchPayload;
  /** Publish many Rewrite documents */
  publishManyRewritesConnection: RewriteConnection;
  /**
   * Publish many RightColumn documents
   * @deprecated Please use the new paginated many mutation (publishManyRightColumnsConnection)
   */
  publishManyRightColumns: BatchPayload;
  /** Publish many RightColumn documents */
  publishManyRightColumnsConnection: RightColumnConnection;
  /**
   * Publish many SearchInput documents
   * @deprecated Please use the new paginated many mutation (publishManySearchInputsConnection)
   */
  publishManySearchInputs: BatchPayload;
  /** Publish many SearchInput documents */
  publishManySearchInputsConnection: SearchInputConnection;
  /**
   * Publish many SearchOverlayComponent documents
   * @deprecated Please use the new paginated many mutation (publishManySearchOverlayComponentsConnection)
   */
  publishManySearchOverlayComponents: BatchPayload;
  /** Publish many SearchOverlayComponent documents */
  publishManySearchOverlayComponentsConnection: SearchOverlayComponentConnection;
  /**
   * Publish many SearchResultPage documents
   * @deprecated Please use the new paginated many mutation (publishManySearchResultPagesConnection)
   */
  publishManySearchResultPages: BatchPayload;
  /** Publish many SearchResultPage documents */
  publishManySearchResultPagesConnection: SearchResultPageConnection;
  /**
   * Publish many ShortHero documents
   * @deprecated Please use the new paginated many mutation (publishManyShortHeroesConnection)
   */
  publishManyShortHeroes: BatchPayload;
  /** Publish many ShortHero documents */
  publishManyShortHeroesConnection: ShortHeroConnection;
  /**
   * Publish many SocialMediaListComponent documents
   * @deprecated Please use the new paginated many mutation (publishManySocialMediaListComponentsConnection)
   */
  publishManySocialMediaListComponents: BatchPayload;
  /** Publish many SocialMediaListComponent documents */
  publishManySocialMediaListComponentsConnection: SocialMediaListComponentConnection;
  /**
   * Publish many Spacer documents
   * @deprecated Please use the new paginated many mutation (publishManySpacersConnection)
   */
  publishManySpacers: BatchPayload;
  /** Publish many Spacer documents */
  publishManySpacersConnection: SpacerConnection;
  /**
   * Publish many Story documents
   * @deprecated Please use the new paginated many mutation (publishManyStoriesConnection)
   */
  publishManyStories: BatchPayload;
  /** Publish many Story documents */
  publishManyStoriesConnection: StoryConnection;
  /**
   * Publish many SubCategoryKeyImage documents
   * @deprecated Please use the new paginated many mutation (publishManySubCategoryKeyImagesConnection)
   */
  publishManySubCategoryKeyImages: BatchPayload;
  /** Publish many SubCategoryKeyImage documents */
  publishManySubCategoryKeyImagesConnection: SubCategoryKeyImageConnection;
  /**
   * Publish many SustainabilityBanner documents
   * @deprecated Please use the new paginated many mutation (publishManySustainabilityBannersConnection)
   */
  publishManySustainabilityBanners: BatchPayload;
  /** Publish many SustainabilityBanner documents */
  publishManySustainabilityBannersConnection: SustainabilityBannerConnection;
  /**
   * Publish many SustainabilityInfo documents
   * @deprecated Please use the new paginated many mutation (publishManySustainabilityInfosConnection)
   */
  publishManySustainabilityInfos: BatchPayload;
  /** Publish many SustainabilityInfo documents */
  publishManySustainabilityInfosConnection: SustainabilityInfoConnection;
  /**
   * Publish many TabContent documents
   * @deprecated Please use the new paginated many mutation (publishManyTabContentsConnection)
   */
  publishManyTabContents: BatchPayload;
  /** Publish many TabContent documents */
  publishManyTabContentsConnection: TabContentConnection;
  /**
   * Publish many Tab documents
   * @deprecated Please use the new paginated many mutation (publishManyTabsConnection)
   */
  publishManyTabs: BatchPayload;
  /** Publish many Tab documents */
  publishManyTabsConnection: TabConnection;
  /**
   * Publish many TestTipsANdTricksInAMarket documents
   * @deprecated Please use the new paginated many mutation (publishManyTestTipsANdTricksInAMarketsConnection)
   */
  publishManyTestTipsANdTricksInAMarkets: BatchPayload;
  /** Publish many TestTipsANdTricksInAMarket documents */
  publishManyTestTipsANdTricksInAMarketsConnection: TestTipsANdTricksInAMarketConnection;
  /**
   * Publish many TextComponent documents
   * @deprecated Please use the new paginated many mutation (publishManyTextComponentsConnection)
   */
  publishManyTextComponents: BatchPayload;
  /** Publish many TextComponent documents */
  publishManyTextComponentsConnection: TextComponentConnection;
  /**
   * Publish many TipsAndTricksDetailsPage documents
   * @deprecated Please use the new paginated many mutation (publishManyTipsAndTricksDetailsPagesConnection)
   */
  publishManyTipsAndTricksDetailsPages: BatchPayload;
  /** Publish many TipsAndTricksDetailsPage documents */
  publishManyTipsAndTricksDetailsPagesConnection: TipsAndTricksDetailsPageConnection;
  /**
   * Publish many Title documents
   * @deprecated Please use the new paginated many mutation (publishManyTitlesConnection)
   */
  publishManyTitles: BatchPayload;
  /** Publish many Title documents */
  publishManyTitlesConnection: TitleConnection;
  /**
   * Publish many TwitterSeo documents
   * @deprecated Please use the new paginated many mutation (publishManyTwitterSeosConnection)
   */
  publishManyTwitterSeos: BatchPayload;
  /** Publish many TwitterSeo documents */
  publishManyTwitterSeosConnection: TwitterSeoConnection;
  /**
   * Publish many Widget documents
   * @deprecated Please use the new paginated many mutation (publishManyWidgetsConnection)
   */
  publishManyWidgets: BatchPayload;
  /** Publish many Widget documents */
  publishManyWidgetsConnection: WidgetConnection;
  /** Publish one mediaLibrary */
  publishMediaLibrary?: Maybe<MediaLibrary>;
  /** Publish one mediaLibraryItem */
  publishMediaLibraryItem?: Maybe<MediaLibraryItem>;
  /** Publish one metaData */
  publishMetaData?: Maybe<MetaData>;
  /** Publish one mobileOnlyMainNavigation */
  publishMobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Publish one navigation */
  publishNavigation?: Maybe<Navigation>;
  /** Publish one navigationItem */
  publishNavigationItem?: Maybe<NavigationItem>;
  /** Publish one notificationBanner */
  publishNotificationBanner?: Maybe<NotificationBanner>;
  /** Publish one pageFooter */
  publishPageFooter?: Maybe<PageFooter>;
  /** Publish one pageHeader */
  publishPageHeader?: Maybe<PageHeader>;
  /** Publish one popularSearchComponent */
  publishPopularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Publish one pressRelease */
  publishPressRelease?: Maybe<PressRelease>;
  /** Publish one pressStoriesCard */
  publishPressStoriesCard?: Maybe<PressStoriesCard>;
  /** Publish one progressBar */
  publishProgressBar?: Maybe<ProgressBar>;
  /** Publish one quickLink */
  publishQuickLink?: Maybe<QuickLink>;
  /** Publish one quickLinkItem */
  publishQuickLinkItem?: Maybe<QuickLinkItem>;
  /** Publish one redirect */
  publishRedirect?: Maybe<Redirect>;
  /** Publish one rewrite */
  publishRewrite?: Maybe<Rewrite>;
  /** Publish one rightColumn */
  publishRightColumn?: Maybe<RightColumn>;
  /** Publish one searchInput */
  publishSearchInput?: Maybe<SearchInput>;
  /** Publish one searchOverlayComponent */
  publishSearchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Publish one searchResultPage */
  publishSearchResultPage?: Maybe<SearchResultPage>;
  /** Publish one shortHero */
  publishShortHero?: Maybe<ShortHero>;
  /** Publish one socialMediaListComponent */
  publishSocialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Publish one spacer */
  publishSpacer?: Maybe<Spacer>;
  /** Publish one story */
  publishStory?: Maybe<Story>;
  /** Publish one subCategoryKeyImage */
  publishSubCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Publish one sustainabilityBanner */
  publishSustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Publish one sustainabilityInfo */
  publishSustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Publish one tab */
  publishTab?: Maybe<Tab>;
  /** Publish one tabContent */
  publishTabContent?: Maybe<TabContent>;
  /** Publish one testTipsANdTricksInAMarket */
  publishTestTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Publish one textComponent */
  publishTextComponent?: Maybe<TextComponent>;
  /** Publish one tipsAndTricksDetailsPage */
  publishTipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Publish one title */
  publishTitle?: Maybe<Title>;
  /** Publish one twitterSeo */
  publishTwitterSeo?: Maybe<TwitterSeo>;
  /** Publish one widget */
  publishWidget?: Maybe<Widget>;
  /** Schedule to publish one accordion */
  schedulePublishAccordion?: Maybe<Accordion>;
  /** Schedule to publish one accordionItem */
  schedulePublishAccordionItem?: Maybe<AccordionItem>;
  /** Schedule to publish one alexTestComponent */
  schedulePublishAlexTestComponent?: Maybe<AlexTestComponent>;
  /** Schedule to publish one algoliaExtension */
  schedulePublishAlgoliaExtension?: Maybe<AlgoliaExtension>;
  /** Schedule to publish one anchorNav */
  schedulePublishAnchorNav?: Maybe<AnchorNav>;
  /** Schedule to publish one anchorNavigation */
  schedulePublishAnchorNavigation?: Maybe<AnchorNavigation>;
  /** Schedule to publish one anchorNavigationList */
  schedulePublishAnchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Schedule to publish one asset */
  schedulePublishAsset?: Maybe<Asset>;
  /** Schedule to publish one assetComponent */
  schedulePublishAssetComponent?: Maybe<AssetComponent>;
  /** Schedule to publish one audioComponent */
  schedulePublishAudioComponent?: Maybe<AudioComponent>;
  /** Schedule to publish one authorableContentCard */
  schedulePublishAuthorableContentCard?: Maybe<AuthorableContentCard>;
  /** Schedule to publish one banner2 */
  schedulePublishBanner2?: Maybe<Banner2>;
  /** Schedule to publish one bigNumber */
  schedulePublishBigNumber?: Maybe<BigNumber>;
  /** Schedule to publish one bigNumberItem */
  schedulePublishBigNumberItem?: Maybe<BigNumberItem>;
  /** Schedule to publish one cardComponent */
  schedulePublishCardComponent?: Maybe<CardComponent>;
  /** Schedule to publish one carouselComponent */
  schedulePublishCarouselComponent?: Maybe<CarouselComponent>;
  /** Schedule to publish one carouselSlide */
  schedulePublishCarouselSlide?: Maybe<CarouselSlide>;
  /** Schedule to publish one categoryCard */
  schedulePublishCategoryCard?: Maybe<CategoryCard>;
  /** Schedule to publish one contactCard */
  schedulePublishContactCard?: Maybe<ContactCard>;
  /** Schedule to publish one contactCardContainer */
  schedulePublishContactCardContainer?: Maybe<ContactCardContainer>;
  /** Schedule to publish one corpAddToCalendar */
  schedulePublishCorpAddToCalendar?: Maybe<CorpAddToCalendar>;
  /** Schedule to publish one corpBanner1 */
  schedulePublishCorpBanner1?: Maybe<CorpBanner1>;
  /** Schedule to publish one corpCalendarEvent */
  schedulePublishCorpCalendarEvent?: Maybe<CorpCalendarEvent>;
  /** Schedule to publish one corpCardCarousel */
  schedulePublishCorpCardCarousel?: Maybe<CorpCardCarousel>;
  /** Schedule to publish one corpContactCard */
  schedulePublishCorpContactCard?: Maybe<CorpContactCard>;
  /** Schedule to publish one corpContactCardContainer */
  schedulePublishCorpContactCardContainer?: Maybe<CorpContactCardContainer>;
  /** Schedule to publish one corpForm */
  schedulePublishCorpForm?: Maybe<CorpForm>;
  /** Schedule to publish one corpGenericAccordion */
  schedulePublishCorpGenericAccordion?: Maybe<CorpGenericAccordion>;
  /** Schedule to publish one corpGenericAccordionItem */
  schedulePublishCorpGenericAccordionItem?: Maybe<CorpGenericAccordionItem>;
  /** Schedule to publish one corpGenericBanner */
  schedulePublishCorpGenericBanner?: Maybe<CorpGenericBanner>;
  /** Schedule to publish one corpGenericContainer */
  schedulePublishCorpGenericContainer?: Maybe<CorpGenericContainer>;
  /** Schedule to publish one corpGridColumnComponent */
  schedulePublishCorpGridColumnComponent?: Maybe<CorpGridColumnComponent>;
  /** Schedule to publish one corpHero */
  schedulePublishCorpHero?: Maybe<CorpHero>;
  /** Schedule to publish one corpMediaDownloadPreview */
  schedulePublishCorpMediaDownloadPreview?: Maybe<CorpMediaDownloadPreview>;
  /** Schedule to publish one corpNavigation */
  schedulePublishCorpNavigation?: Maybe<CorpNavigation>;
  /** Schedule to publish one corpNavigationItem */
  schedulePublishCorpNavigationItem?: Maybe<CorpNavigationItem>;
  /** Schedule to publish one corpNotificationBanner */
  schedulePublishCorpNotificationBanner?: Maybe<CorpNotificationBanner>;
  /** Schedule to publish one corpOurPeople */
  schedulePublishCorpOurPeople?: Maybe<CorpOurPeople>;
  /** Schedule to publish one corpOurPeopleItem */
  schedulePublishCorpOurPeopleItem?: Maybe<CorpOurPeopleItem>;
  /** Schedule to publish one corpPressPage */
  schedulePublishCorpPressPage?: Maybe<CorpPressPage>;
  /** Schedule to publish one corpSocialMediaFooter */
  schedulePublishCorpSocialMediaFooter?: Maybe<CorpSocialMediaFooter>;
  /** Schedule to publish one corpStoriesPage */
  schedulePublishCorpStoriesPage?: Maybe<CorpStoriesPage>;
  /** Schedule to publish one corpStoryCarousel */
  schedulePublishCorpStoryCarousel?: Maybe<CorpStoryCarousel>;
  /** Schedule to publish one corpTimelineAccordion */
  schedulePublishCorpTimelineAccordion?: Maybe<CorpTimelineAccordion>;
  /** Schedule to publish one corpTimelineAccordionItem */
  schedulePublishCorpTimelineAccordionItem?: Maybe<CorpTimelineAccordionItem>;
  /** Schedule to publish one corpTimelineAccordionWrapper */
  schedulePublishCorpTimelineAccordionWrapper?: Maybe<CorpTimelineAccordionWrapper>;
  /** Schedule to publish one corpVideoHero */
  schedulePublishCorpVideoHero?: Maybe<CorpVideoHero>;
  /** Schedule to publish one corpVideoHeroCarousel */
  schedulePublishCorpVideoHeroCarousel?: Maybe<CorpVideoHeroCarousel>;
  /** Schedule to publish one countrySelector */
  schedulePublishCountrySelector?: Maybe<CountrySelector>;
  /** Schedule to publish one countrySelectorItem */
  schedulePublishCountrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Schedule to publish one dEPRECATEDBanner1 */
  schedulePublishDEPRECATEDBanner1?: Maybe<DeprecatedBanner1>;
  /** Schedule to publish one deprecatedCorpNavigationCopy */
  schedulePublishDeprecatedCorpNavigationCopy?: Maybe<DeprecatedCorpNavigationCopy>;
  /** Schedule to publish one dictionary */
  schedulePublishDictionary?: Maybe<Dictionary>;
  /** Schedule to publish one dictionaryItem */
  schedulePublishDictionaryItem?: Maybe<DictionaryItem>;
  /** Schedule to publish one dynamicCardGrid */
  schedulePublishDynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Schedule to publish one evalancheFormComponent */
  schedulePublishEvalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Schedule to publish one exampleComponent */
  schedulePublishExampleComponent?: Maybe<ExampleComponent>;
  /** Schedule to publish one featuredContent */
  schedulePublishFeaturedContent?: Maybe<FeaturedContent>;
  /** Schedule to publish one featuredContentReference */
  schedulePublishFeaturedContentReference?: Maybe<FeaturedContentReference>;
  /** Schedule to publish one footerNavigation */
  schedulePublishFooterNavigation?: Maybe<FooterNavigation>;
  /** Schedule to publish one form */
  schedulePublishForm?: Maybe<Form>;
  /** Schedule to publish one formCheckbox */
  schedulePublishFormCheckbox?: Maybe<FormCheckbox>;
  /** Schedule to publish one formEmailInput */
  schedulePublishFormEmailInput?: Maybe<FormEmailInput>;
  /** Schedule to publish one formError */
  schedulePublishFormError?: Maybe<FormError>;
  /** Schedule to publish one formPasswordInput */
  schedulePublishFormPasswordInput?: Maybe<FormPasswordInput>;
  /** Schedule to publish one formPasswordInputWithConfirmation */
  schedulePublishFormPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Schedule to publish one formRadioButton */
  schedulePublishFormRadioButton?: Maybe<FormRadioButton>;
  /** Schedule to publish one formRadioButtonCollection */
  schedulePublishFormRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Schedule to publish one formSelectComponent */
  schedulePublishFormSelectComponent?: Maybe<FormSelectComponent>;
  /** Schedule to publish one formSelectOption */
  schedulePublishFormSelectOption?: Maybe<FormSelectOption>;
  /** Schedule to publish one formSubmitButton */
  schedulePublishFormSubmitButton?: Maybe<FormSubmitButton>;
  /** Schedule to publish one formSuccessComponent */
  schedulePublishFormSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Schedule to publish one formTextInput */
  schedulePublishFormTextInput?: Maybe<FormTextInput>;
  /** Schedule to publish one formTextareaInput */
  schedulePublishFormTextareaInput?: Maybe<FormTextareaInput>;
  /** Schedule to publish one genericAccordion */
  schedulePublishGenericAccordion?: Maybe<GenericAccordion>;
  /** Schedule to publish one genericAccordionItem */
  schedulePublishGenericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Schedule to publish one genericAccordionTopRated */
  schedulePublishGenericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Schedule to publish one genericCardCarouseComponent */
  schedulePublishGenericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Schedule to publish one genericDownloadComponent */
  schedulePublishGenericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Schedule to publish one genericFollowUs */
  schedulePublishGenericFollowUs?: Maybe<GenericFollowUs>;
  /** Schedule to publish one genericGridAuthorable */
  schedulePublishGenericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Schedule to publish one genericLine */
  schedulePublishGenericLine?: Maybe<GenericLine>;
  /** Schedule to publish one genericLink */
  schedulePublishGenericLink?: Maybe<GenericLink>;
  /** Schedule to publish one genericPage */
  schedulePublishGenericPage?: Maybe<GenericPage>;
  /** Schedule to publish one globalMetaData */
  schedulePublishGlobalMetaData?: Maybe<GlobalMetaData>;
  /** Schedule to publish one heroBanner */
  schedulePublishHeroBanner?: Maybe<HeroBanner>;
  /** Schedule to publish one heroCarouselComponent */
  schedulePublishHeroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Schedule to publish one heroComponent */
  schedulePublishHeroComponent?: Maybe<HeroComponent>;
  /** Schedule to publish one homePage */
  schedulePublishHomePage?: Maybe<HomePage>;
  /** Schedule to publish one iframe */
  schedulePublishIframe?: Maybe<Iframe>;
  /** Schedule to publish one imageAndTextCard */
  schedulePublishImageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Schedule to publish one imageCopy */
  schedulePublishImageCopy?: Maybe<ImageCopy>;
  /** Schedule to publish one imageCopyItem */
  schedulePublishImageCopyItem?: Maybe<ImageCopyItem>;
  /** Schedule to publish one introText */
  schedulePublishIntroText?: Maybe<IntroText>;
  /** Schedule to publish one leftColumn */
  schedulePublishLeftColumn?: Maybe<LeftColumn>;
  /** Schedule to publish one link */
  schedulePublishLink?: Maybe<Link>;
  /** Schedule to publish one locationComponent */
  schedulePublishLocationComponent?: Maybe<LocationComponent>;
  /** Schedule to publish one locationItem */
  schedulePublishLocationItem?: Maybe<LocationItem>;
  /** Schedule to publish one longText */
  schedulePublishLongText?: Maybe<LongText>;
  /** Schedule to publish one mediaLibrary */
  schedulePublishMediaLibrary?: Maybe<MediaLibrary>;
  /** Schedule to publish one mediaLibraryItem */
  schedulePublishMediaLibraryItem?: Maybe<MediaLibraryItem>;
  /** Schedule to publish one metaData */
  schedulePublishMetaData?: Maybe<MetaData>;
  /** Schedule to publish one mobileOnlyMainNavigation */
  schedulePublishMobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Schedule to publish one navigation */
  schedulePublishNavigation?: Maybe<Navigation>;
  /** Schedule to publish one navigationItem */
  schedulePublishNavigationItem?: Maybe<NavigationItem>;
  /** Schedule to publish one notificationBanner */
  schedulePublishNotificationBanner?: Maybe<NotificationBanner>;
  /** Schedule to publish one pageFooter */
  schedulePublishPageFooter?: Maybe<PageFooter>;
  /** Schedule to publish one pageHeader */
  schedulePublishPageHeader?: Maybe<PageHeader>;
  /** Schedule to publish one popularSearchComponent */
  schedulePublishPopularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Schedule to publish one pressRelease */
  schedulePublishPressRelease?: Maybe<PressRelease>;
  /** Schedule to publish one pressStoriesCard */
  schedulePublishPressStoriesCard?: Maybe<PressStoriesCard>;
  /** Schedule to publish one progressBar */
  schedulePublishProgressBar?: Maybe<ProgressBar>;
  /** Schedule to publish one quickLink */
  schedulePublishQuickLink?: Maybe<QuickLink>;
  /** Schedule to publish one quickLinkItem */
  schedulePublishQuickLinkItem?: Maybe<QuickLinkItem>;
  /** Schedule to publish one redirect */
  schedulePublishRedirect?: Maybe<Redirect>;
  /** Schedule to publish one rewrite */
  schedulePublishRewrite?: Maybe<Rewrite>;
  /** Schedule to publish one rightColumn */
  schedulePublishRightColumn?: Maybe<RightColumn>;
  /** Schedule to publish one searchInput */
  schedulePublishSearchInput?: Maybe<SearchInput>;
  /** Schedule to publish one searchOverlayComponent */
  schedulePublishSearchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Schedule to publish one searchResultPage */
  schedulePublishSearchResultPage?: Maybe<SearchResultPage>;
  /** Schedule to publish one shortHero */
  schedulePublishShortHero?: Maybe<ShortHero>;
  /** Schedule to publish one socialMediaListComponent */
  schedulePublishSocialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Schedule to publish one spacer */
  schedulePublishSpacer?: Maybe<Spacer>;
  /** Schedule to publish one story */
  schedulePublishStory?: Maybe<Story>;
  /** Schedule to publish one subCategoryKeyImage */
  schedulePublishSubCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Schedule to publish one sustainabilityBanner */
  schedulePublishSustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Schedule to publish one sustainabilityInfo */
  schedulePublishSustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Schedule to publish one tab */
  schedulePublishTab?: Maybe<Tab>;
  /** Schedule to publish one tabContent */
  schedulePublishTabContent?: Maybe<TabContent>;
  /** Schedule to publish one testTipsANdTricksInAMarket */
  schedulePublishTestTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Schedule to publish one textComponent */
  schedulePublishTextComponent?: Maybe<TextComponent>;
  /** Schedule to publish one tipsAndTricksDetailsPage */
  schedulePublishTipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Schedule to publish one title */
  schedulePublishTitle?: Maybe<Title>;
  /** Schedule to publish one twitterSeo */
  schedulePublishTwitterSeo?: Maybe<TwitterSeo>;
  /** Schedule to publish one widget */
  schedulePublishWidget?: Maybe<Widget>;
  /** Unpublish one accordion from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAccordion?: Maybe<Accordion>;
  /** Unpublish one accordionItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAccordionItem?: Maybe<AccordionItem>;
  /** Unpublish one alexTestComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAlexTestComponent?: Maybe<AlexTestComponent>;
  /** Unpublish one algoliaExtension from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAlgoliaExtension?: Maybe<AlgoliaExtension>;
  /** Unpublish one anchorNav from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAnchorNav?: Maybe<AnchorNav>;
  /** Unpublish one anchorNavigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAnchorNavigation?: Maybe<AnchorNavigation>;
  /** Unpublish one anchorNavigationList from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAnchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAsset?: Maybe<Asset>;
  /** Unpublish one assetComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAssetComponent?: Maybe<AssetComponent>;
  /** Unpublish one audioComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAudioComponent?: Maybe<AudioComponent>;
  /** Unpublish one authorableContentCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishAuthorableContentCard?: Maybe<AuthorableContentCard>;
  /** Unpublish one banner2 from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishBanner2?: Maybe<Banner2>;
  /** Unpublish one bigNumber from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishBigNumber?: Maybe<BigNumber>;
  /** Unpublish one bigNumberItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishBigNumberItem?: Maybe<BigNumberItem>;
  /** Unpublish one cardComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCardComponent?: Maybe<CardComponent>;
  /** Unpublish one carouselComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCarouselComponent?: Maybe<CarouselComponent>;
  /** Unpublish one carouselSlide from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCarouselSlide?: Maybe<CarouselSlide>;
  /** Unpublish one categoryCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCategoryCard?: Maybe<CategoryCard>;
  /** Unpublish one contactCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishContactCard?: Maybe<ContactCard>;
  /** Unpublish one contactCardContainer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishContactCardContainer?: Maybe<ContactCardContainer>;
  /** Unpublish one corpAddToCalendar from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpAddToCalendar?: Maybe<CorpAddToCalendar>;
  /** Unpublish one corpBanner1 from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpBanner1?: Maybe<CorpBanner1>;
  /** Unpublish one corpCalendarEvent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpCalendarEvent?: Maybe<CorpCalendarEvent>;
  /** Unpublish one corpCardCarousel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpCardCarousel?: Maybe<CorpCardCarousel>;
  /** Unpublish one corpContactCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpContactCard?: Maybe<CorpContactCard>;
  /** Unpublish one corpContactCardContainer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpContactCardContainer?: Maybe<CorpContactCardContainer>;
  /** Unpublish one corpForm from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpForm?: Maybe<CorpForm>;
  /** Unpublish one corpGenericAccordion from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpGenericAccordion?: Maybe<CorpGenericAccordion>;
  /** Unpublish one corpGenericAccordionItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpGenericAccordionItem?: Maybe<CorpGenericAccordionItem>;
  /** Unpublish one corpGenericBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpGenericBanner?: Maybe<CorpGenericBanner>;
  /** Unpublish one corpGenericContainer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpGenericContainer?: Maybe<CorpGenericContainer>;
  /** Unpublish one corpGridColumnComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpGridColumnComponent?: Maybe<CorpGridColumnComponent>;
  /** Unpublish one corpHero from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpHero?: Maybe<CorpHero>;
  /** Unpublish one corpMediaDownloadPreview from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpMediaDownloadPreview?: Maybe<CorpMediaDownloadPreview>;
  /** Unpublish one corpNavigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpNavigation?: Maybe<CorpNavigation>;
  /** Unpublish one corpNavigationItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpNavigationItem?: Maybe<CorpNavigationItem>;
  /** Unpublish one corpNotificationBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpNotificationBanner?: Maybe<CorpNotificationBanner>;
  /** Unpublish one corpOurPeople from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpOurPeople?: Maybe<CorpOurPeople>;
  /** Unpublish one corpOurPeopleItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpOurPeopleItem?: Maybe<CorpOurPeopleItem>;
  /** Unpublish one corpPressPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpPressPage?: Maybe<CorpPressPage>;
  /** Unpublish one corpSocialMediaFooter from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpSocialMediaFooter?: Maybe<CorpSocialMediaFooter>;
  /** Unpublish one corpStoriesPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpStoriesPage?: Maybe<CorpStoriesPage>;
  /** Unpublish one corpStoryCarousel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpStoryCarousel?: Maybe<CorpStoryCarousel>;
  /** Unpublish one corpTimelineAccordion from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpTimelineAccordion?: Maybe<CorpTimelineAccordion>;
  /** Unpublish one corpTimelineAccordionItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpTimelineAccordionItem?: Maybe<CorpTimelineAccordionItem>;
  /** Unpublish one corpTimelineAccordionWrapper from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpTimelineAccordionWrapper?: Maybe<CorpTimelineAccordionWrapper>;
  /** Unpublish one corpVideoHero from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpVideoHero?: Maybe<CorpVideoHero>;
  /** Unpublish one corpVideoHeroCarousel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCorpVideoHeroCarousel?: Maybe<CorpVideoHeroCarousel>;
  /** Unpublish one countrySelector from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCountrySelector?: Maybe<CountrySelector>;
  /** Unpublish one countrySelectorItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishCountrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Unpublish one dEPRECATEDBanner1 from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishDEPRECATEDBanner1?: Maybe<DeprecatedBanner1>;
  /** Unpublish one deprecatedCorpNavigationCopy from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishDeprecatedCorpNavigationCopy?: Maybe<DeprecatedCorpNavigationCopy>;
  /** Unpublish one dictionary from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishDictionary?: Maybe<Dictionary>;
  /** Unpublish one dictionaryItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishDictionaryItem?: Maybe<DictionaryItem>;
  /** Unpublish one dynamicCardGrid from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishDynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Unpublish one evalancheFormComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishEvalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Unpublish one exampleComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishExampleComponent?: Maybe<ExampleComponent>;
  /** Unpublish one featuredContent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFeaturedContent?: Maybe<FeaturedContent>;
  /** Unpublish one featuredContentReference from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFeaturedContentReference?: Maybe<FeaturedContentReference>;
  /** Unpublish one footerNavigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFooterNavigation?: Maybe<FooterNavigation>;
  /** Unpublish one form from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishForm?: Maybe<Form>;
  /** Unpublish one formCheckbox from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormCheckbox?: Maybe<FormCheckbox>;
  /** Unpublish one formEmailInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormEmailInput?: Maybe<FormEmailInput>;
  /** Unpublish one formError from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormError?: Maybe<FormError>;
  /** Unpublish one formPasswordInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormPasswordInput?: Maybe<FormPasswordInput>;
  /** Unpublish one formPasswordInputWithConfirmation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Unpublish one formRadioButton from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormRadioButton?: Maybe<FormRadioButton>;
  /** Unpublish one formRadioButtonCollection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Unpublish one formSelectComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormSelectComponent?: Maybe<FormSelectComponent>;
  /** Unpublish one formSelectOption from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormSelectOption?: Maybe<FormSelectOption>;
  /** Unpublish one formSubmitButton from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormSubmitButton?: Maybe<FormSubmitButton>;
  /** Unpublish one formSuccessComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Unpublish one formTextInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormTextInput?: Maybe<FormTextInput>;
  /** Unpublish one formTextareaInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishFormTextareaInput?: Maybe<FormTextareaInput>;
  /** Unpublish one genericAccordion from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericAccordion?: Maybe<GenericAccordion>;
  /** Unpublish one genericAccordionItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Unpublish one genericAccordionTopRated from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Unpublish one genericCardCarouseComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Unpublish one genericDownloadComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Unpublish one genericFollowUs from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericFollowUs?: Maybe<GenericFollowUs>;
  /** Unpublish one genericGridAuthorable from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Unpublish one genericLine from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericLine?: Maybe<GenericLine>;
  /** Unpublish one genericLink from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericLink?: Maybe<GenericLink>;
  /** Unpublish one genericPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGenericPage?: Maybe<GenericPage>;
  /** Unpublish one globalMetaData from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishGlobalMetaData?: Maybe<GlobalMetaData>;
  /** Unpublish one heroBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishHeroBanner?: Maybe<HeroBanner>;
  /** Unpublish one heroCarouselComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishHeroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Unpublish one heroComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishHeroComponent?: Maybe<HeroComponent>;
  /** Unpublish one homePage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishHomePage?: Maybe<HomePage>;
  /** Unpublish one iframe from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishIframe?: Maybe<Iframe>;
  /** Unpublish one imageAndTextCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishImageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Unpublish one imageCopy from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishImageCopy?: Maybe<ImageCopy>;
  /** Unpublish one imageCopyItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishImageCopyItem?: Maybe<ImageCopyItem>;
  /** Unpublish one introText from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishIntroText?: Maybe<IntroText>;
  /** Unpublish one leftColumn from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishLeftColumn?: Maybe<LeftColumn>;
  /** Unpublish one link from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishLink?: Maybe<Link>;
  /** Unpublish one locationComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishLocationComponent?: Maybe<LocationComponent>;
  /** Unpublish one locationItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishLocationItem?: Maybe<LocationItem>;
  /** Unpublish one longText from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishLongText?: Maybe<LongText>;
  /** Unpublish one mediaLibrary from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishMediaLibrary?: Maybe<MediaLibrary>;
  /** Unpublish one mediaLibraryItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishMediaLibraryItem?: Maybe<MediaLibraryItem>;
  /** Unpublish one metaData from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishMetaData?: Maybe<MetaData>;
  /** Unpublish one mobileOnlyMainNavigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishMobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Unpublish one navigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishNavigation?: Maybe<Navigation>;
  /** Unpublish one navigationItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishNavigationItem?: Maybe<NavigationItem>;
  /** Unpublish one notificationBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishNotificationBanner?: Maybe<NotificationBanner>;
  /** Unpublish one pageFooter from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPageFooter?: Maybe<PageFooter>;
  /** Unpublish one pageHeader from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPageHeader?: Maybe<PageHeader>;
  /** Unpublish one popularSearchComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPopularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Unpublish one pressRelease from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPressRelease?: Maybe<PressRelease>;
  /** Unpublish one pressStoriesCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishPressStoriesCard?: Maybe<PressStoriesCard>;
  /** Unpublish one progressBar from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishProgressBar?: Maybe<ProgressBar>;
  /** Unpublish one quickLink from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishQuickLink?: Maybe<QuickLink>;
  /** Unpublish one quickLinkItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishQuickLinkItem?: Maybe<QuickLinkItem>;
  /** Unpublish one redirect from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRedirect?: Maybe<Redirect>;
  /** Unpublish one rewrite from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRewrite?: Maybe<Rewrite>;
  /** Unpublish one rightColumn from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishRightColumn?: Maybe<RightColumn>;
  /** Unpublish one searchInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSearchInput?: Maybe<SearchInput>;
  /** Unpublish one searchOverlayComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSearchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Unpublish one searchResultPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSearchResultPage?: Maybe<SearchResultPage>;
  /** Unpublish one shortHero from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishShortHero?: Maybe<ShortHero>;
  /** Unpublish one socialMediaListComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSocialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Unpublish one spacer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSpacer?: Maybe<Spacer>;
  /** Unpublish one story from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishStory?: Maybe<Story>;
  /** Unpublish one subCategoryKeyImage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSubCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Unpublish one sustainabilityBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Unpublish one sustainabilityInfo from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishSustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Unpublish one tab from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTab?: Maybe<Tab>;
  /** Unpublish one tabContent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTabContent?: Maybe<TabContent>;
  /** Unpublish one testTipsANdTricksInAMarket from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTestTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Unpublish one textComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTextComponent?: Maybe<TextComponent>;
  /** Unpublish one tipsAndTricksDetailsPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Unpublish one title from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTitle?: Maybe<Title>;
  /** Unpublish one twitterSeo from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishTwitterSeo?: Maybe<TwitterSeo>;
  /** Unpublish one widget from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  scheduleUnpublishWidget?: Maybe<Widget>;
  /** Unpublish one accordion from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAccordion?: Maybe<Accordion>;
  /** Unpublish one accordionItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAccordionItem?: Maybe<AccordionItem>;
  /** Unpublish one alexTestComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAlexTestComponent?: Maybe<AlexTestComponent>;
  /** Unpublish one algoliaExtension from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAlgoliaExtension?: Maybe<AlgoliaExtension>;
  /** Unpublish one anchorNav from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAnchorNav?: Maybe<AnchorNav>;
  /** Unpublish one anchorNavigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAnchorNavigation?: Maybe<AnchorNavigation>;
  /** Unpublish one anchorNavigationList from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAnchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Unpublish one asset from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAsset?: Maybe<Asset>;
  /** Unpublish one assetComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAssetComponent?: Maybe<AssetComponent>;
  /** Unpublish one audioComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAudioComponent?: Maybe<AudioComponent>;
  /** Unpublish one authorableContentCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishAuthorableContentCard?: Maybe<AuthorableContentCard>;
  /** Unpublish one banner2 from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishBanner2?: Maybe<Banner2>;
  /** Unpublish one bigNumber from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishBigNumber?: Maybe<BigNumber>;
  /** Unpublish one bigNumberItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishBigNumberItem?: Maybe<BigNumberItem>;
  /** Unpublish one cardComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCardComponent?: Maybe<CardComponent>;
  /** Unpublish one carouselComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCarouselComponent?: Maybe<CarouselComponent>;
  /** Unpublish one carouselSlide from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCarouselSlide?: Maybe<CarouselSlide>;
  /** Unpublish one categoryCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCategoryCard?: Maybe<CategoryCard>;
  /** Unpublish one contactCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishContactCard?: Maybe<ContactCard>;
  /** Unpublish one contactCardContainer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishContactCardContainer?: Maybe<ContactCardContainer>;
  /** Unpublish one corpAddToCalendar from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpAddToCalendar?: Maybe<CorpAddToCalendar>;
  /** Unpublish one corpBanner1 from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpBanner1?: Maybe<CorpBanner1>;
  /** Unpublish one corpCalendarEvent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpCalendarEvent?: Maybe<CorpCalendarEvent>;
  /** Unpublish one corpCardCarousel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpCardCarousel?: Maybe<CorpCardCarousel>;
  /** Unpublish one corpContactCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpContactCard?: Maybe<CorpContactCard>;
  /** Unpublish one corpContactCardContainer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpContactCardContainer?: Maybe<CorpContactCardContainer>;
  /** Unpublish one corpForm from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpForm?: Maybe<CorpForm>;
  /** Unpublish one corpGenericAccordion from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpGenericAccordion?: Maybe<CorpGenericAccordion>;
  /** Unpublish one corpGenericAccordionItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpGenericAccordionItem?: Maybe<CorpGenericAccordionItem>;
  /** Unpublish one corpGenericBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpGenericBanner?: Maybe<CorpGenericBanner>;
  /** Unpublish one corpGenericContainer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpGenericContainer?: Maybe<CorpGenericContainer>;
  /** Unpublish one corpGridColumnComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpGridColumnComponent?: Maybe<CorpGridColumnComponent>;
  /** Unpublish one corpHero from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpHero?: Maybe<CorpHero>;
  /** Unpublish one corpMediaDownloadPreview from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpMediaDownloadPreview?: Maybe<CorpMediaDownloadPreview>;
  /** Unpublish one corpNavigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpNavigation?: Maybe<CorpNavigation>;
  /** Unpublish one corpNavigationItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpNavigationItem?: Maybe<CorpNavigationItem>;
  /** Unpublish one corpNotificationBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpNotificationBanner?: Maybe<CorpNotificationBanner>;
  /** Unpublish one corpOurPeople from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpOurPeople?: Maybe<CorpOurPeople>;
  /** Unpublish one corpOurPeopleItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpOurPeopleItem?: Maybe<CorpOurPeopleItem>;
  /** Unpublish one corpPressPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpPressPage?: Maybe<CorpPressPage>;
  /** Unpublish one corpSocialMediaFooter from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpSocialMediaFooter?: Maybe<CorpSocialMediaFooter>;
  /** Unpublish one corpStoriesPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpStoriesPage?: Maybe<CorpStoriesPage>;
  /** Unpublish one corpStoryCarousel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpStoryCarousel?: Maybe<CorpStoryCarousel>;
  /** Unpublish one corpTimelineAccordion from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpTimelineAccordion?: Maybe<CorpTimelineAccordion>;
  /** Unpublish one corpTimelineAccordionItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpTimelineAccordionItem?: Maybe<CorpTimelineAccordionItem>;
  /** Unpublish one corpTimelineAccordionWrapper from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpTimelineAccordionWrapper?: Maybe<CorpTimelineAccordionWrapper>;
  /** Unpublish one corpVideoHero from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpVideoHero?: Maybe<CorpVideoHero>;
  /** Unpublish one corpVideoHeroCarousel from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCorpVideoHeroCarousel?: Maybe<CorpVideoHeroCarousel>;
  /** Unpublish one countrySelector from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCountrySelector?: Maybe<CountrySelector>;
  /** Unpublish one countrySelectorItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishCountrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Unpublish one dEPRECATEDBanner1 from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishDEPRECATEDBanner1?: Maybe<DeprecatedBanner1>;
  /** Unpublish one deprecatedCorpNavigationCopy from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishDeprecatedCorpNavigationCopy?: Maybe<DeprecatedCorpNavigationCopy>;
  /** Unpublish one dictionary from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishDictionary?: Maybe<Dictionary>;
  /** Unpublish one dictionaryItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishDictionaryItem?: Maybe<DictionaryItem>;
  /** Unpublish one dynamicCardGrid from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishDynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Unpublish one evalancheFormComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishEvalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Unpublish one exampleComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishExampleComponent?: Maybe<ExampleComponent>;
  /** Unpublish one featuredContent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFeaturedContent?: Maybe<FeaturedContent>;
  /** Unpublish one featuredContentReference from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFeaturedContentReference?: Maybe<FeaturedContentReference>;
  /** Unpublish one footerNavigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFooterNavigation?: Maybe<FooterNavigation>;
  /** Unpublish one form from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishForm?: Maybe<Form>;
  /** Unpublish one formCheckbox from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormCheckbox?: Maybe<FormCheckbox>;
  /** Unpublish one formEmailInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormEmailInput?: Maybe<FormEmailInput>;
  /** Unpublish one formError from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormError?: Maybe<FormError>;
  /** Unpublish one formPasswordInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormPasswordInput?: Maybe<FormPasswordInput>;
  /** Unpublish one formPasswordInputWithConfirmation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Unpublish one formRadioButton from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormRadioButton?: Maybe<FormRadioButton>;
  /** Unpublish one formRadioButtonCollection from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Unpublish one formSelectComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormSelectComponent?: Maybe<FormSelectComponent>;
  /** Unpublish one formSelectOption from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormSelectOption?: Maybe<FormSelectOption>;
  /** Unpublish one formSubmitButton from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormSubmitButton?: Maybe<FormSubmitButton>;
  /** Unpublish one formSuccessComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Unpublish one formTextInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormTextInput?: Maybe<FormTextInput>;
  /** Unpublish one formTextareaInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishFormTextareaInput?: Maybe<FormTextareaInput>;
  /** Unpublish one genericAccordion from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericAccordion?: Maybe<GenericAccordion>;
  /** Unpublish one genericAccordionItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Unpublish one genericAccordionTopRated from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Unpublish one genericCardCarouseComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Unpublish one genericDownloadComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Unpublish one genericFollowUs from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericFollowUs?: Maybe<GenericFollowUs>;
  /** Unpublish one genericGridAuthorable from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Unpublish one genericLine from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericLine?: Maybe<GenericLine>;
  /** Unpublish one genericLink from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericLink?: Maybe<GenericLink>;
  /** Unpublish one genericPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGenericPage?: Maybe<GenericPage>;
  /** Unpublish one globalMetaData from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishGlobalMetaData?: Maybe<GlobalMetaData>;
  /** Unpublish one heroBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishHeroBanner?: Maybe<HeroBanner>;
  /** Unpublish one heroCarouselComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishHeroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Unpublish one heroComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishHeroComponent?: Maybe<HeroComponent>;
  /** Unpublish one homePage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishHomePage?: Maybe<HomePage>;
  /** Unpublish one iframe from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishIframe?: Maybe<Iframe>;
  /** Unpublish one imageAndTextCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishImageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Unpublish one imageCopy from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishImageCopy?: Maybe<ImageCopy>;
  /** Unpublish one imageCopyItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishImageCopyItem?: Maybe<ImageCopyItem>;
  /** Unpublish one introText from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishIntroText?: Maybe<IntroText>;
  /** Unpublish one leftColumn from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishLeftColumn?: Maybe<LeftColumn>;
  /** Unpublish one link from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishLink?: Maybe<Link>;
  /** Unpublish one locationComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishLocationComponent?: Maybe<LocationComponent>;
  /** Unpublish one locationItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishLocationItem?: Maybe<LocationItem>;
  /** Unpublish one longText from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishLongText?: Maybe<LongText>;
  /**
   * Unpublish many AccordionItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAccordionItemsConnection)
   */
  unpublishManyAccordionItems: BatchPayload;
  /** Find many AccordionItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAccordionItemsConnection: AccordionItemConnection;
  /**
   * Unpublish many Accordion documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAccordionsConnection)
   */
  unpublishManyAccordions: BatchPayload;
  /** Find many Accordion documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAccordionsConnection: AccordionConnection;
  /**
   * Unpublish many AlexTestComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAlexTestComponentsConnection)
   */
  unpublishManyAlexTestComponents: BatchPayload;
  /** Find many AlexTestComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAlexTestComponentsConnection: AlexTestComponentConnection;
  /**
   * Unpublish many AlgoliaExtension documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAlgoliaExtensionsConnection)
   */
  unpublishManyAlgoliaExtensions: BatchPayload;
  /** Find many AlgoliaExtension documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAlgoliaExtensionsConnection: AlgoliaExtensionConnection;
  /**
   * Unpublish many AnchorNavigationList documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAnchorNavigationListsConnection)
   */
  unpublishManyAnchorNavigationLists: BatchPayload;
  /** Find many AnchorNavigationList documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAnchorNavigationListsConnection: AnchorNavigationListConnection;
  /**
   * Unpublish many AnchorNavigation documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAnchorNavigationsConnection)
   */
  unpublishManyAnchorNavigations: BatchPayload;
  /** Find many AnchorNavigation documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAnchorNavigationsConnection: AnchorNavigationConnection;
  /**
   * Unpublish many AnchorNav documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAnchorNavsConnection)
   */
  unpublishManyAnchorNavs: BatchPayload;
  /** Find many AnchorNav documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAnchorNavsConnection: AnchorNavConnection;
  /**
   * Unpublish many Asset documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAssetsConnection)
   */
  unpublishManyAssets: BatchPayload;
  /**
   * Unpublish many AssetComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAssetsComponentsConnection)
   */
  unpublishManyAssetsComponents: BatchPayload;
  /** Find many AssetComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAssetsComponentsConnection: AssetComponentConnection;
  /** Find many Asset documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAssetsConnection: AssetConnection;
  /**
   * Unpublish many AudioComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAudioComponentsConnection)
   */
  unpublishManyAudioComponents: BatchPayload;
  /** Find many AudioComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAudioComponentsConnection: AudioComponentConnection;
  /**
   * Unpublish many AuthorableContentCard documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAuthorableContentCardsConnection)
   */
  unpublishManyAuthorableContentCards: BatchPayload;
  /** Find many AuthorableContentCard documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAuthorableContentCardsConnection: AuthorableContentCardConnection;
  /**
   * Unpublish many Banner2 documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBanner2SConnection)
   */
  unpublishManyBanner2S: BatchPayload;
  /** Find many Banner2 documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBanner2SConnection: Banner2Connection;
  /**
   * Unpublish many BigNumberItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBigNumberItemsConnection)
   */
  unpublishManyBigNumberItems: BatchPayload;
  /** Find many BigNumberItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBigNumberItemsConnection: BigNumberItemConnection;
  /**
   * Unpublish many BigNumber documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBigNumbersConnection)
   */
  unpublishManyBigNumbers: BatchPayload;
  /** Find many BigNumber documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBigNumbersConnection: BigNumberConnection;
  /**
   * Unpublish many CardComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCardComponentsConnection)
   */
  unpublishManyCardComponents: BatchPayload;
  /** Find many CardComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCardComponentsConnection: CardComponentConnection;
  /**
   * Unpublish many CarouselComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCarouselComponentsConnection)
   */
  unpublishManyCarouselComponents: BatchPayload;
  /** Find many CarouselComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCarouselComponentsConnection: CarouselComponentConnection;
  /**
   * Unpublish many CarouselSlide documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCarouselSlidesConnection)
   */
  unpublishManyCarouselSlides: BatchPayload;
  /** Find many CarouselSlide documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCarouselSlidesConnection: CarouselSlideConnection;
  /**
   * Unpublish many CategoryCard documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCategoryCardsConnection)
   */
  unpublishManyCategoryCards: BatchPayload;
  /** Find many CategoryCard documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCategoryCardsConnection: CategoryCardConnection;
  /**
   * Unpublish many ContactCardContainer documents
   * @deprecated Please use the new paginated many mutation (unpublishManyContactCardContainersConnection)
   */
  unpublishManyContactCardContainers: BatchPayload;
  /** Find many ContactCardContainer documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyContactCardContainersConnection: ContactCardContainerConnection;
  /**
   * Unpublish many ContactCard documents
   * @deprecated Please use the new paginated many mutation (unpublishManyContactCardsConnection)
   */
  unpublishManyContactCards: BatchPayload;
  /** Find many ContactCard documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyContactCardsConnection: ContactCardConnection;
  /**
   * Unpublish many CorpAddToCalendar documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpAddToCalendarsConnection)
   */
  unpublishManyCorpAddToCalendars: BatchPayload;
  /** Find many CorpAddToCalendar documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpAddToCalendarsConnection: CorpAddToCalendarConnection;
  /**
   * Unpublish many CorpBanner1 documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpBanners1Connection)
   */
  unpublishManyCorpBanners1: BatchPayload;
  /** Find many CorpBanner1 documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpBanners1Connection: CorpBanner1Connection;
  /**
   * Unpublish many CorpCalendarEvent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpCalendarEventsConnection)
   */
  unpublishManyCorpCalendarEvents: BatchPayload;
  /** Find many CorpCalendarEvent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpCalendarEventsConnection: CorpCalendarEventConnection;
  /**
   * Unpublish many CorpCardCarousel documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpCardCarouselsConnection)
   */
  unpublishManyCorpCardCarousels: BatchPayload;
  /** Find many CorpCardCarousel documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpCardCarouselsConnection: CorpCardCarouselConnection;
  /**
   * Unpublish many CorpContactCardContainer documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpContactCardContainersConnection)
   */
  unpublishManyCorpContactCardContainers: BatchPayload;
  /** Find many CorpContactCardContainer documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpContactCardContainersConnection: CorpContactCardContainerConnection;
  /**
   * Unpublish many CorpContactCard documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpContactCardsConnection)
   */
  unpublishManyCorpContactCards: BatchPayload;
  /** Find many CorpContactCard documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpContactCardsConnection: CorpContactCardConnection;
  /**
   * Unpublish many CorpForm documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpFormsConnection)
   */
  unpublishManyCorpForms: BatchPayload;
  /** Find many CorpForm documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpFormsConnection: CorpFormConnection;
  /**
   * Unpublish many CorpGenericAccordionItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpGenericAccordionItemsConnection)
   */
  unpublishManyCorpGenericAccordionItems: BatchPayload;
  /** Find many CorpGenericAccordionItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpGenericAccordionItemsConnection: CorpGenericAccordionItemConnection;
  /**
   * Unpublish many CorpGenericAccordion documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpGenericAccordionsConnection)
   */
  unpublishManyCorpGenericAccordions: BatchPayload;
  /** Find many CorpGenericAccordion documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpGenericAccordionsConnection: CorpGenericAccordionConnection;
  /**
   * Unpublish many CorpGenericBanner documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpGenericBannersConnection)
   */
  unpublishManyCorpGenericBanners: BatchPayload;
  /** Find many CorpGenericBanner documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpGenericBannersConnection: CorpGenericBannerConnection;
  /**
   * Unpublish many CorpGenericContainer documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpGenericContainersConnection)
   */
  unpublishManyCorpGenericContainers: BatchPayload;
  /** Find many CorpGenericContainer documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpGenericContainersConnection: CorpGenericContainerConnection;
  /**
   * Unpublish many CorpGridColumnComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpGridColumnComponentsConnection)
   */
  unpublishManyCorpGridColumnComponents: BatchPayload;
  /** Find many CorpGridColumnComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpGridColumnComponentsConnection: CorpGridColumnComponentConnection;
  /**
   * Unpublish many CorpHero documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpHerosConnection)
   */
  unpublishManyCorpHeros: BatchPayload;
  /** Find many CorpHero documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpHerosConnection: CorpHeroConnection;
  /**
   * Unpublish many CorpMediaDownloadPreview documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpMediaDownloadPreviewsConnection)
   */
  unpublishManyCorpMediaDownloadPreviews: BatchPayload;
  /** Find many CorpMediaDownloadPreview documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpMediaDownloadPreviewsConnection: CorpMediaDownloadPreviewConnection;
  /**
   * Unpublish many CorpNavigationItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpNavigationItemsConnection)
   */
  unpublishManyCorpNavigationItems: BatchPayload;
  /** Find many CorpNavigationItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpNavigationItemsConnection: CorpNavigationItemConnection;
  /**
   * Unpublish many CorpNavigation documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpNavigationsConnection)
   */
  unpublishManyCorpNavigations: BatchPayload;
  /** Find many CorpNavigation documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpNavigationsConnection: CorpNavigationConnection;
  /**
   * Unpublish many CorpNotificationBanner documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpNotificationBannersConnection)
   */
  unpublishManyCorpNotificationBanners: BatchPayload;
  /** Find many CorpNotificationBanner documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpNotificationBannersConnection: CorpNotificationBannerConnection;
  /**
   * Unpublish many CorpOurPeopleItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpOurPeopleItemsConnection)
   */
  unpublishManyCorpOurPeopleItems: BatchPayload;
  /** Find many CorpOurPeopleItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpOurPeopleItemsConnection: CorpOurPeopleItemConnection;
  /**
   * Unpublish many CorpOurPeople documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpOurPeoplesConnection)
   */
  unpublishManyCorpOurPeoples: BatchPayload;
  /** Find many CorpOurPeople documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpOurPeoplesConnection: CorpOurPeopleConnection;
  /**
   * Unpublish many CorpPressPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpPressPagesConnection)
   */
  unpublishManyCorpPressPages: BatchPayload;
  /** Find many CorpPressPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpPressPagesConnection: CorpPressPageConnection;
  /**
   * Unpublish many CorpSocialMediaFooter documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpSocialMediaFootersConnection)
   */
  unpublishManyCorpSocialMediaFooters: BatchPayload;
  /** Find many CorpSocialMediaFooter documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpSocialMediaFootersConnection: CorpSocialMediaFooterConnection;
  /**
   * Unpublish many CorpStoriesPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpStoriesPagesConnection)
   */
  unpublishManyCorpStoriesPages: BatchPayload;
  /** Find many CorpStoriesPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpStoriesPagesConnection: CorpStoriesPageConnection;
  /**
   * Unpublish many CorpStoryCarousel documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpStoryCarouselsConnection)
   */
  unpublishManyCorpStoryCarousels: BatchPayload;
  /** Find many CorpStoryCarousel documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpStoryCarouselsConnection: CorpStoryCarouselConnection;
  /**
   * Unpublish many CorpTimelineAccordionItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpTimelineAccordionItemsConnection)
   */
  unpublishManyCorpTimelineAccordionItems: BatchPayload;
  /** Find many CorpTimelineAccordionItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpTimelineAccordionItemsConnection: CorpTimelineAccordionItemConnection;
  /**
   * Unpublish many CorpTimelineAccordionWrapper documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpTimelineAccordionWrappersConnection)
   */
  unpublishManyCorpTimelineAccordionWrappers: BatchPayload;
  /** Find many CorpTimelineAccordionWrapper documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpTimelineAccordionWrappersConnection: CorpTimelineAccordionWrapperConnection;
  /**
   * Unpublish many CorpTimelineAccordion documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpTimelineAccordionsConnection)
   */
  unpublishManyCorpTimelineAccordions: BatchPayload;
  /** Find many CorpTimelineAccordion documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpTimelineAccordionsConnection: CorpTimelineAccordionConnection;
  /**
   * Unpublish many CorpVideoHeroCarousel documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpVideoHeroCarouselsConnection)
   */
  unpublishManyCorpVideoHeroCarousels: BatchPayload;
  /** Find many CorpVideoHeroCarousel documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpVideoHeroCarouselsConnection: CorpVideoHeroCarouselConnection;
  /**
   * Unpublish many CorpVideoHero documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCorpVideoHerosConnection)
   */
  unpublishManyCorpVideoHeros: BatchPayload;
  /** Find many CorpVideoHero documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCorpVideoHerosConnection: CorpVideoHeroConnection;
  /**
   * Unpublish many CountrySelectorItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCountrySelectorItemsConnection)
   */
  unpublishManyCountrySelectorItems: BatchPayload;
  /** Find many CountrySelectorItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCountrySelectorItemsConnection: CountrySelectorItemConnection;
  /**
   * Unpublish many CountrySelector documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCountrySelectorsConnection)
   */
  unpublishManyCountrySelectors: BatchPayload;
  /** Find many CountrySelector documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCountrySelectorsConnection: CountrySelectorConnection;
  /**
   * Unpublish many DEPRECATEDBanner1 documents
   * @deprecated Please use the new paginated many mutation (unpublishManyDEPRECATEDBanner1sConnection)
   */
  unpublishManyDEPRECATEDBanner1s: BatchPayload;
  /** Find many DEPRECATEDBanner1 documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyDEPRECATEDBanner1sConnection: DeprecatedBanner1Connection;
  /**
   * Unpublish many DeprecatedCorpNavigationCopy documents
   * @deprecated Please use the new paginated many mutation (unpublishManyDeprecatedCorpNavigationsConnection)
   */
  unpublishManyDeprecatedCorpNavigations: BatchPayload;
  /** Find many DeprecatedCorpNavigationCopy documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyDeprecatedCorpNavigationsConnection: DeprecatedCorpNavigationCopyConnection;
  /**
   * Unpublish many Dictionary documents
   * @deprecated Please use the new paginated many mutation (unpublishManyDictionariesConnection)
   */
  unpublishManyDictionaries: BatchPayload;
  /** Find many Dictionary documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyDictionariesConnection: DictionaryConnection;
  /**
   * Unpublish many DictionaryItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyDictionaryItemsConnection)
   */
  unpublishManyDictionaryItems: BatchPayload;
  /** Find many DictionaryItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyDictionaryItemsConnection: DictionaryItemConnection;
  /**
   * Unpublish many DynamicCardGrid documents
   * @deprecated Please use the new paginated many mutation (unpublishManyDynamicCardGridsConnection)
   */
  unpublishManyDynamicCardGrids: BatchPayload;
  /** Find many DynamicCardGrid documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyDynamicCardGridsConnection: DynamicCardGridConnection;
  /**
   * Unpublish many EvalancheFormComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyEvalancheFormComponentsConnection)
   */
  unpublishManyEvalancheFormComponents: BatchPayload;
  /** Find many EvalancheFormComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyEvalancheFormComponentsConnection: EvalancheFormComponentConnection;
  /**
   * Unpublish many ExampleComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyExampleComponentsConnection)
   */
  unpublishManyExampleComponents: BatchPayload;
  /** Find many ExampleComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyExampleComponentsConnection: ExampleComponentConnection;
  /**
   * Unpublish many FeaturedContentReference documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFeaturedContentReferencesConnection)
   */
  unpublishManyFeaturedContentReferences: BatchPayload;
  /** Find many FeaturedContentReference documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFeaturedContentReferencesConnection: FeaturedContentReferenceConnection;
  /**
   * Unpublish many FeaturedContent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFeaturedContentsConnection)
   */
  unpublishManyFeaturedContents: BatchPayload;
  /** Find many FeaturedContent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFeaturedContentsConnection: FeaturedContentConnection;
  /**
   * Unpublish many FooterNavigation documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFooterNavigationsConnection)
   */
  unpublishManyFooterNavigations: BatchPayload;
  /** Find many FooterNavigation documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFooterNavigationsConnection: FooterNavigationConnection;
  /**
   * Unpublish many FormCheckbox documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormCheckboxesConnection)
   */
  unpublishManyFormCheckboxes: BatchPayload;
  /** Find many FormCheckbox documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormCheckboxesConnection: FormCheckboxConnection;
  /**
   * Unpublish many FormEmailInput documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormEmailInputsConnection)
   */
  unpublishManyFormEmailInputs: BatchPayload;
  /** Find many FormEmailInput documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormEmailInputsConnection: FormEmailInputConnection;
  /**
   * Unpublish many FormError documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormErrorsConnection)
   */
  unpublishManyFormErrors: BatchPayload;
  /** Find many FormError documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormErrorsConnection: FormErrorConnection;
  /**
   * Unpublish many FormPasswordInputWithConfirmation documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormPasswordInputWithConfirmationsConnection)
   */
  unpublishManyFormPasswordInputWithConfirmations: BatchPayload;
  /** Find many FormPasswordInputWithConfirmation documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormPasswordInputWithConfirmationsConnection: FormPasswordInputWithConfirmationConnection;
  /**
   * Unpublish many FormPasswordInput documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormPasswordInputsConnection)
   */
  unpublishManyFormPasswordInputs: BatchPayload;
  /** Find many FormPasswordInput documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormPasswordInputsConnection: FormPasswordInputConnection;
  /**
   * Unpublish many FormRadioButtonCollection documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormRadioButtonCollectionsConnection)
   */
  unpublishManyFormRadioButtonCollections: BatchPayload;
  /** Find many FormRadioButtonCollection documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormRadioButtonCollectionsConnection: FormRadioButtonCollectionConnection;
  /**
   * Unpublish many FormRadioButton documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormRadioButtonsConnection)
   */
  unpublishManyFormRadioButtons: BatchPayload;
  /** Find many FormRadioButton documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormRadioButtonsConnection: FormRadioButtonConnection;
  /**
   * Unpublish many FormSelectComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormSelectComponentsConnection)
   */
  unpublishManyFormSelectComponents: BatchPayload;
  /** Find many FormSelectComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormSelectComponentsConnection: FormSelectComponentConnection;
  /**
   * Unpublish many FormSelectOption documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormSelectOptionsConnection)
   */
  unpublishManyFormSelectOptions: BatchPayload;
  /** Find many FormSelectOption documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormSelectOptionsConnection: FormSelectOptionConnection;
  /**
   * Unpublish many FormSubmitButton documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormSubmitButtonsConnection)
   */
  unpublishManyFormSubmitButtons: BatchPayload;
  /** Find many FormSubmitButton documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormSubmitButtonsConnection: FormSubmitButtonConnection;
  /**
   * Unpublish many FormSuccessComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormSuccessComponentsConnection)
   */
  unpublishManyFormSuccessComponents: BatchPayload;
  /** Find many FormSuccessComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormSuccessComponentsConnection: FormSuccessComponentConnection;
  /**
   * Unpublish many FormTextInput documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormTextInputsConnection)
   */
  unpublishManyFormTextInputs: BatchPayload;
  /** Find many FormTextInput documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormTextInputsConnection: FormTextInputConnection;
  /**
   * Unpublish many FormTextareaInput documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormTextareaInputsConnection)
   */
  unpublishManyFormTextareaInputs: BatchPayload;
  /** Find many FormTextareaInput documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormTextareaInputsConnection: FormTextareaInputConnection;
  /**
   * Unpublish many Form documents
   * @deprecated Please use the new paginated many mutation (unpublishManyFormsConnection)
   */
  unpublishManyForms: BatchPayload;
  /** Find many Form documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyFormsConnection: FormConnection;
  /**
   * Unpublish many GenericAccordionItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericAccordionItemsConnection)
   */
  unpublishManyGenericAccordionItems: BatchPayload;
  /** Find many GenericAccordionItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericAccordionItemsConnection: GenericAccordionItemConnection;
  /**
   * Unpublish many GenericAccordionTopRated documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericAccordionTopRatedsConnection)
   */
  unpublishManyGenericAccordionTopRateds: BatchPayload;
  /** Find many GenericAccordionTopRated documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericAccordionTopRatedsConnection: GenericAccordionTopRatedConnection;
  /**
   * Unpublish many GenericAccordion documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericAccordionsConnection)
   */
  unpublishManyGenericAccordions: BatchPayload;
  /** Find many GenericAccordion documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericAccordionsConnection: GenericAccordionConnection;
  /**
   * Unpublish many GenericCardCarouseComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericCardCarouseComponentsConnection)
   */
  unpublishManyGenericCardCarouseComponents: BatchPayload;
  /** Find many GenericCardCarouseComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericCardCarouseComponentsConnection: GenericCardCarouseComponentConnection;
  /**
   * Unpublish many GenericDownloadComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericDownloadComponentsConnection)
   */
  unpublishManyGenericDownloadComponents: BatchPayload;
  /** Find many GenericDownloadComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericDownloadComponentsConnection: GenericDownloadComponentConnection;
  /**
   * Unpublish many GenericFollowUs documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericFollowUsesConnection)
   */
  unpublishManyGenericFollowUses: BatchPayload;
  /** Find many GenericFollowUs documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericFollowUsesConnection: GenericFollowUsConnection;
  /**
   * Unpublish many GenericGridAuthorable documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericGridAuthorablesConnection)
   */
  unpublishManyGenericGridAuthorables: BatchPayload;
  /** Find many GenericGridAuthorable documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericGridAuthorablesConnection: GenericGridAuthorableConnection;
  /**
   * Unpublish many GenericLine documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericLinesConnection)
   */
  unpublishManyGenericLines: BatchPayload;
  /** Find many GenericLine documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericLinesConnection: GenericLineConnection;
  /**
   * Unpublish many GenericLink documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericLinksConnection)
   */
  unpublishManyGenericLinks: BatchPayload;
  /** Find many GenericLink documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericLinksConnection: GenericLinkConnection;
  /**
   * Unpublish many GenericPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGenericPagesConnection)
   */
  unpublishManyGenericPages: BatchPayload;
  /** Find many GenericPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGenericPagesConnection: GenericPageConnection;
  /**
   * Unpublish many GlobalMetaData documents
   * @deprecated Please use the new paginated many mutation (unpublishManyGlobalMetaDatasConnection)
   */
  unpublishManyGlobalMetaDatas: BatchPayload;
  /** Find many GlobalMetaData documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyGlobalMetaDatasConnection: GlobalMetaDataConnection;
  /**
   * Unpublish many HeroBanner documents
   * @deprecated Please use the new paginated many mutation (unpublishManyHeroBannersConnection)
   */
  unpublishManyHeroBanners: BatchPayload;
  /** Find many HeroBanner documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyHeroBannersConnection: HeroBannerConnection;
  /**
   * Unpublish many HeroCarouselComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyHeroCarouselComponentsConnection)
   */
  unpublishManyHeroCarouselComponents: BatchPayload;
  /** Find many HeroCarouselComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyHeroCarouselComponentsConnection: HeroCarouselComponentConnection;
  /**
   * Unpublish many HeroComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyHeroComponentsConnection)
   */
  unpublishManyHeroComponents: BatchPayload;
  /** Find many HeroComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyHeroComponentsConnection: HeroComponentConnection;
  /**
   * Unpublish many HomePage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyHomePagesConnection)
   */
  unpublishManyHomePages: BatchPayload;
  /** Find many HomePage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyHomePagesConnection: HomePageConnection;
  /**
   * Unpublish many Iframe documents
   * @deprecated Please use the new paginated many mutation (unpublishManyIframesConnection)
   */
  unpublishManyIframes: BatchPayload;
  /** Find many Iframe documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyIframesConnection: IframeConnection;
  /**
   * Unpublish many ImageAndTextCard documents
   * @deprecated Please use the new paginated many mutation (unpublishManyImageAndTextCardsConnection)
   */
  unpublishManyImageAndTextCards: BatchPayload;
  /** Find many ImageAndTextCard documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyImageAndTextCardsConnection: ImageAndTextCardConnection;
  /**
   * Unpublish many ImageCopy documents
   * @deprecated Please use the new paginated many mutation (unpublishManyImageCopiesConnection)
   */
  unpublishManyImageCopies: BatchPayload;
  /** Find many ImageCopy documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyImageCopiesConnection: ImageCopyConnection;
  /**
   * Unpublish many ImageCopyItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyImageCopyItemsConnection)
   */
  unpublishManyImageCopyItems: BatchPayload;
  /** Find many ImageCopyItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyImageCopyItemsConnection: ImageCopyItemConnection;
  /**
   * Unpublish many IntroText documents
   * @deprecated Please use the new paginated many mutation (unpublishManyIntroTextsConnection)
   */
  unpublishManyIntroTexts: BatchPayload;
  /** Find many IntroText documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyIntroTextsConnection: IntroTextConnection;
  /**
   * Unpublish many LeftColumn documents
   * @deprecated Please use the new paginated many mutation (unpublishManyLeftColumnsConnection)
   */
  unpublishManyLeftColumns: BatchPayload;
  /** Find many LeftColumn documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyLeftColumnsConnection: LeftColumnConnection;
  /**
   * Unpublish many Link documents
   * @deprecated Please use the new paginated many mutation (unpublishManyLinksConnection)
   */
  unpublishManyLinks: BatchPayload;
  /** Find many Link documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyLinksConnection: LinkConnection;
  /**
   * Unpublish many LocationComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyLocationComponentsConnection)
   */
  unpublishManyLocationComponents: BatchPayload;
  /** Find many LocationComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyLocationComponentsConnection: LocationComponentConnection;
  /**
   * Unpublish many LocationItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyLocationItemsConnection)
   */
  unpublishManyLocationItems: BatchPayload;
  /** Find many LocationItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyLocationItemsConnection: LocationItemConnection;
  /**
   * Unpublish many LongText documents
   * @deprecated Please use the new paginated many mutation (unpublishManyLongTextsConnection)
   */
  unpublishManyLongTexts: BatchPayload;
  /** Find many LongText documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyLongTextsConnection: LongTextConnection;
  /**
   * Unpublish many MediaLibrary documents
   * @deprecated Please use the new paginated many mutation (unpublishManyMediaLibrariesConnection)
   */
  unpublishManyMediaLibraries: BatchPayload;
  /** Find many MediaLibrary documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyMediaLibrariesConnection: MediaLibraryConnection;
  /**
   * Unpublish many MediaLibraryItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyMediaLibraryItemsConnection)
   */
  unpublishManyMediaLibraryItems: BatchPayload;
  /** Find many MediaLibraryItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyMediaLibraryItemsConnection: MediaLibraryItemConnection;
  /**
   * Unpublish many MetaData documents
   * @deprecated Please use the new paginated many mutation (unpublishManyMetaDatasConnection)
   */
  unpublishManyMetaDatas: BatchPayload;
  /** Find many MetaData documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyMetaDatasConnection: MetaDataConnection;
  /**
   * Unpublish many MobileOnlyMainNavigation documents
   * @deprecated Please use the new paginated many mutation (unpublishManyMobileOnlyMainNavigationsConnection)
   */
  unpublishManyMobileOnlyMainNavigations: BatchPayload;
  /** Find many MobileOnlyMainNavigation documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyMobileOnlyMainNavigationsConnection: MobileOnlyMainNavigationConnection;
  /**
   * Unpublish many NavigationItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyNavigationItemsConnection)
   */
  unpublishManyNavigationItems: BatchPayload;
  /** Find many NavigationItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyNavigationItemsConnection: NavigationItemConnection;
  /**
   * Unpublish many Navigation documents
   * @deprecated Please use the new paginated many mutation (unpublishManyNavigationsConnection)
   */
  unpublishManyNavigations: BatchPayload;
  /** Find many Navigation documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyNavigationsConnection: NavigationConnection;
  /**
   * Unpublish many NotificationBanner documents
   * @deprecated Please use the new paginated many mutation (unpublishManyNotificationBannersConnection)
   */
  unpublishManyNotificationBanners: BatchPayload;
  /** Find many NotificationBanner documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyNotificationBannersConnection: NotificationBannerConnection;
  /**
   * Unpublish many PageFooter documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPageFootersConnection)
   */
  unpublishManyPageFooters: BatchPayload;
  /** Find many PageFooter documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPageFootersConnection: PageFooterConnection;
  /**
   * Unpublish many PageHeader documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPageHeadersConnection)
   */
  unpublishManyPageHeaders: BatchPayload;
  /** Find many PageHeader documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPageHeadersConnection: PageHeaderConnection;
  /**
   * Unpublish many PopularSearchComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPopularSearchComponentsConnection)
   */
  unpublishManyPopularSearchComponents: BatchPayload;
  /** Find many PopularSearchComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPopularSearchComponentsConnection: PopularSearchComponentConnection;
  /**
   * Unpublish many PressRelease documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPressReleasesConnection)
   */
  unpublishManyPressReleases: BatchPayload;
  /** Find many PressRelease documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPressReleasesConnection: PressReleaseConnection;
  /**
   * Unpublish many PressStoriesCard documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPressStoriesCardsConnection)
   */
  unpublishManyPressStoriesCards: BatchPayload;
  /** Find many PressStoriesCard documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPressStoriesCardsConnection: PressStoriesCardConnection;
  /**
   * Unpublish many ProgressBar documents
   * @deprecated Please use the new paginated many mutation (unpublishManyProgressBarsConnection)
   */
  unpublishManyProgressBars: BatchPayload;
  /** Find many ProgressBar documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyProgressBarsConnection: ProgressBarConnection;
  /**
   * Unpublish many QuickLinkItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManyQuickLinkItemsConnection)
   */
  unpublishManyQuickLinkItems: BatchPayload;
  /** Find many QuickLinkItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyQuickLinkItemsConnection: QuickLinkItemConnection;
  /**
   * Unpublish many QuickLink documents
   * @deprecated Please use the new paginated many mutation (unpublishManyQuickLinksConnection)
   */
  unpublishManyQuickLinks: BatchPayload;
  /** Find many QuickLink documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyQuickLinksConnection: QuickLinkConnection;
  /**
   * Unpublish many Redirect documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRedirectsConnection)
   */
  unpublishManyRedirects: BatchPayload;
  /** Find many Redirect documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRedirectsConnection: RedirectConnection;
  /**
   * Unpublish many Rewrite documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRewritesConnection)
   */
  unpublishManyRewrites: BatchPayload;
  /** Find many Rewrite documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRewritesConnection: RewriteConnection;
  /**
   * Unpublish many RightColumn documents
   * @deprecated Please use the new paginated many mutation (unpublishManyRightColumnsConnection)
   */
  unpublishManyRightColumns: BatchPayload;
  /** Find many RightColumn documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyRightColumnsConnection: RightColumnConnection;
  /**
   * Unpublish many SearchInput documents
   * @deprecated Please use the new paginated many mutation (unpublishManySearchInputsConnection)
   */
  unpublishManySearchInputs: BatchPayload;
  /** Find many SearchInput documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySearchInputsConnection: SearchInputConnection;
  /**
   * Unpublish many SearchOverlayComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManySearchOverlayComponentsConnection)
   */
  unpublishManySearchOverlayComponents: BatchPayload;
  /** Find many SearchOverlayComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySearchOverlayComponentsConnection: SearchOverlayComponentConnection;
  /**
   * Unpublish many SearchResultPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManySearchResultPagesConnection)
   */
  unpublishManySearchResultPages: BatchPayload;
  /** Find many SearchResultPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySearchResultPagesConnection: SearchResultPageConnection;
  /**
   * Unpublish many ShortHero documents
   * @deprecated Please use the new paginated many mutation (unpublishManyShortHeroesConnection)
   */
  unpublishManyShortHeroes: BatchPayload;
  /** Find many ShortHero documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyShortHeroesConnection: ShortHeroConnection;
  /**
   * Unpublish many SocialMediaListComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManySocialMediaListComponentsConnection)
   */
  unpublishManySocialMediaListComponents: BatchPayload;
  /** Find many SocialMediaListComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySocialMediaListComponentsConnection: SocialMediaListComponentConnection;
  /**
   * Unpublish many Spacer documents
   * @deprecated Please use the new paginated many mutation (unpublishManySpacersConnection)
   */
  unpublishManySpacers: BatchPayload;
  /** Find many Spacer documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySpacersConnection: SpacerConnection;
  /**
   * Unpublish many Story documents
   * @deprecated Please use the new paginated many mutation (unpublishManyStoriesConnection)
   */
  unpublishManyStories: BatchPayload;
  /** Find many Story documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyStoriesConnection: StoryConnection;
  /**
   * Unpublish many SubCategoryKeyImage documents
   * @deprecated Please use the new paginated many mutation (unpublishManySubCategoryKeyImagesConnection)
   */
  unpublishManySubCategoryKeyImages: BatchPayload;
  /** Find many SubCategoryKeyImage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySubCategoryKeyImagesConnection: SubCategoryKeyImageConnection;
  /**
   * Unpublish many SustainabilityBanner documents
   * @deprecated Please use the new paginated many mutation (unpublishManySustainabilityBannersConnection)
   */
  unpublishManySustainabilityBanners: BatchPayload;
  /** Find many SustainabilityBanner documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySustainabilityBannersConnection: SustainabilityBannerConnection;
  /**
   * Unpublish many SustainabilityInfo documents
   * @deprecated Please use the new paginated many mutation (unpublishManySustainabilityInfosConnection)
   */
  unpublishManySustainabilityInfos: BatchPayload;
  /** Find many SustainabilityInfo documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySustainabilityInfosConnection: SustainabilityInfoConnection;
  /**
   * Unpublish many TabContent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTabContentsConnection)
   */
  unpublishManyTabContents: BatchPayload;
  /** Find many TabContent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTabContentsConnection: TabContentConnection;
  /**
   * Unpublish many Tab documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTabsConnection)
   */
  unpublishManyTabs: BatchPayload;
  /** Find many Tab documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTabsConnection: TabConnection;
  /**
   * Unpublish many TestTipsANdTricksInAMarket documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTestTipsANdTricksInAMarketsConnection)
   */
  unpublishManyTestTipsANdTricksInAMarkets: BatchPayload;
  /** Find many TestTipsANdTricksInAMarket documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTestTipsANdTricksInAMarketsConnection: TestTipsANdTricksInAMarketConnection;
  /**
   * Unpublish many TextComponent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTextComponentsConnection)
   */
  unpublishManyTextComponents: BatchPayload;
  /** Find many TextComponent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTextComponentsConnection: TextComponentConnection;
  /**
   * Unpublish many TipsAndTricksDetailsPage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTipsAndTricksDetailsPagesConnection)
   */
  unpublishManyTipsAndTricksDetailsPages: BatchPayload;
  /** Find many TipsAndTricksDetailsPage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTipsAndTricksDetailsPagesConnection: TipsAndTricksDetailsPageConnection;
  /**
   * Unpublish many Title documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTitlesConnection)
   */
  unpublishManyTitles: BatchPayload;
  /** Find many Title documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTitlesConnection: TitleConnection;
  /**
   * Unpublish many TwitterSeo documents
   * @deprecated Please use the new paginated many mutation (unpublishManyTwitterSeosConnection)
   */
  unpublishManyTwitterSeos: BatchPayload;
  /** Find many TwitterSeo documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyTwitterSeosConnection: TwitterSeoConnection;
  /**
   * Unpublish many Widget documents
   * @deprecated Please use the new paginated many mutation (unpublishManyWidgetsConnection)
   */
  unpublishManyWidgets: BatchPayload;
  /** Find many Widget documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyWidgetsConnection: WidgetConnection;
  /** Unpublish one mediaLibrary from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishMediaLibrary?: Maybe<MediaLibrary>;
  /** Unpublish one mediaLibraryItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishMediaLibraryItem?: Maybe<MediaLibraryItem>;
  /** Unpublish one metaData from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishMetaData?: Maybe<MetaData>;
  /** Unpublish one mobileOnlyMainNavigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishMobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Unpublish one navigation from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishNavigation?: Maybe<Navigation>;
  /** Unpublish one navigationItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishNavigationItem?: Maybe<NavigationItem>;
  /** Unpublish one notificationBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishNotificationBanner?: Maybe<NotificationBanner>;
  /** Unpublish one pageFooter from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPageFooter?: Maybe<PageFooter>;
  /** Unpublish one pageHeader from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPageHeader?: Maybe<PageHeader>;
  /** Unpublish one popularSearchComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPopularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Unpublish one pressRelease from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPressRelease?: Maybe<PressRelease>;
  /** Unpublish one pressStoriesCard from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishPressStoriesCard?: Maybe<PressStoriesCard>;
  /** Unpublish one progressBar from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishProgressBar?: Maybe<ProgressBar>;
  /** Unpublish one quickLink from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishQuickLink?: Maybe<QuickLink>;
  /** Unpublish one quickLinkItem from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishQuickLinkItem?: Maybe<QuickLinkItem>;
  /** Unpublish one redirect from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRedirect?: Maybe<Redirect>;
  /** Unpublish one rewrite from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRewrite?: Maybe<Rewrite>;
  /** Unpublish one rightColumn from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishRightColumn?: Maybe<RightColumn>;
  /** Unpublish one searchInput from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSearchInput?: Maybe<SearchInput>;
  /** Unpublish one searchOverlayComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSearchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Unpublish one searchResultPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSearchResultPage?: Maybe<SearchResultPage>;
  /** Unpublish one shortHero from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishShortHero?: Maybe<ShortHero>;
  /** Unpublish one socialMediaListComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSocialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Unpublish one spacer from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSpacer?: Maybe<Spacer>;
  /** Unpublish one story from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishStory?: Maybe<Story>;
  /** Unpublish one subCategoryKeyImage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSubCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Unpublish one sustainabilityBanner from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Unpublish one sustainabilityInfo from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishSustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Unpublish one tab from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTab?: Maybe<Tab>;
  /** Unpublish one tabContent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTabContent?: Maybe<TabContent>;
  /** Unpublish one testTipsANdTricksInAMarket from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTestTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Unpublish one textComponent from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTextComponent?: Maybe<TextComponent>;
  /** Unpublish one tipsAndTricksDetailsPage from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Unpublish one title from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTitle?: Maybe<Title>;
  /** Unpublish one twitterSeo from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishTwitterSeo?: Maybe<TwitterSeo>;
  /** Unpublish one widget from selected stages. Unpublish either the complete document with its relations, localizations and base data or specific localizations only. */
  unpublishWidget?: Maybe<Widget>;
  /** Update one accordion */
  updateAccordion?: Maybe<Accordion>;
  /** Update one accordionItem */
  updateAccordionItem?: Maybe<AccordionItem>;
  /** Update one alexTestComponent */
  updateAlexTestComponent?: Maybe<AlexTestComponent>;
  /** Update one algoliaExtension */
  updateAlgoliaExtension?: Maybe<AlgoliaExtension>;
  /** Update one anchorNav */
  updateAnchorNav?: Maybe<AnchorNav>;
  /** Update one anchorNavigation */
  updateAnchorNavigation?: Maybe<AnchorNavigation>;
  /** Update one anchorNavigationList */
  updateAnchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Update one asset */
  updateAsset?: Maybe<Asset>;
  /** Update one assetComponent */
  updateAssetComponent?: Maybe<AssetComponent>;
  /** Update one audioComponent */
  updateAudioComponent?: Maybe<AudioComponent>;
  /** Update one authorableContentCard */
  updateAuthorableContentCard?: Maybe<AuthorableContentCard>;
  /** Update one banner2 */
  updateBanner2?: Maybe<Banner2>;
  /** Update one bigNumber */
  updateBigNumber?: Maybe<BigNumber>;
  /** Update one bigNumberItem */
  updateBigNumberItem?: Maybe<BigNumberItem>;
  /** Update one cardComponent */
  updateCardComponent?: Maybe<CardComponent>;
  /** Update one carouselComponent */
  updateCarouselComponent?: Maybe<CarouselComponent>;
  /** Update one carouselSlide */
  updateCarouselSlide?: Maybe<CarouselSlide>;
  /** Update one categoryCard */
  updateCategoryCard?: Maybe<CategoryCard>;
  /** Update one contactCard */
  updateContactCard?: Maybe<ContactCard>;
  /** Update one contactCardContainer */
  updateContactCardContainer?: Maybe<ContactCardContainer>;
  /** Update one corpAddToCalendar */
  updateCorpAddToCalendar?: Maybe<CorpAddToCalendar>;
  /** Update one corpBanner1 */
  updateCorpBanner1?: Maybe<CorpBanner1>;
  /** Update one corpCalendarEvent */
  updateCorpCalendarEvent?: Maybe<CorpCalendarEvent>;
  /** Update one corpCardCarousel */
  updateCorpCardCarousel?: Maybe<CorpCardCarousel>;
  /** Update one corpContactCard */
  updateCorpContactCard?: Maybe<CorpContactCard>;
  /** Update one corpContactCardContainer */
  updateCorpContactCardContainer?: Maybe<CorpContactCardContainer>;
  /** Update one corpForm */
  updateCorpForm?: Maybe<CorpForm>;
  /** Update one corpGenericAccordion */
  updateCorpGenericAccordion?: Maybe<CorpGenericAccordion>;
  /** Update one corpGenericAccordionItem */
  updateCorpGenericAccordionItem?: Maybe<CorpGenericAccordionItem>;
  /** Update one corpGenericBanner */
  updateCorpGenericBanner?: Maybe<CorpGenericBanner>;
  /** Update one corpGenericContainer */
  updateCorpGenericContainer?: Maybe<CorpGenericContainer>;
  /** Update one corpGridColumnComponent */
  updateCorpGridColumnComponent?: Maybe<CorpGridColumnComponent>;
  /** Update one corpHero */
  updateCorpHero?: Maybe<CorpHero>;
  /** Update one corpMediaDownloadPreview */
  updateCorpMediaDownloadPreview?: Maybe<CorpMediaDownloadPreview>;
  /** Update one corpNavigation */
  updateCorpNavigation?: Maybe<CorpNavigation>;
  /** Update one corpNavigationItem */
  updateCorpNavigationItem?: Maybe<CorpNavigationItem>;
  /** Update one corpNotificationBanner */
  updateCorpNotificationBanner?: Maybe<CorpNotificationBanner>;
  /** Update one corpOurPeople */
  updateCorpOurPeople?: Maybe<CorpOurPeople>;
  /** Update one corpOurPeopleItem */
  updateCorpOurPeopleItem?: Maybe<CorpOurPeopleItem>;
  /** Update one corpPressPage */
  updateCorpPressPage?: Maybe<CorpPressPage>;
  /** Update one corpSocialMediaFooter */
  updateCorpSocialMediaFooter?: Maybe<CorpSocialMediaFooter>;
  /** Update one corpStoriesPage */
  updateCorpStoriesPage?: Maybe<CorpStoriesPage>;
  /** Update one corpStoryCarousel */
  updateCorpStoryCarousel?: Maybe<CorpStoryCarousel>;
  /** Update one corpTimelineAccordion */
  updateCorpTimelineAccordion?: Maybe<CorpTimelineAccordion>;
  /** Update one corpTimelineAccordionItem */
  updateCorpTimelineAccordionItem?: Maybe<CorpTimelineAccordionItem>;
  /** Update one corpTimelineAccordionWrapper */
  updateCorpTimelineAccordionWrapper?: Maybe<CorpTimelineAccordionWrapper>;
  /** Update one corpVideoHero */
  updateCorpVideoHero?: Maybe<CorpVideoHero>;
  /** Update one corpVideoHeroCarousel */
  updateCorpVideoHeroCarousel?: Maybe<CorpVideoHeroCarousel>;
  /** Update one countrySelector */
  updateCountrySelector?: Maybe<CountrySelector>;
  /** Update one countrySelectorItem */
  updateCountrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Update one dEPRECATEDBanner1 */
  updateDEPRECATEDBanner1?: Maybe<DeprecatedBanner1>;
  /** Update one deprecatedCorpNavigationCopy */
  updateDeprecatedCorpNavigationCopy?: Maybe<DeprecatedCorpNavigationCopy>;
  /** Update one dictionary */
  updateDictionary?: Maybe<Dictionary>;
  /** Update one dictionaryItem */
  updateDictionaryItem?: Maybe<DictionaryItem>;
  /** Update one dynamicCardGrid */
  updateDynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Update one evalancheFormComponent */
  updateEvalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Update one exampleComponent */
  updateExampleComponent?: Maybe<ExampleComponent>;
  /** Update one featuredContent */
  updateFeaturedContent?: Maybe<FeaturedContent>;
  /** Update one featuredContentReference */
  updateFeaturedContentReference?: Maybe<FeaturedContentReference>;
  /** Update one footerNavigation */
  updateFooterNavigation?: Maybe<FooterNavigation>;
  /** Update one form */
  updateForm?: Maybe<Form>;
  /** Update one formCheckbox */
  updateFormCheckbox?: Maybe<FormCheckbox>;
  /** Update one formEmailInput */
  updateFormEmailInput?: Maybe<FormEmailInput>;
  /** Update one formError */
  updateFormError?: Maybe<FormError>;
  /** Update one formPasswordInput */
  updateFormPasswordInput?: Maybe<FormPasswordInput>;
  /** Update one formPasswordInputWithConfirmation */
  updateFormPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Update one formRadioButton */
  updateFormRadioButton?: Maybe<FormRadioButton>;
  /** Update one formRadioButtonCollection */
  updateFormRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Update one formSelectComponent */
  updateFormSelectComponent?: Maybe<FormSelectComponent>;
  /** Update one formSelectOption */
  updateFormSelectOption?: Maybe<FormSelectOption>;
  /** Update one formSubmitButton */
  updateFormSubmitButton?: Maybe<FormSubmitButton>;
  /** Update one formSuccessComponent */
  updateFormSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Update one formTextInput */
  updateFormTextInput?: Maybe<FormTextInput>;
  /** Update one formTextareaInput */
  updateFormTextareaInput?: Maybe<FormTextareaInput>;
  /** Update one genericAccordion */
  updateGenericAccordion?: Maybe<GenericAccordion>;
  /** Update one genericAccordionItem */
  updateGenericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Update one genericAccordionTopRated */
  updateGenericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Update one genericCardCarouseComponent */
  updateGenericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Update one genericDownloadComponent */
  updateGenericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Update one genericFollowUs */
  updateGenericFollowUs?: Maybe<GenericFollowUs>;
  /** Update one genericGridAuthorable */
  updateGenericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Update one genericLine */
  updateGenericLine?: Maybe<GenericLine>;
  /** Update one genericLink */
  updateGenericLink?: Maybe<GenericLink>;
  /** Update one genericPage */
  updateGenericPage?: Maybe<GenericPage>;
  /** Update one globalMetaData */
  updateGlobalMetaData?: Maybe<GlobalMetaData>;
  /** Update one heroBanner */
  updateHeroBanner?: Maybe<HeroBanner>;
  /** Update one heroCarouselComponent */
  updateHeroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Update one heroComponent */
  updateHeroComponent?: Maybe<HeroComponent>;
  /** Update one homePage */
  updateHomePage?: Maybe<HomePage>;
  /** Update one iframe */
  updateIframe?: Maybe<Iframe>;
  /** Update one imageAndTextCard */
  updateImageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Update one imageCopy */
  updateImageCopy?: Maybe<ImageCopy>;
  /** Update one imageCopyItem */
  updateImageCopyItem?: Maybe<ImageCopyItem>;
  /** Update one introText */
  updateIntroText?: Maybe<IntroText>;
  /** Update one leftColumn */
  updateLeftColumn?: Maybe<LeftColumn>;
  /** Update one link */
  updateLink?: Maybe<Link>;
  /** Update one locationComponent */
  updateLocationComponent?: Maybe<LocationComponent>;
  /** Update one locationItem */
  updateLocationItem?: Maybe<LocationItem>;
  /** Update one longText */
  updateLongText?: Maybe<LongText>;
  /**
   * Update many accordionItems
   * @deprecated Please use the new paginated many mutation (updateManyAccordionItemsConnection)
   */
  updateManyAccordionItems: BatchPayload;
  /** Update many AccordionItem documents */
  updateManyAccordionItemsConnection: AccordionItemConnection;
  /**
   * Update many accordions
   * @deprecated Please use the new paginated many mutation (updateManyAccordionsConnection)
   */
  updateManyAccordions: BatchPayload;
  /** Update many Accordion documents */
  updateManyAccordionsConnection: AccordionConnection;
  /**
   * Update many alexTestComponents
   * @deprecated Please use the new paginated many mutation (updateManyAlexTestComponentsConnection)
   */
  updateManyAlexTestComponents: BatchPayload;
  /** Update many AlexTestComponent documents */
  updateManyAlexTestComponentsConnection: AlexTestComponentConnection;
  /**
   * Update many algoliaExtensions
   * @deprecated Please use the new paginated many mutation (updateManyAlgoliaExtensionsConnection)
   */
  updateManyAlgoliaExtensions: BatchPayload;
  /** Update many AlgoliaExtension documents */
  updateManyAlgoliaExtensionsConnection: AlgoliaExtensionConnection;
  /**
   * Update many anchorNavigationLists
   * @deprecated Please use the new paginated many mutation (updateManyAnchorNavigationListsConnection)
   */
  updateManyAnchorNavigationLists: BatchPayload;
  /** Update many AnchorNavigationList documents */
  updateManyAnchorNavigationListsConnection: AnchorNavigationListConnection;
  /**
   * Update many anchorNavigations
   * @deprecated Please use the new paginated many mutation (updateManyAnchorNavigationsConnection)
   */
  updateManyAnchorNavigations: BatchPayload;
  /** Update many AnchorNavigation documents */
  updateManyAnchorNavigationsConnection: AnchorNavigationConnection;
  /**
   * Update many anchorNavs
   * @deprecated Please use the new paginated many mutation (updateManyAnchorNavsConnection)
   */
  updateManyAnchorNavs: BatchPayload;
  /** Update many AnchorNav documents */
  updateManyAnchorNavsConnection: AnchorNavConnection;
  /**
   * Update many assets
   * @deprecated Please use the new paginated many mutation (updateManyAssetsConnection)
   */
  updateManyAssets: BatchPayload;
  /**
   * Update many assetsComponents
   * @deprecated Please use the new paginated many mutation (updateManyAssetsComponentsConnection)
   */
  updateManyAssetsComponents: BatchPayload;
  /** Update many AssetComponent documents */
  updateManyAssetsComponentsConnection: AssetComponentConnection;
  /** Update many Asset documents */
  updateManyAssetsConnection: AssetConnection;
  /**
   * Update many audioComponents
   * @deprecated Please use the new paginated many mutation (updateManyAudioComponentsConnection)
   */
  updateManyAudioComponents: BatchPayload;
  /** Update many AudioComponent documents */
  updateManyAudioComponentsConnection: AudioComponentConnection;
  /**
   * Update many authorableContentCards
   * @deprecated Please use the new paginated many mutation (updateManyAuthorableContentCardsConnection)
   */
  updateManyAuthorableContentCards: BatchPayload;
  /** Update many AuthorableContentCard documents */
  updateManyAuthorableContentCardsConnection: AuthorableContentCardConnection;
  /**
   * Update many banner2S
   * @deprecated Please use the new paginated many mutation (updateManyBanner2SConnection)
   */
  updateManyBanner2S: BatchPayload;
  /** Update many Banner2 documents */
  updateManyBanner2SConnection: Banner2Connection;
  /**
   * Update many bigNumberItems
   * @deprecated Please use the new paginated many mutation (updateManyBigNumberItemsConnection)
   */
  updateManyBigNumberItems: BatchPayload;
  /** Update many BigNumberItem documents */
  updateManyBigNumberItemsConnection: BigNumberItemConnection;
  /**
   * Update many bigNumbers
   * @deprecated Please use the new paginated many mutation (updateManyBigNumbersConnection)
   */
  updateManyBigNumbers: BatchPayload;
  /** Update many BigNumber documents */
  updateManyBigNumbersConnection: BigNumberConnection;
  /**
   * Update many cardComponents
   * @deprecated Please use the new paginated many mutation (updateManyCardComponentsConnection)
   */
  updateManyCardComponents: BatchPayload;
  /** Update many CardComponent documents */
  updateManyCardComponentsConnection: CardComponentConnection;
  /**
   * Update many carouselComponents
   * @deprecated Please use the new paginated many mutation (updateManyCarouselComponentsConnection)
   */
  updateManyCarouselComponents: BatchPayload;
  /** Update many CarouselComponent documents */
  updateManyCarouselComponentsConnection: CarouselComponentConnection;
  /**
   * Update many carouselSlides
   * @deprecated Please use the new paginated many mutation (updateManyCarouselSlidesConnection)
   */
  updateManyCarouselSlides: BatchPayload;
  /** Update many CarouselSlide documents */
  updateManyCarouselSlidesConnection: CarouselSlideConnection;
  /**
   * Update many categoryCards
   * @deprecated Please use the new paginated many mutation (updateManyCategoryCardsConnection)
   */
  updateManyCategoryCards: BatchPayload;
  /** Update many CategoryCard documents */
  updateManyCategoryCardsConnection: CategoryCardConnection;
  /**
   * Update many contactCardContainers
   * @deprecated Please use the new paginated many mutation (updateManyContactCardContainersConnection)
   */
  updateManyContactCardContainers: BatchPayload;
  /** Update many ContactCardContainer documents */
  updateManyContactCardContainersConnection: ContactCardContainerConnection;
  /**
   * Update many contactCards
   * @deprecated Please use the new paginated many mutation (updateManyContactCardsConnection)
   */
  updateManyContactCards: BatchPayload;
  /** Update many ContactCard documents */
  updateManyContactCardsConnection: ContactCardConnection;
  /**
   * Update many corpAddToCalendars
   * @deprecated Please use the new paginated many mutation (updateManyCorpAddToCalendarsConnection)
   */
  updateManyCorpAddToCalendars: BatchPayload;
  /** Update many CorpAddToCalendar documents */
  updateManyCorpAddToCalendarsConnection: CorpAddToCalendarConnection;
  /**
   * Update many corpBanners1
   * @deprecated Please use the new paginated many mutation (updateManyCorpBanners1Connection)
   */
  updateManyCorpBanners1: BatchPayload;
  /** Update many CorpBanner1 documents */
  updateManyCorpBanners1Connection: CorpBanner1Connection;
  /**
   * Update many corpCalendarEvents
   * @deprecated Please use the new paginated many mutation (updateManyCorpCalendarEventsConnection)
   */
  updateManyCorpCalendarEvents: BatchPayload;
  /** Update many CorpCalendarEvent documents */
  updateManyCorpCalendarEventsConnection: CorpCalendarEventConnection;
  /**
   * Update many corpCardCarousels
   * @deprecated Please use the new paginated many mutation (updateManyCorpCardCarouselsConnection)
   */
  updateManyCorpCardCarousels: BatchPayload;
  /** Update many CorpCardCarousel documents */
  updateManyCorpCardCarouselsConnection: CorpCardCarouselConnection;
  /**
   * Update many corpContactCardContainers
   * @deprecated Please use the new paginated many mutation (updateManyCorpContactCardContainersConnection)
   */
  updateManyCorpContactCardContainers: BatchPayload;
  /** Update many CorpContactCardContainer documents */
  updateManyCorpContactCardContainersConnection: CorpContactCardContainerConnection;
  /**
   * Update many corpContactCards
   * @deprecated Please use the new paginated many mutation (updateManyCorpContactCardsConnection)
   */
  updateManyCorpContactCards: BatchPayload;
  /** Update many CorpContactCard documents */
  updateManyCorpContactCardsConnection: CorpContactCardConnection;
  /**
   * Update many corpForms
   * @deprecated Please use the new paginated many mutation (updateManyCorpFormsConnection)
   */
  updateManyCorpForms: BatchPayload;
  /** Update many CorpForm documents */
  updateManyCorpFormsConnection: CorpFormConnection;
  /**
   * Update many corpGenericAccordionItems
   * @deprecated Please use the new paginated many mutation (updateManyCorpGenericAccordionItemsConnection)
   */
  updateManyCorpGenericAccordionItems: BatchPayload;
  /** Update many CorpGenericAccordionItem documents */
  updateManyCorpGenericAccordionItemsConnection: CorpGenericAccordionItemConnection;
  /**
   * Update many corpGenericAccordions
   * @deprecated Please use the new paginated many mutation (updateManyCorpGenericAccordionsConnection)
   */
  updateManyCorpGenericAccordions: BatchPayload;
  /** Update many CorpGenericAccordion documents */
  updateManyCorpGenericAccordionsConnection: CorpGenericAccordionConnection;
  /**
   * Update many corpGenericBanners
   * @deprecated Please use the new paginated many mutation (updateManyCorpGenericBannersConnection)
   */
  updateManyCorpGenericBanners: BatchPayload;
  /** Update many CorpGenericBanner documents */
  updateManyCorpGenericBannersConnection: CorpGenericBannerConnection;
  /**
   * Update many corpGenericContainers
   * @deprecated Please use the new paginated many mutation (updateManyCorpGenericContainersConnection)
   */
  updateManyCorpGenericContainers: BatchPayload;
  /** Update many CorpGenericContainer documents */
  updateManyCorpGenericContainersConnection: CorpGenericContainerConnection;
  /**
   * Update many corpGridColumnComponents
   * @deprecated Please use the new paginated many mutation (updateManyCorpGridColumnComponentsConnection)
   */
  updateManyCorpGridColumnComponents: BatchPayload;
  /** Update many CorpGridColumnComponent documents */
  updateManyCorpGridColumnComponentsConnection: CorpGridColumnComponentConnection;
  /**
   * Update many corpHeros
   * @deprecated Please use the new paginated many mutation (updateManyCorpHerosConnection)
   */
  updateManyCorpHeros: BatchPayload;
  /** Update many CorpHero documents */
  updateManyCorpHerosConnection: CorpHeroConnection;
  /**
   * Update many corpMediaDownloadPreviews
   * @deprecated Please use the new paginated many mutation (updateManyCorpMediaDownloadPreviewsConnection)
   */
  updateManyCorpMediaDownloadPreviews: BatchPayload;
  /** Update many CorpMediaDownloadPreview documents */
  updateManyCorpMediaDownloadPreviewsConnection: CorpMediaDownloadPreviewConnection;
  /**
   * Update many corpNavigationItems
   * @deprecated Please use the new paginated many mutation (updateManyCorpNavigationItemsConnection)
   */
  updateManyCorpNavigationItems: BatchPayload;
  /** Update many CorpNavigationItem documents */
  updateManyCorpNavigationItemsConnection: CorpNavigationItemConnection;
  /**
   * Update many corpNavigations
   * @deprecated Please use the new paginated many mutation (updateManyCorpNavigationsConnection)
   */
  updateManyCorpNavigations: BatchPayload;
  /** Update many CorpNavigation documents */
  updateManyCorpNavigationsConnection: CorpNavigationConnection;
  /**
   * Update many corpNotificationBanners
   * @deprecated Please use the new paginated many mutation (updateManyCorpNotificationBannersConnection)
   */
  updateManyCorpNotificationBanners: BatchPayload;
  /** Update many CorpNotificationBanner documents */
  updateManyCorpNotificationBannersConnection: CorpNotificationBannerConnection;
  /**
   * Update many corpOurPeopleItems
   * @deprecated Please use the new paginated many mutation (updateManyCorpOurPeopleItemsConnection)
   */
  updateManyCorpOurPeopleItems: BatchPayload;
  /** Update many CorpOurPeopleItem documents */
  updateManyCorpOurPeopleItemsConnection: CorpOurPeopleItemConnection;
  /**
   * Update many corpOurPeoples
   * @deprecated Please use the new paginated many mutation (updateManyCorpOurPeoplesConnection)
   */
  updateManyCorpOurPeoples: BatchPayload;
  /** Update many CorpOurPeople documents */
  updateManyCorpOurPeoplesConnection: CorpOurPeopleConnection;
  /**
   * Update many corpPressPages
   * @deprecated Please use the new paginated many mutation (updateManyCorpPressPagesConnection)
   */
  updateManyCorpPressPages: BatchPayload;
  /** Update many CorpPressPage documents */
  updateManyCorpPressPagesConnection: CorpPressPageConnection;
  /**
   * Update many corpSocialMediaFooters
   * @deprecated Please use the new paginated many mutation (updateManyCorpSocialMediaFootersConnection)
   */
  updateManyCorpSocialMediaFooters: BatchPayload;
  /** Update many CorpSocialMediaFooter documents */
  updateManyCorpSocialMediaFootersConnection: CorpSocialMediaFooterConnection;
  /**
   * Update many corpStoriesPages
   * @deprecated Please use the new paginated many mutation (updateManyCorpStoriesPagesConnection)
   */
  updateManyCorpStoriesPages: BatchPayload;
  /** Update many CorpStoriesPage documents */
  updateManyCorpStoriesPagesConnection: CorpStoriesPageConnection;
  /**
   * Update many corpStoryCarousels
   * @deprecated Please use the new paginated many mutation (updateManyCorpStoryCarouselsConnection)
   */
  updateManyCorpStoryCarousels: BatchPayload;
  /** Update many CorpStoryCarousel documents */
  updateManyCorpStoryCarouselsConnection: CorpStoryCarouselConnection;
  /**
   * Update many corpTimelineAccordionItems
   * @deprecated Please use the new paginated many mutation (updateManyCorpTimelineAccordionItemsConnection)
   */
  updateManyCorpTimelineAccordionItems: BatchPayload;
  /** Update many CorpTimelineAccordionItem documents */
  updateManyCorpTimelineAccordionItemsConnection: CorpTimelineAccordionItemConnection;
  /**
   * Update many corpTimelineAccordionWrappers
   * @deprecated Please use the new paginated many mutation (updateManyCorpTimelineAccordionWrappersConnection)
   */
  updateManyCorpTimelineAccordionWrappers: BatchPayload;
  /** Update many CorpTimelineAccordionWrapper documents */
  updateManyCorpTimelineAccordionWrappersConnection: CorpTimelineAccordionWrapperConnection;
  /**
   * Update many corpTimelineAccordions
   * @deprecated Please use the new paginated many mutation (updateManyCorpTimelineAccordionsConnection)
   */
  updateManyCorpTimelineAccordions: BatchPayload;
  /** Update many CorpTimelineAccordion documents */
  updateManyCorpTimelineAccordionsConnection: CorpTimelineAccordionConnection;
  /**
   * Update many corpVideoHeroCarousels
   * @deprecated Please use the new paginated many mutation (updateManyCorpVideoHeroCarouselsConnection)
   */
  updateManyCorpVideoHeroCarousels: BatchPayload;
  /** Update many CorpVideoHeroCarousel documents */
  updateManyCorpVideoHeroCarouselsConnection: CorpVideoHeroCarouselConnection;
  /**
   * Update many corpVideoHeros
   * @deprecated Please use the new paginated many mutation (updateManyCorpVideoHerosConnection)
   */
  updateManyCorpVideoHeros: BatchPayload;
  /** Update many CorpVideoHero documents */
  updateManyCorpVideoHerosConnection: CorpVideoHeroConnection;
  /**
   * Update many countrySelectorItems
   * @deprecated Please use the new paginated many mutation (updateManyCountrySelectorItemsConnection)
   */
  updateManyCountrySelectorItems: BatchPayload;
  /** Update many CountrySelectorItem documents */
  updateManyCountrySelectorItemsConnection: CountrySelectorItemConnection;
  /**
   * Update many countrySelectors
   * @deprecated Please use the new paginated many mutation (updateManyCountrySelectorsConnection)
   */
  updateManyCountrySelectors: BatchPayload;
  /** Update many CountrySelector documents */
  updateManyCountrySelectorsConnection: CountrySelectorConnection;
  /**
   * Update many dEPRECATEDBanner1s
   * @deprecated Please use the new paginated many mutation (updateManyDEPRECATEDBanner1sConnection)
   */
  updateManyDEPRECATEDBanner1s: BatchPayload;
  /** Update many DEPRECATEDBanner1 documents */
  updateManyDEPRECATEDBanner1sConnection: DeprecatedBanner1Connection;
  /**
   * Update many deprecatedCorpNavigations
   * @deprecated Please use the new paginated many mutation (updateManyDeprecatedCorpNavigationsConnection)
   */
  updateManyDeprecatedCorpNavigations: BatchPayload;
  /** Update many DeprecatedCorpNavigationCopy documents */
  updateManyDeprecatedCorpNavigationsConnection: DeprecatedCorpNavigationCopyConnection;
  /**
   * Update many dictionaries
   * @deprecated Please use the new paginated many mutation (updateManyDictionariesConnection)
   */
  updateManyDictionaries: BatchPayload;
  /** Update many Dictionary documents */
  updateManyDictionariesConnection: DictionaryConnection;
  /**
   * Update many dictionaryItems
   * @deprecated Please use the new paginated many mutation (updateManyDictionaryItemsConnection)
   */
  updateManyDictionaryItems: BatchPayload;
  /** Update many DictionaryItem documents */
  updateManyDictionaryItemsConnection: DictionaryItemConnection;
  /**
   * Update many dynamicCardGrids
   * @deprecated Please use the new paginated many mutation (updateManyDynamicCardGridsConnection)
   */
  updateManyDynamicCardGrids: BatchPayload;
  /** Update many DynamicCardGrid documents */
  updateManyDynamicCardGridsConnection: DynamicCardGridConnection;
  /**
   * Update many evalancheFormComponents
   * @deprecated Please use the new paginated many mutation (updateManyEvalancheFormComponentsConnection)
   */
  updateManyEvalancheFormComponents: BatchPayload;
  /** Update many EvalancheFormComponent documents */
  updateManyEvalancheFormComponentsConnection: EvalancheFormComponentConnection;
  /**
   * Update many exampleComponents
   * @deprecated Please use the new paginated many mutation (updateManyExampleComponentsConnection)
   */
  updateManyExampleComponents: BatchPayload;
  /** Update many ExampleComponent documents */
  updateManyExampleComponentsConnection: ExampleComponentConnection;
  /**
   * Update many featuredContentReferences
   * @deprecated Please use the new paginated many mutation (updateManyFeaturedContentReferencesConnection)
   */
  updateManyFeaturedContentReferences: BatchPayload;
  /** Update many FeaturedContentReference documents */
  updateManyFeaturedContentReferencesConnection: FeaturedContentReferenceConnection;
  /**
   * Update many featuredContents
   * @deprecated Please use the new paginated many mutation (updateManyFeaturedContentsConnection)
   */
  updateManyFeaturedContents: BatchPayload;
  /** Update many FeaturedContent documents */
  updateManyFeaturedContentsConnection: FeaturedContentConnection;
  /**
   * Update many footerNavigations
   * @deprecated Please use the new paginated many mutation (updateManyFooterNavigationsConnection)
   */
  updateManyFooterNavigations: BatchPayload;
  /** Update many FooterNavigation documents */
  updateManyFooterNavigationsConnection: FooterNavigationConnection;
  /**
   * Update many formCheckboxes
   * @deprecated Please use the new paginated many mutation (updateManyFormCheckboxesConnection)
   */
  updateManyFormCheckboxes: BatchPayload;
  /** Update many FormCheckbox documents */
  updateManyFormCheckboxesConnection: FormCheckboxConnection;
  /**
   * Update many formEmailInputs
   * @deprecated Please use the new paginated many mutation (updateManyFormEmailInputsConnection)
   */
  updateManyFormEmailInputs: BatchPayload;
  /** Update many FormEmailInput documents */
  updateManyFormEmailInputsConnection: FormEmailInputConnection;
  /**
   * Update many formErrors
   * @deprecated Please use the new paginated many mutation (updateManyFormErrorsConnection)
   */
  updateManyFormErrors: BatchPayload;
  /** Update many FormError documents */
  updateManyFormErrorsConnection: FormErrorConnection;
  /**
   * Update many formPasswordInputWithConfirmations
   * @deprecated Please use the new paginated many mutation (updateManyFormPasswordInputWithConfirmationsConnection)
   */
  updateManyFormPasswordInputWithConfirmations: BatchPayload;
  /** Update many FormPasswordInputWithConfirmation documents */
  updateManyFormPasswordInputWithConfirmationsConnection: FormPasswordInputWithConfirmationConnection;
  /**
   * Update many formPasswordInputs
   * @deprecated Please use the new paginated many mutation (updateManyFormPasswordInputsConnection)
   */
  updateManyFormPasswordInputs: BatchPayload;
  /** Update many FormPasswordInput documents */
  updateManyFormPasswordInputsConnection: FormPasswordInputConnection;
  /**
   * Update many formRadioButtonCollections
   * @deprecated Please use the new paginated many mutation (updateManyFormRadioButtonCollectionsConnection)
   */
  updateManyFormRadioButtonCollections: BatchPayload;
  /** Update many FormRadioButtonCollection documents */
  updateManyFormRadioButtonCollectionsConnection: FormRadioButtonCollectionConnection;
  /**
   * Update many formRadioButtons
   * @deprecated Please use the new paginated many mutation (updateManyFormRadioButtonsConnection)
   */
  updateManyFormRadioButtons: BatchPayload;
  /** Update many FormRadioButton documents */
  updateManyFormRadioButtonsConnection: FormRadioButtonConnection;
  /**
   * Update many formSelectComponents
   * @deprecated Please use the new paginated many mutation (updateManyFormSelectComponentsConnection)
   */
  updateManyFormSelectComponents: BatchPayload;
  /** Update many FormSelectComponent documents */
  updateManyFormSelectComponentsConnection: FormSelectComponentConnection;
  /**
   * Update many formSelectOptions
   * @deprecated Please use the new paginated many mutation (updateManyFormSelectOptionsConnection)
   */
  updateManyFormSelectOptions: BatchPayload;
  /** Update many FormSelectOption documents */
  updateManyFormSelectOptionsConnection: FormSelectOptionConnection;
  /**
   * Update many formSubmitButtons
   * @deprecated Please use the new paginated many mutation (updateManyFormSubmitButtonsConnection)
   */
  updateManyFormSubmitButtons: BatchPayload;
  /** Update many FormSubmitButton documents */
  updateManyFormSubmitButtonsConnection: FormSubmitButtonConnection;
  /**
   * Update many formSuccessComponents
   * @deprecated Please use the new paginated many mutation (updateManyFormSuccessComponentsConnection)
   */
  updateManyFormSuccessComponents: BatchPayload;
  /** Update many FormSuccessComponent documents */
  updateManyFormSuccessComponentsConnection: FormSuccessComponentConnection;
  /**
   * Update many formTextInputs
   * @deprecated Please use the new paginated many mutation (updateManyFormTextInputsConnection)
   */
  updateManyFormTextInputs: BatchPayload;
  /** Update many FormTextInput documents */
  updateManyFormTextInputsConnection: FormTextInputConnection;
  /**
   * Update many formTextareaInputs
   * @deprecated Please use the new paginated many mutation (updateManyFormTextareaInputsConnection)
   */
  updateManyFormTextareaInputs: BatchPayload;
  /** Update many FormTextareaInput documents */
  updateManyFormTextareaInputsConnection: FormTextareaInputConnection;
  /**
   * Update many forms
   * @deprecated Please use the new paginated many mutation (updateManyFormsConnection)
   */
  updateManyForms: BatchPayload;
  /** Update many Form documents */
  updateManyFormsConnection: FormConnection;
  /**
   * Update many genericAccordionItems
   * @deprecated Please use the new paginated many mutation (updateManyGenericAccordionItemsConnection)
   */
  updateManyGenericAccordionItems: BatchPayload;
  /** Update many GenericAccordionItem documents */
  updateManyGenericAccordionItemsConnection: GenericAccordionItemConnection;
  /**
   * Update many genericAccordionTopRateds
   * @deprecated Please use the new paginated many mutation (updateManyGenericAccordionTopRatedsConnection)
   */
  updateManyGenericAccordionTopRateds: BatchPayload;
  /** Update many GenericAccordionTopRated documents */
  updateManyGenericAccordionTopRatedsConnection: GenericAccordionTopRatedConnection;
  /**
   * Update many genericAccordions
   * @deprecated Please use the new paginated many mutation (updateManyGenericAccordionsConnection)
   */
  updateManyGenericAccordions: BatchPayload;
  /** Update many GenericAccordion documents */
  updateManyGenericAccordionsConnection: GenericAccordionConnection;
  /**
   * Update many genericCardCarouseComponents
   * @deprecated Please use the new paginated many mutation (updateManyGenericCardCarouseComponentsConnection)
   */
  updateManyGenericCardCarouseComponents: BatchPayload;
  /** Update many GenericCardCarouseComponent documents */
  updateManyGenericCardCarouseComponentsConnection: GenericCardCarouseComponentConnection;
  /**
   * Update many genericDownloadComponents
   * @deprecated Please use the new paginated many mutation (updateManyGenericDownloadComponentsConnection)
   */
  updateManyGenericDownloadComponents: BatchPayload;
  /** Update many GenericDownloadComponent documents */
  updateManyGenericDownloadComponentsConnection: GenericDownloadComponentConnection;
  /**
   * Update many genericFollowUses
   * @deprecated Please use the new paginated many mutation (updateManyGenericFollowUsesConnection)
   */
  updateManyGenericFollowUses: BatchPayload;
  /** Update many GenericFollowUs documents */
  updateManyGenericFollowUsesConnection: GenericFollowUsConnection;
  /**
   * Update many genericGridAuthorables
   * @deprecated Please use the new paginated many mutation (updateManyGenericGridAuthorablesConnection)
   */
  updateManyGenericGridAuthorables: BatchPayload;
  /** Update many GenericGridAuthorable documents */
  updateManyGenericGridAuthorablesConnection: GenericGridAuthorableConnection;
  /**
   * Update many genericLines
   * @deprecated Please use the new paginated many mutation (updateManyGenericLinesConnection)
   */
  updateManyGenericLines: BatchPayload;
  /** Update many GenericLine documents */
  updateManyGenericLinesConnection: GenericLineConnection;
  /**
   * Update many genericLinks
   * @deprecated Please use the new paginated many mutation (updateManyGenericLinksConnection)
   */
  updateManyGenericLinks: BatchPayload;
  /** Update many GenericLink documents */
  updateManyGenericLinksConnection: GenericLinkConnection;
  /**
   * Update many genericPages
   * @deprecated Please use the new paginated many mutation (updateManyGenericPagesConnection)
   */
  updateManyGenericPages: BatchPayload;
  /** Update many GenericPage documents */
  updateManyGenericPagesConnection: GenericPageConnection;
  /**
   * Update many globalMetaDatas
   * @deprecated Please use the new paginated many mutation (updateManyGlobalMetaDatasConnection)
   */
  updateManyGlobalMetaDatas: BatchPayload;
  /** Update many GlobalMetaData documents */
  updateManyGlobalMetaDatasConnection: GlobalMetaDataConnection;
  /**
   * Update many heroBanners
   * @deprecated Please use the new paginated many mutation (updateManyHeroBannersConnection)
   */
  updateManyHeroBanners: BatchPayload;
  /** Update many HeroBanner documents */
  updateManyHeroBannersConnection: HeroBannerConnection;
  /**
   * Update many heroCarouselComponents
   * @deprecated Please use the new paginated many mutation (updateManyHeroCarouselComponentsConnection)
   */
  updateManyHeroCarouselComponents: BatchPayload;
  /** Update many HeroCarouselComponent documents */
  updateManyHeroCarouselComponentsConnection: HeroCarouselComponentConnection;
  /**
   * Update many heroComponents
   * @deprecated Please use the new paginated many mutation (updateManyHeroComponentsConnection)
   */
  updateManyHeroComponents: BatchPayload;
  /** Update many HeroComponent documents */
  updateManyHeroComponentsConnection: HeroComponentConnection;
  /**
   * Update many homePages
   * @deprecated Please use the new paginated many mutation (updateManyHomePagesConnection)
   */
  updateManyHomePages: BatchPayload;
  /** Update many HomePage documents */
  updateManyHomePagesConnection: HomePageConnection;
  /**
   * Update many iframes
   * @deprecated Please use the new paginated many mutation (updateManyIframesConnection)
   */
  updateManyIframes: BatchPayload;
  /** Update many Iframe documents */
  updateManyIframesConnection: IframeConnection;
  /**
   * Update many imageAndTextCards
   * @deprecated Please use the new paginated many mutation (updateManyImageAndTextCardsConnection)
   */
  updateManyImageAndTextCards: BatchPayload;
  /** Update many ImageAndTextCard documents */
  updateManyImageAndTextCardsConnection: ImageAndTextCardConnection;
  /**
   * Update many imageCopies
   * @deprecated Please use the new paginated many mutation (updateManyImageCopiesConnection)
   */
  updateManyImageCopies: BatchPayload;
  /** Update many ImageCopy documents */
  updateManyImageCopiesConnection: ImageCopyConnection;
  /**
   * Update many imageCopyItems
   * @deprecated Please use the new paginated many mutation (updateManyImageCopyItemsConnection)
   */
  updateManyImageCopyItems: BatchPayload;
  /** Update many ImageCopyItem documents */
  updateManyImageCopyItemsConnection: ImageCopyItemConnection;
  /**
   * Update many introTexts
   * @deprecated Please use the new paginated many mutation (updateManyIntroTextsConnection)
   */
  updateManyIntroTexts: BatchPayload;
  /** Update many IntroText documents */
  updateManyIntroTextsConnection: IntroTextConnection;
  /**
   * Update many leftColumns
   * @deprecated Please use the new paginated many mutation (updateManyLeftColumnsConnection)
   */
  updateManyLeftColumns: BatchPayload;
  /** Update many LeftColumn documents */
  updateManyLeftColumnsConnection: LeftColumnConnection;
  /**
   * Update many links
   * @deprecated Please use the new paginated many mutation (updateManyLinksConnection)
   */
  updateManyLinks: BatchPayload;
  /** Update many Link documents */
  updateManyLinksConnection: LinkConnection;
  /**
   * Update many locationComponents
   * @deprecated Please use the new paginated many mutation (updateManyLocationComponentsConnection)
   */
  updateManyLocationComponents: BatchPayload;
  /** Update many LocationComponent documents */
  updateManyLocationComponentsConnection: LocationComponentConnection;
  /**
   * Update many locationItems
   * @deprecated Please use the new paginated many mutation (updateManyLocationItemsConnection)
   */
  updateManyLocationItems: BatchPayload;
  /** Update many LocationItem documents */
  updateManyLocationItemsConnection: LocationItemConnection;
  /**
   * Update many longTexts
   * @deprecated Please use the new paginated many mutation (updateManyLongTextsConnection)
   */
  updateManyLongTexts: BatchPayload;
  /** Update many LongText documents */
  updateManyLongTextsConnection: LongTextConnection;
  /**
   * Update many mediaLibraries
   * @deprecated Please use the new paginated many mutation (updateManyMediaLibrariesConnection)
   */
  updateManyMediaLibraries: BatchPayload;
  /** Update many MediaLibrary documents */
  updateManyMediaLibrariesConnection: MediaLibraryConnection;
  /**
   * Update many mediaLibraryItems
   * @deprecated Please use the new paginated many mutation (updateManyMediaLibraryItemsConnection)
   */
  updateManyMediaLibraryItems: BatchPayload;
  /** Update many MediaLibraryItem documents */
  updateManyMediaLibraryItemsConnection: MediaLibraryItemConnection;
  /**
   * Update many metaDatas
   * @deprecated Please use the new paginated many mutation (updateManyMetaDatasConnection)
   */
  updateManyMetaDatas: BatchPayload;
  /** Update many MetaData documents */
  updateManyMetaDatasConnection: MetaDataConnection;
  /**
   * Update many mobileOnlyMainNavigations
   * @deprecated Please use the new paginated many mutation (updateManyMobileOnlyMainNavigationsConnection)
   */
  updateManyMobileOnlyMainNavigations: BatchPayload;
  /** Update many MobileOnlyMainNavigation documents */
  updateManyMobileOnlyMainNavigationsConnection: MobileOnlyMainNavigationConnection;
  /**
   * Update many navigationItems
   * @deprecated Please use the new paginated many mutation (updateManyNavigationItemsConnection)
   */
  updateManyNavigationItems: BatchPayload;
  /** Update many NavigationItem documents */
  updateManyNavigationItemsConnection: NavigationItemConnection;
  /**
   * Update many navigations
   * @deprecated Please use the new paginated many mutation (updateManyNavigationsConnection)
   */
  updateManyNavigations: BatchPayload;
  /** Update many Navigation documents */
  updateManyNavigationsConnection: NavigationConnection;
  /**
   * Update many notificationBanners
   * @deprecated Please use the new paginated many mutation (updateManyNotificationBannersConnection)
   */
  updateManyNotificationBanners: BatchPayload;
  /** Update many NotificationBanner documents */
  updateManyNotificationBannersConnection: NotificationBannerConnection;
  /**
   * Update many pageFooters
   * @deprecated Please use the new paginated many mutation (updateManyPageFootersConnection)
   */
  updateManyPageFooters: BatchPayload;
  /** Update many PageFooter documents */
  updateManyPageFootersConnection: PageFooterConnection;
  /**
   * Update many pageHeaders
   * @deprecated Please use the new paginated many mutation (updateManyPageHeadersConnection)
   */
  updateManyPageHeaders: BatchPayload;
  /** Update many PageHeader documents */
  updateManyPageHeadersConnection: PageHeaderConnection;
  /**
   * Update many popularSearchComponents
   * @deprecated Please use the new paginated many mutation (updateManyPopularSearchComponentsConnection)
   */
  updateManyPopularSearchComponents: BatchPayload;
  /** Update many PopularSearchComponent documents */
  updateManyPopularSearchComponentsConnection: PopularSearchComponentConnection;
  /**
   * Update many pressReleases
   * @deprecated Please use the new paginated many mutation (updateManyPressReleasesConnection)
   */
  updateManyPressReleases: BatchPayload;
  /** Update many PressRelease documents */
  updateManyPressReleasesConnection: PressReleaseConnection;
  /**
   * Update many pressStoriesCards
   * @deprecated Please use the new paginated many mutation (updateManyPressStoriesCardsConnection)
   */
  updateManyPressStoriesCards: BatchPayload;
  /** Update many PressStoriesCard documents */
  updateManyPressStoriesCardsConnection: PressStoriesCardConnection;
  /**
   * Update many progressBars
   * @deprecated Please use the new paginated many mutation (updateManyProgressBarsConnection)
   */
  updateManyProgressBars: BatchPayload;
  /** Update many ProgressBar documents */
  updateManyProgressBarsConnection: ProgressBarConnection;
  /**
   * Update many quickLinkItems
   * @deprecated Please use the new paginated many mutation (updateManyQuickLinkItemsConnection)
   */
  updateManyQuickLinkItems: BatchPayload;
  /** Update many QuickLinkItem documents */
  updateManyQuickLinkItemsConnection: QuickLinkItemConnection;
  /**
   * Update many quickLinks
   * @deprecated Please use the new paginated many mutation (updateManyQuickLinksConnection)
   */
  updateManyQuickLinks: BatchPayload;
  /** Update many QuickLink documents */
  updateManyQuickLinksConnection: QuickLinkConnection;
  /**
   * Update many redirects
   * @deprecated Please use the new paginated many mutation (updateManyRedirectsConnection)
   */
  updateManyRedirects: BatchPayload;
  /** Update many Redirect documents */
  updateManyRedirectsConnection: RedirectConnection;
  /**
   * Update many rewrites
   * @deprecated Please use the new paginated many mutation (updateManyRewritesConnection)
   */
  updateManyRewrites: BatchPayload;
  /** Update many Rewrite documents */
  updateManyRewritesConnection: RewriteConnection;
  /**
   * Update many rightColumns
   * @deprecated Please use the new paginated many mutation (updateManyRightColumnsConnection)
   */
  updateManyRightColumns: BatchPayload;
  /** Update many RightColumn documents */
  updateManyRightColumnsConnection: RightColumnConnection;
  /**
   * Update many searchInputs
   * @deprecated Please use the new paginated many mutation (updateManySearchInputsConnection)
   */
  updateManySearchInputs: BatchPayload;
  /** Update many SearchInput documents */
  updateManySearchInputsConnection: SearchInputConnection;
  /**
   * Update many searchOverlayComponents
   * @deprecated Please use the new paginated many mutation (updateManySearchOverlayComponentsConnection)
   */
  updateManySearchOverlayComponents: BatchPayload;
  /** Update many SearchOverlayComponent documents */
  updateManySearchOverlayComponentsConnection: SearchOverlayComponentConnection;
  /**
   * Update many searchResultPages
   * @deprecated Please use the new paginated many mutation (updateManySearchResultPagesConnection)
   */
  updateManySearchResultPages: BatchPayload;
  /** Update many SearchResultPage documents */
  updateManySearchResultPagesConnection: SearchResultPageConnection;
  /**
   * Update many shortHeroes
   * @deprecated Please use the new paginated many mutation (updateManyShortHeroesConnection)
   */
  updateManyShortHeroes: BatchPayload;
  /** Update many ShortHero documents */
  updateManyShortHeroesConnection: ShortHeroConnection;
  /**
   * Update many socialMediaListComponents
   * @deprecated Please use the new paginated many mutation (updateManySocialMediaListComponentsConnection)
   */
  updateManySocialMediaListComponents: BatchPayload;
  /** Update many SocialMediaListComponent documents */
  updateManySocialMediaListComponentsConnection: SocialMediaListComponentConnection;
  /**
   * Update many spacers
   * @deprecated Please use the new paginated many mutation (updateManySpacersConnection)
   */
  updateManySpacers: BatchPayload;
  /** Update many Spacer documents */
  updateManySpacersConnection: SpacerConnection;
  /**
   * Update many stories
   * @deprecated Please use the new paginated many mutation (updateManyStoriesConnection)
   */
  updateManyStories: BatchPayload;
  /** Update many Story documents */
  updateManyStoriesConnection: StoryConnection;
  /**
   * Update many subCategoryKeyImages
   * @deprecated Please use the new paginated many mutation (updateManySubCategoryKeyImagesConnection)
   */
  updateManySubCategoryKeyImages: BatchPayload;
  /** Update many SubCategoryKeyImage documents */
  updateManySubCategoryKeyImagesConnection: SubCategoryKeyImageConnection;
  /**
   * Update many sustainabilityBanners
   * @deprecated Please use the new paginated many mutation (updateManySustainabilityBannersConnection)
   */
  updateManySustainabilityBanners: BatchPayload;
  /** Update many SustainabilityBanner documents */
  updateManySustainabilityBannersConnection: SustainabilityBannerConnection;
  /**
   * Update many sustainabilityInfos
   * @deprecated Please use the new paginated many mutation (updateManySustainabilityInfosConnection)
   */
  updateManySustainabilityInfos: BatchPayload;
  /** Update many SustainabilityInfo documents */
  updateManySustainabilityInfosConnection: SustainabilityInfoConnection;
  /**
   * Update many tabContents
   * @deprecated Please use the new paginated many mutation (updateManyTabContentsConnection)
   */
  updateManyTabContents: BatchPayload;
  /** Update many TabContent documents */
  updateManyTabContentsConnection: TabContentConnection;
  /**
   * Update many tabs
   * @deprecated Please use the new paginated many mutation (updateManyTabsConnection)
   */
  updateManyTabs: BatchPayload;
  /** Update many Tab documents */
  updateManyTabsConnection: TabConnection;
  /**
   * Update many testTipsANdTricksInAMarkets
   * @deprecated Please use the new paginated many mutation (updateManyTestTipsANdTricksInAMarketsConnection)
   */
  updateManyTestTipsANdTricksInAMarkets: BatchPayload;
  /** Update many TestTipsANdTricksInAMarket documents */
  updateManyTestTipsANdTricksInAMarketsConnection: TestTipsANdTricksInAMarketConnection;
  /**
   * Update many textComponents
   * @deprecated Please use the new paginated many mutation (updateManyTextComponentsConnection)
   */
  updateManyTextComponents: BatchPayload;
  /** Update many TextComponent documents */
  updateManyTextComponentsConnection: TextComponentConnection;
  /**
   * Update many tipsAndTricksDetailsPages
   * @deprecated Please use the new paginated many mutation (updateManyTipsAndTricksDetailsPagesConnection)
   */
  updateManyTipsAndTricksDetailsPages: BatchPayload;
  /** Update many TipsAndTricksDetailsPage documents */
  updateManyTipsAndTricksDetailsPagesConnection: TipsAndTricksDetailsPageConnection;
  /**
   * Update many titles
   * @deprecated Please use the new paginated many mutation (updateManyTitlesConnection)
   */
  updateManyTitles: BatchPayload;
  /** Update many Title documents */
  updateManyTitlesConnection: TitleConnection;
  /**
   * Update many twitterSeos
   * @deprecated Please use the new paginated many mutation (updateManyTwitterSeosConnection)
   */
  updateManyTwitterSeos: BatchPayload;
  /** Update many TwitterSeo documents */
  updateManyTwitterSeosConnection: TwitterSeoConnection;
  /**
   * Update many widgets
   * @deprecated Please use the new paginated many mutation (updateManyWidgetsConnection)
   */
  updateManyWidgets: BatchPayload;
  /** Update many Widget documents */
  updateManyWidgetsConnection: WidgetConnection;
  /** Update one mediaLibrary */
  updateMediaLibrary?: Maybe<MediaLibrary>;
  /** Update one mediaLibraryItem */
  updateMediaLibraryItem?: Maybe<MediaLibraryItem>;
  /** Update one metaData */
  updateMetaData?: Maybe<MetaData>;
  /** Update one mobileOnlyMainNavigation */
  updateMobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Update one navigation */
  updateNavigation?: Maybe<Navigation>;
  /** Update one navigationItem */
  updateNavigationItem?: Maybe<NavigationItem>;
  /** Update one notificationBanner */
  updateNotificationBanner?: Maybe<NotificationBanner>;
  /** Update one pageFooter */
  updatePageFooter?: Maybe<PageFooter>;
  /** Update one pageHeader */
  updatePageHeader?: Maybe<PageHeader>;
  /** Update one popularSearchComponent */
  updatePopularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Update one pressRelease */
  updatePressRelease?: Maybe<PressRelease>;
  /** Update one pressStoriesCard */
  updatePressStoriesCard?: Maybe<PressStoriesCard>;
  /** Update one progressBar */
  updateProgressBar?: Maybe<ProgressBar>;
  /** Update one quickLink */
  updateQuickLink?: Maybe<QuickLink>;
  /** Update one quickLinkItem */
  updateQuickLinkItem?: Maybe<QuickLinkItem>;
  /** Update one redirect */
  updateRedirect?: Maybe<Redirect>;
  /** Update one rewrite */
  updateRewrite?: Maybe<Rewrite>;
  /** Update one rightColumn */
  updateRightColumn?: Maybe<RightColumn>;
  /** Update one scheduledRelease */
  updateScheduledRelease?: Maybe<ScheduledRelease>;
  /** Update one searchInput */
  updateSearchInput?: Maybe<SearchInput>;
  /** Update one searchOverlayComponent */
  updateSearchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Update one searchResultPage */
  updateSearchResultPage?: Maybe<SearchResultPage>;
  /** Update one shortHero */
  updateShortHero?: Maybe<ShortHero>;
  /** Update one socialMediaListComponent */
  updateSocialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Update one spacer */
  updateSpacer?: Maybe<Spacer>;
  /** Update one story */
  updateStory?: Maybe<Story>;
  /** Update one subCategoryKeyImage */
  updateSubCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Update one sustainabilityBanner */
  updateSustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Update one sustainabilityInfo */
  updateSustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Update one tab */
  updateTab?: Maybe<Tab>;
  /** Update one tabContent */
  updateTabContent?: Maybe<TabContent>;
  /** Update one testTipsANdTricksInAMarket */
  updateTestTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Update one textComponent */
  updateTextComponent?: Maybe<TextComponent>;
  /** Update one tipsAndTricksDetailsPage */
  updateTipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Update one title */
  updateTitle?: Maybe<Title>;
  /** Update one twitterSeo */
  updateTwitterSeo?: Maybe<TwitterSeo>;
  /** Update one widget */
  updateWidget?: Maybe<Widget>;
  /** Upsert one accordion */
  upsertAccordion?: Maybe<Accordion>;
  /** Upsert one accordionItem */
  upsertAccordionItem?: Maybe<AccordionItem>;
  /** Upsert one alexTestComponent */
  upsertAlexTestComponent?: Maybe<AlexTestComponent>;
  /** Upsert one algoliaExtension */
  upsertAlgoliaExtension?: Maybe<AlgoliaExtension>;
  /** Upsert one anchorNav */
  upsertAnchorNav?: Maybe<AnchorNav>;
  /** Upsert one anchorNavigation */
  upsertAnchorNavigation?: Maybe<AnchorNavigation>;
  /** Upsert one anchorNavigationList */
  upsertAnchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Upsert one asset */
  upsertAsset?: Maybe<Asset>;
  /** Upsert one assetComponent */
  upsertAssetComponent?: Maybe<AssetComponent>;
  /** Upsert one audioComponent */
  upsertAudioComponent?: Maybe<AudioComponent>;
  /** Upsert one authorableContentCard */
  upsertAuthorableContentCard?: Maybe<AuthorableContentCard>;
  /** Upsert one banner2 */
  upsertBanner2?: Maybe<Banner2>;
  /** Upsert one bigNumber */
  upsertBigNumber?: Maybe<BigNumber>;
  /** Upsert one bigNumberItem */
  upsertBigNumberItem?: Maybe<BigNumberItem>;
  /** Upsert one cardComponent */
  upsertCardComponent?: Maybe<CardComponent>;
  /** Upsert one carouselComponent */
  upsertCarouselComponent?: Maybe<CarouselComponent>;
  /** Upsert one carouselSlide */
  upsertCarouselSlide?: Maybe<CarouselSlide>;
  /** Upsert one categoryCard */
  upsertCategoryCard?: Maybe<CategoryCard>;
  /** Upsert one contactCard */
  upsertContactCard?: Maybe<ContactCard>;
  /** Upsert one contactCardContainer */
  upsertContactCardContainer?: Maybe<ContactCardContainer>;
  /** Upsert one corpAddToCalendar */
  upsertCorpAddToCalendar?: Maybe<CorpAddToCalendar>;
  /** Upsert one corpBanner1 */
  upsertCorpBanner1?: Maybe<CorpBanner1>;
  /** Upsert one corpCalendarEvent */
  upsertCorpCalendarEvent?: Maybe<CorpCalendarEvent>;
  /** Upsert one corpCardCarousel */
  upsertCorpCardCarousel?: Maybe<CorpCardCarousel>;
  /** Upsert one corpContactCard */
  upsertCorpContactCard?: Maybe<CorpContactCard>;
  /** Upsert one corpContactCardContainer */
  upsertCorpContactCardContainer?: Maybe<CorpContactCardContainer>;
  /** Upsert one corpForm */
  upsertCorpForm?: Maybe<CorpForm>;
  /** Upsert one corpGenericAccordion */
  upsertCorpGenericAccordion?: Maybe<CorpGenericAccordion>;
  /** Upsert one corpGenericAccordionItem */
  upsertCorpGenericAccordionItem?: Maybe<CorpGenericAccordionItem>;
  /** Upsert one corpGenericBanner */
  upsertCorpGenericBanner?: Maybe<CorpGenericBanner>;
  /** Upsert one corpGenericContainer */
  upsertCorpGenericContainer?: Maybe<CorpGenericContainer>;
  /** Upsert one corpGridColumnComponent */
  upsertCorpGridColumnComponent?: Maybe<CorpGridColumnComponent>;
  /** Upsert one corpHero */
  upsertCorpHero?: Maybe<CorpHero>;
  /** Upsert one corpMediaDownloadPreview */
  upsertCorpMediaDownloadPreview?: Maybe<CorpMediaDownloadPreview>;
  /** Upsert one corpNavigation */
  upsertCorpNavigation?: Maybe<CorpNavigation>;
  /** Upsert one corpNavigationItem */
  upsertCorpNavigationItem?: Maybe<CorpNavigationItem>;
  /** Upsert one corpNotificationBanner */
  upsertCorpNotificationBanner?: Maybe<CorpNotificationBanner>;
  /** Upsert one corpOurPeople */
  upsertCorpOurPeople?: Maybe<CorpOurPeople>;
  /** Upsert one corpOurPeopleItem */
  upsertCorpOurPeopleItem?: Maybe<CorpOurPeopleItem>;
  /** Upsert one corpPressPage */
  upsertCorpPressPage?: Maybe<CorpPressPage>;
  /** Upsert one corpSocialMediaFooter */
  upsertCorpSocialMediaFooter?: Maybe<CorpSocialMediaFooter>;
  /** Upsert one corpStoriesPage */
  upsertCorpStoriesPage?: Maybe<CorpStoriesPage>;
  /** Upsert one corpStoryCarousel */
  upsertCorpStoryCarousel?: Maybe<CorpStoryCarousel>;
  /** Upsert one corpTimelineAccordion */
  upsertCorpTimelineAccordion?: Maybe<CorpTimelineAccordion>;
  /** Upsert one corpTimelineAccordionItem */
  upsertCorpTimelineAccordionItem?: Maybe<CorpTimelineAccordionItem>;
  /** Upsert one corpTimelineAccordionWrapper */
  upsertCorpTimelineAccordionWrapper?: Maybe<CorpTimelineAccordionWrapper>;
  /** Upsert one corpVideoHero */
  upsertCorpVideoHero?: Maybe<CorpVideoHero>;
  /** Upsert one corpVideoHeroCarousel */
  upsertCorpVideoHeroCarousel?: Maybe<CorpVideoHeroCarousel>;
  /** Upsert one countrySelector */
  upsertCountrySelector?: Maybe<CountrySelector>;
  /** Upsert one countrySelectorItem */
  upsertCountrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Upsert one dEPRECATEDBanner1 */
  upsertDEPRECATEDBanner1?: Maybe<DeprecatedBanner1>;
  /** Upsert one deprecatedCorpNavigationCopy */
  upsertDeprecatedCorpNavigationCopy?: Maybe<DeprecatedCorpNavigationCopy>;
  /** Upsert one dictionary */
  upsertDictionary?: Maybe<Dictionary>;
  /** Upsert one dictionaryItem */
  upsertDictionaryItem?: Maybe<DictionaryItem>;
  /** Upsert one dynamicCardGrid */
  upsertDynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Upsert one evalancheFormComponent */
  upsertEvalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Upsert one exampleComponent */
  upsertExampleComponent?: Maybe<ExampleComponent>;
  /** Upsert one featuredContent */
  upsertFeaturedContent?: Maybe<FeaturedContent>;
  /** Upsert one featuredContentReference */
  upsertFeaturedContentReference?: Maybe<FeaturedContentReference>;
  /** Upsert one footerNavigation */
  upsertFooterNavigation?: Maybe<FooterNavigation>;
  /** Upsert one form */
  upsertForm?: Maybe<Form>;
  /** Upsert one formCheckbox */
  upsertFormCheckbox?: Maybe<FormCheckbox>;
  /** Upsert one formEmailInput */
  upsertFormEmailInput?: Maybe<FormEmailInput>;
  /** Upsert one formError */
  upsertFormError?: Maybe<FormError>;
  /** Upsert one formPasswordInput */
  upsertFormPasswordInput?: Maybe<FormPasswordInput>;
  /** Upsert one formPasswordInputWithConfirmation */
  upsertFormPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Upsert one formRadioButton */
  upsertFormRadioButton?: Maybe<FormRadioButton>;
  /** Upsert one formRadioButtonCollection */
  upsertFormRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Upsert one formSelectComponent */
  upsertFormSelectComponent?: Maybe<FormSelectComponent>;
  /** Upsert one formSelectOption */
  upsertFormSelectOption?: Maybe<FormSelectOption>;
  /** Upsert one formSubmitButton */
  upsertFormSubmitButton?: Maybe<FormSubmitButton>;
  /** Upsert one formSuccessComponent */
  upsertFormSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Upsert one formTextInput */
  upsertFormTextInput?: Maybe<FormTextInput>;
  /** Upsert one formTextareaInput */
  upsertFormTextareaInput?: Maybe<FormTextareaInput>;
  /** Upsert one genericAccordion */
  upsertGenericAccordion?: Maybe<GenericAccordion>;
  /** Upsert one genericAccordionItem */
  upsertGenericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Upsert one genericAccordionTopRated */
  upsertGenericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Upsert one genericCardCarouseComponent */
  upsertGenericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Upsert one genericDownloadComponent */
  upsertGenericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Upsert one genericFollowUs */
  upsertGenericFollowUs?: Maybe<GenericFollowUs>;
  /** Upsert one genericGridAuthorable */
  upsertGenericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Upsert one genericLine */
  upsertGenericLine?: Maybe<GenericLine>;
  /** Upsert one genericLink */
  upsertGenericLink?: Maybe<GenericLink>;
  /** Upsert one genericPage */
  upsertGenericPage?: Maybe<GenericPage>;
  /** Upsert one globalMetaData */
  upsertGlobalMetaData?: Maybe<GlobalMetaData>;
  /** Upsert one heroBanner */
  upsertHeroBanner?: Maybe<HeroBanner>;
  /** Upsert one heroCarouselComponent */
  upsertHeroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Upsert one heroComponent */
  upsertHeroComponent?: Maybe<HeroComponent>;
  /** Upsert one homePage */
  upsertHomePage?: Maybe<HomePage>;
  /** Upsert one iframe */
  upsertIframe?: Maybe<Iframe>;
  /** Upsert one imageAndTextCard */
  upsertImageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Upsert one imageCopy */
  upsertImageCopy?: Maybe<ImageCopy>;
  /** Upsert one imageCopyItem */
  upsertImageCopyItem?: Maybe<ImageCopyItem>;
  /** Upsert one introText */
  upsertIntroText?: Maybe<IntroText>;
  /** Upsert one leftColumn */
  upsertLeftColumn?: Maybe<LeftColumn>;
  /** Upsert one link */
  upsertLink?: Maybe<Link>;
  /** Upsert one locationComponent */
  upsertLocationComponent?: Maybe<LocationComponent>;
  /** Upsert one locationItem */
  upsertLocationItem?: Maybe<LocationItem>;
  /** Upsert one longText */
  upsertLongText?: Maybe<LongText>;
  /** Upsert one mediaLibrary */
  upsertMediaLibrary?: Maybe<MediaLibrary>;
  /** Upsert one mediaLibraryItem */
  upsertMediaLibraryItem?: Maybe<MediaLibraryItem>;
  /** Upsert one metaData */
  upsertMetaData?: Maybe<MetaData>;
  /** Upsert one mobileOnlyMainNavigation */
  upsertMobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Upsert one navigation */
  upsertNavigation?: Maybe<Navigation>;
  /** Upsert one navigationItem */
  upsertNavigationItem?: Maybe<NavigationItem>;
  /** Upsert one notificationBanner */
  upsertNotificationBanner?: Maybe<NotificationBanner>;
  /** Upsert one pageFooter */
  upsertPageFooter?: Maybe<PageFooter>;
  /** Upsert one pageHeader */
  upsertPageHeader?: Maybe<PageHeader>;
  /** Upsert one popularSearchComponent */
  upsertPopularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Upsert one pressRelease */
  upsertPressRelease?: Maybe<PressRelease>;
  /** Upsert one pressStoriesCard */
  upsertPressStoriesCard?: Maybe<PressStoriesCard>;
  /** Upsert one progressBar */
  upsertProgressBar?: Maybe<ProgressBar>;
  /** Upsert one quickLink */
  upsertQuickLink?: Maybe<QuickLink>;
  /** Upsert one quickLinkItem */
  upsertQuickLinkItem?: Maybe<QuickLinkItem>;
  /** Upsert one redirect */
  upsertRedirect?: Maybe<Redirect>;
  /** Upsert one rewrite */
  upsertRewrite?: Maybe<Rewrite>;
  /** Upsert one rightColumn */
  upsertRightColumn?: Maybe<RightColumn>;
  /** Upsert one searchInput */
  upsertSearchInput?: Maybe<SearchInput>;
  /** Upsert one searchOverlayComponent */
  upsertSearchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Upsert one searchResultPage */
  upsertSearchResultPage?: Maybe<SearchResultPage>;
  /** Upsert one shortHero */
  upsertShortHero?: Maybe<ShortHero>;
  /** Upsert one socialMediaListComponent */
  upsertSocialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Upsert one spacer */
  upsertSpacer?: Maybe<Spacer>;
  /** Upsert one story */
  upsertStory?: Maybe<Story>;
  /** Upsert one subCategoryKeyImage */
  upsertSubCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Upsert one sustainabilityBanner */
  upsertSustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Upsert one sustainabilityInfo */
  upsertSustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Upsert one tab */
  upsertTab?: Maybe<Tab>;
  /** Upsert one tabContent */
  upsertTabContent?: Maybe<TabContent>;
  /** Upsert one testTipsANdTricksInAMarket */
  upsertTestTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Upsert one textComponent */
  upsertTextComponent?: Maybe<TextComponent>;
  /** Upsert one tipsAndTricksDetailsPage */
  upsertTipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Upsert one title */
  upsertTitle?: Maybe<Title>;
  /** Upsert one twitterSeo */
  upsertTwitterSeo?: Maybe<TwitterSeo>;
  /** Upsert one widget */
  upsertWidget?: Maybe<Widget>;
};


export type MutationCreateAccordionArgs = {
  data: AccordionCreateInput;
};


export type MutationCreateAccordionItemArgs = {
  data: AccordionItemCreateInput;
};


export type MutationCreateAlexTestComponentArgs = {
  data: AlexTestComponentCreateInput;
};


export type MutationCreateAlgoliaExtensionArgs = {
  data: AlgoliaExtensionCreateInput;
};


export type MutationCreateAnchorNavArgs = {
  data: AnchorNavCreateInput;
};


export type MutationCreateAnchorNavigationArgs = {
  data: AnchorNavigationCreateInput;
};


export type MutationCreateAnchorNavigationListArgs = {
  data: AnchorNavigationListCreateInput;
};


export type MutationCreateAssetArgs = {
  data: AssetCreateInput;
};


export type MutationCreateAssetComponentArgs = {
  data: AssetComponentCreateInput;
};


export type MutationCreateAudioComponentArgs = {
  data: AudioComponentCreateInput;
};


export type MutationCreateAuthorableContentCardArgs = {
  data: AuthorableContentCardCreateInput;
};


export type MutationCreateBanner2Args = {
  data: Banner2CreateInput;
};


export type MutationCreateBigNumberArgs = {
  data: BigNumberCreateInput;
};


export type MutationCreateBigNumberItemArgs = {
  data: BigNumberItemCreateInput;
};


export type MutationCreateCardComponentArgs = {
  data: CardComponentCreateInput;
};


export type MutationCreateCarouselComponentArgs = {
  data: CarouselComponentCreateInput;
};


export type MutationCreateCarouselSlideArgs = {
  data: CarouselSlideCreateInput;
};


export type MutationCreateCategoryCardArgs = {
  data: CategoryCardCreateInput;
};


export type MutationCreateContactCardArgs = {
  data: ContactCardCreateInput;
};


export type MutationCreateContactCardContainerArgs = {
  data: ContactCardContainerCreateInput;
};


export type MutationCreateCorpAddToCalendarArgs = {
  data: CorpAddToCalendarCreateInput;
};


export type MutationCreateCorpBanner1Args = {
  data: CorpBanner1CreateInput;
};


export type MutationCreateCorpCalendarEventArgs = {
  data: CorpCalendarEventCreateInput;
};


export type MutationCreateCorpCardCarouselArgs = {
  data: CorpCardCarouselCreateInput;
};


export type MutationCreateCorpContactCardArgs = {
  data: CorpContactCardCreateInput;
};


export type MutationCreateCorpContactCardContainerArgs = {
  data: CorpContactCardContainerCreateInput;
};


export type MutationCreateCorpFormArgs = {
  data: CorpFormCreateInput;
};


export type MutationCreateCorpGenericAccordionArgs = {
  data: CorpGenericAccordionCreateInput;
};


export type MutationCreateCorpGenericAccordionItemArgs = {
  data: CorpGenericAccordionItemCreateInput;
};


export type MutationCreateCorpGenericBannerArgs = {
  data: CorpGenericBannerCreateInput;
};


export type MutationCreateCorpGenericContainerArgs = {
  data: CorpGenericContainerCreateInput;
};


export type MutationCreateCorpGridColumnComponentArgs = {
  data: CorpGridColumnComponentCreateInput;
};


export type MutationCreateCorpHeroArgs = {
  data: CorpHeroCreateInput;
};


export type MutationCreateCorpMediaDownloadPreviewArgs = {
  data: CorpMediaDownloadPreviewCreateInput;
};


export type MutationCreateCorpNavigationArgs = {
  data: CorpNavigationCreateInput;
};


export type MutationCreateCorpNavigationItemArgs = {
  data: CorpNavigationItemCreateInput;
};


export type MutationCreateCorpNotificationBannerArgs = {
  data: CorpNotificationBannerCreateInput;
};


export type MutationCreateCorpOurPeopleArgs = {
  data: CorpOurPeopleCreateInput;
};


export type MutationCreateCorpOurPeopleItemArgs = {
  data: CorpOurPeopleItemCreateInput;
};


export type MutationCreateCorpPressPageArgs = {
  data: CorpPressPageCreateInput;
};


export type MutationCreateCorpSocialMediaFooterArgs = {
  data: CorpSocialMediaFooterCreateInput;
};


export type MutationCreateCorpStoriesPageArgs = {
  data: CorpStoriesPageCreateInput;
};


export type MutationCreateCorpStoryCarouselArgs = {
  data: CorpStoryCarouselCreateInput;
};


export type MutationCreateCorpTimelineAccordionArgs = {
  data: CorpTimelineAccordionCreateInput;
};


export type MutationCreateCorpTimelineAccordionItemArgs = {
  data: CorpTimelineAccordionItemCreateInput;
};


export type MutationCreateCorpTimelineAccordionWrapperArgs = {
  data: CorpTimelineAccordionWrapperCreateInput;
};


export type MutationCreateCorpVideoHeroArgs = {
  data: CorpVideoHeroCreateInput;
};


export type MutationCreateCorpVideoHeroCarouselArgs = {
  data: CorpVideoHeroCarouselCreateInput;
};


export type MutationCreateCountrySelectorArgs = {
  data: CountrySelectorCreateInput;
};


export type MutationCreateCountrySelectorItemArgs = {
  data: CountrySelectorItemCreateInput;
};


export type MutationCreateDeprecatedBanner1Args = {
  data: DeprecatedBanner1CreateInput;
};


export type MutationCreateDeprecatedCorpNavigationCopyArgs = {
  data: DeprecatedCorpNavigationCopyCreateInput;
};


export type MutationCreateDictionaryArgs = {
  data: DictionaryCreateInput;
};


export type MutationCreateDictionaryItemArgs = {
  data: DictionaryItemCreateInput;
};


export type MutationCreateDynamicCardGridArgs = {
  data: DynamicCardGridCreateInput;
};


export type MutationCreateEvalancheFormComponentArgs = {
  data: EvalancheFormComponentCreateInput;
};


export type MutationCreateExampleComponentArgs = {
  data: ExampleComponentCreateInput;
};


export type MutationCreateFeaturedContentArgs = {
  data: FeaturedContentCreateInput;
};


export type MutationCreateFeaturedContentReferenceArgs = {
  data: FeaturedContentReferenceCreateInput;
};


export type MutationCreateFooterNavigationArgs = {
  data: FooterNavigationCreateInput;
};


export type MutationCreateFormArgs = {
  data: FormCreateInput;
};


export type MutationCreateFormCheckboxArgs = {
  data: FormCheckboxCreateInput;
};


export type MutationCreateFormEmailInputArgs = {
  data: FormEmailInputCreateInput;
};


export type MutationCreateFormErrorArgs = {
  data: FormErrorCreateInput;
};


export type MutationCreateFormPasswordInputArgs = {
  data: FormPasswordInputCreateInput;
};


export type MutationCreateFormPasswordInputWithConfirmationArgs = {
  data: FormPasswordInputWithConfirmationCreateInput;
};


export type MutationCreateFormRadioButtonArgs = {
  data: FormRadioButtonCreateInput;
};


export type MutationCreateFormRadioButtonCollectionArgs = {
  data: FormRadioButtonCollectionCreateInput;
};


export type MutationCreateFormSelectComponentArgs = {
  data: FormSelectComponentCreateInput;
};


export type MutationCreateFormSelectOptionArgs = {
  data: FormSelectOptionCreateInput;
};


export type MutationCreateFormSubmitButtonArgs = {
  data: FormSubmitButtonCreateInput;
};


export type MutationCreateFormSuccessComponentArgs = {
  data: FormSuccessComponentCreateInput;
};


export type MutationCreateFormTextInputArgs = {
  data: FormTextInputCreateInput;
};


export type MutationCreateFormTextareaInputArgs = {
  data: FormTextareaInputCreateInput;
};


export type MutationCreateGenericAccordionArgs = {
  data: GenericAccordionCreateInput;
};


export type MutationCreateGenericAccordionItemArgs = {
  data: GenericAccordionItemCreateInput;
};


export type MutationCreateGenericAccordionTopRatedArgs = {
  data: GenericAccordionTopRatedCreateInput;
};


export type MutationCreateGenericCardCarouseComponentArgs = {
  data: GenericCardCarouseComponentCreateInput;
};


export type MutationCreateGenericDownloadComponentArgs = {
  data: GenericDownloadComponentCreateInput;
};


export type MutationCreateGenericFollowUsArgs = {
  data: GenericFollowUsCreateInput;
};


export type MutationCreateGenericGridAuthorableArgs = {
  data: GenericGridAuthorableCreateInput;
};


export type MutationCreateGenericLineArgs = {
  data: GenericLineCreateInput;
};


export type MutationCreateGenericLinkArgs = {
  data: GenericLinkCreateInput;
};


export type MutationCreateGenericPageArgs = {
  data: GenericPageCreateInput;
};


export type MutationCreateGlobalMetaDataArgs = {
  data: GlobalMetaDataCreateInput;
};


export type MutationCreateHeroBannerArgs = {
  data: HeroBannerCreateInput;
};


export type MutationCreateHeroCarouselComponentArgs = {
  data: HeroCarouselComponentCreateInput;
};


export type MutationCreateHeroComponentArgs = {
  data: HeroComponentCreateInput;
};


export type MutationCreateHomePageArgs = {
  data: HomePageCreateInput;
};


export type MutationCreateIframeArgs = {
  data: IframeCreateInput;
};


export type MutationCreateImageAndTextCardArgs = {
  data: ImageAndTextCardCreateInput;
};


export type MutationCreateImageCopyArgs = {
  data: ImageCopyCreateInput;
};


export type MutationCreateImageCopyItemArgs = {
  data: ImageCopyItemCreateInput;
};


export type MutationCreateIntroTextArgs = {
  data: IntroTextCreateInput;
};


export type MutationCreateLeftColumnArgs = {
  data: LeftColumnCreateInput;
};


export type MutationCreateLinkArgs = {
  data: LinkCreateInput;
};


export type MutationCreateLocationComponentArgs = {
  data: LocationComponentCreateInput;
};


export type MutationCreateLocationItemArgs = {
  data: LocationItemCreateInput;
};


export type MutationCreateLongTextArgs = {
  data: LongTextCreateInput;
};


export type MutationCreateMediaLibraryArgs = {
  data: MediaLibraryCreateInput;
};


export type MutationCreateMediaLibraryItemArgs = {
  data: MediaLibraryItemCreateInput;
};


export type MutationCreateMetaDataArgs = {
  data: MetaDataCreateInput;
};


export type MutationCreateMobileOnlyMainNavigationArgs = {
  data: MobileOnlyMainNavigationCreateInput;
};


export type MutationCreateNavigationArgs = {
  data: NavigationCreateInput;
};


export type MutationCreateNavigationItemArgs = {
  data: NavigationItemCreateInput;
};


export type MutationCreateNotificationBannerArgs = {
  data: NotificationBannerCreateInput;
};


export type MutationCreatePageFooterArgs = {
  data: PageFooterCreateInput;
};


export type MutationCreatePageHeaderArgs = {
  data: PageHeaderCreateInput;
};


export type MutationCreatePopularSearchComponentArgs = {
  data: PopularSearchComponentCreateInput;
};


export type MutationCreatePressReleaseArgs = {
  data: PressReleaseCreateInput;
};


export type MutationCreatePressStoriesCardArgs = {
  data: PressStoriesCardCreateInput;
};


export type MutationCreateProgressBarArgs = {
  data: ProgressBarCreateInput;
};


export type MutationCreateQuickLinkArgs = {
  data: QuickLinkCreateInput;
};


export type MutationCreateQuickLinkItemArgs = {
  data: QuickLinkItemCreateInput;
};


export type MutationCreateRedirectArgs = {
  data: RedirectCreateInput;
};


export type MutationCreateRewriteArgs = {
  data: RewriteCreateInput;
};


export type MutationCreateRightColumnArgs = {
  data: RightColumnCreateInput;
};


export type MutationCreateScheduledReleaseArgs = {
  data: ScheduledReleaseCreateInput;
};


export type MutationCreateSearchInputArgs = {
  data: SearchInputCreateInput;
};


export type MutationCreateSearchOverlayComponentArgs = {
  data: SearchOverlayComponentCreateInput;
};


export type MutationCreateSearchResultPageArgs = {
  data: SearchResultPageCreateInput;
};


export type MutationCreateShortHeroArgs = {
  data: ShortHeroCreateInput;
};


export type MutationCreateSocialMediaListComponentArgs = {
  data: SocialMediaListComponentCreateInput;
};


export type MutationCreateSpacerArgs = {
  data: SpacerCreateInput;
};


export type MutationCreateStoryArgs = {
  data: StoryCreateInput;
};


export type MutationCreateSubCategoryKeyImageArgs = {
  data: SubCategoryKeyImageCreateInput;
};


export type MutationCreateSustainabilityBannerArgs = {
  data: SustainabilityBannerCreateInput;
};


export type MutationCreateSustainabilityInfoArgs = {
  data: SustainabilityInfoCreateInput;
};


export type MutationCreateTabArgs = {
  data: TabCreateInput;
};


export type MutationCreateTabContentArgs = {
  data: TabContentCreateInput;
};


export type MutationCreateTestTipsANdTricksInAMarketArgs = {
  data: TestTipsANdTricksInAMarketCreateInput;
};


export type MutationCreateTextComponentArgs = {
  data: TextComponentCreateInput;
};


export type MutationCreateTipsAndTricksDetailsPageArgs = {
  data: TipsAndTricksDetailsPageCreateInput;
};


export type MutationCreateTitleArgs = {
  data: TitleCreateInput;
};


export type MutationCreateTwitterSeoArgs = {
  data: TwitterSeoCreateInput;
};


export type MutationCreateWidgetArgs = {
  data: WidgetCreateInput;
};


export type MutationDeleteAccordionArgs = {
  where: AccordionWhereUniqueInput;
};


export type MutationDeleteAccordionItemArgs = {
  where: AccordionItemWhereUniqueInput;
};


export type MutationDeleteAlexTestComponentArgs = {
  where: AlexTestComponentWhereUniqueInput;
};


export type MutationDeleteAlgoliaExtensionArgs = {
  where: AlgoliaExtensionWhereUniqueInput;
};


export type MutationDeleteAnchorNavArgs = {
  where: AnchorNavWhereUniqueInput;
};


export type MutationDeleteAnchorNavigationArgs = {
  where: AnchorNavigationWhereUniqueInput;
};


export type MutationDeleteAnchorNavigationListArgs = {
  where: AnchorNavigationListWhereUniqueInput;
};


export type MutationDeleteAssetArgs = {
  where: AssetWhereUniqueInput;
};


export type MutationDeleteAssetComponentArgs = {
  where: AssetComponentWhereUniqueInput;
};


export type MutationDeleteAudioComponentArgs = {
  where: AudioComponentWhereUniqueInput;
};


export type MutationDeleteAuthorableContentCardArgs = {
  where: AuthorableContentCardWhereUniqueInput;
};


export type MutationDeleteBanner2Args = {
  where: Banner2WhereUniqueInput;
};


export type MutationDeleteBigNumberArgs = {
  where: BigNumberWhereUniqueInput;
};


export type MutationDeleteBigNumberItemArgs = {
  where: BigNumberItemWhereUniqueInput;
};


export type MutationDeleteCardComponentArgs = {
  where: CardComponentWhereUniqueInput;
};


export type MutationDeleteCarouselComponentArgs = {
  where: CarouselComponentWhereUniqueInput;
};


export type MutationDeleteCarouselSlideArgs = {
  where: CarouselSlideWhereUniqueInput;
};


export type MutationDeleteCategoryCardArgs = {
  where: CategoryCardWhereUniqueInput;
};


export type MutationDeleteContactCardArgs = {
  where: ContactCardWhereUniqueInput;
};


export type MutationDeleteContactCardContainerArgs = {
  where: ContactCardContainerWhereUniqueInput;
};


export type MutationDeleteCorpAddToCalendarArgs = {
  where: CorpAddToCalendarWhereUniqueInput;
};


export type MutationDeleteCorpBanner1Args = {
  where: CorpBanner1WhereUniqueInput;
};


export type MutationDeleteCorpCalendarEventArgs = {
  where: CorpCalendarEventWhereUniqueInput;
};


export type MutationDeleteCorpCardCarouselArgs = {
  where: CorpCardCarouselWhereUniqueInput;
};


export type MutationDeleteCorpContactCardArgs = {
  where: CorpContactCardWhereUniqueInput;
};


export type MutationDeleteCorpContactCardContainerArgs = {
  where: CorpContactCardContainerWhereUniqueInput;
};


export type MutationDeleteCorpFormArgs = {
  where: CorpFormWhereUniqueInput;
};


export type MutationDeleteCorpGenericAccordionArgs = {
  where: CorpGenericAccordionWhereUniqueInput;
};


export type MutationDeleteCorpGenericAccordionItemArgs = {
  where: CorpGenericAccordionItemWhereUniqueInput;
};


export type MutationDeleteCorpGenericBannerArgs = {
  where: CorpGenericBannerWhereUniqueInput;
};


export type MutationDeleteCorpGenericContainerArgs = {
  where: CorpGenericContainerWhereUniqueInput;
};


export type MutationDeleteCorpGridColumnComponentArgs = {
  where: CorpGridColumnComponentWhereUniqueInput;
};


export type MutationDeleteCorpHeroArgs = {
  where: CorpHeroWhereUniqueInput;
};


export type MutationDeleteCorpMediaDownloadPreviewArgs = {
  where: CorpMediaDownloadPreviewWhereUniqueInput;
};


export type MutationDeleteCorpNavigationArgs = {
  where: CorpNavigationWhereUniqueInput;
};


export type MutationDeleteCorpNavigationItemArgs = {
  where: CorpNavigationItemWhereUniqueInput;
};


export type MutationDeleteCorpNotificationBannerArgs = {
  where: CorpNotificationBannerWhereUniqueInput;
};


export type MutationDeleteCorpOurPeopleArgs = {
  where: CorpOurPeopleWhereUniqueInput;
};


export type MutationDeleteCorpOurPeopleItemArgs = {
  where: CorpOurPeopleItemWhereUniqueInput;
};


export type MutationDeleteCorpPressPageArgs = {
  where: CorpPressPageWhereUniqueInput;
};


export type MutationDeleteCorpSocialMediaFooterArgs = {
  where: CorpSocialMediaFooterWhereUniqueInput;
};


export type MutationDeleteCorpStoriesPageArgs = {
  where: CorpStoriesPageWhereUniqueInput;
};


export type MutationDeleteCorpStoryCarouselArgs = {
  where: CorpStoryCarouselWhereUniqueInput;
};


export type MutationDeleteCorpTimelineAccordionArgs = {
  where: CorpTimelineAccordionWhereUniqueInput;
};


export type MutationDeleteCorpTimelineAccordionItemArgs = {
  where: CorpTimelineAccordionItemWhereUniqueInput;
};


export type MutationDeleteCorpTimelineAccordionWrapperArgs = {
  where: CorpTimelineAccordionWrapperWhereUniqueInput;
};


export type MutationDeleteCorpVideoHeroArgs = {
  where: CorpVideoHeroWhereUniqueInput;
};


export type MutationDeleteCorpVideoHeroCarouselArgs = {
  where: CorpVideoHeroCarouselWhereUniqueInput;
};


export type MutationDeleteCountrySelectorArgs = {
  where: CountrySelectorWhereUniqueInput;
};


export type MutationDeleteCountrySelectorItemArgs = {
  where: CountrySelectorItemWhereUniqueInput;
};


export type MutationDeleteDeprecatedBanner1Args = {
  where: DeprecatedBanner1WhereUniqueInput;
};


export type MutationDeleteDeprecatedCorpNavigationCopyArgs = {
  where: DeprecatedCorpNavigationCopyWhereUniqueInput;
};


export type MutationDeleteDictionaryArgs = {
  where: DictionaryWhereUniqueInput;
};


export type MutationDeleteDictionaryItemArgs = {
  where: DictionaryItemWhereUniqueInput;
};


export type MutationDeleteDynamicCardGridArgs = {
  where: DynamicCardGridWhereUniqueInput;
};


export type MutationDeleteEvalancheFormComponentArgs = {
  where: EvalancheFormComponentWhereUniqueInput;
};


export type MutationDeleteExampleComponentArgs = {
  where: ExampleComponentWhereUniqueInput;
};


export type MutationDeleteFeaturedContentArgs = {
  where: FeaturedContentWhereUniqueInput;
};


export type MutationDeleteFeaturedContentReferenceArgs = {
  where: FeaturedContentReferenceWhereUniqueInput;
};


export type MutationDeleteFooterNavigationArgs = {
  where: FooterNavigationWhereUniqueInput;
};


export type MutationDeleteFormArgs = {
  where: FormWhereUniqueInput;
};


export type MutationDeleteFormCheckboxArgs = {
  where: FormCheckboxWhereUniqueInput;
};


export type MutationDeleteFormEmailInputArgs = {
  where: FormEmailInputWhereUniqueInput;
};


export type MutationDeleteFormErrorArgs = {
  where: FormErrorWhereUniqueInput;
};


export type MutationDeleteFormPasswordInputArgs = {
  where: FormPasswordInputWhereUniqueInput;
};


export type MutationDeleteFormPasswordInputWithConfirmationArgs = {
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};


export type MutationDeleteFormRadioButtonArgs = {
  where: FormRadioButtonWhereUniqueInput;
};


export type MutationDeleteFormRadioButtonCollectionArgs = {
  where: FormRadioButtonCollectionWhereUniqueInput;
};


export type MutationDeleteFormSelectComponentArgs = {
  where: FormSelectComponentWhereUniqueInput;
};


export type MutationDeleteFormSelectOptionArgs = {
  where: FormSelectOptionWhereUniqueInput;
};


export type MutationDeleteFormSubmitButtonArgs = {
  where: FormSubmitButtonWhereUniqueInput;
};


export type MutationDeleteFormSuccessComponentArgs = {
  where: FormSuccessComponentWhereUniqueInput;
};


export type MutationDeleteFormTextInputArgs = {
  where: FormTextInputWhereUniqueInput;
};


export type MutationDeleteFormTextareaInputArgs = {
  where: FormTextareaInputWhereUniqueInput;
};


export type MutationDeleteGenericAccordionArgs = {
  where: GenericAccordionWhereUniqueInput;
};


export type MutationDeleteGenericAccordionItemArgs = {
  where: GenericAccordionItemWhereUniqueInput;
};


export type MutationDeleteGenericAccordionTopRatedArgs = {
  where: GenericAccordionTopRatedWhereUniqueInput;
};


export type MutationDeleteGenericCardCarouseComponentArgs = {
  where: GenericCardCarouseComponentWhereUniqueInput;
};


export type MutationDeleteGenericDownloadComponentArgs = {
  where: GenericDownloadComponentWhereUniqueInput;
};


export type MutationDeleteGenericFollowUsArgs = {
  where: GenericFollowUsWhereUniqueInput;
};


export type MutationDeleteGenericGridAuthorableArgs = {
  where: GenericGridAuthorableWhereUniqueInput;
};


export type MutationDeleteGenericLineArgs = {
  where: GenericLineWhereUniqueInput;
};


export type MutationDeleteGenericLinkArgs = {
  where: GenericLinkWhereUniqueInput;
};


export type MutationDeleteGenericPageArgs = {
  where: GenericPageWhereUniqueInput;
};


export type MutationDeleteGlobalMetaDataArgs = {
  where: GlobalMetaDataWhereUniqueInput;
};


export type MutationDeleteHeroBannerArgs = {
  where: HeroBannerWhereUniqueInput;
};


export type MutationDeleteHeroCarouselComponentArgs = {
  where: HeroCarouselComponentWhereUniqueInput;
};


export type MutationDeleteHeroComponentArgs = {
  where: HeroComponentWhereUniqueInput;
};


export type MutationDeleteHomePageArgs = {
  where: HomePageWhereUniqueInput;
};


export type MutationDeleteIframeArgs = {
  where: IframeWhereUniqueInput;
};


export type MutationDeleteImageAndTextCardArgs = {
  where: ImageAndTextCardWhereUniqueInput;
};


export type MutationDeleteImageCopyArgs = {
  where: ImageCopyWhereUniqueInput;
};


export type MutationDeleteImageCopyItemArgs = {
  where: ImageCopyItemWhereUniqueInput;
};


export type MutationDeleteIntroTextArgs = {
  where: IntroTextWhereUniqueInput;
};


export type MutationDeleteLeftColumnArgs = {
  where: LeftColumnWhereUniqueInput;
};


export type MutationDeleteLinkArgs = {
  where: LinkWhereUniqueInput;
};


export type MutationDeleteLocationComponentArgs = {
  where: LocationComponentWhereUniqueInput;
};


export type MutationDeleteLocationItemArgs = {
  where: LocationItemWhereUniqueInput;
};


export type MutationDeleteLongTextArgs = {
  where: LongTextWhereUniqueInput;
};


export type MutationDeleteManyAccordionItemsArgs = {
  where?: InputMaybe<AccordionItemManyWhereInput>;
};


export type MutationDeleteManyAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionItemManyWhereInput>;
};


export type MutationDeleteManyAccordionsArgs = {
  where?: InputMaybe<AccordionManyWhereInput>;
};


export type MutationDeleteManyAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionManyWhereInput>;
};


export type MutationDeleteManyAlexTestComponentsArgs = {
  where?: InputMaybe<AlexTestComponentManyWhereInput>;
};


export type MutationDeleteManyAlexTestComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AlexTestComponentManyWhereInput>;
};


export type MutationDeleteManyAlgoliaExtensionsArgs = {
  where?: InputMaybe<AlgoliaExtensionManyWhereInput>;
};


export type MutationDeleteManyAlgoliaExtensionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AlgoliaExtensionManyWhereInput>;
};


export type MutationDeleteManyAnchorNavigationListsArgs = {
  where?: InputMaybe<AnchorNavigationListManyWhereInput>;
};


export type MutationDeleteManyAnchorNavigationListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorNavigationListManyWhereInput>;
};


export type MutationDeleteManyAnchorNavigationsArgs = {
  where?: InputMaybe<AnchorNavigationManyWhereInput>;
};


export type MutationDeleteManyAnchorNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorNavigationManyWhereInput>;
};


export type MutationDeleteManyAnchorNavsArgs = {
  where?: InputMaybe<AnchorNavManyWhereInput>;
};


export type MutationDeleteManyAnchorNavsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorNavManyWhereInput>;
};


export type MutationDeleteManyAssetsArgs = {
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationDeleteManyAssetsComponentsArgs = {
  where?: InputMaybe<AssetComponentManyWhereInput>;
};


export type MutationDeleteManyAssetsComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentManyWhereInput>;
};


export type MutationDeleteManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationDeleteManyAudioComponentsArgs = {
  where?: InputMaybe<AudioComponentManyWhereInput>;
};


export type MutationDeleteManyAudioComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AudioComponentManyWhereInput>;
};


export type MutationDeleteManyAuthorableContentCardsArgs = {
  where?: InputMaybe<AuthorableContentCardManyWhereInput>;
};


export type MutationDeleteManyAuthorableContentCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuthorableContentCardManyWhereInput>;
};


export type MutationDeleteManyBanner2SArgs = {
  where?: InputMaybe<Banner2ManyWhereInput>;
};


export type MutationDeleteManyBanner2SConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Banner2ManyWhereInput>;
};


export type MutationDeleteManyBigNumberItemsArgs = {
  where?: InputMaybe<BigNumberItemManyWhereInput>;
};


export type MutationDeleteManyBigNumberItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BigNumberItemManyWhereInput>;
};


export type MutationDeleteManyBigNumbersArgs = {
  where?: InputMaybe<BigNumberManyWhereInput>;
};


export type MutationDeleteManyBigNumbersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BigNumberManyWhereInput>;
};


export type MutationDeleteManyCardComponentsArgs = {
  where?: InputMaybe<CardComponentManyWhereInput>;
};


export type MutationDeleteManyCardComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardComponentManyWhereInput>;
};


export type MutationDeleteManyCarouselComponentsArgs = {
  where?: InputMaybe<CarouselComponentManyWhereInput>;
};


export type MutationDeleteManyCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselComponentManyWhereInput>;
};


export type MutationDeleteManyCarouselSlidesArgs = {
  where?: InputMaybe<CarouselSlideManyWhereInput>;
};


export type MutationDeleteManyCarouselSlidesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselSlideManyWhereInput>;
};


export type MutationDeleteManyCategoryCardsArgs = {
  where?: InputMaybe<CategoryCardManyWhereInput>;
};


export type MutationDeleteManyCategoryCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryCardManyWhereInput>;
};


export type MutationDeleteManyContactCardContainersArgs = {
  where?: InputMaybe<ContactCardContainerManyWhereInput>;
};


export type MutationDeleteManyContactCardContainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContactCardContainerManyWhereInput>;
};


export type MutationDeleteManyContactCardsArgs = {
  where?: InputMaybe<ContactCardManyWhereInput>;
};


export type MutationDeleteManyContactCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContactCardManyWhereInput>;
};


export type MutationDeleteManyCorpAddToCalendarsArgs = {
  where?: InputMaybe<CorpAddToCalendarManyWhereInput>;
};


export type MutationDeleteManyCorpAddToCalendarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpAddToCalendarManyWhereInput>;
};


export type MutationDeleteManyCorpBanners1Args = {
  where?: InputMaybe<CorpBanner1ManyWhereInput>;
};


export type MutationDeleteManyCorpBanners1ConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpBanner1ManyWhereInput>;
};


export type MutationDeleteManyCorpCalendarEventsArgs = {
  where?: InputMaybe<CorpCalendarEventManyWhereInput>;
};


export type MutationDeleteManyCorpCalendarEventsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpCalendarEventManyWhereInput>;
};


export type MutationDeleteManyCorpCardCarouselsArgs = {
  where?: InputMaybe<CorpCardCarouselManyWhereInput>;
};


export type MutationDeleteManyCorpCardCarouselsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpCardCarouselManyWhereInput>;
};


export type MutationDeleteManyCorpContactCardContainersArgs = {
  where?: InputMaybe<CorpContactCardContainerManyWhereInput>;
};


export type MutationDeleteManyCorpContactCardContainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpContactCardContainerManyWhereInput>;
};


export type MutationDeleteManyCorpContactCardsArgs = {
  where?: InputMaybe<CorpContactCardManyWhereInput>;
};


export type MutationDeleteManyCorpContactCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpContactCardManyWhereInput>;
};


export type MutationDeleteManyCorpFormsArgs = {
  where?: InputMaybe<CorpFormManyWhereInput>;
};


export type MutationDeleteManyCorpFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpFormManyWhereInput>;
};


export type MutationDeleteManyCorpGenericAccordionItemsArgs = {
  where?: InputMaybe<CorpGenericAccordionItemManyWhereInput>;
};


export type MutationDeleteManyCorpGenericAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericAccordionItemManyWhereInput>;
};


export type MutationDeleteManyCorpGenericAccordionsArgs = {
  where?: InputMaybe<CorpGenericAccordionManyWhereInput>;
};


export type MutationDeleteManyCorpGenericAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericAccordionManyWhereInput>;
};


export type MutationDeleteManyCorpGenericBannersArgs = {
  where?: InputMaybe<CorpGenericBannerManyWhereInput>;
};


export type MutationDeleteManyCorpGenericBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericBannerManyWhereInput>;
};


export type MutationDeleteManyCorpGenericContainersArgs = {
  where?: InputMaybe<CorpGenericContainerManyWhereInput>;
};


export type MutationDeleteManyCorpGenericContainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericContainerManyWhereInput>;
};


export type MutationDeleteManyCorpGridColumnComponentsArgs = {
  where?: InputMaybe<CorpGridColumnComponentManyWhereInput>;
};


export type MutationDeleteManyCorpGridColumnComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGridColumnComponentManyWhereInput>;
};


export type MutationDeleteManyCorpHerosArgs = {
  where?: InputMaybe<CorpHeroManyWhereInput>;
};


export type MutationDeleteManyCorpHerosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpHeroManyWhereInput>;
};


export type MutationDeleteManyCorpMediaDownloadPreviewsArgs = {
  where?: InputMaybe<CorpMediaDownloadPreviewManyWhereInput>;
};


export type MutationDeleteManyCorpMediaDownloadPreviewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpMediaDownloadPreviewManyWhereInput>;
};


export type MutationDeleteManyCorpNavigationItemsArgs = {
  where?: InputMaybe<CorpNavigationItemManyWhereInput>;
};


export type MutationDeleteManyCorpNavigationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpNavigationItemManyWhereInput>;
};


export type MutationDeleteManyCorpNavigationsArgs = {
  where?: InputMaybe<CorpNavigationManyWhereInput>;
};


export type MutationDeleteManyCorpNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpNavigationManyWhereInput>;
};


export type MutationDeleteManyCorpNotificationBannersArgs = {
  where?: InputMaybe<CorpNotificationBannerManyWhereInput>;
};


export type MutationDeleteManyCorpNotificationBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpNotificationBannerManyWhereInput>;
};


export type MutationDeleteManyCorpOurPeopleItemsArgs = {
  where?: InputMaybe<CorpOurPeopleItemManyWhereInput>;
};


export type MutationDeleteManyCorpOurPeopleItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpOurPeopleItemManyWhereInput>;
};


export type MutationDeleteManyCorpOurPeoplesArgs = {
  where?: InputMaybe<CorpOurPeopleManyWhereInput>;
};


export type MutationDeleteManyCorpOurPeoplesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpOurPeopleManyWhereInput>;
};


export type MutationDeleteManyCorpPressPagesArgs = {
  where?: InputMaybe<CorpPressPageManyWhereInput>;
};


export type MutationDeleteManyCorpPressPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpPressPageManyWhereInput>;
};


export type MutationDeleteManyCorpSocialMediaFootersArgs = {
  where?: InputMaybe<CorpSocialMediaFooterManyWhereInput>;
};


export type MutationDeleteManyCorpSocialMediaFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpSocialMediaFooterManyWhereInput>;
};


export type MutationDeleteManyCorpStoriesPagesArgs = {
  where?: InputMaybe<CorpStoriesPageManyWhereInput>;
};


export type MutationDeleteManyCorpStoriesPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpStoriesPageManyWhereInput>;
};


export type MutationDeleteManyCorpStoryCarouselsArgs = {
  where?: InputMaybe<CorpStoryCarouselManyWhereInput>;
};


export type MutationDeleteManyCorpStoryCarouselsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpStoryCarouselManyWhereInput>;
};


export type MutationDeleteManyCorpTimelineAccordionItemsArgs = {
  where?: InputMaybe<CorpTimelineAccordionItemManyWhereInput>;
};


export type MutationDeleteManyCorpTimelineAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpTimelineAccordionItemManyWhereInput>;
};


export type MutationDeleteManyCorpTimelineAccordionWrappersArgs = {
  where?: InputMaybe<CorpTimelineAccordionWrapperManyWhereInput>;
};


export type MutationDeleteManyCorpTimelineAccordionWrappersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpTimelineAccordionWrapperManyWhereInput>;
};


export type MutationDeleteManyCorpTimelineAccordionsArgs = {
  where?: InputMaybe<CorpTimelineAccordionManyWhereInput>;
};


export type MutationDeleteManyCorpTimelineAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpTimelineAccordionManyWhereInput>;
};


export type MutationDeleteManyCorpVideoHeroCarouselsArgs = {
  where?: InputMaybe<CorpVideoHeroCarouselManyWhereInput>;
};


export type MutationDeleteManyCorpVideoHeroCarouselsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpVideoHeroCarouselManyWhereInput>;
};


export type MutationDeleteManyCorpVideoHerosArgs = {
  where?: InputMaybe<CorpVideoHeroManyWhereInput>;
};


export type MutationDeleteManyCorpVideoHerosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpVideoHeroManyWhereInput>;
};


export type MutationDeleteManyCountrySelectorItemsArgs = {
  where?: InputMaybe<CountrySelectorItemManyWhereInput>;
};


export type MutationDeleteManyCountrySelectorItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountrySelectorItemManyWhereInput>;
};


export type MutationDeleteManyCountrySelectorsArgs = {
  where?: InputMaybe<CountrySelectorManyWhereInput>;
};


export type MutationDeleteManyCountrySelectorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountrySelectorManyWhereInput>;
};


export type MutationDeleteManyDeprecatedBanner1sArgs = {
  where?: InputMaybe<DeprecatedBanner1ManyWhereInput>;
};


export type MutationDeleteManyDeprecatedBanner1sConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeprecatedBanner1ManyWhereInput>;
};


export type MutationDeleteManyDeprecatedCorpNavigationsArgs = {
  where?: InputMaybe<DeprecatedCorpNavigationCopyManyWhereInput>;
};


export type MutationDeleteManyDeprecatedCorpNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeprecatedCorpNavigationCopyManyWhereInput>;
};


export type MutationDeleteManyDictionariesArgs = {
  where?: InputMaybe<DictionaryManyWhereInput>;
};


export type MutationDeleteManyDictionariesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DictionaryManyWhereInput>;
};


export type MutationDeleteManyDictionaryItemsArgs = {
  where?: InputMaybe<DictionaryItemManyWhereInput>;
};


export type MutationDeleteManyDictionaryItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DictionaryItemManyWhereInput>;
};


export type MutationDeleteManyDynamicCardGridsArgs = {
  where?: InputMaybe<DynamicCardGridManyWhereInput>;
};


export type MutationDeleteManyDynamicCardGridsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DynamicCardGridManyWhereInput>;
};


export type MutationDeleteManyEvalancheFormComponentsArgs = {
  where?: InputMaybe<EvalancheFormComponentManyWhereInput>;
};


export type MutationDeleteManyEvalancheFormComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EvalancheFormComponentManyWhereInput>;
};


export type MutationDeleteManyExampleComponentsArgs = {
  where?: InputMaybe<ExampleComponentManyWhereInput>;
};


export type MutationDeleteManyExampleComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ExampleComponentManyWhereInput>;
};


export type MutationDeleteManyFeaturedContentReferencesArgs = {
  where?: InputMaybe<FeaturedContentReferenceManyWhereInput>;
};


export type MutationDeleteManyFeaturedContentReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FeaturedContentReferenceManyWhereInput>;
};


export type MutationDeleteManyFeaturedContentsArgs = {
  where?: InputMaybe<FeaturedContentManyWhereInput>;
};


export type MutationDeleteManyFeaturedContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FeaturedContentManyWhereInput>;
};


export type MutationDeleteManyFooterNavigationsArgs = {
  where?: InputMaybe<FooterNavigationManyWhereInput>;
};


export type MutationDeleteManyFooterNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FooterNavigationManyWhereInput>;
};


export type MutationDeleteManyFormCheckboxesArgs = {
  where?: InputMaybe<FormCheckboxManyWhereInput>;
};


export type MutationDeleteManyFormCheckboxesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormCheckboxManyWhereInput>;
};


export type MutationDeleteManyFormEmailInputsArgs = {
  where?: InputMaybe<FormEmailInputManyWhereInput>;
};


export type MutationDeleteManyFormEmailInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormEmailInputManyWhereInput>;
};


export type MutationDeleteManyFormErrorsArgs = {
  where?: InputMaybe<FormErrorManyWhereInput>;
};


export type MutationDeleteManyFormErrorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormErrorManyWhereInput>;
};


export type MutationDeleteManyFormPasswordInputWithConfirmationsArgs = {
  where?: InputMaybe<FormPasswordInputWithConfirmationManyWhereInput>;
};


export type MutationDeleteManyFormPasswordInputWithConfirmationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormPasswordInputWithConfirmationManyWhereInput>;
};


export type MutationDeleteManyFormPasswordInputsArgs = {
  where?: InputMaybe<FormPasswordInputManyWhereInput>;
};


export type MutationDeleteManyFormPasswordInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormPasswordInputManyWhereInput>;
};


export type MutationDeleteManyFormRadioButtonCollectionsArgs = {
  where?: InputMaybe<FormRadioButtonCollectionManyWhereInput>;
};


export type MutationDeleteManyFormRadioButtonCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormRadioButtonCollectionManyWhereInput>;
};


export type MutationDeleteManyFormRadioButtonsArgs = {
  where?: InputMaybe<FormRadioButtonManyWhereInput>;
};


export type MutationDeleteManyFormRadioButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormRadioButtonManyWhereInput>;
};


export type MutationDeleteManyFormSelectComponentsArgs = {
  where?: InputMaybe<FormSelectComponentManyWhereInput>;
};


export type MutationDeleteManyFormSelectComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSelectComponentManyWhereInput>;
};


export type MutationDeleteManyFormSelectOptionsArgs = {
  where?: InputMaybe<FormSelectOptionManyWhereInput>;
};


export type MutationDeleteManyFormSelectOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSelectOptionManyWhereInput>;
};


export type MutationDeleteManyFormSubmitButtonsArgs = {
  where?: InputMaybe<FormSubmitButtonManyWhereInput>;
};


export type MutationDeleteManyFormSubmitButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSubmitButtonManyWhereInput>;
};


export type MutationDeleteManyFormSuccessComponentsArgs = {
  where?: InputMaybe<FormSuccessComponentManyWhereInput>;
};


export type MutationDeleteManyFormSuccessComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSuccessComponentManyWhereInput>;
};


export type MutationDeleteManyFormTextInputsArgs = {
  where?: InputMaybe<FormTextInputManyWhereInput>;
};


export type MutationDeleteManyFormTextInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormTextInputManyWhereInput>;
};


export type MutationDeleteManyFormTextareaInputsArgs = {
  where?: InputMaybe<FormTextareaInputManyWhereInput>;
};


export type MutationDeleteManyFormTextareaInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormTextareaInputManyWhereInput>;
};


export type MutationDeleteManyFormsArgs = {
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationDeleteManyFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationDeleteManyGenericAccordionItemsArgs = {
  where?: InputMaybe<GenericAccordionItemManyWhereInput>;
};


export type MutationDeleteManyGenericAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionItemManyWhereInput>;
};


export type MutationDeleteManyGenericAccordionTopRatedsArgs = {
  where?: InputMaybe<GenericAccordionTopRatedManyWhereInput>;
};


export type MutationDeleteManyGenericAccordionTopRatedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionTopRatedManyWhereInput>;
};


export type MutationDeleteManyGenericAccordionsArgs = {
  where?: InputMaybe<GenericAccordionManyWhereInput>;
};


export type MutationDeleteManyGenericAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionManyWhereInput>;
};


export type MutationDeleteManyGenericCardCarouseComponentsArgs = {
  where?: InputMaybe<GenericCardCarouseComponentManyWhereInput>;
};


export type MutationDeleteManyGenericCardCarouseComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericCardCarouseComponentManyWhereInput>;
};


export type MutationDeleteManyGenericDownloadComponentsArgs = {
  where?: InputMaybe<GenericDownloadComponentManyWhereInput>;
};


export type MutationDeleteManyGenericDownloadComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericDownloadComponentManyWhereInput>;
};


export type MutationDeleteManyGenericFollowUsesArgs = {
  where?: InputMaybe<GenericFollowUsManyWhereInput>;
};


export type MutationDeleteManyGenericFollowUsesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericFollowUsManyWhereInput>;
};


export type MutationDeleteManyGenericGridAuthorablesArgs = {
  where?: InputMaybe<GenericGridAuthorableManyWhereInput>;
};


export type MutationDeleteManyGenericGridAuthorablesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericGridAuthorableManyWhereInput>;
};


export type MutationDeleteManyGenericLinesArgs = {
  where?: InputMaybe<GenericLineManyWhereInput>;
};


export type MutationDeleteManyGenericLinesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericLineManyWhereInput>;
};


export type MutationDeleteManyGenericLinksArgs = {
  where?: InputMaybe<GenericLinkManyWhereInput>;
};


export type MutationDeleteManyGenericLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericLinkManyWhereInput>;
};


export type MutationDeleteManyGenericPagesArgs = {
  where?: InputMaybe<GenericPageManyWhereInput>;
};


export type MutationDeleteManyGenericPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageManyWhereInput>;
};


export type MutationDeleteManyGlobalMetaDatasArgs = {
  where?: InputMaybe<GlobalMetaDataManyWhereInput>;
};


export type MutationDeleteManyGlobalMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GlobalMetaDataManyWhereInput>;
};


export type MutationDeleteManyHeroBannersArgs = {
  where?: InputMaybe<HeroBannerManyWhereInput>;
};


export type MutationDeleteManyHeroBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroBannerManyWhereInput>;
};


export type MutationDeleteManyHeroCarouselComponentsArgs = {
  where?: InputMaybe<HeroCarouselComponentManyWhereInput>;
};


export type MutationDeleteManyHeroCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroCarouselComponentManyWhereInput>;
};


export type MutationDeleteManyHeroComponentsArgs = {
  where?: InputMaybe<HeroComponentManyWhereInput>;
};


export type MutationDeleteManyHeroComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroComponentManyWhereInput>;
};


export type MutationDeleteManyHomePagesArgs = {
  where?: InputMaybe<HomePageManyWhereInput>;
};


export type MutationDeleteManyHomePagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HomePageManyWhereInput>;
};


export type MutationDeleteManyIframesArgs = {
  where?: InputMaybe<IframeManyWhereInput>;
};


export type MutationDeleteManyIframesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IframeManyWhereInput>;
};


export type MutationDeleteManyImageAndTextCardsArgs = {
  where?: InputMaybe<ImageAndTextCardManyWhereInput>;
};


export type MutationDeleteManyImageAndTextCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageAndTextCardManyWhereInput>;
};


export type MutationDeleteManyImageCopiesArgs = {
  where?: InputMaybe<ImageCopyManyWhereInput>;
};


export type MutationDeleteManyImageCopiesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageCopyManyWhereInput>;
};


export type MutationDeleteManyImageCopyItemsArgs = {
  where?: InputMaybe<ImageCopyItemManyWhereInput>;
};


export type MutationDeleteManyImageCopyItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageCopyItemManyWhereInput>;
};


export type MutationDeleteManyIntroTextsArgs = {
  where?: InputMaybe<IntroTextManyWhereInput>;
};


export type MutationDeleteManyIntroTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IntroTextManyWhereInput>;
};


export type MutationDeleteManyLeftColumnsArgs = {
  where?: InputMaybe<LeftColumnManyWhereInput>;
};


export type MutationDeleteManyLeftColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LeftColumnManyWhereInput>;
};


export type MutationDeleteManyLinksArgs = {
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationDeleteManyLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationDeleteManyLocationComponentsArgs = {
  where?: InputMaybe<LocationComponentManyWhereInput>;
};


export type MutationDeleteManyLocationComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LocationComponentManyWhereInput>;
};


export type MutationDeleteManyLocationItemsArgs = {
  where?: InputMaybe<LocationItemManyWhereInput>;
};


export type MutationDeleteManyLocationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LocationItemManyWhereInput>;
};


export type MutationDeleteManyLongTextsArgs = {
  where?: InputMaybe<LongTextManyWhereInput>;
};


export type MutationDeleteManyLongTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LongTextManyWhereInput>;
};


export type MutationDeleteManyMediaLibrariesArgs = {
  where?: InputMaybe<MediaLibraryManyWhereInput>;
};


export type MutationDeleteManyMediaLibrariesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MediaLibraryManyWhereInput>;
};


export type MutationDeleteManyMediaLibraryItemsArgs = {
  where?: InputMaybe<MediaLibraryItemManyWhereInput>;
};


export type MutationDeleteManyMediaLibraryItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MediaLibraryItemManyWhereInput>;
};


export type MutationDeleteManyMetaDatasArgs = {
  where?: InputMaybe<MetaDataManyWhereInput>;
};


export type MutationDeleteManyMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetaDataManyWhereInput>;
};


export type MutationDeleteManyMobileOnlyMainNavigationsArgs = {
  where?: InputMaybe<MobileOnlyMainNavigationManyWhereInput>;
};


export type MutationDeleteManyMobileOnlyMainNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MobileOnlyMainNavigationManyWhereInput>;
};


export type MutationDeleteManyNavigationItemsArgs = {
  where?: InputMaybe<NavigationItemManyWhereInput>;
};


export type MutationDeleteManyNavigationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationItemManyWhereInput>;
};


export type MutationDeleteManyNavigationsArgs = {
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationDeleteManyNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationDeleteManyNotificationBannersArgs = {
  where?: InputMaybe<NotificationBannerManyWhereInput>;
};


export type MutationDeleteManyNotificationBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationBannerManyWhereInput>;
};


export type MutationDeleteManyPageFootersArgs = {
  where?: InputMaybe<PageFooterManyWhereInput>;
};


export type MutationDeleteManyPageFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageFooterManyWhereInput>;
};


export type MutationDeleteManyPageHeadersArgs = {
  where?: InputMaybe<PageHeaderManyWhereInput>;
};


export type MutationDeleteManyPageHeadersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageHeaderManyWhereInput>;
};


export type MutationDeleteManyPopularSearchComponentsArgs = {
  where?: InputMaybe<PopularSearchComponentManyWhereInput>;
};


export type MutationDeleteManyPopularSearchComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PopularSearchComponentManyWhereInput>;
};


export type MutationDeleteManyPressReleasesArgs = {
  where?: InputMaybe<PressReleaseManyWhereInput>;
};


export type MutationDeleteManyPressReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PressReleaseManyWhereInput>;
};


export type MutationDeleteManyPressStoriesCardsArgs = {
  where?: InputMaybe<PressStoriesCardManyWhereInput>;
};


export type MutationDeleteManyPressStoriesCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PressStoriesCardManyWhereInput>;
};


export type MutationDeleteManyProgressBarsArgs = {
  where?: InputMaybe<ProgressBarManyWhereInput>;
};


export type MutationDeleteManyProgressBarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProgressBarManyWhereInput>;
};


export type MutationDeleteManyQuickLinkItemsArgs = {
  where?: InputMaybe<QuickLinkItemManyWhereInput>;
};


export type MutationDeleteManyQuickLinkItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuickLinkItemManyWhereInput>;
};


export type MutationDeleteManyQuickLinksArgs = {
  where?: InputMaybe<QuickLinkManyWhereInput>;
};


export type MutationDeleteManyQuickLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuickLinkManyWhereInput>;
};


export type MutationDeleteManyRedirectsArgs = {
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationDeleteManyRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationDeleteManyRewritesArgs = {
  where?: InputMaybe<RewriteManyWhereInput>;
};


export type MutationDeleteManyRewritesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RewriteManyWhereInput>;
};


export type MutationDeleteManyRightColumnsArgs = {
  where?: InputMaybe<RightColumnManyWhereInput>;
};


export type MutationDeleteManyRightColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RightColumnManyWhereInput>;
};


export type MutationDeleteManySearchInputsArgs = {
  where?: InputMaybe<SearchInputManyWhereInput>;
};


export type MutationDeleteManySearchInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SearchInputManyWhereInput>;
};


export type MutationDeleteManySearchOverlayComponentsArgs = {
  where?: InputMaybe<SearchOverlayComponentManyWhereInput>;
};


export type MutationDeleteManySearchOverlayComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SearchOverlayComponentManyWhereInput>;
};


export type MutationDeleteManySearchResultPagesArgs = {
  where?: InputMaybe<SearchResultPageManyWhereInput>;
};


export type MutationDeleteManySearchResultPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SearchResultPageManyWhereInput>;
};


export type MutationDeleteManyShortHeroesArgs = {
  where?: InputMaybe<ShortHeroManyWhereInput>;
};


export type MutationDeleteManyShortHeroesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ShortHeroManyWhereInput>;
};


export type MutationDeleteManySocialMediaListComponentsArgs = {
  where?: InputMaybe<SocialMediaListComponentManyWhereInput>;
};


export type MutationDeleteManySocialMediaListComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SocialMediaListComponentManyWhereInput>;
};


export type MutationDeleteManySpacersArgs = {
  where?: InputMaybe<SpacerManyWhereInput>;
};


export type MutationDeleteManySpacersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpacerManyWhereInput>;
};


export type MutationDeleteManyStoriesArgs = {
  where?: InputMaybe<StoryManyWhereInput>;
};


export type MutationDeleteManyStoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryManyWhereInput>;
};


export type MutationDeleteManySubCategoryKeyImagesArgs = {
  where?: InputMaybe<SubCategoryKeyImageManyWhereInput>;
};


export type MutationDeleteManySubCategoryKeyImagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubCategoryKeyImageManyWhereInput>;
};


export type MutationDeleteManySustainabilityBannersArgs = {
  where?: InputMaybe<SustainabilityBannerManyWhereInput>;
};


export type MutationDeleteManySustainabilityBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SustainabilityBannerManyWhereInput>;
};


export type MutationDeleteManySustainabilityInfosArgs = {
  where?: InputMaybe<SustainabilityInfoManyWhereInput>;
};


export type MutationDeleteManySustainabilityInfosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SustainabilityInfoManyWhereInput>;
};


export type MutationDeleteManyTabContentsArgs = {
  where?: InputMaybe<TabContentManyWhereInput>;
};


export type MutationDeleteManyTabContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabContentManyWhereInput>;
};


export type MutationDeleteManyTabsArgs = {
  where?: InputMaybe<TabManyWhereInput>;
};


export type MutationDeleteManyTabsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabManyWhereInput>;
};


export type MutationDeleteManyTestTipsANdTricksInAMarketsArgs = {
  where?: InputMaybe<TestTipsANdTricksInAMarketManyWhereInput>;
};


export type MutationDeleteManyTestTipsANdTricksInAMarketsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TestTipsANdTricksInAMarketManyWhereInput>;
};


export type MutationDeleteManyTextComponentsArgs = {
  where?: InputMaybe<TextComponentManyWhereInput>;
};


export type MutationDeleteManyTextComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TextComponentManyWhereInput>;
};


export type MutationDeleteManyTipsAndTricksDetailsPagesArgs = {
  where?: InputMaybe<TipsAndTricksDetailsPageManyWhereInput>;
};


export type MutationDeleteManyTipsAndTricksDetailsPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TipsAndTricksDetailsPageManyWhereInput>;
};


export type MutationDeleteManyTitlesArgs = {
  where?: InputMaybe<TitleManyWhereInput>;
};


export type MutationDeleteManyTitlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TitleManyWhereInput>;
};


export type MutationDeleteManyTwitterSeosArgs = {
  where?: InputMaybe<TwitterSeoManyWhereInput>;
};


export type MutationDeleteManyTwitterSeosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TwitterSeoManyWhereInput>;
};


export type MutationDeleteManyWidgetsArgs = {
  where?: InputMaybe<WidgetManyWhereInput>;
};


export type MutationDeleteManyWidgetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WidgetManyWhereInput>;
};


export type MutationDeleteMediaLibraryArgs = {
  where: MediaLibraryWhereUniqueInput;
};


export type MutationDeleteMediaLibraryItemArgs = {
  where: MediaLibraryItemWhereUniqueInput;
};


export type MutationDeleteMetaDataArgs = {
  where: MetaDataWhereUniqueInput;
};


export type MutationDeleteMobileOnlyMainNavigationArgs = {
  where: MobileOnlyMainNavigationWhereUniqueInput;
};


export type MutationDeleteNavigationArgs = {
  where: NavigationWhereUniqueInput;
};


export type MutationDeleteNavigationItemArgs = {
  where: NavigationItemWhereUniqueInput;
};


export type MutationDeleteNotificationBannerArgs = {
  where: NotificationBannerWhereUniqueInput;
};


export type MutationDeletePageFooterArgs = {
  where: PageFooterWhereUniqueInput;
};


export type MutationDeletePageHeaderArgs = {
  where: PageHeaderWhereUniqueInput;
};


export type MutationDeletePopularSearchComponentArgs = {
  where: PopularSearchComponentWhereUniqueInput;
};


export type MutationDeletePressReleaseArgs = {
  where: PressReleaseWhereUniqueInput;
};


export type MutationDeletePressStoriesCardArgs = {
  where: PressStoriesCardWhereUniqueInput;
};


export type MutationDeleteProgressBarArgs = {
  where: ProgressBarWhereUniqueInput;
};


export type MutationDeleteQuickLinkArgs = {
  where: QuickLinkWhereUniqueInput;
};


export type MutationDeleteQuickLinkItemArgs = {
  where: QuickLinkItemWhereUniqueInput;
};


export type MutationDeleteRedirectArgs = {
  where: RedirectWhereUniqueInput;
};


export type MutationDeleteRewriteArgs = {
  where: RewriteWhereUniqueInput;
};


export type MutationDeleteRightColumnArgs = {
  where: RightColumnWhereUniqueInput;
};


export type MutationDeleteScheduledOperationArgs = {
  where: ScheduledOperationWhereUniqueInput;
};


export type MutationDeleteScheduledReleaseArgs = {
  where: ScheduledReleaseWhereUniqueInput;
};


export type MutationDeleteSearchInputArgs = {
  where: SearchInputWhereUniqueInput;
};


export type MutationDeleteSearchOverlayComponentArgs = {
  where: SearchOverlayComponentWhereUniqueInput;
};


export type MutationDeleteSearchResultPageArgs = {
  where: SearchResultPageWhereUniqueInput;
};


export type MutationDeleteShortHeroArgs = {
  where: ShortHeroWhereUniqueInput;
};


export type MutationDeleteSocialMediaListComponentArgs = {
  where: SocialMediaListComponentWhereUniqueInput;
};


export type MutationDeleteSpacerArgs = {
  where: SpacerWhereUniqueInput;
};


export type MutationDeleteStoryArgs = {
  where: StoryWhereUniqueInput;
};


export type MutationDeleteSubCategoryKeyImageArgs = {
  where: SubCategoryKeyImageWhereUniqueInput;
};


export type MutationDeleteSustainabilityBannerArgs = {
  where: SustainabilityBannerWhereUniqueInput;
};


export type MutationDeleteSustainabilityInfoArgs = {
  where: SustainabilityInfoWhereUniqueInput;
};


export type MutationDeleteTabArgs = {
  where: TabWhereUniqueInput;
};


export type MutationDeleteTabContentArgs = {
  where: TabContentWhereUniqueInput;
};


export type MutationDeleteTestTipsANdTricksInAMarketArgs = {
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};


export type MutationDeleteTextComponentArgs = {
  where: TextComponentWhereUniqueInput;
};


export type MutationDeleteTipsAndTricksDetailsPageArgs = {
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};


export type MutationDeleteTitleArgs = {
  where: TitleWhereUniqueInput;
};


export type MutationDeleteTwitterSeoArgs = {
  where: TwitterSeoWhereUniqueInput;
};


export type MutationDeleteWidgetArgs = {
  where: WidgetWhereUniqueInput;
};


export type MutationPublishAccordionArgs = {
  to?: Array<Stage>;
  where: AccordionWhereUniqueInput;
};


export type MutationPublishAccordionItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: AccordionItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishAlexTestComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: AlexTestComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishAlgoliaExtensionArgs = {
  to?: Array<Stage>;
  where: AlgoliaExtensionWhereUniqueInput;
};


export type MutationPublishAnchorNavArgs = {
  to?: Array<Stage>;
  where: AnchorNavWhereUniqueInput;
};


export type MutationPublishAnchorNavigationArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: AnchorNavigationWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishAnchorNavigationListArgs = {
  to?: Array<Stage>;
  where: AnchorNavigationListWhereUniqueInput;
};


export type MutationPublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishAssetComponentArgs = {
  to?: Array<Stage>;
  where: AssetComponentWhereUniqueInput;
};


export type MutationPublishAudioComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: AudioComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishAuthorableContentCardArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: AuthorableContentCardWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishBanner2Args = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: Banner2WhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishBigNumberArgs = {
  to?: Array<Stage>;
  where: BigNumberWhereUniqueInput;
};


export type MutationPublishBigNumberItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: BigNumberItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCardComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CardComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCarouselComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CarouselComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCarouselSlideArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CarouselSlideWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCategoryCardArgs = {
  to?: Array<Stage>;
  where: CategoryCardWhereUniqueInput;
};


export type MutationPublishContactCardArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: ContactCardWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishContactCardContainerArgs = {
  to?: Array<Stage>;
  where: ContactCardContainerWhereUniqueInput;
};


export type MutationPublishCorpAddToCalendarArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpAddToCalendarWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpBanner1Args = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpBanner1WhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpCalendarEventArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpCalendarEventWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpCardCarouselArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpCardCarouselWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpContactCardArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpContactCardWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpContactCardContainerArgs = {
  to?: Array<Stage>;
  where: CorpContactCardContainerWhereUniqueInput;
};


export type MutationPublishCorpFormArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpFormWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpGenericAccordionArgs = {
  to?: Array<Stage>;
  where: CorpGenericAccordionWhereUniqueInput;
};


export type MutationPublishCorpGenericAccordionItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpGenericAccordionItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpGenericBannerArgs = {
  to?: Array<Stage>;
  where: CorpGenericBannerWhereUniqueInput;
};


export type MutationPublishCorpGenericContainerArgs = {
  to?: Array<Stage>;
  where: CorpGenericContainerWhereUniqueInput;
};


export type MutationPublishCorpGridColumnComponentArgs = {
  to?: Array<Stage>;
  where: CorpGridColumnComponentWhereUniqueInput;
};


export type MutationPublishCorpHeroArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpHeroWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpMediaDownloadPreviewArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpMediaDownloadPreviewWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpNavigationArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpNavigationWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpNavigationItemArgs = {
  to?: Array<Stage>;
  where: CorpNavigationItemWhereUniqueInput;
};


export type MutationPublishCorpNotificationBannerArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpNotificationBannerWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpOurPeopleArgs = {
  to?: Array<Stage>;
  where: CorpOurPeopleWhereUniqueInput;
};


export type MutationPublishCorpOurPeopleItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpOurPeopleItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpPressPageArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpPressPageWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpSocialMediaFooterArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpSocialMediaFooterWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpStoriesPageArgs = {
  to?: Array<Stage>;
  where: CorpStoriesPageWhereUniqueInput;
};


export type MutationPublishCorpStoryCarouselArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpStoryCarouselWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpTimelineAccordionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpTimelineAccordionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpTimelineAccordionItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpTimelineAccordionItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpTimelineAccordionWrapperArgs = {
  to?: Array<Stage>;
  where: CorpTimelineAccordionWrapperWhereUniqueInput;
};


export type MutationPublishCorpVideoHeroArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpVideoHeroWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCorpVideoHeroCarouselArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CorpVideoHeroCarouselWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCountrySelectorArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CountrySelectorWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishCountrySelectorItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: CountrySelectorItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishDeprecatedBanner1Args = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: DeprecatedBanner1WhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishDeprecatedCorpNavigationCopyArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: DeprecatedCorpNavigationCopyWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishDictionaryArgs = {
  to?: Array<Stage>;
  where: DictionaryWhereUniqueInput;
};


export type MutationPublishDictionaryItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: DictionaryItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishDynamicCardGridArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: DynamicCardGridWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishEvalancheFormComponentArgs = {
  to?: Array<Stage>;
  where: EvalancheFormComponentWhereUniqueInput;
};


export type MutationPublishExampleComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: ExampleComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishFeaturedContentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: FeaturedContentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishFeaturedContentReferenceArgs = {
  to?: Array<Stage>;
  where: FeaturedContentReferenceWhereUniqueInput;
};


export type MutationPublishFooterNavigationArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: FooterNavigationWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishFormArgs = {
  to?: Array<Stage>;
  where: FormWhereUniqueInput;
};


export type MutationPublishFormCheckboxArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: FormCheckboxWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishFormEmailInputArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: FormEmailInputWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishFormErrorArgs = {
  to?: Array<Stage>;
  where: FormErrorWhereUniqueInput;
};


export type MutationPublishFormPasswordInputArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: FormPasswordInputWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishFormPasswordInputWithConfirmationArgs = {
  to?: Array<Stage>;
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};


export type MutationPublishFormRadioButtonArgs = {
  to?: Array<Stage>;
  where: FormRadioButtonWhereUniqueInput;
};


export type MutationPublishFormRadioButtonCollectionArgs = {
  to?: Array<Stage>;
  where: FormRadioButtonCollectionWhereUniqueInput;
};


export type MutationPublishFormSelectComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: FormSelectComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishFormSelectOptionArgs = {
  to?: Array<Stage>;
  where: FormSelectOptionWhereUniqueInput;
};


export type MutationPublishFormSubmitButtonArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: FormSubmitButtonWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishFormSuccessComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: FormSuccessComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishFormTextInputArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: FormTextInputWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishFormTextareaInputArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: FormTextareaInputWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishGenericAccordionArgs = {
  to?: Array<Stage>;
  where: GenericAccordionWhereUniqueInput;
};


export type MutationPublishGenericAccordionItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: GenericAccordionItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishGenericAccordionTopRatedArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: GenericAccordionTopRatedWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishGenericCardCarouseComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: GenericCardCarouseComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishGenericDownloadComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: GenericDownloadComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishGenericFollowUsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: GenericFollowUsWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishGenericGridAuthorableArgs = {
  to?: Array<Stage>;
  where: GenericGridAuthorableWhereUniqueInput;
};


export type MutationPublishGenericLineArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: GenericLineWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishGenericLinkArgs = {
  to?: Array<Stage>;
  where: GenericLinkWhereUniqueInput;
};


export type MutationPublishGenericPageArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: GenericPageWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishGlobalMetaDataArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: GlobalMetaDataWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishHeroBannerArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: HeroBannerWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishHeroCarouselComponentArgs = {
  to?: Array<Stage>;
  where: HeroCarouselComponentWhereUniqueInput;
};


export type MutationPublishHeroComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: HeroComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishHomePageArgs = {
  to?: Array<Stage>;
  where: HomePageWhereUniqueInput;
};


export type MutationPublishIframeArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: IframeWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishImageAndTextCardArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: ImageAndTextCardWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishImageCopyArgs = {
  to?: Array<Stage>;
  where: ImageCopyWhereUniqueInput;
};


export type MutationPublishImageCopyItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: ImageCopyItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishIntroTextArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: IntroTextWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishLeftColumnArgs = {
  to?: Array<Stage>;
  where: LeftColumnWhereUniqueInput;
};


export type MutationPublishLinkArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: LinkWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishLocationComponentArgs = {
  to?: Array<Stage>;
  where: LocationComponentWhereUniqueInput;
};


export type MutationPublishLocationItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: LocationItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishLongTextArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: LongTextWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAccordionItemsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AccordionItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AccordionItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAccordionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AccordionManyWhereInput>;
};


export type MutationPublishManyAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AccordionManyWhereInput>;
};


export type MutationPublishManyAlexTestComponentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AlexTestComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAlexTestComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AlexTestComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAlgoliaExtensionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AlgoliaExtensionManyWhereInput>;
};


export type MutationPublishManyAlgoliaExtensionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AlgoliaExtensionManyWhereInput>;
};


export type MutationPublishManyAnchorNavigationListsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AnchorNavigationListManyWhereInput>;
};


export type MutationPublishManyAnchorNavigationListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AnchorNavigationListManyWhereInput>;
};


export type MutationPublishManyAnchorNavigationsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AnchorNavigationManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAnchorNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AnchorNavigationManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAnchorNavsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AnchorNavManyWhereInput>;
};


export type MutationPublishManyAnchorNavsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AnchorNavManyWhereInput>;
};


export type MutationPublishManyAssetsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAssetsComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<AssetComponentManyWhereInput>;
};


export type MutationPublishManyAssetsComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetComponentManyWhereInput>;
};


export type MutationPublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AssetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAudioComponentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AudioComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAudioComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AudioComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAuthorableContentCardsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AuthorableContentCardManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyAuthorableContentCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<AuthorableContentCardManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyBanner2SArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<Banner2ManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyBanner2SConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<Banner2ManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyBigNumberItemsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<BigNumberItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyBigNumberItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<BigNumberItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyBigNumbersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<BigNumberManyWhereInput>;
};


export type MutationPublishManyBigNumbersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<BigNumberManyWhereInput>;
};


export type MutationPublishManyCardComponentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CardComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCardComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CardComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCarouselComponentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CarouselComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CarouselComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCarouselSlidesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CarouselSlideManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCarouselSlidesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CarouselSlideManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCategoryCardsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CategoryCardManyWhereInput>;
};


export type MutationPublishManyCategoryCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CategoryCardManyWhereInput>;
};


export type MutationPublishManyContactCardContainersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ContactCardContainerManyWhereInput>;
};


export type MutationPublishManyContactCardContainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ContactCardContainerManyWhereInput>;
};


export type MutationPublishManyContactCardsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ContactCardManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyContactCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ContactCardManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpAddToCalendarsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpAddToCalendarManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpAddToCalendarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpAddToCalendarManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpBanners1Args = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpBanner1ManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpBanners1ConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpBanner1ManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpCalendarEventsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpCalendarEventManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpCalendarEventsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpCalendarEventManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpCardCarouselsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpCardCarouselManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpCardCarouselsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpCardCarouselManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpContactCardContainersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CorpContactCardContainerManyWhereInput>;
};


export type MutationPublishManyCorpContactCardContainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpContactCardContainerManyWhereInput>;
};


export type MutationPublishManyCorpContactCardsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpContactCardManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpContactCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpContactCardManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpFormsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpFormManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpFormManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpGenericAccordionItemsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpGenericAccordionItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpGenericAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpGenericAccordionItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpGenericAccordionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CorpGenericAccordionManyWhereInput>;
};


export type MutationPublishManyCorpGenericAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpGenericAccordionManyWhereInput>;
};


export type MutationPublishManyCorpGenericBannersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CorpGenericBannerManyWhereInput>;
};


export type MutationPublishManyCorpGenericBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpGenericBannerManyWhereInput>;
};


export type MutationPublishManyCorpGenericContainersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CorpGenericContainerManyWhereInput>;
};


export type MutationPublishManyCorpGenericContainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpGenericContainerManyWhereInput>;
};


export type MutationPublishManyCorpGridColumnComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CorpGridColumnComponentManyWhereInput>;
};


export type MutationPublishManyCorpGridColumnComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpGridColumnComponentManyWhereInput>;
};


export type MutationPublishManyCorpHerosArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpHeroManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpHerosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpHeroManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpMediaDownloadPreviewsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpMediaDownloadPreviewManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpMediaDownloadPreviewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpMediaDownloadPreviewManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpNavigationItemsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CorpNavigationItemManyWhereInput>;
};


export type MutationPublishManyCorpNavigationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpNavigationItemManyWhereInput>;
};


export type MutationPublishManyCorpNavigationsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpNavigationManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpNavigationManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpNotificationBannersArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpNotificationBannerManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpNotificationBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpNotificationBannerManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpOurPeopleItemsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpOurPeopleItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpOurPeopleItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpOurPeopleItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpOurPeoplesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CorpOurPeopleManyWhereInput>;
};


export type MutationPublishManyCorpOurPeoplesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpOurPeopleManyWhereInput>;
};


export type MutationPublishManyCorpPressPagesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpPressPageManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpPressPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpPressPageManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpSocialMediaFootersArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpSocialMediaFooterManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpSocialMediaFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpSocialMediaFooterManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpStoriesPagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CorpStoriesPageManyWhereInput>;
};


export type MutationPublishManyCorpStoriesPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpStoriesPageManyWhereInput>;
};


export type MutationPublishManyCorpStoryCarouselsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpStoryCarouselManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpStoryCarouselsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpStoryCarouselManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpTimelineAccordionItemsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpTimelineAccordionItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpTimelineAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpTimelineAccordionItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpTimelineAccordionWrappersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<CorpTimelineAccordionWrapperManyWhereInput>;
};


export type MutationPublishManyCorpTimelineAccordionWrappersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpTimelineAccordionWrapperManyWhereInput>;
};


export type MutationPublishManyCorpTimelineAccordionsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpTimelineAccordionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpTimelineAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpTimelineAccordionManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpVideoHeroCarouselsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpVideoHeroCarouselManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpVideoHeroCarouselsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpVideoHeroCarouselManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpVideoHerosArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpVideoHeroManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCorpVideoHerosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CorpVideoHeroManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCountrySelectorItemsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CountrySelectorItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCountrySelectorItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CountrySelectorItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCountrySelectorsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CountrySelectorManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyCountrySelectorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<CountrySelectorManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyDeprecatedBanner1sArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<DeprecatedBanner1ManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyDeprecatedBanner1sConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<DeprecatedBanner1ManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyDeprecatedCorpNavigationsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<DeprecatedCorpNavigationCopyManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyDeprecatedCorpNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<DeprecatedCorpNavigationCopyManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyDictionariesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<DictionaryManyWhereInput>;
};


export type MutationPublishManyDictionariesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<DictionaryManyWhereInput>;
};


export type MutationPublishManyDictionaryItemsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<DictionaryItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyDictionaryItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<DictionaryItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyDynamicCardGridsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<DynamicCardGridManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyDynamicCardGridsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<DynamicCardGridManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyEvalancheFormComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<EvalancheFormComponentManyWhereInput>;
};


export type MutationPublishManyEvalancheFormComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<EvalancheFormComponentManyWhereInput>;
};


export type MutationPublishManyExampleComponentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ExampleComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyExampleComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ExampleComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFeaturedContentReferencesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FeaturedContentReferenceManyWhereInput>;
};


export type MutationPublishManyFeaturedContentReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FeaturedContentReferenceManyWhereInput>;
};


export type MutationPublishManyFeaturedContentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FeaturedContentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFeaturedContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FeaturedContentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFooterNavigationsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FooterNavigationManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFooterNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FooterNavigationManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFormCheckboxesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormCheckboxManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFormCheckboxesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormCheckboxManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFormEmailInputsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormEmailInputManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFormEmailInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormEmailInputManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFormErrorsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormErrorManyWhereInput>;
};


export type MutationPublishManyFormErrorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormErrorManyWhereInput>;
};


export type MutationPublishManyFormPasswordInputWithConfirmationsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormPasswordInputWithConfirmationManyWhereInput>;
};


export type MutationPublishManyFormPasswordInputWithConfirmationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormPasswordInputWithConfirmationManyWhereInput>;
};


export type MutationPublishManyFormPasswordInputsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormPasswordInputManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFormPasswordInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormPasswordInputManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFormRadioButtonCollectionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormRadioButtonCollectionManyWhereInput>;
};


export type MutationPublishManyFormRadioButtonCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormRadioButtonCollectionManyWhereInput>;
};


export type MutationPublishManyFormRadioButtonsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormRadioButtonManyWhereInput>;
};


export type MutationPublishManyFormRadioButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormRadioButtonManyWhereInput>;
};


export type MutationPublishManyFormSelectComponentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormSelectComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFormSelectComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormSelectComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFormSelectOptionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormSelectOptionManyWhereInput>;
};


export type MutationPublishManyFormSelectOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormSelectOptionManyWhereInput>;
};


export type MutationPublishManyFormSubmitButtonsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormSubmitButtonManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFormSubmitButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormSubmitButtonManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFormSuccessComponentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormSuccessComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFormSuccessComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormSuccessComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFormTextInputsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormTextInputManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFormTextInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormTextInputManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFormTextareaInputsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormTextareaInputManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFormTextareaInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormTextareaInputManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyFormsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationPublishManyFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationPublishManyGenericAccordionItemsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericAccordionItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyGenericAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericAccordionItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyGenericAccordionTopRatedsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericAccordionTopRatedManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyGenericAccordionTopRatedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericAccordionTopRatedManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyGenericAccordionsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GenericAccordionManyWhereInput>;
};


export type MutationPublishManyGenericAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericAccordionManyWhereInput>;
};


export type MutationPublishManyGenericCardCarouseComponentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericCardCarouseComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyGenericCardCarouseComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericCardCarouseComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyGenericDownloadComponentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericDownloadComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyGenericDownloadComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericDownloadComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyGenericFollowUsesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericFollowUsManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyGenericFollowUsesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericFollowUsManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyGenericGridAuthorablesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GenericGridAuthorableManyWhereInput>;
};


export type MutationPublishManyGenericGridAuthorablesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericGridAuthorableManyWhereInput>;
};


export type MutationPublishManyGenericLinesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericLineManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyGenericLinesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericLineManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyGenericLinksArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<GenericLinkManyWhereInput>;
};


export type MutationPublishManyGenericLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericLinkManyWhereInput>;
};


export type MutationPublishManyGenericPagesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericPageManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyGenericPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GenericPageManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyGlobalMetaDatasArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GlobalMetaDataManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyGlobalMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<GlobalMetaDataManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyHeroBannersArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<HeroBannerManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyHeroBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<HeroBannerManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyHeroCarouselComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<HeroCarouselComponentManyWhereInput>;
};


export type MutationPublishManyHeroCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<HeroCarouselComponentManyWhereInput>;
};


export type MutationPublishManyHeroComponentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<HeroComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyHeroComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<HeroComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyHomePagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<HomePageManyWhereInput>;
};


export type MutationPublishManyHomePagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<HomePageManyWhereInput>;
};


export type MutationPublishManyIframesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<IframeManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyIframesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<IframeManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyImageAndTextCardsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ImageAndTextCardManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyImageAndTextCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ImageAndTextCardManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyImageCopiesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<ImageCopyManyWhereInput>;
};


export type MutationPublishManyImageCopiesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ImageCopyManyWhereInput>;
};


export type MutationPublishManyImageCopyItemsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ImageCopyItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyImageCopyItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ImageCopyItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyIntroTextsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<IntroTextManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyIntroTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<IntroTextManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyLeftColumnsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<LeftColumnManyWhereInput>;
};


export type MutationPublishManyLeftColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<LeftColumnManyWhereInput>;
};


export type MutationPublishManyLinksArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<LinkManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<LinkManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyLocationComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<LocationComponentManyWhereInput>;
};


export type MutationPublishManyLocationComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<LocationComponentManyWhereInput>;
};


export type MutationPublishManyLocationItemsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<LocationItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyLocationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<LocationItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyLongTextsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<LongTextManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyLongTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<LongTextManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyMediaLibrariesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<MediaLibraryManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyMediaLibrariesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<MediaLibraryManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyMediaLibraryItemsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<MediaLibraryItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyMediaLibraryItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<MediaLibraryItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyMetaDatasArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<MetaDataManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<MetaDataManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyMobileOnlyMainNavigationsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<MobileOnlyMainNavigationManyWhereInput>;
};


export type MutationPublishManyMobileOnlyMainNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<MobileOnlyMainNavigationManyWhereInput>;
};


export type MutationPublishManyNavigationItemsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<NavigationItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyNavigationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<NavigationItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyNavigationsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<NavigationManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<NavigationManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyNotificationBannersArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<NotificationBannerManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyNotificationBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<NotificationBannerManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyPageFootersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<PageFooterManyWhereInput>;
};


export type MutationPublishManyPageFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PageFooterManyWhereInput>;
};


export type MutationPublishManyPageHeadersArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PageHeaderManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyPageHeadersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PageHeaderManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyPopularSearchComponentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PopularSearchComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyPopularSearchComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PopularSearchComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyPressReleasesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PressReleaseManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyPressReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PressReleaseManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyPressStoriesCardsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PressStoriesCardManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyPressStoriesCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<PressStoriesCardManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyProgressBarsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ProgressBarManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyProgressBarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ProgressBarManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyQuickLinkItemsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<QuickLinkItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyQuickLinkItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<QuickLinkItemManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyQuickLinksArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<QuickLinkManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyQuickLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<QuickLinkManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyRedirectsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationPublishManyRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationPublishManyRewritesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RewriteManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyRewritesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RewriteManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyRightColumnsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<RightColumnManyWhereInput>;
};


export type MutationPublishManyRightColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<RightColumnManyWhereInput>;
};


export type MutationPublishManySearchInputsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SearchInputManyWhereInput>;
};


export type MutationPublishManySearchInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SearchInputManyWhereInput>;
};


export type MutationPublishManySearchOverlayComponentsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SearchOverlayComponentManyWhereInput>;
};


export type MutationPublishManySearchOverlayComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SearchOverlayComponentManyWhereInput>;
};


export type MutationPublishManySearchResultPagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SearchResultPageManyWhereInput>;
};


export type MutationPublishManySearchResultPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SearchResultPageManyWhereInput>;
};


export type MutationPublishManyShortHeroesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ShortHeroManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyShortHeroesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<ShortHeroManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManySocialMediaListComponentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SocialMediaListComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManySocialMediaListComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SocialMediaListComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManySpacersArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SpacerManyWhereInput>;
};


export type MutationPublishManySpacersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SpacerManyWhereInput>;
};


export type MutationPublishManyStoriesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<StoryManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyStoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<StoryManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManySubCategoryKeyImagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<SubCategoryKeyImageManyWhereInput>;
};


export type MutationPublishManySubCategoryKeyImagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SubCategoryKeyImageManyWhereInput>;
};


export type MutationPublishManySustainabilityBannersArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SustainabilityBannerManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManySustainabilityBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SustainabilityBannerManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManySustainabilityInfosArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SustainabilityInfoManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManySustainabilityInfosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<SustainabilityInfoManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyTabContentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TabContentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyTabContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TabContentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyTabsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TabManyWhereInput>;
};


export type MutationPublishManyTabsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TabManyWhereInput>;
};


export type MutationPublishManyTestTipsANdTricksInAMarketsArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TestTipsANdTricksInAMarketManyWhereInput>;
};


export type MutationPublishManyTestTipsANdTricksInAMarketsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TestTipsANdTricksInAMarketManyWhereInput>;
};


export type MutationPublishManyTextComponentsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TextComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyTextComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TextComponentManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyTipsAndTricksDetailsPagesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TipsAndTricksDetailsPageManyWhereInput>;
};


export type MutationPublishManyTipsAndTricksDetailsPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TipsAndTricksDetailsPageManyWhereInput>;
};


export type MutationPublishManyTitlesArgs = {
  to?: Array<Stage>;
  where?: InputMaybe<TitleManyWhereInput>;
};


export type MutationPublishManyTitlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TitleManyWhereInput>;
};


export type MutationPublishManyTwitterSeosArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TwitterSeoManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyTwitterSeosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<TwitterSeoManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyWidgetsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<WidgetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishManyWidgetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  to?: Array<Stage>;
  where?: InputMaybe<WidgetManyWhereInput>;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishMediaLibraryArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: MediaLibraryWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishMediaLibraryItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: MediaLibraryItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishMetaDataArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: MetaDataWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishMobileOnlyMainNavigationArgs = {
  to?: Array<Stage>;
  where: MobileOnlyMainNavigationWhereUniqueInput;
};


export type MutationPublishNavigationArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: NavigationWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishNavigationItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: NavigationItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishNotificationBannerArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: NotificationBannerWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishPageFooterArgs = {
  to?: Array<Stage>;
  where: PageFooterWhereUniqueInput;
};


export type MutationPublishPageHeaderArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: PageHeaderWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishPopularSearchComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: PopularSearchComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishPressReleaseArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: PressReleaseWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishPressStoriesCardArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: PressStoriesCardWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishProgressBarArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: ProgressBarWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishQuickLinkArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: QuickLinkWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishQuickLinkItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: QuickLinkItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishRedirectArgs = {
  to?: Array<Stage>;
  where: RedirectWhereUniqueInput;
};


export type MutationPublishRewriteArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: RewriteWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishRightColumnArgs = {
  to?: Array<Stage>;
  where: RightColumnWhereUniqueInput;
};


export type MutationPublishSearchInputArgs = {
  to?: Array<Stage>;
  where: SearchInputWhereUniqueInput;
};


export type MutationPublishSearchOverlayComponentArgs = {
  to?: Array<Stage>;
  where: SearchOverlayComponentWhereUniqueInput;
};


export type MutationPublishSearchResultPageArgs = {
  to?: Array<Stage>;
  where: SearchResultPageWhereUniqueInput;
};


export type MutationPublishShortHeroArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: ShortHeroWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishSocialMediaListComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: SocialMediaListComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishSpacerArgs = {
  to?: Array<Stage>;
  where: SpacerWhereUniqueInput;
};


export type MutationPublishStoryArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: StoryWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishSubCategoryKeyImageArgs = {
  to?: Array<Stage>;
  where: SubCategoryKeyImageWhereUniqueInput;
};


export type MutationPublishSustainabilityBannerArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: SustainabilityBannerWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishSustainabilityInfoArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: SustainabilityInfoWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishTabArgs = {
  to?: Array<Stage>;
  where: TabWhereUniqueInput;
};


export type MutationPublishTabContentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: TabContentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishTestTipsANdTricksInAMarketArgs = {
  to?: Array<Stage>;
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};


export type MutationPublishTextComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: TextComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishTipsAndTricksDetailsPageArgs = {
  to?: Array<Stage>;
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};


export type MutationPublishTitleArgs = {
  to?: Array<Stage>;
  where: TitleWhereUniqueInput;
};


export type MutationPublishTwitterSeoArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: TwitterSeoWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPublishWidgetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  to?: Array<Stage>;
  where: WidgetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishAccordionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AccordionWhereUniqueInput;
};


export type MutationSchedulePublishAccordionItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AccordionItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishAlexTestComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AlexTestComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishAlgoliaExtensionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AlgoliaExtensionWhereUniqueInput;
};


export type MutationSchedulePublishAnchorNavArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AnchorNavWhereUniqueInput;
};


export type MutationSchedulePublishAnchorNavigationArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AnchorNavigationWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishAnchorNavigationListArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AnchorNavigationListWhereUniqueInput;
};


export type MutationSchedulePublishAssetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AssetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishAssetComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AssetComponentWhereUniqueInput;
};


export type MutationSchedulePublishAudioComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AudioComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishAuthorableContentCardArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: AuthorableContentCardWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishBanner2Args = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: Banner2WhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishBigNumberArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: BigNumberWhereUniqueInput;
};


export type MutationSchedulePublishBigNumberItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: BigNumberItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCardComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CardComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCarouselComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CarouselComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCarouselSlideArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CarouselSlideWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCategoryCardArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CategoryCardWhereUniqueInput;
};


export type MutationSchedulePublishContactCardArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ContactCardWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishContactCardContainerArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ContactCardContainerWhereUniqueInput;
};


export type MutationSchedulePublishCorpAddToCalendarArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpAddToCalendarWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpBanner1Args = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpBanner1WhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpCalendarEventArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpCalendarEventWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpCardCarouselArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpCardCarouselWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpContactCardArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpContactCardWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpContactCardContainerArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpContactCardContainerWhereUniqueInput;
};


export type MutationSchedulePublishCorpFormArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpFormWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpGenericAccordionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpGenericAccordionWhereUniqueInput;
};


export type MutationSchedulePublishCorpGenericAccordionItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpGenericAccordionItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpGenericBannerArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpGenericBannerWhereUniqueInput;
};


export type MutationSchedulePublishCorpGenericContainerArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpGenericContainerWhereUniqueInput;
};


export type MutationSchedulePublishCorpGridColumnComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpGridColumnComponentWhereUniqueInput;
};


export type MutationSchedulePublishCorpHeroArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpHeroWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpMediaDownloadPreviewArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpMediaDownloadPreviewWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpNavigationArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpNavigationWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpNavigationItemArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpNavigationItemWhereUniqueInput;
};


export type MutationSchedulePublishCorpNotificationBannerArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpNotificationBannerWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpOurPeopleArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpOurPeopleWhereUniqueInput;
};


export type MutationSchedulePublishCorpOurPeopleItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpOurPeopleItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpPressPageArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpPressPageWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpSocialMediaFooterArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpSocialMediaFooterWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpStoriesPageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpStoriesPageWhereUniqueInput;
};


export type MutationSchedulePublishCorpStoryCarouselArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpStoryCarouselWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpTimelineAccordionArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpTimelineAccordionWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpTimelineAccordionItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpTimelineAccordionItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpTimelineAccordionWrapperArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpTimelineAccordionWrapperWhereUniqueInput;
};


export type MutationSchedulePublishCorpVideoHeroArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpVideoHeroWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCorpVideoHeroCarouselArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CorpVideoHeroCarouselWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCountrySelectorArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CountrySelectorWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishCountrySelectorItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: CountrySelectorItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishDeprecatedBanner1Args = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: DeprecatedBanner1WhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishDeprecatedCorpNavigationCopyArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: DeprecatedCorpNavigationCopyWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishDictionaryArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: DictionaryWhereUniqueInput;
};


export type MutationSchedulePublishDictionaryItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: DictionaryItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishDynamicCardGridArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: DynamicCardGridWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishEvalancheFormComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: EvalancheFormComponentWhereUniqueInput;
};


export type MutationSchedulePublishExampleComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ExampleComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishFeaturedContentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FeaturedContentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishFeaturedContentReferenceArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FeaturedContentReferenceWhereUniqueInput;
};


export type MutationSchedulePublishFooterNavigationArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FooterNavigationWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishFormArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormWhereUniqueInput;
};


export type MutationSchedulePublishFormCheckboxArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormCheckboxWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishFormEmailInputArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormEmailInputWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishFormErrorArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormErrorWhereUniqueInput;
};


export type MutationSchedulePublishFormPasswordInputArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormPasswordInputWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishFormPasswordInputWithConfirmationArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};


export type MutationSchedulePublishFormRadioButtonArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormRadioButtonWhereUniqueInput;
};


export type MutationSchedulePublishFormRadioButtonCollectionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormRadioButtonCollectionWhereUniqueInput;
};


export type MutationSchedulePublishFormSelectComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormSelectComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishFormSelectOptionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormSelectOptionWhereUniqueInput;
};


export type MutationSchedulePublishFormSubmitButtonArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormSubmitButtonWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishFormSuccessComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormSuccessComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishFormTextInputArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormTextInputWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishFormTextareaInputArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: FormTextareaInputWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishGenericAccordionArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericAccordionWhereUniqueInput;
};


export type MutationSchedulePublishGenericAccordionItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericAccordionItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishGenericAccordionTopRatedArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericAccordionTopRatedWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishGenericCardCarouseComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericCardCarouseComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishGenericDownloadComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericDownloadComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishGenericFollowUsArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericFollowUsWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishGenericGridAuthorableArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericGridAuthorableWhereUniqueInput;
};


export type MutationSchedulePublishGenericLineArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericLineWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishGenericLinkArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericLinkWhereUniqueInput;
};


export type MutationSchedulePublishGenericPageArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GenericPageWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishGlobalMetaDataArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: GlobalMetaDataWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishHeroBannerArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: HeroBannerWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishHeroCarouselComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: HeroCarouselComponentWhereUniqueInput;
};


export type MutationSchedulePublishHeroComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: HeroComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishHomePageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: HomePageWhereUniqueInput;
};


export type MutationSchedulePublishIframeArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: IframeWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishImageAndTextCardArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ImageAndTextCardWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishImageCopyArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ImageCopyWhereUniqueInput;
};


export type MutationSchedulePublishImageCopyItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ImageCopyItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishIntroTextArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: IntroTextWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishLeftColumnArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: LeftColumnWhereUniqueInput;
};


export type MutationSchedulePublishLinkArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: LinkWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishLocationComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: LocationComponentWhereUniqueInput;
};


export type MutationSchedulePublishLocationItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: LocationItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishLongTextArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: LongTextWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishMediaLibraryArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: MediaLibraryWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishMediaLibraryItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: MediaLibraryItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishMetaDataArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: MetaDataWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishMobileOnlyMainNavigationArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: MobileOnlyMainNavigationWhereUniqueInput;
};


export type MutationSchedulePublishNavigationArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: NavigationWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishNavigationItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: NavigationItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishNotificationBannerArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: NotificationBannerWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishPageFooterArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: PageFooterWhereUniqueInput;
};


export type MutationSchedulePublishPageHeaderArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: PageHeaderWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishPopularSearchComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: PopularSearchComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishPressReleaseArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: PressReleaseWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishPressStoriesCardArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: PressStoriesCardWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishProgressBarArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ProgressBarWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishQuickLinkArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: QuickLinkWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishQuickLinkItemArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: QuickLinkItemWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishRedirectArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: RedirectWhereUniqueInput;
};


export type MutationSchedulePublishRewriteArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: RewriteWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishRightColumnArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: RightColumnWhereUniqueInput;
};


export type MutationSchedulePublishSearchInputArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SearchInputWhereUniqueInput;
};


export type MutationSchedulePublishSearchOverlayComponentArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SearchOverlayComponentWhereUniqueInput;
};


export type MutationSchedulePublishSearchResultPageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SearchResultPageWhereUniqueInput;
};


export type MutationSchedulePublishShortHeroArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: ShortHeroWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishSocialMediaListComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SocialMediaListComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishSpacerArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SpacerWhereUniqueInput;
};


export type MutationSchedulePublishStoryArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: StoryWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishSubCategoryKeyImageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SubCategoryKeyImageWhereUniqueInput;
};


export type MutationSchedulePublishSustainabilityBannerArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SustainabilityBannerWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishSustainabilityInfoArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: SustainabilityInfoWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishTabArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TabWhereUniqueInput;
};


export type MutationSchedulePublishTabContentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TabContentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishTestTipsANdTricksInAMarketArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};


export type MutationSchedulePublishTextComponentArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TextComponentWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishTipsAndTricksDetailsPageArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};


export type MutationSchedulePublishTitleArgs = {
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TitleWhereUniqueInput;
};


export type MutationSchedulePublishTwitterSeoArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: TwitterSeoWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSchedulePublishWidgetArgs = {
  locales?: InputMaybe<Array<Locale>>;
  publishBase?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  to?: Array<Stage>;
  where: WidgetWhereUniqueInput;
  withDefaultLocale?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationScheduleUnpublishAccordionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: AccordionWhereUniqueInput;
};


export type MutationScheduleUnpublishAccordionItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AccordionItemWhereUniqueInput;
};


export type MutationScheduleUnpublishAlexTestComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AlexTestComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishAlgoliaExtensionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: AlgoliaExtensionWhereUniqueInput;
};


export type MutationScheduleUnpublishAnchorNavArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: AnchorNavWhereUniqueInput;
};


export type MutationScheduleUnpublishAnchorNavigationArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AnchorNavigationWhereUniqueInput;
};


export type MutationScheduleUnpublishAnchorNavigationListArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: AnchorNavigationListWhereUniqueInput;
};


export type MutationScheduleUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AssetWhereUniqueInput;
};


export type MutationScheduleUnpublishAssetComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: AssetComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishAudioComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AudioComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishAuthorableContentCardArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AuthorableContentCardWhereUniqueInput;
};


export type MutationScheduleUnpublishBanner2Args = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: Banner2WhereUniqueInput;
};


export type MutationScheduleUnpublishBigNumberArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: BigNumberWhereUniqueInput;
};


export type MutationScheduleUnpublishBigNumberItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: BigNumberItemWhereUniqueInput;
};


export type MutationScheduleUnpublishCardComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CardComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishCarouselComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CarouselComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishCarouselSlideArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CarouselSlideWhereUniqueInput;
};


export type MutationScheduleUnpublishCategoryCardArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CategoryCardWhereUniqueInput;
};


export type MutationScheduleUnpublishContactCardArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: ContactCardWhereUniqueInput;
};


export type MutationScheduleUnpublishContactCardContainerArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ContactCardContainerWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpAddToCalendarArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpAddToCalendarWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpBanner1Args = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpBanner1WhereUniqueInput;
};


export type MutationScheduleUnpublishCorpCalendarEventArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpCalendarEventWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpCardCarouselArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpCardCarouselWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpContactCardArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpContactCardWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpContactCardContainerArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CorpContactCardContainerWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpFormArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpFormWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpGenericAccordionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CorpGenericAccordionWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpGenericAccordionItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpGenericAccordionItemWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpGenericBannerArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CorpGenericBannerWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpGenericContainerArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CorpGenericContainerWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpGridColumnComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CorpGridColumnComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpHeroArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpHeroWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpMediaDownloadPreviewArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpMediaDownloadPreviewWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpNavigationArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpNavigationWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpNavigationItemArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CorpNavigationItemWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpNotificationBannerArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpNotificationBannerWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpOurPeopleArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CorpOurPeopleWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpOurPeopleItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpOurPeopleItemWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpPressPageArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpPressPageWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpSocialMediaFooterArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpSocialMediaFooterWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpStoriesPageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CorpStoriesPageWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpStoryCarouselArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpStoryCarouselWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpTimelineAccordionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpTimelineAccordionWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpTimelineAccordionItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpTimelineAccordionItemWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpTimelineAccordionWrapperArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: CorpTimelineAccordionWrapperWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpVideoHeroArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpVideoHeroWhereUniqueInput;
};


export type MutationScheduleUnpublishCorpVideoHeroCarouselArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpVideoHeroCarouselWhereUniqueInput;
};


export type MutationScheduleUnpublishCountrySelectorArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CountrySelectorWhereUniqueInput;
};


export type MutationScheduleUnpublishCountrySelectorItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CountrySelectorItemWhereUniqueInput;
};


export type MutationScheduleUnpublishDeprecatedBanner1Args = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: DeprecatedBanner1WhereUniqueInput;
};


export type MutationScheduleUnpublishDeprecatedCorpNavigationCopyArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: DeprecatedCorpNavigationCopyWhereUniqueInput;
};


export type MutationScheduleUnpublishDictionaryArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: DictionaryWhereUniqueInput;
};


export type MutationScheduleUnpublishDictionaryItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: DictionaryItemWhereUniqueInput;
};


export type MutationScheduleUnpublishDynamicCardGridArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: DynamicCardGridWhereUniqueInput;
};


export type MutationScheduleUnpublishEvalancheFormComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: EvalancheFormComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishExampleComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: ExampleComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishFeaturedContentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FeaturedContentWhereUniqueInput;
};


export type MutationScheduleUnpublishFeaturedContentReferenceArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FeaturedContentReferenceWhereUniqueInput;
};


export type MutationScheduleUnpublishFooterNavigationArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FooterNavigationWhereUniqueInput;
};


export type MutationScheduleUnpublishFormArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormWhereUniqueInput;
};


export type MutationScheduleUnpublishFormCheckboxArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FormCheckboxWhereUniqueInput;
};


export type MutationScheduleUnpublishFormEmailInputArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FormEmailInputWhereUniqueInput;
};


export type MutationScheduleUnpublishFormErrorArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormErrorWhereUniqueInput;
};


export type MutationScheduleUnpublishFormPasswordInputArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FormPasswordInputWhereUniqueInput;
};


export type MutationScheduleUnpublishFormPasswordInputWithConfirmationArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};


export type MutationScheduleUnpublishFormRadioButtonArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormRadioButtonWhereUniqueInput;
};


export type MutationScheduleUnpublishFormRadioButtonCollectionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormRadioButtonCollectionWhereUniqueInput;
};


export type MutationScheduleUnpublishFormSelectComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FormSelectComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishFormSelectOptionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: FormSelectOptionWhereUniqueInput;
};


export type MutationScheduleUnpublishFormSubmitButtonArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FormSubmitButtonWhereUniqueInput;
};


export type MutationScheduleUnpublishFormSuccessComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FormSuccessComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishFormTextInputArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FormTextInputWhereUniqueInput;
};


export type MutationScheduleUnpublishFormTextareaInputArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FormTextareaInputWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericAccordionArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GenericAccordionWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericAccordionItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GenericAccordionItemWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericAccordionTopRatedArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GenericAccordionTopRatedWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericCardCarouseComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GenericCardCarouseComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericDownloadComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GenericDownloadComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericFollowUsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GenericFollowUsWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericGridAuthorableArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GenericGridAuthorableWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericLineArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GenericLineWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericLinkArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: GenericLinkWhereUniqueInput;
};


export type MutationScheduleUnpublishGenericPageArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GenericPageWhereUniqueInput;
};


export type MutationScheduleUnpublishGlobalMetaDataArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GlobalMetaDataWhereUniqueInput;
};


export type MutationScheduleUnpublishHeroBannerArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: HeroBannerWhereUniqueInput;
};


export type MutationScheduleUnpublishHeroCarouselComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: HeroCarouselComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishHeroComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: HeroComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishHomePageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: HomePageWhereUniqueInput;
};


export type MutationScheduleUnpublishIframeArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: IframeWhereUniqueInput;
};


export type MutationScheduleUnpublishImageAndTextCardArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: ImageAndTextCardWhereUniqueInput;
};


export type MutationScheduleUnpublishImageCopyArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: ImageCopyWhereUniqueInput;
};


export type MutationScheduleUnpublishImageCopyItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: ImageCopyItemWhereUniqueInput;
};


export type MutationScheduleUnpublishIntroTextArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: IntroTextWhereUniqueInput;
};


export type MutationScheduleUnpublishLeftColumnArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: LeftColumnWhereUniqueInput;
};


export type MutationScheduleUnpublishLinkArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: LinkWhereUniqueInput;
};


export type MutationScheduleUnpublishLocationComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: LocationComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishLocationItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: LocationItemWhereUniqueInput;
};


export type MutationScheduleUnpublishLongTextArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: LongTextWhereUniqueInput;
};


export type MutationScheduleUnpublishMediaLibraryArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: MediaLibraryWhereUniqueInput;
};


export type MutationScheduleUnpublishMediaLibraryItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: MediaLibraryItemWhereUniqueInput;
};


export type MutationScheduleUnpublishMetaDataArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: MetaDataWhereUniqueInput;
};


export type MutationScheduleUnpublishMobileOnlyMainNavigationArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: MobileOnlyMainNavigationWhereUniqueInput;
};


export type MutationScheduleUnpublishNavigationArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: NavigationWhereUniqueInput;
};


export type MutationScheduleUnpublishNavigationItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: NavigationItemWhereUniqueInput;
};


export type MutationScheduleUnpublishNotificationBannerArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: NotificationBannerWhereUniqueInput;
};


export type MutationScheduleUnpublishPageFooterArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: PageFooterWhereUniqueInput;
};


export type MutationScheduleUnpublishPageHeaderArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: PageHeaderWhereUniqueInput;
};


export type MutationScheduleUnpublishPopularSearchComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: PopularSearchComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishPressReleaseArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: PressReleaseWhereUniqueInput;
};


export type MutationScheduleUnpublishPressStoriesCardArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: PressStoriesCardWhereUniqueInput;
};


export type MutationScheduleUnpublishProgressBarArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: ProgressBarWhereUniqueInput;
};


export type MutationScheduleUnpublishQuickLinkArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: QuickLinkWhereUniqueInput;
};


export type MutationScheduleUnpublishQuickLinkItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: QuickLinkItemWhereUniqueInput;
};


export type MutationScheduleUnpublishRedirectArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: RedirectWhereUniqueInput;
};


export type MutationScheduleUnpublishRewriteArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: RewriteWhereUniqueInput;
};


export type MutationScheduleUnpublishRightColumnArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: RightColumnWhereUniqueInput;
};


export type MutationScheduleUnpublishSearchInputArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SearchInputWhereUniqueInput;
};


export type MutationScheduleUnpublishSearchOverlayComponentArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SearchOverlayComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishSearchResultPageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SearchResultPageWhereUniqueInput;
};


export type MutationScheduleUnpublishShortHeroArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: ShortHeroWhereUniqueInput;
};


export type MutationScheduleUnpublishSocialMediaListComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: SocialMediaListComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishSpacerArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SpacerWhereUniqueInput;
};


export type MutationScheduleUnpublishStoryArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: StoryWhereUniqueInput;
};


export type MutationScheduleUnpublishSubCategoryKeyImageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: SubCategoryKeyImageWhereUniqueInput;
};


export type MutationScheduleUnpublishSustainabilityBannerArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: SustainabilityBannerWhereUniqueInput;
};


export type MutationScheduleUnpublishSustainabilityInfoArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: SustainabilityInfoWhereUniqueInput;
};


export type MutationScheduleUnpublishTabArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TabWhereUniqueInput;
};


export type MutationScheduleUnpublishTabContentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: TabContentWhereUniqueInput;
};


export type MutationScheduleUnpublishTestTipsANdTricksInAMarketArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};


export type MutationScheduleUnpublishTextComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: TextComponentWhereUniqueInput;
};


export type MutationScheduleUnpublishTipsAndTricksDetailsPageArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};


export type MutationScheduleUnpublishTitleArgs = {
  from?: Array<Stage>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  where: TitleWhereUniqueInput;
};


export type MutationScheduleUnpublishTwitterSeoArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: TwitterSeoWhereUniqueInput;
};


export type MutationScheduleUnpublishWidgetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  releaseId?: InputMaybe<Scalars['String']['input']>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: WidgetWhereUniqueInput;
};


export type MutationUnpublishAccordionArgs = {
  from?: Array<Stage>;
  where: AccordionWhereUniqueInput;
};


export type MutationUnpublishAccordionItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AccordionItemWhereUniqueInput;
};


export type MutationUnpublishAlexTestComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AlexTestComponentWhereUniqueInput;
};


export type MutationUnpublishAlgoliaExtensionArgs = {
  from?: Array<Stage>;
  where: AlgoliaExtensionWhereUniqueInput;
};


export type MutationUnpublishAnchorNavArgs = {
  from?: Array<Stage>;
  where: AnchorNavWhereUniqueInput;
};


export type MutationUnpublishAnchorNavigationArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AnchorNavigationWhereUniqueInput;
};


export type MutationUnpublishAnchorNavigationListArgs = {
  from?: Array<Stage>;
  where: AnchorNavigationListWhereUniqueInput;
};


export type MutationUnpublishAssetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AssetWhereUniqueInput;
};


export type MutationUnpublishAssetComponentArgs = {
  from?: Array<Stage>;
  where: AssetComponentWhereUniqueInput;
};


export type MutationUnpublishAudioComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AudioComponentWhereUniqueInput;
};


export type MutationUnpublishAuthorableContentCardArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: AuthorableContentCardWhereUniqueInput;
};


export type MutationUnpublishBanner2Args = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: Banner2WhereUniqueInput;
};


export type MutationUnpublishBigNumberArgs = {
  from?: Array<Stage>;
  where: BigNumberWhereUniqueInput;
};


export type MutationUnpublishBigNumberItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: BigNumberItemWhereUniqueInput;
};


export type MutationUnpublishCardComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CardComponentWhereUniqueInput;
};


export type MutationUnpublishCarouselComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CarouselComponentWhereUniqueInput;
};


export type MutationUnpublishCarouselSlideArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CarouselSlideWhereUniqueInput;
};


export type MutationUnpublishCategoryCardArgs = {
  from?: Array<Stage>;
  where: CategoryCardWhereUniqueInput;
};


export type MutationUnpublishContactCardArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: ContactCardWhereUniqueInput;
};


export type MutationUnpublishContactCardContainerArgs = {
  from?: Array<Stage>;
  where: ContactCardContainerWhereUniqueInput;
};


export type MutationUnpublishCorpAddToCalendarArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpAddToCalendarWhereUniqueInput;
};


export type MutationUnpublishCorpBanner1Args = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpBanner1WhereUniqueInput;
};


export type MutationUnpublishCorpCalendarEventArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpCalendarEventWhereUniqueInput;
};


export type MutationUnpublishCorpCardCarouselArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpCardCarouselWhereUniqueInput;
};


export type MutationUnpublishCorpContactCardArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpContactCardWhereUniqueInput;
};


export type MutationUnpublishCorpContactCardContainerArgs = {
  from?: Array<Stage>;
  where: CorpContactCardContainerWhereUniqueInput;
};


export type MutationUnpublishCorpFormArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpFormWhereUniqueInput;
};


export type MutationUnpublishCorpGenericAccordionArgs = {
  from?: Array<Stage>;
  where: CorpGenericAccordionWhereUniqueInput;
};


export type MutationUnpublishCorpGenericAccordionItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpGenericAccordionItemWhereUniqueInput;
};


export type MutationUnpublishCorpGenericBannerArgs = {
  from?: Array<Stage>;
  where: CorpGenericBannerWhereUniqueInput;
};


export type MutationUnpublishCorpGenericContainerArgs = {
  from?: Array<Stage>;
  where: CorpGenericContainerWhereUniqueInput;
};


export type MutationUnpublishCorpGridColumnComponentArgs = {
  from?: Array<Stage>;
  where: CorpGridColumnComponentWhereUniqueInput;
};


export type MutationUnpublishCorpHeroArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpHeroWhereUniqueInput;
};


export type MutationUnpublishCorpMediaDownloadPreviewArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpMediaDownloadPreviewWhereUniqueInput;
};


export type MutationUnpublishCorpNavigationArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpNavigationWhereUniqueInput;
};


export type MutationUnpublishCorpNavigationItemArgs = {
  from?: Array<Stage>;
  where: CorpNavigationItemWhereUniqueInput;
};


export type MutationUnpublishCorpNotificationBannerArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpNotificationBannerWhereUniqueInput;
};


export type MutationUnpublishCorpOurPeopleArgs = {
  from?: Array<Stage>;
  where: CorpOurPeopleWhereUniqueInput;
};


export type MutationUnpublishCorpOurPeopleItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpOurPeopleItemWhereUniqueInput;
};


export type MutationUnpublishCorpPressPageArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpPressPageWhereUniqueInput;
};


export type MutationUnpublishCorpSocialMediaFooterArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpSocialMediaFooterWhereUniqueInput;
};


export type MutationUnpublishCorpStoriesPageArgs = {
  from?: Array<Stage>;
  where: CorpStoriesPageWhereUniqueInput;
};


export type MutationUnpublishCorpStoryCarouselArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpStoryCarouselWhereUniqueInput;
};


export type MutationUnpublishCorpTimelineAccordionArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpTimelineAccordionWhereUniqueInput;
};


export type MutationUnpublishCorpTimelineAccordionItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpTimelineAccordionItemWhereUniqueInput;
};


export type MutationUnpublishCorpTimelineAccordionWrapperArgs = {
  from?: Array<Stage>;
  where: CorpTimelineAccordionWrapperWhereUniqueInput;
};


export type MutationUnpublishCorpVideoHeroArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpVideoHeroWhereUniqueInput;
};


export type MutationUnpublishCorpVideoHeroCarouselArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CorpVideoHeroCarouselWhereUniqueInput;
};


export type MutationUnpublishCountrySelectorArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CountrySelectorWhereUniqueInput;
};


export type MutationUnpublishCountrySelectorItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: CountrySelectorItemWhereUniqueInput;
};


export type MutationUnpublishDeprecatedBanner1Args = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: DeprecatedBanner1WhereUniqueInput;
};


export type MutationUnpublishDeprecatedCorpNavigationCopyArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: DeprecatedCorpNavigationCopyWhereUniqueInput;
};


export type MutationUnpublishDictionaryArgs = {
  from?: Array<Stage>;
  where: DictionaryWhereUniqueInput;
};


export type MutationUnpublishDictionaryItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: DictionaryItemWhereUniqueInput;
};


export type MutationUnpublishDynamicCardGridArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: DynamicCardGridWhereUniqueInput;
};


export type MutationUnpublishEvalancheFormComponentArgs = {
  from?: Array<Stage>;
  where: EvalancheFormComponentWhereUniqueInput;
};


export type MutationUnpublishExampleComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: ExampleComponentWhereUniqueInput;
};


export type MutationUnpublishFeaturedContentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FeaturedContentWhereUniqueInput;
};


export type MutationUnpublishFeaturedContentReferenceArgs = {
  from?: Array<Stage>;
  where: FeaturedContentReferenceWhereUniqueInput;
};


export type MutationUnpublishFooterNavigationArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FooterNavigationWhereUniqueInput;
};


export type MutationUnpublishFormArgs = {
  from?: Array<Stage>;
  where: FormWhereUniqueInput;
};


export type MutationUnpublishFormCheckboxArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FormCheckboxWhereUniqueInput;
};


export type MutationUnpublishFormEmailInputArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FormEmailInputWhereUniqueInput;
};


export type MutationUnpublishFormErrorArgs = {
  from?: Array<Stage>;
  where: FormErrorWhereUniqueInput;
};


export type MutationUnpublishFormPasswordInputArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FormPasswordInputWhereUniqueInput;
};


export type MutationUnpublishFormPasswordInputWithConfirmationArgs = {
  from?: Array<Stage>;
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};


export type MutationUnpublishFormRadioButtonArgs = {
  from?: Array<Stage>;
  where: FormRadioButtonWhereUniqueInput;
};


export type MutationUnpublishFormRadioButtonCollectionArgs = {
  from?: Array<Stage>;
  where: FormRadioButtonCollectionWhereUniqueInput;
};


export type MutationUnpublishFormSelectComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FormSelectComponentWhereUniqueInput;
};


export type MutationUnpublishFormSelectOptionArgs = {
  from?: Array<Stage>;
  where: FormSelectOptionWhereUniqueInput;
};


export type MutationUnpublishFormSubmitButtonArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FormSubmitButtonWhereUniqueInput;
};


export type MutationUnpublishFormSuccessComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FormSuccessComponentWhereUniqueInput;
};


export type MutationUnpublishFormTextInputArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FormTextInputWhereUniqueInput;
};


export type MutationUnpublishFormTextareaInputArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: FormTextareaInputWhereUniqueInput;
};


export type MutationUnpublishGenericAccordionArgs = {
  from?: Array<Stage>;
  where: GenericAccordionWhereUniqueInput;
};


export type MutationUnpublishGenericAccordionItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GenericAccordionItemWhereUniqueInput;
};


export type MutationUnpublishGenericAccordionTopRatedArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GenericAccordionTopRatedWhereUniqueInput;
};


export type MutationUnpublishGenericCardCarouseComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GenericCardCarouseComponentWhereUniqueInput;
};


export type MutationUnpublishGenericDownloadComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GenericDownloadComponentWhereUniqueInput;
};


export type MutationUnpublishGenericFollowUsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GenericFollowUsWhereUniqueInput;
};


export type MutationUnpublishGenericGridAuthorableArgs = {
  from?: Array<Stage>;
  where: GenericGridAuthorableWhereUniqueInput;
};


export type MutationUnpublishGenericLineArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GenericLineWhereUniqueInput;
};


export type MutationUnpublishGenericLinkArgs = {
  from?: Array<Stage>;
  where: GenericLinkWhereUniqueInput;
};


export type MutationUnpublishGenericPageArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GenericPageWhereUniqueInput;
};


export type MutationUnpublishGlobalMetaDataArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: GlobalMetaDataWhereUniqueInput;
};


export type MutationUnpublishHeroBannerArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: HeroBannerWhereUniqueInput;
};


export type MutationUnpublishHeroCarouselComponentArgs = {
  from?: Array<Stage>;
  where: HeroCarouselComponentWhereUniqueInput;
};


export type MutationUnpublishHeroComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: HeroComponentWhereUniqueInput;
};


export type MutationUnpublishHomePageArgs = {
  from?: Array<Stage>;
  where: HomePageWhereUniqueInput;
};


export type MutationUnpublishIframeArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: IframeWhereUniqueInput;
};


export type MutationUnpublishImageAndTextCardArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: ImageAndTextCardWhereUniqueInput;
};


export type MutationUnpublishImageCopyArgs = {
  from?: Array<Stage>;
  where: ImageCopyWhereUniqueInput;
};


export type MutationUnpublishImageCopyItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: ImageCopyItemWhereUniqueInput;
};


export type MutationUnpublishIntroTextArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: IntroTextWhereUniqueInput;
};


export type MutationUnpublishLeftColumnArgs = {
  from?: Array<Stage>;
  where: LeftColumnWhereUniqueInput;
};


export type MutationUnpublishLinkArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: LinkWhereUniqueInput;
};


export type MutationUnpublishLocationComponentArgs = {
  from?: Array<Stage>;
  where: LocationComponentWhereUniqueInput;
};


export type MutationUnpublishLocationItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: LocationItemWhereUniqueInput;
};


export type MutationUnpublishLongTextArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: LongTextWhereUniqueInput;
};


export type MutationUnpublishManyAccordionItemsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AccordionItemManyWhereInput>;
};


export type MutationUnpublishManyAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AccordionItemManyWhereInput>;
};


export type MutationUnpublishManyAccordionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AccordionManyWhereInput>;
};


export type MutationUnpublishManyAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AccordionManyWhereInput>;
};


export type MutationUnpublishManyAlexTestComponentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AlexTestComponentManyWhereInput>;
};


export type MutationUnpublishManyAlexTestComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AlexTestComponentManyWhereInput>;
};


export type MutationUnpublishManyAlgoliaExtensionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AlgoliaExtensionManyWhereInput>;
};


export type MutationUnpublishManyAlgoliaExtensionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AlgoliaExtensionManyWhereInput>;
};


export type MutationUnpublishManyAnchorNavigationListsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AnchorNavigationListManyWhereInput>;
};


export type MutationUnpublishManyAnchorNavigationListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AnchorNavigationListManyWhereInput>;
};


export type MutationUnpublishManyAnchorNavigationsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnchorNavigationManyWhereInput>;
};


export type MutationUnpublishManyAnchorNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AnchorNavigationManyWhereInput>;
};


export type MutationUnpublishManyAnchorNavsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AnchorNavManyWhereInput>;
};


export type MutationUnpublishManyAnchorNavsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AnchorNavManyWhereInput>;
};


export type MutationUnpublishManyAssetsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUnpublishManyAssetsComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<AssetComponentManyWhereInput>;
};


export type MutationUnpublishManyAssetsComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<AssetComponentManyWhereInput>;
};


export type MutationUnpublishManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUnpublishManyAudioComponentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AudioComponentManyWhereInput>;
};


export type MutationUnpublishManyAudioComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AudioComponentManyWhereInput>;
};


export type MutationUnpublishManyAuthorableContentCardsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AuthorableContentCardManyWhereInput>;
};


export type MutationUnpublishManyAuthorableContentCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<AuthorableContentCardManyWhereInput>;
};


export type MutationUnpublishManyBanner2SArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Banner2ManyWhereInput>;
};


export type MutationUnpublishManyBanner2SConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<Banner2ManyWhereInput>;
};


export type MutationUnpublishManyBigNumberItemsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BigNumberItemManyWhereInput>;
};


export type MutationUnpublishManyBigNumberItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<BigNumberItemManyWhereInput>;
};


export type MutationUnpublishManyBigNumbersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<BigNumberManyWhereInput>;
};


export type MutationUnpublishManyBigNumbersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<BigNumberManyWhereInput>;
};


export type MutationUnpublishManyCardComponentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CardComponentManyWhereInput>;
};


export type MutationUnpublishManyCardComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CardComponentManyWhereInput>;
};


export type MutationUnpublishManyCarouselComponentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CarouselComponentManyWhereInput>;
};


export type MutationUnpublishManyCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CarouselComponentManyWhereInput>;
};


export type MutationUnpublishManyCarouselSlidesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CarouselSlideManyWhereInput>;
};


export type MutationUnpublishManyCarouselSlidesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CarouselSlideManyWhereInput>;
};


export type MutationUnpublishManyCategoryCardsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CategoryCardManyWhereInput>;
};


export type MutationUnpublishManyCategoryCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CategoryCardManyWhereInput>;
};


export type MutationUnpublishManyContactCardContainersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ContactCardContainerManyWhereInput>;
};


export type MutationUnpublishManyContactCardContainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ContactCardContainerManyWhereInput>;
};


export type MutationUnpublishManyContactCardsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContactCardManyWhereInput>;
};


export type MutationUnpublishManyContactCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ContactCardManyWhereInput>;
};


export type MutationUnpublishManyCorpAddToCalendarsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpAddToCalendarManyWhereInput>;
};


export type MutationUnpublishManyCorpAddToCalendarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpAddToCalendarManyWhereInput>;
};


export type MutationUnpublishManyCorpBanners1Args = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpBanner1ManyWhereInput>;
};


export type MutationUnpublishManyCorpBanners1ConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpBanner1ManyWhereInput>;
};


export type MutationUnpublishManyCorpCalendarEventsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpCalendarEventManyWhereInput>;
};


export type MutationUnpublishManyCorpCalendarEventsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpCalendarEventManyWhereInput>;
};


export type MutationUnpublishManyCorpCardCarouselsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpCardCarouselManyWhereInput>;
};


export type MutationUnpublishManyCorpCardCarouselsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpCardCarouselManyWhereInput>;
};


export type MutationUnpublishManyCorpContactCardContainersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CorpContactCardContainerManyWhereInput>;
};


export type MutationUnpublishManyCorpContactCardContainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CorpContactCardContainerManyWhereInput>;
};


export type MutationUnpublishManyCorpContactCardsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpContactCardManyWhereInput>;
};


export type MutationUnpublishManyCorpContactCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpContactCardManyWhereInput>;
};


export type MutationUnpublishManyCorpFormsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpFormManyWhereInput>;
};


export type MutationUnpublishManyCorpFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpFormManyWhereInput>;
};


export type MutationUnpublishManyCorpGenericAccordionItemsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpGenericAccordionItemManyWhereInput>;
};


export type MutationUnpublishManyCorpGenericAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpGenericAccordionItemManyWhereInput>;
};


export type MutationUnpublishManyCorpGenericAccordionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CorpGenericAccordionManyWhereInput>;
};


export type MutationUnpublishManyCorpGenericAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CorpGenericAccordionManyWhereInput>;
};


export type MutationUnpublishManyCorpGenericBannersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CorpGenericBannerManyWhereInput>;
};


export type MutationUnpublishManyCorpGenericBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CorpGenericBannerManyWhereInput>;
};


export type MutationUnpublishManyCorpGenericContainersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CorpGenericContainerManyWhereInput>;
};


export type MutationUnpublishManyCorpGenericContainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CorpGenericContainerManyWhereInput>;
};


export type MutationUnpublishManyCorpGridColumnComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CorpGridColumnComponentManyWhereInput>;
};


export type MutationUnpublishManyCorpGridColumnComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CorpGridColumnComponentManyWhereInput>;
};


export type MutationUnpublishManyCorpHerosArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpHeroManyWhereInput>;
};


export type MutationUnpublishManyCorpHerosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpHeroManyWhereInput>;
};


export type MutationUnpublishManyCorpMediaDownloadPreviewsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpMediaDownloadPreviewManyWhereInput>;
};


export type MutationUnpublishManyCorpMediaDownloadPreviewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpMediaDownloadPreviewManyWhereInput>;
};


export type MutationUnpublishManyCorpNavigationItemsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CorpNavigationItemManyWhereInput>;
};


export type MutationUnpublishManyCorpNavigationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CorpNavigationItemManyWhereInput>;
};


export type MutationUnpublishManyCorpNavigationsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpNavigationManyWhereInput>;
};


export type MutationUnpublishManyCorpNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpNavigationManyWhereInput>;
};


export type MutationUnpublishManyCorpNotificationBannersArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpNotificationBannerManyWhereInput>;
};


export type MutationUnpublishManyCorpNotificationBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpNotificationBannerManyWhereInput>;
};


export type MutationUnpublishManyCorpOurPeopleItemsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpOurPeopleItemManyWhereInput>;
};


export type MutationUnpublishManyCorpOurPeopleItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpOurPeopleItemManyWhereInput>;
};


export type MutationUnpublishManyCorpOurPeoplesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CorpOurPeopleManyWhereInput>;
};


export type MutationUnpublishManyCorpOurPeoplesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CorpOurPeopleManyWhereInput>;
};


export type MutationUnpublishManyCorpPressPagesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpPressPageManyWhereInput>;
};


export type MutationUnpublishManyCorpPressPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpPressPageManyWhereInput>;
};


export type MutationUnpublishManyCorpSocialMediaFootersArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpSocialMediaFooterManyWhereInput>;
};


export type MutationUnpublishManyCorpSocialMediaFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpSocialMediaFooterManyWhereInput>;
};


export type MutationUnpublishManyCorpStoriesPagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CorpStoriesPageManyWhereInput>;
};


export type MutationUnpublishManyCorpStoriesPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CorpStoriesPageManyWhereInput>;
};


export type MutationUnpublishManyCorpStoryCarouselsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpStoryCarouselManyWhereInput>;
};


export type MutationUnpublishManyCorpStoryCarouselsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpStoryCarouselManyWhereInput>;
};


export type MutationUnpublishManyCorpTimelineAccordionItemsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpTimelineAccordionItemManyWhereInput>;
};


export type MutationUnpublishManyCorpTimelineAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpTimelineAccordionItemManyWhereInput>;
};


export type MutationUnpublishManyCorpTimelineAccordionWrappersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<CorpTimelineAccordionWrapperManyWhereInput>;
};


export type MutationUnpublishManyCorpTimelineAccordionWrappersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<CorpTimelineAccordionWrapperManyWhereInput>;
};


export type MutationUnpublishManyCorpTimelineAccordionsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpTimelineAccordionManyWhereInput>;
};


export type MutationUnpublishManyCorpTimelineAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpTimelineAccordionManyWhereInput>;
};


export type MutationUnpublishManyCorpVideoHeroCarouselsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpVideoHeroCarouselManyWhereInput>;
};


export type MutationUnpublishManyCorpVideoHeroCarouselsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpVideoHeroCarouselManyWhereInput>;
};


export type MutationUnpublishManyCorpVideoHerosArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpVideoHeroManyWhereInput>;
};


export type MutationUnpublishManyCorpVideoHerosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CorpVideoHeroManyWhereInput>;
};


export type MutationUnpublishManyCountrySelectorItemsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountrySelectorItemManyWhereInput>;
};


export type MutationUnpublishManyCountrySelectorItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountrySelectorItemManyWhereInput>;
};


export type MutationUnpublishManyCountrySelectorsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountrySelectorManyWhereInput>;
};


export type MutationUnpublishManyCountrySelectorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<CountrySelectorManyWhereInput>;
};


export type MutationUnpublishManyDeprecatedBanner1sArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DeprecatedBanner1ManyWhereInput>;
};


export type MutationUnpublishManyDeprecatedBanner1sConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DeprecatedBanner1ManyWhereInput>;
};


export type MutationUnpublishManyDeprecatedCorpNavigationsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DeprecatedCorpNavigationCopyManyWhereInput>;
};


export type MutationUnpublishManyDeprecatedCorpNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DeprecatedCorpNavigationCopyManyWhereInput>;
};


export type MutationUnpublishManyDictionariesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<DictionaryManyWhereInput>;
};


export type MutationUnpublishManyDictionariesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<DictionaryManyWhereInput>;
};


export type MutationUnpublishManyDictionaryItemsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DictionaryItemManyWhereInput>;
};


export type MutationUnpublishManyDictionaryItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DictionaryItemManyWhereInput>;
};


export type MutationUnpublishManyDynamicCardGridsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DynamicCardGridManyWhereInput>;
};


export type MutationUnpublishManyDynamicCardGridsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<DynamicCardGridManyWhereInput>;
};


export type MutationUnpublishManyEvalancheFormComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<EvalancheFormComponentManyWhereInput>;
};


export type MutationUnpublishManyEvalancheFormComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<EvalancheFormComponentManyWhereInput>;
};


export type MutationUnpublishManyExampleComponentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExampleComponentManyWhereInput>;
};


export type MutationUnpublishManyExampleComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ExampleComponentManyWhereInput>;
};


export type MutationUnpublishManyFeaturedContentReferencesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FeaturedContentReferenceManyWhereInput>;
};


export type MutationUnpublishManyFeaturedContentReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FeaturedContentReferenceManyWhereInput>;
};


export type MutationUnpublishManyFeaturedContentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FeaturedContentManyWhereInput>;
};


export type MutationUnpublishManyFeaturedContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FeaturedContentManyWhereInput>;
};


export type MutationUnpublishManyFooterNavigationsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FooterNavigationManyWhereInput>;
};


export type MutationUnpublishManyFooterNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FooterNavigationManyWhereInput>;
};


export type MutationUnpublishManyFormCheckboxesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormCheckboxManyWhereInput>;
};


export type MutationUnpublishManyFormCheckboxesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormCheckboxManyWhereInput>;
};


export type MutationUnpublishManyFormEmailInputsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormEmailInputManyWhereInput>;
};


export type MutationUnpublishManyFormEmailInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormEmailInputManyWhereInput>;
};


export type MutationUnpublishManyFormErrorsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormErrorManyWhereInput>;
};


export type MutationUnpublishManyFormErrorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormErrorManyWhereInput>;
};


export type MutationUnpublishManyFormPasswordInputWithConfirmationsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormPasswordInputWithConfirmationManyWhereInput>;
};


export type MutationUnpublishManyFormPasswordInputWithConfirmationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormPasswordInputWithConfirmationManyWhereInput>;
};


export type MutationUnpublishManyFormPasswordInputsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormPasswordInputManyWhereInput>;
};


export type MutationUnpublishManyFormPasswordInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormPasswordInputManyWhereInput>;
};


export type MutationUnpublishManyFormRadioButtonCollectionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormRadioButtonCollectionManyWhereInput>;
};


export type MutationUnpublishManyFormRadioButtonCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormRadioButtonCollectionManyWhereInput>;
};


export type MutationUnpublishManyFormRadioButtonsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormRadioButtonManyWhereInput>;
};


export type MutationUnpublishManyFormRadioButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormRadioButtonManyWhereInput>;
};


export type MutationUnpublishManyFormSelectComponentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormSelectComponentManyWhereInput>;
};


export type MutationUnpublishManyFormSelectComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormSelectComponentManyWhereInput>;
};


export type MutationUnpublishManyFormSelectOptionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormSelectOptionManyWhereInput>;
};


export type MutationUnpublishManyFormSelectOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormSelectOptionManyWhereInput>;
};


export type MutationUnpublishManyFormSubmitButtonsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormSubmitButtonManyWhereInput>;
};


export type MutationUnpublishManyFormSubmitButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormSubmitButtonManyWhereInput>;
};


export type MutationUnpublishManyFormSuccessComponentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormSuccessComponentManyWhereInput>;
};


export type MutationUnpublishManyFormSuccessComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormSuccessComponentManyWhereInput>;
};


export type MutationUnpublishManyFormTextInputsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormTextInputManyWhereInput>;
};


export type MutationUnpublishManyFormTextInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormTextInputManyWhereInput>;
};


export type MutationUnpublishManyFormTextareaInputsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormTextareaInputManyWhereInput>;
};


export type MutationUnpublishManyFormTextareaInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<FormTextareaInputManyWhereInput>;
};


export type MutationUnpublishManyFormsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationUnpublishManyFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationUnpublishManyGenericAccordionItemsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericAccordionItemManyWhereInput>;
};


export type MutationUnpublishManyGenericAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericAccordionItemManyWhereInput>;
};


export type MutationUnpublishManyGenericAccordionTopRatedsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericAccordionTopRatedManyWhereInput>;
};


export type MutationUnpublishManyGenericAccordionTopRatedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericAccordionTopRatedManyWhereInput>;
};


export type MutationUnpublishManyGenericAccordionsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GenericAccordionManyWhereInput>;
};


export type MutationUnpublishManyGenericAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GenericAccordionManyWhereInput>;
};


export type MutationUnpublishManyGenericCardCarouseComponentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericCardCarouseComponentManyWhereInput>;
};


export type MutationUnpublishManyGenericCardCarouseComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericCardCarouseComponentManyWhereInput>;
};


export type MutationUnpublishManyGenericDownloadComponentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericDownloadComponentManyWhereInput>;
};


export type MutationUnpublishManyGenericDownloadComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericDownloadComponentManyWhereInput>;
};


export type MutationUnpublishManyGenericFollowUsesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericFollowUsManyWhereInput>;
};


export type MutationUnpublishManyGenericFollowUsesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericFollowUsManyWhereInput>;
};


export type MutationUnpublishManyGenericGridAuthorablesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GenericGridAuthorableManyWhereInput>;
};


export type MutationUnpublishManyGenericGridAuthorablesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GenericGridAuthorableManyWhereInput>;
};


export type MutationUnpublishManyGenericLinesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericLineManyWhereInput>;
};


export type MutationUnpublishManyGenericLinesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericLineManyWhereInput>;
};


export type MutationUnpublishManyGenericLinksArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<GenericLinkManyWhereInput>;
};


export type MutationUnpublishManyGenericLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<GenericLinkManyWhereInput>;
};


export type MutationUnpublishManyGenericPagesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericPageManyWhereInput>;
};


export type MutationUnpublishManyGenericPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GenericPageManyWhereInput>;
};


export type MutationUnpublishManyGlobalMetaDatasArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GlobalMetaDataManyWhereInput>;
};


export type MutationUnpublishManyGlobalMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<GlobalMetaDataManyWhereInput>;
};


export type MutationUnpublishManyHeroBannersArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeroBannerManyWhereInput>;
};


export type MutationUnpublishManyHeroBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeroBannerManyWhereInput>;
};


export type MutationUnpublishManyHeroCarouselComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<HeroCarouselComponentManyWhereInput>;
};


export type MutationUnpublishManyHeroCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<HeroCarouselComponentManyWhereInput>;
};


export type MutationUnpublishManyHeroComponentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeroComponentManyWhereInput>;
};


export type MutationUnpublishManyHeroComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<HeroComponentManyWhereInput>;
};


export type MutationUnpublishManyHomePagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<HomePageManyWhereInput>;
};


export type MutationUnpublishManyHomePagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<HomePageManyWhereInput>;
};


export type MutationUnpublishManyIframesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IframeManyWhereInput>;
};


export type MutationUnpublishManyIframesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IframeManyWhereInput>;
};


export type MutationUnpublishManyImageAndTextCardsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAndTextCardManyWhereInput>;
};


export type MutationUnpublishManyImageAndTextCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageAndTextCardManyWhereInput>;
};


export type MutationUnpublishManyImageCopiesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<ImageCopyManyWhereInput>;
};


export type MutationUnpublishManyImageCopiesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<ImageCopyManyWhereInput>;
};


export type MutationUnpublishManyImageCopyItemsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageCopyItemManyWhereInput>;
};


export type MutationUnpublishManyImageCopyItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ImageCopyItemManyWhereInput>;
};


export type MutationUnpublishManyIntroTextsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IntroTextManyWhereInput>;
};


export type MutationUnpublishManyIntroTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<IntroTextManyWhereInput>;
};


export type MutationUnpublishManyLeftColumnsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<LeftColumnManyWhereInput>;
};


export type MutationUnpublishManyLeftColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<LeftColumnManyWhereInput>;
};


export type MutationUnpublishManyLinksArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationUnpublishManyLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationUnpublishManyLocationComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<LocationComponentManyWhereInput>;
};


export type MutationUnpublishManyLocationComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<LocationComponentManyWhereInput>;
};


export type MutationUnpublishManyLocationItemsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LocationItemManyWhereInput>;
};


export type MutationUnpublishManyLocationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LocationItemManyWhereInput>;
};


export type MutationUnpublishManyLongTextsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LongTextManyWhereInput>;
};


export type MutationUnpublishManyLongTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<LongTextManyWhereInput>;
};


export type MutationUnpublishManyMediaLibrariesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MediaLibraryManyWhereInput>;
};


export type MutationUnpublishManyMediaLibrariesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MediaLibraryManyWhereInput>;
};


export type MutationUnpublishManyMediaLibraryItemsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MediaLibraryItemManyWhereInput>;
};


export type MutationUnpublishManyMediaLibraryItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MediaLibraryItemManyWhereInput>;
};


export type MutationUnpublishManyMetaDatasArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MetaDataManyWhereInput>;
};


export type MutationUnpublishManyMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<MetaDataManyWhereInput>;
};


export type MutationUnpublishManyMobileOnlyMainNavigationsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<MobileOnlyMainNavigationManyWhereInput>;
};


export type MutationUnpublishManyMobileOnlyMainNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<MobileOnlyMainNavigationManyWhereInput>;
};


export type MutationUnpublishManyNavigationItemsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationItemManyWhereInput>;
};


export type MutationUnpublishManyNavigationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationItemManyWhereInput>;
};


export type MutationUnpublishManyNavigationsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationUnpublishManyNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationUnpublishManyNotificationBannersArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NotificationBannerManyWhereInput>;
};


export type MutationUnpublishManyNotificationBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<NotificationBannerManyWhereInput>;
};


export type MutationUnpublishManyPageFootersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<PageFooterManyWhereInput>;
};


export type MutationUnpublishManyPageFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<PageFooterManyWhereInput>;
};


export type MutationUnpublishManyPageHeadersArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageHeaderManyWhereInput>;
};


export type MutationUnpublishManyPageHeadersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PageHeaderManyWhereInput>;
};


export type MutationUnpublishManyPopularSearchComponentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PopularSearchComponentManyWhereInput>;
};


export type MutationUnpublishManyPopularSearchComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PopularSearchComponentManyWhereInput>;
};


export type MutationUnpublishManyPressReleasesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PressReleaseManyWhereInput>;
};


export type MutationUnpublishManyPressReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PressReleaseManyWhereInput>;
};


export type MutationUnpublishManyPressStoriesCardsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PressStoriesCardManyWhereInput>;
};


export type MutationUnpublishManyPressStoriesCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<PressStoriesCardManyWhereInput>;
};


export type MutationUnpublishManyProgressBarsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProgressBarManyWhereInput>;
};


export type MutationUnpublishManyProgressBarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ProgressBarManyWhereInput>;
};


export type MutationUnpublishManyQuickLinkItemsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuickLinkItemManyWhereInput>;
};


export type MutationUnpublishManyQuickLinkItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuickLinkItemManyWhereInput>;
};


export type MutationUnpublishManyQuickLinksArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuickLinkManyWhereInput>;
};


export type MutationUnpublishManyQuickLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<QuickLinkManyWhereInput>;
};


export type MutationUnpublishManyRedirectsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationUnpublishManyRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationUnpublishManyRewritesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RewriteManyWhereInput>;
};


export type MutationUnpublishManyRewritesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<RewriteManyWhereInput>;
};


export type MutationUnpublishManyRightColumnsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<RightColumnManyWhereInput>;
};


export type MutationUnpublishManyRightColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<RightColumnManyWhereInput>;
};


export type MutationUnpublishManySearchInputsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SearchInputManyWhereInput>;
};


export type MutationUnpublishManySearchInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SearchInputManyWhereInput>;
};


export type MutationUnpublishManySearchOverlayComponentsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SearchOverlayComponentManyWhereInput>;
};


export type MutationUnpublishManySearchOverlayComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SearchOverlayComponentManyWhereInput>;
};


export type MutationUnpublishManySearchResultPagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SearchResultPageManyWhereInput>;
};


export type MutationUnpublishManySearchResultPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SearchResultPageManyWhereInput>;
};


export type MutationUnpublishManyShortHeroesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ShortHeroManyWhereInput>;
};


export type MutationUnpublishManyShortHeroesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<ShortHeroManyWhereInput>;
};


export type MutationUnpublishManySocialMediaListComponentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SocialMediaListComponentManyWhereInput>;
};


export type MutationUnpublishManySocialMediaListComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SocialMediaListComponentManyWhereInput>;
};


export type MutationUnpublishManySpacersArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SpacerManyWhereInput>;
};


export type MutationUnpublishManySpacersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SpacerManyWhereInput>;
};


export type MutationUnpublishManyStoriesArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<StoryManyWhereInput>;
};


export type MutationUnpublishManyStoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<StoryManyWhereInput>;
};


export type MutationUnpublishManySubCategoryKeyImagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<SubCategoryKeyImageManyWhereInput>;
};


export type MutationUnpublishManySubCategoryKeyImagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<SubCategoryKeyImageManyWhereInput>;
};


export type MutationUnpublishManySustainabilityBannersArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SustainabilityBannerManyWhereInput>;
};


export type MutationUnpublishManySustainabilityBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SustainabilityBannerManyWhereInput>;
};


export type MutationUnpublishManySustainabilityInfosArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SustainabilityInfoManyWhereInput>;
};


export type MutationUnpublishManySustainabilityInfosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<SustainabilityInfoManyWhereInput>;
};


export type MutationUnpublishManyTabContentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TabContentManyWhereInput>;
};


export type MutationUnpublishManyTabContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TabContentManyWhereInput>;
};


export type MutationUnpublishManyTabsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TabManyWhereInput>;
};


export type MutationUnpublishManyTabsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TabManyWhereInput>;
};


export type MutationUnpublishManyTestTipsANdTricksInAMarketsArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TestTipsANdTricksInAMarketManyWhereInput>;
};


export type MutationUnpublishManyTestTipsANdTricksInAMarketsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TestTipsANdTricksInAMarketManyWhereInput>;
};


export type MutationUnpublishManyTextComponentsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TextComponentManyWhereInput>;
};


export type MutationUnpublishManyTextComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TextComponentManyWhereInput>;
};


export type MutationUnpublishManyTipsAndTricksDetailsPagesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TipsAndTricksDetailsPageManyWhereInput>;
};


export type MutationUnpublishManyTipsAndTricksDetailsPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TipsAndTricksDetailsPageManyWhereInput>;
};


export type MutationUnpublishManyTitlesArgs = {
  from?: Array<Stage>;
  where?: InputMaybe<TitleManyWhereInput>;
};


export type MutationUnpublishManyTitlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  where?: InputMaybe<TitleManyWhereInput>;
};


export type MutationUnpublishManyTwitterSeosArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TwitterSeoManyWhereInput>;
};


export type MutationUnpublishManyTwitterSeosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<TwitterSeoManyWhereInput>;
};


export type MutationUnpublishManyWidgetsArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WidgetManyWhereInput>;
};


export type MutationUnpublishManyWidgetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: Array<Stage>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Stage>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where?: InputMaybe<WidgetManyWhereInput>;
};


export type MutationUnpublishMediaLibraryArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: MediaLibraryWhereUniqueInput;
};


export type MutationUnpublishMediaLibraryItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: MediaLibraryItemWhereUniqueInput;
};


export type MutationUnpublishMetaDataArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: MetaDataWhereUniqueInput;
};


export type MutationUnpublishMobileOnlyMainNavigationArgs = {
  from?: Array<Stage>;
  where: MobileOnlyMainNavigationWhereUniqueInput;
};


export type MutationUnpublishNavigationArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: NavigationWhereUniqueInput;
};


export type MutationUnpublishNavigationItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: NavigationItemWhereUniqueInput;
};


export type MutationUnpublishNotificationBannerArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: NotificationBannerWhereUniqueInput;
};


export type MutationUnpublishPageFooterArgs = {
  from?: Array<Stage>;
  where: PageFooterWhereUniqueInput;
};


export type MutationUnpublishPageHeaderArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: PageHeaderWhereUniqueInput;
};


export type MutationUnpublishPopularSearchComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: PopularSearchComponentWhereUniqueInput;
};


export type MutationUnpublishPressReleaseArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: PressReleaseWhereUniqueInput;
};


export type MutationUnpublishPressStoriesCardArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: PressStoriesCardWhereUniqueInput;
};


export type MutationUnpublishProgressBarArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: ProgressBarWhereUniqueInput;
};


export type MutationUnpublishQuickLinkArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: QuickLinkWhereUniqueInput;
};


export type MutationUnpublishQuickLinkItemArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: QuickLinkItemWhereUniqueInput;
};


export type MutationUnpublishRedirectArgs = {
  from?: Array<Stage>;
  where: RedirectWhereUniqueInput;
};


export type MutationUnpublishRewriteArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: RewriteWhereUniqueInput;
};


export type MutationUnpublishRightColumnArgs = {
  from?: Array<Stage>;
  where: RightColumnWhereUniqueInput;
};


export type MutationUnpublishSearchInputArgs = {
  from?: Array<Stage>;
  where: SearchInputWhereUniqueInput;
};


export type MutationUnpublishSearchOverlayComponentArgs = {
  from?: Array<Stage>;
  where: SearchOverlayComponentWhereUniqueInput;
};


export type MutationUnpublishSearchResultPageArgs = {
  from?: Array<Stage>;
  where: SearchResultPageWhereUniqueInput;
};


export type MutationUnpublishShortHeroArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: ShortHeroWhereUniqueInput;
};


export type MutationUnpublishSocialMediaListComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: SocialMediaListComponentWhereUniqueInput;
};


export type MutationUnpublishSpacerArgs = {
  from?: Array<Stage>;
  where: SpacerWhereUniqueInput;
};


export type MutationUnpublishStoryArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: StoryWhereUniqueInput;
};


export type MutationUnpublishSubCategoryKeyImageArgs = {
  from?: Array<Stage>;
  where: SubCategoryKeyImageWhereUniqueInput;
};


export type MutationUnpublishSustainabilityBannerArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: SustainabilityBannerWhereUniqueInput;
};


export type MutationUnpublishSustainabilityInfoArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: SustainabilityInfoWhereUniqueInput;
};


export type MutationUnpublishTabArgs = {
  from?: Array<Stage>;
  where: TabWhereUniqueInput;
};


export type MutationUnpublishTabContentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: TabContentWhereUniqueInput;
};


export type MutationUnpublishTestTipsANdTricksInAMarketArgs = {
  from?: Array<Stage>;
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};


export type MutationUnpublishTextComponentArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: TextComponentWhereUniqueInput;
};


export type MutationUnpublishTipsAndTricksDetailsPageArgs = {
  from?: Array<Stage>;
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};


export type MutationUnpublishTitleArgs = {
  from?: Array<Stage>;
  where: TitleWhereUniqueInput;
};


export type MutationUnpublishTwitterSeoArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: TwitterSeoWhereUniqueInput;
};


export type MutationUnpublishWidgetArgs = {
  from?: Array<Stage>;
  locales?: InputMaybe<Array<Locale>>;
  unpublishBase?: InputMaybe<Scalars['Boolean']['input']>;
  where: WidgetWhereUniqueInput;
};


export type MutationUpdateAccordionArgs = {
  data: AccordionUpdateInput;
  where: AccordionWhereUniqueInput;
};


export type MutationUpdateAccordionItemArgs = {
  data: AccordionItemUpdateInput;
  where: AccordionItemWhereUniqueInput;
};


export type MutationUpdateAlexTestComponentArgs = {
  data: AlexTestComponentUpdateInput;
  where: AlexTestComponentWhereUniqueInput;
};


export type MutationUpdateAlgoliaExtensionArgs = {
  data: AlgoliaExtensionUpdateInput;
  where: AlgoliaExtensionWhereUniqueInput;
};


export type MutationUpdateAnchorNavArgs = {
  data: AnchorNavUpdateInput;
  where: AnchorNavWhereUniqueInput;
};


export type MutationUpdateAnchorNavigationArgs = {
  data: AnchorNavigationUpdateInput;
  where: AnchorNavigationWhereUniqueInput;
};


export type MutationUpdateAnchorNavigationListArgs = {
  data: AnchorNavigationListUpdateInput;
  where: AnchorNavigationListWhereUniqueInput;
};


export type MutationUpdateAssetArgs = {
  data: AssetUpdateInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpdateAssetComponentArgs = {
  data: AssetComponentUpdateInput;
  where: AssetComponentWhereUniqueInput;
};


export type MutationUpdateAudioComponentArgs = {
  data: AudioComponentUpdateInput;
  where: AudioComponentWhereUniqueInput;
};


export type MutationUpdateAuthorableContentCardArgs = {
  data: AuthorableContentCardUpdateInput;
  where: AuthorableContentCardWhereUniqueInput;
};


export type MutationUpdateBanner2Args = {
  data: Banner2UpdateInput;
  where: Banner2WhereUniqueInput;
};


export type MutationUpdateBigNumberArgs = {
  data: BigNumberUpdateInput;
  where: BigNumberWhereUniqueInput;
};


export type MutationUpdateBigNumberItemArgs = {
  data: BigNumberItemUpdateInput;
  where: BigNumberItemWhereUniqueInput;
};


export type MutationUpdateCardComponentArgs = {
  data: CardComponentUpdateInput;
  where: CardComponentWhereUniqueInput;
};


export type MutationUpdateCarouselComponentArgs = {
  data: CarouselComponentUpdateInput;
  where: CarouselComponentWhereUniqueInput;
};


export type MutationUpdateCarouselSlideArgs = {
  data: CarouselSlideUpdateInput;
  where: CarouselSlideWhereUniqueInput;
};


export type MutationUpdateCategoryCardArgs = {
  data: CategoryCardUpdateInput;
  where: CategoryCardWhereUniqueInput;
};


export type MutationUpdateContactCardArgs = {
  data: ContactCardUpdateInput;
  where: ContactCardWhereUniqueInput;
};


export type MutationUpdateContactCardContainerArgs = {
  data: ContactCardContainerUpdateInput;
  where: ContactCardContainerWhereUniqueInput;
};


export type MutationUpdateCorpAddToCalendarArgs = {
  data: CorpAddToCalendarUpdateInput;
  where: CorpAddToCalendarWhereUniqueInput;
};


export type MutationUpdateCorpBanner1Args = {
  data: CorpBanner1UpdateInput;
  where: CorpBanner1WhereUniqueInput;
};


export type MutationUpdateCorpCalendarEventArgs = {
  data: CorpCalendarEventUpdateInput;
  where: CorpCalendarEventWhereUniqueInput;
};


export type MutationUpdateCorpCardCarouselArgs = {
  data: CorpCardCarouselUpdateInput;
  where: CorpCardCarouselWhereUniqueInput;
};


export type MutationUpdateCorpContactCardArgs = {
  data: CorpContactCardUpdateInput;
  where: CorpContactCardWhereUniqueInput;
};


export type MutationUpdateCorpContactCardContainerArgs = {
  data: CorpContactCardContainerUpdateInput;
  where: CorpContactCardContainerWhereUniqueInput;
};


export type MutationUpdateCorpFormArgs = {
  data: CorpFormUpdateInput;
  where: CorpFormWhereUniqueInput;
};


export type MutationUpdateCorpGenericAccordionArgs = {
  data: CorpGenericAccordionUpdateInput;
  where: CorpGenericAccordionWhereUniqueInput;
};


export type MutationUpdateCorpGenericAccordionItemArgs = {
  data: CorpGenericAccordionItemUpdateInput;
  where: CorpGenericAccordionItemWhereUniqueInput;
};


export type MutationUpdateCorpGenericBannerArgs = {
  data: CorpGenericBannerUpdateInput;
  where: CorpGenericBannerWhereUniqueInput;
};


export type MutationUpdateCorpGenericContainerArgs = {
  data: CorpGenericContainerUpdateInput;
  where: CorpGenericContainerWhereUniqueInput;
};


export type MutationUpdateCorpGridColumnComponentArgs = {
  data: CorpGridColumnComponentUpdateInput;
  where: CorpGridColumnComponentWhereUniqueInput;
};


export type MutationUpdateCorpHeroArgs = {
  data: CorpHeroUpdateInput;
  where: CorpHeroWhereUniqueInput;
};


export type MutationUpdateCorpMediaDownloadPreviewArgs = {
  data: CorpMediaDownloadPreviewUpdateInput;
  where: CorpMediaDownloadPreviewWhereUniqueInput;
};


export type MutationUpdateCorpNavigationArgs = {
  data: CorpNavigationUpdateInput;
  where: CorpNavigationWhereUniqueInput;
};


export type MutationUpdateCorpNavigationItemArgs = {
  data: CorpNavigationItemUpdateInput;
  where: CorpNavigationItemWhereUniqueInput;
};


export type MutationUpdateCorpNotificationBannerArgs = {
  data: CorpNotificationBannerUpdateInput;
  where: CorpNotificationBannerWhereUniqueInput;
};


export type MutationUpdateCorpOurPeopleArgs = {
  data: CorpOurPeopleUpdateInput;
  where: CorpOurPeopleWhereUniqueInput;
};


export type MutationUpdateCorpOurPeopleItemArgs = {
  data: CorpOurPeopleItemUpdateInput;
  where: CorpOurPeopleItemWhereUniqueInput;
};


export type MutationUpdateCorpPressPageArgs = {
  data: CorpPressPageUpdateInput;
  where: CorpPressPageWhereUniqueInput;
};


export type MutationUpdateCorpSocialMediaFooterArgs = {
  data: CorpSocialMediaFooterUpdateInput;
  where: CorpSocialMediaFooterWhereUniqueInput;
};


export type MutationUpdateCorpStoriesPageArgs = {
  data: CorpStoriesPageUpdateInput;
  where: CorpStoriesPageWhereUniqueInput;
};


export type MutationUpdateCorpStoryCarouselArgs = {
  data: CorpStoryCarouselUpdateInput;
  where: CorpStoryCarouselWhereUniqueInput;
};


export type MutationUpdateCorpTimelineAccordionArgs = {
  data: CorpTimelineAccordionUpdateInput;
  where: CorpTimelineAccordionWhereUniqueInput;
};


export type MutationUpdateCorpTimelineAccordionItemArgs = {
  data: CorpTimelineAccordionItemUpdateInput;
  where: CorpTimelineAccordionItemWhereUniqueInput;
};


export type MutationUpdateCorpTimelineAccordionWrapperArgs = {
  data: CorpTimelineAccordionWrapperUpdateInput;
  where: CorpTimelineAccordionWrapperWhereUniqueInput;
};


export type MutationUpdateCorpVideoHeroArgs = {
  data: CorpVideoHeroUpdateInput;
  where: CorpVideoHeroWhereUniqueInput;
};


export type MutationUpdateCorpVideoHeroCarouselArgs = {
  data: CorpVideoHeroCarouselUpdateInput;
  where: CorpVideoHeroCarouselWhereUniqueInput;
};


export type MutationUpdateCountrySelectorArgs = {
  data: CountrySelectorUpdateInput;
  where: CountrySelectorWhereUniqueInput;
};


export type MutationUpdateCountrySelectorItemArgs = {
  data: CountrySelectorItemUpdateInput;
  where: CountrySelectorItemWhereUniqueInput;
};


export type MutationUpdateDeprecatedBanner1Args = {
  data: DeprecatedBanner1UpdateInput;
  where: DeprecatedBanner1WhereUniqueInput;
};


export type MutationUpdateDeprecatedCorpNavigationCopyArgs = {
  data: DeprecatedCorpNavigationCopyUpdateInput;
  where: DeprecatedCorpNavigationCopyWhereUniqueInput;
};


export type MutationUpdateDictionaryArgs = {
  data: DictionaryUpdateInput;
  where: DictionaryWhereUniqueInput;
};


export type MutationUpdateDictionaryItemArgs = {
  data: DictionaryItemUpdateInput;
  where: DictionaryItemWhereUniqueInput;
};


export type MutationUpdateDynamicCardGridArgs = {
  data: DynamicCardGridUpdateInput;
  where: DynamicCardGridWhereUniqueInput;
};


export type MutationUpdateEvalancheFormComponentArgs = {
  data: EvalancheFormComponentUpdateInput;
  where: EvalancheFormComponentWhereUniqueInput;
};


export type MutationUpdateExampleComponentArgs = {
  data: ExampleComponentUpdateInput;
  where: ExampleComponentWhereUniqueInput;
};


export type MutationUpdateFeaturedContentArgs = {
  data: FeaturedContentUpdateInput;
  where: FeaturedContentWhereUniqueInput;
};


export type MutationUpdateFeaturedContentReferenceArgs = {
  data: FeaturedContentReferenceUpdateInput;
  where: FeaturedContentReferenceWhereUniqueInput;
};


export type MutationUpdateFooterNavigationArgs = {
  data: FooterNavigationUpdateInput;
  where: FooterNavigationWhereUniqueInput;
};


export type MutationUpdateFormArgs = {
  data: FormUpdateInput;
  where: FormWhereUniqueInput;
};


export type MutationUpdateFormCheckboxArgs = {
  data: FormCheckboxUpdateInput;
  where: FormCheckboxWhereUniqueInput;
};


export type MutationUpdateFormEmailInputArgs = {
  data: FormEmailInputUpdateInput;
  where: FormEmailInputWhereUniqueInput;
};


export type MutationUpdateFormErrorArgs = {
  data: FormErrorUpdateInput;
  where: FormErrorWhereUniqueInput;
};


export type MutationUpdateFormPasswordInputArgs = {
  data: FormPasswordInputUpdateInput;
  where: FormPasswordInputWhereUniqueInput;
};


export type MutationUpdateFormPasswordInputWithConfirmationArgs = {
  data: FormPasswordInputWithConfirmationUpdateInput;
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};


export type MutationUpdateFormRadioButtonArgs = {
  data: FormRadioButtonUpdateInput;
  where: FormRadioButtonWhereUniqueInput;
};


export type MutationUpdateFormRadioButtonCollectionArgs = {
  data: FormRadioButtonCollectionUpdateInput;
  where: FormRadioButtonCollectionWhereUniqueInput;
};


export type MutationUpdateFormSelectComponentArgs = {
  data: FormSelectComponentUpdateInput;
  where: FormSelectComponentWhereUniqueInput;
};


export type MutationUpdateFormSelectOptionArgs = {
  data: FormSelectOptionUpdateInput;
  where: FormSelectOptionWhereUniqueInput;
};


export type MutationUpdateFormSubmitButtonArgs = {
  data: FormSubmitButtonUpdateInput;
  where: FormSubmitButtonWhereUniqueInput;
};


export type MutationUpdateFormSuccessComponentArgs = {
  data: FormSuccessComponentUpdateInput;
  where: FormSuccessComponentWhereUniqueInput;
};


export type MutationUpdateFormTextInputArgs = {
  data: FormTextInputUpdateInput;
  where: FormTextInputWhereUniqueInput;
};


export type MutationUpdateFormTextareaInputArgs = {
  data: FormTextareaInputUpdateInput;
  where: FormTextareaInputWhereUniqueInput;
};


export type MutationUpdateGenericAccordionArgs = {
  data: GenericAccordionUpdateInput;
  where: GenericAccordionWhereUniqueInput;
};


export type MutationUpdateGenericAccordionItemArgs = {
  data: GenericAccordionItemUpdateInput;
  where: GenericAccordionItemWhereUniqueInput;
};


export type MutationUpdateGenericAccordionTopRatedArgs = {
  data: GenericAccordionTopRatedUpdateInput;
  where: GenericAccordionTopRatedWhereUniqueInput;
};


export type MutationUpdateGenericCardCarouseComponentArgs = {
  data: GenericCardCarouseComponentUpdateInput;
  where: GenericCardCarouseComponentWhereUniqueInput;
};


export type MutationUpdateGenericDownloadComponentArgs = {
  data: GenericDownloadComponentUpdateInput;
  where: GenericDownloadComponentWhereUniqueInput;
};


export type MutationUpdateGenericFollowUsArgs = {
  data: GenericFollowUsUpdateInput;
  where: GenericFollowUsWhereUniqueInput;
};


export type MutationUpdateGenericGridAuthorableArgs = {
  data: GenericGridAuthorableUpdateInput;
  where: GenericGridAuthorableWhereUniqueInput;
};


export type MutationUpdateGenericLineArgs = {
  data: GenericLineUpdateInput;
  where: GenericLineWhereUniqueInput;
};


export type MutationUpdateGenericLinkArgs = {
  data: GenericLinkUpdateInput;
  where: GenericLinkWhereUniqueInput;
};


export type MutationUpdateGenericPageArgs = {
  data: GenericPageUpdateInput;
  where: GenericPageWhereUniqueInput;
};


export type MutationUpdateGlobalMetaDataArgs = {
  data: GlobalMetaDataUpdateInput;
  where: GlobalMetaDataWhereUniqueInput;
};


export type MutationUpdateHeroBannerArgs = {
  data: HeroBannerUpdateInput;
  where: HeroBannerWhereUniqueInput;
};


export type MutationUpdateHeroCarouselComponentArgs = {
  data: HeroCarouselComponentUpdateInput;
  where: HeroCarouselComponentWhereUniqueInput;
};


export type MutationUpdateHeroComponentArgs = {
  data: HeroComponentUpdateInput;
  where: HeroComponentWhereUniqueInput;
};


export type MutationUpdateHomePageArgs = {
  data: HomePageUpdateInput;
  where: HomePageWhereUniqueInput;
};


export type MutationUpdateIframeArgs = {
  data: IframeUpdateInput;
  where: IframeWhereUniqueInput;
};


export type MutationUpdateImageAndTextCardArgs = {
  data: ImageAndTextCardUpdateInput;
  where: ImageAndTextCardWhereUniqueInput;
};


export type MutationUpdateImageCopyArgs = {
  data: ImageCopyUpdateInput;
  where: ImageCopyWhereUniqueInput;
};


export type MutationUpdateImageCopyItemArgs = {
  data: ImageCopyItemUpdateInput;
  where: ImageCopyItemWhereUniqueInput;
};


export type MutationUpdateIntroTextArgs = {
  data: IntroTextUpdateInput;
  where: IntroTextWhereUniqueInput;
};


export type MutationUpdateLeftColumnArgs = {
  data: LeftColumnUpdateInput;
  where: LeftColumnWhereUniqueInput;
};


export type MutationUpdateLinkArgs = {
  data: LinkUpdateInput;
  where: LinkWhereUniqueInput;
};


export type MutationUpdateLocationComponentArgs = {
  data: LocationComponentUpdateInput;
  where: LocationComponentWhereUniqueInput;
};


export type MutationUpdateLocationItemArgs = {
  data: LocationItemUpdateInput;
  where: LocationItemWhereUniqueInput;
};


export type MutationUpdateLongTextArgs = {
  data: LongTextUpdateInput;
  where: LongTextWhereUniqueInput;
};


export type MutationUpdateManyAccordionItemsArgs = {
  data: AccordionItemUpdateManyInput;
  where?: InputMaybe<AccordionItemManyWhereInput>;
};


export type MutationUpdateManyAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AccordionItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionItemManyWhereInput>;
};


export type MutationUpdateManyAccordionsArgs = {
  data: AccordionUpdateManyInput;
  where?: InputMaybe<AccordionManyWhereInput>;
};


export type MutationUpdateManyAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AccordionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AccordionManyWhereInput>;
};


export type MutationUpdateManyAlexTestComponentsArgs = {
  data: AlexTestComponentUpdateManyInput;
  where?: InputMaybe<AlexTestComponentManyWhereInput>;
};


export type MutationUpdateManyAlexTestComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AlexTestComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AlexTestComponentManyWhereInput>;
};


export type MutationUpdateManyAlgoliaExtensionsArgs = {
  data: AlgoliaExtensionUpdateManyInput;
  where?: InputMaybe<AlgoliaExtensionManyWhereInput>;
};


export type MutationUpdateManyAlgoliaExtensionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AlgoliaExtensionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AlgoliaExtensionManyWhereInput>;
};


export type MutationUpdateManyAnchorNavigationListsArgs = {
  data: AnchorNavigationListUpdateManyInput;
  where?: InputMaybe<AnchorNavigationListManyWhereInput>;
};


export type MutationUpdateManyAnchorNavigationListsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AnchorNavigationListUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorNavigationListManyWhereInput>;
};


export type MutationUpdateManyAnchorNavigationsArgs = {
  data: AnchorNavigationUpdateManyInput;
  where?: InputMaybe<AnchorNavigationManyWhereInput>;
};


export type MutationUpdateManyAnchorNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AnchorNavigationUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorNavigationManyWhereInput>;
};


export type MutationUpdateManyAnchorNavsArgs = {
  data: AnchorNavUpdateManyInput;
  where?: InputMaybe<AnchorNavManyWhereInput>;
};


export type MutationUpdateManyAnchorNavsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AnchorNavUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnchorNavManyWhereInput>;
};


export type MutationUpdateManyAssetsArgs = {
  data: AssetUpdateManyInput;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUpdateManyAssetsComponentsArgs = {
  data: AssetComponentUpdateManyInput;
  where?: InputMaybe<AssetComponentManyWhereInput>;
};


export type MutationUpdateManyAssetsComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AssetComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentManyWhereInput>;
};


export type MutationUpdateManyAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AssetUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetManyWhereInput>;
};


export type MutationUpdateManyAudioComponentsArgs = {
  data: AudioComponentUpdateManyInput;
  where?: InputMaybe<AudioComponentManyWhereInput>;
};


export type MutationUpdateManyAudioComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AudioComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AudioComponentManyWhereInput>;
};


export type MutationUpdateManyAuthorableContentCardsArgs = {
  data: AuthorableContentCardUpdateManyInput;
  where?: InputMaybe<AuthorableContentCardManyWhereInput>;
};


export type MutationUpdateManyAuthorableContentCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: AuthorableContentCardUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AuthorableContentCardManyWhereInput>;
};


export type MutationUpdateManyBanner2SArgs = {
  data: Banner2UpdateManyInput;
  where?: InputMaybe<Banner2ManyWhereInput>;
};


export type MutationUpdateManyBanner2SConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: Banner2UpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Banner2ManyWhereInput>;
};


export type MutationUpdateManyBigNumberItemsArgs = {
  data: BigNumberItemUpdateManyInput;
  where?: InputMaybe<BigNumberItemManyWhereInput>;
};


export type MutationUpdateManyBigNumberItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: BigNumberItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BigNumberItemManyWhereInput>;
};


export type MutationUpdateManyBigNumbersArgs = {
  data: BigNumberUpdateManyInput;
  where?: InputMaybe<BigNumberManyWhereInput>;
};


export type MutationUpdateManyBigNumbersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: BigNumberUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BigNumberManyWhereInput>;
};


export type MutationUpdateManyCardComponentsArgs = {
  data: CardComponentUpdateManyInput;
  where?: InputMaybe<CardComponentManyWhereInput>;
};


export type MutationUpdateManyCardComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CardComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CardComponentManyWhereInput>;
};


export type MutationUpdateManyCarouselComponentsArgs = {
  data: CarouselComponentUpdateManyInput;
  where?: InputMaybe<CarouselComponentManyWhereInput>;
};


export type MutationUpdateManyCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CarouselComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselComponentManyWhereInput>;
};


export type MutationUpdateManyCarouselSlidesArgs = {
  data: CarouselSlideUpdateManyInput;
  where?: InputMaybe<CarouselSlideManyWhereInput>;
};


export type MutationUpdateManyCarouselSlidesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CarouselSlideUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CarouselSlideManyWhereInput>;
};


export type MutationUpdateManyCategoryCardsArgs = {
  data: CategoryCardUpdateManyInput;
  where?: InputMaybe<CategoryCardManyWhereInput>;
};


export type MutationUpdateManyCategoryCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CategoryCardUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryCardManyWhereInput>;
};


export type MutationUpdateManyContactCardContainersArgs = {
  data: ContactCardContainerUpdateManyInput;
  where?: InputMaybe<ContactCardContainerManyWhereInput>;
};


export type MutationUpdateManyContactCardContainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ContactCardContainerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContactCardContainerManyWhereInput>;
};


export type MutationUpdateManyContactCardsArgs = {
  data: ContactCardUpdateManyInput;
  where?: InputMaybe<ContactCardManyWhereInput>;
};


export type MutationUpdateManyContactCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ContactCardUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ContactCardManyWhereInput>;
};


export type MutationUpdateManyCorpAddToCalendarsArgs = {
  data: CorpAddToCalendarUpdateManyInput;
  where?: InputMaybe<CorpAddToCalendarManyWhereInput>;
};


export type MutationUpdateManyCorpAddToCalendarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpAddToCalendarUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpAddToCalendarManyWhereInput>;
};


export type MutationUpdateManyCorpBanners1Args = {
  data: CorpBanner1UpdateManyInput;
  where?: InputMaybe<CorpBanner1ManyWhereInput>;
};


export type MutationUpdateManyCorpBanners1ConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpBanner1UpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpBanner1ManyWhereInput>;
};


export type MutationUpdateManyCorpCalendarEventsArgs = {
  data: CorpCalendarEventUpdateManyInput;
  where?: InputMaybe<CorpCalendarEventManyWhereInput>;
};


export type MutationUpdateManyCorpCalendarEventsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpCalendarEventUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpCalendarEventManyWhereInput>;
};


export type MutationUpdateManyCorpCardCarouselsArgs = {
  data: CorpCardCarouselUpdateManyInput;
  where?: InputMaybe<CorpCardCarouselManyWhereInput>;
};


export type MutationUpdateManyCorpCardCarouselsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpCardCarouselUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpCardCarouselManyWhereInput>;
};


export type MutationUpdateManyCorpContactCardContainersArgs = {
  data: CorpContactCardContainerUpdateManyInput;
  where?: InputMaybe<CorpContactCardContainerManyWhereInput>;
};


export type MutationUpdateManyCorpContactCardContainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpContactCardContainerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpContactCardContainerManyWhereInput>;
};


export type MutationUpdateManyCorpContactCardsArgs = {
  data: CorpContactCardUpdateManyInput;
  where?: InputMaybe<CorpContactCardManyWhereInput>;
};


export type MutationUpdateManyCorpContactCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpContactCardUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpContactCardManyWhereInput>;
};


export type MutationUpdateManyCorpFormsArgs = {
  data: CorpFormUpdateManyInput;
  where?: InputMaybe<CorpFormManyWhereInput>;
};


export type MutationUpdateManyCorpFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpFormUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpFormManyWhereInput>;
};


export type MutationUpdateManyCorpGenericAccordionItemsArgs = {
  data: CorpGenericAccordionItemUpdateManyInput;
  where?: InputMaybe<CorpGenericAccordionItemManyWhereInput>;
};


export type MutationUpdateManyCorpGenericAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpGenericAccordionItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericAccordionItemManyWhereInput>;
};


export type MutationUpdateManyCorpGenericAccordionsArgs = {
  data: CorpGenericAccordionUpdateManyInput;
  where?: InputMaybe<CorpGenericAccordionManyWhereInput>;
};


export type MutationUpdateManyCorpGenericAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpGenericAccordionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericAccordionManyWhereInput>;
};


export type MutationUpdateManyCorpGenericBannersArgs = {
  data: CorpGenericBannerUpdateManyInput;
  where?: InputMaybe<CorpGenericBannerManyWhereInput>;
};


export type MutationUpdateManyCorpGenericBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpGenericBannerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericBannerManyWhereInput>;
};


export type MutationUpdateManyCorpGenericContainersArgs = {
  data: CorpGenericContainerUpdateManyInput;
  where?: InputMaybe<CorpGenericContainerManyWhereInput>;
};


export type MutationUpdateManyCorpGenericContainersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpGenericContainerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericContainerManyWhereInput>;
};


export type MutationUpdateManyCorpGridColumnComponentsArgs = {
  data: CorpGridColumnComponentUpdateManyInput;
  where?: InputMaybe<CorpGridColumnComponentManyWhereInput>;
};


export type MutationUpdateManyCorpGridColumnComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpGridColumnComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGridColumnComponentManyWhereInput>;
};


export type MutationUpdateManyCorpHerosArgs = {
  data: CorpHeroUpdateManyInput;
  where?: InputMaybe<CorpHeroManyWhereInput>;
};


export type MutationUpdateManyCorpHerosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpHeroUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpHeroManyWhereInput>;
};


export type MutationUpdateManyCorpMediaDownloadPreviewsArgs = {
  data: CorpMediaDownloadPreviewUpdateManyInput;
  where?: InputMaybe<CorpMediaDownloadPreviewManyWhereInput>;
};


export type MutationUpdateManyCorpMediaDownloadPreviewsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpMediaDownloadPreviewUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpMediaDownloadPreviewManyWhereInput>;
};


export type MutationUpdateManyCorpNavigationItemsArgs = {
  data: CorpNavigationItemUpdateManyInput;
  where?: InputMaybe<CorpNavigationItemManyWhereInput>;
};


export type MutationUpdateManyCorpNavigationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpNavigationItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpNavigationItemManyWhereInput>;
};


export type MutationUpdateManyCorpNavigationsArgs = {
  data: CorpNavigationUpdateManyInput;
  where?: InputMaybe<CorpNavigationManyWhereInput>;
};


export type MutationUpdateManyCorpNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpNavigationUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpNavigationManyWhereInput>;
};


export type MutationUpdateManyCorpNotificationBannersArgs = {
  data: CorpNotificationBannerUpdateManyInput;
  where?: InputMaybe<CorpNotificationBannerManyWhereInput>;
};


export type MutationUpdateManyCorpNotificationBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpNotificationBannerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpNotificationBannerManyWhereInput>;
};


export type MutationUpdateManyCorpOurPeopleItemsArgs = {
  data: CorpOurPeopleItemUpdateManyInput;
  where?: InputMaybe<CorpOurPeopleItemManyWhereInput>;
};


export type MutationUpdateManyCorpOurPeopleItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpOurPeopleItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpOurPeopleItemManyWhereInput>;
};


export type MutationUpdateManyCorpOurPeoplesArgs = {
  data: CorpOurPeopleUpdateManyInput;
  where?: InputMaybe<CorpOurPeopleManyWhereInput>;
};


export type MutationUpdateManyCorpOurPeoplesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpOurPeopleUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpOurPeopleManyWhereInput>;
};


export type MutationUpdateManyCorpPressPagesArgs = {
  data: CorpPressPageUpdateManyInput;
  where?: InputMaybe<CorpPressPageManyWhereInput>;
};


export type MutationUpdateManyCorpPressPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpPressPageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpPressPageManyWhereInput>;
};


export type MutationUpdateManyCorpSocialMediaFootersArgs = {
  data: CorpSocialMediaFooterUpdateManyInput;
  where?: InputMaybe<CorpSocialMediaFooterManyWhereInput>;
};


export type MutationUpdateManyCorpSocialMediaFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpSocialMediaFooterUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpSocialMediaFooterManyWhereInput>;
};


export type MutationUpdateManyCorpStoriesPagesArgs = {
  data: CorpStoriesPageUpdateManyInput;
  where?: InputMaybe<CorpStoriesPageManyWhereInput>;
};


export type MutationUpdateManyCorpStoriesPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpStoriesPageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpStoriesPageManyWhereInput>;
};


export type MutationUpdateManyCorpStoryCarouselsArgs = {
  data: CorpStoryCarouselUpdateManyInput;
  where?: InputMaybe<CorpStoryCarouselManyWhereInput>;
};


export type MutationUpdateManyCorpStoryCarouselsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpStoryCarouselUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpStoryCarouselManyWhereInput>;
};


export type MutationUpdateManyCorpTimelineAccordionItemsArgs = {
  data: CorpTimelineAccordionItemUpdateManyInput;
  where?: InputMaybe<CorpTimelineAccordionItemManyWhereInput>;
};


export type MutationUpdateManyCorpTimelineAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpTimelineAccordionItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpTimelineAccordionItemManyWhereInput>;
};


export type MutationUpdateManyCorpTimelineAccordionWrappersArgs = {
  data: CorpTimelineAccordionWrapperUpdateManyInput;
  where?: InputMaybe<CorpTimelineAccordionWrapperManyWhereInput>;
};


export type MutationUpdateManyCorpTimelineAccordionWrappersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpTimelineAccordionWrapperUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpTimelineAccordionWrapperManyWhereInput>;
};


export type MutationUpdateManyCorpTimelineAccordionsArgs = {
  data: CorpTimelineAccordionUpdateManyInput;
  where?: InputMaybe<CorpTimelineAccordionManyWhereInput>;
};


export type MutationUpdateManyCorpTimelineAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpTimelineAccordionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpTimelineAccordionManyWhereInput>;
};


export type MutationUpdateManyCorpVideoHeroCarouselsArgs = {
  data: CorpVideoHeroCarouselUpdateManyInput;
  where?: InputMaybe<CorpVideoHeroCarouselManyWhereInput>;
};


export type MutationUpdateManyCorpVideoHeroCarouselsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpVideoHeroCarouselUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpVideoHeroCarouselManyWhereInput>;
};


export type MutationUpdateManyCorpVideoHerosArgs = {
  data: CorpVideoHeroUpdateManyInput;
  where?: InputMaybe<CorpVideoHeroManyWhereInput>;
};


export type MutationUpdateManyCorpVideoHerosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CorpVideoHeroUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpVideoHeroManyWhereInput>;
};


export type MutationUpdateManyCountrySelectorItemsArgs = {
  data: CountrySelectorItemUpdateManyInput;
  where?: InputMaybe<CountrySelectorItemManyWhereInput>;
};


export type MutationUpdateManyCountrySelectorItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CountrySelectorItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountrySelectorItemManyWhereInput>;
};


export type MutationUpdateManyCountrySelectorsArgs = {
  data: CountrySelectorUpdateManyInput;
  where?: InputMaybe<CountrySelectorManyWhereInput>;
};


export type MutationUpdateManyCountrySelectorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: CountrySelectorUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CountrySelectorManyWhereInput>;
};


export type MutationUpdateManyDeprecatedBanner1sArgs = {
  data: DeprecatedBanner1UpdateManyInput;
  where?: InputMaybe<DeprecatedBanner1ManyWhereInput>;
};


export type MutationUpdateManyDeprecatedBanner1sConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: DeprecatedBanner1UpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeprecatedBanner1ManyWhereInput>;
};


export type MutationUpdateManyDeprecatedCorpNavigationsArgs = {
  data: DeprecatedCorpNavigationCopyUpdateManyInput;
  where?: InputMaybe<DeprecatedCorpNavigationCopyManyWhereInput>;
};


export type MutationUpdateManyDeprecatedCorpNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: DeprecatedCorpNavigationCopyUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeprecatedCorpNavigationCopyManyWhereInput>;
};


export type MutationUpdateManyDictionariesArgs = {
  data: DictionaryUpdateManyInput;
  where?: InputMaybe<DictionaryManyWhereInput>;
};


export type MutationUpdateManyDictionariesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: DictionaryUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DictionaryManyWhereInput>;
};


export type MutationUpdateManyDictionaryItemsArgs = {
  data: DictionaryItemUpdateManyInput;
  where?: InputMaybe<DictionaryItemManyWhereInput>;
};


export type MutationUpdateManyDictionaryItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: DictionaryItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DictionaryItemManyWhereInput>;
};


export type MutationUpdateManyDynamicCardGridsArgs = {
  data: DynamicCardGridUpdateManyInput;
  where?: InputMaybe<DynamicCardGridManyWhereInput>;
};


export type MutationUpdateManyDynamicCardGridsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: DynamicCardGridUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DynamicCardGridManyWhereInput>;
};


export type MutationUpdateManyEvalancheFormComponentsArgs = {
  data: EvalancheFormComponentUpdateManyInput;
  where?: InputMaybe<EvalancheFormComponentManyWhereInput>;
};


export type MutationUpdateManyEvalancheFormComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: EvalancheFormComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<EvalancheFormComponentManyWhereInput>;
};


export type MutationUpdateManyExampleComponentsArgs = {
  data: ExampleComponentUpdateManyInput;
  where?: InputMaybe<ExampleComponentManyWhereInput>;
};


export type MutationUpdateManyExampleComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ExampleComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ExampleComponentManyWhereInput>;
};


export type MutationUpdateManyFeaturedContentReferencesArgs = {
  data: FeaturedContentReferenceUpdateManyInput;
  where?: InputMaybe<FeaturedContentReferenceManyWhereInput>;
};


export type MutationUpdateManyFeaturedContentReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FeaturedContentReferenceUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FeaturedContentReferenceManyWhereInput>;
};


export type MutationUpdateManyFeaturedContentsArgs = {
  data: FeaturedContentUpdateManyInput;
  where?: InputMaybe<FeaturedContentManyWhereInput>;
};


export type MutationUpdateManyFeaturedContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FeaturedContentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FeaturedContentManyWhereInput>;
};


export type MutationUpdateManyFooterNavigationsArgs = {
  data: FooterNavigationUpdateManyInput;
  where?: InputMaybe<FooterNavigationManyWhereInput>;
};


export type MutationUpdateManyFooterNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FooterNavigationUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FooterNavigationManyWhereInput>;
};


export type MutationUpdateManyFormCheckboxesArgs = {
  data: FormCheckboxUpdateManyInput;
  where?: InputMaybe<FormCheckboxManyWhereInput>;
};


export type MutationUpdateManyFormCheckboxesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormCheckboxUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormCheckboxManyWhereInput>;
};


export type MutationUpdateManyFormEmailInputsArgs = {
  data: FormEmailInputUpdateManyInput;
  where?: InputMaybe<FormEmailInputManyWhereInput>;
};


export type MutationUpdateManyFormEmailInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormEmailInputUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormEmailInputManyWhereInput>;
};


export type MutationUpdateManyFormErrorsArgs = {
  data: FormErrorUpdateManyInput;
  where?: InputMaybe<FormErrorManyWhereInput>;
};


export type MutationUpdateManyFormErrorsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormErrorUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormErrorManyWhereInput>;
};


export type MutationUpdateManyFormPasswordInputWithConfirmationsArgs = {
  data: FormPasswordInputWithConfirmationUpdateManyInput;
  where?: InputMaybe<FormPasswordInputWithConfirmationManyWhereInput>;
};


export type MutationUpdateManyFormPasswordInputWithConfirmationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormPasswordInputWithConfirmationUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormPasswordInputWithConfirmationManyWhereInput>;
};


export type MutationUpdateManyFormPasswordInputsArgs = {
  data: FormPasswordInputUpdateManyInput;
  where?: InputMaybe<FormPasswordInputManyWhereInput>;
};


export type MutationUpdateManyFormPasswordInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormPasswordInputUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormPasswordInputManyWhereInput>;
};


export type MutationUpdateManyFormRadioButtonCollectionsArgs = {
  data: FormRadioButtonCollectionUpdateManyInput;
  where?: InputMaybe<FormRadioButtonCollectionManyWhereInput>;
};


export type MutationUpdateManyFormRadioButtonCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormRadioButtonCollectionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormRadioButtonCollectionManyWhereInput>;
};


export type MutationUpdateManyFormRadioButtonsArgs = {
  data: FormRadioButtonUpdateManyInput;
  where?: InputMaybe<FormRadioButtonManyWhereInput>;
};


export type MutationUpdateManyFormRadioButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormRadioButtonUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormRadioButtonManyWhereInput>;
};


export type MutationUpdateManyFormSelectComponentsArgs = {
  data: FormSelectComponentUpdateManyInput;
  where?: InputMaybe<FormSelectComponentManyWhereInput>;
};


export type MutationUpdateManyFormSelectComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormSelectComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSelectComponentManyWhereInput>;
};


export type MutationUpdateManyFormSelectOptionsArgs = {
  data: FormSelectOptionUpdateManyInput;
  where?: InputMaybe<FormSelectOptionManyWhereInput>;
};


export type MutationUpdateManyFormSelectOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormSelectOptionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSelectOptionManyWhereInput>;
};


export type MutationUpdateManyFormSubmitButtonsArgs = {
  data: FormSubmitButtonUpdateManyInput;
  where?: InputMaybe<FormSubmitButtonManyWhereInput>;
};


export type MutationUpdateManyFormSubmitButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormSubmitButtonUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSubmitButtonManyWhereInput>;
};


export type MutationUpdateManyFormSuccessComponentsArgs = {
  data: FormSuccessComponentUpdateManyInput;
  where?: InputMaybe<FormSuccessComponentManyWhereInput>;
};


export type MutationUpdateManyFormSuccessComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormSuccessComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormSuccessComponentManyWhereInput>;
};


export type MutationUpdateManyFormTextInputsArgs = {
  data: FormTextInputUpdateManyInput;
  where?: InputMaybe<FormTextInputManyWhereInput>;
};


export type MutationUpdateManyFormTextInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormTextInputUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormTextInputManyWhereInput>;
};


export type MutationUpdateManyFormTextareaInputsArgs = {
  data: FormTextareaInputUpdateManyInput;
  where?: InputMaybe<FormTextareaInputManyWhereInput>;
};


export type MutationUpdateManyFormTextareaInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormTextareaInputUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormTextareaInputManyWhereInput>;
};


export type MutationUpdateManyFormsArgs = {
  data: FormUpdateManyInput;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationUpdateManyFormsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: FormUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FormManyWhereInput>;
};


export type MutationUpdateManyGenericAccordionItemsArgs = {
  data: GenericAccordionItemUpdateManyInput;
  where?: InputMaybe<GenericAccordionItemManyWhereInput>;
};


export type MutationUpdateManyGenericAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericAccordionItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionItemManyWhereInput>;
};


export type MutationUpdateManyGenericAccordionTopRatedsArgs = {
  data: GenericAccordionTopRatedUpdateManyInput;
  where?: InputMaybe<GenericAccordionTopRatedManyWhereInput>;
};


export type MutationUpdateManyGenericAccordionTopRatedsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericAccordionTopRatedUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionTopRatedManyWhereInput>;
};


export type MutationUpdateManyGenericAccordionsArgs = {
  data: GenericAccordionUpdateManyInput;
  where?: InputMaybe<GenericAccordionManyWhereInput>;
};


export type MutationUpdateManyGenericAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericAccordionUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericAccordionManyWhereInput>;
};


export type MutationUpdateManyGenericCardCarouseComponentsArgs = {
  data: GenericCardCarouseComponentUpdateManyInput;
  where?: InputMaybe<GenericCardCarouseComponentManyWhereInput>;
};


export type MutationUpdateManyGenericCardCarouseComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericCardCarouseComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericCardCarouseComponentManyWhereInput>;
};


export type MutationUpdateManyGenericDownloadComponentsArgs = {
  data: GenericDownloadComponentUpdateManyInput;
  where?: InputMaybe<GenericDownloadComponentManyWhereInput>;
};


export type MutationUpdateManyGenericDownloadComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericDownloadComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericDownloadComponentManyWhereInput>;
};


export type MutationUpdateManyGenericFollowUsesArgs = {
  data: GenericFollowUsUpdateManyInput;
  where?: InputMaybe<GenericFollowUsManyWhereInput>;
};


export type MutationUpdateManyGenericFollowUsesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericFollowUsUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericFollowUsManyWhereInput>;
};


export type MutationUpdateManyGenericGridAuthorablesArgs = {
  data: GenericGridAuthorableUpdateManyInput;
  where?: InputMaybe<GenericGridAuthorableManyWhereInput>;
};


export type MutationUpdateManyGenericGridAuthorablesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericGridAuthorableUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericGridAuthorableManyWhereInput>;
};


export type MutationUpdateManyGenericLinesArgs = {
  data: GenericLineUpdateManyInput;
  where?: InputMaybe<GenericLineManyWhereInput>;
};


export type MutationUpdateManyGenericLinesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericLineUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericLineManyWhereInput>;
};


export type MutationUpdateManyGenericLinksArgs = {
  data: GenericLinkUpdateManyInput;
  where?: InputMaybe<GenericLinkManyWhereInput>;
};


export type MutationUpdateManyGenericLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericLinkUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericLinkManyWhereInput>;
};


export type MutationUpdateManyGenericPagesArgs = {
  data: GenericPageUpdateManyInput;
  where?: InputMaybe<GenericPageManyWhereInput>;
};


export type MutationUpdateManyGenericPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GenericPageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageManyWhereInput>;
};


export type MutationUpdateManyGlobalMetaDatasArgs = {
  data: GlobalMetaDataUpdateManyInput;
  where?: InputMaybe<GlobalMetaDataManyWhereInput>;
};


export type MutationUpdateManyGlobalMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: GlobalMetaDataUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GlobalMetaDataManyWhereInput>;
};


export type MutationUpdateManyHeroBannersArgs = {
  data: HeroBannerUpdateManyInput;
  where?: InputMaybe<HeroBannerManyWhereInput>;
};


export type MutationUpdateManyHeroBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: HeroBannerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroBannerManyWhereInput>;
};


export type MutationUpdateManyHeroCarouselComponentsArgs = {
  data: HeroCarouselComponentUpdateManyInput;
  where?: InputMaybe<HeroCarouselComponentManyWhereInput>;
};


export type MutationUpdateManyHeroCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: HeroCarouselComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroCarouselComponentManyWhereInput>;
};


export type MutationUpdateManyHeroComponentsArgs = {
  data: HeroComponentUpdateManyInput;
  where?: InputMaybe<HeroComponentManyWhereInput>;
};


export type MutationUpdateManyHeroComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: HeroComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HeroComponentManyWhereInput>;
};


export type MutationUpdateManyHomePagesArgs = {
  data: HomePageUpdateManyInput;
  where?: InputMaybe<HomePageManyWhereInput>;
};


export type MutationUpdateManyHomePagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: HomePageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<HomePageManyWhereInput>;
};


export type MutationUpdateManyIframesArgs = {
  data: IframeUpdateManyInput;
  where?: InputMaybe<IframeManyWhereInput>;
};


export type MutationUpdateManyIframesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: IframeUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IframeManyWhereInput>;
};


export type MutationUpdateManyImageAndTextCardsArgs = {
  data: ImageAndTextCardUpdateManyInput;
  where?: InputMaybe<ImageAndTextCardManyWhereInput>;
};


export type MutationUpdateManyImageAndTextCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ImageAndTextCardUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageAndTextCardManyWhereInput>;
};


export type MutationUpdateManyImageCopiesArgs = {
  data: ImageCopyUpdateManyInput;
  where?: InputMaybe<ImageCopyManyWhereInput>;
};


export type MutationUpdateManyImageCopiesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ImageCopyUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageCopyManyWhereInput>;
};


export type MutationUpdateManyImageCopyItemsArgs = {
  data: ImageCopyItemUpdateManyInput;
  where?: InputMaybe<ImageCopyItemManyWhereInput>;
};


export type MutationUpdateManyImageCopyItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ImageCopyItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ImageCopyItemManyWhereInput>;
};


export type MutationUpdateManyIntroTextsArgs = {
  data: IntroTextUpdateManyInput;
  where?: InputMaybe<IntroTextManyWhereInput>;
};


export type MutationUpdateManyIntroTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: IntroTextUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<IntroTextManyWhereInput>;
};


export type MutationUpdateManyLeftColumnsArgs = {
  data: LeftColumnUpdateManyInput;
  where?: InputMaybe<LeftColumnManyWhereInput>;
};


export type MutationUpdateManyLeftColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: LeftColumnUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LeftColumnManyWhereInput>;
};


export type MutationUpdateManyLinksArgs = {
  data: LinkUpdateManyInput;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationUpdateManyLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: LinkUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkManyWhereInput>;
};


export type MutationUpdateManyLocationComponentsArgs = {
  data: LocationComponentUpdateManyInput;
  where?: InputMaybe<LocationComponentManyWhereInput>;
};


export type MutationUpdateManyLocationComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: LocationComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LocationComponentManyWhereInput>;
};


export type MutationUpdateManyLocationItemsArgs = {
  data: LocationItemUpdateManyInput;
  where?: InputMaybe<LocationItemManyWhereInput>;
};


export type MutationUpdateManyLocationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: LocationItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LocationItemManyWhereInput>;
};


export type MutationUpdateManyLongTextsArgs = {
  data: LongTextUpdateManyInput;
  where?: InputMaybe<LongTextManyWhereInput>;
};


export type MutationUpdateManyLongTextsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: LongTextUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LongTextManyWhereInput>;
};


export type MutationUpdateManyMediaLibrariesArgs = {
  data: MediaLibraryUpdateManyInput;
  where?: InputMaybe<MediaLibraryManyWhereInput>;
};


export type MutationUpdateManyMediaLibrariesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: MediaLibraryUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MediaLibraryManyWhereInput>;
};


export type MutationUpdateManyMediaLibraryItemsArgs = {
  data: MediaLibraryItemUpdateManyInput;
  where?: InputMaybe<MediaLibraryItemManyWhereInput>;
};


export type MutationUpdateManyMediaLibraryItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: MediaLibraryItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MediaLibraryItemManyWhereInput>;
};


export type MutationUpdateManyMetaDatasArgs = {
  data: MetaDataUpdateManyInput;
  where?: InputMaybe<MetaDataManyWhereInput>;
};


export type MutationUpdateManyMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: MetaDataUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MetaDataManyWhereInput>;
};


export type MutationUpdateManyMobileOnlyMainNavigationsArgs = {
  data: MobileOnlyMainNavigationUpdateManyInput;
  where?: InputMaybe<MobileOnlyMainNavigationManyWhereInput>;
};


export type MutationUpdateManyMobileOnlyMainNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: MobileOnlyMainNavigationUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MobileOnlyMainNavigationManyWhereInput>;
};


export type MutationUpdateManyNavigationItemsArgs = {
  data: NavigationItemUpdateManyInput;
  where?: InputMaybe<NavigationItemManyWhereInput>;
};


export type MutationUpdateManyNavigationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: NavigationItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationItemManyWhereInput>;
};


export type MutationUpdateManyNavigationsArgs = {
  data: NavigationUpdateManyInput;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationUpdateManyNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: NavigationUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NavigationManyWhereInput>;
};


export type MutationUpdateManyNotificationBannersArgs = {
  data: NotificationBannerUpdateManyInput;
  where?: InputMaybe<NotificationBannerManyWhereInput>;
};


export type MutationUpdateManyNotificationBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: NotificationBannerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<NotificationBannerManyWhereInput>;
};


export type MutationUpdateManyPageFootersArgs = {
  data: PageFooterUpdateManyInput;
  where?: InputMaybe<PageFooterManyWhereInput>;
};


export type MutationUpdateManyPageFootersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: PageFooterUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageFooterManyWhereInput>;
};


export type MutationUpdateManyPageHeadersArgs = {
  data: PageHeaderUpdateManyInput;
  where?: InputMaybe<PageHeaderManyWhereInput>;
};


export type MutationUpdateManyPageHeadersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: PageHeaderUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PageHeaderManyWhereInput>;
};


export type MutationUpdateManyPopularSearchComponentsArgs = {
  data: PopularSearchComponentUpdateManyInput;
  where?: InputMaybe<PopularSearchComponentManyWhereInput>;
};


export type MutationUpdateManyPopularSearchComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: PopularSearchComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PopularSearchComponentManyWhereInput>;
};


export type MutationUpdateManyPressReleasesArgs = {
  data: PressReleaseUpdateManyInput;
  where?: InputMaybe<PressReleaseManyWhereInput>;
};


export type MutationUpdateManyPressReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: PressReleaseUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PressReleaseManyWhereInput>;
};


export type MutationUpdateManyPressStoriesCardsArgs = {
  data: PressStoriesCardUpdateManyInput;
  where?: InputMaybe<PressStoriesCardManyWhereInput>;
};


export type MutationUpdateManyPressStoriesCardsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: PressStoriesCardUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PressStoriesCardManyWhereInput>;
};


export type MutationUpdateManyProgressBarsArgs = {
  data: ProgressBarUpdateManyInput;
  where?: InputMaybe<ProgressBarManyWhereInput>;
};


export type MutationUpdateManyProgressBarsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ProgressBarUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ProgressBarManyWhereInput>;
};


export type MutationUpdateManyQuickLinkItemsArgs = {
  data: QuickLinkItemUpdateManyInput;
  where?: InputMaybe<QuickLinkItemManyWhereInput>;
};


export type MutationUpdateManyQuickLinkItemsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: QuickLinkItemUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuickLinkItemManyWhereInput>;
};


export type MutationUpdateManyQuickLinksArgs = {
  data: QuickLinkUpdateManyInput;
  where?: InputMaybe<QuickLinkManyWhereInput>;
};


export type MutationUpdateManyQuickLinksConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: QuickLinkUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuickLinkManyWhereInput>;
};


export type MutationUpdateManyRedirectsArgs = {
  data: RedirectUpdateManyInput;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationUpdateManyRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: RedirectUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RedirectManyWhereInput>;
};


export type MutationUpdateManyRewritesArgs = {
  data: RewriteUpdateManyInput;
  where?: InputMaybe<RewriteManyWhereInput>;
};


export type MutationUpdateManyRewritesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: RewriteUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RewriteManyWhereInput>;
};


export type MutationUpdateManyRightColumnsArgs = {
  data: RightColumnUpdateManyInput;
  where?: InputMaybe<RightColumnManyWhereInput>;
};


export type MutationUpdateManyRightColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: RightColumnUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RightColumnManyWhereInput>;
};


export type MutationUpdateManySearchInputsArgs = {
  data: SearchInputUpdateManyInput;
  where?: InputMaybe<SearchInputManyWhereInput>;
};


export type MutationUpdateManySearchInputsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SearchInputUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SearchInputManyWhereInput>;
};


export type MutationUpdateManySearchOverlayComponentsArgs = {
  data: SearchOverlayComponentUpdateManyInput;
  where?: InputMaybe<SearchOverlayComponentManyWhereInput>;
};


export type MutationUpdateManySearchOverlayComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SearchOverlayComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SearchOverlayComponentManyWhereInput>;
};


export type MutationUpdateManySearchResultPagesArgs = {
  data: SearchResultPageUpdateManyInput;
  where?: InputMaybe<SearchResultPageManyWhereInput>;
};


export type MutationUpdateManySearchResultPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SearchResultPageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SearchResultPageManyWhereInput>;
};


export type MutationUpdateManyShortHeroesArgs = {
  data: ShortHeroUpdateManyInput;
  where?: InputMaybe<ShortHeroManyWhereInput>;
};


export type MutationUpdateManyShortHeroesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: ShortHeroUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ShortHeroManyWhereInput>;
};


export type MutationUpdateManySocialMediaListComponentsArgs = {
  data: SocialMediaListComponentUpdateManyInput;
  where?: InputMaybe<SocialMediaListComponentManyWhereInput>;
};


export type MutationUpdateManySocialMediaListComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SocialMediaListComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SocialMediaListComponentManyWhereInput>;
};


export type MutationUpdateManySpacersArgs = {
  data: SpacerUpdateManyInput;
  where?: InputMaybe<SpacerManyWhereInput>;
};


export type MutationUpdateManySpacersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SpacerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SpacerManyWhereInput>;
};


export type MutationUpdateManyStoriesArgs = {
  data: StoryUpdateManyInput;
  where?: InputMaybe<StoryManyWhereInput>;
};


export type MutationUpdateManyStoriesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: StoryUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryManyWhereInput>;
};


export type MutationUpdateManySubCategoryKeyImagesArgs = {
  data: SubCategoryKeyImageUpdateManyInput;
  where?: InputMaybe<SubCategoryKeyImageManyWhereInput>;
};


export type MutationUpdateManySubCategoryKeyImagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SubCategoryKeyImageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SubCategoryKeyImageManyWhereInput>;
};


export type MutationUpdateManySustainabilityBannersArgs = {
  data: SustainabilityBannerUpdateManyInput;
  where?: InputMaybe<SustainabilityBannerManyWhereInput>;
};


export type MutationUpdateManySustainabilityBannersConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SustainabilityBannerUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SustainabilityBannerManyWhereInput>;
};


export type MutationUpdateManySustainabilityInfosArgs = {
  data: SustainabilityInfoUpdateManyInput;
  where?: InputMaybe<SustainabilityInfoManyWhereInput>;
};


export type MutationUpdateManySustainabilityInfosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: SustainabilityInfoUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SustainabilityInfoManyWhereInput>;
};


export type MutationUpdateManyTabContentsArgs = {
  data: TabContentUpdateManyInput;
  where?: InputMaybe<TabContentManyWhereInput>;
};


export type MutationUpdateManyTabContentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TabContentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabContentManyWhereInput>;
};


export type MutationUpdateManyTabsArgs = {
  data: TabUpdateManyInput;
  where?: InputMaybe<TabManyWhereInput>;
};


export type MutationUpdateManyTabsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TabUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabManyWhereInput>;
};


export type MutationUpdateManyTestTipsANdTricksInAMarketsArgs = {
  data: TestTipsANdTricksInAMarketUpdateManyInput;
  where?: InputMaybe<TestTipsANdTricksInAMarketManyWhereInput>;
};


export type MutationUpdateManyTestTipsANdTricksInAMarketsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TestTipsANdTricksInAMarketUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TestTipsANdTricksInAMarketManyWhereInput>;
};


export type MutationUpdateManyTextComponentsArgs = {
  data: TextComponentUpdateManyInput;
  where?: InputMaybe<TextComponentManyWhereInput>;
};


export type MutationUpdateManyTextComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TextComponentUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TextComponentManyWhereInput>;
};


export type MutationUpdateManyTipsAndTricksDetailsPagesArgs = {
  data: TipsAndTricksDetailsPageUpdateManyInput;
  where?: InputMaybe<TipsAndTricksDetailsPageManyWhereInput>;
};


export type MutationUpdateManyTipsAndTricksDetailsPagesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TipsAndTricksDetailsPageUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TipsAndTricksDetailsPageManyWhereInput>;
};


export type MutationUpdateManyTitlesArgs = {
  data: TitleUpdateManyInput;
  where?: InputMaybe<TitleManyWhereInput>;
};


export type MutationUpdateManyTitlesConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TitleUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TitleManyWhereInput>;
};


export type MutationUpdateManyTwitterSeosArgs = {
  data: TwitterSeoUpdateManyInput;
  where?: InputMaybe<TwitterSeoManyWhereInput>;
};


export type MutationUpdateManyTwitterSeosConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: TwitterSeoUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TwitterSeoManyWhereInput>;
};


export type MutationUpdateManyWidgetsArgs = {
  data: WidgetUpdateManyInput;
  where?: InputMaybe<WidgetManyWhereInput>;
};


export type MutationUpdateManyWidgetsConnectionArgs = {
  after?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['ID']['input']>;
  data: WidgetUpdateManyInput;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WidgetManyWhereInput>;
};


export type MutationUpdateMediaLibraryArgs = {
  data: MediaLibraryUpdateInput;
  where: MediaLibraryWhereUniqueInput;
};


export type MutationUpdateMediaLibraryItemArgs = {
  data: MediaLibraryItemUpdateInput;
  where: MediaLibraryItemWhereUniqueInput;
};


export type MutationUpdateMetaDataArgs = {
  data: MetaDataUpdateInput;
  where: MetaDataWhereUniqueInput;
};


export type MutationUpdateMobileOnlyMainNavigationArgs = {
  data: MobileOnlyMainNavigationUpdateInput;
  where: MobileOnlyMainNavigationWhereUniqueInput;
};


export type MutationUpdateNavigationArgs = {
  data: NavigationUpdateInput;
  where: NavigationWhereUniqueInput;
};


export type MutationUpdateNavigationItemArgs = {
  data: NavigationItemUpdateInput;
  where: NavigationItemWhereUniqueInput;
};


export type MutationUpdateNotificationBannerArgs = {
  data: NotificationBannerUpdateInput;
  where: NotificationBannerWhereUniqueInput;
};


export type MutationUpdatePageFooterArgs = {
  data: PageFooterUpdateInput;
  where: PageFooterWhereUniqueInput;
};


export type MutationUpdatePageHeaderArgs = {
  data: PageHeaderUpdateInput;
  where: PageHeaderWhereUniqueInput;
};


export type MutationUpdatePopularSearchComponentArgs = {
  data: PopularSearchComponentUpdateInput;
  where: PopularSearchComponentWhereUniqueInput;
};


export type MutationUpdatePressReleaseArgs = {
  data: PressReleaseUpdateInput;
  where: PressReleaseWhereUniqueInput;
};


export type MutationUpdatePressStoriesCardArgs = {
  data: PressStoriesCardUpdateInput;
  where: PressStoriesCardWhereUniqueInput;
};


export type MutationUpdateProgressBarArgs = {
  data: ProgressBarUpdateInput;
  where: ProgressBarWhereUniqueInput;
};


export type MutationUpdateQuickLinkArgs = {
  data: QuickLinkUpdateInput;
  where: QuickLinkWhereUniqueInput;
};


export type MutationUpdateQuickLinkItemArgs = {
  data: QuickLinkItemUpdateInput;
  where: QuickLinkItemWhereUniqueInput;
};


export type MutationUpdateRedirectArgs = {
  data: RedirectUpdateInput;
  where: RedirectWhereUniqueInput;
};


export type MutationUpdateRewriteArgs = {
  data: RewriteUpdateInput;
  where: RewriteWhereUniqueInput;
};


export type MutationUpdateRightColumnArgs = {
  data: RightColumnUpdateInput;
  where: RightColumnWhereUniqueInput;
};


export type MutationUpdateScheduledReleaseArgs = {
  data: ScheduledReleaseUpdateInput;
  where: ScheduledReleaseWhereUniqueInput;
};


export type MutationUpdateSearchInputArgs = {
  data: SearchInputUpdateInput;
  where: SearchInputWhereUniqueInput;
};


export type MutationUpdateSearchOverlayComponentArgs = {
  data: SearchOverlayComponentUpdateInput;
  where: SearchOverlayComponentWhereUniqueInput;
};


export type MutationUpdateSearchResultPageArgs = {
  data: SearchResultPageUpdateInput;
  where: SearchResultPageWhereUniqueInput;
};


export type MutationUpdateShortHeroArgs = {
  data: ShortHeroUpdateInput;
  where: ShortHeroWhereUniqueInput;
};


export type MutationUpdateSocialMediaListComponentArgs = {
  data: SocialMediaListComponentUpdateInput;
  where: SocialMediaListComponentWhereUniqueInput;
};


export type MutationUpdateSpacerArgs = {
  data: SpacerUpdateInput;
  where: SpacerWhereUniqueInput;
};


export type MutationUpdateStoryArgs = {
  data: StoryUpdateInput;
  where: StoryWhereUniqueInput;
};


export type MutationUpdateSubCategoryKeyImageArgs = {
  data: SubCategoryKeyImageUpdateInput;
  where: SubCategoryKeyImageWhereUniqueInput;
};


export type MutationUpdateSustainabilityBannerArgs = {
  data: SustainabilityBannerUpdateInput;
  where: SustainabilityBannerWhereUniqueInput;
};


export type MutationUpdateSustainabilityInfoArgs = {
  data: SustainabilityInfoUpdateInput;
  where: SustainabilityInfoWhereUniqueInput;
};


export type MutationUpdateTabArgs = {
  data: TabUpdateInput;
  where: TabWhereUniqueInput;
};


export type MutationUpdateTabContentArgs = {
  data: TabContentUpdateInput;
  where: TabContentWhereUniqueInput;
};


export type MutationUpdateTestTipsANdTricksInAMarketArgs = {
  data: TestTipsANdTricksInAMarketUpdateInput;
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};


export type MutationUpdateTextComponentArgs = {
  data: TextComponentUpdateInput;
  where: TextComponentWhereUniqueInput;
};


export type MutationUpdateTipsAndTricksDetailsPageArgs = {
  data: TipsAndTricksDetailsPageUpdateInput;
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};


export type MutationUpdateTitleArgs = {
  data: TitleUpdateInput;
  where: TitleWhereUniqueInput;
};


export type MutationUpdateTwitterSeoArgs = {
  data: TwitterSeoUpdateInput;
  where: TwitterSeoWhereUniqueInput;
};


export type MutationUpdateWidgetArgs = {
  data: WidgetUpdateInput;
  where: WidgetWhereUniqueInput;
};


export type MutationUpsertAccordionArgs = {
  upsert: AccordionUpsertInput;
  where: AccordionWhereUniqueInput;
};


export type MutationUpsertAccordionItemArgs = {
  upsert: AccordionItemUpsertInput;
  where: AccordionItemWhereUniqueInput;
};


export type MutationUpsertAlexTestComponentArgs = {
  upsert: AlexTestComponentUpsertInput;
  where: AlexTestComponentWhereUniqueInput;
};


export type MutationUpsertAlgoliaExtensionArgs = {
  upsert: AlgoliaExtensionUpsertInput;
  where: AlgoliaExtensionWhereUniqueInput;
};


export type MutationUpsertAnchorNavArgs = {
  upsert: AnchorNavUpsertInput;
  where: AnchorNavWhereUniqueInput;
};


export type MutationUpsertAnchorNavigationArgs = {
  upsert: AnchorNavigationUpsertInput;
  where: AnchorNavigationWhereUniqueInput;
};


export type MutationUpsertAnchorNavigationListArgs = {
  upsert: AnchorNavigationListUpsertInput;
  where: AnchorNavigationListWhereUniqueInput;
};


export type MutationUpsertAssetArgs = {
  upsert: AssetUpsertInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpsertAssetComponentArgs = {
  upsert: AssetComponentUpsertInput;
  where: AssetComponentWhereUniqueInput;
};


export type MutationUpsertAudioComponentArgs = {
  upsert: AudioComponentUpsertInput;
  where: AudioComponentWhereUniqueInput;
};


export type MutationUpsertAuthorableContentCardArgs = {
  upsert: AuthorableContentCardUpsertInput;
  where: AuthorableContentCardWhereUniqueInput;
};


export type MutationUpsertBanner2Args = {
  upsert: Banner2UpsertInput;
  where: Banner2WhereUniqueInput;
};


export type MutationUpsertBigNumberArgs = {
  upsert: BigNumberUpsertInput;
  where: BigNumberWhereUniqueInput;
};


export type MutationUpsertBigNumberItemArgs = {
  upsert: BigNumberItemUpsertInput;
  where: BigNumberItemWhereUniqueInput;
};


export type MutationUpsertCardComponentArgs = {
  upsert: CardComponentUpsertInput;
  where: CardComponentWhereUniqueInput;
};


export type MutationUpsertCarouselComponentArgs = {
  upsert: CarouselComponentUpsertInput;
  where: CarouselComponentWhereUniqueInput;
};


export type MutationUpsertCarouselSlideArgs = {
  upsert: CarouselSlideUpsertInput;
  where: CarouselSlideWhereUniqueInput;
};


export type MutationUpsertCategoryCardArgs = {
  upsert: CategoryCardUpsertInput;
  where: CategoryCardWhereUniqueInput;
};


export type MutationUpsertContactCardArgs = {
  upsert: ContactCardUpsertInput;
  where: ContactCardWhereUniqueInput;
};


export type MutationUpsertContactCardContainerArgs = {
  upsert: ContactCardContainerUpsertInput;
  where: ContactCardContainerWhereUniqueInput;
};


export type MutationUpsertCorpAddToCalendarArgs = {
  upsert: CorpAddToCalendarUpsertInput;
  where: CorpAddToCalendarWhereUniqueInput;
};


export type MutationUpsertCorpBanner1Args = {
  upsert: CorpBanner1UpsertInput;
  where: CorpBanner1WhereUniqueInput;
};


export type MutationUpsertCorpCalendarEventArgs = {
  upsert: CorpCalendarEventUpsertInput;
  where: CorpCalendarEventWhereUniqueInput;
};


export type MutationUpsertCorpCardCarouselArgs = {
  upsert: CorpCardCarouselUpsertInput;
  where: CorpCardCarouselWhereUniqueInput;
};


export type MutationUpsertCorpContactCardArgs = {
  upsert: CorpContactCardUpsertInput;
  where: CorpContactCardWhereUniqueInput;
};


export type MutationUpsertCorpContactCardContainerArgs = {
  upsert: CorpContactCardContainerUpsertInput;
  where: CorpContactCardContainerWhereUniqueInput;
};


export type MutationUpsertCorpFormArgs = {
  upsert: CorpFormUpsertInput;
  where: CorpFormWhereUniqueInput;
};


export type MutationUpsertCorpGenericAccordionArgs = {
  upsert: CorpGenericAccordionUpsertInput;
  where: CorpGenericAccordionWhereUniqueInput;
};


export type MutationUpsertCorpGenericAccordionItemArgs = {
  upsert: CorpGenericAccordionItemUpsertInput;
  where: CorpGenericAccordionItemWhereUniqueInput;
};


export type MutationUpsertCorpGenericBannerArgs = {
  upsert: CorpGenericBannerUpsertInput;
  where: CorpGenericBannerWhereUniqueInput;
};


export type MutationUpsertCorpGenericContainerArgs = {
  upsert: CorpGenericContainerUpsertInput;
  where: CorpGenericContainerWhereUniqueInput;
};


export type MutationUpsertCorpGridColumnComponentArgs = {
  upsert: CorpGridColumnComponentUpsertInput;
  where: CorpGridColumnComponentWhereUniqueInput;
};


export type MutationUpsertCorpHeroArgs = {
  upsert: CorpHeroUpsertInput;
  where: CorpHeroWhereUniqueInput;
};


export type MutationUpsertCorpMediaDownloadPreviewArgs = {
  upsert: CorpMediaDownloadPreviewUpsertInput;
  where: CorpMediaDownloadPreviewWhereUniqueInput;
};


export type MutationUpsertCorpNavigationArgs = {
  upsert: CorpNavigationUpsertInput;
  where: CorpNavigationWhereUniqueInput;
};


export type MutationUpsertCorpNavigationItemArgs = {
  upsert: CorpNavigationItemUpsertInput;
  where: CorpNavigationItemWhereUniqueInput;
};


export type MutationUpsertCorpNotificationBannerArgs = {
  upsert: CorpNotificationBannerUpsertInput;
  where: CorpNotificationBannerWhereUniqueInput;
};


export type MutationUpsertCorpOurPeopleArgs = {
  upsert: CorpOurPeopleUpsertInput;
  where: CorpOurPeopleWhereUniqueInput;
};


export type MutationUpsertCorpOurPeopleItemArgs = {
  upsert: CorpOurPeopleItemUpsertInput;
  where: CorpOurPeopleItemWhereUniqueInput;
};


export type MutationUpsertCorpPressPageArgs = {
  upsert: CorpPressPageUpsertInput;
  where: CorpPressPageWhereUniqueInput;
};


export type MutationUpsertCorpSocialMediaFooterArgs = {
  upsert: CorpSocialMediaFooterUpsertInput;
  where: CorpSocialMediaFooterWhereUniqueInput;
};


export type MutationUpsertCorpStoriesPageArgs = {
  upsert: CorpStoriesPageUpsertInput;
  where: CorpStoriesPageWhereUniqueInput;
};


export type MutationUpsertCorpStoryCarouselArgs = {
  upsert: CorpStoryCarouselUpsertInput;
  where: CorpStoryCarouselWhereUniqueInput;
};


export type MutationUpsertCorpTimelineAccordionArgs = {
  upsert: CorpTimelineAccordionUpsertInput;
  where: CorpTimelineAccordionWhereUniqueInput;
};


export type MutationUpsertCorpTimelineAccordionItemArgs = {
  upsert: CorpTimelineAccordionItemUpsertInput;
  where: CorpTimelineAccordionItemWhereUniqueInput;
};


export type MutationUpsertCorpTimelineAccordionWrapperArgs = {
  upsert: CorpTimelineAccordionWrapperUpsertInput;
  where: CorpTimelineAccordionWrapperWhereUniqueInput;
};


export type MutationUpsertCorpVideoHeroArgs = {
  upsert: CorpVideoHeroUpsertInput;
  where: CorpVideoHeroWhereUniqueInput;
};


export type MutationUpsertCorpVideoHeroCarouselArgs = {
  upsert: CorpVideoHeroCarouselUpsertInput;
  where: CorpVideoHeroCarouselWhereUniqueInput;
};


export type MutationUpsertCountrySelectorArgs = {
  upsert: CountrySelectorUpsertInput;
  where: CountrySelectorWhereUniqueInput;
};


export type MutationUpsertCountrySelectorItemArgs = {
  upsert: CountrySelectorItemUpsertInput;
  where: CountrySelectorItemWhereUniqueInput;
};


export type MutationUpsertDeprecatedBanner1Args = {
  upsert: DeprecatedBanner1UpsertInput;
  where: DeprecatedBanner1WhereUniqueInput;
};


export type MutationUpsertDeprecatedCorpNavigationCopyArgs = {
  upsert: DeprecatedCorpNavigationCopyUpsertInput;
  where: DeprecatedCorpNavigationCopyWhereUniqueInput;
};


export type MutationUpsertDictionaryArgs = {
  upsert: DictionaryUpsertInput;
  where: DictionaryWhereUniqueInput;
};


export type MutationUpsertDictionaryItemArgs = {
  upsert: DictionaryItemUpsertInput;
  where: DictionaryItemWhereUniqueInput;
};


export type MutationUpsertDynamicCardGridArgs = {
  upsert: DynamicCardGridUpsertInput;
  where: DynamicCardGridWhereUniqueInput;
};


export type MutationUpsertEvalancheFormComponentArgs = {
  upsert: EvalancheFormComponentUpsertInput;
  where: EvalancheFormComponentWhereUniqueInput;
};


export type MutationUpsertExampleComponentArgs = {
  upsert: ExampleComponentUpsertInput;
  where: ExampleComponentWhereUniqueInput;
};


export type MutationUpsertFeaturedContentArgs = {
  upsert: FeaturedContentUpsertInput;
  where: FeaturedContentWhereUniqueInput;
};


export type MutationUpsertFeaturedContentReferenceArgs = {
  upsert: FeaturedContentReferenceUpsertInput;
  where: FeaturedContentReferenceWhereUniqueInput;
};


export type MutationUpsertFooterNavigationArgs = {
  upsert: FooterNavigationUpsertInput;
  where: FooterNavigationWhereUniqueInput;
};


export type MutationUpsertFormArgs = {
  upsert: FormUpsertInput;
  where: FormWhereUniqueInput;
};


export type MutationUpsertFormCheckboxArgs = {
  upsert: FormCheckboxUpsertInput;
  where: FormCheckboxWhereUniqueInput;
};


export type MutationUpsertFormEmailInputArgs = {
  upsert: FormEmailInputUpsertInput;
  where: FormEmailInputWhereUniqueInput;
};


export type MutationUpsertFormErrorArgs = {
  upsert: FormErrorUpsertInput;
  where: FormErrorWhereUniqueInput;
};


export type MutationUpsertFormPasswordInputArgs = {
  upsert: FormPasswordInputUpsertInput;
  where: FormPasswordInputWhereUniqueInput;
};


export type MutationUpsertFormPasswordInputWithConfirmationArgs = {
  upsert: FormPasswordInputWithConfirmationUpsertInput;
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};


export type MutationUpsertFormRadioButtonArgs = {
  upsert: FormRadioButtonUpsertInput;
  where: FormRadioButtonWhereUniqueInput;
};


export type MutationUpsertFormRadioButtonCollectionArgs = {
  upsert: FormRadioButtonCollectionUpsertInput;
  where: FormRadioButtonCollectionWhereUniqueInput;
};


export type MutationUpsertFormSelectComponentArgs = {
  upsert: FormSelectComponentUpsertInput;
  where: FormSelectComponentWhereUniqueInput;
};


export type MutationUpsertFormSelectOptionArgs = {
  upsert: FormSelectOptionUpsertInput;
  where: FormSelectOptionWhereUniqueInput;
};


export type MutationUpsertFormSubmitButtonArgs = {
  upsert: FormSubmitButtonUpsertInput;
  where: FormSubmitButtonWhereUniqueInput;
};


export type MutationUpsertFormSuccessComponentArgs = {
  upsert: FormSuccessComponentUpsertInput;
  where: FormSuccessComponentWhereUniqueInput;
};


export type MutationUpsertFormTextInputArgs = {
  upsert: FormTextInputUpsertInput;
  where: FormTextInputWhereUniqueInput;
};


export type MutationUpsertFormTextareaInputArgs = {
  upsert: FormTextareaInputUpsertInput;
  where: FormTextareaInputWhereUniqueInput;
};


export type MutationUpsertGenericAccordionArgs = {
  upsert: GenericAccordionUpsertInput;
  where: GenericAccordionWhereUniqueInput;
};


export type MutationUpsertGenericAccordionItemArgs = {
  upsert: GenericAccordionItemUpsertInput;
  where: GenericAccordionItemWhereUniqueInput;
};


export type MutationUpsertGenericAccordionTopRatedArgs = {
  upsert: GenericAccordionTopRatedUpsertInput;
  where: GenericAccordionTopRatedWhereUniqueInput;
};


export type MutationUpsertGenericCardCarouseComponentArgs = {
  upsert: GenericCardCarouseComponentUpsertInput;
  where: GenericCardCarouseComponentWhereUniqueInput;
};


export type MutationUpsertGenericDownloadComponentArgs = {
  upsert: GenericDownloadComponentUpsertInput;
  where: GenericDownloadComponentWhereUniqueInput;
};


export type MutationUpsertGenericFollowUsArgs = {
  upsert: GenericFollowUsUpsertInput;
  where: GenericFollowUsWhereUniqueInput;
};


export type MutationUpsertGenericGridAuthorableArgs = {
  upsert: GenericGridAuthorableUpsertInput;
  where: GenericGridAuthorableWhereUniqueInput;
};


export type MutationUpsertGenericLineArgs = {
  upsert: GenericLineUpsertInput;
  where: GenericLineWhereUniqueInput;
};


export type MutationUpsertGenericLinkArgs = {
  upsert: GenericLinkUpsertInput;
  where: GenericLinkWhereUniqueInput;
};


export type MutationUpsertGenericPageArgs = {
  upsert: GenericPageUpsertInput;
  where: GenericPageWhereUniqueInput;
};


export type MutationUpsertGlobalMetaDataArgs = {
  upsert: GlobalMetaDataUpsertInput;
  where: GlobalMetaDataWhereUniqueInput;
};


export type MutationUpsertHeroBannerArgs = {
  upsert: HeroBannerUpsertInput;
  where: HeroBannerWhereUniqueInput;
};


export type MutationUpsertHeroCarouselComponentArgs = {
  upsert: HeroCarouselComponentUpsertInput;
  where: HeroCarouselComponentWhereUniqueInput;
};


export type MutationUpsertHeroComponentArgs = {
  upsert: HeroComponentUpsertInput;
  where: HeroComponentWhereUniqueInput;
};


export type MutationUpsertHomePageArgs = {
  upsert: HomePageUpsertInput;
  where: HomePageWhereUniqueInput;
};


export type MutationUpsertIframeArgs = {
  upsert: IframeUpsertInput;
  where: IframeWhereUniqueInput;
};


export type MutationUpsertImageAndTextCardArgs = {
  upsert: ImageAndTextCardUpsertInput;
  where: ImageAndTextCardWhereUniqueInput;
};


export type MutationUpsertImageCopyArgs = {
  upsert: ImageCopyUpsertInput;
  where: ImageCopyWhereUniqueInput;
};


export type MutationUpsertImageCopyItemArgs = {
  upsert: ImageCopyItemUpsertInput;
  where: ImageCopyItemWhereUniqueInput;
};


export type MutationUpsertIntroTextArgs = {
  upsert: IntroTextUpsertInput;
  where: IntroTextWhereUniqueInput;
};


export type MutationUpsertLeftColumnArgs = {
  upsert: LeftColumnUpsertInput;
  where: LeftColumnWhereUniqueInput;
};


export type MutationUpsertLinkArgs = {
  upsert: LinkUpsertInput;
  where: LinkWhereUniqueInput;
};


export type MutationUpsertLocationComponentArgs = {
  upsert: LocationComponentUpsertInput;
  where: LocationComponentWhereUniqueInput;
};


export type MutationUpsertLocationItemArgs = {
  upsert: LocationItemUpsertInput;
  where: LocationItemWhereUniqueInput;
};


export type MutationUpsertLongTextArgs = {
  upsert: LongTextUpsertInput;
  where: LongTextWhereUniqueInput;
};


export type MutationUpsertMediaLibraryArgs = {
  upsert: MediaLibraryUpsertInput;
  where: MediaLibraryWhereUniqueInput;
};


export type MutationUpsertMediaLibraryItemArgs = {
  upsert: MediaLibraryItemUpsertInput;
  where: MediaLibraryItemWhereUniqueInput;
};


export type MutationUpsertMetaDataArgs = {
  upsert: MetaDataUpsertInput;
  where: MetaDataWhereUniqueInput;
};


export type MutationUpsertMobileOnlyMainNavigationArgs = {
  upsert: MobileOnlyMainNavigationUpsertInput;
  where: MobileOnlyMainNavigationWhereUniqueInput;
};


export type MutationUpsertNavigationArgs = {
  upsert: NavigationUpsertInput;
  where: NavigationWhereUniqueInput;
};


export type MutationUpsertNavigationItemArgs = {
  upsert: NavigationItemUpsertInput;
  where: NavigationItemWhereUniqueInput;
};


export type MutationUpsertNotificationBannerArgs = {
  upsert: NotificationBannerUpsertInput;
  where: NotificationBannerWhereUniqueInput;
};


export type MutationUpsertPageFooterArgs = {
  upsert: PageFooterUpsertInput;
  where: PageFooterWhereUniqueInput;
};


export type MutationUpsertPageHeaderArgs = {
  upsert: PageHeaderUpsertInput;
  where: PageHeaderWhereUniqueInput;
};


export type MutationUpsertPopularSearchComponentArgs = {
  upsert: PopularSearchComponentUpsertInput;
  where: PopularSearchComponentWhereUniqueInput;
};


export type MutationUpsertPressReleaseArgs = {
  upsert: PressReleaseUpsertInput;
  where: PressReleaseWhereUniqueInput;
};


export type MutationUpsertPressStoriesCardArgs = {
  upsert: PressStoriesCardUpsertInput;
  where: PressStoriesCardWhereUniqueInput;
};


export type MutationUpsertProgressBarArgs = {
  upsert: ProgressBarUpsertInput;
  where: ProgressBarWhereUniqueInput;
};


export type MutationUpsertQuickLinkArgs = {
  upsert: QuickLinkUpsertInput;
  where: QuickLinkWhereUniqueInput;
};


export type MutationUpsertQuickLinkItemArgs = {
  upsert: QuickLinkItemUpsertInput;
  where: QuickLinkItemWhereUniqueInput;
};


export type MutationUpsertRedirectArgs = {
  upsert: RedirectUpsertInput;
  where: RedirectWhereUniqueInput;
};


export type MutationUpsertRewriteArgs = {
  upsert: RewriteUpsertInput;
  where: RewriteWhereUniqueInput;
};


export type MutationUpsertRightColumnArgs = {
  upsert: RightColumnUpsertInput;
  where: RightColumnWhereUniqueInput;
};


export type MutationUpsertSearchInputArgs = {
  upsert: SearchInputUpsertInput;
  where: SearchInputWhereUniqueInput;
};


export type MutationUpsertSearchOverlayComponentArgs = {
  upsert: SearchOverlayComponentUpsertInput;
  where: SearchOverlayComponentWhereUniqueInput;
};


export type MutationUpsertSearchResultPageArgs = {
  upsert: SearchResultPageUpsertInput;
  where: SearchResultPageWhereUniqueInput;
};


export type MutationUpsertShortHeroArgs = {
  upsert: ShortHeroUpsertInput;
  where: ShortHeroWhereUniqueInput;
};


export type MutationUpsertSocialMediaListComponentArgs = {
  upsert: SocialMediaListComponentUpsertInput;
  where: SocialMediaListComponentWhereUniqueInput;
};


export type MutationUpsertSpacerArgs = {
  upsert: SpacerUpsertInput;
  where: SpacerWhereUniqueInput;
};


export type MutationUpsertStoryArgs = {
  upsert: StoryUpsertInput;
  where: StoryWhereUniqueInput;
};


export type MutationUpsertSubCategoryKeyImageArgs = {
  upsert: SubCategoryKeyImageUpsertInput;
  where: SubCategoryKeyImageWhereUniqueInput;
};


export type MutationUpsertSustainabilityBannerArgs = {
  upsert: SustainabilityBannerUpsertInput;
  where: SustainabilityBannerWhereUniqueInput;
};


export type MutationUpsertSustainabilityInfoArgs = {
  upsert: SustainabilityInfoUpsertInput;
  where: SustainabilityInfoWhereUniqueInput;
};


export type MutationUpsertTabArgs = {
  upsert: TabUpsertInput;
  where: TabWhereUniqueInput;
};


export type MutationUpsertTabContentArgs = {
  upsert: TabContentUpsertInput;
  where: TabContentWhereUniqueInput;
};


export type MutationUpsertTestTipsANdTricksInAMarketArgs = {
  upsert: TestTipsANdTricksInAMarketUpsertInput;
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};


export type MutationUpsertTextComponentArgs = {
  upsert: TextComponentUpsertInput;
  where: TextComponentWhereUniqueInput;
};


export type MutationUpsertTipsAndTricksDetailsPageArgs = {
  upsert: TipsAndTricksDetailsPageUpsertInput;
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};


export type MutationUpsertTitleArgs = {
  upsert: TitleUpsertInput;
  where: TitleWhereUniqueInput;
};


export type MutationUpsertTwitterSeoArgs = {
  upsert: TwitterSeoUpsertInput;
  where: TwitterSeoWhereUniqueInput;
};


export type MutationUpsertWidgetArgs = {
  upsert: WidgetUpsertInput;
  where: WidgetWhereUniqueInput;
};

export type NavLinkComponent = Accordion | AuthorableContentCard | Banner2 | CarouselComponent | CategoryCard | ContactCard | ContactCardContainer | CorpBanner1 | CorpGenericAccordion | CorpGenericContainer | CorpGridColumnComponent | CorpOurPeople | CorpTimelineAccordionWrapper | DeprecatedBanner1 | DynamicCardGrid | EvalancheFormComponent | FeaturedContent | Form | GenericAccordionTopRated | GenericCardCarouseComponent | GenericDownloadComponent | GenericFollowUs | HeroBanner | HeroCarouselComponent | HeroComponent | ImageAndTextCard | ImageCopy | IntroText | LocationComponent | LongText | MetaData | PopularSearchComponent | PressStoriesCard | QuickLink | Redirect | SearchInput | SocialMediaListComponent | SustainabilityBanner | Tab | Title;

export type NavLinkComponentConnectInput = {
  Accordion?: InputMaybe<AccordionConnectInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardConnectInput>;
  Banner2?: InputMaybe<Banner2ConnectInput>;
  CarouselComponent?: InputMaybe<CarouselComponentConnectInput>;
  CategoryCard?: InputMaybe<CategoryCardConnectInput>;
  ContactCard?: InputMaybe<ContactCardConnectInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerConnectInput>;
  CorpBanner1?: InputMaybe<CorpBanner1ConnectInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionConnectInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerConnectInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentConnectInput>;
  CorpOurPeople?: InputMaybe<CorpOurPeopleConnectInput>;
  CorpTimelineAccordionWrapper?: InputMaybe<CorpTimelineAccordionWrapperConnectInput>;
  DEPRECATEDBanner1?: InputMaybe<DeprecatedBanner1ConnectInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridConnectInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentConnectInput>;
  FeaturedContent?: InputMaybe<FeaturedContentConnectInput>;
  Form?: InputMaybe<FormConnectInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedConnectInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentConnectInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentConnectInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsConnectInput>;
  HeroBanner?: InputMaybe<HeroBannerConnectInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentConnectInput>;
  HeroComponent?: InputMaybe<HeroComponentConnectInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardConnectInput>;
  ImageCopy?: InputMaybe<ImageCopyConnectInput>;
  IntroText?: InputMaybe<IntroTextConnectInput>;
  LocationComponent?: InputMaybe<LocationComponentConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
  MetaData?: InputMaybe<MetaDataConnectInput>;
  PopularSearchComponent?: InputMaybe<PopularSearchComponentConnectInput>;
  PressStoriesCard?: InputMaybe<PressStoriesCardConnectInput>;
  QuickLink?: InputMaybe<QuickLinkConnectInput>;
  Redirect?: InputMaybe<RedirectConnectInput>;
  SearchInput?: InputMaybe<SearchInputConnectInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentConnectInput>;
  SustainabilityBanner?: InputMaybe<SustainabilityBannerConnectInput>;
  Tab?: InputMaybe<TabConnectInput>;
  Title?: InputMaybe<TitleConnectInput>;
};

export type NavLinkComponentCreateInput = {
  Accordion?: InputMaybe<AccordionCreateInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardCreateInput>;
  Banner2?: InputMaybe<Banner2CreateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentCreateInput>;
  CategoryCard?: InputMaybe<CategoryCardCreateInput>;
  ContactCard?: InputMaybe<ContactCardCreateInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerCreateInput>;
  CorpBanner1?: InputMaybe<CorpBanner1CreateInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionCreateInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerCreateInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentCreateInput>;
  CorpOurPeople?: InputMaybe<CorpOurPeopleCreateInput>;
  CorpTimelineAccordionWrapper?: InputMaybe<CorpTimelineAccordionWrapperCreateInput>;
  DEPRECATEDBanner1?: InputMaybe<DeprecatedBanner1CreateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridCreateInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentCreateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentCreateInput>;
  Form?: InputMaybe<FormCreateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedCreateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentCreateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsCreateInput>;
  HeroBanner?: InputMaybe<HeroBannerCreateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateInput>;
  HeroComponent?: InputMaybe<HeroComponentCreateInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardCreateInput>;
  ImageCopy?: InputMaybe<ImageCopyCreateInput>;
  IntroText?: InputMaybe<IntroTextCreateInput>;
  LocationComponent?: InputMaybe<LocationComponentCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
  MetaData?: InputMaybe<MetaDataCreateInput>;
  PopularSearchComponent?: InputMaybe<PopularSearchComponentCreateInput>;
  PressStoriesCard?: InputMaybe<PressStoriesCardCreateInput>;
  QuickLink?: InputMaybe<QuickLinkCreateInput>;
  Redirect?: InputMaybe<RedirectCreateInput>;
  SearchInput?: InputMaybe<SearchInputCreateInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentCreateInput>;
  SustainabilityBanner?: InputMaybe<SustainabilityBannerCreateInput>;
  Tab?: InputMaybe<TabCreateInput>;
  Title?: InputMaybe<TitleCreateInput>;
};

export type NavLinkComponentCreateManyInlineInput = {
  /** Connect multiple existing NavLinkComponent documents */
  connect?: InputMaybe<Array<NavLinkComponentWhereUniqueInput>>;
  /** Create and connect multiple existing NavLinkComponent documents */
  create?: InputMaybe<Array<NavLinkComponentCreateInput>>;
};

export type NavLinkComponentCreateOneInlineInput = {
  /** Connect one existing NavLinkComponent document */
  connect?: InputMaybe<NavLinkComponentWhereUniqueInput>;
  /** Create and connect one NavLinkComponent document */
  create?: InputMaybe<NavLinkComponentCreateInput>;
};

export type NavLinkComponentUpdateInput = {
  Accordion?: InputMaybe<AccordionUpdateInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateInput>;
  Banner2?: InputMaybe<Banner2UpdateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateInput>;
  CategoryCard?: InputMaybe<CategoryCardUpdateInput>;
  ContactCard?: InputMaybe<ContactCardUpdateInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerUpdateInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpdateInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpdateInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateInput>;
  CorpOurPeople?: InputMaybe<CorpOurPeopleUpdateInput>;
  CorpTimelineAccordionWrapper?: InputMaybe<CorpTimelineAccordionWrapperUpdateInput>;
  DEPRECATEDBanner1?: InputMaybe<DeprecatedBanner1UpdateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateInput>;
  Form?: InputMaybe<FormUpdateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateInput>;
  HeroBanner?: InputMaybe<HeroBannerUpdateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateInput>;
  HeroComponent?: InputMaybe<HeroComponentUpdateInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardUpdateInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateInput>;
  IntroText?: InputMaybe<IntroTextUpdateInput>;
  LocationComponent?: InputMaybe<LocationComponentUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
  MetaData?: InputMaybe<MetaDataUpdateInput>;
  PopularSearchComponent?: InputMaybe<PopularSearchComponentUpdateInput>;
  PressStoriesCard?: InputMaybe<PressStoriesCardUpdateInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateInput>;
  Redirect?: InputMaybe<RedirectUpdateInput>;
  SearchInput?: InputMaybe<SearchInputUpdateInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateInput>;
  SustainabilityBanner?: InputMaybe<SustainabilityBannerUpdateInput>;
  Tab?: InputMaybe<TabUpdateInput>;
  Title?: InputMaybe<TitleUpdateInput>;
};

export type NavLinkComponentUpdateManyInlineInput = {
  /** Connect multiple existing NavLinkComponent documents */
  connect?: InputMaybe<Array<NavLinkComponentConnectInput>>;
  /** Create and connect multiple NavLinkComponent documents */
  create?: InputMaybe<Array<NavLinkComponentCreateInput>>;
  /** Delete multiple NavLinkComponent documents */
  delete?: InputMaybe<Array<NavLinkComponentWhereUniqueInput>>;
  /** Disconnect multiple NavLinkComponent documents */
  disconnect?: InputMaybe<Array<NavLinkComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NavLinkComponent documents */
  set?: InputMaybe<Array<NavLinkComponentWhereUniqueInput>>;
  /** Update multiple NavLinkComponent documents */
  update?: InputMaybe<Array<NavLinkComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NavLinkComponent documents */
  upsert?: InputMaybe<Array<NavLinkComponentUpsertWithNestedWhereUniqueInput>>;
};

export type NavLinkComponentUpdateManyWithNestedWhereInput = {
  Accordion?: InputMaybe<AccordionUpdateManyWithNestedWhereInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateManyWithNestedWhereInput>;
  Banner2?: InputMaybe<Banner2UpdateManyWithNestedWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateManyWithNestedWhereInput>;
  CategoryCard?: InputMaybe<CategoryCardUpdateManyWithNestedWhereInput>;
  ContactCard?: InputMaybe<ContactCardUpdateManyWithNestedWhereInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerUpdateManyWithNestedWhereInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpdateManyWithNestedWhereInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpdateManyWithNestedWhereInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateManyWithNestedWhereInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateManyWithNestedWhereInput>;
  CorpOurPeople?: InputMaybe<CorpOurPeopleUpdateManyWithNestedWhereInput>;
  CorpTimelineAccordionWrapper?: InputMaybe<CorpTimelineAccordionWrapperUpdateManyWithNestedWhereInput>;
  DEPRECATEDBanner1?: InputMaybe<DeprecatedBanner1UpdateManyWithNestedWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateManyWithNestedWhereInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateManyWithNestedWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateManyWithNestedWhereInput>;
  Form?: InputMaybe<FormUpdateManyWithNestedWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateManyWithNestedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateManyWithNestedWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateManyWithNestedWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateManyWithNestedWhereInput>;
  HeroBanner?: InputMaybe<HeroBannerUpdateManyWithNestedWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateManyWithNestedWhereInput>;
  HeroComponent?: InputMaybe<HeroComponentUpdateManyWithNestedWhereInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardUpdateManyWithNestedWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateManyWithNestedWhereInput>;
  IntroText?: InputMaybe<IntroTextUpdateManyWithNestedWhereInput>;
  LocationComponent?: InputMaybe<LocationComponentUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
  MetaData?: InputMaybe<MetaDataUpdateManyWithNestedWhereInput>;
  PopularSearchComponent?: InputMaybe<PopularSearchComponentUpdateManyWithNestedWhereInput>;
  PressStoriesCard?: InputMaybe<PressStoriesCardUpdateManyWithNestedWhereInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateManyWithNestedWhereInput>;
  Redirect?: InputMaybe<RedirectUpdateManyWithNestedWhereInput>;
  SearchInput?: InputMaybe<SearchInputUpdateManyWithNestedWhereInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateManyWithNestedWhereInput>;
  SustainabilityBanner?: InputMaybe<SustainabilityBannerUpdateManyWithNestedWhereInput>;
  Tab?: InputMaybe<TabUpdateManyWithNestedWhereInput>;
  Title?: InputMaybe<TitleUpdateManyWithNestedWhereInput>;
};

export type NavLinkComponentUpdateOneInlineInput = {
  /** Connect existing NavLinkComponent document */
  connect?: InputMaybe<NavLinkComponentWhereUniqueInput>;
  /** Create and connect one NavLinkComponent document */
  create?: InputMaybe<NavLinkComponentCreateInput>;
  /** Delete currently connected NavLinkComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NavLinkComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NavLinkComponent document */
  update?: InputMaybe<NavLinkComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NavLinkComponent document */
  upsert?: InputMaybe<NavLinkComponentUpsertWithNestedWhereUniqueInput>;
};

export type NavLinkComponentUpdateWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpdateWithNestedWhereUniqueInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpdateWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateWithNestedWhereUniqueInput>;
  CategoryCard?: InputMaybe<CategoryCardUpdateWithNestedWhereUniqueInput>;
  ContactCard?: InputMaybe<ContactCardUpdateWithNestedWhereUniqueInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerUpdateWithNestedWhereUniqueInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpdateWithNestedWhereUniqueInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpdateWithNestedWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateWithNestedWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateWithNestedWhereUniqueInput>;
  CorpOurPeople?: InputMaybe<CorpOurPeopleUpdateWithNestedWhereUniqueInput>;
  CorpTimelineAccordionWrapper?: InputMaybe<CorpTimelineAccordionWrapperUpdateWithNestedWhereUniqueInput>;
  DEPRECATEDBanner1?: InputMaybe<DeprecatedBanner1UpdateWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateWithNestedWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpdateWithNestedWhereUniqueInput>;
  Form?: InputMaybe<FormUpdateWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateWithNestedWhereUniqueInput>;
  HeroBanner?: InputMaybe<HeroBannerUpdateWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateWithNestedWhereUniqueInput>;
  HeroComponent?: InputMaybe<HeroComponentUpdateWithNestedWhereUniqueInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardUpdateWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpdateWithNestedWhereUniqueInput>;
  LocationComponent?: InputMaybe<LocationComponentUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  MetaData?: InputMaybe<MetaDataUpdateWithNestedWhereUniqueInput>;
  PopularSearchComponent?: InputMaybe<PopularSearchComponentUpdateWithNestedWhereUniqueInput>;
  PressStoriesCard?: InputMaybe<PressStoriesCardUpdateWithNestedWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateWithNestedWhereUniqueInput>;
  Redirect?: InputMaybe<RedirectUpdateWithNestedWhereUniqueInput>;
  SearchInput?: InputMaybe<SearchInputUpdateWithNestedWhereUniqueInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateWithNestedWhereUniqueInput>;
  SustainabilityBanner?: InputMaybe<SustainabilityBannerUpdateWithNestedWhereUniqueInput>;
  Tab?: InputMaybe<TabUpdateWithNestedWhereUniqueInput>;
  Title?: InputMaybe<TitleUpdateWithNestedWhereUniqueInput>;
};

export type NavLinkComponentUpsertWithNestedWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionUpsertWithNestedWhereUniqueInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpsertWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpsertWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpsertWithNestedWhereUniqueInput>;
  CategoryCard?: InputMaybe<CategoryCardUpsertWithNestedWhereUniqueInput>;
  ContactCard?: InputMaybe<ContactCardUpsertWithNestedWhereUniqueInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerUpsertWithNestedWhereUniqueInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpsertWithNestedWhereUniqueInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpsertWithNestedWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpsertWithNestedWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpsertWithNestedWhereUniqueInput>;
  CorpOurPeople?: InputMaybe<CorpOurPeopleUpsertWithNestedWhereUniqueInput>;
  CorpTimelineAccordionWrapper?: InputMaybe<CorpTimelineAccordionWrapperUpsertWithNestedWhereUniqueInput>;
  DEPRECATEDBanner1?: InputMaybe<DeprecatedBanner1UpsertWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpsertWithNestedWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpsertWithNestedWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentUpsertWithNestedWhereUniqueInput>;
  Form?: InputMaybe<FormUpsertWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpsertWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpsertWithNestedWhereUniqueInput>;
  HeroBanner?: InputMaybe<HeroBannerUpsertWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpsertWithNestedWhereUniqueInput>;
  HeroComponent?: InputMaybe<HeroComponentUpsertWithNestedWhereUniqueInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardUpsertWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpsertWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpsertWithNestedWhereUniqueInput>;
  LocationComponent?: InputMaybe<LocationComponentUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
  MetaData?: InputMaybe<MetaDataUpsertWithNestedWhereUniqueInput>;
  PopularSearchComponent?: InputMaybe<PopularSearchComponentUpsertWithNestedWhereUniqueInput>;
  PressStoriesCard?: InputMaybe<PressStoriesCardUpsertWithNestedWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkUpsertWithNestedWhereUniqueInput>;
  Redirect?: InputMaybe<RedirectUpsertWithNestedWhereUniqueInput>;
  SearchInput?: InputMaybe<SearchInputUpsertWithNestedWhereUniqueInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpsertWithNestedWhereUniqueInput>;
  SustainabilityBanner?: InputMaybe<SustainabilityBannerUpsertWithNestedWhereUniqueInput>;
  Tab?: InputMaybe<TabUpsertWithNestedWhereUniqueInput>;
  Title?: InputMaybe<TitleUpsertWithNestedWhereUniqueInput>;
};

export type NavLinkComponentWhereInput = {
  Accordion?: InputMaybe<AccordionWhereInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereInput>;
  Banner2?: InputMaybe<Banner2WhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  CategoryCard?: InputMaybe<CategoryCardWhereInput>;
  ContactCard?: InputMaybe<ContactCardWhereInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerWhereInput>;
  CorpBanner1?: InputMaybe<CorpBanner1WhereInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionWhereInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerWhereInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentWhereInput>;
  CorpOurPeople?: InputMaybe<CorpOurPeopleWhereInput>;
  CorpTimelineAccordionWrapper?: InputMaybe<CorpTimelineAccordionWrapperWhereInput>;
  DEPRECATEDBanner1?: InputMaybe<DeprecatedBanner1WhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentWhereInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereInput>;
  Form?: InputMaybe<FormWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereInput>;
  HeroBanner?: InputMaybe<HeroBannerWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  HeroComponent?: InputMaybe<HeroComponentWhereInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereInput>;
  IntroText?: InputMaybe<IntroTextWhereInput>;
  LocationComponent?: InputMaybe<LocationComponentWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
  MetaData?: InputMaybe<MetaDataWhereInput>;
  PopularSearchComponent?: InputMaybe<PopularSearchComponentWhereInput>;
  PressStoriesCard?: InputMaybe<PressStoriesCardWhereInput>;
  QuickLink?: InputMaybe<QuickLinkWhereInput>;
  Redirect?: InputMaybe<RedirectWhereInput>;
  SearchInput?: InputMaybe<SearchInputWhereInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentWhereInput>;
  SustainabilityBanner?: InputMaybe<SustainabilityBannerWhereInput>;
  Tab?: InputMaybe<TabWhereInput>;
  Title?: InputMaybe<TitleWhereInput>;
};

export type NavLinkComponentWhereUniqueInput = {
  Accordion?: InputMaybe<AccordionWhereUniqueInput>;
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2WhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereUniqueInput>;
  CategoryCard?: InputMaybe<CategoryCardWhereUniqueInput>;
  ContactCard?: InputMaybe<ContactCardWhereUniqueInput>;
  ContactCardContainer?: InputMaybe<ContactCardContainerWhereUniqueInput>;
  CorpBanner1?: InputMaybe<CorpBanner1WhereUniqueInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentWhereUniqueInput>;
  CorpOurPeople?: InputMaybe<CorpOurPeopleWhereUniqueInput>;
  CorpTimelineAccordionWrapper?: InputMaybe<CorpTimelineAccordionWrapperWhereUniqueInput>;
  DEPRECATEDBanner1?: InputMaybe<DeprecatedBanner1WhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentWhereUniqueInput>;
  FeaturedContent?: InputMaybe<FeaturedContentWhereUniqueInput>;
  Form?: InputMaybe<FormWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereUniqueInput>;
  HeroBanner?: InputMaybe<HeroBannerWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereUniqueInput>;
  HeroComponent?: InputMaybe<HeroComponentWhereUniqueInput>;
  ImageAndTextCard?: InputMaybe<ImageAndTextCardWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextWhereUniqueInput>;
  LocationComponent?: InputMaybe<LocationComponentWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
  MetaData?: InputMaybe<MetaDataWhereUniqueInput>;
  PopularSearchComponent?: InputMaybe<PopularSearchComponentWhereUniqueInput>;
  PressStoriesCard?: InputMaybe<PressStoriesCardWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkWhereUniqueInput>;
  Redirect?: InputMaybe<RedirectWhereUniqueInput>;
  SearchInput?: InputMaybe<SearchInputWhereUniqueInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentWhereUniqueInput>;
  SustainabilityBanner?: InputMaybe<SustainabilityBannerWhereUniqueInput>;
  Tab?: InputMaybe<TabWhereUniqueInput>;
  Title?: InputMaybe<TitleWhereUniqueInput>;
};

/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type Navigation = Entity & Node & {
  __typename?: 'Navigation';
  /** Title Above the card component */
  cardComponentTitle?: Maybe<Scalars['String']['output']>;
  cardItemtId?: Maybe<Scalars['String']['output']>;
  /** Header Nav Category */
  category: Array<NavigationCategory>;
  /** Title is used to display on website */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Navigation>;
  /** List of Navigation versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Unique key for each haeder navigation */
  key: Scalars['String']['output'];
  /** Define link for navigation text and link */
  links: Array<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Navigation>;
  navCard?: Maybe<NavigationNavCard>;
  /** Header Navigation url */
  navUrl?: Maybe<Scalars['String']['output']>;
  navigation_images: Array<NavigationNavigation_Images>;
  /** Specifies where on the page the navigation will be displayed */
  positon: NavigationTypes;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationNavCardArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationNavigation_ImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Contains a list of navigation items (e.g. Main navigation menu items) */
export type NavigationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type NavigationCategory = NavigationItem;

export type NavigationCategoryConnectInput = {
  NavigationItem?: InputMaybe<NavigationItemConnectInput>;
};

export type NavigationCategoryCreateInput = {
  NavigationItem?: InputMaybe<NavigationItemCreateInput>;
};

export type NavigationCategoryCreateManyInlineInput = {
  /** Connect multiple existing NavigationCategory documents */
  connect?: InputMaybe<Array<NavigationCategoryWhereUniqueInput>>;
  /** Create and connect multiple existing NavigationCategory documents */
  create?: InputMaybe<Array<NavigationCategoryCreateInput>>;
};

export type NavigationCategoryCreateOneInlineInput = {
  /** Connect one existing NavigationCategory document */
  connect?: InputMaybe<NavigationCategoryWhereUniqueInput>;
  /** Create and connect one NavigationCategory document */
  create?: InputMaybe<NavigationCategoryCreateInput>;
};

export type NavigationCategoryUpdateInput = {
  NavigationItem?: InputMaybe<NavigationItemUpdateInput>;
};

export type NavigationCategoryUpdateManyInlineInput = {
  /** Connect multiple existing NavigationCategory documents */
  connect?: InputMaybe<Array<NavigationCategoryConnectInput>>;
  /** Create and connect multiple NavigationCategory documents */
  create?: InputMaybe<Array<NavigationCategoryCreateInput>>;
  /** Delete multiple NavigationCategory documents */
  delete?: InputMaybe<Array<NavigationCategoryWhereUniqueInput>>;
  /** Disconnect multiple NavigationCategory documents */
  disconnect?: InputMaybe<Array<NavigationCategoryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NavigationCategory documents */
  set?: InputMaybe<Array<NavigationCategoryWhereUniqueInput>>;
  /** Update multiple NavigationCategory documents */
  update?: InputMaybe<Array<NavigationCategoryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NavigationCategory documents */
  upsert?: InputMaybe<Array<NavigationCategoryUpsertWithNestedWhereUniqueInput>>;
};

export type NavigationCategoryUpdateManyWithNestedWhereInput = {
  NavigationItem?: InputMaybe<NavigationItemUpdateManyWithNestedWhereInput>;
};

export type NavigationCategoryUpdateOneInlineInput = {
  /** Connect existing NavigationCategory document */
  connect?: InputMaybe<NavigationCategoryWhereUniqueInput>;
  /** Create and connect one NavigationCategory document */
  create?: InputMaybe<NavigationCategoryCreateInput>;
  /** Delete currently connected NavigationCategory document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NavigationCategory document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NavigationCategory document */
  update?: InputMaybe<NavigationCategoryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NavigationCategory document */
  upsert?: InputMaybe<NavigationCategoryUpsertWithNestedWhereUniqueInput>;
};

export type NavigationCategoryUpdateWithNestedWhereUniqueInput = {
  NavigationItem?: InputMaybe<NavigationItemUpdateWithNestedWhereUniqueInput>;
};

export type NavigationCategoryUpsertWithNestedWhereUniqueInput = {
  NavigationItem?: InputMaybe<NavigationItemUpsertWithNestedWhereUniqueInput>;
};

export type NavigationCategoryWhereInput = {
  NavigationItem?: InputMaybe<NavigationItemWhereInput>;
};

export type NavigationCategoryWhereUniqueInput = {
  NavigationItem?: InputMaybe<NavigationItemWhereUniqueInput>;
};

export type NavigationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: NavigationWhereUniqueInput;
};

/** A connection to a list of items. */
export type NavigationConnection = {
  __typename?: 'NavigationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<NavigationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type NavigationCreateInput = {
  cardComponentTitle?: InputMaybe<Scalars['String']['input']>;
  cardItemtId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<NavigationCategoryCreateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  key: Scalars['String']['input'];
  links?: InputMaybe<LinkCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<NavigationCreateLocalizationsInput>;
  navCard?: InputMaybe<NavigationNavCardCreateOneInlineInput>;
  /** navUrl input for default locale (default) */
  navUrl?: InputMaybe<Scalars['String']['input']>;
  navigation_images?: InputMaybe<NavigationNavigation_ImagesCreateManyInlineInput>;
  positon: NavigationTypes;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NavigationCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  navUrl?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NavigationCreateLocalizationInput = {
  /** Localization input */
  data: NavigationCreateLocalizationDataInput;
  locale: Locale;
};

export type NavigationCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<NavigationCreateLocalizationInput>>;
};

export type NavigationCreateManyInlineInput = {
  /** Connect multiple existing Navigation documents */
  connect?: InputMaybe<Array<NavigationWhereUniqueInput>>;
  /** Create and connect multiple existing Navigation documents */
  create?: InputMaybe<Array<NavigationCreateInput>>;
};

export type NavigationCreateOneInlineInput = {
  /** Connect one existing Navigation document */
  connect?: InputMaybe<NavigationWhereUniqueInput>;
  /** Create and connect one Navigation document */
  create?: InputMaybe<NavigationCreateInput>;
};

/** An edge in a connection. */
export type NavigationEdge = {
  __typename?: 'NavigationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Navigation;
};

export type NavigationItem = Entity & Node & {
  __typename?: 'NavigationItem';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<NavigationItem>;
  /** List of NavigationItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<NavigationItem>;
  navigation?: Maybe<Navigation>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Navigation Sub Category  */
  subCategory: Array<NavigationItemSubCategory>;
  /** Link to the page this navigation item refers to */
  targetLink?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** Tracking Secondary Navigation */
  trackingSecondaryNavigation?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type NavigationItemCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type NavigationItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NavigationItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type NavigationItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type NavigationItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type NavigationItemNavigationArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NavigationItemPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type NavigationItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NavigationItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type NavigationItemSubCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type NavigationItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type NavigationItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type NavigationItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: NavigationItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type NavigationItemConnection = {
  __typename?: 'NavigationItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<NavigationItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type NavigationItemCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<NavigationItemCreateLocalizationsInput>;
  navigation?: InputMaybe<NavigationCreateOneInlineInput>;
  subCategory?: InputMaybe<NavigationItemSubCategoryCreateManyInlineInput>;
  /** targetLink input for default locale (default) */
  targetLink?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  trackingSecondaryNavigation?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NavigationItemCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  targetLink?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NavigationItemCreateLocalizationInput = {
  /** Localization input */
  data: NavigationItemCreateLocalizationDataInput;
  locale: Locale;
};

export type NavigationItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<NavigationItemCreateLocalizationInput>>;
};

export type NavigationItemCreateManyInlineInput = {
  /** Connect multiple existing NavigationItem documents */
  connect?: InputMaybe<Array<NavigationItemWhereUniqueInput>>;
  /** Create and connect multiple existing NavigationItem documents */
  create?: InputMaybe<Array<NavigationItemCreateInput>>;
};

export type NavigationItemCreateOneInlineInput = {
  /** Connect one existing NavigationItem document */
  connect?: InputMaybe<NavigationItemWhereUniqueInput>;
  /** Create and connect one NavigationItem document */
  create?: InputMaybe<NavigationItemCreateInput>;
};

/** An edge in a connection. */
export type NavigationItemEdge = {
  __typename?: 'NavigationItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: NavigationItem;
};

/** Identifies documents */
export type NavigationItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<NavigationItemWhereStageInput>;
  documentInStages_none?: InputMaybe<NavigationItemWhereStageInput>;
  documentInStages_some?: InputMaybe<NavigationItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  navigation?: InputMaybe<NavigationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values in which the union is empty */
  subCategory_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  subCategory_some?: InputMaybe<NavigationItemSubCategoryWhereInput>;
  trackingSecondaryNavigation?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  trackingSecondaryNavigation_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  trackingSecondaryNavigation_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  trackingSecondaryNavigation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  trackingSecondaryNavigation_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  trackingSecondaryNavigation_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  trackingSecondaryNavigation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  trackingSecondaryNavigation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  trackingSecondaryNavigation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  trackingSecondaryNavigation_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum NavigationItemOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  targetLink_ASC = 'targetLink_ASC',
  targetLink_DESC = 'targetLink_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  trackingSecondaryNavigation_ASC = 'trackingSecondaryNavigation_ASC',
  trackingSecondaryNavigation_DESC = 'trackingSecondaryNavigation_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type NavigationItemSubCategory = Link;

export type NavigationItemSubCategoryConnectInput = {
  Link?: InputMaybe<LinkConnectInput>;
};

export type NavigationItemSubCategoryCreateInput = {
  Link?: InputMaybe<LinkCreateInput>;
};

export type NavigationItemSubCategoryCreateManyInlineInput = {
  /** Connect multiple existing NavigationItemSubCategory documents */
  connect?: InputMaybe<Array<NavigationItemSubCategoryWhereUniqueInput>>;
  /** Create and connect multiple existing NavigationItemSubCategory documents */
  create?: InputMaybe<Array<NavigationItemSubCategoryCreateInput>>;
};

export type NavigationItemSubCategoryCreateOneInlineInput = {
  /** Connect one existing NavigationItemSubCategory document */
  connect?: InputMaybe<NavigationItemSubCategoryWhereUniqueInput>;
  /** Create and connect one NavigationItemSubCategory document */
  create?: InputMaybe<NavigationItemSubCategoryCreateInput>;
};

export type NavigationItemSubCategoryUpdateInput = {
  Link?: InputMaybe<LinkUpdateInput>;
};

export type NavigationItemSubCategoryUpdateManyInlineInput = {
  /** Connect multiple existing NavigationItemSubCategory documents */
  connect?: InputMaybe<Array<NavigationItemSubCategoryConnectInput>>;
  /** Create and connect multiple NavigationItemSubCategory documents */
  create?: InputMaybe<Array<NavigationItemSubCategoryCreateInput>>;
  /** Delete multiple NavigationItemSubCategory documents */
  delete?: InputMaybe<Array<NavigationItemSubCategoryWhereUniqueInput>>;
  /** Disconnect multiple NavigationItemSubCategory documents */
  disconnect?: InputMaybe<Array<NavigationItemSubCategoryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NavigationItemSubCategory documents */
  set?: InputMaybe<Array<NavigationItemSubCategoryWhereUniqueInput>>;
  /** Update multiple NavigationItemSubCategory documents */
  update?: InputMaybe<Array<NavigationItemSubCategoryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NavigationItemSubCategory documents */
  upsert?: InputMaybe<Array<NavigationItemSubCategoryUpsertWithNestedWhereUniqueInput>>;
};

export type NavigationItemSubCategoryUpdateManyWithNestedWhereInput = {
  Link?: InputMaybe<LinkUpdateManyWithNestedWhereInput>;
};

export type NavigationItemSubCategoryUpdateOneInlineInput = {
  /** Connect existing NavigationItemSubCategory document */
  connect?: InputMaybe<NavigationItemSubCategoryWhereUniqueInput>;
  /** Create and connect one NavigationItemSubCategory document */
  create?: InputMaybe<NavigationItemSubCategoryCreateInput>;
  /** Delete currently connected NavigationItemSubCategory document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NavigationItemSubCategory document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NavigationItemSubCategory document */
  update?: InputMaybe<NavigationItemSubCategoryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NavigationItemSubCategory document */
  upsert?: InputMaybe<NavigationItemSubCategoryUpsertWithNestedWhereUniqueInput>;
};

export type NavigationItemSubCategoryUpdateWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
};

export type NavigationItemSubCategoryUpsertWithNestedWhereUniqueInput = {
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
};

export type NavigationItemSubCategoryWhereInput = {
  Link?: InputMaybe<LinkWhereInput>;
};

export type NavigationItemSubCategoryWhereUniqueInput = {
  Link?: InputMaybe<LinkWhereUniqueInput>;
};

export type NavigationItemUpdateInput = {
  /** Manage document localizations */
  localizations?: InputMaybe<NavigationItemUpdateLocalizationsInput>;
  navigation?: InputMaybe<NavigationUpdateOneInlineInput>;
  subCategory?: InputMaybe<NavigationItemSubCategoryUpdateManyInlineInput>;
  /** targetLink input for default locale (default) */
  targetLink?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  trackingSecondaryNavigation?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationItemUpdateLocalizationDataInput = {
  targetLink?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationItemUpdateLocalizationInput = {
  data: NavigationItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type NavigationItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<NavigationItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<NavigationItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<NavigationItemUpsertLocalizationInput>>;
};

export type NavigationItemUpdateManyInlineInput = {
  /** Connect multiple existing NavigationItem documents */
  connect?: InputMaybe<Array<NavigationItemConnectInput>>;
  /** Create and connect multiple NavigationItem documents */
  create?: InputMaybe<Array<NavigationItemCreateInput>>;
  /** Delete multiple NavigationItem documents */
  delete?: InputMaybe<Array<NavigationItemWhereUniqueInput>>;
  /** Disconnect multiple NavigationItem documents */
  disconnect?: InputMaybe<Array<NavigationItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NavigationItem documents */
  set?: InputMaybe<Array<NavigationItemWhereUniqueInput>>;
  /** Update multiple NavigationItem documents */
  update?: InputMaybe<Array<NavigationItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NavigationItem documents */
  upsert?: InputMaybe<Array<NavigationItemUpsertWithNestedWhereUniqueInput>>;
};

export type NavigationItemUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<NavigationItemUpdateManyLocalizationsInput>;
  /** targetLink input for default locale (default) */
  targetLink?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  trackingSecondaryNavigation?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationItemUpdateManyLocalizationDataInput = {
  targetLink?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationItemUpdateManyLocalizationInput = {
  data: NavigationItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type NavigationItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<NavigationItemUpdateManyLocalizationInput>>;
};

export type NavigationItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: NavigationItemUpdateManyInput;
  /** Document search */
  where: NavigationItemWhereInput;
};

export type NavigationItemUpdateOneInlineInput = {
  /** Connect existing NavigationItem document */
  connect?: InputMaybe<NavigationItemWhereUniqueInput>;
  /** Create and connect one NavigationItem document */
  create?: InputMaybe<NavigationItemCreateInput>;
  /** Delete currently connected NavigationItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NavigationItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NavigationItem document */
  update?: InputMaybe<NavigationItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NavigationItem document */
  upsert?: InputMaybe<NavigationItemUpsertWithNestedWhereUniqueInput>;
};

export type NavigationItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: NavigationItemUpdateInput;
  /** Unique document search */
  where: NavigationItemWhereUniqueInput;
};

export type NavigationItemUpsertInput = {
  /** Create document if it didn't exist */
  create: NavigationItemCreateInput;
  /** Update document if it exists */
  update: NavigationItemUpdateInput;
};

export type NavigationItemUpsertLocalizationInput = {
  create: NavigationItemCreateLocalizationDataInput;
  locale: Locale;
  update: NavigationItemUpdateLocalizationDataInput;
};

export type NavigationItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: NavigationItemUpsertInput;
  /** Unique document search */
  where: NavigationItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type NavigationItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type NavigationItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<NavigationItemWhereStageInput>;
  documentInStages_none?: InputMaybe<NavigationItemWhereStageInput>;
  documentInStages_some?: InputMaybe<NavigationItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  navigation?: InputMaybe<NavigationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values in which the union is empty */
  subCategory_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  subCategory_some?: InputMaybe<NavigationItemSubCategoryWhereInput>;
  targetLink?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  targetLink_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  targetLink_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  targetLink_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  targetLink_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  targetLink_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  targetLink_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  targetLink_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  targetLink_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  targetLink_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  trackingSecondaryNavigation?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  trackingSecondaryNavigation_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  trackingSecondaryNavigation_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  trackingSecondaryNavigation_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  trackingSecondaryNavigation_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  trackingSecondaryNavigation_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  trackingSecondaryNavigation_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  trackingSecondaryNavigation_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  trackingSecondaryNavigation_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  trackingSecondaryNavigation_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type NavigationItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<NavigationItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References NavigationItem record uniquely */
export type NavigationItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type NavigationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardComponentTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardComponentTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardComponentTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardComponentTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardComponentTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardComponentTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardComponentTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardComponentTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardComponentTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardComponentTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardItemtId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardItemtId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardItemtId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardItemtId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardItemtId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardItemtId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardItemtId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardItemtId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardItemtId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardItemtId_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  category_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  category_some?: InputMaybe<NavigationCategoryWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<NavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<NavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<NavigationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  /** All values in which the union is connected to the given models */
  navCard?: InputMaybe<NavigationNavCardWhereInput>;
  /** All values in which the union is empty */
  navCard_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** All values in which the union is empty */
  navigation_images_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  navigation_images_some?: InputMaybe<NavigationNavigation_ImagesWhereInput>;
  positon?: InputMaybe<NavigationTypes>;
  /** All values that are contained in given list. */
  positon_in?: InputMaybe<Array<InputMaybe<NavigationTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  positon_not?: InputMaybe<NavigationTypes>;
  /** All values that are not contained in given list. */
  positon_not_in?: InputMaybe<Array<InputMaybe<NavigationTypes>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export type NavigationNavCard = CardComponent;

export type NavigationNavCardConnectInput = {
  CardComponent?: InputMaybe<CardComponentConnectInput>;
};

export type NavigationNavCardCreateInput = {
  CardComponent?: InputMaybe<CardComponentCreateInput>;
};

export type NavigationNavCardCreateManyInlineInput = {
  /** Connect multiple existing NavigationNavCard documents */
  connect?: InputMaybe<Array<NavigationNavCardWhereUniqueInput>>;
  /** Create and connect multiple existing NavigationNavCard documents */
  create?: InputMaybe<Array<NavigationNavCardCreateInput>>;
};

export type NavigationNavCardCreateOneInlineInput = {
  /** Connect one existing NavigationNavCard document */
  connect?: InputMaybe<NavigationNavCardWhereUniqueInput>;
  /** Create and connect one NavigationNavCard document */
  create?: InputMaybe<NavigationNavCardCreateInput>;
};

export type NavigationNavCardUpdateInput = {
  CardComponent?: InputMaybe<CardComponentUpdateInput>;
};

export type NavigationNavCardUpdateManyInlineInput = {
  /** Connect multiple existing NavigationNavCard documents */
  connect?: InputMaybe<Array<NavigationNavCardConnectInput>>;
  /** Create and connect multiple NavigationNavCard documents */
  create?: InputMaybe<Array<NavigationNavCardCreateInput>>;
  /** Delete multiple NavigationNavCard documents */
  delete?: InputMaybe<Array<NavigationNavCardWhereUniqueInput>>;
  /** Disconnect multiple NavigationNavCard documents */
  disconnect?: InputMaybe<Array<NavigationNavCardWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NavigationNavCard documents */
  set?: InputMaybe<Array<NavigationNavCardWhereUniqueInput>>;
  /** Update multiple NavigationNavCard documents */
  update?: InputMaybe<Array<NavigationNavCardUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NavigationNavCard documents */
  upsert?: InputMaybe<Array<NavigationNavCardUpsertWithNestedWhereUniqueInput>>;
};

export type NavigationNavCardUpdateManyWithNestedWhereInput = {
  CardComponent?: InputMaybe<CardComponentUpdateManyWithNestedWhereInput>;
};

export type NavigationNavCardUpdateOneInlineInput = {
  /** Connect existing NavigationNavCard document */
  connect?: InputMaybe<NavigationNavCardWhereUniqueInput>;
  /** Create and connect one NavigationNavCard document */
  create?: InputMaybe<NavigationNavCardCreateInput>;
  /** Delete currently connected NavigationNavCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NavigationNavCard document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NavigationNavCard document */
  update?: InputMaybe<NavigationNavCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NavigationNavCard document */
  upsert?: InputMaybe<NavigationNavCardUpsertWithNestedWhereUniqueInput>;
};

export type NavigationNavCardUpdateWithNestedWhereUniqueInput = {
  CardComponent?: InputMaybe<CardComponentUpdateWithNestedWhereUniqueInput>;
};

export type NavigationNavCardUpsertWithNestedWhereUniqueInput = {
  CardComponent?: InputMaybe<CardComponentUpsertWithNestedWhereUniqueInput>;
};

export type NavigationNavCardWhereInput = {
  CardComponent?: InputMaybe<CardComponentWhereInput>;
};

export type NavigationNavCardWhereUniqueInput = {
  CardComponent?: InputMaybe<CardComponentWhereUniqueInput>;
};

export type NavigationNavigation_Images = AssetComponent;

export type NavigationNavigation_ImagesConnectInput = {
  AssetComponent?: InputMaybe<AssetComponentConnectInput>;
};

export type NavigationNavigation_ImagesCreateInput = {
  AssetComponent?: InputMaybe<AssetComponentCreateInput>;
};

export type NavigationNavigation_ImagesCreateManyInlineInput = {
  /** Connect multiple existing NavigationNavigation_images documents */
  connect?: InputMaybe<Array<NavigationNavigation_ImagesWhereUniqueInput>>;
  /** Create and connect multiple existing NavigationNavigation_images documents */
  create?: InputMaybe<Array<NavigationNavigation_ImagesCreateInput>>;
};

export type NavigationNavigation_ImagesCreateOneInlineInput = {
  /** Connect one existing NavigationNavigation_images document */
  connect?: InputMaybe<NavigationNavigation_ImagesWhereUniqueInput>;
  /** Create and connect one NavigationNavigation_images document */
  create?: InputMaybe<NavigationNavigation_ImagesCreateInput>;
};

export type NavigationNavigation_ImagesUpdateInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateInput>;
};

export type NavigationNavigation_ImagesUpdateManyInlineInput = {
  /** Connect multiple existing NavigationNavigation_images documents */
  connect?: InputMaybe<Array<NavigationNavigation_ImagesConnectInput>>;
  /** Create and connect multiple NavigationNavigation_images documents */
  create?: InputMaybe<Array<NavigationNavigation_ImagesCreateInput>>;
  /** Delete multiple NavigationNavigation_images documents */
  delete?: InputMaybe<Array<NavigationNavigation_ImagesWhereUniqueInput>>;
  /** Disconnect multiple NavigationNavigation_images documents */
  disconnect?: InputMaybe<Array<NavigationNavigation_ImagesWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NavigationNavigation_images documents */
  set?: InputMaybe<Array<NavigationNavigation_ImagesWhereUniqueInput>>;
  /** Update multiple NavigationNavigation_images documents */
  update?: InputMaybe<Array<NavigationNavigation_ImagesUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NavigationNavigation_images documents */
  upsert?: InputMaybe<Array<NavigationNavigation_ImagesUpsertWithNestedWhereUniqueInput>>;
};

export type NavigationNavigation_ImagesUpdateManyWithNestedWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateManyWithNestedWhereInput>;
};

export type NavigationNavigation_ImagesUpdateOneInlineInput = {
  /** Connect existing NavigationNavigation_images document */
  connect?: InputMaybe<NavigationNavigation_ImagesWhereUniqueInput>;
  /** Create and connect one NavigationNavigation_images document */
  create?: InputMaybe<NavigationNavigation_ImagesCreateInput>;
  /** Delete currently connected NavigationNavigation_images document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NavigationNavigation_images document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NavigationNavigation_images document */
  update?: InputMaybe<NavigationNavigation_ImagesUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NavigationNavigation_images document */
  upsert?: InputMaybe<NavigationNavigation_ImagesUpsertWithNestedWhereUniqueInput>;
};

export type NavigationNavigation_ImagesUpdateWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpdateWithNestedWhereUniqueInput>;
};

export type NavigationNavigation_ImagesUpsertWithNestedWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentUpsertWithNestedWhereUniqueInput>;
};

export type NavigationNavigation_ImagesWhereInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereInput>;
};

export type NavigationNavigation_ImagesWhereUniqueInput = {
  AssetComponent?: InputMaybe<AssetComponentWhereUniqueInput>;
};

export enum NavigationOrderByInput {
  cardComponentTitle_ASC = 'cardComponentTitle_ASC',
  cardComponentTitle_DESC = 'cardComponentTitle_DESC',
  cardItemtId_ASC = 'cardItemtId_ASC',
  cardItemtId_DESC = 'cardItemtId_DESC',
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  key_ASC = 'key_ASC',
  key_DESC = 'key_DESC',
  navUrl_ASC = 'navUrl_ASC',
  navUrl_DESC = 'navUrl_DESC',
  positon_ASC = 'positon_ASC',
  positon_DESC = 'positon_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Specifies where on the page the navigation will be displayed */
export enum NavigationTypes {
  Footer = 'Footer',
  Main = 'Main'
}

export type NavigationUpdateInput = {
  cardComponentTitle?: InputMaybe<Scalars['String']['input']>;
  cardItemtId?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<NavigationCategoryUpdateManyInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<LinkUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<NavigationUpdateLocalizationsInput>;
  navCard?: InputMaybe<NavigationNavCardUpdateOneInlineInput>;
  /** navUrl input for default locale (default) */
  navUrl?: InputMaybe<Scalars['String']['input']>;
  navigation_images?: InputMaybe<NavigationNavigation_ImagesUpdateManyInlineInput>;
  positon?: InputMaybe<NavigationTypes>;
};

export type NavigationUpdateLocalizationDataInput = {
  navUrl?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationUpdateLocalizationInput = {
  data: NavigationUpdateLocalizationDataInput;
  locale: Locale;
};

export type NavigationUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<NavigationCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<NavigationUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<NavigationUpsertLocalizationInput>>;
};

export type NavigationUpdateManyInlineInput = {
  /** Connect multiple existing Navigation documents */
  connect?: InputMaybe<Array<NavigationConnectInput>>;
  /** Create and connect multiple Navigation documents */
  create?: InputMaybe<Array<NavigationCreateInput>>;
  /** Delete multiple Navigation documents */
  delete?: InputMaybe<Array<NavigationWhereUniqueInput>>;
  /** Disconnect multiple Navigation documents */
  disconnect?: InputMaybe<Array<NavigationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Navigation documents */
  set?: InputMaybe<Array<NavigationWhereUniqueInput>>;
  /** Update multiple Navigation documents */
  update?: InputMaybe<Array<NavigationUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Navigation documents */
  upsert?: InputMaybe<Array<NavigationUpsertWithNestedWhereUniqueInput>>;
};

export type NavigationUpdateManyInput = {
  cardComponentTitle?: InputMaybe<Scalars['String']['input']>;
  cardItemtId?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<NavigationUpdateManyLocalizationsInput>;
  /** navUrl input for default locale (default) */
  navUrl?: InputMaybe<Scalars['String']['input']>;
  positon?: InputMaybe<NavigationTypes>;
};

export type NavigationUpdateManyLocalizationDataInput = {
  navUrl?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationUpdateManyLocalizationInput = {
  data: NavigationUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type NavigationUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<NavigationUpdateManyLocalizationInput>>;
};

export type NavigationUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: NavigationUpdateManyInput;
  /** Document search */
  where: NavigationWhereInput;
};

export type NavigationUpdateOneInlineInput = {
  /** Connect existing Navigation document */
  connect?: InputMaybe<NavigationWhereUniqueInput>;
  /** Create and connect one Navigation document */
  create?: InputMaybe<NavigationCreateInput>;
  /** Delete currently connected Navigation document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Navigation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Navigation document */
  update?: InputMaybe<NavigationUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Navigation document */
  upsert?: InputMaybe<NavigationUpsertWithNestedWhereUniqueInput>;
};

export type NavigationUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: NavigationUpdateInput;
  /** Unique document search */
  where: NavigationWhereUniqueInput;
};

export type NavigationUpsertInput = {
  /** Create document if it didn't exist */
  create: NavigationCreateInput;
  /** Update document if it exists */
  update: NavigationUpdateInput;
};

export type NavigationUpsertLocalizationInput = {
  create: NavigationCreateLocalizationDataInput;
  locale: Locale;
  update: NavigationUpdateLocalizationDataInput;
};

export type NavigationUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: NavigationUpsertInput;
  /** Unique document search */
  where: NavigationWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type NavigationWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type NavigationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardComponentTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardComponentTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardComponentTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardComponentTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardComponentTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardComponentTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardComponentTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardComponentTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardComponentTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardComponentTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  cardItemtId?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cardItemtId_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cardItemtId_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cardItemtId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardItemtId_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cardItemtId_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cardItemtId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cardItemtId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cardItemtId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cardItemtId_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  category_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  category_some?: InputMaybe<NavigationCategoryWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<NavigationWhereStageInput>;
  documentInStages_none?: InputMaybe<NavigationWhereStageInput>;
  documentInStages_some?: InputMaybe<NavigationWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  key_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  key_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  key_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  key_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  key_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  key_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  key_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  key_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  key_starts_with?: InputMaybe<Scalars['String']['input']>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  /** All values in which the union is connected to the given models */
  navCard?: InputMaybe<NavigationNavCardWhereInput>;
  /** All values in which the union is empty */
  navCard_empty?: InputMaybe<Scalars['Boolean']['input']>;
  navUrl?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  navUrl_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  navUrl_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  navUrl_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  navUrl_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  navUrl_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  navUrl_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  navUrl_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  navUrl_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  navUrl_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  navigation_images_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  navigation_images_some?: InputMaybe<NavigationNavigation_ImagesWhereInput>;
  positon?: InputMaybe<NavigationTypes>;
  /** All values that are contained in given list. */
  positon_in?: InputMaybe<Array<InputMaybe<NavigationTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  positon_not?: InputMaybe<NavigationTypes>;
  /** All values that are not contained in given list. */
  positon_not_in?: InputMaybe<Array<InputMaybe<NavigationTypes>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type NavigationWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NavigationWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NavigationWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NavigationWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<NavigationWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Navigation record uniquely */
export type NavigationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** The Stage of an object */
  stage: Stage;
};

export type NotificationBanner = Entity & Node & {
  __typename?: 'NotificationBanner';
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Choose the type of banner. If not available, a new value should be added to the enumeration model. */
  bannerType?: Maybe<BannerType>;
  /** Label given to this content model, only seen from within the CMS */
  cmsTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<NotificationBanner>;
  /** List of NotificationBanner versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<NotificationBanner>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type NotificationBannerCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type NotificationBannerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NotificationBannerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type NotificationBannerHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type NotificationBannerLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NotificationBannerLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type NotificationBannerPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type NotificationBannerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type NotificationBannerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type NotificationBannerUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type NotificationBannerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type NotificationBannerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: NotificationBannerWhereUniqueInput;
};

/** A connection to a list of items. */
export type NotificationBannerConnection = {
  __typename?: 'NotificationBannerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<NotificationBannerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type NotificationBannerCreateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bannerType?: InputMaybe<BannerType>;
  cmsTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<NotificationBannerCreateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationBannerCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationBannerCreateLocalizationInput = {
  /** Localization input */
  data: NotificationBannerCreateLocalizationDataInput;
  locale: Locale;
};

export type NotificationBannerCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<NotificationBannerCreateLocalizationInput>>;
};

export type NotificationBannerCreateManyInlineInput = {
  /** Connect multiple existing NotificationBanner documents */
  connect?: InputMaybe<Array<NotificationBannerWhereUniqueInput>>;
  /** Create and connect multiple existing NotificationBanner documents */
  create?: InputMaybe<Array<NotificationBannerCreateInput>>;
};

export type NotificationBannerCreateOneInlineInput = {
  /** Connect one existing NotificationBanner document */
  connect?: InputMaybe<NotificationBannerWhereUniqueInput>;
  /** Create and connect one NotificationBanner document */
  create?: InputMaybe<NotificationBannerCreateInput>;
};

/** An edge in a connection. */
export type NotificationBannerEdge = {
  __typename?: 'NotificationBannerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: NotificationBanner;
};

/** Identifies documents */
export type NotificationBannerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NotificationBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NotificationBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NotificationBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  active_not?: InputMaybe<Scalars['Boolean']['input']>;
  bannerType?: InputMaybe<BannerType>;
  /** All values that are contained in given list. */
  bannerType_in?: InputMaybe<Array<InputMaybe<BannerType>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerType_not?: InputMaybe<BannerType>;
  /** All values that are not contained in given list. */
  bannerType_not_in?: InputMaybe<Array<InputMaybe<BannerType>>>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<NotificationBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<NotificationBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<NotificationBannerWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum NotificationBannerOrderByInput {
  active_ASC = 'active_ASC',
  active_DESC = 'active_DESC',
  bannerType_ASC = 'bannerType_ASC',
  bannerType_DESC = 'bannerType_DESC',
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type NotificationBannerUpdateInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bannerType?: InputMaybe<BannerType>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<NotificationBannerUpdateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationBannerUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationBannerUpdateLocalizationInput = {
  data: NotificationBannerUpdateLocalizationDataInput;
  locale: Locale;
};

export type NotificationBannerUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<NotificationBannerCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<NotificationBannerUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<NotificationBannerUpsertLocalizationInput>>;
};

export type NotificationBannerUpdateManyInlineInput = {
  /** Connect multiple existing NotificationBanner documents */
  connect?: InputMaybe<Array<NotificationBannerConnectInput>>;
  /** Create and connect multiple NotificationBanner documents */
  create?: InputMaybe<Array<NotificationBannerCreateInput>>;
  /** Delete multiple NotificationBanner documents */
  delete?: InputMaybe<Array<NotificationBannerWhereUniqueInput>>;
  /** Disconnect multiple NotificationBanner documents */
  disconnect?: InputMaybe<Array<NotificationBannerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing NotificationBanner documents */
  set?: InputMaybe<Array<NotificationBannerWhereUniqueInput>>;
  /** Update multiple NotificationBanner documents */
  update?: InputMaybe<Array<NotificationBannerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple NotificationBanner documents */
  upsert?: InputMaybe<Array<NotificationBannerUpsertWithNestedWhereUniqueInput>>;
};

export type NotificationBannerUpdateManyInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<NotificationBannerUpdateManyLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationBannerUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationBannerUpdateManyLocalizationInput = {
  data: NotificationBannerUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type NotificationBannerUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<NotificationBannerUpdateManyLocalizationInput>>;
};

export type NotificationBannerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: NotificationBannerUpdateManyInput;
  /** Document search */
  where: NotificationBannerWhereInput;
};

export type NotificationBannerUpdateOneInlineInput = {
  /** Connect existing NotificationBanner document */
  connect?: InputMaybe<NotificationBannerWhereUniqueInput>;
  /** Create and connect one NotificationBanner document */
  create?: InputMaybe<NotificationBannerCreateInput>;
  /** Delete currently connected NotificationBanner document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected NotificationBanner document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single NotificationBanner document */
  update?: InputMaybe<NotificationBannerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single NotificationBanner document */
  upsert?: InputMaybe<NotificationBannerUpsertWithNestedWhereUniqueInput>;
};

export type NotificationBannerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: NotificationBannerUpdateInput;
  /** Unique document search */
  where: NotificationBannerWhereUniqueInput;
};

export type NotificationBannerUpsertInput = {
  /** Create document if it didn't exist */
  create: NotificationBannerCreateInput;
  /** Update document if it exists */
  update: NotificationBannerUpdateInput;
};

export type NotificationBannerUpsertLocalizationInput = {
  create: NotificationBannerCreateLocalizationDataInput;
  locale: Locale;
  update: NotificationBannerUpdateLocalizationDataInput;
};

export type NotificationBannerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: NotificationBannerUpsertInput;
  /** Unique document search */
  where: NotificationBannerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type NotificationBannerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type NotificationBannerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NotificationBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NotificationBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NotificationBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  active_not?: InputMaybe<Scalars['Boolean']['input']>;
  bannerType?: InputMaybe<BannerType>;
  /** All values that are contained in given list. */
  bannerType_in?: InputMaybe<Array<InputMaybe<BannerType>>>;
  /** Any other value that exists and is not equal to the given value. */
  bannerType_not?: InputMaybe<BannerType>;
  /** All values that are not contained in given list. */
  bannerType_not_in?: InputMaybe<Array<InputMaybe<BannerType>>>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<NotificationBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<NotificationBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<NotificationBannerWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type NotificationBannerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<NotificationBannerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<NotificationBannerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<NotificationBannerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<NotificationBannerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References NotificationBanner record uniquely */
export type NotificationBannerWhereUniqueInput = {
  bannerType?: InputMaybe<BannerType>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PageFooter = Entity & Node & {
  __typename?: 'PageFooter';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<PageFooter>;
  genericPages: Array<GenericPage>;
  /** List of PageFooter versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type PageFooterCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageFooterDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type PageFooterGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type PageFooterHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type PageFooterPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageFooterScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PageFooterUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PageFooterConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PageFooterWhereUniqueInput;
};

/** A connection to a list of items. */
export type PageFooterConnection = {
  __typename?: 'PageFooterConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PageFooterEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PageFooterCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PageFooterCreateManyInlineInput = {
  /** Connect multiple existing PageFooter documents */
  connect?: InputMaybe<Array<PageFooterWhereUniqueInput>>;
  /** Create and connect multiple existing PageFooter documents */
  create?: InputMaybe<Array<PageFooterCreateInput>>;
};

export type PageFooterCreateOneInlineInput = {
  /** Connect one existing PageFooter document */
  connect?: InputMaybe<PageFooterWhereUniqueInput>;
  /** Create and connect one PageFooter document */
  create?: InputMaybe<PageFooterCreateInput>;
};

/** An edge in a connection. */
export type PageFooterEdge = {
  __typename?: 'PageFooterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PageFooter;
};

/** Identifies documents */
export type PageFooterManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageFooterWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageFooterWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageFooterWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PageFooterWhereStageInput>;
  documentInStages_none?: InputMaybe<PageFooterWhereStageInput>;
  documentInStages_some?: InputMaybe<PageFooterWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PageFooterOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type PageFooterUpdateInput = {
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageFooterUpdateManyInlineInput = {
  /** Connect multiple existing PageFooter documents */
  connect?: InputMaybe<Array<PageFooterConnectInput>>;
  /** Create and connect multiple PageFooter documents */
  create?: InputMaybe<Array<PageFooterCreateInput>>;
  /** Delete multiple PageFooter documents */
  delete?: InputMaybe<Array<PageFooterWhereUniqueInput>>;
  /** Disconnect multiple PageFooter documents */
  disconnect?: InputMaybe<Array<PageFooterWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PageFooter documents */
  set?: InputMaybe<Array<PageFooterWhereUniqueInput>>;
  /** Update multiple PageFooter documents */
  update?: InputMaybe<Array<PageFooterUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PageFooter documents */
  upsert?: InputMaybe<Array<PageFooterUpsertWithNestedWhereUniqueInput>>;
};

export type PageFooterUpdateManyInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageFooterUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PageFooterUpdateManyInput;
  /** Document search */
  where: PageFooterWhereInput;
};

export type PageFooterUpdateOneInlineInput = {
  /** Connect existing PageFooter document */
  connect?: InputMaybe<PageFooterWhereUniqueInput>;
  /** Create and connect one PageFooter document */
  create?: InputMaybe<PageFooterCreateInput>;
  /** Delete currently connected PageFooter document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected PageFooter document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PageFooter document */
  update?: InputMaybe<PageFooterUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PageFooter document */
  upsert?: InputMaybe<PageFooterUpsertWithNestedWhereUniqueInput>;
};

export type PageFooterUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PageFooterUpdateInput;
  /** Unique document search */
  where: PageFooterWhereUniqueInput;
};

export type PageFooterUpsertInput = {
  /** Create document if it didn't exist */
  create: PageFooterCreateInput;
  /** Update document if it exists */
  update: PageFooterUpdateInput;
};

export type PageFooterUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PageFooterUpsertInput;
  /** Unique document search */
  where: PageFooterWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PageFooterWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PageFooterWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageFooterWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageFooterWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageFooterWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PageFooterWhereStageInput>;
  documentInStages_none?: InputMaybe<PageFooterWhereStageInput>;
  documentInStages_some?: InputMaybe<PageFooterWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PageFooterWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageFooterWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageFooterWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageFooterWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PageFooterWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References PageFooter record uniquely */
export type PageFooterWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PageHeader = Entity & Node & {
  __typename?: 'PageHeader';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<PageHeader>;
  genericPages: Array<GenericPage>;
  /** List of PageHeader versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<PageHeader>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type PageHeaderCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type PageHeaderCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageHeaderDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type PageHeaderGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type PageHeaderHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type PageHeaderLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type PageHeaderPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type PageHeaderPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PageHeaderScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PageHeaderUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type PageHeaderUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PageHeaderConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PageHeaderWhereUniqueInput;
};

/** A connection to a list of items. */
export type PageHeaderConnection = {
  __typename?: 'PageHeaderConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PageHeaderEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PageHeaderCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<PageHeaderCreateLocalizationsInput>;
  /** title input for default locale (default) */
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PageHeaderCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PageHeaderCreateLocalizationInput = {
  /** Localization input */
  data: PageHeaderCreateLocalizationDataInput;
  locale: Locale;
};

export type PageHeaderCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<PageHeaderCreateLocalizationInput>>;
};

export type PageHeaderCreateManyInlineInput = {
  /** Connect multiple existing PageHeader documents */
  connect?: InputMaybe<Array<PageHeaderWhereUniqueInput>>;
  /** Create and connect multiple existing PageHeader documents */
  create?: InputMaybe<Array<PageHeaderCreateInput>>;
};

export type PageHeaderCreateOneInlineInput = {
  /** Connect one existing PageHeader document */
  connect?: InputMaybe<PageHeaderWhereUniqueInput>;
  /** Create and connect one PageHeader document */
  create?: InputMaybe<PageHeaderCreateInput>;
};

/** An edge in a connection. */
export type PageHeaderEdge = {
  __typename?: 'PageHeaderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PageHeader;
};

/** Identifies documents */
export type PageHeaderManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageHeaderWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageHeaderWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageHeaderWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PageHeaderWhereStageInput>;
  documentInStages_none?: InputMaybe<PageHeaderWhereStageInput>;
  documentInStages_some?: InputMaybe<PageHeaderWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PageHeaderOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type PageHeaderUpdateInput = {
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<PageHeaderUpdateLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageHeaderUpdateLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageHeaderUpdateLocalizationInput = {
  data: PageHeaderUpdateLocalizationDataInput;
  locale: Locale;
};

export type PageHeaderUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<PageHeaderCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<PageHeaderUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<PageHeaderUpsertLocalizationInput>>;
};

export type PageHeaderUpdateManyInlineInput = {
  /** Connect multiple existing PageHeader documents */
  connect?: InputMaybe<Array<PageHeaderConnectInput>>;
  /** Create and connect multiple PageHeader documents */
  create?: InputMaybe<Array<PageHeaderCreateInput>>;
  /** Delete multiple PageHeader documents */
  delete?: InputMaybe<Array<PageHeaderWhereUniqueInput>>;
  /** Disconnect multiple PageHeader documents */
  disconnect?: InputMaybe<Array<PageHeaderWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PageHeader documents */
  set?: InputMaybe<Array<PageHeaderWhereUniqueInput>>;
  /** Update multiple PageHeader documents */
  update?: InputMaybe<Array<PageHeaderUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PageHeader documents */
  upsert?: InputMaybe<Array<PageHeaderUpsertWithNestedWhereUniqueInput>>;
};

export type PageHeaderUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<PageHeaderUpdateManyLocalizationsInput>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageHeaderUpdateManyLocalizationDataInput = {
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageHeaderUpdateManyLocalizationInput = {
  data: PageHeaderUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type PageHeaderUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<PageHeaderUpdateManyLocalizationInput>>;
};

export type PageHeaderUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PageHeaderUpdateManyInput;
  /** Document search */
  where: PageHeaderWhereInput;
};

export type PageHeaderUpdateOneInlineInput = {
  /** Connect existing PageHeader document */
  connect?: InputMaybe<PageHeaderWhereUniqueInput>;
  /** Create and connect one PageHeader document */
  create?: InputMaybe<PageHeaderCreateInput>;
  /** Delete currently connected PageHeader document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected PageHeader document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PageHeader document */
  update?: InputMaybe<PageHeaderUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PageHeader document */
  upsert?: InputMaybe<PageHeaderUpsertWithNestedWhereUniqueInput>;
};

export type PageHeaderUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PageHeaderUpdateInput;
  /** Unique document search */
  where: PageHeaderWhereUniqueInput;
};

export type PageHeaderUpsertInput = {
  /** Create document if it didn't exist */
  create: PageHeaderCreateInput;
  /** Update document if it exists */
  update: PageHeaderUpdateInput;
};

export type PageHeaderUpsertLocalizationInput = {
  create: PageHeaderCreateLocalizationDataInput;
  locale: Locale;
  update: PageHeaderUpdateLocalizationDataInput;
};

export type PageHeaderUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PageHeaderUpsertInput;
  /** Unique document search */
  where: PageHeaderWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PageHeaderWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PageHeaderWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageHeaderWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageHeaderWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageHeaderWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PageHeaderWhereStageInput>;
  documentInStages_none?: InputMaybe<PageHeaderWhereStageInput>;
  documentInStages_some?: InputMaybe<PageHeaderWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PageHeaderWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PageHeaderWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PageHeaderWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PageHeaderWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PageHeaderWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References PageHeader record uniquely */
export type PageHeaderWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** Number of items in the current page. */
  pageSize?: Maybe<Scalars['Int']['output']>;
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PopularSearchComponent = Entity & Node & {
  __typename?: 'PopularSearchComponent';
  anchorNav?: Maybe<AnchorNavigation>;
  assetsComponents: Array<AssetComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<PopularSearchComponent>;
  /** Title of the component */
  heading?: Maybe<Scalars['String']['output']>;
  /** List of PopularSearchComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Algolia Indices  */
  indices?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<PopularSearchComponent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Super text of the component */
  subHeading?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type PopularSearchComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PopularSearchComponentAssetsComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentWhereInput>;
};


export type PopularSearchComponentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type PopularSearchComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PopularSearchComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type PopularSearchComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type PopularSearchComponentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type PopularSearchComponentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type PopularSearchComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PopularSearchComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PopularSearchComponentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type PopularSearchComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PopularSearchComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PopularSearchComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type PopularSearchComponentConnection = {
  __typename?: 'PopularSearchComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PopularSearchComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PopularSearchComponentCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  assetsComponents?: InputMaybe<AssetComponentCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** indices input for default locale (default) */
  indices?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<PopularSearchComponentCreateLocalizationsInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PopularSearchComponentCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  indices?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PopularSearchComponentCreateLocalizationInput = {
  /** Localization input */
  data: PopularSearchComponentCreateLocalizationDataInput;
  locale: Locale;
};

export type PopularSearchComponentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<PopularSearchComponentCreateLocalizationInput>>;
};

export type PopularSearchComponentCreateManyInlineInput = {
  /** Connect multiple existing PopularSearchComponent documents */
  connect?: InputMaybe<Array<PopularSearchComponentWhereUniqueInput>>;
  /** Create and connect multiple existing PopularSearchComponent documents */
  create?: InputMaybe<Array<PopularSearchComponentCreateInput>>;
};

export type PopularSearchComponentCreateOneInlineInput = {
  /** Connect one existing PopularSearchComponent document */
  connect?: InputMaybe<PopularSearchComponentWhereUniqueInput>;
  /** Create and connect one PopularSearchComponent document */
  create?: InputMaybe<PopularSearchComponentCreateInput>;
};

/** An edge in a connection. */
export type PopularSearchComponentEdge = {
  __typename?: 'PopularSearchComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PopularSearchComponent;
};

/** Identifies documents */
export type PopularSearchComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PopularSearchComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PopularSearchComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PopularSearchComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PopularSearchComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<PopularSearchComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<PopularSearchComponentWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PopularSearchComponentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  indices_ASC = 'indices_ASC',
  indices_DESC = 'indices_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subHeading_ASC = 'subHeading_ASC',
  subHeading_DESC = 'subHeading_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type PopularSearchComponentUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  assetsComponents?: InputMaybe<AssetComponentUpdateManyInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** indices input for default locale (default) */
  indices?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<PopularSearchComponentUpdateLocalizationsInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type PopularSearchComponentUpdateLocalizationDataInput = {
  indices?: InputMaybe<Scalars['String']['input']>;
};

export type PopularSearchComponentUpdateLocalizationInput = {
  data: PopularSearchComponentUpdateLocalizationDataInput;
  locale: Locale;
};

export type PopularSearchComponentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<PopularSearchComponentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<PopularSearchComponentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<PopularSearchComponentUpsertLocalizationInput>>;
};

export type PopularSearchComponentUpdateManyInlineInput = {
  /** Connect multiple existing PopularSearchComponent documents */
  connect?: InputMaybe<Array<PopularSearchComponentConnectInput>>;
  /** Create and connect multiple PopularSearchComponent documents */
  create?: InputMaybe<Array<PopularSearchComponentCreateInput>>;
  /** Delete multiple PopularSearchComponent documents */
  delete?: InputMaybe<Array<PopularSearchComponentWhereUniqueInput>>;
  /** Disconnect multiple PopularSearchComponent documents */
  disconnect?: InputMaybe<Array<PopularSearchComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PopularSearchComponent documents */
  set?: InputMaybe<Array<PopularSearchComponentWhereUniqueInput>>;
  /** Update multiple PopularSearchComponent documents */
  update?: InputMaybe<Array<PopularSearchComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PopularSearchComponent documents */
  upsert?: InputMaybe<Array<PopularSearchComponentUpsertWithNestedWhereUniqueInput>>;
};

export type PopularSearchComponentUpdateManyInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  /** indices input for default locale (default) */
  indices?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<PopularSearchComponentUpdateManyLocalizationsInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type PopularSearchComponentUpdateManyLocalizationDataInput = {
  indices?: InputMaybe<Scalars['String']['input']>;
};

export type PopularSearchComponentUpdateManyLocalizationInput = {
  data: PopularSearchComponentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type PopularSearchComponentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<PopularSearchComponentUpdateManyLocalizationInput>>;
};

export type PopularSearchComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PopularSearchComponentUpdateManyInput;
  /** Document search */
  where: PopularSearchComponentWhereInput;
};

export type PopularSearchComponentUpdateOneInlineInput = {
  /** Connect existing PopularSearchComponent document */
  connect?: InputMaybe<PopularSearchComponentWhereUniqueInput>;
  /** Create and connect one PopularSearchComponent document */
  create?: InputMaybe<PopularSearchComponentCreateInput>;
  /** Delete currently connected PopularSearchComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected PopularSearchComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PopularSearchComponent document */
  update?: InputMaybe<PopularSearchComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PopularSearchComponent document */
  upsert?: InputMaybe<PopularSearchComponentUpsertWithNestedWhereUniqueInput>;
};

export type PopularSearchComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PopularSearchComponentUpdateInput;
  /** Unique document search */
  where: PopularSearchComponentWhereUniqueInput;
};

export type PopularSearchComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: PopularSearchComponentCreateInput;
  /** Update document if it exists */
  update: PopularSearchComponentUpdateInput;
};

export type PopularSearchComponentUpsertLocalizationInput = {
  create: PopularSearchComponentCreateLocalizationDataInput;
  locale: Locale;
  update: PopularSearchComponentUpdateLocalizationDataInput;
};

export type PopularSearchComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PopularSearchComponentUpsertInput;
  /** Unique document search */
  where: PopularSearchComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PopularSearchComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PopularSearchComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PopularSearchComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PopularSearchComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PopularSearchComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PopularSearchComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<PopularSearchComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<PopularSearchComponentWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  indices?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  indices_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  indices_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  indices_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  indices_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  indices_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  indices_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  indices_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  indices_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  indices_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PopularSearchComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PopularSearchComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PopularSearchComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PopularSearchComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PopularSearchComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References PopularSearchComponent record uniquely */
export type PopularSearchComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Corporate Press Releases */
export type PressRelease = Entity & Node & {
  __typename?: 'PressRelease';
  alwaysIndex?: Maybe<Scalars['Boolean']['output']>;
  content: PressReleaseContentRichText;
  corpContactCardContainer?: Maybe<CorpContactCardContainer>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Allows granular control over what date is shown in UI as press release date */
  date?: Maybe<Scalars['Date']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<PressRelease>;
  downloadImage?: Maybe<Asset>;
  /** Please only use PDF Files here */
  downloadPr?: Maybe<Asset>;
  /** List of PressRelease versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<Asset>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<PressRelease>;
  market: Markets;
  metaData?: Maybe<MetaData>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** Teaser/Snippet */
  teaser?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  topicEnum?: Maybe<CorpPressReleaseTopicEnum>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Corporate Press Releases */
export type PressReleaseCorpContactCardContainerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Corporate Press Releases */
export type PressReleaseCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Corporate Press Releases */
export type PressReleaseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Corporate Press Releases */
export type PressReleaseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Corporate Press Releases */
export type PressReleaseDownloadImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Corporate Press Releases */
export type PressReleaseDownloadPrArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Corporate Press Releases */
export type PressReleaseHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Corporate Press Releases */
export type PressReleaseImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Corporate Press Releases */
export type PressReleaseLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Corporate Press Releases */
export type PressReleaseMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Corporate Press Releases */
export type PressReleasePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Corporate Press Releases */
export type PressReleasePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Corporate Press Releases */
export type PressReleaseScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Corporate Press Releases */
export type PressReleaseUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Corporate Press Releases */
export type PressReleaseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PressReleaseConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PressReleaseWhereUniqueInput;
};

/** A connection to a list of items. */
export type PressReleaseConnection = {
  __typename?: 'PressReleaseConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PressReleaseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PressReleaseContentRichText = {
  __typename?: 'PressReleaseContentRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<PressReleaseContentRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type PressReleaseContentRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type PressReleaseContentRichTextEmbeddedTypes = Asset;

export type PressReleaseCreateInput = {
  alwaysIndex?: InputMaybe<Scalars['Boolean']['input']>;
  /** content input for default locale (default) */
  content: Scalars['RichTextAST']['input'];
  corpContactCardContainer?: InputMaybe<CorpContactCardContainerCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  downloadImage?: InputMaybe<AssetCreateOneInlineInput>;
  downloadPr?: InputMaybe<AssetCreateOneInlineInput>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<PressReleaseCreateLocalizationsInput>;
  market: Markets;
  metaData?: InputMaybe<MetaDataCreateOneInlineInput>;
  /** slug input for default locale (default) */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** teaser input for default locale (default) */
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  topicEnum?: InputMaybe<CorpPressReleaseTopicEnum>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PressReleaseCreateLocalizationDataInput = {
  content: Scalars['RichTextAST']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PressReleaseCreateLocalizationInput = {
  /** Localization input */
  data: PressReleaseCreateLocalizationDataInput;
  locale: Locale;
};

export type PressReleaseCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<PressReleaseCreateLocalizationInput>>;
};

export type PressReleaseCreateManyInlineInput = {
  /** Connect multiple existing PressRelease documents */
  connect?: InputMaybe<Array<PressReleaseWhereUniqueInput>>;
  /** Create and connect multiple existing PressRelease documents */
  create?: InputMaybe<Array<PressReleaseCreateInput>>;
};

export type PressReleaseCreateOneInlineInput = {
  /** Connect one existing PressRelease document */
  connect?: InputMaybe<PressReleaseWhereUniqueInput>;
  /** Create and connect one PressRelease document */
  create?: InputMaybe<PressReleaseCreateInput>;
};

/** An edge in a connection. */
export type PressReleaseEdge = {
  __typename?: 'PressReleaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PressRelease;
};

/** Identifies documents */
export type PressReleaseManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PressReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PressReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PressReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alwaysIndex?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  alwaysIndex_not?: InputMaybe<Scalars['Boolean']['input']>;
  corpContactCardContainer?: InputMaybe<CorpContactCardContainerWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  date_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  date_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  date_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  date_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  documentInStages_every?: InputMaybe<PressReleaseWhereStageInput>;
  documentInStages_none?: InputMaybe<PressReleaseWhereStageInput>;
  documentInStages_some?: InputMaybe<PressReleaseWhereStageInput>;
  downloadImage?: InputMaybe<AssetWhereInput>;
  downloadPr?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  market?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  topicEnum?: InputMaybe<CorpPressReleaseTopicEnum>;
  /** All values that are contained in given list. */
  topicEnum_in?: InputMaybe<Array<InputMaybe<CorpPressReleaseTopicEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  topicEnum_not?: InputMaybe<CorpPressReleaseTopicEnum>;
  /** All values that are not contained in given list. */
  topicEnum_not_in?: InputMaybe<Array<InputMaybe<CorpPressReleaseTopicEnum>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PressReleaseOrderByInput {
  alwaysIndex_ASC = 'alwaysIndex_ASC',
  alwaysIndex_DESC = 'alwaysIndex_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  date_ASC = 'date_ASC',
  date_DESC = 'date_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  market_ASC = 'market_ASC',
  market_DESC = 'market_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  teaser_ASC = 'teaser_ASC',
  teaser_DESC = 'teaser_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  topicEnum_ASC = 'topicEnum_ASC',
  topicEnum_DESC = 'topicEnum_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type PressReleaseUpdateInput = {
  alwaysIndex?: InputMaybe<Scalars['Boolean']['input']>;
  /** content input for default locale (default) */
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  corpContactCardContainer?: InputMaybe<CorpContactCardContainerUpdateOneInlineInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  downloadImage?: InputMaybe<AssetUpdateOneInlineInput>;
  downloadPr?: InputMaybe<AssetUpdateOneInlineInput>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<PressReleaseUpdateLocalizationsInput>;
  market?: InputMaybe<Markets>;
  metaData?: InputMaybe<MetaDataUpdateOneInlineInput>;
  /** slug input for default locale (default) */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** teaser input for default locale (default) */
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  topicEnum?: InputMaybe<CorpPressReleaseTopicEnum>;
};

export type PressReleaseUpdateLocalizationDataInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PressReleaseUpdateLocalizationInput = {
  data: PressReleaseUpdateLocalizationDataInput;
  locale: Locale;
};

export type PressReleaseUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<PressReleaseCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<PressReleaseUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<PressReleaseUpsertLocalizationInput>>;
};

export type PressReleaseUpdateManyInlineInput = {
  /** Connect multiple existing PressRelease documents */
  connect?: InputMaybe<Array<PressReleaseConnectInput>>;
  /** Create and connect multiple PressRelease documents */
  create?: InputMaybe<Array<PressReleaseCreateInput>>;
  /** Delete multiple PressRelease documents */
  delete?: InputMaybe<Array<PressReleaseWhereUniqueInput>>;
  /** Disconnect multiple PressRelease documents */
  disconnect?: InputMaybe<Array<PressReleaseWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PressRelease documents */
  set?: InputMaybe<Array<PressReleaseWhereUniqueInput>>;
  /** Update multiple PressRelease documents */
  update?: InputMaybe<Array<PressReleaseUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PressRelease documents */
  upsert?: InputMaybe<Array<PressReleaseUpsertWithNestedWhereUniqueInput>>;
};

export type PressReleaseUpdateManyInput = {
  alwaysIndex?: InputMaybe<Scalars['Boolean']['input']>;
  /** content input for default locale (default) */
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<PressReleaseUpdateManyLocalizationsInput>;
  market?: InputMaybe<Markets>;
  /** teaser input for default locale (default) */
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  topicEnum?: InputMaybe<CorpPressReleaseTopicEnum>;
};

export type PressReleaseUpdateManyLocalizationDataInput = {
  content?: InputMaybe<Scalars['RichTextAST']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PressReleaseUpdateManyLocalizationInput = {
  data: PressReleaseUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type PressReleaseUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<PressReleaseUpdateManyLocalizationInput>>;
};

export type PressReleaseUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PressReleaseUpdateManyInput;
  /** Document search */
  where: PressReleaseWhereInput;
};

export type PressReleaseUpdateOneInlineInput = {
  /** Connect existing PressRelease document */
  connect?: InputMaybe<PressReleaseWhereUniqueInput>;
  /** Create and connect one PressRelease document */
  create?: InputMaybe<PressReleaseCreateInput>;
  /** Delete currently connected PressRelease document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected PressRelease document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PressRelease document */
  update?: InputMaybe<PressReleaseUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PressRelease document */
  upsert?: InputMaybe<PressReleaseUpsertWithNestedWhereUniqueInput>;
};

export type PressReleaseUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PressReleaseUpdateInput;
  /** Unique document search */
  where: PressReleaseWhereUniqueInput;
};

export type PressReleaseUpsertInput = {
  /** Create document if it didn't exist */
  create: PressReleaseCreateInput;
  /** Update document if it exists */
  update: PressReleaseUpdateInput;
};

export type PressReleaseUpsertLocalizationInput = {
  create: PressReleaseCreateLocalizationDataInput;
  locale: Locale;
  update: PressReleaseUpdateLocalizationDataInput;
};

export type PressReleaseUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PressReleaseUpsertInput;
  /** Unique document search */
  where: PressReleaseWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PressReleaseWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PressReleaseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PressReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PressReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PressReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  alwaysIndex?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  alwaysIndex_not?: InputMaybe<Scalars['Boolean']['input']>;
  corpContactCardContainer?: InputMaybe<CorpContactCardContainerWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  date_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  date_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  date_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  date_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  documentInStages_every?: InputMaybe<PressReleaseWhereStageInput>;
  documentInStages_none?: InputMaybe<PressReleaseWhereStageInput>;
  documentInStages_some?: InputMaybe<PressReleaseWhereStageInput>;
  downloadImage?: InputMaybe<AssetWhereInput>;
  downloadPr?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  market?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  market_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  market_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  market_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  teaser_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  teaser_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  teaser_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  teaser_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  teaser_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  teaser_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  teaser_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  teaser_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  teaser_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  topicEnum?: InputMaybe<CorpPressReleaseTopicEnum>;
  /** All values that are contained in given list. */
  topicEnum_in?: InputMaybe<Array<InputMaybe<CorpPressReleaseTopicEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  topicEnum_not?: InputMaybe<CorpPressReleaseTopicEnum>;
  /** All values that are not contained in given list. */
  topicEnum_not_in?: InputMaybe<Array<InputMaybe<CorpPressReleaseTopicEnum>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PressReleaseWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PressReleaseWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PressReleaseWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PressReleaseWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PressReleaseWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References PressRelease record uniquely */
export type PressReleaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PressStoriesCard = Entity & Node & {
  __typename?: 'PressStoriesCard';
  anchorNav?: Maybe<AnchorNavigation>;
  buttonLink?: Maybe<Link>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<PressStoriesCard>;
  /** List of PressStoriesCard versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<AssetComponent>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<PressStoriesCard>;
  /** Another Variation of card with Metaball */
  metaBall?: Maybe<Scalars['Boolean']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Additional  Info text above main heading */
  subHeading?: Maybe<Scalars['String']['output']>;
  /** Heading of the card */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type PressStoriesCardAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PressStoriesCardButtonLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PressStoriesCardCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type PressStoriesCardCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PressStoriesCardDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type PressStoriesCardHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type PressStoriesCardImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PressStoriesCardLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type PressStoriesCardPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type PressStoriesCardPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type PressStoriesCardScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type PressStoriesCardUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type PressStoriesCardUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type PressStoriesCardConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: PressStoriesCardWhereUniqueInput;
};

/** A connection to a list of items. */
export type PressStoriesCardConnection = {
  __typename?: 'PressStoriesCardConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<PressStoriesCardEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type PressStoriesCardCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  buttonLink?: InputMaybe<LinkCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetComponentCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<PressStoriesCardCreateLocalizationsInput>;
  metaBall?: InputMaybe<Scalars['Boolean']['input']>;
  /** subHeading input for default locale (default) */
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PressStoriesCardCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PressStoriesCardCreateLocalizationInput = {
  /** Localization input */
  data: PressStoriesCardCreateLocalizationDataInput;
  locale: Locale;
};

export type PressStoriesCardCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<PressStoriesCardCreateLocalizationInput>>;
};

export type PressStoriesCardCreateManyInlineInput = {
  /** Connect multiple existing PressStoriesCard documents */
  connect?: InputMaybe<Array<PressStoriesCardWhereUniqueInput>>;
  /** Create and connect multiple existing PressStoriesCard documents */
  create?: InputMaybe<Array<PressStoriesCardCreateInput>>;
};

export type PressStoriesCardCreateOneInlineInput = {
  /** Connect one existing PressStoriesCard document */
  connect?: InputMaybe<PressStoriesCardWhereUniqueInput>;
  /** Create and connect one PressStoriesCard document */
  create?: InputMaybe<PressStoriesCardCreateInput>;
};

/** An edge in a connection. */
export type PressStoriesCardEdge = {
  __typename?: 'PressStoriesCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PressStoriesCard;
};

/** Identifies documents */
export type PressStoriesCardManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PressStoriesCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PressStoriesCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PressStoriesCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  buttonLink?: InputMaybe<LinkWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<PressStoriesCardWhereStageInput>;
  documentInStages_none?: InputMaybe<PressStoriesCardWhereStageInput>;
  documentInStages_some?: InputMaybe<PressStoriesCardWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  metaBall?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  metaBall_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum PressStoriesCardOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  metaBall_ASC = 'metaBall_ASC',
  metaBall_DESC = 'metaBall_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subHeading_ASC = 'subHeading_ASC',
  subHeading_DESC = 'subHeading_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type PressStoriesCardUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  buttonLink?: InputMaybe<LinkUpdateOneInlineInput>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<PressStoriesCardUpdateLocalizationsInput>;
  metaBall?: InputMaybe<Scalars['Boolean']['input']>;
  /** subHeading input for default locale (default) */
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PressStoriesCardUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PressStoriesCardUpdateLocalizationInput = {
  data: PressStoriesCardUpdateLocalizationDataInput;
  locale: Locale;
};

export type PressStoriesCardUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<PressStoriesCardCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<PressStoriesCardUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<PressStoriesCardUpsertLocalizationInput>>;
};

export type PressStoriesCardUpdateManyInlineInput = {
  /** Connect multiple existing PressStoriesCard documents */
  connect?: InputMaybe<Array<PressStoriesCardConnectInput>>;
  /** Create and connect multiple PressStoriesCard documents */
  create?: InputMaybe<Array<PressStoriesCardCreateInput>>;
  /** Delete multiple PressStoriesCard documents */
  delete?: InputMaybe<Array<PressStoriesCardWhereUniqueInput>>;
  /** Disconnect multiple PressStoriesCard documents */
  disconnect?: InputMaybe<Array<PressStoriesCardWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing PressStoriesCard documents */
  set?: InputMaybe<Array<PressStoriesCardWhereUniqueInput>>;
  /** Update multiple PressStoriesCard documents */
  update?: InputMaybe<Array<PressStoriesCardUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PressStoriesCard documents */
  upsert?: InputMaybe<Array<PressStoriesCardUpsertWithNestedWhereUniqueInput>>;
};

export type PressStoriesCardUpdateManyInput = {
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<PressStoriesCardUpdateManyLocalizationsInput>;
  metaBall?: InputMaybe<Scalars['Boolean']['input']>;
  /** subHeading input for default locale (default) */
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PressStoriesCardUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PressStoriesCardUpdateManyLocalizationInput = {
  data: PressStoriesCardUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type PressStoriesCardUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<PressStoriesCardUpdateManyLocalizationInput>>;
};

export type PressStoriesCardUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: PressStoriesCardUpdateManyInput;
  /** Document search */
  where: PressStoriesCardWhereInput;
};

export type PressStoriesCardUpdateOneInlineInput = {
  /** Connect existing PressStoriesCard document */
  connect?: InputMaybe<PressStoriesCardWhereUniqueInput>;
  /** Create and connect one PressStoriesCard document */
  create?: InputMaybe<PressStoriesCardCreateInput>;
  /** Delete currently connected PressStoriesCard document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected PressStoriesCard document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single PressStoriesCard document */
  update?: InputMaybe<PressStoriesCardUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PressStoriesCard document */
  upsert?: InputMaybe<PressStoriesCardUpsertWithNestedWhereUniqueInput>;
};

export type PressStoriesCardUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: PressStoriesCardUpdateInput;
  /** Unique document search */
  where: PressStoriesCardWhereUniqueInput;
};

export type PressStoriesCardUpsertInput = {
  /** Create document if it didn't exist */
  create: PressStoriesCardCreateInput;
  /** Update document if it exists */
  update: PressStoriesCardUpdateInput;
};

export type PressStoriesCardUpsertLocalizationInput = {
  create: PressStoriesCardCreateLocalizationDataInput;
  locale: Locale;
  update: PressStoriesCardUpdateLocalizationDataInput;
};

export type PressStoriesCardUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: PressStoriesCardUpsertInput;
  /** Unique document search */
  where: PressStoriesCardWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type PressStoriesCardWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type PressStoriesCardWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PressStoriesCardWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PressStoriesCardWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PressStoriesCardWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  buttonLink?: InputMaybe<LinkWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<PressStoriesCardWhereStageInput>;
  documentInStages_none?: InputMaybe<PressStoriesCardWhereStageInput>;
  documentInStages_some?: InputMaybe<PressStoriesCardWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetComponentWhereInput>;
  metaBall?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  metaBall_not?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type PressStoriesCardWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<PressStoriesCardWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<PressStoriesCardWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<PressStoriesCardWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<PressStoriesCardWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References PressStoriesCard record uniquely */
export type PressStoriesCardWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ProgressBar = Entity & Node & {
  __typename?: 'ProgressBar';
  caption?: Maybe<Scalars['String']['output']>;
  color?: Maybe<CorpColorThemeName>;
  corpGenericContainers: Array<CorpGenericContainer>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  current: Scalars['Int']['output'];
  /** Get the document in other stages */
  documentInStages: Array<ProgressBar>;
  /** Right end value */
  end: Scalars['Int']['output'];
  genericPages: Array<GenericPage>;
  headline?: Maybe<Scalars['String']['output']>;
  /** List of ProgressBar versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<ProgressBar>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Left starting value */
  start: Scalars['Int']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type ProgressBarCorpGenericContainersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericContainerWhereInput>;
};


export type ProgressBarCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type ProgressBarCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProgressBarDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type ProgressBarGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type ProgressBarHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type ProgressBarLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type ProgressBarPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type ProgressBarPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type ProgressBarScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type ProgressBarUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type ProgressBarUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ProgressBarConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ProgressBarWhereUniqueInput;
};

/** A connection to a list of items. */
export type ProgressBarConnection = {
  __typename?: 'ProgressBarConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ProgressBarEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ProgressBarCreateInput = {
  /** caption input for default locale (default) */
  caption?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  corpGenericContainers?: InputMaybe<CorpGenericContainerCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  current: Scalars['Int']['input'];
  end: Scalars['Int']['input'];
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  /** headline input for default locale (default) */
  headline?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ProgressBarCreateLocalizationsInput>;
  start: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProgressBarCreateLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProgressBarCreateLocalizationInput = {
  /** Localization input */
  data: ProgressBarCreateLocalizationDataInput;
  locale: Locale;
};

export type ProgressBarCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ProgressBarCreateLocalizationInput>>;
};

export type ProgressBarCreateManyInlineInput = {
  /** Connect multiple existing ProgressBar documents */
  connect?: InputMaybe<Array<ProgressBarWhereUniqueInput>>;
  /** Create and connect multiple existing ProgressBar documents */
  create?: InputMaybe<Array<ProgressBarCreateInput>>;
};

export type ProgressBarCreateOneInlineInput = {
  /** Connect one existing ProgressBar document */
  connect?: InputMaybe<ProgressBarWhereUniqueInput>;
  /** Create and connect one ProgressBar document */
  create?: InputMaybe<ProgressBarCreateInput>;
};

/** An edge in a connection. */
export type ProgressBarEdge = {
  __typename?: 'ProgressBarEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProgressBar;
};

/** Identifies documents */
export type ProgressBarManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProgressBarWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProgressBarWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProgressBarWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  /** All values that are contained in given list. */
  color_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  /** Any other value that exists and is not equal to the given value. */
  color_not?: InputMaybe<CorpColorThemeName>;
  /** All values that are not contained in given list. */
  color_not_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  corpGenericContainers_every?: InputMaybe<CorpGenericContainerWhereInput>;
  corpGenericContainers_none?: InputMaybe<CorpGenericContainerWhereInput>;
  corpGenericContainers_some?: InputMaybe<CorpGenericContainerWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  current?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  current_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  current_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  current_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  current_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  current_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  current_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  current_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  documentInStages_every?: InputMaybe<ProgressBarWhereStageInput>;
  documentInStages_none?: InputMaybe<ProgressBarWhereStageInput>;
  documentInStages_some?: InputMaybe<ProgressBarWhereStageInput>;
  end?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  end_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  end_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  end_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  end_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  end_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  end_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  end_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  start?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  start_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  start_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  start_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  start_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  start_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  start_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  start_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ProgressBarOrderByInput {
  caption_ASC = 'caption_ASC',
  caption_DESC = 'caption_DESC',
  color_ASC = 'color_ASC',
  color_DESC = 'color_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  current_ASC = 'current_ASC',
  current_DESC = 'current_DESC',
  end_ASC = 'end_ASC',
  end_DESC = 'end_DESC',
  headline_ASC = 'headline_ASC',
  headline_DESC = 'headline_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  start_ASC = 'start_ASC',
  start_DESC = 'start_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ProgressBarUpdateInput = {
  /** caption input for default locale (default) */
  caption?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  corpGenericContainers?: InputMaybe<CorpGenericContainerUpdateManyInlineInput>;
  current?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['Int']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  /** headline input for default locale (default) */
  headline?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<ProgressBarUpdateLocalizationsInput>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgressBarUpdateLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
};

export type ProgressBarUpdateLocalizationInput = {
  data: ProgressBarUpdateLocalizationDataInput;
  locale: Locale;
};

export type ProgressBarUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ProgressBarCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<ProgressBarUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<ProgressBarUpsertLocalizationInput>>;
};

export type ProgressBarUpdateManyInlineInput = {
  /** Connect multiple existing ProgressBar documents */
  connect?: InputMaybe<Array<ProgressBarConnectInput>>;
  /** Create and connect multiple ProgressBar documents */
  create?: InputMaybe<Array<ProgressBarCreateInput>>;
  /** Delete multiple ProgressBar documents */
  delete?: InputMaybe<Array<ProgressBarWhereUniqueInput>>;
  /** Disconnect multiple ProgressBar documents */
  disconnect?: InputMaybe<Array<ProgressBarWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ProgressBar documents */
  set?: InputMaybe<Array<ProgressBarWhereUniqueInput>>;
  /** Update multiple ProgressBar documents */
  update?: InputMaybe<Array<ProgressBarUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ProgressBar documents */
  upsert?: InputMaybe<Array<ProgressBarUpsertWithNestedWhereUniqueInput>>;
};

export type ProgressBarUpdateManyInput = {
  /** caption input for default locale (default) */
  caption?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  current?: InputMaybe<Scalars['Int']['input']>;
  end?: InputMaybe<Scalars['Int']['input']>;
  /** headline input for default locale (default) */
  headline?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<ProgressBarUpdateManyLocalizationsInput>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type ProgressBarUpdateManyLocalizationDataInput = {
  caption?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
};

export type ProgressBarUpdateManyLocalizationInput = {
  data: ProgressBarUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type ProgressBarUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ProgressBarUpdateManyLocalizationInput>>;
};

export type ProgressBarUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ProgressBarUpdateManyInput;
  /** Document search */
  where: ProgressBarWhereInput;
};

export type ProgressBarUpdateOneInlineInput = {
  /** Connect existing ProgressBar document */
  connect?: InputMaybe<ProgressBarWhereUniqueInput>;
  /** Create and connect one ProgressBar document */
  create?: InputMaybe<ProgressBarCreateInput>;
  /** Delete currently connected ProgressBar document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ProgressBar document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ProgressBar document */
  update?: InputMaybe<ProgressBarUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProgressBar document */
  upsert?: InputMaybe<ProgressBarUpsertWithNestedWhereUniqueInput>;
};

export type ProgressBarUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ProgressBarUpdateInput;
  /** Unique document search */
  where: ProgressBarWhereUniqueInput;
};

export type ProgressBarUpsertInput = {
  /** Create document if it didn't exist */
  create: ProgressBarCreateInput;
  /** Update document if it exists */
  update: ProgressBarUpdateInput;
};

export type ProgressBarUpsertLocalizationInput = {
  create: ProgressBarCreateLocalizationDataInput;
  locale: Locale;
  update: ProgressBarUpdateLocalizationDataInput;
};

export type ProgressBarUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ProgressBarUpsertInput;
  /** Unique document search */
  where: ProgressBarWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ProgressBarWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ProgressBarWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProgressBarWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProgressBarWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProgressBarWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  caption_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  caption_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  caption_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  caption_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  caption_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  caption_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  caption_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  caption_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  caption_starts_with?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<CorpColorThemeName>;
  /** All values that are contained in given list. */
  color_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  /** Any other value that exists and is not equal to the given value. */
  color_not?: InputMaybe<CorpColorThemeName>;
  /** All values that are not contained in given list. */
  color_not_in?: InputMaybe<Array<InputMaybe<CorpColorThemeName>>>;
  corpGenericContainers_every?: InputMaybe<CorpGenericContainerWhereInput>;
  corpGenericContainers_none?: InputMaybe<CorpGenericContainerWhereInput>;
  corpGenericContainers_some?: InputMaybe<CorpGenericContainerWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  current?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  current_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  current_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  current_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  current_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  current_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  current_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  current_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  documentInStages_every?: InputMaybe<ProgressBarWhereStageInput>;
  documentInStages_none?: InputMaybe<ProgressBarWhereStageInput>;
  documentInStages_some?: InputMaybe<ProgressBarWhereStageInput>;
  end?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  end_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  end_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  end_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  end_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  end_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  end_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  end_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  headline?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  headline_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  headline_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  headline_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  start?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  start_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  start_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  start_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  start_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  start_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  start_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  start_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ProgressBarWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ProgressBarWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ProgressBarWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ProgressBarWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ProgressBarWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ProgressBar record uniquely */
export type ProgressBarWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PublishLocaleInput = {
  /** Locales to publish */
  locale: Locale;
  /** Stages to publish selected locales to */
  stages: Array<Stage>;
};

export type Query = {
  __typename?: 'Query';
  /** Retrieve a single accordion */
  accordion?: Maybe<Accordion>;
  /** Retrieve a single accordionItem */
  accordionItem?: Maybe<AccordionItem>;
  /** Retrieve document version */
  accordionItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple accordionItems */
  accordionItems: Array<AccordionItem>;
  /** Retrieve multiple accordionItems using the Relay connection interface */
  accordionItemsConnection: AccordionItemConnection;
  /** Retrieve document version */
  accordionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple accordions */
  accordions: Array<Accordion>;
  /** Retrieve multiple accordions using the Relay connection interface */
  accordionsConnection: AccordionConnection;
  /** Retrieve a single alexTestComponent */
  alexTestComponent?: Maybe<AlexTestComponent>;
  /** Retrieve document version */
  alexTestComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple alexTestComponents */
  alexTestComponents: Array<AlexTestComponent>;
  /** Retrieve multiple alexTestComponents using the Relay connection interface */
  alexTestComponentsConnection: AlexTestComponentConnection;
  /** Retrieve a single algoliaExtension */
  algoliaExtension?: Maybe<AlgoliaExtension>;
  /** Retrieve document version */
  algoliaExtensionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple algoliaExtensions */
  algoliaExtensions: Array<AlgoliaExtension>;
  /** Retrieve multiple algoliaExtensions using the Relay connection interface */
  algoliaExtensionsConnection: AlgoliaExtensionConnection;
  /** Retrieve a single anchorNav */
  anchorNav?: Maybe<AnchorNav>;
  /** Retrieve document version */
  anchorNavVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single anchorNavigation */
  anchorNavigation?: Maybe<AnchorNavigation>;
  /** Retrieve a single anchorNavigationList */
  anchorNavigationList?: Maybe<AnchorNavigationList>;
  /** Retrieve document version */
  anchorNavigationListVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple anchorNavigationLists */
  anchorNavigationLists: Array<AnchorNavigationList>;
  /** Retrieve multiple anchorNavigationLists using the Relay connection interface */
  anchorNavigationListsConnection: AnchorNavigationListConnection;
  /** Retrieve document version */
  anchorNavigationVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple anchorNavigations */
  anchorNavigations: Array<AnchorNavigation>;
  /** Retrieve multiple anchorNavigations using the Relay connection interface */
  anchorNavigationsConnection: AnchorNavigationConnection;
  /** Retrieve multiple anchorNavs */
  anchorNavs: Array<AnchorNav>;
  /** Retrieve multiple anchorNavs using the Relay connection interface */
  anchorNavsConnection: AnchorNavConnection;
  /** Retrieve a single asset */
  asset?: Maybe<Asset>;
  /** Retrieve a single assetComponent */
  assetComponent?: Maybe<AssetComponent>;
  /** Retrieve document version */
  assetComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve document version */
  assetVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple assets */
  assets: Array<Asset>;
  /** Retrieve multiple assetsComponents */
  assetsComponents: Array<AssetComponent>;
  /** Retrieve multiple assetsComponents using the Relay connection interface */
  assetsComponentsConnection: AssetComponentConnection;
  /** Retrieve multiple assets using the Relay connection interface */
  assetsConnection: AssetConnection;
  /** Retrieve a single audioComponent */
  audioComponent?: Maybe<AudioComponent>;
  /** Retrieve document version */
  audioComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple audioComponents */
  audioComponents: Array<AudioComponent>;
  /** Retrieve multiple audioComponents using the Relay connection interface */
  audioComponentsConnection: AudioComponentConnection;
  /** Retrieve a single authorableContentCard */
  authorableContentCard?: Maybe<AuthorableContentCard>;
  /** Retrieve document version */
  authorableContentCardVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple authorableContentCards */
  authorableContentCards: Array<AuthorableContentCard>;
  /** Retrieve multiple authorableContentCards using the Relay connection interface */
  authorableContentCardsConnection: AuthorableContentCardConnection;
  /** Retrieve a single banner2 */
  banner2?: Maybe<Banner2>;
  /** Retrieve multiple banner2S */
  banner2S: Array<Banner2>;
  /** Retrieve multiple banner2S using the Relay connection interface */
  banner2SConnection: Banner2Connection;
  /** Retrieve document version */
  banner2Version?: Maybe<DocumentVersion>;
  /** Retrieve a single bigNumber */
  bigNumber?: Maybe<BigNumber>;
  /** Retrieve a single bigNumberItem */
  bigNumberItem?: Maybe<BigNumberItem>;
  /** Retrieve document version */
  bigNumberItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple bigNumberItems */
  bigNumberItems: Array<BigNumberItem>;
  /** Retrieve multiple bigNumberItems using the Relay connection interface */
  bigNumberItemsConnection: BigNumberItemConnection;
  /** Retrieve document version */
  bigNumberVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple bigNumbers */
  bigNumbers: Array<BigNumber>;
  /** Retrieve multiple bigNumbers using the Relay connection interface */
  bigNumbersConnection: BigNumberConnection;
  /** Retrieve a single cardComponent */
  cardComponent?: Maybe<CardComponent>;
  /** Retrieve document version */
  cardComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cardComponents */
  cardComponents: Array<CardComponent>;
  /** Retrieve multiple cardComponents using the Relay connection interface */
  cardComponentsConnection: CardComponentConnection;
  /** Retrieve a single carouselComponent */
  carouselComponent?: Maybe<CarouselComponent>;
  /** Retrieve document version */
  carouselComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple carouselComponents */
  carouselComponents: Array<CarouselComponent>;
  /** Retrieve multiple carouselComponents using the Relay connection interface */
  carouselComponentsConnection: CarouselComponentConnection;
  /** Retrieve a single carouselSlide */
  carouselSlide?: Maybe<CarouselSlide>;
  /** Retrieve document version */
  carouselSlideVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple carouselSlides */
  carouselSlides: Array<CarouselSlide>;
  /** Retrieve multiple carouselSlides using the Relay connection interface */
  carouselSlidesConnection: CarouselSlideConnection;
  /** Retrieve a single categoryCard */
  categoryCard?: Maybe<CategoryCard>;
  /** Retrieve document version */
  categoryCardVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple categoryCards */
  categoryCards: Array<CategoryCard>;
  /** Retrieve multiple categoryCards using the Relay connection interface */
  categoryCardsConnection: CategoryCardConnection;
  /** Retrieve a single contactCard */
  contactCard?: Maybe<ContactCard>;
  /** Retrieve a single contactCardContainer */
  contactCardContainer?: Maybe<ContactCardContainer>;
  /** Retrieve document version */
  contactCardContainerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple contactCardContainers */
  contactCardContainers: Array<ContactCardContainer>;
  /** Retrieve multiple contactCardContainers using the Relay connection interface */
  contactCardContainersConnection: ContactCardContainerConnection;
  /** Retrieve document version */
  contactCardVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple contactCards */
  contactCards: Array<ContactCard>;
  /** Retrieve multiple contactCards using the Relay connection interface */
  contactCardsConnection: ContactCardConnection;
  /** Retrieve a single corpAddToCalendar */
  corpAddToCalendar?: Maybe<CorpAddToCalendar>;
  /** Retrieve document version */
  corpAddToCalendarVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpAddToCalendars */
  corpAddToCalendars: Array<CorpAddToCalendar>;
  /** Retrieve multiple corpAddToCalendars using the Relay connection interface */
  corpAddToCalendarsConnection: CorpAddToCalendarConnection;
  /** Retrieve a single corpBanner1 */
  corpBanner1?: Maybe<CorpBanner1>;
  /** Retrieve document version */
  corpBanner1Version?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpBanners1 */
  corpBanners1: Array<CorpBanner1>;
  /** Retrieve multiple corpBanners1 using the Relay connection interface */
  corpBanners1Connection: CorpBanner1Connection;
  /** Retrieve a single corpCalendarEvent */
  corpCalendarEvent?: Maybe<CorpCalendarEvent>;
  /** Retrieve document version */
  corpCalendarEventVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpCalendarEvents */
  corpCalendarEvents: Array<CorpCalendarEvent>;
  /** Retrieve multiple corpCalendarEvents using the Relay connection interface */
  corpCalendarEventsConnection: CorpCalendarEventConnection;
  /** Retrieve a single corpCardCarousel */
  corpCardCarousel?: Maybe<CorpCardCarousel>;
  /** Retrieve document version */
  corpCardCarouselVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpCardCarousels */
  corpCardCarousels: Array<CorpCardCarousel>;
  /** Retrieve multiple corpCardCarousels using the Relay connection interface */
  corpCardCarouselsConnection: CorpCardCarouselConnection;
  /** Retrieve a single corpContactCard */
  corpContactCard?: Maybe<CorpContactCard>;
  /** Retrieve a single corpContactCardContainer */
  corpContactCardContainer?: Maybe<CorpContactCardContainer>;
  /** Retrieve document version */
  corpContactCardContainerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpContactCardContainers */
  corpContactCardContainers: Array<CorpContactCardContainer>;
  /** Retrieve multiple corpContactCardContainers using the Relay connection interface */
  corpContactCardContainersConnection: CorpContactCardContainerConnection;
  /** Retrieve document version */
  corpContactCardVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpContactCards */
  corpContactCards: Array<CorpContactCard>;
  /** Retrieve multiple corpContactCards using the Relay connection interface */
  corpContactCardsConnection: CorpContactCardConnection;
  /** Retrieve a single corpForm */
  corpForm?: Maybe<CorpForm>;
  /** Retrieve document version */
  corpFormVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpForms */
  corpForms: Array<CorpForm>;
  /** Retrieve multiple corpForms using the Relay connection interface */
  corpFormsConnection: CorpFormConnection;
  /** Retrieve a single corpGenericAccordion */
  corpGenericAccordion?: Maybe<CorpGenericAccordion>;
  /** Retrieve a single corpGenericAccordionItem */
  corpGenericAccordionItem?: Maybe<CorpGenericAccordionItem>;
  /** Retrieve document version */
  corpGenericAccordionItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpGenericAccordionItems */
  corpGenericAccordionItems: Array<CorpGenericAccordionItem>;
  /** Retrieve multiple corpGenericAccordionItems using the Relay connection interface */
  corpGenericAccordionItemsConnection: CorpGenericAccordionItemConnection;
  /** Retrieve document version */
  corpGenericAccordionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpGenericAccordions */
  corpGenericAccordions: Array<CorpGenericAccordion>;
  /** Retrieve multiple corpGenericAccordions using the Relay connection interface */
  corpGenericAccordionsConnection: CorpGenericAccordionConnection;
  /** Retrieve a single corpGenericBanner */
  corpGenericBanner?: Maybe<CorpGenericBanner>;
  /** Retrieve document version */
  corpGenericBannerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpGenericBanners */
  corpGenericBanners: Array<CorpGenericBanner>;
  /** Retrieve multiple corpGenericBanners using the Relay connection interface */
  corpGenericBannersConnection: CorpGenericBannerConnection;
  /** Retrieve a single corpGenericContainer */
  corpGenericContainer?: Maybe<CorpGenericContainer>;
  /** Retrieve document version */
  corpGenericContainerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpGenericContainers */
  corpGenericContainers: Array<CorpGenericContainer>;
  /** Retrieve multiple corpGenericContainers using the Relay connection interface */
  corpGenericContainersConnection: CorpGenericContainerConnection;
  /** Retrieve a single corpGridColumnComponent */
  corpGridColumnComponent?: Maybe<CorpGridColumnComponent>;
  /** Retrieve document version */
  corpGridColumnComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpGridColumnComponents */
  corpGridColumnComponents: Array<CorpGridColumnComponent>;
  /** Retrieve multiple corpGridColumnComponents using the Relay connection interface */
  corpGridColumnComponentsConnection: CorpGridColumnComponentConnection;
  /** Retrieve a single corpHero */
  corpHero?: Maybe<CorpHero>;
  /** Retrieve document version */
  corpHeroVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpHeros */
  corpHeros: Array<CorpHero>;
  /** Retrieve multiple corpHeros using the Relay connection interface */
  corpHerosConnection: CorpHeroConnection;
  /** Retrieve a single corpMediaDownloadPreview */
  corpMediaDownloadPreview?: Maybe<CorpMediaDownloadPreview>;
  /** Retrieve document version */
  corpMediaDownloadPreviewVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpMediaDownloadPreviews */
  corpMediaDownloadPreviews: Array<CorpMediaDownloadPreview>;
  /** Retrieve multiple corpMediaDownloadPreviews using the Relay connection interface */
  corpMediaDownloadPreviewsConnection: CorpMediaDownloadPreviewConnection;
  /** Retrieve a single corpNavigation */
  corpNavigation?: Maybe<CorpNavigation>;
  /** Retrieve a single corpNavigationItem */
  corpNavigationItem?: Maybe<CorpNavigationItem>;
  /** Retrieve document version */
  corpNavigationItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpNavigationItems */
  corpNavigationItems: Array<CorpNavigationItem>;
  /** Retrieve multiple corpNavigationItems using the Relay connection interface */
  corpNavigationItemsConnection: CorpNavigationItemConnection;
  /** Retrieve document version */
  corpNavigationVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpNavigations */
  corpNavigations: Array<CorpNavigation>;
  /** Retrieve multiple corpNavigations using the Relay connection interface */
  corpNavigationsConnection: CorpNavigationConnection;
  /** Retrieve a single corpNotificationBanner */
  corpNotificationBanner?: Maybe<CorpNotificationBanner>;
  /** Retrieve document version */
  corpNotificationBannerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpNotificationBanners */
  corpNotificationBanners: Array<CorpNotificationBanner>;
  /** Retrieve multiple corpNotificationBanners using the Relay connection interface */
  corpNotificationBannersConnection: CorpNotificationBannerConnection;
  /** Retrieve a single corpOurPeople */
  corpOurPeople?: Maybe<CorpOurPeople>;
  /** Retrieve a single corpOurPeopleItem */
  corpOurPeopleItem?: Maybe<CorpOurPeopleItem>;
  /** Retrieve document version */
  corpOurPeopleItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpOurPeopleItems */
  corpOurPeopleItems: Array<CorpOurPeopleItem>;
  /** Retrieve multiple corpOurPeopleItems using the Relay connection interface */
  corpOurPeopleItemsConnection: CorpOurPeopleItemConnection;
  /** Retrieve document version */
  corpOurPeopleVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpOurPeoples */
  corpOurPeoples: Array<CorpOurPeople>;
  /** Retrieve multiple corpOurPeoples using the Relay connection interface */
  corpOurPeoplesConnection: CorpOurPeopleConnection;
  /** Retrieve a single corpPressPage */
  corpPressPage?: Maybe<CorpPressPage>;
  /** Retrieve document version */
  corpPressPageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpPressPages */
  corpPressPages: Array<CorpPressPage>;
  /** Retrieve multiple corpPressPages using the Relay connection interface */
  corpPressPagesConnection: CorpPressPageConnection;
  /** Retrieve a single corpSocialMediaFooter */
  corpSocialMediaFooter?: Maybe<CorpSocialMediaFooter>;
  /** Retrieve document version */
  corpSocialMediaFooterVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpSocialMediaFooters */
  corpSocialMediaFooters: Array<CorpSocialMediaFooter>;
  /** Retrieve multiple corpSocialMediaFooters using the Relay connection interface */
  corpSocialMediaFootersConnection: CorpSocialMediaFooterConnection;
  /** Retrieve a single corpStoriesPage */
  corpStoriesPage?: Maybe<CorpStoriesPage>;
  /** Retrieve document version */
  corpStoriesPageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpStoriesPages */
  corpStoriesPages: Array<CorpStoriesPage>;
  /** Retrieve multiple corpStoriesPages using the Relay connection interface */
  corpStoriesPagesConnection: CorpStoriesPageConnection;
  /** Retrieve a single corpStoryCarousel */
  corpStoryCarousel?: Maybe<CorpStoryCarousel>;
  /** Retrieve document version */
  corpStoryCarouselVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpStoryCarousels */
  corpStoryCarousels: Array<CorpStoryCarousel>;
  /** Retrieve multiple corpStoryCarousels using the Relay connection interface */
  corpStoryCarouselsConnection: CorpStoryCarouselConnection;
  /** Retrieve a single corpTimelineAccordion */
  corpTimelineAccordion?: Maybe<CorpTimelineAccordion>;
  /** Retrieve a single corpTimelineAccordionItem */
  corpTimelineAccordionItem?: Maybe<CorpTimelineAccordionItem>;
  /** Retrieve document version */
  corpTimelineAccordionItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpTimelineAccordionItems */
  corpTimelineAccordionItems: Array<CorpTimelineAccordionItem>;
  /** Retrieve multiple corpTimelineAccordionItems using the Relay connection interface */
  corpTimelineAccordionItemsConnection: CorpTimelineAccordionItemConnection;
  /** Retrieve document version */
  corpTimelineAccordionVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single corpTimelineAccordionWrapper */
  corpTimelineAccordionWrapper?: Maybe<CorpTimelineAccordionWrapper>;
  /** Retrieve document version */
  corpTimelineAccordionWrapperVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpTimelineAccordionWrappers */
  corpTimelineAccordionWrappers: Array<CorpTimelineAccordionWrapper>;
  /** Retrieve multiple corpTimelineAccordionWrappers using the Relay connection interface */
  corpTimelineAccordionWrappersConnection: CorpTimelineAccordionWrapperConnection;
  /** Retrieve multiple corpTimelineAccordions */
  corpTimelineAccordions: Array<CorpTimelineAccordion>;
  /** Retrieve multiple corpTimelineAccordions using the Relay connection interface */
  corpTimelineAccordionsConnection: CorpTimelineAccordionConnection;
  /** Retrieve a single corpVideoHero */
  corpVideoHero?: Maybe<CorpVideoHero>;
  /** Retrieve a single corpVideoHeroCarousel */
  corpVideoHeroCarousel?: Maybe<CorpVideoHeroCarousel>;
  /** Retrieve document version */
  corpVideoHeroCarouselVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpVideoHeroCarousels */
  corpVideoHeroCarousels: Array<CorpVideoHeroCarousel>;
  /** Retrieve multiple corpVideoHeroCarousels using the Relay connection interface */
  corpVideoHeroCarouselsConnection: CorpVideoHeroCarouselConnection;
  /** Retrieve document version */
  corpVideoHeroVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple corpVideoHeros */
  corpVideoHeros: Array<CorpVideoHero>;
  /** Retrieve multiple corpVideoHeros using the Relay connection interface */
  corpVideoHerosConnection: CorpVideoHeroConnection;
  /** Retrieve a single countrySelector */
  countrySelector?: Maybe<CountrySelector>;
  /** Retrieve a single countrySelectorItem */
  countrySelectorItem?: Maybe<CountrySelectorItem>;
  /** Retrieve document version */
  countrySelectorItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple countrySelectorItems */
  countrySelectorItems: Array<CountrySelectorItem>;
  /** Retrieve multiple countrySelectorItems using the Relay connection interface */
  countrySelectorItemsConnection: CountrySelectorItemConnection;
  /** Retrieve document version */
  countrySelectorVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple countrySelectors */
  countrySelectors: Array<CountrySelector>;
  /** Retrieve multiple countrySelectors using the Relay connection interface */
  countrySelectorsConnection: CountrySelectorConnection;
  /** Retrieve a single dEPRECATEDBanner1 */
  dEPRECATEDBanner1?: Maybe<DeprecatedBanner1>;
  /** Retrieve document version */
  dEPRECATEDBanner1Version?: Maybe<DocumentVersion>;
  /** Retrieve multiple dEPRECATEDBanner1s */
  dEPRECATEDBanner1s: Array<DeprecatedBanner1>;
  /** Retrieve multiple dEPRECATEDBanner1s using the Relay connection interface */
  dEPRECATEDBanner1sConnection: DeprecatedBanner1Connection;
  /** Retrieve a single deprecatedCorpNavigationCopy */
  deprecatedCorpNavigationCopy?: Maybe<DeprecatedCorpNavigationCopy>;
  /** Retrieve document version */
  deprecatedCorpNavigationCopyVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple deprecatedCorpNavigations */
  deprecatedCorpNavigations: Array<DeprecatedCorpNavigationCopy>;
  /** Retrieve multiple deprecatedCorpNavigations using the Relay connection interface */
  deprecatedCorpNavigationsConnection: DeprecatedCorpNavigationCopyConnection;
  /** Retrieve multiple dictionaries */
  dictionaries: Array<Dictionary>;
  /** Retrieve multiple dictionaries using the Relay connection interface */
  dictionariesConnection: DictionaryConnection;
  /** Retrieve a single dictionary */
  dictionary?: Maybe<Dictionary>;
  /** Retrieve a single dictionaryItem */
  dictionaryItem?: Maybe<DictionaryItem>;
  /** Retrieve document version */
  dictionaryItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple dictionaryItems */
  dictionaryItems: Array<DictionaryItem>;
  /** Retrieve multiple dictionaryItems using the Relay connection interface */
  dictionaryItemsConnection: DictionaryItemConnection;
  /** Retrieve document version */
  dictionaryVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single dynamicCardGrid */
  dynamicCardGrid?: Maybe<DynamicCardGrid>;
  /** Retrieve document version */
  dynamicCardGridVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple dynamicCardGrids */
  dynamicCardGrids: Array<DynamicCardGrid>;
  /** Retrieve multiple dynamicCardGrids using the Relay connection interface */
  dynamicCardGridsConnection: DynamicCardGridConnection;
  /** Fetches an object given its ID */
  entities?: Maybe<Array<Entity>>;
  /** Retrieve a single evalancheFormComponent */
  evalancheFormComponent?: Maybe<EvalancheFormComponent>;
  /** Retrieve document version */
  evalancheFormComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple evalancheFormComponents */
  evalancheFormComponents: Array<EvalancheFormComponent>;
  /** Retrieve multiple evalancheFormComponents using the Relay connection interface */
  evalancheFormComponentsConnection: EvalancheFormComponentConnection;
  /** Retrieve a single exampleComponent */
  exampleComponent?: Maybe<ExampleComponent>;
  /** Retrieve document version */
  exampleComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple exampleComponents */
  exampleComponents: Array<ExampleComponent>;
  /** Retrieve multiple exampleComponents using the Relay connection interface */
  exampleComponentsConnection: ExampleComponentConnection;
  /** Retrieve a single featuredContent */
  featuredContent?: Maybe<FeaturedContent>;
  /** Retrieve a single featuredContentReference */
  featuredContentReference?: Maybe<FeaturedContentReference>;
  /** Retrieve document version */
  featuredContentReferenceVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple featuredContentReferences */
  featuredContentReferences: Array<FeaturedContentReference>;
  /** Retrieve multiple featuredContentReferences using the Relay connection interface */
  featuredContentReferencesConnection: FeaturedContentReferenceConnection;
  /** Retrieve document version */
  featuredContentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple featuredContents */
  featuredContents: Array<FeaturedContent>;
  /** Retrieve multiple featuredContents using the Relay connection interface */
  featuredContentsConnection: FeaturedContentConnection;
  /** Retrieve a single footerNavigation */
  footerNavigation?: Maybe<FooterNavigation>;
  /** Retrieve document version */
  footerNavigationVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple footerNavigations */
  footerNavigations: Array<FooterNavigation>;
  /** Retrieve multiple footerNavigations using the Relay connection interface */
  footerNavigationsConnection: FooterNavigationConnection;
  /** Retrieve a single form */
  form?: Maybe<Form>;
  /** Retrieve a single formCheckbox */
  formCheckbox?: Maybe<FormCheckbox>;
  /** Retrieve document version */
  formCheckboxVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formCheckboxes */
  formCheckboxes: Array<FormCheckbox>;
  /** Retrieve multiple formCheckboxes using the Relay connection interface */
  formCheckboxesConnection: FormCheckboxConnection;
  /** Retrieve a single formEmailInput */
  formEmailInput?: Maybe<FormEmailInput>;
  /** Retrieve document version */
  formEmailInputVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formEmailInputs */
  formEmailInputs: Array<FormEmailInput>;
  /** Retrieve multiple formEmailInputs using the Relay connection interface */
  formEmailInputsConnection: FormEmailInputConnection;
  /** Retrieve a single formError */
  formError?: Maybe<FormError>;
  /** Retrieve document version */
  formErrorVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formErrors */
  formErrors: Array<FormError>;
  /** Retrieve multiple formErrors using the Relay connection interface */
  formErrorsConnection: FormErrorConnection;
  /** Retrieve a single formPasswordInput */
  formPasswordInput?: Maybe<FormPasswordInput>;
  /** Retrieve document version */
  formPasswordInputVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single formPasswordInputWithConfirmation */
  formPasswordInputWithConfirmation?: Maybe<FormPasswordInputWithConfirmation>;
  /** Retrieve document version */
  formPasswordInputWithConfirmationVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formPasswordInputWithConfirmations */
  formPasswordInputWithConfirmations: Array<FormPasswordInputWithConfirmation>;
  /** Retrieve multiple formPasswordInputWithConfirmations using the Relay connection interface */
  formPasswordInputWithConfirmationsConnection: FormPasswordInputWithConfirmationConnection;
  /** Retrieve multiple formPasswordInputs */
  formPasswordInputs: Array<FormPasswordInput>;
  /** Retrieve multiple formPasswordInputs using the Relay connection interface */
  formPasswordInputsConnection: FormPasswordInputConnection;
  /** Retrieve a single formRadioButton */
  formRadioButton?: Maybe<FormRadioButton>;
  /** Retrieve a single formRadioButtonCollection */
  formRadioButtonCollection?: Maybe<FormRadioButtonCollection>;
  /** Retrieve document version */
  formRadioButtonCollectionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formRadioButtonCollections */
  formRadioButtonCollections: Array<FormRadioButtonCollection>;
  /** Retrieve multiple formRadioButtonCollections using the Relay connection interface */
  formRadioButtonCollectionsConnection: FormRadioButtonCollectionConnection;
  /** Retrieve document version */
  formRadioButtonVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formRadioButtons */
  formRadioButtons: Array<FormRadioButton>;
  /** Retrieve multiple formRadioButtons using the Relay connection interface */
  formRadioButtonsConnection: FormRadioButtonConnection;
  /** Retrieve a single formSelectComponent */
  formSelectComponent?: Maybe<FormSelectComponent>;
  /** Retrieve document version */
  formSelectComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formSelectComponents */
  formSelectComponents: Array<FormSelectComponent>;
  /** Retrieve multiple formSelectComponents using the Relay connection interface */
  formSelectComponentsConnection: FormSelectComponentConnection;
  /** Retrieve a single formSelectOption */
  formSelectOption?: Maybe<FormSelectOption>;
  /** Retrieve document version */
  formSelectOptionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formSelectOptions */
  formSelectOptions: Array<FormSelectOption>;
  /** Retrieve multiple formSelectOptions using the Relay connection interface */
  formSelectOptionsConnection: FormSelectOptionConnection;
  /** Retrieve a single formSubmitButton */
  formSubmitButton?: Maybe<FormSubmitButton>;
  /** Retrieve document version */
  formSubmitButtonVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formSubmitButtons */
  formSubmitButtons: Array<FormSubmitButton>;
  /** Retrieve multiple formSubmitButtons using the Relay connection interface */
  formSubmitButtonsConnection: FormSubmitButtonConnection;
  /** Retrieve a single formSuccessComponent */
  formSuccessComponent?: Maybe<FormSuccessComponent>;
  /** Retrieve document version */
  formSuccessComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formSuccessComponents */
  formSuccessComponents: Array<FormSuccessComponent>;
  /** Retrieve multiple formSuccessComponents using the Relay connection interface */
  formSuccessComponentsConnection: FormSuccessComponentConnection;
  /** Retrieve a single formTextInput */
  formTextInput?: Maybe<FormTextInput>;
  /** Retrieve document version */
  formTextInputVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formTextInputs */
  formTextInputs: Array<FormTextInput>;
  /** Retrieve multiple formTextInputs using the Relay connection interface */
  formTextInputsConnection: FormTextInputConnection;
  /** Retrieve a single formTextareaInput */
  formTextareaInput?: Maybe<FormTextareaInput>;
  /** Retrieve document version */
  formTextareaInputVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple formTextareaInputs */
  formTextareaInputs: Array<FormTextareaInput>;
  /** Retrieve multiple formTextareaInputs using the Relay connection interface */
  formTextareaInputsConnection: FormTextareaInputConnection;
  /** Retrieve document version */
  formVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple forms */
  forms: Array<Form>;
  /** Retrieve multiple forms using the Relay connection interface */
  formsConnection: FormConnection;
  /** Retrieve a single genericAccordion */
  genericAccordion?: Maybe<GenericAccordion>;
  /** Retrieve a single genericAccordionItem */
  genericAccordionItem?: Maybe<GenericAccordionItem>;
  /** Retrieve document version */
  genericAccordionItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericAccordionItems */
  genericAccordionItems: Array<GenericAccordionItem>;
  /** Retrieve multiple genericAccordionItems using the Relay connection interface */
  genericAccordionItemsConnection: GenericAccordionItemConnection;
  /** Retrieve a single genericAccordionTopRated */
  genericAccordionTopRated?: Maybe<GenericAccordionTopRated>;
  /** Retrieve document version */
  genericAccordionTopRatedVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericAccordionTopRateds */
  genericAccordionTopRateds: Array<GenericAccordionTopRated>;
  /** Retrieve multiple genericAccordionTopRateds using the Relay connection interface */
  genericAccordionTopRatedsConnection: GenericAccordionTopRatedConnection;
  /** Retrieve document version */
  genericAccordionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericAccordions */
  genericAccordions: Array<GenericAccordion>;
  /** Retrieve multiple genericAccordions using the Relay connection interface */
  genericAccordionsConnection: GenericAccordionConnection;
  /** Retrieve a single genericCardCarouseComponent */
  genericCardCarouseComponent?: Maybe<GenericCardCarouseComponent>;
  /** Retrieve document version */
  genericCardCarouseComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericCardCarouseComponents */
  genericCardCarouseComponents: Array<GenericCardCarouseComponent>;
  /** Retrieve multiple genericCardCarouseComponents using the Relay connection interface */
  genericCardCarouseComponentsConnection: GenericCardCarouseComponentConnection;
  /** Retrieve a single genericDownloadComponent */
  genericDownloadComponent?: Maybe<GenericDownloadComponent>;
  /** Retrieve document version */
  genericDownloadComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericDownloadComponents */
  genericDownloadComponents: Array<GenericDownloadComponent>;
  /** Retrieve multiple genericDownloadComponents using the Relay connection interface */
  genericDownloadComponentsConnection: GenericDownloadComponentConnection;
  /** Retrieve a single genericFollowUs */
  genericFollowUs?: Maybe<GenericFollowUs>;
  /** Retrieve document version */
  genericFollowUsVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericFollowUses */
  genericFollowUses: Array<GenericFollowUs>;
  /** Retrieve multiple genericFollowUses using the Relay connection interface */
  genericFollowUsesConnection: GenericFollowUsConnection;
  /** Retrieve a single genericGridAuthorable */
  genericGridAuthorable?: Maybe<GenericGridAuthorable>;
  /** Retrieve document version */
  genericGridAuthorableVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericGridAuthorables */
  genericGridAuthorables: Array<GenericGridAuthorable>;
  /** Retrieve multiple genericGridAuthorables using the Relay connection interface */
  genericGridAuthorablesConnection: GenericGridAuthorableConnection;
  /** Retrieve a single genericLine */
  genericLine?: Maybe<GenericLine>;
  /** Retrieve document version */
  genericLineVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericLines */
  genericLines: Array<GenericLine>;
  /** Retrieve multiple genericLines using the Relay connection interface */
  genericLinesConnection: GenericLineConnection;
  /** Retrieve a single genericLink */
  genericLink?: Maybe<GenericLink>;
  /** Retrieve document version */
  genericLinkVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericLinks */
  genericLinks: Array<GenericLink>;
  /** Retrieve multiple genericLinks using the Relay connection interface */
  genericLinksConnection: GenericLinkConnection;
  /** Retrieve a single genericPage */
  genericPage?: Maybe<GenericPage>;
  /** Retrieve document version */
  genericPageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple genericPages */
  genericPages: Array<GenericPage>;
  /** Retrieve multiple genericPages using the Relay connection interface */
  genericPagesConnection: GenericPageConnection;
  /** Retrieve a single globalMetaData */
  globalMetaData?: Maybe<GlobalMetaData>;
  /** Retrieve document version */
  globalMetaDataVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple globalMetaDatas */
  globalMetaDatas: Array<GlobalMetaData>;
  /** Retrieve multiple globalMetaDatas using the Relay connection interface */
  globalMetaDatasConnection: GlobalMetaDataConnection;
  /** Retrieve a single heroBanner */
  heroBanner?: Maybe<HeroBanner>;
  /** Retrieve document version */
  heroBannerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple heroBanners */
  heroBanners: Array<HeroBanner>;
  /** Retrieve multiple heroBanners using the Relay connection interface */
  heroBannersConnection: HeroBannerConnection;
  /** Retrieve a single heroCarouselComponent */
  heroCarouselComponent?: Maybe<HeroCarouselComponent>;
  /** Retrieve document version */
  heroCarouselComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple heroCarouselComponents */
  heroCarouselComponents: Array<HeroCarouselComponent>;
  /** Retrieve multiple heroCarouselComponents using the Relay connection interface */
  heroCarouselComponentsConnection: HeroCarouselComponentConnection;
  /** Retrieve a single heroComponent */
  heroComponent?: Maybe<HeroComponent>;
  /** Retrieve document version */
  heroComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple heroComponents */
  heroComponents: Array<HeroComponent>;
  /** Retrieve multiple heroComponents using the Relay connection interface */
  heroComponentsConnection: HeroComponentConnection;
  /** Retrieve a single homePage */
  homePage?: Maybe<HomePage>;
  /** Retrieve document version */
  homePageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple homePages */
  homePages: Array<HomePage>;
  /** Retrieve multiple homePages using the Relay connection interface */
  homePagesConnection: HomePageConnection;
  /** Retrieve a single iframe */
  iframe?: Maybe<Iframe>;
  /** Retrieve document version */
  iframeVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple iframes */
  iframes: Array<Iframe>;
  /** Retrieve multiple iframes using the Relay connection interface */
  iframesConnection: IframeConnection;
  /** Retrieve a single imageAndTextCard */
  imageAndTextCard?: Maybe<ImageAndTextCard>;
  /** Retrieve document version */
  imageAndTextCardVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple imageAndTextCards */
  imageAndTextCards: Array<ImageAndTextCard>;
  /** Retrieve multiple imageAndTextCards using the Relay connection interface */
  imageAndTextCardsConnection: ImageAndTextCardConnection;
  /** Retrieve multiple imageCopies */
  imageCopies: Array<ImageCopy>;
  /** Retrieve multiple imageCopies using the Relay connection interface */
  imageCopiesConnection: ImageCopyConnection;
  /** Retrieve a single imageCopy */
  imageCopy?: Maybe<ImageCopy>;
  /** Retrieve a single imageCopyItem */
  imageCopyItem?: Maybe<ImageCopyItem>;
  /** Retrieve document version */
  imageCopyItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple imageCopyItems */
  imageCopyItems: Array<ImageCopyItem>;
  /** Retrieve multiple imageCopyItems using the Relay connection interface */
  imageCopyItemsConnection: ImageCopyItemConnection;
  /** Retrieve document version */
  imageCopyVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single introText */
  introText?: Maybe<IntroText>;
  /** Retrieve document version */
  introTextVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple introTexts */
  introTexts: Array<IntroText>;
  /** Retrieve multiple introTexts using the Relay connection interface */
  introTextsConnection: IntroTextConnection;
  /** Retrieve a single leftColumn */
  leftColumn?: Maybe<LeftColumn>;
  /** Retrieve document version */
  leftColumnVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple leftColumns */
  leftColumns: Array<LeftColumn>;
  /** Retrieve multiple leftColumns using the Relay connection interface */
  leftColumnsConnection: LeftColumnConnection;
  /** Retrieve a single link */
  link?: Maybe<Link>;
  /** Retrieve document version */
  linkVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple links */
  links: Array<Link>;
  /** Retrieve multiple links using the Relay connection interface */
  linksConnection: LinkConnection;
  /** Retrieve a single locationComponent */
  locationComponent?: Maybe<LocationComponent>;
  /** Retrieve document version */
  locationComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple locationComponents */
  locationComponents: Array<LocationComponent>;
  /** Retrieve multiple locationComponents using the Relay connection interface */
  locationComponentsConnection: LocationComponentConnection;
  /** Retrieve a single locationItem */
  locationItem?: Maybe<LocationItem>;
  /** Retrieve document version */
  locationItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple locationItems */
  locationItems: Array<LocationItem>;
  /** Retrieve multiple locationItems using the Relay connection interface */
  locationItemsConnection: LocationItemConnection;
  /** Retrieve a single longText */
  longText?: Maybe<LongText>;
  /** Retrieve document version */
  longTextVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple longTexts */
  longTexts: Array<LongText>;
  /** Retrieve multiple longTexts using the Relay connection interface */
  longTextsConnection: LongTextConnection;
  /** Retrieve multiple mediaLibraries */
  mediaLibraries: Array<MediaLibrary>;
  /** Retrieve multiple mediaLibraries using the Relay connection interface */
  mediaLibrariesConnection: MediaLibraryConnection;
  /** Retrieve a single mediaLibrary */
  mediaLibrary?: Maybe<MediaLibrary>;
  /** Retrieve a single mediaLibraryItem */
  mediaLibraryItem?: Maybe<MediaLibraryItem>;
  /** Retrieve document version */
  mediaLibraryItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple mediaLibraryItems */
  mediaLibraryItems: Array<MediaLibraryItem>;
  /** Retrieve multiple mediaLibraryItems using the Relay connection interface */
  mediaLibraryItemsConnection: MediaLibraryItemConnection;
  /** Retrieve document version */
  mediaLibraryVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single metaData */
  metaData?: Maybe<MetaData>;
  /** Retrieve document version */
  metaDataVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple metaDatas */
  metaDatas: Array<MetaData>;
  /** Retrieve multiple metaDatas using the Relay connection interface */
  metaDatasConnection: MetaDataConnection;
  /** Retrieve a single mobileOnlyMainNavigation */
  mobileOnlyMainNavigation?: Maybe<MobileOnlyMainNavigation>;
  /** Retrieve document version */
  mobileOnlyMainNavigationVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple mobileOnlyMainNavigations */
  mobileOnlyMainNavigations: Array<MobileOnlyMainNavigation>;
  /** Retrieve multiple mobileOnlyMainNavigations using the Relay connection interface */
  mobileOnlyMainNavigationsConnection: MobileOnlyMainNavigationConnection;
  /** Retrieve a single navigation */
  navigation?: Maybe<Navigation>;
  /** Retrieve a single navigationItem */
  navigationItem?: Maybe<NavigationItem>;
  /** Retrieve document version */
  navigationItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple navigationItems */
  navigationItems: Array<NavigationItem>;
  /** Retrieve multiple navigationItems using the Relay connection interface */
  navigationItemsConnection: NavigationItemConnection;
  /** Retrieve document version */
  navigationVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple navigations */
  navigations: Array<Navigation>;
  /** Retrieve multiple navigations using the Relay connection interface */
  navigationsConnection: NavigationConnection;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  /** Retrieve a single notificationBanner */
  notificationBanner?: Maybe<NotificationBanner>;
  /** Retrieve document version */
  notificationBannerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple notificationBanners */
  notificationBanners: Array<NotificationBanner>;
  /** Retrieve multiple notificationBanners using the Relay connection interface */
  notificationBannersConnection: NotificationBannerConnection;
  /** Retrieve a single pageFooter */
  pageFooter?: Maybe<PageFooter>;
  /** Retrieve document version */
  pageFooterVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple pageFooters */
  pageFooters: Array<PageFooter>;
  /** Retrieve multiple pageFooters using the Relay connection interface */
  pageFootersConnection: PageFooterConnection;
  /** Retrieve a single pageHeader */
  pageHeader?: Maybe<PageHeader>;
  /** Retrieve document version */
  pageHeaderVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple pageHeaders */
  pageHeaders: Array<PageHeader>;
  /** Retrieve multiple pageHeaders using the Relay connection interface */
  pageHeadersConnection: PageHeaderConnection;
  /** Retrieve a single popularSearchComponent */
  popularSearchComponent?: Maybe<PopularSearchComponent>;
  /** Retrieve document version */
  popularSearchComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple popularSearchComponents */
  popularSearchComponents: Array<PopularSearchComponent>;
  /** Retrieve multiple popularSearchComponents using the Relay connection interface */
  popularSearchComponentsConnection: PopularSearchComponentConnection;
  /** Retrieve a single pressRelease */
  pressRelease?: Maybe<PressRelease>;
  /** Retrieve document version */
  pressReleaseVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple pressReleases */
  pressReleases: Array<PressRelease>;
  /** Retrieve multiple pressReleases using the Relay connection interface */
  pressReleasesConnection: PressReleaseConnection;
  /** Retrieve a single pressStoriesCard */
  pressStoriesCard?: Maybe<PressStoriesCard>;
  /** Retrieve document version */
  pressStoriesCardVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple pressStoriesCards */
  pressStoriesCards: Array<PressStoriesCard>;
  /** Retrieve multiple pressStoriesCards using the Relay connection interface */
  pressStoriesCardsConnection: PressStoriesCardConnection;
  /** Retrieve a single progressBar */
  progressBar?: Maybe<ProgressBar>;
  /** Retrieve document version */
  progressBarVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple progressBars */
  progressBars: Array<ProgressBar>;
  /** Retrieve multiple progressBars using the Relay connection interface */
  progressBarsConnection: ProgressBarConnection;
  /** Retrieve a single quickLink */
  quickLink?: Maybe<QuickLink>;
  /** Retrieve a single quickLinkItem */
  quickLinkItem?: Maybe<QuickLinkItem>;
  /** Retrieve document version */
  quickLinkItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple quickLinkItems */
  quickLinkItems: Array<QuickLinkItem>;
  /** Retrieve multiple quickLinkItems using the Relay connection interface */
  quickLinkItemsConnection: QuickLinkItemConnection;
  /** Retrieve document version */
  quickLinkVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple quickLinks */
  quickLinks: Array<QuickLink>;
  /** Retrieve multiple quickLinks using the Relay connection interface */
  quickLinksConnection: QuickLinkConnection;
  /** Retrieve a single redirect */
  redirect?: Maybe<Redirect>;
  /** Retrieve document version */
  redirectVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple redirects */
  redirects: Array<Redirect>;
  /** Retrieve multiple redirects using the Relay connection interface */
  redirectsConnection: RedirectConnection;
  /** Retrieve a single rewrite */
  rewrite?: Maybe<Rewrite>;
  /** Retrieve document version */
  rewriteVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple rewrites */
  rewrites: Array<Rewrite>;
  /** Retrieve multiple rewrites using the Relay connection interface */
  rewritesConnection: RewriteConnection;
  /** Retrieve a single rightColumn */
  rightColumn?: Maybe<RightColumn>;
  /** Retrieve document version */
  rightColumnVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple rightColumns */
  rightColumns: Array<RightColumn>;
  /** Retrieve multiple rightColumns using the Relay connection interface */
  rightColumnsConnection: RightColumnConnection;
  /** Retrieve a single scheduledOperation */
  scheduledOperation?: Maybe<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations */
  scheduledOperations: Array<ScheduledOperation>;
  /** Retrieve multiple scheduledOperations using the Relay connection interface */
  scheduledOperationsConnection: ScheduledOperationConnection;
  /** Retrieve a single scheduledRelease */
  scheduledRelease?: Maybe<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases */
  scheduledReleases: Array<ScheduledRelease>;
  /** Retrieve multiple scheduledReleases using the Relay connection interface */
  scheduledReleasesConnection: ScheduledReleaseConnection;
  /** Retrieve a single searchInput */
  searchInput?: Maybe<SearchInput>;
  /** Retrieve document version */
  searchInputVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple searchInputs */
  searchInputs: Array<SearchInput>;
  /** Retrieve multiple searchInputs using the Relay connection interface */
  searchInputsConnection: SearchInputConnection;
  /** Retrieve a single searchOverlayComponent */
  searchOverlayComponent?: Maybe<SearchOverlayComponent>;
  /** Retrieve document version */
  searchOverlayComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple searchOverlayComponents */
  searchOverlayComponents: Array<SearchOverlayComponent>;
  /** Retrieve multiple searchOverlayComponents using the Relay connection interface */
  searchOverlayComponentsConnection: SearchOverlayComponentConnection;
  /** Retrieve a single searchResultPage */
  searchResultPage?: Maybe<SearchResultPage>;
  /** Retrieve document version */
  searchResultPageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple searchResultPages */
  searchResultPages: Array<SearchResultPage>;
  /** Retrieve multiple searchResultPages using the Relay connection interface */
  searchResultPagesConnection: SearchResultPageConnection;
  /** Retrieve a single shortHero */
  shortHero?: Maybe<ShortHero>;
  /** Retrieve document version */
  shortHeroVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple shortHeroes */
  shortHeroes: Array<ShortHero>;
  /** Retrieve multiple shortHeroes using the Relay connection interface */
  shortHeroesConnection: ShortHeroConnection;
  /** Retrieve a single socialMediaListComponent */
  socialMediaListComponent?: Maybe<SocialMediaListComponent>;
  /** Retrieve document version */
  socialMediaListComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple socialMediaListComponents */
  socialMediaListComponents: Array<SocialMediaListComponent>;
  /** Retrieve multiple socialMediaListComponents using the Relay connection interface */
  socialMediaListComponentsConnection: SocialMediaListComponentConnection;
  /** Retrieve a single spacer */
  spacer?: Maybe<Spacer>;
  /** Retrieve document version */
  spacerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple spacers */
  spacers: Array<Spacer>;
  /** Retrieve multiple spacers using the Relay connection interface */
  spacersConnection: SpacerConnection;
  /** Retrieve multiple stories */
  stories: Array<Story>;
  /** Retrieve multiple stories using the Relay connection interface */
  storiesConnection: StoryConnection;
  /** Retrieve a single story */
  story?: Maybe<Story>;
  /** Retrieve document version */
  storyVersion?: Maybe<DocumentVersion>;
  /** Retrieve a single subCategoryKeyImage */
  subCategoryKeyImage?: Maybe<SubCategoryKeyImage>;
  /** Retrieve document version */
  subCategoryKeyImageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple subCategoryKeyImages */
  subCategoryKeyImages: Array<SubCategoryKeyImage>;
  /** Retrieve multiple subCategoryKeyImages using the Relay connection interface */
  subCategoryKeyImagesConnection: SubCategoryKeyImageConnection;
  /** Retrieve a single sustainabilityBanner */
  sustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** Retrieve document version */
  sustainabilityBannerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple sustainabilityBanners */
  sustainabilityBanners: Array<SustainabilityBanner>;
  /** Retrieve multiple sustainabilityBanners using the Relay connection interface */
  sustainabilityBannersConnection: SustainabilityBannerConnection;
  /** Retrieve a single sustainabilityInfo */
  sustainabilityInfo?: Maybe<SustainabilityInfo>;
  /** Retrieve document version */
  sustainabilityInfoVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple sustainabilityInfos */
  sustainabilityInfos: Array<SustainabilityInfo>;
  /** Retrieve multiple sustainabilityInfos using the Relay connection interface */
  sustainabilityInfosConnection: SustainabilityInfoConnection;
  /** Retrieve a single tab */
  tab?: Maybe<Tab>;
  /** Retrieve a single tabContent */
  tabContent?: Maybe<TabContent>;
  /** Retrieve document version */
  tabContentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple tabContents */
  tabContents: Array<TabContent>;
  /** Retrieve multiple tabContents using the Relay connection interface */
  tabContentsConnection: TabContentConnection;
  /** Retrieve document version */
  tabVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple tabs */
  tabs: Array<Tab>;
  /** Retrieve multiple tabs using the Relay connection interface */
  tabsConnection: TabConnection;
  /** Retrieve a single testTipsANdTricksInAMarket */
  testTipsANdTricksInAMarket?: Maybe<TestTipsANdTricksInAMarket>;
  /** Retrieve document version */
  testTipsANdTricksInAMarketVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple testTipsANdTricksInAMarkets */
  testTipsANdTricksInAMarkets: Array<TestTipsANdTricksInAMarket>;
  /** Retrieve multiple testTipsANdTricksInAMarkets using the Relay connection interface */
  testTipsANdTricksInAMarketsConnection: TestTipsANdTricksInAMarketConnection;
  /** Retrieve a single textComponent */
  textComponent?: Maybe<TextComponent>;
  /** Retrieve document version */
  textComponentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple textComponents */
  textComponents: Array<TextComponent>;
  /** Retrieve multiple textComponents using the Relay connection interface */
  textComponentsConnection: TextComponentConnection;
  /** Retrieve a single tipsAndTricksDetailsPage */
  tipsAndTricksDetailsPage?: Maybe<TipsAndTricksDetailsPage>;
  /** Retrieve document version */
  tipsAndTricksDetailsPageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple tipsAndTricksDetailsPages */
  tipsAndTricksDetailsPages: Array<TipsAndTricksDetailsPage>;
  /** Retrieve multiple tipsAndTricksDetailsPages using the Relay connection interface */
  tipsAndTricksDetailsPagesConnection: TipsAndTricksDetailsPageConnection;
  /** Retrieve a single title */
  title?: Maybe<Title>;
  /** Retrieve document version */
  titleVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple titles */
  titles: Array<Title>;
  /** Retrieve multiple titles using the Relay connection interface */
  titlesConnection: TitleConnection;
  /** Retrieve a single twitterSeo */
  twitterSeo?: Maybe<TwitterSeo>;
  /** Retrieve document version */
  twitterSeoVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple twitterSeos */
  twitterSeos: Array<TwitterSeo>;
  /** Retrieve multiple twitterSeos using the Relay connection interface */
  twitterSeosConnection: TwitterSeoConnection;
  /** Retrieve a single user */
  user?: Maybe<User>;
  /** Retrieve multiple users */
  users: Array<User>;
  /** Retrieve multiple users using the Relay connection interface */
  usersConnection: UserConnection;
  /** Retrieve a single widget */
  widget?: Maybe<Widget>;
  /** Retrieve document version */
  widgetVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple widgets */
  widgets: Array<Widget>;
  /** Retrieve multiple widgets using the Relay connection interface */
  widgetsConnection: WidgetConnection;
};


export type QueryAccordionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AccordionWhereUniqueInput;
};


export type QueryAccordionItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AccordionItemWhereUniqueInput;
};


export type QueryAccordionItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AccordionItemWhereInput>;
};


export type QueryAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AccordionItemWhereInput>;
};


export type QueryAccordionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAccordionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AccordionWhereInput>;
};


export type QueryAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AccordionWhereInput>;
};


export type QueryAlexTestComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AlexTestComponentWhereUniqueInput;
};


export type QueryAlexTestComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAlexTestComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AlexTestComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AlexTestComponentWhereInput>;
};


export type QueryAlexTestComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AlexTestComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AlexTestComponentWhereInput>;
};


export type QueryAlgoliaExtensionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AlgoliaExtensionWhereUniqueInput;
};


export type QueryAlgoliaExtensionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAlgoliaExtensionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AlgoliaExtensionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AlgoliaExtensionWhereInput>;
};


export type QueryAlgoliaExtensionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AlgoliaExtensionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AlgoliaExtensionWhereInput>;
};


export type QueryAnchorNavArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AnchorNavWhereUniqueInput;
};


export type QueryAnchorNavVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAnchorNavigationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AnchorNavigationWhereUniqueInput;
};


export type QueryAnchorNavigationListArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AnchorNavigationListWhereUniqueInput;
};


export type QueryAnchorNavigationListVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAnchorNavigationListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AnchorNavigationListOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AnchorNavigationListWhereInput>;
};


export type QueryAnchorNavigationListsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AnchorNavigationListOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AnchorNavigationListWhereInput>;
};


export type QueryAnchorNavigationVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAnchorNavigationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AnchorNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AnchorNavigationWhereInput>;
};


export type QueryAnchorNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AnchorNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AnchorNavigationWhereInput>;
};


export type QueryAnchorNavsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AnchorNavOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AnchorNavWhereInput>;
};


export type QueryAnchorNavsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AnchorNavOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AnchorNavWhereInput>;
};


export type QueryAssetArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AssetWhereUniqueInput;
};


export type QueryAssetComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AssetComponentWhereUniqueInput;
};


export type QueryAssetComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAssetVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryAssetsComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetComponentWhereInput>;
};


export type QueryAssetsComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetComponentWhereInput>;
};


export type QueryAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AssetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryAudioComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AudioComponentWhereUniqueInput;
};


export type QueryAudioComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAudioComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AudioComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AudioComponentWhereInput>;
};


export type QueryAudioComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AudioComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AudioComponentWhereInput>;
};


export type QueryAuthorableContentCardArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: AuthorableContentCardWhereUniqueInput;
};


export type QueryAuthorableContentCardVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAuthorableContentCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AuthorableContentCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AuthorableContentCardWhereInput>;
};


export type QueryAuthorableContentCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<AuthorableContentCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<AuthorableContentCardWhereInput>;
};


export type QueryBanner2Args = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: Banner2WhereUniqueInput;
};


export type QueryBanner2SArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<Banner2OrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<Banner2WhereInput>;
};


export type QueryBanner2SConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<Banner2OrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<Banner2WhereInput>;
};


export type QueryBanner2VersionArgs = {
  where: VersionWhereInput;
};


export type QueryBigNumberArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: BigNumberWhereUniqueInput;
};


export type QueryBigNumberItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: BigNumberItemWhereUniqueInput;
};


export type QueryBigNumberItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryBigNumberItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BigNumberItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<BigNumberItemWhereInput>;
};


export type QueryBigNumberItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BigNumberItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<BigNumberItemWhereInput>;
};


export type QueryBigNumberVersionArgs = {
  where: VersionWhereInput;
};


export type QueryBigNumbersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BigNumberOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<BigNumberWhereInput>;
};


export type QueryBigNumbersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<BigNumberOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<BigNumberWhereInput>;
};


export type QueryCardComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CardComponentWhereUniqueInput;
};


export type QueryCardComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCardComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CardComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CardComponentWhereInput>;
};


export type QueryCardComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CardComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CardComponentWhereInput>;
};


export type QueryCarouselComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CarouselComponentWhereUniqueInput;
};


export type QueryCarouselComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCarouselComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CarouselComponentWhereInput>;
};


export type QueryCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CarouselComponentWhereInput>;
};


export type QueryCarouselSlideArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CarouselSlideWhereUniqueInput;
};


export type QueryCarouselSlideVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCarouselSlidesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CarouselSlideOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CarouselSlideWhereInput>;
};


export type QueryCarouselSlidesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CarouselSlideOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CarouselSlideWhereInput>;
};


export type QueryCategoryCardArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CategoryCardWhereUniqueInput;
};


export type QueryCategoryCardVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCategoryCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CategoryCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CategoryCardWhereInput>;
};


export type QueryCategoryCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CategoryCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CategoryCardWhereInput>;
};


export type QueryContactCardArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ContactCardWhereUniqueInput;
};


export type QueryContactCardContainerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ContactCardContainerWhereUniqueInput;
};


export type QueryContactCardContainerVersionArgs = {
  where: VersionWhereInput;
};


export type QueryContactCardContainersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContactCardContainerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContactCardContainerWhereInput>;
};


export type QueryContactCardContainersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContactCardContainerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContactCardContainerWhereInput>;
};


export type QueryContactCardVersionArgs = {
  where: VersionWhereInput;
};


export type QueryContactCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContactCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContactCardWhereInput>;
};


export type QueryContactCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ContactCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ContactCardWhereInput>;
};


export type QueryCorpAddToCalendarArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpAddToCalendarWhereUniqueInput;
};


export type QueryCorpAddToCalendarVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpAddToCalendarsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpAddToCalendarOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpAddToCalendarWhereInput>;
};


export type QueryCorpAddToCalendarsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpAddToCalendarOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpAddToCalendarWhereInput>;
};


export type QueryCorpBanner1Args = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpBanner1WhereUniqueInput;
};


export type QueryCorpBanner1VersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpBanners1Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpBanner1OrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpBanner1WhereInput>;
};


export type QueryCorpBanners1ConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpBanner1OrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpBanner1WhereInput>;
};


export type QueryCorpCalendarEventArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpCalendarEventWhereUniqueInput;
};


export type QueryCorpCalendarEventVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpCalendarEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpCalendarEventOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpCalendarEventWhereInput>;
};


export type QueryCorpCalendarEventsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpCalendarEventOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpCalendarEventWhereInput>;
};


export type QueryCorpCardCarouselArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpCardCarouselWhereUniqueInput;
};


export type QueryCorpCardCarouselVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpCardCarouselsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpCardCarouselOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpCardCarouselWhereInput>;
};


export type QueryCorpCardCarouselsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpCardCarouselOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpCardCarouselWhereInput>;
};


export type QueryCorpContactCardArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpContactCardWhereUniqueInput;
};


export type QueryCorpContactCardContainerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpContactCardContainerWhereUniqueInput;
};


export type QueryCorpContactCardContainerVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpContactCardContainersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpContactCardContainerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpContactCardContainerWhereInput>;
};


export type QueryCorpContactCardContainersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpContactCardContainerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpContactCardContainerWhereInput>;
};


export type QueryCorpContactCardVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpContactCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpContactCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpContactCardWhereInput>;
};


export type QueryCorpContactCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpContactCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpContactCardWhereInput>;
};


export type QueryCorpFormArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpFormWhereUniqueInput;
};


export type QueryCorpFormVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpFormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpFormWhereInput>;
};


export type QueryCorpFormsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpFormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpFormWhereInput>;
};


export type QueryCorpGenericAccordionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpGenericAccordionWhereUniqueInput;
};


export type QueryCorpGenericAccordionItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpGenericAccordionItemWhereUniqueInput;
};


export type QueryCorpGenericAccordionItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpGenericAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpGenericAccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpGenericAccordionItemWhereInput>;
};


export type QueryCorpGenericAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpGenericAccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpGenericAccordionItemWhereInput>;
};


export type QueryCorpGenericAccordionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpGenericAccordionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpGenericAccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpGenericAccordionWhereInput>;
};


export type QueryCorpGenericAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpGenericAccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpGenericAccordionWhereInput>;
};


export type QueryCorpGenericBannerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpGenericBannerWhereUniqueInput;
};


export type QueryCorpGenericBannerVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpGenericBannersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpGenericBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpGenericBannerWhereInput>;
};


export type QueryCorpGenericBannersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpGenericBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpGenericBannerWhereInput>;
};


export type QueryCorpGenericContainerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpGenericContainerWhereUniqueInput;
};


export type QueryCorpGenericContainerVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpGenericContainersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpGenericContainerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpGenericContainerWhereInput>;
};


export type QueryCorpGenericContainersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpGenericContainerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpGenericContainerWhereInput>;
};


export type QueryCorpGridColumnComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpGridColumnComponentWhereUniqueInput;
};


export type QueryCorpGridColumnComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpGridColumnComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpGridColumnComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpGridColumnComponentWhereInput>;
};


export type QueryCorpGridColumnComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpGridColumnComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpGridColumnComponentWhereInput>;
};


export type QueryCorpHeroArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpHeroWhereUniqueInput;
};


export type QueryCorpHeroVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpHerosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpHeroOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpHeroWhereInput>;
};


export type QueryCorpHerosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpHeroOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpHeroWhereInput>;
};


export type QueryCorpMediaDownloadPreviewArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpMediaDownloadPreviewWhereUniqueInput;
};


export type QueryCorpMediaDownloadPreviewVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpMediaDownloadPreviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpMediaDownloadPreviewOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpMediaDownloadPreviewWhereInput>;
};


export type QueryCorpMediaDownloadPreviewsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpMediaDownloadPreviewOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpMediaDownloadPreviewWhereInput>;
};


export type QueryCorpNavigationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpNavigationWhereUniqueInput;
};


export type QueryCorpNavigationItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpNavigationItemWhereUniqueInput;
};


export type QueryCorpNavigationItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpNavigationItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpNavigationItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpNavigationItemWhereInput>;
};


export type QueryCorpNavigationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpNavigationItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpNavigationItemWhereInput>;
};


export type QueryCorpNavigationVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpNavigationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpNavigationWhereInput>;
};


export type QueryCorpNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpNavigationWhereInput>;
};


export type QueryCorpNotificationBannerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpNotificationBannerWhereUniqueInput;
};


export type QueryCorpNotificationBannerVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpNotificationBannersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpNotificationBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpNotificationBannerWhereInput>;
};


export type QueryCorpNotificationBannersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpNotificationBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpNotificationBannerWhereInput>;
};


export type QueryCorpOurPeopleArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpOurPeopleWhereUniqueInput;
};


export type QueryCorpOurPeopleItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpOurPeopleItemWhereUniqueInput;
};


export type QueryCorpOurPeopleItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpOurPeopleItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpOurPeopleItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpOurPeopleItemWhereInput>;
};


export type QueryCorpOurPeopleItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpOurPeopleItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpOurPeopleItemWhereInput>;
};


export type QueryCorpOurPeopleVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpOurPeoplesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpOurPeopleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpOurPeopleWhereInput>;
};


export type QueryCorpOurPeoplesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpOurPeopleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpOurPeopleWhereInput>;
};


export type QueryCorpPressPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpPressPageWhereUniqueInput;
};


export type QueryCorpPressPageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpPressPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpPressPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpPressPageWhereInput>;
};


export type QueryCorpPressPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpPressPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpPressPageWhereInput>;
};


export type QueryCorpSocialMediaFooterArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpSocialMediaFooterWhereUniqueInput;
};


export type QueryCorpSocialMediaFooterVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpSocialMediaFootersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpSocialMediaFooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpSocialMediaFooterWhereInput>;
};


export type QueryCorpSocialMediaFootersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpSocialMediaFooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpSocialMediaFooterWhereInput>;
};


export type QueryCorpStoriesPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpStoriesPageWhereUniqueInput;
};


export type QueryCorpStoriesPageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpStoriesPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpStoriesPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpStoriesPageWhereInput>;
};


export type QueryCorpStoriesPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpStoriesPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpStoriesPageWhereInput>;
};


export type QueryCorpStoryCarouselArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpStoryCarouselWhereUniqueInput;
};


export type QueryCorpStoryCarouselVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpStoryCarouselsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpStoryCarouselOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpStoryCarouselWhereInput>;
};


export type QueryCorpStoryCarouselsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpStoryCarouselOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpStoryCarouselWhereInput>;
};


export type QueryCorpTimelineAccordionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpTimelineAccordionWhereUniqueInput;
};


export type QueryCorpTimelineAccordionItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpTimelineAccordionItemWhereUniqueInput;
};


export type QueryCorpTimelineAccordionItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpTimelineAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpTimelineAccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpTimelineAccordionItemWhereInput>;
};


export type QueryCorpTimelineAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpTimelineAccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpTimelineAccordionItemWhereInput>;
};


export type QueryCorpTimelineAccordionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpTimelineAccordionWrapperArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpTimelineAccordionWrapperWhereUniqueInput;
};


export type QueryCorpTimelineAccordionWrapperVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpTimelineAccordionWrappersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpTimelineAccordionWrapperOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpTimelineAccordionWrapperWhereInput>;
};


export type QueryCorpTimelineAccordionWrappersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpTimelineAccordionWrapperOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpTimelineAccordionWrapperWhereInput>;
};


export type QueryCorpTimelineAccordionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpTimelineAccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpTimelineAccordionWhereInput>;
};


export type QueryCorpTimelineAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpTimelineAccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpTimelineAccordionWhereInput>;
};


export type QueryCorpVideoHeroArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpVideoHeroWhereUniqueInput;
};


export type QueryCorpVideoHeroCarouselArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CorpVideoHeroCarouselWhereUniqueInput;
};


export type QueryCorpVideoHeroCarouselVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpVideoHeroCarouselsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpVideoHeroCarouselOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpVideoHeroCarouselWhereInput>;
};


export type QueryCorpVideoHeroCarouselsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpVideoHeroCarouselOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpVideoHeroCarouselWhereInput>;
};


export type QueryCorpVideoHeroVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCorpVideoHerosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpVideoHeroOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpVideoHeroWhereInput>;
};


export type QueryCorpVideoHerosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CorpVideoHeroOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CorpVideoHeroWhereInput>;
};


export type QueryCountrySelectorArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CountrySelectorWhereUniqueInput;
};


export type QueryCountrySelectorItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: CountrySelectorItemWhereUniqueInput;
};


export type QueryCountrySelectorItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCountrySelectorItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CountrySelectorItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CountrySelectorItemWhereInput>;
};


export type QueryCountrySelectorItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CountrySelectorItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CountrySelectorItemWhereInput>;
};


export type QueryCountrySelectorVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCountrySelectorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CountrySelectorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CountrySelectorWhereInput>;
};


export type QueryCountrySelectorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<CountrySelectorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<CountrySelectorWhereInput>;
};


export type QueryDEprecatedBanner1Args = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: DeprecatedBanner1WhereUniqueInput;
};


export type QueryDEprecatedBanner1VersionArgs = {
  where: VersionWhereInput;
};


export type QueryDEprecatedBanner1sArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DeprecatedBanner1OrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DeprecatedBanner1WhereInput>;
};


export type QueryDEprecatedBanner1sConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DeprecatedBanner1OrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DeprecatedBanner1WhereInput>;
};


export type QueryDeprecatedCorpNavigationCopyArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: DeprecatedCorpNavigationCopyWhereUniqueInput;
};


export type QueryDeprecatedCorpNavigationCopyVersionArgs = {
  where: VersionWhereInput;
};


export type QueryDeprecatedCorpNavigationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DeprecatedCorpNavigationCopyOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DeprecatedCorpNavigationCopyWhereInput>;
};


export type QueryDeprecatedCorpNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DeprecatedCorpNavigationCopyOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DeprecatedCorpNavigationCopyWhereInput>;
};


export type QueryDictionariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DictionaryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DictionaryWhereInput>;
};


export type QueryDictionariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DictionaryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DictionaryWhereInput>;
};


export type QueryDictionaryArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: DictionaryWhereUniqueInput;
};


export type QueryDictionaryItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: DictionaryItemWhereUniqueInput;
};


export type QueryDictionaryItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryDictionaryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DictionaryItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DictionaryItemWhereInput>;
};


export type QueryDictionaryItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DictionaryItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DictionaryItemWhereInput>;
};


export type QueryDictionaryVersionArgs = {
  where: VersionWhereInput;
};


export type QueryDynamicCardGridArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: DynamicCardGridWhereUniqueInput;
};


export type QueryDynamicCardGridVersionArgs = {
  where: VersionWhereInput;
};


export type QueryDynamicCardGridsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DynamicCardGridOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DynamicCardGridWhereInput>;
};


export type QueryDynamicCardGridsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<DynamicCardGridOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<DynamicCardGridWhereInput>;
};


export type QueryEntitiesArgs = {
  locales?: InputMaybe<Array<Locale>>;
  where: Array<EntityWhereInput>;
};


export type QueryEvalancheFormComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: EvalancheFormComponentWhereUniqueInput;
};


export type QueryEvalancheFormComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryEvalancheFormComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<EvalancheFormComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<EvalancheFormComponentWhereInput>;
};


export type QueryEvalancheFormComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<EvalancheFormComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<EvalancheFormComponentWhereInput>;
};


export type QueryExampleComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ExampleComponentWhereUniqueInput;
};


export type QueryExampleComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryExampleComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ExampleComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ExampleComponentWhereInput>;
};


export type QueryExampleComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ExampleComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ExampleComponentWhereInput>;
};


export type QueryFeaturedContentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FeaturedContentWhereUniqueInput;
};


export type QueryFeaturedContentReferenceArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FeaturedContentReferenceWhereUniqueInput;
};


export type QueryFeaturedContentReferenceVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFeaturedContentReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FeaturedContentReferenceOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FeaturedContentReferenceWhereInput>;
};


export type QueryFeaturedContentReferencesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FeaturedContentReferenceOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FeaturedContentReferenceWhereInput>;
};


export type QueryFeaturedContentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFeaturedContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FeaturedContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FeaturedContentWhereInput>;
};


export type QueryFeaturedContentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FeaturedContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FeaturedContentWhereInput>;
};


export type QueryFooterNavigationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FooterNavigationWhereUniqueInput;
};


export type QueryFooterNavigationVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFooterNavigationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FooterNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FooterNavigationWhereInput>;
};


export type QueryFooterNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FooterNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FooterNavigationWhereInput>;
};


export type QueryFormArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormWhereUniqueInput;
};


export type QueryFormCheckboxArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormCheckboxWhereUniqueInput;
};


export type QueryFormCheckboxVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormCheckboxesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormCheckboxOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormCheckboxWhereInput>;
};


export type QueryFormCheckboxesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormCheckboxOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormCheckboxWhereInput>;
};


export type QueryFormEmailInputArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormEmailInputWhereUniqueInput;
};


export type QueryFormEmailInputVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormEmailInputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormEmailInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormEmailInputWhereInput>;
};


export type QueryFormEmailInputsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormEmailInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormEmailInputWhereInput>;
};


export type QueryFormErrorArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormErrorWhereUniqueInput;
};


export type QueryFormErrorVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormErrorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormErrorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormErrorWhereInput>;
};


export type QueryFormErrorsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormErrorOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormErrorWhereInput>;
};


export type QueryFormPasswordInputArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormPasswordInputWhereUniqueInput;
};


export type QueryFormPasswordInputVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormPasswordInputWithConfirmationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormPasswordInputWithConfirmationWhereUniqueInput;
};


export type QueryFormPasswordInputWithConfirmationVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormPasswordInputWithConfirmationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormPasswordInputWithConfirmationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormPasswordInputWithConfirmationWhereInput>;
};


export type QueryFormPasswordInputWithConfirmationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormPasswordInputWithConfirmationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormPasswordInputWithConfirmationWhereInput>;
};


export type QueryFormPasswordInputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormPasswordInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormPasswordInputWhereInput>;
};


export type QueryFormPasswordInputsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormPasswordInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormPasswordInputWhereInput>;
};


export type QueryFormRadioButtonArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormRadioButtonWhereUniqueInput;
};


export type QueryFormRadioButtonCollectionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormRadioButtonCollectionWhereUniqueInput;
};


export type QueryFormRadioButtonCollectionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormRadioButtonCollectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormRadioButtonCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormRadioButtonCollectionWhereInput>;
};


export type QueryFormRadioButtonCollectionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormRadioButtonCollectionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormRadioButtonCollectionWhereInput>;
};


export type QueryFormRadioButtonVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormRadioButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormRadioButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormRadioButtonWhereInput>;
};


export type QueryFormRadioButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormRadioButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormRadioButtonWhereInput>;
};


export type QueryFormSelectComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormSelectComponentWhereUniqueInput;
};


export type QueryFormSelectComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormSelectComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormSelectComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormSelectComponentWhereInput>;
};


export type QueryFormSelectComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormSelectComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormSelectComponentWhereInput>;
};


export type QueryFormSelectOptionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormSelectOptionWhereUniqueInput;
};


export type QueryFormSelectOptionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormSelectOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormSelectOptionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormSelectOptionWhereInput>;
};


export type QueryFormSelectOptionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormSelectOptionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormSelectOptionWhereInput>;
};


export type QueryFormSubmitButtonArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormSubmitButtonWhereUniqueInput;
};


export type QueryFormSubmitButtonVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormSubmitButtonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormSubmitButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormSubmitButtonWhereInput>;
};


export type QueryFormSubmitButtonsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormSubmitButtonOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormSubmitButtonWhereInput>;
};


export type QueryFormSuccessComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormSuccessComponentWhereUniqueInput;
};


export type QueryFormSuccessComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormSuccessComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormSuccessComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormSuccessComponentWhereInput>;
};


export type QueryFormSuccessComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormSuccessComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormSuccessComponentWhereInput>;
};


export type QueryFormTextInputArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormTextInputWhereUniqueInput;
};


export type QueryFormTextInputVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormTextInputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormTextInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormTextInputWhereInput>;
};


export type QueryFormTextInputsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormTextInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormTextInputWhereInput>;
};


export type QueryFormTextareaInputArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: FormTextareaInputWhereUniqueInput;
};


export type QueryFormTextareaInputVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormTextareaInputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormTextareaInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormTextareaInputWhereInput>;
};


export type QueryFormTextareaInputsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormTextareaInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormTextareaInputWhereInput>;
};


export type QueryFormVersionArgs = {
  where: VersionWhereInput;
};


export type QueryFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormWhereInput>;
};


export type QueryFormsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<FormOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<FormWhereInput>;
};


export type QueryGenericAccordionArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericAccordionWhereUniqueInput;
};


export type QueryGenericAccordionItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericAccordionItemWhereUniqueInput;
};


export type QueryGenericAccordionItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericAccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericAccordionItemWhereInput>;
};


export type QueryGenericAccordionItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericAccordionItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericAccordionItemWhereInput>;
};


export type QueryGenericAccordionTopRatedArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericAccordionTopRatedWhereUniqueInput;
};


export type QueryGenericAccordionTopRatedVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericAccordionTopRatedsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericAccordionTopRatedOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericAccordionTopRatedWhereInput>;
};


export type QueryGenericAccordionTopRatedsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericAccordionTopRatedOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericAccordionTopRatedWhereInput>;
};


export type QueryGenericAccordionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericAccordionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericAccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericAccordionWhereInput>;
};


export type QueryGenericAccordionsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericAccordionOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericAccordionWhereInput>;
};


export type QueryGenericCardCarouseComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericCardCarouseComponentWhereUniqueInput;
};


export type QueryGenericCardCarouseComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericCardCarouseComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericCardCarouseComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericCardCarouseComponentWhereInput>;
};


export type QueryGenericCardCarouseComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericCardCarouseComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericCardCarouseComponentWhereInput>;
};


export type QueryGenericDownloadComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericDownloadComponentWhereUniqueInput;
};


export type QueryGenericDownloadComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericDownloadComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericDownloadComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericDownloadComponentWhereInput>;
};


export type QueryGenericDownloadComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericDownloadComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericDownloadComponentWhereInput>;
};


export type QueryGenericFollowUsArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericFollowUsWhereUniqueInput;
};


export type QueryGenericFollowUsVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericFollowUsesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericFollowUsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericFollowUsWhereInput>;
};


export type QueryGenericFollowUsesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericFollowUsOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericFollowUsWhereInput>;
};


export type QueryGenericGridAuthorableArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericGridAuthorableWhereUniqueInput;
};


export type QueryGenericGridAuthorableVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericGridAuthorablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericGridAuthorableOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericGridAuthorableWhereInput>;
};


export type QueryGenericGridAuthorablesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericGridAuthorableOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericGridAuthorableWhereInput>;
};


export type QueryGenericLineArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericLineWhereUniqueInput;
};


export type QueryGenericLineVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericLinesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericLineOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericLineWhereInput>;
};


export type QueryGenericLinesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericLineOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericLineWhereInput>;
};


export type QueryGenericLinkArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericLinkWhereUniqueInput;
};


export type QueryGenericLinkVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericLinkWhereInput>;
};


export type QueryGenericLinksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericLinkWhereInput>;
};


export type QueryGenericPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GenericPageWhereUniqueInput;
};


export type QueryGenericPageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type QueryGenericPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GenericPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type QueryGlobalMetaDataArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: GlobalMetaDataWhereUniqueInput;
};


export type QueryGlobalMetaDataVersionArgs = {
  where: VersionWhereInput;
};


export type QueryGlobalMetaDatasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GlobalMetaDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GlobalMetaDataWhereInput>;
};


export type QueryGlobalMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<GlobalMetaDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<GlobalMetaDataWhereInput>;
};


export type QueryHeroBannerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: HeroBannerWhereUniqueInput;
};


export type QueryHeroBannerVersionArgs = {
  where: VersionWhereInput;
};


export type QueryHeroBannersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeroBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HeroBannerWhereInput>;
};


export type QueryHeroBannersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeroBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HeroBannerWhereInput>;
};


export type QueryHeroCarouselComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: HeroCarouselComponentWhereUniqueInput;
};


export type QueryHeroCarouselComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryHeroCarouselComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeroCarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HeroCarouselComponentWhereInput>;
};


export type QueryHeroCarouselComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeroCarouselComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HeroCarouselComponentWhereInput>;
};


export type QueryHeroComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: HeroComponentWhereUniqueInput;
};


export type QueryHeroComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryHeroComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeroComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HeroComponentWhereInput>;
};


export type QueryHeroComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HeroComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HeroComponentWhereInput>;
};


export type QueryHomePageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: HomePageWhereUniqueInput;
};


export type QueryHomePageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryHomePagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HomePageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HomePageWhereInput>;
};


export type QueryHomePagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<HomePageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<HomePageWhereInput>;
};


export type QueryIframeArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: IframeWhereUniqueInput;
};


export type QueryIframeVersionArgs = {
  where: VersionWhereInput;
};


export type QueryIframesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<IframeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<IframeWhereInput>;
};


export type QueryIframesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<IframeOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<IframeWhereInput>;
};


export type QueryImageAndTextCardArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ImageAndTextCardWhereUniqueInput;
};


export type QueryImageAndTextCardVersionArgs = {
  where: VersionWhereInput;
};


export type QueryImageAndTextCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ImageAndTextCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ImageAndTextCardWhereInput>;
};


export type QueryImageAndTextCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ImageAndTextCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ImageAndTextCardWhereInput>;
};


export type QueryImageCopiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ImageCopyOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ImageCopyWhereInput>;
};


export type QueryImageCopiesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ImageCopyOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ImageCopyWhereInput>;
};


export type QueryImageCopyArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ImageCopyWhereUniqueInput;
};


export type QueryImageCopyItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ImageCopyItemWhereUniqueInput;
};


export type QueryImageCopyItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryImageCopyItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ImageCopyItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ImageCopyItemWhereInput>;
};


export type QueryImageCopyItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ImageCopyItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ImageCopyItemWhereInput>;
};


export type QueryImageCopyVersionArgs = {
  where: VersionWhereInput;
};


export type QueryIntroTextArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: IntroTextWhereUniqueInput;
};


export type QueryIntroTextVersionArgs = {
  where: VersionWhereInput;
};


export type QueryIntroTextsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<IntroTextOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<IntroTextWhereInput>;
};


export type QueryIntroTextsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<IntroTextOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<IntroTextWhereInput>;
};


export type QueryLeftColumnArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: LeftColumnWhereUniqueInput;
};


export type QueryLeftColumnVersionArgs = {
  where: VersionWhereInput;
};


export type QueryLeftColumnsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LeftColumnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LeftColumnWhereInput>;
};


export type QueryLeftColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LeftColumnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LeftColumnWhereInput>;
};


export type QueryLinkArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: LinkWhereUniqueInput;
};


export type QueryLinkVersionArgs = {
  where: VersionWhereInput;
};


export type QueryLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LinkWhereInput>;
};


export type QueryLinksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LinkWhereInput>;
};


export type QueryLocationComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: LocationComponentWhereUniqueInput;
};


export type QueryLocationComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryLocationComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LocationComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LocationComponentWhereInput>;
};


export type QueryLocationComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LocationComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LocationComponentWhereInput>;
};


export type QueryLocationItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: LocationItemWhereUniqueInput;
};


export type QueryLocationItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryLocationItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LocationItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LocationItemWhereInput>;
};


export type QueryLocationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LocationItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LocationItemWhereInput>;
};


export type QueryLongTextArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: LongTextWhereUniqueInput;
};


export type QueryLongTextVersionArgs = {
  where: VersionWhereInput;
};


export type QueryLongTextsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LongTextOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LongTextWhereInput>;
};


export type QueryLongTextsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<LongTextOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<LongTextWhereInput>;
};


export type QueryMediaLibrariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MediaLibraryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MediaLibraryWhereInput>;
};


export type QueryMediaLibrariesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MediaLibraryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MediaLibraryWhereInput>;
};


export type QueryMediaLibraryArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: MediaLibraryWhereUniqueInput;
};


export type QueryMediaLibraryItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: MediaLibraryItemWhereUniqueInput;
};


export type QueryMediaLibraryItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryMediaLibraryItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MediaLibraryItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MediaLibraryItemWhereInput>;
};


export type QueryMediaLibraryItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MediaLibraryItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MediaLibraryItemWhereInput>;
};


export type QueryMediaLibraryVersionArgs = {
  where: VersionWhereInput;
};


export type QueryMetaDataArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: MetaDataWhereUniqueInput;
};


export type QueryMetaDataVersionArgs = {
  where: VersionWhereInput;
};


export type QueryMetaDatasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MetaDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MetaDataWhereInput>;
};


export type QueryMetaDatasConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MetaDataOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MetaDataWhereInput>;
};


export type QueryMobileOnlyMainNavigationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: MobileOnlyMainNavigationWhereUniqueInput;
};


export type QueryMobileOnlyMainNavigationVersionArgs = {
  where: VersionWhereInput;
};


export type QueryMobileOnlyMainNavigationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MobileOnlyMainNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MobileOnlyMainNavigationWhereInput>;
};


export type QueryMobileOnlyMainNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<MobileOnlyMainNavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<MobileOnlyMainNavigationWhereInput>;
};


export type QueryNavigationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: NavigationWhereUniqueInput;
};


export type QueryNavigationItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: NavigationItemWhereUniqueInput;
};


export type QueryNavigationItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryNavigationItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NavigationItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NavigationItemWhereInput>;
};


export type QueryNavigationItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NavigationItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NavigationItemWhereInput>;
};


export type QueryNavigationVersionArgs = {
  where: VersionWhereInput;
};


export type QueryNavigationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NavigationWhereInput>;
};


export type QueryNavigationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NavigationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NavigationWhereInput>;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
  locales?: Array<Locale>;
  stage?: Stage;
};


export type QueryNotificationBannerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: NotificationBannerWhereUniqueInput;
};


export type QueryNotificationBannerVersionArgs = {
  where: VersionWhereInput;
};


export type QueryNotificationBannersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NotificationBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NotificationBannerWhereInput>;
};


export type QueryNotificationBannersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<NotificationBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<NotificationBannerWhereInput>;
};


export type QueryPageFooterArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PageFooterWhereUniqueInput;
};


export type QueryPageFooterVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPageFootersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PageFooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PageFooterWhereInput>;
};


export type QueryPageFootersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PageFooterOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PageFooterWhereInput>;
};


export type QueryPageHeaderArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PageHeaderWhereUniqueInput;
};


export type QueryPageHeaderVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPageHeadersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PageHeaderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PageHeaderWhereInput>;
};


export type QueryPageHeadersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PageHeaderOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PageHeaderWhereInput>;
};


export type QueryPopularSearchComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PopularSearchComponentWhereUniqueInput;
};


export type QueryPopularSearchComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPopularSearchComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PopularSearchComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PopularSearchComponentWhereInput>;
};


export type QueryPopularSearchComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PopularSearchComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PopularSearchComponentWhereInput>;
};


export type QueryPressReleaseArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PressReleaseWhereUniqueInput;
};


export type QueryPressReleaseVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPressReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PressReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PressReleaseWhereInput>;
};


export type QueryPressReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PressReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PressReleaseWhereInput>;
};


export type QueryPressStoriesCardArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: PressStoriesCardWhereUniqueInput;
};


export type QueryPressStoriesCardVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPressStoriesCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PressStoriesCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PressStoriesCardWhereInput>;
};


export type QueryPressStoriesCardsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<PressStoriesCardOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<PressStoriesCardWhereInput>;
};


export type QueryProgressBarArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ProgressBarWhereUniqueInput;
};


export type QueryProgressBarVersionArgs = {
  where: VersionWhereInput;
};


export type QueryProgressBarsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProgressBarOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProgressBarWhereInput>;
};


export type QueryProgressBarsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ProgressBarOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ProgressBarWhereInput>;
};


export type QueryQuickLinkArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: QuickLinkWhereUniqueInput;
};


export type QueryQuickLinkItemArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: QuickLinkItemWhereUniqueInput;
};


export type QueryQuickLinkItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryQuickLinkItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuickLinkItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<QuickLinkItemWhereInput>;
};


export type QueryQuickLinkItemsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuickLinkItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<QuickLinkItemWhereInput>;
};


export type QueryQuickLinkVersionArgs = {
  where: VersionWhereInput;
};


export type QueryQuickLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuickLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<QuickLinkWhereInput>;
};


export type QueryQuickLinksConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<QuickLinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<QuickLinkWhereInput>;
};


export type QueryRedirectArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RedirectWhereUniqueInput;
};


export type QueryRedirectVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRedirectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RedirectOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RedirectWhereInput>;
};


export type QueryRedirectsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RedirectOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RedirectWhereInput>;
};


export type QueryRewriteArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RewriteWhereUniqueInput;
};


export type QueryRewriteVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRewritesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RewriteOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RewriteWhereInput>;
};


export type QueryRewritesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RewriteOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RewriteWhereInput>;
};


export type QueryRightColumnArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: RightColumnWhereUniqueInput;
};


export type QueryRightColumnVersionArgs = {
  where: VersionWhereInput;
};


export type QueryRightColumnsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RightColumnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RightColumnWhereInput>;
};


export type QueryRightColumnsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<RightColumnOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<RightColumnWhereInput>;
};


export type QueryScheduledOperationArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledOperationWhereUniqueInput;
};


export type QueryScheduledOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QueryScheduledOperationsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QueryScheduledReleaseArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ScheduledReleaseWhereUniqueInput;
};


export type QueryScheduledReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type QueryScheduledReleasesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ScheduledReleaseOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ScheduledReleaseWhereInput>;
};


export type QuerySearchInputArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SearchInputWhereUniqueInput;
};


export type QuerySearchInputVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySearchInputsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SearchInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SearchInputWhereInput>;
};


export type QuerySearchInputsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SearchInputOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SearchInputWhereInput>;
};


export type QuerySearchOverlayComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SearchOverlayComponentWhereUniqueInput;
};


export type QuerySearchOverlayComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySearchOverlayComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SearchOverlayComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SearchOverlayComponentWhereInput>;
};


export type QuerySearchOverlayComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SearchOverlayComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SearchOverlayComponentWhereInput>;
};


export type QuerySearchResultPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SearchResultPageWhereUniqueInput;
};


export type QuerySearchResultPageVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySearchResultPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SearchResultPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SearchResultPageWhereInput>;
};


export type QuerySearchResultPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SearchResultPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SearchResultPageWhereInput>;
};


export type QueryShortHeroArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: ShortHeroWhereUniqueInput;
};


export type QueryShortHeroVersionArgs = {
  where: VersionWhereInput;
};


export type QueryShortHeroesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ShortHeroOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ShortHeroWhereInput>;
};


export type QueryShortHeroesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<ShortHeroOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<ShortHeroWhereInput>;
};


export type QuerySocialMediaListComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SocialMediaListComponentWhereUniqueInput;
};


export type QuerySocialMediaListComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySocialMediaListComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SocialMediaListComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SocialMediaListComponentWhereInput>;
};


export type QuerySocialMediaListComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SocialMediaListComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SocialMediaListComponentWhereInput>;
};


export type QuerySpacerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SpacerWhereUniqueInput;
};


export type QuerySpacerVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySpacersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SpacerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SpacerWhereInput>;
};


export type QuerySpacersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SpacerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SpacerWhereInput>;
};


export type QueryStoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<StoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<StoryWhereInput>;
};


export type QueryStoriesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<StoryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<StoryWhereInput>;
};


export type QueryStoryArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: StoryWhereUniqueInput;
};


export type QueryStoryVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySubCategoryKeyImageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SubCategoryKeyImageWhereUniqueInput;
};


export type QuerySubCategoryKeyImageVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySubCategoryKeyImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SubCategoryKeyImageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SubCategoryKeyImageWhereInput>;
};


export type QuerySubCategoryKeyImagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SubCategoryKeyImageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SubCategoryKeyImageWhereInput>;
};


export type QuerySustainabilityBannerArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SustainabilityBannerWhereUniqueInput;
};


export type QuerySustainabilityBannerVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySustainabilityBannersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SustainabilityBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SustainabilityBannerWhereInput>;
};


export type QuerySustainabilityBannersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SustainabilityBannerOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SustainabilityBannerWhereInput>;
};


export type QuerySustainabilityInfoArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: SustainabilityInfoWhereUniqueInput;
};


export type QuerySustainabilityInfoVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySustainabilityInfosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SustainabilityInfoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SustainabilityInfoWhereInput>;
};


export type QuerySustainabilityInfosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<SustainabilityInfoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<SustainabilityInfoWhereInput>;
};


export type QueryTabArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TabWhereUniqueInput;
};


export type QueryTabContentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TabContentWhereUniqueInput;
};


export type QueryTabContentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTabContentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TabContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TabContentWhereInput>;
};


export type QueryTabContentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TabContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TabContentWhereInput>;
};


export type QueryTabVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTabsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TabOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TabWhereInput>;
};


export type QueryTabsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TabOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TabWhereInput>;
};


export type QueryTestTipsANdTricksInAMarketArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};


export type QueryTestTipsANdTricksInAMarketVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTestTipsANdTricksInAMarketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TestTipsANdTricksInAMarketOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TestTipsANdTricksInAMarketWhereInput>;
};


export type QueryTestTipsANdTricksInAMarketsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TestTipsANdTricksInAMarketOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TestTipsANdTricksInAMarketWhereInput>;
};


export type QueryTextComponentArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TextComponentWhereUniqueInput;
};


export type QueryTextComponentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTextComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TextComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TextComponentWhereInput>;
};


export type QueryTextComponentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TextComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TextComponentWhereInput>;
};


export type QueryTipsAndTricksDetailsPageArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};


export type QueryTipsAndTricksDetailsPageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTipsAndTricksDetailsPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TipsAndTricksDetailsPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TipsAndTricksDetailsPageWhereInput>;
};


export type QueryTipsAndTricksDetailsPagesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TipsAndTricksDetailsPageOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TipsAndTricksDetailsPageWhereInput>;
};


export type QueryTitleArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TitleWhereUniqueInput;
};


export type QueryTitleVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTitlesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TitleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TitleWhereInput>;
};


export type QueryTitlesConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TitleOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TitleWhereInput>;
};


export type QueryTwitterSeoArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: TwitterSeoWhereUniqueInput;
};


export type QueryTwitterSeoVersionArgs = {
  where: VersionWhereInput;
};


export type QueryTwitterSeosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TwitterSeoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TwitterSeoWhereInput>;
};


export type QueryTwitterSeosConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<TwitterSeoOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<TwitterSeoWhereInput>;
};


export type QueryUserArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryUsersConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<UserOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryWidgetArgs = {
  locales?: Array<Locale>;
  stage?: Stage;
  where: WidgetWhereUniqueInput;
};


export type QueryWidgetVersionArgs = {
  where: VersionWhereInput;
};


export type QueryWidgetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<WidgetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<WidgetWhereInput>;
};


export type QueryWidgetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: Array<Locale>;
  orderBy?: InputMaybe<WidgetOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  stage?: Stage;
  where?: InputMaybe<WidgetWhereInput>;
};

export type QuickLink = Entity & Node & {
  __typename?: 'QuickLink';
  anchorNav?: Maybe<AnchorNavigation>;
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<QuickLink>;
  genericAccordionItems: Array<CorpGenericAccordionItem>;
  genericPages: Array<GenericPage>;
  headline?: Maybe<Scalars['String']['output']>;
  /** List of QuickLink versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<QuickLink>;
  locationItem?: Maybe<LocationItem>;
  mediaLibrary?: Maybe<MediaLibrary>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  quickLinkItems: Array<QuickLinkItem>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type QuickLinkAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuickLinkCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type QuickLinkCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuickLinkDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type QuickLinkGenericAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericAccordionItemWhereInput>;
};


export type QuickLinkGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type QuickLinkHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type QuickLinkLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type QuickLinkLocationItemArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuickLinkMediaLibraryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuickLinkPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type QuickLinkPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuickLinkQuickLinkItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<QuickLinkItemOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuickLinkItemWhereInput>;
};


export type QuickLinkScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QuickLinkStoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


export type QuickLinkTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuickLinkUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type QuickLinkUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type QuickLinkConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: QuickLinkWhereUniqueInput;
};

/** A connection to a list of items. */
export type QuickLinkConnection = {
  __typename?: 'QuickLinkConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<QuickLinkEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type QuickLinkCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  /** headline input for default locale (default) */
  headline?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<QuickLinkCreateLocalizationsInput>;
  locationItem?: InputMaybe<LocationItemCreateOneInlineInput>;
  mediaLibrary?: InputMaybe<MediaLibraryCreateOneInlineInput>;
  quickLinkItems?: InputMaybe<QuickLinkItemCreateManyInlineInput>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuickLinkCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuickLinkCreateLocalizationInput = {
  /** Localization input */
  data: QuickLinkCreateLocalizationDataInput;
  locale: Locale;
};

export type QuickLinkCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<QuickLinkCreateLocalizationInput>>;
};

export type QuickLinkCreateManyInlineInput = {
  /** Connect multiple existing QuickLink documents */
  connect?: InputMaybe<Array<QuickLinkWhereUniqueInput>>;
  /** Create and connect multiple existing QuickLink documents */
  create?: InputMaybe<Array<QuickLinkCreateInput>>;
};

export type QuickLinkCreateOneInlineInput = {
  /** Connect one existing QuickLink document */
  connect?: InputMaybe<QuickLinkWhereUniqueInput>;
  /** Create and connect one QuickLink document */
  create?: InputMaybe<QuickLinkCreateInput>;
};

/** An edge in a connection. */
export type QuickLinkEdge = {
  __typename?: 'QuickLinkEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: QuickLink;
};

export type QuickLinkItem = Entity & Node & {
  __typename?: 'QuickLinkItem';
  buttonHeadline: Scalars['String']['output'];
  buttonSubheadline?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<QuickLinkItem>;
  /** List of QuickLinkItem versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<QuickLinkItem>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type QuickLinkItemCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type QuickLinkItemCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuickLinkItemDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type QuickLinkItemHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type QuickLinkItemLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuickLinkItemLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type QuickLinkItemPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type QuickLinkItemPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type QuickLinkItemScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type QuickLinkItemUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type QuickLinkItemUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type QuickLinkItemConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: QuickLinkItemWhereUniqueInput;
};

/** A connection to a list of items. */
export type QuickLinkItemConnection = {
  __typename?: 'QuickLinkItemConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<QuickLinkItemEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type QuickLinkItemCreateInput = {
  /** buttonHeadline input for default locale (default) */
  buttonHeadline: Scalars['String']['input'];
  /** buttonSubheadline input for default locale (default) */
  buttonSubheadline?: InputMaybe<Scalars['String']['input']>;
  cl0z69bg34pc901xv9s8q41ur?: InputMaybe<QuickLinkCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<QuickLinkItemCreateLocalizationsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuickLinkItemCreateLocalizationDataInput = {
  buttonHeadline: Scalars['String']['input'];
  buttonSubheadline?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QuickLinkItemCreateLocalizationInput = {
  /** Localization input */
  data: QuickLinkItemCreateLocalizationDataInput;
  locale: Locale;
};

export type QuickLinkItemCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<QuickLinkItemCreateLocalizationInput>>;
};

export type QuickLinkItemCreateManyInlineInput = {
  /** Connect multiple existing QuickLinkItem documents */
  connect?: InputMaybe<Array<QuickLinkItemWhereUniqueInput>>;
  /** Create and connect multiple existing QuickLinkItem documents */
  create?: InputMaybe<Array<QuickLinkItemCreateInput>>;
};

export type QuickLinkItemCreateOneInlineInput = {
  /** Connect one existing QuickLinkItem document */
  connect?: InputMaybe<QuickLinkItemWhereUniqueInput>;
  /** Create and connect one QuickLinkItem document */
  create?: InputMaybe<QuickLinkItemCreateInput>;
};

/** An edge in a connection. */
export type QuickLinkItemEdge = {
  __typename?: 'QuickLinkItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: QuickLinkItem;
};

/** Identifies documents */
export type QuickLinkItemManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuickLinkItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuickLinkItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuickLinkItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuickLinkItemWhereStageInput>;
  documentInStages_none?: InputMaybe<QuickLinkItemWhereStageInput>;
  documentInStages_some?: InputMaybe<QuickLinkItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum QuickLinkItemOrderByInput {
  buttonHeadline_ASC = 'buttonHeadline_ASC',
  buttonHeadline_DESC = 'buttonHeadline_DESC',
  buttonSubheadline_ASC = 'buttonSubheadline_ASC',
  buttonSubheadline_DESC = 'buttonSubheadline_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type QuickLinkItemUpdateInput = {
  /** buttonHeadline input for default locale (default) */
  buttonHeadline?: InputMaybe<Scalars['String']['input']>;
  /** buttonSubheadline input for default locale (default) */
  buttonSubheadline?: InputMaybe<Scalars['String']['input']>;
  cl0z69bg34pc901xv9s8q41ur?: InputMaybe<QuickLinkUpdateManyInlineInput>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<QuickLinkItemUpdateLocalizationsInput>;
};

export type QuickLinkItemUpdateLocalizationDataInput = {
  buttonHeadline?: InputMaybe<Scalars['String']['input']>;
  buttonSubheadline?: InputMaybe<Scalars['String']['input']>;
};

export type QuickLinkItemUpdateLocalizationInput = {
  data: QuickLinkItemUpdateLocalizationDataInput;
  locale: Locale;
};

export type QuickLinkItemUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<QuickLinkItemCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<QuickLinkItemUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<QuickLinkItemUpsertLocalizationInput>>;
};

export type QuickLinkItemUpdateManyInlineInput = {
  /** Connect multiple existing QuickLinkItem documents */
  connect?: InputMaybe<Array<QuickLinkItemConnectInput>>;
  /** Create and connect multiple QuickLinkItem documents */
  create?: InputMaybe<Array<QuickLinkItemCreateInput>>;
  /** Delete multiple QuickLinkItem documents */
  delete?: InputMaybe<Array<QuickLinkItemWhereUniqueInput>>;
  /** Disconnect multiple QuickLinkItem documents */
  disconnect?: InputMaybe<Array<QuickLinkItemWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing QuickLinkItem documents */
  set?: InputMaybe<Array<QuickLinkItemWhereUniqueInput>>;
  /** Update multiple QuickLinkItem documents */
  update?: InputMaybe<Array<QuickLinkItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple QuickLinkItem documents */
  upsert?: InputMaybe<Array<QuickLinkItemUpsertWithNestedWhereUniqueInput>>;
};

export type QuickLinkItemUpdateManyInput = {
  /** buttonHeadline input for default locale (default) */
  buttonHeadline?: InputMaybe<Scalars['String']['input']>;
  /** buttonSubheadline input for default locale (default) */
  buttonSubheadline?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<QuickLinkItemUpdateManyLocalizationsInput>;
};

export type QuickLinkItemUpdateManyLocalizationDataInput = {
  buttonHeadline?: InputMaybe<Scalars['String']['input']>;
  buttonSubheadline?: InputMaybe<Scalars['String']['input']>;
};

export type QuickLinkItemUpdateManyLocalizationInput = {
  data: QuickLinkItemUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type QuickLinkItemUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<QuickLinkItemUpdateManyLocalizationInput>>;
};

export type QuickLinkItemUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: QuickLinkItemUpdateManyInput;
  /** Document search */
  where: QuickLinkItemWhereInput;
};

export type QuickLinkItemUpdateOneInlineInput = {
  /** Connect existing QuickLinkItem document */
  connect?: InputMaybe<QuickLinkItemWhereUniqueInput>;
  /** Create and connect one QuickLinkItem document */
  create?: InputMaybe<QuickLinkItemCreateInput>;
  /** Delete currently connected QuickLinkItem document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected QuickLinkItem document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single QuickLinkItem document */
  update?: InputMaybe<QuickLinkItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single QuickLinkItem document */
  upsert?: InputMaybe<QuickLinkItemUpsertWithNestedWhereUniqueInput>;
};

export type QuickLinkItemUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: QuickLinkItemUpdateInput;
  /** Unique document search */
  where: QuickLinkItemWhereUniqueInput;
};

export type QuickLinkItemUpsertInput = {
  /** Create document if it didn't exist */
  create: QuickLinkItemCreateInput;
  /** Update document if it exists */
  update: QuickLinkItemUpdateInput;
};

export type QuickLinkItemUpsertLocalizationInput = {
  create: QuickLinkItemCreateLocalizationDataInput;
  locale: Locale;
  update: QuickLinkItemUpdateLocalizationDataInput;
};

export type QuickLinkItemUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: QuickLinkItemUpsertInput;
  /** Unique document search */
  where: QuickLinkItemWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type QuickLinkItemWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type QuickLinkItemWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuickLinkItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuickLinkItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuickLinkItemWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  buttonHeadline?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  buttonHeadline_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  buttonHeadline_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  buttonHeadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonHeadline_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  buttonHeadline_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  buttonHeadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  buttonHeadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  buttonHeadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  buttonHeadline_starts_with?: InputMaybe<Scalars['String']['input']>;
  buttonSubheadline?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  buttonSubheadline_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  buttonSubheadline_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  buttonSubheadline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  buttonSubheadline_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  buttonSubheadline_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  buttonSubheadline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  buttonSubheadline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  buttonSubheadline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  buttonSubheadline_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuickLinkItemWhereStageInput>;
  documentInStages_none?: InputMaybe<QuickLinkItemWhereStageInput>;
  documentInStages_some?: InputMaybe<QuickLinkItemWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type QuickLinkItemWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuickLinkItemWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuickLinkItemWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuickLinkItemWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<QuickLinkItemWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References QuickLinkItem record uniquely */
export type QuickLinkItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Identifies documents */
export type QuickLinkManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuickLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuickLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuickLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuickLinkWhereStageInput>;
  documentInStages_none?: InputMaybe<QuickLinkWhereStageInput>;
  documentInStages_some?: InputMaybe<QuickLinkWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  locationItem?: InputMaybe<LocationItemWhereInput>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  quickLinkItems_every?: InputMaybe<QuickLinkItemWhereInput>;
  quickLinkItems_none?: InputMaybe<QuickLinkItemWhereInput>;
  quickLinkItems_some?: InputMaybe<QuickLinkItemWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum QuickLinkOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  headline_ASC = 'headline_ASC',
  headline_DESC = 'headline_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type QuickLinkUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  /** headline input for default locale (default) */
  headline?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<QuickLinkUpdateLocalizationsInput>;
  locationItem?: InputMaybe<LocationItemUpdateOneInlineInput>;
  mediaLibrary?: InputMaybe<MediaLibraryUpdateOneInlineInput>;
  quickLinkItems?: InputMaybe<QuickLinkItemUpdateManyInlineInput>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
};

export type QuickLinkUpdateLocalizationDataInput = {
  headline?: InputMaybe<Scalars['String']['input']>;
};

export type QuickLinkUpdateLocalizationInput = {
  data: QuickLinkUpdateLocalizationDataInput;
  locale: Locale;
};

export type QuickLinkUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<QuickLinkCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<QuickLinkUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<QuickLinkUpsertLocalizationInput>>;
};

export type QuickLinkUpdateManyInlineInput = {
  /** Connect multiple existing QuickLink documents */
  connect?: InputMaybe<Array<QuickLinkConnectInput>>;
  /** Create and connect multiple QuickLink documents */
  create?: InputMaybe<Array<QuickLinkCreateInput>>;
  /** Delete multiple QuickLink documents */
  delete?: InputMaybe<Array<QuickLinkWhereUniqueInput>>;
  /** Disconnect multiple QuickLink documents */
  disconnect?: InputMaybe<Array<QuickLinkWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing QuickLink documents */
  set?: InputMaybe<Array<QuickLinkWhereUniqueInput>>;
  /** Update multiple QuickLink documents */
  update?: InputMaybe<Array<QuickLinkUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple QuickLink documents */
  upsert?: InputMaybe<Array<QuickLinkUpsertWithNestedWhereUniqueInput>>;
};

export type QuickLinkUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** headline input for default locale (default) */
  headline?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<QuickLinkUpdateManyLocalizationsInput>;
};

export type QuickLinkUpdateManyLocalizationDataInput = {
  headline?: InputMaybe<Scalars['String']['input']>;
};

export type QuickLinkUpdateManyLocalizationInput = {
  data: QuickLinkUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type QuickLinkUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<QuickLinkUpdateManyLocalizationInput>>;
};

export type QuickLinkUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: QuickLinkUpdateManyInput;
  /** Document search */
  where: QuickLinkWhereInput;
};

export type QuickLinkUpdateOneInlineInput = {
  /** Connect existing QuickLink document */
  connect?: InputMaybe<QuickLinkWhereUniqueInput>;
  /** Create and connect one QuickLink document */
  create?: InputMaybe<QuickLinkCreateInput>;
  /** Delete currently connected QuickLink document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected QuickLink document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single QuickLink document */
  update?: InputMaybe<QuickLinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single QuickLink document */
  upsert?: InputMaybe<QuickLinkUpsertWithNestedWhereUniqueInput>;
};

export type QuickLinkUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: QuickLinkUpdateInput;
  /** Unique document search */
  where: QuickLinkWhereUniqueInput;
};

export type QuickLinkUpsertInput = {
  /** Create document if it didn't exist */
  create: QuickLinkCreateInput;
  /** Update document if it exists */
  update: QuickLinkUpdateInput;
};

export type QuickLinkUpsertLocalizationInput = {
  create: QuickLinkCreateLocalizationDataInput;
  locale: Locale;
  update: QuickLinkUpdateLocalizationDataInput;
};

export type QuickLinkUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: QuickLinkUpsertInput;
  /** Unique document search */
  where: QuickLinkWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type QuickLinkWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type QuickLinkWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuickLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuickLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuickLinkWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<QuickLinkWhereStageInput>;
  documentInStages_none?: InputMaybe<QuickLinkWhereStageInput>;
  documentInStages_some?: InputMaybe<QuickLinkWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  headline?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  headline_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  headline_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  headline_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  headline_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  headline_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  headline_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  headline_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  headline_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  headline_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  locationItem?: InputMaybe<LocationItemWhereInput>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  quickLinkItems_every?: InputMaybe<QuickLinkItemWhereInput>;
  quickLinkItems_none?: InputMaybe<QuickLinkItemWhereInput>;
  quickLinkItems_some?: InputMaybe<QuickLinkItemWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type QuickLinkWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<QuickLinkWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<QuickLinkWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<QuickLinkWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<QuickLinkWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References QuickLink record uniquely */
export type QuickLinkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type Rgba = {
  __typename?: 'RGBA';
  a: Scalars['RGBATransparency']['output'];
  b: Scalars['RGBAHue']['output'];
  g: Scalars['RGBAHue']['output'];
  r: Scalars['RGBAHue']['output'];
};

/** Input type representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type RgbaInput = {
  a: Scalars['RGBATransparency']['input'];
  b: Scalars['RGBAHue']['input'];
  g: Scalars['RGBAHue']['input'];
  r: Scalars['RGBAHue']['input'];
};

export type Redirect = Entity & Node & {
  __typename?: 'Redirect';
  anchorNav?: Maybe<AnchorNavigation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Redirect>;
  /** List of Redirect versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** String that can be used to find the component in the CMS */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** The old URL eg. /recipes/apfel-kuchen */
  urlFrom?: Maybe<Scalars['String']['output']>;
  /** The new URL eg. /recipes/neu-apfel-kuchen */
  urlTo?: Maybe<Scalars['String']['output']>;
};


export type RedirectAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RedirectCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RedirectDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type RedirectHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type RedirectPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RedirectScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type RedirectUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RedirectConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RedirectWhereUniqueInput;
};

/** A connection to a list of items. */
export type RedirectConnection = {
  __typename?: 'RedirectConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RedirectEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RedirectCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  urlFrom?: InputMaybe<Scalars['String']['input']>;
  urlTo?: InputMaybe<Scalars['String']['input']>;
};

export type RedirectCreateManyInlineInput = {
  /** Connect multiple existing Redirect documents */
  connect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  /** Create and connect multiple existing Redirect documents */
  create?: InputMaybe<Array<RedirectCreateInput>>;
};

export type RedirectCreateOneInlineInput = {
  /** Connect one existing Redirect document */
  connect?: InputMaybe<RedirectWhereUniqueInput>;
  /** Create and connect one Redirect document */
  create?: InputMaybe<RedirectCreateInput>;
};

/** An edge in a connection. */
export type RedirectEdge = {
  __typename?: 'RedirectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Redirect;
};

/** Identifies documents */
export type RedirectManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RedirectWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RedirectWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RedirectWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RedirectWhereStageInput>;
  documentInStages_none?: InputMaybe<RedirectWhereStageInput>;
  documentInStages_some?: InputMaybe<RedirectWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  urlFrom?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  urlFrom_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  urlFrom_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  urlFrom_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  urlFrom_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  urlFrom_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  urlFrom_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  urlFrom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  urlFrom_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  urlFrom_starts_with?: InputMaybe<Scalars['String']['input']>;
  urlTo?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  urlTo_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  urlTo_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  urlTo_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  urlTo_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  urlTo_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  urlTo_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  urlTo_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  urlTo_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  urlTo_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum RedirectOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  urlFrom_ASC = 'urlFrom_ASC',
  urlFrom_DESC = 'urlFrom_DESC',
  urlTo_ASC = 'urlTo_ASC',
  urlTo_DESC = 'urlTo_DESC'
}

export type RedirectUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  urlFrom?: InputMaybe<Scalars['String']['input']>;
  urlTo?: InputMaybe<Scalars['String']['input']>;
};

export type RedirectUpdateManyInlineInput = {
  /** Connect multiple existing Redirect documents */
  connect?: InputMaybe<Array<RedirectConnectInput>>;
  /** Create and connect multiple Redirect documents */
  create?: InputMaybe<Array<RedirectCreateInput>>;
  /** Delete multiple Redirect documents */
  delete?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  /** Disconnect multiple Redirect documents */
  disconnect?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Redirect documents */
  set?: InputMaybe<Array<RedirectWhereUniqueInput>>;
  /** Update multiple Redirect documents */
  update?: InputMaybe<Array<RedirectUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Redirect documents */
  upsert?: InputMaybe<Array<RedirectUpsertWithNestedWhereUniqueInput>>;
};

export type RedirectUpdateManyInput = {
  title?: InputMaybe<Scalars['String']['input']>;
  urlFrom?: InputMaybe<Scalars['String']['input']>;
  urlTo?: InputMaybe<Scalars['String']['input']>;
};

export type RedirectUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RedirectUpdateManyInput;
  /** Document search */
  where: RedirectWhereInput;
};

export type RedirectUpdateOneInlineInput = {
  /** Connect existing Redirect document */
  connect?: InputMaybe<RedirectWhereUniqueInput>;
  /** Create and connect one Redirect document */
  create?: InputMaybe<RedirectCreateInput>;
  /** Delete currently connected Redirect document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Redirect document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Redirect document */
  update?: InputMaybe<RedirectUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Redirect document */
  upsert?: InputMaybe<RedirectUpsertWithNestedWhereUniqueInput>;
};

export type RedirectUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RedirectUpdateInput;
  /** Unique document search */
  where: RedirectWhereUniqueInput;
};

export type RedirectUpsertInput = {
  /** Create document if it didn't exist */
  create: RedirectCreateInput;
  /** Update document if it exists */
  update: RedirectUpdateInput;
};

export type RedirectUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RedirectUpsertInput;
  /** Unique document search */
  where: RedirectWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RedirectWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RedirectWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RedirectWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RedirectWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RedirectWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RedirectWhereStageInput>;
  documentInStages_none?: InputMaybe<RedirectWhereStageInput>;
  documentInStages_some?: InputMaybe<RedirectWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  urlFrom?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  urlFrom_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  urlFrom_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  urlFrom_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  urlFrom_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  urlFrom_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  urlFrom_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  urlFrom_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  urlFrom_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  urlFrom_starts_with?: InputMaybe<Scalars['String']['input']>;
  urlTo?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  urlTo_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  urlTo_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  urlTo_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  urlTo_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  urlTo_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  urlTo_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  urlTo_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  urlTo_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  urlTo_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RedirectWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RedirectWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RedirectWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RedirectWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RedirectWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Redirect record uniquely */
export type RedirectWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Rewrite = Entity & Node & {
  __typename?: 'Rewrite';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  destination: Scalars['String']['output'];
  /** Get the document in other stages */
  documentInStages: Array<Rewrite>;
  /** List of Rewrite versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Rewrite>;
  page: RewriteTypes;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** if set to true, make sure both source and destination have /{locale} in them at the beginning  */
  showLocale: Scalars['Boolean']['output'];
  source: Scalars['String']['output'];
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type RewriteCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type RewriteCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RewriteDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type RewriteHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type RewriteLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type RewritePublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type RewritePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RewriteScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type RewriteUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type RewriteUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RewriteConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RewriteWhereUniqueInput;
};

/** A connection to a list of items. */
export type RewriteConnection = {
  __typename?: 'RewriteConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RewriteEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RewriteCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** destination input for default locale (default) */
  destination: Scalars['String']['input'];
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<RewriteCreateLocalizationsInput>;
  page: RewriteTypes;
  /** showLocale input for default locale (default) */
  showLocale: Scalars['Boolean']['input'];
  /** source input for default locale (default) */
  source: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RewriteCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  destination: Scalars['String']['input'];
  showLocale: Scalars['Boolean']['input'];
  source: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type RewriteCreateLocalizationInput = {
  /** Localization input */
  data: RewriteCreateLocalizationDataInput;
  locale: Locale;
};

export type RewriteCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<RewriteCreateLocalizationInput>>;
};

export type RewriteCreateManyInlineInput = {
  /** Connect multiple existing Rewrite documents */
  connect?: InputMaybe<Array<RewriteWhereUniqueInput>>;
  /** Create and connect multiple existing Rewrite documents */
  create?: InputMaybe<Array<RewriteCreateInput>>;
};

export type RewriteCreateOneInlineInput = {
  /** Connect one existing Rewrite document */
  connect?: InputMaybe<RewriteWhereUniqueInput>;
  /** Create and connect one Rewrite document */
  create?: InputMaybe<RewriteCreateInput>;
};

/** An edge in a connection. */
export type RewriteEdge = {
  __typename?: 'RewriteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Rewrite;
};

/** Identifies documents */
export type RewriteManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RewriteWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RewriteWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RewriteWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RewriteWhereStageInput>;
  documentInStages_none?: InputMaybe<RewriteWhereStageInput>;
  documentInStages_some?: InputMaybe<RewriteWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<RewriteTypes>;
  /** All values that are contained in given list. */
  page_in?: InputMaybe<Array<InputMaybe<RewriteTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  page_not?: InputMaybe<RewriteTypes>;
  /** All values that are not contained in given list. */
  page_not_in?: InputMaybe<Array<InputMaybe<RewriteTypes>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum RewriteOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  destination_ASC = 'destination_ASC',
  destination_DESC = 'destination_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  page_ASC = 'page_ASC',
  page_DESC = 'page_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  showLocale_ASC = 'showLocale_ASC',
  showLocale_DESC = 'showLocale_DESC',
  source_ASC = 'source_ASC',
  source_DESC = 'source_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum RewriteTypes {
  aboutus = 'aboutus',
  careers = 'careers',
  magazine = 'magazine',
  medialibrary = 'medialibrary',
  press = 'press',
  responsibility = 'responsibility',
  suppliers = 'suppliers'
}

export type RewriteUpdateInput = {
  /** destination input for default locale (default) */
  destination?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<RewriteUpdateLocalizationsInput>;
  page?: InputMaybe<RewriteTypes>;
  /** showLocale input for default locale (default) */
  showLocale?: InputMaybe<Scalars['Boolean']['input']>;
  /** source input for default locale (default) */
  source?: InputMaybe<Scalars['String']['input']>;
};

export type RewriteUpdateLocalizationDataInput = {
  destination?: InputMaybe<Scalars['String']['input']>;
  showLocale?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type RewriteUpdateLocalizationInput = {
  data: RewriteUpdateLocalizationDataInput;
  locale: Locale;
};

export type RewriteUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<RewriteCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<RewriteUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<RewriteUpsertLocalizationInput>>;
};

export type RewriteUpdateManyInlineInput = {
  /** Connect multiple existing Rewrite documents */
  connect?: InputMaybe<Array<RewriteConnectInput>>;
  /** Create and connect multiple Rewrite documents */
  create?: InputMaybe<Array<RewriteCreateInput>>;
  /** Delete multiple Rewrite documents */
  delete?: InputMaybe<Array<RewriteWhereUniqueInput>>;
  /** Disconnect multiple Rewrite documents */
  disconnect?: InputMaybe<Array<RewriteWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Rewrite documents */
  set?: InputMaybe<Array<RewriteWhereUniqueInput>>;
  /** Update multiple Rewrite documents */
  update?: InputMaybe<Array<RewriteUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Rewrite documents */
  upsert?: InputMaybe<Array<RewriteUpsertWithNestedWhereUniqueInput>>;
};

export type RewriteUpdateManyInput = {
  /** destination input for default locale (default) */
  destination?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<RewriteUpdateManyLocalizationsInput>;
  /** showLocale input for default locale (default) */
  showLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RewriteUpdateManyLocalizationDataInput = {
  destination?: InputMaybe<Scalars['String']['input']>;
  showLocale?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RewriteUpdateManyLocalizationInput = {
  data: RewriteUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type RewriteUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<RewriteUpdateManyLocalizationInput>>;
};

export type RewriteUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RewriteUpdateManyInput;
  /** Document search */
  where: RewriteWhereInput;
};

export type RewriteUpdateOneInlineInput = {
  /** Connect existing Rewrite document */
  connect?: InputMaybe<RewriteWhereUniqueInput>;
  /** Create and connect one Rewrite document */
  create?: InputMaybe<RewriteCreateInput>;
  /** Delete currently connected Rewrite document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Rewrite document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Rewrite document */
  update?: InputMaybe<RewriteUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Rewrite document */
  upsert?: InputMaybe<RewriteUpsertWithNestedWhereUniqueInput>;
};

export type RewriteUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RewriteUpdateInput;
  /** Unique document search */
  where: RewriteWhereUniqueInput;
};

export type RewriteUpsertInput = {
  /** Create document if it didn't exist */
  create: RewriteCreateInput;
  /** Update document if it exists */
  update: RewriteUpdateInput;
};

export type RewriteUpsertLocalizationInput = {
  create: RewriteCreateLocalizationDataInput;
  locale: Locale;
  update: RewriteUpdateLocalizationDataInput;
};

export type RewriteUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RewriteUpsertInput;
  /** Unique document search */
  where: RewriteWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RewriteWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RewriteWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RewriteWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RewriteWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RewriteWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  destination?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  destination_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  destination_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  destination_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  destination_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  destination_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  destination_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  destination_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  destination_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  destination_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<RewriteWhereStageInput>;
  documentInStages_none?: InputMaybe<RewriteWhereStageInput>;
  documentInStages_some?: InputMaybe<RewriteWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<RewriteTypes>;
  /** All values that are contained in given list. */
  page_in?: InputMaybe<Array<InputMaybe<RewriteTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  page_not?: InputMaybe<RewriteTypes>;
  /** All values that are not contained in given list. */
  page_not_in?: InputMaybe<Array<InputMaybe<RewriteTypes>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showLocale?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showLocale_not?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  source_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  source_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  source_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  source_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  source_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  source_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  source_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  source_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  source_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RewriteWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RewriteWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RewriteWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RewriteWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RewriteWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Rewrite record uniquely */
export type RewriteWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<RewriteTypes>;
};

/** Custom type representing a rich text value comprising of raw rich text ast, html, markdown and text values */
export type RichText = {
  __typename?: 'RichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** Returns AST representation */
  raw: Scalars['RichTextAST']['output'];
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};

export type RightColumn = Entity & Node & {
  __typename?: 'RightColumn';
  assetsComponents: Array<AssetComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Right column rich text */
  description?: Maybe<RightColumnDescriptionRichText>;
  /** Get the document in other stages */
  documentInStages: Array<RightColumn>;
  /** List of RightColumn versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Right column title to the rich text */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** Video url for right column of ImageCopy component */
  video?: Maybe<Scalars['String']['output']>;
};


export type RightColumnAssetsComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentWhereInput>;
};


export type RightColumnCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RightColumnDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type RightColumnHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type RightColumnPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type RightColumnScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type RightColumnUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type RightColumnConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: RightColumnWhereUniqueInput;
};

/** A connection to a list of items. */
export type RightColumnConnection = {
  __typename?: 'RightColumnConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<RightColumnEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type RightColumnCreateInput = {
  assetsComponents?: InputMaybe<AssetComponentCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type RightColumnCreateManyInlineInput = {
  /** Connect multiple existing RightColumn documents */
  connect?: InputMaybe<Array<RightColumnWhereUniqueInput>>;
  /** Create and connect multiple existing RightColumn documents */
  create?: InputMaybe<Array<RightColumnCreateInput>>;
};

export type RightColumnCreateOneInlineInput = {
  /** Connect one existing RightColumn document */
  connect?: InputMaybe<RightColumnWhereUniqueInput>;
  /** Create and connect one RightColumn document */
  create?: InputMaybe<RightColumnCreateInput>;
};

export type RightColumnDescriptionRichText = {
  __typename?: 'RightColumnDescriptionRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<RightColumnDescriptionRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type RightColumnDescriptionRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type RightColumnDescriptionRichTextEmbeddedTypes = Asset;

/** An edge in a connection. */
export type RightColumnEdge = {
  __typename?: 'RightColumnEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RightColumn;
};

/** Identifies documents */
export type RightColumnManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RightColumnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RightColumnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RightColumnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RightColumnWhereStageInput>;
  documentInStages_none?: InputMaybe<RightColumnWhereStageInput>;
  documentInStages_some?: InputMaybe<RightColumnWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  video_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  video_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  video_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  video_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  video_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  video_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  video_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  video_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  video_starts_with?: InputMaybe<Scalars['String']['input']>;
};

export enum RightColumnOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  video_ASC = 'video_ASC',
  video_DESC = 'video_DESC'
}

export type RightColumnUpdateInput = {
  assetsComponents?: InputMaybe<AssetComponentUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type RightColumnUpdateManyInlineInput = {
  /** Connect multiple existing RightColumn documents */
  connect?: InputMaybe<Array<RightColumnConnectInput>>;
  /** Create and connect multiple RightColumn documents */
  create?: InputMaybe<Array<RightColumnCreateInput>>;
  /** Delete multiple RightColumn documents */
  delete?: InputMaybe<Array<RightColumnWhereUniqueInput>>;
  /** Disconnect multiple RightColumn documents */
  disconnect?: InputMaybe<Array<RightColumnWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing RightColumn documents */
  set?: InputMaybe<Array<RightColumnWhereUniqueInput>>;
  /** Update multiple RightColumn documents */
  update?: InputMaybe<Array<RightColumnUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple RightColumn documents */
  upsert?: InputMaybe<Array<RightColumnUpsertWithNestedWhereUniqueInput>>;
};

export type RightColumnUpdateManyInput = {
  description?: InputMaybe<Scalars['RichTextAST']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type RightColumnUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: RightColumnUpdateManyInput;
  /** Document search */
  where: RightColumnWhereInput;
};

export type RightColumnUpdateOneInlineInput = {
  /** Connect existing RightColumn document */
  connect?: InputMaybe<RightColumnWhereUniqueInput>;
  /** Create and connect one RightColumn document */
  create?: InputMaybe<RightColumnCreateInput>;
  /** Delete currently connected RightColumn document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected RightColumn document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single RightColumn document */
  update?: InputMaybe<RightColumnUpdateWithNestedWhereUniqueInput>;
  /** Upsert single RightColumn document */
  upsert?: InputMaybe<RightColumnUpsertWithNestedWhereUniqueInput>;
};

export type RightColumnUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: RightColumnUpdateInput;
  /** Unique document search */
  where: RightColumnWhereUniqueInput;
};

export type RightColumnUpsertInput = {
  /** Create document if it didn't exist */
  create: RightColumnCreateInput;
  /** Update document if it exists */
  update: RightColumnUpdateInput;
};

export type RightColumnUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: RightColumnUpsertInput;
  /** Unique document search */
  where: RightColumnWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type RightColumnWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type RightColumnWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RightColumnWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RightColumnWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RightColumnWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<RightColumnWhereStageInput>;
  documentInStages_none?: InputMaybe<RightColumnWhereStageInput>;
  documentInStages_some?: InputMaybe<RightColumnWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  video?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  video_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  video_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  video_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  video_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  video_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  video_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  video_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  video_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  video_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type RightColumnWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<RightColumnWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<RightColumnWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<RightColumnWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<RightColumnWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References RightColumn record uniquely */
export type RightColumnWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Scheduled Operation system model */
export type ScheduledOperation = Entity & Node & {
  __typename?: 'ScheduledOperation';
  affectedDocuments: Array<ScheduledOperationAffectedDocument>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Operation description */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledOperation>;
  /** Operation error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Raw operation payload including all details, this field is subject to change */
  rawPayload: Scalars['Json']['output'];
  /** The release this operation is scheduled for */
  release?: Maybe<ScheduledRelease>;
  /** System stage field */
  stage: Stage;
  /** operation Status */
  status: ScheduledOperationStatus;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Operation system model */
export type ScheduledOperationAffectedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Scheduled Operation system model */
export type ScheduledOperationCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Scheduled Operation system model */
export type ScheduledOperationPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationReleaseArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Operation system model */
export type ScheduledOperationUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledOperationAffectedDocument = Accordion | AccordionItem | AlexTestComponent | AlgoliaExtension | AnchorNav | AnchorNavigation | AnchorNavigationList | Asset | AssetComponent | AudioComponent | AuthorableContentCard | Banner2 | BigNumber | BigNumberItem | CardComponent | CarouselComponent | CarouselSlide | CategoryCard | ContactCard | ContactCardContainer | CorpAddToCalendar | CorpBanner1 | CorpCalendarEvent | CorpCardCarousel | CorpContactCard | CorpContactCardContainer | CorpForm | CorpGenericAccordion | CorpGenericAccordionItem | CorpGenericBanner | CorpGenericContainer | CorpGridColumnComponent | CorpHero | CorpMediaDownloadPreview | CorpNavigation | CorpNavigationItem | CorpNotificationBanner | CorpOurPeople | CorpOurPeopleItem | CorpPressPage | CorpSocialMediaFooter | CorpStoriesPage | CorpStoryCarousel | CorpTimelineAccordion | CorpTimelineAccordionItem | CorpTimelineAccordionWrapper | CorpVideoHero | CorpVideoHeroCarousel | CountrySelector | CountrySelectorItem | DeprecatedBanner1 | DeprecatedCorpNavigationCopy | Dictionary | DictionaryItem | DynamicCardGrid | EvalancheFormComponent | ExampleComponent | FeaturedContent | FeaturedContentReference | FooterNavigation | Form | FormCheckbox | FormEmailInput | FormError | FormPasswordInput | FormPasswordInputWithConfirmation | FormRadioButton | FormRadioButtonCollection | FormSelectComponent | FormSelectOption | FormSubmitButton | FormSuccessComponent | FormTextInput | FormTextareaInput | GenericAccordion | GenericAccordionItem | GenericAccordionTopRated | GenericCardCarouseComponent | GenericDownloadComponent | GenericFollowUs | GenericGridAuthorable | GenericLine | GenericLink | GenericPage | GlobalMetaData | HeroBanner | HeroCarouselComponent | HeroComponent | HomePage | Iframe | ImageAndTextCard | ImageCopy | ImageCopyItem | IntroText | LeftColumn | Link | LocationComponent | LocationItem | LongText | MediaLibrary | MediaLibraryItem | MetaData | MobileOnlyMainNavigation | Navigation | NavigationItem | NotificationBanner | PageFooter | PageHeader | PopularSearchComponent | PressRelease | PressStoriesCard | ProgressBar | QuickLink | QuickLinkItem | Redirect | Rewrite | RightColumn | SearchInput | SearchOverlayComponent | SearchResultPage | ShortHero | SocialMediaListComponent | Spacer | Story | SubCategoryKeyImage | SustainabilityBanner | SustainabilityInfo | Tab | TabContent | TestTipsANdTricksInAMarket | TextComponent | TipsAndTricksDetailsPage | Title | TwitterSeo | Widget;

export type ScheduledOperationConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledOperationWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledOperationConnection = {
  __typename?: 'ScheduledOperationConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledOperationEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledOperationCreateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationCreateOneInlineInput = {
  /** Connect one existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
};

/** An edge in a connection. */
export type ScheduledOperationEdge = {
  __typename?: 'ScheduledOperationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduledOperation;
};

/** Identifies documents */
export type ScheduledOperationManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledOperationOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  errorMessage_ASC = 'errorMessage_ASC',
  errorMessage_DESC = 'errorMessage_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** System Scheduled Operation Status */
export enum ScheduledOperationStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING'
}

export type ScheduledOperationUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledOperation documents */
  connect?: InputMaybe<Array<ScheduledOperationConnectInput>>;
  /** Disconnect multiple ScheduledOperation documents */
  disconnect?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledOperation documents */
  set?: InputMaybe<Array<ScheduledOperationWhereUniqueInput>>;
};

export type ScheduledOperationUpdateOneInlineInput = {
  /** Connect existing ScheduledOperation document */
  connect?: InputMaybe<ScheduledOperationWhereUniqueInput>;
  /** Disconnect currently connected ScheduledOperation document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ScheduledOperationWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledOperationWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  /** All values containing the given json path. */
  rawPayload_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  rawPayload_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  release?: InputMaybe<ScheduledReleaseWhereInput>;
  status?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledOperationStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledOperationStatus>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledOperation record uniquely */
export type ScheduledOperationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Scheduled Release system model */
export type ScheduledRelease = Entity & Node & {
  __typename?: 'ScheduledRelease';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Release description */
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<ScheduledRelease>;
  /** Release error message */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Whether scheduled release should be run */
  isActive: Scalars['Boolean']['output'];
  /** Whether scheduled release is implicit */
  isImplicit: Scalars['Boolean']['output'];
  /** Operations to run with this release */
  operations: Array<ScheduledOperation>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** Release date and time */
  releaseAt?: Maybe<Scalars['DateTime']['output']>;
  /** System stage field */
  stage: Stage;
  /** Release Status */
  status: ScheduledReleaseStatus;
  /** Release Title */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Scheduled Release system model */
export type ScheduledReleaseCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Scheduled Release system model */
export type ScheduledReleaseOperationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<ScheduledOperationOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Scheduled Release system model */
export type ScheduledReleasePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Scheduled Release system model */
export type ScheduledReleaseUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ScheduledReleaseConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ScheduledReleaseWhereUniqueInput;
};

/** A connection to a list of items. */
export type ScheduledReleaseConnection = {
  __typename?: 'ScheduledReleaseConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ScheduledReleaseEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ScheduledReleaseCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ScheduledReleaseCreateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Create and connect multiple existing ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
};

export type ScheduledReleaseCreateOneInlineInput = {
  /** Connect one existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
};

/** An edge in a connection. */
export type ScheduledReleaseEdge = {
  __typename?: 'ScheduledReleaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ScheduledRelease;
};

/** Identifies documents */
export type ScheduledReleaseManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ScheduledReleaseOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  errorMessage_ASC = 'errorMessage_ASC',
  errorMessage_DESC = 'errorMessage_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isActive_ASC = 'isActive_ASC',
  isActive_DESC = 'isActive_DESC',
  isImplicit_ASC = 'isImplicit_ASC',
  isImplicit_DESC = 'isImplicit_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  releaseAt_ASC = 'releaseAt_ASC',
  releaseAt_DESC = 'releaseAt_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** System Scheduled Release Status */
export enum ScheduledReleaseStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING'
}

export type ScheduledReleaseUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyInlineInput = {
  /** Connect multiple existing ScheduledRelease documents */
  connect?: InputMaybe<Array<ScheduledReleaseConnectInput>>;
  /** Create and connect multiple ScheduledRelease documents */
  create?: InputMaybe<Array<ScheduledReleaseCreateInput>>;
  /** Delete multiple ScheduledRelease documents */
  delete?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Disconnect multiple ScheduledRelease documents */
  disconnect?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ScheduledRelease documents */
  set?: InputMaybe<Array<ScheduledReleaseWhereUniqueInput>>;
  /** Update multiple ScheduledRelease documents */
  update?: InputMaybe<Array<ScheduledReleaseUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ScheduledRelease documents */
  upsert?: InputMaybe<Array<ScheduledReleaseUpsertWithNestedWhereUniqueInput>>;
};

export type ScheduledReleaseUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReleaseUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ScheduledReleaseUpdateManyInput;
  /** Document search */
  where: ScheduledReleaseWhereInput;
};

export type ScheduledReleaseUpdateOneInlineInput = {
  /** Connect existing ScheduledRelease document */
  connect?: InputMaybe<ScheduledReleaseWhereUniqueInput>;
  /** Create and connect one ScheduledRelease document */
  create?: InputMaybe<ScheduledReleaseCreateInput>;
  /** Delete currently connected ScheduledRelease document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ScheduledRelease document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ScheduledRelease document */
  update?: InputMaybe<ScheduledReleaseUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ScheduledRelease document */
  upsert?: InputMaybe<ScheduledReleaseUpsertWithNestedWhereUniqueInput>;
};

export type ScheduledReleaseUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ScheduledReleaseUpdateInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

export type ScheduledReleaseUpsertInput = {
  /** Create document if it didn't exist */
  create: ScheduledReleaseCreateInput;
  /** Update document if it exists */
  update: ScheduledReleaseUpdateInput;
};

export type ScheduledReleaseUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ScheduledReleaseUpsertInput;
  /** Unique document search */
  where: ScheduledReleaseWhereUniqueInput;
};

/** Identifies documents */
export type ScheduledReleaseWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ScheduledReleaseWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  errorMessage_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  errorMessage_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  errorMessage_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  errorMessage_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  errorMessage_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  errorMessage_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  errorMessage_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  errorMessage_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  errorMessage_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  isImplicit?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isImplicit_not?: InputMaybe<Scalars['Boolean']['input']>;
  operations_every?: InputMaybe<ScheduledOperationWhereInput>;
  operations_none?: InputMaybe<ScheduledOperationWhereInput>;
  operations_some?: InputMaybe<ScheduledOperationWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  releaseAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  releaseAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  releaseAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  releaseAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  releaseAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  releaseAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  releaseAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  releaseAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  status?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are contained in given list. */
  status_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  /** Any other value that exists and is not equal to the given value. */
  status_not?: InputMaybe<ScheduledReleaseStatus>;
  /** All values that are not contained in given list. */
  status_not_in?: InputMaybe<Array<InputMaybe<ScheduledReleaseStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** References ScheduledRelease record uniquely */
export type ScheduledReleaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SearchInput = Entity & Node & {
  __typename?: 'SearchInput';
  anchorNav?: Maybe<AnchorNavigation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SearchInput>;
  genericPages: Array<GenericPage>;
  /** List of SearchInput versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  showLabel?: Maybe<Scalars['Boolean']['output']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type SearchInputAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchInputCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchInputDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type SearchInputGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


export type SearchInputHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type SearchInputPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchInputScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SearchInputUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SearchInputConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SearchInputWhereUniqueInput;
};

/** A connection to a list of items. */
export type SearchInputConnection = {
  __typename?: 'SearchInputConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SearchInputEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SearchInputCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  showLabel?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SearchInputCreateManyInlineInput = {
  /** Connect multiple existing SearchInput documents */
  connect?: InputMaybe<Array<SearchInputWhereUniqueInput>>;
  /** Create and connect multiple existing SearchInput documents */
  create?: InputMaybe<Array<SearchInputCreateInput>>;
};

export type SearchInputCreateOneInlineInput = {
  /** Connect one existing SearchInput document */
  connect?: InputMaybe<SearchInputWhereUniqueInput>;
  /** Create and connect one SearchInput document */
  create?: InputMaybe<SearchInputCreateInput>;
};

/** An edge in a connection. */
export type SearchInputEdge = {
  __typename?: 'SearchInputEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SearchInput;
};

/** Identifies documents */
export type SearchInputManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SearchInputWhereStageInput>;
  documentInStages_none?: InputMaybe<SearchInputWhereStageInput>;
  documentInStages_some?: InputMaybe<SearchInputWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholder_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholder_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholder_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholder_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholder_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholder_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholder_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showLabel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showLabel_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SearchInputOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  placeholder_ASC = 'placeholder_ASC',
  placeholder_DESC = 'placeholder_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  showLabel_ASC = 'showLabel_ASC',
  showLabel_DESC = 'showLabel_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SearchInputUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  showLabel?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchInputUpdateManyInlineInput = {
  /** Connect multiple existing SearchInput documents */
  connect?: InputMaybe<Array<SearchInputConnectInput>>;
  /** Create and connect multiple SearchInput documents */
  create?: InputMaybe<Array<SearchInputCreateInput>>;
  /** Delete multiple SearchInput documents */
  delete?: InputMaybe<Array<SearchInputWhereUniqueInput>>;
  /** Disconnect multiple SearchInput documents */
  disconnect?: InputMaybe<Array<SearchInputWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SearchInput documents */
  set?: InputMaybe<Array<SearchInputWhereUniqueInput>>;
  /** Update multiple SearchInput documents */
  update?: InputMaybe<Array<SearchInputUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SearchInput documents */
  upsert?: InputMaybe<Array<SearchInputUpsertWithNestedWhereUniqueInput>>;
};

export type SearchInputUpdateManyInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  showLabel?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchInputUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SearchInputUpdateManyInput;
  /** Document search */
  where: SearchInputWhereInput;
};

export type SearchInputUpdateOneInlineInput = {
  /** Connect existing SearchInput document */
  connect?: InputMaybe<SearchInputWhereUniqueInput>;
  /** Create and connect one SearchInput document */
  create?: InputMaybe<SearchInputCreateInput>;
  /** Delete currently connected SearchInput document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SearchInput document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SearchInput document */
  update?: InputMaybe<SearchInputUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SearchInput document */
  upsert?: InputMaybe<SearchInputUpsertWithNestedWhereUniqueInput>;
};

export type SearchInputUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SearchInputUpdateInput;
  /** Unique document search */
  where: SearchInputWhereUniqueInput;
};

export type SearchInputUpsertInput = {
  /** Create document if it didn't exist */
  create: SearchInputCreateInput;
  /** Update document if it exists */
  update: SearchInputUpdateInput;
};

export type SearchInputUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SearchInputUpsertInput;
  /** Unique document search */
  where: SearchInputWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SearchInputWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SearchInputWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchInputWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchInputWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchInputWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SearchInputWhereStageInput>;
  documentInStages_none?: InputMaybe<SearchInputWhereStageInput>;
  documentInStages_some?: InputMaybe<SearchInputWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  label_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  label_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  label_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  label_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  placeholder_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  placeholder_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  placeholder_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  placeholder_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  placeholder_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  placeholder_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  placeholder_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  placeholder_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  placeholder_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  showLabel?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  showLabel_not?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SearchInputWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchInputWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchInputWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchInputWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SearchInputWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SearchInput record uniquely */
export type SearchInputWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SearchOverlayComponent = Entity & Node & {
  __typename?: 'SearchOverlayComponent';
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  dictionaries: Array<Dictionary>;
  /** Get the document in other stages */
  documentInStages: Array<SearchOverlayComponent>;
  /** Title on the overlay */
  heading?: Maybe<Scalars['String']['output']>;
  /** List of SearchOverlayComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  links: Array<Link>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Super text on overlay */
  subHeading?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type SearchOverlayComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchOverlayComponentDictionariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<DictionaryOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DictionaryWhereInput>;
};


export type SearchOverlayComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type SearchOverlayComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type SearchOverlayComponentLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<LinkOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LinkWhereInput>;
};


export type SearchOverlayComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchOverlayComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SearchOverlayComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SearchOverlayComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SearchOverlayComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type SearchOverlayComponentConnection = {
  __typename?: 'SearchOverlayComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SearchOverlayComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SearchOverlayComponentCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dictionaries?: InputMaybe<DictionaryCreateManyInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<LinkCreateManyInlineInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SearchOverlayComponentCreateManyInlineInput = {
  /** Connect multiple existing SearchOverlayComponent documents */
  connect?: InputMaybe<Array<SearchOverlayComponentWhereUniqueInput>>;
  /** Create and connect multiple existing SearchOverlayComponent documents */
  create?: InputMaybe<Array<SearchOverlayComponentCreateInput>>;
};

export type SearchOverlayComponentCreateOneInlineInput = {
  /** Connect one existing SearchOverlayComponent document */
  connect?: InputMaybe<SearchOverlayComponentWhereUniqueInput>;
  /** Create and connect one SearchOverlayComponent document */
  create?: InputMaybe<SearchOverlayComponentCreateInput>;
};

/** An edge in a connection. */
export type SearchOverlayComponentEdge = {
  __typename?: 'SearchOverlayComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SearchOverlayComponent;
};

/** Identifies documents */
export type SearchOverlayComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchOverlayComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchOverlayComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchOverlayComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaries_every?: InputMaybe<DictionaryWhereInput>;
  dictionaries_none?: InputMaybe<DictionaryWhereInput>;
  dictionaries_some?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<SearchOverlayComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<SearchOverlayComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<SearchOverlayComponentWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SearchOverlayComponentOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subHeading_ASC = 'subHeading_ASC',
  subHeading_DESC = 'subHeading_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SearchOverlayComponentUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  dictionaries?: InputMaybe<DictionaryUpdateManyInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<LinkUpdateManyInlineInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type SearchOverlayComponentUpdateManyInlineInput = {
  /** Connect multiple existing SearchOverlayComponent documents */
  connect?: InputMaybe<Array<SearchOverlayComponentConnectInput>>;
  /** Create and connect multiple SearchOverlayComponent documents */
  create?: InputMaybe<Array<SearchOverlayComponentCreateInput>>;
  /** Delete multiple SearchOverlayComponent documents */
  delete?: InputMaybe<Array<SearchOverlayComponentWhereUniqueInput>>;
  /** Disconnect multiple SearchOverlayComponent documents */
  disconnect?: InputMaybe<Array<SearchOverlayComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SearchOverlayComponent documents */
  set?: InputMaybe<Array<SearchOverlayComponentWhereUniqueInput>>;
  /** Update multiple SearchOverlayComponent documents */
  update?: InputMaybe<Array<SearchOverlayComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SearchOverlayComponent documents */
  upsert?: InputMaybe<Array<SearchOverlayComponentUpsertWithNestedWhereUniqueInput>>;
};

export type SearchOverlayComponentUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type SearchOverlayComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SearchOverlayComponentUpdateManyInput;
  /** Document search */
  where: SearchOverlayComponentWhereInput;
};

export type SearchOverlayComponentUpdateOneInlineInput = {
  /** Connect existing SearchOverlayComponent document */
  connect?: InputMaybe<SearchOverlayComponentWhereUniqueInput>;
  /** Create and connect one SearchOverlayComponent document */
  create?: InputMaybe<SearchOverlayComponentCreateInput>;
  /** Delete currently connected SearchOverlayComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SearchOverlayComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SearchOverlayComponent document */
  update?: InputMaybe<SearchOverlayComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SearchOverlayComponent document */
  upsert?: InputMaybe<SearchOverlayComponentUpsertWithNestedWhereUniqueInput>;
};

export type SearchOverlayComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SearchOverlayComponentUpdateInput;
  /** Unique document search */
  where: SearchOverlayComponentWhereUniqueInput;
};

export type SearchOverlayComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: SearchOverlayComponentCreateInput;
  /** Update document if it exists */
  update: SearchOverlayComponentUpdateInput;
};

export type SearchOverlayComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SearchOverlayComponentUpsertInput;
  /** Unique document search */
  where: SearchOverlayComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SearchOverlayComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SearchOverlayComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchOverlayComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchOverlayComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchOverlayComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  dictionaries_every?: InputMaybe<DictionaryWhereInput>;
  dictionaries_none?: InputMaybe<DictionaryWhereInput>;
  dictionaries_some?: InputMaybe<DictionaryWhereInput>;
  documentInStages_every?: InputMaybe<SearchOverlayComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<SearchOverlayComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<SearchOverlayComponentWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  links_every?: InputMaybe<LinkWhereInput>;
  links_none?: InputMaybe<LinkWhereInput>;
  links_some?: InputMaybe<LinkWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SearchOverlayComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchOverlayComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchOverlayComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchOverlayComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SearchOverlayComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SearchOverlayComponent record uniquely */
export type SearchOverlayComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SearchResultPage = Entity & Node & {
  __typename?: 'SearchResultPage';
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SearchResultPage>;
  /** Title of the page */
  heading?: Maybe<Scalars['String']['output']>;
  /** List of SearchResultPage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  searchPageTitles?: Maybe<Dictionary>;
  /** System stage field */
  stage: Stage;
  /** Super text of the page */
  subHeading?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type SearchResultPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchResultPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type SearchResultPageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type SearchResultPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchResultPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SearchResultPageSearchPageTitlesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SearchResultPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SearchResultPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SearchResultPageWhereUniqueInput;
};

/** A connection to a list of items. */
export type SearchResultPageConnection = {
  __typename?: 'SearchResultPageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SearchResultPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SearchResultPageCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  searchPageTitles?: InputMaybe<DictionaryCreateOneInlineInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SearchResultPageCreateManyInlineInput = {
  /** Connect multiple existing SearchResultPage documents */
  connect?: InputMaybe<Array<SearchResultPageWhereUniqueInput>>;
  /** Create and connect multiple existing SearchResultPage documents */
  create?: InputMaybe<Array<SearchResultPageCreateInput>>;
};

export type SearchResultPageCreateOneInlineInput = {
  /** Connect one existing SearchResultPage document */
  connect?: InputMaybe<SearchResultPageWhereUniqueInput>;
  /** Create and connect one SearchResultPage document */
  create?: InputMaybe<SearchResultPageCreateInput>;
};

/** An edge in a connection. */
export type SearchResultPageEdge = {
  __typename?: 'SearchResultPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SearchResultPage;
};

/** Identifies documents */
export type SearchResultPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchResultPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchResultPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchResultPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SearchResultPageWhereStageInput>;
  documentInStages_none?: InputMaybe<SearchResultPageWhereStageInput>;
  documentInStages_some?: InputMaybe<SearchResultPageWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  searchPageTitles?: InputMaybe<DictionaryWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SearchResultPageOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subHeading_ASC = 'subHeading_ASC',
  subHeading_DESC = 'subHeading_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SearchResultPageUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  searchPageTitles?: InputMaybe<DictionaryUpdateOneInlineInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type SearchResultPageUpdateManyInlineInput = {
  /** Connect multiple existing SearchResultPage documents */
  connect?: InputMaybe<Array<SearchResultPageConnectInput>>;
  /** Create and connect multiple SearchResultPage documents */
  create?: InputMaybe<Array<SearchResultPageCreateInput>>;
  /** Delete multiple SearchResultPage documents */
  delete?: InputMaybe<Array<SearchResultPageWhereUniqueInput>>;
  /** Disconnect multiple SearchResultPage documents */
  disconnect?: InputMaybe<Array<SearchResultPageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SearchResultPage documents */
  set?: InputMaybe<Array<SearchResultPageWhereUniqueInput>>;
  /** Update multiple SearchResultPage documents */
  update?: InputMaybe<Array<SearchResultPageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SearchResultPage documents */
  upsert?: InputMaybe<Array<SearchResultPageUpsertWithNestedWhereUniqueInput>>;
};

export type SearchResultPageUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
};

export type SearchResultPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SearchResultPageUpdateManyInput;
  /** Document search */
  where: SearchResultPageWhereInput;
};

export type SearchResultPageUpdateOneInlineInput = {
  /** Connect existing SearchResultPage document */
  connect?: InputMaybe<SearchResultPageWhereUniqueInput>;
  /** Create and connect one SearchResultPage document */
  create?: InputMaybe<SearchResultPageCreateInput>;
  /** Delete currently connected SearchResultPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SearchResultPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SearchResultPage document */
  update?: InputMaybe<SearchResultPageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SearchResultPage document */
  upsert?: InputMaybe<SearchResultPageUpsertWithNestedWhereUniqueInput>;
};

export type SearchResultPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SearchResultPageUpdateInput;
  /** Unique document search */
  where: SearchResultPageWhereUniqueInput;
};

export type SearchResultPageUpsertInput = {
  /** Create document if it didn't exist */
  create: SearchResultPageCreateInput;
  /** Update document if it exists */
  update: SearchResultPageUpdateInput;
};

export type SearchResultPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SearchResultPageUpsertInput;
  /** Unique document search */
  where: SearchResultPageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SearchResultPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SearchResultPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchResultPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchResultPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchResultPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SearchResultPageWhereStageInput>;
  documentInStages_none?: InputMaybe<SearchResultPageWhereStageInput>;
  documentInStages_some?: InputMaybe<SearchResultPageWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  searchPageTitles?: InputMaybe<DictionaryWhereInput>;
  subHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SearchResultPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SearchResultPageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SearchResultPageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SearchResultPageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SearchResultPageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SearchResultPage record uniquely */
export type SearchResultPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Blue curve that can be placed at the beginning of a page */
export type ShortHero = Entity & Node & {
  __typename?: 'ShortHero';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<ShortHero>;
  genericPages: Array<GenericPage>;
  /** List of ShortHero versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<ShortHero>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  superTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Blue curve that can be placed at the beginning of a page */
export type ShortHeroCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Blue curve that can be placed at the beginning of a page */
export type ShortHeroCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Blue curve that can be placed at the beginning of a page */
export type ShortHeroDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Blue curve that can be placed at the beginning of a page */
export type ShortHeroGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Blue curve that can be placed at the beginning of a page */
export type ShortHeroHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Blue curve that can be placed at the beginning of a page */
export type ShortHeroLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Blue curve that can be placed at the beginning of a page */
export type ShortHeroPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Blue curve that can be placed at the beginning of a page */
export type ShortHeroPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Blue curve that can be placed at the beginning of a page */
export type ShortHeroScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Blue curve that can be placed at the beginning of a page */
export type ShortHeroUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Blue curve that can be placed at the beginning of a page */
export type ShortHeroUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type ShortHeroConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: ShortHeroWhereUniqueInput;
};

/** A connection to a list of items. */
export type ShortHeroConnection = {
  __typename?: 'ShortHeroConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<ShortHeroEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type ShortHeroCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<ShortHeroCreateLocalizationsInput>;
  /** superTitle input for default locale (default) */
  superTitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ShortHeroCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  superTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ShortHeroCreateLocalizationInput = {
  /** Localization input */
  data: ShortHeroCreateLocalizationDataInput;
  locale: Locale;
};

export type ShortHeroCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<ShortHeroCreateLocalizationInput>>;
};

export type ShortHeroCreateManyInlineInput = {
  /** Connect multiple existing ShortHero documents */
  connect?: InputMaybe<Array<ShortHeroWhereUniqueInput>>;
  /** Create and connect multiple existing ShortHero documents */
  create?: InputMaybe<Array<ShortHeroCreateInput>>;
};

export type ShortHeroCreateOneInlineInput = {
  /** Connect one existing ShortHero document */
  connect?: InputMaybe<ShortHeroWhereUniqueInput>;
  /** Create and connect one ShortHero document */
  create?: InputMaybe<ShortHeroCreateInput>;
};

/** An edge in a connection. */
export type ShortHeroEdge = {
  __typename?: 'ShortHeroEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ShortHero;
};

/** Identifies documents */
export type ShortHeroManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ShortHeroWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ShortHeroWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ShortHeroWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<ShortHeroWhereStageInput>;
  documentInStages_none?: InputMaybe<ShortHeroWhereStageInput>;
  documentInStages_some?: InputMaybe<ShortHeroWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum ShortHeroOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superTitle_ASC = 'superTitle_ASC',
  superTitle_DESC = 'superTitle_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type ShortHeroUpdateInput = {
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<ShortHeroUpdateLocalizationsInput>;
  /** superTitle input for default locale (default) */
  superTitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ShortHeroUpdateLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  superTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ShortHeroUpdateLocalizationInput = {
  data: ShortHeroUpdateLocalizationDataInput;
  locale: Locale;
};

export type ShortHeroUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<ShortHeroCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<ShortHeroUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<ShortHeroUpsertLocalizationInput>>;
};

export type ShortHeroUpdateManyInlineInput = {
  /** Connect multiple existing ShortHero documents */
  connect?: InputMaybe<Array<ShortHeroConnectInput>>;
  /** Create and connect multiple ShortHero documents */
  create?: InputMaybe<Array<ShortHeroCreateInput>>;
  /** Delete multiple ShortHero documents */
  delete?: InputMaybe<Array<ShortHeroWhereUniqueInput>>;
  /** Disconnect multiple ShortHero documents */
  disconnect?: InputMaybe<Array<ShortHeroWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing ShortHero documents */
  set?: InputMaybe<Array<ShortHeroWhereUniqueInput>>;
  /** Update multiple ShortHero documents */
  update?: InputMaybe<Array<ShortHeroUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ShortHero documents */
  upsert?: InputMaybe<Array<ShortHeroUpsertWithNestedWhereUniqueInput>>;
};

export type ShortHeroUpdateManyInput = {
  /** description input for default locale (default) */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<ShortHeroUpdateManyLocalizationsInput>;
  /** superTitle input for default locale (default) */
  superTitle?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ShortHeroUpdateManyLocalizationDataInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  superTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ShortHeroUpdateManyLocalizationInput = {
  data: ShortHeroUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type ShortHeroUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<ShortHeroUpdateManyLocalizationInput>>;
};

export type ShortHeroUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: ShortHeroUpdateManyInput;
  /** Document search */
  where: ShortHeroWhereInput;
};

export type ShortHeroUpdateOneInlineInput = {
  /** Connect existing ShortHero document */
  connect?: InputMaybe<ShortHeroWhereUniqueInput>;
  /** Create and connect one ShortHero document */
  create?: InputMaybe<ShortHeroCreateInput>;
  /** Delete currently connected ShortHero document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected ShortHero document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single ShortHero document */
  update?: InputMaybe<ShortHeroUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ShortHero document */
  upsert?: InputMaybe<ShortHeroUpsertWithNestedWhereUniqueInput>;
};

export type ShortHeroUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: ShortHeroUpdateInput;
  /** Unique document search */
  where: ShortHeroWhereUniqueInput;
};

export type ShortHeroUpsertInput = {
  /** Create document if it didn't exist */
  create: ShortHeroCreateInput;
  /** Update document if it exists */
  update: ShortHeroUpdateInput;
};

export type ShortHeroUpsertLocalizationInput = {
  create: ShortHeroCreateLocalizationDataInput;
  locale: Locale;
  update: ShortHeroUpdateLocalizationDataInput;
};

export type ShortHeroUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: ShortHeroUpsertInput;
  /** Unique document search */
  where: ShortHeroWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type ShortHeroWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type ShortHeroWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ShortHeroWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ShortHeroWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ShortHeroWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<ShortHeroWhereStageInput>;
  documentInStages_none?: InputMaybe<ShortHeroWhereStageInput>;
  documentInStages_some?: InputMaybe<ShortHeroWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type ShortHeroWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<ShortHeroWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<ShortHeroWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<ShortHeroWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<ShortHeroWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References ShortHero record uniquely */
export type ShortHeroWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum SocialMediaComponentName {
  EmailShareButton = 'EmailShareButton',
  FacebookShareButton = 'FacebookShareButton',
  HatenaShareButton = 'HatenaShareButton',
  InstapaperShareButton = 'InstapaperShareButton',
  LineShareButton = 'LineShareButton',
  LinkedinShareButton = 'LinkedinShareButton',
  LivejournalShareButton = 'LivejournalShareButton',
  MailruShareButton = 'MailruShareButton',
  OKShareButton = 'OKShareButton',
  PinterestShareButton = 'PinterestShareButton',
  PocketShareButton = 'PocketShareButton',
  RedditShareButton = 'RedditShareButton',
  TelegramShareButton = 'TelegramShareButton',
  TumblrShareButton = 'TumblrShareButton',
  TwitterShareButton = 'TwitterShareButton',
  VKShareButton = 'VKShareButton',
  ViberShareButton = 'ViberShareButton',
  WhatsappShareButton = 'WhatsappShareButton',
  WorkplaceShareButton = 'WorkplaceShareButton'
}

export type SocialMediaListComponent = Entity & Node & {
  __typename?: 'SocialMediaListComponent';
  anchorNav?: Maybe<AnchorNavigation>;
  assetsComponents: Array<AssetComponent>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SocialMediaListComponent>;
  /** List of SocialMediaListComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<SocialMediaListComponent>;
  /** Name of social media */
  name: Scalars['String']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** a message with the social sharing platform , it can be share it, tweet it, etc. */
  shareMsg?: Maybe<Scalars['String']['output']>;
  socialMediaComponentName?: Maybe<SocialMediaComponentName>;
  socialSharePosition: SocialSharePosition;
  /** System stage field */
  stage: Stage;
  tabContent?: Maybe<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** URL of social media */
  url: Scalars['String']['output'];
};


export type SocialMediaListComponentAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SocialMediaListComponentAssetsComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<AssetComponentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetComponentWhereInput>;
};


export type SocialMediaListComponentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type SocialMediaListComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SocialMediaListComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type SocialMediaListComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type SocialMediaListComponentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type SocialMediaListComponentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type SocialMediaListComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SocialMediaListComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SocialMediaListComponentTabContentArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SocialMediaListComponentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type SocialMediaListComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SocialMediaListComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SocialMediaListComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type SocialMediaListComponentConnection = {
  __typename?: 'SocialMediaListComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SocialMediaListComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SocialMediaListComponentCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  assetsComponents?: InputMaybe<AssetComponentCreateManyInlineInput>;
  ckryvqsbd252f01z830y60gx1?: InputMaybe<GenericFollowUsCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SocialMediaListComponentCreateLocalizationsInput>;
  /** name input for default locale (default) */
  name: Scalars['String']['input'];
  /** shareMsg input for default locale (default) */
  shareMsg?: InputMaybe<Scalars['String']['input']>;
  socialMediaComponentName?: InputMaybe<SocialMediaComponentName>;
  socialSharePosition: SocialSharePosition;
  tabContent?: InputMaybe<TabContentCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** url input for default locale (default) */
  url: Scalars['String']['input'];
};

export type SocialMediaListComponentCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name: Scalars['String']['input'];
  shareMsg?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type SocialMediaListComponentCreateLocalizationInput = {
  /** Localization input */
  data: SocialMediaListComponentCreateLocalizationDataInput;
  locale: Locale;
};

export type SocialMediaListComponentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SocialMediaListComponentCreateLocalizationInput>>;
};

export type SocialMediaListComponentCreateManyInlineInput = {
  /** Connect multiple existing SocialMediaListComponent documents */
  connect?: InputMaybe<Array<SocialMediaListComponentWhereUniqueInput>>;
  /** Create and connect multiple existing SocialMediaListComponent documents */
  create?: InputMaybe<Array<SocialMediaListComponentCreateInput>>;
};

export type SocialMediaListComponentCreateOneInlineInput = {
  /** Connect one existing SocialMediaListComponent document */
  connect?: InputMaybe<SocialMediaListComponentWhereUniqueInput>;
  /** Create and connect one SocialMediaListComponent document */
  create?: InputMaybe<SocialMediaListComponentCreateInput>;
};

/** An edge in a connection. */
export type SocialMediaListComponentEdge = {
  __typename?: 'SocialMediaListComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SocialMediaListComponent;
};

/** Identifies documents */
export type SocialMediaListComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SocialMediaListComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SocialMediaListComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SocialMediaListComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SocialMediaListComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<SocialMediaListComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<SocialMediaListComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  socialMediaComponentName?: InputMaybe<SocialMediaComponentName>;
  /** All values that are contained in given list. */
  socialMediaComponentName_in?: InputMaybe<Array<InputMaybe<SocialMediaComponentName>>>;
  /** Any other value that exists and is not equal to the given value. */
  socialMediaComponentName_not?: InputMaybe<SocialMediaComponentName>;
  /** All values that are not contained in given list. */
  socialMediaComponentName_not_in?: InputMaybe<Array<InputMaybe<SocialMediaComponentName>>>;
  socialSharePosition?: InputMaybe<SocialSharePosition>;
  /** All values that are contained in given list. */
  socialSharePosition_in?: InputMaybe<Array<InputMaybe<SocialSharePosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  socialSharePosition_not?: InputMaybe<SocialSharePosition>;
  /** All values that are not contained in given list. */
  socialSharePosition_not_in?: InputMaybe<Array<InputMaybe<SocialSharePosition>>>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SocialMediaListComponentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  shareMsg_ASC = 'shareMsg_ASC',
  shareMsg_DESC = 'shareMsg_DESC',
  socialMediaComponentName_ASC = 'socialMediaComponentName_ASC',
  socialMediaComponentName_DESC = 'socialMediaComponentName_DESC',
  socialSharePosition_ASC = 'socialSharePosition_ASC',
  socialSharePosition_DESC = 'socialSharePosition_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC'
}

export type SocialMediaListComponentUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  assetsComponents?: InputMaybe<AssetComponentUpdateManyInlineInput>;
  ckryvqsbd252f01z830y60gx1?: InputMaybe<GenericFollowUsUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<SocialMediaListComponentUpdateLocalizationsInput>;
  /** name input for default locale (default) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** shareMsg input for default locale (default) */
  shareMsg?: InputMaybe<Scalars['String']['input']>;
  socialMediaComponentName?: InputMaybe<SocialMediaComponentName>;
  socialSharePosition?: InputMaybe<SocialSharePosition>;
  tabContent?: InputMaybe<TabContentUpdateOneInlineInput>;
  /** url input for default locale (default) */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SocialMediaListComponentUpdateLocalizationDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  shareMsg?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SocialMediaListComponentUpdateLocalizationInput = {
  data: SocialMediaListComponentUpdateLocalizationDataInput;
  locale: Locale;
};

export type SocialMediaListComponentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SocialMediaListComponentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<SocialMediaListComponentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<SocialMediaListComponentUpsertLocalizationInput>>;
};

export type SocialMediaListComponentUpdateManyInlineInput = {
  /** Connect multiple existing SocialMediaListComponent documents */
  connect?: InputMaybe<Array<SocialMediaListComponentConnectInput>>;
  /** Create and connect multiple SocialMediaListComponent documents */
  create?: InputMaybe<Array<SocialMediaListComponentCreateInput>>;
  /** Delete multiple SocialMediaListComponent documents */
  delete?: InputMaybe<Array<SocialMediaListComponentWhereUniqueInput>>;
  /** Disconnect multiple SocialMediaListComponent documents */
  disconnect?: InputMaybe<Array<SocialMediaListComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SocialMediaListComponent documents */
  set?: InputMaybe<Array<SocialMediaListComponentWhereUniqueInput>>;
  /** Update multiple SocialMediaListComponent documents */
  update?: InputMaybe<Array<SocialMediaListComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SocialMediaListComponent documents */
  upsert?: InputMaybe<Array<SocialMediaListComponentUpsertWithNestedWhereUniqueInput>>;
};

export type SocialMediaListComponentUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<SocialMediaListComponentUpdateManyLocalizationsInput>;
  /** name input for default locale (default) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** shareMsg input for default locale (default) */
  shareMsg?: InputMaybe<Scalars['String']['input']>;
  socialMediaComponentName?: InputMaybe<SocialMediaComponentName>;
  socialSharePosition?: InputMaybe<SocialSharePosition>;
  /** url input for default locale (default) */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SocialMediaListComponentUpdateManyLocalizationDataInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  shareMsg?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SocialMediaListComponentUpdateManyLocalizationInput = {
  data: SocialMediaListComponentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type SocialMediaListComponentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SocialMediaListComponentUpdateManyLocalizationInput>>;
};

export type SocialMediaListComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SocialMediaListComponentUpdateManyInput;
  /** Document search */
  where: SocialMediaListComponentWhereInput;
};

export type SocialMediaListComponentUpdateOneInlineInput = {
  /** Connect existing SocialMediaListComponent document */
  connect?: InputMaybe<SocialMediaListComponentWhereUniqueInput>;
  /** Create and connect one SocialMediaListComponent document */
  create?: InputMaybe<SocialMediaListComponentCreateInput>;
  /** Delete currently connected SocialMediaListComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SocialMediaListComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SocialMediaListComponent document */
  update?: InputMaybe<SocialMediaListComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SocialMediaListComponent document */
  upsert?: InputMaybe<SocialMediaListComponentUpsertWithNestedWhereUniqueInput>;
};

export type SocialMediaListComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SocialMediaListComponentUpdateInput;
  /** Unique document search */
  where: SocialMediaListComponentWhereUniqueInput;
};

export type SocialMediaListComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: SocialMediaListComponentCreateInput;
  /** Update document if it exists */
  update: SocialMediaListComponentUpdateInput;
};

export type SocialMediaListComponentUpsertLocalizationInput = {
  create: SocialMediaListComponentCreateLocalizationDataInput;
  locale: Locale;
  update: SocialMediaListComponentUpdateLocalizationDataInput;
};

export type SocialMediaListComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SocialMediaListComponentUpsertInput;
  /** Unique document search */
  where: SocialMediaListComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SocialMediaListComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SocialMediaListComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SocialMediaListComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SocialMediaListComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SocialMediaListComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  assetsComponents_every?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_none?: InputMaybe<AssetComponentWhereInput>;
  assetsComponents_some?: InputMaybe<AssetComponentWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SocialMediaListComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<SocialMediaListComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<SocialMediaListComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  shareMsg?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  shareMsg_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  shareMsg_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  shareMsg_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  shareMsg_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  shareMsg_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  shareMsg_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  shareMsg_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  shareMsg_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  shareMsg_starts_with?: InputMaybe<Scalars['String']['input']>;
  socialMediaComponentName?: InputMaybe<SocialMediaComponentName>;
  /** All values that are contained in given list. */
  socialMediaComponentName_in?: InputMaybe<Array<InputMaybe<SocialMediaComponentName>>>;
  /** Any other value that exists and is not equal to the given value. */
  socialMediaComponentName_not?: InputMaybe<SocialMediaComponentName>;
  /** All values that are not contained in given list. */
  socialMediaComponentName_not_in?: InputMaybe<Array<InputMaybe<SocialMediaComponentName>>>;
  socialSharePosition?: InputMaybe<SocialSharePosition>;
  /** All values that are contained in given list. */
  socialSharePosition_in?: InputMaybe<Array<InputMaybe<SocialSharePosition>>>;
  /** Any other value that exists and is not equal to the given value. */
  socialSharePosition_not?: InputMaybe<SocialSharePosition>;
  /** All values that are not contained in given list. */
  socialSharePosition_not_in?: InputMaybe<Array<InputMaybe<SocialSharePosition>>>;
  tabContent?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SocialMediaListComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SocialMediaListComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SocialMediaListComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SocialMediaListComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SocialMediaListComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SocialMediaListComponent record uniquely */
export type SocialMediaListComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum SocialSharePosition {
  SocialShareComponent = 'SocialShareComponent'
}

/** Empty spacer block  */
export type Spacer = Entity & Node & {
  __typename?: 'Spacer';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Spacer>;
  genericAccordionItems: Array<CorpGenericAccordionItem>;
  genericPages: Array<GenericPage>;
  /** Set block height in px */
  height?: Maybe<Scalars['Int']['output']>;
  /** List of Spacer versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  locationItem?: Maybe<LocationItem>;
  mediaLibrary?: Maybe<MediaLibrary>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Empty spacer block  */
export type SpacerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Empty spacer block  */
export type SpacerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Empty spacer block  */
export type SpacerGenericAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CorpGenericAccordionItemWhereInput>;
};


/** Empty spacer block  */
export type SpacerGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** Empty spacer block  */
export type SpacerHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Empty spacer block  */
export type SpacerLocationItemArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Empty spacer block  */
export type SpacerMediaLibraryArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Empty spacer block  */
export type SpacerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Empty spacer block  */
export type SpacerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Empty spacer block  */
export type SpacerStoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


/** Empty spacer block  */
export type SpacerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SpacerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SpacerWhereUniqueInput;
};

/** A connection to a list of items. */
export type SpacerConnection = {
  __typename?: 'SpacerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SpacerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SpacerCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemCreateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  locationItem?: InputMaybe<LocationItemCreateOneInlineInput>;
  mediaLibrary?: InputMaybe<MediaLibraryCreateOneInlineInput>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SpacerCreateManyInlineInput = {
  /** Connect multiple existing Spacer documents */
  connect?: InputMaybe<Array<SpacerWhereUniqueInput>>;
  /** Create and connect multiple existing Spacer documents */
  create?: InputMaybe<Array<SpacerCreateInput>>;
};

export type SpacerCreateOneInlineInput = {
  /** Connect one existing Spacer document */
  connect?: InputMaybe<SpacerWhereUniqueInput>;
  /** Create and connect one Spacer document */
  create?: InputMaybe<SpacerCreateInput>;
};

/** An edge in a connection. */
export type SpacerEdge = {
  __typename?: 'SpacerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Spacer;
};

/** Identifies documents */
export type SpacerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpacerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpacerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpacerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SpacerWhereStageInput>;
  documentInStages_none?: InputMaybe<SpacerWhereStageInput>;
  documentInStages_some?: InputMaybe<SpacerWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  locationItem?: InputMaybe<LocationItemWhereInput>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SpacerOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  height_ASC = 'height_ASC',
  height_DESC = 'height_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SpacerUpdateInput = {
  genericAccordionItems?: InputMaybe<CorpGenericAccordionItemUpdateManyInlineInput>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  locationItem?: InputMaybe<LocationItemUpdateOneInlineInput>;
  mediaLibrary?: InputMaybe<MediaLibraryUpdateOneInlineInput>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
};

export type SpacerUpdateManyInlineInput = {
  /** Connect multiple existing Spacer documents */
  connect?: InputMaybe<Array<SpacerConnectInput>>;
  /** Create and connect multiple Spacer documents */
  create?: InputMaybe<Array<SpacerCreateInput>>;
  /** Delete multiple Spacer documents */
  delete?: InputMaybe<Array<SpacerWhereUniqueInput>>;
  /** Disconnect multiple Spacer documents */
  disconnect?: InputMaybe<Array<SpacerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Spacer documents */
  set?: InputMaybe<Array<SpacerWhereUniqueInput>>;
  /** Update multiple Spacer documents */
  update?: InputMaybe<Array<SpacerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Spacer documents */
  upsert?: InputMaybe<Array<SpacerUpsertWithNestedWhereUniqueInput>>;
};

export type SpacerUpdateManyInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
};

export type SpacerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SpacerUpdateManyInput;
  /** Document search */
  where: SpacerWhereInput;
};

export type SpacerUpdateOneInlineInput = {
  /** Connect existing Spacer document */
  connect?: InputMaybe<SpacerWhereUniqueInput>;
  /** Create and connect one Spacer document */
  create?: InputMaybe<SpacerCreateInput>;
  /** Delete currently connected Spacer document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Spacer document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Spacer document */
  update?: InputMaybe<SpacerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Spacer document */
  upsert?: InputMaybe<SpacerUpsertWithNestedWhereUniqueInput>;
};

export type SpacerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SpacerUpdateInput;
  /** Unique document search */
  where: SpacerWhereUniqueInput;
};

export type SpacerUpsertInput = {
  /** Create document if it didn't exist */
  create: SpacerCreateInput;
  /** Update document if it exists */
  update: SpacerUpdateInput;
};

export type SpacerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SpacerUpsertInput;
  /** Unique document search */
  where: SpacerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SpacerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SpacerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpacerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpacerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpacerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SpacerWhereStageInput>;
  documentInStages_none?: InputMaybe<SpacerWhereStageInput>;
  documentInStages_some?: InputMaybe<SpacerWhereStageInput>;
  genericAccordionItems_every?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_none?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericAccordionItems_some?: InputMaybe<CorpGenericAccordionItemWhereInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  height?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than the given value. */
  height_gt?: InputMaybe<Scalars['Int']['input']>;
  /** All values greater than or equal the given value. */
  height_gte?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are contained in given list. */
  height_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** All values less than the given value. */
  height_lt?: InputMaybe<Scalars['Int']['input']>;
  /** All values less than or equal the given value. */
  height_lte?: InputMaybe<Scalars['Int']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  height_not?: InputMaybe<Scalars['Int']['input']>;
  /** All values that are not contained in given list. */
  height_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  locationItem?: InputMaybe<LocationItemWhereInput>;
  mediaLibrary?: InputMaybe<MediaLibraryWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SpacerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SpacerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SpacerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SpacerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SpacerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Spacer record uniquely */
export type SpacerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Stage system enumeration */
export enum Stage {
  /** The Draft is the default stage for all your content. */
  DRAFT = 'DRAFT',
  /** The Published stage is where you can publish your content to. */
  PUBLISHED = 'PUBLISHED'
}

/** Corporate Stories */
export type Story = Entity & Node & {
  __typename?: 'Story';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Allows granular control over what date is shown in UI as press release date */
  date?: Maybe<Scalars['Date']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<Story>;
  /** List of Story versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  image?: Maybe<Asset>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Story>;
  markets: Array<Markets>;
  metaData?: Maybe<MetaData>;
  pageComponents: Array<StoryPageComponents>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  slug?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  storyTagEnum?: Maybe<CorpStoryTagEnum>;
  /** Teaser/Snippet */
  teaser: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Corporate Stories */
export type StoryCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Corporate Stories */
export type StoryCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Corporate Stories */
export type StoryDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Corporate Stories */
export type StoryHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Corporate Stories */
export type StoryImageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


/** Corporate Stories */
export type StoryLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Corporate Stories */
export type StoryMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Corporate Stories */
export type StoryPageComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** Corporate Stories */
export type StoryPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Corporate Stories */
export type StoryPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Corporate Stories */
export type StoryScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Corporate Stories */
export type StoryUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Corporate Stories */
export type StoryUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type StoryConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: StoryWhereUniqueInput;
};

/** A connection to a list of items. */
export type StoryConnection = {
  __typename?: 'StoryConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<StoryEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type StoryCreateInput = {
  cm9gy9xnd01gj06ulezx6dqfm?: InputMaybe<CorpStoryCarouselCreateManyInlineInput>;
  cm9k0a3xq00qj07w1fhui7b2b?: InputMaybe<CorpCardCarouselCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  image?: InputMaybe<AssetCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<StoryCreateLocalizationsInput>;
  markets?: InputMaybe<Array<Markets>>;
  metaData?: InputMaybe<MetaDataCreateOneInlineInput>;
  pageComponents?: InputMaybe<StoryPageComponentsCreateManyInlineInput>;
  /** slug input for default locale (default) */
  slug?: InputMaybe<Scalars['String']['input']>;
  storyTagEnum?: InputMaybe<CorpStoryTagEnum>;
  /** teaser input for default locale (default) */
  teaser: Scalars['String']['input'];
  /** title input for default locale (default) */
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StoryCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  teaser: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StoryCreateLocalizationInput = {
  /** Localization input */
  data: StoryCreateLocalizationDataInput;
  locale: Locale;
};

export type StoryCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<StoryCreateLocalizationInput>>;
};

export type StoryCreateManyInlineInput = {
  /** Connect multiple existing Story documents */
  connect?: InputMaybe<Array<StoryWhereUniqueInput>>;
  /** Create and connect multiple existing Story documents */
  create?: InputMaybe<Array<StoryCreateInput>>;
};

export type StoryCreateOneInlineInput = {
  /** Connect one existing Story document */
  connect?: InputMaybe<StoryWhereUniqueInput>;
  /** Create and connect one Story document */
  create?: InputMaybe<StoryCreateInput>;
};

/** An edge in a connection. */
export type StoryEdge = {
  __typename?: 'StoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Story;
};

/** Identifies documents */
export type StoryManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<StoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<StoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<StoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  date_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  date_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  date_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  date_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  documentInStages_every?: InputMaybe<StoryWhereStageInput>;
  documentInStages_none?: InputMaybe<StoryWhereStageInput>;
  documentInStages_some?: InputMaybe<StoryWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  markets?: InputMaybe<Array<Markets>>;
  /** Matches if the field array contains *all* items provided to the filter */
  markets_contains_all?: InputMaybe<Array<Markets>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  markets_contains_none?: InputMaybe<Array<Markets>>;
  /** Matches if the field array contains at least one item provided to the filter */
  markets_contains_some?: InputMaybe<Array<Markets>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  markets_not?: InputMaybe<Array<Markets>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<StoryPageComponentsWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  storyTagEnum?: InputMaybe<CorpStoryTagEnum>;
  /** All values that are contained in given list. */
  storyTagEnum_in?: InputMaybe<Array<InputMaybe<CorpStoryTagEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  storyTagEnum_not?: InputMaybe<CorpStoryTagEnum>;
  /** All values that are not contained in given list. */
  storyTagEnum_not_in?: InputMaybe<Array<InputMaybe<CorpStoryTagEnum>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum StoryOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  date_ASC = 'date_ASC',
  date_DESC = 'date_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  markets_ASC = 'markets_ASC',
  markets_DESC = 'markets_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  storyTagEnum_ASC = 'storyTagEnum_ASC',
  storyTagEnum_DESC = 'storyTagEnum_DESC',
  teaser_ASC = 'teaser_ASC',
  teaser_DESC = 'teaser_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type StoryPageComponents = AudioComponent | Banner2 | CarouselComponent | CorpBanner1 | CorpCardCarousel | CorpContactCardContainer | CorpGenericAccordion | CorpGenericContainer | CorpGridColumnComponent | GenericLine | IntroText | LongText | QuickLink | Spacer | Tab;

export type StoryPageComponentsConnectInput = {
  AudioComponent?: InputMaybe<AudioComponentConnectInput>;
  Banner2?: InputMaybe<Banner2ConnectInput>;
  CarouselComponent?: InputMaybe<CarouselComponentConnectInput>;
  CorpBanner1?: InputMaybe<CorpBanner1ConnectInput>;
  CorpCardCarousel?: InputMaybe<CorpCardCarouselConnectInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerConnectInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionConnectInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerConnectInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentConnectInput>;
  GenericLine?: InputMaybe<GenericLineConnectInput>;
  IntroText?: InputMaybe<IntroTextConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
  QuickLink?: InputMaybe<QuickLinkConnectInput>;
  Spacer?: InputMaybe<SpacerConnectInput>;
  Tab?: InputMaybe<TabConnectInput>;
};

export type StoryPageComponentsCreateInput = {
  AudioComponent?: InputMaybe<AudioComponentCreateInput>;
  Banner2?: InputMaybe<Banner2CreateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentCreateInput>;
  CorpBanner1?: InputMaybe<CorpBanner1CreateInput>;
  CorpCardCarousel?: InputMaybe<CorpCardCarouselCreateInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerCreateInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionCreateInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerCreateInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentCreateInput>;
  GenericLine?: InputMaybe<GenericLineCreateInput>;
  IntroText?: InputMaybe<IntroTextCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
  QuickLink?: InputMaybe<QuickLinkCreateInput>;
  Spacer?: InputMaybe<SpacerCreateInput>;
  Tab?: InputMaybe<TabCreateInput>;
};

export type StoryPageComponentsCreateManyInlineInput = {
  /** Connect multiple existing StoryPageComponents documents */
  connect?: InputMaybe<Array<StoryPageComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing StoryPageComponents documents */
  create?: InputMaybe<Array<StoryPageComponentsCreateInput>>;
};

export type StoryPageComponentsCreateOneInlineInput = {
  /** Connect one existing StoryPageComponents document */
  connect?: InputMaybe<StoryPageComponentsWhereUniqueInput>;
  /** Create and connect one StoryPageComponents document */
  create?: InputMaybe<StoryPageComponentsCreateInput>;
};

export type StoryPageComponentsUpdateInput = {
  AudioComponent?: InputMaybe<AudioComponentUpdateInput>;
  Banner2?: InputMaybe<Banner2UpdateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpdateInput>;
  CorpCardCarousel?: InputMaybe<CorpCardCarouselUpdateInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpdateInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpdateInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateInput>;
  GenericLine?: InputMaybe<GenericLineUpdateInput>;
  IntroText?: InputMaybe<IntroTextUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateInput>;
  Spacer?: InputMaybe<SpacerUpdateInput>;
  Tab?: InputMaybe<TabUpdateInput>;
};

export type StoryPageComponentsUpdateManyInlineInput = {
  /** Connect multiple existing StoryPageComponents documents */
  connect?: InputMaybe<Array<StoryPageComponentsConnectInput>>;
  /** Create and connect multiple StoryPageComponents documents */
  create?: InputMaybe<Array<StoryPageComponentsCreateInput>>;
  /** Delete multiple StoryPageComponents documents */
  delete?: InputMaybe<Array<StoryPageComponentsWhereUniqueInput>>;
  /** Disconnect multiple StoryPageComponents documents */
  disconnect?: InputMaybe<Array<StoryPageComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing StoryPageComponents documents */
  set?: InputMaybe<Array<StoryPageComponentsWhereUniqueInput>>;
  /** Update multiple StoryPageComponents documents */
  update?: InputMaybe<Array<StoryPageComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple StoryPageComponents documents */
  upsert?: InputMaybe<Array<StoryPageComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type StoryPageComponentsUpdateManyWithNestedWhereInput = {
  AudioComponent?: InputMaybe<AudioComponentUpdateManyWithNestedWhereInput>;
  Banner2?: InputMaybe<Banner2UpdateManyWithNestedWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateManyWithNestedWhereInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpdateManyWithNestedWhereInput>;
  CorpCardCarousel?: InputMaybe<CorpCardCarouselUpdateManyWithNestedWhereInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpdateManyWithNestedWhereInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpdateManyWithNestedWhereInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateManyWithNestedWhereInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateManyWithNestedWhereInput>;
  GenericLine?: InputMaybe<GenericLineUpdateManyWithNestedWhereInput>;
  IntroText?: InputMaybe<IntroTextUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateManyWithNestedWhereInput>;
  Spacer?: InputMaybe<SpacerUpdateManyWithNestedWhereInput>;
  Tab?: InputMaybe<TabUpdateManyWithNestedWhereInput>;
};

export type StoryPageComponentsUpdateOneInlineInput = {
  /** Connect existing StoryPageComponents document */
  connect?: InputMaybe<StoryPageComponentsWhereUniqueInput>;
  /** Create and connect one StoryPageComponents document */
  create?: InputMaybe<StoryPageComponentsCreateInput>;
  /** Delete currently connected StoryPageComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected StoryPageComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single StoryPageComponents document */
  update?: InputMaybe<StoryPageComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single StoryPageComponents document */
  upsert?: InputMaybe<StoryPageComponentsUpsertWithNestedWhereUniqueInput>;
};

export type StoryPageComponentsUpdateWithNestedWhereUniqueInput = {
  AudioComponent?: InputMaybe<AudioComponentUpdateWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpdateWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateWithNestedWhereUniqueInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpdateWithNestedWhereUniqueInput>;
  CorpCardCarousel?: InputMaybe<CorpCardCarouselUpdateWithNestedWhereUniqueInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpdateWithNestedWhereUniqueInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpdateWithNestedWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpdateWithNestedWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateWithNestedWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineUpdateWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpdateWithNestedWhereUniqueInput>;
  Tab?: InputMaybe<TabUpdateWithNestedWhereUniqueInput>;
};

export type StoryPageComponentsUpsertWithNestedWhereUniqueInput = {
  AudioComponent?: InputMaybe<AudioComponentUpsertWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpsertWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpsertWithNestedWhereUniqueInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpsertWithNestedWhereUniqueInput>;
  CorpCardCarousel?: InputMaybe<CorpCardCarouselUpsertWithNestedWhereUniqueInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerUpsertWithNestedWhereUniqueInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpsertWithNestedWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerUpsertWithNestedWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpsertWithNestedWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineUpsertWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkUpsertWithNestedWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerUpsertWithNestedWhereUniqueInput>;
  Tab?: InputMaybe<TabUpsertWithNestedWhereUniqueInput>;
};

export type StoryPageComponentsWhereInput = {
  AudioComponent?: InputMaybe<AudioComponentWhereInput>;
  Banner2?: InputMaybe<Banner2WhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  CorpBanner1?: InputMaybe<CorpBanner1WhereInput>;
  CorpCardCarousel?: InputMaybe<CorpCardCarouselWhereInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerWhereInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionWhereInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerWhereInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentWhereInput>;
  GenericLine?: InputMaybe<GenericLineWhereInput>;
  IntroText?: InputMaybe<IntroTextWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
  QuickLink?: InputMaybe<QuickLinkWhereInput>;
  Spacer?: InputMaybe<SpacerWhereInput>;
  Tab?: InputMaybe<TabWhereInput>;
};

export type StoryPageComponentsWhereUniqueInput = {
  AudioComponent?: InputMaybe<AudioComponentWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2WhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereUniqueInput>;
  CorpBanner1?: InputMaybe<CorpBanner1WhereUniqueInput>;
  CorpCardCarousel?: InputMaybe<CorpCardCarouselWhereUniqueInput>;
  CorpContactCardContainer?: InputMaybe<CorpContactCardContainerWhereUniqueInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionWhereUniqueInput>;
  CorpGenericContainer?: InputMaybe<CorpGenericContainerWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkWhereUniqueInput>;
  Spacer?: InputMaybe<SpacerWhereUniqueInput>;
  Tab?: InputMaybe<TabWhereUniqueInput>;
};

export type StoryUpdateInput = {
  cm9gy9xnd01gj06ulezx6dqfm?: InputMaybe<CorpStoryCarouselUpdateManyInlineInput>;
  cm9k0a3xq00qj07w1fhui7b2b?: InputMaybe<CorpCardCarouselUpdateManyInlineInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  image?: InputMaybe<AssetUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<StoryUpdateLocalizationsInput>;
  markets?: InputMaybe<Array<Markets>>;
  metaData?: InputMaybe<MetaDataUpdateOneInlineInput>;
  pageComponents?: InputMaybe<StoryPageComponentsUpdateManyInlineInput>;
  /** slug input for default locale (default) */
  slug?: InputMaybe<Scalars['String']['input']>;
  storyTagEnum?: InputMaybe<CorpStoryTagEnum>;
  /** teaser input for default locale (default) */
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StoryUpdateLocalizationDataInput = {
  slug?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StoryUpdateLocalizationInput = {
  data: StoryUpdateLocalizationDataInput;
  locale: Locale;
};

export type StoryUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<StoryCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<StoryUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<StoryUpsertLocalizationInput>>;
};

export type StoryUpdateManyInlineInput = {
  /** Connect multiple existing Story documents */
  connect?: InputMaybe<Array<StoryConnectInput>>;
  /** Create and connect multiple Story documents */
  create?: InputMaybe<Array<StoryCreateInput>>;
  /** Delete multiple Story documents */
  delete?: InputMaybe<Array<StoryWhereUniqueInput>>;
  /** Disconnect multiple Story documents */
  disconnect?: InputMaybe<Array<StoryWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Story documents */
  set?: InputMaybe<Array<StoryWhereUniqueInput>>;
  /** Update multiple Story documents */
  update?: InputMaybe<Array<StoryUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Story documents */
  upsert?: InputMaybe<Array<StoryUpsertWithNestedWhereUniqueInput>>;
};

export type StoryUpdateManyInput = {
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<StoryUpdateManyLocalizationsInput>;
  markets?: InputMaybe<Array<Markets>>;
  storyTagEnum?: InputMaybe<CorpStoryTagEnum>;
  /** teaser input for default locale (default) */
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StoryUpdateManyLocalizationDataInput = {
  teaser?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type StoryUpdateManyLocalizationInput = {
  data: StoryUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type StoryUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<StoryUpdateManyLocalizationInput>>;
};

export type StoryUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: StoryUpdateManyInput;
  /** Document search */
  where: StoryWhereInput;
};

export type StoryUpdateOneInlineInput = {
  /** Connect existing Story document */
  connect?: InputMaybe<StoryWhereUniqueInput>;
  /** Create and connect one Story document */
  create?: InputMaybe<StoryCreateInput>;
  /** Delete currently connected Story document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Story document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Story document */
  update?: InputMaybe<StoryUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Story document */
  upsert?: InputMaybe<StoryUpsertWithNestedWhereUniqueInput>;
};

export type StoryUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: StoryUpdateInput;
  /** Unique document search */
  where: StoryWhereUniqueInput;
};

export type StoryUpsertInput = {
  /** Create document if it didn't exist */
  create: StoryCreateInput;
  /** Update document if it exists */
  update: StoryUpdateInput;
};

export type StoryUpsertLocalizationInput = {
  create: StoryCreateLocalizationDataInput;
  locale: Locale;
  update: StoryUpdateLocalizationDataInput;
};

export type StoryUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: StoryUpsertInput;
  /** Unique document search */
  where: StoryWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type StoryWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type StoryWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<StoryWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<StoryWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<StoryWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  date?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than the given value. */
  date_gt?: InputMaybe<Scalars['Date']['input']>;
  /** All values greater than or equal the given value. */
  date_gte?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are contained in given list. */
  date_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  /** All values less than the given value. */
  date_lt?: InputMaybe<Scalars['Date']['input']>;
  /** All values less than or equal the given value. */
  date_lte?: InputMaybe<Scalars['Date']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  date_not?: InputMaybe<Scalars['Date']['input']>;
  /** All values that are not contained in given list. */
  date_not_in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  documentInStages_every?: InputMaybe<StoryWhereStageInput>;
  documentInStages_none?: InputMaybe<StoryWhereStageInput>;
  documentInStages_some?: InputMaybe<StoryWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<AssetWhereInput>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  markets?: InputMaybe<Array<Markets>>;
  /** Matches if the field array contains *all* items provided to the filter */
  markets_contains_all?: InputMaybe<Array<Markets>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  markets_contains_none?: InputMaybe<Array<Markets>>;
  /** Matches if the field array contains at least one item provided to the filter */
  markets_contains_some?: InputMaybe<Array<Markets>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  markets_not?: InputMaybe<Array<Markets>>;
  metaData?: InputMaybe<MetaDataWhereInput>;
  /** All values in which the union is empty */
  pageComponents_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  pageComponents_some?: InputMaybe<StoryPageComponentsWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  slug_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  storyTagEnum?: InputMaybe<CorpStoryTagEnum>;
  /** All values that are contained in given list. */
  storyTagEnum_in?: InputMaybe<Array<InputMaybe<CorpStoryTagEnum>>>;
  /** Any other value that exists and is not equal to the given value. */
  storyTagEnum_not?: InputMaybe<CorpStoryTagEnum>;
  /** All values that are not contained in given list. */
  storyTagEnum_not_in?: InputMaybe<Array<InputMaybe<CorpStoryTagEnum>>>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  teaser_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  teaser_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  teaser_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  teaser_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  teaser_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  teaser_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  teaser_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  teaser_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  teaser_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type StoryWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<StoryWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<StoryWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<StoryWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<StoryWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Story record uniquely */
export type StoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SubCategoryKeyImage = Entity & Node & {
  __typename?: 'SubCategoryKeyImage';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SubCategoryKeyImage>;
  /** Image for use on the category & subcategory component that displays on the all recipes page */
  forAllRecipePages?: Maybe<Asset>;
  /** Image for use on subcategory component that displays on recipe category pages */
  forRecipeCategoryPage?: Maybe<Asset>;
  /** List of SubCategoryKeyImage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type SubCategoryKeyImageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SubCategoryKeyImageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type SubCategoryKeyImageForAllRecipePagesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type SubCategoryKeyImageForRecipeCategoryPageArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  where?: InputMaybe<AssetSingleRelationWhereInput>;
};


export type SubCategoryKeyImageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type SubCategoryKeyImagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type SubCategoryKeyImageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type SubCategoryKeyImageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SubCategoryKeyImageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SubCategoryKeyImageWhereUniqueInput;
};

/** A connection to a list of items. */
export type SubCategoryKeyImageConnection = {
  __typename?: 'SubCategoryKeyImageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SubCategoryKeyImageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SubCategoryKeyImageCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  forAllRecipePages?: InputMaybe<AssetCreateOneInlineInput>;
  forRecipeCategoryPage?: InputMaybe<AssetCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubCategoryKeyImageCreateManyInlineInput = {
  /** Connect multiple existing SubCategoryKeyImage documents */
  connect?: InputMaybe<Array<SubCategoryKeyImageWhereUniqueInput>>;
  /** Create and connect multiple existing SubCategoryKeyImage documents */
  create?: InputMaybe<Array<SubCategoryKeyImageCreateInput>>;
};

export type SubCategoryKeyImageCreateOneInlineInput = {
  /** Connect one existing SubCategoryKeyImage document */
  connect?: InputMaybe<SubCategoryKeyImageWhereUniqueInput>;
  /** Create and connect one SubCategoryKeyImage document */
  create?: InputMaybe<SubCategoryKeyImageCreateInput>;
};

/** An edge in a connection. */
export type SubCategoryKeyImageEdge = {
  __typename?: 'SubCategoryKeyImageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SubCategoryKeyImage;
};

/** Identifies documents */
export type SubCategoryKeyImageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SubCategoryKeyImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SubCategoryKeyImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SubCategoryKeyImageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SubCategoryKeyImageWhereStageInput>;
  documentInStages_none?: InputMaybe<SubCategoryKeyImageWhereStageInput>;
  documentInStages_some?: InputMaybe<SubCategoryKeyImageWhereStageInput>;
  forAllRecipePages?: InputMaybe<AssetWhereInput>;
  forRecipeCategoryPage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum SubCategoryKeyImageOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SubCategoryKeyImageUpdateInput = {
  forAllRecipePages?: InputMaybe<AssetUpdateOneInlineInput>;
  forRecipeCategoryPage?: InputMaybe<AssetUpdateOneInlineInput>;
};

export type SubCategoryKeyImageUpdateManyInlineInput = {
  /** Connect multiple existing SubCategoryKeyImage documents */
  connect?: InputMaybe<Array<SubCategoryKeyImageConnectInput>>;
  /** Create and connect multiple SubCategoryKeyImage documents */
  create?: InputMaybe<Array<SubCategoryKeyImageCreateInput>>;
  /** Delete multiple SubCategoryKeyImage documents */
  delete?: InputMaybe<Array<SubCategoryKeyImageWhereUniqueInput>>;
  /** Disconnect multiple SubCategoryKeyImage documents */
  disconnect?: InputMaybe<Array<SubCategoryKeyImageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SubCategoryKeyImage documents */
  set?: InputMaybe<Array<SubCategoryKeyImageWhereUniqueInput>>;
  /** Update multiple SubCategoryKeyImage documents */
  update?: InputMaybe<Array<SubCategoryKeyImageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SubCategoryKeyImage documents */
  upsert?: InputMaybe<Array<SubCategoryKeyImageUpsertWithNestedWhereUniqueInput>>;
};

export type SubCategoryKeyImageUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type SubCategoryKeyImageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SubCategoryKeyImageUpdateManyInput;
  /** Document search */
  where: SubCategoryKeyImageWhereInput;
};

export type SubCategoryKeyImageUpdateOneInlineInput = {
  /** Connect existing SubCategoryKeyImage document */
  connect?: InputMaybe<SubCategoryKeyImageWhereUniqueInput>;
  /** Create and connect one SubCategoryKeyImage document */
  create?: InputMaybe<SubCategoryKeyImageCreateInput>;
  /** Delete currently connected SubCategoryKeyImage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SubCategoryKeyImage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SubCategoryKeyImage document */
  update?: InputMaybe<SubCategoryKeyImageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SubCategoryKeyImage document */
  upsert?: InputMaybe<SubCategoryKeyImageUpsertWithNestedWhereUniqueInput>;
};

export type SubCategoryKeyImageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SubCategoryKeyImageUpdateInput;
  /** Unique document search */
  where: SubCategoryKeyImageWhereUniqueInput;
};

export type SubCategoryKeyImageUpsertInput = {
  /** Create document if it didn't exist */
  create: SubCategoryKeyImageCreateInput;
  /** Update document if it exists */
  update: SubCategoryKeyImageUpdateInput;
};

export type SubCategoryKeyImageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SubCategoryKeyImageUpsertInput;
  /** Unique document search */
  where: SubCategoryKeyImageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SubCategoryKeyImageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SubCategoryKeyImageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SubCategoryKeyImageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SubCategoryKeyImageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SubCategoryKeyImageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SubCategoryKeyImageWhereStageInput>;
  documentInStages_none?: InputMaybe<SubCategoryKeyImageWhereStageInput>;
  documentInStages_some?: InputMaybe<SubCategoryKeyImageWhereStageInput>;
  forAllRecipePages?: InputMaybe<AssetWhereInput>;
  forRecipeCategoryPage?: InputMaybe<AssetWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SubCategoryKeyImageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SubCategoryKeyImageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SubCategoryKeyImageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SubCategoryKeyImageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SubCategoryKeyImageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SubCategoryKeyImage record uniquely */
export type SubCategoryKeyImageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Banner for sustainability teaser information */
export type SustainabilityBanner = Entity & Node & {
  __typename?: 'SustainabilityBanner';
  anchorNav?: Maybe<AnchorNavigation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get the document in other stages */
  documentInStages: Array<SustainabilityBanner>;
  /** List of SustainabilityBanner versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  link?: Maybe<Link>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<SustainabilityBanner>;
  lowerRightCorner?: Maybe<AssetComponent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  superText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  upperLeftCorner?: Maybe<AssetComponent>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerLinkArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerLowerRightCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Banner for sustainability teaser information */
export type SustainabilityBannerUpperLeftCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SustainabilityBannerConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SustainabilityBannerWhereUniqueInput;
};

/** A connection to a list of items. */
export type SustainabilityBannerConnection = {
  __typename?: 'SustainabilityBannerConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SustainabilityBannerEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SustainabilityBannerCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cktby1ql611f501z7g4f27jd7?: InputMaybe<TipsAndTricksDetailsPageCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkCreateOneInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SustainabilityBannerCreateLocalizationsInput>;
  lowerRightCorner?: InputMaybe<AssetComponentCreateOneInlineInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  upperLeftCorner?: InputMaybe<AssetComponentCreateOneInlineInput>;
};

export type SustainabilityBannerCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SustainabilityBannerCreateLocalizationInput = {
  /** Localization input */
  data: SustainabilityBannerCreateLocalizationDataInput;
  locale: Locale;
};

export type SustainabilityBannerCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SustainabilityBannerCreateLocalizationInput>>;
};

export type SustainabilityBannerCreateManyInlineInput = {
  /** Connect multiple existing SustainabilityBanner documents */
  connect?: InputMaybe<Array<SustainabilityBannerWhereUniqueInput>>;
  /** Create and connect multiple existing SustainabilityBanner documents */
  create?: InputMaybe<Array<SustainabilityBannerCreateInput>>;
};

export type SustainabilityBannerCreateOneInlineInput = {
  /** Connect one existing SustainabilityBanner document */
  connect?: InputMaybe<SustainabilityBannerWhereUniqueInput>;
  /** Create and connect one SustainabilityBanner document */
  create?: InputMaybe<SustainabilityBannerCreateInput>;
};

/** An edge in a connection. */
export type SustainabilityBannerEdge = {
  __typename?: 'SustainabilityBannerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SustainabilityBanner;
};

/** Identifies documents */
export type SustainabilityBannerManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SustainabilityBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SustainabilityBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SustainabilityBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<SustainabilityBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<SustainabilityBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<SustainabilityBannerWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  lowerRightCorner?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upperLeftCorner?: InputMaybe<AssetComponentWhereInput>;
};

export enum SustainabilityBannerOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superText_ASC = 'superText_ASC',
  superText_DESC = 'superText_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SustainabilityBannerUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cktby1ql611f501z7g4f27jd7?: InputMaybe<TipsAndTricksDetailsPageUpdateManyInlineInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<LinkUpdateOneInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<SustainabilityBannerUpdateLocalizationsInput>;
  lowerRightCorner?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  upperLeftCorner?: InputMaybe<AssetComponentUpdateOneInlineInput>;
};

export type SustainabilityBannerUpdateLocalizationDataInput = {
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SustainabilityBannerUpdateLocalizationInput = {
  data: SustainabilityBannerUpdateLocalizationDataInput;
  locale: Locale;
};

export type SustainabilityBannerUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SustainabilityBannerCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<SustainabilityBannerUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<SustainabilityBannerUpsertLocalizationInput>>;
};

export type SustainabilityBannerUpdateManyInlineInput = {
  /** Connect multiple existing SustainabilityBanner documents */
  connect?: InputMaybe<Array<SustainabilityBannerConnectInput>>;
  /** Create and connect multiple SustainabilityBanner documents */
  create?: InputMaybe<Array<SustainabilityBannerCreateInput>>;
  /** Delete multiple SustainabilityBanner documents */
  delete?: InputMaybe<Array<SustainabilityBannerWhereUniqueInput>>;
  /** Disconnect multiple SustainabilityBanner documents */
  disconnect?: InputMaybe<Array<SustainabilityBannerWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SustainabilityBanner documents */
  set?: InputMaybe<Array<SustainabilityBannerWhereUniqueInput>>;
  /** Update multiple SustainabilityBanner documents */
  update?: InputMaybe<Array<SustainabilityBannerUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SustainabilityBanner documents */
  upsert?: InputMaybe<Array<SustainabilityBannerUpsertWithNestedWhereUniqueInput>>;
};

export type SustainabilityBannerUpdateManyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<SustainabilityBannerUpdateManyLocalizationsInput>;
  /** superText input for default locale (default) */
  superText?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SustainabilityBannerUpdateManyLocalizationDataInput = {
  superText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SustainabilityBannerUpdateManyLocalizationInput = {
  data: SustainabilityBannerUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type SustainabilityBannerUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SustainabilityBannerUpdateManyLocalizationInput>>;
};

export type SustainabilityBannerUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SustainabilityBannerUpdateManyInput;
  /** Document search */
  where: SustainabilityBannerWhereInput;
};

export type SustainabilityBannerUpdateOneInlineInput = {
  /** Connect existing SustainabilityBanner document */
  connect?: InputMaybe<SustainabilityBannerWhereUniqueInput>;
  /** Create and connect one SustainabilityBanner document */
  create?: InputMaybe<SustainabilityBannerCreateInput>;
  /** Delete currently connected SustainabilityBanner document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SustainabilityBanner document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SustainabilityBanner document */
  update?: InputMaybe<SustainabilityBannerUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SustainabilityBanner document */
  upsert?: InputMaybe<SustainabilityBannerUpsertWithNestedWhereUniqueInput>;
};

export type SustainabilityBannerUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SustainabilityBannerUpdateInput;
  /** Unique document search */
  where: SustainabilityBannerWhereUniqueInput;
};

export type SustainabilityBannerUpsertInput = {
  /** Create document if it didn't exist */
  create: SustainabilityBannerCreateInput;
  /** Update document if it exists */
  update: SustainabilityBannerUpdateInput;
};

export type SustainabilityBannerUpsertLocalizationInput = {
  create: SustainabilityBannerCreateLocalizationDataInput;
  locale: Locale;
  update: SustainabilityBannerUpdateLocalizationDataInput;
};

export type SustainabilityBannerUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SustainabilityBannerUpsertInput;
  /** Unique document search */
  where: SustainabilityBannerWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SustainabilityBannerWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SustainabilityBannerWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SustainabilityBannerWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SustainabilityBannerWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SustainabilityBannerWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  description_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  description_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  description_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  description_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  description_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  description_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  description_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  description_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  description_starts_with?: InputMaybe<Scalars['String']['input']>;
  documentInStages_every?: InputMaybe<SustainabilityBannerWhereStageInput>;
  documentInStages_none?: InputMaybe<SustainabilityBannerWhereStageInput>;
  documentInStages_some?: InputMaybe<SustainabilityBannerWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<LinkWhereInput>;
  lowerRightCorner?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superText?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superText_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superText_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superText_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superText_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superText_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superText_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superText_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superText_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superText_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upperLeftCorner?: InputMaybe<AssetComponentWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SustainabilityBannerWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SustainabilityBannerWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SustainabilityBannerWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SustainabilityBannerWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SustainabilityBannerWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SustainabilityBanner record uniquely */
export type SustainabilityBannerWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfo = Entity & Node & {
  __typename?: 'SustainabilityInfo';
  /** This title is not displayed on the website; it is only used to identify this item within CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<SustainabilityInfo>;
  /** List of SustainabilityInfo versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Ingredients heading */
  ingredientsTitle?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<SustainabilityInfo>;
  lowerLeftCorner?: Maybe<AssetComponent>;
  lowerRightCorner?: Maybe<AssetComponent>;
  /** Packaging header */
  packagingTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Superscript heading */
  superHeading?: Maybe<Scalars['String']['output']>;
  /** Main heading */
  title?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  upperLeftCorner?: Maybe<AssetComponent>;
  upperRightCorner?: Maybe<AssetComponent>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoLowerLeftCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoLowerRightCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoUpperLeftCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Template to hold all the information for the sustainability section of the product pages */
export type SustainabilityInfoUpperRightCornerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type SustainabilityInfoConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: SustainabilityInfoWhereUniqueInput;
};

/** A connection to a list of items. */
export type SustainabilityInfoConnection = {
  __typename?: 'SustainabilityInfoConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<SustainabilityInfoEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type SustainabilityInfoCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** ingredientsTitle input for default locale (default) */
  ingredientsTitle?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<SustainabilityInfoCreateLocalizationsInput>;
  lowerLeftCorner?: InputMaybe<AssetComponentCreateOneInlineInput>;
  lowerRightCorner?: InputMaybe<AssetComponentCreateOneInlineInput>;
  /** packagingTitle input for default locale (default) */
  packagingTitle?: InputMaybe<Scalars['String']['input']>;
  /** superHeading input for default locale (default) */
  superHeading?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  upperLeftCorner?: InputMaybe<AssetComponentCreateOneInlineInput>;
  upperRightCorner?: InputMaybe<AssetComponentCreateOneInlineInput>;
};

export type SustainabilityInfoCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  ingredientsTitle?: InputMaybe<Scalars['String']['input']>;
  packagingTitle?: InputMaybe<Scalars['String']['input']>;
  superHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SustainabilityInfoCreateLocalizationInput = {
  /** Localization input */
  data: SustainabilityInfoCreateLocalizationDataInput;
  locale: Locale;
};

export type SustainabilityInfoCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<SustainabilityInfoCreateLocalizationInput>>;
};

export type SustainabilityInfoCreateManyInlineInput = {
  /** Connect multiple existing SustainabilityInfo documents */
  connect?: InputMaybe<Array<SustainabilityInfoWhereUniqueInput>>;
  /** Create and connect multiple existing SustainabilityInfo documents */
  create?: InputMaybe<Array<SustainabilityInfoCreateInput>>;
};

export type SustainabilityInfoCreateOneInlineInput = {
  /** Connect one existing SustainabilityInfo document */
  connect?: InputMaybe<SustainabilityInfoWhereUniqueInput>;
  /** Create and connect one SustainabilityInfo document */
  create?: InputMaybe<SustainabilityInfoCreateInput>;
};

/** An edge in a connection. */
export type SustainabilityInfoEdge = {
  __typename?: 'SustainabilityInfoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SustainabilityInfo;
};

/** Identifies documents */
export type SustainabilityInfoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SustainabilityInfoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SustainabilityInfoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SustainabilityInfoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SustainabilityInfoWhereStageInput>;
  documentInStages_none?: InputMaybe<SustainabilityInfoWhereStageInput>;
  documentInStages_some?: InputMaybe<SustainabilityInfoWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  lowerLeftCorner?: InputMaybe<AssetComponentWhereInput>;
  lowerRightCorner?: InputMaybe<AssetComponentWhereInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upperLeftCorner?: InputMaybe<AssetComponentWhereInput>;
  upperRightCorner?: InputMaybe<AssetComponentWhereInput>;
};

export enum SustainabilityInfoOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  ingredientsTitle_ASC = 'ingredientsTitle_ASC',
  ingredientsTitle_DESC = 'ingredientsTitle_DESC',
  packagingTitle_ASC = 'packagingTitle_ASC',
  packagingTitle_DESC = 'packagingTitle_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  superHeading_ASC = 'superHeading_ASC',
  superHeading_DESC = 'superHeading_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type SustainabilityInfoUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** ingredientsTitle input for default locale (default) */
  ingredientsTitle?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<SustainabilityInfoUpdateLocalizationsInput>;
  lowerLeftCorner?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  lowerRightCorner?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  /** packagingTitle input for default locale (default) */
  packagingTitle?: InputMaybe<Scalars['String']['input']>;
  /** superHeading input for default locale (default) */
  superHeading?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
  upperLeftCorner?: InputMaybe<AssetComponentUpdateOneInlineInput>;
  upperRightCorner?: InputMaybe<AssetComponentUpdateOneInlineInput>;
};

export type SustainabilityInfoUpdateLocalizationDataInput = {
  ingredientsTitle?: InputMaybe<Scalars['String']['input']>;
  packagingTitle?: InputMaybe<Scalars['String']['input']>;
  superHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SustainabilityInfoUpdateLocalizationInput = {
  data: SustainabilityInfoUpdateLocalizationDataInput;
  locale: Locale;
};

export type SustainabilityInfoUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<SustainabilityInfoCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<SustainabilityInfoUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<SustainabilityInfoUpsertLocalizationInput>>;
};

export type SustainabilityInfoUpdateManyInlineInput = {
  /** Connect multiple existing SustainabilityInfo documents */
  connect?: InputMaybe<Array<SustainabilityInfoConnectInput>>;
  /** Create and connect multiple SustainabilityInfo documents */
  create?: InputMaybe<Array<SustainabilityInfoCreateInput>>;
  /** Delete multiple SustainabilityInfo documents */
  delete?: InputMaybe<Array<SustainabilityInfoWhereUniqueInput>>;
  /** Disconnect multiple SustainabilityInfo documents */
  disconnect?: InputMaybe<Array<SustainabilityInfoWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing SustainabilityInfo documents */
  set?: InputMaybe<Array<SustainabilityInfoWhereUniqueInput>>;
  /** Update multiple SustainabilityInfo documents */
  update?: InputMaybe<Array<SustainabilityInfoUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SustainabilityInfo documents */
  upsert?: InputMaybe<Array<SustainabilityInfoUpsertWithNestedWhereUniqueInput>>;
};

export type SustainabilityInfoUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** ingredientsTitle input for default locale (default) */
  ingredientsTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<SustainabilityInfoUpdateManyLocalizationsInput>;
  /** packagingTitle input for default locale (default) */
  packagingTitle?: InputMaybe<Scalars['String']['input']>;
  /** superHeading input for default locale (default) */
  superHeading?: InputMaybe<Scalars['String']['input']>;
  /** title input for default locale (default) */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SustainabilityInfoUpdateManyLocalizationDataInput = {
  ingredientsTitle?: InputMaybe<Scalars['String']['input']>;
  packagingTitle?: InputMaybe<Scalars['String']['input']>;
  superHeading?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SustainabilityInfoUpdateManyLocalizationInput = {
  data: SustainabilityInfoUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type SustainabilityInfoUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<SustainabilityInfoUpdateManyLocalizationInput>>;
};

export type SustainabilityInfoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: SustainabilityInfoUpdateManyInput;
  /** Document search */
  where: SustainabilityInfoWhereInput;
};

export type SustainabilityInfoUpdateOneInlineInput = {
  /** Connect existing SustainabilityInfo document */
  connect?: InputMaybe<SustainabilityInfoWhereUniqueInput>;
  /** Create and connect one SustainabilityInfo document */
  create?: InputMaybe<SustainabilityInfoCreateInput>;
  /** Delete currently connected SustainabilityInfo document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected SustainabilityInfo document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single SustainabilityInfo document */
  update?: InputMaybe<SustainabilityInfoUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SustainabilityInfo document */
  upsert?: InputMaybe<SustainabilityInfoUpsertWithNestedWhereUniqueInput>;
};

export type SustainabilityInfoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: SustainabilityInfoUpdateInput;
  /** Unique document search */
  where: SustainabilityInfoWhereUniqueInput;
};

export type SustainabilityInfoUpsertInput = {
  /** Create document if it didn't exist */
  create: SustainabilityInfoCreateInput;
  /** Update document if it exists */
  update: SustainabilityInfoUpdateInput;
};

export type SustainabilityInfoUpsertLocalizationInput = {
  create: SustainabilityInfoCreateLocalizationDataInput;
  locale: Locale;
  update: SustainabilityInfoUpdateLocalizationDataInput;
};

export type SustainabilityInfoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: SustainabilityInfoUpsertInput;
  /** Unique document search */
  where: SustainabilityInfoWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type SustainabilityInfoWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type SustainabilityInfoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SustainabilityInfoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SustainabilityInfoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SustainabilityInfoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<SustainabilityInfoWhereStageInput>;
  documentInStages_none?: InputMaybe<SustainabilityInfoWhereStageInput>;
  documentInStages_some?: InputMaybe<SustainabilityInfoWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  ingredientsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  ingredientsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  ingredientsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  ingredientsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  ingredientsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  ingredientsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  ingredientsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  ingredientsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  ingredientsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  ingredientsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  lowerLeftCorner?: InputMaybe<AssetComponentWhereInput>;
  lowerRightCorner?: InputMaybe<AssetComponentWhereInput>;
  packagingTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  packagingTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  packagingTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  packagingTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  packagingTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  packagingTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  packagingTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  packagingTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  packagingTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  packagingTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  superHeading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  superHeading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  superHeading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  superHeading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  superHeading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  superHeading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  superHeading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  superHeading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  superHeading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  superHeading_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  upperLeftCorner?: InputMaybe<AssetComponentWhereInput>;
  upperRightCorner?: InputMaybe<AssetComponentWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type SustainabilityInfoWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<SustainabilityInfoWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<SustainabilityInfoWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<SustainabilityInfoWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<SustainabilityInfoWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References SustainabilityInfo record uniquely */
export type SustainabilityInfoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum SystemDateTimeFieldVariation {
  BASE = 'BASE',
  COMBINED = 'COMBINED',
  LOCALIZATION = 'LOCALIZATION'
}

/** A collection of tabs that can be rendered on screen. */
export type Tab = Entity & Node & {
  __typename?: 'Tab';
  anchorNav?: Maybe<AnchorNavigation>;
  /** A title to uniquely identify the name of collection of different tabs based on the usage. */
  cmsTabTitle: Scalars['String']['output'];
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Tab>;
  genericPages: Array<GenericPage>;
  /** List of Tab versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  stories: Array<Story>;
  /** Contains tabs that can come. */
  tabs: Array<TabContent>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabGenericPagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<GenericPageWhereInput>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabStoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StoryWhereInput>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabTabsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  orderBy?: InputMaybe<TabContentOrderByInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TabContentWhereInput>;
};


/** A collection of tabs that can be rendered on screen. */
export type TabUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TabConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TabWhereUniqueInput;
};

/** A connection to a list of items. */
export type TabConnection = {
  __typename?: 'TabConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TabEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContent = Entity & Node & {
  __typename?: 'TabContent';
  /** list of components that can be held by a particular tab. */
  components: Array<TabContentComponents>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<TabContent>;
  /** List of TabContent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<TabContent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Name of the tab, this is the clickable element which will open the components held by a particular tab. */
  tabTitle: Scalars['String']['output'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentComponentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** A schema for an individual tab, a tab contents might include tab title and multiple generic components. */
export type TabContentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TabContentComponents = AuthorableContentCard | Banner2 | CardComponent | CarouselComponent | CorpBanner1 | CorpGenericAccordion | CorpGridColumnComponent | DynamicCardGrid | EvalancheFormComponent | Form | GenericAccordionTopRated | GenericCardCarouseComponent | GenericDownloadComponent | GenericFollowUs | GenericLine | HeroCarouselComponent | Iframe | ImageCopy | IntroText | Link | LongText | QuickLink | SocialMediaListComponent;

export type TabContentComponentsConnectInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardConnectInput>;
  Banner2?: InputMaybe<Banner2ConnectInput>;
  CardComponent?: InputMaybe<CardComponentConnectInput>;
  CarouselComponent?: InputMaybe<CarouselComponentConnectInput>;
  CorpBanner1?: InputMaybe<CorpBanner1ConnectInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionConnectInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentConnectInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridConnectInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentConnectInput>;
  Form?: InputMaybe<FormConnectInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedConnectInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentConnectInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentConnectInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsConnectInput>;
  GenericLine?: InputMaybe<GenericLineConnectInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentConnectInput>;
  Iframe?: InputMaybe<IframeConnectInput>;
  ImageCopy?: InputMaybe<ImageCopyConnectInput>;
  IntroText?: InputMaybe<IntroTextConnectInput>;
  Link?: InputMaybe<LinkConnectInput>;
  LongText?: InputMaybe<LongTextConnectInput>;
  QuickLink?: InputMaybe<QuickLinkConnectInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentConnectInput>;
};

export type TabContentComponentsCreateInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardCreateInput>;
  Banner2?: InputMaybe<Banner2CreateInput>;
  CardComponent?: InputMaybe<CardComponentCreateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentCreateInput>;
  CorpBanner1?: InputMaybe<CorpBanner1CreateInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionCreateInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentCreateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridCreateInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentCreateInput>;
  Form?: InputMaybe<FormCreateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedCreateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentCreateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentCreateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsCreateInput>;
  GenericLine?: InputMaybe<GenericLineCreateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentCreateInput>;
  Iframe?: InputMaybe<IframeCreateInput>;
  ImageCopy?: InputMaybe<ImageCopyCreateInput>;
  IntroText?: InputMaybe<IntroTextCreateInput>;
  Link?: InputMaybe<LinkCreateInput>;
  LongText?: InputMaybe<LongTextCreateInput>;
  QuickLink?: InputMaybe<QuickLinkCreateInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentCreateInput>;
};

export type TabContentComponentsCreateManyInlineInput = {
  /** Connect multiple existing TabContentComponents documents */
  connect?: InputMaybe<Array<TabContentComponentsWhereUniqueInput>>;
  /** Create and connect multiple existing TabContentComponents documents */
  create?: InputMaybe<Array<TabContentComponentsCreateInput>>;
};

export type TabContentComponentsCreateOneInlineInput = {
  /** Connect one existing TabContentComponents document */
  connect?: InputMaybe<TabContentComponentsWhereUniqueInput>;
  /** Create and connect one TabContentComponents document */
  create?: InputMaybe<TabContentComponentsCreateInput>;
};

export type TabContentComponentsUpdateInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateInput>;
  Banner2?: InputMaybe<Banner2UpdateInput>;
  CardComponent?: InputMaybe<CardComponentUpdateInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpdateInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpdateInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateInput>;
  Form?: InputMaybe<FormUpdateInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateInput>;
  GenericLine?: InputMaybe<GenericLineUpdateInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateInput>;
  Iframe?: InputMaybe<IframeUpdateInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateInput>;
  IntroText?: InputMaybe<IntroTextUpdateInput>;
  Link?: InputMaybe<LinkUpdateInput>;
  LongText?: InputMaybe<LongTextUpdateInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateInput>;
};

export type TabContentComponentsUpdateManyInlineInput = {
  /** Connect multiple existing TabContentComponents documents */
  connect?: InputMaybe<Array<TabContentComponentsConnectInput>>;
  /** Create and connect multiple TabContentComponents documents */
  create?: InputMaybe<Array<TabContentComponentsCreateInput>>;
  /** Delete multiple TabContentComponents documents */
  delete?: InputMaybe<Array<TabContentComponentsWhereUniqueInput>>;
  /** Disconnect multiple TabContentComponents documents */
  disconnect?: InputMaybe<Array<TabContentComponentsWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TabContentComponents documents */
  set?: InputMaybe<Array<TabContentComponentsWhereUniqueInput>>;
  /** Update multiple TabContentComponents documents */
  update?: InputMaybe<Array<TabContentComponentsUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TabContentComponents documents */
  upsert?: InputMaybe<Array<TabContentComponentsUpsertWithNestedWhereUniqueInput>>;
};

export type TabContentComponentsUpdateManyWithNestedWhereInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateManyWithNestedWhereInput>;
  Banner2?: InputMaybe<Banner2UpdateManyWithNestedWhereInput>;
  CardComponent?: InputMaybe<CardComponentUpdateManyWithNestedWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateManyWithNestedWhereInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpdateManyWithNestedWhereInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpdateManyWithNestedWhereInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateManyWithNestedWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateManyWithNestedWhereInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateManyWithNestedWhereInput>;
  Form?: InputMaybe<FormUpdateManyWithNestedWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateManyWithNestedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateManyWithNestedWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateManyWithNestedWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateManyWithNestedWhereInput>;
  GenericLine?: InputMaybe<GenericLineUpdateManyWithNestedWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateManyWithNestedWhereInput>;
  Iframe?: InputMaybe<IframeUpdateManyWithNestedWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateManyWithNestedWhereInput>;
  IntroText?: InputMaybe<IntroTextUpdateManyWithNestedWhereInput>;
  Link?: InputMaybe<LinkUpdateManyWithNestedWhereInput>;
  LongText?: InputMaybe<LongTextUpdateManyWithNestedWhereInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateManyWithNestedWhereInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateManyWithNestedWhereInput>;
};

export type TabContentComponentsUpdateOneInlineInput = {
  /** Connect existing TabContentComponents document */
  connect?: InputMaybe<TabContentComponentsWhereUniqueInput>;
  /** Create and connect one TabContentComponents document */
  create?: InputMaybe<TabContentComponentsCreateInput>;
  /** Delete currently connected TabContentComponents document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TabContentComponents document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TabContentComponents document */
  update?: InputMaybe<TabContentComponentsUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TabContentComponents document */
  upsert?: InputMaybe<TabContentComponentsUpsertWithNestedWhereUniqueInput>;
};

export type TabContentComponentsUpdateWithNestedWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpdateWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpdateWithNestedWhereUniqueInput>;
  CardComponent?: InputMaybe<CardComponentUpdateWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpdateWithNestedWhereUniqueInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpdateWithNestedWhereUniqueInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpdateWithNestedWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpdateWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpdateWithNestedWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpdateWithNestedWhereUniqueInput>;
  Form?: InputMaybe<FormUpdateWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpdateWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpdateWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpdateWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpdateWithNestedWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineUpdateWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpdateWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpdateWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpdateWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpdateWithNestedWhereUniqueInput>;
  Link?: InputMaybe<LinkUpdateWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpdateWithNestedWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkUpdateWithNestedWhereUniqueInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpdateWithNestedWhereUniqueInput>;
};

export type TabContentComponentsUpsertWithNestedWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardUpsertWithNestedWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2UpsertWithNestedWhereUniqueInput>;
  CardComponent?: InputMaybe<CardComponentUpsertWithNestedWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentUpsertWithNestedWhereUniqueInput>;
  CorpBanner1?: InputMaybe<CorpBanner1UpsertWithNestedWhereUniqueInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionUpsertWithNestedWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentUpsertWithNestedWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridUpsertWithNestedWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentUpsertWithNestedWhereUniqueInput>;
  Form?: InputMaybe<FormUpsertWithNestedWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedUpsertWithNestedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentUpsertWithNestedWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentUpsertWithNestedWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsUpsertWithNestedWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineUpsertWithNestedWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentUpsertWithNestedWhereUniqueInput>;
  Iframe?: InputMaybe<IframeUpsertWithNestedWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyUpsertWithNestedWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextUpsertWithNestedWhereUniqueInput>;
  Link?: InputMaybe<LinkUpsertWithNestedWhereUniqueInput>;
  LongText?: InputMaybe<LongTextUpsertWithNestedWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkUpsertWithNestedWhereUniqueInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentUpsertWithNestedWhereUniqueInput>;
};

export type TabContentComponentsWhereInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereInput>;
  Banner2?: InputMaybe<Banner2WhereInput>;
  CardComponent?: InputMaybe<CardComponentWhereInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereInput>;
  CorpBanner1?: InputMaybe<CorpBanner1WhereInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionWhereInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentWhereInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentWhereInput>;
  Form?: InputMaybe<FormWhereInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereInput>;
  GenericLine?: InputMaybe<GenericLineWhereInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereInput>;
  Iframe?: InputMaybe<IframeWhereInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereInput>;
  IntroText?: InputMaybe<IntroTextWhereInput>;
  Link?: InputMaybe<LinkWhereInput>;
  LongText?: InputMaybe<LongTextWhereInput>;
  QuickLink?: InputMaybe<QuickLinkWhereInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentWhereInput>;
};

export type TabContentComponentsWhereUniqueInput = {
  AuthorableContentCard?: InputMaybe<AuthorableContentCardWhereUniqueInput>;
  Banner2?: InputMaybe<Banner2WhereUniqueInput>;
  CardComponent?: InputMaybe<CardComponentWhereUniqueInput>;
  CarouselComponent?: InputMaybe<CarouselComponentWhereUniqueInput>;
  CorpBanner1?: InputMaybe<CorpBanner1WhereUniqueInput>;
  CorpGenericAccordion?: InputMaybe<CorpGenericAccordionWhereUniqueInput>;
  CorpGridColumnComponent?: InputMaybe<CorpGridColumnComponentWhereUniqueInput>;
  DynamicCardGrid?: InputMaybe<DynamicCardGridWhereUniqueInput>;
  EvalancheFormComponent?: InputMaybe<EvalancheFormComponentWhereUniqueInput>;
  Form?: InputMaybe<FormWhereUniqueInput>;
  GenericAccordionTopRated?: InputMaybe<GenericAccordionTopRatedWhereUniqueInput>;
  GenericCardCarouseComponent?: InputMaybe<GenericCardCarouseComponentWhereUniqueInput>;
  GenericDownloadComponent?: InputMaybe<GenericDownloadComponentWhereUniqueInput>;
  GenericFollowUs?: InputMaybe<GenericFollowUsWhereUniqueInput>;
  GenericLine?: InputMaybe<GenericLineWhereUniqueInput>;
  HeroCarouselComponent?: InputMaybe<HeroCarouselComponentWhereUniqueInput>;
  Iframe?: InputMaybe<IframeWhereUniqueInput>;
  ImageCopy?: InputMaybe<ImageCopyWhereUniqueInput>;
  IntroText?: InputMaybe<IntroTextWhereUniqueInput>;
  Link?: InputMaybe<LinkWhereUniqueInput>;
  LongText?: InputMaybe<LongTextWhereUniqueInput>;
  QuickLink?: InputMaybe<QuickLinkWhereUniqueInput>;
  SocialMediaListComponent?: InputMaybe<SocialMediaListComponentWhereUniqueInput>;
};

export type TabContentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TabContentWhereUniqueInput;
};

/** A connection to a list of items. */
export type TabContentConnection = {
  __typename?: 'TabContentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TabContentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TabContentCreateInput = {
  cksful2sa0yka01z2e9hsh1fp?: InputMaybe<TabCreateManyInlineInput>;
  components?: InputMaybe<TabContentComponentsCreateManyInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TabContentCreateLocalizationsInput>;
  /** tabTitle input for default locale (default) */
  tabTitle: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TabContentCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  tabTitle: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TabContentCreateLocalizationInput = {
  /** Localization input */
  data: TabContentCreateLocalizationDataInput;
  locale: Locale;
};

export type TabContentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TabContentCreateLocalizationInput>>;
};

export type TabContentCreateManyInlineInput = {
  /** Connect multiple existing TabContent documents */
  connect?: InputMaybe<Array<TabContentWhereUniqueInput>>;
  /** Create and connect multiple existing TabContent documents */
  create?: InputMaybe<Array<TabContentCreateInput>>;
};

export type TabContentCreateOneInlineInput = {
  /** Connect one existing TabContent document */
  connect?: InputMaybe<TabContentWhereUniqueInput>;
  /** Create and connect one TabContent document */
  create?: InputMaybe<TabContentCreateInput>;
};

/** An edge in a connection. */
export type TabContentEdge = {
  __typename?: 'TabContentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TabContent;
};

/** Identifies documents */
export type TabContentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TabContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TabContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TabContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  components_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  components_some?: InputMaybe<TabContentComponentsWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TabContentWhereStageInput>;
  documentInStages_none?: InputMaybe<TabContentWhereStageInput>;
  documentInStages_some?: InputMaybe<TabContentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TabContentOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  tabTitle_ASC = 'tabTitle_ASC',
  tabTitle_DESC = 'tabTitle_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TabContentUpdateInput = {
  cksful2sa0yka01z2e9hsh1fp?: InputMaybe<TabUpdateManyInlineInput>;
  components?: InputMaybe<TabContentComponentsUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: InputMaybe<TabContentUpdateLocalizationsInput>;
  /** tabTitle input for default locale (default) */
  tabTitle?: InputMaybe<Scalars['String']['input']>;
};

export type TabContentUpdateLocalizationDataInput = {
  tabTitle?: InputMaybe<Scalars['String']['input']>;
};

export type TabContentUpdateLocalizationInput = {
  data: TabContentUpdateLocalizationDataInput;
  locale: Locale;
};

export type TabContentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TabContentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<TabContentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<TabContentUpsertLocalizationInput>>;
};

export type TabContentUpdateManyInlineInput = {
  /** Connect multiple existing TabContent documents */
  connect?: InputMaybe<Array<TabContentConnectInput>>;
  /** Create and connect multiple TabContent documents */
  create?: InputMaybe<Array<TabContentCreateInput>>;
  /** Delete multiple TabContent documents */
  delete?: InputMaybe<Array<TabContentWhereUniqueInput>>;
  /** Disconnect multiple TabContent documents */
  disconnect?: InputMaybe<Array<TabContentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TabContent documents */
  set?: InputMaybe<Array<TabContentWhereUniqueInput>>;
  /** Update multiple TabContent documents */
  update?: InputMaybe<Array<TabContentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TabContent documents */
  upsert?: InputMaybe<Array<TabContentUpsertWithNestedWhereUniqueInput>>;
};

export type TabContentUpdateManyInput = {
  /** Optional updates to localizations */
  localizations?: InputMaybe<TabContentUpdateManyLocalizationsInput>;
  /** tabTitle input for default locale (default) */
  tabTitle?: InputMaybe<Scalars['String']['input']>;
};

export type TabContentUpdateManyLocalizationDataInput = {
  tabTitle?: InputMaybe<Scalars['String']['input']>;
};

export type TabContentUpdateManyLocalizationInput = {
  data: TabContentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type TabContentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<TabContentUpdateManyLocalizationInput>>;
};

export type TabContentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TabContentUpdateManyInput;
  /** Document search */
  where: TabContentWhereInput;
};

export type TabContentUpdateOneInlineInput = {
  /** Connect existing TabContent document */
  connect?: InputMaybe<TabContentWhereUniqueInput>;
  /** Create and connect one TabContent document */
  create?: InputMaybe<TabContentCreateInput>;
  /** Delete currently connected TabContent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TabContent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TabContent document */
  update?: InputMaybe<TabContentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TabContent document */
  upsert?: InputMaybe<TabContentUpsertWithNestedWhereUniqueInput>;
};

export type TabContentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TabContentUpdateInput;
  /** Unique document search */
  where: TabContentWhereUniqueInput;
};

export type TabContentUpsertInput = {
  /** Create document if it didn't exist */
  create: TabContentCreateInput;
  /** Update document if it exists */
  update: TabContentUpdateInput;
};

export type TabContentUpsertLocalizationInput = {
  create: TabContentCreateLocalizationDataInput;
  locale: Locale;
  update: TabContentUpdateLocalizationDataInput;
};

export type TabContentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TabContentUpsertInput;
  /** Unique document search */
  where: TabContentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TabContentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TabContentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TabContentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TabContentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TabContentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  /** All values in which the union is empty */
  components_empty?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches if the union contains at least one connection to the provided item to the filter */
  components_some?: InputMaybe<TabContentComponentsWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TabContentWhereStageInput>;
  documentInStages_none?: InputMaybe<TabContentWhereStageInput>;
  documentInStages_some?: InputMaybe<TabContentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  tabTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  tabTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  tabTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  tabTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  tabTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  tabTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  tabTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  tabTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  tabTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  tabTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TabContentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TabContentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TabContentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TabContentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TabContentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TabContent record uniquely */
export type TabContentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TabCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  cmsTabTitle: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  genericPages?: InputMaybe<GenericPageCreateManyInlineInput>;
  stories?: InputMaybe<StoryCreateManyInlineInput>;
  tabs?: InputMaybe<TabContentCreateManyInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TabCreateManyInlineInput = {
  /** Connect multiple existing Tab documents */
  connect?: InputMaybe<Array<TabWhereUniqueInput>>;
  /** Create and connect multiple existing Tab documents */
  create?: InputMaybe<Array<TabCreateInput>>;
};

export type TabCreateOneInlineInput = {
  /** Connect one existing Tab document */
  connect?: InputMaybe<TabWhereUniqueInput>;
  /** Create and connect one Tab document */
  create?: InputMaybe<TabCreateInput>;
};

/** An edge in a connection. */
export type TabEdge = {
  __typename?: 'TabEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Tab;
};

/** Identifies documents */
export type TabManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TabWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TabWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TabWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTabTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTabTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTabTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTabTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTabTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTabTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTabTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTabTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTabTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTabTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TabWhereStageInput>;
  documentInStages_none?: InputMaybe<TabWhereStageInput>;
  documentInStages_some?: InputMaybe<TabWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabs_every?: InputMaybe<TabContentWhereInput>;
  tabs_none?: InputMaybe<TabContentWhereInput>;
  tabs_some?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TabOrderByInput {
  cmsTabTitle_ASC = 'cmsTabTitle_ASC',
  cmsTabTitle_DESC = 'cmsTabTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TabUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  cmsTabTitle?: InputMaybe<Scalars['String']['input']>;
  genericPages?: InputMaybe<GenericPageUpdateManyInlineInput>;
  stories?: InputMaybe<StoryUpdateManyInlineInput>;
  tabs?: InputMaybe<TabContentUpdateManyInlineInput>;
};

export type TabUpdateManyInlineInput = {
  /** Connect multiple existing Tab documents */
  connect?: InputMaybe<Array<TabConnectInput>>;
  /** Create and connect multiple Tab documents */
  create?: InputMaybe<Array<TabCreateInput>>;
  /** Delete multiple Tab documents */
  delete?: InputMaybe<Array<TabWhereUniqueInput>>;
  /** Disconnect multiple Tab documents */
  disconnect?: InputMaybe<Array<TabWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Tab documents */
  set?: InputMaybe<Array<TabWhereUniqueInput>>;
  /** Update multiple Tab documents */
  update?: InputMaybe<Array<TabUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Tab documents */
  upsert?: InputMaybe<Array<TabUpsertWithNestedWhereUniqueInput>>;
};

export type TabUpdateManyInput = {
  cmsTabTitle?: InputMaybe<Scalars['String']['input']>;
};

export type TabUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TabUpdateManyInput;
  /** Document search */
  where: TabWhereInput;
};

export type TabUpdateOneInlineInput = {
  /** Connect existing Tab document */
  connect?: InputMaybe<TabWhereUniqueInput>;
  /** Create and connect one Tab document */
  create?: InputMaybe<TabCreateInput>;
  /** Delete currently connected Tab document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Tab document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Tab document */
  update?: InputMaybe<TabUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Tab document */
  upsert?: InputMaybe<TabUpsertWithNestedWhereUniqueInput>;
};

export type TabUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TabUpdateInput;
  /** Unique document search */
  where: TabWhereUniqueInput;
};

export type TabUpsertInput = {
  /** Create document if it didn't exist */
  create: TabCreateInput;
  /** Update document if it exists */
  update: TabUpdateInput;
};

export type TabUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TabUpsertInput;
  /** Unique document search */
  where: TabWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TabWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TabWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TabWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TabWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TabWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  cmsTabTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTabTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTabTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTabTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTabTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTabTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTabTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTabTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTabTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTabTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TabWhereStageInput>;
  documentInStages_none?: InputMaybe<TabWhereStageInput>;
  documentInStages_some?: InputMaybe<TabWhereStageInput>;
  genericPages_every?: InputMaybe<GenericPageWhereInput>;
  genericPages_none?: InputMaybe<GenericPageWhereInput>;
  genericPages_some?: InputMaybe<GenericPageWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  stories_every?: InputMaybe<StoryWhereInput>;
  stories_none?: InputMaybe<StoryWhereInput>;
  stories_some?: InputMaybe<StoryWhereInput>;
  tabs_every?: InputMaybe<TabContentWhereInput>;
  tabs_none?: InputMaybe<TabContentWhereInput>;
  tabs_some?: InputMaybe<TabContentWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TabWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TabWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TabWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TabWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TabWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Tab record uniquely */
export type TabWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TestTipsANdTricksInAMarket = Entity & Node & {
  __typename?: 'TestTipsANdTricksInAMarket';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<TestTipsANdTricksInAMarket>;
  environment?: Maybe<DbEnvironment>;
  /** List of TestTipsANdTricksInAMarket versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  markets?: Maybe<Markets>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  tipsAndTricks?: Maybe<Scalars['Json']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type TestTipsANdTricksInAMarketCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TestTipsANdTricksInAMarketDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type TestTipsANdTricksInAMarketHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type TestTipsANdTricksInAMarketPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TestTipsANdTricksInAMarketScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type TestTipsANdTricksInAMarketUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TestTipsANdTricksInAMarketConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};

/** A connection to a list of items. */
export type TestTipsANdTricksInAMarketConnection = {
  __typename?: 'TestTipsANdTricksInAMarketConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TestTipsANdTricksInAMarketEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TestTipsANdTricksInAMarketCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  environment?: InputMaybe<DbEnvironment>;
  markets?: InputMaybe<Markets>;
  tipsAndTricks?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TestTipsANdTricksInAMarketCreateManyInlineInput = {
  /** Connect multiple existing TestTipsANdTricksInAMarket documents */
  connect?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereUniqueInput>>;
  /** Create and connect multiple existing TestTipsANdTricksInAMarket documents */
  create?: InputMaybe<Array<TestTipsANdTricksInAMarketCreateInput>>;
};

export type TestTipsANdTricksInAMarketCreateOneInlineInput = {
  /** Connect one existing TestTipsANdTricksInAMarket document */
  connect?: InputMaybe<TestTipsANdTricksInAMarketWhereUniqueInput>;
  /** Create and connect one TestTipsANdTricksInAMarket document */
  create?: InputMaybe<TestTipsANdTricksInAMarketCreateInput>;
};

/** An edge in a connection. */
export type TestTipsANdTricksInAMarketEdge = {
  __typename?: 'TestTipsANdTricksInAMarketEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TestTipsANdTricksInAMarket;
};

/** Identifies documents */
export type TestTipsANdTricksInAMarketManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TestTipsANdTricksInAMarketWhereStageInput>;
  documentInStages_none?: InputMaybe<TestTipsANdTricksInAMarketWhereStageInput>;
  documentInStages_some?: InputMaybe<TestTipsANdTricksInAMarketWhereStageInput>;
  environment?: InputMaybe<DbEnvironment>;
  /** All values that are contained in given list. */
  environment_in?: InputMaybe<Array<InputMaybe<DbEnvironment>>>;
  /** Any other value that exists and is not equal to the given value. */
  environment_not?: InputMaybe<DbEnvironment>;
  /** All values that are not contained in given list. */
  environment_not_in?: InputMaybe<Array<InputMaybe<DbEnvironment>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  markets?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  markets_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  markets_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  markets_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values containing the given json path. */
  tipsAndTricks_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  tipsAndTricks_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TestTipsANdTricksInAMarketOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  environment_ASC = 'environment_ASC',
  environment_DESC = 'environment_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  markets_ASC = 'markets_ASC',
  markets_DESC = 'markets_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TestTipsANdTricksInAMarketUpdateInput = {
  environment?: InputMaybe<DbEnvironment>;
  markets?: InputMaybe<Markets>;
  tipsAndTricks?: InputMaybe<Scalars['Json']['input']>;
};

export type TestTipsANdTricksInAMarketUpdateManyInlineInput = {
  /** Connect multiple existing TestTipsANdTricksInAMarket documents */
  connect?: InputMaybe<Array<TestTipsANdTricksInAMarketConnectInput>>;
  /** Create and connect multiple TestTipsANdTricksInAMarket documents */
  create?: InputMaybe<Array<TestTipsANdTricksInAMarketCreateInput>>;
  /** Delete multiple TestTipsANdTricksInAMarket documents */
  delete?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereUniqueInput>>;
  /** Disconnect multiple TestTipsANdTricksInAMarket documents */
  disconnect?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TestTipsANdTricksInAMarket documents */
  set?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereUniqueInput>>;
  /** Update multiple TestTipsANdTricksInAMarket documents */
  update?: InputMaybe<Array<TestTipsANdTricksInAMarketUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TestTipsANdTricksInAMarket documents */
  upsert?: InputMaybe<Array<TestTipsANdTricksInAMarketUpsertWithNestedWhereUniqueInput>>;
};

export type TestTipsANdTricksInAMarketUpdateManyInput = {
  environment?: InputMaybe<DbEnvironment>;
  markets?: InputMaybe<Markets>;
  tipsAndTricks?: InputMaybe<Scalars['Json']['input']>;
};

export type TestTipsANdTricksInAMarketUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TestTipsANdTricksInAMarketUpdateManyInput;
  /** Document search */
  where: TestTipsANdTricksInAMarketWhereInput;
};

export type TestTipsANdTricksInAMarketUpdateOneInlineInput = {
  /** Connect existing TestTipsANdTricksInAMarket document */
  connect?: InputMaybe<TestTipsANdTricksInAMarketWhereUniqueInput>;
  /** Create and connect one TestTipsANdTricksInAMarket document */
  create?: InputMaybe<TestTipsANdTricksInAMarketCreateInput>;
  /** Delete currently connected TestTipsANdTricksInAMarket document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TestTipsANdTricksInAMarket document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TestTipsANdTricksInAMarket document */
  update?: InputMaybe<TestTipsANdTricksInAMarketUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TestTipsANdTricksInAMarket document */
  upsert?: InputMaybe<TestTipsANdTricksInAMarketUpsertWithNestedWhereUniqueInput>;
};

export type TestTipsANdTricksInAMarketUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TestTipsANdTricksInAMarketUpdateInput;
  /** Unique document search */
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};

export type TestTipsANdTricksInAMarketUpsertInput = {
  /** Create document if it didn't exist */
  create: TestTipsANdTricksInAMarketCreateInput;
  /** Update document if it exists */
  update: TestTipsANdTricksInAMarketUpdateInput;
};

export type TestTipsANdTricksInAMarketUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TestTipsANdTricksInAMarketUpsertInput;
  /** Unique document search */
  where: TestTipsANdTricksInAMarketWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TestTipsANdTricksInAMarketWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TestTipsANdTricksInAMarketWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TestTipsANdTricksInAMarketWhereStageInput>;
  documentInStages_none?: InputMaybe<TestTipsANdTricksInAMarketWhereStageInput>;
  documentInStages_some?: InputMaybe<TestTipsANdTricksInAMarketWhereStageInput>;
  environment?: InputMaybe<DbEnvironment>;
  /** All values that are contained in given list. */
  environment_in?: InputMaybe<Array<InputMaybe<DbEnvironment>>>;
  /** Any other value that exists and is not equal to the given value. */
  environment_not?: InputMaybe<DbEnvironment>;
  /** All values that are not contained in given list. */
  environment_not_in?: InputMaybe<Array<InputMaybe<DbEnvironment>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  markets?: InputMaybe<Markets>;
  /** All values that are contained in given list. */
  markets_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  /** Any other value that exists and is not equal to the given value. */
  markets_not?: InputMaybe<Markets>;
  /** All values that are not contained in given list. */
  markets_not_in?: InputMaybe<Array<InputMaybe<Markets>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  /** All values containing the given json path. */
  tipsAndTricks_json_path_exists?: InputMaybe<Scalars['String']['input']>;
  /**
   * Recursively tries to find the provided JSON scalar value inside the field.
   * It does use an exact match when comparing values.
   * If you pass `null` as value the filter will be ignored.
   * Note: This filter fails if you try to look for a non scalar JSON value!
   */
  tipsAndTricks_value_recursive?: InputMaybe<Scalars['Json']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TestTipsANdTricksInAMarketWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TestTipsANdTricksInAMarketWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TestTipsANdTricksInAMarketWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TestTipsANdTricksInAMarket record uniquely */
export type TestTipsANdTricksInAMarketWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Single text component that can be used to add rich text to a page */
export type TextComponent = Entity & Node & {
  __typename?: 'TextComponent';
  /** This title is not displayed on the website; it is only used to identify this item within CMS */
  cmsTitle?: Maybe<Scalars['String']['output']>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<TextComponent>;
  /** List of TextComponent versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<TextComponent>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  richtext?: Maybe<RichText>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  /** Rich text editor for adding long form text paragraphs */
  text?: Maybe<TextComponentTextRichText>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Single text component that can be used to add rich text to a page */
export type TextComponentCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Single text component that can be used to add rich text to a page */
export type TextComponentCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Single text component that can be used to add rich text to a page */
export type TextComponentDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Single text component that can be used to add rich text to a page */
export type TextComponentHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Single text component that can be used to add rich text to a page */
export type TextComponentLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Single text component that can be used to add rich text to a page */
export type TextComponentPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Single text component that can be used to add rich text to a page */
export type TextComponentPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Single text component that can be used to add rich text to a page */
export type TextComponentScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Single text component that can be used to add rich text to a page */
export type TextComponentUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Single text component that can be used to add rich text to a page */
export type TextComponentUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TextComponentConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TextComponentWhereUniqueInput;
};

/** A connection to a list of items. */
export type TextComponentConnection = {
  __typename?: 'TextComponentConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TextComponentEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TextComponentCreateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TextComponentCreateLocalizationsInput>;
  richtext?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** text input for default locale (default) */
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TextComponentCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TextComponentCreateLocalizationInput = {
  /** Localization input */
  data: TextComponentCreateLocalizationDataInput;
  locale: Locale;
};

export type TextComponentCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TextComponentCreateLocalizationInput>>;
};

export type TextComponentCreateManyInlineInput = {
  /** Connect multiple existing TextComponent documents */
  connect?: InputMaybe<Array<TextComponentWhereUniqueInput>>;
  /** Create and connect multiple existing TextComponent documents */
  create?: InputMaybe<Array<TextComponentCreateInput>>;
};

export type TextComponentCreateOneInlineInput = {
  /** Connect one existing TextComponent document */
  connect?: InputMaybe<TextComponentWhereUniqueInput>;
  /** Create and connect one TextComponent document */
  create?: InputMaybe<TextComponentCreateInput>;
};

/** An edge in a connection. */
export type TextComponentEdge = {
  __typename?: 'TextComponentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TextComponent;
};

/** Identifies documents */
export type TextComponentManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TextComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<TextComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<TextComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TextComponentOrderByInput {
  cmsTitle_ASC = 'cmsTitle_ASC',
  cmsTitle_DESC = 'cmsTitle_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TextComponentTextRichText = {
  __typename?: 'TextComponentTextRichText';
  /** Returns HTMl representation */
  html: Scalars['String']['output'];
  json: Scalars['RichTextAST']['output'];
  /** Returns Markdown representation */
  markdown: Scalars['String']['output'];
  /** @deprecated Please use the 'json' field */
  raw: Scalars['RichTextAST']['output'];
  references: Array<TextComponentTextRichTextEmbeddedTypes>;
  /** Returns plain-text contents of RichText */
  text: Scalars['String']['output'];
};


export type TextComponentTextRichTextReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type TextComponentTextRichTextEmbeddedTypes = Asset;

export type TextComponentUpdateInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<TextComponentUpdateLocalizationsInput>;
  richtext?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** text input for default locale (default) */
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type TextComponentUpdateLocalizationDataInput = {
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type TextComponentUpdateLocalizationInput = {
  data: TextComponentUpdateLocalizationDataInput;
  locale: Locale;
};

export type TextComponentUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TextComponentCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<TextComponentUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<TextComponentUpsertLocalizationInput>>;
};

export type TextComponentUpdateManyInlineInput = {
  /** Connect multiple existing TextComponent documents */
  connect?: InputMaybe<Array<TextComponentConnectInput>>;
  /** Create and connect multiple TextComponent documents */
  create?: InputMaybe<Array<TextComponentCreateInput>>;
  /** Delete multiple TextComponent documents */
  delete?: InputMaybe<Array<TextComponentWhereUniqueInput>>;
  /** Disconnect multiple TextComponent documents */
  disconnect?: InputMaybe<Array<TextComponentWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TextComponent documents */
  set?: InputMaybe<Array<TextComponentWhereUniqueInput>>;
  /** Update multiple TextComponent documents */
  update?: InputMaybe<Array<TextComponentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TextComponent documents */
  upsert?: InputMaybe<Array<TextComponentUpsertWithNestedWhereUniqueInput>>;
};

export type TextComponentUpdateManyInput = {
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<TextComponentUpdateManyLocalizationsInput>;
  richtext?: InputMaybe<Scalars['RichTextAST']['input']>;
  /** text input for default locale (default) */
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type TextComponentUpdateManyLocalizationDataInput = {
  text?: InputMaybe<Scalars['RichTextAST']['input']>;
};

export type TextComponentUpdateManyLocalizationInput = {
  data: TextComponentUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type TextComponentUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<TextComponentUpdateManyLocalizationInput>>;
};

export type TextComponentUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TextComponentUpdateManyInput;
  /** Document search */
  where: TextComponentWhereInput;
};

export type TextComponentUpdateOneInlineInput = {
  /** Connect existing TextComponent document */
  connect?: InputMaybe<TextComponentWhereUniqueInput>;
  /** Create and connect one TextComponent document */
  create?: InputMaybe<TextComponentCreateInput>;
  /** Delete currently connected TextComponent document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TextComponent document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TextComponent document */
  update?: InputMaybe<TextComponentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TextComponent document */
  upsert?: InputMaybe<TextComponentUpsertWithNestedWhereUniqueInput>;
};

export type TextComponentUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TextComponentUpdateInput;
  /** Unique document search */
  where: TextComponentWhereUniqueInput;
};

export type TextComponentUpsertInput = {
  /** Create document if it didn't exist */
  create: TextComponentCreateInput;
  /** Update document if it exists */
  update: TextComponentUpdateInput;
};

export type TextComponentUpsertLocalizationInput = {
  create: TextComponentCreateLocalizationDataInput;
  locale: Locale;
  update: TextComponentUpdateLocalizationDataInput;
};

export type TextComponentUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TextComponentUpsertInput;
  /** Unique document search */
  where: TextComponentWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TextComponentWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TextComponentWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextComponentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextComponentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextComponentWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cmsTitle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  cmsTitle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  cmsTitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  cmsTitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  cmsTitle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  cmsTitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  cmsTitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  cmsTitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  cmsTitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  cmsTitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TextComponentWhereStageInput>;
  documentInStages_none?: InputMaybe<TextComponentWhereStageInput>;
  documentInStages_some?: InputMaybe<TextComponentWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TextComponentWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TextComponentWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TextComponentWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TextComponentWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TextComponentWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TextComponent record uniquely */
export type TextComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type TipsAndTricksDetailsPage = Entity & Node & {
  __typename?: 'TipsAndTricksDetailsPage';
  anchorNavigationList?: Maybe<AnchorNavigationList>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<TipsAndTricksDetailsPage>;
  /** List of TipsAndTricksDetailsPage versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** card carousel data for related tips and tricks */
  relatedTipsCarouselData?: Maybe<GenericCardCarouseComponent>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  sustainabilityBanner?: Maybe<SustainabilityBanner>;
  /** titles to be referenced on a tip and trick detail page */
  titles?: Maybe<Dictionary>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type TipsAndTricksDetailsPageAnchorNavigationListArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TipsAndTricksDetailsPageCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TipsAndTricksDetailsPageDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type TipsAndTricksDetailsPageHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type TipsAndTricksDetailsPagePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TipsAndTricksDetailsPageRelatedTipsCarouselDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TipsAndTricksDetailsPageScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type TipsAndTricksDetailsPageSustainabilityBannerArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TipsAndTricksDetailsPageTitlesArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TipsAndTricksDetailsPageUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TipsAndTricksDetailsPageConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};

/** A connection to a list of items. */
export type TipsAndTricksDetailsPageConnection = {
  __typename?: 'TipsAndTricksDetailsPageConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TipsAndTricksDetailsPageEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TipsAndTricksDetailsPageCreateInput = {
  anchorNavigationList?: InputMaybe<AnchorNavigationListCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  relatedTipsCarouselData?: InputMaybe<GenericCardCarouseComponentCreateOneInlineInput>;
  sustainabilityBanner?: InputMaybe<SustainabilityBannerCreateOneInlineInput>;
  titles?: InputMaybe<DictionaryCreateOneInlineInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TipsAndTricksDetailsPageCreateManyInlineInput = {
  /** Connect multiple existing TipsAndTricksDetailsPage documents */
  connect?: InputMaybe<Array<TipsAndTricksDetailsPageWhereUniqueInput>>;
  /** Create and connect multiple existing TipsAndTricksDetailsPage documents */
  create?: InputMaybe<Array<TipsAndTricksDetailsPageCreateInput>>;
};

export type TipsAndTricksDetailsPageCreateOneInlineInput = {
  /** Connect one existing TipsAndTricksDetailsPage document */
  connect?: InputMaybe<TipsAndTricksDetailsPageWhereUniqueInput>;
  /** Create and connect one TipsAndTricksDetailsPage document */
  create?: InputMaybe<TipsAndTricksDetailsPageCreateInput>;
};

/** An edge in a connection. */
export type TipsAndTricksDetailsPageEdge = {
  __typename?: 'TipsAndTricksDetailsPageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TipsAndTricksDetailsPage;
};

/** Identifies documents */
export type TipsAndTricksDetailsPageManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TipsAndTricksDetailsPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TipsAndTricksDetailsPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TipsAndTricksDetailsPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNavigationList?: InputMaybe<AnchorNavigationListWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TipsAndTricksDetailsPageWhereStageInput>;
  documentInStages_none?: InputMaybe<TipsAndTricksDetailsPageWhereStageInput>;
  documentInStages_some?: InputMaybe<TipsAndTricksDetailsPageWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  relatedTipsCarouselData?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sustainabilityBanner?: InputMaybe<SustainabilityBannerWhereInput>;
  titles?: InputMaybe<DictionaryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TipsAndTricksDetailsPageOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TipsAndTricksDetailsPageUpdateInput = {
  anchorNavigationList?: InputMaybe<AnchorNavigationListUpdateOneInlineInput>;
  relatedTipsCarouselData?: InputMaybe<GenericCardCarouseComponentUpdateOneInlineInput>;
  sustainabilityBanner?: InputMaybe<SustainabilityBannerUpdateOneInlineInput>;
  titles?: InputMaybe<DictionaryUpdateOneInlineInput>;
};

export type TipsAndTricksDetailsPageUpdateManyInlineInput = {
  /** Connect multiple existing TipsAndTricksDetailsPage documents */
  connect?: InputMaybe<Array<TipsAndTricksDetailsPageConnectInput>>;
  /** Create and connect multiple TipsAndTricksDetailsPage documents */
  create?: InputMaybe<Array<TipsAndTricksDetailsPageCreateInput>>;
  /** Delete multiple TipsAndTricksDetailsPage documents */
  delete?: InputMaybe<Array<TipsAndTricksDetailsPageWhereUniqueInput>>;
  /** Disconnect multiple TipsAndTricksDetailsPage documents */
  disconnect?: InputMaybe<Array<TipsAndTricksDetailsPageWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TipsAndTricksDetailsPage documents */
  set?: InputMaybe<Array<TipsAndTricksDetailsPageWhereUniqueInput>>;
  /** Update multiple TipsAndTricksDetailsPage documents */
  update?: InputMaybe<Array<TipsAndTricksDetailsPageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TipsAndTricksDetailsPage documents */
  upsert?: InputMaybe<Array<TipsAndTricksDetailsPageUpsertWithNestedWhereUniqueInput>>;
};

export type TipsAndTricksDetailsPageUpdateManyInput = {
  /** No fields in updateMany data input */
  _?: InputMaybe<Scalars['String']['input']>;
};

export type TipsAndTricksDetailsPageUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TipsAndTricksDetailsPageUpdateManyInput;
  /** Document search */
  where: TipsAndTricksDetailsPageWhereInput;
};

export type TipsAndTricksDetailsPageUpdateOneInlineInput = {
  /** Connect existing TipsAndTricksDetailsPage document */
  connect?: InputMaybe<TipsAndTricksDetailsPageWhereUniqueInput>;
  /** Create and connect one TipsAndTricksDetailsPage document */
  create?: InputMaybe<TipsAndTricksDetailsPageCreateInput>;
  /** Delete currently connected TipsAndTricksDetailsPage document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TipsAndTricksDetailsPage document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TipsAndTricksDetailsPage document */
  update?: InputMaybe<TipsAndTricksDetailsPageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TipsAndTricksDetailsPage document */
  upsert?: InputMaybe<TipsAndTricksDetailsPageUpsertWithNestedWhereUniqueInput>;
};

export type TipsAndTricksDetailsPageUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TipsAndTricksDetailsPageUpdateInput;
  /** Unique document search */
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};

export type TipsAndTricksDetailsPageUpsertInput = {
  /** Create document if it didn't exist */
  create: TipsAndTricksDetailsPageCreateInput;
  /** Update document if it exists */
  update: TipsAndTricksDetailsPageUpdateInput;
};

export type TipsAndTricksDetailsPageUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TipsAndTricksDetailsPageUpsertInput;
  /** Unique document search */
  where: TipsAndTricksDetailsPageWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TipsAndTricksDetailsPageWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TipsAndTricksDetailsPageWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TipsAndTricksDetailsPageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TipsAndTricksDetailsPageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TipsAndTricksDetailsPageWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNavigationList?: InputMaybe<AnchorNavigationListWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TipsAndTricksDetailsPageWhereStageInput>;
  documentInStages_none?: InputMaybe<TipsAndTricksDetailsPageWhereStageInput>;
  documentInStages_some?: InputMaybe<TipsAndTricksDetailsPageWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  relatedTipsCarouselData?: InputMaybe<GenericCardCarouseComponentWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  sustainabilityBanner?: InputMaybe<SustainabilityBannerWhereInput>;
  titles?: InputMaybe<DictionaryWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TipsAndTricksDetailsPageWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TipsAndTricksDetailsPageWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TipsAndTricksDetailsPageWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TipsAndTricksDetailsPageWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TipsAndTricksDetailsPageWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TipsAndTricksDetailsPage record uniquely */
export type TipsAndTricksDetailsPageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Title = Entity & Node & {
  __typename?: 'Title';
  anchorNav?: Maybe<AnchorNavigation>;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Title>;
  heading: Scalars['String']['output'];
  /** List of Title versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  subheading?: Maybe<Scalars['String']['output']>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


export type TitleAnchorNavArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TitleCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TitleDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type TitleHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type TitlePublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type TitleScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type TitleUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TitleConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TitleWhereUniqueInput;
};

/** A connection to a list of items. */
export type TitleConnection = {
  __typename?: 'TitleConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TitleEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TitleCreateInput = {
  anchorNav?: InputMaybe<AnchorNavigationCreateOneInlineInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  heading: Scalars['String']['input'];
  subheading?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TitleCreateManyInlineInput = {
  /** Connect multiple existing Title documents */
  connect?: InputMaybe<Array<TitleWhereUniqueInput>>;
  /** Create and connect multiple existing Title documents */
  create?: InputMaybe<Array<TitleCreateInput>>;
};

export type TitleCreateOneInlineInput = {
  /** Connect one existing Title document */
  connect?: InputMaybe<TitleWhereUniqueInput>;
  /** Create and connect one Title document */
  create?: InputMaybe<TitleCreateInput>;
};

/** An edge in a connection. */
export type TitleEdge = {
  __typename?: 'TitleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Title;
};

/** Identifies documents */
export type TitleManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TitleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TitleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TitleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TitleWhereStageInput>;
  documentInStages_none?: InputMaybe<TitleWhereStageInput>;
  documentInStages_some?: InputMaybe<TitleWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subheading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subheading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subheading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subheading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subheading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subheading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subheading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subheading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subheading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subheading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TitleOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  heading_ASC = 'heading_ASC',
  heading_DESC = 'heading_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  subheading_ASC = 'subheading_ASC',
  subheading_DESC = 'subheading_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TitleUpdateInput = {
  anchorNav?: InputMaybe<AnchorNavigationUpdateOneInlineInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  subheading?: InputMaybe<Scalars['String']['input']>;
};

export type TitleUpdateManyInlineInput = {
  /** Connect multiple existing Title documents */
  connect?: InputMaybe<Array<TitleConnectInput>>;
  /** Create and connect multiple Title documents */
  create?: InputMaybe<Array<TitleCreateInput>>;
  /** Delete multiple Title documents */
  delete?: InputMaybe<Array<TitleWhereUniqueInput>>;
  /** Disconnect multiple Title documents */
  disconnect?: InputMaybe<Array<TitleWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Title documents */
  set?: InputMaybe<Array<TitleWhereUniqueInput>>;
  /** Update multiple Title documents */
  update?: InputMaybe<Array<TitleUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Title documents */
  upsert?: InputMaybe<Array<TitleUpsertWithNestedWhereUniqueInput>>;
};

export type TitleUpdateManyInput = {
  heading?: InputMaybe<Scalars['String']['input']>;
  subheading?: InputMaybe<Scalars['String']['input']>;
};

export type TitleUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TitleUpdateManyInput;
  /** Document search */
  where: TitleWhereInput;
};

export type TitleUpdateOneInlineInput = {
  /** Connect existing Title document */
  connect?: InputMaybe<TitleWhereUniqueInput>;
  /** Create and connect one Title document */
  create?: InputMaybe<TitleCreateInput>;
  /** Delete currently connected Title document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Title document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Title document */
  update?: InputMaybe<TitleUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Title document */
  upsert?: InputMaybe<TitleUpsertWithNestedWhereUniqueInput>;
};

export type TitleUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TitleUpdateInput;
  /** Unique document search */
  where: TitleWhereUniqueInput;
};

export type TitleUpsertInput = {
  /** Create document if it didn't exist */
  create: TitleCreateInput;
  /** Update document if it exists */
  update: TitleUpdateInput;
};

export type TitleUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TitleUpsertInput;
  /** Unique document search */
  where: TitleWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TitleWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TitleWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TitleWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TitleWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TitleWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  anchorNav?: InputMaybe<AnchorNavigationWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TitleWhereStageInput>;
  documentInStages_none?: InputMaybe<TitleWhereStageInput>;
  documentInStages_some?: InputMaybe<TitleWhereStageInput>;
  heading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  heading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  heading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  heading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  heading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  heading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  heading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  heading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  heading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  heading_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  subheading?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  subheading_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  subheading_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  subheading_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  subheading_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  subheading_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  subheading_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  subheading_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  subheading_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  subheading_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TitleWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TitleWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TitleWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TitleWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TitleWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Title record uniquely */
export type TitleWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Tracking Value used for Content Grouping */
export enum TrackingContentGrouping {
  FAQs = 'FAQs',
  about = 'about',
  about_Dr_Oetker = 'about_Dr_Oetker',
  back_club = 'back_club',
  contact_us = 'contact_us',
  error = 'error',
  events_and_seminars = 'events_and_seminars',
  home = 'home',
  inspiration = 'inspiration',
  our_services = 'our_services',
  support = 'support',
  sustanability = 'sustanability',
  test_kitchen = 'test_kitchen'
}

export enum TwitterCardTypes {
  app = 'app',
  player = 'player',
  summary = 'summary',
  summary_large_image = 'summary_large_image'
}

/** Twitter SEO Optimization object */
export type TwitterSeo = Entity & Node & {
  __typename?: 'TwitterSeo';
  cardType: TwitterCardTypes;
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<TwitterSeo>;
  globalMetaData?: Maybe<GlobalMetaData>;
  /**
   * @username for the content creator / author.
   * Only apply if applicable to the page this object is referenced in.
   */
  handle?: Maybe<Scalars['String']['output']>;
  /** List of TwitterSeo versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<TwitterSeo>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** @username for the website used in the card footer */
  site?: Maybe<Scalars['String']['output']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
};


/** Twitter SEO Optimization object */
export type TwitterSeoCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Twitter SEO Optimization object */
export type TwitterSeoCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Twitter SEO Optimization object */
export type TwitterSeoDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


/** Twitter SEO Optimization object */
export type TwitterSeoGlobalMetaDataArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Twitter SEO Optimization object */
export type TwitterSeoHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


/** Twitter SEO Optimization object */
export type TwitterSeoLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


/** Twitter SEO Optimization object */
export type TwitterSeoPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Twitter SEO Optimization object */
export type TwitterSeoPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


/** Twitter SEO Optimization object */
export type TwitterSeoScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


/** Twitter SEO Optimization object */
export type TwitterSeoUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Twitter SEO Optimization object */
export type TwitterSeoUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type TwitterSeoConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: TwitterSeoWhereUniqueInput;
};

/** A connection to a list of items. */
export type TwitterSeoConnection = {
  __typename?: 'TwitterSeoConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<TwitterSeoEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type TwitterSeoCreateInput = {
  /** cardType input for default locale (default) */
  cardType: TwitterCardTypes;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  globalMetaData?: InputMaybe<GlobalMetaDataCreateOneInlineInput>;
  /** handle input for default locale (default) */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<TwitterSeoCreateLocalizationsInput>;
  /** site input for default locale (default) */
  site?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TwitterSeoCreateLocalizationDataInput = {
  cardType: TwitterCardTypes;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type TwitterSeoCreateLocalizationInput = {
  /** Localization input */
  data: TwitterSeoCreateLocalizationDataInput;
  locale: Locale;
};

export type TwitterSeoCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<TwitterSeoCreateLocalizationInput>>;
};

export type TwitterSeoCreateManyInlineInput = {
  /** Connect multiple existing TwitterSeo documents */
  connect?: InputMaybe<Array<TwitterSeoWhereUniqueInput>>;
  /** Create and connect multiple existing TwitterSeo documents */
  create?: InputMaybe<Array<TwitterSeoCreateInput>>;
};

export type TwitterSeoCreateOneInlineInput = {
  /** Connect one existing TwitterSeo document */
  connect?: InputMaybe<TwitterSeoWhereUniqueInput>;
  /** Create and connect one TwitterSeo document */
  create?: InputMaybe<TwitterSeoCreateInput>;
};

/** An edge in a connection. */
export type TwitterSeoEdge = {
  __typename?: 'TwitterSeoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TwitterSeo;
};

/** Identifies documents */
export type TwitterSeoManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TwitterSeoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TwitterSeoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TwitterSeoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TwitterSeoWhereStageInput>;
  documentInStages_none?: InputMaybe<TwitterSeoWhereStageInput>;
  documentInStages_some?: InputMaybe<TwitterSeoWhereStageInput>;
  globalMetaData?: InputMaybe<GlobalMetaDataWhereInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum TwitterSeoOrderByInput {
  cardType_ASC = 'cardType_ASC',
  cardType_DESC = 'cardType_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  handle_ASC = 'handle_ASC',
  handle_DESC = 'handle_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  site_ASC = 'site_ASC',
  site_DESC = 'site_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type TwitterSeoUpdateInput = {
  /** cardType input for default locale (default) */
  cardType?: InputMaybe<TwitterCardTypes>;
  globalMetaData?: InputMaybe<GlobalMetaDataUpdateOneInlineInput>;
  /** handle input for default locale (default) */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<TwitterSeoUpdateLocalizationsInput>;
  /** site input for default locale (default) */
  site?: InputMaybe<Scalars['String']['input']>;
};

export type TwitterSeoUpdateLocalizationDataInput = {
  cardType?: InputMaybe<TwitterCardTypes>;
  handle?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
};

export type TwitterSeoUpdateLocalizationInput = {
  data: TwitterSeoUpdateLocalizationDataInput;
  locale: Locale;
};

export type TwitterSeoUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<TwitterSeoCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<TwitterSeoUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<TwitterSeoUpsertLocalizationInput>>;
};

export type TwitterSeoUpdateManyInlineInput = {
  /** Connect multiple existing TwitterSeo documents */
  connect?: InputMaybe<Array<TwitterSeoConnectInput>>;
  /** Create and connect multiple TwitterSeo documents */
  create?: InputMaybe<Array<TwitterSeoCreateInput>>;
  /** Delete multiple TwitterSeo documents */
  delete?: InputMaybe<Array<TwitterSeoWhereUniqueInput>>;
  /** Disconnect multiple TwitterSeo documents */
  disconnect?: InputMaybe<Array<TwitterSeoWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing TwitterSeo documents */
  set?: InputMaybe<Array<TwitterSeoWhereUniqueInput>>;
  /** Update multiple TwitterSeo documents */
  update?: InputMaybe<Array<TwitterSeoUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple TwitterSeo documents */
  upsert?: InputMaybe<Array<TwitterSeoUpsertWithNestedWhereUniqueInput>>;
};

export type TwitterSeoUpdateManyInput = {
  /** cardType input for default locale (default) */
  cardType?: InputMaybe<TwitterCardTypes>;
  /** handle input for default locale (default) */
  handle?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<TwitterSeoUpdateManyLocalizationsInput>;
  /** site input for default locale (default) */
  site?: InputMaybe<Scalars['String']['input']>;
};

export type TwitterSeoUpdateManyLocalizationDataInput = {
  cardType?: InputMaybe<TwitterCardTypes>;
  handle?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
};

export type TwitterSeoUpdateManyLocalizationInput = {
  data: TwitterSeoUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type TwitterSeoUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<TwitterSeoUpdateManyLocalizationInput>>;
};

export type TwitterSeoUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: TwitterSeoUpdateManyInput;
  /** Document search */
  where: TwitterSeoWhereInput;
};

export type TwitterSeoUpdateOneInlineInput = {
  /** Connect existing TwitterSeo document */
  connect?: InputMaybe<TwitterSeoWhereUniqueInput>;
  /** Create and connect one TwitterSeo document */
  create?: InputMaybe<TwitterSeoCreateInput>;
  /** Delete currently connected TwitterSeo document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected TwitterSeo document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single TwitterSeo document */
  update?: InputMaybe<TwitterSeoUpdateWithNestedWhereUniqueInput>;
  /** Upsert single TwitterSeo document */
  upsert?: InputMaybe<TwitterSeoUpsertWithNestedWhereUniqueInput>;
};

export type TwitterSeoUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: TwitterSeoUpdateInput;
  /** Unique document search */
  where: TwitterSeoWhereUniqueInput;
};

export type TwitterSeoUpsertInput = {
  /** Create document if it didn't exist */
  create: TwitterSeoCreateInput;
  /** Update document if it exists */
  update: TwitterSeoUpdateInput;
};

export type TwitterSeoUpsertLocalizationInput = {
  create: TwitterSeoCreateLocalizationDataInput;
  locale: Locale;
  update: TwitterSeoUpdateLocalizationDataInput;
};

export type TwitterSeoUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: TwitterSeoUpsertInput;
  /** Unique document search */
  where: TwitterSeoWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type TwitterSeoWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type TwitterSeoWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TwitterSeoWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TwitterSeoWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TwitterSeoWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<TwitterCardTypes>;
  /** All values that are contained in given list. */
  cardType_in?: InputMaybe<Array<InputMaybe<TwitterCardTypes>>>;
  /** Any other value that exists and is not equal to the given value. */
  cardType_not?: InputMaybe<TwitterCardTypes>;
  /** All values that are not contained in given list. */
  cardType_not_in?: InputMaybe<Array<InputMaybe<TwitterCardTypes>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<TwitterSeoWhereStageInput>;
  documentInStages_none?: InputMaybe<TwitterSeoWhereStageInput>;
  documentInStages_some?: InputMaybe<TwitterSeoWhereStageInput>;
  globalMetaData?: InputMaybe<GlobalMetaDataWhereInput>;
  handle?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  handle_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  handle_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  handle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  handle_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  handle_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  handle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  handle_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  site?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  site_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  site_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  site_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  site_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  site_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  site_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  site_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  site_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  site_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type TwitterSeoWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<TwitterSeoWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<TwitterSeoWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<TwitterSeoWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<TwitterSeoWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References TwitterSeo record uniquely */
export type TwitterSeoWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UnpublishLocaleInput = {
  /** Locales to unpublish */
  locale: Locale;
  /** Stages to unpublish selected locales from */
  stages: Array<Stage>;
};

/** User system model */
export type User = Entity & Node & {
  __typename?: 'User';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** Get the document in other stages */
  documentInStages: Array<User>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  /** Flag to determine if user is active or not */
  isActive: Scalars['Boolean']['output'];
  /** User Kind. Can be either MEMBER, PAT or PUBLIC */
  kind: UserKind;
  /** The username */
  name: Scalars['String']['output'];
  /** Profile Picture url */
  picture?: Maybe<Scalars['String']['output']>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** System stage field */
  stage: Stage;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
};


/** User system model */
export type UserDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};

export type UserConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: UserWhereUniqueInput;
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type UserCreateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserCreateOneInlineInput = {
  /** Connect one existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: User;
};

/** System User Kind */
export enum UserKind {
  MEMBER = 'MEMBER',
  PAT = 'PAT',
  PUBLIC = 'PUBLIC',
  WEBHOOK = 'WEBHOOK'
}

/** Identifies documents */
export type UserManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

export enum UserOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isActive_ASC = 'isActive_ASC',
  isActive_DESC = 'isActive_DESC',
  kind_ASC = 'kind_ASC',
  kind_DESC = 'kind_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  picture_ASC = 'picture_ASC',
  picture_DESC = 'picture_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export type UserUpdateManyInlineInput = {
  /** Connect multiple existing User documents */
  connect?: InputMaybe<Array<UserConnectInput>>;
  /** Disconnect multiple User documents */
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing User documents */
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserUpdateOneInlineInput = {
  /** Connect existing User document */
  connect?: InputMaybe<UserWhereUniqueInput>;
  /** Disconnect currently connected User document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** This contains a set of filters that can be used to compare values internally */
export type UserWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type UserWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  documentInStages_every?: InputMaybe<UserWhereStageInput>;
  documentInStages_none?: InputMaybe<UserWhereStageInput>;
  documentInStages_some?: InputMaybe<UserWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  isActive_not?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  /** Any other value that exists and is not equal to the given value. */
  kind_not?: InputMaybe<UserKind>;
  /** All values that are not contained in given list. */
  kind_not_in?: InputMaybe<Array<InputMaybe<UserKind>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  name_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  name_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  name_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  name_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  name_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  name_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  name_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  name_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  name_starts_with?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  picture_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  picture_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  picture_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  picture_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  picture_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  picture_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  picture_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type UserWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<UserWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<UserWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<UserWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References User record uniquely */
export type UserWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type Version = {
  __typename?: 'Version';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  revision: Scalars['Int']['output'];
  stage: Stage;
};

export type VersionWhereInput = {
  id: Scalars['ID']['input'];
  revision: Scalars['Int']['input'];
  stage: Stage;
};

export enum VerticalAlignment {
  bottom = 'bottom',
  middle = 'middle',
  top = 'top'
}

export enum VideoCarouselTextColor {
  black = 'black',
  white = 'white'
}

export enum VideoHeroBannerSize {
  short = 'short',
  tall = 'tall'
}

export type Widget = Entity & Node & {
  __typename?: 'Widget';
  /** The time the document was created */
  createdAt: Scalars['DateTime']['output'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** Get the document in other stages */
  documentInStages: Array<Widget>;
  /** List of Widget versions */
  history: Array<Version>;
  /** The unique identifier */
  id: Scalars['ID']['output'];
  imageAlt?: Maybe<Scalars['String']['output']>;
  imageSource?: Maybe<Scalars['String']['output']>;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Widget>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  scheduledIn: Array<ScheduledOperation>;
  /** System stage field */
  stage: Stage;
  title: Scalars['String']['output'];
  type: Widgets;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime']['output'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  url: Scalars['String']['output'];
};


export type WidgetCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type WidgetCreatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type WidgetDocumentInStagesArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  inheritLocale?: Scalars['Boolean']['input'];
  stages?: Array<Stage>;
};


export type WidgetHistoryArgs = {
  limit?: Scalars['Int']['input'];
  skip?: Scalars['Int']['input'];
  stageOverride?: InputMaybe<Stage>;
};


export type WidgetLocalizationsArgs = {
  includeCurrent?: Scalars['Boolean']['input'];
  locales?: Array<Locale>;
};


export type WidgetPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type WidgetPublishedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};


export type WidgetScheduledInArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locales?: InputMaybe<Array<Locale>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledOperationWhereInput>;
};


export type WidgetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


export type WidgetUpdatedByArgs = {
  forceParentLocale?: InputMaybe<Scalars['Boolean']['input']>;
  locales?: InputMaybe<Array<Locale>>;
};

export type WidgetConnectInput = {
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: InputMaybe<ConnectPositionInput>;
  /** Document to connect */
  where: WidgetWhereUniqueInput;
};

/** A connection to a list of items. */
export type WidgetConnection = {
  __typename?: 'WidgetConnection';
  aggregate: Aggregate;
  /** A list of edges. */
  edges: Array<WidgetEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type WidgetCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** imageAlt input for default locale (default) */
  imageAlt?: InputMaybe<Scalars['String']['input']>;
  /** imageSource input for default locale (default) */
  imageSource?: InputMaybe<Scalars['String']['input']>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: InputMaybe<WidgetCreateLocalizationsInput>;
  title: Scalars['String']['input'];
  type: Widgets;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** url input for default locale (default) */
  url: Scalars['String']['input'];
};

export type WidgetCreateLocalizationDataInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  imageAlt?: InputMaybe<Scalars['String']['input']>;
  imageSource?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  url: Scalars['String']['input'];
};

export type WidgetCreateLocalizationInput = {
  /** Localization input */
  data: WidgetCreateLocalizationDataInput;
  locale: Locale;
};

export type WidgetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: InputMaybe<Array<WidgetCreateLocalizationInput>>;
};

export type WidgetCreateManyInlineInput = {
  /** Connect multiple existing Widget documents */
  connect?: InputMaybe<Array<WidgetWhereUniqueInput>>;
  /** Create and connect multiple existing Widget documents */
  create?: InputMaybe<Array<WidgetCreateInput>>;
};

export type WidgetCreateOneInlineInput = {
  /** Connect one existing Widget document */
  connect?: InputMaybe<WidgetWhereUniqueInput>;
  /** Create and connect one Widget document */
  create?: InputMaybe<WidgetCreateInput>;
};

/** An edge in a connection. */
export type WidgetEdge = {
  __typename?: 'WidgetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Widget;
};

/** Identifies documents */
export type WidgetManyWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<WidgetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<WidgetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<WidgetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<WidgetWhereStageInput>;
  documentInStages_none?: InputMaybe<WidgetWhereStageInput>;
  documentInStages_some?: InputMaybe<WidgetWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Widgets>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<Widgets>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<Widgets>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<Widgets>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
};

export enum WidgetOrderByInput {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  imageAlt_ASC = 'imageAlt_ASC',
  imageAlt_DESC = 'imageAlt_DESC',
  imageSource_ASC = 'imageSource_ASC',
  imageSource_DESC = 'imageSource_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC'
}

export type WidgetUpdateInput = {
  /** imageAlt input for default locale (default) */
  imageAlt?: InputMaybe<Scalars['String']['input']>;
  /** imageSource input for default locale (default) */
  imageSource?: InputMaybe<Scalars['String']['input']>;
  /** Manage document localizations */
  localizations?: InputMaybe<WidgetUpdateLocalizationsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Widgets>;
  /** url input for default locale (default) */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type WidgetUpdateLocalizationDataInput = {
  imageAlt?: InputMaybe<Scalars['String']['input']>;
  imageSource?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type WidgetUpdateLocalizationInput = {
  data: WidgetUpdateLocalizationDataInput;
  locale: Locale;
};

export type WidgetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: InputMaybe<Array<WidgetCreateLocalizationInput>>;
  /** Localizations to delete */
  delete?: InputMaybe<Array<Locale>>;
  /** Localizations to update */
  update?: InputMaybe<Array<WidgetUpdateLocalizationInput>>;
  upsert?: InputMaybe<Array<WidgetUpsertLocalizationInput>>;
};

export type WidgetUpdateManyInlineInput = {
  /** Connect multiple existing Widget documents */
  connect?: InputMaybe<Array<WidgetConnectInput>>;
  /** Create and connect multiple Widget documents */
  create?: InputMaybe<Array<WidgetCreateInput>>;
  /** Delete multiple Widget documents */
  delete?: InputMaybe<Array<WidgetWhereUniqueInput>>;
  /** Disconnect multiple Widget documents */
  disconnect?: InputMaybe<Array<WidgetWhereUniqueInput>>;
  /** Override currently-connected documents with multiple existing Widget documents */
  set?: InputMaybe<Array<WidgetWhereUniqueInput>>;
  /** Update multiple Widget documents */
  update?: InputMaybe<Array<WidgetUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Widget documents */
  upsert?: InputMaybe<Array<WidgetUpsertWithNestedWhereUniqueInput>>;
};

export type WidgetUpdateManyInput = {
  /** imageAlt input for default locale (default) */
  imageAlt?: InputMaybe<Scalars['String']['input']>;
  /** imageSource input for default locale (default) */
  imageSource?: InputMaybe<Scalars['String']['input']>;
  /** Optional updates to localizations */
  localizations?: InputMaybe<WidgetUpdateManyLocalizationsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Widgets>;
  /** url input for default locale (default) */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type WidgetUpdateManyLocalizationDataInput = {
  imageAlt?: InputMaybe<Scalars['String']['input']>;
  imageSource?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type WidgetUpdateManyLocalizationInput = {
  data: WidgetUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type WidgetUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: InputMaybe<Array<WidgetUpdateManyLocalizationInput>>;
};

export type WidgetUpdateManyWithNestedWhereInput = {
  /** Update many input */
  data: WidgetUpdateManyInput;
  /** Document search */
  where: WidgetWhereInput;
};

export type WidgetUpdateOneInlineInput = {
  /** Connect existing Widget document */
  connect?: InputMaybe<WidgetWhereUniqueInput>;
  /** Create and connect one Widget document */
  create?: InputMaybe<WidgetCreateInput>;
  /** Delete currently connected Widget document */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Disconnect currently connected Widget document */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update single Widget document */
  update?: InputMaybe<WidgetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Widget document */
  upsert?: InputMaybe<WidgetUpsertWithNestedWhereUniqueInput>;
};

export type WidgetUpdateWithNestedWhereUniqueInput = {
  /** Document to update */
  data: WidgetUpdateInput;
  /** Unique document search */
  where: WidgetWhereUniqueInput;
};

export type WidgetUpsertInput = {
  /** Create document if it didn't exist */
  create: WidgetCreateInput;
  /** Update document if it exists */
  update: WidgetUpdateInput;
};

export type WidgetUpsertLocalizationInput = {
  create: WidgetCreateLocalizationDataInput;
  locale: Locale;
  update: WidgetUpdateLocalizationDataInput;
};

export type WidgetUpsertWithNestedWhereUniqueInput = {
  /** Upsert data */
  data: WidgetUpsertInput;
  /** Unique document search */
  where: WidgetWhereUniqueInput;
};

/** This contains a set of filters that can be used to compare values internally */
export type WidgetWhereComparatorInput = {
  /** This field can be used to request to check if the entry is outdated by internal comparison */
  outdated_to?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Identifies documents */
export type WidgetWhereInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<WidgetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<WidgetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<WidgetWhereInput>>;
  /** Contains search across all appropriate fields. */
  _search?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  createdAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  createdBy?: InputMaybe<UserWhereInput>;
  documentInStages_every?: InputMaybe<WidgetWhereStageInput>;
  documentInStages_none?: InputMaybe<WidgetWhereStageInput>;
  documentInStages_some?: InputMaybe<WidgetWhereStageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** All values containing the given string. */
  id_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values ending with the given string. */
  id_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are contained in given list. */
  id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  id_not?: InputMaybe<Scalars['ID']['input']>;
  /** All values not containing the given string. */
  id_not_contains?: InputMaybe<Scalars['ID']['input']>;
  /** All values not ending with the given string */
  id_not_ends_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values that are not contained in given list. */
  id_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** All values not starting with the given string. */
  id_not_starts_with?: InputMaybe<Scalars['ID']['input']>;
  /** All values starting with the given string. */
  id_starts_with?: InputMaybe<Scalars['ID']['input']>;
  imageAlt?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  imageAlt_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  imageAlt_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  imageAlt_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageAlt_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  imageAlt_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  imageAlt_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  imageAlt_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  imageAlt_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  imageAlt_starts_with?: InputMaybe<Scalars['String']['input']>;
  imageSource?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  imageSource_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  imageSource_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  imageSource_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  imageSource_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  imageSource_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  imageSource_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  imageSource_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  imageSource_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  imageSource_starts_with?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedBy?: InputMaybe<UserWhereInput>;
  scheduledIn_every?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_none?: InputMaybe<ScheduledOperationWhereInput>;
  scheduledIn_some?: InputMaybe<ScheduledOperationWhereInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  title_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  title_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  title_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  title_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Widgets>;
  /** All values that are contained in given list. */
  type_in?: InputMaybe<Array<InputMaybe<Widgets>>>;
  /** Any other value that exists and is not equal to the given value. */
  type_not?: InputMaybe<Widgets>;
  /** All values that are not contained in given list. */
  type_not_in?: InputMaybe<Array<InputMaybe<Widgets>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than the given value. */
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are contained in given list. */
  updatedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  /** All values less than the given value. */
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  /** Any other value that exists and is not equal to the given value. */
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  updatedBy?: InputMaybe<UserWhereInput>;
  url?: InputMaybe<Scalars['String']['input']>;
  /** All values containing the given string. */
  url_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values ending with the given string. */
  url_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are contained in given list. */
  url_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Any other value that exists and is not equal to the given value. */
  url_not?: InputMaybe<Scalars['String']['input']>;
  /** All values not containing the given string. */
  url_not_contains?: InputMaybe<Scalars['String']['input']>;
  /** All values not ending with the given string */
  url_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  /** All values that are not contained in given list. */
  url_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** All values not starting with the given string. */
  url_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  /** All values starting with the given string. */
  url_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** The document in stages filter allows specifying a stage entry to cross compare the same document between different stages */
export type WidgetWhereStageInput = {
  /** Logical AND on all given filters. */
  AND?: InputMaybe<Array<WidgetWhereStageInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: InputMaybe<Array<WidgetWhereStageInput>>;
  /** Logical OR on all given filters. */
  OR?: InputMaybe<Array<WidgetWhereStageInput>>;
  /** This field contains fields which can be set as true or false to specify an internal comparison */
  compareWithParent?: InputMaybe<WidgetWhereComparatorInput>;
  /** Specify the stage to compare with */
  stage?: InputMaybe<Stage>;
};

/** References Widget record uniquely */
export type WidgetWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum Widgets {
  kununu = 'kununu'
}

export enum _FilterKind {
  AND = 'AND',
  NOT = 'NOT',
  OR = 'OR',
  contains = 'contains',
  contains_all = 'contains_all',
  contains_none = 'contains_none',
  contains_some = 'contains_some',
  ends_with = 'ends_with',
  eq = 'eq',
  eq_not = 'eq_not',
  gt = 'gt',
  gte = 'gte',
  in = 'in',
  json_path_exists = 'json_path_exists',
  json_value_recursive = 'json_value_recursive',
  lt = 'lt',
  lte = 'lte',
  not_contains = 'not_contains',
  not_ends_with = 'not_ends_with',
  not_in = 'not_in',
  not_starts_with = 'not_starts_with',
  relational_every = 'relational_every',
  relational_none = 'relational_none',
  relational_single = 'relational_single',
  relational_some = 'relational_some',
  search = 'search',
  starts_with = 'starts_with',
  union_empty = 'union_empty',
  union_every = 'union_every',
  union_none = 'union_none',
  union_single = 'union_single',
  union_some = 'union_some'
}

export enum _MutationInputFieldKind {
  enum = 'enum',
  relation = 'relation',
  richText = 'richText',
  richTextWithEmbeds = 'richTextWithEmbeds',
  scalar = 'scalar',
  union = 'union',
  virtual = 'virtual'
}

export enum _MutationKind {
  create = 'create',
  delete = 'delete',
  deleteMany = 'deleteMany',
  publish = 'publish',
  publishMany = 'publishMany',
  schedulePublish = 'schedulePublish',
  scheduleUnpublish = 'scheduleUnpublish',
  unpublish = 'unpublish',
  unpublishMany = 'unpublishMany',
  update = 'update',
  updateMany = 'updateMany',
  upsert = 'upsert'
}

export enum _OrderDirection {
  asc = 'asc',
  desc = 'desc'
}

export enum _RelationInputCardinality {
  many = 'many',
  one = 'one'
}

export enum _RelationInputKind {
  create = 'create',
  update = 'update'
}

export enum _RelationKind {
  regular = 'regular',
  union = 'union'
}

export enum _SystemDateTimeFieldVariation {
  base = 'base',
  combined = 'combined',
  localization = 'localization'
}

export type GetAnchorNavigationListQueryVariables = Exact<{
  where: AnchorNavigationListWhereUniqueInput;
}>;


export type GetAnchorNavigationListQuery = { __typename?: 'Query', anchorNavigationList?: { __typename?: 'AnchorNavigationList', id: string, anchorNavigations: Array<{ __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null }> } | null };

export type GetAnchorNavigationQueryVariables = Exact<{
  where: AnchorNavigationWhereUniqueInput;
}>;


export type GetAnchorNavigationQuery = { __typename?: 'Query', anchorNavigation?: { __typename: 'AnchorNavigation', id: string } | null };

export type GetAudioComponentQueryVariables = Exact<{
  where: AudioComponentWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetAudioComponentQuery = { __typename?: 'Query', audioComponent?: { __typename: 'AudioComponent', id: string, title?: string | null, description?: string | null, transcript?: string | null, audioFile?: { __typename?: 'Asset', url: string } | null, image: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', image: string }> }> } | null };

export type GetAuthorableContentCardQueryVariables = Exact<{
  where: AuthorableContentCardWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetAuthorableContentCardQuery = { __typename?: 'Query', authorableContentCard?: { __typename: 'AuthorableContentCard', id: string, copy: string, name: string, subtitle?: string | null, videoId?: string | null, image?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', id: string, desktop: string, desktopFallback: string, mobile: string, hero: string, tablet: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetCorpBanner1QueryVariables = Exact<{
  where: CorpBanner1WhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetCorpBanner1Query = { __typename?: 'Query', corpBanner1?: { __typename: 'CorpBanner1', id: string, superText?: string | null, title?: string | null, description?: string | null, color: CorpColorThemeName, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetBanner2QueryVariables = Exact<{
  where: Banner2WhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetBanner2Query = { __typename?: 'Query', banner2?: { __typename: 'Banner2', id: string, title?: string | null, superText?: string | null, description?: string | null, fullBleed?: boolean | null, imageAlignment?: LeftRight | null, backgroundAsset?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', background: string, backgroundFallback: string }> } | null, mobileBackgroundAsset?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', background: string, backgroundFallback: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetBigNumberQueryVariables = Exact<{
  where: BigNumberWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetBigNumberQuery = { __typename?: 'Query', bigNumber?: { __typename?: 'BigNumber', bigNumberItems: Array<{ __typename?: 'BigNumberItem', bigNumber: string, bottomText: string }> } | null };

export type CarouselComponentPartsFragment = { __typename: 'CarouselComponent', id: string, heading?: string | null, title?: string | null, slidesToShow?: number | null, cardVariant?: CorpCardCarouselVariant | null, carouselType: CarouselType, carouselSlides: Array<{ __typename?: 'CarouselSlide', caption?: string | null, videoId?: string | null, slideAsset?: { __typename?: 'Asset', desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null }>, topRightAsset?: { __typename?: 'Asset', url: string } | null, bottomLeftAsset?: { __typename?: 'Asset', url: string } | null, backgroundImg?: { __typename?: 'Asset', background: string, backgroundFallback: string } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null };

export type GetCarouselComponentQueryVariables = Exact<{
  where: CarouselComponentWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetCarouselComponentQuery = { __typename?: 'Query', carouselComponent?: { __typename: 'CarouselComponent', id: string, heading?: string | null, title?: string | null, slidesToShow?: number | null, cardVariant?: CorpCardCarouselVariant | null, carouselType: CarouselType, carouselSlides: Array<{ __typename?: 'CarouselSlide', caption?: string | null, videoId?: string | null, slideAsset?: { __typename?: 'Asset', desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null }>, topRightAsset?: { __typename?: 'Asset', url: string } | null, bottomLeftAsset?: { __typename?: 'Asset', url: string } | null, backgroundImg?: { __typename?: 'Asset', background: string, backgroundFallback: string } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetCorpCalendarEventComponentQueryVariables = Exact<{
  where: CorpCalendarEventWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetCorpCalendarEventComponentQuery = { __typename?: 'Query', corpCalendarEvent?: { __typename: 'CorpCalendarEvent', id: string, title: string, eventDescription: string, eventLocation: string, startDate: any, endDate: any, richText?: { __typename?: 'CorpCalendarEventRichTextRichText', raw: any, references: Array<{ __typename: 'LongText', id: string, LongText_cmsTitle?: string | null }> } | null } | null };

export type CorpCardCarouselPartsFragment = { __typename: 'CorpCardCarousel', id: string, super?: string | null, title?: string | null, color?: CorpColorThemeName | null, cardVariant?: CorpCardCarouselVariant | null, corpCarouselType?: CorpCardCarouselType | null, slidesToShow?: number | null, storyItems: Array<{ __typename?: 'Story', id: string, title: string, slug?: string | null, date?: any | null, publishedAt?: any | null, tag?: CorpStoryTagEnum | null, image?: { __typename?: 'Asset', id: string, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null }>, buttonLink?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null };

export type GetCorpCardCarouselQueryVariables = Exact<{
  where: CorpCardCarouselWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetCorpCardCarouselQuery = { __typename?: 'Query', corpCardCarousel?: { __typename: 'CorpCardCarousel', id: string, super?: string | null, title?: string | null, color?: CorpColorThemeName | null, cardVariant?: CorpCardCarouselVariant | null, corpCarouselType?: CorpCardCarouselType | null, slidesToShow?: number | null, storyItems: Array<{ __typename?: 'Story', id: string, title: string, slug?: string | null, date?: any | null, publishedAt?: any | null, tag?: CorpStoryTagEnum | null, image?: { __typename?: 'Asset', id: string, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null }>, buttonLink?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null } | null };

export type CorpContactCardContainerPartsFragment = { __typename: 'CorpContactCardContainer', id: string, corpContactCards: Array<{ __typename?: 'CorpContactCard', name?: string | null, description?: string | null, email?: string | null, linkedInUrl?: string | null, phone?: string | null, phoneLink?: string | null, image?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', id: string, url: string, mobile: string, mobileFallback: string, desktop: string, desktopFallback: string }> } | null }> };

export type GetCorpContactCardContainerQueryVariables = Exact<{
  where: CorpContactCardContainerWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetCorpContactCardContainerQuery = { __typename?: 'Query', corpContactCardContainer?: { __typename: 'CorpContactCardContainer', id: string, corpContactCards: Array<{ __typename?: 'CorpContactCard', name?: string | null, description?: string | null, email?: string | null, linkedInUrl?: string | null, phone?: string | null, phoneLink?: string | null, image?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', id: string, url: string, mobile: string, mobileFallback: string, desktop: string, desktopFallback: string }> } | null }> } | null };

export type GetCorpFormQueryVariables = Exact<{
  where: CorpFormWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetCorpFormQuery = { __typename?: 'Query', corpForm?: { __typename: 'CorpForm', id: string, formType: CorpFormType, title?: string | null, subtitle?: string | null, checkboxText?: { __typename: 'LongText', id: string, theme?: CorpColorThemeName | null, longText?: { __typename?: 'LongTextLongTextRichText', raw: any, references: Array<{ __typename: 'Asset', id: string, url: string, altText?: string | null, caption?: string | null, mimeType?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | { __typename: 'Widget', id: string, title: string, url: string, imageSource?: string | null, imageAlt?: string | null, type: Widgets }> } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null } | null };

export type GetCorpGenericAccordionQueryVariables = Exact<{
  where: CorpGenericAccordionWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetCorpGenericAccordionQuery = { __typename?: 'Query', corpGenericAccordion?: { __typename: 'CorpGenericAccordion', id: string, numbered?: boolean | null, corpGenericAccordionItems: Array<{ __typename?: 'CorpGenericAccordionItem', id: string, title: string, genericAccordionItemBodyComponents: Array<{ __typename: 'CorpBanner1', id: string } | { __typename: 'CorpCalendarEvent', id: string } | { __typename: 'CorpContactCardContainer', id: string } | { __typename: 'CorpGenericContainer', id: string } | { __typename: 'CorpGridColumnComponent', id: string } | { __typename: 'GenericDownloadComponent', id: string } | { __typename: 'ImageCopy', id: string } | { __typename: 'IntroText', id: string } | { __typename: 'LongText', id: string } | { __typename: 'QuickLink', id: string } | { __typename: 'Spacer', id: string }> }> } | null };

export type CorpGridColumnComponentPartsFragment = { __typename: 'CorpGridColumnComponent', id: string, gridMetaball: boolean, color?: CorpColorThemeName | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, cardData: Array<{ __typename?: 'ImageAndTextCard', subHeading?: string | null, title?: string | null, description?: string | null, metaBall?: boolean | null, image?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', altText?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> } | null, buttonLink?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null }> };

export type GetCorpGridColumnComponentQueryVariables = Exact<{
  where: CorpGridColumnComponentWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetCorpGridColumnComponentQuery = { __typename?: 'Query', corpGridColumnComponent?: { __typename: 'CorpGridColumnComponent', id: string, gridMetaball: boolean, color?: CorpColorThemeName | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, cardData: Array<{ __typename?: 'ImageAndTextCard', subHeading?: string | null, title?: string | null, description?: string | null, metaBall?: boolean | null, image?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', altText?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> } | null, buttonLink?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null }> } | null };

export type CorpHeroPartsFragment = { __typename: 'CorpHero', id: string, backgroundGradient?: boolean | null, superText?: string | null, title?: string | null, description?: string | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null, bannerImage?: { __typename?: 'Asset', imageAlt?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null, mobileImage?: { __typename?: 'Asset', mobile: string, mobileFallback: string } | null };

export type GetCorpHeroComponentQueryVariables = Exact<{
  where: CorpHeroWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetCorpHeroComponentQuery = { __typename?: 'Query', corpHero?: { __typename: 'CorpHero', id: string, backgroundGradient?: boolean | null, superText?: string | null, title?: string | null, description?: string | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null, bannerImage?: { __typename?: 'Asset', imageAlt?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null, mobileImage?: { __typename?: 'Asset', mobile: string, mobileFallback: string } | null } | null };

export type GetCorpMediaDownloadPreviewQueryVariables = Exact<{
  where: CorpMediaDownloadPreviewWhereUniqueInput;
  locales: Array<Locale> | Locale;
  itemsLocale: Locale;
}>;


export type GetCorpMediaDownloadPreviewQuery = { __typename?: 'Query', corpMediaDownloadPreview?: { __typename: 'CorpMediaDownloadPreview', id: string, super?: string | null, title?: string | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null } | null, downloads: Array<{ __typename?: 'MediaLibraryItem', id: string, title: string, mediaCategory: MediaLibraryCategory, market: Markets, mediaType: MediaLibraryItemType, assetComponent?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, mimeType?: string | null, fileName: string, size?: number | null, height?: number | null, width?: number | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> } | null, posterImage?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, mimeType?: string | null, fileName: string, size?: number | null, height?: number | null, width?: number | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> } | null }> };

export type CorpNavigationItemsPartFragment = { __typename?: 'CorpNavigationItem', createdAt: any, highlighted?: boolean | null, id: string, markets: Array<Markets>, excludedMarkets: Array<Markets>, cmsTitle?: string | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null };

export type GetCorpNavigationQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
}>;


export type GetCorpNavigationQuery = { __typename?: 'Query', corpNavigations: Array<{ __typename?: 'CorpNavigation', id: string, linkText: string, navigationItems: Array<{ __typename?: 'CorpNavigationItem', createdAt: any, highlighted?: boolean | null, id: string, markets: Array<Markets>, excludedMarkets: Array<Markets>, cmsTitle?: string | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null }> }> };

export type GetCorpNotificationBannerQueryVariables = Exact<{
  where: CorpNotificationBannerWhereInput;
  locales: Array<Locale> | Locale;
}>;


export type GetCorpNotificationBannerQuery = { __typename?: 'Query', corpNotificationBanners: Array<{ __typename: 'CorpNotificationBanner', id: string, title: string, description?: string | null, market: Markets, active?: boolean | null, bannerType?: BannerType | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null }> };

export type GetCorpOurPeopleQueryVariables = Exact<{
  where: CorpOurPeopleWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetCorpOurPeopleQuery = { __typename?: 'Query', corpOurPeople?: { __typename: 'CorpOurPeople', id: string, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, corpOurPeopleItems: Array<{ __typename?: 'CorpOurPeopleItem', id: string, name: string, description: string, favoriteProduct?: string | null, text?: string | null, image?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', altText?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> } | null }> } | null };

export type GetCorpSocialMediaFooterQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
}>;


export type GetCorpSocialMediaFooterQuery = { __typename?: 'Query', corpSocialMediaFooters: Array<{ __typename: 'CorpSocialMediaFooter', id: string, twitterLink?: string | null, youtubeLink?: string | null, instagramLink?: string | null, facebookLink?: string | null, linkedinLink?: string | null, xingLink?: string | null }> };

export type GetCorpTimelineAccordionWrapperQueryVariables = Exact<{
  where: CorpTimelineAccordionWrapperWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetCorpTimelineAccordionWrapperQuery = { __typename?: 'Query', corpTimelineAccordionWrapper?: { __typename: 'CorpTimelineAccordionWrapper', id: string, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, corpTimelineAccordions: Array<{ __typename: 'CorpTimelineAccordion', id: string, title?: string | null, daterange?: string | null, corpTimelineAccordionItems: Array<{ __typename: 'CorpTimelineAccordionItem', id: string, title: string, date?: string | null, image?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', id: string, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> } | null, text?: { __typename?: 'CorpTimelineAccordionItemTextRichText', html: string } | null }> }> } | null };

export type GetCorpVideoHeroCarouselComponentQueryVariables = Exact<{
  where: CorpVideoHeroCarouselWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetCorpVideoHeroCarouselComponentQuery = { __typename?: 'Query', corpVideoHeroCarousel?: { __typename: 'CorpVideoHeroCarousel', id: string, bannerSize?: VideoHeroBannerSize | null, autoPlay?: boolean | null, corpVideoHero: Array<{ __typename: 'CorpVideoHero', id: string, superTitle?: string | null, description?: string | null, videoId?: string | null, textColor?: VideoCarouselTextColor | null, contentAlignment?: AlignmentTypes | null, verticalAlignment?: VerticalAlignment | null, darkOverlay?: boolean | null, title?: string | null, linkComponent?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null, bannerImage?: { __typename?: 'Asset', imageAlt?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null, mobileImage?: { __typename?: 'Asset', mobile: string, mobileFallback: string } | null }> } | null };

export type CorpVideoHeroDetailsFragment = { __typename: 'CorpVideoHero', id: string, superTitle?: string | null, description?: string | null, videoId?: string | null, textColor?: VideoCarouselTextColor | null, contentAlignment?: AlignmentTypes | null, verticalAlignment?: VerticalAlignment | null, darkOverlay?: boolean | null, title?: string | null, linkComponent?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null, bannerImage?: { __typename?: 'Asset', imageAlt?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null, mobileImage?: { __typename?: 'Asset', mobile: string, mobileFallback: string } | null };

export type GetCorpVideoHeroComponentQueryVariables = Exact<{
  where: CorpVideoHeroWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetCorpVideoHeroComponentQuery = { __typename?: 'Query', corpVideoHero?: { __typename: 'CorpVideoHero', id: string, superTitle?: string | null, description?: string | null, videoId?: string | null, textColor?: VideoCarouselTextColor | null, contentAlignment?: AlignmentTypes | null, verticalAlignment?: VerticalAlignment | null, darkOverlay?: boolean | null, title?: string | null, linkComponent?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null, bannerImage?: { __typename?: 'Asset', imageAlt?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null, mobileImage?: { __typename?: 'Asset', mobile: string, mobileFallback: string } | null } | null };

export type GetCountrySelectorQueryVariables = Exact<{
  where?: InputMaybe<CountrySelectorWhereInput>;
  locales: Array<Locale> | Locale;
}>;


export type GetCountrySelectorQuery = { __typename?: 'Query', countrySelectors: Array<{ __typename: 'CountrySelector', id: string, title?: string | null, countryLabel?: string | null, languageLabel?: string | null, textOnButton?: string | null, countrySelectorList: Array<{ __typename?: 'CountrySelectorItem', id: string, country: string, countryCode: string, countryFlag?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', url: string, altText?: string | null }> } | null, language: Array<{ __typename?: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean }> }> }> };

export type GetDynamicCardGridQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where: DynamicCardGridWhereUniqueInput;
}>;


export type GetDynamicCardGridQuery = { __typename?: 'Query', dynamicCardGrid?: { __typename: 'DynamicCardGrid', id: string, subHeading?: string | null, heading?: string | null, description?: string | null, cardVariation?: CardVariation | null, cardLinkLabel?: string | null, showCards?: number | null, gridCta?: { __typename?: 'Link', displayName: string } | null, dictionaryItem: Array<{ __typename?: 'DictionaryItem', key: string, value: string }>, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, environment: DbEnvironment, extension?: any | null, tipsAndTricks?: any | null, products?: any | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetExampleComponentQueryVariables = Exact<{
  where: ExampleComponentWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetExampleComponentQuery = { __typename?: 'Query', exampleComponent?: { __typename?: 'ExampleComponent', id: string, title?: string | null, imageTextAlignment?: ImageTextAlignment | null, description?: { __typename?: 'ExampleComponentDescriptionRichText', text: string, html: string } | null, assetsComponents: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, url: string }> }> } | null };

export type GetFeaturedContentQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where: FeaturedContentWhereUniqueInput;
}>;


export type GetFeaturedContentQuery = { __typename?: 'Query', featuredContent?: { __typename: 'FeaturedContent', id: string, title: string, superText?: string | null, dictionary?: { __typename?: 'Dictionary', dictionaryItems: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> } | null, items: Array<{ __typename: 'AuthorableContentCard', id: string, copy: string, name: string, subtitle?: string | null, videoId?: string | null, image?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', id: string, url: string, mobile: string, mobileFallback: string, desktop: string, desktopFallback: string, hero: string, tablet: string, tabletFallback: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | { __typename: 'FeaturedContentReference', id: string, title?: string | null, recipeId?: string | null }>, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetFooterQueryVariables = Exact<{
  footerNavigation?: InputMaybe<FooterNavigationWhereInput>;
  locales: Array<Locale> | Locale;
}>;


export type GetFooterQuery = { __typename?: 'Query', footerNavigations: Array<{ __typename?: 'FooterNavigation', footerNavType: FooterNav, id: string, cmsTitle: string, links: Array<{ __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null }> }> };

export type GetFormQueryVariables = Exact<{
  where: FormWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetFormQuery = { __typename?: 'Query', form?: { __typename: 'Form', id: string, formFields: Array<{ __typename: 'FormCheckbox', id: string, fieldName?: string | null, label?: string | null, required?: boolean | null, requiredErrorMessage?: string | null, title?: string | null } | { __typename: 'FormEmailInput', id: string, placeholderText?: string | null, label?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename: 'FormPasswordInput', id: string, label?: string | null, fieldName?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename: 'FormPasswordInputWithConfirmation', id: string, title?: string | null, confirmationTitle?: string | null } | { __typename?: 'FormRadioButtonCollection', id: string, requiredErrorMessage?: string | null, required?: boolean | null, fieldName?: string | null, title?: string | null, formRadioButtons: Array<{ __typename?: 'FormRadioButton', label?: string | null, option?: string | null, title?: string | null }> } | { __typename: 'FormSelectComponent', id: string, label?: string | null, fieldName?: string | null, initialValue?: string | null, options: Array<{ __typename?: 'FormSelectOption', label: string, id: string, value: string }> } | { __typename: 'FormSubmitButton', id: string, buttonLoadingText?: string | null, buttonText?: string | null } | { __typename: 'FormTextInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null } | { __typename: 'FormTextareaInput', id: string, label?: string | null, placeholderText?: string | null, title?: string | null, fieldName?: string | null, initialValue?: string | null, required?: boolean | null, requiredErrorMessage?: string | null }>, formErrors: Array<{ __typename?: 'FormError', id: string, message?: string | null, errorCode?: number | null }>, formSuccess?: { __typename?: 'FormSuccessComponent', id: string, message: string, description?: string | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type MetadataPartsFragment = { __typename?: 'MetaData', id: string, pageName: string, description?: string | null, openGraphType?: string | null, theme?: string | null, images: Array<{ __typename?: 'Asset', id: string, url: string }> };

export type GetCorpAddToCalendarQueryVariables = Exact<{
  where: CorpAddToCalendarWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetCorpAddToCalendarQuery = { __typename?: 'Query', corpAddToCalendar?: { __typename: 'CorpAddToCalendar', id: string, title?: string | null, description?: string | null, startDate?: any | null, endDate?: any | null, location?: string | null } | null };

export type GetGenericAccordionTopRatedQueryVariables = Exact<{
  where: GenericAccordionTopRatedWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetGenericAccordionTopRatedQuery = { __typename?: 'Query', genericAccordionTopRated?: { __typename: 'GenericAccordionTopRated', id: string, title?: string | null, super?: string | null, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, topRated?: boolean | null, environment: DbEnvironment, extension?: any | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetGenericAccordionQueryVariables = Exact<{
  where: GenericAccordionWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetGenericAccordionQuery = { __typename?: 'Query', genericAccordion?: { __typename: 'GenericAccordion', id: string, numbered?: boolean | null, genericAccordionItems: Array<{ __typename?: 'GenericAccordionItem', id: string, title: string, alignment: AccordionContentAlignment, text?: { __typename?: 'GenericAccordionItemTextRichText', html: string } | null }> } | null };

export type GetGenericGridAuthorableQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where: GenericGridAuthorableWhereUniqueInput;
}>;


export type GetGenericGridAuthorableQuery = { __typename?: 'Query', genericGridAuthorable?: { __typename: 'GenericGridAuthorable', id: string, title?: string | null, superText?: string | null, regularLayout?: boolean | null, dictionary?: { __typename?: 'Dictionary', dictionaryItems: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> } | null, cards: Array<{ __typename: 'AuthorableContentCard', id: string, copy: string, name: string, subtitle?: string | null, videoId?: string | null, image?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', id: string, url: string, mobile: string, mobileFallback: string, desktop: string, desktopFallback: string, hero: string, heroFallback: string, tablet: string, tabletFallback: string }> } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | { __typename: 'FeaturedContentReference', id: string, title?: string | null, recipeId?: string | null, tipsAndTricksId?: string | null, articlePage?: { __typename?: 'GenericPage', slug: string, title: string, id: string } | null }> } | null };

export type GetGenericCardCarouseComponentQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where: GenericCardCarouseComponentWhereUniqueInput;
}>;


export type GetGenericCardCarouseComponentQuery = { __typename?: 'Query', genericCardCarouseComponent?: { __typename: 'GenericCardCarouseComponent', id: string, key?: string | null, subHeading?: string | null, heading?: string | null, cardVariation?: CardVariation | null, pointCtaToArticlesList?: boolean | null, componentBackground: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', url: string }> }>, floatingObject: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', url: string, altText?: string | null }> }>, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, environment: DbEnvironment, extension?: any | null, tipsAndTricks?: any | null, products?: any | null } | null, dictionaryItem: Array<{ __typename?: 'DictionaryItem', key: string, value: string }>, genericCardCarouselCta?: { __typename?: 'Link', displayName: string, url?: string | null } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, articles: Array<{ __typename: 'GenericPage', slug: string, title: string, id: string, metaData?: { __typename?: 'MetaData', id: string, images: Array<{ __typename?: 'Asset', url: string }> } | null }> } | null };

export type GenericContainerPartsFragment = { __typename: 'CorpGenericContainer', id: string, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, content?: { __typename: 'BigNumber', id: string } | { __typename: 'ProgressBar', id: string } | null };

export type GetCorpGenericContainerQueryVariables = Exact<{
  where: CorpGenericContainerWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetCorpGenericContainerQuery = { __typename?: 'Query', corpGenericContainer?: { __typename: 'CorpGenericContainer', id: string, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, content?: { __typename: 'BigNumber', id: string } | { __typename: 'ProgressBar', id: string } | null } | null };

export type GetGenericDownloadComponentQueryVariables = Exact<{
  where: GenericDownloadComponentWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetGenericDownloadComponentQuery = { __typename?: 'Query', genericDownloadComponent?: { __typename: 'GenericDownloadComponent', id: string, superText?: string | null, title: string, body: string, downloadableFile: { __typename?: 'Asset', url: string }, assetComponent?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', altText?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GenericFollowUsPartsFragment = { __typename: 'GenericFollowUs', id: string, super?: string | null, title?: string | null, color: CorpColorThemeName, socialMedia: Array<{ __typename?: 'SocialMediaListComponent', name: string, url: string, assetsComponents: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, url: string }> }> }>, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null };

export type GetGenericFollowUsQueryVariables = Exact<{
  where: GenericFollowUsWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetGenericFollowUsQuery = { __typename?: 'Query', genericFollowUs?: { __typename: 'GenericFollowUs', id: string, super?: string | null, title?: string | null, color: CorpColorThemeName, socialMedia: Array<{ __typename?: 'SocialMediaListComponent', name: string, url: string, assetsComponents: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, url: string }> }> }>, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetGenericLineQueryVariables = Exact<{
  where: GenericLineWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetGenericLineQuery = { __typename?: 'Query', genericLine?: { __typename: 'GenericLine', enableLine?: boolean | null, id: string } | null };

export type GetGenericPageQueryVariables = Exact<{
  where?: InputMaybe<GenericPageWhereInput>;
  locales: Array<Locale> | Locale;
}>;


export type GetGenericPageQuery = { __typename?: 'Query', genericPages: Array<{ __typename?: 'GenericPage', slug: string, hideNavigation?: boolean | null, title: string, showCookieBanner: boolean, contentGroupingTrackingValue?: TrackingContentGrouping | null, contentGroupingTrackingValues?: TrackingContentGrouping | null, alwaysIndex?: boolean | null, markets: Array<Markets>, metaData?: { __typename?: 'MetaData', id: string, pageName: string, description?: string | null, openGraphType?: string | null, theme?: string | null, images: Array<{ __typename?: 'Asset', id: string, url: string }> } | null, anchorNavigationList?: { __typename?: 'AnchorNavigationList', id: string, anchorNavigations: Array<{ __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null }> } | null, pageComponents: Array<{ __typename: 'AnchorNavigationList', id: string } | { __typename: 'AudioComponent', id: string } | { __typename: 'AuthorableContentCard', id: string } | { __typename: 'Banner2', id: string } | { __typename: 'CarouselComponent', id: string } | { __typename?: 'ContactCardContainer' } | { __typename: 'CorpBanner1', id: string } | { __typename: 'CorpCalendarEvent', id: string } | { __typename: 'CorpCardCarousel', id: string, corpCarouselType?: CorpCardCarouselType | null } | { __typename: 'CorpContactCardContainer', id: string } | { __typename: 'CorpForm', id: string } | { __typename: 'CorpGenericAccordion', id: string } | { __typename?: 'CorpGenericBanner' } | { __typename: 'CorpGenericContainer', id: string } | { __typename: 'CorpGridColumnComponent', id: string } | { __typename: 'CorpHero', id: string } | { __typename: 'CorpMediaDownloadPreview', id: string } | { __typename: 'CorpOurPeople', id: string } | { __typename: 'CorpTimelineAccordionWrapper', id: string } | { __typename: 'CorpVideoHero', id: string } | { __typename: 'CorpVideoHeroCarousel', id: string } | { __typename: 'DynamicCardGrid', id: string } | { __typename: 'ExampleComponent', id: string } | { __typename: 'FeaturedContent', id: string } | { __typename: 'Form', id: string } | { __typename: 'GenericAccordion', id: string } | { __typename: 'GenericAccordionTopRated', id: string } | { __typename: 'GenericCardCarouseComponent', id: string } | { __typename: 'GenericDownloadComponent', id: string } | { __typename: 'GenericFollowUs', id: string } | { __typename: 'GenericGridAuthorable', id: string } | { __typename: 'GenericLine', id: string } | { __typename?: 'GenericPage' } | { __typename?: 'HeroBanner' } | { __typename: 'HeroCarouselComponent', id: string } | { __typename: 'HeroComponent', id: string } | { __typename: 'Iframe', id: string } | { __typename?: 'ImageAndTextCard' } | { __typename: 'ImageCopy', id: string } | { __typename: 'IntroText', id: string } | { __typename: 'Link', id: string } | { __typename: 'LocationComponent', id: string } | { __typename: 'LongText', id: string } | { __typename?: 'MetaData' } | { __typename?: 'PageFooter' } | { __typename?: 'PageHeader' } | { __typename: 'ProgressBar', id: string } | { __typename: 'QuickLink', id: string } | { __typename?: 'SearchInput' } | { __typename: 'ShortHero', id: string } | { __typename: 'Spacer', id: string } | { __typename: 'Tab', id: string }> }> };

export type GetGenericPagesForSitemapQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGenericPagesForSitemapQuery = { __typename?: 'Query', genericPages: Array<{ __typename?: 'GenericPage', markets: Array<Markets>, alwaysIndex?: boolean | null, localizations: Array<{ __typename?: 'GenericPage', locale: Locale, slug: string }> }> };

export type GetGlobalMetadataQueryVariables = Exact<{
  where: GlobalMetaDataWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetGlobalMetadataQuery = { __typename?: 'Query', globalMetaData?: { __typename?: 'GlobalMetaData', siteName: string, url: string, titleTemplate: string, description?: string | null, facebookAppId?: string | null, image?: { __typename?: 'Asset', url: string, height?: number | null, width?: number | null } | null, twitterSeo?: { __typename?: 'TwitterSeo', handle?: string | null, site?: string | null, cardType: TwitterCardTypes } | null } | null };

export type GetHeaderQueryVariables = Exact<{
  where?: InputMaybe<NavigationWhereInput>;
  locales: Array<Locale> | Locale;
}>;


export type GetHeaderQuery = { __typename?: 'Query', navigations: Array<{ __typename?: 'Navigation', cmsTitle?: string | null, positon: NavigationTypes, key: string, navUrl?: string | null, cardComponentTitle?: string | null, links: Array<{ __typename?: 'Link', url?: string | null, displayName: string, openInNewTab: boolean, id: string }>, category: Array<{ __typename?: 'NavigationItem', title?: string | null, targetLink?: string | null, trackingSecondaryNavigation?: string | null, subCategory: Array<{ __typename?: 'Link', displayName: string, url?: string | null, openInNewTab: boolean, id: string }> }>, navigation_images: Array<{ __typename?: 'AssetComponent', cmsAssetTitle?: string | null, asset: Array<{ __typename?: 'Asset', url: string, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> }>, navCard?: { __typename?: 'CardComponent', cardId: string, category: string, categoryId: string, description?: string | null, difficulty?: string | null, preparationTime?: string | null, rating?: string | null, title: string, video?: string | null, cardVariation?: CardVariation | null, parentPage?: string | null, parentCategory?: string | null, linkTitle?: string | null, image: Array<{ __typename?: 'AssetComponent', id: string, cmsAssetTitle?: string | null, asset: Array<{ __typename?: 'Asset', url: string, altText?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> }> } | null }> };

export type GetMobileHeaderQueryVariables = Exact<{
  where: MobileOnlyMainNavigationWhereUniqueInput;
}>;


export type GetMobileHeaderQuery = { __typename?: 'Query', mobileOnlyMainNavigation?: { __typename?: 'MobileOnlyMainNavigation', navigationAsset: Array<{ __typename?: 'AssetComponent', id: string, cmsAssetTitle?: string | null, asset: Array<{ __typename?: 'Asset', altText?: string | null, url: string, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> }> } | null };

export type GetHeroCarouselComponentQueryVariables = Exact<{
  where: HeroCarouselComponentWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetHeroCarouselComponentQuery = { __typename?: 'Query', heroCarouselComponent?: { __typename: 'HeroCarouselComponent', id: string, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, banners: Array<{ __typename?: 'HeroBanner', bannerSize?: BannerHeight | null, bannerTitle?: string | null, superText?: string | null, bannerDescriptionText?: string | null, bannerVideoUrl?: string | null, alignment?: AlignmentTypes | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null, bannerImage: Array<{ __typename?: 'Asset', imageAlt?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }>, mobileImage?: { __typename?: 'Asset', mobile: string, mobileFallback: string } | null }> } | null };

export type GetHeroComponentQueryVariables = Exact<{
  where: HeroComponentWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetHeroComponentQuery = { __typename?: 'Query', heroComponent?: { __typename: 'HeroComponent', id: string, superText?: string | null, title?: string | null, description?: string | null, alignment?: AlignmentTypes | null, imageComponent?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> } | null, topRightImageAsset?: { __typename?: 'Asset', desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null, bottomLeftImageAsset?: { __typename?: 'Asset', desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null, mobileImage?: { __typename?: 'Asset', mobile: string, mobileFallback: string } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetIframeQueryVariables = Exact<{
  where: IframeWhereUniqueInput;
}>;


export type GetIframeQuery = { __typename?: 'Query', iframe?: { __typename: 'Iframe', id: string, cmsTitle?: string | null, iframeUrl: string, iframeType: IframeTypes, iframeWidth?: string | null, iframeHeight: string, alignment?: IFrameAlignment | null } | null };

export type ImageCopyPartsFragment = { __typename: 'ImageCopy', id: string, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, imageCopyItem: Array<{ __typename?: 'ImageCopyItem', id: string, title?: string | null, columnType: ColumnType, addImage?: boolean | null, imagePosition?: DisplayPosition | null, addTitle?: boolean | null, addVideo?: boolean | null, videoPosition?: DisplayPosition | null, addDescription?: boolean | null, videoId?: string | null, description?: { __typename?: 'ImageCopyItemDescriptionRichText', json: any, references: Array<{ __typename: 'QuickLink', id: string, headline?: string | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, quickLinkItems: Array<{ __typename?: 'QuickLinkItem', buttonHeadline: string, buttonSubheadline?: string | null, id: string, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null }> }> } | null, image: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', altText?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> }>, videoPosterImage?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', altText?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> } | null }> };

export type GetImageCopyQueryVariables = Exact<{
  where: ImageCopyWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetImageCopyQuery = { __typename?: 'Query', imageCopy?: { __typename: 'ImageCopy', id: string, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, imageCopyItem: Array<{ __typename?: 'ImageCopyItem', id: string, title?: string | null, columnType: ColumnType, addImage?: boolean | null, imagePosition?: DisplayPosition | null, addTitle?: boolean | null, addVideo?: boolean | null, videoPosition?: DisplayPosition | null, addDescription?: boolean | null, videoId?: string | null, description?: { __typename?: 'ImageCopyItemDescriptionRichText', json: any, references: Array<{ __typename: 'QuickLink', id: string, headline?: string | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, quickLinkItems: Array<{ __typename?: 'QuickLinkItem', buttonHeadline: string, buttonSubheadline?: string | null, id: string, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null }> }> } | null, image: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', altText?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> }>, videoPosterImage?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', altText?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> } | null }> } | null };

export type IntroTextPartsFragment = { __typename: 'IntroText', id: string, title?: string | null, description?: string | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, richText?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null };

export type GetIntroTextQueryVariables = Exact<{
  where: IntroTextWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetIntroTextQuery = { __typename?: 'Query', introText?: { __typename: 'IntroText', id: string, title?: string | null, description?: string | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, richText?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null } | null };

export type LinkPartsFragment = { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null };

export type GetLinkQueryVariables = Exact<{
  where: LinkWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetLinkQuery = { __typename?: 'Query', link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null };

export type GetLocationComponentQueryVariables = Exact<{
  where: LocationComponentWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetLocationComponentQuery = { __typename?: 'Query', locationComponent?: { __typename: 'LocationComponent', id: string, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, mapAllSites?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', url: string, id: string, altText?: string | null }> } | null, mapProductionSites?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', url: string, altText?: string | null }> } | null, locationItems: Array<{ __typename: 'LocationItem', id: string, locationName?: string | null, description?: string | null, date?: string | null, isProductionSite?: boolean | null, numberOfEmployees: number }> } | null };

export type GetLocationItemQueryVariables = Exact<{
  where: LocationItemWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetLocationItemQuery = { __typename?: 'Query', locationItem?: { __typename: 'LocationItem', id: string, locationName?: string | null, description?: string | null, date?: string | null, isProductionSite?: boolean | null, numberOfEmployees: number, bodyComponents: Array<{ __typename: 'CorpContactCardContainer', id: string } | { __typename: 'CorpGenericContainer', id: string } | { __typename: 'CorpGridColumnComponent', id: string } | { __typename: 'ImageCopy', id: string } | { __typename: 'LongText', id: string } | { __typename: 'QuickLink', id: string } | { __typename: 'Spacer', id: string }> } | null };

export type LongTextPartsFragment = { __typename: 'LongText', id: string, theme?: CorpColorThemeName | null, longText?: { __typename?: 'LongTextLongTextRichText', raw: any, references: Array<{ __typename: 'Asset', id: string, url: string, altText?: string | null, caption?: string | null, mimeType?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | { __typename: 'Widget', id: string, title: string, url: string, imageSource?: string | null, imageAlt?: string | null, type: Widgets }> } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null };

export type GetLongTextQueryVariables = Exact<{
  where: LongTextWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetLongTextQuery = { __typename?: 'Query', longText?: { __typename: 'LongText', id: string, theme?: CorpColorThemeName | null, longText?: { __typename?: 'LongTextLongTextRichText', raw: any, references: Array<{ __typename: 'Asset', id: string, url: string, altText?: string | null, caption?: string | null, mimeType?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | { __typename: 'Widget', id: string, title: string, url: string, imageSource?: string | null, imageAlt?: string | null, type: Widgets }> } | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null };

export type GetMediaLibraryItemsAlgoliaQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMediaLibraryItemsAlgoliaQuery = { __typename?: 'Query', mediaLibraryItemsConnection: { __typename?: 'MediaLibraryItemConnection', edges: Array<{ __typename?: 'MediaLibraryItemEdge', node: { __typename?: 'MediaLibraryItem', id: string, market: Markets, mediaCategory: MediaLibraryCategory, mediaType: MediaLibraryItemType, localizations: Array<{ __typename?: 'MediaLibraryItem', locale: Locale, title: string }>, assetComponent?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, mimeType?: string | null, fileName: string, size?: number | null, height?: number | null, width?: number | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> } | null, posterImage?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, mimeType?: string | null, fileName: string, size?: number | null, height?: number | null, width?: number | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, pageSize?: number | null, startCursor?: string | null, endCursor?: string | null }, aggregate: { __typename?: 'Aggregate', count: number } } };

export type MediaLibraryItemPartsFragment = { __typename?: 'MediaLibraryItem', id: string, title: string, mediaCategory: MediaLibraryCategory, market: Markets, mediaType: MediaLibraryItemType, assetComponent?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, mimeType?: string | null, fileName: string, size?: number | null, height?: number | null, width?: number | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> } | null, posterImage?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, url: string, altText?: string | null, mimeType?: string | null, fileName: string, size?: number | null, height?: number | null, width?: number | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string }> } | null };

export type GetMediaLibraryQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
}>;


export type GetMediaLibraryQuery = { __typename?: 'Query', page: Array<{ __typename?: 'MediaLibrary', title: string, subtitle: string, introText: string, metaData?: { __typename?: 'MetaData', id: string, pageName: string, description?: string | null, openGraphType?: string | null, theme?: string | null, images: Array<{ __typename?: 'Asset', id: string, url: string }> } | null, bodyComponents: Array<{ __typename: 'Banner2', id: string } | { __typename: 'CarouselComponent', id: string } | { __typename: 'CorpBanner1', id: string } | { __typename: 'CorpContactCardContainer', id: string } | { __typename: 'CorpGenericAccordion', id: string } | { __typename: 'CorpGenericContainer', id: string } | { __typename: 'CorpGridColumnComponent', id: string } | { __typename: 'LongText', id: string } | { __typename: 'QuickLink', id: string } | { __typename: 'Spacer', id: string }> }> };

export type GetNotificationBannerQueryVariables = Exact<{
  where?: InputMaybe<NotificationBannerWhereInput>;
  locales: Array<Locale> | Locale;
}>;


export type GetNotificationBannerQuery = { __typename?: 'Query', notificationBanners: Array<{ __typename: 'NotificationBanner', id: string, active?: boolean | null, cmsTitle: string, title?: string | null, description?: string | null, link?: { __typename?: 'Link', displayName: string, url?: string | null, openInNewTab: boolean, id: string } | null }> };

export type GetPageSearchQueryVariables = Exact<{
  search: Scalars['String']['input'];
  locales: Array<Locale> | Locale;
  localeGlobalPressRelease: Locale;
  storyPressMarkets: Array<Markets> | Markets;
  pagesMarket: Markets;
  first?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPageSearchQuery = { __typename?: 'Query', stories: { __typename?: 'StoryConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, pageSize?: number | null, startCursor?: string | null, endCursor?: string | null }, aggregate: { __typename?: 'Aggregate', count: number }, edges: Array<{ __typename?: 'StoryEdge', cursor: string, node: { __typename?: 'Story', id: string, title: string, slug?: string | null, locale: Locale, teaser: string, markets: Array<Markets>, storyTagEnum?: CorpStoryTagEnum | null, date?: any | null, image?: { __typename?: 'Asset', id: string, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null } }> }, pressReleasesGlobal: { __typename?: 'PressReleaseConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, pageSize?: number | null, startCursor?: string | null, endCursor?: string | null }, aggregate: { __typename?: 'Aggregate', count: number }, edges: Array<{ __typename?: 'PressReleaseEdge', cursor: string, node: { __typename?: 'PressRelease', id: string, title?: string | null, slug?: string | null, locale: Locale, market: Markets, teaser?: string | null, date?: any | null, image?: { __typename?: 'Asset', id: string, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null } }> }, pressReleases: { __typename?: 'PressReleaseConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, pageSize?: number | null, startCursor?: string | null, endCursor?: string | null }, aggregate: { __typename?: 'Aggregate', count: number }, edges: Array<{ __typename?: 'PressReleaseEdge', cursor: string, node: { __typename?: 'PressRelease', id: string, title?: string | null, slug?: string | null, locale: Locale, market: Markets, teaser?: string | null, date?: any | null, image?: { __typename?: 'Asset', id: string, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null } }> }, pages: { __typename?: 'GenericPageConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, pageSize?: number | null, startCursor?: string | null, endCursor?: string | null }, aggregate: { __typename?: 'Aggregate', count: number }, edges: Array<{ __typename?: 'GenericPageEdge', cursor: string, node: { __typename?: 'GenericPage', id: string, title: string, slug: string, locale: Locale, markets: Array<Markets>, createdAt: any, metaData?: { __typename?: 'MetaData', pageName: string, description?: string | null } | null } }> } };

export type GetPressPageIntroQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
}>;


export type GetPressPageIntroQuery = { __typename?: 'Query', page: Array<{ __typename?: 'CorpPressPage', title: string, subtitle: string, introText: string, metaData?: { __typename?: 'MetaData', id: string, pageName: string, description?: string | null, openGraphType?: string | null, theme?: string | null, images: Array<{ __typename?: 'Asset', id: string, url: string }> } | null }> };

export type GetPressReleasesFilteredQueryVariables = Exact<{
  where?: InputMaybe<PressReleaseWhereInput>;
  locales: Array<Locale> | Locale;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPressReleasesFilteredQuery = { __typename?: 'Query', pressReleases: Array<{ __typename?: 'PressRelease', id: string, date?: any | null, slug?: string | null, title?: string | null, tag?: CorpPressReleaseTopicEnum | null, image?: { __typename?: 'Asset', id: string, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null }> };

export type PressReleasePartsFragment = { __typename?: 'PressRelease', id: string, title?: string | null, slug?: string | null, teaser?: string | null, alwaysIndex?: boolean | null, market: Markets, topicEnum?: CorpPressReleaseTopicEnum | null, date?: any | null, publishedAt?: any | null, metaData?: { __typename?: 'MetaData', id: string, pageName: string, description?: string | null, openGraphType?: string | null, theme?: string | null, images: Array<{ __typename?: 'Asset', id: string, url: string }> } | null, corpContactCardContainer?: { __typename: 'CorpContactCardContainer', id: string, corpContactCards: Array<{ __typename?: 'CorpContactCard', name?: string | null, description?: string | null, email?: string | null, linkedInUrl?: string | null, phone?: string | null, phoneLink?: string | null, image?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', id: string, url: string, mobile: string, mobileFallback: string, desktop: string, desktopFallback: string }> } | null }> } | null, downloadPr?: { __typename?: 'Asset', id: string, mimeType?: string | null, url: string } | null, downloadImage?: { __typename?: 'Asset', id: string, mimeType?: string | null, url: string } | null, image?: { __typename?: 'Asset', id: string, mimeType?: string | null, url: string } | null, content: { __typename?: 'PressReleaseContentRichText', html: string, json: any, references: Array<{ __typename?: 'Asset', id: string, mimeType?: string | null, url: string }> } };

export type GetPressReleaseQueryVariables = Exact<{
  where?: InputMaybe<PressReleaseWhereInput>;
  locales: Array<Locale> | Locale;
}>;


export type GetPressReleaseQuery = { __typename?: 'Query', pressReleases: Array<{ __typename?: 'PressRelease', id: string, title?: string | null, slug?: string | null, teaser?: string | null, alwaysIndex?: boolean | null, market: Markets, topicEnum?: CorpPressReleaseTopicEnum | null, date?: any | null, publishedAt?: any | null, metaData?: { __typename?: 'MetaData', id: string, pageName: string, description?: string | null, openGraphType?: string | null, theme?: string | null, images: Array<{ __typename?: 'Asset', id: string, url: string }> } | null, corpContactCardContainer?: { __typename: 'CorpContactCardContainer', id: string, corpContactCards: Array<{ __typename?: 'CorpContactCard', name?: string | null, description?: string | null, email?: string | null, linkedInUrl?: string | null, phone?: string | null, phoneLink?: string | null, image?: { __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', id: string, url: string, mobile: string, mobileFallback: string, desktop: string, desktopFallback: string }> } | null }> } | null, downloadPr?: { __typename?: 'Asset', id: string, mimeType?: string | null, url: string } | null, downloadImage?: { __typename?: 'Asset', id: string, mimeType?: string | null, url: string } | null, image?: { __typename?: 'Asset', id: string, mimeType?: string | null, url: string } | null, content: { __typename?: 'PressReleaseContentRichText', html: string, json: any, references: Array<{ __typename?: 'Asset', id: string, mimeType?: string | null, url: string }> } }> };

export type GetPressReleasesAlgoliaQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPressReleasesAlgoliaQuery = { __typename?: 'Query', pressReleasesConnection: { __typename?: 'PressReleaseConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, pageSize?: number | null, startCursor?: string | null, endCursor?: string | null }, aggregate: { __typename?: 'Aggregate', count: number }, edges: Array<{ __typename?: 'PressReleaseEdge', cursor: string, node: { __typename?: 'PressRelease', id: string, topicEnum?: CorpPressReleaseTopicEnum | null, date?: any | null, market: Markets, localizations: Array<{ __typename?: 'PressRelease', title?: string | null, slug?: string | null, locale: Locale, teaser?: string | null }>, image?: { __typename?: 'Asset', id: string, url: string } | null, downloadPr?: { __typename?: 'Asset', url: string } | null } }> } };

export type GetPressReleasesForSitemapQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPressReleasesForSitemapQuery = { __typename?: 'Query', pressReleases: Array<{ __typename?: 'PressRelease', market: Markets, localizations: Array<{ __typename?: 'PressRelease', slug?: string | null, locale: Locale }> }> };

export type GetProgressBarQueryVariables = Exact<{
  where: ProgressBarWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetProgressBarQuery = { __typename?: 'Query', progressBar?: { __typename: 'ProgressBar', id: string, current: number, end: number, headline?: string | null, start: number, color?: CorpColorThemeName | null, caption?: string | null } | null };

export type GetQuickLinkQueryVariables = Exact<{
  where: QuickLinkWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetQuickLinkQuery = { __typename?: 'Query', quickLink?: { __typename: 'QuickLink', id: string, headline?: string | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, quickLinkItems: Array<{ __typename?: 'QuickLinkItem', buttonHeadline: string, buttonSubheadline?: string | null, id: string, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null }> } | null };

export type GetRewritesQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where?: InputMaybe<RewriteWhereInput>;
}>;


export type GetRewritesQuery = { __typename?: 'Query', rewrites: Array<{ __typename?: 'Rewrite', destination: string, source: string, showLocale: boolean, page: RewriteTypes, locale: Locale }> };

export type GetSearchOverlayQueryVariables = Exact<{
  where?: InputMaybe<SearchOverlayComponentWhereInput>;
  locales: Array<Locale> | Locale;
}>;


export type GetSearchOverlayQuery = { __typename?: 'Query', searchOverlayComponents: Array<{ __typename?: 'SearchOverlayComponent', heading?: string | null, subHeading?: string | null, links: Array<{ __typename?: 'Link', displayName: string, url?: string | null }>, dictionaries: Array<{ __typename?: 'Dictionary', dictionaryTitle?: string | null, dictionaryItems: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> }> }> };

export type GetCardCarouselQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where?: InputMaybe<GenericCardCarouseComponentWhereInput>;
}>;


export type GetCardCarouselQuery = { __typename?: 'Query', genericCardCarouseComponents: Array<{ __typename?: 'GenericCardCarouseComponent', subHeading?: string | null, heading?: string | null, cardVariation?: CardVariation | null, componentBackground: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', url: string }> }>, floatingObject: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', url: string, altText?: string | null }> }>, extension?: { __typename: 'AlgoliaExtension', id: string, markets: Markets, environment: DbEnvironment, extension?: any | null, tipsAndTricks?: any | null } | null, dictionaryItem: Array<{ __typename?: 'DictionaryItem', key: string, value: string }>, genericCardCarouselCta?: { __typename?: 'Link', displayName: string, url?: string | null } | null }> };

export type GetSearchResultPageQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
  where?: InputMaybe<SearchResultPageWhereInput>;
}>;


export type GetSearchResultPageQuery = { __typename?: 'Query', searchResultPages: Array<{ __typename?: 'SearchResultPage', searchPageTitles?: { __typename?: 'Dictionary', dictionaryItems: Array<{ __typename?: 'DictionaryItem', key: string, value: string }> } | null }> };

export type GetShortHeroComponentQueryVariables = Exact<{
  where: ShortHeroWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetShortHeroComponentQuery = { __typename?: 'Query', shortHero?: { __typename: 'ShortHero', id: string, title?: string | null, superTitle?: string | null, description?: string | null } | null };

export type GetSocialSharingQueryVariables = Exact<{
  where?: InputMaybe<SocialMediaListComponentWhereInput>;
}>;


export type GetSocialSharingQuery = { __typename?: 'Query', socialMediaListComponents: Array<{ __typename: 'SocialMediaListComponent', id: string, name: string, url: string, shareMsg?: string | null, socialMediaComponentName?: SocialMediaComponentName | null, socialSharePosition: SocialSharePosition, assetsComponents: Array<{ __typename?: 'AssetComponent', asset: Array<{ __typename?: 'Asset', url: string }> }> }> };

export type SpacerPartsFragment = { __typename: 'Spacer', id: string, height?: number | null };

export type GetSpacerQueryVariables = Exact<{
  where: SpacerWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetSpacerQuery = { __typename?: 'Query', spacer?: { __typename: 'Spacer', id: string, height?: number | null } | null };

export type GetStoriesAlgoliaQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetStoriesAlgoliaQuery = { __typename?: 'Query', storiesConnection: { __typename?: 'StoryConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, pageSize?: number | null, startCursor?: string | null, endCursor?: string | null }, aggregate: { __typename?: 'Aggregate', count: number }, edges: Array<{ __typename?: 'StoryEdge', cursor: string, node: { __typename?: 'Story', id: string, markets: Array<Markets>, storyTagEnum?: CorpStoryTagEnum | null, date?: any | null, localizations: Array<{ __typename?: 'Story', title: string, slug?: string | null, locale: Locale, teaser: string }>, image?: { __typename?: 'Asset', id: string, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null } }> } };

export type GetStoriesFilteredQueryVariables = Exact<{
  where?: InputMaybe<StoryWhereInput>;
  locales: Array<Locale> | Locale;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetStoriesFilteredQuery = { __typename?: 'Query', stories: Array<{ __typename?: 'Story', id: string, date?: any | null, slug?: string | null, title: string, tag?: CorpStoryTagEnum | null, image?: { __typename?: 'Asset', id: string, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null }> };

export type GetStoriesPageQueryVariables = Exact<{
  locales: Array<Locale> | Locale;
}>;


export type GetStoriesPageQuery = { __typename?: 'Query', page: Array<{ __typename?: 'CorpStoriesPage', introText?: { __typename: 'IntroText', id: string, title?: string | null, description?: string | null, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, richText?: { __typename?: 'RichText', raw: any } | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null } | null, corpHero?: { __typename: 'CorpHero', id: string, backgroundGradient?: boolean | null, superText?: string | null, title?: string | null, description?: string | null, link?: { __typename: 'Link', id: string, displayName: string, url?: string | null, openInNewTab: boolean, internalLink?: { __typename?: 'GenericPage', slug: string } | null } | null, bannerImage?: { __typename?: 'Asset', imageAlt?: string | null, desktop: string, desktopFallback: string, mobile: string, mobileFallback: string } | null, mobileImage?: { __typename?: 'Asset', mobile: string, mobileFallback: string } | null } | null, genericFollowUs?: { __typename: 'GenericFollowUs', id: string, super?: string | null, title?: string | null, color: CorpColorThemeName, socialMedia: Array<{ __typename?: 'SocialMediaListComponent', name: string, url: string, assetsComponents: Array<{ __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', id: string, url: string }> }> }>, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null } | null, metaData?: { __typename?: 'MetaData', id: string, pageName: string, description?: string | null, openGraphType?: string | null, theme?: string | null, images: Array<{ __typename?: 'Asset', id: string, url: string }> } | null }> };

export type GetStoriesForSitemapQueryVariables = Exact<{
  where?: InputMaybe<StoryWhereInput>;
}>;


export type GetStoriesForSitemapQuery = { __typename?: 'Query', stories: Array<{ __typename?: 'Story', localizations: Array<{ __typename?: 'Story', locale: Locale, slug?: string | null }> }> };

export type StoryPartsFragment = { __typename?: 'Story', id: string, title: string, slug?: string | null, teaser: string, date?: any | null, publishedAt?: any | null, storyTagEnum?: CorpStoryTagEnum | null, metaData?: { __typename?: 'MetaData', id: string, pageName: string, description?: string | null, openGraphType?: string | null, theme?: string | null, images: Array<{ __typename?: 'Asset', id: string, url: string }> } | null, image?: { __typename?: 'Asset', id: string, mimeType?: string | null, url: string } | null, pageComponents: Array<{ __typename: 'AudioComponent', id: string } | { __typename: 'Banner2', id: string } | { __typename: 'CarouselComponent', id: string } | { __typename: 'CorpBanner1', id: string } | { __typename: 'CorpCardCarousel', id: string } | { __typename: 'CorpContactCardContainer', id: string } | { __typename: 'CorpGenericAccordion', id: string } | { __typename: 'CorpGenericContainer', id: string } | { __typename: 'CorpGridColumnComponent', id: string } | { __typename?: 'GenericLine' } | { __typename: 'IntroText', id: string } | { __typename: 'LongText', id: string } | { __typename: 'QuickLink', id: string } | { __typename: 'Spacer', id: string } | { __typename: 'Tab', id: string }> };

export type GetStoryQueryVariables = Exact<{
  where?: InputMaybe<StoryWhereInput>;
  locales: Array<Locale> | Locale;
}>;


export type GetStoryQuery = { __typename?: 'Query', stories: Array<{ __typename?: 'Story', id: string, title: string, slug?: string | null, teaser: string, date?: any | null, publishedAt?: any | null, storyTagEnum?: CorpStoryTagEnum | null, metaData?: { __typename?: 'MetaData', id: string, pageName: string, description?: string | null, openGraphType?: string | null, theme?: string | null, images: Array<{ __typename?: 'Asset', id: string, url: string }> } | null, image?: { __typename?: 'Asset', id: string, mimeType?: string | null, url: string } | null, pageComponents: Array<{ __typename: 'AudioComponent', id: string } | { __typename: 'Banner2', id: string } | { __typename: 'CarouselComponent', id: string } | { __typename: 'CorpBanner1', id: string } | { __typename: 'CorpCardCarousel', id: string } | { __typename: 'CorpContactCardContainer', id: string } | { __typename: 'CorpGenericAccordion', id: string } | { __typename: 'CorpGenericContainer', id: string } | { __typename: 'CorpGridColumnComponent', id: string } | { __typename?: 'GenericLine' } | { __typename: 'IntroText', id: string } | { __typename: 'LongText', id: string } | { __typename: 'QuickLink', id: string } | { __typename: 'Spacer', id: string } | { __typename: 'Tab', id: string }> }> };

export type GetSustainabilityInfoQueryVariables = Exact<{
  where: SustainabilityInfoWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetSustainabilityInfoQuery = { __typename?: 'Query', sustainabilityInfo?: { __typename?: 'SustainabilityInfo', cmsTitle?: string | null, id: string, superHeading?: string | null, title?: string | null, ingredientsTitle?: string | null, packagingTitle?: string | null, upperLeftCorner?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', url: string, altText?: string | null }> } | null, upperRightCorner?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', url: string, altText?: string | null }> } | null, lowerLeftCorner?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', url: string, altText?: string | null }> } | null, lowerRightCorner?: { __typename?: 'AssetComponent', id: string, asset: Array<{ __typename?: 'Asset', url: string, altText?: string | null }> } | null } | null };

export type GetTabsQueryVariables = Exact<{
  where: TabWhereUniqueInput;
  locales: Array<Locale> | Locale;
}>;


export type GetTabsQuery = { __typename?: 'Query', tab?: { __typename: 'Tab', id: string, cmsTabTitle: string, anchorNav?: { __typename?: 'AnchorNavigation', id: string, navigationTitle?: string | null } | null, tabs: Array<{ __typename?: 'TabContent', id: string, tabTitle: string, components: Array<{ __typename: 'AuthorableContentCard', id: string } | { __typename: 'Banner2', id: string } | { __typename?: 'CardComponent' } | { __typename: 'CarouselComponent', id: string } | { __typename: 'CorpBanner1', id: string } | { __typename: 'CorpGenericAccordion', id: string } | { __typename: 'CorpGridColumnComponent', id: string } | { __typename: 'DynamicCardGrid', id: string } | { __typename: 'EvalancheFormComponent', id: string } | { __typename: 'Form', id: string } | { __typename?: 'GenericAccordionTopRated' } | { __typename: 'GenericCardCarouseComponent', id: string } | { __typename: 'GenericDownloadComponent', id: string } | { __typename: 'GenericFollowUs', id: string } | { __typename: 'GenericLine', id: string } | { __typename: 'HeroCarouselComponent', id: string } | { __typename: 'Iframe', id: string } | { __typename: 'ImageCopy', id: string } | { __typename: 'IntroText', id: string } | { __typename: 'Link', id: string } | { __typename: 'LongText', id: string } | { __typename: 'QuickLink', id: string } | { __typename?: 'SocialMediaListComponent' }> }> } | null };

export const LinkPartsFragmentDoc = gql`
    fragment LinkParts on Link {
  id
  __typename
  displayName
  url
  openInNewTab
  internalLink {
    ... on GenericPage {
      slug
    }
  }
}
    `;
export const CarouselComponentPartsFragmentDoc = gql`
    fragment CarouselComponentParts on CarouselComponent {
  id
  __typename
  heading
  title
  slidesToShow
  cardVariant
  carouselSlides {
    caption
    slideAsset {
      desktop: url(
        transformation: {image: {resize: {fit: max, width: 800}}, document: {output: {format: webp}}}
      )
      desktopFallback: url(
        transformation: {image: {resize: {fit: max, width: 800}}, document: {output: {format: jpg}}}
      )
      mobile: url(
        transformation: {image: {resize: {fit: max, width: 500}}, document: {output: {format: webp}}}
      )
      mobileFallback: url(
        transformation: {image: {resize: {fit: max, width: 500}}, document: {output: {format: jpg}}}
      )
    }
    videoId
    link {
      ...LinkParts
    }
  }
  topRightAsset {
    url(
      transformation: {image: {resize: {fit: max, width: 400}}, document: {output: {format: png}}}
    )
  }
  bottomLeftAsset {
    url(
      transformation: {image: {resize: {fit: max, width: 400}}, document: {output: {format: png}}}
    )
  }
  backgroundImg {
    background: url(
      transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: webp}}}
    )
    backgroundFallback: url(
      transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: jpg}}}
    )
  }
  carouselType
  anchorNav {
    id
    navigationTitle
  }
}
    ${LinkPartsFragmentDoc}`;
export const CorpCardCarouselPartsFragmentDoc = gql`
    fragment CorpCardCarouselParts on CorpCardCarousel {
  id
  __typename
  super
  title
  color
  cardVariant
  corpCarouselType
  slidesToShow
  storyItems {
    id
    title
    slug
    image {
      ... on Asset {
        id
        desktop: url(
          transformation: {image: {resize: {fit: max, width: 500}}, document: {output: {format: webp}}}
        )
        desktopFallback: url(
          transformation: {image: {resize: {fit: max, width: 500}}, document: {output: {format: jpg}}}
        )
        mobile: url(
          transformation: {image: {resize: {fit: max, width: 300}}, document: {output: {format: webp}}}
        )
        mobileFallback: url(
          transformation: {image: {resize: {fit: max, width: 300}}, document: {output: {format: jpg}}}
        )
      }
    }
    date
    publishedAt
    tag: storyTagEnum
  }
  buttonLink {
    ...LinkParts
  }
}
    ${LinkPartsFragmentDoc}`;
export const CorpGridColumnComponentPartsFragmentDoc = gql`
    fragment CorpGridColumnComponentParts on CorpGridColumnComponent {
  id
  __typename
  gridMetaball
  color
  anchorNav {
    id
    navigationTitle
  }
  cardData {
    subHeading
    title
    description
    image {
      asset {
        desktop: url(
          transformation: {image: {resize: {fit: max, width: 700}}, document: {output: {format: webp}}}
        )
        desktopFallback: url(
          transformation: {image: {resize: {fit: max, width: 700}}, document: {output: {format: png}}}
        )
        mobile: url(
          transformation: {image: {resize: {fit: max, width: 500}}, document: {output: {format: webp}}}
        )
        mobileFallback: url(
          transformation: {image: {resize: {fit: max, width: 500}}, document: {output: {format: png}}}
        )
        altText
      }
    }
    buttonLink {
      ...LinkParts
    }
    metaBall
  }
}
    ${LinkPartsFragmentDoc}`;
export const CorpHeroPartsFragmentDoc = gql`
    fragment CorpHeroParts on CorpHero {
  id
  __typename
  backgroundGradient
  title: bannerTitle
  superText
  description: bannerDescriptionText
  link {
    ...LinkParts
  }
  bannerImage {
    imageAlt: altText
    desktop: url(
      transformation: {image: {resize: {fit: max, width: 1800}}, document: {output: {format: webp}}}
    )
    desktopFallback: url(
      transformation: {image: {resize: {fit: max, width: 1800}}, document: {output: {format: jpg}}}
    )
    mobile: url(
      transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: webp}}}
    )
    mobileFallback: url(
      transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: jpg}}}
    )
  }
  mobileImage {
    mobile: url(
      transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: webp}}}
    )
    mobileFallback: url(
      transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: jpg}}}
    )
  }
}
    ${LinkPartsFragmentDoc}`;
export const CorpNavigationItemsPartFragmentDoc = gql`
    fragment CorpNavigationItemsPart on CorpNavigationItem {
  createdAt
  highlighted
  id
  markets
  excludedMarkets
  link {
    ...LinkParts
  }
  cmsTitle
}
    ${LinkPartsFragmentDoc}`;
export const CorpVideoHeroDetailsFragmentDoc = gql`
    fragment CorpVideoHeroDetails on CorpVideoHero {
  id
  __typename
  title: bannerTitle
  superTitle
  description
  videoId
  textColor
  contentAlignment
  verticalAlignment
  darkOverlay
  linkComponent {
    ...LinkParts
  }
  bannerImage {
    imageAlt: altText
    desktop: url(
      transformation: {image: {resize: {fit: max, width: 1800}}, document: {output: {format: webp}}}
    )
    desktopFallback: url(
      transformation: {image: {resize: {fit: max, width: 1800}}, document: {output: {format: jpg}}}
    )
    mobile: url(
      transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: webp}}}
    )
    mobileFallback: url(
      transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: jpg}}}
    )
  }
  mobileImage {
    mobile: url(
      transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: webp}}}
    )
    mobileFallback: url(
      transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: jpg}}}
    )
  }
}
    ${LinkPartsFragmentDoc}`;
export const GenericContainerPartsFragmentDoc = gql`
    fragment GenericContainerParts on CorpGenericContainer {
  __typename
  anchorNav {
    id
    navigationTitle
  }
  content {
    ... on ProgressBar {
      id
      __typename
    }
    ... on BigNumber {
      id
      __typename
    }
  }
  id
}
    `;
export const GenericFollowUsPartsFragmentDoc = gql`
    fragment GenericFollowUsParts on GenericFollowUs {
  id
  __typename
  super
  title
  color
  socialMedia {
    name
    url
    assetsComponents {
      id
      asset {
        id
        url
      }
    }
  }
  anchorNav {
    id
    navigationTitle
  }
}
    `;
export const ImageCopyPartsFragmentDoc = gql`
    fragment ImageCopyParts on ImageCopy {
  id
  __typename
  anchorNav {
    id
    navigationTitle
  }
  imageCopyItem {
    ... on ImageCopyItem {
      id
      title
      description {
        json
        references {
          ... on QuickLink {
            id
            __typename
            headline
            anchorNav {
              id
              navigationTitle
            }
            quickLinkItems {
              buttonHeadline
              buttonSubheadline
              id
              link {
                ...LinkParts
              }
            }
          }
        }
      }
      image {
        ... on AssetComponent {
          id
          asset {
            altText
            desktop: url(
              transformation: {image: {resize: {fit: max, width: 500}}, document: {output: {format: webp}}}
            )
            desktopFallback: url(
              transformation: {image: {resize: {fit: max, width: 500}}, document: {output: {format: jpg}}}
            )
            mobile: url(
              transformation: {image: {resize: {fit: max, width: 300}}, document: {output: {format: webp}}}
            )
            mobileFallback: url(
              transformation: {image: {resize: {fit: max, width: 300}}, document: {output: {format: jpg}}}
            )
          }
        }
      }
      columnType
      addImage
      imagePosition
      addTitle
      addVideo
      videoPosition
      addDescription
      videoId
      videoPosterImage {
        ... on AssetComponent {
          id
          asset {
            altText
            desktop: url(
              transformation: {image: {resize: {fit: max, width: 500}}, document: {output: {format: webp}}}
            )
            desktopFallback: url(
              transformation: {image: {resize: {fit: max, width: 500}}, document: {output: {format: jpg}}}
            )
            mobile: url(
              transformation: {image: {resize: {fit: max, width: 300}}, document: {output: {format: webp}}}
            )
            mobileFallback: url(
              transformation: {image: {resize: {fit: max, width: 300}}, document: {output: {format: jpg}}}
            )
          }
        }
      }
    }
  }
}
    ${LinkPartsFragmentDoc}`;
export const IntroTextPartsFragmentDoc = gql`
    fragment IntroTextParts on IntroText {
  __typename
  id
  title
  description
  anchorNav {
    id
    navigationTitle
  }
  richText {
    raw
  }
  link {
    ...LinkParts
  }
}
    ${LinkPartsFragmentDoc}`;
export const LongTextPartsFragmentDoc = gql`
    fragment LongTextParts on LongText {
  id
  __typename
  longText {
    raw
    references {
      __typename
      ... on Asset {
        id
        url
        altText
        caption
        mimeType
        desktop: url(
          transformation: {image: {resize: {fit: max, width: 1400}}, document: {output: {format: webp}}}
        )
        desktopFallback: url(
          transformation: {image: {resize: {fit: max, width: 1400}}, document: {output: {format: jpg}}}
        )
        mobile: url(
          transformation: {image: {resize: {fit: max, width: 900}}, document: {output: {format: webp}}}
        )
        mobileFallback: url(
          transformation: {image: {resize: {fit: max, width: 900}}, document: {output: {format: jpg}}}
        )
      }
      ... on Widget {
        id
        title
        url
        imageSource
        imageAlt
        type
      }
    }
  }
  anchorNav {
    id
    navigationTitle
  }
  theme
}
    `;
export const MediaLibraryItemPartsFragmentDoc = gql`
    fragment MediaLibraryItemParts on MediaLibraryItem {
  id
  title
  mediaCategory
  market
  mediaType
  assetComponent {
    id
    asset {
      id
      url
      desktop: url(
        transformation: {image: {resize: {fit: max, width: 600}}, document: {output: {format: webp}}}
      )
      desktopFallback: url(
        transformation: {image: {resize: {fit: max, width: 600}}, document: {output: {format: jpg}}}
      )
      mobile: url(
        transformation: {image: {resize: {fit: max, width: 800}}, document: {output: {format: webp}}}
      )
      mobileFallback: url(
        transformation: {image: {resize: {fit: max, width: 800}}, document: {output: {format: jpg}}}
      )
      altText
      mimeType
      fileName
      size
      height
      width
    }
  }
  posterImage {
    id
    asset {
      id
      url
      altText
      mimeType
      fileName
      size
      height
      width
      desktop: url(
        transformation: {image: {resize: {fit: max, width: 600}}, document: {output: {format: webp}}}
      )
      desktopFallback: url(
        transformation: {image: {resize: {fit: max, width: 600}}, document: {output: {format: jpg}}}
      )
      mobile: url(
        transformation: {image: {resize: {fit: max, width: 800}}, document: {output: {format: webp}}}
      )
      mobileFallback: url(
        transformation: {image: {resize: {fit: max, width: 800}}, document: {output: {format: jpg}}}
      )
    }
  }
}
    `;
export const MetadataPartsFragmentDoc = gql`
    fragment MetadataParts on MetaData {
  id
  pageName
  description
  openGraphType
  theme
  images {
    id
    url(
      transformation: {image: {resize: {width: 200, height: 200, fit: clip}}, document: {output: {format: png}}}
    )
  }
}
    `;
export const CorpContactCardContainerPartsFragmentDoc = gql`
    fragment CorpContactCardContainerParts on CorpContactCardContainer {
  __typename
  id
  corpContactCards {
    name
    description
    email
    linkedInUrl
    phone
    phoneLink
    image {
      asset {
        id
        url
        mobile: url(
          transformation: {image: {resize: {fit: max, height: 500}}, document: {output: {format: webp}}}
        )
        mobileFallback: url(
          transformation: {image: {resize: {fit: max, height: 500}}, document: {output: {format: png}}}
        )
        desktop: url(
          transformation: {image: {resize: {fit: max, height: 700}}, document: {output: {format: webp}}}
        )
        desktopFallback: url(
          transformation: {image: {resize: {fit: max, height: 700}}, document: {output: {format: png}}}
        )
      }
    }
  }
}
    `;
export const PressReleasePartsFragmentDoc = gql`
    fragment PressReleaseParts on PressRelease {
  id
  title
  slug
  teaser
  alwaysIndex
  metaData {
    ...MetadataParts
  }
  market
  topicEnum
  corpContactCardContainer {
    ...CorpContactCardContainerParts
  }
  downloadPr {
    ... on Asset {
      id
      mimeType
      url(transformation: {})
    }
  }
  downloadImage {
    ... on Asset {
      id
      mimeType
      url(transformation: {})
    }
  }
  image {
    ... on Asset {
      id
      mimeType
      url(transformation: {})
    }
  }
  date
  publishedAt
  content {
    html
    json
    references {
      ... on Asset {
        id
        mimeType
        url(transformation: {})
      }
    }
  }
}
    ${MetadataPartsFragmentDoc}
${CorpContactCardContainerPartsFragmentDoc}`;
export const SpacerPartsFragmentDoc = gql`
    fragment SpacerParts on Spacer {
  id
  __typename
  height
}
    `;
export const StoryPartsFragmentDoc = gql`
    fragment StoryParts on Story {
  id
  title
  slug
  teaser
  metaData {
    ...MetadataParts
  }
  image {
    ... on Asset {
      id
      mimeType
      url(transformation: {})
    }
  }
  date
  publishedAt
  pageComponents {
    ... on AudioComponent {
      id
      __typename
    }
    ... on LongText {
      id
      __typename
    }
    ... on Tab {
      id
      __typename
    }
    ... on CarouselComponent {
      id
      __typename
    }
    ... on Spacer {
      id
      __typename
    }
    ... on QuickLink {
      id
      __typename
    }
    ... on IntroText {
      id
      __typename
    }
    ... on CorpBanner1 {
      id
      __typename
    }
    ... on Banner2 {
      id
      __typename
    }
    ... on CorpGenericContainer {
      id
      __typename
    }
    ... on CorpContactCardContainer {
      id
      __typename
    }
    ... on CorpGridColumnComponent {
      id
      __typename
    }
    ... on CorpGenericAccordion {
      id
      __typename
    }
    ... on CorpCardCarousel {
      id
      __typename
    }
  }
  storyTagEnum
}
    ${MetadataPartsFragmentDoc}`;
export const GetAnchorNavigationListDocument = gql`
    query GetAnchorNavigationList($where: AnchorNavigationListWhereUniqueInput!) {
  anchorNavigationList(where: $where) {
    id
    anchorNavigations {
      id
      navigationTitle
    }
  }
}
    `;

/**
 * __useGetAnchorNavigationListQuery__
 *
 * To run a query within a React component, call `useGetAnchorNavigationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnchorNavigationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnchorNavigationListQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAnchorNavigationListQuery(baseOptions: Apollo.QueryHookOptions<GetAnchorNavigationListQuery, GetAnchorNavigationListQueryVariables> & ({ variables: GetAnchorNavigationListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnchorNavigationListQuery, GetAnchorNavigationListQueryVariables>(GetAnchorNavigationListDocument, options);
      }
export function useGetAnchorNavigationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnchorNavigationListQuery, GetAnchorNavigationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnchorNavigationListQuery, GetAnchorNavigationListQueryVariables>(GetAnchorNavigationListDocument, options);
        }
export function useGetAnchorNavigationListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnchorNavigationListQuery, GetAnchorNavigationListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnchorNavigationListQuery, GetAnchorNavigationListQueryVariables>(GetAnchorNavigationListDocument, options);
        }
export type GetAnchorNavigationListQueryHookResult = ReturnType<typeof useGetAnchorNavigationListQuery>;
export type GetAnchorNavigationListLazyQueryHookResult = ReturnType<typeof useGetAnchorNavigationListLazyQuery>;
export type GetAnchorNavigationListSuspenseQueryHookResult = ReturnType<typeof useGetAnchorNavigationListSuspenseQuery>;
export type GetAnchorNavigationListQueryResult = Apollo.QueryResult<GetAnchorNavigationListQuery, GetAnchorNavigationListQueryVariables>;
export const GetAnchorNavigationDocument = gql`
    query GetAnchorNavigation($where: AnchorNavigationWhereUniqueInput!) {
  anchorNavigation(where: $where) {
    id
    __typename
  }
}
    `;

/**
 * __useGetAnchorNavigationQuery__
 *
 * To run a query within a React component, call `useGetAnchorNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnchorNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnchorNavigationQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAnchorNavigationQuery(baseOptions: Apollo.QueryHookOptions<GetAnchorNavigationQuery, GetAnchorNavigationQueryVariables> & ({ variables: GetAnchorNavigationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnchorNavigationQuery, GetAnchorNavigationQueryVariables>(GetAnchorNavigationDocument, options);
      }
export function useGetAnchorNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnchorNavigationQuery, GetAnchorNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnchorNavigationQuery, GetAnchorNavigationQueryVariables>(GetAnchorNavigationDocument, options);
        }
export function useGetAnchorNavigationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnchorNavigationQuery, GetAnchorNavigationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnchorNavigationQuery, GetAnchorNavigationQueryVariables>(GetAnchorNavigationDocument, options);
        }
export type GetAnchorNavigationQueryHookResult = ReturnType<typeof useGetAnchorNavigationQuery>;
export type GetAnchorNavigationLazyQueryHookResult = ReturnType<typeof useGetAnchorNavigationLazyQuery>;
export type GetAnchorNavigationSuspenseQueryHookResult = ReturnType<typeof useGetAnchorNavigationSuspenseQuery>;
export type GetAnchorNavigationQueryResult = Apollo.QueryResult<GetAnchorNavigationQuery, GetAnchorNavigationQueryVariables>;
export const GetAudioComponentDocument = gql`
    query GetAudioComponent($where: AudioComponentWhereUniqueInput!, $locales: [Locale!]!) {
  audioComponent(where: $where, locales: $locales) {
    id
    __typename
    title
    description
    transcript
    audioFile {
      url
    }
    image {
      id
      asset {
        image: url(
          transformation: {image: {resize: {fit: max, width: 1800}}, document: {output: {format: webp}}}
        )
      }
    }
  }
}
    `;

/**
 * __useGetAudioComponentQuery__
 *
 * To run a query within a React component, call `useGetAudioComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAudioComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAudioComponentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetAudioComponentQuery(baseOptions: Apollo.QueryHookOptions<GetAudioComponentQuery, GetAudioComponentQueryVariables> & ({ variables: GetAudioComponentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAudioComponentQuery, GetAudioComponentQueryVariables>(GetAudioComponentDocument, options);
      }
export function useGetAudioComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAudioComponentQuery, GetAudioComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAudioComponentQuery, GetAudioComponentQueryVariables>(GetAudioComponentDocument, options);
        }
export function useGetAudioComponentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAudioComponentQuery, GetAudioComponentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAudioComponentQuery, GetAudioComponentQueryVariables>(GetAudioComponentDocument, options);
        }
export type GetAudioComponentQueryHookResult = ReturnType<typeof useGetAudioComponentQuery>;
export type GetAudioComponentLazyQueryHookResult = ReturnType<typeof useGetAudioComponentLazyQuery>;
export type GetAudioComponentSuspenseQueryHookResult = ReturnType<typeof useGetAudioComponentSuspenseQuery>;
export type GetAudioComponentQueryResult = Apollo.QueryResult<GetAudioComponentQuery, GetAudioComponentQueryVariables>;
export const GetAuthorableContentCardDocument = gql`
    query GetAuthorableContentCard($where: AuthorableContentCardWhereUniqueInput!, $locales: [Locale!]!) {
  authorableContentCard(where: $where, locales: $locales) {
    __typename
    id
    copy
    name
    subtitle
    videoId
    image {
      asset {
        id
        desktop: url(
          transformation: {image: {resize: {fit: max, width: 1440}}, document: {output: {format: webp}}}
        )
        desktopFallback: url(
          transformation: {image: {resize: {fit: max, width: 1440}}, document: {output: {format: jpg}}}
        )
        mobile: url(
          transformation: {image: {resize: {width: 320, height: 500, fit: crop}}, document: {output: {format: png}}}
        )
        hero: url(
          transformation: {image: {resize: {width: 1900, height: 500, fit: crop}}, document: {output: {format: png}}}
        )
        tablet: url(
          transformation: {image: {resize: {width: 1024, height: 500, fit: crop}}, document: {output: {format: png}}}
        )
      }
    }
    link {
      ...LinkParts
    }
    anchorNav {
      id
      navigationTitle
    }
  }
}
    ${LinkPartsFragmentDoc}`;

/**
 * __useGetAuthorableContentCardQuery__
 *
 * To run a query within a React component, call `useGetAuthorableContentCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthorableContentCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthorableContentCardQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetAuthorableContentCardQuery(baseOptions: Apollo.QueryHookOptions<GetAuthorableContentCardQuery, GetAuthorableContentCardQueryVariables> & ({ variables: GetAuthorableContentCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAuthorableContentCardQuery, GetAuthorableContentCardQueryVariables>(GetAuthorableContentCardDocument, options);
      }
export function useGetAuthorableContentCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAuthorableContentCardQuery, GetAuthorableContentCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAuthorableContentCardQuery, GetAuthorableContentCardQueryVariables>(GetAuthorableContentCardDocument, options);
        }
export function useGetAuthorableContentCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAuthorableContentCardQuery, GetAuthorableContentCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAuthorableContentCardQuery, GetAuthorableContentCardQueryVariables>(GetAuthorableContentCardDocument, options);
        }
export type GetAuthorableContentCardQueryHookResult = ReturnType<typeof useGetAuthorableContentCardQuery>;
export type GetAuthorableContentCardLazyQueryHookResult = ReturnType<typeof useGetAuthorableContentCardLazyQuery>;
export type GetAuthorableContentCardSuspenseQueryHookResult = ReturnType<typeof useGetAuthorableContentCardSuspenseQuery>;
export type GetAuthorableContentCardQueryResult = Apollo.QueryResult<GetAuthorableContentCardQuery, GetAuthorableContentCardQueryVariables>;
export const GetCorpBanner1Document = gql`
    query GetCorpBanner1($where: CorpBanner1WhereUniqueInput!, $locales: [Locale!]!) {
  corpBanner1(where: $where, locales: $locales) {
    id
    __typename
    superText
    title
    description
    color
    link {
      ...LinkParts
    }
    anchorNav {
      id
      navigationTitle
    }
  }
}
    ${LinkPartsFragmentDoc}`;

/**
 * __useGetCorpBanner1Query__
 *
 * To run a query within a React component, call `useGetCorpBanner1Query` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpBanner1Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpBanner1Query({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCorpBanner1Query(baseOptions: Apollo.QueryHookOptions<GetCorpBanner1Query, GetCorpBanner1QueryVariables> & ({ variables: GetCorpBanner1QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpBanner1Query, GetCorpBanner1QueryVariables>(GetCorpBanner1Document, options);
      }
export function useGetCorpBanner1LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpBanner1Query, GetCorpBanner1QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpBanner1Query, GetCorpBanner1QueryVariables>(GetCorpBanner1Document, options);
        }
export function useGetCorpBanner1SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpBanner1Query, GetCorpBanner1QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpBanner1Query, GetCorpBanner1QueryVariables>(GetCorpBanner1Document, options);
        }
export type GetCorpBanner1QueryHookResult = ReturnType<typeof useGetCorpBanner1Query>;
export type GetCorpBanner1LazyQueryHookResult = ReturnType<typeof useGetCorpBanner1LazyQuery>;
export type GetCorpBanner1SuspenseQueryHookResult = ReturnType<typeof useGetCorpBanner1SuspenseQuery>;
export type GetCorpBanner1QueryResult = Apollo.QueryResult<GetCorpBanner1Query, GetCorpBanner1QueryVariables>;
export const GetBanner2Document = gql`
    query GetBanner2($where: Banner2WhereUniqueInput!, $locales: [Locale!]!) {
  banner2(where: $where, locales: $locales) {
    id
    __typename
    title
    superText
    description
    backgroundAsset {
      id
      asset {
        background: url(
          transformation: {image: {resize: {fit: max, width: 1800}}, document: {output: {format: webp}}}
        )
        backgroundFallback: url(
          transformation: {image: {resize: {fit: max, width: 1800}}, document: {output: {format: jpg}}}
        )
      }
    }
    mobileBackgroundAsset {
      id
      asset {
        background: url(
          transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: webp}}}
        )
        backgroundFallback: url(
          transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: jpg}}}
        )
      }
    }
    fullBleed
    imageAlignment
    link {
      ...LinkParts
    }
    anchorNav {
      id
      navigationTitle
    }
  }
}
    ${LinkPartsFragmentDoc}`;

/**
 * __useGetBanner2Query__
 *
 * To run a query within a React component, call `useGetBanner2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetBanner2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBanner2Query({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetBanner2Query(baseOptions: Apollo.QueryHookOptions<GetBanner2Query, GetBanner2QueryVariables> & ({ variables: GetBanner2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBanner2Query, GetBanner2QueryVariables>(GetBanner2Document, options);
      }
export function useGetBanner2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBanner2Query, GetBanner2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBanner2Query, GetBanner2QueryVariables>(GetBanner2Document, options);
        }
export function useGetBanner2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBanner2Query, GetBanner2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBanner2Query, GetBanner2QueryVariables>(GetBanner2Document, options);
        }
export type GetBanner2QueryHookResult = ReturnType<typeof useGetBanner2Query>;
export type GetBanner2LazyQueryHookResult = ReturnType<typeof useGetBanner2LazyQuery>;
export type GetBanner2SuspenseQueryHookResult = ReturnType<typeof useGetBanner2SuspenseQuery>;
export type GetBanner2QueryResult = Apollo.QueryResult<GetBanner2Query, GetBanner2QueryVariables>;
export const GetBigNumberDocument = gql`
    query GetBigNumber($where: BigNumberWhereUniqueInput!, $locales: [Locale!]!) {
  bigNumber(where: $where, locales: $locales) {
    bigNumberItems {
      bigNumber
      bottomText
    }
  }
}
    `;

/**
 * __useGetBigNumberQuery__
 *
 * To run a query within a React component, call `useGetBigNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBigNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBigNumberQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetBigNumberQuery(baseOptions: Apollo.QueryHookOptions<GetBigNumberQuery, GetBigNumberQueryVariables> & ({ variables: GetBigNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBigNumberQuery, GetBigNumberQueryVariables>(GetBigNumberDocument, options);
      }
export function useGetBigNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBigNumberQuery, GetBigNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBigNumberQuery, GetBigNumberQueryVariables>(GetBigNumberDocument, options);
        }
export function useGetBigNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBigNumberQuery, GetBigNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBigNumberQuery, GetBigNumberQueryVariables>(GetBigNumberDocument, options);
        }
export type GetBigNumberQueryHookResult = ReturnType<typeof useGetBigNumberQuery>;
export type GetBigNumberLazyQueryHookResult = ReturnType<typeof useGetBigNumberLazyQuery>;
export type GetBigNumberSuspenseQueryHookResult = ReturnType<typeof useGetBigNumberSuspenseQuery>;
export type GetBigNumberQueryResult = Apollo.QueryResult<GetBigNumberQuery, GetBigNumberQueryVariables>;
export const GetCarouselComponentDocument = gql`
    query GetCarouselComponent($where: CarouselComponentWhereUniqueInput!, $locales: [Locale!]!) {
  carouselComponent(where: $where, locales: $locales) {
    ...CarouselComponentParts
  }
}
    ${CarouselComponentPartsFragmentDoc}`;

/**
 * __useGetCarouselComponentQuery__
 *
 * To run a query within a React component, call `useGetCarouselComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarouselComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarouselComponentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCarouselComponentQuery(baseOptions: Apollo.QueryHookOptions<GetCarouselComponentQuery, GetCarouselComponentQueryVariables> & ({ variables: GetCarouselComponentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCarouselComponentQuery, GetCarouselComponentQueryVariables>(GetCarouselComponentDocument, options);
      }
export function useGetCarouselComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarouselComponentQuery, GetCarouselComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCarouselComponentQuery, GetCarouselComponentQueryVariables>(GetCarouselComponentDocument, options);
        }
export function useGetCarouselComponentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCarouselComponentQuery, GetCarouselComponentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCarouselComponentQuery, GetCarouselComponentQueryVariables>(GetCarouselComponentDocument, options);
        }
export type GetCarouselComponentQueryHookResult = ReturnType<typeof useGetCarouselComponentQuery>;
export type GetCarouselComponentLazyQueryHookResult = ReturnType<typeof useGetCarouselComponentLazyQuery>;
export type GetCarouselComponentSuspenseQueryHookResult = ReturnType<typeof useGetCarouselComponentSuspenseQuery>;
export type GetCarouselComponentQueryResult = Apollo.QueryResult<GetCarouselComponentQuery, GetCarouselComponentQueryVariables>;
export const GetCorpCalendarEventComponentDocument = gql`
    query GetCorpCalendarEventComponent($where: CorpCalendarEventWhereUniqueInput!, $locales: [Locale!]!) {
  corpCalendarEvent(where: $where, locales: $locales) {
    id
    __typename
    title
    eventDescription
    eventLocation
    startDate
    endDate
    richText {
      raw
      references {
        ... on LongText {
          id
          __typename
          LongText_cmsTitle: cmsTitle
        }
      }
    }
  }
}
    `;

/**
 * __useGetCorpCalendarEventComponentQuery__
 *
 * To run a query within a React component, call `useGetCorpCalendarEventComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpCalendarEventComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpCalendarEventComponentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCorpCalendarEventComponentQuery(baseOptions: Apollo.QueryHookOptions<GetCorpCalendarEventComponentQuery, GetCorpCalendarEventComponentQueryVariables> & ({ variables: GetCorpCalendarEventComponentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpCalendarEventComponentQuery, GetCorpCalendarEventComponentQueryVariables>(GetCorpCalendarEventComponentDocument, options);
      }
export function useGetCorpCalendarEventComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpCalendarEventComponentQuery, GetCorpCalendarEventComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpCalendarEventComponentQuery, GetCorpCalendarEventComponentQueryVariables>(GetCorpCalendarEventComponentDocument, options);
        }
export function useGetCorpCalendarEventComponentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpCalendarEventComponentQuery, GetCorpCalendarEventComponentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpCalendarEventComponentQuery, GetCorpCalendarEventComponentQueryVariables>(GetCorpCalendarEventComponentDocument, options);
        }
export type GetCorpCalendarEventComponentQueryHookResult = ReturnType<typeof useGetCorpCalendarEventComponentQuery>;
export type GetCorpCalendarEventComponentLazyQueryHookResult = ReturnType<typeof useGetCorpCalendarEventComponentLazyQuery>;
export type GetCorpCalendarEventComponentSuspenseQueryHookResult = ReturnType<typeof useGetCorpCalendarEventComponentSuspenseQuery>;
export type GetCorpCalendarEventComponentQueryResult = Apollo.QueryResult<GetCorpCalendarEventComponentQuery, GetCorpCalendarEventComponentQueryVariables>;
export const GetCorpCardCarouselDocument = gql`
    query GetCorpCardCarousel($where: CorpCardCarouselWhereUniqueInput!, $locales: [Locale!]!) {
  corpCardCarousel(where: $where, locales: $locales) {
    ...CorpCardCarouselParts
  }
}
    ${CorpCardCarouselPartsFragmentDoc}`;

/**
 * __useGetCorpCardCarouselQuery__
 *
 * To run a query within a React component, call `useGetCorpCardCarouselQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpCardCarouselQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpCardCarouselQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCorpCardCarouselQuery(baseOptions: Apollo.QueryHookOptions<GetCorpCardCarouselQuery, GetCorpCardCarouselQueryVariables> & ({ variables: GetCorpCardCarouselQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpCardCarouselQuery, GetCorpCardCarouselQueryVariables>(GetCorpCardCarouselDocument, options);
      }
export function useGetCorpCardCarouselLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpCardCarouselQuery, GetCorpCardCarouselQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpCardCarouselQuery, GetCorpCardCarouselQueryVariables>(GetCorpCardCarouselDocument, options);
        }
export function useGetCorpCardCarouselSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpCardCarouselQuery, GetCorpCardCarouselQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpCardCarouselQuery, GetCorpCardCarouselQueryVariables>(GetCorpCardCarouselDocument, options);
        }
export type GetCorpCardCarouselQueryHookResult = ReturnType<typeof useGetCorpCardCarouselQuery>;
export type GetCorpCardCarouselLazyQueryHookResult = ReturnType<typeof useGetCorpCardCarouselLazyQuery>;
export type GetCorpCardCarouselSuspenseQueryHookResult = ReturnType<typeof useGetCorpCardCarouselSuspenseQuery>;
export type GetCorpCardCarouselQueryResult = Apollo.QueryResult<GetCorpCardCarouselQuery, GetCorpCardCarouselQueryVariables>;
export const GetCorpContactCardContainerDocument = gql`
    query GetCorpContactCardContainer($where: CorpContactCardContainerWhereUniqueInput!, $locales: [Locale!]!) {
  corpContactCardContainer(where: $where, locales: $locales) {
    ...CorpContactCardContainerParts
  }
}
    ${CorpContactCardContainerPartsFragmentDoc}`;

/**
 * __useGetCorpContactCardContainerQuery__
 *
 * To run a query within a React component, call `useGetCorpContactCardContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpContactCardContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpContactCardContainerQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCorpContactCardContainerQuery(baseOptions: Apollo.QueryHookOptions<GetCorpContactCardContainerQuery, GetCorpContactCardContainerQueryVariables> & ({ variables: GetCorpContactCardContainerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpContactCardContainerQuery, GetCorpContactCardContainerQueryVariables>(GetCorpContactCardContainerDocument, options);
      }
export function useGetCorpContactCardContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpContactCardContainerQuery, GetCorpContactCardContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpContactCardContainerQuery, GetCorpContactCardContainerQueryVariables>(GetCorpContactCardContainerDocument, options);
        }
export function useGetCorpContactCardContainerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpContactCardContainerQuery, GetCorpContactCardContainerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpContactCardContainerQuery, GetCorpContactCardContainerQueryVariables>(GetCorpContactCardContainerDocument, options);
        }
export type GetCorpContactCardContainerQueryHookResult = ReturnType<typeof useGetCorpContactCardContainerQuery>;
export type GetCorpContactCardContainerLazyQueryHookResult = ReturnType<typeof useGetCorpContactCardContainerLazyQuery>;
export type GetCorpContactCardContainerSuspenseQueryHookResult = ReturnType<typeof useGetCorpContactCardContainerSuspenseQuery>;
export type GetCorpContactCardContainerQueryResult = Apollo.QueryResult<GetCorpContactCardContainerQuery, GetCorpContactCardContainerQueryVariables>;
export const GetCorpFormDocument = gql`
    query GetCorpForm($where: CorpFormWhereUniqueInput!, $locales: [Locale!]!) {
  corpForm(where: $where, locales: $locales) {
    __typename
    id
    formType
    title
    subtitle
    checkboxText {
      ...LongTextParts
    }
  }
}
    ${LongTextPartsFragmentDoc}`;

/**
 * __useGetCorpFormQuery__
 *
 * To run a query within a React component, call `useGetCorpFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpFormQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCorpFormQuery(baseOptions: Apollo.QueryHookOptions<GetCorpFormQuery, GetCorpFormQueryVariables> & ({ variables: GetCorpFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpFormQuery, GetCorpFormQueryVariables>(GetCorpFormDocument, options);
      }
export function useGetCorpFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpFormQuery, GetCorpFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpFormQuery, GetCorpFormQueryVariables>(GetCorpFormDocument, options);
        }
export function useGetCorpFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpFormQuery, GetCorpFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpFormQuery, GetCorpFormQueryVariables>(GetCorpFormDocument, options);
        }
export type GetCorpFormQueryHookResult = ReturnType<typeof useGetCorpFormQuery>;
export type GetCorpFormLazyQueryHookResult = ReturnType<typeof useGetCorpFormLazyQuery>;
export type GetCorpFormSuspenseQueryHookResult = ReturnType<typeof useGetCorpFormSuspenseQuery>;
export type GetCorpFormQueryResult = Apollo.QueryResult<GetCorpFormQuery, GetCorpFormQueryVariables>;
export const GetCorpGenericAccordionDocument = gql`
    query GetCorpGenericAccordion($where: CorpGenericAccordionWhereUniqueInput!, $locales: [Locale!]!) {
  corpGenericAccordion(where: $where, locales: $locales) {
    id
    __typename
    numbered
    corpGenericAccordionItems {
      id
      title
      genericAccordionItemBodyComponents {
        ... on LongText {
          __typename
          id
        }
        ... on Spacer {
          __typename
          id
        }
        ... on IntroText {
          __typename
          id
        }
        ... on CorpBanner1 {
          __typename
          id
        }
        ... on ImageCopy {
          __typename
          id
        }
        ... on CorpGridColumnComponent {
          __typename
          id
        }
        ... on CorpGenericContainer {
          __typename
          id
        }
        ... on CorpContactCardContainer {
          __typename
          id
        }
        ... on GenericDownloadComponent {
          id
          __typename
        }
        ... on QuickLink {
          id
          __typename
        }
        ... on CorpCalendarEvent {
          id
          __typename
        }
      }
    }
  }
}
    `;

/**
 * __useGetCorpGenericAccordionQuery__
 *
 * To run a query within a React component, call `useGetCorpGenericAccordionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpGenericAccordionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpGenericAccordionQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCorpGenericAccordionQuery(baseOptions: Apollo.QueryHookOptions<GetCorpGenericAccordionQuery, GetCorpGenericAccordionQueryVariables> & ({ variables: GetCorpGenericAccordionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpGenericAccordionQuery, GetCorpGenericAccordionQueryVariables>(GetCorpGenericAccordionDocument, options);
      }
export function useGetCorpGenericAccordionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpGenericAccordionQuery, GetCorpGenericAccordionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpGenericAccordionQuery, GetCorpGenericAccordionQueryVariables>(GetCorpGenericAccordionDocument, options);
        }
export function useGetCorpGenericAccordionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpGenericAccordionQuery, GetCorpGenericAccordionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpGenericAccordionQuery, GetCorpGenericAccordionQueryVariables>(GetCorpGenericAccordionDocument, options);
        }
export type GetCorpGenericAccordionQueryHookResult = ReturnType<typeof useGetCorpGenericAccordionQuery>;
export type GetCorpGenericAccordionLazyQueryHookResult = ReturnType<typeof useGetCorpGenericAccordionLazyQuery>;
export type GetCorpGenericAccordionSuspenseQueryHookResult = ReturnType<typeof useGetCorpGenericAccordionSuspenseQuery>;
export type GetCorpGenericAccordionQueryResult = Apollo.QueryResult<GetCorpGenericAccordionQuery, GetCorpGenericAccordionQueryVariables>;
export const GetCorpGridColumnComponentDocument = gql`
    query GetCorpGridColumnComponent($where: CorpGridColumnComponentWhereUniqueInput!, $locales: [Locale!]!) {
  corpGridColumnComponent(where: $where, locales: $locales) {
    ...CorpGridColumnComponentParts
  }
}
    ${CorpGridColumnComponentPartsFragmentDoc}`;

/**
 * __useGetCorpGridColumnComponentQuery__
 *
 * To run a query within a React component, call `useGetCorpGridColumnComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpGridColumnComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpGridColumnComponentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCorpGridColumnComponentQuery(baseOptions: Apollo.QueryHookOptions<GetCorpGridColumnComponentQuery, GetCorpGridColumnComponentQueryVariables> & ({ variables: GetCorpGridColumnComponentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpGridColumnComponentQuery, GetCorpGridColumnComponentQueryVariables>(GetCorpGridColumnComponentDocument, options);
      }
export function useGetCorpGridColumnComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpGridColumnComponentQuery, GetCorpGridColumnComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpGridColumnComponentQuery, GetCorpGridColumnComponentQueryVariables>(GetCorpGridColumnComponentDocument, options);
        }
export function useGetCorpGridColumnComponentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpGridColumnComponentQuery, GetCorpGridColumnComponentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpGridColumnComponentQuery, GetCorpGridColumnComponentQueryVariables>(GetCorpGridColumnComponentDocument, options);
        }
export type GetCorpGridColumnComponentQueryHookResult = ReturnType<typeof useGetCorpGridColumnComponentQuery>;
export type GetCorpGridColumnComponentLazyQueryHookResult = ReturnType<typeof useGetCorpGridColumnComponentLazyQuery>;
export type GetCorpGridColumnComponentSuspenseQueryHookResult = ReturnType<typeof useGetCorpGridColumnComponentSuspenseQuery>;
export type GetCorpGridColumnComponentQueryResult = Apollo.QueryResult<GetCorpGridColumnComponentQuery, GetCorpGridColumnComponentQueryVariables>;
export const GetCorpHeroComponentDocument = gql`
    query GetCorpHeroComponent($where: CorpHeroWhereUniqueInput!, $locales: [Locale!]!) {
  corpHero(where: $where, locales: $locales) {
    ...CorpHeroParts
  }
}
    ${CorpHeroPartsFragmentDoc}`;

/**
 * __useGetCorpHeroComponentQuery__
 *
 * To run a query within a React component, call `useGetCorpHeroComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpHeroComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpHeroComponentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCorpHeroComponentQuery(baseOptions: Apollo.QueryHookOptions<GetCorpHeroComponentQuery, GetCorpHeroComponentQueryVariables> & ({ variables: GetCorpHeroComponentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpHeroComponentQuery, GetCorpHeroComponentQueryVariables>(GetCorpHeroComponentDocument, options);
      }
export function useGetCorpHeroComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpHeroComponentQuery, GetCorpHeroComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpHeroComponentQuery, GetCorpHeroComponentQueryVariables>(GetCorpHeroComponentDocument, options);
        }
export function useGetCorpHeroComponentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpHeroComponentQuery, GetCorpHeroComponentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpHeroComponentQuery, GetCorpHeroComponentQueryVariables>(GetCorpHeroComponentDocument, options);
        }
export type GetCorpHeroComponentQueryHookResult = ReturnType<typeof useGetCorpHeroComponentQuery>;
export type GetCorpHeroComponentLazyQueryHookResult = ReturnType<typeof useGetCorpHeroComponentLazyQuery>;
export type GetCorpHeroComponentSuspenseQueryHookResult = ReturnType<typeof useGetCorpHeroComponentSuspenseQuery>;
export type GetCorpHeroComponentQueryResult = Apollo.QueryResult<GetCorpHeroComponentQuery, GetCorpHeroComponentQueryVariables>;
export const GetCorpMediaDownloadPreviewDocument = gql`
    query GetCorpMediaDownloadPreview($where: CorpMediaDownloadPreviewWhereUniqueInput!, $locales: [Locale!]!, $itemsLocale: Locale!) {
  corpMediaDownloadPreview(where: $where, locales: $locales) {
    __typename
    id
    super
    title
    link {
      ...LinkParts
    }
  }
  downloads: mediaLibraryItems(
    first: 4
    locales: [$itemsLocale]
    orderBy: createdAt_DESC
  ) {
    ...MediaLibraryItemParts
  }
}
    ${LinkPartsFragmentDoc}
${MediaLibraryItemPartsFragmentDoc}`;

/**
 * __useGetCorpMediaDownloadPreviewQuery__
 *
 * To run a query within a React component, call `useGetCorpMediaDownloadPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpMediaDownloadPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpMediaDownloadPreviewQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *      itemsLocale: // value for 'itemsLocale'
 *   },
 * });
 */
export function useGetCorpMediaDownloadPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetCorpMediaDownloadPreviewQuery, GetCorpMediaDownloadPreviewQueryVariables> & ({ variables: GetCorpMediaDownloadPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpMediaDownloadPreviewQuery, GetCorpMediaDownloadPreviewQueryVariables>(GetCorpMediaDownloadPreviewDocument, options);
      }
export function useGetCorpMediaDownloadPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpMediaDownloadPreviewQuery, GetCorpMediaDownloadPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpMediaDownloadPreviewQuery, GetCorpMediaDownloadPreviewQueryVariables>(GetCorpMediaDownloadPreviewDocument, options);
        }
export function useGetCorpMediaDownloadPreviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpMediaDownloadPreviewQuery, GetCorpMediaDownloadPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpMediaDownloadPreviewQuery, GetCorpMediaDownloadPreviewQueryVariables>(GetCorpMediaDownloadPreviewDocument, options);
        }
export type GetCorpMediaDownloadPreviewQueryHookResult = ReturnType<typeof useGetCorpMediaDownloadPreviewQuery>;
export type GetCorpMediaDownloadPreviewLazyQueryHookResult = ReturnType<typeof useGetCorpMediaDownloadPreviewLazyQuery>;
export type GetCorpMediaDownloadPreviewSuspenseQueryHookResult = ReturnType<typeof useGetCorpMediaDownloadPreviewSuspenseQuery>;
export type GetCorpMediaDownloadPreviewQueryResult = Apollo.QueryResult<GetCorpMediaDownloadPreviewQuery, GetCorpMediaDownloadPreviewQueryVariables>;
export const GetCorpNavigationDocument = gql`
    query GetCorpNavigation($locales: [Locale!]!) {
  corpNavigations(locales: $locales) {
    id
    linkText
    navigationItems {
      ...CorpNavigationItemsPart
    }
  }
}
    ${CorpNavigationItemsPartFragmentDoc}`;

/**
 * __useGetCorpNavigationQuery__
 *
 * To run a query within a React component, call `useGetCorpNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpNavigationQuery({
 *   variables: {
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCorpNavigationQuery(baseOptions: Apollo.QueryHookOptions<GetCorpNavigationQuery, GetCorpNavigationQueryVariables> & ({ variables: GetCorpNavigationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpNavigationQuery, GetCorpNavigationQueryVariables>(GetCorpNavigationDocument, options);
      }
export function useGetCorpNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpNavigationQuery, GetCorpNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpNavigationQuery, GetCorpNavigationQueryVariables>(GetCorpNavigationDocument, options);
        }
export function useGetCorpNavigationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpNavigationQuery, GetCorpNavigationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpNavigationQuery, GetCorpNavigationQueryVariables>(GetCorpNavigationDocument, options);
        }
export type GetCorpNavigationQueryHookResult = ReturnType<typeof useGetCorpNavigationQuery>;
export type GetCorpNavigationLazyQueryHookResult = ReturnType<typeof useGetCorpNavigationLazyQuery>;
export type GetCorpNavigationSuspenseQueryHookResult = ReturnType<typeof useGetCorpNavigationSuspenseQuery>;
export type GetCorpNavigationQueryResult = Apollo.QueryResult<GetCorpNavigationQuery, GetCorpNavigationQueryVariables>;
export const GetCorpNotificationBannerDocument = gql`
    query GetCorpNotificationBanner($where: CorpNotificationBannerWhereInput!, $locales: [Locale!]!) {
  corpNotificationBanners(where: $where, locales: $locales) {
    id
    __typename
    title
    description
    market
    link {
      ...LinkParts
    }
    active
    bannerType
  }
}
    ${LinkPartsFragmentDoc}`;

/**
 * __useGetCorpNotificationBannerQuery__
 *
 * To run a query within a React component, call `useGetCorpNotificationBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpNotificationBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpNotificationBannerQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCorpNotificationBannerQuery(baseOptions: Apollo.QueryHookOptions<GetCorpNotificationBannerQuery, GetCorpNotificationBannerQueryVariables> & ({ variables: GetCorpNotificationBannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpNotificationBannerQuery, GetCorpNotificationBannerQueryVariables>(GetCorpNotificationBannerDocument, options);
      }
export function useGetCorpNotificationBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpNotificationBannerQuery, GetCorpNotificationBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpNotificationBannerQuery, GetCorpNotificationBannerQueryVariables>(GetCorpNotificationBannerDocument, options);
        }
export function useGetCorpNotificationBannerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpNotificationBannerQuery, GetCorpNotificationBannerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpNotificationBannerQuery, GetCorpNotificationBannerQueryVariables>(GetCorpNotificationBannerDocument, options);
        }
export type GetCorpNotificationBannerQueryHookResult = ReturnType<typeof useGetCorpNotificationBannerQuery>;
export type GetCorpNotificationBannerLazyQueryHookResult = ReturnType<typeof useGetCorpNotificationBannerLazyQuery>;
export type GetCorpNotificationBannerSuspenseQueryHookResult = ReturnType<typeof useGetCorpNotificationBannerSuspenseQuery>;
export type GetCorpNotificationBannerQueryResult = Apollo.QueryResult<GetCorpNotificationBannerQuery, GetCorpNotificationBannerQueryVariables>;
export const GetCorpOurPeopleDocument = gql`
    query GetCorpOurPeople($where: CorpOurPeopleWhereUniqueInput!, $locales: [Locale!]!) {
  corpOurPeople(where: $where, locales: $locales) {
    id
    __typename
    anchorNav {
      id
      navigationTitle
    }
    corpOurPeopleItems {
      id
      name
      description
      favoriteProduct
      text
      image {
        ... on AssetComponent {
          id
          asset {
            altText
            desktop: url(
              transformation: {image: {resize: {fit: max, width: 1600}}, document: {output: {format: webp}}}
            )
            desktopFallback: url(
              transformation: {image: {resize: {fit: max, width: 1600}}, document: {output: {format: jpg}}}
            )
            mobile: url(
              transformation: {image: {resize: {fit: max, width: 600}}, document: {output: {format: webp}}}
            )
            mobileFallback: url(
              transformation: {image: {resize: {fit: max, width: 600}}, document: {output: {format: jpg}}}
            )
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCorpOurPeopleQuery__
 *
 * To run a query within a React component, call `useGetCorpOurPeopleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpOurPeopleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpOurPeopleQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCorpOurPeopleQuery(baseOptions: Apollo.QueryHookOptions<GetCorpOurPeopleQuery, GetCorpOurPeopleQueryVariables> & ({ variables: GetCorpOurPeopleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpOurPeopleQuery, GetCorpOurPeopleQueryVariables>(GetCorpOurPeopleDocument, options);
      }
export function useGetCorpOurPeopleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpOurPeopleQuery, GetCorpOurPeopleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpOurPeopleQuery, GetCorpOurPeopleQueryVariables>(GetCorpOurPeopleDocument, options);
        }
export function useGetCorpOurPeopleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpOurPeopleQuery, GetCorpOurPeopleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpOurPeopleQuery, GetCorpOurPeopleQueryVariables>(GetCorpOurPeopleDocument, options);
        }
export type GetCorpOurPeopleQueryHookResult = ReturnType<typeof useGetCorpOurPeopleQuery>;
export type GetCorpOurPeopleLazyQueryHookResult = ReturnType<typeof useGetCorpOurPeopleLazyQuery>;
export type GetCorpOurPeopleSuspenseQueryHookResult = ReturnType<typeof useGetCorpOurPeopleSuspenseQuery>;
export type GetCorpOurPeopleQueryResult = Apollo.QueryResult<GetCorpOurPeopleQuery, GetCorpOurPeopleQueryVariables>;
export const GetCorpSocialMediaFooterDocument = gql`
    query GetCorpSocialMediaFooter($locales: [Locale!]!) {
  corpSocialMediaFooters(locales: $locales) {
    id
    __typename
    twitterLink
    youtubeLink
    instagramLink
    facebookLink
    linkedinLink
    xingLink
  }
}
    `;

/**
 * __useGetCorpSocialMediaFooterQuery__
 *
 * To run a query within a React component, call `useGetCorpSocialMediaFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpSocialMediaFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpSocialMediaFooterQuery({
 *   variables: {
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCorpSocialMediaFooterQuery(baseOptions: Apollo.QueryHookOptions<GetCorpSocialMediaFooterQuery, GetCorpSocialMediaFooterQueryVariables> & ({ variables: GetCorpSocialMediaFooterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpSocialMediaFooterQuery, GetCorpSocialMediaFooterQueryVariables>(GetCorpSocialMediaFooterDocument, options);
      }
export function useGetCorpSocialMediaFooterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpSocialMediaFooterQuery, GetCorpSocialMediaFooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpSocialMediaFooterQuery, GetCorpSocialMediaFooterQueryVariables>(GetCorpSocialMediaFooterDocument, options);
        }
export function useGetCorpSocialMediaFooterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpSocialMediaFooterQuery, GetCorpSocialMediaFooterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpSocialMediaFooterQuery, GetCorpSocialMediaFooterQueryVariables>(GetCorpSocialMediaFooterDocument, options);
        }
export type GetCorpSocialMediaFooterQueryHookResult = ReturnType<typeof useGetCorpSocialMediaFooterQuery>;
export type GetCorpSocialMediaFooterLazyQueryHookResult = ReturnType<typeof useGetCorpSocialMediaFooterLazyQuery>;
export type GetCorpSocialMediaFooterSuspenseQueryHookResult = ReturnType<typeof useGetCorpSocialMediaFooterSuspenseQuery>;
export type GetCorpSocialMediaFooterQueryResult = Apollo.QueryResult<GetCorpSocialMediaFooterQuery, GetCorpSocialMediaFooterQueryVariables>;
export const GetCorpTimelineAccordionWrapperDocument = gql`
    query GetCorpTimelineAccordionWrapper($where: CorpTimelineAccordionWrapperWhereUniqueInput!, $locales: [Locale!]!) {
  corpTimelineAccordionWrapper(where: $where, locales: $locales) {
    id
    __typename
    anchorNav {
      id
      navigationTitle
    }
    corpTimelineAccordions {
      id
      __typename
      title
      daterange
      corpTimelineAccordionItems {
        id
        __typename
        title
        date
        image {
          asset {
            id
            desktop: url(
              transformation: {image: {resize: {fit: max, width: 700}}, document: {output: {format: webp}}}
            )
            desktopFallback: url(
              transformation: {image: {resize: {fit: max, width: 700}}, document: {output: {format: png}}}
            )
            mobile: url(
              transformation: {image: {resize: {fit: max, width: 500}}, document: {output: {format: webp}}}
            )
            mobileFallback: url(
              transformation: {image: {resize: {fit: max, width: 500}}, document: {output: {format: png}}}
            )
          }
        }
        text {
          html
        }
      }
    }
  }
}
    `;

/**
 * __useGetCorpTimelineAccordionWrapperQuery__
 *
 * To run a query within a React component, call `useGetCorpTimelineAccordionWrapperQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpTimelineAccordionWrapperQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpTimelineAccordionWrapperQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCorpTimelineAccordionWrapperQuery(baseOptions: Apollo.QueryHookOptions<GetCorpTimelineAccordionWrapperQuery, GetCorpTimelineAccordionWrapperQueryVariables> & ({ variables: GetCorpTimelineAccordionWrapperQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpTimelineAccordionWrapperQuery, GetCorpTimelineAccordionWrapperQueryVariables>(GetCorpTimelineAccordionWrapperDocument, options);
      }
export function useGetCorpTimelineAccordionWrapperLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpTimelineAccordionWrapperQuery, GetCorpTimelineAccordionWrapperQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpTimelineAccordionWrapperQuery, GetCorpTimelineAccordionWrapperQueryVariables>(GetCorpTimelineAccordionWrapperDocument, options);
        }
export function useGetCorpTimelineAccordionWrapperSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpTimelineAccordionWrapperQuery, GetCorpTimelineAccordionWrapperQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpTimelineAccordionWrapperQuery, GetCorpTimelineAccordionWrapperQueryVariables>(GetCorpTimelineAccordionWrapperDocument, options);
        }
export type GetCorpTimelineAccordionWrapperQueryHookResult = ReturnType<typeof useGetCorpTimelineAccordionWrapperQuery>;
export type GetCorpTimelineAccordionWrapperLazyQueryHookResult = ReturnType<typeof useGetCorpTimelineAccordionWrapperLazyQuery>;
export type GetCorpTimelineAccordionWrapperSuspenseQueryHookResult = ReturnType<typeof useGetCorpTimelineAccordionWrapperSuspenseQuery>;
export type GetCorpTimelineAccordionWrapperQueryResult = Apollo.QueryResult<GetCorpTimelineAccordionWrapperQuery, GetCorpTimelineAccordionWrapperQueryVariables>;
export const GetCorpVideoHeroCarouselComponentDocument = gql`
    query GetCorpVideoHeroCarouselComponent($where: CorpVideoHeroCarouselWhereUniqueInput!, $locales: [Locale!]!) {
  corpVideoHeroCarousel(where: $where, locales: $locales) {
    id
    __typename
    corpVideoHero {
      ...CorpVideoHeroDetails
    }
    bannerSize
    autoPlay
  }
}
    ${CorpVideoHeroDetailsFragmentDoc}`;

/**
 * __useGetCorpVideoHeroCarouselComponentQuery__
 *
 * To run a query within a React component, call `useGetCorpVideoHeroCarouselComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpVideoHeroCarouselComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpVideoHeroCarouselComponentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCorpVideoHeroCarouselComponentQuery(baseOptions: Apollo.QueryHookOptions<GetCorpVideoHeroCarouselComponentQuery, GetCorpVideoHeroCarouselComponentQueryVariables> & ({ variables: GetCorpVideoHeroCarouselComponentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpVideoHeroCarouselComponentQuery, GetCorpVideoHeroCarouselComponentQueryVariables>(GetCorpVideoHeroCarouselComponentDocument, options);
      }
export function useGetCorpVideoHeroCarouselComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpVideoHeroCarouselComponentQuery, GetCorpVideoHeroCarouselComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpVideoHeroCarouselComponentQuery, GetCorpVideoHeroCarouselComponentQueryVariables>(GetCorpVideoHeroCarouselComponentDocument, options);
        }
export function useGetCorpVideoHeroCarouselComponentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpVideoHeroCarouselComponentQuery, GetCorpVideoHeroCarouselComponentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpVideoHeroCarouselComponentQuery, GetCorpVideoHeroCarouselComponentQueryVariables>(GetCorpVideoHeroCarouselComponentDocument, options);
        }
export type GetCorpVideoHeroCarouselComponentQueryHookResult = ReturnType<typeof useGetCorpVideoHeroCarouselComponentQuery>;
export type GetCorpVideoHeroCarouselComponentLazyQueryHookResult = ReturnType<typeof useGetCorpVideoHeroCarouselComponentLazyQuery>;
export type GetCorpVideoHeroCarouselComponentSuspenseQueryHookResult = ReturnType<typeof useGetCorpVideoHeroCarouselComponentSuspenseQuery>;
export type GetCorpVideoHeroCarouselComponentQueryResult = Apollo.QueryResult<GetCorpVideoHeroCarouselComponentQuery, GetCorpVideoHeroCarouselComponentQueryVariables>;
export const GetCorpVideoHeroComponentDocument = gql`
    query GetCorpVideoHeroComponent($where: CorpVideoHeroWhereUniqueInput!, $locales: [Locale!]!) {
  corpVideoHero(where: $where, locales: $locales) {
    id
    __typename
    title: bannerTitle
    superTitle
    description
    videoId
    textColor
    contentAlignment
    verticalAlignment
    linkComponent {
      ...LinkParts
    }
    darkOverlay
    bannerImage {
      imageAlt: altText
      desktop: url(
        transformation: {image: {resize: {fit: max, width: 1800}}, document: {output: {format: webp}}}
      )
      desktopFallback: url(
        transformation: {image: {resize: {fit: max, width: 1800}}, document: {output: {format: jpg}}}
      )
      mobile: url(
        transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: webp}}}
      )
      mobileFallback: url(
        transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: jpg}}}
      )
    }
    mobileImage {
      mobile: url(
        transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: webp}}}
      )
      mobileFallback: url(
        transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: jpg}}}
      )
    }
  }
}
    ${LinkPartsFragmentDoc}`;

/**
 * __useGetCorpVideoHeroComponentQuery__
 *
 * To run a query within a React component, call `useGetCorpVideoHeroComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpVideoHeroComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpVideoHeroComponentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCorpVideoHeroComponentQuery(baseOptions: Apollo.QueryHookOptions<GetCorpVideoHeroComponentQuery, GetCorpVideoHeroComponentQueryVariables> & ({ variables: GetCorpVideoHeroComponentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpVideoHeroComponentQuery, GetCorpVideoHeroComponentQueryVariables>(GetCorpVideoHeroComponentDocument, options);
      }
export function useGetCorpVideoHeroComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpVideoHeroComponentQuery, GetCorpVideoHeroComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpVideoHeroComponentQuery, GetCorpVideoHeroComponentQueryVariables>(GetCorpVideoHeroComponentDocument, options);
        }
export function useGetCorpVideoHeroComponentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpVideoHeroComponentQuery, GetCorpVideoHeroComponentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpVideoHeroComponentQuery, GetCorpVideoHeroComponentQueryVariables>(GetCorpVideoHeroComponentDocument, options);
        }
export type GetCorpVideoHeroComponentQueryHookResult = ReturnType<typeof useGetCorpVideoHeroComponentQuery>;
export type GetCorpVideoHeroComponentLazyQueryHookResult = ReturnType<typeof useGetCorpVideoHeroComponentLazyQuery>;
export type GetCorpVideoHeroComponentSuspenseQueryHookResult = ReturnType<typeof useGetCorpVideoHeroComponentSuspenseQuery>;
export type GetCorpVideoHeroComponentQueryResult = Apollo.QueryResult<GetCorpVideoHeroComponentQuery, GetCorpVideoHeroComponentQueryVariables>;
export const GetCountrySelectorDocument = gql`
    query GetCountrySelector($where: CountrySelectorWhereInput, $locales: [Locale!]!) {
  countrySelectors(where: $where, locales: $locales) {
    id
    __typename
    title
    countryLabel
    languageLabel
    textOnButton
    countrySelectorList {
      ... on CountrySelectorItem {
        id
        country
        countryCode
        countryFlag {
          ... on AssetComponent {
            id
            asset {
              url(transformation: {image: {resize: {width: 18, height: 12, fit: clip}}})
              altText
            }
          }
        }
        language {
          ... on Link {
            id
            displayName
            url
            openInNewTab
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCountrySelectorQuery__
 *
 * To run a query within a React component, call `useGetCountrySelectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountrySelectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountrySelectorQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCountrySelectorQuery(baseOptions: Apollo.QueryHookOptions<GetCountrySelectorQuery, GetCountrySelectorQueryVariables> & ({ variables: GetCountrySelectorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCountrySelectorQuery, GetCountrySelectorQueryVariables>(GetCountrySelectorDocument, options);
      }
export function useGetCountrySelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountrySelectorQuery, GetCountrySelectorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCountrySelectorQuery, GetCountrySelectorQueryVariables>(GetCountrySelectorDocument, options);
        }
export function useGetCountrySelectorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCountrySelectorQuery, GetCountrySelectorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCountrySelectorQuery, GetCountrySelectorQueryVariables>(GetCountrySelectorDocument, options);
        }
export type GetCountrySelectorQueryHookResult = ReturnType<typeof useGetCountrySelectorQuery>;
export type GetCountrySelectorLazyQueryHookResult = ReturnType<typeof useGetCountrySelectorLazyQuery>;
export type GetCountrySelectorSuspenseQueryHookResult = ReturnType<typeof useGetCountrySelectorSuspenseQuery>;
export type GetCountrySelectorQueryResult = Apollo.QueryResult<GetCountrySelectorQuery, GetCountrySelectorQueryVariables>;
export const GetDynamicCardGridDocument = gql`
    query GetDynamicCardGrid($locales: [Locale!]!, $where: DynamicCardGridWhereUniqueInput!) {
  dynamicCardGrid(where: $where, locales: $locales) {
    id
    __typename
    subHeading
    heading
    description
    cardVariation
    cardLinkLabel
    showCards
    gridCta {
      displayName
    }
    dictionaryItem(locales: $locales) {
      ... on DictionaryItem {
        key
        value
      }
    }
    extension {
      __typename
      id
      markets
      environment
      extension
      tipsAndTricks
      products
    }
    anchorNav {
      id
      navigationTitle
    }
  }
}
    `;

/**
 * __useGetDynamicCardGridQuery__
 *
 * To run a query within a React component, call `useGetDynamicCardGridQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDynamicCardGridQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDynamicCardGridQuery({
 *   variables: {
 *      locales: // value for 'locales'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetDynamicCardGridQuery(baseOptions: Apollo.QueryHookOptions<GetDynamicCardGridQuery, GetDynamicCardGridQueryVariables> & ({ variables: GetDynamicCardGridQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDynamicCardGridQuery, GetDynamicCardGridQueryVariables>(GetDynamicCardGridDocument, options);
      }
export function useGetDynamicCardGridLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDynamicCardGridQuery, GetDynamicCardGridQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDynamicCardGridQuery, GetDynamicCardGridQueryVariables>(GetDynamicCardGridDocument, options);
        }
export function useGetDynamicCardGridSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDynamicCardGridQuery, GetDynamicCardGridQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDynamicCardGridQuery, GetDynamicCardGridQueryVariables>(GetDynamicCardGridDocument, options);
        }
export type GetDynamicCardGridQueryHookResult = ReturnType<typeof useGetDynamicCardGridQuery>;
export type GetDynamicCardGridLazyQueryHookResult = ReturnType<typeof useGetDynamicCardGridLazyQuery>;
export type GetDynamicCardGridSuspenseQueryHookResult = ReturnType<typeof useGetDynamicCardGridSuspenseQuery>;
export type GetDynamicCardGridQueryResult = Apollo.QueryResult<GetDynamicCardGridQuery, GetDynamicCardGridQueryVariables>;
export const GetExampleComponentDocument = gql`
    query GetExampleComponent($where: ExampleComponentWhereUniqueInput!, $locales: [Locale!]!) {
  exampleComponent(where: $where, locales: $locales) {
    id
    title
    description {
      text
      html
    }
    assetsComponents {
      id
      asset {
        id
        url(transformation: {image: {resize: {fit: clip, width: 500, height: 500}}})
      }
    }
    imageTextAlignment
  }
}
    `;

/**
 * __useGetExampleComponentQuery__
 *
 * To run a query within a React component, call `useGetExampleComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExampleComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExampleComponentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetExampleComponentQuery(baseOptions: Apollo.QueryHookOptions<GetExampleComponentQuery, GetExampleComponentQueryVariables> & ({ variables: GetExampleComponentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExampleComponentQuery, GetExampleComponentQueryVariables>(GetExampleComponentDocument, options);
      }
export function useGetExampleComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExampleComponentQuery, GetExampleComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExampleComponentQuery, GetExampleComponentQueryVariables>(GetExampleComponentDocument, options);
        }
export function useGetExampleComponentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExampleComponentQuery, GetExampleComponentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExampleComponentQuery, GetExampleComponentQueryVariables>(GetExampleComponentDocument, options);
        }
export type GetExampleComponentQueryHookResult = ReturnType<typeof useGetExampleComponentQuery>;
export type GetExampleComponentLazyQueryHookResult = ReturnType<typeof useGetExampleComponentLazyQuery>;
export type GetExampleComponentSuspenseQueryHookResult = ReturnType<typeof useGetExampleComponentSuspenseQuery>;
export type GetExampleComponentQueryResult = Apollo.QueryResult<GetExampleComponentQuery, GetExampleComponentQueryVariables>;
export const GetFeaturedContentDocument = gql`
    query GetFeaturedContent($locales: [Locale!]!, $where: FeaturedContentWhereUniqueInput!) {
  featuredContent(where: $where, locales: $locales) {
    __typename
    id
    title
    superText
    dictionary {
      dictionaryItems(locales: $locales) {
        key
        value
      }
    }
    items {
      ... on AuthorableContentCard {
        __typename
        id
        copy
        name
        subtitle
        videoId
        image {
          asset {
            id
            url
            mobile: url(
              transformation: {image: {resize: {width: 320, height: 500, fit: crop}}, document: {output: {format: webp}}}
            )
            mobileFallback: url(
              transformation: {image: {resize: {width: 320, height: 500, fit: crop}}, document: {output: {format: png}}}
            )
            desktop: url(
              transformation: {image: {resize: {width: 1440, height: 500, fit: crop}}, document: {output: {format: webp}}}
            )
            desktopFallback: url(
              transformation: {image: {resize: {width: 1440, height: 500, fit: crop}}, document: {output: {format: png}}}
            )
            hero: url(
              transformation: {image: {resize: {width: 1900, height: 500, fit: crop}}, document: {output: {format: png}}}
            )
            tablet: url(
              transformation: {image: {resize: {width: 1024, height: 500, fit: crop}}, document: {output: {format: webp}}}
            )
            tabletFallback: url(
              transformation: {image: {resize: {width: 1024, height: 500, fit: crop}}, document: {output: {format: png}}}
            )
          }
        }
        link {
          ...LinkParts
        }
        anchorNav {
          id
          navigationTitle
        }
      }
      ... on FeaturedContentReference {
        __typename
        id
        title
        recipeId
      }
    }
    anchorNav {
      id
      navigationTitle
    }
  }
}
    ${LinkPartsFragmentDoc}`;

/**
 * __useGetFeaturedContentQuery__
 *
 * To run a query within a React component, call `useGetFeaturedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturedContentQuery({
 *   variables: {
 *      locales: // value for 'locales'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetFeaturedContentQuery(baseOptions: Apollo.QueryHookOptions<GetFeaturedContentQuery, GetFeaturedContentQueryVariables> & ({ variables: GetFeaturedContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturedContentQuery, GetFeaturedContentQueryVariables>(GetFeaturedContentDocument, options);
      }
export function useGetFeaturedContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturedContentQuery, GetFeaturedContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturedContentQuery, GetFeaturedContentQueryVariables>(GetFeaturedContentDocument, options);
        }
export function useGetFeaturedContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeaturedContentQuery, GetFeaturedContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeaturedContentQuery, GetFeaturedContentQueryVariables>(GetFeaturedContentDocument, options);
        }
export type GetFeaturedContentQueryHookResult = ReturnType<typeof useGetFeaturedContentQuery>;
export type GetFeaturedContentLazyQueryHookResult = ReturnType<typeof useGetFeaturedContentLazyQuery>;
export type GetFeaturedContentSuspenseQueryHookResult = ReturnType<typeof useGetFeaturedContentSuspenseQuery>;
export type GetFeaturedContentQueryResult = Apollo.QueryResult<GetFeaturedContentQuery, GetFeaturedContentQueryVariables>;
export const GetFooterDocument = gql`
    query GetFooter($footerNavigation: FooterNavigationWhereInput, $locales: [Locale!]!) {
  footerNavigations(where: $footerNavigation, locales: $locales) {
    cmsTitle: title
    footerNavType
    id
    links {
      ... on Link {
        ...LinkParts
      }
    }
  }
}
    ${LinkPartsFragmentDoc}`;

/**
 * __useGetFooterQuery__
 *
 * To run a query within a React component, call `useGetFooterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFooterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFooterQuery({
 *   variables: {
 *      footerNavigation: // value for 'footerNavigation'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetFooterQuery(baseOptions: Apollo.QueryHookOptions<GetFooterQuery, GetFooterQueryVariables> & ({ variables: GetFooterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFooterQuery, GetFooterQueryVariables>(GetFooterDocument, options);
      }
export function useGetFooterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFooterQuery, GetFooterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFooterQuery, GetFooterQueryVariables>(GetFooterDocument, options);
        }
export function useGetFooterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFooterQuery, GetFooterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFooterQuery, GetFooterQueryVariables>(GetFooterDocument, options);
        }
export type GetFooterQueryHookResult = ReturnType<typeof useGetFooterQuery>;
export type GetFooterLazyQueryHookResult = ReturnType<typeof useGetFooterLazyQuery>;
export type GetFooterSuspenseQueryHookResult = ReturnType<typeof useGetFooterSuspenseQuery>;
export type GetFooterQueryResult = Apollo.QueryResult<GetFooterQuery, GetFooterQueryVariables>;
export const GetFormDocument = gql`
    query GetForm($where: FormWhereUniqueInput!, $locales: [Locale!]!) {
  form(where: $where, locales: $locales) {
    __typename
    id
    formFields {
      ... on FormEmailInput {
        __typename
        id
        placeholderText
        label
        fieldName
        initialValue
        required
        requiredErrorMessage
      }
      ... on FormPasswordInput {
        __typename
        id
        label
        fieldName
        required
        requiredErrorMessage
      }
      ... on FormSubmitButton {
        __typename
        id
        buttonLoadingText
        buttonText
      }
      ... on FormTextInput {
        __typename
        id
        label
        placeholderText
        title
        fieldName
        initialValue
        required
        requiredErrorMessage
      }
      ... on FormTextareaInput {
        __typename
        id
        label
        placeholderText
        title
        fieldName
        initialValue
        required
        requiredErrorMessage
      }
      ... on FormPasswordInputWithConfirmation {
        __typename
        id
        title
        confirmationTitle
      }
      ... on FormCheckbox {
        __typename
        id
        fieldName
        label
        required
        requiredErrorMessage
        title
      }
      ... on FormRadioButtonCollection {
        id
        requiredErrorMessage
        required
        fieldName
        title
        formRadioButtons {
          label
          option
          title
        }
      }
      ... on FormSelectComponent {
        __typename
        id
        label
        fieldName
        initialValue
        options {
          label
          id
          value
        }
      }
    }
    formErrors {
      id
      message
      errorCode
    }
    formSuccess {
      id
      message
      description
    }
    anchorNav {
      id
      navigationTitle
    }
  }
}
    `;

/**
 * __useGetFormQuery__
 *
 * To run a query within a React component, call `useGetFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFormQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetFormQuery(baseOptions: Apollo.QueryHookOptions<GetFormQuery, GetFormQueryVariables> & ({ variables: GetFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFormQuery, GetFormQueryVariables>(GetFormDocument, options);
      }
export function useGetFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFormQuery, GetFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFormQuery, GetFormQueryVariables>(GetFormDocument, options);
        }
export function useGetFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFormQuery, GetFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFormQuery, GetFormQueryVariables>(GetFormDocument, options);
        }
export type GetFormQueryHookResult = ReturnType<typeof useGetFormQuery>;
export type GetFormLazyQueryHookResult = ReturnType<typeof useGetFormLazyQuery>;
export type GetFormSuspenseQueryHookResult = ReturnType<typeof useGetFormSuspenseQuery>;
export type GetFormQueryResult = Apollo.QueryResult<GetFormQuery, GetFormQueryVariables>;
export const GetCorpAddToCalendarDocument = gql`
    query GetCorpAddToCalendar($where: CorpAddToCalendarWhereUniqueInput!, $locales: [Locale!]!) {
  corpAddToCalendar(where: $where, locales: $locales) {
    id
    __typename
    title
    description
    startDate
    endDate
    location
  }
}
    `;

/**
 * __useGetCorpAddToCalendarQuery__
 *
 * To run a query within a React component, call `useGetCorpAddToCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpAddToCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpAddToCalendarQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCorpAddToCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetCorpAddToCalendarQuery, GetCorpAddToCalendarQueryVariables> & ({ variables: GetCorpAddToCalendarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpAddToCalendarQuery, GetCorpAddToCalendarQueryVariables>(GetCorpAddToCalendarDocument, options);
      }
export function useGetCorpAddToCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpAddToCalendarQuery, GetCorpAddToCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpAddToCalendarQuery, GetCorpAddToCalendarQueryVariables>(GetCorpAddToCalendarDocument, options);
        }
export function useGetCorpAddToCalendarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpAddToCalendarQuery, GetCorpAddToCalendarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpAddToCalendarQuery, GetCorpAddToCalendarQueryVariables>(GetCorpAddToCalendarDocument, options);
        }
export type GetCorpAddToCalendarQueryHookResult = ReturnType<typeof useGetCorpAddToCalendarQuery>;
export type GetCorpAddToCalendarLazyQueryHookResult = ReturnType<typeof useGetCorpAddToCalendarLazyQuery>;
export type GetCorpAddToCalendarSuspenseQueryHookResult = ReturnType<typeof useGetCorpAddToCalendarSuspenseQuery>;
export type GetCorpAddToCalendarQueryResult = Apollo.QueryResult<GetCorpAddToCalendarQuery, GetCorpAddToCalendarQueryVariables>;
export const GetGenericAccordionTopRatedDocument = gql`
    query GetGenericAccordionTopRated($where: GenericAccordionTopRatedWhereUniqueInput!, $locales: [Locale!]!) {
  genericAccordionTopRated(where: $where, locales: $locales) {
    id
    __typename
    title
    super
    extension {
      __typename
      id
      markets
      topRated
      environment
      extension
    }
    anchorNav {
      id
      navigationTitle
    }
  }
}
    `;

/**
 * __useGetGenericAccordionTopRatedQuery__
 *
 * To run a query within a React component, call `useGetGenericAccordionTopRatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenericAccordionTopRatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenericAccordionTopRatedQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetGenericAccordionTopRatedQuery(baseOptions: Apollo.QueryHookOptions<GetGenericAccordionTopRatedQuery, GetGenericAccordionTopRatedQueryVariables> & ({ variables: GetGenericAccordionTopRatedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenericAccordionTopRatedQuery, GetGenericAccordionTopRatedQueryVariables>(GetGenericAccordionTopRatedDocument, options);
      }
export function useGetGenericAccordionTopRatedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenericAccordionTopRatedQuery, GetGenericAccordionTopRatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenericAccordionTopRatedQuery, GetGenericAccordionTopRatedQueryVariables>(GetGenericAccordionTopRatedDocument, options);
        }
export function useGetGenericAccordionTopRatedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenericAccordionTopRatedQuery, GetGenericAccordionTopRatedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenericAccordionTopRatedQuery, GetGenericAccordionTopRatedQueryVariables>(GetGenericAccordionTopRatedDocument, options);
        }
export type GetGenericAccordionTopRatedQueryHookResult = ReturnType<typeof useGetGenericAccordionTopRatedQuery>;
export type GetGenericAccordionTopRatedLazyQueryHookResult = ReturnType<typeof useGetGenericAccordionTopRatedLazyQuery>;
export type GetGenericAccordionTopRatedSuspenseQueryHookResult = ReturnType<typeof useGetGenericAccordionTopRatedSuspenseQuery>;
export type GetGenericAccordionTopRatedQueryResult = Apollo.QueryResult<GetGenericAccordionTopRatedQuery, GetGenericAccordionTopRatedQueryVariables>;
export const GetGenericAccordionDocument = gql`
    query GetGenericAccordion($where: GenericAccordionWhereUniqueInput!, $locales: [Locale!]!) {
  genericAccordion(where: $where, locales: $locales) {
    id
    __typename
    numbered
    genericAccordionItems {
      id
      title
      alignment
      text {
        html
      }
    }
  }
}
    `;

/**
 * __useGetGenericAccordionQuery__
 *
 * To run a query within a React component, call `useGetGenericAccordionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenericAccordionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenericAccordionQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetGenericAccordionQuery(baseOptions: Apollo.QueryHookOptions<GetGenericAccordionQuery, GetGenericAccordionQueryVariables> & ({ variables: GetGenericAccordionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenericAccordionQuery, GetGenericAccordionQueryVariables>(GetGenericAccordionDocument, options);
      }
export function useGetGenericAccordionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenericAccordionQuery, GetGenericAccordionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenericAccordionQuery, GetGenericAccordionQueryVariables>(GetGenericAccordionDocument, options);
        }
export function useGetGenericAccordionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenericAccordionQuery, GetGenericAccordionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenericAccordionQuery, GetGenericAccordionQueryVariables>(GetGenericAccordionDocument, options);
        }
export type GetGenericAccordionQueryHookResult = ReturnType<typeof useGetGenericAccordionQuery>;
export type GetGenericAccordionLazyQueryHookResult = ReturnType<typeof useGetGenericAccordionLazyQuery>;
export type GetGenericAccordionSuspenseQueryHookResult = ReturnType<typeof useGetGenericAccordionSuspenseQuery>;
export type GetGenericAccordionQueryResult = Apollo.QueryResult<GetGenericAccordionQuery, GetGenericAccordionQueryVariables>;
export const GetGenericGridAuthorableDocument = gql`
    query GetGenericGridAuthorable($locales: [Locale!]!, $where: GenericGridAuthorableWhereUniqueInput!) {
  genericGridAuthorable(where: $where, locales: $locales) {
    __typename
    id
    title
    superText
    regularLayout
    dictionary {
      dictionaryItems(locales: $locales) {
        key
        value
      }
    }
    cards {
      ... on AuthorableContentCard {
        __typename
        id
        copy
        name
        subtitle
        videoId
        image {
          asset {
            id
            url
            mobile: url(
              transformation: {image: {resize: {width: 320, height: 500, fit: crop}}, document: {output: {format: webp}}}
            )
            mobileFallback: url(
              transformation: {image: {resize: {width: 320, height: 500, fit: crop}}, document: {output: {format: png}}}
            )
            desktop: url(
              transformation: {image: {resize: {width: 1440, height: 500, fit: crop}}, document: {output: {format: webp}}}
            )
            desktopFallback: url(
              transformation: {image: {resize: {width: 1440, height: 500, fit: crop}}, document: {output: {format: png}}}
            )
            hero: url(
              transformation: {image: {resize: {width: 1900, height: 500, fit: crop}}, document: {output: {format: webp}}}
            )
            heroFallback: url(
              transformation: {image: {resize: {width: 1900, height: 500, fit: crop}}, document: {output: {format: png}}}
            )
            tablet: url(
              transformation: {image: {resize: {width: 1024, height: 500, fit: crop}}, document: {output: {format: webp}}}
            )
            tabletFallback: url(
              transformation: {image: {resize: {width: 1024, height: 500, fit: crop}}, document: {output: {format: png}}}
            )
          }
        }
        link {
          ...LinkParts
        }
        anchorNav {
          id
          navigationTitle
        }
      }
      ... on FeaturedContentReference {
        __typename
        id
        title
        recipeId
        tipsAndTricksId
        articlePage {
          slug
          title
          id
        }
      }
    }
  }
}
    ${LinkPartsFragmentDoc}`;

/**
 * __useGetGenericGridAuthorableQuery__
 *
 * To run a query within a React component, call `useGetGenericGridAuthorableQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenericGridAuthorableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenericGridAuthorableQuery({
 *   variables: {
 *      locales: // value for 'locales'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetGenericGridAuthorableQuery(baseOptions: Apollo.QueryHookOptions<GetGenericGridAuthorableQuery, GetGenericGridAuthorableQueryVariables> & ({ variables: GetGenericGridAuthorableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenericGridAuthorableQuery, GetGenericGridAuthorableQueryVariables>(GetGenericGridAuthorableDocument, options);
      }
export function useGetGenericGridAuthorableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenericGridAuthorableQuery, GetGenericGridAuthorableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenericGridAuthorableQuery, GetGenericGridAuthorableQueryVariables>(GetGenericGridAuthorableDocument, options);
        }
export function useGetGenericGridAuthorableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenericGridAuthorableQuery, GetGenericGridAuthorableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenericGridAuthorableQuery, GetGenericGridAuthorableQueryVariables>(GetGenericGridAuthorableDocument, options);
        }
export type GetGenericGridAuthorableQueryHookResult = ReturnType<typeof useGetGenericGridAuthorableQuery>;
export type GetGenericGridAuthorableLazyQueryHookResult = ReturnType<typeof useGetGenericGridAuthorableLazyQuery>;
export type GetGenericGridAuthorableSuspenseQueryHookResult = ReturnType<typeof useGetGenericGridAuthorableSuspenseQuery>;
export type GetGenericGridAuthorableQueryResult = Apollo.QueryResult<GetGenericGridAuthorableQuery, GetGenericGridAuthorableQueryVariables>;
export const GetGenericCardCarouseComponentDocument = gql`
    query GetGenericCardCarouseComponent($locales: [Locale!]!, $where: GenericCardCarouseComponentWhereUniqueInput!) {
  genericCardCarouseComponent(where: $where, locales: $locales) {
    id
    __typename
    key
    subHeading
    heading
    cardVariation
    componentBackground {
      ... on AssetComponent {
        id
        asset {
          url(
            transformation: {image: {resize: {fit: max, width: 427}}, document: {output: {format: webp}}}
          )
        }
      }
    }
    floatingObject {
      ... on AssetComponent {
        id
        asset {
          url(
            transformation: {image: {resize: {fit: max, width: 427}}, document: {output: {format: webp}}}
          )
          altText
        }
      }
    }
    extension {
      __typename
      id
      markets
      environment
      extension
      tipsAndTricks
      products
    }
    dictionaryItem(locales: $locales) {
      ... on DictionaryItem {
        key
        value
      }
    }
    genericCardCarouselCta {
      ... on Link {
        displayName
        url
      }
    }
    anchorNav {
      id
      navigationTitle
    }
    pointCtaToArticlesList
    articles {
      __typename
      slug
      title
      id
      metaData {
        id
        images {
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetGenericCardCarouseComponentQuery__
 *
 * To run a query within a React component, call `useGetGenericCardCarouseComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenericCardCarouseComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenericCardCarouseComponentQuery({
 *   variables: {
 *      locales: // value for 'locales'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetGenericCardCarouseComponentQuery(baseOptions: Apollo.QueryHookOptions<GetGenericCardCarouseComponentQuery, GetGenericCardCarouseComponentQueryVariables> & ({ variables: GetGenericCardCarouseComponentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenericCardCarouseComponentQuery, GetGenericCardCarouseComponentQueryVariables>(GetGenericCardCarouseComponentDocument, options);
      }
export function useGetGenericCardCarouseComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenericCardCarouseComponentQuery, GetGenericCardCarouseComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenericCardCarouseComponentQuery, GetGenericCardCarouseComponentQueryVariables>(GetGenericCardCarouseComponentDocument, options);
        }
export function useGetGenericCardCarouseComponentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenericCardCarouseComponentQuery, GetGenericCardCarouseComponentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenericCardCarouseComponentQuery, GetGenericCardCarouseComponentQueryVariables>(GetGenericCardCarouseComponentDocument, options);
        }
export type GetGenericCardCarouseComponentQueryHookResult = ReturnType<typeof useGetGenericCardCarouseComponentQuery>;
export type GetGenericCardCarouseComponentLazyQueryHookResult = ReturnType<typeof useGetGenericCardCarouseComponentLazyQuery>;
export type GetGenericCardCarouseComponentSuspenseQueryHookResult = ReturnType<typeof useGetGenericCardCarouseComponentSuspenseQuery>;
export type GetGenericCardCarouseComponentQueryResult = Apollo.QueryResult<GetGenericCardCarouseComponentQuery, GetGenericCardCarouseComponentQueryVariables>;
export const GetCorpGenericContainerDocument = gql`
    query GetCorpGenericContainer($where: CorpGenericContainerWhereUniqueInput!, $locales: [Locale!]!) {
  corpGenericContainer(where: $where, locales: $locales) {
    ...GenericContainerParts
  }
}
    ${GenericContainerPartsFragmentDoc}`;

/**
 * __useGetCorpGenericContainerQuery__
 *
 * To run a query within a React component, call `useGetCorpGenericContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCorpGenericContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCorpGenericContainerQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetCorpGenericContainerQuery(baseOptions: Apollo.QueryHookOptions<GetCorpGenericContainerQuery, GetCorpGenericContainerQueryVariables> & ({ variables: GetCorpGenericContainerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCorpGenericContainerQuery, GetCorpGenericContainerQueryVariables>(GetCorpGenericContainerDocument, options);
      }
export function useGetCorpGenericContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCorpGenericContainerQuery, GetCorpGenericContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCorpGenericContainerQuery, GetCorpGenericContainerQueryVariables>(GetCorpGenericContainerDocument, options);
        }
export function useGetCorpGenericContainerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCorpGenericContainerQuery, GetCorpGenericContainerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCorpGenericContainerQuery, GetCorpGenericContainerQueryVariables>(GetCorpGenericContainerDocument, options);
        }
export type GetCorpGenericContainerQueryHookResult = ReturnType<typeof useGetCorpGenericContainerQuery>;
export type GetCorpGenericContainerLazyQueryHookResult = ReturnType<typeof useGetCorpGenericContainerLazyQuery>;
export type GetCorpGenericContainerSuspenseQueryHookResult = ReturnType<typeof useGetCorpGenericContainerSuspenseQuery>;
export type GetCorpGenericContainerQueryResult = Apollo.QueryResult<GetCorpGenericContainerQuery, GetCorpGenericContainerQueryVariables>;
export const GetGenericDownloadComponentDocument = gql`
    query GetGenericDownloadComponent($where: GenericDownloadComponentWhereUniqueInput!, $locales: [Locale!]!) {
  genericDownloadComponent(where: $where, locales: $locales) {
    __typename
    id
    superText
    title
    body
    downloadableFile {
      url
    }
    assetComponent {
      asset {
        desktop: url(
          transformation: {image: {resize: {fit: max, width: 400}}, document: {output: {format: webp}}}
        )
        desktopFallback: url(
          transformation: {image: {resize: {fit: max, width: 400}}, document: {output: {format: png}}}
        )
        mobile: url(
          transformation: {image: {resize: {fit: max, width: 276, height: 276}}, document: {output: {format: webp}}}
        )
        mobileFallback: url(
          transformation: {image: {resize: {fit: max, width: 276, height: 276}}, document: {output: {format: png}}}
        )
        altText
      }
    }
    anchorNav {
      id
      navigationTitle
    }
  }
}
    `;

/**
 * __useGetGenericDownloadComponentQuery__
 *
 * To run a query within a React component, call `useGetGenericDownloadComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenericDownloadComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenericDownloadComponentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetGenericDownloadComponentQuery(baseOptions: Apollo.QueryHookOptions<GetGenericDownloadComponentQuery, GetGenericDownloadComponentQueryVariables> & ({ variables: GetGenericDownloadComponentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenericDownloadComponentQuery, GetGenericDownloadComponentQueryVariables>(GetGenericDownloadComponentDocument, options);
      }
export function useGetGenericDownloadComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenericDownloadComponentQuery, GetGenericDownloadComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenericDownloadComponentQuery, GetGenericDownloadComponentQueryVariables>(GetGenericDownloadComponentDocument, options);
        }
export function useGetGenericDownloadComponentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenericDownloadComponentQuery, GetGenericDownloadComponentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenericDownloadComponentQuery, GetGenericDownloadComponentQueryVariables>(GetGenericDownloadComponentDocument, options);
        }
export type GetGenericDownloadComponentQueryHookResult = ReturnType<typeof useGetGenericDownloadComponentQuery>;
export type GetGenericDownloadComponentLazyQueryHookResult = ReturnType<typeof useGetGenericDownloadComponentLazyQuery>;
export type GetGenericDownloadComponentSuspenseQueryHookResult = ReturnType<typeof useGetGenericDownloadComponentSuspenseQuery>;
export type GetGenericDownloadComponentQueryResult = Apollo.QueryResult<GetGenericDownloadComponentQuery, GetGenericDownloadComponentQueryVariables>;
export const GetGenericFollowUsDocument = gql`
    query GetGenericFollowUs($where: GenericFollowUsWhereUniqueInput!, $locales: [Locale!]!) {
  genericFollowUs(where: $where, locales: $locales) {
    ...GenericFollowUsParts
  }
}
    ${GenericFollowUsPartsFragmentDoc}`;

/**
 * __useGetGenericFollowUsQuery__
 *
 * To run a query within a React component, call `useGetGenericFollowUsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenericFollowUsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenericFollowUsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetGenericFollowUsQuery(baseOptions: Apollo.QueryHookOptions<GetGenericFollowUsQuery, GetGenericFollowUsQueryVariables> & ({ variables: GetGenericFollowUsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenericFollowUsQuery, GetGenericFollowUsQueryVariables>(GetGenericFollowUsDocument, options);
      }
export function useGetGenericFollowUsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenericFollowUsQuery, GetGenericFollowUsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenericFollowUsQuery, GetGenericFollowUsQueryVariables>(GetGenericFollowUsDocument, options);
        }
export function useGetGenericFollowUsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenericFollowUsQuery, GetGenericFollowUsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenericFollowUsQuery, GetGenericFollowUsQueryVariables>(GetGenericFollowUsDocument, options);
        }
export type GetGenericFollowUsQueryHookResult = ReturnType<typeof useGetGenericFollowUsQuery>;
export type GetGenericFollowUsLazyQueryHookResult = ReturnType<typeof useGetGenericFollowUsLazyQuery>;
export type GetGenericFollowUsSuspenseQueryHookResult = ReturnType<typeof useGetGenericFollowUsSuspenseQuery>;
export type GetGenericFollowUsQueryResult = Apollo.QueryResult<GetGenericFollowUsQuery, GetGenericFollowUsQueryVariables>;
export const GetGenericLineDocument = gql`
    query GetGenericLine($where: GenericLineWhereUniqueInput!, $locales: [Locale!]!) {
  genericLine(where: $where, locales: $locales) {
    __typename
    enableLine
    id
  }
}
    `;

/**
 * __useGetGenericLineQuery__
 *
 * To run a query within a React component, call `useGetGenericLineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenericLineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenericLineQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetGenericLineQuery(baseOptions: Apollo.QueryHookOptions<GetGenericLineQuery, GetGenericLineQueryVariables> & ({ variables: GetGenericLineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenericLineQuery, GetGenericLineQueryVariables>(GetGenericLineDocument, options);
      }
export function useGetGenericLineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenericLineQuery, GetGenericLineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenericLineQuery, GetGenericLineQueryVariables>(GetGenericLineDocument, options);
        }
export function useGetGenericLineSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenericLineQuery, GetGenericLineQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenericLineQuery, GetGenericLineQueryVariables>(GetGenericLineDocument, options);
        }
export type GetGenericLineQueryHookResult = ReturnType<typeof useGetGenericLineQuery>;
export type GetGenericLineLazyQueryHookResult = ReturnType<typeof useGetGenericLineLazyQuery>;
export type GetGenericLineSuspenseQueryHookResult = ReturnType<typeof useGetGenericLineSuspenseQuery>;
export type GetGenericLineQueryResult = Apollo.QueryResult<GetGenericLineQuery, GetGenericLineQueryVariables>;
export const GetGenericPageDocument = gql`
    query GetGenericPage($where: GenericPageWhereInput, $locales: [Locale!]!) {
  genericPages(where: $where, locales: $locales) {
    slug
    hideNavigation
    title
    showCookieBanner
    contentGroupingTrackingValue
    contentGroupingTrackingValues
    alwaysIndex
    metaData {
      ...MetadataParts
    }
    anchorNavigationList {
      id
      anchorNavigations {
        id
        navigationTitle
      }
    }
    pageComponents {
      ... on AudioComponent {
        id
        __typename
      }
      ... on CorpCalendarEvent {
        id
        __typename
      }
      ... on CorpOurPeople {
        id
        __typename
      }
      ... on CarouselComponent {
        id
        __typename
      }
      ... on GenericAccordionTopRated {
        id
        __typename
      }
      ... on CorpGenericAccordion {
        id
        __typename
      }
      ... on CorpMediaDownloadPreview {
        id
        __typename
      }
      ... on HeroCarouselComponent {
        id
        __typename
      }
      ... on FeaturedContent {
        id
        __typename
      }
      ... on GenericGridAuthorable {
        id
        __typename
      }
      ... on Form {
        id
        __typename
      }
      ... on Link {
        id
        __typename
      }
      ... on LongText {
        id
        __typename
      }
      ... on LocationComponent {
        id
        __typename
      }
      ... on CorpCardCarousel {
        id
        __typename
        corpCarouselType
      }
      ... on IntroText {
        id
        __typename
      }
      ... on GenericAccordion {
        id
        __typename
      }
      ... on GenericFollowUs {
        id
        __typename
      }
      ... on AuthorableContentCard {
        id
        __typename
      }
      ... on CorpBanner1 {
        id
        __typename
      }
      ... on Banner2 {
        id
        __typename
      }
      ... on ShortHero {
        id
        __typename
      }
      ... on CorpContactCardContainer {
        id
        __typename
      }
      ... on GenericCardCarouseComponent {
        id
        __typename
      }
      ... on CorpHero {
        id
        __typename
      }
      ... on CorpVideoHero {
        id
        __typename
      }
      ... on CorpVideoHeroCarousel {
        id
        __typename
      }
      ... on CorpForm {
        id
        __typename
      }
      ... on CorpTimelineAccordionWrapper {
        id
        __typename
      }
      ... on DynamicCardGrid {
        id
        __typename
      }
      ... on GenericLine {
        id
        __typename
      }
      ... on ImageCopy {
        id
        __typename
      }
      ... on CorpGridColumnComponent {
        id
        __typename
      }
      ... on Tab {
        id
        __typename
      }
      ... on ExampleComponent {
        id
        __typename
      }
      ... on HeroComponent {
        id
        __typename
      }
      ... on GenericDownloadComponent {
        id
        __typename
      }
      ... on QuickLink {
        id
        __typename
      }
      ... on Iframe {
        id
        __typename
      }
      ... on Spacer {
        id
        __typename
      }
      ... on ProgressBar {
        id
        __typename
      }
      ... on AnchorNavigationList {
        id
        __typename
      }
      ... on CorpGenericContainer {
        id
        __typename
      }
    }
    markets
  }
}
    ${MetadataPartsFragmentDoc}`;

/**
 * __useGetGenericPageQuery__
 *
 * To run a query within a React component, call `useGetGenericPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenericPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenericPageQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetGenericPageQuery(baseOptions: Apollo.QueryHookOptions<GetGenericPageQuery, GetGenericPageQueryVariables> & ({ variables: GetGenericPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenericPageQuery, GetGenericPageQueryVariables>(GetGenericPageDocument, options);
      }
export function useGetGenericPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenericPageQuery, GetGenericPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenericPageQuery, GetGenericPageQueryVariables>(GetGenericPageDocument, options);
        }
export function useGetGenericPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenericPageQuery, GetGenericPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenericPageQuery, GetGenericPageQueryVariables>(GetGenericPageDocument, options);
        }
export type GetGenericPageQueryHookResult = ReturnType<typeof useGetGenericPageQuery>;
export type GetGenericPageLazyQueryHookResult = ReturnType<typeof useGetGenericPageLazyQuery>;
export type GetGenericPageSuspenseQueryHookResult = ReturnType<typeof useGetGenericPageSuspenseQuery>;
export type GetGenericPageQueryResult = Apollo.QueryResult<GetGenericPageQuery, GetGenericPageQueryVariables>;
export const GetGenericPagesForSitemapDocument = gql`
    query GetGenericPagesForSitemap {
  genericPages(last: 9999999) {
    markets
    alwaysIndex
    localizations(includeCurrent: true) {
      locale
      slug
    }
  }
}
    `;

/**
 * __useGetGenericPagesForSitemapQuery__
 *
 * To run a query within a React component, call `useGetGenericPagesForSitemapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGenericPagesForSitemapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGenericPagesForSitemapQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGenericPagesForSitemapQuery(baseOptions?: Apollo.QueryHookOptions<GetGenericPagesForSitemapQuery, GetGenericPagesForSitemapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGenericPagesForSitemapQuery, GetGenericPagesForSitemapQueryVariables>(GetGenericPagesForSitemapDocument, options);
      }
export function useGetGenericPagesForSitemapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGenericPagesForSitemapQuery, GetGenericPagesForSitemapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGenericPagesForSitemapQuery, GetGenericPagesForSitemapQueryVariables>(GetGenericPagesForSitemapDocument, options);
        }
export function useGetGenericPagesForSitemapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGenericPagesForSitemapQuery, GetGenericPagesForSitemapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGenericPagesForSitemapQuery, GetGenericPagesForSitemapQueryVariables>(GetGenericPagesForSitemapDocument, options);
        }
export type GetGenericPagesForSitemapQueryHookResult = ReturnType<typeof useGetGenericPagesForSitemapQuery>;
export type GetGenericPagesForSitemapLazyQueryHookResult = ReturnType<typeof useGetGenericPagesForSitemapLazyQuery>;
export type GetGenericPagesForSitemapSuspenseQueryHookResult = ReturnType<typeof useGetGenericPagesForSitemapSuspenseQuery>;
export type GetGenericPagesForSitemapQueryResult = Apollo.QueryResult<GetGenericPagesForSitemapQuery, GetGenericPagesForSitemapQueryVariables>;
export const GetGlobalMetadataDocument = gql`
    query GetGlobalMetadata($where: GlobalMetaDataWhereUniqueInput!, $locales: [Locale!]!) {
  globalMetaData(where: $where, locales: $locales) {
    siteName
    url
    titleTemplate
    description
    facebookAppId
    image {
      url
      height
      width
    }
    twitterSeo {
      handle
      site
      cardType
    }
  }
}
    `;

/**
 * __useGetGlobalMetadataQuery__
 *
 * To run a query within a React component, call `useGetGlobalMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlobalMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlobalMetadataQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetGlobalMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetGlobalMetadataQuery, GetGlobalMetadataQueryVariables> & ({ variables: GetGlobalMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGlobalMetadataQuery, GetGlobalMetadataQueryVariables>(GetGlobalMetadataDocument, options);
      }
export function useGetGlobalMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGlobalMetadataQuery, GetGlobalMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGlobalMetadataQuery, GetGlobalMetadataQueryVariables>(GetGlobalMetadataDocument, options);
        }
export function useGetGlobalMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGlobalMetadataQuery, GetGlobalMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGlobalMetadataQuery, GetGlobalMetadataQueryVariables>(GetGlobalMetadataDocument, options);
        }
export type GetGlobalMetadataQueryHookResult = ReturnType<typeof useGetGlobalMetadataQuery>;
export type GetGlobalMetadataLazyQueryHookResult = ReturnType<typeof useGetGlobalMetadataLazyQuery>;
export type GetGlobalMetadataSuspenseQueryHookResult = ReturnType<typeof useGetGlobalMetadataSuspenseQuery>;
export type GetGlobalMetadataQueryResult = Apollo.QueryResult<GetGlobalMetadataQuery, GetGlobalMetadataQueryVariables>;
export const GetHeaderDocument = gql`
    query getHeader($where: NavigationWhereInput, $locales: [Locale!]!) {
  navigations(where: $where, locales: $locales) {
    cmsTitle
    positon
    key
    navUrl
    links {
      url
      displayName
      openInNewTab
      id
    }
    category {
      ... on NavigationItem {
        title
        targetLink
        trackingSecondaryNavigation
        subCategory {
          ... on Link {
            displayName
            url
            openInNewTab
            id
          }
        }
      }
    }
    navigation_images {
      ... on AssetComponent {
        cmsAssetTitle
        asset {
          url(transformation: {image: {resize: {width: 400, height: 400, fit: clip}}})
          desktop: url(
            transformation: {image: {resize: {fit: max, width: 400, height: 400}}, document: {output: {format: webp}}}
          )
          desktopFallback: url(
            transformation: {image: {resize: {fit: max, width: 400, height: 400}}, document: {output: {format: png}}}
          )
          mobile: url(
            transformation: {image: {resize: {fit: max, width: 400, height: 400}}, document: {output: {format: webp}}}
          )
          mobileFallback: url(
            transformation: {image: {resize: {fit: max, width: 400, height: 400}}, document: {output: {format: png}}}
          )
        }
      }
    }
    cardComponentTitle
    navCard {
      ... on CardComponent {
        cardId
        category
        categoryId
        description
        difficulty
        preparationTime
        rating
        title
        video
        image {
          ... on AssetComponent {
            id
            cmsAssetTitle
            asset {
              url(transformation: {image: {resize: {width: 400, height: 400, fit: clip}}})
              altText
              desktop: url(
                transformation: {image: {resize: {fit: clip, width: 600, height: 600}}, document: {output: {format: webp}}}
              )
              desktopFallback: url(
                transformation: {image: {resize: {fit: clip, width: 600, height: 600}}, document: {output: {format: png}}}
              )
              mobile: url(
                transformation: {image: {resize: {fit: clip, width: 320, height: 320}}, document: {output: {format: webp}}}
              )
              mobileFallback: url(
                transformation: {image: {resize: {fit: clip, width: 320, height: 320}}, document: {output: {format: png}}}
              )
            }
          }
        }
        cardVariation
        parentPage
        parentCategory
        linkTitle
      }
    }
  }
}
    `;

/**
 * __useGetHeaderQuery__
 *
 * To run a query within a React component, call `useGetHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeaderQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetHeaderQuery(baseOptions: Apollo.QueryHookOptions<GetHeaderQuery, GetHeaderQueryVariables> & ({ variables: GetHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderQuery, GetHeaderQueryVariables>(GetHeaderDocument, options);
      }
export function useGetHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderQuery, GetHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderQuery, GetHeaderQueryVariables>(GetHeaderDocument, options);
        }
export function useGetHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHeaderQuery, GetHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeaderQuery, GetHeaderQueryVariables>(GetHeaderDocument, options);
        }
export type GetHeaderQueryHookResult = ReturnType<typeof useGetHeaderQuery>;
export type GetHeaderLazyQueryHookResult = ReturnType<typeof useGetHeaderLazyQuery>;
export type GetHeaderSuspenseQueryHookResult = ReturnType<typeof useGetHeaderSuspenseQuery>;
export type GetHeaderQueryResult = Apollo.QueryResult<GetHeaderQuery, GetHeaderQueryVariables>;
export const GetMobileHeaderDocument = gql`
    query GetMobileHeader($where: MobileOnlyMainNavigationWhereUniqueInput!) {
  mobileOnlyMainNavigation(where: $where) {
    navigationAsset {
      ... on AssetComponent {
        id
        cmsAssetTitle
        asset {
          altText
          url(transformation: {image: {resize: {width: 400, height: 400, fit: clip}}})
          desktop: url(
            transformation: {image: {resize: {fit: max, width: 400, height: 400}}, document: {output: {format: webp}}}
          )
          desktopFallback: url(
            transformation: {image: {resize: {fit: max, width: 400, height: 400}}, document: {output: {format: png}}}
          )
          mobile: url(
            transformation: {image: {resize: {fit: max, width: 400, height: 400}}, document: {output: {format: webp}}}
          )
          mobileFallback: url(
            transformation: {image: {resize: {fit: max, width: 400, height: 400}}, document: {output: {format: png}}}
          )
        }
      }
    }
  }
}
    `;

/**
 * __useGetMobileHeaderQuery__
 *
 * To run a query within a React component, call `useGetMobileHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMobileHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMobileHeaderQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMobileHeaderQuery(baseOptions: Apollo.QueryHookOptions<GetMobileHeaderQuery, GetMobileHeaderQueryVariables> & ({ variables: GetMobileHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMobileHeaderQuery, GetMobileHeaderQueryVariables>(GetMobileHeaderDocument, options);
      }
export function useGetMobileHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMobileHeaderQuery, GetMobileHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMobileHeaderQuery, GetMobileHeaderQueryVariables>(GetMobileHeaderDocument, options);
        }
export function useGetMobileHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMobileHeaderQuery, GetMobileHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMobileHeaderQuery, GetMobileHeaderQueryVariables>(GetMobileHeaderDocument, options);
        }
export type GetMobileHeaderQueryHookResult = ReturnType<typeof useGetMobileHeaderQuery>;
export type GetMobileHeaderLazyQueryHookResult = ReturnType<typeof useGetMobileHeaderLazyQuery>;
export type GetMobileHeaderSuspenseQueryHookResult = ReturnType<typeof useGetMobileHeaderSuspenseQuery>;
export type GetMobileHeaderQueryResult = Apollo.QueryResult<GetMobileHeaderQuery, GetMobileHeaderQueryVariables>;
export const GetHeroCarouselComponentDocument = gql`
    query GetHeroCarouselComponent($where: HeroCarouselComponentWhereUniqueInput!, $locales: [Locale!]!) {
  heroCarouselComponent(where: $where, locales: $locales) {
    id
    __typename
    anchorNav {
      id
      navigationTitle
    }
    banners {
      bannerSize
      bannerTitle
      superText
      bannerDescriptionText
      bannerVideoUrl
      alignment
      link {
        ...LinkParts
      }
      bannerImage {
        imageAlt: altText
        desktop: url(
          transformation: {image: {resize: {fit: max, height: 780}}, document: {output: {format: webp}}}
        )
        desktopFallback: url(
          transformation: {image: {resize: {fit: max, height: 780}}, document: {output: {format: jpg}}}
        )
        mobile: url(
          transformation: {image: {resize: {fit: max, height: 560}}, document: {output: {format: webp}}}
        )
        mobileFallback: url(
          transformation: {image: {resize: {fit: max, height: 560}}, document: {output: {format: jpg}}}
        )
      }
      mobileImage {
        mobile: url(
          transformation: {image: {resize: {fit: max, height: 560}}, document: {output: {format: webp}}}
        )
        mobileFallback: url(
          transformation: {image: {resize: {fit: max, height: 560}}, document: {output: {format: jpg}}}
        )
      }
    }
  }
}
    ${LinkPartsFragmentDoc}`;

/**
 * __useGetHeroCarouselComponentQuery__
 *
 * To run a query within a React component, call `useGetHeroCarouselComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeroCarouselComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeroCarouselComponentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetHeroCarouselComponentQuery(baseOptions: Apollo.QueryHookOptions<GetHeroCarouselComponentQuery, GetHeroCarouselComponentQueryVariables> & ({ variables: GetHeroCarouselComponentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeroCarouselComponentQuery, GetHeroCarouselComponentQueryVariables>(GetHeroCarouselComponentDocument, options);
      }
export function useGetHeroCarouselComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeroCarouselComponentQuery, GetHeroCarouselComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeroCarouselComponentQuery, GetHeroCarouselComponentQueryVariables>(GetHeroCarouselComponentDocument, options);
        }
export function useGetHeroCarouselComponentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHeroCarouselComponentQuery, GetHeroCarouselComponentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeroCarouselComponentQuery, GetHeroCarouselComponentQueryVariables>(GetHeroCarouselComponentDocument, options);
        }
export type GetHeroCarouselComponentQueryHookResult = ReturnType<typeof useGetHeroCarouselComponentQuery>;
export type GetHeroCarouselComponentLazyQueryHookResult = ReturnType<typeof useGetHeroCarouselComponentLazyQuery>;
export type GetHeroCarouselComponentSuspenseQueryHookResult = ReturnType<typeof useGetHeroCarouselComponentSuspenseQuery>;
export type GetHeroCarouselComponentQueryResult = Apollo.QueryResult<GetHeroCarouselComponentQuery, GetHeroCarouselComponentQueryVariables>;
export const GetHeroComponentDocument = gql`
    query GetHeroComponent($where: HeroComponentWhereUniqueInput!, $locales: [Locale!]!) {
  heroComponent(where: $where, locales: $locales) {
    id
    __typename
    superText
    title
    description
    alignment
    imageComponent {
      id
      asset {
        desktop: url(
          transformation: {image: {resize: {fit: max, width: 800}}, document: {output: {format: webp}}}
        )
        desktopFallback: url(
          transformation: {image: {resize: {fit: max, width: 800}}, document: {output: {format: jpg}}}
        )
        mobile: url(
          transformation: {image: {resize: {fit: max, width: 800}}, document: {output: {format: webp}}}
        )
        mobileFallback: url(
          transformation: {image: {resize: {fit: max, width: 800}}, document: {output: {format: jpg}}}
        )
      }
    }
    topRightImageAsset {
      desktop: url(
        transformation: {image: {resize: {fit: max, width: 316}}, document: {output: {format: webp}}}
      )
      desktopFallback: url(
        transformation: {image: {resize: {fit: max, width: 316}}, document: {output: {format: png}}}
      )
      mobile: url(
        transformation: {image: {resize: {fit: max, width: 200}}, document: {output: {format: webp}}}
      )
      mobileFallback: url(
        transformation: {image: {resize: {fit: max, width: 200}}, document: {output: {format: png}}}
      )
    }
    bottomLeftImageAsset {
      desktop: url(
        transformation: {image: {resize: {fit: max, width: 316}}, document: {output: {format: webp}}}
      )
      desktopFallback: url(
        transformation: {image: {resize: {fit: max, width: 316}}, document: {output: {format: png}}}
      )
      mobile: url(
        transformation: {image: {resize: {fit: max, width: 200}}, document: {output: {format: webp}}}
      )
      mobileFallback: url(
        transformation: {image: {resize: {fit: max, width: 200}}, document: {output: {format: png}}}
      )
    }
    mobileImage {
      mobile: url(
        transformation: {image: {resize: {fit: max, width: 400}}, document: {output: {format: webp}}}
      )
      mobileFallback: url(
        transformation: {image: {resize: {fit: max, width: 400}}, document: {output: {format: jpg}}}
      )
    }
    anchorNav {
      id
      navigationTitle
    }
  }
}
    `;

/**
 * __useGetHeroComponentQuery__
 *
 * To run a query within a React component, call `useGetHeroComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeroComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeroComponentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetHeroComponentQuery(baseOptions: Apollo.QueryHookOptions<GetHeroComponentQuery, GetHeroComponentQueryVariables> & ({ variables: GetHeroComponentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeroComponentQuery, GetHeroComponentQueryVariables>(GetHeroComponentDocument, options);
      }
export function useGetHeroComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeroComponentQuery, GetHeroComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeroComponentQuery, GetHeroComponentQueryVariables>(GetHeroComponentDocument, options);
        }
export function useGetHeroComponentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHeroComponentQuery, GetHeroComponentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeroComponentQuery, GetHeroComponentQueryVariables>(GetHeroComponentDocument, options);
        }
export type GetHeroComponentQueryHookResult = ReturnType<typeof useGetHeroComponentQuery>;
export type GetHeroComponentLazyQueryHookResult = ReturnType<typeof useGetHeroComponentLazyQuery>;
export type GetHeroComponentSuspenseQueryHookResult = ReturnType<typeof useGetHeroComponentSuspenseQuery>;
export type GetHeroComponentQueryResult = Apollo.QueryResult<GetHeroComponentQuery, GetHeroComponentQueryVariables>;
export const GetIframeDocument = gql`
    query GetIframe($where: IframeWhereUniqueInput!) {
  iframe(where: $where) {
    id
    __typename
    cmsTitle
    iframeUrl
    iframeType
    iframeWidth
    iframeHeight
    alignment
  }
}
    `;

/**
 * __useGetIframeQuery__
 *
 * To run a query within a React component, call `useGetIframeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIframeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIframeQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetIframeQuery(baseOptions: Apollo.QueryHookOptions<GetIframeQuery, GetIframeQueryVariables> & ({ variables: GetIframeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIframeQuery, GetIframeQueryVariables>(GetIframeDocument, options);
      }
export function useGetIframeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIframeQuery, GetIframeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIframeQuery, GetIframeQueryVariables>(GetIframeDocument, options);
        }
export function useGetIframeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIframeQuery, GetIframeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIframeQuery, GetIframeQueryVariables>(GetIframeDocument, options);
        }
export type GetIframeQueryHookResult = ReturnType<typeof useGetIframeQuery>;
export type GetIframeLazyQueryHookResult = ReturnType<typeof useGetIframeLazyQuery>;
export type GetIframeSuspenseQueryHookResult = ReturnType<typeof useGetIframeSuspenseQuery>;
export type GetIframeQueryResult = Apollo.QueryResult<GetIframeQuery, GetIframeQueryVariables>;
export const GetImageCopyDocument = gql`
    query GetImageCopy($where: ImageCopyWhereUniqueInput!, $locales: [Locale!]!) {
  imageCopy(where: $where, locales: $locales) {
    ...ImageCopyParts
  }
}
    ${ImageCopyPartsFragmentDoc}`;

/**
 * __useGetImageCopyQuery__
 *
 * To run a query within a React component, call `useGetImageCopyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetImageCopyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetImageCopyQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetImageCopyQuery(baseOptions: Apollo.QueryHookOptions<GetImageCopyQuery, GetImageCopyQueryVariables> & ({ variables: GetImageCopyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetImageCopyQuery, GetImageCopyQueryVariables>(GetImageCopyDocument, options);
      }
export function useGetImageCopyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetImageCopyQuery, GetImageCopyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetImageCopyQuery, GetImageCopyQueryVariables>(GetImageCopyDocument, options);
        }
export function useGetImageCopySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetImageCopyQuery, GetImageCopyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetImageCopyQuery, GetImageCopyQueryVariables>(GetImageCopyDocument, options);
        }
export type GetImageCopyQueryHookResult = ReturnType<typeof useGetImageCopyQuery>;
export type GetImageCopyLazyQueryHookResult = ReturnType<typeof useGetImageCopyLazyQuery>;
export type GetImageCopySuspenseQueryHookResult = ReturnType<typeof useGetImageCopySuspenseQuery>;
export type GetImageCopyQueryResult = Apollo.QueryResult<GetImageCopyQuery, GetImageCopyQueryVariables>;
export const GetIntroTextDocument = gql`
    query GetIntroText($where: IntroTextWhereUniqueInput!, $locales: [Locale!]!) {
  introText(where: $where, locales: $locales) {
    ...IntroTextParts
  }
}
    ${IntroTextPartsFragmentDoc}`;

/**
 * __useGetIntroTextQuery__
 *
 * To run a query within a React component, call `useGetIntroTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntroTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntroTextQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetIntroTextQuery(baseOptions: Apollo.QueryHookOptions<GetIntroTextQuery, GetIntroTextQueryVariables> & ({ variables: GetIntroTextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntroTextQuery, GetIntroTextQueryVariables>(GetIntroTextDocument, options);
      }
export function useGetIntroTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntroTextQuery, GetIntroTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntroTextQuery, GetIntroTextQueryVariables>(GetIntroTextDocument, options);
        }
export function useGetIntroTextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntroTextQuery, GetIntroTextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntroTextQuery, GetIntroTextQueryVariables>(GetIntroTextDocument, options);
        }
export type GetIntroTextQueryHookResult = ReturnType<typeof useGetIntroTextQuery>;
export type GetIntroTextLazyQueryHookResult = ReturnType<typeof useGetIntroTextLazyQuery>;
export type GetIntroTextSuspenseQueryHookResult = ReturnType<typeof useGetIntroTextSuspenseQuery>;
export type GetIntroTextQueryResult = Apollo.QueryResult<GetIntroTextQuery, GetIntroTextQueryVariables>;
export const GetLinkDocument = gql`
    query GetLink($where: LinkWhereUniqueInput!, $locales: [Locale!]!) {
  link(where: $where, locales: $locales) {
    ...LinkParts
  }
}
    ${LinkPartsFragmentDoc}`;

/**
 * __useGetLinkQuery__
 *
 * To run a query within a React component, call `useGetLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetLinkQuery(baseOptions: Apollo.QueryHookOptions<GetLinkQuery, GetLinkQueryVariables> & ({ variables: GetLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkQuery, GetLinkQueryVariables>(GetLinkDocument, options);
      }
export function useGetLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkQuery, GetLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkQuery, GetLinkQueryVariables>(GetLinkDocument, options);
        }
export function useGetLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLinkQuery, GetLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLinkQuery, GetLinkQueryVariables>(GetLinkDocument, options);
        }
export type GetLinkQueryHookResult = ReturnType<typeof useGetLinkQuery>;
export type GetLinkLazyQueryHookResult = ReturnType<typeof useGetLinkLazyQuery>;
export type GetLinkSuspenseQueryHookResult = ReturnType<typeof useGetLinkSuspenseQuery>;
export type GetLinkQueryResult = Apollo.QueryResult<GetLinkQuery, GetLinkQueryVariables>;
export const GetLocationComponentDocument = gql`
    query GetLocationComponent($where: LocationComponentWhereUniqueInput!, $locales: [Locale!]!) {
  locationComponent(where: $where, locales: $locales) {
    id
    __typename
    anchorNav {
      id
      navigationTitle
    }
    mapAllSites {
      id
      asset {
        url
        id
        altText
      }
    }
    mapProductionSites {
      id
      asset {
        url
        altText
      }
    }
    locationItems {
      id
      __typename
      locationName
      description
      date
      isProductionSite
      numberOfEmployees
    }
  }
}
    `;

/**
 * __useGetLocationComponentQuery__
 *
 * To run a query within a React component, call `useGetLocationComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationComponentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetLocationComponentQuery(baseOptions: Apollo.QueryHookOptions<GetLocationComponentQuery, GetLocationComponentQueryVariables> & ({ variables: GetLocationComponentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationComponentQuery, GetLocationComponentQueryVariables>(GetLocationComponentDocument, options);
      }
export function useGetLocationComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationComponentQuery, GetLocationComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationComponentQuery, GetLocationComponentQueryVariables>(GetLocationComponentDocument, options);
        }
export function useGetLocationComponentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationComponentQuery, GetLocationComponentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationComponentQuery, GetLocationComponentQueryVariables>(GetLocationComponentDocument, options);
        }
export type GetLocationComponentQueryHookResult = ReturnType<typeof useGetLocationComponentQuery>;
export type GetLocationComponentLazyQueryHookResult = ReturnType<typeof useGetLocationComponentLazyQuery>;
export type GetLocationComponentSuspenseQueryHookResult = ReturnType<typeof useGetLocationComponentSuspenseQuery>;
export type GetLocationComponentQueryResult = Apollo.QueryResult<GetLocationComponentQuery, GetLocationComponentQueryVariables>;
export const GetLocationItemDocument = gql`
    query GetLocationItem($where: LocationItemWhereUniqueInput!, $locales: [Locale!]!) {
  locationItem(where: $where, locales: $locales) {
    id
    __typename
    locationName
    description
    date
    isProductionSite
    numberOfEmployees
    bodyComponents {
      ... on ImageCopy {
        id
        __typename
      }
      ... on LongText {
        id
        __typename
      }
      ... on Spacer {
        id
        __typename
      }
      ... on CorpGridColumnComponent {
        id
        __typename
      }
      ... on CorpGenericContainer {
        id
        __typename
      }
      ... on CorpContactCardContainer {
        id
        __typename
      }
      ... on QuickLink {
        id
        __typename
      }
    }
  }
}
    `;

/**
 * __useGetLocationItemQuery__
 *
 * To run a query within a React component, call `useGetLocationItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationItemQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetLocationItemQuery(baseOptions: Apollo.QueryHookOptions<GetLocationItemQuery, GetLocationItemQueryVariables> & ({ variables: GetLocationItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationItemQuery, GetLocationItemQueryVariables>(GetLocationItemDocument, options);
      }
export function useGetLocationItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationItemQuery, GetLocationItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationItemQuery, GetLocationItemQueryVariables>(GetLocationItemDocument, options);
        }
export function useGetLocationItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationItemQuery, GetLocationItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationItemQuery, GetLocationItemQueryVariables>(GetLocationItemDocument, options);
        }
export type GetLocationItemQueryHookResult = ReturnType<typeof useGetLocationItemQuery>;
export type GetLocationItemLazyQueryHookResult = ReturnType<typeof useGetLocationItemLazyQuery>;
export type GetLocationItemSuspenseQueryHookResult = ReturnType<typeof useGetLocationItemSuspenseQuery>;
export type GetLocationItemQueryResult = Apollo.QueryResult<GetLocationItemQuery, GetLocationItemQueryVariables>;
export const GetLongTextDocument = gql`
    query GetLongText($where: LongTextWhereUniqueInput!, $locales: [Locale!]!) {
  longText(where: $where, locales: $locales) {
    ...LongTextParts
  }
}
    ${LongTextPartsFragmentDoc}`;

/**
 * __useGetLongTextQuery__
 *
 * To run a query within a React component, call `useGetLongTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLongTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLongTextQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetLongTextQuery(baseOptions: Apollo.QueryHookOptions<GetLongTextQuery, GetLongTextQueryVariables> & ({ variables: GetLongTextQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLongTextQuery, GetLongTextQueryVariables>(GetLongTextDocument, options);
      }
export function useGetLongTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLongTextQuery, GetLongTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLongTextQuery, GetLongTextQueryVariables>(GetLongTextDocument, options);
        }
export function useGetLongTextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLongTextQuery, GetLongTextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLongTextQuery, GetLongTextQueryVariables>(GetLongTextDocument, options);
        }
export type GetLongTextQueryHookResult = ReturnType<typeof useGetLongTextQuery>;
export type GetLongTextLazyQueryHookResult = ReturnType<typeof useGetLongTextLazyQuery>;
export type GetLongTextSuspenseQueryHookResult = ReturnType<typeof useGetLongTextSuspenseQuery>;
export type GetLongTextQueryResult = Apollo.QueryResult<GetLongTextQuery, GetLongTextQueryVariables>;
export const GetMediaLibraryItemsAlgoliaDocument = gql`
    query getMediaLibraryItemsAlgolia($first: Int, $after: String) {
  mediaLibraryItemsConnection(first: $first, after: $after) {
    edges {
      node {
        id
        localizations(includeCurrent: true) {
          locale
          title
        }
        market
        mediaCategory
        mediaType
        assetComponent {
          id
          asset {
            id
            url
            altText
            mimeType
            fileName
            size
            height
            width
            desktop: url(
              transformation: {image: {resize: {fit: max, width: 600}}, document: {output: {format: webp}}}
            )
            desktopFallback: url(
              transformation: {image: {resize: {fit: max, width: 600}}, document: {output: {format: jpg}}}
            )
            mobile: url(
              transformation: {image: {resize: {fit: max, width: 800}}, document: {output: {format: webp}}}
            )
            mobileFallback: url(
              transformation: {image: {resize: {fit: max, width: 800}}, document: {output: {format: jpg}}}
            )
          }
        }
        posterImage {
          id
          asset {
            id
            url
            altText
            mimeType
            fileName
            size
            height
            width
            desktop: url(
              transformation: {image: {resize: {fit: max, width: 600}}, document: {output: {format: webp}}}
            )
            desktopFallback: url(
              transformation: {image: {resize: {fit: max, width: 600}}, document: {output: {format: jpg}}}
            )
            mobile: url(
              transformation: {image: {resize: {fit: max, width: 800}}, document: {output: {format: webp}}}
            )
            mobileFallback: url(
              transformation: {image: {resize: {fit: max, width: 800}}, document: {output: {format: jpg}}}
            )
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      pageSize
      startCursor
      endCursor
    }
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetMediaLibraryItemsAlgoliaQuery__
 *
 * To run a query within a React component, call `useGetMediaLibraryItemsAlgoliaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaLibraryItemsAlgoliaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaLibraryItemsAlgoliaQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetMediaLibraryItemsAlgoliaQuery(baseOptions?: Apollo.QueryHookOptions<GetMediaLibraryItemsAlgoliaQuery, GetMediaLibraryItemsAlgoliaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMediaLibraryItemsAlgoliaQuery, GetMediaLibraryItemsAlgoliaQueryVariables>(GetMediaLibraryItemsAlgoliaDocument, options);
      }
export function useGetMediaLibraryItemsAlgoliaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMediaLibraryItemsAlgoliaQuery, GetMediaLibraryItemsAlgoliaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMediaLibraryItemsAlgoliaQuery, GetMediaLibraryItemsAlgoliaQueryVariables>(GetMediaLibraryItemsAlgoliaDocument, options);
        }
export function useGetMediaLibraryItemsAlgoliaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMediaLibraryItemsAlgoliaQuery, GetMediaLibraryItemsAlgoliaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMediaLibraryItemsAlgoliaQuery, GetMediaLibraryItemsAlgoliaQueryVariables>(GetMediaLibraryItemsAlgoliaDocument, options);
        }
export type GetMediaLibraryItemsAlgoliaQueryHookResult = ReturnType<typeof useGetMediaLibraryItemsAlgoliaQuery>;
export type GetMediaLibraryItemsAlgoliaLazyQueryHookResult = ReturnType<typeof useGetMediaLibraryItemsAlgoliaLazyQuery>;
export type GetMediaLibraryItemsAlgoliaSuspenseQueryHookResult = ReturnType<typeof useGetMediaLibraryItemsAlgoliaSuspenseQuery>;
export type GetMediaLibraryItemsAlgoliaQueryResult = Apollo.QueryResult<GetMediaLibraryItemsAlgoliaQuery, GetMediaLibraryItemsAlgoliaQueryVariables>;
export const GetMediaLibraryDocument = gql`
    query GetMediaLibrary($locales: [Locale!]!) {
  page: mediaLibraries(locales: $locales) {
    title
    subtitle
    introText
    metaData {
      ...MetadataParts
    }
    bodyComponents {
      ... on LongText {
        id
        __typename
      }
      ... on Spacer {
        id
        __typename
      }
      ... on CarouselComponent {
        id
        __typename
      }
      ... on CorpGridColumnComponent {
        id
        __typename
      }
      ... on Banner2 {
        id
        __typename
      }
      ... on CorpBanner1 {
        id
        __typename
      }
      ... on QuickLink {
        id
        __typename
      }
      ... on CorpContactCardContainer {
        id
        __typename
      }
      ... on CorpGenericAccordion {
        id
        __typename
      }
      ... on CorpGenericContainer {
        id
        __typename
      }
    }
  }
}
    ${MetadataPartsFragmentDoc}`;

/**
 * __useGetMediaLibraryQuery__
 *
 * To run a query within a React component, call `useGetMediaLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMediaLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMediaLibraryQuery({
 *   variables: {
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetMediaLibraryQuery(baseOptions: Apollo.QueryHookOptions<GetMediaLibraryQuery, GetMediaLibraryQueryVariables> & ({ variables: GetMediaLibraryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMediaLibraryQuery, GetMediaLibraryQueryVariables>(GetMediaLibraryDocument, options);
      }
export function useGetMediaLibraryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMediaLibraryQuery, GetMediaLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMediaLibraryQuery, GetMediaLibraryQueryVariables>(GetMediaLibraryDocument, options);
        }
export function useGetMediaLibrarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMediaLibraryQuery, GetMediaLibraryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMediaLibraryQuery, GetMediaLibraryQueryVariables>(GetMediaLibraryDocument, options);
        }
export type GetMediaLibraryQueryHookResult = ReturnType<typeof useGetMediaLibraryQuery>;
export type GetMediaLibraryLazyQueryHookResult = ReturnType<typeof useGetMediaLibraryLazyQuery>;
export type GetMediaLibrarySuspenseQueryHookResult = ReturnType<typeof useGetMediaLibrarySuspenseQuery>;
export type GetMediaLibraryQueryResult = Apollo.QueryResult<GetMediaLibraryQuery, GetMediaLibraryQueryVariables>;
export const GetNotificationBannerDocument = gql`
    query GetNotificationBanner($where: NotificationBannerWhereInput, $locales: [Locale!]!) {
  notificationBanners(where: $where, locales: $locales) {
    id
    __typename
    active
    cmsTitle
    title
    description
    link {
      displayName
      url
      openInNewTab
      id
    }
  }
}
    `;

/**
 * __useGetNotificationBannerQuery__
 *
 * To run a query within a React component, call `useGetNotificationBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationBannerQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetNotificationBannerQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationBannerQuery, GetNotificationBannerQueryVariables> & ({ variables: GetNotificationBannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationBannerQuery, GetNotificationBannerQueryVariables>(GetNotificationBannerDocument, options);
      }
export function useGetNotificationBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationBannerQuery, GetNotificationBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationBannerQuery, GetNotificationBannerQueryVariables>(GetNotificationBannerDocument, options);
        }
export function useGetNotificationBannerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNotificationBannerQuery, GetNotificationBannerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNotificationBannerQuery, GetNotificationBannerQueryVariables>(GetNotificationBannerDocument, options);
        }
export type GetNotificationBannerQueryHookResult = ReturnType<typeof useGetNotificationBannerQuery>;
export type GetNotificationBannerLazyQueryHookResult = ReturnType<typeof useGetNotificationBannerLazyQuery>;
export type GetNotificationBannerSuspenseQueryHookResult = ReturnType<typeof useGetNotificationBannerSuspenseQuery>;
export type GetNotificationBannerQueryResult = Apollo.QueryResult<GetNotificationBannerQuery, GetNotificationBannerQueryVariables>;
export const GetPageSearchDocument = gql`
    query GetPageSearch($search: String!, $locales: [Locale!]!, $localeGlobalPressRelease: Locale!, $storyPressMarkets: [Markets!]!, $pagesMarket: Markets!, $first: Int, $skip: Int) {
  stories: storiesConnection(
    orderBy: date_DESC
    first: $first
    skip: $skip
    locales: $locales
    where: {_search: $search, markets_contains_some: $storyPressMarkets}
  ) {
    pageInfo {
      hasNextPage
      pageSize
      startCursor
      endCursor
    }
    aggregate {
      count
    }
    edges {
      cursor
      node {
        id
        title
        slug
        locale
        teaser
        markets
        storyTagEnum
        image {
          ... on Asset {
            id
            desktop: url(
              transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: webp}}}
            )
            desktopFallback: url(
              transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: jpg}}}
            )
            mobile: url(
              transformation: {image: {resize: {fit: max, width: 700}}, document: {output: {format: webp}}}
            )
            mobileFallback: url(
              transformation: {image: {resize: {fit: max, width: 700}}, document: {output: {format: jpg}}}
            )
          }
        }
        date
      }
    }
  }
  pressReleasesGlobal: pressReleasesConnection(
    orderBy: date_DESC
    first: $first
    skip: $skip
    locales: [$localeGlobalPressRelease]
    where: {_search: $search, market: global}
  ) {
    pageInfo {
      hasNextPage
      pageSize
      startCursor
      endCursor
    }
    aggregate {
      count
    }
    edges {
      cursor
      node {
        id
        title
        slug
        locale
        market
        teaser
        image {
          ... on Asset {
            id
            desktop: url(
              transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: webp}}}
            )
            desktopFallback: url(
              transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: jpg}}}
            )
            mobile: url(
              transformation: {image: {resize: {fit: max, width: 700}}, document: {output: {format: webp}}}
            )
            mobileFallback: url(
              transformation: {image: {resize: {fit: max, width: 700}}, document: {output: {format: jpg}}}
            )
          }
        }
        date
      }
    }
  }
  pressReleases: pressReleasesConnection(
    orderBy: date_DESC
    first: $first
    skip: $skip
    where: {_search: $search, market_in: $storyPressMarkets}
  ) {
    pageInfo {
      hasNextPage
      pageSize
      startCursor
      endCursor
    }
    aggregate {
      count
    }
    edges {
      cursor
      node {
        id
        title
        slug
        locale
        market
        teaser
        image {
          ... on Asset {
            id
            desktop: url(
              transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: webp}}}
            )
            desktopFallback: url(
              transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: jpg}}}
            )
            mobile: url(
              transformation: {image: {resize: {fit: max, width: 700}}, document: {output: {format: webp}}}
            )
            mobileFallback: url(
              transformation: {image: {resize: {fit: max, width: 700}}, document: {output: {format: jpg}}}
            )
          }
        }
        date
      }
    }
  }
  pages: genericPagesConnection(
    orderBy: createdAt_DESC
    first: $first
    skip: $skip
    locales: $locales
    where: {_search: $search, markets_contains_some: [$pagesMarket]}
  ) {
    pageInfo {
      hasNextPage
      pageSize
      startCursor
      endCursor
    }
    aggregate {
      count
    }
    edges {
      cursor
      node {
        id
        title
        slug
        locale
        markets
        createdAt
        metaData {
          pageName
          description
        }
      }
    }
  }
}
    `;

/**
 * __useGetPageSearchQuery__
 *
 * To run a query within a React component, call `useGetPageSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      locales: // value for 'locales'
 *      localeGlobalPressRelease: // value for 'localeGlobalPressRelease'
 *      storyPressMarkets: // value for 'storyPressMarkets'
 *      pagesMarket: // value for 'pagesMarket'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetPageSearchQuery(baseOptions: Apollo.QueryHookOptions<GetPageSearchQuery, GetPageSearchQueryVariables> & ({ variables: GetPageSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPageSearchQuery, GetPageSearchQueryVariables>(GetPageSearchDocument, options);
      }
export function useGetPageSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageSearchQuery, GetPageSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPageSearchQuery, GetPageSearchQueryVariables>(GetPageSearchDocument, options);
        }
export function useGetPageSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPageSearchQuery, GetPageSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPageSearchQuery, GetPageSearchQueryVariables>(GetPageSearchDocument, options);
        }
export type GetPageSearchQueryHookResult = ReturnType<typeof useGetPageSearchQuery>;
export type GetPageSearchLazyQueryHookResult = ReturnType<typeof useGetPageSearchLazyQuery>;
export type GetPageSearchSuspenseQueryHookResult = ReturnType<typeof useGetPageSearchSuspenseQuery>;
export type GetPageSearchQueryResult = Apollo.QueryResult<GetPageSearchQuery, GetPageSearchQueryVariables>;
export const GetPressPageIntroDocument = gql`
    query GetPressPageIntro($locales: [Locale!]!) {
  page: corpPressPages(locales: $locales) {
    title
    subtitle
    introText
    metaData {
      ...MetadataParts
    }
  }
}
    ${MetadataPartsFragmentDoc}`;

/**
 * __useGetPressPageIntroQuery__
 *
 * To run a query within a React component, call `useGetPressPageIntroQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPressPageIntroQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPressPageIntroQuery({
 *   variables: {
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetPressPageIntroQuery(baseOptions: Apollo.QueryHookOptions<GetPressPageIntroQuery, GetPressPageIntroQueryVariables> & ({ variables: GetPressPageIntroQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPressPageIntroQuery, GetPressPageIntroQueryVariables>(GetPressPageIntroDocument, options);
      }
export function useGetPressPageIntroLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPressPageIntroQuery, GetPressPageIntroQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPressPageIntroQuery, GetPressPageIntroQueryVariables>(GetPressPageIntroDocument, options);
        }
export function useGetPressPageIntroSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPressPageIntroQuery, GetPressPageIntroQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPressPageIntroQuery, GetPressPageIntroQueryVariables>(GetPressPageIntroDocument, options);
        }
export type GetPressPageIntroQueryHookResult = ReturnType<typeof useGetPressPageIntroQuery>;
export type GetPressPageIntroLazyQueryHookResult = ReturnType<typeof useGetPressPageIntroLazyQuery>;
export type GetPressPageIntroSuspenseQueryHookResult = ReturnType<typeof useGetPressPageIntroSuspenseQuery>;
export type GetPressPageIntroQueryResult = Apollo.QueryResult<GetPressPageIntroQuery, GetPressPageIntroQueryVariables>;
export const GetPressReleasesFilteredDocument = gql`
    query getPressReleasesFiltered($where: PressReleaseWhereInput, $locales: [Locale!]!, $first: Int) {
  pressReleases(
    where: $where
    locales: $locales
    first: $first
    orderBy: date_DESC
  ) {
    id
    tag: topicEnum
    date
    slug
    title
    image {
      ... on Asset {
        id
        desktop: url(
          transformation: {image: {resize: {fit: max, width: 900}}, document: {output: {format: webp}}}
        )
        desktopFallback: url(
          transformation: {image: {resize: {fit: max, width: 900}}, document: {output: {format: jpg}}}
        )
        mobile: url(
          transformation: {image: {resize: {fit: max, width: 500}}, document: {output: {format: webp}}}
        )
        mobileFallback: url(
          transformation: {image: {resize: {fit: max, width: 500}}, document: {output: {format: jpg}}}
        )
      }
    }
  }
}
    `;

/**
 * __useGetPressReleasesFilteredQuery__
 *
 * To run a query within a React component, call `useGetPressReleasesFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPressReleasesFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPressReleasesFilteredQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetPressReleasesFilteredQuery(baseOptions: Apollo.QueryHookOptions<GetPressReleasesFilteredQuery, GetPressReleasesFilteredQueryVariables> & ({ variables: GetPressReleasesFilteredQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPressReleasesFilteredQuery, GetPressReleasesFilteredQueryVariables>(GetPressReleasesFilteredDocument, options);
      }
export function useGetPressReleasesFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPressReleasesFilteredQuery, GetPressReleasesFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPressReleasesFilteredQuery, GetPressReleasesFilteredQueryVariables>(GetPressReleasesFilteredDocument, options);
        }
export function useGetPressReleasesFilteredSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPressReleasesFilteredQuery, GetPressReleasesFilteredQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPressReleasesFilteredQuery, GetPressReleasesFilteredQueryVariables>(GetPressReleasesFilteredDocument, options);
        }
export type GetPressReleasesFilteredQueryHookResult = ReturnType<typeof useGetPressReleasesFilteredQuery>;
export type GetPressReleasesFilteredLazyQueryHookResult = ReturnType<typeof useGetPressReleasesFilteredLazyQuery>;
export type GetPressReleasesFilteredSuspenseQueryHookResult = ReturnType<typeof useGetPressReleasesFilteredSuspenseQuery>;
export type GetPressReleasesFilteredQueryResult = Apollo.QueryResult<GetPressReleasesFilteredQuery, GetPressReleasesFilteredQueryVariables>;
export const GetPressReleaseDocument = gql`
    query getPressRelease($where: PressReleaseWhereInput, $locales: [Locale!]!) {
  pressReleases(where: $where, locales: $locales) {
    ...PressReleaseParts
  }
}
    ${PressReleasePartsFragmentDoc}`;

/**
 * __useGetPressReleaseQuery__
 *
 * To run a query within a React component, call `useGetPressReleaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPressReleaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPressReleaseQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetPressReleaseQuery(baseOptions: Apollo.QueryHookOptions<GetPressReleaseQuery, GetPressReleaseQueryVariables> & ({ variables: GetPressReleaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPressReleaseQuery, GetPressReleaseQueryVariables>(GetPressReleaseDocument, options);
      }
export function useGetPressReleaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPressReleaseQuery, GetPressReleaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPressReleaseQuery, GetPressReleaseQueryVariables>(GetPressReleaseDocument, options);
        }
export function useGetPressReleaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPressReleaseQuery, GetPressReleaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPressReleaseQuery, GetPressReleaseQueryVariables>(GetPressReleaseDocument, options);
        }
export type GetPressReleaseQueryHookResult = ReturnType<typeof useGetPressReleaseQuery>;
export type GetPressReleaseLazyQueryHookResult = ReturnType<typeof useGetPressReleaseLazyQuery>;
export type GetPressReleaseSuspenseQueryHookResult = ReturnType<typeof useGetPressReleaseSuspenseQuery>;
export type GetPressReleaseQueryResult = Apollo.QueryResult<GetPressReleaseQuery, GetPressReleaseQueryVariables>;
export const GetPressReleasesAlgoliaDocument = gql`
    query getPressReleasesAlgolia($first: Int, $after: String) {
  pressReleasesConnection(first: $first, after: $after) {
    pageInfo {
      hasNextPage
      pageSize
      startCursor
      endCursor
    }
    aggregate {
      count
    }
    edges {
      cursor
      node {
        id
        localizations(includeCurrent: true) {
          title
          slug
          locale
          teaser
        }
        topicEnum
        image {
          ... on Asset {
            id
            url(
              transformation: {image: {resize: {fit: clip, width: 640}}, document: {output: {format: webp}}}
            )
          }
        }
        date
        market
        downloadPr {
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetPressReleasesAlgoliaQuery__
 *
 * To run a query within a React component, call `useGetPressReleasesAlgoliaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPressReleasesAlgoliaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPressReleasesAlgoliaQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetPressReleasesAlgoliaQuery(baseOptions?: Apollo.QueryHookOptions<GetPressReleasesAlgoliaQuery, GetPressReleasesAlgoliaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPressReleasesAlgoliaQuery, GetPressReleasesAlgoliaQueryVariables>(GetPressReleasesAlgoliaDocument, options);
      }
export function useGetPressReleasesAlgoliaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPressReleasesAlgoliaQuery, GetPressReleasesAlgoliaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPressReleasesAlgoliaQuery, GetPressReleasesAlgoliaQueryVariables>(GetPressReleasesAlgoliaDocument, options);
        }
export function useGetPressReleasesAlgoliaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPressReleasesAlgoliaQuery, GetPressReleasesAlgoliaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPressReleasesAlgoliaQuery, GetPressReleasesAlgoliaQueryVariables>(GetPressReleasesAlgoliaDocument, options);
        }
export type GetPressReleasesAlgoliaQueryHookResult = ReturnType<typeof useGetPressReleasesAlgoliaQuery>;
export type GetPressReleasesAlgoliaLazyQueryHookResult = ReturnType<typeof useGetPressReleasesAlgoliaLazyQuery>;
export type GetPressReleasesAlgoliaSuspenseQueryHookResult = ReturnType<typeof useGetPressReleasesAlgoliaSuspenseQuery>;
export type GetPressReleasesAlgoliaQueryResult = Apollo.QueryResult<GetPressReleasesAlgoliaQuery, GetPressReleasesAlgoliaQueryVariables>;
export const GetPressReleasesForSitemapDocument = gql`
    query getPressReleasesForSitemap {
  pressReleases {
    market
    localizations(includeCurrent: true) {
      slug
      locale
    }
  }
}
    `;

/**
 * __useGetPressReleasesForSitemapQuery__
 *
 * To run a query within a React component, call `useGetPressReleasesForSitemapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPressReleasesForSitemapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPressReleasesForSitemapQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPressReleasesForSitemapQuery(baseOptions?: Apollo.QueryHookOptions<GetPressReleasesForSitemapQuery, GetPressReleasesForSitemapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPressReleasesForSitemapQuery, GetPressReleasesForSitemapQueryVariables>(GetPressReleasesForSitemapDocument, options);
      }
export function useGetPressReleasesForSitemapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPressReleasesForSitemapQuery, GetPressReleasesForSitemapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPressReleasesForSitemapQuery, GetPressReleasesForSitemapQueryVariables>(GetPressReleasesForSitemapDocument, options);
        }
export function useGetPressReleasesForSitemapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPressReleasesForSitemapQuery, GetPressReleasesForSitemapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPressReleasesForSitemapQuery, GetPressReleasesForSitemapQueryVariables>(GetPressReleasesForSitemapDocument, options);
        }
export type GetPressReleasesForSitemapQueryHookResult = ReturnType<typeof useGetPressReleasesForSitemapQuery>;
export type GetPressReleasesForSitemapLazyQueryHookResult = ReturnType<typeof useGetPressReleasesForSitemapLazyQuery>;
export type GetPressReleasesForSitemapSuspenseQueryHookResult = ReturnType<typeof useGetPressReleasesForSitemapSuspenseQuery>;
export type GetPressReleasesForSitemapQueryResult = Apollo.QueryResult<GetPressReleasesForSitemapQuery, GetPressReleasesForSitemapQueryVariables>;
export const GetProgressBarDocument = gql`
    query GetProgressBar($where: ProgressBarWhereUniqueInput!, $locales: [Locale!]!) {
  progressBar(where: $where, locales: $locales) {
    id
    __typename
    current
    end
    headline
    start
    color
    caption
  }
}
    `;

/**
 * __useGetProgressBarQuery__
 *
 * To run a query within a React component, call `useGetProgressBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProgressBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProgressBarQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetProgressBarQuery(baseOptions: Apollo.QueryHookOptions<GetProgressBarQuery, GetProgressBarQueryVariables> & ({ variables: GetProgressBarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProgressBarQuery, GetProgressBarQueryVariables>(GetProgressBarDocument, options);
      }
export function useGetProgressBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProgressBarQuery, GetProgressBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProgressBarQuery, GetProgressBarQueryVariables>(GetProgressBarDocument, options);
        }
export function useGetProgressBarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProgressBarQuery, GetProgressBarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProgressBarQuery, GetProgressBarQueryVariables>(GetProgressBarDocument, options);
        }
export type GetProgressBarQueryHookResult = ReturnType<typeof useGetProgressBarQuery>;
export type GetProgressBarLazyQueryHookResult = ReturnType<typeof useGetProgressBarLazyQuery>;
export type GetProgressBarSuspenseQueryHookResult = ReturnType<typeof useGetProgressBarSuspenseQuery>;
export type GetProgressBarQueryResult = Apollo.QueryResult<GetProgressBarQuery, GetProgressBarQueryVariables>;
export const GetQuickLinkDocument = gql`
    query GetQuickLink($where: QuickLinkWhereUniqueInput!, $locales: [Locale!]!) {
  quickLink(where: $where, locales: $locales) {
    id
    __typename
    headline
    anchorNav {
      id
      navigationTitle
    }
    quickLinkItems {
      buttonHeadline
      buttonSubheadline
      id
      link {
        ...LinkParts
      }
    }
  }
}
    ${LinkPartsFragmentDoc}`;

/**
 * __useGetQuickLinkQuery__
 *
 * To run a query within a React component, call `useGetQuickLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickLinkQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetQuickLinkQuery(baseOptions: Apollo.QueryHookOptions<GetQuickLinkQuery, GetQuickLinkQueryVariables> & ({ variables: GetQuickLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickLinkQuery, GetQuickLinkQueryVariables>(GetQuickLinkDocument, options);
      }
export function useGetQuickLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickLinkQuery, GetQuickLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickLinkQuery, GetQuickLinkQueryVariables>(GetQuickLinkDocument, options);
        }
export function useGetQuickLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQuickLinkQuery, GetQuickLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQuickLinkQuery, GetQuickLinkQueryVariables>(GetQuickLinkDocument, options);
        }
export type GetQuickLinkQueryHookResult = ReturnType<typeof useGetQuickLinkQuery>;
export type GetQuickLinkLazyQueryHookResult = ReturnType<typeof useGetQuickLinkLazyQuery>;
export type GetQuickLinkSuspenseQueryHookResult = ReturnType<typeof useGetQuickLinkSuspenseQuery>;
export type GetQuickLinkQueryResult = Apollo.QueryResult<GetQuickLinkQuery, GetQuickLinkQueryVariables>;
export const GetRewritesDocument = gql`
    query GetRewrites($locales: [Locale!]!, $where: RewriteWhereInput) {
  rewrites(where: $where, locales: $locales) {
    destination
    source
    showLocale
    page
    locale
  }
}
    `;

/**
 * __useGetRewritesQuery__
 *
 * To run a query within a React component, call `useGetRewritesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRewritesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewritesQuery({
 *   variables: {
 *      locales: // value for 'locales'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetRewritesQuery(baseOptions: Apollo.QueryHookOptions<GetRewritesQuery, GetRewritesQueryVariables> & ({ variables: GetRewritesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRewritesQuery, GetRewritesQueryVariables>(GetRewritesDocument, options);
      }
export function useGetRewritesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRewritesQuery, GetRewritesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRewritesQuery, GetRewritesQueryVariables>(GetRewritesDocument, options);
        }
export function useGetRewritesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRewritesQuery, GetRewritesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRewritesQuery, GetRewritesQueryVariables>(GetRewritesDocument, options);
        }
export type GetRewritesQueryHookResult = ReturnType<typeof useGetRewritesQuery>;
export type GetRewritesLazyQueryHookResult = ReturnType<typeof useGetRewritesLazyQuery>;
export type GetRewritesSuspenseQueryHookResult = ReturnType<typeof useGetRewritesSuspenseQuery>;
export type GetRewritesQueryResult = Apollo.QueryResult<GetRewritesQuery, GetRewritesQueryVariables>;
export const GetSearchOverlayDocument = gql`
    query GetSearchOverlay($where: SearchOverlayComponentWhereInput, $locales: [Locale!]!) {
  searchOverlayComponents(where: $where, locales: $locales) {
    heading
    subHeading
    links {
      displayName
      url
    }
    dictionaries {
      dictionaryTitle
      dictionaryItems {
        key
        value
      }
    }
  }
}
    `;

/**
 * __useGetSearchOverlayQuery__
 *
 * To run a query within a React component, call `useGetSearchOverlayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchOverlayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchOverlayQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetSearchOverlayQuery(baseOptions: Apollo.QueryHookOptions<GetSearchOverlayQuery, GetSearchOverlayQueryVariables> & ({ variables: GetSearchOverlayQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchOverlayQuery, GetSearchOverlayQueryVariables>(GetSearchOverlayDocument, options);
      }
export function useGetSearchOverlayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchOverlayQuery, GetSearchOverlayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchOverlayQuery, GetSearchOverlayQueryVariables>(GetSearchOverlayDocument, options);
        }
export function useGetSearchOverlaySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchOverlayQuery, GetSearchOverlayQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchOverlayQuery, GetSearchOverlayQueryVariables>(GetSearchOverlayDocument, options);
        }
export type GetSearchOverlayQueryHookResult = ReturnType<typeof useGetSearchOverlayQuery>;
export type GetSearchOverlayLazyQueryHookResult = ReturnType<typeof useGetSearchOverlayLazyQuery>;
export type GetSearchOverlaySuspenseQueryHookResult = ReturnType<typeof useGetSearchOverlaySuspenseQuery>;
export type GetSearchOverlayQueryResult = Apollo.QueryResult<GetSearchOverlayQuery, GetSearchOverlayQueryVariables>;
export const GetCardCarouselDocument = gql`
    query GetCardCarousel($locales: [Locale!]!, $where: GenericCardCarouseComponentWhereInput) {
  genericCardCarouseComponents(where: $where) {
    subHeading
    heading
    cardVariation
    componentBackground {
      ... on AssetComponent {
        id
        asset {
          url(
            transformation: {image: {resize: {fit: max, width: 427}}, document: {output: {format: png}}}
          )
        }
      }
    }
    floatingObject {
      ... on AssetComponent {
        id
        asset {
          url(
            transformation: {image: {resize: {fit: max, width: 427}}, document: {output: {format: png}}}
          )
          altText
        }
      }
    }
    extension {
      __typename
      id
      markets
      environment
      extension
      tipsAndTricks
    }
    dictionaryItem(locales: $locales) {
      ... on DictionaryItem {
        key
        value
      }
    }
    genericCardCarouselCta {
      ... on Link {
        displayName
        url
      }
    }
  }
}
    `;

/**
 * __useGetCardCarouselQuery__
 *
 * To run a query within a React component, call `useGetCardCarouselQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCardCarouselQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCardCarouselQuery({
 *   variables: {
 *      locales: // value for 'locales'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetCardCarouselQuery(baseOptions: Apollo.QueryHookOptions<GetCardCarouselQuery, GetCardCarouselQueryVariables> & ({ variables: GetCardCarouselQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCardCarouselQuery, GetCardCarouselQueryVariables>(GetCardCarouselDocument, options);
      }
export function useGetCardCarouselLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCardCarouselQuery, GetCardCarouselQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCardCarouselQuery, GetCardCarouselQueryVariables>(GetCardCarouselDocument, options);
        }
export function useGetCardCarouselSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCardCarouselQuery, GetCardCarouselQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCardCarouselQuery, GetCardCarouselQueryVariables>(GetCardCarouselDocument, options);
        }
export type GetCardCarouselQueryHookResult = ReturnType<typeof useGetCardCarouselQuery>;
export type GetCardCarouselLazyQueryHookResult = ReturnType<typeof useGetCardCarouselLazyQuery>;
export type GetCardCarouselSuspenseQueryHookResult = ReturnType<typeof useGetCardCarouselSuspenseQuery>;
export type GetCardCarouselQueryResult = Apollo.QueryResult<GetCardCarouselQuery, GetCardCarouselQueryVariables>;
export const GetSearchResultPageDocument = gql`
    query GetSearchResultPage($locales: [Locale!]!, $where: SearchResultPageWhereInput) {
  searchResultPages(where: $where, locales: $locales) {
    searchPageTitles {
      dictionaryItems(locales: $locales) {
        key
        value
      }
    }
  }
}
    `;

/**
 * __useGetSearchResultPageQuery__
 *
 * To run a query within a React component, call `useGetSearchResultPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultPageQuery({
 *   variables: {
 *      locales: // value for 'locales'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetSearchResultPageQuery(baseOptions: Apollo.QueryHookOptions<GetSearchResultPageQuery, GetSearchResultPageQueryVariables> & ({ variables: GetSearchResultPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchResultPageQuery, GetSearchResultPageQueryVariables>(GetSearchResultPageDocument, options);
      }
export function useGetSearchResultPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchResultPageQuery, GetSearchResultPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchResultPageQuery, GetSearchResultPageQueryVariables>(GetSearchResultPageDocument, options);
        }
export function useGetSearchResultPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSearchResultPageQuery, GetSearchResultPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSearchResultPageQuery, GetSearchResultPageQueryVariables>(GetSearchResultPageDocument, options);
        }
export type GetSearchResultPageQueryHookResult = ReturnType<typeof useGetSearchResultPageQuery>;
export type GetSearchResultPageLazyQueryHookResult = ReturnType<typeof useGetSearchResultPageLazyQuery>;
export type GetSearchResultPageSuspenseQueryHookResult = ReturnType<typeof useGetSearchResultPageSuspenseQuery>;
export type GetSearchResultPageQueryResult = Apollo.QueryResult<GetSearchResultPageQuery, GetSearchResultPageQueryVariables>;
export const GetShortHeroComponentDocument = gql`
    query GetShortHeroComponent($where: ShortHeroWhereUniqueInput!, $locales: [Locale!]!) {
  shortHero(where: $where, locales: $locales) {
    id
    __typename
    title
    superTitle
    description
  }
}
    `;

/**
 * __useGetShortHeroComponentQuery__
 *
 * To run a query within a React component, call `useGetShortHeroComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShortHeroComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShortHeroComponentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetShortHeroComponentQuery(baseOptions: Apollo.QueryHookOptions<GetShortHeroComponentQuery, GetShortHeroComponentQueryVariables> & ({ variables: GetShortHeroComponentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShortHeroComponentQuery, GetShortHeroComponentQueryVariables>(GetShortHeroComponentDocument, options);
      }
export function useGetShortHeroComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShortHeroComponentQuery, GetShortHeroComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShortHeroComponentQuery, GetShortHeroComponentQueryVariables>(GetShortHeroComponentDocument, options);
        }
export function useGetShortHeroComponentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShortHeroComponentQuery, GetShortHeroComponentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShortHeroComponentQuery, GetShortHeroComponentQueryVariables>(GetShortHeroComponentDocument, options);
        }
export type GetShortHeroComponentQueryHookResult = ReturnType<typeof useGetShortHeroComponentQuery>;
export type GetShortHeroComponentLazyQueryHookResult = ReturnType<typeof useGetShortHeroComponentLazyQuery>;
export type GetShortHeroComponentSuspenseQueryHookResult = ReturnType<typeof useGetShortHeroComponentSuspenseQuery>;
export type GetShortHeroComponentQueryResult = Apollo.QueryResult<GetShortHeroComponentQuery, GetShortHeroComponentQueryVariables>;
export const GetSocialSharingDocument = gql`
    query GetSocialSharing($where: SocialMediaListComponentWhereInput) {
  socialMediaListComponents(where: $where) {
    id
    __typename
    name
    url
    shareMsg
    socialMediaComponentName
    socialSharePosition
    assetsComponents {
      asset {
        url
      }
    }
  }
}
    `;

/**
 * __useGetSocialSharingQuery__
 *
 * To run a query within a React component, call `useGetSocialSharingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialSharingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialSharingQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetSocialSharingQuery(baseOptions?: Apollo.QueryHookOptions<GetSocialSharingQuery, GetSocialSharingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialSharingQuery, GetSocialSharingQueryVariables>(GetSocialSharingDocument, options);
      }
export function useGetSocialSharingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialSharingQuery, GetSocialSharingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialSharingQuery, GetSocialSharingQueryVariables>(GetSocialSharingDocument, options);
        }
export function useGetSocialSharingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSocialSharingQuery, GetSocialSharingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSocialSharingQuery, GetSocialSharingQueryVariables>(GetSocialSharingDocument, options);
        }
export type GetSocialSharingQueryHookResult = ReturnType<typeof useGetSocialSharingQuery>;
export type GetSocialSharingLazyQueryHookResult = ReturnType<typeof useGetSocialSharingLazyQuery>;
export type GetSocialSharingSuspenseQueryHookResult = ReturnType<typeof useGetSocialSharingSuspenseQuery>;
export type GetSocialSharingQueryResult = Apollo.QueryResult<GetSocialSharingQuery, GetSocialSharingQueryVariables>;
export const GetSpacerDocument = gql`
    query GetSpacer($where: SpacerWhereUniqueInput!, $locales: [Locale!]!) {
  spacer(where: $where, locales: $locales) {
    ...SpacerParts
  }
}
    ${SpacerPartsFragmentDoc}`;

/**
 * __useGetSpacerQuery__
 *
 * To run a query within a React component, call `useGetSpacerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpacerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpacerQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetSpacerQuery(baseOptions: Apollo.QueryHookOptions<GetSpacerQuery, GetSpacerQueryVariables> & ({ variables: GetSpacerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpacerQuery, GetSpacerQueryVariables>(GetSpacerDocument, options);
      }
export function useGetSpacerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSpacerQuery, GetSpacerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpacerQuery, GetSpacerQueryVariables>(GetSpacerDocument, options);
        }
export function useGetSpacerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpacerQuery, GetSpacerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpacerQuery, GetSpacerQueryVariables>(GetSpacerDocument, options);
        }
export type GetSpacerQueryHookResult = ReturnType<typeof useGetSpacerQuery>;
export type GetSpacerLazyQueryHookResult = ReturnType<typeof useGetSpacerLazyQuery>;
export type GetSpacerSuspenseQueryHookResult = ReturnType<typeof useGetSpacerSuspenseQuery>;
export type GetSpacerQueryResult = Apollo.QueryResult<GetSpacerQuery, GetSpacerQueryVariables>;
export const GetStoriesAlgoliaDocument = gql`
    query getStoriesAlgolia($first: Int, $after: String) {
  storiesConnection(first: $first, after: $after) {
    pageInfo {
      hasNextPage
      pageSize
      startCursor
      endCursor
    }
    aggregate {
      count
    }
    edges {
      cursor
      node {
        id
        localizations(includeCurrent: true) {
          title
          slug
          locale
          teaser
        }
        markets
        storyTagEnum
        image {
          ... on Asset {
            id
            desktop: url(
              transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: webp}}}
            )
            desktopFallback: url(
              transformation: {image: {resize: {fit: max, width: 1000}}, document: {output: {format: jpg}}}
            )
            mobile: url(
              transformation: {image: {resize: {fit: max, width: 700}}, document: {output: {format: webp}}}
            )
            mobileFallback: url(
              transformation: {image: {resize: {fit: max, width: 700}}, document: {output: {format: jpg}}}
            )
          }
        }
        date
      }
    }
  }
}
    `;

/**
 * __useGetStoriesAlgoliaQuery__
 *
 * To run a query within a React component, call `useGetStoriesAlgoliaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoriesAlgoliaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoriesAlgoliaQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetStoriesAlgoliaQuery(baseOptions?: Apollo.QueryHookOptions<GetStoriesAlgoliaQuery, GetStoriesAlgoliaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoriesAlgoliaQuery, GetStoriesAlgoliaQueryVariables>(GetStoriesAlgoliaDocument, options);
      }
export function useGetStoriesAlgoliaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoriesAlgoliaQuery, GetStoriesAlgoliaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoriesAlgoliaQuery, GetStoriesAlgoliaQueryVariables>(GetStoriesAlgoliaDocument, options);
        }
export function useGetStoriesAlgoliaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStoriesAlgoliaQuery, GetStoriesAlgoliaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoriesAlgoliaQuery, GetStoriesAlgoliaQueryVariables>(GetStoriesAlgoliaDocument, options);
        }
export type GetStoriesAlgoliaQueryHookResult = ReturnType<typeof useGetStoriesAlgoliaQuery>;
export type GetStoriesAlgoliaLazyQueryHookResult = ReturnType<typeof useGetStoriesAlgoliaLazyQuery>;
export type GetStoriesAlgoliaSuspenseQueryHookResult = ReturnType<typeof useGetStoriesAlgoliaSuspenseQuery>;
export type GetStoriesAlgoliaQueryResult = Apollo.QueryResult<GetStoriesAlgoliaQuery, GetStoriesAlgoliaQueryVariables>;
export const GetStoriesFilteredDocument = gql`
    query getStoriesFiltered($where: StoryWhereInput, $locales: [Locale!]!, $first: Int) {
  stories(where: $where, locales: $locales, first: $first, orderBy: date_DESC) {
    id
    tag: storyTagEnum
    date
    slug
    title
    image {
      ... on Asset {
        id
        desktop: url(
          transformation: {image: {resize: {fit: max, width: 500}}, document: {output: {format: webp}}}
        )
        desktopFallback: url(
          transformation: {image: {resize: {fit: max, width: 500}}, document: {output: {format: jpg}}}
        )
        mobile: url(
          transformation: {image: {resize: {fit: max, width: 300}}, document: {output: {format: webp}}}
        )
        mobileFallback: url(
          transformation: {image: {resize: {fit: max, width: 300}}, document: {output: {format: jpg}}}
        )
      }
    }
  }
}
    `;

/**
 * __useGetStoriesFilteredQuery__
 *
 * To run a query within a React component, call `useGetStoriesFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoriesFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoriesFilteredQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetStoriesFilteredQuery(baseOptions: Apollo.QueryHookOptions<GetStoriesFilteredQuery, GetStoriesFilteredQueryVariables> & ({ variables: GetStoriesFilteredQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoriesFilteredQuery, GetStoriesFilteredQueryVariables>(GetStoriesFilteredDocument, options);
      }
export function useGetStoriesFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoriesFilteredQuery, GetStoriesFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoriesFilteredQuery, GetStoriesFilteredQueryVariables>(GetStoriesFilteredDocument, options);
        }
export function useGetStoriesFilteredSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStoriesFilteredQuery, GetStoriesFilteredQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoriesFilteredQuery, GetStoriesFilteredQueryVariables>(GetStoriesFilteredDocument, options);
        }
export type GetStoriesFilteredQueryHookResult = ReturnType<typeof useGetStoriesFilteredQuery>;
export type GetStoriesFilteredLazyQueryHookResult = ReturnType<typeof useGetStoriesFilteredLazyQuery>;
export type GetStoriesFilteredSuspenseQueryHookResult = ReturnType<typeof useGetStoriesFilteredSuspenseQuery>;
export type GetStoriesFilteredQueryResult = Apollo.QueryResult<GetStoriesFilteredQuery, GetStoriesFilteredQueryVariables>;
export const GetStoriesPageDocument = gql`
    query GetStoriesPage($locales: [Locale!]!) {
  page: corpStoriesPages(locales: $locales) {
    introText {
      ...IntroTextParts
    }
    corpHero {
      ...CorpHeroParts
    }
    genericFollowUs {
      ...GenericFollowUsParts
    }
    metaData {
      ...MetadataParts
    }
  }
}
    ${IntroTextPartsFragmentDoc}
${CorpHeroPartsFragmentDoc}
${GenericFollowUsPartsFragmentDoc}
${MetadataPartsFragmentDoc}`;

/**
 * __useGetStoriesPageQuery__
 *
 * To run a query within a React component, call `useGetStoriesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoriesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoriesPageQuery({
 *   variables: {
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetStoriesPageQuery(baseOptions: Apollo.QueryHookOptions<GetStoriesPageQuery, GetStoriesPageQueryVariables> & ({ variables: GetStoriesPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoriesPageQuery, GetStoriesPageQueryVariables>(GetStoriesPageDocument, options);
      }
export function useGetStoriesPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoriesPageQuery, GetStoriesPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoriesPageQuery, GetStoriesPageQueryVariables>(GetStoriesPageDocument, options);
        }
export function useGetStoriesPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStoriesPageQuery, GetStoriesPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoriesPageQuery, GetStoriesPageQueryVariables>(GetStoriesPageDocument, options);
        }
export type GetStoriesPageQueryHookResult = ReturnType<typeof useGetStoriesPageQuery>;
export type GetStoriesPageLazyQueryHookResult = ReturnType<typeof useGetStoriesPageLazyQuery>;
export type GetStoriesPageSuspenseQueryHookResult = ReturnType<typeof useGetStoriesPageSuspenseQuery>;
export type GetStoriesPageQueryResult = Apollo.QueryResult<GetStoriesPageQuery, GetStoriesPageQueryVariables>;
export const GetStoriesForSitemapDocument = gql`
    query getStoriesForSitemap($where: StoryWhereInput) {
  stories(where: $where) {
    localizations(includeCurrent: true) {
      locale
      slug
    }
  }
}
    `;

/**
 * __useGetStoriesForSitemapQuery__
 *
 * To run a query within a React component, call `useGetStoriesForSitemapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoriesForSitemapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoriesForSitemapQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetStoriesForSitemapQuery(baseOptions?: Apollo.QueryHookOptions<GetStoriesForSitemapQuery, GetStoriesForSitemapQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoriesForSitemapQuery, GetStoriesForSitemapQueryVariables>(GetStoriesForSitemapDocument, options);
      }
export function useGetStoriesForSitemapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoriesForSitemapQuery, GetStoriesForSitemapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoriesForSitemapQuery, GetStoriesForSitemapQueryVariables>(GetStoriesForSitemapDocument, options);
        }
export function useGetStoriesForSitemapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStoriesForSitemapQuery, GetStoriesForSitemapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoriesForSitemapQuery, GetStoriesForSitemapQueryVariables>(GetStoriesForSitemapDocument, options);
        }
export type GetStoriesForSitemapQueryHookResult = ReturnType<typeof useGetStoriesForSitemapQuery>;
export type GetStoriesForSitemapLazyQueryHookResult = ReturnType<typeof useGetStoriesForSitemapLazyQuery>;
export type GetStoriesForSitemapSuspenseQueryHookResult = ReturnType<typeof useGetStoriesForSitemapSuspenseQuery>;
export type GetStoriesForSitemapQueryResult = Apollo.QueryResult<GetStoriesForSitemapQuery, GetStoriesForSitemapQueryVariables>;
export const GetStoryDocument = gql`
    query getStory($where: StoryWhereInput, $locales: [Locale!]!) {
  stories(where: $where, locales: $locales) {
    ...StoryParts
  }
}
    ${StoryPartsFragmentDoc}`;

/**
 * __useGetStoryQuery__
 *
 * To run a query within a React component, call `useGetStoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStoryQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetStoryQuery(baseOptions: Apollo.QueryHookOptions<GetStoryQuery, GetStoryQueryVariables> & ({ variables: GetStoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStoryQuery, GetStoryQueryVariables>(GetStoryDocument, options);
      }
export function useGetStoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStoryQuery, GetStoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStoryQuery, GetStoryQueryVariables>(GetStoryDocument, options);
        }
export function useGetStorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStoryQuery, GetStoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStoryQuery, GetStoryQueryVariables>(GetStoryDocument, options);
        }
export type GetStoryQueryHookResult = ReturnType<typeof useGetStoryQuery>;
export type GetStoryLazyQueryHookResult = ReturnType<typeof useGetStoryLazyQuery>;
export type GetStorySuspenseQueryHookResult = ReturnType<typeof useGetStorySuspenseQuery>;
export type GetStoryQueryResult = Apollo.QueryResult<GetStoryQuery, GetStoryQueryVariables>;
export const GetSustainabilityInfoDocument = gql`
    query GetSustainabilityInfo($where: SustainabilityInfoWhereUniqueInput!, $locales: [Locale!]!) {
  sustainabilityInfo(where: $where, locales: $locales) {
    cmsTitle
    id
    superHeading
    title
    ingredientsTitle
    packagingTitle
    upperLeftCorner {
      id
      asset {
        url
        altText
      }
    }
    upperRightCorner {
      id
      asset {
        url
        altText
      }
    }
    lowerLeftCorner {
      id
      asset {
        url
        altText
      }
    }
    lowerRightCorner {
      id
      asset {
        url
        altText
      }
    }
  }
}
    `;

/**
 * __useGetSustainabilityInfoQuery__
 *
 * To run a query within a React component, call `useGetSustainabilityInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSustainabilityInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSustainabilityInfoQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetSustainabilityInfoQuery(baseOptions: Apollo.QueryHookOptions<GetSustainabilityInfoQuery, GetSustainabilityInfoQueryVariables> & ({ variables: GetSustainabilityInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSustainabilityInfoQuery, GetSustainabilityInfoQueryVariables>(GetSustainabilityInfoDocument, options);
      }
export function useGetSustainabilityInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSustainabilityInfoQuery, GetSustainabilityInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSustainabilityInfoQuery, GetSustainabilityInfoQueryVariables>(GetSustainabilityInfoDocument, options);
        }
export function useGetSustainabilityInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSustainabilityInfoQuery, GetSustainabilityInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSustainabilityInfoQuery, GetSustainabilityInfoQueryVariables>(GetSustainabilityInfoDocument, options);
        }
export type GetSustainabilityInfoQueryHookResult = ReturnType<typeof useGetSustainabilityInfoQuery>;
export type GetSustainabilityInfoLazyQueryHookResult = ReturnType<typeof useGetSustainabilityInfoLazyQuery>;
export type GetSustainabilityInfoSuspenseQueryHookResult = ReturnType<typeof useGetSustainabilityInfoSuspenseQuery>;
export type GetSustainabilityInfoQueryResult = Apollo.QueryResult<GetSustainabilityInfoQuery, GetSustainabilityInfoQueryVariables>;
export const GetTabsDocument = gql`
    query GetTabs($where: TabWhereUniqueInput!, $locales: [Locale!]!) {
  tab(where: $where, locales: $locales) {
    id
    __typename
    cmsTabTitle
    anchorNav {
      id
      navigationTitle
    }
    tabs {
      ... on TabContent {
        id
        tabTitle
        components {
          ... on CarouselComponent {
            id
            __typename
          }
          ... on EvalancheFormComponent {
            id
            __typename
          }
          ... on HeroCarouselComponent {
            id
            __typename
          }
          ... on Form {
            id
            __typename
          }
          ... on Link {
            id
            __typename
          }
          ... on LongText {
            id
            __typename
          }
          ... on IntroText {
            id
            __typename
          }
          ... on CorpGenericAccordion {
            id
            __typename
          }
          ... on GenericFollowUs {
            id
            __typename
          }
          ... on AuthorableContentCard {
            id
            __typename
          }
          ... on CorpBanner1 {
            id
            __typename
          }
          ... on Banner2 {
            id
            __typename
          }
          ... on GenericCardCarouseComponent {
            id
            __typename
          }
          ... on DynamicCardGrid {
            id
            __typename
          }
          ... on GenericLine {
            id
            __typename
          }
          ... on ImageCopy {
            id
            __typename
          }
          ... on CorpGridColumnComponent {
            id
            __typename
          }
          ... on GenericDownloadComponent {
            id
            __typename
          }
          ... on Iframe {
            id
            __typename
          }
          ... on QuickLink {
            id
            __typename
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTabsQuery__
 *
 * To run a query within a React component, call `useGetTabsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTabsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTabsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      locales: // value for 'locales'
 *   },
 * });
 */
export function useGetTabsQuery(baseOptions: Apollo.QueryHookOptions<GetTabsQuery, GetTabsQueryVariables> & ({ variables: GetTabsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTabsQuery, GetTabsQueryVariables>(GetTabsDocument, options);
      }
export function useGetTabsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTabsQuery, GetTabsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTabsQuery, GetTabsQueryVariables>(GetTabsDocument, options);
        }
export function useGetTabsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTabsQuery, GetTabsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTabsQuery, GetTabsQueryVariables>(GetTabsDocument, options);
        }
export type GetTabsQueryHookResult = ReturnType<typeof useGetTabsQuery>;
export type GetTabsLazyQueryHookResult = ReturnType<typeof useGetTabsLazyQuery>;
export type GetTabsSuspenseQueryHookResult = ReturnType<typeof useGetTabsSuspenseQuery>;
export type GetTabsQueryResult = Apollo.QueryResult<GetTabsQuery, GetTabsQueryVariables>;